/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `Byte` scalar type represents byte value as a Buffer */
  Byte: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  Long: any;
  /** Represents NULL values */
  Void: any;
};

export type ComWixBookingsCalendarApiV2QuerySessionsRequestInput = {
  /**
   * Start of the time range for which sessions are returned, in [ISO 8601 format](https://en.wikipedia.org/wiki/ISO_8601#Coordinated_Universal_Time_(UTC)).
   *
   * Sessions that begin before the `fromDate` but end after it are included in the results. For recurring session definitions, this means the `start` value is before the `fromDate` and the `UNTIL` value in the `recurrence` property is after the `fromDate`.
   *
   * Required, unless `query.cursorPaging` is provided.
   */
  fromDate?: InputMaybe<Scalars['String']>;
  /**
   * Whether to include sessions imported from connected external calendars in the results.
   *
   * Default: `false`.
   */
  includeExternal?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to return only single session instances and instances of recurring sessions.
   *
   * If `true`, only single session instances and instances of recurring sessions are returned.
   *
   * If `false`, only recurring session definitions are returned. **Note:** Cursor pagination is not supported for recurring session definition queries.
   *
   * Default: `true`.
   */
  instances?: InputMaybe<Scalars['Boolean']>;
  /** Query options. */
  query?: InputMaybe<ComWixBookingsCalendarApiV2UpstreamWixCommonQueryV2Input>;
  /**
   * End of the time range for which sessions are returned, in [ISO 8601 format](https://en.wikipedia.org/wiki/ISO_8601#Coordinated_Universal_Time_(UTC)).
   *
   * Sessions that begin before the `toDate` but end after it are included in the results. For recurring session definitions, this means the `start` value is before the `toDate` and the `UNTIL` value in the `recurrence` property is after the `toDate`.
   *
   * Required, unless `query.cursorPaging` is provided.
   *
   * Max: 1 year after `fromDate` for session instance queries. This limit doesn't apply to recurring session definition queries.
   */
  toDate?: InputMaybe<Scalars['String']>;
  /**
   * Type of sessions to return.
   * + `EVENT`: Returns only sessions of type `EVENT`.
   * + `WORKING_HOURS`: Returns only sessions of type `WORKING_HOURS`.
   * + `ALL`: Returns sessions of all types.
   *
   * Default: `EVENT`.
   */
  type?: InputMaybe<ComWixBookingsCalendarApiV2QuerySessionsRequestSessionTypeFilter>;
};

export enum ComWixBookingsCalendarApiV2QuerySessionsRequestSessionTypeFilter {
  /** Return sessions of any type. */
  ALL = 'ALL',
  /** Filter sessions of type `EVENT`. This is the default. */
  EVENT = 'EVENT',
  UNKNOWN_SESSION_TYPE = 'UNKNOWN_SESSION_TYPE',
  /** Filter sessions of type `WORKING_HOURS`. */
  WORKING_HOURS = 'WORKING_HOURS'
}

export type ComWixBookingsCalendarApiV2QuerySessionsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixBookingsSchedulesApiV1Session>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixBookingsCalendarApiV2UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /**
   * Number of sessions to return.
   *
   * Default: `100`
   * Max: `1000`
   */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixBookingsCalendarApiV2UpstreamWixCommonQueryV2Input = {
  /**
   * Cursor token pointing to a page of results.
   * Not used in the first request.
   * Following requests use the cursor token and not `filter`.
   */
  cursorPaging?: InputMaybe<ComWixBookingsCalendarApiV2UpstreamWixCommonCursorPagingInput>;
  /**
   * Predefined sets of fields to return.
   * - `NO_PI`: Returns session objects without personal information.
   * - `ALL_PI`: Returns complete session objects, including personal information. Requires the Read Bookings Calendar - Including Participants or the Manage Bookings Services and Settings or the Manage Business Calendar [permission scope](https://devforum.wix.com/kb/en/article/available-permissions).
   *
   * Default: `NO_PI`
   */
  fieldsets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter object. For field support for filters, see
   * [Sessions: Supported Filters](./filtering).
   * See [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) for more information about querying with filters.
   */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type ComWixBookingsCommonApiV1Location = {
  /** Free text address used when locationType is `OWNER_CUSTOM`. */
  address?: Maybe<Scalars['String']>;
  /**
   * The Wix Business location formatted address.
   * Valid when `locationType` is `OWNER_BUSINESS`. Defaults to the business's location.
   * To retrieve the full location data please use the [Locations API](https://dev.wix.com/api/rest/business-info/locations).
   */
  businessLocation?: Maybe<ComWixpressLocationsLocation>;
  /** Custom address, used when locationType is `"OWNER_CUSTOM"`. Might be used when locationType is `"CUSTOM"` in case the owner sets a custom address for the session which is different from the default. */
  customAddress?: Maybe<ComWixBookingsUpstreamWixCommonAddress>;
  /**
   * Location type.
   * One of:
   * - `"OWNER_BUSINESS"` The business address as set in the site’s general settings.
   * - `"OWNER_CUSTOM"` The address as set when creating the service.
   * - `"CUSTOM"` The address set for the individual session.
   */
  locationType?: Maybe<ComWixBookingsCommonApiV1LocationLocationType>;
};

export type ComWixBookingsCommonApiV1LocationInput = {
  /** Free text address used when locationType is `OWNER_CUSTOM`. */
  address?: InputMaybe<Scalars['String']>;
  /**
   * The Wix Business location formatted address.
   * Valid when `locationType` is `OWNER_BUSINESS`. Defaults to the business's location.
   * To retrieve the full location data please use the [Locations API](https://dev.wix.com/api/rest/business-info/locations).
   */
  businessLocation?: InputMaybe<ComWixpressLocationsLocationInput>;
  /** Custom address, used when locationType is `"OWNER_CUSTOM"`. Might be used when locationType is `"CUSTOM"` in case the owner sets a custom address for the session which is different from the default. */
  customAddress?: InputMaybe<ComWixBookingsUpstreamWixCommonAddressInput>;
  /**
   * Location type.
   * One of:
   * - `"OWNER_BUSINESS"` The business address as set in the site’s general settings.
   * - `"OWNER_CUSTOM"` The address as set when creating the service.
   * - `"CUSTOM"` The address set for the individual session.
   */
  locationType?: InputMaybe<ComWixBookingsCommonApiV1LocationLocationType>;
};

export enum ComWixBookingsCommonApiV1LocationLocationType {
  CUSTOM = 'CUSTOM',
  OWNER_BUSINESS = 'OWNER_BUSINESS',
  OWNER_CUSTOM = 'OWNER_CUSTOM',
  UNDEFINED = 'UNDEFINED'
}

export type ComWixBookingsCommonApiV1Price = {
  /** Required payment amount. */
  amount?: Maybe<Scalars['String']>;
  /** Currency in which the amount is quoted. */
  currency?: Maybe<Scalars['String']>;
  /** Amount of a down payment or deposit as part of the transaction. */
  downPayAmount?: Maybe<Scalars['String']>;
};

export type ComWixBookingsCommonApiV1PriceInput = {
  /** Required payment amount. */
  amount?: InputMaybe<Scalars['String']>;
  /** Currency in which the amount is quoted. */
  currency?: InputMaybe<Scalars['String']>;
  /** Amount of a down payment or deposit as part of the transaction. */
  downPayAmount?: InputMaybe<Scalars['String']>;
};

export type ComWixBookingsCommonApiV1QueryMetaData = {
  items?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ComWixBookingsCommonApiV1Rate = {
  /**
   * Default service price. Always vailable when a service has
   * [variants](https://dev.wix.com/api/rest/wix-bookings/service-options-and-variants/introduction).
   * Sometimes also available for services without variants.
   * Ignored in [updates to a service](https://dev.wix.com/api/rest/wix-bookings/services/service/update-service),
   * when either `labeled_price_options` or `price_text` is also specified.
   */
  defaultVariedPrice?: Maybe<ComWixBookingsCommonApiV1Price>;
  /**
   * Mapping between a named price option, for example, adult or child prices, and the price, currency, and down payment amount.
   * When present in an update request, the `default_varied_price` is ignored to support backward compatibility.
   */
  labeledPriceOptions?: Maybe<ComWixBookingsCommonApiV1Price>;
  /**
   * Textual price information used when **Price Per Session** is set to **Custom Price** in the app's service details page.
   * When present in an update request, the `default_varied_price` is ignored to support backward compatibility.
   */
  priceText?: Maybe<Scalars['String']>;
};

export type ComWixBookingsCommonApiV1RateInput = {
  /**
   * Default service price. Always vailable when a service has
   * [variants](https://dev.wix.com/api/rest/wix-bookings/service-options-and-variants/introduction).
   * Sometimes also available for services without variants.
   * Ignored in [updates to a service](https://dev.wix.com/api/rest/wix-bookings/services/service/update-service),
   * when either `labeled_price_options` or `price_text` is also specified.
   */
  defaultVariedPrice?: InputMaybe<ComWixBookingsCommonApiV1PriceInput>;
  /**
   * Mapping between a named price option, for example, adult or child prices, and the price, currency, and down payment amount.
   * When present in an update request, the `default_varied_price` is ignored to support backward compatibility.
   */
  labeledPriceOptions?: InputMaybe<ComWixBookingsCommonApiV1PriceInput>;
  /**
   * Textual price information used when **Price Per Session** is set to **Custom Price** in the app's service details page.
   * When present in an update request, the `default_varied_price` is ignored to support backward compatibility.
   */
  priceText?: InputMaybe<Scalars['String']>;
};

export enum ComWixBookingsExternalcalendarSpiV1CalendarTypeEnumCalendarType {
  /** [Google Calendar](https://developers.google.com/calendar/api/guides/overview). */
  GOOGLE = 'GOOGLE',
  /** Apple iCalendar. */
  I_CAL = 'I_CAL',
  /** Microsoft Calendar. For example, Office 365 calendar or Outlook calendar. */
  MICROSOFT = 'MICROSOFT',
  /** __Deprecated__. Use `MICROSOFT` instead. */
  OFFICE_365 = 'OFFICE_365',
  /** A different type of external calendar, not listed here. */
  OTHER = 'OTHER',
  /** __Deprecated__. Use `MICROSOFT` instead. */
  OUTLOOK = 'OUTLOOK',
  /** There is no information about the external calendar type. */
  UNDEFINED = 'UNDEFINED'
}

export type ComWixBookingsSchedulesApiV1Availability = {
  /** Constraints for calculating the schedule's availability. */
  constraints?: Maybe<ComWixBookingsSchedulesApiV1AvailabilityConstraints>;
  /** Date and time the schedule stops being available for booking. No value indicates no end time. */
  end?: Maybe<Scalars['String']>;
  /** Other schedules that impact the availability calculation. Relevant only when there are availability constraints. */
  linkedSchedules?: Maybe<Array<Maybe<ComWixBookingsSchedulesApiV1LinkedSchedule>>>;
  /**
   * Not supported yet.
   * A list of possible locations for the session when `use_default_location` is set to `false`. Slots are generated for each location. Only one of the possible locations can be chosen by the customer.
   *
   * **NOTE**: When using the `locations` parameter, the default location is not automatically included in the list.
   */
  locations?: Maybe<Array<Maybe<ComWixBookingsCommonApiV1Location>>>;
  /** Date and time the schedule starts to be available for booking. */
  start?: Maybe<Scalars['String']>;
  /**
   * Not supported yet.
   * Whether the schedule's slots are only available at the schedule's default location, as set in `schedule.location`. If set to `false`, the `locations` array is used to set the possible locations of the schedule's sessions.
   * Default is `true`.
   */
  useDefaultLocation?: Maybe<Scalars['Boolean']>;
};

export type ComWixBookingsSchedulesApiV1AvailabilityConstraints = {
  /**
   * A list of duration options for slots, in minutes. Minimum value for a duration is 1.
   * The availability calculation generates slots with these durations, where there is no conflict with existing sessions or other availability constraints.
   */
  slotDurations?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** An object defining the time between available slots' start times.  For example, a slot with slots_split_interval=5 can start every 5 minutes. The default is the slot duration. */
  slotsSplitInterval?: Maybe<ComWixBookingsSchedulesApiV1SplitInterval>;
  /**
   * Specify how to split the slots in intervals of minutes.
   * This value indicates the time between available slots' start time. e.g., from 5 minute slots (3:00, 3:05, 3:15) and 1 hour slots (3:00, 4:00, 5:00).
   * Optional. The default is the first duration in slot_durations field.
   * Deprecated. Use the `split_slots_interval.value_in_minutes`.
   */
  splitInterval?: Maybe<Scalars['Int']>;
  /**
   * The number of minutes between the `end` of one slot, and the `start` of the next.
   * Minimum value is 0, maximum value is 120.
   */
  timeBetweenSlots?: Maybe<Scalars['Int']>;
};

export type ComWixBookingsSchedulesApiV1AvailabilityConstraintsInput = {
  /**
   * A list of duration options for slots, in minutes. Minimum value for a duration is 1.
   * The availability calculation generates slots with these durations, where there is no conflict with existing sessions or other availability constraints.
   */
  slotDurations?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** An object defining the time between available slots' start times.  For example, a slot with slots_split_interval=5 can start every 5 minutes. The default is the slot duration. */
  slotsSplitInterval?: InputMaybe<ComWixBookingsSchedulesApiV1SplitIntervalInput>;
  /**
   * Specify how to split the slots in intervals of minutes.
   * This value indicates the time between available slots' start time. e.g., from 5 minute slots (3:00, 3:05, 3:15) and 1 hour slots (3:00, 4:00, 5:00).
   * Optional. The default is the first duration in slot_durations field.
   * Deprecated. Use the `split_slots_interval.value_in_minutes`.
   */
  splitInterval?: InputMaybe<Scalars['Int']>;
  /**
   * The number of minutes between the `end` of one slot, and the `start` of the next.
   * Minimum value is 0, maximum value is 120.
   */
  timeBetweenSlots?: InputMaybe<Scalars['Int']>;
};

export type ComWixBookingsSchedulesApiV1AvailabilityInput = {
  /** Constraints for calculating the schedule's availability. */
  constraints?: InputMaybe<ComWixBookingsSchedulesApiV1AvailabilityConstraintsInput>;
  /** Date and time the schedule stops being available for booking. No value indicates no end time. */
  end?: InputMaybe<Scalars['String']>;
  /** Other schedules that impact the availability calculation. Relevant only when there are availability constraints. */
  linkedSchedules?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1LinkedScheduleInput>>>;
  /**
   * Not supported yet.
   * A list of possible locations for the session when `use_default_location` is set to `false`. Slots are generated for each location. Only one of the possible locations can be chosen by the customer.
   *
   * **NOTE**: When using the `locations` parameter, the default location is not automatically included in the list.
   */
  locations?: InputMaybe<Array<InputMaybe<ComWixBookingsCommonApiV1LocationInput>>>;
  /** Date and time the schedule starts to be available for booking. */
  start?: InputMaybe<Scalars['String']>;
  /**
   * Not supported yet.
   * Whether the schedule's slots are only available at the schedule's default location, as set in `schedule.location`. If set to `false`, the `locations` array is used to set the possible locations of the schedule's sessions.
   * Default is `true`.
   */
  useDefaultLocation?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixBookingsSchedulesApiV1AvailabilityPolicyInput = {
  /** Specify how to split the schedule slots in intervals of minutes. */
  splitInterval?: InputMaybe<ComWixBookingsSchedulesApiV1SplitIntervalInput>;
};

export type ComWixBookingsSchedulesApiV1AvailabilityPolicyUpdatedInput = {
  availabilityPolicy?: InputMaybe<ComWixBookingsSchedulesApiV1AvailabilityPolicyInput>;
};

export type ComWixBookingsSchedulesApiV1BatchRequestInput = {
  /**
   * Cancel multiple schedules.
   * The given schedules move to a CANCELLED status which means that all sessions up until
   * the cancellation point in time are kept, while removing all following sessions.
   */
  cancelRequests?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1CancelScheduleRequestInput>>>;
  /** Create multiple schedules. */
  createRequests?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1CreateScheduleRequestInput>>>;
  /** Update multiple schedules. Not Supported yet. */
  updateRequests?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1UpdateScheduleRequestInput>>>;
};

export type ComWixBookingsSchedulesApiV1BatchResponse = {
  /** Cancelled schedules. */
  cancelled?: Maybe<Array<Maybe<ComWixBookingsSchedulesApiV1Schedule>>>;
  /** Created schedules. */
  created?: Maybe<Array<Maybe<ComWixBookingsSchedulesApiV1Schedule>>>;
  /** Updated schedules. */
  updated?: Maybe<Array<Maybe<ComWixBookingsSchedulesApiV1Schedule>>>;
};

export type ComWixBookingsSchedulesApiV1CalendarConference = {
  /** ID of the account owner in the video conferencing service. */
  accountOwnerId?: Maybe<Scalars['String']>;
  /** A generated id for the conference entity - Base62($providerId$accountOwnerId$conferenceId) */
  conferenceId?: Maybe<Scalars['String']>;
  /** Conference type. */
  conferenceType?: Maybe<ComWixBookingsSchedulesApiV1CalendarConferenceConferenceType>;
  /** Conference description. */
  description?: Maybe<Scalars['String']>;
  /** Conference meeting ID in the provider's conferencing system. */
  externalId?: Maybe<Scalars['String']>;
  /** URL used by a guest to join the conference. */
  guestUrl?: Maybe<Scalars['String']>;
  /** URL used by the host to start the conference. */
  hostUrl?: Maybe<Scalars['String']>;
  /** Wix Calendar conference ID. */
  id?: Maybe<Scalars['String']>;
  /** Password to join the conference. */
  password?: Maybe<Scalars['String']>;
  /** Conference provider ID. */
  providerId?: Maybe<Scalars['String']>;
};

export enum ComWixBookingsSchedulesApiV1CalendarConferenceConferenceType {
  /** User-defined meeting. */
  CUSTOM = 'CUSTOM',
  /** API-generated online meeting. */
  ONLINE_MEETING_PROVIDER = 'ONLINE_MEETING_PROVIDER',
  /** Undefined conference type. */
  UNDEFINED = 'UNDEFINED'
}

export type ComWixBookingsSchedulesApiV1CalendarConferenceInput = {
  /** ID of the account owner in the video conferencing service. */
  accountOwnerId?: InputMaybe<Scalars['String']>;
  /** A generated id for the conference entity - Base62($providerId$accountOwnerId$conferenceId) */
  conferenceId?: InputMaybe<Scalars['String']>;
  /** Conference type. */
  conferenceType?: InputMaybe<ComWixBookingsSchedulesApiV1CalendarConferenceConferenceType>;
  /** Conference description. */
  description?: InputMaybe<Scalars['String']>;
  /** Conference meeting ID in the provider's conferencing system. */
  externalId?: InputMaybe<Scalars['String']>;
  /** URL used by a guest to join the conference. */
  guestUrl?: InputMaybe<Scalars['String']>;
  /** URL used by the host to start the conference. */
  hostUrl?: InputMaybe<Scalars['String']>;
  /** Wix Calendar conference ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Password to join the conference. */
  password?: InputMaybe<Scalars['String']>;
  /** Conference provider ID. */
  providerId?: InputMaybe<Scalars['String']>;
};

export type ComWixBookingsSchedulesApiV1CalendarDateTime = {
  /** An object containing the local date and time for the business's time zone. */
  localDateTime?: Maybe<ComWixBookingsSchedulesApiV1LocalDateTime>;
  /**
   * The time zone. Optional. Derived from the schedule's time zone.
   * In case this field is associated with recurring session, this field is empty.
   */
  timeZone?: Maybe<Scalars['String']>;
  /**
   * UTC date-time in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601#Coordinated_Universal_Time_(UTC)) format. If a time zone offset is specified, the time is converted to UTC. For example, if you specify  `new Date('2021-01-06T16:00:00.000-07:00')`, the stored value will be `"2021-01-06T23:00:00.000Z"`.
   * Required if `localDateTime` is not specified.
   * If `localDateTime` is specified, `timestamp` is calculated as `localDateTime`, using the business's time zone.
   */
  timestamp?: Maybe<Scalars['String']>;
};

export type ComWixBookingsSchedulesApiV1CalendarDateTimeInput = {
  /** An object containing the local date and time for the business's time zone. */
  localDateTime?: InputMaybe<ComWixBookingsSchedulesApiV1LocalDateTimeInput>;
  /**
   * The time zone. Optional. Derived from the schedule's time zone.
   * In case this field is associated with recurring session, this field is empty.
   */
  timeZone?: InputMaybe<Scalars['String']>;
  /**
   * UTC date-time in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601#Coordinated_Universal_Time_(UTC)) format. If a time zone offset is specified, the time is converted to UTC. For example, if you specify  `new Date('2021-01-06T16:00:00.000-07:00')`, the stored value will be `"2021-01-06T23:00:00.000Z"`.
   * Required if `localDateTime` is not specified.
   * If `localDateTime` is specified, `timestamp` is calculated as `localDateTime`, using the business's time zone.
   */
  timestamp?: InputMaybe<Scalars['String']>;
};

export type ComWixBookingsSchedulesApiV1CancelScheduleRequestInput = {
  /** Time to cancel the sessions from. Optional. If this field is empty, all of this schedule's sessions will be canceled. */
  from?: InputMaybe<Scalars['String']>;
  /** Deprecated, use participant_notification */
  notifyParticipants?: InputMaybe<Scalars['Boolean']>;
  /** Whether to notify participants about the change, and an optional custom message. */
  participantNotification?: InputMaybe<ComWixBookingsSchedulesApiV1ParticipantNotificationInput>;
  /** Whether to preserve future sessions with reservations. Defaults to false. */
  preserveFutureSessionsWithParticipants?: InputMaybe<Scalars['Boolean']>;
  /** Schedule ID. */
  scheduleId?: InputMaybe<Scalars['String']>;
};

export type ComWixBookingsSchedulesApiV1ConferenceProvider = {
  /** Conferencing provider ID */
  providerId?: Maybe<Scalars['String']>;
};

export type ComWixBookingsSchedulesApiV1ConferenceProviderInput = {
  /** Conferencing provider ID */
  providerId?: InputMaybe<Scalars['String']>;
};

export type ComWixBookingsSchedulesApiV1CreateScheduleRequestInput = {
  /** Optional. Idempotency key. */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** Schedule. */
  schedule?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleInput>;
};

export type ComWixBookingsSchedulesApiV1ExternalCalendarInfo = {
  /** The external calendar type (e.g. Google Calendar, iCal, etc). */
  calendarType?: Maybe<ComWixBookingsExternalcalendarSpiV1CalendarTypeEnumCalendarType>;
};

export type ComWixBookingsSchedulesApiV1ExternalCalendarInfoInput = {
  /** The external calendar type (e.g. Google Calendar, iCal, etc). */
  calendarType?: InputMaybe<ComWixBookingsExternalcalendarSpiV1CalendarTypeEnumCalendarType>;
};

export type ComWixBookingsSchedulesApiV1ExternalCalendarOverrides = {
  /** Synced description of the external calendar event. */
  description?: Maybe<Scalars['String']>;
  /** Synced title of the external calendar event. */
  title?: Maybe<Scalars['String']>;
};

export type ComWixBookingsSchedulesApiV1ExternalCalendarOverridesInput = {
  /** Synced description of the external calendar event. */
  description?: InputMaybe<Scalars['String']>;
  /** Synced title of the external calendar event. */
  title?: InputMaybe<Scalars['String']>;
};

export type ComWixBookingsSchedulesApiV1Frequency = {
  /** The frequency of the recurrence in weeks. i.e. when this value is 4, the interval occurs every 4 weeks. Optional. The default is 1. minimum: 1, maximum: 52. */
  repetition?: Maybe<Scalars['Int']>;
};

export type ComWixBookingsSchedulesApiV1FrequencyInput = {
  /** The frequency of the recurrence in weeks. i.e. when this value is 4, the interval occurs every 4 weeks. Optional. The default is 1. minimum: 1, maximum: 52. */
  repetition?: InputMaybe<Scalars['Int']>;
};

export type ComWixBookingsSchedulesApiV1GetSessionRequestInput = {
  /**
   * Predefined sets of fields to return.
   * - `NO_PI`: Returns session objects without personal information.
   * - `ALL_PI`: Returns complete session objects, including personal information. Requires the CALENDAR.SESSION_READ_PI permission scope.
   *
   * Default: `NO_PI`
   */
  fieldsets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id: Scalars['ID'];
};

export type ComWixBookingsSchedulesApiV1Interval = {
  /** The day the interval occurs. Optional. The default is the day of the recurring interval's start time. */
  daysOfWeek?: Maybe<ComWixBookingsSchedulesApiV1IntervalDay>;
  /** The duration of the interval in minutes. Required. Part of the session end time calculation. */
  duration?: Maybe<Scalars['Int']>;
  /** The hour of the day the interval occurs. Must be consistent with the interval start time. Optional. The default is 0. Minimum: 0, maximum: 23. */
  hourOfDay?: Maybe<Scalars['Int']>;
  /** The minutes of the hour the interval accrues. Must be consistent with the interval end time. Optional. The default is 0. Minimum: 0, maximum: 59. */
  minuteOfHour?: Maybe<Scalars['Int']>;
};

export enum ComWixBookingsSchedulesApiV1IntervalDay {
  /** Friday. */
  FRI = 'FRI',
  /** Monday. */
  MON = 'MON',
  /** Saturday. */
  SAT = 'SAT',
  /** Sunday. */
  SUN = 'SUN',
  /** Thursday. */
  THU = 'THU',
  /** Tuesday. */
  TUE = 'TUE',
  /** Undefined. */
  UNDEFINED = 'UNDEFINED',
  /** Wednesday. */
  WED = 'WED'
}

export type ComWixBookingsSchedulesApiV1IntervalInput = {
  /** The day the interval occurs. Optional. The default is the day of the recurring interval's start time. */
  daysOfWeek?: InputMaybe<ComWixBookingsSchedulesApiV1IntervalDay>;
  /** The duration of the interval in minutes. Required. Part of the session end time calculation. */
  duration?: InputMaybe<Scalars['Int']>;
  /** The hour of the day the interval occurs. Must be consistent with the interval start time. Optional. The default is 0. Minimum: 0, maximum: 23. */
  hourOfDay?: InputMaybe<Scalars['Int']>;
  /** The minutes of the hour the interval accrues. Must be consistent with the interval end time. Optional. The default is 0. Minimum: 0, maximum: 59. */
  minuteOfHour?: InputMaybe<Scalars['Int']>;
};

export type ComWixBookingsSchedulesApiV1IntervalSplitInput = {
  intervals?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1RecurringIntervalInput>>>;
  newScheduleVersion?: InputMaybe<Scalars['Int']>;
  oldScheduleVersion?: InputMaybe<Scalars['Int']>;
  scheduleId?: InputMaybe<Scalars['String']>;
};

export type ComWixBookingsSchedulesApiV1LinkedSchedule = {
  /** Schedule ID. */
  scheduleId?: Maybe<Scalars['String']>;
  /** Owner ID, of the linked schedule. */
  scheduleOwnerId?: Maybe<Scalars['String']>;
  /**
   * The name of the linked schedule owner. It may be a resource name or a service name. Optional.
   * This field is inherited from the schedule identified by scheduleId above.
   */
  scheduleOwnerName?: Maybe<Scalars['String']>;
  /**
   * The user id of the linked schedule owner. Optional.
   * This field is inherited from the schedule identified by scheduleId above.
   * NOT IMPLEMENTED. YET.
   */
  scheduleOwnerUserId?: Maybe<Scalars['String']>;
  /** Sets this schedule's availability for the duration of the linked schedule's sessions. Default is `"BUSY"`. */
  transparency?: Maybe<ComWixBookingsSchedulesApiV1LinkedScheduleTransparency>;
};

export type ComWixBookingsSchedulesApiV1LinkedScheduleInput = {
  /** Schedule ID. */
  scheduleId?: InputMaybe<Scalars['String']>;
  /** Owner ID, of the linked schedule. */
  scheduleOwnerId?: InputMaybe<Scalars['String']>;
  /**
   * The name of the linked schedule owner. It may be a resource name or a service name. Optional.
   * This field is inherited from the schedule identified by scheduleId above.
   */
  scheduleOwnerName?: InputMaybe<Scalars['String']>;
  /**
   * The user id of the linked schedule owner. Optional.
   * This field is inherited from the schedule identified by scheduleId above.
   * NOT IMPLEMENTED. YET.
   */
  scheduleOwnerUserId?: InputMaybe<Scalars['String']>;
  /** Sets this schedule's availability for the duration of the linked schedule's sessions. Default is `"BUSY"`. */
  transparency?: InputMaybe<ComWixBookingsSchedulesApiV1LinkedScheduleTransparency>;
};

export enum ComWixBookingsSchedulesApiV1LinkedScheduleTransparency {
  /** The schedule can't have available slots during the linked schedule's sessions. */
  BUSY = 'BUSY',
  /** The schedule can have available slots during the linked schedule's sessions. */
  FREE = 'FREE',
  UNDEFINED = 'UNDEFINED'
}

export type ComWixBookingsSchedulesApiV1LocalDateTime = {
  /** Day of the month, from 1-31. */
  dayOfMonth?: Maybe<Scalars['Int']>;
  /** Hour of the day in 24-hour format, from 0-23. */
  hourOfDay?: Maybe<Scalars['Int']>;
  /** Minute, from 0-59. */
  minutesOfHour?: Maybe<Scalars['Int']>;
  /** Month number, from 1-12. */
  monthOfYear?: Maybe<Scalars['Int']>;
  /** Year. 4-digit format. */
  year?: Maybe<Scalars['Int']>;
};

export type ComWixBookingsSchedulesApiV1LocalDateTimeInput = {
  /** Day of the month, from 1-31. */
  dayOfMonth?: InputMaybe<Scalars['Int']>;
  /** Hour of the day in 24-hour format, from 0-23. */
  hourOfDay?: InputMaybe<Scalars['Int']>;
  /** Minute, from 0-59. */
  minutesOfHour?: InputMaybe<Scalars['Int']>;
  /** Month number, from 1-12. */
  monthOfYear?: InputMaybe<Scalars['Int']>;
  /** Year. 4-digit format. */
  year?: InputMaybe<Scalars['Int']>;
};

export type ComWixBookingsSchedulesApiV1MigrationDataInput = {
  businessId?: InputMaybe<Scalars['String']>;
  staffs?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1MigrationDataStaffDataInput>>>;
};

export type ComWixBookingsSchedulesApiV1MigrationDataStaffDataInput = {
  refreshToken?: InputMaybe<Scalars['String']>;
  resourceId?: InputMaybe<Scalars['String']>;
  syncRequestEmail?: InputMaybe<Scalars['String']>;
};

export type ComWixBookingsSchedulesApiV1MigrationEventInput = {
  migrationData?: InputMaybe<ComWixBookingsSchedulesApiV1MigrationDataInput>;
};

export type ComWixBookingsSchedulesApiV1MultipleSessionsCreatedInput = {
  schedulesWithSessions?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1ScheduleWithSessionsInput>>>;
};

export type ComWixBookingsSchedulesApiV1Participant = {
  /**
   * Approval status for the participant.
   * <!-- Commented out untill updateParticipant is exposed Generally the same status as the booking, unless updated using the `updateParticipant()` API. Defaults to `"UNDEFINED"`.-->
   */
  approvalStatus?: Maybe<ComWixBookingsSchedulesApiV1ParticipantApprovalStatus>;
  /** Contact ID. */
  contactId?: Maybe<Scalars['String']>;
  /** Participant's email address. */
  email?: Maybe<Scalars['String']>;
  /** Participant ID. Currently represents the booking.id. */
  id?: Maybe<Scalars['String']>;
  /** Whether the participant was inherited from the schedule, as opposed to being booked directly to the session. */
  inherited?: Maybe<Scalars['Boolean']>;
  /** Participant's name. */
  name?: Maybe<Scalars['String']>;
  /** Group or party size. The number of people attending. Defaults to 0. Maximum is 250. */
  partySize?: Maybe<Scalars['Int']>;
  /** Participant's phone number. */
  phone?: Maybe<Scalars['String']>;
};

export enum ComWixBookingsSchedulesApiV1ParticipantApprovalStatus {
  /** Approved by the business. */
  APPROVED = 'APPROVED',
  /** Declined by the business. */
  DECLINED = 'DECLINED',
  /** Pending business approval. */
  PENDING = 'PENDING',
  /** Default. */
  UNDEFINED = 'UNDEFINED'
}

export type ComWixBookingsSchedulesApiV1ParticipantInput = {
  /**
   * Approval status for the participant.
   * <!-- Commented out untill updateParticipant is exposed Generally the same status as the booking, unless updated using the `updateParticipant()` API. Defaults to `"UNDEFINED"`.-->
   */
  approvalStatus?: InputMaybe<ComWixBookingsSchedulesApiV1ParticipantApprovalStatus>;
  /** Contact ID. */
  contactId?: InputMaybe<Scalars['String']>;
  /** Participant's email address. */
  email?: InputMaybe<Scalars['String']>;
  /** Participant ID. Currently represents the booking.id. */
  id?: InputMaybe<Scalars['String']>;
  /** Whether the participant was inherited from the schedule, as opposed to being booked directly to the session. */
  inherited?: InputMaybe<Scalars['Boolean']>;
  /** Participant's name. */
  name?: InputMaybe<Scalars['String']>;
  /** Group or party size. The number of people attending. Defaults to 0. Maximum is 250. */
  partySize?: InputMaybe<Scalars['Int']>;
  /** Participant's phone number. */
  phone?: InputMaybe<Scalars['String']>;
};

export type ComWixBookingsSchedulesApiV1ParticipantNotificationInput = {
  /** Custom message to send to the participants about the changes to the booking. */
  message?: InputMaybe<Scalars['String']>;
  /**
   * Optional additional metadata.
   * Supported only in V3 APIs.
   */
  metadata?: InputMaybe<Scalars['JSON']>;
  /**
   * Whether to send the message about the changes to the customer.
   *
   * Default: `false`
   */
  notifyParticipants?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixBookingsSchedulesApiV1RecurringInterval = {
  /** Specifies the list of linked schedules and the way this link affects the corresponding schedules' availability. Can be calculated from the schedule or overridden on the recurring interval. */
  affectedSchedules?: Maybe<Array<Maybe<ComWixBookingsSchedulesApiV1LinkedSchedule>>>;
  /** The end time of the recurring interval. Optional. Empty value indicates that there is no end time. */
  end?: Maybe<Scalars['String']>;
  /** The frequency of the interval. Optional. The default is frequency with the default repetition. */
  frequency?: Maybe<ComWixBookingsSchedulesApiV1Frequency>;
  /** The recurring interval identifier. */
  id?: Maybe<Scalars['String']>;
  /** The interval rules. The day, hour and minutes the interval is recurring. */
  interval?: Maybe<ComWixBookingsSchedulesApiV1Interval>;
  /** The type of recurring interval. */
  intervalType?: Maybe<ComWixBookingsSchedulesApiV1RecurringIntervalRecurringIntervalType>;
  /** The start time of the recurring interval. Required. */
  start?: Maybe<Scalars['String']>;
};

export type ComWixBookingsSchedulesApiV1RecurringIntervalInput = {
  /** Specifies the list of linked schedules and the way this link affects the corresponding schedules' availability. Can be calculated from the schedule or overridden on the recurring interval. */
  affectedSchedules?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1LinkedScheduleInput>>>;
  /** The end time of the recurring interval. Optional. Empty value indicates that there is no end time. */
  end?: InputMaybe<Scalars['String']>;
  /** The frequency of the interval. Optional. The default is frequency with the default repetition. */
  frequency?: InputMaybe<ComWixBookingsSchedulesApiV1FrequencyInput>;
  /** The recurring interval identifier. */
  id?: InputMaybe<Scalars['String']>;
  /** The interval rules. The day, hour and minutes the interval is recurring. */
  interval?: InputMaybe<ComWixBookingsSchedulesApiV1IntervalInput>;
  /** The type of recurring interval. */
  intervalType?: InputMaybe<ComWixBookingsSchedulesApiV1RecurringIntervalRecurringIntervalType>;
  /** The start time of the recurring interval. Required. */
  start?: InputMaybe<Scalars['String']>;
};

export enum ComWixBookingsSchedulesApiV1RecurringIntervalRecurringIntervalType {
  /** A recurring interval for availability. */
  AVAILABILITY = 'AVAILABILITY',
  /** A recurring interval of events. */
  EVENT = 'EVENT',
  /** Deprecated. */
  TIME_AVAILABILITY = 'TIME_AVAILABILITY',
  /** The default value. Sessions for this interval will be of type EVENT. */
  UNDEFINED = 'UNDEFINED'
}

export type ComWixBookingsSchedulesApiV1RecurringSessionSplitInput = {
  newScheduleVersion?: InputMaybe<Scalars['Int']>;
  oldScheduleVersion?: InputMaybe<Scalars['Int']>;
  recurringSessions?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1SessionInput>>>;
  scheduleId?: InputMaybe<Scalars['String']>;
};

export type ComWixBookingsSchedulesApiV1RecurringSessionsUpdatedInput = {
  /** New schedule's recurring session list. */
  newRecurringSessions?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1SessionInput>>>;
  /** Old schedule's recurring session list. */
  oldRecurringSessions?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1SessionInput>>>;
};

export type ComWixBookingsSchedulesApiV1Schedule = {
  /** __Deprecated.__ */
  availability?: Maybe<ComWixBookingsSchedulesApiV1Availability>;
  /**
   * A conference created for the schedule. This is used when a participant is added to a schedule.
   * **Partially deprecated.** Only `hostUrl` and `guestUrl` are to be supported.
   */
  calendarConference?: Maybe<ComWixBookingsSchedulesApiV1CalendarConference>;
  /**
   * Maximum number of participants that can be added to the schedule's sessions.
   * Must be at most `1` for schedule whose availability is affected by another schedule. E.g, appointment schedules of the Wix Bookings app.
   */
  capacity?: Maybe<Scalars['Int']>;
  /** __Deprecated.__ */
  conferenceProvider?: Maybe<ComWixBookingsSchedulesApiV1ConferenceProvider>;
  /** Schedule creation date. */
  created?: Maybe<Scalars['String']>;
  /** __Deprecated.__ */
  externalCalendarOverrides?: Maybe<ComWixBookingsSchedulesApiV1ExternalCalendarOverrides>;
  /** Start time of the first session in the schedule. */
  firstSessionStart?: Maybe<Scalars['String']>;
  /** Schedule ID. */
  id?: Maybe<Scalars['String']>;
  /** Fields which were inherited from the Business Info page under Settings in the Dashboard. */
  inheritedFields?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Deprecated. Please use the [Sessions API](https://dev.wix.com/api/rest/wix-bookings/schedules-and-sessions/session) instead. */
  intervals?: Maybe<Array<Maybe<ComWixBookingsSchedulesApiV1RecurringInterval>>>;
  /** End time of the last session in the schedule. */
  lastSessionEnd?: Maybe<Scalars['String']>;
  /** Default location for the schedule's sessions. */
  location?: Maybe<ComWixBookingsCommonApiV1Location>;
  /**
   * *Partial list** of participants which are registered to sessions in this schedule.
   * Participants who are registered in the schedule are automatically registered to any session that is created for the schedule.
   * To retrieve the full list of schedule participants please use the [Query Extended Bookings API](https://dev.wix.com/api/rest/wix-bookings/bookings-reader-v2/query-extended-bookings).
   */
  participants?: Maybe<Array<Maybe<ComWixBookingsSchedulesApiV1Participant>>>;
  /** Deprecated. Please use the [Booking Services V2](https://dev.wix.com/api/rest/wix-bookings/services-v2) payment instead. */
  rate?: Maybe<ComWixBookingsCommonApiV1Rate>;
  /** ID of the schedule's owner entity. This may be a resource ID or a service ID. */
  scheduleOwnerId?: Maybe<Scalars['String']>;
  /** The name of the schedule owner. It may be a resource name or a service name. Optional. */
  scheduleOwnerName?: Maybe<Scalars['String']>;
  /**
   * The user id of the schedule owner. Optional.
   * Currently, in Bookings system, it would be present when the schedule is owned by a staff resource and the resource is connected to a user.
   * NOT IMPLEMENTED. YET.
   */
  scheduleOwnerUserId?: Maybe<Scalars['String']>;
  /** Schedule status. Default: Created */
  status?: Maybe<ComWixBookingsSchedulesApiV1ScheduleScheduleStatus>;
  /**
   * __Deprecated.__
   * Tags for grouping schedules. These tags are the default tags for the schedule's sessions.
   * The Wix Bookings app uses the following predefined tags to set schedule type: `"INDIVIDUAL"`, `"GROUP"`, and `"COURSE"`. Once the schedule type is set using these tags, you cannot update it. In addition to the app's tags, you can create and update your own tags.
   */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Schedule's time zone in [Area/Location](https://en.wikipedia.org/wiki/Tz_database) format. Read-only.
   * Derived from the Wix Business time zone.
   */
  timeZone?: Maybe<Scalars['String']>;
  /** Default title for the schedule's sessions. Maximum length: 6000 characters. */
  title?: Maybe<Scalars['String']>;
  /** Number of participants registered to sessions in this schedule, calculated as the sum of the party sizes. */
  totalNumberOfParticipants?: Maybe<Scalars['Int']>;
  /** Schedule last update date. */
  updated?: Maybe<Scalars['String']>;
  /** Schedule version number, updated each time the schedule is updated. */
  version?: Maybe<Scalars['Int']>;
  /** The schedule version, updated each time the schedule or the schedule participants are updated. */
  versions?: Maybe<ComWixBookingsSchedulesApiV1ScheduleVersion>;
};

export type ComWixBookingsSchedulesApiV1ScheduleCancelledInput = {
  oldSchedule?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleInput>;
  /** Whether to notify participants about the change and an optional custom message */
  participantNotification?: InputMaybe<ComWixBookingsSchedulesApiV1ParticipantNotificationInput>;
  schedule?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleInput>;
};

export type ComWixBookingsSchedulesApiV1ScheduleCreatedInput = {
  schedule?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleInput>;
};

export type ComWixBookingsSchedulesApiV1ScheduleInput = {
  /** __Deprecated.__ */
  availability?: InputMaybe<ComWixBookingsSchedulesApiV1AvailabilityInput>;
  /**
   * A conference created for the schedule. This is used when a participant is added to a schedule.
   * **Partially deprecated.** Only `hostUrl` and `guestUrl` are to be supported.
   */
  calendarConference?: InputMaybe<ComWixBookingsSchedulesApiV1CalendarConferenceInput>;
  /**
   * Maximum number of participants that can be added to the schedule's sessions.
   * Must be at most `1` for schedule whose availability is affected by another schedule. E.g, appointment schedules of the Wix Bookings app.
   */
  capacity?: InputMaybe<Scalars['Int']>;
  /** __Deprecated.__ */
  conferenceProvider?: InputMaybe<ComWixBookingsSchedulesApiV1ConferenceProviderInput>;
  /** Schedule creation date. */
  created?: InputMaybe<Scalars['String']>;
  /** __Deprecated.__ */
  externalCalendarOverrides?: InputMaybe<ComWixBookingsSchedulesApiV1ExternalCalendarOverridesInput>;
  /** Start time of the first session in the schedule. */
  firstSessionStart?: InputMaybe<Scalars['String']>;
  /** Schedule ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Fields which were inherited from the Business Info page under Settings in the Dashboard. */
  inheritedFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Deprecated. Please use the [Sessions API](https://dev.wix.com/api/rest/wix-bookings/schedules-and-sessions/session) instead. */
  intervals?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1RecurringIntervalInput>>>;
  /** End time of the last session in the schedule. */
  lastSessionEnd?: InputMaybe<Scalars['String']>;
  /** Default location for the schedule's sessions. */
  location?: InputMaybe<ComWixBookingsCommonApiV1LocationInput>;
  /**
   * *Partial list** of participants which are registered to sessions in this schedule.
   * Participants who are registered in the schedule are automatically registered to any session that is created for the schedule.
   * To retrieve the full list of schedule participants please use the [Query Extended Bookings API](https://dev.wix.com/api/rest/wix-bookings/bookings-reader-v2/query-extended-bookings).
   */
  participants?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1ParticipantInput>>>;
  /** Deprecated. Please use the [Booking Services V2](https://dev.wix.com/api/rest/wix-bookings/services-v2) payment instead. */
  rate?: InputMaybe<ComWixBookingsCommonApiV1RateInput>;
  /** ID of the schedule's owner entity. This may be a resource ID or a service ID. */
  scheduleOwnerId?: InputMaybe<Scalars['String']>;
  /** The name of the schedule owner. It may be a resource name or a service name. Optional. */
  scheduleOwnerName?: InputMaybe<Scalars['String']>;
  /**
   * The user id of the schedule owner. Optional.
   * Currently, in Bookings system, it would be present when the schedule is owned by a staff resource and the resource is connected to a user.
   * NOT IMPLEMENTED. YET.
   */
  scheduleOwnerUserId?: InputMaybe<Scalars['String']>;
  /** Schedule status. Default: Created */
  status?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleScheduleStatus>;
  /**
   * __Deprecated.__
   * Tags for grouping schedules. These tags are the default tags for the schedule's sessions.
   * The Wix Bookings app uses the following predefined tags to set schedule type: `"INDIVIDUAL"`, `"GROUP"`, and `"COURSE"`. Once the schedule type is set using these tags, you cannot update it. In addition to the app's tags, you can create and update your own tags.
   */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Schedule's time zone in [Area/Location](https://en.wikipedia.org/wiki/Tz_database) format. Read-only.
   * Derived from the Wix Business time zone.
   */
  timeZone?: InputMaybe<Scalars['String']>;
  /** Default title for the schedule's sessions. Maximum length: 6000 characters. */
  title?: InputMaybe<Scalars['String']>;
  /** Number of participants registered to sessions in this schedule, calculated as the sum of the party sizes. */
  totalNumberOfParticipants?: InputMaybe<Scalars['Int']>;
  /** Schedule last update date. */
  updated?: InputMaybe<Scalars['String']>;
  /** Schedule version number, updated each time the schedule is updated. */
  version?: InputMaybe<Scalars['Int']>;
  /** The schedule version, updated each time the schedule or the schedule participants are updated. */
  versions?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleVersionInput>;
};

export type ComWixBookingsSchedulesApiV1ScheduleNotificationInput = {
  availabilityPolicyUpdated?: InputMaybe<ComWixBookingsSchedulesApiV1AvailabilityPolicyUpdatedInput>;
  instanceId?: InputMaybe<Scalars['String']>;
  intervalSplit?: InputMaybe<ComWixBookingsSchedulesApiV1IntervalSplitInput>;
  /** supported only for schedule migration apis. */
  migrationEvent?: InputMaybe<ComWixBookingsSchedulesApiV1MigrationEventInput>;
  /** supported only for schedule migration apis. */
  multipleSessionsCreated?: InputMaybe<ComWixBookingsSchedulesApiV1MultipleSessionsCreatedInput>;
  /** Whether to notify participants about changed sessions. deprecated, use participant_notification */
  notifyParticipants?: InputMaybe<Scalars['Boolean']>;
  preserveFutureSessionsWithParticipants?: InputMaybe<Scalars['Boolean']>;
  recurringSessionSplit?: InputMaybe<ComWixBookingsSchedulesApiV1RecurringSessionSplitInput>;
  /** true when the schedule belongs to a site that is rolled out to calendar v3 */
  rolledOut?: InputMaybe<Scalars['Boolean']>;
  scheduleCancelled?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleCancelledInput>;
  scheduleCreated?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleCreatedInput>;
  /** Inspect `schedule.scheduleOwnerUserId` on `scheduleUpdated` instead. */
  scheduleUnassignedFromUser?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleUnassignedFromUserInput>;
  scheduleUpdated?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleUpdatedInput>;
  sessionCancelled?: InputMaybe<ComWixBookingsSchedulesApiV1SessionCancelledInput>;
  sessionCreated?: InputMaybe<ComWixBookingsSchedulesApiV1SessionCreatedInput>;
  sessionUpdated?: InputMaybe<ComWixBookingsSchedulesApiV1SessionUpdatedInput>;
  /** site properties. Optional. Given in create schedule notification. */
  siteProperties?: InputMaybe<ComWixBookingsSchedulesApiV1SitePropertiesOnScheduleCreationInput>;
};

export enum ComWixBookingsSchedulesApiV1ScheduleScheduleStatus {
  /** The schedule was cancelled. */
  CANCELLED = 'CANCELLED',
  /** The schedule was created. */
  CREATED = 'CREATED',
  /** Undefined schedule status. */
  UNDEFINED = 'UNDEFINED'
}

export type ComWixBookingsSchedulesApiV1ScheduleUnassignedFromUserInput = {
  /** The schedule that was unassigned from the user. */
  schedule?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleInput>;
  /** The Wix user id. */
  userId?: InputMaybe<Scalars['String']>;
};

export type ComWixBookingsSchedulesApiV1ScheduleUpdatedInput = {
  /** The new schedule after the update. */
  newSchedule?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleInput>;
  /** The old schedule before the update. */
  oldSchedule?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleInput>;
  /** Whether to notify participants about the change and an optional custom message */
  participantNotification?: InputMaybe<ComWixBookingsSchedulesApiV1ParticipantNotificationInput>;
  /**
   * Recurring sessions updated event. If this field is given, the reason for the schedule updated event was
   * updating at least one of the given schedule's recurring sessions.
   * This event is triggered by create/update/delete recurring session apis.
   */
  recurringSessions?: InputMaybe<ComWixBookingsSchedulesApiV1RecurringSessionsUpdatedInput>;
  /**
   * Whether this notification was created as a result of an anonymization request, such as GDPR.
   * An anonymized participant will have the following details:
   * name = "deleted"
   * phone = "deleted"
   * email = "deleted@deleted.com"
   */
  triggeredByAnonymizeRequest?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixBookingsSchedulesApiV1ScheduleVersion = {
  /** Participants version number, updated each time the schedule participants are updated. */
  participantsVersion?: Maybe<Scalars['Int']>;
  /** Schedule version number, updated each time the schedule is updated. */
  scheduleVersion?: Maybe<Scalars['Int']>;
};

export type ComWixBookingsSchedulesApiV1ScheduleVersionInput = {
  /** Participants version number, updated each time the schedule participants are updated. */
  participantsVersion?: InputMaybe<Scalars['Int']>;
  /** Schedule version number, updated each time the schedule is updated. */
  scheduleVersion?: InputMaybe<Scalars['Int']>;
};

export type ComWixBookingsSchedulesApiV1ScheduleWithSessionsInput = {
  schedule?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleInput>;
  sessions?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1SessionInput>>>;
  siteProperties?: InputMaybe<ComWixBookingsSchedulesApiV1SitePropertiesOnScheduleCreationInput>;
};

export type ComWixBookingsSchedulesApiV1Session = {
  /**
   * An object specifying a list of schedules and the way each schedule's availability is affected by the session. For example, the schedule of an instructor is affected by sessions of the class that they instruct.
   * The array is inherited from the schedule and can be overridden even if the session is a recurring session.
   */
  affectedSchedules?: Maybe<Array<Maybe<ComWixBookingsSchedulesApiV1LinkedSchedule>>>;
  /**
   * A conference created for the session according to the details set in the schedule's conference provider information.
   * If the session is a recurring session, this field is inherited from the schedule.
   * **Partially deprecated.** Only `hostUrl` and `guestUrl` are to be supported.
   */
  calendarConference?: Maybe<ComWixBookingsSchedulesApiV1CalendarConference>;
  /**
   * Maximum number of participants that can be added to the session. Defaults to the schedule capacity.
   * The value is inherited from the schedule and can be overridden unless the session is a recurring session.
   */
  capacity?: Maybe<Scalars['Int']>;
  /**
   * An object specifying the end date and time of the session. The `end` time must be after the `start` time and be same type as `start`.
   * If the session is a recurring session, `end` must contain a `localDateTime`.
   */
  end?: Maybe<ComWixBookingsSchedulesApiV1CalendarDateTime>;
  /** The ID of the event in the new Calendar Events V3 API. */
  event?: Maybe<WixCalendarEventsV3Event>;
  /** The ID of the event in the new Calendar Events V3 API. */
  eventId?: Maybe<Scalars['String']>;
  /** Information about the external calendar, if the session originated in an external calendar. */
  externalCalendarInfo?: Maybe<ComWixBookingsSchedulesApiV1ExternalCalendarInfo>;
  /** __Deprecated.__ */
  externalCalendarOverrides?: Maybe<ComWixBookingsSchedulesApiV1ExternalCalendarOverrides>;
  /** Session ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * A list of properties for which values were inherited from the schedule.
   * This does not include participants that were inherited from the schedule.
   */
  inheritedFields?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * A string representing a recurrence rule (RRULE) if the session is an instance of a recurrence pattern.
   * Empty when the session is not an instance of a recurrence rule, or if the session defines a recurrence pattern, and `recurrence` is not empty.
   */
  instanceOfRecurrence?: Maybe<Scalars['String']>;
  /**
   * An object describing the location where the session takes place.
   * Defaults to the schedule location.
   * For single sessions, `session.location.businessLocation` can only be provided for locations that are defined in the schedule using `schedule.location` or `schedule.availability.locations`.
   */
  location?: Maybe<ComWixBookingsCommonApiV1Location>;
  /**
   * Additional information about the session.
   * Notes are not supported for recurring sessions.
   */
  notes?: Maybe<Scalars['String']>;
  /** Original start date and time of the session in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601#Coordinated_Universal_Time_(UTC)) format. */
  originalStart?: Maybe<Scalars['String']>;
  /**
   * *Partial list** list of participants booked for the session.
   * The list includes participants who have registered for this specific session, and participants who have registered for a schedule that includes this session.
   * If the session is a recurring session, this field must be empty.
   * To retrieve the full list of session participants please use the [Query Extended Bookings API](https://dev.wix.com/api/rest/wix-bookings/bookings-reader-v2/query-extended-bookings).
   */
  participants?: Maybe<Array<Maybe<ComWixBookingsSchedulesApiV1Participant>>>;
  /** Deprecated. Please use the [Booking Services V2](https://dev.wix.com/api/rest/wix-bookings/services-v2) payment instead. */
  rate?: Maybe<ComWixBookingsCommonApiV1Rate>;
  /**
   * A string representing a recurrence rule (RRULE) for a recurring session, as defined in [iCalendar RFC 5545](https://icalendar.org/iCalendar-RFC-5545/3-3-10-recurrence-rule.html).
   * If the session is an instance of a recurrence pattern, the `instanceOfRecurrence` property will be contain the recurrence rule and this property will be empty.
   * The RRULE defines a rule for repeating a session.
   * Supported parameters are:
   *
   * |Keyword|Description|Supported values|
   * |--|--|---|
   * |`FREQ`|The frequency at which the session is recurs. Required.|`WEEKLY`|
   * |`INTERVAL`|How often, in terms of `FREQ`, the session recurs. Default is 1. Optional.|
   * |`UNTIL`|The UTC end date and time of the recurrence. Optional.|
   * |`BYDAY`|Day of the week when the event should recur. Required.|One of: `MO`, `TU`, `WE`, `TH`, `FR`, `SA`, `SU`|
   *
   *
   * For example, a session that repeats every second week on a Monday until January 7, 2022 at 8 AM:
   * `"FREQ=WEEKLY;INTERVAL=2;BYDAY=MO;UNTIL=20220107T080000Z"`
   *
   * <!--ORIGINAL COMMENTS:
   * `FREQ` — The frequency with which the session should be repeated (such as DAILY or WEEKLY).
   * Supported `WEEKLY` value is supported.
   * INTERVAL — Works together with FREQ to specify how often the session should be repeated. For example, FREQ=WEEKLY;INTERVAL=2 means once every two weeks. Optional. Default value is 1.
   * COUNT — The number of times this event should be repeated. Not yet supported.
   * UNTIL — The UTC date & time until which the session should be repeated. This parameter is optional. When it is not specified, the event repeats forever.
   * The format is a short ISO date, followed by 'T' and a short time with seconds and without milliseconds, terminated by the UTC designator 'Z'. For example, until Jan. 19th 2018 at 7:00 AM: 'UNTIL=20180119T070000Z'.
   * BYDAY - The days of the week when the event should be repeated. Currently, only a single day is supported. This parameter is mandatory.
   * Possible values are: MO, TU, WE, TH, FR, SA, SU
   * Note that DTSTART and DTEND lines are not allowed in this field; session start and end times are specified in the start and end fields.
   * **Example**: FREQ=WEEKLY;INTERVAL=2;BYDAY=MO;UNTIL=20200427T070000Z
   * ORIGINAL COMMENTS-->
   */
  recurrence?: Maybe<Scalars['String']>;
  /**
   * Recurring interval ID. Defined when a session will be a recurring session. read-only. Optional.
   * For example, when creating a class service  with recurring sessions, you add a recurrence rule to create recurring sessions.
   * This field is omitted for single sessions or instances of recurring sessions.
   * Specified when the session was originally generated from a schedule recurring interval.
   * Deprecated. Use `recurringSessionId`.
   */
  recurringIntervalId?: Maybe<Scalars['String']>;
  /** The ID of the recurring session if this session is an instance of a recurrence. Use this ID to update the recurrence and all of the instances. */
  recurringSessionId?: Maybe<Scalars['String']>;
  /**
   * The remaining number of participants that can be added to the session. Read-only.
   * Can be negative, in case the session is over capacity.
   */
  remainingCapacity?: Maybe<Scalars['Int']>;
  /** ID of the schedule that the session belongs to. */
  scheduleId?: Maybe<Scalars['String']>;
  /** ID of the resource or service that the session's schedule belongs to. */
  scheduleOwnerId?: Maybe<Scalars['String']>;
  /** The name of the schedule owner. It may be a resource name or a service name. Optional. */
  scheduleOwnerName?: Maybe<Scalars['String']>;
  /**
   * The user id of the schedule owner. Optional.
   * NOT IMPLEMENTED YET.
   */
  scheduleOwnerUserId?: Maybe<Scalars['String']>;
  /** An object specifying the start date and time of the session. If the session is a recurring session, `start` must contain a `localDateTime`. */
  start?: Maybe<ComWixBookingsSchedulesApiV1CalendarDateTime>;
  /** Session status. */
  status?: Maybe<ComWixBookingsSchedulesApiV1SessionStatus>;
  /**
   * __Deprecated.__
   * Tags for the session.
   * The value is inherited from the schedule and can be overridden unless the session is a recurring session.
   */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Time reserved after the session end time, derived from the schedule availability constraints and the time between slots. Read-only.
   * If the session is a recurring session, this field must be empty.
   */
  timeReservedAfter?: Maybe<Scalars['Int']>;
  /**
   * Session title.
   * The value is inherited from the schedule and can be overridden unless the session is a recurring session.
   */
  title?: Maybe<Scalars['String']>;
  /**
   * The number of participants booked for the session. Read-only.
   * Calculated as the sum of the party sizes.
   */
  totalNumberOfParticipants?: Maybe<Scalars['Int']>;
  /** Session type. */
  type?: Maybe<ComWixBookingsSchedulesApiV1SessionType>;
  /**
   * The session version.
   * Composed by the schedule, session and participants versions.
   */
  version?: Maybe<ComWixBookingsSchedulesApiV1SessionVersion>;
};

export type ComWixBookingsSchedulesApiV1SessionCancelledInput = {
  /** Whether to notify participants about the change and an optional custom message */
  participantNotification?: InputMaybe<ComWixBookingsSchedulesApiV1ParticipantNotificationInput>;
  session?: InputMaybe<ComWixBookingsSchedulesApiV1SessionInput>;
};

export type ComWixBookingsSchedulesApiV1SessionCreatedInput = {
  session?: InputMaybe<ComWixBookingsSchedulesApiV1SessionInput>;
};

export type ComWixBookingsSchedulesApiV1SessionInput = {
  /**
   * An object specifying a list of schedules and the way each schedule's availability is affected by the session. For example, the schedule of an instructor is affected by sessions of the class that they instruct.
   * The array is inherited from the schedule and can be overridden even if the session is a recurring session.
   */
  affectedSchedules?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1LinkedScheduleInput>>>;
  /**
   * A conference created for the session according to the details set in the schedule's conference provider information.
   * If the session is a recurring session, this field is inherited from the schedule.
   * **Partially deprecated.** Only `hostUrl` and `guestUrl` are to be supported.
   */
  calendarConference?: InputMaybe<ComWixBookingsSchedulesApiV1CalendarConferenceInput>;
  /**
   * Maximum number of participants that can be added to the session. Defaults to the schedule capacity.
   * The value is inherited from the schedule and can be overridden unless the session is a recurring session.
   */
  capacity?: InputMaybe<Scalars['Int']>;
  /**
   * An object specifying the end date and time of the session. The `end` time must be after the `start` time and be same type as `start`.
   * If the session is a recurring session, `end` must contain a `localDateTime`.
   */
  end?: InputMaybe<ComWixBookingsSchedulesApiV1CalendarDateTimeInput>;
  /** The ID of the event in the new Calendar Events V3 API. */
  eventId?: InputMaybe<Scalars['String']>;
  /** Information about the external calendar, if the session originated in an external calendar. */
  externalCalendarInfo?: InputMaybe<ComWixBookingsSchedulesApiV1ExternalCalendarInfoInput>;
  /** __Deprecated.__ */
  externalCalendarOverrides?: InputMaybe<ComWixBookingsSchedulesApiV1ExternalCalendarOverridesInput>;
  /** Session ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * A list of properties for which values were inherited from the schedule.
   * This does not include participants that were inherited from the schedule.
   */
  inheritedFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * A string representing a recurrence rule (RRULE) if the session is an instance of a recurrence pattern.
   * Empty when the session is not an instance of a recurrence rule, or if the session defines a recurrence pattern, and `recurrence` is not empty.
   */
  instanceOfRecurrence?: InputMaybe<Scalars['String']>;
  /**
   * An object describing the location where the session takes place.
   * Defaults to the schedule location.
   * For single sessions, `session.location.businessLocation` can only be provided for locations that are defined in the schedule using `schedule.location` or `schedule.availability.locations`.
   */
  location?: InputMaybe<ComWixBookingsCommonApiV1LocationInput>;
  /**
   * Additional information about the session.
   * Notes are not supported for recurring sessions.
   */
  notes?: InputMaybe<Scalars['String']>;
  /** Original start date and time of the session in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601#Coordinated_Universal_Time_(UTC)) format. */
  originalStart?: InputMaybe<Scalars['String']>;
  /**
   * *Partial list** list of participants booked for the session.
   * The list includes participants who have registered for this specific session, and participants who have registered for a schedule that includes this session.
   * If the session is a recurring session, this field must be empty.
   * To retrieve the full list of session participants please use the [Query Extended Bookings API](https://dev.wix.com/api/rest/wix-bookings/bookings-reader-v2/query-extended-bookings).
   */
  participants?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1ParticipantInput>>>;
  /** Deprecated. Please use the [Booking Services V2](https://dev.wix.com/api/rest/wix-bookings/services-v2) payment instead. */
  rate?: InputMaybe<ComWixBookingsCommonApiV1RateInput>;
  /**
   * A string representing a recurrence rule (RRULE) for a recurring session, as defined in [iCalendar RFC 5545](https://icalendar.org/iCalendar-RFC-5545/3-3-10-recurrence-rule.html).
   * If the session is an instance of a recurrence pattern, the `instanceOfRecurrence` property will be contain the recurrence rule and this property will be empty.
   * The RRULE defines a rule for repeating a session.
   * Supported parameters are:
   *
   * |Keyword|Description|Supported values|
   * |--|--|---|
   * |`FREQ`|The frequency at which the session is recurs. Required.|`WEEKLY`|
   * |`INTERVAL`|How often, in terms of `FREQ`, the session recurs. Default is 1. Optional.|
   * |`UNTIL`|The UTC end date and time of the recurrence. Optional.|
   * |`BYDAY`|Day of the week when the event should recur. Required.|One of: `MO`, `TU`, `WE`, `TH`, `FR`, `SA`, `SU`|
   *
   *
   * For example, a session that repeats every second week on a Monday until January 7, 2022 at 8 AM:
   * `"FREQ=WEEKLY;INTERVAL=2;BYDAY=MO;UNTIL=20220107T080000Z"`
   *
   * <!--ORIGINAL COMMENTS:
   * `FREQ` — The frequency with which the session should be repeated (such as DAILY or WEEKLY).
   * Supported `WEEKLY` value is supported.
   * INTERVAL — Works together with FREQ to specify how often the session should be repeated. For example, FREQ=WEEKLY;INTERVAL=2 means once every two weeks. Optional. Default value is 1.
   * COUNT — The number of times this event should be repeated. Not yet supported.
   * UNTIL — The UTC date & time until which the session should be repeated. This parameter is optional. When it is not specified, the event repeats forever.
   * The format is a short ISO date, followed by 'T' and a short time with seconds and without milliseconds, terminated by the UTC designator 'Z'. For example, until Jan. 19th 2018 at 7:00 AM: 'UNTIL=20180119T070000Z'.
   * BYDAY - The days of the week when the event should be repeated. Currently, only a single day is supported. This parameter is mandatory.
   * Possible values are: MO, TU, WE, TH, FR, SA, SU
   * Note that DTSTART and DTEND lines are not allowed in this field; session start and end times are specified in the start and end fields.
   * **Example**: FREQ=WEEKLY;INTERVAL=2;BYDAY=MO;UNTIL=20200427T070000Z
   * ORIGINAL COMMENTS-->
   */
  recurrence?: InputMaybe<Scalars['String']>;
  /**
   * Recurring interval ID. Defined when a session will be a recurring session. read-only. Optional.
   * For example, when creating a class service  with recurring sessions, you add a recurrence rule to create recurring sessions.
   * This field is omitted for single sessions or instances of recurring sessions.
   * Specified when the session was originally generated from a schedule recurring interval.
   * Deprecated. Use `recurringSessionId`.
   */
  recurringIntervalId?: InputMaybe<Scalars['String']>;
  /** The ID of the recurring session if this session is an instance of a recurrence. Use this ID to update the recurrence and all of the instances. */
  recurringSessionId?: InputMaybe<Scalars['String']>;
  /**
   * The remaining number of participants that can be added to the session. Read-only.
   * Can be negative, in case the session is over capacity.
   */
  remainingCapacity?: InputMaybe<Scalars['Int']>;
  /** ID of the schedule that the session belongs to. */
  scheduleId?: InputMaybe<Scalars['String']>;
  /** ID of the resource or service that the session's schedule belongs to. */
  scheduleOwnerId?: InputMaybe<Scalars['String']>;
  /** The name of the schedule owner. It may be a resource name or a service name. Optional. */
  scheduleOwnerName?: InputMaybe<Scalars['String']>;
  /**
   * The user id of the schedule owner. Optional.
   * NOT IMPLEMENTED YET.
   */
  scheduleOwnerUserId?: InputMaybe<Scalars['String']>;
  /** An object specifying the start date and time of the session. If the session is a recurring session, `start` must contain a `localDateTime`. */
  start?: InputMaybe<ComWixBookingsSchedulesApiV1CalendarDateTimeInput>;
  /** Session status. */
  status?: InputMaybe<ComWixBookingsSchedulesApiV1SessionStatus>;
  /**
   * __Deprecated.__
   * Tags for the session.
   * The value is inherited from the schedule and can be overridden unless the session is a recurring session.
   */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Time reserved after the session end time, derived from the schedule availability constraints and the time between slots. Read-only.
   * If the session is a recurring session, this field must be empty.
   */
  timeReservedAfter?: InputMaybe<Scalars['Int']>;
  /**
   * Session title.
   * The value is inherited from the schedule and can be overridden unless the session is a recurring session.
   */
  title?: InputMaybe<Scalars['String']>;
  /**
   * The number of participants booked for the session. Read-only.
   * Calculated as the sum of the party sizes.
   */
  totalNumberOfParticipants?: InputMaybe<Scalars['Int']>;
  /** Session type. */
  type?: InputMaybe<ComWixBookingsSchedulesApiV1SessionType>;
  /**
   * The session version.
   * Composed by the schedule, session and participants versions.
   */
  version?: InputMaybe<ComWixBookingsSchedulesApiV1SessionVersionInput>;
};

export enum ComWixBookingsSchedulesApiV1SessionStatus {
  /**
   * Session is cancelled.
   * A cancelled session can be the cancellation of a recurring session that should no longer be displayed or a deleted single session.
   * The ListSessions returns cancelled sessions only if 'includeDelete' flag is set to true.
   */
  CANCELLED = 'CANCELLED',
  /** Session is confirmed. Default status. */
  CONFIRMED = 'CONFIRMED',
  /** Undefined status. */
  UNDEFINED = 'UNDEFINED'
}

export enum ComWixBookingsSchedulesApiV1SessionType {
  /** Deprecated. Represents a resource's available hours. Please use WORKING_HOURS. */
  AVAILABILITY = 'AVAILABILITY',
  /**
   * Creates an event on the calendar for the owner of the schedule that the session belongs to.
   * Default type.
   */
  EVENT = 'EVENT',
  /** Deprecated. Please use WORKING_HOURS. */
  TIME_AVAILABILITY = 'TIME_AVAILABILITY',
  UNDEFINED = 'UNDEFINED',
  /** Represents a resource's available working hours. */
  WORKING_HOURS = 'WORKING_HOURS'
}

export type ComWixBookingsSchedulesApiV1SessionUpdatedInput = {
  newSession?: InputMaybe<ComWixBookingsSchedulesApiV1SessionInput>;
  oldSession?: InputMaybe<ComWixBookingsSchedulesApiV1SessionInput>;
  /** Whether to notify participants about the change and an optional custom message */
  participantNotification?: InputMaybe<ComWixBookingsSchedulesApiV1ParticipantNotificationInput>;
  /**
   * Whether this notification was created as a result of an anonymization request, such as GDPR.
   * An anonymized participant will have the following details:
   * name = "deleted"
   * phone = "deleted"
   * email = "deleted@deleted.com"
   */
  triggeredByAnonymizeRequest?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixBookingsSchedulesApiV1SessionVersion = {
  /** Incremental version number, which is updated on each change to the session or on changes affecting the session. */
  number?: Maybe<Scalars['Long']>;
  /** Participants version number, updated each time the session participants are updated. */
  participantsVersion?: Maybe<Scalars['Int']>;
  /** Schedule version number, updated each time the schedule is updated. */
  scheduleVersion?: Maybe<Scalars['Int']>;
  /** Session version number, updated each time the session is updated. */
  sessionVersion?: Maybe<Scalars['Int']>;
};

export type ComWixBookingsSchedulesApiV1SessionVersionInput = {
  /** Incremental version number, which is updated on each change to the session or on changes affecting the session. */
  number?: InputMaybe<Scalars['Long']>;
  /** Participants version number, updated each time the session participants are updated. */
  participantsVersion?: InputMaybe<Scalars['Int']>;
  /** Schedule version number, updated each time the schedule is updated. */
  scheduleVersion?: InputMaybe<Scalars['Int']>;
  /** Session version number, updated each time the session is updated. */
  sessionVersion?: InputMaybe<Scalars['Int']>;
};

export type ComWixBookingsSchedulesApiV1SitePropertiesOnScheduleCreationInput = {
  /** The global time zone value. */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type ComWixBookingsSchedulesApiV1SplitInterval = {
  /**
   * Whether the slot duration is used as the split interval value.
   * If `same_as_duration` is `true`, the `value_in_minutes` is the sum of the first duration in
   * `schedule.availabilityConstraints.SlotDurations` field, and `schedule.availabilityConstraints.TimeBetweenSlots` field.
   */
  sameAsDuration?: Maybe<Scalars['Boolean']>;
  /** Number of minutes between available slots' start times when `same_as_duration` is `false`. */
  valueInMinutes?: Maybe<Scalars['Int']>;
};

export type ComWixBookingsSchedulesApiV1SplitIntervalInput = {
  /**
   * Whether the slot duration is used as the split interval value.
   * If `same_as_duration` is `true`, the `value_in_minutes` is the sum of the first duration in
   * `schedule.availabilityConstraints.SlotDurations` field, and `schedule.availabilityConstraints.TimeBetweenSlots` field.
   */
  sameAsDuration?: InputMaybe<Scalars['Boolean']>;
  /** Number of minutes between available slots' start times when `same_as_duration` is `false`. */
  valueInMinutes?: InputMaybe<Scalars['Int']>;
};

export type ComWixBookingsSchedulesApiV1UpdateScheduleRequestInput = {
  /** Optional. Defaults to false. In case of updated intervals' start time, this field indicates whether to align those interval's time exceptions. */
  alignTimeExceptions?: InputMaybe<Scalars['Boolean']>;
  /** Field mask of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Deprecated, use participant_notification. */
  notifyParticipants?: InputMaybe<Scalars['Boolean']>;
  /** Whether to notify participants about the change, and an optional custom message. */
  participantNotification?: InputMaybe<ComWixBookingsSchedulesApiV1ParticipantNotificationInput>;
  /** Schedule. */
  schedule?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleInput>;
};

export type ComWixBookingsSchedulesVeloV2CreateSessionRequestInput = {
  /** The session to create. */
  session?: InputMaybe<ComWixBookingsSchedulesApiV1SessionInput>;
};

export type ComWixBookingsSchedulesVeloV2CreateSessionResponse = {
  /** The created session. */
  session?: Maybe<ComWixBookingsSchedulesApiV1Session>;
};

export type ComWixBookingsSchedulesVeloV2DeleteSessionRequestInput = {
  /** Whether to notify participants about the change, and an optional custom message. */
  participantNotification?: InputMaybe<ComWixBookingsSchedulesApiV1ParticipantNotificationInput>;
  /** The ID of the session to delete. */
  sessionId?: InputMaybe<Scalars['String']>;
};

export type ComWixBookingsSchedulesVeloV2UpdateSessionRequestInput = {
  /** Field mask of fields to update. */
  fieldmask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Whether to notify participants about the change, and an optional custom message. */
  participantNotification?: InputMaybe<ComWixBookingsSchedulesApiV1ParticipantNotificationInput>;
  /** The session to update. */
  session?: InputMaybe<ComWixBookingsSchedulesApiV1SessionInput>;
};

export type ComWixBookingsSchedulesVeloV2UpdateSessionResponse = {
  /** The updated session. */
  session?: Maybe<ComWixBookingsSchedulesApiV1Session>;
};

export type ComWixBookingsUpstreamWixCommonAddress = {
  /** Main address line, usually street and number, as free text. */
  addressLine?: Maybe<Scalars['String']>;
  /** Free text providing more detailed address info. Usually contains Apt, Suite, and Floor. */
  addressLine2?: Maybe<Scalars['String']>;
  /** City name. */
  city?: Maybe<Scalars['String']>;
  /** Country code. */
  country?: Maybe<Scalars['String']>;
  /** Country full name. */
  countryFullname?: Maybe<Scalars['String']>;
  /** A string containing the full address of this location. */
  formattedAddress?: Maybe<Scalars['String']>;
  /** Coordinates of the physical address. */
  geocode?: Maybe<ComWixBookingsUpstreamWixCommonAddressLocation>;
  /** Free text to help find the address. */
  hint?: Maybe<Scalars['String']>;
  /** Zip/postal code. */
  postalCode?: Maybe<Scalars['String']>;
  /** Street name, number and apartment number. */
  streetAddress?: Maybe<ComWixBookingsUpstreamWixCommonStreetAddress>;
  /** Subdivision. Usually state, region, prefecture or province code, according to [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2). */
  subdivision?: Maybe<Scalars['String']>;
  /** Multi-level subdivisions from top to bottom. */
  subdivisions?: Maybe<Array<Maybe<ComWixBookingsUpstreamWixCommonSubdivision>>>;
};

export type ComWixBookingsUpstreamWixCommonAddressInput = {
  /** Main address line, usually street and number, as free text. */
  addressLine?: InputMaybe<Scalars['String']>;
  /** Free text providing more detailed address info. Usually contains Apt, Suite, and Floor. */
  addressLine2?: InputMaybe<Scalars['String']>;
  /** City name. */
  city?: InputMaybe<Scalars['String']>;
  /** Country code. */
  country?: InputMaybe<Scalars['String']>;
  /** Country full name. */
  countryFullname?: InputMaybe<Scalars['String']>;
  /** A string containing the full address of this location. */
  formattedAddress?: InputMaybe<Scalars['String']>;
  /** Coordinates of the physical address. */
  geocode?: InputMaybe<ComWixBookingsUpstreamWixCommonAddressLocationInput>;
  /** Free text to help find the address. */
  hint?: InputMaybe<Scalars['String']>;
  /** Zip/postal code. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** Street name, number and apartment number. */
  streetAddress?: InputMaybe<ComWixBookingsUpstreamWixCommonStreetAddressInput>;
  /** Subdivision. Usually state, region, prefecture or province code, according to [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2). */
  subdivision?: InputMaybe<Scalars['String']>;
  /** Multi-level subdivisions from top to bottom. */
  subdivisions?: InputMaybe<Array<InputMaybe<ComWixBookingsUpstreamWixCommonSubdivisionInput>>>;
};

export type ComWixBookingsUpstreamWixCommonAddressLocation = {
  /** Address latitude. */
  latitude?: Maybe<Scalars['Float']>;
  /** Address longitude. */
  longitude?: Maybe<Scalars['Float']>;
};

export type ComWixBookingsUpstreamWixCommonAddressLocationInput = {
  /** Address latitude. */
  latitude?: InputMaybe<Scalars['Float']>;
  /** Address longitude. */
  longitude?: InputMaybe<Scalars['Float']>;
};

export type ComWixBookingsUpstreamWixCommonPagingInput = {
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the current sort order. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type ComWixBookingsUpstreamWixCommonQueryInput = {
  /** Array of projected fields. A list of specific field names to return. If `fieldsets` are also specified, the union of `fieldsets` and `fields` is returned. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of named, predefined sets of projected fields. A array of predefined named sets of fields to be returned. Specifying multiple `fieldsets` will return the union of fields from all sets. If `fields` are also specified, the union of `fieldsets` and `fields` is returned. */
  fieldsets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Paging options to limit and skip the number of items. */
  paging?: InputMaybe<ComWixBookingsUpstreamWixCommonPagingInput>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type ComWixBookingsUpstreamWixCommonQueryV2Input = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixCommonCursorPagingInput>;
  /** Array of projected fields. A list of specific field names to return. If `fieldsets` are also specified, the union of `fieldsets` and `fields` is returned. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of named, predefined sets of projected fields. A array of predefined named sets of fields to be returned. Specifying multiple `fieldsets` will return the union of fields from all sets. If `fields` are also specified, the union of `fieldsets` and `fields` is returned. */
  fieldsets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Paging options to limit and skip the number of items. */
  paging?: InputMaybe<ComWixBookingsUpstreamWixCommonPagingInput>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type ComWixBookingsUpstreamWixCommonStreetAddress = {
  /** Apartment number. */
  apt?: Maybe<Scalars['String']>;
  /** Street name. */
  name?: Maybe<Scalars['String']>;
  /** Street number. */
  number?: Maybe<Scalars['String']>;
};

export type ComWixBookingsUpstreamWixCommonStreetAddressInput = {
  /** Apartment number. */
  apt?: InputMaybe<Scalars['String']>;
  /** Street name. */
  name?: InputMaybe<Scalars['String']>;
  /** Street number. */
  number?: InputMaybe<Scalars['String']>;
};

export type ComWixBookingsUpstreamWixCommonSubdivision = {
  /** Subdivision code. Usually state, region, prefecture or province code, according to [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2). */
  code?: Maybe<Scalars['String']>;
  /** Subdivision full name. */
  name?: Maybe<Scalars['String']>;
};

export type ComWixBookingsUpstreamWixCommonSubdivisionInput = {
  /** Subdivision code. Usually state, region, prefecture or province code, according to [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2). */
  code?: InputMaybe<Scalars['String']>;
  /** Subdivision full name. */
  name?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomCartCheckoutCommonApiV1CatalogOverrideFields = {
  /** Only eligible for catalog items with `lineItem.paymentOption.value` type of `DEPOSIT_ONLINE`. */
  depositAmount?: Maybe<Scalars['String']>;
  /** Item description lines. Used when displaying the line item to customers. */
  descriptionLines?: Maybe<Array<Maybe<ComWixEcommerceCatalogSpiApiV1DescriptionLine>>>;
  /** Item price **before** discounts. */
  fullPrice?: Maybe<Scalars['String']>;
  /** Item image. */
  image?: Maybe<ComWixEcomCartCheckoutCommonApiV1Image>;
  /** Payment method selected for the item. */
  paymentOption?: Maybe<ComWixEcomCartCheckoutCommonApiV1PaymentOption>;
  /** Physical properties of the item. */
  physicalProperties?: Maybe<ComWixEcommerceCatalogSpiApiV1PhysicalProperties>;
  /** Item price **after** discounts. */
  price?: Maybe<Scalars['String']>;
  /** Item name. */
  productName?: Maybe<ComWixEcommerceCatalogSpiApiV1ProductName>;
  /**
   * Whether to save the payment method on the order.
   *
   * Default: `false`
   */
  savePaymentMethod?: Maybe<Scalars['Boolean']>;
};

export type ComWixEcomCartCheckoutCommonApiV1CatalogOverrideFieldsInput = {
  /** Only eligible for catalog items with `lineItem.paymentOption.value` type of `DEPOSIT_ONLINE`. */
  depositAmount?: InputMaybe<Scalars['String']>;
  /** Item description lines. Used when displaying the line item to customers. */
  descriptionLines?: InputMaybe<Array<InputMaybe<ComWixEcommerceCatalogSpiApiV1DescriptionLineInput>>>;
  /** Item price **before** discounts. */
  fullPrice?: InputMaybe<Scalars['String']>;
  /** Item image. */
  image?: InputMaybe<ComWixEcomCartCheckoutCommonApiV1ImageInput>;
  /** Payment method selected for the item. */
  paymentOption?: InputMaybe<ComWixEcomCartCheckoutCommonApiV1PaymentOptionInput>;
  /** Physical properties of the item. */
  physicalProperties?: InputMaybe<ComWixEcommerceCatalogSpiApiV1PhysicalPropertiesInput>;
  /** Item price **after** discounts. */
  price?: InputMaybe<Scalars['String']>;
  /** Item name. */
  productName?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ProductNameInput>;
  /**
   * Whether to save the payment method on the order.
   *
   * Default: `false`
   */
  savePaymentMethod?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomCartCheckoutCommonApiV1CustomContentReference = {
  /**
   * ID of the app providing the content.
   *
   * You can get your app's ID from its page in the [app dashboard](https://dev.wix.com/dc3/my-apps/).
   */
  appId?: Maybe<Scalars['String']>;
  /**
   * ID of the component within the app it belongs to.
   *
   * You can get your component's ID from its page in the [app dashboard](https://dev.wix.com/dc3/my-apps/).
   */
  componentId?: Maybe<Scalars['String']>;
};

export type ComWixEcomCartCheckoutCommonApiV1CustomContentReferenceInput = {
  /**
   * ID of the app providing the content.
   *
   * You can get your app's ID from its page in the [app dashboard](https://dev.wix.com/dc3/my-apps/).
   */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * ID of the component within the app it belongs to.
   *
   * You can get your component's ID from its page in the [app dashboard](https://dev.wix.com/dc3/my-apps/).
   */
  componentId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomCartCheckoutCommonApiV1CustomLineItemInput = {
  /** Catalog and item reference. Includes IDs for the item and the catalog it came from, as well as further optional info. Optional for custom line items, which don't trigger the Catalog service plugin. */
  catalogReference?: InputMaybe<ComWixEcommerceCatalogSpiApiV1CatalogReferenceInput>;
  /** Item payment policy that requires customer consent to complete purchase. The payment policy will be displayed on the checkout page. */
  consentRequiredPaymentPolicy?: InputMaybe<Scalars['String']>;
  /** Delivery profile ID. */
  deliveryProfileId?: InputMaybe<Scalars['String']>;
  /**
   * Partial payment for the given item to be paid upfront during the checkout.
   *
   * Eligible for catalog items with type `DEPOSIT_ONLINE`.
   * When omitted, the item's price will not be split and is expected to be paid in a single installment.
   */
  depositAmount?: InputMaybe<Scalars['String']>;
  /** Custom line item description lines. Used for display purposes for the cart, checkout and order. */
  descriptionLines?: InputMaybe<Array<InputMaybe<ComWixEcommerceCatalogSpiApiV1DescriptionLineInput>>>;
  /** Digital file ID and name. Required if `itemType: DIGITAL`. */
  digitalFile?: InputMaybe<ComWixEcommerceCatalogSpiApiV1SecuredMediaInput>;
  /**
   * Whether the line item quantity is fixed and cannot be changed.
   *
   * Default: `false`
   */
  fixedQuantity?: InputMaybe<Scalars['Boolean']>;
  /** Item price **before** catalog-defined discount. Defaults to `price` when not provided. */
  fullPrice?: InputMaybe<Scalars['String']>;
  /**
   * Custom line item ID. If passed, `id` must be unique.
   *
   * Default: auto-generated ID
   */
  id?: InputMaybe<Scalars['String']>;
  /** ID of the app managing the inventory. */
  inventoryAppId?: InputMaybe<Scalars['String']>;
  /** Item type. Either a preset type or custom. */
  itemType?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ItemTypeInput>;
  /** Custom line item's media. */
  media?: InputMaybe<ComWixEcomCartCheckoutCommonApiV1ImageInput>;
  /**
   * Whether the item can only be purchased by site members.
   *
   * Default: `false`
   */
  membersOnly?: InputMaybe<Scalars['Boolean']>;
  /** Modifier groups that were added to the item. */
  modifierGroups?: InputMaybe<Array<InputMaybe<ComWixEcommerceCatalogSpiApiV1ModifierGroupInput>>>;
  /**
   * Type of selected payment option for current item. Defaults to `FULL_PAYMENT_ONLINE`.
   *
   * + `FULL_PAYMENT_ONLINE` - Entire payment for this item happens as part of the checkout.
   * + `FULL_PAYMENT_OFFLINE` - Entire payment for this item happens after the checkout. For example, when using cash, check, or other offline payment methods.
   * + `MEMBERSHIP` - Payment for this item is done by charging a membership. When this option is used, `lineItem.price.amount` is 0.
   * + `DEPOSIT_ONLINE` -  Partial payment for the given item to be paid upfront during the checkout. Amount to be paid is defined by deposit_amount field.
   */
  paymentOption?: InputMaybe<ComWixEcommerceCatalogSpiApiV1PaymentOptionType>;
  /** Physical properties of the item. */
  physicalProperties?: InputMaybe<ComWixEcommerceCatalogSpiApiV1PhysicalPropertiesInput>;
  /** Policies to be displayed to the customer on the checkout page. */
  policies?: InputMaybe<Array<InputMaybe<ComWixEcommerceCatalogSpiApiV1PolicyInput>>>;
  /**
   * Custom line item price.
   *
   * Must be a number or a decimal without symbols.
   */
  price?: InputMaybe<Scalars['String']>;
  /** Additional description for the price. For example, when price is 0 but additional details about the actual price are needed - "Starts at $67". */
  priceDescription?: InputMaybe<ComWixEcommerceCatalogSpiApiV1PriceDescriptionInput>;
  /**
   * Whether the price is not yet defined, and will be updated after the order is created.
   *
   * Default: `false`
   */
  priceUndetermined?: InputMaybe<Scalars['Boolean']>;
  /** Name of the item or product. */
  productName?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ProductNameInput>;
  /**
   * Custom line item quantity.
   *
   * Min: `1`
   * Max: `100000`
   */
  quantity?: InputMaybe<Scalars['Int']>;
  /**
   * Item quantity available for purchase. Only return this if inventory is managed.
   * Not returning this field means that the buyer can "infinitely" tick up the number of items in the cart.
   */
  quantityAvailable?: InputMaybe<Scalars['Int']>;
  /**
   * In cases where `catalogReference.catalogItemId` is NOT the actual catalog item ID, this field will return the true item's ID.
   *
   * + For example, for Wix Bookings, `catalogReference.catalogItemId` is the booking ID. Therefore this value is set to the service ID.
   * + In most cases, this field is the same as `catalogReference.catalogItemId`.
   * + Used in membership validation.
   */
  rootCatalogItemId?: InputMaybe<Scalars['String']>;
  /**
   * Whether to save the payment method on the order.
   *
   * Default: `false`
   */
  savePaymentMethod?: InputMaybe<Scalars['Boolean']>;
  /**
   * Service properties. When relevant, this contains information such as date and number of participants.
   * Used, among other things, when checking for valid memberships.
   */
  serviceProperties?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ServicePropertiesInput>;
  /** Subscription option info. This field is internal and only used by Stores. */
  subscriptionOptionInfo?: InputMaybe<ComWixEcommerceCatalogSpiApiV1SubscriptionOptionInfoInput>;
  /** Tax group ID for this custom line item. */
  taxGroupId?: InputMaybe<Scalars['String']>;
  /** Address to use for tax calculation purposes. */
  taxableAddress?: InputMaybe<ComWixEcommercePlatformCommonApiTaxableAddressInput>;
  /** URL to the item's page on the site. When not provided, the link back from the cart page to the relevant product page will not work. */
  url?: InputMaybe<WixCommonPageUrlV2Input>;
};

export type ComWixEcomCartCheckoutCommonApiV1Image = {
  /** Image alt text. Optional. */
  altText?: Maybe<Scalars['String']>;
  /** Image filename. Optional. */
  filename?: Maybe<Scalars['String']>;
  /** Original image height. */
  height?: Maybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: Maybe<Scalars['String']>;
  /** Original image width. */
  width?: Maybe<Scalars['Int']>;
};

export type ComWixEcomCartCheckoutCommonApiV1ImageInput = {
  /** Image alt text. Optional. */
  altText?: InputMaybe<Scalars['String']>;
  /** Image filename. Optional. */
  filename?: InputMaybe<Scalars['String']>;
  /** Original image height. */
  height?: InputMaybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Original image width. */
  width?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomCartCheckoutCommonApiV1ItemModifier = {
  /** Additional details. */
  details?: Maybe<ComWixEcommercePlatformCommonApiTranslatableString>;
  /** Modifier ID. */
  id?: Maybe<Scalars['String']>;
  /** Primary display label for the modifier. */
  label?: Maybe<ComWixEcommercePlatformCommonApiTranslatableString>;
  /** The price of the modifier. */
  price?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** The quantity of this modifier. */
  quantity?: Maybe<Scalars['Int']>;
};

export type ComWixEcomCartCheckoutCommonApiV1ItemModifierInput = {
  /** Additional details. */
  details?: InputMaybe<ComWixEcommercePlatformCommonApiTranslatableStringInput>;
  /** Modifier ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Primary display label for the modifier. */
  label?: InputMaybe<ComWixEcommercePlatformCommonApiTranslatableStringInput>;
  /** The price of the modifier. */
  price?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** The quantity of this modifier. */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomCartCheckoutCommonApiV1ModifierGroup = {
  /** Modifier group ID. */
  id?: Maybe<Scalars['String']>;
  /** List of modifiers in this group. */
  modifiers?: Maybe<Array<Maybe<ComWixEcomCartCheckoutCommonApiV1ItemModifier>>>;
  /** Modifier group name. */
  name?: Maybe<ComWixEcommercePlatformCommonApiTranslatableString>;
};

export type ComWixEcomCartCheckoutCommonApiV1ModifierGroupInput = {
  /** Modifier group ID. */
  id?: InputMaybe<Scalars['String']>;
  /** List of modifiers in this group. */
  modifiers?: InputMaybe<Array<InputMaybe<ComWixEcomCartCheckoutCommonApiV1ItemModifierInput>>>;
  /** Modifier group name. */
  name?: InputMaybe<ComWixEcommercePlatformCommonApiTranslatableStringInput>;
};

export type ComWixEcomCartCheckoutCommonApiV1PaymentOption = {
  /**
   * Type of selected payment option for current item.
   *
   * Default: `FULL_PAYMENT_ONLINE`
   */
  value?: Maybe<ComWixEcommerceCatalogSpiApiV1PaymentOptionType>;
};

export type ComWixEcomCartCheckoutCommonApiV1PaymentOptionInput = {
  /**
   * Type of selected payment option for current item.
   *
   * Default: `FULL_PAYMENT_ONLINE`
   */
  value?: InputMaybe<ComWixEcommerceCatalogSpiApiV1PaymentOptionType>;
};

export type ComWixEcomDiscountsActiveTimeInfo = {
  /** Date and time the discount rule is active **till**, in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  end?: Maybe<Scalars['String']>;
  /** Recurring schedule for this discount rule. */
  recurrence?: Maybe<ComWixEcomDiscountsRecurrence>;
  /** Date and time the discount rule is active **from**, in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  start?: Maybe<Scalars['String']>;
};

export type ComWixEcomDiscountsActiveTimeInfoInput = {
  /** Date and time the discount rule is active **till**, in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  end?: InputMaybe<Scalars['String']>;
  /** Recurring schedule for this discount rule. */
  recurrence?: InputMaybe<ComWixEcomDiscountsRecurrenceInput>;
  /** Date and time the discount rule is active **from**, in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  start?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomDiscountsAddressInput = {
  /** City name. */
  city?: InputMaybe<Scalars['String']>;
  /** Two-letter country code in [ISO-3166 alpha-2](https://www.iso.org/obp/ui/#search/code/) format. */
  country?: InputMaybe<Scalars['String']>;
  /** Code for a subdivision (such as state, prefecture, or province) in [ISO 3166-2](https://www.iso.org/standard/72483.html) format. */
  subdivision?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomDiscountsAppliedDiscount = {
  /** Applied discount rule. */
  appliedDiscountRule?: Maybe<ComWixEcomDiscountsAppliedDiscountRule>;
  /** Discount type. */
  discountType?: Maybe<ComWixEcomDiscountsDiscountTargetType>;
  /** IDs of line items the discount applies to, in GUID format. */
  lineItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixEcomDiscountsAppliedDiscountRule = {
  /** Total amount reduced from all discounted line items. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Applied discount rule ID. */
  discountRule?: Maybe<ComWixEcomDiscountsDiscountRule>;
  /** Discount rule type. */
  discountRuleType?: Maybe<ComWixEcomDiscountsDiscountDiscountType>;
  /** Applied discount rule ID. */
  id?: Maybe<Scalars['String']>;
  /** Discount rule name. */
  name?: Maybe<ComWixEcomDiscountsDiscountRuleName>;
};

export type ComWixEcomDiscountsBuyXGetYInfo = {
  /** Information about which items must be in the cart (buy X) for the discount to apply (get Y). */
  customerBuys?: Maybe<ComWixEcomDiscountsCustomerBuy>;
  /** Information about which items will be discounted (get Y). */
  customerGets?: Maybe<ComWixEcomDiscountsCustomerGet>;
  /**
   * The maximum number of times the 'buy X get Y' discount can be applied.
   * For example, when the value of `limit` is `2`, with a "2+1" sale on all items, the following logic applies:
   * + Buy 2 get 1, buy 3 get 1.
   * + Buy 4 get 2, buy 6 get 2, buy 9 get 2, and so on.
   */
  limit?: Maybe<Scalars['Int']>;
};

export type ComWixEcomDiscountsBuyXGetYInfoInput = {
  /** Information about which items must be in the cart (buy X) for the discount to apply (get Y). */
  customerBuys?: InputMaybe<ComWixEcomDiscountsCustomerBuyInput>;
  /** Information about which items will be discounted (get Y). */
  customerGets?: InputMaybe<ComWixEcomDiscountsCustomerGetInput>;
  /**
   * The maximum number of times the 'buy X get Y' discount can be applied.
   * For example, when the value of `limit` is `2`, with a "2+1" sale on all items, the following logic applies:
   * + Buy 2 get 1, buy 3 get 1.
   * + Buy 4 get 2, buy 6 get 2, buy 9 get 2, and so on.
   */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomDiscountsBuyerInfoInput = {
  /** Email of the customer. */
  buyerEmail?: InputMaybe<Scalars['String']>;
  /** Contact id of the customer. */
  contactId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomDiscountsCatalogItemFilter = {
  /** Catalog App ID. For example, the Wix Stores, Wix Bookings, or 3rd-party `appId`. */
  catalogAppId?: Maybe<Scalars['String']>;
  /** ID of the item within its Wix or 3rd-party catalog. For example, `productId` for Wix Stores. */
  catalogItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixEcomDiscountsCatalogItemFilterInput = {
  /** Catalog App ID. For example, the Wix Stores, Wix Bookings, or 3rd-party `appId`. */
  catalogAppId?: InputMaybe<Scalars['String']>;
  /** ID of the item within its Wix or 3rd-party catalog. For example, `productId` for Wix Stores. */
  catalogItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomDiscountsContactSegments = {
  /** Eligible segment ids. */
  segmentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixEcomDiscountsContactSegmentsInput = {
  /** Eligible segment ids. */
  segmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomDiscountsContactTags = {
  /** Eligible tag and label ids. */
  tagReferences?: Maybe<Array<Maybe<ComWixEcomDiscountsTagReference>>>;
};

export type ComWixEcomDiscountsContactTagsInput = {
  /** Eligible tag and label ids. */
  tagReferences?: InputMaybe<Array<InputMaybe<ComWixEcomDiscountsTagReferenceInput>>>;
};

export type ComWixEcomDiscountsCreateDiscountRuleRequestInput = {
  /** Discount rule info. */
  discountRule?: InputMaybe<ComWixEcomDiscountsDiscountRuleInput>;
};

export type ComWixEcomDiscountsCreateDiscountRuleResponse = {
  /** Discount rule. */
  discountRule?: Maybe<ComWixEcomDiscountsDiscountRule>;
};

export type ComWixEcomDiscountsCustomFilter = {
  /** Custom filter app ID, when relevant. */
  appId?: Maybe<Scalars['String']>;
  /**
   * Custom filter in `{ "key": "value" }` form.
   * For example, an array of `collectionIDs`:
   * `{ ["collectionId": "12345"], ["collectionId": "67890"] }`.
   */
  params?: Maybe<Scalars['JSON']>;
};

export type ComWixEcomDiscountsCustomFilterInput = {
  /** Custom filter app ID, when relevant. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Custom filter in `{ "key": "value" }` form.
   * For example, an array of `collectionIDs`:
   * `{ ["collectionId": "12345"], ["collectionId": "67890"] }`.
   */
  params?: InputMaybe<Scalars['JSON']>;
};

export type ComWixEcomDiscountsCustomerBuy = {
  /** Minimum number of items the customer must add to the cart to be eligible for a discount. */
  minimumQuantity?: Maybe<Scalars['Int']>;
  /** Minimum price the customer must add to the cart to be eligible for a discount. */
  minimumSpend?: Maybe<Scalars['String']>;
  /** Scopes of the items that must be added to the cart to enable the discount. */
  scopes?: Maybe<Array<Maybe<ComWixEcomDiscountsScope>>>;
};

export type ComWixEcomDiscountsCustomerBuyInput = {
  /** Minimum number of items the customer must add to the cart to be eligible for a discount. */
  minimumQuantity?: InputMaybe<Scalars['Int']>;
  /** Minimum price the customer must add to the cart to be eligible for a discount. */
  minimumSpend?: InputMaybe<Scalars['String']>;
  /** Scopes of the items that must be added to the cart to enable the discount. */
  scopes?: InputMaybe<Array<InputMaybe<ComWixEcomDiscountsScopeInput>>>;
};

export type ComWixEcomDiscountsCustomerEligibility = {
  /** Information about specific segments. */
  contactSegmentsInfo?: Maybe<ComWixEcomDiscountsContactSegments>;
  /** Information about specific lables. */
  contactTagsInfo?: Maybe<ComWixEcomDiscountsContactTags>;
  /** Customer eligibility type. */
  eligibilityType?: Maybe<ComWixEcomDiscountsCustomerEligibilityEligibilityType>;
  /** Information about specific customers. */
  individualContactsInfo?: Maybe<ComWixEcomDiscountsIndividualContacts>;
};

export enum ComWixEcomDiscountsCustomerEligibilityEligibilityType {
  /** Only customers with specific segments. */
  CONTACT_SEGMENTS = 'CONTACT_SEGMENTS',
  /** Only customers with specific labels (labels are being migrated to tags). */
  CONTACT_TAGS = 'CONTACT_TAGS',
  /** Only specific customers based on contact id. */
  INDIVIDUAL_CONTACTS = 'INDIVIDUAL_CONTACTS',
  /** Eligibility type is not defined. */
  UNKNOWN_ELIGIBILITY_TYPE = 'UNKNOWN_ELIGIBILITY_TYPE'
}

export type ComWixEcomDiscountsCustomerEligibilityInput = {
  /** Information about specific segments. */
  contactSegmentsInfo?: InputMaybe<ComWixEcomDiscountsContactSegmentsInput>;
  /** Information about specific lables. */
  contactTagsInfo?: InputMaybe<ComWixEcomDiscountsContactTagsInput>;
  /** Customer eligibility type. */
  eligibilityType?: InputMaybe<ComWixEcomDiscountsCustomerEligibilityEligibilityType>;
  /** Information about specific customers. */
  individualContactsInfo?: InputMaybe<ComWixEcomDiscountsIndividualContactsInput>;
};

export type ComWixEcomDiscountsCustomerGet = {
  /**
   * Exact number of items in the cart that will be discounted.
   * If the cart contains fewer items than the value of quantity, the discount will not apply.
   */
  quantity?: Maybe<Scalars['Int']>;
  /** Scopes of the items that will be discounted. */
  scopes?: Maybe<Array<Maybe<ComWixEcomDiscountsScope>>>;
};

export type ComWixEcomDiscountsCustomerGetInput = {
  /**
   * Exact number of items in the cart that will be discounted.
   * If the cart contains fewer items than the value of quantity, the discount will not apply.
   */
  quantity?: InputMaybe<Scalars['Int']>;
  /** Scopes of the items that will be discounted. */
  scopes?: InputMaybe<Array<InputMaybe<ComWixEcomDiscountsScopeInput>>>;
};

export enum ComWixEcomDiscountsDayOfWeek {
  /** Friday. */
  FRI = 'FRI',
  /** Monday. */
  MON = 'MON',
  /** Saturday. */
  SAT = 'SAT',
  /** Sunday. */
  SUN = 'SUN',
  /** Thursday. */
  THU = 'THU',
  /** Tuesday. */
  TUE = 'TUE',
  UNKOWN_DAY_OF_WEEK = 'UNKOWN_DAY_OF_WEEK',
  /** Wednesday. */
  WED = 'WED'
}

export type ComWixEcomDiscountsDeleteDiscountRuleRequestInput = {
  /** ID of the discount rule to delete. */
  discountRuleId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomDiscountsDiscount = {
  /** Data related to `BUY_X_GET_Y` target type. */
  buyXGetYInfo?: Maybe<ComWixEcomDiscountsBuyXGetYInfo>;
  /** Discount type. */
  discountType?: Maybe<ComWixEcomDiscountsDiscountDiscountType>;
  /** Amount to discount from original price. */
  fixedAmount?: Maybe<Scalars['String']>;
  /** Fixed price. Line item will be fixed to this price. */
  fixedPrice?: Maybe<Scalars['String']>;
  /** Percentage to discount from original price. */
  percentage?: Maybe<Scalars['Float']>;
  /** A special price is applied for a specific quantity of items. For example, 3 for $10. */
  quantityBased?: Maybe<ComWixEcomDiscountsQuantityBased>;
  /** Data related to `SPECIFIC_ITEMS` target type. */
  specificItemsInfo?: Maybe<ComWixEcomDiscountsSpecificItemsInfo>;
  /**
   * Discount target.
   *
   * + `SPECIFIC_ITEMS`: Discount applies to a specific set of items.
   */
  targetType?: Maybe<ComWixEcomDiscountsDiscountTargetType>;
};

export type ComWixEcomDiscountsDiscountConfig = {
  /** DiscountConfig ID. */
  id?: Maybe<Scalars['String']>;
  /** The DiscountConfig price (Represents Amount). */
  price?: Maybe<Scalars['String']>;
  /** The number of items that must be added to the cart to be eligible for the discount (Represents X). */
  quantity?: Maybe<Scalars['Int']>;
};

export type ComWixEcomDiscountsDiscountConfigInput = {
  /** DiscountConfig ID. */
  id?: InputMaybe<Scalars['String']>;
  /** The DiscountConfig price (Represents Amount). */
  price?: InputMaybe<Scalars['String']>;
  /** The number of items that must be added to the cart to be eligible for the discount (Represents X). */
  quantity?: InputMaybe<Scalars['Int']>;
};

export enum ComWixEcomDiscountsDiscountDiscountType {
  /** Price is reduced by fixed amount. */
  FIXED_AMOUNT = 'FIXED_AMOUNT',
  /** Price will be set to fixed amount. */
  FIXED_PRICE = 'FIXED_PRICE',
  /** Price is reduced by percentage value. */
  PERCENTAGE = 'PERCENTAGE',
  /** Quantity based options for Buy X For Amount. */
  QUANTITY_BASED = 'QUANTITY_BASED',
  UNDEFINED = 'UNDEFINED'
}

export type ComWixEcomDiscountsDiscountInput = {
  /** Data related to `BUY_X_GET_Y` target type. */
  buyXGetYInfo?: InputMaybe<ComWixEcomDiscountsBuyXGetYInfoInput>;
  /** Discount type. */
  discountType?: InputMaybe<ComWixEcomDiscountsDiscountDiscountType>;
  /** Amount to discount from original price. */
  fixedAmount?: InputMaybe<Scalars['String']>;
  /** Fixed price. Line item will be fixed to this price. */
  fixedPrice?: InputMaybe<Scalars['String']>;
  /** Percentage to discount from original price. */
  percentage?: InputMaybe<Scalars['Float']>;
  /** A special price is applied for a specific quantity of items. For example, 3 for $10. */
  quantityBased?: InputMaybe<ComWixEcomDiscountsQuantityBasedInput>;
  /** Data related to `SPECIFIC_ITEMS` target type. */
  specificItemsInfo?: InputMaybe<ComWixEcomDiscountsSpecificItemsInfoInput>;
  /**
   * Discount target.
   *
   * + `SPECIFIC_ITEMS`: Discount applies to a specific set of items.
   */
  targetType?: InputMaybe<ComWixEcomDiscountsDiscountTargetType>;
};

export type ComWixEcomDiscountsDiscountRule = {
  /**
   * Whether the discount rule is active.
   *
   * Default: `true`
   */
  active?: Maybe<Scalars['Boolean']>;
  /** Time frame in which the discount rule is active. */
  activeTimeInfo?: Maybe<ComWixEcomDiscountsActiveTimeInfo>;
  /** Date and time the discount rule was created. */
  createdDate?: Maybe<Scalars['String']>;
  /**
   * List of discounts that are applied when one or more triggers are met.
   *
   * > **Notes:**
   * >
   * > + Currently, only 1 discount can be defined per discount rule.
   * > + A discount rule can be applied on multiple items per cart.
   * > + A discount rule can only be applied once per item.
   */
  discounts?: Maybe<ComWixEcomDiscountsDiscounts>;
  /** Data Extensions. */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** Discount rule ID. */
  id?: Maybe<Scalars['String']>;
  /** Discount rule name. */
  name?: Maybe<Scalars['String']>;
  /** calculated string which describe the discount rule */
  offer?: Maybe<Scalars['String']>;
  /**
   * Revision number, which increments by 1 each time the discount rule is updated.
   * To prevent conflicting changes, the current `revision` must be passed when updating the discount rule.
   */
  revision?: Maybe<Scalars['Long']>;
  /** Discount advance settings. */
  settings?: Maybe<ComWixEcomDiscountsDiscountSettings>;
  /**
   * Discount rule status.
   * Default: `UNDEFINED`
   */
  status?: Maybe<ComWixEcomDiscountsDiscountRuleStatus>;
  /**
   * Discount rule trigger.
   * A set of conditions that must be met for the `discounts` to be applied.
   * Not passing a trigger will cause the discount to always apply.
   */
  trigger?: Maybe<ComWixEcomDiscountsDiscountTrigger>;
  /** Date and time the discount rule was last updated. */
  updatedDate?: Maybe<Scalars['String']>;
  /** Number of times the discount rule was used. */
  usageCount?: Maybe<Scalars['Int']>;
};

export type ComWixEcomDiscountsDiscountRuleInput = {
  /**
   * Whether the discount rule is active.
   *
   * Default: `true`
   */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Time frame in which the discount rule is active. */
  activeTimeInfo?: InputMaybe<ComWixEcomDiscountsActiveTimeInfoInput>;
  /** Date and time the discount rule was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /**
   * List of discounts that are applied when one or more triggers are met.
   *
   * > **Notes:**
   * >
   * > + Currently, only 1 discount can be defined per discount rule.
   * > + A discount rule can be applied on multiple items per cart.
   * > + A discount rule can only be applied once per item.
   */
  discounts?: InputMaybe<ComWixEcomDiscountsDiscountsInput>;
  /** Data Extensions. */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** Discount rule ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Discount rule name. */
  name?: InputMaybe<Scalars['String']>;
  /** calculated string which describe the discount rule */
  offer?: InputMaybe<Scalars['String']>;
  /**
   * Revision number, which increments by 1 each time the discount rule is updated.
   * To prevent conflicting changes, the current `revision` must be passed when updating the discount rule.
   */
  revision?: InputMaybe<Scalars['Long']>;
  /** Discount advance settings. */
  settings?: InputMaybe<ComWixEcomDiscountsDiscountSettingsInput>;
  /**
   * Discount rule status.
   * Default: `UNDEFINED`
   */
  status?: InputMaybe<ComWixEcomDiscountsDiscountRuleStatus>;
  /**
   * Discount rule trigger.
   * A set of conditions that must be met for the `discounts` to be applied.
   * Not passing a trigger will cause the discount to always apply.
   */
  trigger?: InputMaybe<ComWixEcomDiscountsDiscountTriggerInput>;
  /** Date and time the discount rule was last updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** Number of times the discount rule was used. */
  usageCount?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomDiscountsDiscountRuleName = {
  /** Original discount rule name (in site's default language). */
  original?: Maybe<Scalars['String']>;
  /**
   * Translated discount rule name according to buyer language.
   *
   * Default: `original`
   */
  translated?: Maybe<Scalars['String']>;
};

export enum ComWixEcomDiscountsDiscountRuleStatus {
  /** Rule status is expired, it might have been live in the past. */
  EXPIRED = 'EXPIRED',
  /** Rule status is live. */
  LIVE = 'LIVE',
  /** Rule status is pending, it might be live in the future. */
  PENDING = 'PENDING',
  /** Rule status is not defined. */
  UNDEFINED = 'UNDEFINED'
}

export type ComWixEcomDiscountsDiscountSettings = {
  /** Discount applies to either `ALL_ITEMS`, or to the `LOWEST_PRICED_ITEM`. */
  appliesTo?: Maybe<ComWixEcomDiscountsDiscountSettingsAppliedSubjectType>;
  /**
   * Whether the discount will apply to subscriptions.
   *
   * Default: `false`
   */
  includeSubscription?: Maybe<Scalars['Boolean']>;
  /**
   * Opt in to indexing this discount rule by an offline pipeline.
   * Default value is false (rules are not indexed by default).
   * The purpose of indexing discount rules is to allow fast reads of potential discounts on given catalog items,
   * without having to do heavy calculations like in `GetAppliedDiscounts` API.
   * One can read this data from [Discounts Cache Reader Service](https://todo-add-working-link)
   * This can be used for example, to display potential discounts on the storefront.
   */
  indexOptIn?: Maybe<Scalars['Boolean']>;
  /** Maximum total number of uses allowed for the discount rule. */
  usageLimit?: Maybe<Scalars['Int']>;
  /**
   * The usage limit per user per discount.
   * When not provided, this setting will not apply.
   */
  usageLimitPerUser?: Maybe<Scalars['Int']>;
};

export enum ComWixEcomDiscountsDiscountSettingsAppliedSubjectType {
  /** Discount applies to all items at checkout. */
  ALL_ITEMS = 'ALL_ITEMS',
  /** Discount applies to the lowest priced item at checkout. */
  LOWEST_PRICED_ITEM = 'LOWEST_PRICED_ITEM',
  UNDEFINED = 'UNDEFINED'
}

export type ComWixEcomDiscountsDiscountSettingsInput = {
  /** Discount applies to either `ALL_ITEMS`, or to the `LOWEST_PRICED_ITEM`. */
  appliesTo?: InputMaybe<ComWixEcomDiscountsDiscountSettingsAppliedSubjectType>;
  /**
   * Whether the discount will apply to subscriptions.
   *
   * Default: `false`
   */
  includeSubscription?: InputMaybe<Scalars['Boolean']>;
  /**
   * Opt in to indexing this discount rule by an offline pipeline.
   * Default value is false (rules are not indexed by default).
   * The purpose of indexing discount rules is to allow fast reads of potential discounts on given catalog items,
   * without having to do heavy calculations like in `GetAppliedDiscounts` API.
   * One can read this data from [Discounts Cache Reader Service](https://todo-add-working-link)
   * This can be used for example, to display potential discounts on the storefront.
   */
  indexOptIn?: InputMaybe<Scalars['Boolean']>;
  /** Maximum total number of uses allowed for the discount rule. */
  usageLimit?: InputMaybe<Scalars['Int']>;
  /**
   * The usage limit per user per discount.
   * When not provided, this setting will not apply.
   */
  usageLimitPerUser?: InputMaybe<Scalars['Int']>;
};

export enum ComWixEcomDiscountsDiscountTargetType {
  /** Target type is a buy x get y */
  BUY_X_GET_Y = 'BUY_X_GET_Y',
  /** Target type is a set of specific items */
  SPECIFIC_ITEMS = 'SPECIFIC_ITEMS',
  /** Target type is not defined */
  UNDEFINED = 'UNDEFINED'
}

export type ComWixEcomDiscountsDiscountTrigger = {
  /** Chain multiple triggers with the `and` operator. */
  and?: Maybe<ComWixEcomDiscountsDiscountTriggerAnd>;
  /** Custom trigger. */
  customTrigger?: Maybe<ComWixEcomDiscountsDiscountTriggerCustom>;
  /** Customer Eligibility info */
  customerEligibility?: Maybe<ComWixEcomDiscountsCustomerEligibility>;
  /** Item quantity trigger range. */
  itemQuantityRange?: Maybe<ComWixEcomDiscountsDiscountTriggerItemQuantityRange>;
  /** Chain multiple triggers with the `or` operator. */
  or?: Maybe<ComWixEcomDiscountsDiscountTriggerOr>;
  /** Subtotal trigger range. */
  subtotalRange?: Maybe<ComWixEcomDiscountsDiscountTriggerSubtotalRange>;
  /** Trigger type. */
  triggerType?: Maybe<ComWixEcomDiscountsDiscountTriggerTriggerType>;
};

export type ComWixEcomDiscountsDiscountTriggerAnd = {
  /** List of triggers to have an "AND" operator between their results. */
  triggers?: Maybe<Array<Maybe<ComWixEcomDiscountsDiscountTrigger>>>;
};

export type ComWixEcomDiscountsDiscountTriggerAndInput = {
  /** List of triggers to have an "AND" operator between their results. */
  triggers?: InputMaybe<Array<InputMaybe<ComWixEcomDiscountsDiscountTriggerInput>>>;
};

export type ComWixEcomDiscountsDiscountTriggerCustom = {
  /** ID of the app that created the trigger. */
  appId?: Maybe<Scalars['String']>;
  /** Trigger ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Additional data in { "key": value } form.
   * + This data will be passed to the Custom Triggers Service SPI.
   * + For example, for a trigger that would activate if temperature is above 30 degrees, `params` field would be: `{ "minTemp": 30 }`.
   */
  params?: Maybe<Scalars['JSON']>;
};

export type ComWixEcomDiscountsDiscountTriggerCustomInput = {
  /** ID of the app that created the trigger. */
  appId?: InputMaybe<Scalars['String']>;
  /** Trigger ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Additional data in { "key": value } form.
   * + This data will be passed to the Custom Triggers Service SPI.
   * + For example, for a trigger that would activate if temperature is above 30 degrees, `params` field would be: `{ "minTemp": 30 }`.
   */
  params?: InputMaybe<Scalars['JSON']>;
};

export type ComWixEcomDiscountsDiscountTriggerInput = {
  /** Chain multiple triggers with the `and` operator. */
  and?: InputMaybe<ComWixEcomDiscountsDiscountTriggerAndInput>;
  /** Custom trigger. */
  customTrigger?: InputMaybe<ComWixEcomDiscountsDiscountTriggerCustomInput>;
  /** Customer Eligibility info */
  customerEligibility?: InputMaybe<ComWixEcomDiscountsCustomerEligibilityInput>;
  /** Item quantity trigger range. */
  itemQuantityRange?: InputMaybe<ComWixEcomDiscountsDiscountTriggerItemQuantityRangeInput>;
  /** Chain multiple triggers with the `or` operator. */
  or?: InputMaybe<ComWixEcomDiscountsDiscountTriggerOrInput>;
  /** Subtotal trigger range. */
  subtotalRange?: InputMaybe<ComWixEcomDiscountsDiscountTriggerSubtotalRangeInput>;
  /** Trigger type. */
  triggerType?: InputMaybe<ComWixEcomDiscountsDiscountTriggerTriggerType>;
};

export type ComWixEcomDiscountsDiscountTriggerItemQuantityRange = {
  /** Minimum item quantity (inclusive). */
  from?: Maybe<Scalars['Int']>;
  /** Relevant scopes for `SPECIFIC_ITEMS` target type. */
  scopes?: Maybe<Array<Maybe<ComWixEcomDiscountsScope>>>;
  /** Maximum item quantity (inclusive). */
  to?: Maybe<Scalars['Int']>;
};

export type ComWixEcomDiscountsDiscountTriggerItemQuantityRangeInput = {
  /** Minimum item quantity (inclusive). */
  from?: InputMaybe<Scalars['Int']>;
  /** Relevant scopes for `SPECIFIC_ITEMS` target type. */
  scopes?: InputMaybe<Array<InputMaybe<ComWixEcomDiscountsScopeInput>>>;
  /** Maximum item quantity (inclusive). */
  to?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomDiscountsDiscountTriggerOr = {
  /** List of triggers to have an "OR" operator between their results. */
  triggers?: Maybe<Array<Maybe<ComWixEcomDiscountsDiscountTrigger>>>;
};

export type ComWixEcomDiscountsDiscountTriggerOrInput = {
  /** List of triggers to have an "OR" operator between their results. */
  triggers?: InputMaybe<Array<InputMaybe<ComWixEcomDiscountsDiscountTriggerInput>>>;
};

export type ComWixEcomDiscountsDiscountTriggerSubtotalRange = {
  /** Minimum subtotal price (inclusive). */
  from?: Maybe<Scalars['String']>;
  /** Relevant scopes for `SPECIFIC_ITEMS` target type. */
  scopes?: Maybe<Array<Maybe<ComWixEcomDiscountsScope>>>;
  /** Maximum subtotal price (inclusive). */
  to?: Maybe<Scalars['String']>;
};

export type ComWixEcomDiscountsDiscountTriggerSubtotalRangeInput = {
  /** Minimum subtotal price (inclusive). */
  from?: InputMaybe<Scalars['String']>;
  /** Relevant scopes for `SPECIFIC_ITEMS` target type. */
  scopes?: InputMaybe<Array<InputMaybe<ComWixEcomDiscountsScopeInput>>>;
  /** Maximum subtotal price (inclusive). */
  to?: InputMaybe<Scalars['String']>;
};

export enum ComWixEcomDiscountsDiscountTriggerTriggerType {
  /** Operator used for chaining multiple triggers. Currently 1 `AND` chain operator is supported. */
  AND = 'AND',
  /** Custom trigger type defined in `customTrigger` object. */
  CUSTOM = 'CUSTOM',
  /** Customer eligibility type must be within specified `customerEligibility` values. */
  CUSTOMER_ELIGIBILITY = 'CUSTOMER_ELIGIBILITY',
  /** Quantity of items in scope must be within specified `itemQuantityRange` values. */
  ITEM_QUANTITY_RANGE = 'ITEM_QUANTITY_RANGE',
  /** Chain multiple triggers with OR operator */
  OR = 'OR',
  /** Subtotal must be within the specified `subtotalRange` values. */
  SUBTOTAL_RANGE = 'SUBTOTAL_RANGE',
  UNDEFINED = 'UNDEFINED'
}

export type ComWixEcomDiscountsDiscounts = {
  /** Discounts. */
  values?: Maybe<Array<Maybe<ComWixEcomDiscountsDiscount>>>;
};

export type ComWixEcomDiscountsDiscountsInput = {
  /** Discounts. */
  values?: InputMaybe<Array<InputMaybe<ComWixEcomDiscountsDiscountInput>>>;
};

export type ComWixEcomDiscountsGetAppliedDiscountsRequestInput = {
  /**
   * The business location ID to be used as the basis for some calculations.
   * Learn more about the [Locations API](https://dev.wix.com/docs/rest/business-management/locations/introduction).
   */
  businessLocationId?: InputMaybe<Scalars['String']>;
  /** Buyer Information */
  buyerInfo?: InputMaybe<ComWixEcomDiscountsBuyerInfoInput>;
  /** Line items for which to check for discount rules. */
  lineItems?: InputMaybe<Array<InputMaybe<ComWixEcomDiscountsLineItemInput>>>;
  /** Persistent ID that correlates between the various eCommerce elements: cart, checkout, and order. */
  purchaseFlowId?: InputMaybe<Scalars['String']>;
  /** Shipping information. */
  shippingInfo?: InputMaybe<ComWixEcomDiscountsShippingInfoInput>;
};

export type ComWixEcomDiscountsGetAppliedDiscountsResponse = {
  /** All eligible discounts. */
  appliedDiscounts?: Maybe<Array<Maybe<ComWixEcomDiscountsAppliedDiscount>>>;
};

export type ComWixEcomDiscountsGetDiscountRuleRequestInput = {
  id: Scalars['ID'];
};

export type ComWixEcomDiscountsIndividualContacts = {
  /** Eligible contact ids. */
  contactIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Eligible contact ids. */
  contacts?: Maybe<ComWixpressContactsCoreApiV4QueryContactsResponse>;
};


export type ComWixEcomDiscountsIndividualContactsContactsArgs = {
  queryInput?: InputMaybe<ComWixpressContactsCoreApiV4QueryContactsRequestInput>;
};

export type ComWixEcomDiscountsIndividualContactsInput = {
  /** Eligible contact ids. */
  contactIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomDiscountsLineItemInput = {
  /** Catalog and item reference info. Learn more about [integrating Wix Stores products with Wix eCommerce](https://dev.wix.com/api/rest/wix-stores/catalog/ecommerce-integration). */
  catalogReference?: InputMaybe<ComWixEcommerceCatalogSpiApiV1CatalogReferenceInput>;
  /** Line item ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Line item price. */
  price?: InputMaybe<Scalars['String']>;
  /** Line item quantity. */
  quantity?: InputMaybe<Scalars['Int']>;
  /**
   * Additional ID for the item in the catalog.
   * This field provides an additional identifier for the item if your flow requires another ID as well as `catalogReference.catalogItemId`.
   * Can be used for membership validation.
   */
  rootCatalogItemId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomDiscountsQuantityBased = {
  /** list of discountConfig options. */
  configurations?: Maybe<Array<Maybe<ComWixEcomDiscountsDiscountConfig>>>;
};

export type ComWixEcomDiscountsQuantityBasedInput = {
  /** list of discountConfig options. */
  configurations?: InputMaybe<Array<InputMaybe<ComWixEcomDiscountsDiscountConfigInput>>>;
};

export type ComWixEcomDiscountsQueryDiscountRulesRequestInput = {
  /** Query options. */
  query?: InputMaybe<ComWixEcommerceCommonsApiPlatformQueryInput>;
};

export type ComWixEcomDiscountsQueryDiscountRulesResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixEcomDiscountsDiscountRule>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixEcomDiscountsRecurrence = {
  /** Weekly discount recurrence. */
  weeklySchedule?: Maybe<ComWixEcomDiscountsRecurrenceWeeklySchedule>;
};

export type ComWixEcomDiscountsRecurrenceInput = {
  /** Weekly discount recurrence. */
  weeklySchedule?: InputMaybe<ComWixEcomDiscountsRecurrenceWeeklyScheduleInput>;
};

export type ComWixEcomDiscountsRecurrenceWeeklySchedule = {
  /** A list of days with their respective active time ranges. */
  timeWindows?: Maybe<Array<Maybe<ComWixEcomDiscountsRecurrenceWeeklyScheduleTimeWindow>>>;
};

export type ComWixEcomDiscountsRecurrenceWeeklyScheduleInput = {
  /** A list of days with their respective active time ranges. */
  timeWindows?: InputMaybe<Array<InputMaybe<ComWixEcomDiscountsRecurrenceWeeklyScheduleTimeWindowInput>>>;
};

export type ComWixEcomDiscountsRecurrenceWeeklyScheduleTimeWindow = {
  /** Day of week. */
  dayOfWeek?: Maybe<ComWixEcomDiscountsDayOfWeek>;
  /** End time window during each recurrence. */
  endTime?: Maybe<ComWixEcomDiscountsTimeOfDay>;
  /** Start time window during each recurrence. */
  startTime?: Maybe<ComWixEcomDiscountsTimeOfDay>;
};

export type ComWixEcomDiscountsRecurrenceWeeklyScheduleTimeWindowInput = {
  /** Day of week. */
  dayOfWeek?: InputMaybe<ComWixEcomDiscountsDayOfWeek>;
  /** End time window during each recurrence. */
  endTime?: InputMaybe<ComWixEcomDiscountsTimeOfDayInput>;
  /** Start time window during each recurrence. */
  startTime?: InputMaybe<ComWixEcomDiscountsTimeOfDayInput>;
};

export type ComWixEcomDiscountsScope = {
  /** Catalog item filter. Must be passed with `type."CATALOG_ITEM"`. */
  catalogItemFilter?: Maybe<ComWixEcomDiscountsCatalogItemFilter>;
  /** Custom filter. Must be passed with `type."CATALOG_ITEM"`. */
  customFilter?: Maybe<ComWixEcomDiscountsCustomFilter>;
  /** Scope ID. */
  id?: Maybe<Scalars['String']>;
  /** Scope type. */
  type?: Maybe<ComWixEcomDiscountsScopeType>;
};

export type ComWixEcomDiscountsScopeInput = {
  /** Catalog item filter. Must be passed with `type."CATALOG_ITEM"`. */
  catalogItemFilter?: InputMaybe<ComWixEcomDiscountsCatalogItemFilterInput>;
  /** Custom filter. Must be passed with `type."CATALOG_ITEM"`. */
  customFilter?: InputMaybe<ComWixEcomDiscountsCustomFilterInput>;
  /** Scope ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Scope type. */
  type?: InputMaybe<ComWixEcomDiscountsScopeType>;
};

export enum ComWixEcomDiscountsScopeType {
  /** Specific catalog items */
  CATALOG_ITEM = 'CATALOG_ITEM',
  /** Specific items by custom filters */
  CUSTOM_FILTER = 'CUSTOM_FILTER',
  UNDEFINED_SCOPE = 'UNDEFINED_SCOPE'
}

export type ComWixEcomDiscountsShippingInfoInput = {
  /** Address (if applicable). */
  address?: InputMaybe<ComWixEcomDiscountsAddressInput>;
  /** Preferred shipping option code. For example, "usps_std_overnight". */
  preferredShippingOptionCode?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomDiscountsSpecificItemsInfo = {
  /**
   * limit number of items the discount can be applied to
   * if no limit specified, the discount will be applied to all items in the request that match 'scopes' field
   */
  limit?: Maybe<Scalars['Int']>;
  /** All associated scopes for `SPECIFIC_ITEMS` target type. */
  scopes?: Maybe<Array<Maybe<ComWixEcomDiscountsScope>>>;
};

export type ComWixEcomDiscountsSpecificItemsInfoInput = {
  /**
   * limit number of items the discount can be applied to
   * if no limit specified, the discount will be applied to all items in the request that match 'scopes' field
   */
  limit?: InputMaybe<Scalars['Int']>;
  /** All associated scopes for `SPECIFIC_ITEMS` target type. */
  scopes?: InputMaybe<Array<InputMaybe<ComWixEcomDiscountsScopeInput>>>;
};

export type ComWixEcomDiscountsTagReference = {
  /** Eligible label id. */
  labelKey?: Maybe<Scalars['String']>;
  /** Eligible tag id. */
  tagId?: Maybe<Scalars['String']>;
};

export type ComWixEcomDiscountsTagReferenceInput = {
  /** Eligible label id. */
  labelKey?: InputMaybe<Scalars['String']>;
  /** Eligible tag id. */
  tagId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomDiscountsTimeOfDay = {
  /** Hours. Min: `0`. Max: `23`. */
  hours?: Maybe<Scalars['Int']>;
  /** Minutes. Min: `0`. Max: `59`. */
  minutes?: Maybe<Scalars['Int']>;
};

export type ComWixEcomDiscountsTimeOfDayInput = {
  /** Hours. Min: `0`. Max: `23`. */
  hours?: InputMaybe<Scalars['Int']>;
  /** Minutes. Min: `0`. Max: `59`. */
  minutes?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomDiscountsUpdateDiscountRuleRequestInput = {
  /** Discount rule info. */
  discountRule?: InputMaybe<ComWixEcomDiscountsDiscountRuleInput>;
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomDiscountsUpdateDiscountRuleResponse = {
  /** Updated discount rule. */
  discountRule?: Maybe<ComWixEcomDiscountsDiscountRule>;
};

export type ComWixEcomLineItemsEnricherSpiApiV1EnrichedLineItem = {
  /** Line item ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Description lines to replace the original
   * This is optional - If you do not want to override, do not return this and the original description lines will be used
   * If you do pass it, it overrides the existing description line.
   * If you want to append, copy the original description lines and add your own
   */
  overriddenDescriptionLines?: Maybe<ComWixEcomLineItemsEnricherSpiApiV1OverriddenDescriptionLines>;
  /** Option to hide specific sections */
  renderingConfig?: Maybe<ComWixEcomLineItemsEnricherSpiApiV1LineItemRenderingConfig>;
};

export type ComWixEcomLineItemsEnricherSpiApiV1EnrichedLineItemWithActions = {
  /**
   * Optional list of actions to be rendered next to the line item
   * Implementation depends on the client (checkout page, mobile)
   */
  actions?: Maybe<Array<Maybe<ComWixEcomLineItemsEnricherSpiApiV1LineItemAction>>>;
  /** Line item ID */
  id?: Maybe<Scalars['String']>;
  /**
   * Description lines to replace the original
   * This is optional - If you do not want to override, do not return this and the original description lines will be used
   * If you do pass it, it overrides the existing description line.
   * If you want to append, copy the original description lines and add your own
   */
  overriddenDescriptionLines?: Maybe<ComWixEcomLineItemsEnricherSpiApiV1OverriddenDescriptionLines>;
  /** Option to hide specific sections */
  renderingConfig?: Maybe<ComWixEcomLineItemsEnricherSpiApiV1LineItemRenderingConfig>;
};

export type ComWixEcomLineItemsEnricherSpiApiV1LineItemAction = {
  /**
   * The unique id of the action
   * for example: DOWNLOAD_LINK, ADD_TO_CALENDAR
   * Note that a specific client may rely on action id and parameters and ignore the URL or the other way around
   */
  actionId?: Maybe<Scalars['String']>;
  /** Parameters for the actions, will be used by the client implementing the action based on actionId */
  actionParameters?: Maybe<Scalars['JSON']>;
  /** the translated text to display (i.e. will be shown "as is") */
  label?: Maybe<Scalars['String']>;
  /** the key that we use to save the text in the editor settings panel */
  settingsKey?: Maybe<Scalars['String']>;
  /**
   * URL to navigate to in order to perform the action
   * can be relative e.g "/api/download" or absolute e.g. "http://www.google.com"
   * Note that a specific client may rely on action id and parameters and ignore the URL or the other way around
   */
  url?: Maybe<Scalars['String']>;
};

export type ComWixEcomLineItemsEnricherSpiApiV1LineItemRenderingConfig = {
  hidePrice?: Maybe<Scalars['Boolean']>;
  hideQuantity?: Maybe<Scalars['Boolean']>;
};

export type ComWixEcomLineItemsEnricherSpiApiV1OverriddenDescriptionLines = {
  descriptionLines?: Maybe<Array<Maybe<ComWixEcommerceCatalogSpiApiV1DescriptionLine>>>;
};

export type ComWixEcomLineItemsEnricherSpiHostApiV1EnrichLineItemsForCheckoutResponse = {
  enrichedLineItems?: Maybe<Array<Maybe<ComWixEcomLineItemsEnricherSpiApiV1EnrichedLineItem>>>;
};

export type ComWixEcomLineItemsEnricherSpiHostApiV1EnrichLineItemsForOrderPageResponse = {
  enrichedLineItems?: Maybe<Array<Maybe<ComWixEcomLineItemsEnricherSpiApiV1EnrichedLineItem>>>;
};

export type ComWixEcomLineItemsEnricherSpiHostApiV1EnrichLineItemsForThankYouPageResponse = {
  enrichedLineItems?: Maybe<Array<Maybe<ComWixEcomLineItemsEnricherSpiApiV1EnrichedLineItemWithActions>>>;
};

export type ComWixEcomMembershipsSpiV1HostInvalidMembership = {
  /** Membership details. */
  membership?: Maybe<ComWixEcomMembershipsSpiV1HostMembership>;
  /** Reason why this membership is invalid and cannot be used. */
  reason?: Maybe<Scalars['String']>;
};

export type ComWixEcomMembershipsSpiV1HostInvalidMembershipInput = {
  /** Membership details. */
  membership?: InputMaybe<ComWixEcomMembershipsSpiV1HostMembershipInput>;
  /** Reason why this membership is invalid and cannot be used. */
  reason?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomMembershipsSpiV1HostMembership = {
  /** Additional data about this membership. */
  additionalData?: Maybe<Scalars['JSON']>;
  /** ID of the application providing this payment option. */
  appId?: Maybe<Scalars['String']>;
  /** Optional - For a membership that has limited credits, information about credit usage. */
  credits?: Maybe<ComWixEcomMembershipsSpiV1MembershipPaymentCredits>;
  /** Optional - TMembership expiry date. */
  expirationDate?: Maybe<Scalars['String']>;
  /** Membership ID. */
  id?: Maybe<Scalars['String']>;
  /** Line item IDs which are "paid" for by this membership. */
  lineItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The name of this membership. */
  name?: Maybe<ComWixEcomMembershipsSpiV1MembershipName>;
};

export type ComWixEcomMembershipsSpiV1HostMembershipInput = {
  /** Additional data about this membership. */
  additionalData?: InputMaybe<Scalars['JSON']>;
  /** ID of the application providing this payment option. */
  appId?: InputMaybe<Scalars['String']>;
  /** Optional - For a membership that has limited credits, information about credit usage. */
  credits?: InputMaybe<ComWixEcomMembershipsSpiV1MembershipPaymentCreditsInput>;
  /** Optional - TMembership expiry date. */
  expirationDate?: InputMaybe<Scalars['String']>;
  /** Membership ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Line item IDs which are "paid" for by this membership. */
  lineItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The name of this membership. */
  name?: InputMaybe<ComWixEcomMembershipsSpiV1MembershipNameInput>;
};

export type ComWixEcomMembershipsSpiV1HostSelectedMembership = {
  /** ID of the app providing this payment option. */
  appId?: Maybe<Scalars['String']>;
  /** Membership ID. */
  id?: Maybe<Scalars['String']>;
  /** IDs of the line items this membership applies to. */
  lineItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixEcomMembershipsSpiV1HostSelectedMembershipInput = {
  /** ID of the app providing this payment option. */
  appId?: InputMaybe<Scalars['String']>;
  /** Membership ID. */
  id?: InputMaybe<Scalars['String']>;
  /** IDs of the line items this membership applies to. */
  lineItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomMembershipsSpiV1HostSelectedMemberships = {
  /** Selected memberships. */
  memberships?: Maybe<Array<Maybe<ComWixEcomMembershipsSpiV1HostSelectedMembership>>>;
};

export type ComWixEcomMembershipsSpiV1HostSelectedMembershipsInput = {
  /** Selected memberships. */
  memberships?: InputMaybe<Array<InputMaybe<ComWixEcomMembershipsSpiV1HostSelectedMembershipInput>>>;
};

export type ComWixEcomMembershipsSpiV1MembershipName = {
  /** Membership name. */
  original?: Maybe<Scalars['String']>;
  /** Translated membership name. Defaults to `original` when not provided. */
  translated?: Maybe<Scalars['String']>;
};

export type ComWixEcomMembershipsSpiV1MembershipNameInput = {
  /** Membership name. */
  original?: InputMaybe<Scalars['String']>;
  /** Translated membership name. Defaults to `original` when not provided. */
  translated?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomMembershipsSpiV1MembershipPaymentCredits = {
  /** Membership's remaining amount of credits. */
  remaining?: Maybe<Scalars['Int']>;
  /** Membership's total amount of credits. */
  total?: Maybe<Scalars['Int']>;
};

export type ComWixEcomMembershipsSpiV1MembershipPaymentCreditsInput = {
  /** Membership's remaining amount of credits. */
  remaining?: InputMaybe<Scalars['Int']>;
  /** Membership's total amount of credits. */
  total?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomOrdersBillingV1AdditionalFeeRefund = {
  /** Additional fee ID. */
  additionalFeeId?: Maybe<Scalars['String']>;
  /**
   * Amount to refund.
   *
   * Passing an empty value will refund the remaining refundable amount.
   */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersBillingV1AdditionalFeeRefundInput = {
  /** Additional fee ID. */
  additionalFeeId?: InputMaybe<Scalars['String']>;
  /**
   * Amount to refund.
   *
   * Passing an empty value will refund the remaining refundable amount.
   */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersBillingV1AdditionalFeeRefundOption = {
  /** Additional fee ID. */
  additionalFeeId?: Maybe<Scalars['String']>;
  /** Original additional fee amount. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Additional fee amount available for refund. */
  availableRefundAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Previously refunded additional fee amount. */
  refundedAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersBillingV1AdditionalFeeRefundability = {
  /** Additional fee ID. */
  additionalFeeId?: Maybe<Scalars['String']>;
  /** Original additional fee amount. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Additional fee amount available for refund. */
  availableRefundAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Previously refunded additional fee amount. */
  refundedAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersBillingV1AggregatedRefundSummary = {
  /** Total cost of the additional fees being refunded. */
  additionalFeesTotal?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Discount amount for the items being refunded. */
  discount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total cost of the line items being refunded (without tax and discount). */
  lineItemsSubtotal?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total cost of the items being refunded (without tax and discount). */
  subtotal?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Tax amount for the items being refunded. */
  tax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total refund amount. */
  total?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersBillingV1AuthorizeChargeWithSavedPaymentMethodRequestInput = {
  /** Amount to authorize. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Currency code, in [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217#List_of_ISO_4217_currency_codes) format. */
  currency?: InputMaybe<Scalars['String']>;
  /** Settings for scheduled action to perform automatically. */
  delayedCaptureSettings?: InputMaybe<ComWixEcomOrdersBillingV1DelayedCaptureSettingsInput>;
  /**
   * Order ID.
   *
   * The order must have a saved payment method associated.
   * Pass the order ID to the List Transactions For Single Order method and search the response for a payment with `regularPaymentDetails.savedPaymentMethod: true`.
   * If no saved payment exists, the call will fail.
   */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersBillingV1AuthorizeChargeWithSavedPaymentMethodResponse = {
  /** Order transactions updated with authorized payment. */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
  /** Authorized payment. */
  payment?: Maybe<ComWixEcomOrdersPaymentsV1Payment>;
};

export type ComWixEcomOrdersBillingV1AuthorizePaymentWithSavedPaymentMethodRequestInput = {
  /** Amount to authorize on saved payment method. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Currency. */
  currency?: InputMaybe<Scalars['String']>;
  /** Delayed capture settings. */
  delayedCaptureSettings?: InputMaybe<ComWixEcomOrdersBillingV1DelayedCaptureSettingsInput>;
  /** Order ID. Must have saved payment method associated with it. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersBillingV1AuthorizePaymentWithSavedPaymentMethodResponse = {
  /** Order transactions after payment was authorized. */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
  /** Authorized payment, created using saved payment method. */
  payment?: Maybe<ComWixEcomOrdersPaymentsV1Payment>;
};

export type ComWixEcomOrdersBillingV1CalculateRefundRequestInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
  /** List of line items, shipping and additional fees to be calculated for refund. */
  refundItems?: InputMaybe<ComWixEcomOrdersBillingV1RefundItemsInput>;
};

export type ComWixEcomOrdersBillingV1CalculateRefundResponse = {
  /** Whether refund is available for the given list of items. */
  available?: Maybe<Scalars['Boolean']>;
  /** Calculated summary of each item provided for refund. */
  calculatedRefundItems?: Maybe<ComWixEcomOrdersBillingV1CalculatedRefundItems>;
  /** If the calculated refund is not available, this field contains error details and amounts for each item. */
  notAvailable?: Maybe<ComWixEcomOrdersBillingV1CalculatedRefundNotAvailableStatus>;
  /**
   * Aggregated summary of all items provided for refund.
   *
   * This field is not returned when refund is not available for the given list of items.
   */
  summary?: Maybe<ComWixEcomOrdersBillingV1AggregatedRefundSummary>;
};

export type ComWixEcomOrdersBillingV1CalculatedAdditionalFeeRefund = {
  /** Additional fee refund details. */
  additionalFee?: Maybe<ComWixEcomOrdersBillingV1AdditionalFeeRefund>;
  /** Calculated refund summary for this additional fee. */
  summary?: Maybe<ComWixEcomOrdersBillingV1CalculatedRefundSummary>;
};

export type ComWixEcomOrdersBillingV1CalculatedLineItemRefund = {
  /** Line item refund details. */
  item?: Maybe<ComWixEcomOrdersBillingV1LineItemRefund>;
  /** Calculated refund summary for this line item. */
  summary?: Maybe<ComWixEcomOrdersBillingV1CalculatedRefundSummary>;
};

export type ComWixEcomOrdersBillingV1CalculatedRefundItems = {
  /** Calculated refund details for each additional fee. */
  additionalFees?: Maybe<Array<Maybe<ComWixEcomOrdersBillingV1CalculatedAdditionalFeeRefund>>>;
  /** Calculated refund details for each line item. */
  lineItems?: Maybe<Array<Maybe<ComWixEcomOrdersBillingV1CalculatedLineItemRefund>>>;
  /** Calculated refund details for the shipping fee. */
  shipping?: Maybe<ComWixEcomOrdersBillingV1CalculatedShippingRefund>;
};

export type ComWixEcomOrdersBillingV1CalculatedRefundNotAvailableStatus = {
  /** Refund calculation errors. */
  errors?: Maybe<Array<Maybe<ComWixEcomOrdersBillingV1CalculationError>>>;
};

export type ComWixEcomOrdersBillingV1CalculatedRefundSummary = {
  /** Discount amount for the items being refunded. */
  discount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total cost of the items being refunded (without tax and discount). */
  subtotal?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Tax amount for the items being refunded. */
  tax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total refundable amount. */
  total?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersBillingV1CalculatedShippingRefund = {
  /** Shipping refund details. */
  shipping?: Maybe<ComWixEcomOrdersBillingV1ShippingRefund>;
  /** Calculated refund summary for shipping. */
  summary?: Maybe<ComWixEcomOrdersBillingV1CalculatedRefundSummary>;
};

export type ComWixEcomOrdersBillingV1CalculationError = {
  /** Additional fee */
  additionalFee?: Maybe<ComWixEcomOrdersBillingV1AdditionalFeeRefund>;
  /** Error details */
  error?: Maybe<WixApiDetails>;
  /** Line item */
  lineItem?: Maybe<ComWixEcomOrdersBillingV1LineItemRefund>;
  /** Shipping */
  shipping?: Maybe<ComWixEcomOrdersBillingV1ShippingRefund>;
};

export type ComWixEcomOrdersBillingV1CaptureAuthorizedPaymentsRequestInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
  /** List payment IDs and amounts to capture. */
  payments?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersBillingV1PaymentCaptureInput>>>;
};

export type ComWixEcomOrdersBillingV1CaptureAuthorizedPaymentsResponse = {
  /** Order transactions updated with captured payment. */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
};

export type ComWixEcomOrdersBillingV1DelayedCaptureSettingsInput = {
  /**
   * Delay duration before performing the scheduled action.
   * > **Note:** If not set, the payment provider's default period will be used.
   */
  delayDuration?: InputMaybe<ComWixEcommercePlatformCommonApiDurationInput>;
  /** The action to perform on the authorized payment after the specified duration. */
  scheduledAction?: InputMaybe<ComWixEcomOrdersBillingV1DelayedCaptureSettingsScheduledAction>;
};

export enum ComWixEcomOrdersBillingV1DelayedCaptureSettingsScheduledAction {
  /** Whether payment will be auto-captured when duration passes. */
  CAPTURE = 'CAPTURE',
  UNSPECIFIED = 'UNSPECIFIED',
  /** Whether payment will be auto-voided when duration passes. */
  VOID = 'VOID'
}

export type ComWixEcomOrdersBillingV1ExternalRefundInfoInput = {
  /**
   * Affects the refund status of the refund and payment.
   * If set to `SUCCEEDED`, the payment will be marked as refunded immediately.
   * If set to `PENDING`, the payment will not be marked as refunded until the payment provider notifies us about the success/failure of the refund
   * OR until the caller updates the refund status to SUCCEEDED/FAILED. Meanwhile additional refunds for this payment are blocked.
   */
  refundStatus?: InputMaybe<ComWixEcomOrdersBillingV1ExternalRefundStatus>;
};

export enum ComWixEcomOrdersBillingV1ExternalRefundStatus {
  /** An external refund was or going to be initiated on payment provider side. */
  PENDING = 'PENDING',
  /** An external refund transaction succeeded. */
  SUCCEEDED = 'SUCCEEDED'
}

export type ComWixEcomOrdersBillingV1GenerateReceiptsRequestInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
  /** Payment IDs. */
  paymentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersBillingV1GenerateReceiptsResponse = {
  /** Generated receipts information. */
  receipts?: Maybe<Array<Maybe<ComWixEcomOrdersBillingV1ReceiptInfo>>>;
};

export type ComWixEcomOrdersBillingV1GetOrderRefundabilityRequestInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersBillingV1GetOrderRefundabilityResponse = {
  /** List of additional fee refund amounts - both previously refunded and the amount still available for refund. */
  additionalFees?: Maybe<Array<Maybe<ComWixEcomOrdersBillingV1AdditionalFeeRefundability>>>;
  /** Line item refundability showing available refund quantities for each product. */
  lineItems?: Maybe<Array<Maybe<ComWixEcomOrdersBillingV1LineItemRefundability>>>;
  /**
   * Payment refundability status and amounts for each payment method used in the order.
   *
   * Shows whether payments can be refunded automatically, manually, or not at all.
   */
  payments?: Maybe<Array<Maybe<ComWixEcomOrdersBillingV1PaymentRefundability>>>;
  /** Aggregated summary of all payment amounts across all payment methods. */
  paymentsSummary?: Maybe<ComWixEcomOrdersBillingV1PaymentsSummary>;
  /**
   * Shipping refundability including original amount, previously refunded amount, and remaining refundable amount.
   *
   * Only present if the order includes shipping charges.
   */
  shipping?: Maybe<ComWixEcomOrdersBillingV1ShippingRefundability>;
};

export type ComWixEcomOrdersBillingV1GetRefundOptionsRequestInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersBillingV1GetRefundOptionsResponse = {
  /** Refund options for additional fees: Describes available refund amount per additional fee. */
  additionalFeeRefundOptions?: Maybe<Array<Maybe<ComWixEcomOrdersBillingV1AdditionalFeeRefundOption>>>;
  /** Refund options for order items: Describes how much of each item can be refunded. */
  lineItemRefundOptions?: Maybe<Array<Maybe<ComWixEcomOrdersBillingV1LineItemRefundOption>>>;
  /**
   * Refund options for payments, linked to given order.
   * Contains refundability status and max refund amounts for each payment.
   */
  paymentRefundOptions?: Maybe<Array<Maybe<ComWixEcomOrdersBillingV1PaymentRefundOption>>>;
  /** Aggregated summary of payments. */
  paymentsSummary?: Maybe<ComWixEcomOrdersBillingV1PaymentsSummary>;
  /** Refund option for shipping: Describes available refund amount for shipping. */
  shippingRefundOption?: Maybe<ComWixEcomOrdersBillingV1ShippingRefundOption>;
};

export type ComWixEcomOrdersBillingV1LineItemRefund = {
  /** Line item ID. */
  lineItemId?: Maybe<Scalars['String']>;
  /** Quantity to refund. */
  quantity?: Maybe<Scalars['Int']>;
};

export type ComWixEcomOrdersBillingV1LineItemRefundInput = {
  /** Line item ID. */
  lineItemId?: InputMaybe<Scalars['String']>;
  /** Quantity to refund. */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomOrdersBillingV1LineItemRefundOption = {
  /** Line item quantity that is available for refund. */
  availableRefundQuantity?: Maybe<Scalars['Int']>;
  /** Line item ID. */
  lineItemId?: Maybe<Scalars['String']>;
  /** Original line item quantity before any refunds. */
  originalQuantity?: Maybe<Scalars['Int']>;
  /** Previously refunded line item quantity. */
  refundedQuantity?: Maybe<Scalars['Int']>;
};

export type ComWixEcomOrdersBillingV1LineItemRefundability = {
  /** Maximum quantity of this item that can still be refunded. */
  availableRefundQuantity?: Maybe<Scalars['Int']>;
  /** Line item ID. */
  lineItemId?: Maybe<Scalars['String']>;
  /** Total quantity of this item originally ordered. */
  originalQuantity?: Maybe<Scalars['Int']>;
  /** Quantity of this item previously refunded across all refund transactions. */
  refundedQuantity?: Maybe<Scalars['Int']>;
};

export type ComWixEcomOrdersBillingV1ManuallyRefundablePaymentStatus = {
  /** Specific reason why this payment requires manual refund processing. */
  reason?: Maybe<ComWixEcomOrdersBillingV1ManuallyRefundablePaymentStatusManuallyRefundableReason>;
};

export enum ComWixEcomOrdersBillingV1ManuallyRefundablePaymentStatusManuallyRefundableReason {
  /**
   * Payment authorization or refund window has expired with the payment provider.
   * Refunds must be processed manually through the provider's dashboard.
   */
  EXPIRED = 'EXPIRED',
  /**
   * Payment provider does not support automatic refunds for this payment method.
   * Manual refund through provider dashboard is required.
   */
  NOT_SUPPORTED = 'NOT_SUPPORTED',
  /**
   * Payment was processed offline (cash, check, or manually marked as paid).
   * Refund must be handled manually outside the payment system.
   */
  OFFLINE = 'OFFLINE',
  /**
   * Payment requires a physical card reader device to process the refund.
   * Typically applies to in-person credit card transactions.
   */
  REQUIRES_CARD_READER = 'REQUIRES_CARD_READER',
  /** Unknown manual refund reason. */
  UNKNOWN_REASON = 'UNKNOWN_REASON'
}

export type ComWixEcomOrdersBillingV1MembershipPaymentSummary = {
  /** Line item IDs that were originally paid using membership credits or benefits. */
  paidLineItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Line item IDs paid with membership benefits that can still be refunded.
   * Refunding these items may restore membership credits to the customer's account.
   */
  refundableLineItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Line item IDs that were previously refunded and had been paid with membership benefits.
   * These items have already been processed for membership credit restoration.
   */
  refundedLineItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersBillingV1MonetaryPaymentSummary = {
  /**
   * Maximum amount available for additional refunds if the payment is refundable.
   * Calculated as: `paid` - `refunded` - `refundPending`
   */
  maxRefund?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Amount paid. */
  paid?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Amount currently being processed for refund but not yet completed. */
  refundPending?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total amount already refunded from this payment method. */
  refunded?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersBillingV1NonRefundablePaymentStatus = {
  /** Specific reason why this payment cannot be refunded through any method. */
  reason?: Maybe<ComWixEcomOrdersBillingV1NonRefundablePaymentStatusNonRefundableReason>;
};

export enum ComWixEcomOrdersBillingV1NonRefundablePaymentStatusNonRefundableReason {
  /** Payment has already been fully refunded. No additional refund amount is available. */
  ALREADY_REFUNDED = 'ALREADY_REFUNDED',
  /** Payment amount has been offset by chargeback claims, preventing standard refund processing. */
  AMOUNT_OFFSET_BY_CHARGEBACK = 'AMOUNT_OFFSET_BY_CHARGEBACK',
  /** Payment provider has disabled refunds for this payment method or account. */
  DISABLED_BY_PROVIDER = 'DISABLED_BY_PROVIDER',
  /** Refund is not allowed due to business rules, compliance restrictions, or account limitations. */
  FORBIDDEN = 'FORBIDDEN',
  /** Payment has not been successfully completed. Only paid transactions can be refunded. */
  NOT_PAID = 'NOT_PAID',
  /** Order is still pending confirmation and has not been finalized for refund processing. */
  ORDER_IS_PENDING = 'ORDER_IS_PENDING',
  /** Order was rejected or cancelled before payment completion, making refunds unnecessary. */
  ORDER_IS_REJECTED = 'ORDER_IS_REJECTED',
  /** A refund is already in progress for this payment. Wait for completion before initiating another refund. */
  PENDING_REFUND = 'PENDING_REFUND',
  /**
   * Payment provider's system is currently unavailable for refund processing.
   * Try again later or contact the provider directly.
   */
  PROVIDER_IS_DOWN = 'PROVIDER_IS_DOWN',
  /** Payment transaction cannot be found in the provider's system, preventing refund processing. */
  TRANSACTION_NOT_FOUND = 'TRANSACTION_NOT_FOUND',
  /** Unknown non-refundable reason. */
  UNKNOWN_REASON = 'UNKNOWN_REASON',
  /** Payment amount is zero, so there is nothing to refund. */
  ZERO_PRICE = 'ZERO_PRICE'
}

export type ComWixEcomOrdersBillingV1PaymentCaptureInput = {
  /**
   * Capture amount.
   *
   * > **Note:** If not provided, the full authorized amount will be captured.
   */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** ID of the payment to capture. */
  paymentId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersBillingV1PaymentInfo = {
  /** Credit card information for credit card payments, including card type and last 4 digits. */
  creditCardDetails?: Maybe<ComWixEcomOrdersPaymentsV1CreditCardPaymentMethodDetails>;
  /** Membership payment details for payments made using membership credits or plans. */
  membership?: Maybe<ComWixEcomOrdersBillingV1MembershipPaymentSummary>;
  /** Monetary payment details with amounts for cash-based payments. */
  monetary?: Maybe<ComWixEcomOrdersBillingV1MonetaryPaymentSummary>;
  /**
   * Whether this payment was processed offline (not through an online payment gateway).
   * Offline payments typically require manual refund processing.
   */
  offlinePayment?: Maybe<Scalars['Boolean']>;
  /** Payment ID used to reference this payment in refund operations. */
  paymentId?: Maybe<Scalars['String']>;
  /**
   * Payment method type used for this transaction.
   *
   * Non-exhaustive list of supported values: `CreditCard`, `Alipay`, `AstropayCash`, `AstropayDBT`, `AstropayMBT`, `Bitcoin`, `BitPay`, `Cash`, `ConvenienceStore`, `EPay`, `Fake`, `Giropay`, `IDeal`, `InPerson`, `Klarna`, `MercadoPago`, `Netpay`, `NordeaSolo`, `Offline`, `PagSeguro`, `PayEasy`, `PayPal`, `Paysafecard`, `Paysafecash`, `PointOfSale`, `Poli`, `Privat24`, `Przelewy24`, `RapidTransfer`, `Sepa`, `Skrill`, `Sofort`, `Trustly`, `Neteller`, `Unionpay`, `UniPay`, `Yandex`
   */
  paymentMethod?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersBillingV1PaymentRefundInput = {
  /** Refund amount. Not relevant for membership and gift card refunds. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /**
   * Indicates that refund is made externally and manually (on the payment provider's side)
   * When false (default), the payment gateway will be called in order to make an actual refund, and then the payment will be marked as refunded.
   * When true, the payment will only be *marked* as refunded, refund will be added with status SUCCEEDED and no actual refund will be performed.
   */
  externalRefund?: InputMaybe<Scalars['Boolean']>;
  /**
   * If set, indicates that refund is made externally and manually (on the payment provider's side) and payment gateway will NOT be called to make an actual refund.
   * When not set (default), the payment gateway will be called in order to make an actual refund, and then the payment will be marked as refunded.
   */
  externalRefundInfo?: InputMaybe<ComWixEcomOrdersBillingV1ExternalRefundInfoInput>;
  /** Specific payment within the order to refund */
  paymentId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersBillingV1PaymentRefundOption = {
  /** Reason why the payment is only manually refundable. */
  manuallyRefundable?: Maybe<ComWixEcomOrdersBillingV1ManuallyRefundablePaymentStatus>;
  /** Reason why the payment is not refundable. */
  nonRefundable?: Maybe<ComWixEcomOrdersBillingV1NonRefundablePaymentStatus>;
  /** Payment details. */
  payment?: Maybe<ComWixEcomOrdersBillingV1PaymentInfo>;
  /** URL to the payment provider's dashboard. */
  providerLink?: Maybe<Scalars['String']>;
  /** Whether the payment is available for both automatic and manual refunds. */
  refundable?: Maybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersBillingV1PaymentRefundability = {
  /**
   * Payment requires manual/external refund processing. Can be manually marked as refunded.
   * Use the provided `providerLink` to access the provider's refund interface.
   */
  manuallyRefundable?: Maybe<ComWixEcomOrdersBillingV1ManuallyRefundablePaymentStatus>;
  /**
   * Payment cannot be refunded due to business rules, provider restrictions, or payment state.
   * Check the specific reason to understand why refunding is not possible.
   */
  nonRefundable?: Maybe<ComWixEcomOrdersBillingV1NonRefundablePaymentStatus>;
  /** Payment details including method, amounts, and transaction information. */
  payment?: Maybe<ComWixEcomOrdersBillingV1PaymentInfo>;
  /**
   * URL to the payment provider's dashboard for manual refund processing.
   * Required when payment has manual refund status.
   */
  providerLink?: Maybe<Scalars['String']>;
  /**
   * Whether the payment supports automatic API-based refunds.
   * Choose automatic refunds for faster processing when possible.
   */
  refundable?: Maybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersBillingV1PaymentsSummary = {
  /** Summary of membership-based payments using credits, plans, or benefits. */
  membership?: Maybe<ComWixEcomOrdersBillingV1MembershipPaymentSummary>;
  /** Summary of cash-based payment methods (credit cards, PayPal, etc.). */
  monetary?: Maybe<ComWixEcomOrdersBillingV1MonetaryPaymentSummary>;
};

export type ComWixEcomOrdersBillingV1ReceiptInfo = {
  /** Payment ID. */
  paymentId?: Maybe<Scalars['String']>;
  /** Receipt ID. */
  receipt?: Maybe<WixReceiptsV1Receipt>;
  /** Receipt ID. */
  receiptId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersBillingV1RedeemGiftCardRequestInput = {
  /** Amount to redeem from the gift card. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Currency code, in [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217#List_of_ISO_4217_currency_codes) format. */
  currency?: InputMaybe<Scalars['String']>;
  /** Code of the gift card to redeem. */
  giftCardCode?: InputMaybe<Scalars['String']>;
  /** ID of the order to pay for with the gift card. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersBillingV1RedeemGiftCardResponse = {
  /** Updated order transactions. */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
  /** Gift card payment. */
  payment?: Maybe<ComWixEcomOrdersPaymentsV1Payment>;
};

export type ComWixEcomOrdersBillingV1RefundItemsInput = {
  /** Additional fees and their amounts to refund. */
  additionalFees?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersBillingV1AdditionalFeeRefundInput>>>;
  /** Line items and their quantities to refund. */
  lineItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersBillingV1LineItemRefundInput>>>;
  /** Shipping amount to refund. */
  shipping?: InputMaybe<ComWixEcomOrdersBillingV1ShippingRefundInput>;
};

export type ComWixEcomOrdersBillingV1RefundPaymentsRequestInput = {
  /** Customer-provided reason for the refund. */
  customerReason?: InputMaybe<Scalars['String']>;
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
  /** List of payments and their amounts to refund. */
  paymentRefunds?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersBillingV1PaymentRefundInput>>>;
  /** List of line items, shipping and additional fees to refund. */
  refundItems?: InputMaybe<ComWixEcomOrdersBillingV1RefundItemsInput>;
  /** Side effect actions for restocking and notifications. */
  sideEffects?: InputMaybe<ComWixEcomOrdersBillingV1RefundSideEffectsInput>;
};

export type ComWixEcomOrdersBillingV1RefundPaymentsResponse = {
  /** The order's transactions records after the refunds were performed. */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
  /** Refund details. */
  refund?: Maybe<ComWixEcomOrdersPaymentsV1Refund>;
};

export type ComWixEcomOrdersBillingV1RefundSideEffectsInput = {
  /** Notification side effects. */
  notifications?: InputMaybe<ComWixEcomOrdersBillingV1RefundSideEffectsNotificationSideEffectsInput>;
  /** Restocking side effects. */
  restock?: InputMaybe<ComWixEcomOrdersBillingV1RefundSideEffectsRestockSideEffectsInput>;
};

export type ComWixEcomOrdersBillingV1RefundSideEffectsNotificationSideEffectsInput = {
  /** Custom message added to the refund confirmation email. */
  customMessage?: InputMaybe<Scalars['String']>;
  /**
   * Whether to send a refund confirmation email to the customer.
   *
   * Default: `false`
   */
  sendCustomerEmail?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersBillingV1RefundSideEffectsRestockItemInput = {
  /** Line item ID. */
  lineItemId?: InputMaybe<Scalars['String']>;
  /** Quantity to restock. */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomOrdersBillingV1RefundSideEffectsRestockSideEffectsInput = {
  /** List of items to restock. */
  lineItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersBillingV1RefundSideEffectsRestockItemInput>>>;
};

export type ComWixEcomOrdersBillingV1ShippingRefund = {
  /**
   * Amount to refund.
   *
   * Passing an empty value will refund the remaining refundable amount.
   */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersBillingV1ShippingRefundInput = {
  /**
   * Amount to refund.
   *
   * Passing an empty value will refund the remaining refundable amount.
   */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersBillingV1ShippingRefundOption = {
  /** Original shipping fee amount. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Shipping fee amount available for refund. */
  availableRefundAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Previously refunded shipping fee amount. */
  refundedAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersBillingV1ShippingRefundability = {
  /** Original shipping fee amount. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Shipping fee amount available for refund. */
  availableRefundAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Previously refunded shipping fee amount. */
  refundedAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersBillingV1VoidAuthorizedPaymentsRequestInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
  /** IDs of the authorized payments to void. */
  paymentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersBillingV1VoidAuthorizedPaymentsResponse = {
  /** Order transactions updated with voided payment. */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
};

export type ComWixEcomOrdersFulfillmentsV1BulkCreateFulfillmentRequestInput = {
  /** List of order IDs and their associated fulfillments. */
  ordersWithFulfillments?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersFulfillmentsV1BulkCreateOrderWithFulfillmentsInput>>>;
};

export type ComWixEcomOrdersFulfillmentsV1BulkCreateFulfillmentResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Items updated by bulk action. */
  results?: Maybe<Array<Maybe<ComWixEcomOrdersFulfillmentsV1BulkOrderFulfillmentsResult>>>;
};

export type ComWixEcomOrdersFulfillmentsV1BulkCreateOrderWithFulfillmentsInput = {
  /** Fulfillments associated with the order. */
  fulfillments?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersFulfillmentsV1FulfillmentInput>>>;
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersFulfillmentsV1BulkOrderFulfillmentsResult = {
  /** Item metadata. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
  ordersWithFulfillments?: Maybe<ComWixEcomOrdersFulfillmentsV1OrderWithFulfillments>;
};

export type ComWixEcomOrdersFulfillmentsV1CreateFulfillmentRequestInput = {
  /** Fulfillment info. */
  fulfillment?: InputMaybe<ComWixEcomOrdersFulfillmentsV1FulfillmentInput>;
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersFulfillmentsV1CreateFulfillmentResponse = {
  /** ID of created fulfillment. */
  fulfillmentId?: Maybe<Scalars['String']>;
  /** Order ID and the orders' fulfillments. */
  orderWithFulfillments?: Maybe<ComWixEcomOrdersFulfillmentsV1OrderWithFulfillments>;
};

export type ComWixEcomOrdersFulfillmentsV1CustomFulfillmentInfo = {
  /** Custom fulfillment info in key:value form. */
  fieldsData?: Maybe<Scalars['JSON']>;
};

export type ComWixEcomOrdersFulfillmentsV1CustomFulfillmentInfoInput = {
  /** Custom fulfillment info in key:value form. */
  fieldsData?: InputMaybe<Scalars['JSON']>;
};

export type ComWixEcomOrdersFulfillmentsV1DeleteFulfillmentRequestInput = {
  /** ID of the fulfillment to delete. */
  fulfillmentId?: InputMaybe<Scalars['String']>;
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersFulfillmentsV1DeleteFulfillmentResponse = {
  /** Order ID and the order's associated fulfillments after deletion. */
  orderWithFulfillments?: Maybe<ComWixEcomOrdersFulfillmentsV1OrderWithFulfillments>;
};

export type ComWixEcomOrdersFulfillmentsV1Fulfillment = {
  /** Fulfillment handling complete. */
  completed?: Maybe<Scalars['Boolean']>;
  /** Fulfillment creation date and time in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  createdDate?: Maybe<Scalars['String']>;
  /** Custom fulfillment info. */
  customInfo?: Maybe<ComWixEcomOrdersFulfillmentsV1CustomFulfillmentInfo>;
  /** Fulfillment ID. */
  id?: Maybe<Scalars['String']>;
  /** Line items being fulfilled. */
  lineItems?: Maybe<Array<Maybe<ComWixEcomOrdersFulfillmentsV1FulfillmentLineItem>>>;
  /**
   * The current status of the fulfillment process.
   *
   * Supported values:
   * + `"Pending"` - Initial state when fulfillment is created but processing hasn't started.
   * + `"Accepted"` - Order has been received and validated for fulfillment.
   * + `"Ready"` - Items have been picked and packed, ready for shipping.
   * + `"In_Delivery"` - Items have been handed over to the shipping carrier.
   * + `"Fulfilled"` - Delivery has been completed successfully.
   *
   * The status typically progresses from Pending → Accepted → Ready → In_Delivery → Fulfilled.
   * Status can be updated manually or automatically depending on your fulfillment workflow.
   */
  status?: Maybe<Scalars['String']>;
  /** Tracking info. */
  trackingInfo?: Maybe<ComWixEcomOrdersFulfillmentsV1FulfillmentTrackingInfo>;
};

export type ComWixEcomOrdersFulfillmentsV1FulfillmentInput = {
  /** Fulfillment handling complete. */
  completed?: InputMaybe<Scalars['Boolean']>;
  /** Fulfillment creation date and time in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Custom fulfillment info. */
  customInfo?: InputMaybe<ComWixEcomOrdersFulfillmentsV1CustomFulfillmentInfoInput>;
  /** Fulfillment ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Line items being fulfilled. */
  lineItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersFulfillmentsV1FulfillmentLineItemInput>>>;
  /**
   * Fulfillment status.
   *
   * Supported values:
   * + `"Pending"`
   * + `"Accepted"`
   * + `"Ready"`
   * + `"In_Delivery"`
   * + `"Fulfilled"`
   */
  status?: InputMaybe<Scalars['String']>;
  /** Tracking info. */
  trackingInfo?: InputMaybe<ComWixEcomOrdersFulfillmentsV1FulfillmentTrackingInfoInput>;
};

export type ComWixEcomOrdersFulfillmentsV1FulfillmentLineItem = {
  /** Line item ID (mirrors the ID of the order line item). */
  id?: Maybe<Scalars['String']>;
  /**
   * Line item quantity.
   *
   * * If this property isn't passed on creation, it defaults to the number of items not already linked to a fulfillment.
   * * If the order does not have the requested quantity of line items available to add to this fulfillment, the fulfillment will not be created and an error is returned.
   */
  quantity?: Maybe<Scalars['Int']>;
};

export type ComWixEcomOrdersFulfillmentsV1FulfillmentLineItemInput = {
  /** Line item ID (mirrors the ID of the order line item). */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Line item quantity.
   * * If this property isn't passed on creation, it defaults to the number of items not already linked to a fulfillment.
   * * If the order does not have the requested quantity of line items available to add to this fulfillment, the fulfillment will not be created and an error is returned.
   *
   * Min: `1`
   * Max: `100000`
   */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomOrdersFulfillmentsV1FulfillmentTrackingInfo = {
  /**
   * Shipping provider name. Can be either a predefined provider for automatic tracking link generation,
   * or a custom provider name for manual tracking link management.
   *
   * Predefined providers that support automatic tracking link generation:
   * `"fedex"` - FedEx shipping services
   * `"ups"` - UPS shipping services
   * `"usps"` - United States Postal Service
   * `"dhl"` - DHL shipping services
   * `"canadaPost"` - Canada Post shipping services
   *
   * For predefined providers:
   * - The `trackingLink` field will be automatically populated based on the `trackingNumber`
   * - Standard tracking URL formats are used for each carrier
   * - No additional configuration is needed
   *
   * For custom shipping providers:
   * - Use any string value to identify your provider
   * - You must manually provide the `trackingLink`
   * - Useful for local carriers or specialized shipping services
   */
  shippingProvider?: Maybe<Scalars['String']>;
  /**
   * URL where customers can track their shipment status.
   *
   * For predefined shipping providers:
   * - Automatically generated based on the `trackingNumber`
   * - Uses the carrier's official tracking URL format
   * - No manual input required
   *
   * For custom shipping providers:
   * - Must be provided when creating the fulfillment
   * - Should be a valid URL to the carrier's tracking page
   * - Can include the tracking number as a parameter if needed
   */
  trackingLink?: Maybe<Scalars['String']>;
  /** Shipping/delivery tracking number. */
  trackingNumber?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersFulfillmentsV1FulfillmentTrackingInfoInput = {
  /**
   * Shipping provider. Using one of the following shipping providers will allow for auto-filling the tracking link:
   * * `'fedex'`
   * * `'ups'`
   * * `'usps'`
   * * `'dhl'`
   * * `'canadaPost'`
   */
  shippingProvider?: InputMaybe<Scalars['String']>;
  /** Tracking link. Auto-filled if a predefined shipping provider is used, otherwise provided on creation. */
  trackingLink?: InputMaybe<Scalars['String']>;
  /** Shipping/delivery tracking number. */
  trackingNumber?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersFulfillmentsV1ListFulfillmentsForMultipleOrdersRequestInput = {
  /** List of order IDs for which to retrieve fulfillments. */
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersFulfillmentsV1ListFulfillmentsForMultipleOrdersResponse = {
  /** List of order IDs and their associated fulfillments. */
  ordersWithFulfillments?: Maybe<Array<Maybe<ComWixEcomOrdersFulfillmentsV1OrderWithFulfillments>>>;
};

export type ComWixEcomOrdersFulfillmentsV1ListFulfillmentsForSingleOrderRequestInput = {
  /** Order ID for which to retrieve fulfillments. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersFulfillmentsV1ListFulfillmentsForSingleOrderResponse = {
  /** List of fulfillments associated with the order. */
  orderWithFulfillments?: Maybe<ComWixEcomOrdersFulfillmentsV1OrderWithFulfillments>;
};

export type ComWixEcomOrdersFulfillmentsV1OrderWithFulfillments = {
  /** Fulfillments associated with the order. */
  fulfillments?: Maybe<Array<Maybe<ComWixEcomOrdersFulfillmentsV1Fulfillment>>>;
  /** Order ID. */
  orderId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersFulfillmentsV1UpdateFulfillmentRequestInput = {
  /** Set of fields to update. Fields that aren't included in `fieldMask.paths` are ignored. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Fulfillment info to update. */
  fulfillment?: InputMaybe<ComWixEcomOrdersFulfillmentsV1FulfillmentInput>;
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersFulfillmentsV1UpdateFulfillmentResponse = {
  /** Order ID and the orders' associated fulfillments after update. */
  orderWithFulfillments?: Maybe<ComWixEcomOrdersFulfillmentsV1OrderWithFulfillments>;
};

export type ComWixEcomOrdersImporterV1BulkDeleteImportedOrdersRequestInput = {
  /**
   * List of order ids to be deleted.
   * Only orders imported via ImportOrders API can be deleted.
   */
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersImporterV1BulkDeleteImportedOrdersResponse = {
  /** Job ID for async operation tracking. Pass to [Get Async Job](https://dev.wix.com/docs/rest/business-management/async-job/get-async-job) or [List Async Job Items](https://dev.wix.com/docs/rest/business-management/async-job/list-async-job-items) to retrieve details and metadata */
  jobId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersImporterV1ImportOrderRequestInput = {
  /**
   * Order to be imported
   * If order.order_settings.order_type and order.order_settings.custom_order_type not set than VIEW_ONLY will be used
   */
  order?: InputMaybe<ComWixEcomOrdersV1OrderInput>;
};

export type ComWixEcomOrdersImporterV1ImportOrderResponse = {
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersImporterV1SetOrderNumberCounterRequestInput = {
  /** Whether to allow setting a lower counter than current value */
  allowLowerCounter?: InputMaybe<Scalars['Boolean']>;
  /**
   * Order number counter to set.
   * Counter will be used as start of number sequence and used as order number with increment
   */
  counter?: InputMaybe<Scalars['Long']>;
};

export type ComWixEcomOrdersImporterV1SetOrderNumberCounterResponse = {
  /** Order number counter after update */
  newCounter?: Maybe<Scalars['Long']>;
  /** Order number counter before update */
  oldCounter?: Maybe<Scalars['Long']>;
};

export type ComWixEcomOrdersIndexerV1BatchOfTriggerReindexOrderRequestInput = {
  requests?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersIndexerV1TriggerReindexOrderRequestInput>>>;
};

export type ComWixEcomOrdersIndexerV1TriggerReindexOrderRequestInput = {
  metasiteId?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersIndexerV1TriggerReindexRequestInput = {
  metasiteId?: InputMaybe<Scalars['String']>;
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersInvoicesV1AddInvoiceToOrderRequestInput = {
  /** Invoice info. */
  invoiceInfo?: InputMaybe<ComWixEcomOrdersInvoicesV1InvoiceInput>;
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersInvoicesV1AddInvoiceToOrderResponse = {
  /** List of order invoices. */
  orderInvoices?: Maybe<Array<Maybe<ComWixEcomOrdersInvoicesV1Invoice>>>;
};

export type ComWixEcomOrdersInvoicesV1BulkGenerateInvoicesRequestInput = {
  /** Order IDs. */
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersInvoicesV1BulkGenerateInvoicesResponse = {
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  results?: Maybe<Array<Maybe<ComWixEcomOrdersInvoicesV1BulkInvoiceResult>>>;
};

export type ComWixEcomOrdersInvoicesV1BulkInvoiceResult = {
  item?: Maybe<ComWixEcomOrdersInvoicesV1InvoiceForOrder>;
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixEcomOrdersInvoicesV1GenerateInvoiceRequestInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersInvoicesV1GenerateInvoiceResponse = {
  /** Invoice ID. */
  invoiceId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersInvoicesV1GenerateInvoiceWithNumberRequestInput = {
  invoiceNumber?: InputMaybe<Scalars['String']>;
  /** Date and time the payment was created in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. Defaults to current time when not provided. */
  issueDate?: InputMaybe<Scalars['String']>;
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersInvoicesV1GenerateInvoiceWithNumberResponse = {
  /** Invoice ID. */
  invoiceId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersInvoicesV1GetOrderInvoiceRequestInput = {
  /** Invoice ID. */
  invoiceId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersInvoicesV1GetOrderInvoiceResponse = {
  /** Invoice info. */
  invoiceInfo?: Maybe<ComWixEcomOrdersInvoicesV1Invoice>;
  /** Order ID. */
  orderId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersInvoicesV1Invoice = {
  /** ID of the app that set the invoice. */
  appId?: Maybe<Scalars['String']>;
  /** Invoice ID. */
  id?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersInvoicesV1InvoiceForOrder = {
  /** Invoice ID. */
  invoiceId?: Maybe<Scalars['String']>;
  /** Order ID. */
  orderId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersInvoicesV1InvoiceInput = {
  /** ID of the app that set the invoice. */
  appId?: InputMaybe<Scalars['String']>;
  /** Invoice ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersInvoicesV1InvoicesForOrder = {
  /** Invoices info. Deprecated: use `invoices_info` instead */
  invoices?: Maybe<Array<Maybe<ComWixEcomOrdersInvoicesV1Invoice>>>;
  /** Invoices info. */
  invoicesInfo?: Maybe<Array<Maybe<ComWixEcomOrdersInvoicesV1Invoice>>>;
  /** Order ID. */
  orderId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersInvoicesV1ListInvoicesForMultipleOrdersRequestInput = {
  /** Order IDs for which to retrieve invoices. */
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersInvoicesV1ListInvoicesForMultipleOrdersResponse = {
  /** List of order IDs and their associated invoices. */
  invoicesForOrder?: Maybe<Array<Maybe<ComWixEcomOrdersInvoicesV1InvoicesForOrder>>>;
};

export type ComWixEcomOrdersInvoicesV1ListInvoicesForSingleOrderRequestInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersInvoicesV1ListInvoicesForSingleOrderResponse = {
  /** List of invoices. */
  invoices?: Maybe<Array<Maybe<ComWixEcomOrdersInvoicesV1Invoice>>>;
};

export type ComWixEcomOrdersNotificationsV1BulkSendBuyerPickupConfirmationEmailsRequestInput = {
  /** IDs of orders to send pickup emails for. */
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersNotificationsV1BulkSendBuyerShippingConfirmationEmailsRequestInput = {
  /** IDs of orders to send pickup emails for. */
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersNotificationsV1PreviewBuyerConfirmationEmailResponse = {
  emailPreview?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1PreviewBuyerPaymentsReceivedEmailResponse = {
  emailPreview?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1PreviewBuyerPickupConfirmationEmailResponse = {
  emailPreview?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1PreviewCancelEmailRequestInput = {
  /** Personal note added to the email (optional) */
  customMessage?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1PreviewCancelEmailResponse = {
  emailPreview?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1PreviewCancelRefundEmailRequestInput = {
  /** Personal note added to the email (optional) */
  customMessage?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
  /** Refund amount */
  refundAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Refund ID. (Optional) */
  refundId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1PreviewCancelRefundEmailResponse = {
  emailPreview?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1PreviewEmailByTypeRequestInput = {
  emailType?: InputMaybe<ComWixEcomOrdersNotificationsV1PreviewEmailType>;
};

export type ComWixEcomOrdersNotificationsV1PreviewEmailByTypeResponse = {
  emailPreview?: Maybe<Scalars['String']>;
};

export enum ComWixEcomOrdersNotificationsV1PreviewEmailType {
  DOWNLOAD_LINKS = 'DOWNLOAD_LINKS',
  ORDER_PLACED = 'ORDER_PLACED',
  ORDER_READY_FOR_PICKUP = 'ORDER_READY_FOR_PICKUP',
  ORDER_SHIPPED = 'ORDER_SHIPPED'
}

export type ComWixEcomOrdersNotificationsV1PreviewRefundEmailRequestInput = {
  /** Personal note added to the email (optional) */
  customMessage?: InputMaybe<Scalars['String']>;
  /** Refund business details */
  details?: InputMaybe<ComWixEcomOrdersPaymentsV1RefundDetailsInput>;
  orderId?: InputMaybe<Scalars['String']>;
  /** Refund amount */
  refundAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Refund ID. (Optional) */
  refundId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1PreviewRefundEmailResponse = {
  emailPreview?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1PreviewResendDownloadLinksEmailResponse = {
  emailPreview?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1PreviewShippingConfirmationEmailResponse = {
  emailPreview?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1SendBuyerConfirmationEmailRequestInput = {
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1SendBuyerPaymentsReceivedEmailRequestInput = {
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1SendBuyerPickupConfirmationEmailRequestInput = {
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1SendBuyerShippingConfirmationEmailRequestInput = {
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1SendCancelRefundEmailRequestInput = {
  /** Personal note added to the email (optional) */
  customMessage?: InputMaybe<Scalars['String']>;
  /** The ID of order that is canceled/refunded */
  orderId?: InputMaybe<Scalars['String']>;
  /** Refund amount */
  refundAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Refund ID. (Optional) */
  refundId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1SendMerchantOrderReceivedNotificationRequestInput = {
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1SendMerchantOrderReceivedPushRequestInput = {
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersNotificationsV1SendRefundEmailRequestInput = {
  /** Personal note added to the email (optional) */
  customMessage?: InputMaybe<Scalars['String']>;
  /** The ID of order that is refunded */
  orderId?: InputMaybe<Scalars['String']>;
  /** Refund ID */
  refundId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1AdditionalFeeRefund = {
  /** Additional fee  ID. */
  additionalFeeId?: Maybe<Scalars['String']>;
  /** Amount to refund. Empty value means refund for remaining (refundable) amount. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersPaymentsCollectorV1AdditionalFeeRefundInput = {
  /** Additional fee  ID. */
  additionalFeeId?: InputMaybe<Scalars['String']>;
  /** Amount to refund. Empty value means refund for remaining (refundable) amount. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersPaymentsCollectorV1AdditionalFeeRefundOption = {
  /** Additional fee ID */
  additionalFeeId?: Maybe<Scalars['String']>;
  /** Original additional fee amount */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Additional fee amount available for refund */
  availableRefundAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Previously refunded additional fee amount */
  refundedAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersPaymentsCollectorV1BulkMarkOrdersAsPaidRequestInput = {
  /** IDs of orders to mark as paid. */
  ecomOrderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersPaymentsCollectorV1BulkMarkOrdersAsPaidResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /**
   * Items updated by the bulk action.
   * The Order entity within the results optimistically changes its payment status to paid, however this process is async.
   */
  results?: Maybe<Array<Maybe<ComWixEcomOrdersV1BulkOrderResult>>>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CalculateRefundItemRequestInput = {
  /** ID of the line item being refunded */
  id?: InputMaybe<Scalars['String']>;
  /** How much of that line item is being refunded */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CalculateRefundItemResponse = {
  /** Line item ID */
  id?: Maybe<Scalars['String']>;
  /** Refundable amount for requested quantity of items (price of requested quantity of items without tax and discount) */
  price?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CalculateRefundRequestInput = {
  /** Order ID */
  ecomOrderId?: InputMaybe<Scalars['String']>;
  /** Refunded line items and quantity */
  refundItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundItemRequestInput>>>;
  /** Should include shipping in refund calculation */
  refundShipping?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CalculateRefundResponse = {
  /** Discount given for this order */
  discount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** The refundable items of that order */
  items?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundItemResponse>>>;
  /** Previous refund given on that order */
  previouslyRefundedAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total shipping cost for order */
  shipping?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total cost of the order (without tax) */
  subtotal?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Tax cost of the order */
  tax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total refundable amount */
  total?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CalculateRefundV1RequestInput = {
  /** Order ID */
  ecomOrderId?: InputMaybe<Scalars['String']>;
  /** Refunded line items and quantity */
  refundItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundItemRequestInput>>>;
  /** Should include shipping in refund calculation */
  refundShipping?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CalculateRefundV1Response = {
  /** Discount given for this order */
  discount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** The refundable items of that order */
  items?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundItemResponse>>>;
  /** Previous refund given on that order */
  previouslyRefundedAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total shipping cost for order */
  shipping?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total cost of the order (without tax) */
  subtotal?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Tax cost of the order */
  tax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total refundable amount */
  total?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CalculateRefundV2RequestInput = {
  /**
   * Refund details: list of items that are going to be refunded
   * (Optional): When not passed will return calculation for all items available for refund (line items, additional fees, shipping)
   */
  details?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1RefundDetailsInput>;
  /** Order ID */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CalculateRefundV2Response = {
  /** Refund with given list of items will succeed */
  available?: Maybe<Scalars['Boolean']>;
  /** Calculated summary of each item provided for refund */
  calculatedDetails?: Maybe<ComWixEcomOrdersPaymentsCollectorV1CalculatedRefundDetails>;
  /**
   * Refund with given list of items will cause validation error. Contains details of items that would cause
   * validation error.
   */
  notAvailable?: Maybe<ComWixEcomOrdersPaymentsCollectorV1CalculatedRefundNotAvailableStatus>;
  /** Calculated summary of all items provided for refund */
  summary?: Maybe<ComWixEcomOrdersPaymentsCollectorV1CalculatedRefundSummary>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CalculatedAdditionalFeeRefund = {
  /** Additional fee refund details */
  additionalFee?: Maybe<ComWixEcomOrdersPaymentsCollectorV1AdditionalFeeRefund>;
  /** Is refund available with given details */
  available?: Maybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CalculatedLineItemRefund = {
  /** Calculated refund amount for given item */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Line item refund details */
  item?: Maybe<ComWixEcomOrdersPaymentsCollectorV1LineItemRefund>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CalculatedRefundDetails = {
  /** Calculated refund details for each order additional fee */
  additionalFees?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsCollectorV1CalculatedAdditionalFeeRefund>>>;
  /** Calculated refund details for each order item */
  lineItems?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsCollectorV1CalculatedLineItemRefund>>>;
  /** Calculated refund details for order shipping */
  shipping?: Maybe<ComWixEcomOrdersPaymentsCollectorV1CalculatedShippingRefund>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CalculatedRefundNotAvailableStatus = {
  /** Refund calculation errors */
  errors?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsCollectorV1CalculationError>>>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CalculatedRefundSummary = {
  /** Discount of the items being refunded */
  discount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Previously refunded amount for given order */
  previouslyRefundedAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Shipping amount that is being refunded */
  shipping?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total cost of the items being refunded (without tax) */
  subtotal?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Tax of the items being refunded */
  tax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total refundable amount */
  total?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CalculatedShippingRefund = {
  /** Is refund available with given details */
  available?: Maybe<Scalars['Boolean']>;
  /** Shipping refund details */
  shipping?: Maybe<ComWixEcomOrdersPaymentsCollectorV1ShippingRefund>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CalculationError = {
  /** Additional fee */
  additionalFee?: Maybe<ComWixEcomOrdersPaymentsCollectorV1AdditionalFeeRefund>;
  /** Error details */
  error?: Maybe<WixApiDetails>;
  /** Line item */
  lineItem?: Maybe<ComWixEcomOrdersPaymentsCollectorV1LineItemRefund>;
  /** Shipping */
  shipping?: Maybe<ComWixEcomOrdersPaymentsCollectorV1ShippingRefund>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CaptureAuthorizedPaymentRequestInput = {
  /**
   * Capture amount.
   * Currently we support only full payment amount capture.
   */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Wix eCommerce order ID */
  ecomOrderId?: InputMaybe<Scalars['String']>;
  /** Payment ID */
  paymentId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CaptureAuthorizedPaymentsRequestInput = {
  /** Wix eCommerce order ID */
  ecomOrderId?: InputMaybe<Scalars['String']>;
  /** Capture payments information */
  payments?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsCollectorV1PaymentCaptureInput>>>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CaptureAuthorizedPaymentsResponse = {
  /** All order's transactions after the capture was triggered */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
};

export type ComWixEcomOrdersPaymentsCollectorV1ChargeMembershipsRequestInput = {
  /** Order ID. */
  ecomOrderId?: InputMaybe<Scalars['String']>;
  /**
   * The member id. Do not attempt to get it from the request context, since in some cases the caller is not a member
   * but a user which is using the membership on behalf of the a member
   */
  memberId?: InputMaybe<Scalars['String']>;
  /** List of items to be paid by memberships */
  membershipCharges?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsCollectorV1MembershipChargeItemInput>>>;
};

export type ComWixEcomOrdersPaymentsCollectorV1ChargeSavedPaymentMethodRequestInput = {
  /** Amount to be charged */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Ecom Order ID. */
  ecomOrderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1ChargeSavedPaymentMethodResponse = {
  /** Payment gateway's order ID (e.g Wix Payments) */
  paymentGatewayOrderId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1ChargedByInput = {
  /** Full name - name of the user who initiated the payment */
  fullName?: InputMaybe<Scalars['String']>;
  /** ID - id of the user who initiated the payment */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CreatePaymentGatewayOrderRequestInput = {
  /** Information about the user who initiated the payment. */
  chargedBy?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1ChargedByInput>;
  /**
   * Whether to delay capture of the payment.
   *
   * Default: false
   */
  delayedCapture?: InputMaybe<Scalars['Boolean']>;
  /** Ecom order ID. */
  ecomOrderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1CreatePaymentGatewayOrderResponse = {
  /** ID of the order created in the payment gateway */
  paymentGatewayOrderId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1DelayedCaptureSettingsInput = {
  /** Delay duration before execution. Optional - if not set, providers default period will be used */
  delayDuration?: InputMaybe<ComWixEcommercePlatformCommonApiDurationInput>;
  /** Specifies the automatic action (void/capture) for authorized transaction after the specified duration */
  scheduledAction?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1DelayedCaptureSettingsScheduledAction>;
};

export enum ComWixEcomOrdersPaymentsCollectorV1DelayedCaptureSettingsScheduledAction {
  /** Whether payment will be auto-captured when duration passes */
  CAPTURE = 'CAPTURE',
  UNSPECIFIED = 'UNSPECIFIED',
  /** Whether payment will be auto-voided when duration passes */
  VOID = 'VOID'
}

export type ComWixEcomOrdersPaymentsCollectorV1GetPaymentCollectabilityStatusRequestInput = {
  /** Ecom order ID. */
  ecomOrderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1GetPaymentCollectabilityStatusResponse = {
  /** Collectable order amount */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Whether authorization supported */
  authorizationSupported?: Maybe<Scalars['Boolean']>;
  /** Payment collectability status */
  status?: Maybe<ComWixEcomOrdersPaymentsCollectorV1PaymentCollectabilityStatusEnumPaymentCollectabilityStatus>;
};

export type ComWixEcomOrdersPaymentsCollectorV1GetRefundOptionsRequestInput = {
  /** Order Id */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1GetRefundOptionsResponse = {
  /** Refund options for additional fees: Describes available refund amount per additional fee */
  additionalFeeRefundOptions?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsCollectorV1AdditionalFeeRefundOption>>>;
  /** Refund options for order items: Describes how much of each item can be refunded */
  lineItemRefundOptions?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsCollectorV1LineItemRefundOption>>>;
  /** Refund options for payments, linked to given order. Contains refundability status and max refund amounts for each payment */
  paymentRefundOptions?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsCollectorV1PaymentRefundOption>>>;
  /** Aggregated summary of payments */
  paymentsSummary?: Maybe<ComWixEcomOrdersPaymentsCollectorV1PaymentsSummary>;
  /** Refund option for shipping: Describes available refund amount for shipping */
  shippingRefundOption?: Maybe<ComWixEcomOrdersPaymentsCollectorV1ShippingRefundOption>;
};

export type ComWixEcomOrdersPaymentsCollectorV1GetRefundabilityStatusRequestInput = {
  /** Order ID. */
  ecomOrderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1GetRefundabilityStatusResponse = {
  /** Refundability details. */
  refundabilities?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsCollectorV1Refundability>>>;
  /** Whether the order supports refunding per item. */
  refundablePerItem?: Maybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1LineItemRefund = {
  /** Line item ID */
  lineItemId?: Maybe<Scalars['String']>;
  /** Quantity to refund */
  quantity?: Maybe<Scalars['Int']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1LineItemRefundInput = {
  /** Line item ID */
  lineItemId?: InputMaybe<Scalars['String']>;
  /** Quantity to refund */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1LineItemRefundOption = {
  /** Line item quantity available for refund */
  availableRefundQuantity?: Maybe<Scalars['Int']>;
  /** Line item ID */
  lineItemId?: Maybe<Scalars['String']>;
  /** Line item quantity */
  originalQuantity?: Maybe<Scalars['Int']>;
  /** Previously refunded quantity */
  refundedQuantity?: Maybe<Scalars['Int']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1ManuallyRefundablePaymentStatus = {
  /** Reason why payment has to be refunded manually via payment provider dashboard */
  reason?: Maybe<ComWixEcomOrdersPaymentsCollectorV1ManuallyRefundablePaymentStatusManuallyRefundableReason>;
};

export enum ComWixEcomOrdersPaymentsCollectorV1ManuallyRefundablePaymentStatusManuallyRefundableReason {
  EXPIRED = 'EXPIRED',
  NOT_SUPPORTED = 'NOT_SUPPORTED',
  OFFLINE = 'OFFLINE',
  UNKNOWN_REASON = 'UNKNOWN_REASON'
}

export type ComWixEcomOrdersPaymentsCollectorV1MarkOrderAsPaidRequestInput = {
  /** Ecom order ID. */
  ecomOrderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1MarkOrderAsPaidResponse = {
  /** Updated order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersPaymentsCollectorV1MembershipChargeItemInput = {
  /** ID of the application providing this payment option */
  appId?: InputMaybe<Scalars['String']>;
  /** Catalog and item reference info. */
  catalogReference?: InputMaybe<ComWixEcommerceCatalogSpiApiV1CatalogReferenceInput>;
  /** line item id of Checkout/Order line item */
  lineItemId?: InputMaybe<Scalars['String']>;
  /** Additional data about this membership */
  membershipAdditionalData?: InputMaybe<Scalars['JSON']>;
  /** The id of used membership */
  membershipId?: InputMaybe<Scalars['String']>;
  /** The name of used membership */
  membershipName?: InputMaybe<ComWixEcomMembershipsSpiV1MembershipNameInput>;
  /**
   * Usually would be the same as catalogReference.catalogItemId
   * For cases when these are not the same, this field would return the actual id of the item in the catalog
   * For example, for Wix bookings, catalogReference.catalogItemId is the booking id, and this value is being set to be the service id
   */
  rootCatalogItemId?: InputMaybe<Scalars['String']>;
  /** Properties of the service. When relevant, contains information such as date and number of participants. */
  serviceProperties?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ServicePropertiesInput>;
};

export type ComWixEcomOrdersPaymentsCollectorV1MembershipPaymentSummary = {
  /** Line items that were paid with membership */
  paidLineItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Line items, paid with membership, that are available for refund */
  refundableLineItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Previously refunded line items that were paid with membership */
  refundedLineItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersPaymentsCollectorV1MonetaryPaymentSummary = {
  /**
   * Maximum amount to refund ** when refund is allowed  **
   * max_refund = paid - refunded - refund_pending
   */
  maxRefund?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Paid amount */
  paid?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Pending refund amount */
  refundPending?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Refunded amount */
  refunded?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersPaymentsCollectorV1NonRefundablePaymentStatus = {
  /** Reason why payment is not refundable */
  reason?: Maybe<ComWixEcomOrdersPaymentsCollectorV1NonRefundablePaymentStatusNonRefundableReason>;
};

export enum ComWixEcomOrdersPaymentsCollectorV1NonRefundablePaymentStatusNonRefundableReason {
  ALREADY_REFUNDED = 'ALREADY_REFUNDED',
  DISABLED_BY_PROVIDER = 'DISABLED_BY_PROVIDER',
  FORBIDDEN = 'FORBIDDEN',
  NOT_PAID = 'NOT_PAID',
  PENDING_REFUND = 'PENDING_REFUND',
  PROVIDER_IS_DOWN = 'PROVIDER_IS_DOWN',
  TRANSACTION_NOT_FOUND = 'TRANSACTION_NOT_FOUND',
  UNKNOWN_REASON = 'UNKNOWN_REASON',
  ZERO_PRICE = 'ZERO_PRICE'
}

export type ComWixEcomOrdersPaymentsCollectorV1PaymentCaptureInput = {
  /**
   * Capture amount.
   * If not provided - full authorized amount will be captured.
   */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Payment ID */
  paymentId?: InputMaybe<Scalars['String']>;
};

export enum ComWixEcomOrdersPaymentsCollectorV1PaymentCollectabilityStatusEnumPaymentCollectabilityStatus {
  COLLECTABLE = 'COLLECTABLE',
  NONCOLLECTABLE_MISSING_PAYMENT_METHOD = 'NONCOLLECTABLE_MISSING_PAYMENT_METHOD',
  NONCOLLECTABLE_ORDER_HAS_CHARGEBACKS = 'NONCOLLECTABLE_ORDER_HAS_CHARGEBACKS',
  NONCOLLECTABLE_ORDER_HAS_SUBSCRIPTIONS = 'NONCOLLECTABLE_ORDER_HAS_SUBSCRIPTIONS',
  NONCOLLECTABLE_ORDER_IS_CANCELLED = 'NONCOLLECTABLE_ORDER_IS_CANCELLED',
  NONCOLLECTABLE_ORDER_IS_PAID = 'NONCOLLECTABLE_ORDER_IS_PAID',
  NONCOLLECTABLE_ORDER_IS_PENDING = 'NONCOLLECTABLE_ORDER_IS_PENDING',
  NONCOLLECTABLE_ORDER_IS_REJECTED = 'NONCOLLECTABLE_ORDER_IS_REJECTED',
  UNKNOWN = 'UNKNOWN'
}

export type ComWixEcomOrdersPaymentsCollectorV1PaymentInfo = {
  /** Details of credit card, used for this payment */
  creditCardDetails?: Maybe<ComWixEcomOrdersPaymentsV1CreditCardPaymentMethodDetails>;
  /** Membership payment summary */
  membership?: Maybe<ComWixEcomOrdersPaymentsCollectorV1MembershipPaymentSummary>;
  /** Monetary payment summary */
  monetary?: Maybe<ComWixEcomOrdersPaymentsCollectorV1MonetaryPaymentSummary>;
  /** Payment ID */
  paymentId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1PaymentRefundInput = {
  /** Refund amount. Not relevant for membership and gift card refunds. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /**
   * Indicates that refund is made externally and manually (on the payment provider's side)
   * When false (default), the payment gateway will be called in order to make an actual refund, and then the payment will be marked as refunded.
   * When true, the payment will only be *marked* as refunded, and no actual refund will be performed.
   */
  externalRefund?: InputMaybe<Scalars['Boolean']>;
  /** Specific payment within the order to refund */
  paymentId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1PaymentRefundOption = {
  /** Payment is refundable. Only manual refund. Contains reason */
  manuallyRefundable?: Maybe<ComWixEcomOrdersPaymentsCollectorV1ManuallyRefundablePaymentStatus>;
  /** Payment is not refundable. Contains reason */
  nonRefundable?: Maybe<ComWixEcomOrdersPaymentsCollectorV1NonRefundablePaymentStatus>;
  /** Payment details with summary */
  payment?: Maybe<ComWixEcomOrdersPaymentsCollectorV1PaymentInfo>;
  /** Link to payment provider dashboard */
  providerLink?: Maybe<Scalars['String']>;
  /** Payment is refundable. Available for automatic and manual refund */
  refundable?: Maybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1PaymentsSummary = {
  /** Membership payments summary */
  membership?: Maybe<ComWixEcomOrdersPaymentsCollectorV1MembershipPaymentSummary>;
  /** Monetary payments summary */
  monetary?: Maybe<ComWixEcomOrdersPaymentsCollectorV1MonetaryPaymentSummary>;
};

export type ComWixEcomOrdersPaymentsCollectorV1PreparePaymentCollectionRequestInput = {
  /** Amount to collect */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Delayed capture payment settings */
  delayedCaptureSettings?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1DelayedCaptureSettingsInput>;
  /** Ecom order ID. */
  ecomOrderId?: InputMaybe<Scalars['String']>;
  /**
   * Specifies whether payment collection is initiated by Merchant or User of User
   * Default: `true`
   */
  merchantInitiated?: InputMaybe<Scalars['Boolean']>;
  /**
   * Optional parameter. When present, payment collection will be performed using given payment gateway order.
   * Existing payment gateway order will be updated with a new amount.
   * When parameter is absent, new payment gateway order will be created and used for payment collection.
   */
  paymentGatewayOrderId?: InputMaybe<Scalars['String']>;
  /** Redirect urls which are used to return buyer to third party system. */
  redirectUrls?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1RedirectUrlsInput>;
};

export type ComWixEcomOrdersPaymentsCollectorV1PreparePaymentCollectionResponse = {
  /** Payment gateway order id which is associated with given payment */
  paymentGatewayOrderId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1RecordManuallyCollectedPaymentRequestInput = {
  /** Amount to be recorded as approved manual payment for given order */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1RedirectUrlsInput = {
  /** URL to redirect buyer in case of buyer canceled the transaction */
  cancelUrl?: InputMaybe<Scalars['String']>;
  /** URL to redirect buyer in case of failed/rejected transaction */
  errorUrl?: InputMaybe<Scalars['String']>;
  /** URL to redirect buyer in case of pending transaction (that might take some time to process) */
  pendingUrl?: InputMaybe<Scalars['String']>;
  /** URL to redirect buyer in case of approved (successful) transaction */
  successUrl?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1RefundDetailsInput = {
  /** Additional fees to refund */
  additionalFees?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsCollectorV1AdditionalFeeRefundInput>>>;
  /** Reason for the refund, provided by customer (optional). */
  customerReason?: InputMaybe<Scalars['String']>;
  /** Line items to refund */
  lineItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsCollectorV1LineItemRefundInput>>>;
  /** Shipping to refund */
  shipping?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1ShippingRefundInput>;
};

export type ComWixEcomOrdersPaymentsCollectorV1RefundRequestInput = {
  /** Details about refunded items */
  details?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1RefundDetailsInput>;
  /** The order this refund is related to */
  orderId?: InputMaybe<Scalars['String']>;
  /** Refund operations information */
  paymentRefunds?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsCollectorV1PaymentRefundInput>>>;
  /** Side effect details related to refund */
  sideEffects?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1RefundSideEffectsInput>;
};

export type ComWixEcomOrdersPaymentsCollectorV1RefundResponse = {
  /** All order's transactions after the refunds were added */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
  /** Created refund */
  refund?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1Refund>>>;
};

export type ComWixEcomOrdersPaymentsCollectorV1RefundSideEffectsInput = {
  /** Notification side effects */
  notifications?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1RefundSideEffectsNotificationSideEffectsInput>;
  /** Restock side effects */
  restock?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1RefundSideEffectsRestockSideEffectsInput>;
};

export type ComWixEcomOrdersPaymentsCollectorV1RefundSideEffectsNotificationSideEffectsInput = {
  /** Custom message added to the refund confirmation emails. */
  customMessage?: InputMaybe<Scalars['String']>;
  /** Customer will be notified about each refund transaction via email. Default: false */
  sendCustomerEmail?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1RefundSideEffectsRestockItemInput = {
  /** Line item ID */
  lineItemId?: InputMaybe<Scalars['String']>;
  /** Quantity to restock */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1RefundSideEffectsRestockSideEffectsInput = {
  /** List of items for restock */
  lineItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsCollectorV1RefundSideEffectsRestockItemInput>>>;
};

export type ComWixEcomOrdersPaymentsCollectorV1Refundability = {
  /** Reason why payment is only refundable manually. */
  manuallyRefundableReason?: Maybe<ComWixEcomOrdersPaymentsCollectorV1RefundabilityManuallyRefundableReason>;
  /** Reason why payment is not refundable. */
  nonRefundableReason?: Maybe<ComWixEcomOrdersPaymentsCollectorV1RefundabilityNonRefundableReason>;
  /** Payment ID. */
  paymentId?: Maybe<Scalars['String']>;
  /** Link to payment provider dashboard. */
  providerLink?: Maybe<Scalars['String']>;
  /** Payment refundability status. */
  refundabilityStatus?: Maybe<ComWixEcomOrdersPaymentsCollectorV1RefundabilityRefundableStatus>;
};

export enum ComWixEcomOrdersPaymentsCollectorV1RefundabilityManuallyRefundableReason {
  EXPIRED = 'EXPIRED',
  NOT_SUPPORTED = 'NOT_SUPPORTED',
  OFFLINE = 'OFFLINE',
  REQUIRES_CARD_READER = 'REQUIRES_CARD_READER'
}

export enum ComWixEcomOrdersPaymentsCollectorV1RefundabilityNonRefundableReason {
  ACCESS_DENIED = 'ACCESS_DENIED',
  ALREADY_REFUNDED = 'ALREADY_REFUNDED',
  DISABLED_BY_PROVIDER = 'DISABLED_BY_PROVIDER',
  FORBIDDEN = 'FORBIDDEN',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  NONE = 'NONE',
  NOT_PAID = 'NOT_PAID',
  ORDER_IS_PENDING = 'ORDER_IS_PENDING',
  ORDER_IS_REJECTED = 'ORDER_IS_REJECTED',
  PENDING_REFUND = 'PENDING_REFUND',
  PROVIDER_IS_DOWN = 'PROVIDER_IS_DOWN',
  TRANSACTION_NOT_FOUND = 'TRANSACTION_NOT_FOUND',
  ZERO_PRICE = 'ZERO_PRICE'
}

export enum ComWixEcomOrdersPaymentsCollectorV1RefundabilityRefundableStatus {
  MANUAL = 'MANUAL',
  NOT_REFUNDABLE = 'NOT_REFUNDABLE',
  REFUNDABLE = 'REFUNDABLE'
}

export type ComWixEcomOrdersPaymentsCollectorV1ShippingRefund = {
  /** Amount to refund. Empty value means refund for remaining (refundable) amount. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersPaymentsCollectorV1ShippingRefundInput = {
  /** Amount to refund. Empty value means refund for remaining (refundable) amount. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersPaymentsCollectorV1ShippingRefundOption = {
  /** Original shipping amount */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Shipping amount available for refund */
  availableRefundAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Previously refunded shipping amount */
  refundedAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersPaymentsCollectorV1TriggerRefundRequestInput = {
  /** Business model of a refund */
  details?: InputMaybe<ComWixEcomOrdersPaymentsV1RefundDetailsInput>;
  /** The order this refund related to */
  ecomOrderId?: InputMaybe<Scalars['String']>;
  /** Refund operations information */
  payments?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsV1PaymentRefundInput>>>;
  /** Side effect details related to refund */
  sideEffects?: InputMaybe<ComWixEcomOrdersPaymentsV1RefundSideEffectsInput>;
};

export type ComWixEcomOrdersPaymentsCollectorV1TriggerRefundResponse = {
  /** Payment ID's that the refund execution had failed for */
  failedPaymentIds?: Maybe<Array<Maybe<WixCommonItemMetadata>>>;
  /** All order's transactions after the refunds were added */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
  /** Created refund ID */
  refundId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1VoidAuthorizedPaymentRequestInput = {
  /** Wix eCommerce order ID */
  ecomOrderId?: InputMaybe<Scalars['String']>;
  /** Payment ID */
  paymentId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsCollectorV1VoidAuthorizedPaymentsRequestInput = {
  /** Wix eCommerce order ID */
  ecomOrderId?: InputMaybe<Scalars['String']>;
  /** Payment IDs */
  paymentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersPaymentsCollectorV1VoidAuthorizedPaymentsResponse = {
  /** All order's transactions after the void was triggered */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
};

export type ComWixEcomOrdersPaymentsV1AddChargebackRequestInput = {
  /** Chargeback. */
  chargeback?: InputMaybe<ComWixEcomOrdersPaymentsV1ChargebackInput>;
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
  /** Payment ID. */
  paymentId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1AddChargebackResponse = {
  /** Chargeback. */
  chargeback?: Maybe<ComWixEcomOrdersPaymentsV1Chargeback>;
  /** Order transactions. */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
  /** Payment ID of a payment which received chargeback. */
  paymentId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1AddInvoiceToOrderRequestInput = {
  /** Invoice info. */
  invoiceInfo?: InputMaybe<ComWixEcomOrdersPaymentsV1InvoiceInfoInput>;
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1AddInvoiceToOrderResponse = {
  /** List of order invoices. */
  orderInvoices?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1InvoiceInfo>>>;
};

export type ComWixEcomOrdersPaymentsV1AddPaymentsRequestInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
  /** Payments to be added to order. */
  payments?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsV1PaymentInput>>>;
};

export type ComWixEcomOrdersPaymentsV1AddPaymentsResponse = {
  /** Order ID and its associated transactions. */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
  /** IDs of added order payments. */
  paymentsIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersPaymentsV1AddRefundRequestInput = {
  /** Order ID this refunds related to */
  orderId?: InputMaybe<Scalars['String']>;
  /** Refund with refund transactions to be added to order. */
  refund?: InputMaybe<ComWixEcomOrdersPaymentsV1RefundInput>;
  /** Side effect details related to refund */
  sideEffects?: InputMaybe<ComWixEcomOrdersPaymentsV1RefundSideEffectsInput>;
};

export type ComWixEcomOrdersPaymentsV1AddRefundResponse = {
  /** Order ID and its associated transactions. */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
  /** Created refund ID */
  refundId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1AdditionalFeeRefund = {
  /** Additional fee ID. */
  additionalFeeId?: Maybe<Scalars['String']>;
  /** Refund amount. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersPaymentsV1AdditionalFeeRefundInput = {
  /** Additional fee ID. */
  additionalFeeId?: InputMaybe<Scalars['String']>;
  /** Refund amount. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersPaymentsV1AggregatedRefundSummary = {
  /** Breakdown of refunded items. Available only after refund is complete. */
  breakdown?: Maybe<ComWixEcomOrdersPaymentsV1RefundItemsBreakdown>;
  /** Failed refund amount - the portion of `requestedRefund` that failed. */
  failedRefundAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Whether at least one refund transaction is still in `"PENDING"` status. */
  pending?: Maybe<Scalars['Boolean']>;
  /** Pending refund amount - the portion of `requestedRefund` that is still pending. */
  pendingRefund?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Refunded amount - the portion of `requestedRefund` that refunded successfully. */
  refunded?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total amount requested for refund. */
  requestedRefund?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersPaymentsV1AggregatedRefundSummaryInput = {
  /** Breakdown of refunded items. Available only after refund is complete. */
  breakdown?: InputMaybe<ComWixEcomOrdersPaymentsV1RefundItemsBreakdownInput>;
  /** Failed refund amount - the portion of `requestedRefund` that failed. */
  failedRefundAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Whether at least one refund transaction is still in `"PENDING"` status. */
  pending?: InputMaybe<Scalars['Boolean']>;
  /** Pending refund amount - the portion of `requestedRefund` that is still pending. */
  pendingRefund?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Refunded amount - the portion of `requestedRefund` that refunded successfully. */
  refunded?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Total amount requested for refund. */
  requestedRefund?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersPaymentsV1AuthorizationActionFailureDetails = {
  failureCode?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1AuthorizationActionFailureDetailsInput = {
  failureCode?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1AuthorizationCapture = {
  /** Amount of this capture */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Date and time the capture was initiated in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  createdDate?: Maybe<Scalars['String']>;
  /** In case of status is FAILED may contain failure details */
  failureDetails?: Maybe<ComWixEcomOrdersPaymentsV1AuthorizationActionFailureDetails>;
  /** Capture ID. */
  id?: Maybe<Scalars['String']>;
  /** Status of this capture action */
  status?: Maybe<ComWixEcomOrdersPaymentsV1AuthorizationCaptureStatusEnumAuthorizationCaptureStatus>;
};

export type ComWixEcomOrdersPaymentsV1AuthorizationCaptureInput = {
  /** Amount of this capture */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Date and time the capture was initiated in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** In case of status is FAILED may contain failure details */
  failureDetails?: InputMaybe<ComWixEcomOrdersPaymentsV1AuthorizationActionFailureDetailsInput>;
  /** Capture ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Status of this capture action */
  status?: InputMaybe<ComWixEcomOrdersPaymentsV1AuthorizationCaptureStatusEnumAuthorizationCaptureStatus>;
};

export enum ComWixEcomOrdersPaymentsV1AuthorizationCaptureStatusEnumAuthorizationCaptureStatus {
  /** Capture operation failed. */
  FAILED = 'FAILED',
  /** Capture operation still in progress. */
  PENDING = 'PENDING',
  /** Capture operation succeeded. */
  SUCCEEDED = 'SUCCEEDED',
  UNKNOWN_STATUS = 'UNKNOWN_STATUS'
}

export type ComWixEcomOrdersPaymentsV1AuthorizationDetails = {
  /** Date and time the payment was authorized in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  authorizedDate?: Maybe<Scalars['String']>;
  /**
   * List of captures associated with payment
   * In case of failed it can be replaced with new one with PENDING or SUCCESS statuses
   */
  captures?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1AuthorizationCapture>>>;
  /** Whether the authorized payment is of a delayed capture. */
  delayedCapture?: Maybe<Scalars['Boolean']>;
  /** Scheduled action for this transaction */
  scheduledAction?: Maybe<ComWixEcomOrdersPaymentsV1ScheduledAction>;
  /** Void associated with payment */
  void?: Maybe<ComWixEcomOrdersPaymentsV1AuthorizationVoid>;
};

export type ComWixEcomOrdersPaymentsV1AuthorizationDetailsInput = {
  /** Date and time the payment was authorized in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  authorizedDate?: InputMaybe<Scalars['String']>;
  /**
   * List of captures associated with payment
   * In case of failed it can be replaced with new one with PENDING or SUCCESS statuses
   */
  captures?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsV1AuthorizationCaptureInput>>>;
  /** Whether the authorized payment is of a delayed capture. */
  delayedCapture?: InputMaybe<Scalars['Boolean']>;
  /** Scheduled action for this transaction */
  scheduledAction?: InputMaybe<ComWixEcomOrdersPaymentsV1ScheduledActionInput>;
  /** Void associated with payment */
  void?: InputMaybe<ComWixEcomOrdersPaymentsV1AuthorizationVoidInput>;
};

export type ComWixEcomOrdersPaymentsV1AuthorizationVoid = {
  /** In case of status is FAILED may contain failure details */
  failureDetails?: Maybe<ComWixEcomOrdersPaymentsV1AuthorizationActionFailureDetails>;
  /** Reason of void action */
  reason?: Maybe<ComWixEcomOrdersPaymentsV1AuthorizationVoidReason>;
  /** Status of this void action */
  status?: Maybe<ComWixEcomOrdersPaymentsV1AuthorizationVoidStatusEnumAuthorizationVoidStatus>;
  /** Date and time the void was initiated in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  voidedDate?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1AuthorizationVoidInput = {
  /** In case of status is FAILED may contain failure details */
  failureDetails?: InputMaybe<ComWixEcomOrdersPaymentsV1AuthorizationActionFailureDetailsInput>;
  /** Reason of void action */
  reason?: InputMaybe<ComWixEcomOrdersPaymentsV1AuthorizationVoidReason>;
  /** Status of this void action */
  status?: InputMaybe<ComWixEcomOrdersPaymentsV1AuthorizationVoidStatusEnumAuthorizationVoidStatus>;
  /** Date and time the void was initiated in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  voidedDate?: InputMaybe<Scalars['String']>;
};

export enum ComWixEcomOrdersPaymentsV1AuthorizationVoidReason {
  /** Authorization was voided by user. */
  MANUAL = 'MANUAL',
  /** Authorization passed execution date. */
  SCHEDULED = 'SCHEDULED',
  UNKNOWN_REASON = 'UNKNOWN_REASON'
}

export enum ComWixEcomOrdersPaymentsV1AuthorizationVoidStatusEnumAuthorizationVoidStatus {
  /** Void operation failed. */
  FAILED = 'FAILED',
  /** Void operation still in progress. */
  PENDING = 'PENDING',
  /** Void operation succeeded. */
  SUCCEEDED = 'SUCCEEDED',
  UNKNOWN_STATUS = 'UNKNOWN_STATUS'
}

export type ComWixEcomOrdersPaymentsV1BulkGenerateInvoicesRequestInput = {
  /** Order IDs. */
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersPaymentsV1BulkGenerateInvoicesResponse = {
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  results?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1BulkInvoiceResult>>>;
};

export type ComWixEcomOrdersPaymentsV1BulkInvoiceResult = {
  item?: Maybe<ComWixEcomOrdersPaymentsV1InvoiceForOrder>;
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixEcomOrdersPaymentsV1BulkPaymentResult = {
  /** Updated payment. Returned if `return_full_entity` set to `true`. */
  item?: Maybe<ComWixEcomOrdersPaymentsV1Payment>;
  /** Item metadata. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixEcomOrdersPaymentsV1BulkUpdatePaymentStatusesRequestInput = {
  /** Order and payment IDs for which to update payment status. */
  paymentAndOrderIds?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsV1PaymentAndOrderIdInput>>>;
  /** Whether to return the full payment entity (`results.item`) in the response. */
  returnFullEntity?: InputMaybe<Scalars['Boolean']>;
  /** Payment status. */
  status?: InputMaybe<WixPaymentApiPayV3TransactionTransactionStatus>;
  /**
   * *TBD** NOT IMPLEMENTED
   * Status update date
   * When defined -> the update will be applied only if it's newer than existing one, otherwise will throw 409
   * Not defined -> apply the update without any verification.
   */
  statusUpdatedDate?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1BulkUpdatePaymentStatusesResponse = {
  /** Bulk operation metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Bulk operation results. */
  results?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1BulkPaymentResult>>>;
};

export type ComWixEcomOrdersPaymentsV1CalculateRefundItemRequestInput = {
  /** ID of the line item being refunded */
  lineItemId?: InputMaybe<Scalars['String']>;
  /** How much of that line item is being refunded */
  quantity?: InputMaybe<Scalars['Int']>;
  /** Should this item be restocked (used for validation purposes) */
  restock?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersPaymentsV1CalculateRefundItemResponse = {
  /** Line item ID */
  lineItemId?: Maybe<Scalars['String']>;
  /** The line item's price */
  lineItemPrice?: Maybe<Scalars['Float']>;
};

export type ComWixEcomOrdersPaymentsV1CalculateRefundRequestInput = {
  /** Order ID */
  orderId?: InputMaybe<Scalars['String']>;
  /** Refunded line items and quantity */
  refundItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsV1CalculateRefundItemRequestInput>>>;
  /** Should include shipping in refund calculation */
  refundShipping?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersPaymentsV1CalculateRefundResponse = {
  /** Discount given for this order */
  discount?: Maybe<Scalars['String']>;
  /** The refundable items of that order */
  items?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1CalculateRefundItemResponse>>>;
  /** Previous refund given on that order */
  previouslyRefundedAmount?: Maybe<Scalars['String']>;
  /** Total cost of the order (without tax) */
  subtotal?: Maybe<Scalars['String']>;
  /** Tax cost of the order */
  tax?: Maybe<Scalars['String']>;
  /** Total refundable amount */
  total?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1Chargeback = {
  /** Amount. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Date and time the chargeback was created in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. Defaults to current time when not provided. */
  createdDate?: Maybe<Scalars['String']>;
  /** External chargeback ID. */
  externalId?: Maybe<Scalars['String']>;
  /** Chargeback ID. */
  id?: Maybe<Scalars['String']>;
  /** Reversal amount. Present only when status is REVERSED. */
  reversalAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /**
   * Status.
   *
   * Default: `"APPROVED"`.
   */
  status?: Maybe<ComWixEcomOrdersPaymentsV1ChargebackStatus>;
  /** Date and time the chargeback was updated in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. Defaults to current time when not provided. */
  updatedDate?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1ChargebackInput = {
  /** Amount. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Date and time the chargeback was created in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. Defaults to current time when not provided. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** External chargeback ID. */
  externalId?: InputMaybe<Scalars['String']>;
  /** Chargeback ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Reversal amount. Present only when status is REVERSED. */
  reversalAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /**
   * Status.
   *
   * Default: `"APPROVED"`.
   */
  status?: InputMaybe<ComWixEcomOrdersPaymentsV1ChargebackStatus>;
  /** Date and time the chargeback was updated in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. Defaults to current time when not provided. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export enum ComWixEcomOrdersPaymentsV1ChargebackStatus {
  /** Chargeback was approved. */
  APPROVED = 'APPROVED',
  /** Chargeback was reversed. */
  REVERSED = 'REVERSED',
  UNSPECIFIED = 'UNSPECIFIED'
}

export type ComWixEcomOrdersPaymentsV1CreditCardPaymentMethodDetails = {
  /** Card issuer's brand. */
  brand?: Maybe<Scalars['String']>;
  /** The last 4 digits of the card number. */
  lastFourDigits?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1CreditCardPaymentMethodDetailsInput = {
  /** Card issuer's brand. */
  brand?: InputMaybe<Scalars['String']>;
  /** The last 4 digits of the card number. */
  lastFourDigits?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1ExternalReceiptInfo = {
  /** ID of the app providing the receipt */
  appId?: Maybe<Scalars['String']>;
  /** Display number of receipt */
  displayNumber?: Maybe<Scalars['String']>;
  /** External receipt ID */
  receiptId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1ExternalReceiptInfoInput = {
  /** ID of the app providing the receipt */
  appId?: InputMaybe<Scalars['String']>;
  /** Display number of receipt */
  displayNumber?: InputMaybe<Scalars['String']>;
  /** External receipt ID */
  receiptId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1GenerateInvoiceRequestInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1GenerateInvoiceResponse = {
  /** Invoice ID. */
  invoiceId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1GetOrderTransactionsRequestInput = {
  id: Scalars['ID'];
};

export type ComWixEcomOrdersPaymentsV1GetRefundabilityStatusRequestInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1GetRefundabilityStatusResponse = {
  /** Refundability details. */
  refundabilities?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1Refundability>>>;
  /** Whether the order supports refunding per item. */
  refundablePerItem?: Maybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersPaymentsV1GiftCardPaymentDetails = {
  /** ID of the app that created the gift card. */
  appId?: Maybe<Scalars['String']>;
  /** Gift card ID. */
  giftCardId?: Maybe<Scalars['String']>;
  /** Gift card payment ID. */
  giftCardPaymentId?: Maybe<Scalars['String']>;
  /** Gift card obfuscated code. */
  obfuscatedCode?: Maybe<Scalars['String']>;
  /** Whether the gift card is voided. */
  voided?: Maybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersPaymentsV1GiftCardPaymentDetailsInput = {
  /** ID of the app that created the gift card. */
  appId?: InputMaybe<Scalars['String']>;
  /** Gift card ID. */
  giftCardId?: InputMaybe<Scalars['String']>;
  /** Gift card payment ID. */
  giftCardPaymentId?: InputMaybe<Scalars['String']>;
  /** Gift card obfuscated code. */
  obfuscatedCode?: InputMaybe<Scalars['String']>;
  /** Whether the gift card is voided. */
  voided?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersPaymentsV1InvoiceForOrder = {
  /** Invoice ID. */
  invoiceId?: Maybe<Scalars['String']>;
  /** Order ID. */
  orderId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1InvoiceInfo = {
  /** ID of the app that set the invoice. */
  appId?: Maybe<Scalars['String']>;
  /** Invoice creation date and time. */
  createdDate?: Maybe<Scalars['String']>;
  /** Invoice ID. */
  id?: Maybe<Scalars['String']>;
  /** Invoice URL. */
  url?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1InvoiceInfoInput = {
  /** ID of the app that set the invoice. */
  appId?: InputMaybe<Scalars['String']>;
  /** Invoice creation date and time. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Invoice ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Invoice URL. */
  url?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1InvoicesForOrder = {
  /** Invoices info. */
  invoicesInfo?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1InvoiceInfo>>>;
  /** Order ID. */
  orderId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1LineItemRefund = {
  /** Line item ID. */
  lineItemId?: Maybe<Scalars['String']>;
  /** Refund quantity. */
  quantity?: Maybe<Scalars['Int']>;
};

export type ComWixEcomOrdersPaymentsV1LineItemRefundInput = {
  /** Line item ID. */
  lineItemId?: InputMaybe<Scalars['String']>;
  /** Refund quantity. */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomOrdersPaymentsV1LineItemRefundSummary = {
  /** ID of the refunded line item. */
  lineItemId?: Maybe<Scalars['String']>;
  /** Total refunded amount for the line item. */
  totalRefundedAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersPaymentsV1LineItemRefundSummaryInput = {
  /** ID of the refunded line item. */
  lineItemId?: InputMaybe<Scalars['String']>;
  /** Total refunded amount for the line item. */
  totalRefundedAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersPaymentsV1ListInvoicesForMultipleOrdersRequestInput = {
  /** Order IDs for which to retrieve invoices. */
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersPaymentsV1ListInvoicesForMultipleOrdersResponse = {
  /** List of order IDs and their associated invoices. */
  invoicesForOrder?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1InvoicesForOrder>>>;
};

export type ComWixEcomOrdersPaymentsV1ListInvoicesForSingleOrderRequestInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1ListInvoicesForSingleOrderResponse = {
  /** List of invoices. */
  invoices?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1InvoiceInfo>>>;
};

export type ComWixEcomOrdersPaymentsV1ListTransactionsForMultipleOrdersRequestInput = {
  /** Order IDs for which to retrieve transactions. */
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersPaymentsV1ListTransactionsForMultipleOrdersResponse = {
  /** List of order IDs and their associated transactions. */
  orderTransactions?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>>>;
};

export type ComWixEcomOrdersPaymentsV1ListTransactionsForSingleOrderRequestInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1ListTransactionsForSingleOrderResponse = {
  /** Order ID and its associated transactions. */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
};

export type ComWixEcomOrdersPaymentsV1MaskedPaymentInput = {
  /** Field mask of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Updated payment */
  payment?: InputMaybe<ComWixEcomOrdersPaymentsV1PaymentInput>;
  /**
   * Status update date
   * When defined -> the update will be applied only if it's newer than existing one, otherwise will throw error
   * Not defined -> apply the update without any verification.
   */
  statusUpdatedDate?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1MembershipPaymentDetails = {
  /** The transaction ID in the membership system. Can be used to void the transaction. */
  externalTransactionId?: Maybe<Scalars['String']>;
  /** ID of the line item this membership applies to. */
  lineItemId?: Maybe<Scalars['String']>;
  /** Membership ID. */
  membershipId?: Maybe<Scalars['String']>;
  /** Membership name. */
  name?: Maybe<ComWixEcomMembershipsSpiV1MembershipName>;
  /** ID of the application providing this payment option. */
  providerAppId?: Maybe<Scalars['String']>;
  /** Payment status. */
  status?: Maybe<ComWixEcomOrdersPaymentsV1MembershipPaymentStatus>;
  /** Whether the membership is voided. */
  voided?: Maybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersPaymentsV1MembershipPaymentDetailsInput = {
  /** The transaction ID in the membership system. Can be used to void the transaction. */
  externalTransactionId?: InputMaybe<Scalars['String']>;
  /** ID of the line item this membership applies to. */
  lineItemId?: InputMaybe<Scalars['String']>;
  /** Membership ID. */
  membershipId?: InputMaybe<Scalars['String']>;
  /** Membership name. */
  name?: InputMaybe<ComWixEcomMembershipsSpiV1MembershipNameInput>;
  /** ID of the application providing this payment option. */
  providerAppId?: InputMaybe<Scalars['String']>;
  /** Payment status. */
  status?: InputMaybe<ComWixEcomOrdersPaymentsV1MembershipPaymentStatus>;
  /** Whether the membership is voided. */
  voided?: InputMaybe<Scalars['Boolean']>;
};

export enum ComWixEcomOrdersPaymentsV1MembershipPaymentStatus {
  /** Payment was charged. */
  CHARGED = 'CHARGED',
  /** The attempt to charge the payment failed, for example, due to lack of credits. */
  CHARGE_FAILED = 'CHARGE_FAILED'
}

export type ComWixEcomOrdersPaymentsV1OrderTransactions = {
  /** Order ID. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
  /** Order ID. */
  orderId?: Maybe<Scalars['String']>;
  /** Record of payments made to the merchant. */
  payments?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1Payment>>>;
  /** Record of refunds made to the buyer. */
  refunds?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1Refund>>>;
};

export type ComWixEcomOrdersPaymentsV1Payment = {
  /** Payment amount. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Date and time the payment was created in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. Defaults to current time when not provided. */
  createdDate?: Maybe<Scalars['String']>;
  /** Receipt created by an external system. */
  externalReceipt?: Maybe<ComWixEcomOrdersPaymentsV1ExternalReceiptInfo>;
  /** Gift card payment details. */
  giftcardPaymentDetails?: Maybe<ComWixEcomOrdersPaymentsV1GiftCardPaymentDetails>;
  /** Payment ID. */
  id?: Maybe<Scalars['String']>;
  /** Membership payment details. */
  membershipPaymentDetails?: Maybe<ComWixEcomOrdersPaymentsV1MembershipPaymentDetails>;
  /**
   * Whether refunds for this payment are disabled.
   * + `true`: This payment is not refundable.
   * + `false`: This payment may be refunded. However, this ultimately depends on the payment provider.
   */
  refundDisabled?: Maybe<Scalars['Boolean']>;
  /** Regular payment details. */
  regularPaymentDetails?: Maybe<ComWixEcomOrdersPaymentsV1RegularPaymentDetails>;
  /**
   * Whether receipt generation for this payment are allowed.
   * + `true`: This payment supports receipt generation.
   * + `false`: This payment not supports receipt generation, or receipt already generated
   */
  supportReceiptGeneration?: Maybe<Scalars['Boolean']>;
  /** Date and time the payment was last updated in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  updatedDate?: Maybe<Scalars['String']>;
  /** Receipt created by Wix */
  wixReceipt?: Maybe<ComWixEcomOrdersPaymentsV1WixReceiptInfo>;
};

export type ComWixEcomOrdersPaymentsV1PaymentAndOrderIdInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
  /**
   * Payment ID.
   * todo: remove comment once UI will use BulkMarkOrderAsPaid
   */
  paymentId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1PaymentInput = {
  /** Payment amount. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Date and time the payment was created in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. Defaults to current time when not provided. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Receipt created by an external system. */
  externalReceipt?: InputMaybe<ComWixEcomOrdersPaymentsV1ExternalReceiptInfoInput>;
  /** Gift card payment details. */
  giftcardPaymentDetails?: InputMaybe<ComWixEcomOrdersPaymentsV1GiftCardPaymentDetailsInput>;
  /** Payment ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Membership payment details. */
  membershipPaymentDetails?: InputMaybe<ComWixEcomOrdersPaymentsV1MembershipPaymentDetailsInput>;
  /**
   * Whether refunds for this payment are disabled.
   * + `true`: This payment is not refundable.
   * + `false`: This payment may be refunded. However, this ultimately depends on the payment provider.
   */
  refundDisabled?: InputMaybe<Scalars['Boolean']>;
  /** Regular payment details. */
  regularPaymentDetails?: InputMaybe<ComWixEcomOrdersPaymentsV1RegularPaymentDetailsInput>;
  /**
   * Whether receipt generation for this payment are allowed.
   * + `true`: This payment supports receipt generation.
   * + `false`: This payment not supports receipt generation, or receipt already generated
   */
  supportReceiptGeneration?: InputMaybe<Scalars['Boolean']>;
  /** Date and time the payment was last updated in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** Receipt created by Wix */
  wixReceipt?: InputMaybe<ComWixEcomOrdersPaymentsV1WixReceiptInfoInput>;
};

export type ComWixEcomOrdersPaymentsV1PaymentRefundInput = {
  /** Refund amount. Not relevant for membership and gift card refunds. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /**
   * Whether refund is made externally and manually (on the payment provider's side)
   * When false (default), the payment gateway will be called in order to make an actual refund, and then the payment will be marked as refunded.
   * When true, the payment will only be *marked* as refunded, and no actual refund will be performed.
   */
  externalRefund?: InputMaybe<Scalars['Boolean']>;
  /**
   * Gateway refund id. When param is present, new refund is not created.
   * Instead if order has a refund transaction with given gateway refund id, this refund will be updated with details from request,
   * and all side effects from request will be executed.
   */
  gatewayRefundId?: InputMaybe<Scalars['String']>;
  /** Specific payment within the order to refund */
  paymentId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1QueryOrderTransactionsRequestInput = {
  /** Query options. */
  query?: InputMaybe<ComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorQueryInput>;
};

export type ComWixEcomOrdersPaymentsV1QueryOrderTransactionsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixEcomOrdersPaymentsV1Refund = {
  /** Date and time the refund was created in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. Defaults to current time when not provided. */
  createdDate?: Maybe<Scalars['String']>;
  /** Refund business details. */
  details?: Maybe<ComWixEcomOrdersPaymentsV1RefundDetails>;
  /** Refund ID. */
  id?: Maybe<Scalars['String']>;
  /** ID of the app that initiated this refund. */
  requestingServiceAppId?: Maybe<Scalars['String']>;
  /** Aggregated refund summary. */
  summary?: Maybe<ComWixEcomOrdersPaymentsV1AggregatedRefundSummary>;
  /** List of transactions. */
  transactions?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1RefundTransaction>>>;
};

export type ComWixEcomOrdersPaymentsV1RefundDetails = {
  /** Additional fees that were refunded. */
  additionalFees?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1AdditionalFeeRefund>>>;
  /** Order line item IDs and quantities that were refunded. */
  items?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1RefundItem>>>;
  /** Line items that were refunded. */
  lineItems?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1LineItemRefund>>>;
  /** Reason for the refund, provided by customer (optional). */
  reason?: Maybe<Scalars['String']>;
  /** Shipping amount that was refunded. */
  shipping?: Maybe<ComWixEcomOrdersPaymentsV1ShippingRefund>;
  /** Whether the shipping fee was also refunded. */
  shippingIncluded?: Maybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersPaymentsV1RefundDetailsInput = {
  /** Additional fees that were refunded. */
  additionalFees?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsV1AdditionalFeeRefundInput>>>;
  /** Order line item IDs and quantities that were refunded. */
  items?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsV1RefundItemInput>>>;
  /** Line items that were refunded. */
  lineItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsV1LineItemRefundInput>>>;
  /** Reason for the refund, provided by customer (optional). */
  reason?: InputMaybe<Scalars['String']>;
  /** Shipping amount that was refunded. */
  shipping?: InputMaybe<ComWixEcomOrdersPaymentsV1ShippingRefundInput>;
  /** Whether the shipping fee was also refunded. */
  shippingIncluded?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersPaymentsV1RefundInput = {
  /** Date and time the refund was created in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. Defaults to current time when not provided. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Refund business details. */
  details?: InputMaybe<ComWixEcomOrdersPaymentsV1RefundDetailsInput>;
  /** Refund ID. */
  id?: InputMaybe<Scalars['String']>;
  /** ID of the app that initiated this refund. */
  requestingServiceAppId?: InputMaybe<Scalars['String']>;
  /** Aggregated refund summary. */
  summary?: InputMaybe<ComWixEcomOrdersPaymentsV1AggregatedRefundSummaryInput>;
  /** List of transactions. */
  transactions?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsV1RefundTransactionInput>>>;
};

export type ComWixEcomOrdersPaymentsV1RefundItem = {
  /** Line item ID the refunded line item. */
  lineItemId?: Maybe<Scalars['String']>;
  /** Line item quantity refunded. */
  quantity?: Maybe<Scalars['Int']>;
};

export type ComWixEcomOrdersPaymentsV1RefundItemInput = {
  /** Line item ID the refunded line item. */
  lineItemId?: InputMaybe<Scalars['String']>;
  /** Line item quantity refunded. */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomOrdersPaymentsV1RefundItemsBreakdown = {
  /** Refunded line items and the amount refunded for each. */
  lineItems?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1LineItemRefundSummary>>>;
};

export type ComWixEcomOrdersPaymentsV1RefundItemsBreakdownInput = {
  /** Refunded line items and the amount refunded for each. */
  lineItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsV1LineItemRefundSummaryInput>>>;
};

export type ComWixEcomOrdersPaymentsV1RefundSideEffectsInput = {
  /** Custom message added to the refund confirmation email. */
  customMessage?: InputMaybe<Scalars['String']>;
  /** Inventory restock details as part of this refund. */
  restockInfo?: InputMaybe<ComWixEcomOrdersPaymentsV1RestockInfoInput>;
  /** Whether to send a refund confirmation email to the customer. */
  sendOrderRefundedEmail?: InputMaybe<Scalars['Boolean']>;
};

export enum ComWixEcomOrdersPaymentsV1RefundStatus {
  /** Refund transaction failed. */
  FAILED = 'FAILED',
  /** Refund was initiated on payment provider side. PENDING status was assigned by provider. */
  PENDING = 'PENDING',
  /** Refund request acknowledged, and will be executed soon. */
  SCHEDULED = 'SCHEDULED',
  /** Refund was initiated on payment provider side. */
  STARTED = 'STARTED',
  /** Refund transaction succeeded. */
  SUCCEEDED = 'SUCCEEDED'
}

export type ComWixEcomOrdersPaymentsV1RefundStatusInfo = {
  /** Free text explanation of current refund status. */
  description?: Maybe<Scalars['String']>;
  /**
   * Reason code for the refund's current status.
   *
   * Learn more about [reason codes](https://dev.wix.com/docs/rest/business-management/payments/service-plugins/payment-service-provider-service-plugin/reason-codes).
   */
  paymentGatewayReasonCode?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1RefundStatusInfoInput = {
  /** Free text explanation of current refund status. */
  description?: InputMaybe<Scalars['String']>;
  /**
   * Reason code for the refund's current status.
   *
   * Learn more about [reason codes](https://dev.wix.com/docs/rest/business-management/payments/service-plugins/payment-service-provider-service-plugin/reason-codes).
   */
  paymentGatewayReasonCode?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1RefundTransaction = {
  /** Refund amount. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Whether refund was made externally and manually on the payment provider's side. */
  externalRefund?: Maybe<Scalars['Boolean']>;
  /**
   * Payment gateway's refund ID.
   * This field is only returned when the value of `external_refund` is `false`.
   */
  gatewayRefundId?: Maybe<Scalars['String']>;
  /** ID of the payment associated with this refund. */
  paymentId?: Maybe<Scalars['String']>;
  /** ID of the refund in the payment provider's system. For example, at PayPal, Square, Stripe, etc. Not returned for external refunds. */
  providerRefundId?: Maybe<Scalars['String']>;
  /** Refund status. */
  refundStatus?: Maybe<ComWixEcomOrdersPaymentsV1RefundStatus>;
  /** Optional details of current refund status. */
  refundStatusInfo?: Maybe<ComWixEcomOrdersPaymentsV1RefundStatusInfo>;
};

export type ComWixEcomOrdersPaymentsV1RefundTransactionInput = {
  /** Refund amount. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Whether refund was made externally and manually on the payment provider's side. */
  externalRefund?: InputMaybe<Scalars['Boolean']>;
  /**
   * Payment gateway's refund ID.
   * This field is only returned when the value of `external_refund` is `false`.
   */
  gatewayRefundId?: InputMaybe<Scalars['String']>;
  /** ID of the payment associated with this refund. */
  paymentId?: InputMaybe<Scalars['String']>;
  /** ID of the refund in the payment provider's system. For example, at PayPal, Square, Stripe, etc. Not returned for external refunds. */
  providerRefundId?: InputMaybe<Scalars['String']>;
  /** Refund status. */
  refundStatus?: InputMaybe<ComWixEcomOrdersPaymentsV1RefundStatus>;
  /** Optional details of current refund status. */
  refundStatusInfo?: InputMaybe<ComWixEcomOrdersPaymentsV1RefundStatusInfoInput>;
};

export type ComWixEcomOrdersPaymentsV1Refundability = {
  /** Reason why payment is only refundable manually. */
  manuallyRefundableReason?: Maybe<ComWixEcomOrdersPaymentsV1RefundabilityManuallyRefundableReason>;
  /** Reason why payment is not refundable. */
  nonRefundableReason?: Maybe<ComWixEcomOrdersPaymentsV1RefundabilityNonRefundableReason>;
  /** Payment ID. */
  paymentId?: Maybe<Scalars['String']>;
  /** Link to payment provider dashboard. */
  providerLink?: Maybe<Scalars['String']>;
  /** Payment refundability status. */
  refundabilityStatus?: Maybe<ComWixEcomOrdersPaymentsV1RefundabilityRefundableStatus>;
};

export enum ComWixEcomOrdersPaymentsV1RefundabilityManuallyRefundableReason {
  /** Payment expired. */
  EXPIRED = 'EXPIRED',
  /** Payment not found. */
  NOT_FOUND = 'NOT_FOUND',
  /** Payment method not supported. */
  NOT_SUPPORTED = 'NOT_SUPPORTED',
  /** Payment made offline. */
  OFFLINE = 'OFFLINE',
  /** Refund requires interaction with card reader. */
  REQUIRES_CARD_READER = 'REQUIRES_CARD_READER'
}

export enum ComWixEcomOrdersPaymentsV1RefundabilityNonRefundableReason {
  /** Access denied. */
  ACCESS_DENIED = 'ACCESS_DENIED',
  /** Payment already refunded. */
  ALREADY_REFUNDED = 'ALREADY_REFUNDED',
  /** Deposit for online item. */
  DEPOSIT_ONLINE_ITEM = 'DEPOSIT_ONLINE_ITEM',
  /** Disabled by provider. */
  DISABLED_BY_PROVIDER = 'DISABLED_BY_PROVIDER',
  /** Action forbidden. */
  FORBIDDEN = 'FORBIDDEN',
  /** Internal error occurred. */
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  /** No reason. */
  NONE = 'NONE',
  /** Payment not made. */
  NOT_PAID = 'NOT_PAID',
  /** Payment partially paid. */
  PARTIALLY_PAID = 'PARTIALLY_PAID',
  /** Refund is pending. */
  PENDING_REFUND = 'PENDING_REFUND',
  /** Payment provider is down. */
  PROVIDER_IS_DOWN = 'PROVIDER_IS_DOWN',
  /** Payment amount is zero. */
  ZERO_PRICE = 'ZERO_PRICE'
}

export enum ComWixEcomOrdersPaymentsV1RefundabilityRefundableStatus {
  /** Refundable manually. */
  MANUAL = 'MANUAL',
  /** Not refundable. */
  NOT_REFUNDABLE = 'NOT_REFUNDABLE',
  /** Refundable. */
  REFUNDABLE = 'REFUNDABLE'
}

export type ComWixEcomOrdersPaymentsV1RegularPaymentDetails = {
  /** Authorization details. */
  authorizationDetails?: Maybe<ComWixEcomOrdersPaymentsV1AuthorizationDetails>;
  /** Record of chargebacks made by the buyer. */
  chargebacks?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1Chargeback>>>;
  /** Whether regular card used */
  creditCardDetails?: Maybe<ComWixEcomOrdersPaymentsV1CreditCardPaymentMethodDetails>;
  /**
   * Payment gateway's transaction ID.
   * This field is only returned when the value of `offline_payment` is `false`.
   */
  gatewayTransactionId?: Maybe<Scalars['String']>;
  /** Whether the payment was made offline. For example, when using cash or when marked as paid in the Business Manager. */
  offlinePayment?: Maybe<Scalars['Boolean']>;
  /**
   * Payment method. Non-exhaustive list of supported values:
   * + `CreditCard`, `Alipay`, `AstropayCash`, `AstropayDBT`, `AstropayMBT`, `Bitcoin`, `BitPay`, `Cash`, `ConvenienceStore`, `EPay`, `Fake`, `Giropay`, `IDeal`, `InPerson`, `Klarna`, `MercadoPago`, `Netpay`, `NordeaSolo`, `Offline`, `PagSeguro`, `PayEasy`, `PayPal`, `Paysafecard`, `Paysafecash`, `PointOfSale`, `Poli`, `Privat24`, `Przelewy24`, `RapidTransfer`, `Sepa`, `Skrill`, `Sofort`, `Trustly`, `Neteller`, `Unionpay`, `UniPay`, `Yandex`
   */
  paymentMethod?: Maybe<Scalars['String']>;
  /** Wix Payments order ID. */
  paymentOrderId?: Maybe<Scalars['String']>;
  /** Payment service provider display name. Non-exhaustive list of supported values: Wix Payments, PayPal, Square, Stripe, etc. */
  paymentProvider?: Maybe<Scalars['String']>;
  /** Transaction ID in the payment provider's system. For example, at PayPal, Square, Stripe, etc. Not returned for offline payments. */
  providerTransactionId?: Maybe<Scalars['String']>;
  /** Whether there is a payment agreement that allows for future charges. */
  savedPaymentMethod?: Maybe<Scalars['Boolean']>;
  /** Payment status. */
  status?: Maybe<WixPaymentApiPayV3TransactionTransactionStatus>;
};

export type ComWixEcomOrdersPaymentsV1RegularPaymentDetailsInput = {
  /** Authorization details. */
  authorizationDetails?: InputMaybe<ComWixEcomOrdersPaymentsV1AuthorizationDetailsInput>;
  /** Record of chargebacks made by the buyer. */
  chargebacks?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsV1ChargebackInput>>>;
  /** Whether regular card used */
  creditCardDetails?: InputMaybe<ComWixEcomOrdersPaymentsV1CreditCardPaymentMethodDetailsInput>;
  /**
   * Payment gateway's transaction ID.
   * This field is only returned when the value of `offline_payment` is `false`.
   */
  gatewayTransactionId?: InputMaybe<Scalars['String']>;
  /** Whether the payment was made offline. For example, when using cash or when marked as paid in the Business Manager. */
  offlinePayment?: InputMaybe<Scalars['Boolean']>;
  /**
   * Payment method. Non-exhaustive list of supported values:
   * + `CreditCard`, `Alipay`, `AstropayCash`, `AstropayDBT`, `AstropayMBT`, `Bitcoin`, `BitPay`, `Cash`, `ConvenienceStore`, `EPay`, `Fake`, `Giropay`, `IDeal`, `InPerson`, `Klarna`, `MercadoPago`, `Netpay`, `NordeaSolo`, `Offline`, `PagSeguro`, `PayEasy`, `PayPal`, `Paysafecard`, `Paysafecash`, `PointOfSale`, `Poli`, `Privat24`, `Przelewy24`, `RapidTransfer`, `Sepa`, `Skrill`, `Sofort`, `Trustly`, `Neteller`, `Unionpay`, `UniPay`, `Yandex`
   */
  paymentMethod?: InputMaybe<Scalars['String']>;
  /** Wix Payments order ID. */
  paymentOrderId?: InputMaybe<Scalars['String']>;
  /** Payment service provider display name. Non-exhaustive list of supported values: Wix Payments, PayPal, Square, Stripe, etc. */
  paymentProvider?: InputMaybe<Scalars['String']>;
  /** Transaction ID in the payment provider's system. For example, at PayPal, Square, Stripe, etc. Not returned for offline payments. */
  providerTransactionId?: InputMaybe<Scalars['String']>;
  /** Whether there is a payment agreement that allows for future charges. */
  savedPaymentMethod?: InputMaybe<Scalars['Boolean']>;
  /** Payment status. */
  status?: InputMaybe<WixPaymentApiPayV3TransactionTransactionStatus>;
};

export type ComWixEcomOrdersPaymentsV1RestockInfoInput = {
  /** Restocked line items and quantities. Only relevant for `{"type": "SOME_ITEMS"}`. */
  items?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsV1RestockItemInput>>>;
  /** Deprecated, use items instead */
  lineItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Restock type. */
  type?: InputMaybe<ComWixEcomOrdersPaymentsV1RestockInfoRestockType>;
};

export enum ComWixEcomOrdersPaymentsV1RestockInfoRestockType {
  ALL_ITEMS = 'ALL_ITEMS',
  NO_ITEMS = 'NO_ITEMS',
  SOME_ITEMS = 'SOME_ITEMS'
}

export type ComWixEcomOrdersPaymentsV1RestockItemInput = {
  /** ID of the line item being restocked. */
  lineItemId?: InputMaybe<Scalars['String']>;
  /** Line item quantity being restocked. */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomOrdersPaymentsV1ReverseChargebackRequestInput = {
  /** Chargeback ID. */
  chargebackId?: InputMaybe<Scalars['String']>;
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
  /** Payment ID. */
  paymentId?: InputMaybe<Scalars['String']>;
  /**
   * Reversal amount.
   *
   * Default: original chargeback amount.
   */
  reversalAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersPaymentsV1ReverseChargebackResponse = {
  /** Updated order transactions. */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
};

export type ComWixEcomOrdersPaymentsV1ScheduledAction = {
  /** Type of the action. */
  actionType?: Maybe<ComWixEcomOrdersPaymentsV1ScheduledActionActionType>;
  /** The date and time of the action. */
  executionDate?: Maybe<Scalars['String']>;
};

export enum ComWixEcomOrdersPaymentsV1ScheduledActionActionType {
  CAPTURE = 'CAPTURE',
  UNKNOWN_ACTION_TYPE = 'UNKNOWN_ACTION_TYPE',
  VOID = 'VOID'
}

export type ComWixEcomOrdersPaymentsV1ScheduledActionInput = {
  /** Type of the action. */
  actionType?: InputMaybe<ComWixEcomOrdersPaymentsV1ScheduledActionActionType>;
  /** The date and time of the action. */
  executionDate?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1SearchOrderTransactionsRequestInput = {
  /** Search options. */
  search?: InputMaybe<ComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorSearchInput>;
};

export type ComWixEcomOrdersPaymentsV1SearchOrderTransactionsResponse = {
  /** Details on the paged set of results returned. */
  metadata?: Maybe<ComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorPagingMetadata>;
  /** Order transactions */
  orderTransactions?: Maybe<Array<Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>>>;
};

export type ComWixEcomOrdersPaymentsV1ShippingRefund = {
  /** Refund amount. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersPaymentsV1ShippingRefundInput = {
  /** Refund amount. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersPaymentsV1TriggerRefundRequestInput = {
  /** Personal note added to the email */
  customMessage?: InputMaybe<Scalars['String']>;
  /** Business model of a refund */
  details?: InputMaybe<ComWixEcomOrdersPaymentsV1RefundDetailsInput>;
  /** The order this refund related to */
  orderId?: InputMaybe<Scalars['String']>;
  /**
   * Refund operations information
   * Currently, only *one* payment refund is supported per request
   */
  payments?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsV1PaymentRefundInput>>>;
  /** How to restock items as part of this refund */
  restockInfo?: InputMaybe<ComWixEcomOrdersPaymentsV1RestockInfoInput>;
  /** Should send a confirmation mail to the customer */
  sendOrderRefundedEmail?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersPaymentsV1TriggerRefundResponse = {
  /** Payment ID's that the refund execution had failed for */
  failedPaymentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** All order's transactions after the refunds were added */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
  /** Created refund ID */
  refundId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1UpdateChargebackRequestInput = {
  /** Chargeback. */
  chargeback?: InputMaybe<ComWixEcomOrdersPaymentsV1ChargebackInput>;
  /** Field mask of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1UpdateChargebackResponse = {
  /** Updated order transactions. */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
};

export type ComWixEcomOrdersPaymentsV1UpdatePaymentStatusRequestInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
  /** Payment ID. */
  paymentId?: InputMaybe<Scalars['String']>;
  /** Payment status. */
  status?: InputMaybe<WixPaymentApiPayV3TransactionTransactionStatus>;
  /**
   * *TBD** NOT IMPLEMENTED
   * Status update date
   * When defined -> the update will be applied only if it's newer than existing one, otherwise will throw 409
   * Not defined -> apply the update without any verification.
   */
  statusUpdatedDate?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1UpdatePaymentStatusResponse = {
  /** Order ID and its associated transactions after update. */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
};

export type ComWixEcomOrdersPaymentsV1UpdatePaymentsRequestInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
  /** Payments to be updated */
  payments?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsV1MaskedPaymentInput>>>;
};

export type ComWixEcomOrdersPaymentsV1UpdatePaymentsResponse = {
  /** OrderTransactions with updated payments */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
};

export type ComWixEcomOrdersPaymentsV1UpdateRefundRequestInput = {
  /** Field mask of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
  /** Refund with updated field values. */
  refund?: InputMaybe<ComWixEcomOrdersPaymentsV1RefundInput>;
};

export type ComWixEcomOrdersPaymentsV1UpdateRefundResponse = {
  /** Order transactions after update. */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
  /** Refund after update. */
  refund?: Maybe<ComWixEcomOrdersPaymentsV1Refund>;
};

export type ComWixEcomOrdersPaymentsV1UpdateRefundTransactionRequestInput = {
  /** Field mask of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
  /** Payment ID. */
  refundId?: InputMaybe<Scalars['String']>;
  /** Updated refund transaction */
  transaction?: InputMaybe<ComWixEcomOrdersPaymentsV1RefundTransactionInput>;
};

export type ComWixEcomOrdersPaymentsV1UpdateRefundTransactionResponse = {
  /** OrderTransactions with updated refund transaction */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
};

export type ComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * Pass the relevant cursor token from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Maximum number of items to return in the results. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorPagingMetadata = {
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Cursor strings that point to the next page, previous page, or both. */
  cursors?: Maybe<ComWixEcomOrdersPaymentsV1UpstreamWixCommonCursors>;
  /**
   * Whether there are more pages to retrieve following the current page.
   *
   * + `true`: Another page of results can be retrieved.
   * + `false`: This is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<ComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorPagingInput>;
  /** A filter object. See documentation [here](https://bo.wix.com/wix-docs/rnd/platformization-guidelines/api-query-language#platformization-guidelines_api-query-language_defining-in-protobuf) */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsV1UpstreamWixCommonSortingInput>>>;
};

export type ComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorSearchInput = {
  /**
   * Cursor pointing to page of results.
   * When requesting 'cursor_paging.cursor', no `filter`, `sort` or `search` can be provided.
   */
  cursorPaging?: InputMaybe<ComWixEcomOrdersPaymentsV1UpstreamWixCommonCursorPagingInput>;
  /** A filter object. See documentation [here](https://bo.wix.com/wix-docs/rnd/platformization-guidelines/api-query-language#platformization-guidelines_api-query-language_defining-in-protobuf) */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Sort object in the form [{"fieldName":"sortField1"},{"fieldName":"sortField2","direction":"DESC"}] */
  sort?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersPaymentsV1UpstreamWixCommonSortingInput>>>;
};

export type ComWixEcomOrdersPaymentsV1UpstreamWixCommonCursors = {
  /** Cursor string pointing to the next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to the previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export enum ComWixEcomOrdersPaymentsV1UpstreamWixCommonSortOrder {
  /** Ascending order. */
  ASC = 'ASC',
  /** Descending order. */
  DESC = 'DESC'
}

export type ComWixEcomOrdersPaymentsV1UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<ComWixEcomOrdersPaymentsV1UpstreamWixCommonSortOrder>;
  /**
   * When `field_name` is a property of repeated field that is marked as `MATCH_ITEMS` and sort should be done by
   * a specific element from a collection, filter can/should be provided to ensure correct sort value is picked.
   *
   * If multiple filters are provided, they are combined with AND operator.
   *
   * Example:
   * Given we have document like {"id": "1", "nestedField": [{"price": 10, "region": "EU"}, {"price": 20, "region": "US"}]}
   * and `nestedField` is marked as `MATCH_ITEMS`, to ensure that sorting is done by correct region, filter should be
   * { fieldName: "nestedField.price", "select_items_by": [{"nestedField.region": "US"}] }
   */
  selectItemsBy?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type ComWixEcomOrdersPaymentsV1WixReceiptInfo = {
  /** Display number of receipt */
  displayNumber?: Maybe<Scalars['String']>;
  /** Receipt ID */
  receipt?: Maybe<WixReceiptsV1Receipt>;
  /** Receipt ID */
  receiptId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersPaymentsV1WixReceiptInfoInput = {
  /** Display number of receipt */
  displayNumber?: InputMaybe<Scalars['String']>;
  /** Receipt ID */
  receiptId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersRolloutManagerV1CanMigrateResponse = {
  canMigrate?: Maybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersRolloutManagerV1CreateSiteRolloutStatusRequestInput = {
  siteRolloutStatus?: InputMaybe<ComWixEcomOrdersRolloutManagerV1SiteRolloutStatusInput>;
};

export type ComWixEcomOrdersRolloutManagerV1CreateSiteRolloutStatusResponse = {
  siteRolloutStatus?: Maybe<ComWixEcomOrdersRolloutManagerV1SiteRolloutStatus>;
};

export type ComWixEcomOrdersRolloutManagerV1GetSiteRolloutStatusResponse = {
  siteRolloutStatus?: Maybe<ComWixEcomOrdersRolloutManagerV1SiteRolloutStatus>;
};

export type ComWixEcomOrdersRolloutManagerV1HasOrdersInOldSystemRequestInput = {
  /** Target metasite ID value that will be used to derive ecom instance ID for check. */
  metasiteId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersRolloutManagerV1HasOrdersInOldSystemResponse = {
  /** True if any non zero number of orders exist in legacy system, false otherwise */
  hasOrdersInOldSystem?: Maybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersRolloutManagerV1MarkEmptyAndOpenNewFlowResponse = {
  siteRolloutStatus?: Maybe<ComWixEcomOrdersRolloutManagerV1SiteRolloutStatus>;
};

export type ComWixEcomOrdersRolloutManagerV1SiteRolloutStatus = {
  allowLazyMigration?: Maybe<Scalars['Boolean']>;
  comparisonModeOpen?: Maybe<Scalars['Boolean']>;
  migrationFailed?: Maybe<Scalars['Boolean']>;
  newFlowOpen?: Maybe<Scalars['Boolean']>;
  noDataToMigrate?: Maybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersRolloutManagerV1SiteRolloutStatusInput = {
  allowLazyMigration?: InputMaybe<Scalars['Boolean']>;
  comparisonModeOpen?: InputMaybe<Scalars['Boolean']>;
  migrationFailed?: InputMaybe<Scalars['Boolean']>;
  newFlowOpen?: InputMaybe<Scalars['Boolean']>;
  noDataToMigrate?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersRolloutManagerV1UpdateAllowLazyMigrationRequestInput = {
  allowLazyMigration?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersRolloutManagerV1UpdateAllowLazyMigrationResponse = {
  siteRolloutStatus?: Maybe<ComWixEcomOrdersRolloutManagerV1SiteRolloutStatus>;
};

export type ComWixEcomOrdersRolloutManagerV1UpdateComparisonStatusRequestInput = {
  comparisonModeOpen?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersRolloutManagerV1UpdateComparisonStatusResponse = {
  siteRolloutStatus?: Maybe<ComWixEcomOrdersRolloutManagerV1SiteRolloutStatus>;
};

export type ComWixEcomOrdersRolloutManagerV1UpdateMigrationFailedRequestInput = {
  migrationFailed?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersRolloutManagerV1UpdateMigrationFailedResponse = {
  siteRolloutStatus?: Maybe<ComWixEcomOrdersRolloutManagerV1SiteRolloutStatus>;
};

export type ComWixEcomOrdersRolloutManagerV1UpdateNewFlowOpenRequestInput = {
  newFlowOpen?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersRolloutManagerV1UpdateNewFlowOpenResponse = {
  siteRolloutStatus?: Maybe<ComWixEcomOrdersRolloutManagerV1SiteRolloutStatus>;
};

export type ComWixEcomOrdersRolloutManagerV1UpdateNoDataToMigrateRequestInput = {
  noDataToMigrate?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersRolloutManagerV1UpdateNoDataToMigrateResponse = {
  siteRolloutStatus?: Maybe<ComWixEcomOrdersRolloutManagerV1SiteRolloutStatus>;
};

export type ComWixEcomOrdersSideEffectsMigrationApiOrdersExperimentsInput = {
  enableRewrittenSideEffects?: InputMaybe<Scalars['Boolean']>;
  epCommitTax?: InputMaybe<Scalars['Boolean']>;
  moveBuyerOrderConfirmationEmailToEp?: InputMaybe<Scalars['Boolean']>;
  moveMerchantEmailToEp?: InputMaybe<Scalars['Boolean']>;
  producedByEpBridge?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersSideEffectsMigrationApiTriggerSideEffectsFromLegacyDataInput = {
  orderId?: InputMaybe<Scalars['String']>;
  ordersExperiments?: InputMaybe<ComWixEcomOrdersSideEffectsMigrationApiOrdersExperimentsInput>;
  storeId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1Activity = {
  /** Activity author's email. */
  authorEmail?: Maybe<Scalars['String']>;
  /** Details of an authorized payment captured. */
  authorizedPaymentCaptured?: Maybe<ComWixEcomOrdersV1AuthorizedPaymentCaptured>;
  /** Details of an authorized payment created. */
  authorizedPaymentCreated?: Maybe<ComWixEcomOrdersV1AuthorizedPaymentCreated>;
  /** Details of an authorized payment voided. */
  authorizedPaymentVoided?: Maybe<ComWixEcomOrdersV1AuthorizedPaymentVoided>;
  /** Order received a chargeback for one of its' payments. */
  chargebackCreated?: Maybe<ComWixEcomOrdersV1ChargebackCreated>;
  /** Chargeback reversed for one of the order's payments. */
  chargebackReversed?: Maybe<ComWixEcomOrdersV1ChargebackReversed>;
  /** Activity creation date and time. */
  createdDate?: Maybe<Scalars['String']>;
  /** Custom activity details (optional). `activity.type` must be `CUSTOM_ACTIVITY`. */
  customActivity?: Maybe<ComWixEcomOrdersV1CustomActivity>;
  /** Details of changes made by the Draft Orders API. */
  draftOrderChangesApplied?: Maybe<ComWixEcomOrdersV1DraftOrderChangesApplied>;
  /** Activity ID. */
  id?: Maybe<Scalars['String']>;
  /** Merchant comment details (optional). `activity.type` must be `MERCHANT_COMMENT`. */
  merchantComment?: Maybe<ComWixEcomOrdersV1MerchantComment>;
  /** Details of an order that was created as a result of an exchange of items in this order. `activity.type` must be `NEW_EXCHANGE_ORDER_CREATED`. */
  newExchangeOrderCreated?: Maybe<ComWixEcomOrdersV1NewExchangeOrderCreated>;
  /** Details of the original order for this exchange order. `activity.type` must be `ORDER_CREATED_FROM_EXCHANGE`. */
  orderCreatedFromExchange?: Maybe<ComWixEcomOrdersV1OrderCreatedFromExchange>;
  /** Additional info about order refunded activity (optional). `activity.type` must be `ORDER_REFUNDED`. */
  orderRefunded?: Maybe<ComWixEcomOrdersV1OrderRefunded>;
  /** Details of a canceled payment. */
  paymentCanceled?: Maybe<ComWixEcomOrdersV1PaymentCanceled>;
  /** Details of a declined payment. */
  paymentDeclined?: Maybe<ComWixEcomOrdersV1PaymentDeclined>;
  /** Details of a pending payment. */
  paymentPending?: Maybe<ComWixEcomOrdersV1PaymentPending>;
  /**
   * Details of a failed payment refund.
   *
   * > **Note:** A single `refundInitiated` activity can result in multiple `paymentRefunded` or `paymentRefundFailed` activities.
   * > In these cases, the `refundId` will be identical across the activities.
   */
  paymentRefundFailed?: Maybe<ComWixEcomOrdersV1PaymentRefundFailed>;
  /**
   * Details of a refunded payment.
   *
   * > **Note:** A single `refundInitiated` activity can result in multiple `paymentRefunded` or `paymentRefundFailed` activities.
   * > In these cases, the `refundId` will be identical across the activities.
   */
  paymentRefunded?: Maybe<ComWixEcomOrdersV1PaymentRefunded>;
  /** Receipt was added for associated payment. */
  receiptCreated?: Maybe<ComWixEcomOrdersV1ReceiptCreated>;
  /** Receipt sent to customer. */
  receiptSent?: Maybe<ComWixEcomOrdersV1ReceiptSent>;
  /**
   * Details of an initiated refund process.
   *
   * > **Note:** A single `refundInitiated` activity can result in multiple `paymentRefunded` or `paymentRefundFailed` activities.
   * > In these cases, the `refundId` will be identical across the activities.
   */
  refundInitiated?: Maybe<ComWixEcomOrdersV1RefundInitiated>;
  /** Details of refund to store credit. */
  refundedAsStoreCredit?: Maybe<ComWixEcomOrdersV1RefundedAsStoreCredit>;
  /** Details of the payment method saved for order */
  savedPaymentMethod?: Maybe<ComWixEcomOrdersV1SavedPaymentMethod>;
  /** Activity type. */
  type?: Maybe<ComWixEcomOrdersV1ActivityTypeEnumActivityType>;
};

export type ComWixEcomOrdersV1ActivityInput = {
  /** Activity author's email. */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** Details of an authorized payment captured. */
  authorizedPaymentCaptured?: InputMaybe<ComWixEcomOrdersV1AuthorizedPaymentCapturedInput>;
  /** Details of an authorized payment created. */
  authorizedPaymentCreated?: InputMaybe<ComWixEcomOrdersV1AuthorizedPaymentCreatedInput>;
  /** Details of an authorized payment voided. */
  authorizedPaymentVoided?: InputMaybe<ComWixEcomOrdersV1AuthorizedPaymentVoidedInput>;
  /** Order received a chargeback for one of its' payments. */
  chargebackCreated?: InputMaybe<ComWixEcomOrdersV1ChargebackCreatedInput>;
  /** Chargeback reversed for one of the order's payments. */
  chargebackReversed?: InputMaybe<ComWixEcomOrdersV1ChargebackReversedInput>;
  /** Activity creation date and time. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Custom activity details (optional). `activity.type` must be `CUSTOM_ACTIVITY`. */
  customActivity?: InputMaybe<ComWixEcomOrdersV1CustomActivityInput>;
  /** Details of changes made by the Draft Orders API. */
  draftOrderChangesApplied?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedInput>;
  /** Activity ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Merchant comment details (optional). `activity.type` must be `MERCHANT_COMMENT`. */
  merchantComment?: InputMaybe<ComWixEcomOrdersV1MerchantCommentInput>;
  /** Details of an order that was created as a result of an exchange of items in this order. `activity.type` must be `NEW_EXCHANGE_ORDER_CREATED`. */
  newExchangeOrderCreated?: InputMaybe<ComWixEcomOrdersV1NewExchangeOrderCreatedInput>;
  /** Details of the original order for this exchange order. `activity.type` must be `ORDER_CREATED_FROM_EXCHANGE`. */
  orderCreatedFromExchange?: InputMaybe<ComWixEcomOrdersV1OrderCreatedFromExchangeInput>;
  /** Additional info about order refunded activity (optional). `activity.type` must be `ORDER_REFUNDED`. */
  orderRefunded?: InputMaybe<ComWixEcomOrdersV1OrderRefundedInput>;
  /** Details of a canceled payment. */
  paymentCanceled?: InputMaybe<ComWixEcomOrdersV1PaymentCanceledInput>;
  /** Details of a declined payment. */
  paymentDeclined?: InputMaybe<ComWixEcomOrdersV1PaymentDeclinedInput>;
  /** Details of a pending payment. */
  paymentPending?: InputMaybe<ComWixEcomOrdersV1PaymentPendingInput>;
  /**
   * Details of a failed payment refund.
   *
   * > **Note:** A single `refundInitiated` activity can result in multiple `paymentRefunded` or `paymentRefundFailed` activities.
   * > In these cases, the `refundId` will be identical across the activities.
   */
  paymentRefundFailed?: InputMaybe<ComWixEcomOrdersV1PaymentRefundFailedInput>;
  /**
   * Details of a refunded payment.
   *
   * > **Note:** A single `refundInitiated` activity can result in multiple `paymentRefunded` or `paymentRefundFailed` activities.
   * > In these cases, the `refundId` will be identical across the activities.
   */
  paymentRefunded?: InputMaybe<ComWixEcomOrdersV1PaymentRefundedInput>;
  /** Receipt was added for associated payment. */
  receiptCreated?: InputMaybe<ComWixEcomOrdersV1ReceiptCreatedInput>;
  /** Receipt sent to customer. */
  receiptSent?: InputMaybe<ComWixEcomOrdersV1ReceiptSentInput>;
  /**
   * Details of an initiated refund process.
   *
   * > **Note:** A single `refundInitiated` activity can result in multiple `paymentRefunded` or `paymentRefundFailed` activities.
   * > In these cases, the `refundId` will be identical across the activities.
   */
  refundInitiated?: InputMaybe<ComWixEcomOrdersV1RefundInitiatedInput>;
  /** Details of refund to store credit. */
  refundedAsStoreCredit?: InputMaybe<ComWixEcomOrdersV1RefundedAsStoreCreditInput>;
  /** Details of the payment method saved for order */
  savedPaymentMethod?: InputMaybe<ComWixEcomOrdersV1SavedPaymentMethodInput>;
  /** Activity type. */
  type?: InputMaybe<ComWixEcomOrdersV1ActivityTypeEnumActivityType>;
};

export enum ComWixEcomOrdersV1ActivityTypeEnumActivityType {
  /** Previously authorized payment was captured. */
  AUTHORIZED_PAYMENT_CAPTURED = 'AUTHORIZED_PAYMENT_CAPTURED',
  /** Payment was authorized but not yet captured. */
  AUTHORIZED_PAYMENT_CREATED = 'AUTHORIZED_PAYMENT_CREATED',
  /** Previously authorized payment was voided. */
  AUTHORIZED_PAYMENT_VOIDED = 'AUTHORIZED_PAYMENT_VOIDED',
  /** Chargeback was created for one of the order's payments. */
  CHARGEBACK_CREATED = 'CHARGEBACK_CREATED',
  /** Chargeback was resolved in merchant's favor. */
  CHARGEBACK_REVERSED = 'CHARGEBACK_REVERSED',
  /** Custom activity created by a third-party application. */
  CUSTOM_ACTIVITY = 'CUSTOM_ACTIVITY',
  /** Download link was sent for digital items in the order. */
  DOWNLOAD_LINK_SENT = 'DOWNLOAD_LINK_SENT',
  /** Changes were applied to a draft order. */
  DRAFT_ORDER_CHANGES_APPLIED = 'DRAFT_ORDER_CHANGES_APPLIED',
  /** Order's contact email address was changed. */
  EMAIL_EDITED = 'EMAIL_EDITED',
  /** Notification email was sent to the order fulfiller. */
  FULFILLER_EMAIL_SENT = 'FULFILLER_EMAIL_SENT',
  /** Invoice document was added to the order. */
  INVOICE_ADDED = 'INVOICE_ADDED',
  /** Invoice was removed from the order. */
  INVOICE_REMOVED = 'INVOICE_REMOVED',
  /** Invoice was sent to the customer via email. */
  INVOICE_SENT = 'INVOICE_SENT',
  /** Comment added to the order by a merchant. */
  MERCHANT_COMMENT = 'MERCHANT_COMMENT',
  /** New exchange order was created from this order. */
  NEW_EXCHANGE_ORDER_CREATED = 'NEW_EXCHANGE_ORDER_CREATED',
  /** Order was canceled by merchant or customer. */
  ORDER_CANCELED = 'ORDER_CANCELED',
  /** Order was created as a result of an exchange. */
  ORDER_CREATED_FROM_EXCHANGE = 'ORDER_CREATED_FROM_EXCHANGE',
  /** Order items were marked as fulfilled (shipped or ready for pickup). */
  ORDER_FULFILLED = 'ORDER_FULFILLED',
  /** Order fulfillment status was changed to not fulfilled. */
  ORDER_NOT_FULFILLED = 'ORDER_NOT_FULFILLED',
  /** Order payment was completed and confirmed. */
  ORDER_PAID = 'ORDER_PAID',
  /** Partial payment was received for the order. */
  ORDER_PARTIALLY_PAID = 'ORDER_PARTIALLY_PAID',
  /** Order is awaiting approval or processing. */
  ORDER_PENDING = 'ORDER_PENDING',
  /** New order was created and placed. */
  ORDER_PLACED = 'ORDER_PLACED',
  /** Order was refunded, either partially or fully. */
  ORDER_REFUNDED = 'ORDER_REFUNDED',
  /** Order was rejected by merchant. */
  ORDER_REJECTED = 'ORDER_REJECTED',
  /** Payment was canceled before completion. */
  PAYMENT_CANCELED = 'PAYMENT_CANCELED',
  /** Payment was declined by payment provider. */
  PAYMENT_DECLINED = 'PAYMENT_DECLINED',
  /** Payment is awaiting processing or confirmation. */
  PAYMENT_PENDING = 'PAYMENT_PENDING',
  /** Payment was successfully refunded. */
  PAYMENT_REFUNDED = 'PAYMENT_REFUNDED',
  /** Attempt to refund payment failed. */
  PAYMENT_REFUND_FAILED = 'PAYMENT_REFUND_FAILED',
  /** Email notification for pickup readiness was sent. */
  PICKUP_READY_EMAIL_SENT = 'PICKUP_READY_EMAIL_SENT',
  /** Receipt was generated for a payment. */
  RECEIPT_CREATED = 'RECEIPT_CREATED',
  /** Receipt was sent to the customer. */
  RECEIPT_SENT = 'RECEIPT_SENT',
  /** Refund was issued as store credit. */
  REFUNDED_AS_STORE_CREDIT = 'REFUNDED_AS_STORE_CREDIT',
  /** Refund process was initiated. */
  REFUND_INITIATED = 'REFUND_INITIATED',
  /** Payment method was saved for future use. */
  SAVED_PAYMENT_METHOD = 'SAVED_PAYMENT_METHOD',
  /** Order's shipping address was modified. */
  SHIPPING_ADDRESS_EDITED = 'SHIPPING_ADDRESS_EDITED',
  /** Email confirming shipment was sent to the customer. */
  SHIPPING_CONFIRMATION_EMAIL_SENT = 'SHIPPING_CONFIRMATION_EMAIL_SENT',
  /** Tracking link for shipment was added to the order. */
  TRACKING_LINK_ADDED = 'TRACKING_LINK_ADDED',
  /** Shipping tracking number was added to the order. */
  TRACKING_NUMBER_ADDED = 'TRACKING_NUMBER_ADDED',
  /** Existing shipping tracking number was modified. */
  TRACKING_NUMBER_EDITED = 'TRACKING_NUMBER_EDITED'
}

export type ComWixEcomOrdersV1AddActivitiesRequestInput = {
  /** Activities to add. */
  orderActivities?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1ActivityInput>>>;
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1AddActivitiesResponse = {
  /**
   * IDs of the added activities.
   * Use this IDs to either [update](https://bo.wix.com/wix-docs/rest/ecommerce/orders/update-activities) or [delete](https://bo.wix.com/wix-docs/rest/ecommerce/orders/delete-activities) the activities.
   */
  activityIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Updated order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1AddActivityRequestInput = {
  /** Activity info. */
  activity?: InputMaybe<ComWixEcomOrdersV1PublicActivityInput>;
  /** Order ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1AddActivityResponse = {
  /**
   * ID of the added activity.
   * Use this ID to either [update](https://bo.wix.com/wix-docs/rest/ecommerce/orders/update-activity) or [delete](https://bo.wix.com/wix-docs/rest/ecommerce/orders/delete-activity) the activity.
   */
  activityId?: Maybe<Scalars['String']>;
  /** Updated order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1AddInternalActivityRequestInput = {
  /** Activity info. */
  activity?: InputMaybe<ComWixEcomOrdersV1InternalActivityInput>;
  /** Order ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1AddInternalActivityResponse = {
  /**
   * ID of the added internal activity.
   * Use this ID to either [update](https://bo.wix.com/wix-docs/rest/ecommerce/orders/update-activity) or [delete](https://bo.wix.com/wix-docs/rest/ecommerce/orders/delete-activity) the activity.
   */
  activityId?: Maybe<Scalars['String']>;
  /** Updated order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1AdditionalFee = {
  /** Additional fee's unique code for future processing. */
  code?: Maybe<Scalars['String']>;
  /** Additional fee's id. */
  id?: Maybe<Scalars['String']>;
  /**
   * Optional - Line items associated with this additional fee.
   * If no `lineItemIds` are provided, the fee will be associated with the whole cart/checkout/order.
   */
  lineItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Name of additional fee. */
  name?: Maybe<Scalars['String']>;
  /** Additional fee's price. */
  price?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Additional fee's price after tax. */
  priceAfterTax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Additional fee's price before tax. */
  priceBeforeTax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** SPI implementer's `appId`. */
  providerAppId?: Maybe<Scalars['String']>;
  /**
   * Number of subscription billing cycles the additional fee applies to.
   * If None and additional fee is linked to subscription line item, it applies to all cycles.
   */
  subscriptionCycles?: Maybe<Scalars['Int']>;
  /**
   * Tax details.
   * @deprecated Tax details. Replaced by: tax_info. Removal date: 2026-03-30.
   */
  taxDetails?: Maybe<ComWixEcomTaxApiItemTaxFullDetails>;
  /** Represents all the relevant tax details for additional fee. */
  taxInfo?: Maybe<ComWixEcomOrdersV1LineItemTaxInfo>;
};

export type ComWixEcomOrdersV1AdditionalFeeDeltaInput = {
  /** Additional fee id. */
  additionalFeeId?: InputMaybe<Scalars['String']>;
  additionalFeeRemoved?: InputMaybe<Scalars['Boolean']>;
  editedAdditionalFee?: InputMaybe<ComWixEcomOrdersV1AdditionalFeeInput>;
};

export type ComWixEcomOrdersV1AdditionalFeeInput = {
  /** Additional fee's unique code for future processing. */
  code?: InputMaybe<Scalars['String']>;
  /** Additional fee's id. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Optional - Line items associated with this additional fee.
   * If no `lineItemIds` are provided, the fee will be associated with the whole cart/checkout/order.
   */
  lineItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Name of additional fee. */
  name?: InputMaybe<Scalars['String']>;
  /** Additional fee's price. */
  price?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Additional fee's price after tax. */
  priceAfterTax?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Additional fee's price before tax. */
  priceBeforeTax?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** SPI implementer's `appId`. */
  providerAppId?: InputMaybe<Scalars['String']>;
  /**
   * Number of subscription billing cycles the additional fee applies to.
   * If None and additional fee is linked to subscription line item, it applies to all cycles.
   */
  subscriptionCycles?: InputMaybe<Scalars['Int']>;
  /** Represents all the relevant tax details for additional fee. */
  taxInfo?: InputMaybe<ComWixEcomOrdersV1LineItemTaxInfoInput>;
};

export type ComWixEcomOrdersV1AggregateOrdersRequestInput = {
  /** This is an object defining aggregation itself */
  aggregation?: InputMaybe<Scalars['JSON']>;
  /** Filter applied to original data */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Optional custom separator string that can be used to override default separator value '|'
   * for hierarchical responses of multifaceted aggregation requests like:
   * '{"aggregation": {"example_request_key": {"$count" : ["deliveryMethod", "shippingRegion"]}}}'
   * with example response for default '|' separator like:
   * '{"aggregates" :{"example_request_key": {"(Mail|Region 1)": 5, "(Pickup|Region 2)": 10}}}'
   */
  hierarchySeparatorOverride?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1AggregateOrdersResponse = {
  aggregates?: Maybe<Scalars['JSON']>;
};

export type ComWixEcomOrdersV1AppliedDiscount = {
  /** Applied coupon info. */
  coupon?: Maybe<ComWixEcomOrdersV1Coupon>;
  /** Automatic Discount */
  discountRule?: Maybe<ComWixEcomOrdersV1DiscountRule>;
  /**
   * Discount type.
   * * `"GLOBAL"` - discount applies to entire order.
   * * `"SPECIFIC-ITEMS"` - discount applies to specific items.
   * * `"SHIPPING"` - discount applies to shipping. For example, free shipping.
   */
  discountType?: Maybe<ComWixEcomOrdersV1AppliedDiscountDiscountType>;
  /** Discount id. */
  id?: Maybe<Scalars['String']>;
  /** Line items the discount applies to. */
  lineItemDiscounts?: Maybe<Array<Maybe<ComWixEcomOrdersV1LineItemDiscount>>>;
  /**
   * IDs of line items discount applies to.
   * Deprecated. Use `line_item_discounts` instead.
   * @deprecated IDs of line items discount applies to.
   * Deprecated. Use `line_item_discounts` instead. Replaced by: line_item_discounts. Removal date: 2024-10-30.
   */
  lineItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Merchant discount. */
  merchantDiscount?: Maybe<ComWixEcomOrdersV1MerchantDiscount>;
  /**
   * Number of subscription billing cycles the discount applies to.
   * If None and discount is linked to subscription line item, it applies to all cycles.
   */
  subscriptionCycles?: Maybe<Scalars['Int']>;
};

export type ComWixEcomOrdersV1AppliedDiscountDeltaInput = {
  /** Discount id. */
  discountId?: InputMaybe<Scalars['String']>;
  discountRemoved?: InputMaybe<Scalars['Boolean']>;
  editedDiscount?: InputMaybe<ComWixEcomOrdersV1AppliedDiscountInput>;
};

export enum ComWixEcomOrdersV1AppliedDiscountDiscountType {
  GLOBAL = 'GLOBAL',
  SHIPPING = 'SHIPPING',
  SPECIFIC_ITEMS = 'SPECIFIC_ITEMS'
}

export type ComWixEcomOrdersV1AppliedDiscountInput = {
  /** Applied coupon info. */
  coupon?: InputMaybe<ComWixEcomOrdersV1CouponInput>;
  /** Automatic Discount */
  discountRule?: InputMaybe<ComWixEcomOrdersV1DiscountRuleInput>;
  /**
   * Discount type.
   * * `"GLOBAL"` - discount applies to entire order.
   * * `"SPECIFIC-ITEMS"` - discount applies to specific items.
   * * `"SHIPPING"` - discount applies to shipping. For example, free shipping.
   */
  discountType?: InputMaybe<ComWixEcomOrdersV1AppliedDiscountDiscountType>;
  /** Discount id. */
  id?: InputMaybe<Scalars['String']>;
  /** Line items the discount applies to. */
  lineItemDiscounts?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1LineItemDiscountInput>>>;
  /** Merchant discount. */
  merchantDiscount?: InputMaybe<ComWixEcomOrdersV1MerchantDiscountInput>;
  /**
   * Number of subscription billing cycles the discount applies to.
   * If None and discount is linked to subscription line item, it applies to all cycles.
   */
  subscriptionCycles?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomOrdersV1ArchiveOrderRequestInput = {
  /** Order ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1ArchiveOrderResponse = {
  /** Archived order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export enum ComWixEcomOrdersV1AttributionSourceEnumAttributionSource {
  FACEBOOK_ADS = 'FACEBOOK_ADS',
  UNSPECIFIED = 'UNSPECIFIED'
}

export type ComWixEcomOrdersV1AuthorizedPaymentCaptured = {
  /** Payment amount */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Card issuer's brand. */
  brand?: Maybe<Scalars['String']>;
  /** The last 4 digits of the card number. */
  lastFourDigits?: Maybe<Scalars['String']>;
  /** Payment ID of payment associated with this activity */
  paymentId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1AuthorizedPaymentCapturedInput = {
  /** Payment amount */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Card issuer's brand. */
  brand?: InputMaybe<Scalars['String']>;
  /** The last 4 digits of the card number. */
  lastFourDigits?: InputMaybe<Scalars['String']>;
  /** Payment ID of payment associated with this activity */
  paymentId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1AuthorizedPaymentCreated = {
  /** Payment amount */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Card issuer's brand. */
  brand?: Maybe<Scalars['String']>;
  /** The last 4 digits of the card number. */
  lastFourDigits?: Maybe<Scalars['String']>;
  /** Payment ID of payment associated with this activity */
  paymentId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1AuthorizedPaymentCreatedInput = {
  /** Payment amount */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Card issuer's brand. */
  brand?: InputMaybe<Scalars['String']>;
  /** The last 4 digits of the card number. */
  lastFourDigits?: InputMaybe<Scalars['String']>;
  /** Payment ID of payment associated with this activity */
  paymentId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1AuthorizedPaymentVoided = {
  /** Payment amount */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Card issuer's brand. */
  brand?: Maybe<Scalars['String']>;
  /** The last 4 digits of the card number. */
  lastFourDigits?: Maybe<Scalars['String']>;
  /** Payment ID of payment associated with this activity */
  paymentId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1AuthorizedPaymentVoidedInput = {
  /** Payment amount */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Card issuer's brand. */
  brand?: InputMaybe<Scalars['String']>;
  /** The last 4 digits of the card number. */
  lastFourDigits?: InputMaybe<Scalars['String']>;
  /** Payment ID of payment associated with this activity */
  paymentId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1Balance = {
  /**
   * Balance amount.
   *
   * A negative `amount` represents the amount to be refunded. This can happen due to overcharging or the order being modified after a payment has been made.
   */
  amount?: Maybe<Scalars['String']>;
  /** Amount formatted with currency symbol. */
  formattedAmount?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1BalanceInput = {
  /**
   * Balance amount.
   *
   * A negative `amount` represents the amount to be refunded. This can happen due to overcharging or the order being modified after a payment has been made.
   */
  amount?: InputMaybe<Scalars['String']>;
  /** Amount formatted with currency symbol. */
  formattedAmount?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1BalanceSummary = {
  /** Sum of all authorized payments. */
  authorized?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Current amount left to pay. */
  balance?: Maybe<ComWixEcomOrdersV1Balance>;
  /** Sum of all transaction chargebacks. */
  chargeback?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Sum of all chargeback reversals. */
  chargebackReversal?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /**
   * Sum of all approved and successful payments.
   *
   * The value includes payments that have subsequently been fully or partially refunded.
   */
  paid?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Sum of all pending transactions. */
  pending?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Sum of all pending refund transactions. */
  pendingRefund?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Sum of all successfully refunded payments. */
  refunded?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersV1BalanceSummaryInput = {
  /** Sum of all authorized payments. */
  authorized?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Current amount left to pay. */
  balance?: InputMaybe<ComWixEcomOrdersV1BalanceInput>;
  /** Sum of all transaction chargebacks. */
  chargeback?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Sum of all chargeback reversals. */
  chargebackReversal?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /**
   * Sum of all approved and successful payments.
   *
   * The value includes payments that have subsequently been fully or partially refunded.
   */
  paid?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Sum of all pending transactions. */
  pending?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Sum of all pending refund transactions. */
  pendingRefund?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Sum of all successfully refunded payments. */
  refunded?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersV1BillingAdjustment = {
  /** Summary of the prorated adjustment amount. */
  priceSummary?: Maybe<ComWixEcomOrdersV1BillingAdjustmentPriceSummary>;
  /** The type of adjustment. */
  type?: Maybe<ComWixEcomOrdersV1BillingAdjustmentAdjustmentType>;
};

export enum ComWixEcomOrdersV1BillingAdjustmentAdjustmentType {
  /** Adjustment reduces the total amount due to changes like covering fewer billing days. Typically results in a credit or discount. */
  CREDIT = 'CREDIT',
  /** Adjustment increases the total amount due to changes like covering extra billing days. Typically results in an additional fee. */
  EXTRA_CHARGE = 'EXTRA_CHARGE',
  UNKNOWN_ADJUSTMENT_TYPE = 'UNKNOWN_ADJUSTMENT_TYPE'
}

export type ComWixEcomOrdersV1BillingAdjustmentInput = {
  /** Summary of the prorated adjustment amount. */
  priceSummary?: InputMaybe<ComWixEcomOrdersV1BillingAdjustmentPriceSummaryInput>;
  /** The type of adjustment. */
  type?: InputMaybe<ComWixEcomOrdersV1BillingAdjustmentAdjustmentType>;
};

export type ComWixEcomOrdersV1BillingAdjustmentPriceSummary = {
  /** Subtotal of adjustment, before tax. */
  subtotal?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Tax on adjustment. */
  tax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total price after tax. */
  total?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersV1BillingAdjustmentPriceSummaryInput = {
  /** Subtotal of adjustment, before tax. */
  subtotal?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Tax on adjustment. */
  tax?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Total price after tax. */
  total?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersV1BulkArchiveOrdersByFilterRequestInput = {
  /** Filter object. Learn more about supported filters [here](https://bo.wix.com/wix-docs/rest/ecommerce/orders/filter-and-sort). */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type ComWixEcomOrdersV1BulkArchiveOrdersByFilterResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Items updated by bulk action. */
  results?: Maybe<Array<Maybe<ComWixEcomOrdersV1BulkOrderResult>>>;
};

export type ComWixEcomOrdersV1BulkArchiveOrdersRequestInput = {
  /** IDs of orders to archive. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Whether to return the full updated order entities in the response. */
  returnFullEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersV1BulkArchiveOrdersResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Items updated by bulk action. */
  results?: Maybe<Array<Maybe<ComWixEcomOrdersV1BulkOrderResult>>>;
};

export type ComWixEcomOrdersV1BulkMarkAsFulfilledByFilterRequestInput = {
  /** Filter object. Learn more about supported filters [here](https://bo.wix.com/wix-docs/rest/ecommerce/orders/filter-and-sort). */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type ComWixEcomOrdersV1BulkMarkAsFulfilledByFilterResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Items updated by bulk action. */
  results?: Maybe<Array<Maybe<ComWixEcomOrdersV1BulkOrderResult>>>;
};

export type ComWixEcomOrdersV1BulkMarkAsFulfilledRequestInput = {
  /** IDs of orders to be marked as fulfilled. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Whether to return the full updated order entities in the response. */
  returnFullEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersV1BulkMarkAsFulfilledResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Items updated by bulk action. */
  results?: Maybe<Array<Maybe<ComWixEcomOrdersV1BulkOrderResult>>>;
};

export type ComWixEcomOrdersV1BulkMarkAsUnfulfilledByFilterRequestInput = {
  /** Filter object. Learn more about supported filters [here](https://bo.wix.com/wix-docs/rest/ecommerce/orders/filter-and-sort). */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type ComWixEcomOrdersV1BulkMarkAsUnfulfilledByFilterResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Items updated by bulk action. */
  results?: Maybe<Array<Maybe<ComWixEcomOrdersV1BulkOrderResult>>>;
};

export type ComWixEcomOrdersV1BulkMarkAsUnfulfilledRequestInput = {
  /** IDs of orders to be marked as not fulfilled. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Whether to return the full updated order entities in the response. */
  returnFullEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersV1BulkMarkAsUnfulfilledResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Items updated by bulk action. */
  results?: Maybe<Array<Maybe<ComWixEcomOrdersV1BulkOrderResult>>>;
};

export type ComWixEcomOrdersV1BulkMarkOrdersAsPaidRequestInput = {
  /** IDs of orders to mark as paid. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersV1BulkMarkOrdersAsPaidResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /**
   * Items updated by the bulk action.
   * The Order entity within the results optimistically changes its payment status to paid, however this process is async.
   */
  results?: Maybe<Array<Maybe<ComWixEcomOrdersV1BulkOrderResult>>>;
};

export type ComWixEcomOrdersV1BulkOrderResult = {
  /**
   * Updated order.
   *
   * Returned when `returnFullEntity = true`.
   */
  item?: Maybe<ComWixEcomOrdersV1Order>;
  /** Item metadata. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixEcomOrdersV1BulkSetBusinessLocationRequestInput = {
  /** Business location. */
  businessLocation?: InputMaybe<ComWixEcommercePlatformCommonApiLocationInput>;
  /** IDs of orders to update location for. */
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersV1BulkSetBusinessLocationResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Bulk action results. */
  results?: Maybe<Array<Maybe<ComWixEcomOrdersV1BulkSetBusinessLocationResponseBulkSetBusinessLocationResult>>>;
};

export type ComWixEcomOrdersV1BulkSetBusinessLocationResponseBulkSetBusinessLocationResult = {
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixEcomOrdersV1BulkUnArchiveOrdersByFilterRequestInput = {
  /** Filter object. Learn more about supported filters [here](https://bo.wix.com/wix-docs/rest/ecommerce/orders/filter-and-sort). */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type ComWixEcomOrdersV1BulkUnArchiveOrdersByFilterResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Items updated by bulk action. */
  results?: Maybe<Array<Maybe<ComWixEcomOrdersV1BulkOrderResult>>>;
};

export type ComWixEcomOrdersV1BulkUnArchiveOrdersRequestInput = {
  /** IDs or orders to unarchive. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Whether to return the full updated order entities in the response. */
  returnFullEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersV1BulkUnArchiveOrdersResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Items updated by bulk action. */
  results?: Maybe<Array<Maybe<ComWixEcomOrdersV1BulkOrderResult>>>;
};

export type ComWixEcomOrdersV1BulkUpdateOrderRequestInput = {
  /** Orders to be updated. */
  orders?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1MaskedOrderInput>>>;
  /** Set to `true` if you wish to receive back the updated orders in the response */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersV1BulkUpdateOrderResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Bulk action results. */
  results?: Maybe<Array<Maybe<ComWixEcomOrdersV1BulkOrderResult>>>;
};

export type ComWixEcomOrdersV1BulkUpdateOrderTagsRequestInput = {
  /** Tags to be added to orders */
  assignTags?: InputMaybe<WixCommonTagsTagsInput>;
  /** IDs of orders to update tags for. */
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Tags to be removed from orders */
  unassignTags?: InputMaybe<WixCommonTagsTagsInput>;
};

export type ComWixEcomOrdersV1BulkUpdateOrderTagsResponse = {
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  results?: Maybe<Array<Maybe<ComWixEcomOrdersV1BulkUpdateOrderTagsResponseBulkUpdateOrderTagsResult>>>;
};

export type ComWixEcomOrdersV1BulkUpdateOrderTagsResponseBulkUpdateOrderTagsResult = {
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixEcomOrdersV1BulkUpdateOrdersRequestInput = {
  /** Orders to update. */
  orders?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1MaskedOrderInput>>>;
  /**
   * Whether to return the full order entities.
   *
   * Default: `false`
   */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersV1BulkUpdateOrdersResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Bulk action results. */
  results?: Maybe<Array<Maybe<ComWixEcomOrdersV1BulkOrderResult>>>;
};

export type ComWixEcomOrdersV1BuyerInfo = {
  /** Contact ID. Auto-created if one does not yet exist. For more information, see [Contacts API](https://dev.wix.com/api/rest/contacts/contacts/introduction). */
  contact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
  /** Contact ID. Auto-created if one does not yet exist. For more information, see [Contacts API](https://dev.wix.com/api/rest/contacts/contacts/introduction). */
  contactId?: Maybe<Scalars['String']>;
  /** Buyer email address. */
  email?: Maybe<Scalars['String']>;
  /** Member ID (if site visitor is a site member). */
  member?: Maybe<ComWixpressMembersApiMember>;
  /** Member ID (if site visitor is a site member). */
  memberId?: Maybe<Scalars['String']>;
  /** Visitor ID (if site visitor is not a member). */
  visitorId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1BuyerInfoInput = {
  /** Contact ID. Auto-created if one does not yet exist. For more information, see [Contacts API](https://dev.wix.com/api/rest/contacts/contacts/introduction). */
  contactId?: InputMaybe<Scalars['String']>;
  /** Buyer email address. */
  email?: InputMaybe<Scalars['String']>;
  /** Member ID (if site visitor is a site member). */
  memberId?: InputMaybe<Scalars['String']>;
  /** Visitor ID (if site visitor is not a member). */
  visitorId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1BuyerInfoUpdateInput = {
  /** Contact ID. */
  contactId?: InputMaybe<Scalars['String']>;
  /** Email associated with the buyer. */
  email?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1CancelOrderRequestInput = {
  /** Custom note to be added to the email (optional). */
  customMessage?: InputMaybe<Scalars['String']>;
  /** Order ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Whether to restock all items in the order. This will only apply to products in the Wix Stores inventory. */
  restockAllItems?: InputMaybe<Scalars['Boolean']>;
  /** Whether to send an order canceled email to the buyer. */
  sendOrderCanceledEmail?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersV1CancelOrderResponse = {
  /** Canceled order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1ChannelInfo = {
  /** Reference to an order ID from an external system. */
  externalOrderId?: Maybe<Scalars['String']>;
  /** URL to the order in the external system. */
  externalOrderUrl?: Maybe<Scalars['String']>;
  /** Sales channel that submitted the order. */
  type?: Maybe<ComWixEcommercePlatformCommonApiChannelType>;
};

export type ComWixEcomOrdersV1ChannelInfoInput = {
  /** Reference to an order ID from an external system. */
  externalOrderId?: InputMaybe<Scalars['String']>;
  /** URL to the order in the external system. */
  externalOrderUrl?: InputMaybe<Scalars['String']>;
  /** Sales channel that submitted the order. */
  type?: InputMaybe<ComWixEcommercePlatformCommonApiChannelType>;
};

export type ComWixEcomOrdersV1ChargebackCreated = {
  /** Chargeback amount. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Chargeback ID. */
  chargebackId?: Maybe<Scalars['String']>;
  /** Payment details. */
  paymentDetails?: Maybe<ComWixEcomOrdersV1RegularPayment>;
  /** ID of the payment that received a chargeback. */
  paymentId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1ChargebackCreatedInput = {
  /** Chargeback amount. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Chargeback ID. */
  chargebackId?: InputMaybe<Scalars['String']>;
  /** Payment details. */
  paymentDetails?: InputMaybe<ComWixEcomOrdersV1RegularPaymentInput>;
  /** ID of the payment that received a chargeback. */
  paymentId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1ChargebackReversed = {
  /** Chargeback amount. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Chargeback ID. */
  chargebackId?: Maybe<Scalars['String']>;
  /** Payment details. */
  paymentDetails?: Maybe<ComWixEcomOrdersV1RegularPayment>;
  /** ID of the payment involved with the chargeback. */
  paymentId?: Maybe<Scalars['String']>;
  /** Chargeback reversal amount. */
  reversalAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersV1ChargebackReversedInput = {
  /** Chargeback amount. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Chargeback ID. */
  chargebackId?: InputMaybe<Scalars['String']>;
  /** Payment details. */
  paymentDetails?: InputMaybe<ComWixEcomOrdersV1RegularPaymentInput>;
  /** ID of the payment involved with the chargeback. */
  paymentId?: InputMaybe<Scalars['String']>;
  /** Chargeback reversal amount. */
  reversalAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersV1CommitDeltasRequestInput = {
  /** Draft order changes to be applied */
  changes?: InputMaybe<ComWixEcomOrdersV1DraftOrderDiffsInput>;
  /** Side-effects to happen after order is updated */
  commitSettings?: InputMaybe<ComWixEcomOrdersV1DraftOrderCommitSettingsInput>;
  /**
   * Draft order Id representing this change.
   * Use this ID to get this specific draft content. call .../v1/draft-orders/{draft_order_id}/get
   */
  draftOrderId?: InputMaybe<Scalars['String']>;
  /** Order id to be updated */
  id?: InputMaybe<Scalars['String']>;
  /** Reason for edit, given by user (optional). */
  reason?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1CommitDeltasResponse = {
  /** Order after deltas are applied */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1Coupon = {
  /** Coupon value. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Coupon code. */
  code?: Maybe<Scalars['String']>;
  /** Coupon ID. */
  id?: Maybe<Scalars['String']>;
  /** Coupon name. */
  name?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1CouponInput = {
  /** Coupon value. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Coupon code. */
  code?: InputMaybe<Scalars['String']>;
  /** Coupon ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Coupon name. */
  name?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1CreateOrderRequestInput = {
  /** Order info. */
  order?: InputMaybe<ComWixEcomOrdersV1OrderInput>;
  /** Determine order lifecycle */
  settings?: InputMaybe<ComWixEcomOrdersV1OrderCreationSettingsInput>;
};

export type ComWixEcomOrdersV1CreateOrderResponse = {
  /** Newly created order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1CreatePaymentGatewayOrderRequestInput = {
  /** eCom Order ID */
  ecomOrderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1CreatePaymentGatewayOrderResponse = {
  /** ID of the order created in the payment gateway */
  paymentGatewayOrderId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1CreatedBy = {
  /** App ID - when the order was created by an external application. */
  appId?: Maybe<Scalars['String']>;
  /** Member ID - when the order was created by a **logged in** site visitor. */
  memberId?: Maybe<Scalars['String']>;
  /**
   * User ID - when the order was created by a Wix user on behalf of a buyer.
   * For example, via POS (point of service).
   */
  userId?: Maybe<Scalars['String']>;
  /** Visitor ID - when the order was created by a site visitor that was **not** logged in. */
  visitorId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1CreatedByInput = {
  /** App ID - when the order was created by an external application. */
  appId?: InputMaybe<Scalars['String']>;
  /** Member ID - when the order was created by a **logged in** site visitor. */
  memberId?: InputMaybe<Scalars['String']>;
  /**
   * User ID - when the order was created by a Wix user on behalf of a buyer.
   * For example, via POS (point of service).
   */
  userId?: InputMaybe<Scalars['String']>;
  /** Visitor ID - when the order was created by a site visitor that was **not** logged in. */
  visitorId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1CreditCardDetails = {
  /** Card issuer's brand. */
  brand?: Maybe<Scalars['String']>;
  /** The last 4 digits of the card number. */
  lastFourDigits?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1CreditCardDetailsInput = {
  /** Card issuer's brand. */
  brand?: InputMaybe<Scalars['String']>;
  /** The last 4 digits of the card number. */
  lastFourDigits?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1CurrencyConversionDetails = {
  /** The rate used for converting the original currency to the currency used for payment. */
  conversionRate?: Maybe<Scalars['String']>;
  /**
   * Currency used for the pricing of this order, in [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217#List_of_ISO_4217_currency_codes) format.
   *
   * This currency is used to calculate the pricing before conversion to the buyer's payment currency.
   */
  originalCurrency?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1CurrencyConversionDetailsInput = {
  /** The rate used for converting the original currency to the currency used for payment. */
  conversionRate?: InputMaybe<Scalars['String']>;
  /**
   * Currency used for the pricing of this order, in [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217#List_of_ISO_4217_currency_codes) format.
   *
   * This currency is used to calculate the pricing before conversion to the buyer's payment currency.
   */
  originalCurrency?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1CustomActivity = {
  /** Additional data in key-value form. For example, `{ "Ticket number": "123456" }`. */
  additionalData?: Maybe<Scalars['JSON']>;
  /** ID of the app that created the custom activity. */
  appId?: Maybe<Scalars['String']>;
  /** Custom activity type. For example, `"Ticket number set"`. */
  type?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1CustomActivityInput = {
  /** Additional data in key-value form. For example, `{ "Ticket number": "123456" }`. */
  additionalData?: InputMaybe<Scalars['JSON']>;
  /** ID of the app that created the custom activity. */
  appId?: InputMaybe<Scalars['String']>;
  /** Custom activity type. For example, `"Ticket number set"`. */
  type?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1CustomAllowedActions = {
  orderActions?: Maybe<Array<Maybe<ComWixEcomOrdersV1OrderActionType>>>;
};

export type ComWixEcomOrdersV1CustomAllowedActionsInput = {
  orderActions?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1OrderActionType>>>;
};

export type ComWixEcomOrdersV1CustomField = {
  /** Custom field title. */
  title?: Maybe<Scalars['String']>;
  /** Translated custom field title. */
  translatedTitle?: Maybe<Scalars['String']>;
  /** Custom field value. */
  value?: Maybe<Scalars['JSON']>;
};

export type ComWixEcomOrdersV1CustomFieldInput = {
  /** Custom field title. */
  title?: InputMaybe<Scalars['String']>;
  /** Translated custom field title. */
  translatedTitle?: InputMaybe<Scalars['String']>;
  /** Custom field value. */
  value?: InputMaybe<Scalars['JSON']>;
};

export type ComWixEcomOrdersV1DecrementDataInput = {
  /** Line item quantity being decremented. */
  decrementBy?: InputMaybe<Scalars['Int']>;
  /** ID of the line item being decremented. */
  lineItemId?: InputMaybe<Scalars['String']>;
  /** Whether to restock the line item (triggers inventory update). */
  restock?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersV1DecrementItemsQuantityRequestInput = {
  /** Which items to decrement, and how much to decrement from each one */
  decrementData?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1DecrementDataInput>>>;
  /** Order ID */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1DecrementItemsQuantityResponse = {
  /** Updated order data */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1DeleteActivityRequestInput = {
  /** ID of the activity to delete. */
  activityId?: InputMaybe<Scalars['String']>;
  /** Order ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1DeleteActivityResponse = {
  /** Updated order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1DeliveryLogistics = {
  /** Deprecated - Latest expected delivery date and time in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  deliverByDate?: Maybe<Scalars['String']>;
  /** Expected delivery time in free text. For example, `"3-5 business days"`. */
  deliveryTime?: Maybe<Scalars['String']>;
  /** Expected delivery time. */
  deliveryTimeSlot?: Maybe<ComWixEcomOrdersV1DeliveryTimeSlot>;
  /** Instructions for carrier. For example, `"Please knock on the door. If unanswered, please call contact number. Thanks."`. */
  instructions?: Maybe<Scalars['String']>;
  /** Pickup details. */
  pickupDetails?: Maybe<ComWixEcomOrdersV1PickupDetails>;
  /** Shipping address and contact details. */
  shippingDestination?: Maybe<ComWixEcommercePlatformCommonApiAddressWithContact>;
};

export type ComWixEcomOrdersV1DeliveryLogisticsInput = {
  /** Deprecated - Latest expected delivery date and time in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  deliverByDate?: InputMaybe<Scalars['String']>;
  /** Expected delivery time in free text. For example, `"3-5 business days"`. */
  deliveryTime?: InputMaybe<Scalars['String']>;
  /** Expected delivery time. */
  deliveryTimeSlot?: InputMaybe<ComWixEcomOrdersV1DeliveryTimeSlotInput>;
  /** Instructions for carrier. For example, `"Please knock on the door. If unanswered, please call contact number. Thanks."`. */
  instructions?: InputMaybe<Scalars['String']>;
  /** Pickup details. */
  pickupDetails?: InputMaybe<ComWixEcomOrdersV1PickupDetailsInput>;
  /** Shipping address and contact details. */
  shippingDestination?: InputMaybe<ComWixEcommercePlatformCommonApiAddressWithContactInput>;
};

export type ComWixEcomOrdersV1DeliveryTimeSlot = {
  /** Delivery slot starting time. */
  from?: Maybe<Scalars['String']>;
  /** Delivery slot ending time. */
  to?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1DeliveryTimeSlotInput = {
  /** Delivery slot starting time. */
  from?: InputMaybe<Scalars['String']>;
  /** Delivery slot ending time. */
  to?: InputMaybe<Scalars['String']>;
};

export enum ComWixEcomOrdersV1DeltaPaymentOptionType {
  /** The entire payment for the given item will happen after checkout. */
  FULL_PAYMENT_OFFLINE = 'FULL_PAYMENT_OFFLINE',
  /**
   * Payment for this item can only be done using a membership and must be manually redeemed in the dashboard by the site owner.
   * Note: when this option is used, the price will be 0.
   */
  MEMBERSHIP_OFFLINE = 'MEMBERSHIP_OFFLINE',
  /** Irrelevant */
  UNKNOWN_PAYMENT_OPTION = 'UNKNOWN_PAYMENT_OPTION'
}

export type ComWixEcomOrdersV1DigitalFile = {
  /** Link expiration time and date. */
  expirationDate?: Maybe<Scalars['String']>;
  /** ID of the secure file in media. */
  fileId?: Maybe<Scalars['String']>;
  /** Link will exist after the digital links have been generated on the order. */
  link?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1DigitalFileInput = {
  /** Link expiration time and date. */
  expirationDate?: InputMaybe<Scalars['String']>;
  /** ID of the secure file in media. */
  fileId?: InputMaybe<Scalars['String']>;
  /** Link will exist after the digital links have been generated on the order. */
  link?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1DiscountRule = {
  /** Discount value. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Discount rule ID */
  discountRule?: Maybe<ComWixEcomDiscountsDiscountRule>;
  /** Discount rule ID */
  id?: Maybe<Scalars['String']>;
  /** Discount rule name */
  name?: Maybe<ComWixEcomOrdersV1DiscountRuleName>;
};

export type ComWixEcomOrdersV1DiscountRuleInput = {
  /** Discount value. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Discount rule ID */
  id?: InputMaybe<Scalars['String']>;
  /** Discount rule name */
  name?: InputMaybe<ComWixEcomOrdersV1DiscountRuleNameInput>;
};

export type ComWixEcomOrdersV1DiscountRuleName = {
  /** Original discount rule name (in site's default language). */
  original?: Maybe<Scalars['String']>;
  /** Translated discount rule name according to buyer language. Defaults to `original` when not provided. */
  translated?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1DiscountRuleNameInput = {
  /** Original discount rule name (in site's default language). */
  original?: InputMaybe<Scalars['String']>;
  /** Translated discount rule name according to buyer language. Defaults to `original` when not provided. */
  translated?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1DraftOrderChangesApplied = {
  /** Changes applied to order. */
  changes?: Maybe<Array<Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesOrderChange>>>;
  /** Draft order id. */
  draftOrderId?: Maybe<Scalars['String']>;
  /** Reason for edit, given by user (optional). */
  reason?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItem = {
  descriptionLines?: Maybe<Array<Maybe<ComWixEcommerceCatalogSpiApiV1DescriptionLine>>>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<ComWixEcommerceCatalogSpiApiV1ProductName>;
  quantity?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItemItemQuantityChangeDetails>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItemInput = {
  descriptionLines?: InputMaybe<Array<InputMaybe<ComWixEcommerceCatalogSpiApiV1DescriptionLineInput>>>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ProductNameInput>;
  quantity?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItemItemQuantityChangeDetailsInput>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItemItemQuantityChangeDetails = {
  changeType?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItemItemQuantityChangeDetailsItemQuantityChangeType>;
  diff?: Maybe<Scalars['Int']>;
  newQuantity?: Maybe<Scalars['Int']>;
  originalQuantity?: Maybe<Scalars['Int']>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItemItemQuantityChangeDetailsInput = {
  changeType?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItemItemQuantityChangeDetailsItemQuantityChangeType>;
  diff?: InputMaybe<Scalars['Int']>;
  newQuantity?: InputMaybe<Scalars['Int']>;
  originalQuantity?: InputMaybe<Scalars['Int']>;
};

export enum ComWixEcomOrdersV1DraftOrderChangesAppliedChangedOrderItemItemQuantityChangeDetailsItemQuantityChangeType {
  ITEM_ADDED = 'ITEM_ADDED',
  ITEM_REMOVED = 'ITEM_REMOVED',
  QUANTITY_DECREASED = 'QUANTITY_DECREASED',
  QUANTITY_INCREASED = 'QUANTITY_INCREASED'
}

export type ComWixEcomOrdersV1DraftOrderChangesAppliedInput = {
  /** Changes applied to order. */
  changes?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesOrderChangeInput>>>;
  /** Draft order id. */
  draftOrderId?: InputMaybe<Scalars['String']>;
  /** Reason for edit, given by user (optional). */
  reason?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemAmount = {
  /** Amount associated with this item. (Discount amount for item / additional fee amount for item) */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Order line item id */
  id?: Maybe<Scalars['String']>;
  /** Item name. */
  name?: Maybe<ComWixEcommerceCatalogSpiApiV1ProductName>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemAmountInput = {
  /** Amount associated with this item. (Discount amount for item / additional fee amount for item) */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Order line item id */
  id?: InputMaybe<Scalars['String']>;
  /** Item name. */
  name?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ProductNameInput>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemChanges = {
  /** Item description lines change. */
  descriptionLines?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemDescriptionLineChange>;
  /** Line item ID. */
  id?: Maybe<Scalars['String']>;
  /** Item modifiers change. */
  modifierGroups?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemModifiersChange>;
  /** Item name after change. */
  name?: Maybe<ComWixEcommerceCatalogSpiApiV1ProductName>;
  /** Item price change. */
  price?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemPriceChange>;
  /** Item product name change. */
  productName?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemProductNameChange>;
  /** Item quantity change. */
  quantity?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemQuantityChange>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemChangesInput = {
  /** Item description lines change. */
  descriptionLines?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemDescriptionLineChangeInput>;
  /** Line item ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Item modifiers change. */
  modifierGroups?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemModifiersChangeInput>;
  /** Item name after change. */
  name?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ProductNameInput>;
  /** Item price change. */
  price?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemPriceChangeInput>;
  /** Item product name change. */
  productName?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemProductNameChangeInput>;
  /** Item quantity change. */
  quantity?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemQuantityChangeInput>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemDescriptionLineChange = {
  /** Description lines that were added to the line item. */
  addedDescriptionLines?: Maybe<Array<Maybe<ComWixEcommerceCatalogSpiApiV1DescriptionLine>>>;
  /** Description lines that were removed from the line item. */
  removedDescriptionLines?: Maybe<Array<Maybe<ComWixEcommerceCatalogSpiApiV1DescriptionLine>>>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemDescriptionLineChangeInput = {
  /** Description lines that were added to the line item. */
  addedDescriptionLines?: InputMaybe<Array<InputMaybe<ComWixEcommerceCatalogSpiApiV1DescriptionLineInput>>>;
  /** Description lines that were removed from the line item. */
  removedDescriptionLines?: InputMaybe<Array<InputMaybe<ComWixEcommerceCatalogSpiApiV1DescriptionLineInput>>>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemModifiersChange = {
  /** Modifier groups that were added to the line item. */
  addedModifierGroups?: Maybe<Array<Maybe<ComWixEcomOrdersV1ModifierGroup>>>;
  /** Modifier groups that were removed from the line item. */
  removedModifierGroups?: Maybe<Array<Maybe<ComWixEcomOrdersV1ModifierGroup>>>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemModifiersChangeInput = {
  /** Modifier groups that were added to the line item. */
  addedModifierGroups?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1ModifierGroupInput>>>;
  /** Modifier groups that were removed from the line item. */
  removedModifierGroups?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1ModifierGroupInput>>>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemPriceChange = {
  /** Item price after update. */
  newPrice?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Item price before update. */
  originalPrice?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemPriceChangeInput = {
  /** Item price after update. */
  newPrice?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Item price before update. */
  originalPrice?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemProductNameChange = {
  /** Item product name after update. */
  newProductName?: Maybe<ComWixEcommerceCatalogSpiApiV1ProductName>;
  /** Item product name before update. */
  originalProductName?: Maybe<ComWixEcommerceCatalogSpiApiV1ProductName>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemProductNameChangeInput = {
  /** Item product name after update. */
  newProductName?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ProductNameInput>;
  /** Item product name before update. */
  originalProductName?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ProductNameInput>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemQuantityChange = {
  /** Type of quantity change: increase or decrease. */
  deltaType?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemQuantityChangeLineItemQuantityChangeType>;
  /** Difference between original and new quantity. Absolute value. */
  diff?: Maybe<Scalars['Int']>;
  /** Item quantity after update. */
  newQuantity?: Maybe<Scalars['Int']>;
  /** Item quantity before update. */
  originalQuantity?: Maybe<Scalars['Int']>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemQuantityChangeInput = {
  /** Type of quantity change: increase or decrease. */
  deltaType?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemQuantityChangeLineItemQuantityChangeType>;
  /** Difference between original and new quantity. Absolute value. */
  diff?: InputMaybe<Scalars['Int']>;
  /** Item quantity after update. */
  newQuantity?: InputMaybe<Scalars['Int']>;
  /** Item quantity before update. */
  originalQuantity?: InputMaybe<Scalars['Int']>;
};

export enum ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemQuantityChangeLineItemQuantityChangeType {
  /** Quantity decreased. */
  QUANTITY_DECREASED = 'QUANTITY_DECREASED',
  /** Quantity increased. */
  QUANTITY_INCREASED = 'QUANTITY_INCREASED'
}

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedAdditionalFee = {
  /** Line items additional fee applies to. */
  affectedLineItems?: Maybe<Array<Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemAmount>>>;
  /** Additional fee id. */
  id?: Maybe<Scalars['String']>;
  /** Additional fee name. */
  name?: Maybe<ComWixEcomOrdersV1TranslatedValue>;
  /** Additional fee amount. */
  totalAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedAdditionalFeeInput = {
  /** Line items additional fee applies to. */
  affectedLineItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemAmountInput>>>;
  /** Additional fee id. */
  id?: InputMaybe<Scalars['String']>;
  /** Additional fee name. */
  name?: InputMaybe<ComWixEcomOrdersV1TranslatedValueInput>;
  /** Additional fee amount. */
  totalAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedDiscount = {
  /** Line items discount applies to. */
  affectedLineItems?: Maybe<Array<Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemAmount>>>;
  /** Discount id. */
  id?: Maybe<Scalars['String']>;
  /** Discount name: coupon name / discount rule name / merchant discount description. */
  name?: Maybe<ComWixEcomOrdersV1TranslatedValue>;
  /** Discount amount. */
  totalAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedDiscountInput = {
  /** Line items discount applies to. */
  affectedLineItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemAmountInput>>>;
  /** Discount id. */
  id?: InputMaybe<Scalars['String']>;
  /** Discount name: coupon name / discount rule name / merchant discount description. */
  name?: InputMaybe<ComWixEcomOrdersV1TranslatedValueInput>;
  /** Discount amount. */
  totalAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedLineItem = {
  /** Line item ID. */
  id?: Maybe<Scalars['String']>;
  /** Item name. */
  name?: Maybe<ComWixEcommerceCatalogSpiApiV1ProductName>;
  /** Added or removed item quantity. */
  quantity?: Maybe<Scalars['Int']>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedLineItemInput = {
  /** Line item ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Item name. */
  name?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ProductNameInput>;
  /** Added or removed item quantity. */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesOrderChange = {
  additionalFeeAdded?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedAdditionalFee>;
  additionalFeeRemoved?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedAdditionalFee>;
  discountAdded?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedDiscount>;
  discountRemoved?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedDiscount>;
  lineItemAdded?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedLineItem>;
  lineItemChanged?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemChanges>;
  lineItemRemoved?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedLineItem>;
  shippingInformationChanged?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChange>;
  totalPriceChanged?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesTotalPriceChange>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesOrderChangeInput = {
  additionalFeeAdded?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedAdditionalFeeInput>;
  additionalFeeRemoved?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedAdditionalFeeInput>;
  discountAdded?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedDiscountInput>;
  discountRemoved?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedDiscountInput>;
  lineItemAdded?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedLineItemInput>;
  lineItemChanged?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesLineItemChangesInput>;
  lineItemRemoved?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesManagedLineItemInput>;
  shippingInformationChanged?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeInput>;
  totalPriceChanged?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesTotalPriceChangeInput>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChange = {
  /** Order’s Shipping Information. After update */
  newShippingInfo?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeShippingInformation>;
  /** Order’s Shipping Information. Before update */
  originalShippingInfo?: Maybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeShippingInformation>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeInput = {
  /** Order’s Shipping Information. After update */
  newShippingInfo?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeShippingInformationInput>;
  /** Order’s Shipping Information. Before update */
  originalShippingInfo?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeShippingInformationInput>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeShippingInformation = {
  /** Order’s shipping title. */
  shippingTitle?: Maybe<Scalars['String']>;
  /** Order’s shipping price. */
  total?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesShippingInformationChangeShippingInformationInput = {
  /** Order’s shipping title. */
  shippingTitle?: InputMaybe<Scalars['String']>;
  /** Order’s shipping price. */
  total?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesTotalPriceChange = {
  /** Order’s total price after discounts and tax. After update */
  newTotal?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Order’s total price after discounts and tax. Before update */
  originalTotal?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersV1DraftOrderChangesAppliedTypesTotalPriceChangeInput = {
  /** Order’s total price after discounts and tax. After update */
  newTotal?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Order’s total price after discounts and tax. Before update */
  originalTotal?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersV1DraftOrderCommitSettingsInput = {
  /** If false, do not add activities to the order. Default is true. */
  addActivitiesToOrder?: InputMaybe<Scalars['Boolean']>;
  /** Inventory changes to be applied. Either to restock, or decrease. */
  inventoryUpdates?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1InventoryUpdateDetailsInput>>>;
  /** If false, do not send notifications to business. Default is true. */
  sendNotificationsToBusiness?: InputMaybe<Scalars['Boolean']>;
  /** If false, do not send notifications to buyer. Default is true. */
  sendNotificationsToBuyer?: InputMaybe<Scalars['Boolean']>;
  /** If false, do not send mails to custom fulfillers in case of a change of shippable items fulfilled by custom fulfillers. Default is true. */
  sendNotificationsToCustomFulfillers?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersV1DraftOrderDiffsInput = {
  /** Added/updated/removed additional fee. */
  additionalFees?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1AdditionalFeeDeltaInput>>>;
  /** Added/updated/removed discounts. */
  appliedDiscounts?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1AppliedDiscountDeltaInput>>>;
  /** Remove existing billing info. */
  billingInfoRemoved?: InputMaybe<Scalars['Boolean']>;
  /** Remove existing buyer info. */
  buyerInfoRemoved?: InputMaybe<Scalars['Boolean']>;
  /** Updated billing info. */
  changedBillingInfo?: InputMaybe<ComWixEcommercePlatformCommonApiAddressWithContactInput>;
  /** Buyer info and selected buyer option details. */
  changedBuyerInfo?: InputMaybe<ComWixEcomOrdersV1BuyerInfoInput>;
  /** Updated recipient info. */
  changedRecipientInfo?: InputMaybe<ComWixEcommercePlatformCommonApiAddressWithContactInput>;
  /** Shipping info and selected shipping option details. */
  changedShippingInfo?: InputMaybe<ComWixEcomOrdersV1ShippingInformationInput>;
  /** Updated order extended fields. Overrides existing extended fields. todo fully? partially? */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** Added/updated/removed order line items. */
  lineItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1LineItemDeltaInput>>>;
  /**
   * Updated order price summary. overwrites existing price summary.
   * balance will be updated automatically.
   */
  priceSummary?: InputMaybe<ComWixEcomOrdersV1PriceSummaryInput>;
  /** Remove existing recipient info. */
  recipientInfoRemoved?: InputMaybe<Scalars['Boolean']>;
  /** Remove existing shipping info. */
  shippingInfoRemoved?: InputMaybe<Scalars['Boolean']>;
  /** Tax information. */
  taxInfo?: InputMaybe<ComWixEcomOrdersV1OrderTaxInfoInput>;
};

export type ComWixEcomOrdersV1ExternalReceipt = {
  /** Display number of receipt */
  displayNumber?: Maybe<Scalars['String']>;
  /** Receipt ID */
  receiptId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1ExternalReceiptInput = {
  /** Display number of receipt */
  displayNumber?: InputMaybe<Scalars['String']>;
  /** Receipt ID */
  receiptId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1FreeTrialPeriod = {
  /** Frequency of period. Values: DAY, WEEK, MONTH, YEAR */
  frequency?: Maybe<WixPaymentApiPayV2SubscriptionFrequency>;
  /** interval of period */
  interval?: Maybe<Scalars['Int']>;
};

export type ComWixEcomOrdersV1FreeTrialPeriodInput = {
  /** Frequency of period. Values: DAY, WEEK, MONTH, YEAR */
  frequency?: InputMaybe<WixPaymentApiPayV2SubscriptionFrequency>;
  /** interval of period */
  interval?: InputMaybe<Scalars['Int']>;
};

export enum ComWixEcomOrdersV1FulfillmentStatus {
  /**
   * All of the order items are fulfilled or the order was manually marked as fulfilled.
   * Orders without shipping info are fulfilled automatically.
   */
  FULFILLED = 'FULFILLED',
  /** None of the order items are fulfilled or the order was manually marked as unfulfilled. */
  NOT_FULFILLED = 'NOT_FULFILLED',
  /** Some, but not all, of the order items are fulfilled. */
  PARTIALLY_FULFILLED = 'PARTIALLY_FULFILLED'
}

export type ComWixEcomOrdersV1FulfillmentStatusesAggregate = {
  /** Unique string values based on Fulfillment entities statuses */
  statuses?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersV1FulfillmentStatusesAggregateInput = {
  /** Unique string values based on Fulfillment entities statuses */
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersV1GetOrderRequestInput = {
  id: Scalars['ID'];
};

export type ComWixEcomOrdersV1GetShipmentsRequestInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1GetShipmentsResponse = {
  shipmentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixEcomOrdersV1GiftCardPaymentRefund = {
  /** Refund amount */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Gift card payment ID */
  giftCardPaymentId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1GiftCardPaymentRefundInput = {
  /** Refund amount */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Gift card payment ID */
  giftCardPaymentId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1InternalActivityInput = {
  /** Internal activity author's email. */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** Details of an authorized payment captured. */
  authorizedPaymentCaptured?: InputMaybe<ComWixEcomOrdersV1AuthorizedPaymentCapturedInput>;
  /** Details of an authorized payment created. */
  authorizedPaymentCreated?: InputMaybe<ComWixEcomOrdersV1AuthorizedPaymentCreatedInput>;
  /** Details of an authorized payment voided. */
  authorizedPaymentVoided?: InputMaybe<ComWixEcomOrdersV1AuthorizedPaymentVoidedInput>;
  /** Chargeback created for one of the order's payments. */
  chargebackCreated?: InputMaybe<ComWixEcomOrdersV1ChargebackCreatedInput>;
  /** Chargeback reversed for one of the order's payments. */
  chargebackReversed?: InputMaybe<ComWixEcomOrdersV1ChargebackReversedInput>;
  /** Internal activity creation date and time. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Download link was sent (relevant for orders with digital line items). */
  downloadLinkSent?: InputMaybe<Scalars['Void']>;
  /** Draft order changes applied. */
  draftOrderChangesApplied?: InputMaybe<ComWixEcomOrdersV1DraftOrderChangesAppliedInput>;
  /** Order email was updated. */
  emailEdited?: InputMaybe<Scalars['Void']>;
  /** Email sent to fulfiller. */
  fulfillerEmailSent?: InputMaybe<Scalars['Void']>;
  /** Internal activity ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Invoice was added to order. */
  invoiceAdded?: InputMaybe<Scalars['Void']>;
  /** Invoice sent to customer via email. */
  invoiceSent?: InputMaybe<Scalars['Void']>;
  /** New exchange order created. */
  newExchangeOrderCreated?: InputMaybe<ComWixEcomOrdersV1NewExchangeOrderCreatedInput>;
  /** Order canceled. */
  orderCanceled?: InputMaybe<Scalars['Void']>;
  /** Order created as a result of items exchange. */
  orderCreatedFromExchange?: InputMaybe<ComWixEcomOrdersV1OrderCreatedFromExchangeInput>;
  /** Order shipping status set as fulfilled. */
  orderFulfilled?: InputMaybe<Scalars['Void']>;
  /** Order shipping status set as not fulfilled. */
  orderNotFulfilled?: InputMaybe<Scalars['Void']>;
  /** Order paid. Either by the store owner (for offline orders), or when an online transaction was confirmed. */
  orderPaid?: InputMaybe<Scalars['Void']>;
  /** Order partially paid. During the checkout for orders with deposit items. */
  orderPartiallyPaid?: InputMaybe<Scalars['Void']>;
  /** Order pending. */
  orderPending?: InputMaybe<Scalars['Void']>;
  /** Order placed. */
  orderPlaced?: InputMaybe<Scalars['Void']>;
  /** Order refunded. */
  orderRefunded?: InputMaybe<ComWixEcomOrdersV1OrderRefundedInput>;
  /** Order rejected. */
  orderRejected?: InputMaybe<Scalars['Void']>;
  /** Details of a canceled payment. */
  paymentCanceled?: InputMaybe<ComWixEcomOrdersV1PaymentCanceledInput>;
  /** Details of a declined payment. */
  paymentDeclined?: InputMaybe<ComWixEcomOrdersV1PaymentDeclinedInput>;
  /** Details of a pending payment. */
  paymentPending?: InputMaybe<ComWixEcomOrdersV1PaymentPendingInput>;
  /**
   * Details of a failed payment refund.
   *
   * > **Note:** A single `refundInitiated` activity can result in multiple `paymentRefunded` or `paymentRefundFailed` activities.
   * > In these cases, the `refundId` will be identical across the activities.
   */
  paymentRefundFailed?: InputMaybe<ComWixEcomOrdersV1PaymentRefundFailedInput>;
  /**
   * Details of a refunded payment.
   *
   * > **Note:** A single `refundInitiated` activity can result in multiple `paymentRefunded` or `paymentRefundFailed` activities.
   * > In these cases, the `refundId` will be identical across the activities.
   */
  paymentRefunded?: InputMaybe<ComWixEcomOrdersV1PaymentRefundedInput>;
  /** Email notification for pickup sent. */
  pickupReadyEmailSent?: InputMaybe<Scalars['Void']>;
  /** Receipt was added for associated payment. */
  receiptCreated?: InputMaybe<ComWixEcomOrdersV1ReceiptCreatedInput>;
  /** Receipt sent to customer. */
  receiptSent?: InputMaybe<ComWixEcomOrdersV1ReceiptSentInput>;
  /**
   * Details of an initiated refund process.
   *
   * > **Note:** A single `refundInitiated` activity can result in multiple `paymentRefunded` or `paymentRefundFailed` activities.
   * > In these cases, the `refundId` will be identical across the activities.
   */
  refundInitiated?: InputMaybe<ComWixEcomOrdersV1RefundInitiatedInput>;
  /** Details of refund to store credit. */
  refundedAsStoreCredit?: InputMaybe<ComWixEcomOrdersV1RefundedAsStoreCreditInput>;
  /** Payment method is saved for order. */
  savedPaymentMethod?: InputMaybe<ComWixEcomOrdersV1SavedPaymentMethodInput>;
  /** Shipping address was updated. */
  shippingAddressEdited?: InputMaybe<Scalars['Void']>;
  /** An email confirmation of order shipment was sent. */
  shippingConfirmationEmailSent?: InputMaybe<Scalars['Void']>;
  /** Shipping tracking link added to order. */
  trackingLinkAdded?: InputMaybe<Scalars['Void']>;
  /** Shipping tracking number added to order. */
  trackingNumberAdded?: InputMaybe<Scalars['Void']>;
  /** Shipping tracking number was edited. */
  trackingNumberEdited?: InputMaybe<Scalars['Void']>;
};

export type ComWixEcomOrdersV1InternalQueryOrdersRequestInput = {
  /** Query options. */
  query?: InputMaybe<ComWixEcommerceCommonsApiPlatformQueryInput>;
};

export type ComWixEcomOrdersV1InternalQueryOrdersResponse = {
  /** Details on the paged set of results returned. */
  metadata?: Maybe<ComWixEcommerceCommonsApiPlatformPagingMetadata>;
  /** List of orders. */
  orders?: Maybe<Array<Maybe<ComWixEcomOrdersV1Order>>>;
};

export type ComWixEcomOrdersV1InventoryUpdateDetailsInput = {
  /** Action to be applied - decrease or restock */
  actionType?: InputMaybe<ComWixEcomOrdersV1InventoryUpdateDetailsInventoryAction>;
  /** Order line item id */
  lineItemId?: InputMaybe<Scalars['String']>;
  /** The amount to be increased or restocked */
  quantityChange?: InputMaybe<Scalars['Int']>;
};

export enum ComWixEcomOrdersV1InventoryUpdateDetailsInventoryAction {
  /** Decrease inventory. Without failing on negative inventory. */
  DECREASE = 'DECREASE',
  /** Restock inventory */
  RESTOCK = 'RESTOCK'
}

export type ComWixEcomOrdersV1ItemChangedDetailsInput = {
  /** Line item description lines before change */
  descriptionLinesBeforeChange?: InputMaybe<Array<InputMaybe<ComWixEcommerceCatalogSpiApiV1DescriptionLineInput>>>;
  /** Modifier groups before the change. */
  modifierGroupsBeforeChange?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1ModifierGroupInput>>>;
  /** The price before the change. */
  priceBeforeChange?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** The price description before the change */
  priceDescriptionBeforeChange?: InputMaybe<ComWixEcommerceCatalogSpiApiV1PriceDescriptionInput>;
  /** Line Item product name before change. */
  productNameBeforeChange?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ProductNameInput>;
  /** The quantity before the change. */
  quantityBeforeChange?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomOrdersV1ItemModifier = {
  /** Additional details. */
  details?: Maybe<ComWixEcommercePlatformCommonApiTranslatableString>;
  /** Modifier ID. */
  id?: Maybe<Scalars['String']>;
  /** Primary display label for the modifier. */
  label?: Maybe<ComWixEcommercePlatformCommonApiTranslatableString>;
  /** The price of the modifier. */
  price?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** The quantity of this modifier. */
  quantity?: Maybe<Scalars['Int']>;
};

export type ComWixEcomOrdersV1ItemModifierInput = {
  /** Additional details. */
  details?: InputMaybe<ComWixEcommercePlatformCommonApiTranslatableStringInput>;
  /** Modifier ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Primary display label for the modifier. */
  label?: InputMaybe<ComWixEcommercePlatformCommonApiTranslatableStringInput>;
  /** The price of the modifier. */
  price?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** The quantity of this modifier. */
  quantity?: InputMaybe<Scalars['Int']>;
};

export enum ComWixEcomOrdersV1JurisdictionType {
  CITY = 'CITY',
  COUNTRY = 'COUNTRY',
  COUNTY = 'COUNTY',
  SPECIAL = 'SPECIAL',
  STATE = 'STATE',
  UNDEFINED = 'UNDEFINED'
}

export type ComWixEcomOrdersV1LineItemDeltaInput = {
  /** The line item was modified. */
  changedDetails?: InputMaybe<ComWixEcomOrdersV1ItemChangedDetailsInput>;
  lineItem?: InputMaybe<ComWixEcomOrdersV1OrderLineItemChangedDetailsInput>;
  /** The line item was added. */
  lineItemAdded?: InputMaybe<Scalars['Boolean']>;
  /** Line item ID. */
  lineItemId?: InputMaybe<Scalars['String']>;
  /** The line item was added. */
  lineItemRemoved?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersV1LineItemDiscount = {
  /** ID of line item the discount applies to. */
  id?: Maybe<Scalars['String']>;
  /** Total discount for this line item. */
  totalDiscount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersV1LineItemDiscountInput = {
  /** ID of line item the discount applies to. */
  id?: InputMaybe<Scalars['String']>;
  /** Total discount for this line item. */
  totalDiscount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersV1LineItemExchangeData = {
  /** ID of the exchanged line item. */
  lineItemId?: Maybe<Scalars['String']>;
  /** Line item quantity being exchanged. */
  quantity?: Maybe<Scalars['Int']>;
};

export type ComWixEcomOrdersV1LineItemExchangeDataInput = {
  /** ID of the exchanged line item. */
  lineItemId?: InputMaybe<Scalars['String']>;
  /** Line item quantity being exchanged. */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomOrdersV1LineItemTaxBreakdown = {
  /** Amount of the line item price that was exempt from this authority. */
  exemptAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Jurisdiction that taxes were calculated for. For example, "New York", or "Quebec". */
  jurisdiction?: Maybe<Scalars['String']>;
  /** Type of jurisdiction that taxes were calculated for. */
  jurisdictionType?: Maybe<ComWixEcomOrdersV1JurisdictionType>;
  /** Non-taxable amount of the line item price. */
  nonTaxableAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Tax rate used for this jurisdiction, as a decimal. For example, 10% tax is 0.1000. */
  rate?: Maybe<Scalars['String']>;
  /** Amount of tax calculated for this line item. */
  taxAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /**
   * The name of the tax against which this tax amount was calculated. For example, "NY State Sales Tax", "Quebec GST", etc.
   * This name should be explicit enough to allow the merchant to understand what tax was calculated.
   */
  taxName?: Maybe<Scalars['String']>;
  /** The type of tax that was calculated. Depends on the jurisdiction's tax laws. For example, "Sales Tax", "Income Tax", "Value Added Tax", etc. */
  taxType?: Maybe<Scalars['String']>;
  /** Taxable amount of the line item price. */
  taxableAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersV1LineItemTaxBreakdownInput = {
  /** Amount of the line item price that was exempt from this authority. */
  exemptAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Jurisdiction that taxes were calculated for. For example, "New York", or "Quebec". */
  jurisdiction?: InputMaybe<Scalars['String']>;
  /** Type of jurisdiction that taxes were calculated for. */
  jurisdictionType?: InputMaybe<ComWixEcomOrdersV1JurisdictionType>;
  /** Non-taxable amount of the line item price. */
  nonTaxableAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Tax rate used for this jurisdiction, as a decimal. For example, 10% tax is 0.1000. */
  rate?: InputMaybe<Scalars['String']>;
  /** Amount of tax calculated for this line item. */
  taxAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /**
   * The name of the tax against which this tax amount was calculated. For example, "NY State Sales Tax", "Quebec GST", etc.
   * This name should be explicit enough to allow the merchant to understand what tax was calculated.
   */
  taxName?: InputMaybe<Scalars['String']>;
  /** The type of tax that was calculated. Depends on the jurisdiction's tax laws. For example, "Sales Tax", "Income Tax", "Value Added Tax", etc. */
  taxType?: InputMaybe<Scalars['String']>;
  /** Taxable amount of the line item price. */
  taxableAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersV1LineItemTaxInfo = {
  /** Amount of the line item price that was exempt from tax. */
  exemptAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Calculated tax, based on `taxable_amount` and `tax_rate`. */
  taxAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Tax information for a line item. */
  taxBreakdown?: Maybe<Array<Maybe<ComWixEcomOrdersV1LineItemTaxBreakdown>>>;
  /** Tax group ID. */
  taxGroupId?: Maybe<Scalars['String']>;
  /** Indicates whether the price already includes tax. */
  taxIncludedInPrice?: Maybe<Scalars['Boolean']>;
  /** Tax rate %, as a decimal point. */
  taxRate?: Maybe<Scalars['String']>;
  /** Amount for which tax is calculated. */
  taxableAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersV1LineItemTaxInfoInput = {
  /** Amount of the line item price that was exempt from tax. */
  exemptAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Calculated tax, based on `taxable_amount` and `tax_rate`. */
  taxAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Tax information for a line item. */
  taxBreakdown?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1LineItemTaxBreakdownInput>>>;
  /** Tax group ID. */
  taxGroupId?: InputMaybe<Scalars['String']>;
  /** Indicates whether the price already includes tax. */
  taxIncludedInPrice?: InputMaybe<Scalars['Boolean']>;
  /** Tax rate %, as a decimal point. */
  taxRate?: InputMaybe<Scalars['String']>;
  /** Amount for which tax is calculated. */
  taxableAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersV1LineItemUpdateInput = {
  /**
   * Description lines' info.
   * If description line already exists for this name, it will be replaced.
   */
  descriptionLines?: InputMaybe<Array<InputMaybe<ComWixEcommerceCatalogSpiApiV1DescriptionLineInput>>>;
  /** Line item ID. */
  lineItemId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1ListOrdersRequestInput = {
  /** ID of the order to retrieve. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Cursor token pointing to a page of results. Not used in the first request. */
  paging?: InputMaybe<ComWixEcommerceCommonsApiPlatformCursorPagingInput>;
};

export type ComWixEcomOrdersV1ListOrdersResponse = {
  /** The requested order. */
  orders?: Maybe<Array<Maybe<ComWixEcomOrdersV1Order>>>;
  /** Details on the paged set of results returned. */
  pagingMetadata?: Maybe<WixCommonCursorPagingMetadata>;
};

export type ComWixEcomOrdersV1MarkAsFulfilledRequestInput = {
  /** Order ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1MarkAsFulfilledResponse = {
  /** Updated order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1MarkAsUnfulfilledRequestInput = {
  /** Order ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1MarkAsUnfulfilledResponse = {
  /** Updated order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1MarkOrderAsPaidRequestInput = {
  /** Order ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1MarkOrderAsPaidResponse = {
  /** Updated order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1MarkOrderAsSeenByHumanRequestInput = {
  /** Order ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1MarkOrderAsSeenByHumanResponse = {
  /** Updated order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1MaskedOrderInput = {
  /** Field mask of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Order to be updated. */
  order?: InputMaybe<ComWixEcomOrdersV1OrderInput>;
};

export type ComWixEcomOrdersV1MaskedOrderLineItemInput = {
  /** Field mask of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Order line item to update */
  lineItem?: InputMaybe<ComWixEcomOrdersV1OrderLineItemInput>;
};

export type ComWixEcomOrdersV1MembershipPaymentRefund = {
  /** Membership ID */
  membershipId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1MembershipPaymentRefundInput = {
  /** Membership ID */
  membershipId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1MerchantComment = {
  /** Merchant comment message. */
  message?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1MerchantCommentInput = {
  /** Merchant comment message. */
  message?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1MerchantDiscount = {
  /** Discount amount. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Discount description as free text (optional). */
  description?: Maybe<Scalars['String']>;
  /**
   * Pre-defined discount reason (optional).
   * * `"ITEMS_EXCHANGE"` - exchange balance acquired as a result of items exchange.
   */
  discountReason?: Maybe<ComWixEcomOrdersV1MerchantDiscountDiscountReason>;
  /** Name for discount. */
  name?: Maybe<Scalars['String']>;
  /** Discount percentage. */
  percentage?: Maybe<Scalars['String']>;
};

export enum ComWixEcomOrdersV1MerchantDiscountDiscountReason {
  BILLING_ADJUSTMENT = 'BILLING_ADJUSTMENT',
  EXCHANGED_ITEMS = 'EXCHANGED_ITEMS',
  UNSPECIFIED = 'UNSPECIFIED'
}

export type ComWixEcomOrdersV1MerchantDiscountInput = {
  /** Discount amount. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Discount description as free text (optional). */
  description?: InputMaybe<Scalars['String']>;
  /**
   * Pre-defined discount reason (optional).
   * * `"ITEMS_EXCHANGE"` - exchange balance acquired as a result of items exchange.
   */
  discountReason?: InputMaybe<ComWixEcomOrdersV1MerchantDiscountDiscountReason>;
  /** Name for discount. */
  name?: InputMaybe<Scalars['String']>;
  /** Discount percentage. */
  percentage?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1ModifierGroup = {
  /** Modifier group ID. */
  id?: Maybe<Scalars['String']>;
  /** List of modifiers in this group. */
  modifiers?: Maybe<Array<Maybe<ComWixEcomOrdersV1ItemModifier>>>;
  /** Modifier group name. */
  name?: Maybe<ComWixEcommercePlatformCommonApiTranslatableString>;
};

export type ComWixEcomOrdersV1ModifierGroupInput = {
  /** Modifier group ID. */
  id?: InputMaybe<Scalars['String']>;
  /** List of modifiers in this group. */
  modifiers?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1ItemModifierInput>>>;
  /** Modifier group name. */
  name?: InputMaybe<ComWixEcommercePlatformCommonApiTranslatableStringInput>;
};

export type ComWixEcomOrdersV1NewExchangeOrderCreated = {
  /** ID of the new order created as a result of an exchange of items. */
  exchangeOrderId?: Maybe<Scalars['String']>;
  /** IDs of the items that were exchanged. */
  lineItems?: Maybe<Array<Maybe<ComWixEcomOrdersV1LineItemExchangeData>>>;
};

export type ComWixEcomOrdersV1NewExchangeOrderCreatedInput = {
  /** ID of the new order created as a result of an exchange of items. */
  exchangeOrderId?: InputMaybe<Scalars['String']>;
  /** IDs of the items that were exchanged. */
  lineItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1LineItemExchangeDataInput>>>;
};

export type ComWixEcomOrdersV1Order = {
  /** Order activities. */
  activities?: Maybe<Array<Maybe<ComWixEcomOrdersV1Activity>>>;
  /** Additional fees applied to the order. */
  additionalFees?: Maybe<Array<Maybe<ComWixEcomOrdersV1AdditionalFee>>>;
  /** Applied discounts. */
  appliedDiscounts?: Maybe<Array<Maybe<ComWixEcomOrdersV1AppliedDiscount>>>;
  /** Whether order is archived. */
  archived?: Maybe<Scalars['Boolean']>;
  /** Order attribution source. */
  attributionSource?: Maybe<ComWixEcomOrdersV1AttributionSourceEnumAttributionSource>;
  /** Balance summary. */
  balanceSummary?: Maybe<ComWixEcomOrdersV1BalanceSummary>;
  /** Billing address and contact details. */
  billingInfo?: Maybe<ComWixEcommercePlatformCommonApiAddressWithContact>;
  /** Order Location */
  businessLocation?: Maybe<ComWixEcommercePlatformCommonApiLocation>;
  /** Buyer information. */
  buyerInfo?: Maybe<ComWixEcomOrdersV1BuyerInfo>;
  /**
   * Language for communication with the buyer. Defaults to the site language.
   * For a site that supports multiple languages, this is the language the buyer selected.
   */
  buyerLanguage?: Maybe<Scalars['String']>;
  /** [Buyer note](https://support.wix.com/en/article/wix-stores-viewing-buyer-notes) left by the customer. */
  buyerNote?: Maybe<Scalars['String']>;
  /** Cart ID - required by TYP OOI for legacy orders. */
  cartId?: Maybe<Scalars['String']>;
  /** Information about the sales channel that submitted this order. */
  channelInfo?: Maybe<ComWixEcomOrdersV1ChannelInfo>;
  /** Checkout ID. */
  checkoutId?: Maybe<Scalars['String']>;
  /** ID of the order's initiator. */
  createdBy?: Maybe<ComWixEcomOrdersV1CreatedBy>;
  /** Date and time the order was created in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  createdDate?: Maybe<Scalars['String']>;
  /** Currency used for the pricing of this order in [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217#List_of_ISO_4217_currency_codes) format. */
  currency?: Maybe<Scalars['String']>;
  /** Currency conversion details. For use with multi-currency sites. */
  currencyConversionDetails?: Maybe<ComWixEcomOrdersV1CurrencyConversionDetails>;
  /** Custom fields. */
  customFields?: Maybe<Array<Maybe<ComWixEcomOrdersV1CustomField>>>;
  /** Deposit price summary. Part of price_summary that must be payed at checkout */
  deposit?: Maybe<ComWixEcomOrdersV1PriceSummary>;
  /**
   * Custom field data for the order object.
   *
   * [Extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields) must be configured in the app dashboard before they can be accessed with API calls.
   */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  externalEnrichedLineItemsForOrderPage?: Maybe<ComWixEcomLineItemsEnricherSpiHostApiV1EnrichLineItemsForOrderPageResponse>;
  externalEnrichedLineItemsForTYP?: Maybe<ComWixEcomLineItemsEnricherSpiHostApiV1EnrichLineItemsForThankYouPageResponse>;
  externalFulfillments?: Maybe<Array<Maybe<ComWixEcomOrdersFulfillmentsV1Fulfillment>>>;
  externalInvoices?: Maybe<Array<Maybe<ComWixEcomOrdersInvoicesV1Invoice>>>;
  externalOrderRefundability?: Maybe<ComWixEcomOrdersBillingV1GetOrderRefundabilityResponse>;
  externalPaymentCollectabilityStatus?: Maybe<ComWixEcomOrdersPaymentsCollectorV1GetPaymentCollectabilityStatusResponse>;
  externalRefundOptions?: Maybe<ComWixEcomOrdersBillingV1GetRefundOptionsResponse>;
  externalTransactions?: Maybe<ComWixEcomOrdersPaymentsV1ListTransactionsForSingleOrderResponse>;
  /** Order fulfillment status. */
  fulfillmentStatus?: Maybe<ComWixEcomOrdersV1FulfillmentStatus>;
  /** Custom string status values aggregated from every fulfillment entity associated with current order */
  fulfillmentStatusesAggregate?: Maybe<ComWixEcomOrdersV1FulfillmentStatusesAggregate>;
  /** Order ID. */
  id?: Maybe<Scalars['String']>;
  /** Private API flag that allows using read-only "id" during order creation. */
  isInternalOrderCreate?: Maybe<Scalars['Boolean']>;
  /** Order line items. */
  lineItems?: Maybe<Array<Maybe<ComWixEcomOrdersV1OrderLineItem>>>;
  /** Order number displayed in the site owner's dashboard (auto-generated). */
  number?: Maybe<Scalars['Long']>;
  orderTransactionsVirtualReference?: Maybe<ComWixEcomOrdersPaymentsV1QueryOrderTransactionsResponse>;
  /** Pay after free trial price summary. Price summary that should be paid for subscriptions after free trial period. */
  payAfterFreeTrial?: Maybe<ComWixEcomOrdersV1PriceSummary>;
  /**
   * Pay now price summary. Part of price_summary that must be payed at checkout
   * Deprecated. Use `deposit` instead.
   * This field will be removed on March 09, 2026.
   * @deprecated Pay now price summary. Part of price_summary that must be payed at checkout
   * Deprecated. Use `deposit` instead.
   * This field will be removed on March 09, 2026. Replaced by: deposit. Removal date: 2026-03-09.
   */
  payNow?: Maybe<ComWixEcomOrdersV1PriceSummary>;
  /** Order payment status. */
  paymentStatus?: Maybe<ComWixEcomOrdersV1PaymentStatusEnumPaymentStatus>;
  /** Order price summary. */
  priceSummary?: Maybe<ComWixEcomOrdersV1PriceSummary>;
  /** Persistent ID that correlates between the various eCommerce elements: cart, checkout, and order. */
  purchaseFlowId?: Maybe<Scalars['String']>;
  /**
   * Date and time the order was originally purchased in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format.
   * Used for migration from external systems.
   */
  purchasedDate?: Maybe<Scalars['String']>;
  /**
   * Order recipient address and contact details.
   *
   * This field may differ from the address in `shippingInfo.logistics` when:
   * + The chosen shipping option is pickup point or store pickup.
   * + No shipping option is selected.
   */
  recipientInfo?: Maybe<ComWixEcommercePlatformCommonApiAddressWithContact>;
  /** Whether a human has seen the order. Set when an order is clicked on in the dashboard. */
  seenByAHuman?: Maybe<Scalars['Boolean']>;
  /** Order-level settings and allowed actions. */
  settings?: Maybe<ComWixEcomOrdersV1OrderSettings>;
  /** Shipping info and selected shipping option details. */
  shippingInfo?: Maybe<ComWixEcomOrdersV1ShippingInformation>;
  /** Site language in which original values are shown. */
  siteLanguage?: Maybe<Scalars['String']>;
  /** Order status. */
  status?: Maybe<ComWixEcomOrdersV1OrderStatus>;
  /**
   * Order tags.
   *
   * [Tags](https://dev.wix.com/docs/rest/business-management/tags/introduction) are labels attached to entities, allowing for flexible categorization and data management.
   */
  tags?: Maybe<WixCommonTagsTags>;
  /** Whether tax is included in line item prices. */
  taxIncludedInPrices?: Maybe<Scalars['Boolean']>;
  /** Tax information. */
  taxInfo?: Maybe<ComWixEcomOrdersV1OrderTaxInfo>;
  /**
   * Tax summary.
   * Deprecated. Use `taxInfo` instead.
   * This field will be removed on September 30, 2024.
   * @deprecated Tax summary.
   * Deprecated. Use `taxInfo` instead.
   * This field will be removed on September 30, 2024. Replaced by: tax_info. Removal date: 2024-09-30.
   */
  taxSummary?: Maybe<ComWixEcomTaxApiTaxSummary>;
  /** Date and time the order was last updated in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  updatedDate?: Maybe<Scalars['String']>;
  /** Weight measurement unit - defaults to site's weight unit. */
  weightUnit?: Maybe<ComWixEcommercePlatformCommonApiWeightUnit>;
};


export type ComWixEcomOrdersV1OrderOrderTransactionsVirtualReferenceArgs = {
  queryInput?: InputMaybe<ComWixEcomOrdersPaymentsV1QueryOrderTransactionsRequestInput>;
};

export enum ComWixEcomOrdersV1OrderActionType {
  /** Allow add all types of activities on order */
  ADD_ACTIVITY = 'ADD_ACTIVITY',
  /** Allow add merchant activities on order */
  ADD_MERCHANT_ACTIVITY = 'ADD_MERCHANT_ACTIVITY',
  /** Allow mark order as approved */
  APPROVE = 'APPROVE',
  /** Allow assign tags on order */
  ASSIGN_TAG = 'ASSIGN_TAG',
  /** Allow cancel order */
  CANCEL = 'CANCEL',
  /** Allow to collect payment for order */
  COLLECT_PAYMENTS = 'COLLECT_PAYMENTS',
  /** Allow create invoice */
  CREATE_INVOICE = 'CREATE_INVOICE',
  /** Allow create receipts for order payments */
  CREATE_RECEIPTS = 'CREATE_RECEIPTS',
  /** Order is editable */
  EDIT = 'EDIT',
  /** Allow fulfill order */
  FULFILL = 'FULFILL',
  /** Allow to update inventory */
  MODIFY_INVENTORY = 'MODIFY_INVENTORY',
  /** Allow print packaging slip */
  PRINT_PACKAGING_SLIP = 'PRINT_PACKAGING_SLIP',
  /** Order is refundable */
  REFUND = 'REFUND',
  /** Allow send notifications for order */
  SEND_NOTIFICATIONS = 'SEND_NOTIFICATIONS',
  /** Order is updatable */
  UPDATE = 'UPDATE'
}

export enum ComWixEcomOrdersV1OrderApprovalStrategy {
  /** Order is automatically approved when `order.priceSummary.total = 0`, **or** after receiving payment. */
  DEFAULT = 'DEFAULT',
  /** Order is automatically approved when payment method is saved for it. */
  PAYMENT_METHOD_SAVED = 'PAYMENT_METHOD_SAVED',
  /** Order is automatically approved **only** after receiving payment. */
  PAYMENT_RECEIVED = 'PAYMENT_RECEIVED'
}

export type ComWixEcomOrdersV1OrderCreateNotificationsInput = {
  /**
   * Whether to send notification to the buyer.
   *
   * Default: `true`
   */
  sendNotificationToBuyer?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to send notifications to the business.
   *
   * Default: `true`
   */
  sendNotificationsToBusiness?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersV1OrderCreatedFromExchange = {
  /** ID of the original order for which the exchange happened. */
  originalOrderId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1OrderCreatedFromExchangeInput = {
  /** ID of the original order for which the exchange happened. */
  originalOrderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1OrderCreationSettingsInput = {
  /** Notification settings to be applied on order creation */
  notifications?: InputMaybe<ComWixEcomOrdersV1OrderCreateNotificationsInput>;
  /**
   * Condition for the order to be approved.
   * Default: `DEFAULT`
   */
  orderApprovalStrategy?: InputMaybe<ComWixEcomOrdersV1OrderApprovalStrategy>;
};

export type ComWixEcomOrdersV1OrderInput = {
  /** Order activities. */
  activities?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1ActivityInput>>>;
  /** Additional fees applied to the order. */
  additionalFees?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1AdditionalFeeInput>>>;
  /** Applied discounts. */
  appliedDiscounts?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1AppliedDiscountInput>>>;
  /** Whether order is archived. */
  archived?: InputMaybe<Scalars['Boolean']>;
  /** Order attribution source. */
  attributionSource?: InputMaybe<ComWixEcomOrdersV1AttributionSourceEnumAttributionSource>;
  /** Balance summary. */
  balanceSummary?: InputMaybe<ComWixEcomOrdersV1BalanceSummaryInput>;
  /** Billing address and contact details. */
  billingInfo?: InputMaybe<ComWixEcommercePlatformCommonApiAddressWithContactInput>;
  /** Order Location */
  businessLocation?: InputMaybe<ComWixEcommercePlatformCommonApiLocationInput>;
  /** Buyer information. */
  buyerInfo?: InputMaybe<ComWixEcomOrdersV1BuyerInfoInput>;
  /**
   * Language for communication with the buyer. Defaults to the site language.
   * For a site that supports multiple languages, this is the language the buyer selected.
   */
  buyerLanguage?: InputMaybe<Scalars['String']>;
  /** [Buyer note](https://support.wix.com/en/article/wix-stores-viewing-buyer-notes) left by the customer. */
  buyerNote?: InputMaybe<Scalars['String']>;
  /** Cart ID - required by TYP OOI for legacy orders. */
  cartId?: InputMaybe<Scalars['String']>;
  /** Information about the sales channel that submitted this order. */
  channelInfo?: InputMaybe<ComWixEcomOrdersV1ChannelInfoInput>;
  /** Checkout ID. */
  checkoutId?: InputMaybe<Scalars['String']>;
  /** ID of the order's initiator. */
  createdBy?: InputMaybe<ComWixEcomOrdersV1CreatedByInput>;
  /** Date and time the order was created in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Currency used for the pricing of this order in [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217#List_of_ISO_4217_currency_codes) format. */
  currency?: InputMaybe<Scalars['String']>;
  /** Currency conversion details. For use with multi-currency sites. */
  currencyConversionDetails?: InputMaybe<ComWixEcomOrdersV1CurrencyConversionDetailsInput>;
  /** Custom fields. */
  customFields?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1CustomFieldInput>>>;
  /** Deposit price summary. Part of price_summary that must be payed at checkout */
  deposit?: InputMaybe<ComWixEcomOrdersV1PriceSummaryInput>;
  /**
   * Custom field data for the order object.
   *
   * [Extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields) must be configured in the app dashboard before they can be accessed with API calls.
   */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** Order fulfillment status. */
  fulfillmentStatus?: InputMaybe<ComWixEcomOrdersV1FulfillmentStatus>;
  /** Custom string status values aggregated from every fulfillment entity associated with current order */
  fulfillmentStatusesAggregate?: InputMaybe<ComWixEcomOrdersV1FulfillmentStatusesAggregateInput>;
  /** Order ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Private API flag that allows using read-only "id" during order creation. */
  isInternalOrderCreate?: InputMaybe<Scalars['Boolean']>;
  /** Order line items. */
  lineItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1OrderLineItemInput>>>;
  /** Order number displayed in the site owner's dashboard (auto-generated). */
  number?: InputMaybe<Scalars['Long']>;
  /** Pay after free trial price summary. Price summary that should be paid for subscriptions after free trial period. */
  payAfterFreeTrial?: InputMaybe<ComWixEcomOrdersV1PriceSummaryInput>;
  /** Order payment status. */
  paymentStatus?: InputMaybe<ComWixEcomOrdersV1PaymentStatusEnumPaymentStatus>;
  /** Order price summary. */
  priceSummary?: InputMaybe<ComWixEcomOrdersV1PriceSummaryInput>;
  /** Persistent ID that correlates between the various eCommerce elements: cart, checkout, and order. */
  purchaseFlowId?: InputMaybe<Scalars['String']>;
  /**
   * Date and time the order was originally purchased in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format.
   * Used for migration from external systems.
   */
  purchasedDate?: InputMaybe<Scalars['String']>;
  /**
   * Order recipient address and contact details.
   *
   * This field may differ from the address in `shippingInfo.logistics` when:
   * + The chosen shipping option is pickup point or store pickup.
   * + No shipping option is selected.
   */
  recipientInfo?: InputMaybe<ComWixEcommercePlatformCommonApiAddressWithContactInput>;
  /** Whether a human has seen the order. Set when an order is clicked on in the dashboard. */
  seenByAHuman?: InputMaybe<Scalars['Boolean']>;
  /** Order-level settings and allowed actions. */
  settings?: InputMaybe<ComWixEcomOrdersV1OrderSettingsInput>;
  /** Shipping info and selected shipping option details. */
  shippingInfo?: InputMaybe<ComWixEcomOrdersV1ShippingInformationInput>;
  /** Site language in which original values are shown. */
  siteLanguage?: InputMaybe<Scalars['String']>;
  /** Order status. */
  status?: InputMaybe<ComWixEcomOrdersV1OrderStatus>;
  /**
   * Order tags.
   *
   * [Tags](https://dev.wix.com/docs/rest/business-management/tags/introduction) are labels attached to entities, allowing for flexible categorization and data management.
   */
  tags?: InputMaybe<WixCommonTagsTagsInput>;
  /** Whether tax is included in line item prices. */
  taxIncludedInPrices?: InputMaybe<Scalars['Boolean']>;
  /** Tax information. */
  taxInfo?: InputMaybe<ComWixEcomOrdersV1OrderTaxInfoInput>;
  /** Date and time the order was last updated in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format. */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** Weight measurement unit - defaults to site's weight unit. */
  weightUnit?: InputMaybe<ComWixEcommercePlatformCommonApiWeightUnit>;
};

export type ComWixEcomOrdersV1OrderLineItem = {
  /**
   * References to the line item's origin catalog.
   * This field may be empty in the case of a custom line item.
   */
  catalogReference?: Maybe<ComWixEcommerceCatalogSpiApiV1CatalogReference>;
  /** Whether the line item is a custom line item. Custom line items don't trigger the Catalog service plugin. */
  customLineItem?: Maybe<Scalars['Boolean']>;
  /** The Item's Delivery Profile Id */
  deliveryProfileId?: Maybe<Scalars['String']>;
  /** Item's price amount to be charged during checkout. Relevant for items with a `paymentOption` value of `"DEPOSIT_ONLINE"`. */
  depositAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Line item description lines. Used for display purposes for the cart, checkout and order. */
  descriptionLines?: Maybe<Array<Maybe<ComWixEcommerceCatalogSpiApiV1DescriptionLine>>>;
  /** Digital file identifier, relevant only for items with type DIGITAL. */
  digitalFile?: Maybe<ComWixEcomOrdersV1DigitalFile>;
  /**
   * Custom extended fields for the line item object.
   *
   * [Extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields) must be configured in the app dashboard before they can be accessed with API calls.
   */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** Line item ID in external systems. */
  externalLineItemId?: Maybe<Scalars['String']>;
  /**
   * Whether the line item quantity is fixed and cannot be changed.
   *
   * Default: `false`
   */
  fixedQuantity?: Maybe<Scalars['Boolean']>;
  /**
   * Fulfiller ID. Field is empty when the line item is self-fulfilled.
   * To get fulfillment information, pass the order ID to [List Fulfillments For Single Order](https://dev.wix.com/docs/rest/api-reference/wix-e-commerce/order-fulfillments/list-fulfillments-for-single-order).
   */
  fulfillerId?: Maybe<Scalars['String']>;
  /** Line item ID. */
  id?: Maybe<Scalars['String']>;
  /** Line item image. */
  image?: Maybe<WixCommonImage>;
  /** ID of the app managing the inventory. */
  inventoryAppId?: Maybe<Scalars['String']>;
  /** Item type. Either a preset type or custom. */
  itemType?: Maybe<ComWixEcommerceCatalogSpiApiV1ItemType>;
  /** Total price **after** catalog discounts and line item discounts. */
  lineItemPrice?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /**
   * Line item locations.
   *
   * The location's total quantity must not exceed the line item quantity.
   */
  locations?: Maybe<Array<Maybe<ComWixEcommercePlatformCommonApiLocationAndQuantity>>>;
  /** Modifier groups that were added to the item. */
  modifierGroups?: Maybe<Array<Maybe<ComWixEcomOrdersV1ModifierGroup>>>;
  /**
   * Type of selected payment option for current item.
   *
   * Default: `FULL_PAYMENT_ONLINE`
   */
  paymentOption?: Maybe<ComWixEcommerceCatalogSpiApiV1PaymentOptionType>;
  /** Physical properties of the item. When relevant, contains information such as SKU and item weight. */
  physicalProperties?: Maybe<ComWixEcommerceCatalogSpiApiV1PhysicalProperties>;
  /** Line item price after line item discounts for display purposes. */
  price?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Line item price before line item discounts for display purposes. Defaults to `price` when not provided. */
  priceBeforeDiscounts?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Line item price per unit before line item discounts and before tax. */
  priceBeforeDiscountsAndTax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Additional description for the price. For example, when price is 0 but additional details about the actual price are needed - "Starts at $67". */
  priceDescription?: Maybe<ComWixEcommerceCatalogSpiApiV1PriceDescription>;
  /**
   * Whether the price is not yet defined, and will be updated after the order is created.
   *
   * Default: `false`
   */
  priceUndetermined?: Maybe<Scalars['Boolean']>;
  /**
   * Item name.
   * + Stores - `product.name`
   * + Bookings - `service.info.name`
   * + Events - `ticket.name`
   */
  productName?: Maybe<ComWixEcommerceCatalogSpiApiV1ProductName>;
  /** Line item quantity. */
  quantity?: Maybe<Scalars['Int']>;
  /** Number of items that were refunded. */
  refundQuantity?: Maybe<Scalars['Int']>;
  /** Number of items restocked. */
  restockQuantity?: Maybe<Scalars['Int']>;
  /**
   * In cases where `catalogReference.catalogItemId` is NOT the actual catalog item ID, this field will return the true item's ID.
   * + For example, for Wix Bookings, `catalogReference.catalogItemId` is the booking ID. Therefore this value is set to the service ID.
   * + In most cases, this field has the same value as `catalogReference.catalogItemId`.
   */
  rootCatalogItemId?: Maybe<Scalars['String']>;
  shippingGroupId?: Maybe<Scalars['String']>;
  /** Subscription info. */
  subscriptionInfo?: Maybe<ComWixEcomOrdersV1SubscriptionInfo>;
  /**
   * Deprecated. Use `taxInfo` instead.
   * This field will be removed on September 30, 2024.
   * Tax details for this line item.
   * @deprecated Deprecated. Use `taxInfo` instead.
   * This field will be removed on September 30, 2024.
   * Tax details for this line item. Replaced by: tax_info. Removal date: 2024-09-30.
   */
  taxDetails?: Maybe<ComWixEcomTaxApiItemTaxFullDetails>;
  /** Represents all the relevant tax details for a specific line item. */
  taxInfo?: Maybe<ComWixEcomOrdersV1LineItemTaxInfo>;
  /** Address used for tax calculation. */
  taxableAddress?: Maybe<ComWixEcommercePlatformCommonApiTaxableAddress>;
  /** Total discount for this line item's entire quantity. */
  totalDiscount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total price after all discounts and tax. */
  totalPriceAfterTax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total price after discounts, and before tax. */
  totalPriceBeforeTax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersV1OrderLineItemChangedDetailsInput = {
  /**
   * References to the line item's origin catalog.
   * This field may be empty in the case of a custom line item.
   */
  catalogReference?: InputMaybe<ComWixEcommerceCatalogSpiApiV1CatalogReferenceInput>;
  /** Whether the line item is a custom line item. Custom line items don't trigger the Catalog service plugin. */
  customLineItem?: InputMaybe<Scalars['Boolean']>;
  /** Item's price amount to be charged during checkout. Relevant for items with a `paymentOption` value of `"DEPOSIT_ONLINE"`. */
  depositAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Line item description lines. Used for display purposes for the cart, checkout and order. */
  descriptionLines?: InputMaybe<Array<InputMaybe<ComWixEcommerceCatalogSpiApiV1DescriptionLineInput>>>;
  /** Digital file identifier, relevant only for items with type DIGITAL. */
  digitalFile?: InputMaybe<ComWixEcomOrdersV1DigitalFileInput>;
  /** Line item ID in external systems. */
  externalLineItemId?: InputMaybe<Scalars['String']>;
  /**
   * Fulfiller ID. Field is empty when the line item is self-fulfilled.
   * To get fulfillment information, pass this order's ID to [List Fulfillments For Single Order](https://bo.wix.com/wix-docs/rest/ecommerce/order-fulfillments/list-fulfillments-for-single-order).
   */
  fulfillerId?: InputMaybe<Scalars['String']>;
  /** Line item image. */
  image?: InputMaybe<WixCommonImageInput>;
  /** ID of the app managing the inventory. */
  inventoryAppId?: InputMaybe<Scalars['String']>;
  /** Item type. Either a preset type or custom. */
  itemType?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ItemTypeInput>;
  /** Total price **after** catalog-defined discount and line item discounts. */
  lineItemPrice?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /**
   * Line item locations.
   *
   * The location's total quantity must not exceed the line item quantity.
   */
  locations?: InputMaybe<Array<InputMaybe<ComWixEcommercePlatformCommonApiLocationAndQuantityInput>>>;
  /** Modifier groups that were added to the item. */
  modifierGroups?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1ModifierGroupInput>>>;
  /**
   * Type of selected payment option for current item. Defaults to `FULL_PAYMENT_ONLINE`.
   * + `FULL_PAYMENT_OFFLINE` - The entire payment for this item happens after the checkout. For example, when using cash, check, or other offline payment methods.
   * + `MEMBERSHIP` - Payment for this item is done by charging a membership. When this option is used, `lineItem.price.amount` is 0.
   */
  paymentOption?: InputMaybe<ComWixEcomOrdersV1DeltaPaymentOptionType>;
  /** Physical properties of the item. When relevant, contains information such as SKU and item weight. */
  physicalProperties?: InputMaybe<ComWixEcommerceCatalogSpiApiV1PhysicalPropertiesInput>;
  /** Line item price after line item discounts for display purposes. */
  price?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Line item price before line item discounts for display purposes. Defaults to `price` when not provided. */
  priceBeforeDiscounts?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Line item price per unit before line item discounts and before tax. */
  priceBeforeDiscountsAndTax?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Additional description for the price. For example, when price is 0 but additional details about the actual price are needed - "Starts at $67". */
  priceDescription?: InputMaybe<ComWixEcommerceCatalogSpiApiV1PriceDescriptionInput>;
  /**
   * Item name.
   * + Stores - `product.name`
   * + Bookings - `service.info.name`
   * + Events - `ticket.name`
   */
  productName?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ProductNameInput>;
  /** Line item quantity. */
  quantity?: InputMaybe<Scalars['Int']>;
  /** Subscription info. */
  subscriptionInfo?: InputMaybe<ComWixEcomOrdersV1SubscriptionInfoInput>;
  /** Represents all the relevant tax details for a specific line item. */
  taxInfo?: InputMaybe<ComWixEcomOrdersV1LineItemTaxInfoInput>;
  /** Total discount for this line item's entire quantity. */
  totalDiscount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Total price after all discounts and tax. */
  totalPriceAfterTax?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Total price after all discounts excluding tax. */
  totalPriceBeforeTax?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersV1OrderLineItemInput = {
  /**
   * References to the line item's origin catalog.
   * This field may be empty in the case of a custom line item.
   */
  catalogReference?: InputMaybe<ComWixEcommerceCatalogSpiApiV1CatalogReferenceInput>;
  /** Whether the line item is a custom line item. Custom line items don't trigger the Catalog service plugin. */
  customLineItem?: InputMaybe<Scalars['Boolean']>;
  /** The Item's Delivery Profile Id */
  deliveryProfileId?: InputMaybe<Scalars['String']>;
  /** Item's price amount to be charged during checkout. Relevant for items with a `paymentOption` value of `"DEPOSIT_ONLINE"`. */
  depositAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Line item description lines. Used for display purposes for the cart, checkout and order. */
  descriptionLines?: InputMaybe<Array<InputMaybe<ComWixEcommerceCatalogSpiApiV1DescriptionLineInput>>>;
  /** Digital file identifier, relevant only for items with type DIGITAL. */
  digitalFile?: InputMaybe<ComWixEcomOrdersV1DigitalFileInput>;
  /**
   * Custom extended fields for the line item object.
   *
   * [Extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields) must be configured in the app dashboard before they can be accessed with API calls.
   */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** Line item ID in external systems. */
  externalLineItemId?: InputMaybe<Scalars['String']>;
  /**
   * Whether the line item quantity is fixed and cannot be changed.
   *
   * Default: `false`
   */
  fixedQuantity?: InputMaybe<Scalars['Boolean']>;
  /**
   * Fulfiller ID. Field is empty when the line item is self-fulfilled.
   * To get fulfillment information, pass the order ID to [List Fulfillments For Single Order](https://dev.wix.com/docs/rest/api-reference/wix-e-commerce/order-fulfillments/list-fulfillments-for-single-order).
   */
  fulfillerId?: InputMaybe<Scalars['String']>;
  /** Line item ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Line item image. */
  image?: InputMaybe<WixCommonImageInput>;
  /** ID of the app managing the inventory. */
  inventoryAppId?: InputMaybe<Scalars['String']>;
  /** Item type. Either a preset type or custom. */
  itemType?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ItemTypeInput>;
  /** Total price **after** catalog discounts and line item discounts. */
  lineItemPrice?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /**
   * Line item locations.
   *
   * The location's total quantity must not exceed the line item quantity.
   */
  locations?: InputMaybe<Array<InputMaybe<ComWixEcommercePlatformCommonApiLocationAndQuantityInput>>>;
  /** Modifier groups that were added to the item. */
  modifierGroups?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1ModifierGroupInput>>>;
  /**
   * Type of selected payment option for current item.
   *
   * Default: `FULL_PAYMENT_ONLINE`
   */
  paymentOption?: InputMaybe<ComWixEcommerceCatalogSpiApiV1PaymentOptionType>;
  /** Physical properties of the item. When relevant, contains information such as SKU and item weight. */
  physicalProperties?: InputMaybe<ComWixEcommerceCatalogSpiApiV1PhysicalPropertiesInput>;
  /** Line item price after line item discounts for display purposes. */
  price?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Line item price before line item discounts for display purposes. Defaults to `price` when not provided. */
  priceBeforeDiscounts?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Line item price per unit before line item discounts and before tax. */
  priceBeforeDiscountsAndTax?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Additional description for the price. For example, when price is 0 but additional details about the actual price are needed - "Starts at $67". */
  priceDescription?: InputMaybe<ComWixEcommerceCatalogSpiApiV1PriceDescriptionInput>;
  /**
   * Whether the price is not yet defined, and will be updated after the order is created.
   *
   * Default: `false`
   */
  priceUndetermined?: InputMaybe<Scalars['Boolean']>;
  /**
   * Item name.
   * + Stores - `product.name`
   * + Bookings - `service.info.name`
   * + Events - `ticket.name`
   */
  productName?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ProductNameInput>;
  /** Line item quantity. */
  quantity?: InputMaybe<Scalars['Int']>;
  /** Number of items that were refunded. */
  refundQuantity?: InputMaybe<Scalars['Int']>;
  /** Number of items restocked. */
  restockQuantity?: InputMaybe<Scalars['Int']>;
  /**
   * In cases where `catalogReference.catalogItemId` is NOT the actual catalog item ID, this field will return the true item's ID.
   * + For example, for Wix Bookings, `catalogReference.catalogItemId` is the booking ID. Therefore this value is set to the service ID.
   * + In most cases, this field has the same value as `catalogReference.catalogItemId`.
   */
  rootCatalogItemId?: InputMaybe<Scalars['String']>;
  shippingGroupId?: InputMaybe<Scalars['String']>;
  /** Subscription info. */
  subscriptionInfo?: InputMaybe<ComWixEcomOrdersV1SubscriptionInfoInput>;
  /** Represents all the relevant tax details for a specific line item. */
  taxInfo?: InputMaybe<ComWixEcomOrdersV1LineItemTaxInfoInput>;
  /** Address used for tax calculation. */
  taxableAddress?: InputMaybe<ComWixEcommercePlatformCommonApiTaxableAddressInput>;
  /** Total discount for this line item's entire quantity. */
  totalDiscount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Total price after all discounts and tax. */
  totalPriceAfterTax?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Total price after discounts, and before tax. */
  totalPriceBeforeTax?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersV1OrderRefunded = {
  /** Refund amount. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Whether order was refunded manually. For example, via payment provider or using cash. */
  manual?: Maybe<Scalars['Boolean']>;
  /** Reason for refund. */
  reason?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1OrderRefundedInput = {
  /** Refund amount. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Whether order was refunded manually. For example, via payment provider or using cash. */
  manual?: InputMaybe<Scalars['Boolean']>;
  /** Reason for refund. */
  reason?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1OrderReindexRequestInput = {
  eventTime?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1OrderSettings = {
  /** Custom list of allowed actions for order. */
  customActions?: Maybe<ComWixEcomOrdersV1CustomAllowedActions>;
  /**
   * View only order with limited set of allowed actions:
   * 1. Add merchant activity
   * 2. Send order notifications
   * 3. Archiving order
   * 4. Assign tags on orders
   * 5. Export order
   * 6. Print order
   */
  limitedActions?: Maybe<Scalars['Boolean']>;
  /** Regular order with full set of allowed actions (ActionType for reference). */
  standardActions?: Maybe<Scalars['Boolean']>;
};

export type ComWixEcomOrdersV1OrderSettingsInput = {
  /** Custom list of allowed actions for order. */
  customActions?: InputMaybe<ComWixEcomOrdersV1CustomAllowedActionsInput>;
  /**
   * View only order with limited set of allowed actions:
   * 1. Add merchant activity
   * 2. Send order notifications
   * 3. Archiving order
   * 4. Assign tags on orders
   * 5. Export order
   * 6. Print order
   */
  limitedActions?: InputMaybe<Scalars['Boolean']>;
  /** Regular order with full set of allowed actions (ActionType for reference). */
  standardActions?: InputMaybe<Scalars['Boolean']>;
};

export enum ComWixEcomOrdersV1OrderStatus {
  /**
   * Order approved.
   *
   * This happens when either an online payment is received **or** when `order.priceSummary.total = 0` (a zero-total order).
   * Offline orders (cash payment) are automatically approved.
   */
  APPROVED = 'APPROVED',
  /** Order canceled by the user. */
  CANCELED = 'CANCELED',
  /** Order created, but not yet approved or canceled. */
  INITIALIZED = 'INITIALIZED',
  /** Order pending. */
  PENDING = 'PENDING',
  /**
   * Order rejected.
   *
   * This happens when pending payments fail.
   */
  REJECTED = 'REJECTED'
}

export type ComWixEcomOrdersV1OrderTaxBreakdown = {
  /** The aggregated exempt amount from all line items for tax identifiers. */
  aggregatedExemptAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** The sum of all the tax from line items that calculated by the tax identifiers. */
  aggregatedTaxAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** The sum of all the taxable amount from line items for tax identifiers. */
  aggregatedTaxableAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** The name of the jurisdiction in which this tax detail applies. */
  jurisdiction?: Maybe<Scalars['String']>;
  /** The type of the jurisdiction in which this tax detail applies (e.g. Country,State,County,City,Special). */
  jurisdictionType?: Maybe<ComWixEcomOrdersV1JurisdictionType>;
  /** The rate at which this tax detail was calculated. */
  rate?: Maybe<Scalars['String']>;
  /** The name of the tax against which this tax amount was calculated. */
  taxName?: Maybe<Scalars['String']>;
  /** The type of tax that was calculated. Depends on the company's nexus settings as well as the jurisdiction's tax laws. */
  taxType?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1OrderTaxBreakdownInput = {
  /** The aggregated exempt amount from all line items for tax identifiers. */
  aggregatedExemptAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** The sum of all the tax from line items that calculated by the tax identifiers. */
  aggregatedTaxAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** The sum of all the taxable amount from line items for tax identifiers. */
  aggregatedTaxableAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** The name of the jurisdiction in which this tax detail applies. */
  jurisdiction?: InputMaybe<Scalars['String']>;
  /** The type of the jurisdiction in which this tax detail applies (e.g. Country,State,County,City,Special). */
  jurisdictionType?: InputMaybe<ComWixEcomOrdersV1JurisdictionType>;
  /** The rate at which this tax detail was calculated. */
  rate?: InputMaybe<Scalars['String']>;
  /** The name of the tax against which this tax amount was calculated. */
  taxName?: InputMaybe<Scalars['String']>;
  /** The type of tax that was calculated. Depends on the company's nexus settings as well as the jurisdiction's tax laws. */
  taxType?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1OrderTaxInfo = {
  /** Manual tax rate */
  manualTaxRate?: Maybe<Scalars['String']>;
  /** The summary of the tax breakdown for all the line items. It will hold for each tax name, the aggregated tax amount paid for it and the tax rate. */
  taxBreakdown?: Maybe<Array<Maybe<ComWixEcomOrdersV1OrderTaxBreakdown>>>;
  /**
   * Whether the order is exempt from tax calculations.
   *
   * Default: `false`
   */
  taxExempt?: Maybe<Scalars['Boolean']>;
  /** The total amount that was exempt from tax calculations. */
  totalExempt?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Calculated tax, added from line items. */
  totalTax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersV1OrderTaxInfoInput = {
  /** Manual tax rate */
  manualTaxRate?: InputMaybe<Scalars['String']>;
  /** The summary of the tax breakdown for all the line items. It will hold for each tax name, the aggregated tax amount paid for it and the tax rate. */
  taxBreakdown?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1OrderTaxBreakdownInput>>>;
  /**
   * Whether the order is exempt from tax calculations.
   *
   * Default: `false`
   */
  taxExempt?: InputMaybe<Scalars['Boolean']>;
  /** The total amount that was exempt from tax calculations. */
  totalExempt?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Calculated tax, added from line items. */
  totalTax?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersV1PaymentCanceled = {
  /** Payment ID of payment associated with this activity */
  paymentId?: Maybe<Scalars['String']>;
  /** Regular payment. */
  regular?: Maybe<ComWixEcomOrdersV1RegularPayment>;
};

export type ComWixEcomOrdersV1PaymentCanceledInput = {
  /** Payment ID of payment associated with this activity */
  paymentId?: InputMaybe<Scalars['String']>;
  /** Regular payment. */
  regular?: InputMaybe<ComWixEcomOrdersV1RegularPaymentInput>;
};

export type ComWixEcomOrdersV1PaymentDeclined = {
  /** Payment ID of payment associated with this activity */
  paymentId?: Maybe<Scalars['String']>;
  /** Regular payment. */
  regular?: Maybe<ComWixEcomOrdersV1RegularPayment>;
};

export type ComWixEcomOrdersV1PaymentDeclinedInput = {
  /** Payment ID of payment associated with this activity */
  paymentId?: InputMaybe<Scalars['String']>;
  /** Regular payment. */
  regular?: InputMaybe<ComWixEcomOrdersV1RegularPaymentInput>;
};

export type ComWixEcomOrdersV1PaymentPending = {
  /** Payment ID of payment associated with this activity */
  paymentId?: Maybe<Scalars['String']>;
  /** Regular payment. */
  regular?: Maybe<ComWixEcomOrdersV1RegularPayment>;
};

export type ComWixEcomOrdersV1PaymentPendingInput = {
  /** Payment ID of payment associated with this activity */
  paymentId?: InputMaybe<Scalars['String']>;
  /** Regular payment. */
  regular?: InputMaybe<ComWixEcomOrdersV1RegularPaymentInput>;
};

export type ComWixEcomOrdersV1PaymentRefundFailed = {
  /** Details about the failed payment refund. */
  payment?: Maybe<ComWixEcomOrdersV1RefundedPayment>;
  /** Refund ID. */
  refundId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1PaymentRefundFailedInput = {
  /** Details about the failed payment refund. */
  payment?: InputMaybe<ComWixEcomOrdersV1RefundedPaymentInput>;
  /** Refund ID. */
  refundId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1PaymentRefunded = {
  /** Details about the refunded payment. */
  payment?: Maybe<ComWixEcomOrdersV1RefundedPayment>;
  /** Refund ID. */
  refundId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1PaymentRefundedInput = {
  /** Details about the refunded payment. */
  payment?: InputMaybe<ComWixEcomOrdersV1RefundedPaymentInput>;
  /** Refund ID. */
  refundId?: InputMaybe<Scalars['String']>;
};

export enum ComWixEcomOrdersV1PaymentStatusEnumPaymentStatus {
  /** One or more payments canceled. */
  CANCELED = 'CANCELED',
  /** One or more payments declined. */
  DECLINED = 'DECLINED',
  /** Order fully refunded. Refund amount equals total price. See `order.balanceSummary` for more details. */
  FULLY_REFUNDED = 'FULLY_REFUNDED',
  /**
   * `NOT_PAID` can apply to an order made online, but not yet paid. In such cases `order.status` will be `INITIALIZED`.
   * This status also applies when an offline order needs to be manually marked as paid. In such cases `order.status` will be `APPROVED`.
   */
  NOT_PAID = 'NOT_PAID',
  /** All required payments associated with this order are paid. */
  PAID = 'PAID',
  /** At least one payment received and approved, but it covers less than the order's total price. See `order.balanceSummary` for more details. */
  PARTIALLY_PAID = 'PARTIALLY_PAID',
  /** Order partially refunded, but the refunded amount is less than the order's total price. See `order.balanceSummary` for more details. */
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
  /**
   * All payments pending.
   *
   * This can happen with two-step payments, when a payment requires manual review, or when a payment is in progress and will be concluded shortly.
   * Learn more about [pending orders](https://support.wix.com/en/article/pending-orders).
   */
  PENDING = 'PENDING',
  /**
   * Payment received, but not yet confirmed by the payment provider.
   *
   * In most cases, when a payment provider is holding payment it's because setup hasn't been successfully completed by the merchant/site owner.
   * To solve this, the merchant/site owner should log in to the payment provider's dashboard and make sure their account is set up correctly, or contact their support for further assistance.
   */
  PENDING_MERCHANT = 'PENDING_MERCHANT',
  UNSPECIFIED = 'UNSPECIFIED'
}

export type ComWixEcomOrdersV1PaymentStatusUpdatedInput = {
  /** The order that was updated */
  order?: InputMaybe<ComWixEcomOrdersV1OrderInput>;
  /** The previous status (before the update) */
  previousPaymentStatus?: InputMaybe<ComWixEcomOrdersV1PaymentStatusEnumPaymentStatus>;
};

export type ComWixEcomOrdersV1PickupDetails = {
  /** Pickup address. */
  address?: Maybe<ComWixEcommercePlatformCommonApiPickupAddress>;
  /** Pickup method */
  pickupMethod?: Maybe<ComWixEcomOrdersV1PickupDetailsPickupMethod>;
};

export type ComWixEcomOrdersV1PickupDetailsInput = {
  /** Pickup address. */
  address?: InputMaybe<ComWixEcommercePlatformCommonApiPickupAddressInput>;
  /** Pickup method */
  pickupMethod?: InputMaybe<ComWixEcomOrdersV1PickupDetailsPickupMethod>;
};

export enum ComWixEcomOrdersV1PickupDetailsPickupMethod {
  PICKUP_POINT = 'PICKUP_POINT',
  STORE_PICKUP = 'STORE_PICKUP',
  UNKNOWN_METHOD = 'UNKNOWN_METHOD'
}

export type ComWixEcomOrdersV1PriceSummary = {
  /** Total calculated discount value. */
  discount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total shipping price, before discounts and before tax. */
  shipping?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Subtotal of all the line items, before discounts and before tax. */
  subtotal?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total tax on this order. */
  tax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Order’s total price after discounts and tax. */
  total?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total price of additional fees before tax. */
  totalAdditionalFees?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Deprecated - use `total` instead. */
  totalPrice?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Order's total price including gift card. */
  totalWithGiftCard?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Order's total price after without gift card. */
  totalWithoutGiftCard?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersV1PriceSummaryInput = {
  /** Total calculated discount value. */
  discount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Total shipping price, before discounts and before tax. */
  shipping?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Subtotal of all the line items, before discounts and before tax. */
  subtotal?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Total tax on this order. */
  tax?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Order’s total price after discounts and tax. */
  total?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Total price of additional fees before tax. */
  totalAdditionalFees?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Deprecated - use `total` instead. */
  totalPrice?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Order's total price including gift card. */
  totalWithGiftCard?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Order's total price after without gift card. */
  totalWithoutGiftCard?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersV1PublicActivityInput = {
  /** Custom activity details. */
  customActivity?: InputMaybe<ComWixEcomOrdersV1CustomActivityInput>;
  /** Merchant commment. */
  merchantComment?: InputMaybe<ComWixEcomOrdersV1MerchantCommentInput>;
};

export type ComWixEcomOrdersV1QueryOrderRequestInput = {
  /** Query options. */
  query?: InputMaybe<ComWixEcommerceCommonsApiPlatformQueryInput>;
};

export type ComWixEcomOrdersV1QueryOrderResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixEcomOrdersV1Order>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixEcomOrdersV1ReceiptCreated = {
  /** Receipt created by an external system. */
  externalReceipt?: Maybe<ComWixEcomOrdersV1ExternalReceipt>;
  /** Payment ID of payment associated with this activity */
  paymentId?: Maybe<Scalars['String']>;
  /** Receipt created by Wix */
  wixReceipt?: Maybe<ComWixEcomOrdersV1WixReceipt>;
};

export type ComWixEcomOrdersV1ReceiptCreatedInput = {
  /** Receipt created by an external system. */
  externalReceipt?: InputMaybe<ComWixEcomOrdersV1ExternalReceiptInput>;
  /** Payment ID of payment associated with this activity */
  paymentId?: InputMaybe<Scalars['String']>;
  /** Receipt created by Wix */
  wixReceipt?: InputMaybe<ComWixEcomOrdersV1WixReceiptInput>;
};

export type ComWixEcomOrdersV1ReceiptSent = {
  /** Receipt created by an external system. */
  externalReceipt?: Maybe<ComWixEcomOrdersV1ExternalReceipt>;
  /** Payment ID of payment associated with this activity */
  paymentId?: Maybe<Scalars['String']>;
  /** Receipt created by Wix */
  wixReceipt?: Maybe<ComWixEcomOrdersV1WixReceipt>;
};

export type ComWixEcomOrdersV1ReceiptSentInput = {
  /** Receipt created by an external system. */
  externalReceipt?: InputMaybe<ComWixEcomOrdersV1ExternalReceiptInput>;
  /** Payment ID of payment associated with this activity */
  paymentId?: InputMaybe<Scalars['String']>;
  /** Receipt created by Wix */
  wixReceipt?: InputMaybe<ComWixEcomOrdersV1WixReceiptInput>;
};

export type ComWixEcomOrdersV1RefundInitiated = {
  /** Refund amount. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Details about the payments being refunded. */
  payments?: Maybe<Array<Maybe<ComWixEcomOrdersV1RefundedPayment>>>;
  /** Reason for refund. */
  reason?: Maybe<Scalars['String']>;
  /** Refund ID. */
  refundId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1RefundInitiatedInput = {
  /** Refund amount. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Details about the payments being refunded. */
  payments?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1RefundedPaymentInput>>>;
  /** Reason for refund. */
  reason?: InputMaybe<Scalars['String']>;
  /** Refund ID. */
  refundId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1RefundedAsStoreCredit = {
  /** Refund amount */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Reason for refund */
  reason?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1RefundedAsStoreCreditInput = {
  /** Refund amount */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Reason for refund */
  reason?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1RefundedPayment = {
  /** Whether refund was made externally and manually on the payment provider's side. */
  externalRefund?: Maybe<Scalars['Boolean']>;
  /** Gift card payment refund. */
  giftCard?: Maybe<ComWixEcomOrdersV1GiftCardPaymentRefund>;
  /** Membership payment refund. */
  membership?: Maybe<ComWixEcomOrdersV1MembershipPaymentRefund>;
  /** Payment ID. */
  paymentId?: Maybe<Scalars['String']>;
  /** Regular payment refund. */
  regular?: Maybe<ComWixEcomOrdersV1RegularPaymentRefund>;
};

export type ComWixEcomOrdersV1RefundedPaymentInput = {
  /** Whether refund was made externally and manually on the payment provider's side. */
  externalRefund?: InputMaybe<Scalars['Boolean']>;
  /** Gift card payment refund. */
  giftCard?: InputMaybe<ComWixEcomOrdersV1GiftCardPaymentRefundInput>;
  /** Membership payment refund. */
  membership?: InputMaybe<ComWixEcomOrdersV1MembershipPaymentRefundInput>;
  /** Payment ID. */
  paymentId?: InputMaybe<Scalars['String']>;
  /** Regular payment refund. */
  regular?: InputMaybe<ComWixEcomOrdersV1RegularPaymentRefundInput>;
};

export type ComWixEcomOrdersV1RegularPayment = {
  /** Payment amount */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Whether regular card used */
  creditCardDetails?: Maybe<ComWixEcomOrdersV1CreditCardDetails>;
};

export type ComWixEcomOrdersV1RegularPaymentInput = {
  /** Payment amount */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Whether regular card used */
  creditCardDetails?: InputMaybe<ComWixEcomOrdersV1CreditCardDetailsInput>;
};

export type ComWixEcomOrdersV1RegularPaymentRefund = {
  /** Refund amount */
  amount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Card issuer's brand. */
  brand?: Maybe<Scalars['String']>;
  /** The last 4 digits of the card number. */
  lastFourDigits?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1RegularPaymentRefundInput = {
  /** Refund amount */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Card issuer's brand. */
  brand?: InputMaybe<Scalars['String']>;
  /** The last 4 digits of the card number. */
  lastFourDigits?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1SavedPaymentMethod = {
  /** Payment method description */
  description?: Maybe<Scalars['String']>;
  /** Payment method name */
  name?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1SavedPaymentMethodInput = {
  /** Payment method description */
  description?: InputMaybe<Scalars['String']>;
  /** Payment method name */
  name?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1SearchOrdersRequestInput = {
  /** Search options. */
  search?: InputMaybe<ComWixEcomOrdersV1UpstreamWixQueryCursorSearchInput>;
};

export type ComWixEcomOrdersV1SearchOrdersResponse = {
  /** Details on the paged set of results returned. */
  metadata?: Maybe<WixCommonCursorPagingMetadata>;
  /** List of orders. */
  orders?: Maybe<Array<Maybe<ComWixEcomOrdersV1Order>>>;
};

export type ComWixEcomOrdersV1ShippingInformation = {
  /** App Def Id of external provider which was a source of shipping info */
  carrierId?: Maybe<Scalars['String']>;
  /** Unique code (or ID) of selected shipping option. For example, `"usps_std_overnight"`. */
  code?: Maybe<Scalars['String']>;
  /** Shipping costs. */
  cost?: Maybe<ComWixEcomOrdersV1ShippingPrice>;
  /** Shipping logistics. */
  logistics?: Maybe<ComWixEcomOrdersV1DeliveryLogistics>;
  /** Shipping region. */
  region?: Maybe<ComWixEcomOrdersV1ShippingRegion>;
  /**
   * Shipping option title.
   * For example, `"USPS Standard Overnight Delivery"`, `"Standard"` or `"First-Class Package International"`.
   */
  title?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1ShippingInformationInput = {
  /** App Def Id of external provider which was a source of shipping info */
  carrierId?: InputMaybe<Scalars['String']>;
  /** Unique code (or ID) of selected shipping option. For example, `"usps_std_overnight"`. */
  code?: InputMaybe<Scalars['String']>;
  /** Shipping costs. */
  cost?: InputMaybe<ComWixEcomOrdersV1ShippingPriceInput>;
  /** Shipping logistics. */
  logistics?: InputMaybe<ComWixEcomOrdersV1DeliveryLogisticsInput>;
  /** Shipping region. */
  region?: InputMaybe<ComWixEcomOrdersV1ShippingRegionInput>;
  /**
   * Shipping option title.
   * For example, `"USPS Standard Overnight Delivery"`, `"Standard"` or `"First-Class Package International"`.
   */
  title?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1ShippingPrice = {
  /** Shipping discount before tax. */
  discount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Shipping price for display purposes. */
  price?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /**
   * Tax details.
   * @deprecated Tax details. Replaced by: tax_info. Removal date: 2026-03-30.
   */
  taxDetails?: Maybe<ComWixEcomTaxApiItemTaxFullDetails>;
  /** Represents all the relevant tax details for a shipping. */
  taxInfo?: Maybe<ComWixEcomOrdersV1LineItemTaxInfo>;
  /** Shipping price after all discounts (if any exist), and after tax. */
  totalPriceAfterTax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** Total price of shipping after discounts (when relevant), and before tax. */
  totalPriceBeforeTax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomOrdersV1ShippingPriceInput = {
  /** Shipping discount before tax. */
  discount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Shipping price for display purposes. */
  price?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Represents all the relevant tax details for a shipping. */
  taxInfo?: InputMaybe<ComWixEcomOrdersV1LineItemTaxInfoInput>;
  /** Shipping price after all discounts (if any exist), and after tax. */
  totalPriceAfterTax?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** Total price of shipping after discounts (when relevant), and before tax. */
  totalPriceBeforeTax?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomOrdersV1ShippingRegion = {
  /** Name of shipping region. For example, `"Metropolitan London"`, or `"Outer Melbourne suburbs"`. */
  name?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1ShippingRegionInput = {
  /** Name of shipping region. For example, `"Metropolitan London"`, or `"Outer Melbourne suburbs"`. */
  name?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1SubscriptionDescription = {
  /** Subscription option description. */
  original?: Maybe<Scalars['String']>;
  /** Translated subscription option description. */
  translated?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1SubscriptionDescriptionInput = {
  /** Subscription option description. */
  original?: InputMaybe<Scalars['String']>;
  /** Translated subscription option description. */
  translated?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1SubscriptionInfo = {
  /** Details of the billing adjustment applied to the current subscription cycle due to a shift in the subscription’s billing date. */
  billingAdjustment?: Maybe<ComWixEcomOrdersV1BillingAdjustment>;
  /** Description of the charges that will be applied for subscription. */
  chargesDescription?: Maybe<Scalars['String']>;
  /** Subscription cycle. For example, if this order is for the 3rd cycle of a subscription, value will be `3`. */
  cycleNumber?: Maybe<Scalars['Int']>;
  /** Subscription description. For example, `"1kg of selected coffee, once a month"`. */
  description?: Maybe<ComWixEcomOrdersV1SubscriptionDescription>;
  /** Subscription ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Subscription option description. For example, `"1kg of selected coffee, once a month"`.
   * @deprecated Subscription option description. For example, `"1kg of selected coffee, once a month"`. Replaced by: description. Removal date: 2025-10-01.
   */
  subscriptionOptionDescription?: Maybe<Scalars['String']>;
  /**
   * Subscription option title. For example, `"Monthly coffee Subscription"`.
   * @deprecated Subscription option title. For example, `"Monthly coffee Subscription"`. Replaced by: title. Removal date: 2025-10-01.
   */
  subscriptionOptionTitle?: Maybe<Scalars['String']>;
  /** Subscription detailed information. */
  subscriptionSettings?: Maybe<ComWixEcomOrdersV1SubscriptionSettings>;
  /** Subscription title. For example, `"Monthly coffee Subscription"`. */
  title?: Maybe<ComWixEcomOrdersV1SubscriptionTitle>;
};

export type ComWixEcomOrdersV1SubscriptionInfoInput = {
  /** Details of the billing adjustment applied to the current subscription cycle due to a shift in the subscription’s billing date. */
  billingAdjustment?: InputMaybe<ComWixEcomOrdersV1BillingAdjustmentInput>;
  /** Description of the charges that will be applied for subscription. */
  chargesDescription?: InputMaybe<Scalars['String']>;
  /** Subscription cycle. For example, if this order is for the 3rd cycle of a subscription, value will be `3`. */
  cycleNumber?: InputMaybe<Scalars['Int']>;
  /** Subscription description. For example, `"1kg of selected coffee, once a month"`. */
  description?: InputMaybe<ComWixEcomOrdersV1SubscriptionDescriptionInput>;
  /** Subscription ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Subscription detailed information. */
  subscriptionSettings?: InputMaybe<ComWixEcomOrdersV1SubscriptionSettingsInput>;
  /** Subscription title. For example, `"Monthly coffee Subscription"`. */
  title?: InputMaybe<ComWixEcomOrdersV1SubscriptionTitleInput>;
};

export type ComWixEcomOrdersV1SubscriptionSettings = {
  /** Whether subscription is renewed automatically at the end of each period. */
  autoRenewal?: Maybe<Scalars['Boolean']>;
  /** Number of billing cycles before subscription ends. Ignored if `autoRenewal: true`. */
  billingCycles?: Maybe<Scalars['Int']>;
  /** Whether to allow the customer to cancel the subscription. */
  enableCustomerCancellation?: Maybe<Scalars['Boolean']>;
  /** Period until first cycle starts. If None => no free trial */
  freeTrialPeriod?: Maybe<ComWixEcomOrdersV1FreeTrialPeriod>;
  /** Frequency of recurring payment. */
  frequency?: Maybe<WixPaymentApiPayV2SubscriptionFrequency>;
  /** Interval of recurring payment. */
  interval?: Maybe<Scalars['Int']>;
  /** The date the subscription will start. The subscription will be charged either now or according to freeTrialDays. */
  startDate?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1SubscriptionSettingsInput = {
  /** Whether subscription is renewed automatically at the end of each period. */
  autoRenewal?: InputMaybe<Scalars['Boolean']>;
  /** Number of billing cycles before subscription ends. Ignored if `autoRenewal: true`. */
  billingCycles?: InputMaybe<Scalars['Int']>;
  /** Whether to allow the customer to cancel the subscription. */
  enableCustomerCancellation?: InputMaybe<Scalars['Boolean']>;
  /** Period until first cycle starts. If None => no free trial */
  freeTrialPeriod?: InputMaybe<ComWixEcomOrdersV1FreeTrialPeriodInput>;
  /** Frequency of recurring payment. */
  frequency?: InputMaybe<WixPaymentApiPayV2SubscriptionFrequency>;
  /** Interval of recurring payment. */
  interval?: InputMaybe<Scalars['Int']>;
  /** The date the subscription will start. The subscription will be charged either now or according to freeTrialDays. */
  startDate?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1SubscriptionTitle = {
  /** Subscription option name in the site's default language as defined in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope). */
  original?: Maybe<Scalars['String']>;
  /**
   * Subscription option name translated into the buyer's language.
   *
   * Default: Same as `original`.
   */
  translated?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1SubscriptionTitleInput = {
  /** Subscription option name in the site's default language as defined in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope). */
  original?: InputMaybe<Scalars['String']>;
  /**
   * Subscription option name translated into the buyer's language.
   *
   * Default: Same as `original`.
   */
  translated?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1TranslatedValue = {
  /** Value in site default language. */
  original?: Maybe<Scalars['String']>;
  /** Translated value. */
  translated?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1TranslatedValueInput = {
  /** Value in site default language. */
  original?: InputMaybe<Scalars['String']>;
  /** Translated value. */
  translated?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1UnArchiveOrderRequestInput = {
  /** Order ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1UnArchiveOrderResponse = {
  /** Unarchived order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1UpdateActivityRequestInput = {
  /** Activity info. */
  activity?: InputMaybe<ComWixEcomOrdersV1PublicActivityInput>;
  /** ID of the activity to update. */
  activityId?: InputMaybe<Scalars['String']>;
  /** Order ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1UpdateActivityResponse = {
  /** Updated order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1UpdateBillingContactDetailsRequestInput = {
  /** Contact details. */
  addressContactDetails?: InputMaybe<ComWixEcommercePlatformCommonApiFullAddressContactDetailsInput>;
  /** mask of contact details fields to update */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Order ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1UpdateBillingContactDetailsResponse = {
  /** Updated order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1UpdateBuyerEmailRequestInput = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1UpdateBuyerEmailResponse = {
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1UpdateBuyerInfoRequestInput = {
  /** Buyer info. */
  buyerInfo?: InputMaybe<ComWixEcomOrdersV1BuyerInfoUpdateInput>;
  /** Field mask of buyerInfo fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Order ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1UpdateBuyerInfoResponse = {
  /** Updated order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1UpdateLineItemsDescriptionLinesRequestInput = {
  /** Order ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Line items. */
  lineItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1LineItemUpdateInput>>>;
};

export type ComWixEcomOrdersV1UpdateLineItemsDescriptionLinesResponse = {
  /** Updated order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1UpdateOrderLineItemRequestInput = {
  /** Field mask of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Order ID */
  id?: InputMaybe<Scalars['String']>;
  /** Order line item to update */
  lineItem?: InputMaybe<ComWixEcomOrdersV1OrderLineItemInput>;
};

export type ComWixEcomOrdersV1UpdateOrderLineItemResponse = {
  /** Updated order data */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1UpdateOrderLineItemsRequestInput = {
  /** Order line items to update */
  lineItems?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1MaskedOrderLineItemInput>>>;
  /** Order ID */
  orderId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1UpdateOrderLineItemsResponse = {
  /** Updated order data */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1UpdateOrderRequestInput = {
  /** Field mask of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Order to be updated. */
  order?: InputMaybe<ComWixEcomOrdersV1OrderInput>;
};

export type ComWixEcomOrdersV1UpdateOrderResponse = {
  /** Newly created order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1UpdateOrderShippingAddressRequestInput = {
  /** mask of shipping address fields to update */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Order ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Shipping address and contact details to be updated. */
  shippingAddress?: InputMaybe<ComWixEcommercePlatformCommonApiAddressWithContactInput>;
};

export type ComWixEcomOrdersV1UpdateOrderShippingAddressResponse = {
  /** Updated order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1UpdateOrderStatusRequestInput = {
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
  /** New order status. */
  status?: InputMaybe<ComWixEcomOrdersV1OrderStatus>;
};

export type ComWixEcomOrdersV1UpdateOrderStatusResponse = {
  /** Updated order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type ComWixEcomOrdersV1UpstreamWixQueryCursorSearchInput = {
  /**
   * Cursor paging options.
   *
   * Learn more about [cursor paging](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#cursor-paging).
   */
  cursorPaging?: InputMaybe<WixCommonCursorPagingInput>;
  /**
   * Filter object.
   *
   * Learn more about [filtering](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#filters).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * List of sort objects.
   *
   * Learn more about [sorting](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#sorting).
   */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type ComWixEcomOrdersV1WixReceipt = {
  /** Display number of receipt */
  displayNumber?: Maybe<Scalars['String']>;
  /** Receipt ID */
  receipt?: Maybe<WixReceiptsV1Receipt>;
  /** Receipt ID */
  receiptId?: Maybe<Scalars['String']>;
};

export type ComWixEcomOrdersV1WixReceiptInput = {
  /** Display number of receipt */
  displayNumber?: InputMaybe<Scalars['String']>;
  /** Receipt ID */
  receiptId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomTaxApiAutoTaxFallbackCalculationDetails = {
  /** invalid request (i.e. address), timeout, internal error, license error, and others will be encoded here */
  error?: Maybe<WixApiApplicationError>;
  /** reason for fallback */
  fallbackReason?: Maybe<ComWixEcomTaxApiAutoTaxFallbackCalculationDetailsFallbackReason>;
};

export enum ComWixEcomTaxApiAutoTaxFallbackCalculationDetailsFallbackReason {
  /** auto-tax was temporarily deactivated on a system-level */
  AUTO_TAX_DEACTIVATED = 'AUTO_TAX_DEACTIVATED',
  /** auto-tax failed to be calculated */
  AUTO_TAX_FAILED = 'AUTO_TAX_FAILED'
}

export type ComWixEcomTaxApiAutoTaxFallbackCalculationDetailsInput = {
  /** invalid request (i.e. address), timeout, internal error, license error, and others will be encoded here */
  error?: InputMaybe<WixApiApplicationErrorInput>;
  /** reason for fallback */
  fallbackReason?: InputMaybe<ComWixEcomTaxApiAutoTaxFallbackCalculationDetailsFallbackReason>;
};

export type ComWixEcomTaxApiItemTaxFullDetails = {
  /** Amount that was exempt from tax calculations. */
  exemptAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** ID of the item's tax group, if specified. */
  taxGroupId?: Maybe<Scalars['String']>;
  /** Tax rate percentage, as a decimal numeral between 0 and 1. For example, `"0.13"`. */
  taxRate?: Maybe<Scalars['String']>;
  /** Taxable amount of this line item. */
  taxableAmount?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
  /** The calculated tax, based on the `taxableAmount` and `taxRate`. */
  totalTax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomTaxApiItemTaxFullDetailsInput = {
  /** Amount that was exempt from tax calculations. */
  exemptAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** ID of the item's tax group, if specified. */
  taxGroupId?: InputMaybe<Scalars['String']>;
  /** Tax rate percentage, as a decimal numeral between 0 and 1. For example, `"0.13"`. */
  taxRate?: InputMaybe<Scalars['String']>;
  /** Taxable amount of this line item. */
  taxableAmount?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
  /** The calculated tax, based on the `taxableAmount` and `taxRate`. */
  totalTax?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export enum ComWixEcomTaxApiManualCalculationReason {
  /** user set calculator in Business Manager to be Manual */
  GLOBAL_SETTING_TO_MANUAL = 'GLOBAL_SETTING_TO_MANUAL',
  /** specific region is on manual even though Global setting is Auto-tax */
  REGION_SETTING_TO_MANUAL = 'REGION_SETTING_TO_MANUAL'
}

export enum ComWixEcomTaxApiRateType {
  /** autotax rate used for calculation */
  AUTO_RATE = 'AUTO_RATE',
  /** fallback rate used for calculation */
  FALLBACK_RATE = 'FALLBACK_RATE',
  /** manual rate used for calculation */
  MANUAL_RATE = 'MANUAL_RATE',
  /** no tax being collected for this request due to location of purchase */
  NO_TAX_COLLECTED = 'NO_TAX_COLLECTED'
}

export type ComWixEcomTaxApiTaxCalculationDetails = {
  /** Details of the fallback rate calculation. */
  autoTaxFallbackDetails?: Maybe<ComWixEcomTaxApiAutoTaxFallbackCalculationDetails>;
  /** Reason the manual calculation was used. */
  manualRateReason?: Maybe<ComWixEcomTaxApiManualCalculationReason>;
  /** Rate calculation type. */
  rateType?: Maybe<ComWixEcomTaxApiRateType>;
};

export type ComWixEcomTaxApiTaxCalculationDetailsInput = {
  /** Details of the fallback rate calculation. */
  autoTaxFallbackDetails?: InputMaybe<ComWixEcomTaxApiAutoTaxFallbackCalculationDetailsInput>;
  /** Reason the manual calculation was used. */
  manualRateReason?: InputMaybe<ComWixEcomTaxApiManualCalculationReason>;
  /** Rate calculation type. */
  rateType?: InputMaybe<ComWixEcomTaxApiRateType>;
};

export type ComWixEcomTaxApiTaxSummary = {
  /** manual tax rate */
  manualTaxRate?: Maybe<Scalars['String']>;
  /** Total tax. */
  totalTax?: Maybe<ComWixEcommercePlatformCommonApiPrice>;
};

export type ComWixEcomTaxApiTaxSummaryInput = {
  /** manual tax rate */
  manualTaxRate?: InputMaybe<Scalars['String']>;
  /** Total tax. */
  totalTax?: InputMaybe<ComWixEcommercePlatformCommonApiPriceInput>;
};

export type ComWixEcomTotalsCalculatorV1AdditionalFee = {
  /** Additional fee's unique code (or ID) for future processing. */
  code?: Maybe<Scalars['String']>;
  /**
   * Optional - Line items associated with this additional fee.
   * If no `lineItemIds` are provided, the fee will be associated with the whole cart/checkout/order.
   */
  lineItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Translated additional fee's name. */
  name?: Maybe<Scalars['String']>;
  /** Additional fee's price. */
  price?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Additional fee's price after tax. */
  priceAfterTax?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Additional fee's price before tax. */
  priceBeforeTax?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Provider's app id. */
  providerAppId?: Maybe<Scalars['String']>;
  /** the source the additional fee was added from */
  source?: Maybe<ComWixEcomTotalsCalculatorV1AdditionalFeeAdditionalFeeSource>;
  /**
   * Number of subscription cycle this fee applies to
   * default None - all billing cycle
   */
  subscriptionCycles?: Maybe<Scalars['Int']>;
  /** Tax details. */
  taxDetails?: Maybe<ComWixEcomTotalsCalculatorV1ItemTaxFullDetails>;
  /** The translated name of the additional fee. The translation language is determined by the `languages` field in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope). */
  translatedName?: Maybe<Scalars['String']>;
};

export enum ComWixEcomTotalsCalculatorV1AdditionalFeeAdditionalFeeSource {
  /** The additional fee was added on the item either via the catalog or on custom line item */
  ITEM = 'ITEM',
  /** The additional fee was added manually on the request */
  MANUAL = 'MANUAL',
  /** The additional fee was added by an additional fee service plugin */
  SERVICE_PLUGIN = 'SERVICE_PLUGIN',
  /** The additional fee was added by the shipping provider */
  SHIPPING = 'SHIPPING',
  UNKNOWN_ADDITIONAL_FEE_SOURCE = 'UNKNOWN_ADDITIONAL_FEE_SOURCE'
}

export type ComWixEcomTotalsCalculatorV1AdditionalFeeInput = {
  /** Additional fee's unique code (or ID) for future processing. */
  code?: InputMaybe<Scalars['String']>;
  /**
   * Optional - Line items associated with this additional fee.
   * If no `lineItemIds` are provided, the fee will be associated with the whole cart/checkout/order.
   */
  lineItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Translated additional fee's name. */
  name?: InputMaybe<Scalars['String']>;
  /** Additional fee's price. */
  price?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Additional fee's price after tax. */
  priceAfterTax?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Additional fee's price before tax. */
  priceBeforeTax?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Provider's app id. */
  providerAppId?: InputMaybe<Scalars['String']>;
  /** the source the additional fee was added from */
  source?: InputMaybe<ComWixEcomTotalsCalculatorV1AdditionalFeeAdditionalFeeSource>;
  /**
   * Number of subscription cycle this fee applies to
   * default None - all billing cycle
   */
  subscriptionCycles?: InputMaybe<Scalars['Int']>;
  /** Tax details. */
  taxDetails?: InputMaybe<ComWixEcomTotalsCalculatorV1ItemTaxFullDetailsInput>;
  /** The translated name of the additional fee. The translation language is determined by the `languages` field in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope). */
  translatedName?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1AggregatedTaxBreakdown = {
  /** The aggregated exempt amount from all line items for tax identifiers. */
  aggregatedExemptAmount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** The sum of all the tax from line items that calculated by the tax identifiers. */
  aggregatedTaxAmount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** The sum of all the taxable amount from line items for tax identifiers. */
  aggregatedTaxableAmount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** The name of the jurisdiction in which this tax detail applies. */
  jurisdiction?: Maybe<Scalars['String']>;
  /** The type of the jurisdiction in which this tax detail applies (e.g. Country,State,County,City,Special). */
  jurisdictionTypeEnum?: Maybe<ComWixEcomTotalsCalculatorV1JurisdictionType>;
  /** The rate at which this tax detail was calculated, e.g 0.1000 signifies 10% tax and 2.000 signifies 200% tax. (Decimal value) */
  rate?: Maybe<Scalars['String']>;
  /** The name of the tax against which this tax amount was calculated. */
  taxName?: Maybe<Scalars['String']>;
  /** The type of tax that was calculated. Depends on the company's nexus settings as well as the jurisdiction's tax laws. */
  taxType?: Maybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1AggregatedTaxBreakdownInput = {
  /** The aggregated exempt amount from all line items for tax identifiers. */
  aggregatedExemptAmount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** The sum of all the tax from line items that calculated by the tax identifiers. */
  aggregatedTaxAmount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** The sum of all the taxable amount from line items for tax identifiers. */
  aggregatedTaxableAmount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** The name of the jurisdiction in which this tax detail applies. */
  jurisdiction?: InputMaybe<Scalars['String']>;
  /** The type of the jurisdiction in which this tax detail applies (e.g. Country,State,County,City,Special). */
  jurisdictionTypeEnum?: InputMaybe<ComWixEcomTotalsCalculatorV1JurisdictionType>;
  /** The rate at which this tax detail was calculated, e.g 0.1000 signifies 10% tax and 2.000 signifies 200% tax. (Decimal value) */
  rate?: InputMaybe<Scalars['String']>;
  /** The name of the tax against which this tax amount was calculated. */
  taxName?: InputMaybe<Scalars['String']>;
  /** The type of tax that was calculated. Depends on the company's nexus settings as well as the jurisdiction's tax laws. */
  taxType?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1ApplicableLineItems = {
  /** Line items that the delivery solution is for. */
  lineItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixEcomTotalsCalculatorV1ApplicableLineItemsInput = {
  /** Line items that the delivery solution is for. */
  lineItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomTotalsCalculatorV1AppliedDiscount = {
  /** Coupon details. */
  coupon?: Maybe<ComWixEcomTotalsCalculatorV1Coupon>;
  /** Discount rule */
  discountRule?: Maybe<ComWixEcomTotalsCalculatorV1DiscountRule>;
  /** Discount type. */
  discountType?: Maybe<ComWixEcomTotalsCalculatorV1AppliedDiscountDiscountType>;
  /** Discount ID. */
  id?: Maybe<Scalars['String']>;
  /** Line items the discount applies to. */
  lineItemDiscounts?: Maybe<Array<Maybe<ComWixEcomTotalsCalculatorV1LineItemDiscount>>>;
  /**
   * IDs of line items the discount applies to.
   * @deprecated IDs of line items the discount applies to. Replaced by: line_items_discounts. Removal date: 2025-12-31.
   */
  lineItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Merchant discount. */
  merchantDiscount?: Maybe<ComWixEcomTotalsCalculatorV1MerchantDiscount>;
  /**
   * Number of subscription cycle this discount applies to
   * default None - all billing cycle
   */
  subscriptionCycles?: Maybe<Scalars['Int']>;
};

export enum ComWixEcomTotalsCalculatorV1AppliedDiscountDiscountType {
  GLOBAL = 'GLOBAL',
  SHIPPING = 'SHIPPING',
  SPECIFIC_ITEMS = 'SPECIFIC_ITEMS'
}

export type ComWixEcomTotalsCalculatorV1AppliedDiscountInput = {
  /** Coupon details. */
  coupon?: InputMaybe<ComWixEcomTotalsCalculatorV1CouponInput>;
  /** Discount rule */
  discountRule?: InputMaybe<ComWixEcomTotalsCalculatorV1DiscountRuleInput>;
  /** Discount type. */
  discountType?: InputMaybe<ComWixEcomTotalsCalculatorV1AppliedDiscountDiscountType>;
  /** Discount ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Line items the discount applies to. */
  lineItemDiscounts?: InputMaybe<Array<InputMaybe<ComWixEcomTotalsCalculatorV1LineItemDiscountInput>>>;
  /** Merchant discount. */
  merchantDiscount?: InputMaybe<ComWixEcomTotalsCalculatorV1MerchantDiscountInput>;
  /**
   * Number of subscription cycle this discount applies to
   * default None - all billing cycle
   */
  subscriptionCycles?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcomTotalsCalculatorV1CalculationErrors = {
  /** Carrier errors. */
  carrierErrors?: Maybe<ComWixEcomTotalsCalculatorV1CarrierErrors>;
  /** Coupon calculation error. */
  couponCalculationError?: Maybe<WixApiDetails>;
  /** Discount Rule calculation error. */
  discountsCalculationError?: Maybe<WixApiDetails>;
  /** General shipping calculation error. */
  generalShippingCalculationError?: Maybe<WixApiDetails>;
  /** Gift card calculation error. */
  giftCardCalculationError?: Maybe<WixApiDetails>;
  /**
   * Membership payment methods calculation errors
   * For example, will indicate that a line item that must be paid with membership payment doesn't have one or selected memberships are invalid
   */
  membershipError?: Maybe<WixApiDetails>;
  /** Order validation errors. */
  orderValidationErrors?: Maybe<Array<Maybe<WixApiApplicationError>>>;
  /** Tax calculation error. */
  taxCalculationError?: Maybe<WixApiDetails>;
};

export type ComWixEcomTotalsCalculatorV1CalculationErrorsInput = {
  /** Carrier errors. */
  carrierErrors?: InputMaybe<ComWixEcomTotalsCalculatorV1CarrierErrorsInput>;
  /** Coupon calculation error. */
  couponCalculationError?: InputMaybe<WixApiDetailsInput>;
  /** Discount Rule calculation error. */
  discountsCalculationError?: InputMaybe<WixApiDetailsInput>;
  /** General shipping calculation error. */
  generalShippingCalculationError?: InputMaybe<WixApiDetailsInput>;
  /** Gift card calculation error. */
  giftCardCalculationError?: InputMaybe<WixApiDetailsInput>;
  /**
   * Membership payment methods calculation errors
   * For example, will indicate that a line item that must be paid with membership payment doesn't have one or selected memberships are invalid
   */
  membershipError?: InputMaybe<WixApiDetailsInput>;
  /** Order validation errors. */
  orderValidationErrors?: InputMaybe<Array<InputMaybe<WixApiApplicationErrorInput>>>;
  /** Tax calculation error. */
  taxCalculationError?: InputMaybe<WixApiDetailsInput>;
};

export type ComWixEcomTotalsCalculatorV1Carrier = {
  /** The carrier app id */
  appId?: Maybe<Scalars['String']>;
  /** Unique code that acts as an ID for a shipping rate. For example, `"usps_std_overnight"`. */
  code?: Maybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1CarrierError = {
  /** Carrier ID. */
  carrierId?: Maybe<Scalars['String']>;
  /** Error details. */
  error?: Maybe<WixApiDetails>;
};

export type ComWixEcomTotalsCalculatorV1CarrierErrorInput = {
  /** Carrier ID. */
  carrierId?: InputMaybe<Scalars['String']>;
  /** Error details. */
  error?: InputMaybe<WixApiDetailsInput>;
};

export type ComWixEcomTotalsCalculatorV1CarrierErrors = {
  /** Carrier errors. */
  errors?: Maybe<Array<Maybe<ComWixEcomTotalsCalculatorV1CarrierError>>>;
};

export type ComWixEcomTotalsCalculatorV1CarrierErrorsInput = {
  /** Carrier errors. */
  errors?: InputMaybe<Array<InputMaybe<ComWixEcomTotalsCalculatorV1CarrierErrorInput>>>;
};

export type ComWixEcomTotalsCalculatorV1CarrierInput = {
  /** The carrier app id */
  appId?: InputMaybe<Scalars['String']>;
  /** Unique code that acts as an ID for a shipping rate. For example, `"usps_std_overnight"`. */
  code?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1CarrierServiceOption = {
  /** Carrier ID. */
  carrierId?: Maybe<Scalars['String']>;
  /** Shipping options offered by this carrier for this request. */
  shippingOptions?: Maybe<Array<Maybe<ComWixEcomTotalsCalculatorV1ShippingOption>>>;
};

export type ComWixEcomTotalsCalculatorV1CarrierServiceOptionInput = {
  /** Carrier ID. */
  carrierId?: InputMaybe<Scalars['String']>;
  /** Shipping options offered by this carrier for this request. */
  shippingOptions?: InputMaybe<Array<InputMaybe<ComWixEcomTotalsCalculatorV1ShippingOptionInput>>>;
};

export enum ComWixEcomTotalsCalculatorV1ChargeType {
  HANDLING_FEE = 'HANDLING_FEE',
  INSURANCE = 'INSURANCE'
}

export type ComWixEcomTotalsCalculatorV1Coupon = {
  /** Coupon value. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Coupon code. */
  code?: Maybe<Scalars['String']>;
  /** Coupon type: We want it to be an enum and not a string but currently we have no time to do it so we leave it as is to be aligned with cart summary. */
  couponType?: Maybe<Scalars['String']>;
  /** Coupon ID. */
  id?: Maybe<Scalars['String']>;
  /** Coupon name. */
  name?: Maybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1CouponInput = {
  /** Coupon value. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Coupon code. */
  code?: InputMaybe<Scalars['String']>;
  /** Coupon type: We want it to be an enum and not a string but currently we have no time to do it so we leave it as is to be aligned with cart summary. */
  couponType?: InputMaybe<Scalars['String']>;
  /** Coupon ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Coupon name. */
  name?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1DeliveryAllocation = {
  /** Populated if the delivery solution is a partially supplied by this carrier. */
  applicableLineItems?: Maybe<ComWixEcomTotalsCalculatorV1ApplicableLineItems>;
  /** The delivery option's carrier details, could be multiple if the delivery option is a combination of multiple carriers */
  deliveryCarrier?: Maybe<ComWixEcomTotalsCalculatorV1Carrier>;
  /** The delivery region that are relevant for this delivery solution. */
  deliveryRegion?: Maybe<ComWixEcomTotalsCalculatorV1Region>;
};

export type ComWixEcomTotalsCalculatorV1DeliveryAllocationInput = {
  /** Populated if the delivery solution is a partially supplied by this carrier. */
  applicableLineItems?: InputMaybe<ComWixEcomTotalsCalculatorV1ApplicableLineItemsInput>;
  /** The delivery option's carrier details, could be multiple if the delivery option is a combination of multiple carriers */
  deliveryCarrier?: InputMaybe<ComWixEcomTotalsCalculatorV1CarrierInput>;
  /** The delivery region that are relevant for this delivery solution. */
  deliveryRegion?: InputMaybe<ComWixEcomTotalsCalculatorV1RegionInput>;
};

export type ComWixEcomTotalsCalculatorV1DeliveryLogistics = {
  /** Expected delivery time, in free text. For example, "3-5 business days". */
  deliveryTime?: Maybe<Scalars['String']>;
  /** Expected delivery time slot (from and to time stamps representation) */
  deliveryTimeSlot?: Maybe<ComWixEcomTotalsCalculatorV1DeliveryTimeSlot>;
  /** Instructions for caller, e.g for pickup: "Please deliver during opening hours, and please don't park in disabled parking spot". */
  instructions?: Maybe<Scalars['String']>;
  /** Pickup details. */
  pickupDetails?: Maybe<ComWixEcomTotalsCalculatorV1PickupDetails>;
};

export type ComWixEcomTotalsCalculatorV1DeliveryLogisticsInput = {
  /** Expected delivery time, in free text. For example, "3-5 business days". */
  deliveryTime?: InputMaybe<Scalars['String']>;
  /** Expected delivery time slot (from and to time stamps representation) */
  deliveryTimeSlot?: InputMaybe<ComWixEcomTotalsCalculatorV1DeliveryTimeSlotInput>;
  /** Instructions for caller, e.g for pickup: "Please deliver during opening hours, and please don't park in disabled parking spot". */
  instructions?: InputMaybe<Scalars['String']>;
  /** Pickup details. */
  pickupDetails?: InputMaybe<ComWixEcomTotalsCalculatorV1PickupDetailsInput>;
};

export type ComWixEcomTotalsCalculatorV1DeliveryTimeSlot = {
  /** starting time of the delivery time slot */
  from?: Maybe<Scalars['String']>;
  /** ending time of the delivery time slot */
  to?: Maybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1DeliveryTimeSlotInput = {
  /** starting time of the delivery time slot */
  from?: InputMaybe<Scalars['String']>;
  /** ending time of the delivery time slot */
  to?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1DiscountRule = {
  /** Discount value. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Discount rule ID */
  discountRule?: Maybe<ComWixEcomDiscountsDiscountRule>;
  /** Discount rule ID */
  id?: Maybe<Scalars['String']>;
  /** Discount rule name */
  name?: Maybe<ComWixEcomTotalsCalculatorV1DiscountRuleName>;
};

export type ComWixEcomTotalsCalculatorV1DiscountRuleInput = {
  /** Discount value. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Discount rule ID */
  id?: InputMaybe<Scalars['String']>;
  /** Discount rule name */
  name?: InputMaybe<ComWixEcomTotalsCalculatorV1DiscountRuleNameInput>;
};

export type ComWixEcomTotalsCalculatorV1DiscountRuleName = {
  /** Original discount rule name (in site's default language). */
  original?: Maybe<Scalars['String']>;
  /** Translated discount rule name according to buyer language. Defaults to `original` when not provided. */
  translated?: Maybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1DiscountRuleNameInput = {
  /** Original discount rule name (in site's default language). */
  original?: InputMaybe<Scalars['String']>;
  /** Translated discount rule name according to buyer language. Defaults to `original` when not provided. */
  translated?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1GiftCard = {
  /** Actual amount to be redeemed from the gift card. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** App ID of the gift card provider. */
  appId?: Maybe<Scalars['String']>;
  /**
   * External ID in the gift card provider's system.
   * Used for integration and tracking across different platforms.
   */
  externalId?: Maybe<Scalars['String']>;
  /** Gift Card ID. */
  id?: Maybe<Scalars['String']>;
  /** Gift card obfuscated code. */
  obfuscatedCode?: Maybe<Scalars['String']>;
  /** Requested amount to redeem from the gift card. */
  requestedAmount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
};

export type ComWixEcomTotalsCalculatorV1GiftCardInput = {
  /** Actual amount to be redeemed from the gift card. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** App ID of the gift card provider. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * External ID in the gift card provider's system.
   * Used for integration and tracking across different platforms.
   */
  externalId?: InputMaybe<Scalars['String']>;
  /** Gift Card ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Gift card obfuscated code. */
  obfuscatedCode?: InputMaybe<Scalars['String']>;
  /** Requested amount to redeem from the gift card. */
  requestedAmount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
};

export type ComWixEcomTotalsCalculatorV1ItemTaxFullDetails = {
  /** The calculator that calculated this line tax */
  calculatorName?: Maybe<Scalars['String']>;
  /** The amount of this line item that was exempt. */
  exemptAmount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** True for items we have a tax applied on them */
  isItemTaxable?: Maybe<Scalars['Boolean']>;
  /** True if the lineAmount include tax in it. */
  isTaxIncluded?: Maybe<Scalars['Boolean']>;
  /** If breakdown exists, the sum of rates in the breakdown must equal `tax_rate`. Deprecated - use 'tax_breakdown' instead. */
  rateBreakdown?: Maybe<Array<Maybe<ComWixEcomTotalsCalculatorV1TaxRateBreakdown>>>;
  /** tax information for a line item. */
  taxBreakdown?: Maybe<Array<Maybe<ComWixEcomTotalsCalculatorV1TaxBreakdown>>>;
  /** Tax group ID, if specified. */
  taxGroupId?: Maybe<Scalars['String']>;
  /** Tax rate %, as a decimal point between 0 and 1. */
  taxRate?: Maybe<Scalars['String']>;
  /** Amount for which tax is calculated. */
  taxableAmount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Calculated tax, based on `taxable_amount` and `tax_rate`. */
  totalTax?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
};

export type ComWixEcomTotalsCalculatorV1ItemTaxFullDetailsInput = {
  /** The calculator that calculated this line tax */
  calculatorName?: InputMaybe<Scalars['String']>;
  /** The amount of this line item that was exempt. */
  exemptAmount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** True for items we have a tax applied on them */
  isItemTaxable?: InputMaybe<Scalars['Boolean']>;
  /** True if the lineAmount include tax in it. */
  isTaxIncluded?: InputMaybe<Scalars['Boolean']>;
  /** If breakdown exists, the sum of rates in the breakdown must equal `tax_rate`. Deprecated - use 'tax_breakdown' instead. */
  rateBreakdown?: InputMaybe<Array<InputMaybe<ComWixEcomTotalsCalculatorV1TaxRateBreakdownInput>>>;
  /** tax information for a line item. */
  taxBreakdown?: InputMaybe<Array<InputMaybe<ComWixEcomTotalsCalculatorV1TaxBreakdownInput>>>;
  /** Tax group ID, if specified. */
  taxGroupId?: InputMaybe<Scalars['String']>;
  /** Tax rate %, as a decimal point between 0 and 1. */
  taxRate?: InputMaybe<Scalars['String']>;
  /** Amount for which tax is calculated. */
  taxableAmount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Calculated tax, based on `taxable_amount` and `tax_rate`. */
  totalTax?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
};

export enum ComWixEcomTotalsCalculatorV1JurisdictionType {
  CITY = 'CITY',
  COUNTRY = 'COUNTRY',
  COUNTY = 'COUNTY',
  SPECIAL = 'SPECIAL',
  STATE = 'STATE',
  UNDEFINED = 'UNDEFINED'
}

export type ComWixEcomTotalsCalculatorV1LineItemDiscount = {
  /** ID of line item the discount applies to. */
  id?: Maybe<Scalars['String']>;
  /** Discount value. */
  totalDiscountAmount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
};

export type ComWixEcomTotalsCalculatorV1LineItemDiscountInput = {
  /** ID of line item the discount applies to. */
  id?: InputMaybe<Scalars['String']>;
  /** Discount value. */
  totalDiscountAmount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
};

export type ComWixEcomTotalsCalculatorV1MerchantDiscount = {
  /** Discount value. */
  amount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Discount Percentage. Will be calculated from items price before other discounts. */
  percentage?: Maybe<Scalars['Float']>;
};

export type ComWixEcomTotalsCalculatorV1MerchantDiscountInput = {
  /** Discount value. */
  amount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Discount Percentage. Will be calculated from items price before other discounts. */
  percentage?: InputMaybe<Scalars['Float']>;
};

export type ComWixEcomTotalsCalculatorV1MerchantDiscountInputInput = {
  /** Discount amount. */
  amount?: InputMaybe<Scalars['String']>;
  /** IDs of line items the discount applies to. */
  lineItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixEcomTotalsCalculatorV1OtherCharge = {
  /** Description of the additional charge. For example, `"Handling fee of $5 applied for gift wrapping"`. */
  details?: Maybe<Scalars['String']>;
  /** Price of added cost. */
  price?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Type of additional cost. */
  type?: Maybe<ComWixEcomTotalsCalculatorV1ChargeType>;
};

export type ComWixEcomTotalsCalculatorV1OtherChargeInput = {
  /** Description of the additional charge. For example, `"Handling fee of $5 applied for gift wrapping"`. */
  details?: InputMaybe<Scalars['String']>;
  /** Price of added cost. */
  price?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Type of additional cost. */
  type?: InputMaybe<ComWixEcomTotalsCalculatorV1ChargeType>;
};

export type ComWixEcomTotalsCalculatorV1PickupDetails = {
  /** Pickup address. */
  address?: Maybe<ComWixEcommercePlatformCommonApiAddress>;
  /** Whether the pickup address is that of a business - this may effect tax calculation. */
  businessLocation?: Maybe<Scalars['Boolean']>;
  /** Pickup method */
  pickupMethod?: Maybe<ComWixEcomTotalsCalculatorV1PickupDetailsPickupMethod>;
};

export type ComWixEcomTotalsCalculatorV1PickupDetailsInput = {
  /** Pickup address. */
  address?: InputMaybe<ComWixEcommercePlatformCommonApiAddressInput>;
  /** Whether the pickup address is that of a business - this may effect tax calculation. */
  businessLocation?: InputMaybe<Scalars['Boolean']>;
  /** Pickup method */
  pickupMethod?: InputMaybe<ComWixEcomTotalsCalculatorV1PickupDetailsPickupMethod>;
};

export enum ComWixEcomTotalsCalculatorV1PickupDetailsPickupMethod {
  PICKUP_POINT = 'PICKUP_POINT',
  STORE_PICKUP = 'STORE_PICKUP',
  UNKNOWN_METHOD = 'UNKNOWN_METHOD'
}

export type ComWixEcomTotalsCalculatorV1PriceSummary = {
  /** Total additional fees price before tax. */
  additionalFees?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Total calculated discount value. */
  discount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Total shipping price, before discounts and before tax. */
  shipping?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Subtotal of all line items, before discounts and before tax. */
  subtotal?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Total tax. */
  tax?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Total price after discounts, gift cards, and tax. */
  total?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
};

export type ComWixEcomTotalsCalculatorV1PriceSummaryInput = {
  /** Total additional fees price before tax. */
  additionalFees?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Total calculated discount value. */
  discount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Total shipping price, before discounts and before tax. */
  shipping?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Subtotal of all line items, before discounts and before tax. */
  subtotal?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Total tax. */
  tax?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Total price after discounts, gift cards, and tax. */
  total?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
};

export type ComWixEcomTotalsCalculatorV1Region = {
  /** The delivery region id. */
  id?: Maybe<Scalars['String']>;
  /** The delivery region name. */
  name?: Maybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1RegionInput = {
  /** The delivery region id. */
  id?: InputMaybe<Scalars['String']>;
  /** The delivery region name. */
  name?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOption = {
  /** This carrier's unique ID */
  carrierId?: Maybe<Scalars['String']>;
  /** Unique identifier of selected option. For example, "usps_std_overnight". */
  code?: Maybe<Scalars['String']>;
  /** Shipping costs. */
  cost?: Maybe<ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPrices>;
  /** Delivery solution allocations to different delivery carriers and delivery regions */
  deliveryAllocations?: Maybe<Array<Maybe<ComWixEcomTotalsCalculatorV1DeliveryAllocation>>>;
  /** Delivery logistics. */
  logistics?: Maybe<ComWixEcomTotalsCalculatorV1DeliveryLogistics>;
  /**
   * Other charges
   * @deprecated Other charges. Replaced by: additional_fees. Removal date: 2025-10-01.
   */
  otherCharges?: Maybe<Array<Maybe<ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionOtherCharge>>>;
  /** If the delivery solution is a partial and doesn't apply to all items. */
  partial?: Maybe<Scalars['Boolean']>;
  /** Were we able to find the requested shipping option, or otherwise we fallback to the default one (the first) */
  requestedShippingOption?: Maybe<Scalars['Boolean']>;
  /**
   * Title of the option, such as USPS Standard Overnight Delivery (in the requested locale).
   * For example, "Standard" or "First-Class Package International".
   */
  title?: Maybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionInput = {
  /** This carrier's unique ID */
  carrierId?: InputMaybe<Scalars['String']>;
  /** Unique identifier of selected option. For example, "usps_std_overnight". */
  code?: InputMaybe<Scalars['String']>;
  /** Shipping costs. */
  cost?: InputMaybe<ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPricesInput>;
  /** Delivery solution allocations to different delivery carriers and delivery regions */
  deliveryAllocations?: InputMaybe<Array<InputMaybe<ComWixEcomTotalsCalculatorV1DeliveryAllocationInput>>>;
  /** Delivery logistics. */
  logistics?: InputMaybe<ComWixEcomTotalsCalculatorV1DeliveryLogisticsInput>;
  /** If the delivery solution is a partial and doesn't apply to all items. */
  partial?: InputMaybe<Scalars['Boolean']>;
  /** Were we able to find the requested shipping option, or otherwise we fallback to the default one (the first) */
  requestedShippingOption?: InputMaybe<Scalars['Boolean']>;
  /**
   * Title of the option, such as USPS Standard Overnight Delivery (in the requested locale).
   * For example, "Standard" or "First-Class Package International".
   */
  title?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionOtherCharge = {
  /** Price of added charge. */
  cost?: Maybe<ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPrices>;
  /** Details of the charge, such as 'Full Coverage Insurance of up to 80% of value of shipment'. */
  details?: Maybe<Scalars['String']>;
  /** Type of additional cost. */
  type?: Maybe<ComWixEcomTotalsCalculatorV1ChargeType>;
};

export type ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionOtherChargeInput = {
  /** Price of added charge. */
  cost?: InputMaybe<ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPricesInput>;
  /** Details of the charge, such as 'Full Coverage Insurance of up to 80% of value of shipment'. */
  details?: InputMaybe<Scalars['String']>;
  /** Type of additional cost. */
  type?: InputMaybe<ComWixEcomTotalsCalculatorV1ChargeType>;
};

export type ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPrices = {
  /** Shipping price before discount and before tax. */
  price?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Tax details. */
  taxDetails?: Maybe<ComWixEcomTotalsCalculatorV1ItemTaxFullDetails>;
  /** Shipping discount before tax. */
  totalDiscount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Total shipping price, after discount and after tax. */
  totalPriceAfterTax?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Total price of shipping after discounts (when relevant), and before tax. */
  totalPriceBeforeTax?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
};

export type ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPricesInput = {
  /** Shipping price before discount and before tax. */
  price?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Tax details. */
  taxDetails?: InputMaybe<ComWixEcomTotalsCalculatorV1ItemTaxFullDetailsInput>;
  /** Shipping discount before tax. */
  totalDiscount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Total shipping price, after discount and after tax. */
  totalPriceAfterTax?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Total price of shipping after discounts (when relevant), and before tax. */
  totalPriceBeforeTax?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
};

export type ComWixEcomTotalsCalculatorV1ShippingOption = {
  /**
   * Unique code of provided shipping option like "usps_std_overnight".
   * For legacy calculators this would be the UUID of the option.
   */
  code?: Maybe<Scalars['String']>;
  /** Sipping price information. */
  cost?: Maybe<ComWixEcomTotalsCalculatorV1ShippingPrice>;
  /** Delivery solution allocations to different delivery carriers and delivery regions */
  deliveryAllocations?: Maybe<Array<Maybe<ComWixEcomTotalsCalculatorV1DeliveryAllocation>>>;
  /** Delivery logistics. */
  logistics?: Maybe<ComWixEcomTotalsCalculatorV1DeliveryLogistics>;
  /** If the delivery solution is a partial and doesn't apply to all items. */
  partial?: Maybe<Scalars['Boolean']>;
  /**
   * Title of the option, such as USPS Standard Overnight Delivery (in the requested locale).
   * For example, "Standard" or "First-Class Package International".
   */
  title?: Maybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1ShippingOptionInput = {
  /**
   * Unique code of provided shipping option like "usps_std_overnight".
   * For legacy calculators this would be the UUID of the option.
   */
  code?: InputMaybe<Scalars['String']>;
  /** Sipping price information. */
  cost?: InputMaybe<ComWixEcomTotalsCalculatorV1ShippingPriceInput>;
  /** Delivery solution allocations to different delivery carriers and delivery regions */
  deliveryAllocations?: InputMaybe<Array<InputMaybe<ComWixEcomTotalsCalculatorV1DeliveryAllocationInput>>>;
  /** Delivery logistics. */
  logistics?: InputMaybe<ComWixEcomTotalsCalculatorV1DeliveryLogisticsInput>;
  /** If the delivery solution is a partial and doesn't apply to all items. */
  partial?: InputMaybe<Scalars['Boolean']>;
  /**
   * Title of the option, such as USPS Standard Overnight Delivery (in the requested locale).
   * For example, "Standard" or "First-Class Package International".
   */
  title?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1ShippingPrice = {
  /** Other costs such as insurance, handling & packaging for fragile items, etc. */
  otherCharges?: Maybe<Array<Maybe<ComWixEcomTotalsCalculatorV1OtherCharge>>>;
  /** Shipping price. */
  price?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
};

export type ComWixEcomTotalsCalculatorV1ShippingPriceInput = {
  /** Other costs such as insurance, handling & packaging for fragile items, etc. */
  otherCharges?: InputMaybe<Array<InputMaybe<ComWixEcomTotalsCalculatorV1OtherChargeInput>>>;
  /** Shipping price. */
  price?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
};

export type ComWixEcomTotalsCalculatorV1ShippingRegion = {
  /** Shipping region ID. */
  id?: Maybe<Scalars['String']>;
  /** Shipping region name. */
  name?: Maybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1ShippingRegionInput = {
  /** Shipping region ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Shipping region name. */
  name?: InputMaybe<Scalars['String']>;
};

export type ComWixEcomTotalsCalculatorV1TaxBreakdown = {
  /** The amount of this line item that was exempt from this authority. */
  exemptAmount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** The name of the jurisdiction to which this tax detail applies. For example, "New York" or "Quebec". */
  jurisdiction?: Maybe<Scalars['String']>;
  /** The type of the jurisdiction in which this tax detail applies. */
  jurisdictionType?: Maybe<ComWixEcomTotalsCalculatorV1JurisdictionType>;
  /** The amount of this line item price that was considered nontaxable. (Decimal value) */
  nonTaxableAmount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** The rate at which this tax detail was calculated, e.g 0.1000 signifies 10% tax and 2.0000 signifies 200% tax. (Decimal value) */
  rate?: Maybe<Scalars['String']>;
  /** The amount of tax estimated for this line item. (Decimal value) */
  taxAmount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /**
   * The name of the tax against which this tax amount was calculated. For example, "NY State Sales Tax", "Quebec GST", etc.
   * This name should be explicit enough to allow the merchant to understand what tax was calculated.
   */
  taxName?: Maybe<Scalars['String']>;
  /** The type of tax that was calculated. Depends on the jurisdiction's tax laws. For example, "Sales Tax", "Income Tax", "Value Added Tax", etc. */
  taxType?: Maybe<Scalars['String']>;
  /** The taxable amount of this line item. */
  taxableAmount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
};

export type ComWixEcomTotalsCalculatorV1TaxBreakdownInput = {
  /** The amount of this line item that was exempt from this authority. */
  exemptAmount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** The name of the jurisdiction to which this tax detail applies. For example, "New York" or "Quebec". */
  jurisdiction?: InputMaybe<Scalars['String']>;
  /** The type of the jurisdiction in which this tax detail applies. */
  jurisdictionType?: InputMaybe<ComWixEcomTotalsCalculatorV1JurisdictionType>;
  /** The amount of this line item price that was considered nontaxable. (Decimal value) */
  nonTaxableAmount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** The rate at which this tax detail was calculated, e.g 0.1000 signifies 10% tax and 2.0000 signifies 200% tax. (Decimal value) */
  rate?: InputMaybe<Scalars['String']>;
  /** The amount of tax estimated for this line item. (Decimal value) */
  taxAmount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /**
   * The name of the tax against which this tax amount was calculated. For example, "NY State Sales Tax", "Quebec GST", etc.
   * This name should be explicit enough to allow the merchant to understand what tax was calculated.
   */
  taxName?: InputMaybe<Scalars['String']>;
  /** The type of tax that was calculated. Depends on the jurisdiction's tax laws. For example, "Sales Tax", "Income Tax", "Value Added Tax", etc. */
  taxType?: InputMaybe<Scalars['String']>;
  /** The taxable amount of this line item. */
  taxableAmount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
};

export type ComWixEcomTotalsCalculatorV1TaxRateBreakdown = {
  /** The amount of this line item that was exempt from this authority. */
  exemptAmount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** ids of the used exemptions from the TaxEstimate exemptions array. */
  exemptionIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** The Taxes/Fee component. True if the fee is applied. */
  isFee?: Maybe<Scalars['Boolean']>;
  /** The name of the jurisdiction in which this tax detail applies */
  jurisdiction?: Maybe<Scalars['String']>;
  /** The type of the jurisdiction in which this tax detail applies(Country,State,County,City,Special). */
  jurisdictionType?: Maybe<Scalars['String']>;
  /** Name of tax against which the calculation was performed. */
  name?: Maybe<Scalars['String']>;
  /** Rate at which this tax detail was calculated. */
  rate?: Maybe<Scalars['String']>;
  /** Amount of tax for this tax detail. */
  tax?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** The type of tax that was calculated */
  taxType?: Maybe<Scalars['String']>;
  /** The taxable amount of this tax detail */
  taxableAmount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
};

export type ComWixEcomTotalsCalculatorV1TaxRateBreakdownInput = {
  /** The amount of this line item that was exempt from this authority. */
  exemptAmount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** ids of the used exemptions from the TaxEstimate exemptions array. */
  exemptionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** The Taxes/Fee component. True if the fee is applied. */
  isFee?: InputMaybe<Scalars['Boolean']>;
  /** The name of the jurisdiction in which this tax detail applies */
  jurisdiction?: InputMaybe<Scalars['String']>;
  /** The type of the jurisdiction in which this tax detail applies(Country,State,County,City,Special). */
  jurisdictionType?: InputMaybe<Scalars['String']>;
  /** Name of tax against which the calculation was performed. */
  name?: InputMaybe<Scalars['String']>;
  /** Rate at which this tax detail was calculated. */
  rate?: InputMaybe<Scalars['String']>;
  /** Amount of tax for this tax detail. */
  tax?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** The type of tax that was calculated */
  taxType?: InputMaybe<Scalars['String']>;
  /** The taxable amount of this tax detail */
  taxableAmount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
};

export type ComWixEcomTotalsCalculatorV1TaxSummary = {
  /** The summary of the tax breakdown for all the line items. It will hold for each tax name, the aggregated tax amount paid for it and the tax rate. */
  aggregatedTaxBreakdown?: Maybe<Array<Maybe<ComWixEcomTotalsCalculatorV1AggregatedTaxBreakdown>>>;
  /** Average Tax Rate */
  averageTaxRate?: Maybe<Scalars['String']>;
  /** Tax calculator that was active when the order was created. */
  calculationDetails?: Maybe<ComWixEcomTaxApiTaxCalculationDetails>;
  /** Manual tax rate */
  manualTaxRate?: Maybe<Scalars['String']>;
  /** Tax estimation id in tax service */
  taxEstimationId?: Maybe<Scalars['String']>;
  /** Default name of the tax that was calculated. */
  taxName?: Maybe<Scalars['String']>;
  /** Amount for which tax is calculated, added from line items. */
  taxableAmount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** The amount of this estimate that was exempt (for all line items). */
  totalExempt?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Calculated tax, added from line items. */
  totalTax?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
};

export type ComWixEcomTotalsCalculatorV1TaxSummaryInput = {
  /** The summary of the tax breakdown for all the line items. It will hold for each tax name, the aggregated tax amount paid for it and the tax rate. */
  aggregatedTaxBreakdown?: InputMaybe<Array<InputMaybe<ComWixEcomTotalsCalculatorV1AggregatedTaxBreakdownInput>>>;
  /** Average Tax Rate */
  averageTaxRate?: InputMaybe<Scalars['String']>;
  /** Tax calculator that was active when the order was created. */
  calculationDetails?: InputMaybe<ComWixEcomTaxApiTaxCalculationDetailsInput>;
  /** Manual tax rate */
  manualTaxRate?: InputMaybe<Scalars['String']>;
  /** Tax estimation id in tax service */
  taxEstimationId?: InputMaybe<Scalars['String']>;
  /** Default name of the tax that was calculated. */
  taxName?: InputMaybe<Scalars['String']>;
  /** Amount for which tax is calculated, added from line items. */
  taxableAmount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** The amount of this estimate that was exempt (for all line items). */
  totalExempt?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Calculated tax, added from line items. */
  totalTax?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
};

export type ComWixEcommerceCatalogSpiApiV1CatalogReference = {
  /**
   * ID of the app providing the catalog.
   *
   * You can get your app's ID from its page in the [app dashboard](https://dev.wix.com/dc3/my-apps/).
   *
   * For items from Wix catalogs, the following values always apply:
   * + Wix Stores: `"215238eb-22a5-4c36-9e7b-e7c08025e04e"`
   * + Wix Bookings: `"13d21c63-b5ec-5912-8397-c3a5ddb27a97"`
   * + Wix Restaurants: `"9a5d83fd-8570-482e-81ab-cfa88942ee60"`
   */
  appId?: Maybe<Scalars['String']>;
  /** ID of the item within the catalog it belongs to. */
  catalogItemId?: Maybe<Scalars['String']>;
  /**
   * Additional item details in key:value pairs. Use this optional field to provide more specificity with item selection. The `options` field values differ depending on which catalog is providing the items.
   *
   * For products and variants from a Wix Stores catalog, learn more about [eCommerce integration](https://dev.wix.com/docs/rest/business-solutions/stores/catalog/e-commerce-integration).
   */
  options?: Maybe<Scalars['JSON']>;
};

export type ComWixEcommerceCatalogSpiApiV1CatalogReferenceInput = {
  /**
   * ID of the app providing the catalog.
   *
   * You can get your app's ID from its page in the [app dashboard](https://dev.wix.com/dc3/my-apps/).
   *
   * For items from Wix catalogs, the following values always apply:
   * + Wix Stores: `"215238eb-22a5-4c36-9e7b-e7c08025e04e"`
   * + Wix Bookings: `"13d21c63-b5ec-5912-8397-c3a5ddb27a97"`
   * + Wix Restaurants: `"9a5d83fd-8570-482e-81ab-cfa88942ee60"`
   */
  appId?: InputMaybe<Scalars['String']>;
  /** ID of the item within the catalog it belongs to. */
  catalogItemId?: InputMaybe<Scalars['String']>;
  /**
   * Additional item details in key:value pairs. Use this optional field to provide more specificity with item selection. The `options` field values differ depending on which catalog is providing the items.
   *
   * For products and variants from a Wix Stores catalog, learn more about [eCommerce integration](https://dev.wix.com/docs/rest/business-solutions/stores/catalog/e-commerce-integration).
   */
  options?: InputMaybe<Scalars['JSON']>;
};

export type ComWixEcommerceCatalogSpiApiV1Color = {
  /** HEX or RGB color code for display. */
  code?: Maybe<Scalars['String']>;
  /** Description line color name in the site's default language as defined in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope). */
  original?: Maybe<Scalars['String']>;
  /**
   * Description line color name translated into the buyer's language.
   *
   * Default: Same as `original`.
   */
  translated?: Maybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1ColorInput = {
  /** HEX or RGB color code for display. */
  code?: InputMaybe<Scalars['String']>;
  /** Description line color name in the site's default language as defined in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope). */
  original?: InputMaybe<Scalars['String']>;
  /**
   * Description line color name translated into the buyer's language.
   *
   * Default: Same as `original`.
   */
  translated?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1Description = {
  /** Subscription option description. */
  original?: Maybe<Scalars['String']>;
  /** Translated subscription option description. */
  translated?: Maybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1DescriptionInput = {
  /** Subscription option description. */
  original?: InputMaybe<Scalars['String']>;
  /** Translated subscription option description. */
  translated?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1DescriptionLine = {
  /** Description line color. */
  color?: Maybe<Scalars['String']>;
  /** Description line color value. */
  colorInfo?: Maybe<ComWixEcommerceCatalogSpiApiV1Color>;
  /** Description line type. */
  lineType?: Maybe<ComWixEcommerceCatalogSpiApiV1DescriptionLineDescriptionLineType>;
  /**
   * Whether the description line originates from a modifier.
   * @deprecated Whether the description line originates from a modifier. Replaced by: none. Removal date: 2025-12-31.
   */
  modifierDescriptionLine?: Maybe<Scalars['Boolean']>;
  /** Description line name. */
  name?: Maybe<ComWixEcommerceCatalogSpiApiV1DescriptionLineName>;
  /** Description line plain text value. */
  plainText?: Maybe<ComWixEcommerceCatalogSpiApiV1PlainTextValue>;
  /** Description line plain text value. */
  plainTextValue?: Maybe<ComWixEcommerceCatalogSpiApiV1PlainTextValue>;
};

export enum ComWixEcommerceCatalogSpiApiV1DescriptionLineDescriptionLineType {
  /** Color type. */
  COLOR = 'COLOR',
  /** Plain text type. */
  PLAIN_TEXT = 'PLAIN_TEXT',
  /** Unrecognized type. */
  UNRECOGNISED = 'UNRECOGNISED'
}

export type ComWixEcommerceCatalogSpiApiV1DescriptionLineInput = {
  /** Description line color. */
  color?: InputMaybe<Scalars['String']>;
  /** Description line color value. */
  colorInfo?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ColorInput>;
  /** Description line type. */
  lineType?: InputMaybe<ComWixEcommerceCatalogSpiApiV1DescriptionLineDescriptionLineType>;
  /** Description line name. */
  name?: InputMaybe<ComWixEcommerceCatalogSpiApiV1DescriptionLineNameInput>;
  /** Description line plain text value. */
  plainText?: InputMaybe<ComWixEcommerceCatalogSpiApiV1PlainTextValueInput>;
  /** Description line plain text value. */
  plainTextValue?: InputMaybe<ComWixEcommerceCatalogSpiApiV1PlainTextValueInput>;
};

export type ComWixEcommerceCatalogSpiApiV1DescriptionLineName = {
  /** Description line name in the site's default language as defined in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope). */
  original?: Maybe<Scalars['String']>;
  /**
   * Description line name translated into the buyer's language.
   *
   * Default: Same as `original`.
   */
  translated?: Maybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1DescriptionLineNameInput = {
  /** Description line name in the site's default language as defined in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope). */
  original?: InputMaybe<Scalars['String']>;
  /**
   * Description line name translated into the buyer's language.
   *
   * Default: Same as `original`.
   */
  translated?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1FreeTrialPeriod = {
  /** Frequency of period. Values: DAY, WEEK, MONTH, YEAR */
  frequency?: Maybe<WixPaymentApiPayV2SubscriptionFrequency>;
  /** interval of period */
  interval?: Maybe<Scalars['Int']>;
};

export type ComWixEcommerceCatalogSpiApiV1FreeTrialPeriodInput = {
  /** Frequency of period. Values: DAY, WEEK, MONTH, YEAR */
  frequency?: InputMaybe<WixPaymentApiPayV2SubscriptionFrequency>;
  /** interval of period */
  interval?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcommerceCatalogSpiApiV1ItemModifierInput = {
  /** Additional details. */
  details?: InputMaybe<ComWixEcommercePlatformCommonApiTranslatableStringInput>;
  /** Modifier ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Primary display label for the modifier. */
  label?: InputMaybe<ComWixEcommercePlatformCommonApiTranslatableStringInput>;
  /** The price of the modifier. */
  price?: InputMaybe<Scalars['String']>;
  /** The quantity of this modifier. */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcommerceCatalogSpiApiV1ItemType = {
  /** Custom item type. When none of the preset types are suitable, specifies the custom type. */
  custom?: Maybe<Scalars['String']>;
  /** Preset item type. */
  preset?: Maybe<ComWixEcommerceCatalogSpiApiV1ItemTypeItemType>;
};

export type ComWixEcommerceCatalogSpiApiV1ItemTypeInput = {
  /** Custom item type. When none of the preset types are suitable, specifies the custom type. */
  custom?: InputMaybe<Scalars['String']>;
  /** Preset item type. */
  preset?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ItemTypeItemType>;
};

export enum ComWixEcommerceCatalogSpiApiV1ItemTypeItemType {
  DIGITAL = 'DIGITAL',
  GIFT_CARD = 'GIFT_CARD',
  PHYSICAL = 'PHYSICAL',
  SERVICE = 'SERVICE',
  UNRECOGNISED = 'UNRECOGNISED'
}

export type ComWixEcommerceCatalogSpiApiV1ModifierGroupInput = {
  /** Modifier group ID. */
  id?: InputMaybe<Scalars['String']>;
  /** List of modifiers in this group. */
  modifiers?: InputMaybe<Array<InputMaybe<ComWixEcommerceCatalogSpiApiV1ItemModifierInput>>>;
  /** Modifier group name. */
  name?: InputMaybe<ComWixEcommercePlatformCommonApiTranslatableStringInput>;
};

export type ComWixEcommerceCatalogSpiApiV1NumericPropertyRange = {
  /** Maximum value. */
  maxValue?: Maybe<Scalars['Float']>;
  /** Minimum value. */
  minValue?: Maybe<Scalars['Float']>;
};

export type ComWixEcommerceCatalogSpiApiV1NumericPropertyRangeInput = {
  /** Maximum value. */
  maxValue?: InputMaybe<Scalars['Float']>;
  /** Minimum value. */
  minValue?: InputMaybe<Scalars['Float']>;
};

export enum ComWixEcommerceCatalogSpiApiV1PaymentOptionType {
  /** Partial payment to be paid upfront during checkout. The initial amount to be paid for each line item is specified in `depositAmount`. */
  DEPOSIT_ONLINE = 'DEPOSIT_ONLINE',
  /** The entire payment for this item happens after checkout. For example, when using cash, check, or other offline payment methods. */
  FULL_PAYMENT_OFFLINE = 'FULL_PAYMENT_OFFLINE',
  /** The entire payment for this item happens as part of the checkout. */
  FULL_PAYMENT_ONLINE = 'FULL_PAYMENT_ONLINE',
  /** Payment for this item is done by charging a membership. Any remaining amount not covered by the membership, such as item modifiers, is paid online. */
  MEMBERSHIP = 'MEMBERSHIP',
  /** Payment for this item can only be done by charging a membership and must be manually redeemed in the dashboard by the site admin. When selected, `price` is `0`. */
  MEMBERSHIP_OFFLINE = 'MEMBERSHIP_OFFLINE',
  /** Item price is charged to online membership. Any remaining amount not covered by the membership, such as item modifiers, is paid offline. */
  MEMBERSHIP_ONLINE_WITH_OFFLINE_REMAINDER = 'MEMBERSHIP_ONLINE_WITH_OFFLINE_REMAINDER'
}

export type ComWixEcommerceCatalogSpiApiV1PhysicalProperties = {
  /** Whether this line item is shippable. */
  shippable?: Maybe<Scalars['Boolean']>;
  /** Stock-keeping unit. Learn more about [SKUs](https://www.wix.com/encyclopedia/definition/stock-keeping-unit-sku). */
  sku?: Maybe<Scalars['String']>;
  /** Line item weight. Measurement unit matches the weight unit specified in `weightUnit` in the request. */
  weight?: Maybe<Scalars['Float']>;
};

export type ComWixEcommerceCatalogSpiApiV1PhysicalPropertiesInput = {
  /** Whether this line item is shippable. */
  shippable?: InputMaybe<Scalars['Boolean']>;
  /** Stock-keeping unit. Learn more about [SKUs](https://www.wix.com/encyclopedia/definition/stock-keeping-unit-sku). */
  sku?: InputMaybe<Scalars['String']>;
  /** Line item weight. Measurement unit matches the weight unit specified in `weightUnit` in the request. */
  weight?: InputMaybe<Scalars['Float']>;
};

export type ComWixEcommerceCatalogSpiApiV1PlainTextValue = {
  /** Description line plain text value in the site's default language as defined in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope). */
  original?: Maybe<Scalars['String']>;
  /**
   * Description line plain text value translated into the buyer's language.
   *
   * Default: Same as `original`.
   */
  translated?: Maybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1PlainTextValueInput = {
  /** Description line plain text value in the site's default language as defined in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope). */
  original?: InputMaybe<Scalars['String']>;
  /**
   * Description line plain text value translated into the buyer's language.
   *
   * Default: Same as `original`.
   */
  translated?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1Policy = {
  /** Policy content - should be translated */
  content?: Maybe<Scalars['String']>;
  /** Policy title - should be translated */
  title?: Maybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1PolicyInput = {
  /** Policy content - should be translated */
  content?: InputMaybe<Scalars['String']>;
  /** Policy title - should be translated */
  title?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1PriceDescription = {
  /** __Required.__ Price description in the site's default language as defined in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope). */
  original?: Maybe<Scalars['String']>;
  /**
   * Price description translated into the buyer's language.
   *
   * Default: Same as `original`.
   */
  translated?: Maybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1PriceDescriptionInput = {
  /** __Required.__ Price description in the site's default language as defined in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope). */
  original?: InputMaybe<Scalars['String']>;
  /**
   * Price description translated into the buyer's language.
   *
   * Default: Same as `original`.
   */
  translated?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1ProductName = {
  /**
   * __Required.__ Item name in the site's default language as defined in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope).
   *
   * Min: 1 character.
   * Max: 200 characters.
   */
  original?: Maybe<Scalars['String']>;
  /**
   * Item name translated into the buyer's language.
   *
   * Min: 1 character.
   * Max: 400 characters.
   * Default: Same as `original`.
   */
  translated?: Maybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1ProductNameInput = {
  /**
   * __Required.__ Item name in the site's default language as defined in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope).
   *
   * Min: 1 character.
   * Max: 200 characters.
   */
  original?: InputMaybe<Scalars['String']>;
  /**
   * Item name translated into the buyer's language.
   *
   * Min: 1 character.
   * Max: 400 characters.
   * Default: Same as `original`.
   */
  translated?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1SecuredMedia = {
  /** Original filename. */
  fileName?: Maybe<Scalars['String']>;
  /** File type. */
  fileType?: Maybe<ComWixEcommerceCatalogSpiApiV1SecuredMediaFileType>;
  /** Media ID in Wix Media Manager. */
  id?: Maybe<Scalars['String']>;
};

export enum ComWixEcommerceCatalogSpiApiV1SecuredMediaFileType {
  SECURE_ARCHIVE = 'SECURE_ARCHIVE',
  SECURE_DOCUMENT = 'SECURE_DOCUMENT',
  SECURE_MUSIC = 'SECURE_MUSIC',
  SECURE_PICTURE = 'SECURE_PICTURE',
  SECURE_VIDEO = 'SECURE_VIDEO',
  UNSPECIFIED = 'UNSPECIFIED'
}

export type ComWixEcommerceCatalogSpiApiV1SecuredMediaInput = {
  /** Original filename. */
  fileName?: InputMaybe<Scalars['String']>;
  /** File type. */
  fileType?: InputMaybe<ComWixEcommerceCatalogSpiApiV1SecuredMediaFileType>;
  /** Media ID in Wix Media Manager. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1ServiceProperties = {
  /** The number of people participating in the service. For example, the number of people attending a class or the number of people per hotel room. */
  numberOfParticipants?: Maybe<Scalars['Int']>;
  /**
   * Date and time the service is to be provided, in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format.
   * For example, the start time of a class.
   */
  scheduledDate?: Maybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1ServicePropertiesInput = {
  /** The number of people participating in the service. For example, the number of people attending a class or the number of people per hotel room. */
  numberOfParticipants?: InputMaybe<Scalars['Int']>;
  /**
   * Date and time the service is to be provided, in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) format.
   * For example, the start time of a class.
   */
  scheduledDate?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1SubscriptionOptionInfo = {
  /** Subscription option description. */
  description?: Maybe<ComWixEcommerceCatalogSpiApiV1Description>;
  /** Subscription option settings. */
  subscriptionSettings?: Maybe<ComWixEcommerceCatalogSpiApiV1SubscriptionSettings>;
  /** Subscription option title. */
  title?: Maybe<ComWixEcommerceCatalogSpiApiV1Title>;
};

export type ComWixEcommerceCatalogSpiApiV1SubscriptionOptionInfoInput = {
  /** Subscription option description. */
  description?: InputMaybe<ComWixEcommerceCatalogSpiApiV1DescriptionInput>;
  /** Subscription option settings. */
  subscriptionSettings?: InputMaybe<ComWixEcommerceCatalogSpiApiV1SubscriptionSettingsInput>;
  /** Subscription option title. */
  title?: InputMaybe<ComWixEcommerceCatalogSpiApiV1TitleInput>;
};

export type ComWixEcommerceCatalogSpiApiV1SubscriptionSettings = {
  /** Whether subscription is renewed automatically at the end of each period. */
  autoRenewal?: Maybe<Scalars['Boolean']>;
  /** Number of billing cycles before subscription ends. Ignored if `autoRenewal` is `true`. */
  billingCycles?: Maybe<Scalars['Int']>;
  /** Whether to allow the customer to cancel the subscription.. */
  enableCustomerCancellation?: Maybe<Scalars['Boolean']>;
  /**
   * Period until first cycle starts. If applied payNow will be 0
   * If None => no free trial
   */
  freeTrialPeriod?: Maybe<ComWixEcommerceCatalogSpiApiV1FreeTrialPeriod>;
  /** Frequency of recurring payment. */
  frequency?: Maybe<WixPaymentApiPayV2SubscriptionFrequency>;
  /**
   * Interval of recurring payment.
   *
   * Default: `1`.
   * If SubscriptionFrequency is Day the minimum interval is 7
   */
  interval?: Maybe<Scalars['Int']>;
  /** The date the subscription will start. The subscription will be charged either now or according to freeTrialDays. */
  startDate?: Maybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1SubscriptionSettingsInput = {
  /** Whether subscription is renewed automatically at the end of each period. */
  autoRenewal?: InputMaybe<Scalars['Boolean']>;
  /** Number of billing cycles before subscription ends. Ignored if `autoRenewal` is `true`. */
  billingCycles?: InputMaybe<Scalars['Int']>;
  /** Whether to allow the customer to cancel the subscription.. */
  enableCustomerCancellation?: InputMaybe<Scalars['Boolean']>;
  /**
   * Period until first cycle starts. If applied payNow will be 0
   * If None => no free trial
   */
  freeTrialPeriod?: InputMaybe<ComWixEcommerceCatalogSpiApiV1FreeTrialPeriodInput>;
  /** Frequency of recurring payment. */
  frequency?: InputMaybe<WixPaymentApiPayV2SubscriptionFrequency>;
  /**
   * Interval of recurring payment.
   *
   * Default: `1`.
   * If SubscriptionFrequency is Day the minimum interval is 7
   */
  interval?: InputMaybe<Scalars['Int']>;
  /** The date the subscription will start. The subscription will be charged either now or according to freeTrialDays. */
  startDate?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1Title = {
  /** Subscription option name in the site's default language as defined in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope). */
  original?: Maybe<Scalars['String']>;
  /**
   * Subscription option name translated into the buyer's language.
   *
   * Default: Same as `original`.
   */
  translated?: Maybe<Scalars['String']>;
};

export type ComWixEcommerceCatalogSpiApiV1TitleInput = {
  /** Subscription option name in the site's default language as defined in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope). */
  original?: InputMaybe<Scalars['String']>;
  /**
   * Subscription option name translated into the buyer's language.
   *
   * Default: Same as `original`.
   */
  translated?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommerceCommonsApiAddressInput = {
  /** Address line 1 (free text) */
  addressLine1?: InputMaybe<Scalars['String']>;
  /** address line */
  addressLine2?: InputMaybe<Scalars['String']>;
  /** City name */
  city?: InputMaybe<Scalars['String']>;
  /** Company name */
  company?: InputMaybe<Scalars['String']>;
  /** Country code (2 letters) */
  country?: InputMaybe<Scalars['String']>;
  /** Email address */
  email?: InputMaybe<Scalars['String']>;
  /** Addressee name */
  fullName?: InputMaybe<ComWixEcommerceCommonsApiFullNameInput>;
  /** Phone number */
  phone?: InputMaybe<Scalars['String']>;
  /** Address line 1 (street) */
  street?: InputMaybe<ComWixEcommerceCommonsApiStreetInput>;
  /** State or district */
  subdivision?: InputMaybe<Scalars['String']>;
  /** Tax information (for Brazil only) */
  vatId?: InputMaybe<ComWixEcommerceCommonsApiVatIdInput>;
  /** ZIP/postal code */
  zipCode?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommerceCommonsApiFullNameInput = {
  /** Customer's first name */
  firstName?: InputMaybe<Scalars['String']>;
  /** Customer's last name */
  lastName?: InputMaybe<Scalars['String']>;
};

export enum ComWixEcommerceCommonsApiMeasurementUnitEnumMeasurementUnit {
  CBM = 'CBM',
  CL = 'CL',
  CM = 'CM',
  FLOZ = 'FLOZ',
  FT = 'FT',
  G = 'G',
  GAL = 'GAL',
  IN = 'IN',
  KG = 'KG',
  L = 'L',
  LB = 'LB',
  M = 'M',
  MG = 'MG',
  ML = 'ML',
  MM = 'MM',
  OZ = 'OZ',
  PT = 'PT',
  QT = 'QT',
  SQFT = 'SQFT',
  SQM = 'SQM',
  UNSPECIFIED = 'UNSPECIFIED',
  YD = 'YD'
}

export type ComWixEcommerceCommonsApiPlatformCursorPagingInput = {
  /** Cursor returned in last query response. Should not be provided on first page request */
  cursor?: InputMaybe<Scalars['String']>;
  /**
   * The number of items to load.
   * Cursor token returned in the query response. To be used on the next query request, but not the first query request.
   */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcommerceCommonsApiPlatformMedia = {
  image?: Maybe<WixCommonImage>;
  video?: Maybe<WixCommonVideoV2>;
};

export type ComWixEcommerceCommonsApiPlatformPagingInput = {
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the current sort order. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcommerceCommonsApiPlatformPagingMetadata = {
  /** The number of items returned in this response. */
  count?: Maybe<Scalars['Int']>;
  /** Cursors to navigate through result pages. Returned if cursor paging was used. */
  cursors?: Maybe<WixCommonCursors>;
  /** The offset which was requested. Returned if offset paging was used. */
  offset?: Maybe<Scalars['Int']>;
  /** The total number of items that match the query. Returned if offset paging was used. */
  total?: Maybe<Scalars['Int']>;
};

export type ComWixEcommerceCommonsApiPlatformQueryInput = {
  /** Cursor pointing to page of results. Cannot be used together with `paging`. `cursorPaging.cursor` can not be used together with `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixCommonCursorPagingInput>;
  /** Filter object. */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Pointer to page of results using offset. Cannot be used together with `cursorPaging`. */
  paging?: InputMaybe<ComWixEcommerceCommonsApiPlatformPagingInput>;
  /** Sorting options. For example, `[{"fieldName":"sortField1"},{"fieldName":"sortField2","direction":"DESC"}]`. */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type ComWixEcommerceCommonsApiStreetInput = {
  /** Street name */
  name?: InputMaybe<Scalars['String']>;
  /** Street number */
  number?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommerceCommonsApiUnlimitedPlatformCursorPagingInput = {
  /** Cursor returned in last query response. Should not be provided on first page request */
  cursor?: InputMaybe<Scalars['String']>;
  /**
   * The number of items to load.
   * Cursor token returned in the query response. To be used on the next query request, but not the first query request.
   */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcommerceCommonsApiUnlimitedPlatformPagingInput = {
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the current sort order. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcommerceCommonsApiUnlimitedPlatformQueryInput = {
  /** Cursor pointing to page of results. Cannot be used together with `paging`. `cursorPaging.cursor` can not be used together with `filter` or `sort`. */
  cursorPaging?: InputMaybe<ComWixEcommerceCommonsApiUnlimitedPlatformCursorPagingInput>;
  /** Filter object. */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Pointer to page of results using offset. Cannot be used together with `cursorPaging`. */
  paging?: InputMaybe<ComWixEcommerceCommonsApiUnlimitedPlatformPagingInput>;
  /** Sorting options. For example, `[{"fieldName":"sortField1"},{"fieldName":"sortField2","direction":"DESC"}]`. */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type ComWixEcommerceCommonsApiVatIdInput = {
  /** Customer's tax ID. */
  number?: InputMaybe<Scalars['String']>;
  /**
   * Tax type.
   * + `CPF`: For individual tax payers.
   * + `CNPJ`: For corporations.
   */
  type?: InputMaybe<ComWixEcommerceCommonsApiVatType>;
};

export enum ComWixEcommerceCommonsApiVatType {
  /** CNPJ - for corporations */
  CNPJ = 'CNPJ',
  /** CPF - for individual tax payers */
  CPF = 'CPF',
  /** When the tax info type can't be classified, due to an error */
  UNSPECIFIED_TAX_TYPE = 'UNSPECIFIED_TAX_TYPE'
}

export type ComWixEcommercePlatformCommonApiAddress = {
  /** Main address line (usually street name and number). */
  addressLine?: Maybe<Scalars['String']>;
  /** Free text providing more detailed address info. Usually contains apt, suite, floor. */
  addressLine2?: Maybe<Scalars['String']>;
  /** City name. */
  city?: Maybe<Scalars['String']>;
  /** Two-letter country code in [ISO-3166 alpha-2](https://www.iso.org/obp/ui/#search/code/) format. */
  country?: Maybe<Scalars['String']>;
  /** Country's full name. */
  countryFullname?: Maybe<Scalars['String']>;
  /** Geocode object containing latitude and longitude coordinates. */
  geocode?: Maybe<WixCommonAddressLocation>;
  /** Postal or zip code. */
  postalCode?: Maybe<Scalars['String']>;
  /** Street address. */
  streetAddress?: Maybe<WixCommonStreetAddress>;
  /** Code for a subdivision (such as state, prefecture, or province) in [ISO 3166-2](https://www.iso.org/standard/72483.html) format. */
  subdivision?: Maybe<Scalars['String']>;
  /** Subdivision full-name. */
  subdivisionFullname?: Maybe<Scalars['String']>;
};

export type ComWixEcommercePlatformCommonApiAddressInput = {
  /** Main address line (usually street name and number). */
  addressLine?: InputMaybe<Scalars['String']>;
  /** Free text providing more detailed address info. Usually contains apt, suite, floor. */
  addressLine2?: InputMaybe<Scalars['String']>;
  /** City name. */
  city?: InputMaybe<Scalars['String']>;
  /** Two-letter country code in [ISO-3166 alpha-2](https://www.iso.org/obp/ui/#search/code/) format. */
  country?: InputMaybe<Scalars['String']>;
  /** Country's full name. */
  countryFullname?: InputMaybe<Scalars['String']>;
  /** Geocode object containing latitude and longitude coordinates. */
  geocode?: InputMaybe<WixCommonAddressLocationInput>;
  /** Postal or zip code. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** Street address. */
  streetAddress?: InputMaybe<WixCommonStreetAddressInput>;
  /** Code for a subdivision (such as state, prefecture, or province) in [ISO 3166-2](https://www.iso.org/standard/72483.html) format. */
  subdivision?: InputMaybe<Scalars['String']>;
  /** Subdivision full-name. */
  subdivisionFullname?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommercePlatformCommonApiAddressWithContact = {
  /** Address. */
  address?: Maybe<ComWixEcommercePlatformCommonApiAddress>;
  /** Contact details. */
  contactDetails?: Maybe<ComWixEcommercePlatformCommonApiFullAddressContactDetails>;
};

export type ComWixEcommercePlatformCommonApiAddressWithContactInput = {
  /** Address. */
  address?: InputMaybe<ComWixEcommercePlatformCommonApiAddressInput>;
  /** Contact details. */
  contactDetails?: InputMaybe<ComWixEcommercePlatformCommonApiFullAddressContactDetailsInput>;
};

export enum ComWixEcommercePlatformCommonApiAutoTaxFallbackCalculationDetailsFallbackReason {
  /** auto-tax was temporarily deactivated on a system-level */
  AUTO_TAX_DEACTIVATED = 'AUTO_TAX_DEACTIVATED',
  /** auto-tax failed to be calculated */
  AUTO_TAX_FAILED = 'AUTO_TAX_FAILED'
}

export enum ComWixEcommercePlatformCommonApiChannelType {
  /** [Amazon shop](https://support.wix.com/en/article/wix-stores-connecting-and-setting-up-an-amazon-shop). */
  AMAZON = 'AMAZON',
  /** Wix merchant backoffice. */
  BACKOFFICE_MERCHANT = 'BACKOFFICE_MERCHANT',
  /** [ClassPass sales channel](https://support.wix.com/en/article/wix-bookings-letting-clients-book-your-services-with-classpass). */
  CLASS_PASS = 'CLASS_PASS',
  /** [eBay shop](https://support.wix.com/en/article/wix-stores-connecting-and-setting-up-an-ebay-shop). */
  EBAY = 'EBAY',
  /** [Etsy sales channel](https://support.wix.com/en/article/wix-stores-request-adding-etsy-as-a-sales-channel). */
  ETSY = 'ETSY',
  /** [Facebook shop](https://support.wix.com/en/article/wix-stores-changes-to-facebook-shops). */
  FACEBOOK = 'FACEBOOK',
  /** [Faire marketplace integration](https://support.wix.com/en/article/wix-stores-creating-a-faire-store-using-the-faire-integration-app). */
  FAIRE_COM = 'FAIRE_COM',
  /** Global-E sales channel. */
  GLOBAL_E = 'GLOBAL_E',
  /** Other sales platform. */
  OTHER_PLATFORM = 'OTHER_PLATFORM',
  /** PayPal Agentic Checkout sales channel. */
  PAYPAL_AGENTIC_CHECKOUT = 'PAYPAL_AGENTIC_CHECKOUT',
  /** [Point of sale solutions](https://support.wix.com/en/wix-mobile-pos-2196395). */
  POS = 'POS',
  /** [TikTok sales channel](https://support.wix.com/en/article/wix-stores-request-adding-tiktok-as-a-sales-channel). */
  TIKTOK = 'TIKTOK',
  /** Unspecified sales channel. This value is not supported. */
  UNSPECIFIED = 'UNSPECIFIED',
  /** A web client. */
  WEB = 'WEB',
  /** Wish sales channel. */
  WISH = 'WISH',
  /** [Wix Owner app](https://support.wix.com/article/wix-owner-app-an-overview). */
  WIX_APP_STORE = 'WIX_APP_STORE',
  /** Wix Invoices app in [your dashboard](https://www.wix.com/my-account/site-selector/?buttonText=Select%20Site&title=Select%20a%20Site&autoSelectOnSingleSite=true&actionUrl=https:%2F%2Fwww.wix.com%2Fdashboard%2F%7B%7BmetaSiteId%7D%7D%2Finvoices/settings/general-settings) */
  WIX_INVOICES = 'WIX_INVOICES'
}

export enum ComWixEcommercePlatformCommonApiDurationDurationUnit {
  DAYS = 'DAYS',
  HOURS = 'HOURS',
  MINUTES = 'MINUTES',
  UNKNOWN_DURATION_UNIT = 'UNKNOWN_DURATION_UNIT'
}

export type ComWixEcommercePlatformCommonApiDurationInput = {
  /** Amount of units. For example, 30 MINUTES, 1 HOURS, 7 DAYS, etc */
  count?: InputMaybe<Scalars['Int']>;
  /** Duration unit: MINUTES, HOURS and DAYS */
  unit?: InputMaybe<ComWixEcommercePlatformCommonApiDurationDurationUnit>;
};

export type ComWixEcommercePlatformCommonApiExternalReference = {
  /**
   * ID of the app associated with the purchase flow.
   * For example, the Wix Pay Links app ID.
   */
  appId?: Maybe<Scalars['String']>;
  /**
   * Reference to an external resource ID. Used to link the purchase flow to a specific entity in an external system.
   * For example, a Wix Pay Link ID.
   */
  resourceId?: Maybe<Scalars['String']>;
};

export type ComWixEcommercePlatformCommonApiExternalReferenceInput = {
  /**
   * ID of the app associated with the purchase flow.
   * For example, the Wix Pay Links app ID.
   */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Reference to an external resource ID. Used to link the purchase flow to a specific entity in an external system.
   * For example, a Wix Pay Link ID.
   */
  resourceId?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommercePlatformCommonApiFullAddressContactDetails = {
  /** Company name. */
  company?: Maybe<Scalars['String']>;
  /** First name. */
  firstName?: Maybe<Scalars['String']>;
  /** Last name. */
  lastName?: Maybe<Scalars['String']>;
  /** Phone number. */
  phone?: Maybe<Scalars['String']>;
  /** Tax information (for Brazil only). If ID is provided, `vatId.type` must also be set, `UNSPECIFIED` is not allowed. */
  vatId?: Maybe<WixCommonVatId>;
};

export type ComWixEcommercePlatformCommonApiFullAddressContactDetailsInput = {
  /** Company name. */
  company?: InputMaybe<Scalars['String']>;
  /** First name. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Last name. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Phone number. */
  phone?: InputMaybe<Scalars['String']>;
  /** Tax information (for Brazil only). If ID is provided, `vatId.type` must also be set, `UNSPECIFIED` is not allowed. */
  vatId?: InputMaybe<WixCommonVatIdInput>;
};

export type ComWixEcommercePlatformCommonApiLocation = {
  /**
   * Location ID.
   * Learn more about the [Wix Locations API](https://dev.wix.com/docs/rest/business-management/locations/introduction).
   */
  id?: Maybe<Scalars['String']>;
  /**
   * Location ID.
   * Learn more about the [Wix Locations API](https://dev.wix.com/docs/rest/business-management/locations/introduction).
   */
  location?: Maybe<ComWixpressLocationsLocation>;
  /** Location name. */
  name?: Maybe<Scalars['String']>;
};

export type ComWixEcommercePlatformCommonApiLocationAndQuantity = {
  /**
   * Location owner app, if not provided then the site business info locations will be used.
   * @deprecated Location owner app, if not provided then the site business info locations will be used. Removal date: 2025-03-01.
   */
  appId?: Maybe<Scalars['String']>;
  /** Location id in the associated owner app. */
  id?: Maybe<Scalars['String']>;
  /** Location name. */
  name?: Maybe<Scalars['String']>;
  /** Quantity for specific location. */
  quantity?: Maybe<Scalars['Int']>;
};

export type ComWixEcommercePlatformCommonApiLocationAndQuantityInput = {
  /** Location id in the associated owner app. */
  id?: InputMaybe<Scalars['String']>;
  /** Location name. */
  name?: InputMaybe<Scalars['String']>;
  /** Quantity for specific location. */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ComWixEcommercePlatformCommonApiLocationInput = {
  /**
   * Location ID.
   * Learn more about the [Wix Locations API](https://dev.wix.com/docs/rest/business-management/locations/introduction).
   */
  id?: InputMaybe<Scalars['String']>;
  /** Location name. */
  name?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommercePlatformCommonApiMultiCurrencyPrice = {
  /** Amount. */
  amount?: Maybe<Scalars['String']>;
  /** Converted amount. */
  convertedAmount?: Maybe<Scalars['String']>;
  /** Amount formatted with currency symbol. */
  formattedAmount?: Maybe<Scalars['String']>;
  /** Converted amount formatted with currency symbol. */
  formattedConvertedAmount?: Maybe<Scalars['String']>;
};

export type ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput = {
  /** Amount. */
  amount?: InputMaybe<Scalars['String']>;
  /** Converted amount. */
  convertedAmount?: InputMaybe<Scalars['String']>;
  /** Amount formatted with currency symbol. */
  formattedAmount?: InputMaybe<Scalars['String']>;
  /** Converted amount formatted with currency symbol. */
  formattedConvertedAmount?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommercePlatformCommonApiPickupAddress = {
  /** Main address line (usually street name and number). */
  addressLine?: Maybe<Scalars['String']>;
  /** Free text providing more detailed address info. Usually contains apt, suite, floor. */
  addressLine2?: Maybe<Scalars['String']>;
  /** City name. */
  city?: Maybe<Scalars['String']>;
  /** Two-letter country code in [ISO-3166 alpha-2](https://www.iso.org/obp/ui/#search/code/) format. */
  country?: Maybe<Scalars['String']>;
  /** Country's full name. */
  countryFullname?: Maybe<Scalars['String']>;
  geocode?: Maybe<WixCommonAddressLocation>;
  /** Postal or zip code. */
  postalCode?: Maybe<Scalars['String']>;
  /** Street address object, with number, name, and apartment number in separate fields. */
  streetAddress?: Maybe<WixCommonStreetAddress>;
  /** Code for a subdivision (such as state, prefecture, or province) in [ISO 3166-2](https://www.iso.org/standard/72483.html) format. */
  subdivision?: Maybe<Scalars['String']>;
  /** Subdivision full-name. */
  subdivisionFullname?: Maybe<Scalars['String']>;
};

export type ComWixEcommercePlatformCommonApiPickupAddressInput = {
  /** Main address line (usually street name and number). */
  addressLine?: InputMaybe<Scalars['String']>;
  /** Free text providing more detailed address info. Usually contains apt, suite, floor. */
  addressLine2?: InputMaybe<Scalars['String']>;
  /** City name. */
  city?: InputMaybe<Scalars['String']>;
  /** Two-letter country code in [ISO-3166 alpha-2](https://www.iso.org/obp/ui/#search/code/) format. */
  country?: InputMaybe<Scalars['String']>;
  /** Country's full name. */
  countryFullname?: InputMaybe<Scalars['String']>;
  geocode?: InputMaybe<WixCommonAddressLocationInput>;
  /** Postal or zip code. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** Street address object, with number, name, and apartment number in separate fields. */
  streetAddress?: InputMaybe<WixCommonStreetAddressInput>;
  /** Code for a subdivision (such as state, prefecture, or province) in [ISO 3166-2](https://www.iso.org/standard/72483.html) format. */
  subdivision?: InputMaybe<Scalars['String']>;
  /** Subdivision full-name. */
  subdivisionFullname?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommercePlatformCommonApiPrice = {
  /** Amount. */
  amount?: Maybe<Scalars['String']>;
  /** Amount formatted with currency symbol. */
  formattedAmount?: Maybe<Scalars['String']>;
};

export type ComWixEcommercePlatformCommonApiPriceInput = {
  /** Amount. */
  amount?: InputMaybe<Scalars['String']>;
  /** Amount formatted with currency symbol. */
  formattedAmount?: InputMaybe<Scalars['String']>;
};

export type ComWixEcommercePlatformCommonApiTaxableAddress = {
  /** taxable address type. if this field is selected, the address is automatically resolved, and the tax is calculated accordingly. */
  addressType?: Maybe<ComWixEcommercePlatformCommonApiTaxableAddressTaxableAddressType>;
};

export type ComWixEcommercePlatformCommonApiTaxableAddressInput = {
  /** taxable address type. if this field is selected, the address is automatically resolved, and the tax is calculated accordingly. */
  addressType?: InputMaybe<ComWixEcommercePlatformCommonApiTaxableAddressTaxableAddressType>;
};

export enum ComWixEcommercePlatformCommonApiTaxableAddressTaxableAddressType {
  BILLING = 'BILLING',
  BUSINESS = 'BUSINESS',
  SHIPPING = 'SHIPPING',
  UNKNOWN_TAXABLE_ADDRESS = 'UNKNOWN_TAXABLE_ADDRESS'
}

export type ComWixEcommercePlatformCommonApiTranslatableString = {
  /**
   * __Required.__ String in the site's default language as defined in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope).
   *
   * Min: 1 character.
   * Max: 200 characters.
   */
  original?: Maybe<Scalars['String']>;
  /**
   * String translated into the buyer's language.
   *
   * Min: 1 character.
   * Max: 400 characters.
   * Default: Same as `original`.
   */
  translated?: Maybe<Scalars['String']>;
};

export type ComWixEcommercePlatformCommonApiTranslatableStringInput = {
  /**
   * __Required.__ String in the site's default language as defined in the [request envelope](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/self-hosting/supported-extensions/backend-extensions/add-self-hosted-service-plugin-extensions#request-envelope).
   *
   * Min: 1 character.
   * Max: 200 characters.
   */
  original?: InputMaybe<Scalars['String']>;
  /**
   * String translated into the buyer's language.
   *
   * Min: 1 character.
   * Max: 400 characters.
   * Default: Same as `original`.
   */
  translated?: InputMaybe<Scalars['String']>;
};

export enum ComWixEcommercePlatformCommonApiWeightUnit {
  /** Kilograms. */
  KG = 'KG',
  /** Pounds. */
  LB = 'LB',
  /** Weight unit can't be classified due to an error. */
  UNSPECIFIED_WEIGHT_UNIT = 'UNSPECIFIED_WEIGHT_UNIT'
}

export type ComWixEcommerceValidationsSpiV1Target = {
  /** Specific line item violation. */
  lineItem?: Maybe<ComWixEcommerceValidationsSpiV1TargetLineItem>;
  /** General (other) violation. */
  other?: Maybe<ComWixEcommerceValidationsSpiV1TargetOther>;
};

export type ComWixEcommerceValidationsSpiV1TargetInput = {
  /** Specific line item violation. */
  lineItem?: InputMaybe<ComWixEcommerceValidationsSpiV1TargetLineItemInput>;
  /** General (other) violation. */
  other?: InputMaybe<ComWixEcommerceValidationsSpiV1TargetOtherInput>;
};

export type ComWixEcommerceValidationsSpiV1TargetLineItem = {
  /** ID of the line item containing the violation. */
  id?: Maybe<Scalars['String']>;
  /** Location on a checkout or a cart page where the specific line item violation will be displayed. */
  name?: Maybe<ComWixEcommerceValidationsSpiV1TargetNameInLineItem>;
  /** Suggested fix for resolving the line item violation. */
  suggestedFix?: Maybe<ComWixEcommerceValidationsSpiV1TargetLineItemSuggestedFix>;
};

export type ComWixEcommerceValidationsSpiV1TargetLineItemInput = {
  /** ID of the line item containing the violation. */
  id?: InputMaybe<Scalars['String']>;
  /** Location on a checkout or a cart page where the specific line item violation will be displayed. */
  name?: InputMaybe<ComWixEcommerceValidationsSpiV1TargetNameInLineItem>;
  /** Suggested fix for resolving the line item violation. */
  suggestedFix?: InputMaybe<ComWixEcommerceValidationsSpiV1TargetLineItemSuggestedFix>;
};

export enum ComWixEcommerceValidationsSpiV1TargetLineItemSuggestedFix {
  /** The line item should be removed from the cart or checkout to resolve the violation. */
  REMOVE_LINE_ITEM = 'REMOVE_LINE_ITEM',
  /** No suggested fix is specified. The user should refer to the violation description to resolve the issue. */
  UNKNOWN_SUGGESTED_FIX = 'UNKNOWN_SUGGESTED_FIX'
}

export enum ComWixEcommerceValidationsSpiV1TargetNameInLineItem {
  /** Default location, in case no specific location is specified. */
  LINE_ITEM_DEFAULT = 'LINE_ITEM_DEFAULT'
}

export enum ComWixEcommerceValidationsSpiV1TargetNameInOther {
  /**
   * Deprecated.
   * Delivery section.
   */
  DELIVERY = 'DELIVERY',
  /** Default location, in case no specific location is specified. */
  OTHER_DEFAULT = 'OTHER_DEFAULT'
}

export type ComWixEcommerceValidationsSpiV1TargetOther = {
  /** Location on a checkout or a cart page where a general (other) violation will be displayed. */
  name?: Maybe<ComWixEcommerceValidationsSpiV1TargetNameInOther>;
};

export type ComWixEcommerceValidationsSpiV1TargetOtherInput = {
  /** Location on a checkout or a cart page where a general (other) violation will be displayed. */
  name?: InputMaybe<ComWixEcommerceValidationsSpiV1TargetNameInOther>;
};

export type ComWixEcommerceValidationsSpiV1Violation = {
  /** Violation description. Can include rich text. Only HTTP or HTTPS links in the following format are allowed: `<a href="https://www.wix.com">Click me</a>`. */
  description?: Maybe<Scalars['String']>;
  /** Severity of the violation. The violations are shown on the cart and checkout pages. A warning is displayed as yellow, and allows a site visitor to proceed with caution. An error is displayed as red, and doesn't allow a site visitor to proceed with the eCommerce flow. */
  severity?: Maybe<ComWixEcommerceValidationsSpiV1ViolationSeverity>;
  /** Target location on a checkout or cart page where the violation will be displayed. */
  target?: Maybe<ComWixEcommerceValidationsSpiV1Target>;
};

export type ComWixEcommerceValidationsSpiV1ViolationInput = {
  /** Violation description. Can include rich text. Only HTTP or HTTPS links in the following format are allowed: `<a href="https://www.wix.com">Click me</a>`. */
  description?: InputMaybe<Scalars['String']>;
  /** Severity of the violation. The violations are shown on the cart and checkout pages. A warning is displayed as yellow, and allows a site visitor to proceed with caution. An error is displayed as red, and doesn't allow a site visitor to proceed with the eCommerce flow. */
  severity?: InputMaybe<ComWixEcommerceValidationsSpiV1ViolationSeverity>;
  /** Target location on a checkout or cart page where the violation will be displayed. */
  target?: InputMaybe<ComWixEcommerceValidationsSpiV1TargetInput>;
};

export enum ComWixEcommerceValidationsSpiV1ViolationSeverity {
  /**
   * The user is blocked from moving forward in the flow.
   * For example, if callerContext is CART - moving to checkout is blocked. if callerContext is CHECKOUT, placing an order is blocked.
   */
  ERROR = 'ERROR',
  /** The user is allowed to move forward in the flow. */
  WARNING = 'WARNING'
}

export type ComWixEventsUpstreamWixCommonAddress = {
  /** Main address line (usually street and number) as free text */
  addressLine?: Maybe<Scalars['String']>;
  /** Free text providing more detailed address info. Usually contains Apt, Suite, Floor */
  addressLine2?: Maybe<Scalars['String']>;
  /** city name */
  city?: Maybe<Scalars['String']>;
  /** country code */
  country?: Maybe<Scalars['String']>;
  /** country full-name */
  countryFullname?: Maybe<Scalars['String']>;
  /** A string containing the human-readable address of this location */
  formattedAddress?: Maybe<Scalars['String']>;
  /** coordinates of the physical address */
  geocode?: Maybe<ComWixEventsUpstreamWixCommonAddressLocation>;
  /** Free text for human-to-human textual orientation aid purposes */
  hint?: Maybe<Scalars['String']>;
  /** zip/postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** a break down of the street to number and street name */
  streetAddress?: Maybe<ComWixEventsUpstreamWixCommonStreetAddress>;
  /** subdivision (usually state or region) code according to ISO 3166-2 */
  subdivision?: Maybe<Scalars['String']>;
  /** multi-level subdivisions from top to bottom */
  subdivisions?: Maybe<Array<Maybe<ComWixEventsUpstreamWixCommonSubdivision>>>;
};

export type ComWixEventsUpstreamWixCommonAddressInput = {
  /** Main address line (usually street and number) as free text */
  addressLine?: InputMaybe<Scalars['String']>;
  /** Free text providing more detailed address info. Usually contains Apt, Suite, Floor */
  addressLine2?: InputMaybe<Scalars['String']>;
  /** city name */
  city?: InputMaybe<Scalars['String']>;
  /** country code */
  country?: InputMaybe<Scalars['String']>;
  /** country full-name */
  countryFullname?: InputMaybe<Scalars['String']>;
  /** A string containing the human-readable address of this location */
  formattedAddress?: InputMaybe<Scalars['String']>;
  /** coordinates of the physical address */
  geocode?: InputMaybe<ComWixEventsUpstreamWixCommonAddressLocationInput>;
  /** Free text for human-to-human textual orientation aid purposes */
  hint?: InputMaybe<Scalars['String']>;
  /** zip/postal code */
  postalCode?: InputMaybe<Scalars['String']>;
  /** a break down of the street to number and street name */
  streetAddress?: InputMaybe<ComWixEventsUpstreamWixCommonStreetAddressInput>;
  /** subdivision (usually state or region) code according to ISO 3166-2 */
  subdivision?: InputMaybe<Scalars['String']>;
  /** multi-level subdivisions from top to bottom */
  subdivisions?: InputMaybe<Array<InputMaybe<ComWixEventsUpstreamWixCommonSubdivisionInput>>>;
};

export type ComWixEventsUpstreamWixCommonAddressLocation = {
  /** address latitude coordinates */
  latitude?: Maybe<Scalars['Float']>;
  /** address longitude coordinates */
  longitude?: Maybe<Scalars['Float']>;
};

export type ComWixEventsUpstreamWixCommonAddressLocationInput = {
  /** address latitude coordinates */
  latitude?: InputMaybe<Scalars['Float']>;
  /** address longitude coordinates */
  longitude?: InputMaybe<Scalars['Float']>;
};

export type ComWixEventsUpstreamWixCommonImage = {
  /** Image alt text. Optional. */
  altText?: Maybe<Scalars['String']>;
  /** Original image height. */
  height?: Maybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: Maybe<Scalars['String']>;
  /** Image URL. */
  url?: Maybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). Optional */
  urlExpirationDate?: Maybe<Scalars['String']>;
  /** Original image width. */
  width?: Maybe<Scalars['Int']>;
};

export type ComWixEventsUpstreamWixCommonImageInput = {
  /** Image alt text. Optional. */
  altText?: InputMaybe<Scalars['String']>;
  /** Original image height. */
  height?: InputMaybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Image URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). Optional */
  urlExpirationDate?: InputMaybe<Scalars['String']>;
  /** Original image width. */
  width?: InputMaybe<Scalars['Int']>;
};

export type ComWixEventsUpstreamWixCommonPagingInput = {
  /** Number of items to load per page. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the current sort order. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type ComWixEventsUpstreamWixCommonQueryV2Input = {
  /** Filter. See [supported fields and operators](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events). */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Pointer to page of results using offset.
   * See [Pagination](https://dev.wix.com/api/rest/getting-started/pagination).
   */
  paging?: InputMaybe<ComWixEventsUpstreamWixCommonPagingInput>;
  /**
   * Sort object in the form [{"fieldName":"sortField1"},{"fieldName":"sortField2","direction":"DESC"}]
   * See [supported fields](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events).
   */
  sort?: InputMaybe<Array<InputMaybe<ComWixEventsUpstreamWixCommonSortingInput>>>;
};

export type ComWixEventsUpstreamWixCommonSortingInput = {
  /** Name of the field to sort by */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order (ASC/DESC). Defaults to ASC */
  order?: InputMaybe<WixCommonSortOrder>;
};

export type ComWixEventsUpstreamWixCommonStreetAddress = {
  /** apartment number */
  apt?: Maybe<Scalars['String']>;
  /** street name */
  name?: Maybe<Scalars['String']>;
  /** street number */
  number?: Maybe<Scalars['String']>;
};

export type ComWixEventsUpstreamWixCommonStreetAddressInput = {
  /** apartment number */
  apt?: InputMaybe<Scalars['String']>;
  /** street name */
  name?: InputMaybe<Scalars['String']>;
  /** street number */
  number?: InputMaybe<Scalars['String']>;
};

export type ComWixEventsUpstreamWixCommonSubdivision = {
  /** subdivision short code */
  code?: Maybe<Scalars['String']>;
  /** subdivision full-name */
  name?: Maybe<Scalars['String']>;
  /** subdivision level */
  type?: Maybe<WixCommonSubdivisionSubdivisionType>;
  /** free text description of subdivision type */
  typeInfo?: Maybe<Scalars['String']>;
};

export type ComWixEventsUpstreamWixCommonSubdivisionInput = {
  /** subdivision short code */
  code?: InputMaybe<Scalars['String']>;
  /** subdivision full-name */
  name?: InputMaybe<Scalars['String']>;
  /** subdivision level */
  type?: InputMaybe<WixCommonSubdivisionSubdivisionType>;
  /** free text description of subdivision type */
  typeInfo?: InputMaybe<Scalars['String']>;
};

export type ComWixFormsUpstreamWixCommonBulkActionMetadata = {
  /** Number of items that couldn't be processed. */
  totalFailures?: Maybe<Scalars['Int']>;
  /** Number of items that were successfully processed. */
  totalSuccesses?: Maybe<Scalars['Int']>;
  /** Number of failures without details because detailed failure threshold was exceeded. */
  undetailedFailures?: Maybe<Scalars['Int']>;
};

export type ComWixFormsUpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixFormsUpstreamWixCommonCursorPagingMetadata = {
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Offset that was requested. */
  cursors?: Maybe<ComWixFormsUpstreamWixCommonCursors>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
};

export type ComWixFormsUpstreamWixCommonCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<ComWixFormsUpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<ComWixFormsUpstreamWixCommonSortingInput>>>;
};

export type ComWixFormsUpstreamWixCommonCursors = {
  /** Cursor pointing to next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export type ComWixFormsUpstreamWixCommonImage = {
  /** Image alt text. */
  altText?: Maybe<Scalars['String']>;
  /** Image filename. */
  filename?: Maybe<Scalars['String']>;
  /** Original image height. */
  height?: Maybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: Maybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: Maybe<Scalars['String']>;
  /** Image URL. */
  url?: Maybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: Maybe<Scalars['String']>;
  /** Original image width. */
  width?: Maybe<Scalars['Int']>;
};

export type ComWixFormsUpstreamWixCommonImageInput = {
  /** Image alt text. */
  altText?: InputMaybe<Scalars['String']>;
  /** Image filename. */
  filename?: InputMaybe<Scalars['String']>;
  /** Original image height. */
  height?: InputMaybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: InputMaybe<Scalars['String']>;
  /** Image URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: InputMaybe<Scalars['String']>;
  /** Original image width. */
  width?: InputMaybe<Scalars['Int']>;
};

export type ComWixFormsUpstreamWixCommonItemMetadata = {
  /** Details about the error in case of failure. */
  error?: Maybe<WixApiApplicationError>;
  /** Item ID. Should always be available, unless it's impossible (for example, when failing to create an item). */
  id?: Maybe<Scalars['String']>;
  /** Index of the item within the request array. Allows for correlation between request and response items. */
  originalIndex?: Maybe<Scalars['Int']>;
  /** Whether the requested action was successful for this item. When `false`, the `error` field is populated. */
  success?: Maybe<Scalars['Boolean']>;
};

export type ComWixFormsUpstreamWixCommonPublicTags = {
  /** Tags that are exposed to anyone who has access to the labeled entity itself, including site members and visitors. */
  tags?: Maybe<ComWixFormsUpstreamWixCommonPublicTagsTagList>;
};

export type ComWixFormsUpstreamWixCommonPublicTagsInput = {
  /** Tags that are exposed to anyone who has access to the labeled entity itself, including site members and visitors. */
  tags?: InputMaybe<ComWixFormsUpstreamWixCommonPublicTagsTagListInput>;
};

export type ComWixFormsUpstreamWixCommonPublicTagsTagList = {
  /** List of tag IDs */
  tagIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixFormsUpstreamWixCommonPublicTagsTagListInput = {
  /** List of tag IDs */
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum ComWixFormsUpstreamWixCommonSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type ComWixFormsUpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<ComWixFormsUpstreamWixCommonSortOrder>;
};

export type ComWixPricingplansBenefitsApiV2BenefitBehaviorDiscountInput = {
  /** Absolute amount discount */
  moneyOffAmount?: InputMaybe<Scalars['String']>;
  /** Fixed-rate percent off discount */
  percentOffRate?: InputMaybe<Scalars['String']>;
};

export type ComWixPricingplansBenefitsApiV2BenefitBehaviorInput = {
  /** Entry pass for resources, e.g. a ticket for Bookings service or a ticket for Events. */
  defaultBehavior?: InputMaybe<Scalars['Void']>;
  /** Discount applied to paid resources */
  discount?: InputMaybe<ComWixPricingplansBenefitsApiV2BenefitBehaviorDiscountInput>;
};

export enum ComWixPricingplansBenefitsApiV2BenefitBenefitType {
  /** Limited benefit type */
  LIMITED = 'LIMITED',
  /** Should never be used */
  UNDEFINED = 'UNDEFINED',
  /** Unlimited benefit type */
  UNLIMITED = 'UNLIMITED'
}

export type ComWixPricingplansBenefitsApiV2BenefitInput = {
  /** Id of the app associated with this benefit */
  appDefId?: InputMaybe<Scalars['String']>;
  /** Benefit behavior */
  behavior?: InputMaybe<ComWixPricingplansBenefitsApiV2BenefitBehaviorInput>;
  /** Benefit Type */
  benefitType?: InputMaybe<ComWixPricingplansBenefitsApiV2BenefitBenefitType>;
  /** Amount of credits that provided by this benefit */
  creditAmount?: InputMaybe<Scalars['Float']>;
  /** additional details related to benefit; limited to 20 entries, 20 symbols for key and 20 symbols for value */
  customFields?: InputMaybe<Scalars['JSON']>;
  /** return value only in case it required in the ListRequest, true means that benefit's type could be updated */
  editable?: InputMaybe<Scalars['Boolean']>;
  /** Benefit unique ID */
  id?: InputMaybe<Scalars['String']>;
  /** Resource IDs that serves by this benefit */
  resourceIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum ComWixPricingplansBenefitsApiV2BenefitNotificationEvent {
  Created = 'Created',
  Deleted = 'Deleted',
  Updated = 'Updated'
}

export type ComWixPricingplansBenefitsApiV2BenefitNotificationInput = {
  /** App def ID */
  appDefId?: InputMaybe<Scalars['String']>;
  /** Current benefit details */
  benefit?: InputMaybe<ComWixPricingplansBenefitsApiV2BenefitInput>;
  /** Notification event */
  event?: InputMaybe<ComWixPricingplansBenefitsApiV2BenefitNotificationEvent>;
  /** Plan unique ID */
  planId?: InputMaybe<Scalars['String']>;
  /** Previous benefit */
  prevBenefit?: InputMaybe<ComWixPricingplansBenefitsApiV2BenefitInput>;
};

export type ComWixpressAdvancedSeoSeoSchema = {
  /** SEO general settings. */
  settings?: Maybe<ComWixpressAdvancedSeoSeoSchemaSettings>;
  /** SEO tag information. */
  tags?: Maybe<Array<Maybe<ComWixpressAdvancedSeoSeoSchemaTag>>>;
};

export type ComWixpressAdvancedSeoSeoSchemaInput = {
  /** SEO general settings. */
  settings?: InputMaybe<ComWixpressAdvancedSeoSeoSchemaSettingsInput>;
  /** SEO tag information. */
  tags?: InputMaybe<Array<InputMaybe<ComWixpressAdvancedSeoSeoSchemaTagInput>>>;
};

export type ComWixpressAdvancedSeoSeoSchemaKeyword = {
  /** Whether the keyword is the main focus keyword. */
  isMain?: Maybe<Scalars['Boolean']>;
  /** The source that added the keyword terms to the SEO settings. */
  origin?: Maybe<Scalars['String']>;
  /** Keyword value. */
  term?: Maybe<Scalars['String']>;
};

export type ComWixpressAdvancedSeoSeoSchemaKeywordInput = {
  /** Whether the keyword is the main focus keyword. */
  isMain?: InputMaybe<Scalars['Boolean']>;
  /** The source that added the keyword terms to the SEO settings. */
  origin?: InputMaybe<Scalars['String']>;
  /** Keyword value. */
  term?: InputMaybe<Scalars['String']>;
};

export type ComWixpressAdvancedSeoSeoSchemaSettings = {
  /** User-selected keyword terms for a specific page. */
  keywords?: Maybe<Array<Maybe<ComWixpressAdvancedSeoSeoSchemaKeyword>>>;
  /**
   * Whether the [automatical redirect visits](https://support.wix.com/en/article/customizing-your-pages-seo-settings-in-the-seo-panel) from the old URL to the new one is enabled.
   *
   *
   * Default: `false` (automatical redirect is enabled).
   */
  preventAutoRedirect?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressAdvancedSeoSeoSchemaSettingsInput = {
  /** User-selected keyword terms for a specific page. */
  keywords?: InputMaybe<Array<InputMaybe<ComWixpressAdvancedSeoSeoSchemaKeywordInput>>>;
  /**
   * Whether the [automatical redirect visits](https://support.wix.com/en/article/customizing-your-pages-seo-settings-in-the-seo-panel) from the old URL to the new one is enabled.
   *
   *
   * Default: `false` (automatical redirect is enabled).
   */
  preventAutoRedirect?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressAdvancedSeoSeoSchemaTag = {
  /** SEO tag inner content. For example, `<title> inner content </title>`. */
  children?: Maybe<Scalars['String']>;
  /** Whether the tag is a [custom tag](https://support.wix.com/en/article/adding-additional-meta-tags-to-your-sites-pages). */
  custom?: Maybe<Scalars['Boolean']>;
  /** Whether the tag is disabled. If the tag is disabled, people can't find your page when searching for this phrase in search engines. */
  disabled?: Maybe<Scalars['Boolean']>;
  /** SEO tag metadata. For example, `{"height": 300, "width": 240}`. */
  meta?: Maybe<Scalars['JSON']>;
  /**
   * A `{"key": "value"}` pair object where each SEO tag property (`"name"`, `"content"`, `"rel"`, `"href"`) contains a value.
   * For example: `{"name": "description", "content": "the description itself"}`.
   */
  props?: Maybe<Scalars['JSON']>;
  /**
   * SEO tag type.
   *
   *
   * Supported values: `title`, `meta`, `script`, `link`.
   */
  type?: Maybe<Scalars['String']>;
};

export type ComWixpressAdvancedSeoSeoSchemaTagInput = {
  /** SEO tag inner content. For example, `<title> inner content </title>`. */
  children?: InputMaybe<Scalars['String']>;
  /** Whether the tag is a [custom tag](https://support.wix.com/en/article/adding-additional-meta-tags-to-your-sites-pages). */
  custom?: InputMaybe<Scalars['Boolean']>;
  /** Whether the tag is disabled. If the tag is disabled, people can't find your page when searching for this phrase in search engines. */
  disabled?: InputMaybe<Scalars['Boolean']>;
  /** SEO tag metadata. For example, `{"height": 300, "width": 240}`. */
  meta?: InputMaybe<Scalars['JSON']>;
  /**
   * A `{"key": "value"}` pair object where each SEO tag property (`"name"`, `"content"`, `"rel"`, `"href"`) contains a value.
   * For example: `{"name": "description", "content": "the description itself"}`.
   */
  props?: InputMaybe<Scalars['JSON']>;
  /**
   * SEO tag type.
   *
   *
   * Supported values: `title`, `meta`, `script`, `link`.
   */
  type?: InputMaybe<Scalars['String']>;
};

export enum ComWixpressAppserviceApiAppChangedEventAction {
  CREATED = 'CREATED',
  DELETED = 'DELETED',
  DEPRECATED = 'DEPRECATED',
  UPDATED = 'UPDATED'
}

export type ComWixpressAppserviceApiAppChangedEventInput = {
  action?: InputMaybe<ComWixpressAppserviceApiAppChangedEventAction>;
  app?: InputMaybe<ComWixpressAppserviceApiAppInput>;
  updatedFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressAppserviceApiAppInput = {
  /** Used to create signed instances/authenticate with oauth provider */
  appSecret?: InputMaybe<Scalars['String']>;
  /** application status calculated from app versions status */
  appStatus?: InputMaybe<Scalars['String']>;
  /** The type of App */
  classification?: InputMaybe<Scalars['String']>;
  /** The company id which the App belongs to */
  companyId?: InputMaybe<Scalars['String']>;
  /** represents all the contactEmails */
  contactEmails?: InputMaybe<ComWixpressAppserviceApiContactEmailsInput>;
  /** updates only one time, when the app is published for the first time */
  firstPublishDate?: InputMaybe<Scalars['String']>;
  /** if true, app will not show on the managed apps page */
  hideFromManagedApps?: InputMaybe<Scalars['Boolean']>;
  /** App's icon, to be displayed in UI */
  iconUrl?: InputMaybe<Scalars['String']>;
  /** The id of the app */
  id?: InputMaybe<Scalars['String']>;
  /** true if and ony if the app is archived */
  isArchived?: InputMaybe<Scalars['Boolean']>;
  /** Is it a core Wix app? */
  isCoreApp?: InputMaybe<Scalars['Boolean']>;
  /** Can the app be updated? */
  isEditable?: InputMaybe<Scalars['Boolean']>;
  /** Is it a Wix app? */
  isWixApp?: InputMaybe<Scalars['Boolean']>;
  /** App's latest GA version, formatted as xx.xx.xx */
  latestVersion?: InputMaybe<Scalars['String']>;
  /** The name of the App */
  name?: InputMaybe<Scalars['String']>;
  /** The namespace of the App */
  namespace?: InputMaybe<Scalars['String']>;
  /** The team id which the App belongs to */
  teamId?: InputMaybe<Scalars['String']>;
  /** Used to sign webhooks that are sent to tpas */
  webhooksPublicKey?: InputMaybe<Scalars['String']>;
};

export type ComWixpressAppserviceApiAppSlugChangedInput = {
  /** app id of the app with the changed slug */
  appId?: InputMaybe<Scalars['String']>;
  /** The slug of the app. A human readable identifier of the app */
  slug?: InputMaybe<Scalars['String']>;
};

export type ComWixpressAppserviceApiAppVersionStateChangedInput = {
  appId?: InputMaybe<Scalars['String']>;
  approved?: InputMaybe<Scalars['Void']>;
  archived?: InputMaybe<Scalars['Void']>;
  created?: InputMaybe<Scalars['Void']>;
  declined?: InputMaybe<Scalars['Void']>;
  draftChanged?: InputMaybe<Scalars['Void']>;
  /** If defined, only a partial snapshot of the app draft was updated */
  partialVersionOptions?: InputMaybe<ComWixpressAppserviceApiPartialVersionOptionsInput>;
  previousState?: InputMaybe<ComWixpressAppserviceApiVersionStatus>;
  published?: InputMaybe<Scalars['Void']>;
  released?: InputMaybe<Scalars['Void']>;
  submitted?: InputMaybe<Scalars['Void']>;
  version?: InputMaybe<Scalars['String']>;
};

export type ComWixpressAppserviceApiContactEmailsInput = {
  billingEmails?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  supportEmails?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  urgentEmails?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressAppserviceApiPartialVersionOptionsInput = {
  /** Include dev center draft changes in the submitted data */
  includeDraftDevCenterData?: InputMaybe<Scalars['Boolean']>;
  /** Include market listing draft data in the submitted data */
  includeDraftMarketListingData?: InputMaybe<Scalars['Boolean']>;
  /** Include pricing info draft data in the submitted data */
  includeDraftPricingInfoData?: InputMaybe<Scalars['Boolean']>;
};

export enum ComWixpressAppserviceApiVersionStatus {
  /** our team approved the version */
  APPROVED = 'APPROVED',
  /** the status for versions that are no longer relevant */
  ARCHIVED = 'ARCHIVED',
  /** our team did not accept this version of the app */
  DECLINED = 'DECLINED',
  /** a version which was created in the dev center and has not started the approval process yet */
  DRAFT = 'DRAFT',
  /** status for versions with no significant changes, e.g. for test app. for questions contact our team */
  HIDDEN = 'HIDDEN',
  /** the version is being reviewed by the app market team in cactus */
  IN_REVIEW = 'IN_REVIEW',
  /** default, internal use status. do not use */
  NONE_STATUS = 'NONE_STATUS',
  /** this version is published - only one version can be published at any given time; if this app was already published, the previously published version's status is now ARCHIVED */
  PUBLISHED = 'PUBLISHED',
  /** mark apps as RELEASED, without adding to the apps cache, and allow users to install */
  RELEASED = 'RELEASED',
  /** the version was submitted for review by the developer */
  SUBMITTED = 'SUBMITTED'
}

export type ComWixpressAuthorizationAbacManagementEventsPolicyRemovedFromContributorInput = {
  accountId?: InputMaybe<Scalars['String']>;
  metaSiteId?: InputMaybe<Scalars['String']>;
  policyIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressAuthorizationAbacManagementEventsPolicyUpdatedForContributorInput = {
  accountId?: InputMaybe<Scalars['String']>;
  metaSiteId?: InputMaybe<Scalars['String']>;
  newPolicyIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  oldPolicyIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressBiOctopusApiV1BiEventInput = {
  eventType?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['String']>;
};

export type ComWixpressBookingsAttendanceV2Attendance = {
  /** Corresponding booking ID. */
  bookingId?: Maybe<Scalars['String']>;
  /** Corresponding event ID. */
  eventId?: Maybe<Scalars['String']>;
  /** ID of the `attendance` object. */
  id?: Maybe<Scalars['String']>;
  /**
   * Total number of participants that attended the session. By default, the number
   * of attendees is set to `1`, but you can set a number to greater than `1` if multiple
   * participants attended.
   *
   * Do not set to `0` to indicate that no one attended the session. Instead, set the `status` field to `NOT_ATTENDED`.
   *
   * Default: 1
   */
  numberOfAttendees?: Maybe<Scalars['Int']>;
  /** Corresponding session ID. */
  sessionId?: Maybe<Scalars['String']>;
  /** Status indicating if any participants attended the session. */
  status?: Maybe<ComWixpressBookingsAttendanceV2AttendanceAttendanceStatus>;
  /** Date and time the attendance status was updated. */
  statusUpdatedDate?: Maybe<Scalars['String']>;
  /** Date and time the attendance was updated. */
  updatedDate?: Maybe<Scalars['String']>;
};

export enum ComWixpressBookingsAttendanceV2AttendanceAttendanceStatus {
  /** At least a single participant attended the session. */
  ATTENDED = 'ATTENDED',
  /** No participants attended the session. */
  NOT_ATTENDED = 'NOT_ATTENDED',
  /** There is no available attendance information. */
  NOT_SET = 'NOT_SET'
}

export type ComWixpressBookingsAttendanceV2AttendanceInput = {
  /** Corresponding booking ID. */
  bookingId?: InputMaybe<Scalars['String']>;
  /** Corresponding event ID. */
  eventId?: InputMaybe<Scalars['String']>;
  /** ID of the `attendance` object. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Total number of participants that attended the session. By default, the number
   * of attendees is set to `1`, but you can set a number to greater than `1` if multiple
   * participants attended.
   *
   * Do not set to `0` to indicate that no one attended the session. Instead, set the `status` field to `NOT_ATTENDED`.
   *
   * Default: 1
   */
  numberOfAttendees?: InputMaybe<Scalars['Int']>;
  /** Corresponding session ID. */
  sessionId?: InputMaybe<Scalars['String']>;
  /** Status indicating if any participants attended the session. */
  status?: InputMaybe<ComWixpressBookingsAttendanceV2AttendanceAttendanceStatus>;
  /** Date and time the attendance status was updated. */
  statusUpdatedDate?: InputMaybe<Scalars['String']>;
  /** Date and time the attendance was updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export type ComWixpressBookingsAttendanceV2BulkAttendanceResult = {
  /** Created or updated `attendance` object. */
  item?: Maybe<ComWixpressBookingsAttendanceV2Attendance>;
  /** Metadata for the created or updated `attendance` object. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressBookingsAttendanceV2BulkSetAttendanceRequestAttendanceDetailsInput = {
  /** Created or updated attendance information for a booking session. */
  attendance?: InputMaybe<ComWixpressBookingsAttendanceV2AttendanceInput>;
  /** Information about whether to send a message to the customer after their attendance was set. */
  participantNotification?: InputMaybe<ComWixpressBookingsAttendanceV2ParticipantNotificationInput>;
};

export type ComWixpressBookingsAttendanceV2BulkSetAttendanceRequestInput = {
  /** List of attendance details for booking sessions to create or update. */
  attendanceDetails?: InputMaybe<Array<InputMaybe<ComWixpressBookingsAttendanceV2BulkSetAttendanceRequestAttendanceDetailsInput>>>;
  returnFullEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressBookingsAttendanceV2BulkSetAttendanceResponse = {
  /** Information about the total number of successes and failures for the Bulk Set Attendance call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** List of created or updated `attendance` objects. */
  results?: Maybe<Array<Maybe<ComWixpressBookingsAttendanceV2BulkAttendanceResult>>>;
};

export type ComWixpressBookingsAttendanceV2CountAttendancesRequestInput = {
  /** Filter criteria for counting attendance records. If not provided, counts all attendance records for the contact. */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type ComWixpressBookingsAttendanceV2CountAttendancesResponse = {
  /** Total number of attendance records matching the filters. */
  count?: Maybe<Scalars['Int']>;
};

export type ComWixpressBookingsAttendanceV2GetAttendanceRequestInput = {
  id: Scalars['ID'];
};

export type ComWixpressBookingsAttendanceV2ParticipantNotificationInput = {
  /** Optional custom message to send to the participants about the changes to the booking. */
  message?: InputMaybe<Scalars['String']>;
  /**
   * Specify whether to send the message about the changes to the customer.
   *
   * Default: `false`
   */
  notifyParticipants?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressBookingsAttendanceV2QueryAttendanceRequestInput = {
  /** Query options. */
  query?: InputMaybe<ComWixpressBookingsAttendanceV2UpstreamWixCommonQueryV2Input>;
};

export type ComWixpressBookingsAttendanceV2QueryAttendanceResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressBookingsAttendanceV2Attendance>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressBookingsAttendanceV2SetAttendanceRequestInput = {
  /** Attendance to create or update. */
  attendance?: InputMaybe<ComWixpressBookingsAttendanceV2AttendanceInput>;
  /** Information about whether to send a message to a customer after their attendance was set. */
  participantNotification?: InputMaybe<ComWixpressBookingsAttendanceV2ParticipantNotificationInput>;
};

export type ComWixpressBookingsAttendanceV2SetAttendanceResponse = {
  /** Created or updated attendance. */
  attendance?: Maybe<ComWixpressBookingsAttendanceV2Attendance>;
};

export type ComWixpressBookingsAttendanceV2UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   *
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /**
   * Number of `Attendance` objects to return.
   *
   * Default: `50`
   * Maximum: `1000`
   */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressBookingsAttendanceV2UpstreamWixCommonQueryV2Input = {
  /**
   * Cursor token pointing to a page of results. In the first request,
   * specify `cursorPaging.limit`. For following requests, specify the
   * retrieved `cursorPaging.cursor` token and not `query.filter` or
   * `query.sort`.
   */
  cursorPaging?: InputMaybe<ComWixpressBookingsAttendanceV2UpstreamWixCommonCursorPagingInput>;
  /** Array of projected fields. A list of specific field names to return. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fieldsets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter object. See [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) for more information.
   *
   * For a detailed list of supported fields and operators, see [Supported Filters and Sorting](https://dev.wix.com/api/rest/wix-bookings/attendance/supported-filters).
   *
   * Max: 1 filter
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Paging options to limit and skip the number of items. */
  paging?: InputMaybe<WixCommonPagingInput>;
  /**
   * Sort object in the following format:
   * `[ {"fieldName":"sortField1","order":"ASC"}, {"fieldName":"sortField2","order":"DESC"} ]`
   *
   * For details about sorting, see [Supported Filters and Sorting](https://dev.wix.com/api/rest/wix-bookings/attendance/supported-filters).
   */
  sort?: InputMaybe<Array<InputMaybe<ComWixpressBookingsAttendanceV2UpstreamWixCommonSortingInput>>>;
};

export enum ComWixpressBookingsAttendanceV2UpstreamWixCommonSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type ComWixpressBookingsAttendanceV2UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<ComWixpressBookingsAttendanceV2UpstreamWixCommonSortOrder>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceBatchCreateResourceRequestInput = {
  /** Optional. If provided, the resources field is ignored. */
  batchedResources?: InputMaybe<Array<InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceCreateResourceRequestInput>>>;
  /** List of resource entities to create. */
  resources?: InputMaybe<Array<InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceResourceInput>>>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceBatchCreateResourceResponse = {
  /** List of the created resources. */
  resources?: Maybe<Array<Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceResource>>>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceBatchDeleteResourceRequestInput = {
  /** List of resource IDs to delete. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceBusinessLocation = {
  /** The ID of the business location. Has to be non-empty */
  locationId?: Maybe<Scalars['String']>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceBusinessLocationInput = {
  /** The ID of the business location. Has to be non-empty */
  locationId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceCreateResourceRequestInput = {
  /** Resource to create. */
  resource?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceResourceInput>;
  /**
   * List of schedules to be assigned for the created resource. Currently only a single schedule is allowed.
   * If provided, any schedules in the resource entity will be ignored.
   */
  schedules?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1ScheduleInput>>>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceCreateResourceResponse = {
  /** Created resource. */
  resource?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceResource>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceDeleteResourceRequestInput = {
  /** ID of the resource to delete. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceDeleteResourceResponse = {
  /** Deleted resource ID. */
  id?: Maybe<Scalars['String']>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceGetBusinessResourceRequestInput = {
  excludeSchedule?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceGetBusinessResourceResponse = {
  /** The business resource. */
  resource?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceResource>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceLinkResourceToUserRequestInput = {
  /** The id of the resource to link. */
  resourceId?: InputMaybe<Scalars['String']>;
  /** The email address of the Wix user to link. This field is only intended for internal as it is needed to proxy the request to StaffMembersService. */
  userEmail?: InputMaybe<Scalars['String']>;
  /** The id of Wix user to link. */
  userId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceLinkResourceToUserResponse = {
  /** The updated resource. */
  resource?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceResource>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceListResourcesRequestInput = {
  query?: InputMaybe<ComWixBookingsUpstreamWixCommonQueryInput>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceListResourcesResponse = {
  metadata?: Maybe<ComWixBookingsCommonApiV1QueryMetaData>;
  pagingMetadata?: Maybe<WixCommonPagingMetadataV2>;
  /** List of resources matching the query object. */
  resources?: Maybe<Array<Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceResource>>>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceQueryResourcesRequestInput = {
  /** Whether to include resources with non-empty group in response. False by default. */
  includeResourcesWithGroups?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<ComWixBookingsUpstreamWixCommonQueryV2Input>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceQueryResourcesResponse = {
  pagingMetadata?: Maybe<WixCommonPagingMetadataV2>;
  /** List of resources matching the query object. */
  resources?: Maybe<Array<Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceResource>>>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceResource = {
  /**
   * True if the resource is available in all locations, false if the resource is available only in a specific business location. Empty if `has_working_hours_schedule` is true.
   * Information on the location(s) can then be found in the sessions of one of the connected schedules.
   */
  availableInAllLocations?: Maybe<Scalars['Boolean']>;
  /** Information about business location connected to the resource. Should be empty if `available_in_all_locations` is true or if no business location exists in OS. */
  businessLocation?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceBusinessLocation>;
  /** Resource description. */
  description?: Maybe<Scalars['String']>;
  /** Resource email address. */
  email?: Maybe<Scalars['String']>;
  /**
   * This schedule contains the sessions in which this resource is booked.
   * Equals to the first element of `schedules` array.
   */
  eventsSchedule?: Maybe<ComWixBookingsSchedulesApiV1Schedule>;
  /** The ID of the Resource Group that this resource belongs to. This is an optional field as not every resource is part of a group. */
  groupId?: Maybe<Scalars['String']>;
  /**
   * This field determines how to resolve the working hours of this resource. Defaults to `true` if was not set by the client.
   * When set to `true` then working hours (including location information) can be found in the sessions of a schedule that is connected to this resource.
   * If `false`, then the working hours are not specified as sessions of a connected schedule. Instead this resource is then by definition full-time available (7 x 24).
   */
  hasWorkingHoursSchedule?: Maybe<Scalars['Boolean']>;
  /** Resource ID. */
  id?: Maybe<Scalars['String']>;
  /** Resource images. */
  images?: Maybe<Array<Maybe<WixCommonImage>>>;
  /** Resource name. */
  name?: Maybe<Scalars['String']>;
  /** Resource phone number. */
  phone?: Maybe<Scalars['String']>;
  /** List of IDs of schedules owned by this resource. */
  scheduleIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Deprecated. Please use scheduleIds. List of the schedules owned by this resource. Min size 1. */
  schedules?: Maybe<Array<Maybe<ComWixBookingsSchedulesApiV1Schedule>>>;
  /** Resource status. Default: `CREATED`. */
  status?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceResourceResourceStatus>;
  /** Deprecated. Please use tags. */
  tag?: Maybe<Scalars['String']>;
  /** Resource tags. Tags are used to identify, group, and filter the different types of resources. For example, 'staff' or 'room'. */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * The type of of the resource. Currently this field is only filled for staff and will contain the ID as configured in the
   * BOOKINGS_RESOURCE_TYPES component of the Bookings app.
   */
  type?: Maybe<Scalars['String']>;
  /**
   * Wix user ID, if the resource is associated with the Wix user.
   * A staff member resource can be associated with a Wix user via assignment of a permissions role in the business manager.
   */
  wixUserId?: Maybe<Scalars['String']>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceResourceInput = {
  /**
   * True if the resource is available in all locations, false if the resource is available only in a specific business location. Empty if `has_working_hours_schedule` is true.
   * Information on the location(s) can then be found in the sessions of one of the connected schedules.
   */
  availableInAllLocations?: InputMaybe<Scalars['Boolean']>;
  /** Information about business location connected to the resource. Should be empty if `available_in_all_locations` is true or if no business location exists in OS. */
  businessLocation?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceBusinessLocationInput>;
  /** Resource description. */
  description?: InputMaybe<Scalars['String']>;
  /** Resource email address. */
  email?: InputMaybe<Scalars['String']>;
  /**
   * This schedule contains the sessions in which this resource is booked.
   * Equals to the first element of `schedules` array.
   */
  eventsSchedule?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleInput>;
  /** The ID of the Resource Group that this resource belongs to. This is an optional field as not every resource is part of a group. */
  groupId?: InputMaybe<Scalars['String']>;
  /**
   * This field determines how to resolve the working hours of this resource. Defaults to `true` if was not set by the client.
   * When set to `true` then working hours (including location information) can be found in the sessions of a schedule that is connected to this resource.
   * If `false`, then the working hours are not specified as sessions of a connected schedule. Instead this resource is then by definition full-time available (7 x 24).
   */
  hasWorkingHoursSchedule?: InputMaybe<Scalars['Boolean']>;
  /** Resource ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Resource images. */
  images?: InputMaybe<Array<InputMaybe<WixCommonImageInput>>>;
  /** Resource name. */
  name?: InputMaybe<Scalars['String']>;
  /** Resource phone number. */
  phone?: InputMaybe<Scalars['String']>;
  /** List of IDs of schedules owned by this resource. */
  scheduleIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Deprecated. Please use scheduleIds. List of the schedules owned by this resource. Min size 1. */
  schedules?: InputMaybe<Array<InputMaybe<ComWixBookingsSchedulesApiV1ScheduleInput>>>;
  /** Resource status. Default: `CREATED`. */
  status?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceResourceResourceStatus>;
  /** Deprecated. Please use tags. */
  tag?: InputMaybe<Scalars['String']>;
  /** Resource tags. Tags are used to identify, group, and filter the different types of resources. For example, 'staff' or 'room'. */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * The type of of the resource. Currently this field is only filled for staff and will contain the ID as configured in the
   * BOOKINGS_RESOURCE_TYPES component of the Bookings app.
   */
  type?: InputMaybe<Scalars['String']>;
  /**
   * Wix user ID, if the resource is associated with the Wix user.
   * A staff member resource can be associated with a Wix user via assignment of a permissions role in the business manager.
   */
  wixUserId?: InputMaybe<Scalars['String']>;
};

export enum ComWixpressBookingsResourcesCoreApiV1ResourceResourceNotificationEvent {
  /** The resource was created. */
  Created = 'Created',
  /** The resource was deleted. */
  Deleted = 'Deleted',
  /** The schedule was updated. */
  Schedule_Updated = 'Schedule_Updated',
  /** Undefined resource event. */
  UNDEFINED = 'UNDEFINED',
  /** The resource was updated. */
  Updated = 'Updated'
}

export type ComWixpressBookingsResourcesCoreApiV1ResourceResourceNotificationInput = {
  /** Event type. */
  event?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceResourceNotificationEvent>;
  /**
   * Updated resource entity.
   * 'resource.schedules' is deprecated and will not be returned. Please use 'resource.scheduleIds' instead.
   */
  resource?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceResourceInput>;
};

export enum ComWixpressBookingsResourcesCoreApiV1ResourceResourceResourceStatus {
  /** The resource was created. */
  CREATED = 'CREATED',
  /** The resource was deleted. */
  DELETED = 'DELETED',
  /** Undefined resource status. */
  UNDEFINED = 'UNDEFINED',
  /** The resource was updated. */
  UPDATED = 'UPDATED'
}

export type ComWixpressBookingsResourcesCoreApiV1ResourceUnLinkResourceFromOwnerRequestInput = {
  /** The id of the resource to unlink. */
  resourceId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceUnLinkResourceFromOwnerResponse = {
  /** The updated resource. */
  resource?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceResource>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceUpdateResourceRequestInput = {
  /** Field mask of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Resource to update. */
  resource?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceResourceInput>;
  /**
   * Actions to perform on the resources schedules. Can contain schedules to create, update, and cancel.
   * Either the 'schedules' or 'schedule_actions' should be specified but not both. If both are provided, the schedules in the resource entity is ignored.
   */
  scheduleActions?: InputMaybe<ComWixBookingsSchedulesApiV1BatchRequestInput>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceUpdateResourceResponse = {
  /** Updated resource. */
  resource?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceResource>;
  /** Updated schedules. */
  schedules?: Maybe<ComWixBookingsSchedulesApiV1BatchResponse>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceUpdateScheduleRequestInput = {
  /** Fieldmask for schedule */
  fieldmask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Resource ID to update. */
  resourceId?: InputMaybe<Scalars['String']>;
  /** Schedule to update. */
  schedule?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleInput>;
};

export type ComWixpressBookingsResourcesCoreApiV1ResourceUpdateScheduleResponse = {
  /** Updated schedule. */
  schedule?: Maybe<ComWixBookingsSchedulesApiV1Schedule>;
};

export type ComWixpressBookingsServicesApiV1BookingPolicyInput = {
  /** Minimum number of minutes before the start of a session that a booking can be made. For a schedule, this is relative to the start time of the next session, excluding past sessions. Default value is taken form BusinessServicesPolicy. */
  bookUpToXMinutesBefore?: InputMaybe<Scalars['Int']>;
  /** Bookings approval policy for the service. Empty by default. */
  bookingsApprovalPolicy?: InputMaybe<ComWixpressBookingsServicesApiV1BookingsApprovalPolicyInput>;
  /** Minimum number of minutes before the start of a session that a booking can be canceled or rescheduled. Default value is taken form BusinessServicesPolicy. */
  cancelRescheduleUpToXMinutesBefore?: InputMaybe<Scalars['Int']>;
  /** User defined cancellation policy message. */
  cancellationPolicy?: InputMaybe<Scalars['String']>;
  /** How far in advance a booking can be made. Default value is taken form BusinessServicesPolicy. */
  futureBookingsPolicy?: InputMaybe<ComWixpressBookingsServicesApiV1FutureBookingPolicyInput>;
  /** Whether online booking is available. Defaults to true. */
  isBookOnlineAllowed?: InputMaybe<Scalars['Boolean']>;
  /** Whether bookings for the service can be canceled. Defaults to true. */
  isCancelAllowed?: InputMaybe<Scalars['Boolean']>;
  /** Whether bookings for the service can be rescheduled. Defaults to true. */
  isRescheduleAllowed?: InputMaybe<Scalars['Boolean']>;
  /** Maximum number of participants for a single booking. Defaults to 1. */
  maxParticipantsPerBooking?: InputMaybe<Scalars['Int']>;
  /**
   * A list of booking policy field names of fields that override the respective values of the default business booking policy.
   * Currently only 'service.policy.bookUpToXMinutesBefore' field is supported
   */
  overrideBusinessPolicyFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Waitlist policy for the service. Default value is taken form BusinessServicesPolicy. */
  waitingListPolicy?: InputMaybe<ComWixpressBookingsServicesApiV1WaitingListPolicyInput>;
};

export type ComWixpressBookingsServicesApiV1BookingsApprovalPolicyInput = {
  /** Whether bookings to the service require approval. */
  isBusinessApprovalRequired?: InputMaybe<Scalars['Boolean']>;
  /** Whether the booking requests affect the session or slot availability. For example, 3 booking requests for a 10-person session will cause the session to have 7 available spots, before the requests are approved. */
  requestsAffectsAvailability?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressBookingsServicesApiV1BusinessServicesPolicy = {
  /** Minimum amount of time to make a booking before the start of the booked item. For sessions, this is relative to the start time of the session. For schedules, this is relative to the start time of the first session, excluding past sessions. Defaults to 0. */
  bookUpToXMinutesBefore?: Maybe<Scalars['Int']>;
  /** Minimum time that a booking can be canceled or rescheduled before the session starts. Defaults to 0. */
  cancelRescheduleUpToXMinutesBefore?: Maybe<Scalars['Int']>;
  /** User defined cancellation policy message. */
  cancellationPolicy?: Maybe<Scalars['String']>;
  /** An object specifying how far in advance a booking can be made. */
  futureBookingsPolicy?: Maybe<ComWixpressBookingsServicesApiV1FutureBookingPolicy>;
  /** Waitlist policy for the service. Empty by default. */
  waitingListPolicy?: Maybe<ComWixpressBookingsServicesApiV1WaitingListPolicy>;
};

export type ComWixpressBookingsServicesApiV1BusinessServicesPolicyInput = {
  /** Minimum amount of time to make a booking before the start of the booked item. For sessions, this is relative to the start time of the session. For schedules, this is relative to the start time of the first session, excluding past sessions. Defaults to 0. */
  bookUpToXMinutesBefore?: InputMaybe<Scalars['Int']>;
  /** Minimum time that a booking can be canceled or rescheduled before the session starts. Defaults to 0. */
  cancelRescheduleUpToXMinutesBefore?: InputMaybe<Scalars['Int']>;
  /** User defined cancellation policy message. */
  cancellationPolicy?: InputMaybe<Scalars['String']>;
  /** An object specifying how far in advance a booking can be made. */
  futureBookingsPolicy?: InputMaybe<ComWixpressBookingsServicesApiV1FutureBookingPolicyInput>;
  /** Waitlist policy for the service. Empty by default. */
  waitingListPolicy?: InputMaybe<ComWixpressBookingsServicesApiV1WaitingListPolicyInput>;
};

export type ComWixpressBookingsServicesApiV1CategoryInput = {
  /** Custom properties that can be associated with the category. */
  customProperties?: InputMaybe<Scalars['JSON']>;
  /** Category ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Category name. */
  name?: InputMaybe<Scalars['String']>;
  /** Sort order of the category in the live site and dashboard. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /**
   * Category status.
   *
   * Default: `CREATED`
   */
  status?: InputMaybe<ComWixpressBookingsServicesApiV1CategoryStatus>;
};

export enum ComWixpressBookingsServicesApiV1CategoryNotificationEvent {
  /** Category was created. */
  Created = 'Created',
  /** Category was deleted. */
  Deleted = 'Deleted',
  /** Category was updated. */
  Updated = 'Updated'
}

export type ComWixpressBookingsServicesApiV1CategoryNotificationInput = {
  category?: InputMaybe<ComWixpressBookingsServicesApiV1CategoryInput>;
  event?: InputMaybe<ComWixpressBookingsServicesApiV1CategoryNotificationEvent>;
};

export enum ComWixpressBookingsServicesApiV1CategoryStatus {
  /** The category was created. */
  CREATED = 'CREATED',
  /** The category was deleted. */
  DELETED = 'DELETED'
}

export type ComWixpressBookingsServicesApiV1DeleteMetadataInput = {
  participantNotification?: InputMaybe<ComWixBookingsSchedulesApiV1ParticipantNotificationInput>;
  preserveFutureSessionsWithParticipants?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressBookingsServicesApiV1FutureBookingPolicy = {
  /** How far in advance, in minutes, a session can be booked. Defaults to 10,080 minutes (3 days). */
  limitXMinutesToTheFuture?: Maybe<Scalars['Int']>;
  /** Whether a limit is imposed on advance bookings. */
  shouldLimit?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressBookingsServicesApiV1FutureBookingPolicyInput = {
  /** How far in advance, in minutes, a session can be booked. Defaults to 10,080 minutes (3 days). */
  limitXMinutesToTheFuture?: InputMaybe<Scalars['Int']>;
  /** Whether a limit is imposed on advance bookings. */
  shouldLimit?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressBookingsServicesApiV1GetPolicyResponse = {
  /** Service policy. */
  policy?: Maybe<ComWixpressBookingsServicesApiV1BusinessServicesPolicy>;
};

export type ComWixpressBookingsServicesApiV1MediaInput = {
  /** Cover image associated with the service. */
  coverMedia?: InputMaybe<ComWixpressBookingsServicesApiV1MediaItemInput>;
  /** Images associated with the service. */
  items?: InputMaybe<Array<InputMaybe<ComWixpressBookingsServicesApiV1MediaItemInput>>>;
  /** Primary image associated with the service. */
  mainMedia?: InputMaybe<ComWixpressBookingsServicesApiV1MediaItemInput>;
};

export type ComWixpressBookingsServicesApiV1MediaItemInput = {
  /** Image metadata. */
  image?: InputMaybe<WixCommonImageInput>;
};

export type ComWixpressBookingsServicesApiV1PaymentOptionsInput = {
  /** Whether a booking made for the service can be paid in a customized way, defined by the API. */
  custom?: InputMaybe<Scalars['Boolean']>;
  /** Whether a booking made for the service can be paid using Wix Pricing Plans. */
  wixPaidPlan?: InputMaybe<Scalars['Boolean']>;
  /** Whether a booking made for the service can be paid in person. */
  wixPayInPerson?: InputMaybe<Scalars['Boolean']>;
  /** Whether a booking made for the service can be paid online through Wix. */
  wixPayOnline?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressBookingsServicesApiV1ServiceInfoInput = {
  /** Service description. */
  description?: InputMaybe<Scalars['String']>;
  /** Images associated with the service. Deprecated. */
  images?: InputMaybe<Array<InputMaybe<WixCommonImageInput>>>;
  /** Images associated with the service. Optional. Not supported yet. */
  media?: InputMaybe<ComWixpressBookingsServicesApiV1MediaInput>;
  /** Service name. */
  name?: InputMaybe<Scalars['String']>;
  /** Short service description. */
  tagLine?: InputMaybe<Scalars['String']>;
};

export type ComWixpressBookingsServicesApiV1ServiceInput = {
  /** Advanced SEO data */
  advancedSeoData?: InputMaybe<ComWixpressAdvancedSeoSeoSchemaInput>;
  /** ID of the form that visitors fill out when booking the service. */
  bookingFormId?: InputMaybe<Scalars['String']>;
  /** ID of the category to which the service belongs. */
  categoryId?: InputMaybe<Scalars['String']>;
  /** Set of custom properties for the service. */
  customProperties?: InputMaybe<Scalars['JSON']>;
  /** Service ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Whether a conference is to be generated for the service. */
  includeConferenceOption?: InputMaybe<Scalars['Boolean']>;
  /** Information about the service. */
  info?: InputMaybe<ComWixpressBookingsServicesApiV1ServiceInfoInput>;
  /** Payment options available for use when booking the service. */
  paymentOptions?: InputMaybe<ComWixpressBookingsServicesApiV1PaymentOptionsInput>;
  /** Description of the bookings policy for the service. */
  policy?: InputMaybe<ComWixpressBookingsServicesApiV1BookingPolicyInput>;
  /**
   * List of schedule IDs for the sessions and slots that can be booked for the service.
   * The list can include schedules with any `status` values, however the Bookings application only uses the schedules with a `status` of `"CREATED"`. There is only one schedule with a status of `"CREATED"` per service. The ID of that schedule must always be the first in the list.
   */
  scheduleIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** SEO data */
  seoData?: InputMaybe<ComWixpressAdvancedSeoSeoSchemaInput>;
  /** Sort order of the service within its category. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Service status. */
  status?: InputMaybe<ComWixpressBookingsServicesApiV1ServiceStatus>;
};

export enum ComWixpressBookingsServicesApiV1ServiceNotificationEvent {
  Created = 'Created',
  Deleted = 'Deleted',
  Unspecified = 'Unspecified',
  Updated = 'Updated'
}

export type ComWixpressBookingsServicesApiV1ServiceNotificationInput = {
  deleteMetadata?: InputMaybe<ComWixpressBookingsServicesApiV1DeleteMetadataInput>;
  event?: InputMaybe<ComWixpressBookingsServicesApiV1ServiceNotificationEvent>;
  policy?: InputMaybe<ComWixpressBookingsServicesApiV1BusinessServicesPolicyInput>;
  /** Updated service entity. */
  service?: InputMaybe<ComWixpressBookingsServicesApiV1ServiceInput>;
};

export enum ComWixpressBookingsServicesApiV1ServiceStatus {
  /** The default service status. */
  CREATED = 'CREATED',
  /** The service is deleted. */
  DELETED = 'DELETED'
}

export type ComWixpressBookingsServicesApiV1UpdatePolicyRequestInput = {
  /** Service policy. */
  policy?: InputMaybe<ComWixpressBookingsServicesApiV1BusinessServicesPolicyInput>;
};

export type ComWixpressBookingsServicesApiV1WaitingListPolicy = {
  /** Number of spots available in the waitlist. Defaults to 10 spots. */
  capacity?: Maybe<Scalars['Int']>;
  /** Whether waitlisting is enabled for the service. */
  isEnabled?: Maybe<Scalars['Boolean']>;
  /** Amount of time a participant is given to book, once notified that a spot is available. Defaults to 10 minutes. */
  timeWindowMinutes?: Maybe<Scalars['Int']>;
};

export type ComWixpressBookingsServicesApiV1WaitingListPolicyInput = {
  /** Number of spots available in the waitlist. Defaults to 10 spots. */
  capacity?: InputMaybe<Scalars['Int']>;
  /** Whether waitlisting is enabled for the service. */
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Amount of time a participant is given to book, once notified that a spot is available. Defaults to 10 minutes. */
  timeWindowMinutes?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationInput = {
  /** Fields by which to group items for the aggregation. If empty, the aggregation is carried out on all items in the collection. */
  groupingFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Operations to carry out on the data in each grouping. */
  operations?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationInput>>>;
};

export type ComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationAverageInput = {
  /** Name of the field for which to calculate the average value. */
  itemFieldName?: InputMaybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationInput = {
  /** Calculate the average value of a specified field for all items in the grouping. */
  average?: InputMaybe<ComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationAverageInput>;
  /** Calculate the number of items in the grouping. */
  itemCount?: InputMaybe<Scalars['Void']>;
  /** Calculate the maximum value of a specified field for all items in the grouping. */
  max?: InputMaybe<ComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationMaxInput>;
  /** Calculate the minimum value of a specified field for all items in the grouping. */
  min?: InputMaybe<ComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationMinInput>;
  /** Name of the field containing results of the operation. */
  resultFieldName?: InputMaybe<Scalars['String']>;
  /** Calculate the sum of values of a specified field for all items in the grouping. */
  sum?: InputMaybe<ComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationSumInput>;
};

export type ComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationMaxInput = {
  /** Name of the field for which to calculate the maximum value. */
  itemFieldName?: InputMaybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationMinInput = {
  /** Name of the field for which to calculate the minimum value. */
  itemFieldName?: InputMaybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationOperationSumInput = {
  /** Name of the field for which to calculate the sum. */
  itemFieldName?: InputMaybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataAggregateDataItemsRequestInput = {
  /** Aggregation applied to the data. */
  aggregation?: InputMaybe<ComWixpressCloudDataApiDataAggregateDataItemsRequestAggregationInput>;
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional parameters specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying.
   *
   * When querying the Wix Stores [Products collection](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-e-commerce-stores/wix-stores-products-collection-fields), pass the following optional parameters:
   * - `includeHiddenProducts`: Whether to include hidden products in the response. Default: `false`.
   * - `includeVariants`: Whether to include product variants in the query. Default: `false`.
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /**
   * Whether to retrieve data from the primary database instance.
   * This decreases performance but ensures data retrieved is up to date even immediately after an update.
   * Learn more about [Wix Data and eventual consistency](https://dev.wix.com/api/rest/wix-data/wix-data/eventual-consistency).
   *
   * Default: `false`
   */
  consistentRead?: InputMaybe<Scalars['Boolean']>;
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonCursorPagingInput>;
  /** ID of the collection on which to run the aggregation. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /**
   * Filter applied to the processed data following the aggregation. See [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language#getting-started_api-query-language_the-filter-section) for information on how to structure a filter object.
   * **Note:** The values you provide for each filter field must adhere to that field's type. For example, when filtering by a field whose type is Date and Time, use an object in the following format: `"someDateAndTimeFieldKey": { "$date": "YYYY-MM-DDTHH:mm:ss.sssZ"}`. Learn more about [data types in Wix Data](https://dev.wix.com/docs/rest/business-solutions/cms/data-items/data-types-in-wix-data).
   */
  finalFilter?: InputMaybe<Scalars['JSON']>;
  /**
   * Filter applied to the collection's data prior to running the aggregation. See [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language#getting-started_api-query-language_the-filter-section) for information on how to structure a filter object.
   *
   * **Note:** The values you provide for each filter field must adhere to that field's type. For example, when filtering by a field whose type is Date and Time, use an object in the following format: `"someDateAndTimeFieldKey": { "$date": "YYYY-MM-DDTHH:mm:ss.sssZ"}`. Learn more about [data types in Wix Data](https://dev.wix.com/docs/rest/business-solutions/cms/data-items/data-types-in-wix-data).
   */
  initialFilter?: InputMaybe<Scalars['JSON']>;
  /**
   * Language to run the aggregation on, in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   *
   * If not provided, the aggregation runs on items in the default language.
   *
   * > **Note:** The site must have [Wix Multilingual](https://www.wix.com/app-market/wix-multilingual) installed, and translation for the specified language must be enabled for the collection.
   *
   * Learn more about [Using Wix Multilingual to Translate CMS Content](https://support.wix.com/en/article/wix-multilingual-translating-cms-collection-content).
   */
  language?: InputMaybe<Scalars['String']>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /** Paging options to limit and skip the number of items. */
  paging?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonPagingInput>;
  /**
   * Options for the Publish plugin.
   * This plugin allows items in a [data collection](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/data-collection-object) to be marked as draft or published. Published items are visible to site visitors, while draft items are not.
   */
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataPublishPluginOptionsInput>;
  /**
   * Whether to return the total count in the response for a query with offset paging.
   * When `true`, the `pagingMetadata` object in the response contains a `total` field.
   *
   * Default: `false`
   */
  returnTotalCount?: InputMaybe<Scalars['Boolean']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonSortingInput>>>;
};

export type ComWixpressCloudDataApiDataAggregateDataItemsResponse = {
  /** Paging information. */
  pagingMetadata?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonPagingMetadataV2>;
  /** Aggregation results. */
  results?: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorAvgInput = {
  /**
   * Expression to calculate the group's average value.
   *
   * Expression must resolve to a number.
   */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorFirstInput = {
  /** Expression to find the first item in the group. */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorInput = {
  /** Calculates the average value across all items in the group based on the specified expression. */
  avg?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorAvgInput>;
  /** Finds the first item in the group. */
  first?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorFirstInput>;
  /** Finds the last item in the group. */
  last?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorLastInput>;
  /** Finds the maximum value across all items in the group. */
  max?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorMaxInput>;
  /** Finds the minimum value across all items in the group. */
  min?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorMinInput>;
  /** Collects values from all items in the group into an array. */
  push?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorPushInput>;
  /** Field key in the output item to store the result in. */
  resultFieldName?: InputMaybe<Scalars['String']>;
  /** Calculates the sum of the specified expression across all items in the group. */
  sum?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorSumInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorLastInput = {
  /** Expression to find the last item in the group. */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorMaxInput = {
  /**
   * Expression to find the group's maximum value.
   *
   * Expression must resolve to a comparable value, such as a number or string.
   */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorMinInput = {
  /**
   * Expression to find the group's minimum value.
   *
   * Expression must resolve to a comparable value, such as a number or string.
   */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorPushInput = {
  /** Expression to collect items into an array. */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorSumInput = {
  /**
   * Expression to calculate the group's total sum.
   *
   * Expression must resolve to a number.
   */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAggregationPipelineInput = {
  /**
   * Cursor token referring to a page of results.
   *
   * Not used in the first request. Subsequent requests use the cursor token and not `filter` or `sort`.
   */
  cursorPaging?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonCursorPagingInput>;
  /**
   * Paging options to limit and skip the number of results.
   *
   * Learn more about [sorting and paging](https://dev.wix.com/docs/rest/articles/get-started/sorting-and-paging).
   */
  paging?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonPagingInput>;
  /**
   * Sequence of aggregation operations to apply to the data.
   *
   * Stages are processed in order, with each stage operating on the output of the previous stage.
   */
  stages?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestStageInput>>>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionAbsOperationInput = {
  /**
   * Expression to find the absolute value of.
   *
   * Expression must resolve to a number.
   */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionAddOperationInput = {
  /**
   * Expressions to add together.
   *
   * All expressions must resolve to numbers.
   */
  expressions?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>>>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionCeilOperationInput = {
  /**
   * Expression to round up to the nearest whole number.
   *
   * Expression must resolve to a number.
   */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionConcatOperationInput = {
  /**
   * Expressions to join together.
   *
   * All expressions must resolve to strings.
   */
  expressions?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>>>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionDivideOperationInput = {
  /**
   * Expression to divide by `secondExpression`.
   *
   * Expression must resolve to a number.
   */
  firstExpression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
  /**
   * Expression to divide `firstExpression` by.
   *
   * Expression must resolve to a non-zero number.
   */
  secondExpression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionFloorOperationInput = {
  /**
   * Expression to round down to the nearest whole number.
   *
   * Expression must resolve to a number.
   */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput = {
  /** Finds the absolute value of an expression. */
  abs?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionAbsOperationInput>;
  /** Adds the specified expressions together. */
  add?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionAddOperationInput>;
  /** Rounds an expression up to the nearest whole number. */
  ceil?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionCeilOperationInput>;
  /** Joins multiple expressions together to create a string. */
  concat?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionConcatOperationInput>;
  /** Divides 1 expression by another. */
  divide?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionDivideOperationInput>;
  /**
   * Path to the field containing the value to resolve.
   *
   * Use dot notation to specify nested fields. For example, `user.name` or `product.price`.
   */
  fieldPath?: InputMaybe<Scalars['String']>;
  /** Rounds an expression down to the nearest whole number. */
  floor?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionFloorOperationInput>;
  /** Finds the length of a string expression. */
  length?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionLengthOperationInput>;
  /** Finds the remainder when dividing 1 expression by another. */
  mod?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionModOperationInput>;
  /** Multiplies multiple expressions together. */
  multiply?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionMultiplyOperationInput>;
  /** Number value. */
  numeric?: InputMaybe<Scalars['Float']>;
  /** Converts an expression to a string. */
  stringify?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionStringifyOperationInput>;
  /** Extracts a portion of a string expression. */
  substring?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSubstringOperationInput>;
  /** Subtracts 1 expression from another. */
  subtract?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSubtractOperationInput>;
  /** Calculates the total sum of multiple expressions. */
  sum?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSumOperationInput>;
  /** Text value. */
  text?: InputMaybe<Scalars['String']>;
  /** Converts an expression to lowercase. */
  toLower?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionToLowerOperationInput>;
  /** Converts an expression to uppercase. */
  toUpper?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionToUpperOperationInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionLengthOperationInput = {
  /**
   * Expression to count the total number of characters of.
   *
   * Expression must resolve to a string.
   */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionModOperationInput = {
  /**
   * Expression to divide by `secondExpression` to find the remainder.
   *
   * Expression must resolve to a number.
   */
  firstExpression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
  /**
   * Expression to divide `firstExpression` by.
   *
   * Expression must resolve to a non-zero number.
   */
  secondExpression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionMultiplyOperationInput = {
  /**
   * Expressions to multiply.
   *
   * All expressions must resolve to numbers.
   */
  expressions?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>>>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionStringifyOperationInput = {
  /** Expression to convert to a string. */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSubstringOperationInput = {
  /**
   * Expression to extract a substring from.
   *
   * Expression must resolve to a string.
   */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
  /**
   * Number of characters to extract from the starting position.
   *
   * Expression must resolve to a number.
   */
  lengthExpression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
  /**
   * Starting position of the substring to extract, specified in zero-based indexing.
   *
   * Expression must resolve to a number.
   */
  startExpression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSubtractOperationInput = {
  /**
   * Expression to subtract `secondExpression` from.
   *
   * Expression must resolve to a number.
   */
  firstExpression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
  /**
   * Expression to subtract from `firstExpression`.
   *
   * Expression must resolve to a number.
   */
  secondExpression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionSumOperationInput = {
  /**
   * Expressions to calculate the total sum of.
   *
   * All expressions must resolve to numbers.
   */
  expressions?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>>>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionToLowerOperationInput = {
  /**
   * Expression to convert to lowercase.
   *
   * Expression must resolve to a string.
   */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionToUpperOperationInput = {
  /**
   * Expression to convert to uppercase.
   *
   * Expression must resolve to a string.
   */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestGroupGroupIdInput = {
  /** Expression to determine the grouping value. Items whose expression resolves to the same value are grouped together in the result item's `_id` property. */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
  /**
   * Name of the field to group items by.
   *
   * This becomes the field name in the result's `_id` property.
   */
  key?: InputMaybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestGroupInput = {
  /**
   * Accumulation operations to run on each group.
   *
   * Accumulators aggregate data across all items in the group and return the result in a new field.
   *
   * > **Note:** When using accumulators, the type of expression must be compatible with the operation type. For example, when using the `sum` accumulator, the specified expression must resolve to a number.
   */
  accumulators?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAccumulatorInput>>>;
  /**
   * Grouping criteria by which to organize items.
   *
   * Each `groupId` specifies a field by which to group items, and serves as the result item's unique `_id` property.
   *
   * Items with identical values for the specified `expression` are placed in the same group based on the specified `key`. If empty, all items are treated as a single group.
   */
  groupIds?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestGroupGroupIdInput>>>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestInput = {
  /** Grid app ID. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional parameters specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying.
   *
   * Learn more about [querying Wix app collections](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-app-collections/querying-wix-app-collections).
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /**
   * Whether to read from the primary database for the most current data.
   *
   * This decreases performance but ensures data retrieved is up to date even immediately after an update.
   *
   * Learn more about [Wix Data and eventual consistency](https://dev.wix.com/api/rest/wix-data/wix-data/eventual-consistency).
   *
   * Default: `false`.
   */
  consistentRead?: InputMaybe<Scalars['Boolean']>;
  /** ID of the collection to run the aggregation pipeline on. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Environment: `LIVE` or `SANDBOX`. */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /**
   * Language to run the aggregation in, in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   *
   * When provided, the aggregation runs on items in the specified language. When not provided, the aggregation runs on items in the default language.
   *
   * > **Note:** The Wix user must enable translation for the specified language in [Wix Multilingual](https://www.wix.com/app-market/wix-multilingual).
   *
   * Learn more about [using Wix Multilingual to translate CMS content](https://support.wix.com/en/article/wix-multilingual-translating-cms-collection-content).
   */
  language?: InputMaybe<Scalars['String']>;
  /** Aggregation pipeline configuration containing stages and paging options. */
  pipeline?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestAggregationPipelineInput>;
  /**
   * Options for the Publish plugin.
   *
   * This plugin allows items in a [data collection](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/data-collection-object) to be marked as draft or published. Published items are visible to site visitors, while draft items aren't.
   */
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataPublishPluginOptionsInput>;
  /**
   * Whether to return the total result count when running a query with offset paging. When `true`, the `pagingMetadata` property in the response contains a `total` field.
   *
   * Learn more about [offset paging](https://dev.wix.com/docs/rest/articles/get-started/sorting-and-paging#paging).
   *
   * Default: `false`.
   */
  returnTotalCount?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestObjectToArrayInput = {
  /**
   * Key of the new array to create in the result item.
   *
   * Learn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).
   */
  destinationFieldName?: InputMaybe<Scalars['String']>;
  /**
   * Key of the object field to convert to an array.
   *
   * Use dot notation to specify nested fields. For example, `user.name` or `product.price`. Learn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).
   */
  objectFieldName?: InputMaybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionExcludeInput = {
  /**
   * Key of the field to exclude from the result.
   *
   * Use dot notation to specify nested fields. For example, `user.name` or `product.price`. Learn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).
   */
  fieldName?: InputMaybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionFieldInput = {
  /** When specified, excludes the specified field from the result. All other fields are included. */
  exclude?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionExcludeInput>;
  /** When specified, includes only the specified field in the result. All other fields are excluded. */
  include?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionIncludeInput>;
  /** Creates nested fields by including, excluding, or reshaping fields. */
  projectNested?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionProjectNestedInput>;
  /** Reshapes a new field based on the specified expression. The field used by the expression is not included in the result. */
  reshape?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionReshapeInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionIncludeInput = {
  /**
   * Key of the field to include in the result.
   *
   * Use dot notation to specify nested fields. For example, `user.name` or `product.price`. Learn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).
   */
  fieldName?: InputMaybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionInput = {
  /** Fields to include, exclude, or reshape. */
  fields?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionFieldInput>>>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionProjectNestedInput = {
  /** Nested fields to include, exclude, or reshape. */
  fields?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionFieldInput>>>;
  /**
   * Key of the parent field for the nested fields.
   *
   * Learn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).
   */
  resultFieldName?: InputMaybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionReshapeInput = {
  /** Expression to resolve. The result of the expression becomes the value of the new field. */
  expression?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestExpressionInput>;
  /**
   * Key of the field to create in the result item.
   *
   * Learn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).
   */
  resultFieldName?: InputMaybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestSortingInput = {
  /** Fields to sort the results by. */
  values?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonSortingInput>>>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestStageInput = {
  /**
   * Aggregation filter. Only items that match the filter are processed.
   *
   * Learn more about [filters in API Query Language](https://dev.wix.com/docs/rest/articles/get-started/api-query-language#filters).
   *
   * > **Note:** The values you provide for each filter field must adhere to that field's data type. For example, when filtering by a field whose type is Date and Time, use an object in the following format: `"someDateAndTimeFieldKey": { "$date": "YYYY-MM-DDTHH:mm:ss.sssZ"}`. Learn more about [data types in Wix Data](https://dev.wix.com/docs/rest/business-solutions/cms/data-items/data-types-in-wix-data).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Groups aggregated items to new result items. */
  group?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestGroupInput>;
  /** Maximum number of results to return. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Transforms an object into an array where each object property becomes a new array element containing the property's key and value, as well as all other properties from the original object. */
  objectToArray?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestObjectToArrayInput>;
  /** Transforms items by including, excluding, or reshaping fields. */
  projection?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestProjectionInput>;
  /** Number of results to skip from the beginning of the result set. */
  skip?: InputMaybe<Scalars['Int']>;
  /**
   * Sorting preferences.
   *
   * Learn more about [sorting and paging](https://dev.wix.com/docs/rest/articles/get-started/sorting-and-paging).
   */
  sort?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestSortingInput>;
  /** Creates a result item for each array element. Each result contains the full original item, with the array field replaced by an element whose key is the array name and whose value is the array element. */
  unwindArray?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestUnwindArrayInput>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestUnwindArrayInput = {
  /**
   * Key of the array field to unwind.
   *
   * Use dot notation to specify a nested array. For example, `user.products` or `product.colors`. Learn more about [field keys](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-id-velo-by-wix-only).
   */
  arrayFieldName?: InputMaybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataAggregatePipelineDataItemsResponse = {
  /** Paging information. */
  pagingMetadata?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonPagingMetadataV2>;
  /** Aggregation results. */
  results?: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

export type ComWixpressCloudDataApiDataBulkDataItemReferenceResult = {
  /** The action attempted for the reference. */
  action?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonBulkActionType>;
  /** The reference for which the action was attempted. Only returned if `returnEntity` is `true` in the request and the action is successful. */
  dataItemReference?: Maybe<ComWixpressCloudDataApiDataDataItemReference>;
  /** Metadata related to the reference for which the action was attempted. */
  referenceMetadata?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonItemMetadata>;
};

export type ComWixpressCloudDataApiDataBulkDataItemResult = {
  /** Action attempted for the data item. */
  action?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonBulkActionType>;
  /**
   * Updated data item.
   *
   * Returned if `returnEntity` is set to `true` and the action is successful.
   */
  dataItem?: Maybe<ComWixpressCloudDataApiDataDataItem>;
  /** Item metadata. */
  itemMetadata?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonItemMetadata>;
};

export type ComWixpressCloudDataApiDataBulkInsertDataItemReferencesRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  appOptions?: InputMaybe<Scalars['JSON']>;
  /** ID of the collection containing the referring items. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** References to insert. */
  dataItemReferences?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataDataItemReferenceInput>>>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /**
   * Whether to return the inserted data item references.
   * When `true`, the `results` objects contain a `dataItemReference` field.
   *
   * Default: `false`
   */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataBulkInsertDataItemReferencesResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata>;
  /** Information about the inserted references. */
  results?: Maybe<Array<Maybe<ComWixpressCloudDataApiDataBulkDataItemReferenceResult>>>;
};

export type ComWixpressCloudDataApiDataBulkInsertDataItemsRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional parameters specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying.
   *
   * When querying the Wix Stores [Products collection](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-e-commerce-stores/wix-stores-products-collection-fields), pass the following optional parameters:
   * - `includeHiddenProducts`: Whether to include hidden products in the response. Default: `false`.
   * - `includeVariants`: Whether to include product variants in the query. Default: `false`.
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /** ID of the collection in which to insert the items. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Data items to insert. */
  dataItems?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataDataItemInput>>>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** Data access options. */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /**
   * Whether to return the inserted data items.
   * When `true`, the `results` objects contain a `dataItem` field.
   *
   * Default: `false`
   */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to suppress data hooks.
   * When `true`, data hooks typically triggered by this endpoint don't run.
   *
   * **Note:** This option can only be used in code that runs in [the Wix site backend](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/backend-code/about-the-site-backend).
   *
   * Default: `false`
   */
  suppressHooks?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataBulkInsertDataItemsResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata>;
  /** Information about the inserted items. */
  results?: Maybe<Array<Maybe<ComWixpressCloudDataApiDataBulkDataItemResult>>>;
};

export type ComWixpressCloudDataApiDataBulkPatchDataItemsRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional options specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying.
   *
   * Learn more about [querying Wix app collections](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-app-collections/querying-wix-app-collections).
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /**
   * Condition for patching the items.
   *
   * When a condition is provided, the items are only patched if the condition is met.
   */
  condition?: InputMaybe<ComWixpressCloudDataApiDataConditionInput>;
  /** ID of the collection that contains the items to patch. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /**
   * [Collection environment](https://support.wix.com/en/article/cms-about-sandbox-and-live-collections-and-syncing) from which to delete item.
   *
   * Default: `LIVE`.
   */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** Patches to apply to the items. */
  patches?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataPatchInput>>>;
  /**
   * Options for the [Publish plugin](https://support.wix.com/en/article/cms-controlling-live-site-item-visibility-from-your-collection).
   *
   * This plugin allows items in a [data collection](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/data-collection-object) to be marked as draft or published. Published items are visible to site visitors, while draft items are not.
   */
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataPublishPluginOptionsInput>;
  /**
   * Whether to return the patched data items. When `true`, each item in the `results` array contains a `dataItem` field with the full patched data item.
   *
   * Default: `false`
   */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to suppress data hooks.
   * When `true`, data hooks typically triggered by this endpoint don't run.
   *
   * > **Note:** This option can only be used in code that runs in [the Wix site backend](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/backend-code/about-the-site-backend).
   *
   * Default: `false`
   */
  suppressHooks?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataBulkPatchDataItemsResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata>;
  /** Patched items. */
  results?: Maybe<Array<Maybe<ComWixpressCloudDataApiDataBulkDataItemResult>>>;
};

export type ComWixpressCloudDataApiDataBulkRemoveDataItemReferencesRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  appOptions?: InputMaybe<Scalars['JSON']>;
  /** ID of the collection containing the referring items. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** References to remove. */
  dataItemReferences?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataDataItemReferenceInput>>>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
};

export type ComWixpressCloudDataApiDataBulkRemoveDataItemReferencesResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata>;
  /** Information about the removed references. */
  results?: Maybe<Array<Maybe<ComWixpressCloudDataApiDataBulkDataItemReferenceResult>>>;
};

export type ComWixpressCloudDataApiDataBulkRemoveDataItemsRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional parameters specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying.
   *
   * When querying the Wix Stores [Products collection](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-e-commerce-stores/wix-stores-products-collection-fields), pass the following optional parameters:
   * - `includeHiddenProducts`: Whether to include hidden products in the response. Default: `false`.
   * - `includeVariants`: Whether to include product variants in the query. Default: `false`.
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /**
   * Condition for removing the items.
   *
   * When a condition is provided, the items are only removed if the condition is met.
   */
  condition?: InputMaybe<ComWixpressCloudDataApiDataConditionInput>;
  /** ID of the collection from which to remove the item. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** IDs of data items to remove. */
  dataItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /**
   * Options for the Publish plugin.
   * This plugin allows items in a [data collection](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/data-collection-object) to be marked as draft or published. Published items are visible to site visitors, while draft items are not.
   */
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataPublishPluginOptionsInput>;
  /**
   * Whether to suppress data hooks.
   * When `true`, data hooks typically triggered by this endpoint don't run.
   *
   * **Note:** This option can only be used in code that runs in [the Wix site backend](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/backend-code/about-the-site-backend).
   *
   * Default: `false`
   */
  suppressHooks?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataBulkRemoveDataItemsResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata>;
  /** Information about the removed data items. */
  results?: Maybe<Array<Maybe<ComWixpressCloudDataApiDataBulkDataItemResult>>>;
};

export type ComWixpressCloudDataApiDataBulkSaveDataItemsRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional parameters specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying.
   *
   * When querying the Wix Stores [Products collection](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-e-commerce-stores/wix-stores-products-collection-fields), pass the following optional parameters:
   * - `includeHiddenProducts`: Whether to include hidden products in the response. Default: `false`.
   * - `includeVariants`: Whether to include product variants in the query. Default: `false`.
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /** ID of the collection in which to insert or update the items. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Data items to insert or update. */
  dataItems?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataDataItemInput>>>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /**
   * Options for the Publish plugin.
   * This plugin allows items in a [data collection](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/data-collection-object) to be marked as draft or published. Published items are visible to site visitors, while draft items are not.
   */
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataPublishPluginOptionsInput>;
  /**
   * Whether to return the saved data item.
   * When `true`, the `results` objects contain a `dataItem` field.
   *
   * Default: `false`
   */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to suppress data hooks.
   * When `true`, data hooks typically triggered by this endpoint don't run.
   *
   * **Note:** This option can only be used in code that runs in [the Wix site backend](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/backend-code/about-the-site-backend).
   *
   * Default: `false`
   */
  suppressHooks?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataBulkSaveDataItemsResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata>;
  /** Information about the saved items. */
  results?: Maybe<Array<Maybe<ComWixpressCloudDataApiDataBulkDataItemResult>>>;
};

export type ComWixpressCloudDataApiDataBulkUpdateDataItemsRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional parameters specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying.
   *
   * When querying the Wix Stores [Products collection](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-e-commerce-stores/wix-stores-products-collection-fields), pass the following optional parameters:
   * - `includeHiddenProducts`: Whether to include hidden products in the response. Default: `false`.
   * - `includeVariants`: Whether to include product variants in the query. Default: `false`.
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /**
   * Condition for updating the items.
   *
   * When a condition is provided, the items are only updated if the condition is met.
   */
  condition?: InputMaybe<ComWixpressCloudDataApiDataConditionInput>;
  /** ID of the collection in which to update items. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Data items to update. */
  dataItems?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataDataItemInput>>>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /**
   * Options for the Publish plugin.
   * This plugin allows items in a [data collection](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/data-collection-object) to be marked as draft or published. Published items are visible to site visitors, while draft items are not.
   */
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataPublishPluginOptionsInput>;
  /**
   * Whether to return the updated data items.
   * When `true`, the `results` objects contain a `dataItem` field.
   *
   * Default: `false`
   */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to suppress data hooks.
   * When `true`, data hooks typically triggered by this endpoint don't run.
   *
   * **Note:** This option can only be used in code that runs in [the Wix site backend](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/backend-code/about-the-site-backend).
   *
   * Default: `false`
   */
  suppressHooks?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataBulkUpdateDataItemsResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata>;
  /** Information about the updated items. */
  results?: Maybe<Array<Maybe<ComWixpressCloudDataApiDataBulkDataItemResult>>>;
};

export type ComWixpressCloudDataApiDataConditionInput = {
  /**
   * Filter, changes to item(s) will only apply if they satisfy this filter.
   * Learn more about filters in [API Query Language](https://dev.wix.com/docs/rest/articles/get-started/api-query-language#filters).
   */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type ComWixpressCloudDataApiDataCountDataItemsRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional parameters specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying.
   *
   * When querying the Wix Stores [Products collection](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-e-commerce-stores/wix-stores-products-collection-fields), pass the following optional parameters:
   * - `includeHiddenProducts`: Whether to include hidden products in the response. Default: `false`.
   * - `includeVariants`: Whether to include product variants in the query. Default: `false`.
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /**
   * Whether to retrieve data from the primary database instance.
   * This decreases performance but ensures data retrieved is up to date even immediately after an update.
   * Learn more about [Wix Data and eventual consistency](https://dev.wix.com/api/rest/wix-data/wix-data/eventual-consistency).
   *
   * Default: `false`
   */
  consistentRead?: InputMaybe<Scalars['Boolean']>;
  /** ID of the collection for which to count query results. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /**
   * Filter object in the following format:
   *
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`.
   *
   * Examples of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`.
   *
   * **Note:** The values you provide for each field must adhere to that field's type. For example, when filtering by a field whose type is Date and Time, use an object in the following format: `"someDateAndTimeFieldKey": { "$date": "YYYY-MM-DDTHH:mm:ss.sssZ"}`. Learn more about [data types in Wix Data](https://dev.wix.com/docs/rest/business-solutions/cms/data-items/data-types-in-wix-data).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Language to translate result text into, in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * If provided, the result text is returned in the specified language.
   * **Note:** Translation for the specified language must be enabled for the collection in [Wix Multilingual](https://www.wix.com/app-market/wix-multilingual).
   *
   * If not provided, result text is not translated.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /**
   * Options for the Publish plugin.
   * This plugin allows items in a [data collection](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/data-collection-object) to be marked as draft or published. Published items are visible to site visitors, while draft items are not.
   */
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataPublishPluginOptionsInput>;
  /**
   * Whether to suppress data hooks.
   * When `true`, data hooks typically triggered by this endpoint don't run.
   *
   * **Note:** This option can only be used in code that runs in [the Wix site backend](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/backend-code/about-the-site-backend).
   *
   * Default: `false`
   */
  suppressHooks?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataCountDataItemsResponse = {
  /** Number of items matching the query. */
  totalCount?: Maybe<Scalars['Int']>;
};

export type ComWixpressCloudDataApiDataDataItem = {
  /**
   * Data item contents.
   *
   * Property-value pairs representing the data item's payload. When retrieving a data item, it also includes the following read-only fields:
   *
   * + `_id`: Item ID.
   * + `_createdDate`: Date and time the item was added to the collection.
   * + `_updatedDate`: Date and time the item was last modified. When the item is first inserted, `_createdDate` and `_updatedDate` have the same value.
   * + `_ownerId`: ID of the user who created the item. Can be modified with site owner permissions.
   */
  data?: Maybe<Scalars['JSON']>;
  /** ID of the collection this item belongs to */
  dataCollectionId?: Maybe<Scalars['String']>;
  /** Data item ID. */
  id?: Maybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataDataItemInput = {
  /**
   * Data item contents.
   *
   * Property-value pairs representing the data item's payload. When retrieving a data item, it also includes the following read-only fields:
   *
   * + `_id`: Item ID.
   * + `_createdDate`: Date and time the item was added to the collection.
   * + `_updatedDate`: Date and time the item was last modified. When the item is first inserted, `_createdDate` and `_updatedDate` have the same value.
   * + `_ownerId`: ID of the user who created the item. Can be modified with site owner permissions.
   */
  data?: InputMaybe<Scalars['JSON']>;
  /** ID of the collection this item belongs to */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Data item ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataDataItemReference = {
  /** ID of the referenced item. */
  referencedItemId?: Maybe<Scalars['String']>;
  /** Referring item field containing the references to the referenced items. */
  referringItemFieldName?: Maybe<Scalars['String']>;
  /** ID of the referring item. */
  referringItemId?: Maybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataDataItemReferenceInput = {
  /** ID of the referenced item. */
  referencedItemId?: InputMaybe<Scalars['String']>;
  /** Referring item field containing the references to the referenced items. */
  referringItemFieldName?: InputMaybe<Scalars['String']>;
  /** ID of the referring item. */
  referringItemId?: InputMaybe<Scalars['String']>;
};

export enum ComWixpressCloudDataApiDataFieldModificationAction {
  /**
   * Appends the specified value to the array.
   *
   * Learn more about [data types in Wix Data](https://dev.wix.com/docs/rest/business-solutions/cms/data-types-in-wix-data).
   */
  APPEND_TO_ARRAY = 'APPEND_TO_ARRAY',
  /** Increments the specified field by the specified value. To decrement, specify a negative value. */
  INCREMENT_FIELD = 'INCREMENT_FIELD',
  /** Clears the specified field. */
  REMOVE_FIELD = 'REMOVE_FIELD',
  /**
   * Removes the first instance of the specified value from the array.
   *
   * Learn more about [data types in Wix Data](https://dev.wix.com/docs/rest/business-solutions/cms/data-types-in-wix-data).
   */
  REMOVE_FROM_ARRAY = 'REMOVE_FROM_ARRAY',
  /** Sets the specified field to the specified value. */
  SET_FIELD = 'SET_FIELD',
  UNKNOWN_ACTION = 'UNKNOWN_ACTION'
}

export type ComWixpressCloudDataApiDataFieldModificationAppendToArrayOptionsInput = {
  /** Value to append to the specified array. */
  value?: InputMaybe<Scalars['JSON']>;
};

export type ComWixpressCloudDataApiDataFieldModificationIncrementFieldOptionsInput = {
  /** Numerical value by which to increment the field value. To decrement, specify a negative value. */
  value?: InputMaybe<Scalars['Float']>;
};

export type ComWixpressCloudDataApiDataFieldModificationInput = {
  /** Patch action to apply to the specified field. */
  action?: InputMaybe<ComWixpressCloudDataApiDataFieldModificationAction>;
  /** Options for appending a value to the specified array. Required when `action` is `APPEND_TO_ARRAY`. */
  appendToArrayOptions?: InputMaybe<ComWixpressCloudDataApiDataFieldModificationAppendToArrayOptionsInput>;
  /**
   * Path of the field to be modified. For example: `title`.
   *
   * Nested fields can be specified using dot notation. For example: `address.street`.
   */
  fieldPath?: InputMaybe<Scalars['String']>;
  /** Options for incrementing the value of the specified field. Required when `action` is `INCREMENT_FIELD`. */
  incrementFieldOptions?: InputMaybe<ComWixpressCloudDataApiDataFieldModificationIncrementFieldOptionsInput>;
  /** Options for removing a value from the specified array. Required when `action` is `REMOVE_FROM_ARRAY`. */
  removeFromArrayOptions?: InputMaybe<ComWixpressCloudDataApiDataFieldModificationRemoveFromArrayOptionsInput>;
  /** Options for setting the value of the specified field. Required when `action` is `SET_FIELD`. */
  setFieldOptions?: InputMaybe<ComWixpressCloudDataApiDataFieldModificationSetFieldOptionsInput>;
};

export type ComWixpressCloudDataApiDataFieldModificationRemoveFromArrayOptionsInput = {
  /** Value whose first instance is removed from the specified array. */
  value?: InputMaybe<Scalars['JSON']>;
};

export type ComWixpressCloudDataApiDataFieldModificationSetFieldOptionsInput = {
  /** Value to set for the specified field. This replaces the existing value. */
  value?: InputMaybe<Scalars['JSON']>;
};

export enum ComWixpressCloudDataApiDataFieldUpdateAction {
  APPEND_TO_ARRAY = 'APPEND_TO_ARRAY',
  INCREMENT_FIELD = 'INCREMENT_FIELD',
  REMOVE_FIELD = 'REMOVE_FIELD',
  REMOVE_FROM_ARRAY = 'REMOVE_FROM_ARRAY',
  SET_FIELD = 'SET_FIELD',
  UNKNOWN_ACTION = 'UNKNOWN_ACTION'
}

export type ComWixpressCloudDataApiDataFieldUpdateAppendToArrayInput = {
  value?: InputMaybe<Scalars['JSON']>;
};

export type ComWixpressCloudDataApiDataFieldUpdateIncrementFieldInput = {
  value?: InputMaybe<Scalars['Float']>;
};

export type ComWixpressCloudDataApiDataFieldUpdateRemoveFromArrayInput = {
  value?: InputMaybe<Scalars['JSON']>;
};

export type ComWixpressCloudDataApiDataFieldUpdateSetFieldInput = {
  value?: InputMaybe<Scalars['JSON']>;
};

export type ComWixpressCloudDataApiDataGetDataItemRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional parameters specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying.
   *
   * When querying the Wix Stores [Products collection](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-e-commerce-stores/wix-stores-products-collection-fields), pass the following optional parameters:
   * - `includeHiddenProducts`: Whether to include hidden products in the response. Default: `false`.
   * - `includeVariants`: Whether to include product variants in the query. Default: `false`.
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /**
   * Whether to retrieve data from the primary database instance.
   * This decreases performance but ensures data retrieved is up to date even immediately after an update.
   * Learn more about [Wix Data and eventual consistency](https://dev.wix.com/api/rest/wix-data/wix-data/eventual-consistency).
   *
   * Default: `false`
   */
  consistentRead?: InputMaybe<Scalars['Boolean']>;
  /** ID of the collection from which to retrieve the data item. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /**
   * Fields to return for the item. Only fields specified in the array are included in the response. If the array is empty, all fields are returned.
   * **Note:** The `_id` system field is always returned.
   */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id: Scalars['ID'];
  /**
   * Language to translate result text into, in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * If provided, the result text is returned in the specified language.
   * **Note:** Translation for the specified language must be enabled for the collection in [Wix Multilingual](https://www.wix.com/app-market/wix-multilingual).
   *
   * If not provided, result text is not translated.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /**
   * Options for the Publish plugin.
   * This plugin allows items in a [data collection](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/data-collection-object) to be marked as draft or published. Published items are visible to site visitors, while draft items are not.
   */
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataPublishPluginOptionsInput>;
  /**
   * Whether to suppress data hooks.
   * When `true`, data hooks typically triggered by this endpoint don't run.
   *
   * **Note:** This option can only be used in code that runs in [the Wix site backend](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/backend-code/about-the-site-backend).
   *
   * Default: `false`
   */
  suppressHooks?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataInsertDataItemReferenceRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional parameters specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying.
   *
   * When querying the Wix Stores [Products collection](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-e-commerce-stores/wix-stores-products-collection-fields), pass the following optional parameters:
   * - `includeHiddenProducts`: Whether to include hidden products in the response. Default: `false`.
   * - `includeVariants`: Whether to include product variants in the query. Default: `false`.
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /** ID of the collection in which to insert the reference. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Reference to insert */
  dataItemReference?: InputMaybe<ComWixpressCloudDataApiDataDataItemReferenceInput>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
};

export type ComWixpressCloudDataApiDataInsertDataItemReferenceResponse = {
  /** Inserted reference. */
  dataItemReference?: Maybe<ComWixpressCloudDataApiDataDataItemReference>;
};

export type ComWixpressCloudDataApiDataInsertDataItemRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional parameters specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying.
   *
   * When querying the Wix Stores [Products collection](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-e-commerce-stores/wix-stores-products-collection-fields), pass the following optional parameters:
   * - `includeHiddenProducts`: Whether to include hidden products in the response. Default: `false`.
   * - `includeVariants`: Whether to include product variants in the query. Default: `false`.
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /** ID of the collection in which to insert the item. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Item to insert. */
  dataItem?: InputMaybe<ComWixpressCloudDataApiDataDataItemInput>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** If true, referenced items will be included. */
  includeReferencedItems?: InputMaybe<Scalars['Boolean']>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /**
   * Whether to suppress data hooks.
   * When `true`, data hooks typically triggered by this endpoint don't run.
   *
   * **Note:** This option can only be used in code that runs in [the Wix site backend](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/backend-code/about-the-site-backend).
   *
   * Default: `false`
   */
  suppressHooks?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataInsertDataItemResponse = {
  /** Inserted data item. */
  dataItem?: Maybe<ComWixpressCloudDataApiDataDataItem>;
};

export type ComWixpressCloudDataApiDataIsReferencedDataItemRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  appOptions?: InputMaybe<Scalars['JSON']>;
  /**
   * Whether to retrieve data from the primary database instance.
   * This decreases performance but ensures data retrieved is up to date even immediately after an update.
   * Learn more about [Wix Data and eventual consistency](https://dev.wix.com/api/rest/wix-data/wix-data/eventual-consistency).
   *
   * Default: `false`
   */
  consistentRead?: InputMaybe<Scalars['Boolean']>;
  /** ID of the collection containing the referring data item. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /** ID of the item that may be referenced. */
  referencedItemId?: InputMaybe<Scalars['String']>;
  /** Field to check for a reference to the item that may be referenced. */
  referringItemFieldName?: InputMaybe<Scalars['String']>;
  /** ID of the referring item. */
  referringItemId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataIsReferencedDataItemResponse = {
  /** Whether the specified reference exists. */
  isReferenced?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataOptionsInput = {
  appOptions?: InputMaybe<Scalars['JSON']>;
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataOptionsPublishPluginOptionsInput>;
  /**
   * Should hooks execution be suppressed.
   * This option can only be used with Corvid backend
   * code identity.
   */
  suppressHooks?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataOptionsPublishPluginOptionsInput = {
  showDraftItems?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataPatchDataItemRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional options specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying.
   *
   * Learn more about [querying Wix app collections](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-app-collections/querying-wix-app-collections).
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /**
   * Condition for patching the item.
   *
   * When a condition is provided, the item is only patched if the condition is met.
   */
  condition?: InputMaybe<ComWixpressCloudDataApiDataConditionInput>;
  /** ID of the collection that contains the item to patch. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /**
   * [Collection environment](https://support.wix.com/en/article/cms-about-sandbox-and-live-collections-and-syncing) from which to delete item.
   *
   * Default: `LIVE`.
   */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** Patch to apply to the item. */
  patch?: InputMaybe<ComWixpressCloudDataApiDataPatchInput>;
  /**
   * Options for the [Publish plugin](https://support.wix.com/en/article/cms-controlling-live-site-item-visibility-from-your-collection).
   *
   * This plugin allows items in a [data collection](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/data-collection-object) to be marked as draft or published. Published items are visible to site visitors, while draft items are not.
   */
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataPublishPluginOptionsInput>;
  /**
   * Whether to suppress data hooks. When `true`, data hooks typically triggered by this method don't run.
   *
   * > **Note:** This can only be used in code that runs in a [Wix site backend](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/backend-code/about-the-site-backend).
   *
   * Default: `false`.
   */
  suppressHooks?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataPatchDataItemResponse = {
  /** Patched data item. */
  dataItem?: Maybe<ComWixpressCloudDataApiDataDataItem>;
};

export type ComWixpressCloudDataApiDataPatchInput = {
  /** ID of the item to patch. */
  dataItemId?: InputMaybe<Scalars['String']>;
  /** Modifications to apply. */
  fieldModifications?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataFieldModificationInput>>>;
};

export type ComWixpressCloudDataApiDataPublishPluginOptionsInput = {
  /**
   * Whether to include draft items.
   *
   * When `true`, both published and draft items are affected. Default: `false`.
   */
  includeDraftItems?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataQueryDataItemsRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional parameters specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying.
   *
   * When querying the Wix Stores [Products collection](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-e-commerce-stores/wix-stores-products-collection-fields), pass the following optional parameters:
   * - `includeHiddenProducts`: Whether to include hidden products in the response. Default: `false`.
   * - `includeVariants`: Whether to include product variants in the query. Default: `false`.
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /**
   * Whether to retrieve data from the primary database instance.
   * This decreases performance but ensures data retrieved is up to date even immediately after an update.
   * Learn more about [Wix Data and eventual consistency](https://dev.wix.com/api/rest/wix-data/wix-data/eventual-consistency).
   *
   * Default: `false`
   */
  consistentRead?: InputMaybe<Scalars['Boolean']>;
  /** ID of the collection to query. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /**
   * Properties for which to include referenced items in the query's results.
   * Up to 50 referenced items can be included for each item that matches the query.
   */
  includeReferencedItems?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Language to translate result text into, in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * If provided, the result text is returned in the specified language.
   * **Note:** Translation for the specified language must be enabled for the collection in [Wix Multilingual](https://www.wix.com/app-market/wix-multilingual).
   *
   * If not provided, result text is not translated.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /**
   * Options for the Publish plugin.
   * This plugin allows items in a [data collection](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/data-collection-object) to be marked as draft or published. Published items are visible to site visitors, while draft items are not.
   */
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataPublishPluginOptionsInput>;
  /** Query preferences. For more details on using queries, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language). */
  query?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonQueryV2Input>;
  /** Additional options for random sorting. */
  randomOptions?: InputMaybe<ComWixpressCloudDataApiDataQueryDataItemsRequestRandomOptionsInput>;
  /** Options for retrieving referenced items. */
  referencedItemOptions?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataQueryDataItemsRequestReferencedItemOptionsInput>>>;
  /** Request information about this collection caching */
  requestCachingInfo?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to return the total count in the response for a query with offset paging.
   * When `true`, the `pagingMetadata` object in the response contains a `total` field.
   *
   * Default: `false`
   */
  returnTotalCount?: InputMaybe<Scalars['Boolean']>;
  /** Selects how sorting is applied to the response. */
  sortMode?: InputMaybe<ComWixpressCloudDataApiDataQueryDataItemsRequestSortMode>;
  /**
   * Whether to suppress data hooks.
   * When `true`, data hooks typically triggered by this endpoint don't run.
   *
   * **Note:** This option can only be used in code that runs in [the Wix site backend](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/backend-code/about-the-site-backend).
   *
   * Default: `false`
   */
  suppressHooks?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataQueryDataItemsRequestRandomOptionsInput = {
  /** Seed for the pseudo-random generator. The same seed always generates the same order. */
  seed?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressCloudDataApiDataQueryDataItemsRequestReferencedItemOptionsInput = {
  /** Field containing references in the queried item. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Maximum number of referenced items to include for each queried item. */
  limit?: InputMaybe<Scalars['Int']>;
};

export enum ComWixpressCloudDataApiDataQueryDataItemsRequestSortMode {
  /** Return randomly sorted results, disregarding query.sort. */
  RANDOM = 'RANDOM',
  /** Placeholder. Falls back to REGULAR. */
  UNKNOWN_SORT_MODE = 'UNKNOWN_SORT_MODE',
  /** Use the sorting specified in query.sort. */
  WIX_QUERY = 'WIX_QUERY'
}

export type ComWixpressCloudDataApiDataQueryDataItemsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressCloudDataApiDataDataItem>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressCloudDataApiDataQueryDistinctValuesRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Whether to retrieve data from the primary database instance.
   * This decreases performance but ensures data retrieved is up to date even immediately after an update.
   * Learn more about [Wix Data and eventual consistency](https://dev.wix.com/api/rest/wix-data/wix-data/eventual-consistency).
   *
   * Default: `false`
   */
  consistentRead?: InputMaybe<Scalars['Boolean']>;
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonCursorPagingInput>;
  /** ID of the collection to query. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** Item field name for which to return all distinct values. */
  fieldName?: InputMaybe<Scalars['String']>;
  /**
   * Filter object in the following format:
   *
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`.
   *
   * Examples of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`.
   *
   * **Note:** The values you provide for each field must adhere to that field's type. For example, when filtering by a field whose type is Date and Time, use an object in the following format: `"someDateAndTimeFieldKey": { "$date": "YYYY-MM-DDTHH:mm:ss.sssZ"}`. Learn more about [data types in Wix Data](https://dev.wix.com/docs/rest/business-solutions/cms/data-items/data-types-in-wix-data).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Language to translate result text into, in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * If provided, the result text is returned in the specified language.
   * **Note:** Translation for the specified language must be enabled for the collection in [Wix Multilingual](https://www.wix.com/app-market/wix-multilingual).
   *
   * If not provided, result text is not translated.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /** Sort order. */
  order?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonSortOrder>;
  /** Paging options to limit and skip the number of items. */
  paging?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonPagingInput>;
  /**
   * Options for the Publish plugin.
   * This plugin allows items in a [data collection](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/data-collection-object) to be marked as draft or published. Published items are visible to site visitors, while draft items are not.
   */
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataPublishPluginOptionsInput>;
  /**
   * Whether to return the total count in the response for a query with offset paging.
   * When `true`, the `pagingMetadata` object in the response contains a `total` field.
   *
   * Default: `false`
   */
  returnTotalCount?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataQueryDistinctValuesResponse = {
  /** List of distinct values contained in the field specified in `fieldName`. */
  distinctValues?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  /** Paging information. */
  pagingMetadata?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonPagingMetadataV2>;
};

export type ComWixpressCloudDataApiDataQueryReferencedDataItemsRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional parameters specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying:
   *
   * When querying the Wix Stores [Products collection](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-e-commerce-stores/wix-stores-products-collection-fields), pass the following optional parameters:
   * - `includeHiddenProducts`: Whether to include hidden products in the response. Default: `false`.
   * - `includeVariants`: Whether to include product variants in the query. Default: `false`.
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /**
   * Whether to retrieve data from the primary database instance.
   * This decreases performance but ensures data retrieved is up to date even immediately after an update.
   * Learn more about [Wix Data and eventual consistency](https://dev.wix.com/api/rest/wix-data/wix-data/eventual-consistency).
   *
   * Default: `false`
   */
  consistentRead?: InputMaybe<Scalars['Boolean']>;
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonCursorPagingInput>;
  /** ID of the collection containing the referring item. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /**
   * Fields to return for each referenced item. Only fields specified in the array are included in the response. If the array is empty, all fields are returned.
   * **Note:** The `_id` system field is always returned.
   */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Language to translate result text into, in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * If provided, the result text is returned in the specified language.
   * **Note:** Translation for the specified language must be enabled for the collection in [Wix Multilingual](https://www.wix.com/app-market/wix-multilingual).
   *
   * If not provided, result text is not translated.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /** Order of the returned referenced items. Sorted by the date each item was referenced. */
  order?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonSortOrder>;
  /** Paging options to limit and skip the number of items. */
  paging?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonPagingInput>;
  /**
   * Options for the Publish plugin.
   * This plugin allows items in a [data collection](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/data-collection-object) to be marked as draft or published. Published items are visible to site visitors, while draft items are not.
   */
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataPublishPluginOptionsInput>;
  /** Field containing references in the referring item. */
  referringItemFieldName?: InputMaybe<Scalars['String']>;
  /** ID of the referring item. */
  referringItemId?: InputMaybe<Scalars['String']>;
  /** IDs of the referring items. */
  referringItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Whether to return the total count in the response.
   * When `true`, the `pagingMetadata` object in the response contains a `total` field.
   *
   * Default: `false`
   */
  returnTotalCount?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataQueryReferencedDataItemsResponse = {
  /** Paging information. */
  pagingMetadata?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonPagingMetadataV2>;
  /** Referenced items and/or IDs. For successfully resolved references, the referenced data item is returned. For references that can't be resolved, the ID is returned. */
  results?: Maybe<Array<Maybe<ComWixpressCloudDataApiDataQueryReferencedDataItemsResponseReferencedResult>>>;
};

export type ComWixpressCloudDataApiDataQueryReferencedDataItemsResponseReferencedResult = {
  /** Data item referenced. */
  dataItem?: Maybe<ComWixpressCloudDataApiDataDataItem>;
  /** ID of the referring item. */
  referringItemId?: Maybe<Scalars['String']>;
  /** Unresolved reference. Appears instead of the data item when the reference doesn't resolve, for example, when an ID isn't found or if an item is in draft state. */
  unresolvedReference?: Maybe<ComWixpressCloudDataApiDataQueryReferencedDataItemsResponseUnresolvedReference>;
};

export type ComWixpressCloudDataApiDataQueryReferencedDataItemsResponseUnresolvedReference = {
  /** ID of unresolved referenced item */
  referencedItemId?: Maybe<Scalars['String']>;
  /** Field specified to query for references. */
  referringItemFieldName?: Maybe<Scalars['String']>;
  /** ID of the referring item. */
  referringItemId?: Maybe<Scalars['String']>;
  /** Flag is set if item exists, but user is not authorized to read it */
  unauthorized?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataRemoveDataItemReferenceRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  appOptions?: InputMaybe<Scalars['JSON']>;
  /** ID of the collection containing the referring item. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Reference to remove. */
  dataItemReference?: InputMaybe<ComWixpressCloudDataApiDataDataItemReferenceInput>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
};

export type ComWixpressCloudDataApiDataRemoveDataItemReferenceResponse = {
  /** Removed reference. */
  dataItemReference?: Maybe<ComWixpressCloudDataApiDataDataItemReference>;
};

export type ComWixpressCloudDataApiDataRemoveDataItemRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional parameters specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying.
   *
   * When querying the Wix Stores [Products collection](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-e-commerce-stores/wix-stores-products-collection-fields), pass the following optional parameters:
   * - `includeHiddenProducts`: Whether to include hidden products in the response. Default: `false`.
   * - `includeVariants`: Whether to include product variants in the query. Default: `false`.
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /**
   * Condition for removing the item.
   *
   * When a condition is provided, the item is only removed if the condition is met.
   */
  condition?: InputMaybe<ComWixpressCloudDataApiDataConditionInput>;
  /** ID of the collection from which to remove the item. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** ID of the item to remove. */
  dataItemId?: InputMaybe<Scalars['String']>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /**
   * Options for the Publish plugin.
   * This plugin allows items in a [data collection](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/data-collection-object) to be marked as draft or published. Published items are visible to site visitors, while draft items are not.
   */
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataPublishPluginOptionsInput>;
  /**
   * Whether to suppress data hooks.
   * When `true`, data hooks typically triggered by this endpoint don't run.
   *
   * **Note:** This option can only be used in code that runs in [the Wix site backend](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/backend-code/about-the-site-backend).
   *
   * Default: `false`
   */
  suppressHooks?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataRemoveDataItemResponse = {
  /** Removed item. */
  dataItem?: Maybe<ComWixpressCloudDataApiDataDataItem>;
};

export type ComWixpressCloudDataApiDataReplaceDataItemReferencesRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  appOptions?: InputMaybe<Scalars['JSON']>;
  /** ID of the collection containing the referring item. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** List of new referenced item IDs to replace the existing ones. */
  newReferencedItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /** Field containing references in the referring item. */
  referringItemFieldName?: InputMaybe<Scalars['String']>;
  /** ID of the referring item. */
  referringItemId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataReplaceDataItemReferencesResponse = {
  /** Updated references. */
  dataItemReferences?: Maybe<Array<Maybe<ComWixpressCloudDataApiDataDataItemReference>>>;
};

export type ComWixpressCloudDataApiDataSaveDataItemRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional parameters specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying.
   *
   * When querying the Wix Stores [Products collection](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-e-commerce-stores/wix-stores-products-collection-fields), pass the following optional parameters:
   * - `includeHiddenProducts`: Whether to include hidden products in the response. Default: `false`.
   * - `includeVariants`: Whether to include product variants in the query. Default: `false`.
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /** ID of the collection in which to insert or update the item. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Data item to insert or update. */
  dataItem?: InputMaybe<ComWixpressCloudDataApiDataDataItemInput>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** If true, referenced items will be included. */
  includeReferencedItems?: InputMaybe<Scalars['Boolean']>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /**
   * Options for the Publish plugin.
   * This plugin allows items in a [data collection](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/data-collection-object) to be marked as draft or published. Published items are visible to site visitors, while draft items are not.
   */
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataPublishPluginOptionsInput>;
  /**
   * Whether to suppress data hooks.
   * When `true`, data hooks typically triggered by this endpoint don't run.
   *
   * **Note:** This option can only be used in code that runs in [the Wix site backend](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/backend-code/about-the-site-backend).
   *
   * Default: `false`
   */
  suppressHooks?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataSaveDataItemResponse = {
  /** The action carried out for the item. */
  action?: Maybe<ComWixpressCloudDataApiDataSaveDataItemResponseAction>;
  /** Inserted or updated data item. */
  dataItem?: Maybe<ComWixpressCloudDataApiDataDataItem>;
};

export enum ComWixpressCloudDataApiDataSaveDataItemResponseAction {
  /** A new item was added to the collection. */
  INSERTED = 'INSERTED',
  /** Undefined action. */
  UNKNOWN_ACTION = 'UNKNOWN_ACTION',
  /** An existing item in the collection was updated. */
  UPDATED = 'UPDATED'
}

export type ComWixpressCloudDataApiDataSearchDataItemsRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /** ID of the collection to search. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Environment: `LIVE` or `SANDBOX`. */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /**
   * NOT IMPLEMENTED!
   * Language to translate result text into, in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * If provided, the result text is returned in the specified language. If not provided, result text is not translated.
   *
   * > **Note:** Translation for the specified language must be enabled for the collection in [Wix Multilingual](https://www.wix.com/app-market/wix-multilingual).
   */
  language?: InputMaybe<Scalars['String']>;
  /**
   * Options for the Publish plugin.
   *
   * This plugin allows items to be marked as draft or published. Published items are visible to site visitors, while draft items are not.
   */
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataPublishPluginOptionsInput>;
  /**
   * Options for retrieving referenced items.
   *
   * Learn more about [using reference fields](https://support.wix.com/en/article/cms-using-reference-fields-to-display-content-from-multiple-collections).
   */
  referencedItemOptions?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataSearchDataItemsRequestReferencedItemOptionsInput>>>;
  /** Search query configuration. */
  search?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonSearchInput>;
  /**
   * Whether to suppress data hooks.
   *
   * When `true`, data hooks typically triggered by this endpoint don't run.
   *
   * Default: `false`.
   *
   * > **Note:** This option can only be used in code that runs in [the Wix site backend](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/backend-code/about-the-site-backend).
   */
  suppressHooks?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataSearchDataItemsRequestReferencedItemOptionsInput = {
  /** Field in the retrieved item that contains references. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Maximum number of referenced items to include for each retrieved item. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressCloudDataApiDataSearchDataItemsResponse = {
  /** Retrieved items. */
  dataItems?: Maybe<Array<Maybe<ComWixpressCloudDataApiDataDataItem>>>;
  /** Paging configuration. */
  pagingMetadata?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonPagingMetadataV2>;
};

export type ComWixpressCloudDataApiDataTruncateDataItemsRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /** ID of the collection to truncate. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
};

export type ComWixpressCloudDataApiDataUpdateDataItemRequestInput = {
  /** Grid app id. Optional in Live segment. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Additional parameters specific to the [Wix app collection](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections) you are querying.
   *
   * When querying the Wix Stores [Products collection](https://dev.wix.com/docs/develop-websites/articles/wix-apps/wix-e-commerce-stores/wix-stores-products-collection-fields), pass the following optional parameters:
   * - `includeHiddenProducts`: Whether to include hidden products in the response. Default: `false`.
   * - `includeVariants`: Whether to include product variants in the query. Default: `false`.
   */
  appOptions?: InputMaybe<Scalars['JSON']>;
  /**
   * Condition for updating the item.
   *
   * When a condition is provided, the item is only updated if the condition is met.
   */
  condition?: InputMaybe<ComWixpressCloudDataApiDataConditionInput>;
  /** ID of the collection containing the existing item. */
  dataCollectionId?: InputMaybe<Scalars['String']>;
  /** Updated data item content. The existing data item's content is replaced entirely. */
  dataItem?: InputMaybe<ComWixpressCloudDataApiDataDataItemInput>;
  /** Environment: LIVE or SANDBOX */
  environment?: InputMaybe<ComWixpressCloudDataApiEnvironment>;
  /** If true, referenced items will be included. */
  includeReferencedItems?: InputMaybe<Scalars['Boolean']>;
  /** Data access options */
  options?: InputMaybe<ComWixpressCloudDataApiDataOptionsInput>;
  /**
   * Options for the Publish plugin.
   * This plugin allows items in a [data collection](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/data-collection-object) to be marked as draft or published. Published items are visible to site visitors, while draft items are not.
   */
  publishPluginOptions?: InputMaybe<ComWixpressCloudDataApiDataPublishPluginOptionsInput>;
  /**
   * Whether to suppress data hooks.
   * When `true`, data hooks typically triggered by this endpoint don't run.
   *
   * **Note:** This option can only be used in code that runs in [the Wix site backend](https://dev.wix.com/docs/develop-websites/articles/coding-with-velo/backend-code/about-the-site-backend).
   *
   * Default: `false`
   */
  suppressHooks?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataUpdateDataItemResponse = {
  /** Updated data item. */
  dataItem?: Maybe<ComWixpressCloudDataApiDataDataItem>;
};

export type ComWixpressCloudDataApiDataUpstreamWixCommonBulkActionMetadata = {
  /** Number of items that couldn't be processed. */
  totalFailures?: Maybe<Scalars['Int']>;
  /** Number of items successfully processed. */
  totalSuccesses?: Maybe<Scalars['Int']>;
};

export enum ComWixpressCloudDataApiDataUpstreamWixCommonBulkActionType {
  DELETE = 'DELETE',
  INSERT = 'INSERT',
  PATCH = 'PATCH',
  UNKNOWN_ACTION_TYPE = 'UNKNOWN_ACTION_TYPE',
  UPDATE = 'UPDATE'
}

export type ComWixpressCloudDataApiDataUpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressCloudDataApiDataUpstreamWixCommonCursors = {
  /** Cursor pointing to next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export type ComWixpressCloudDataApiDataUpstreamWixCommonItemMetadata = {
  /** In case of failure, the error details. */
  error?: Maybe<WixApiApplicationError>;
  /** Item ID. Does not appear if the item ID is missing. For example, when item creation fails. */
  id?: Maybe<Scalars['String']>;
  /** Original index of the item in the array specified in the request. Use this to match items in the request with those in the response. */
  originalIndex?: Maybe<Scalars['Int']>;
  /** Whether the requested action was successful. When `false`, the `error` field is populated. */
  success?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressCloudDataApiDataUpstreamWixCommonPagingInput = {
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the current sort order. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressCloudDataApiDataUpstreamWixCommonPagingMetadataV2 = {
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Cursors to navigate through the result pages using `next` and `prev`. Returned if cursor paging is used. */
  cursors?: Maybe<ComWixpressCloudDataApiDataUpstreamWixCommonCursors>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
  /** Offset that was requested. */
  offset?: Maybe<Scalars['Int']>;
  /** Whether the server failed to calculate the `total` field. */
  tooManyToCount?: Maybe<Scalars['Boolean']>;
  /** Total number of items that match the query. Returned if offset paging is used, `returnTotalCount` is `true` in the request, and `tooManyToCount` is false. */
  total?: Maybe<Scalars['Int']>;
};

export type ComWixpressCloudDataApiDataUpstreamWixCommonQueryV2Input = {
  /**
   * Cursor pointing to a page of results. Not used in the first request.
   *
   * Subsequent requests use the cursor and ignore `filter` and `sort`.
   */
  cursorPaging?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonCursorPagingInput>;
  /**
   * Fields to include for each retrieved item. Only fields specified in the array are included in the response. If the array is empty, all fields are returned.
   *
   * > **Note:** The `_id` system field is always returned.
   */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter object.
   *
   * Learn more about filters in [API Query Language](https://dev.wix.com/docs/rest/articles/get-started/api-query-language#filters).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Paging options to limit and skip the number of retrieved items. */
  paging?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonPagingInput>;
  /**
   * Sort object.
   *
   * Learn more about sorting in [API Query Language](https://dev.wix.com/docs/rest/articles/get-started/api-query-language#sorting).
   */
  sort?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonSortingInput>>>;
};

export type ComWixpressCloudDataApiDataUpstreamWixCommonSearchDetailsInput = {
  /** Search query. Search terms are separated by whitespace. */
  expression?: InputMaybe<Scalars['String']>;
  /**
   * Whether to use fuzzy search to accommodate typos and partial matches.
   *
   * Default: `false`.
   */
  fuzzy?: InputMaybe<Scalars['Boolean']>;
  /**
   * Determines how multiple search terms are handled.
   *
   * Default: `OR`.
   */
  mode?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonSearchDetailsMode>;
};

export enum ComWixpressCloudDataApiDataUpstreamWixCommonSearchDetailsMode {
  /** Logical **AND** relationship. All search terms must exist for an item to be retrieved. */
  AND = 'AND',
  /** Logical **OR** relationship. Any search term must exist for an item to be retrieved. */
  OR = 'OR'
}

export type ComWixpressCloudDataApiDataUpstreamWixCommonSearchInput = {
  /**
   * Cursor pointing to a page of results. Not used in the first request.
   *
   * Subsequent requests use this cursor and ignore `filter` and `sort`.
   */
  cursorPaging?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonCursorPagingInput>;
  /**
   * Fields to include for each retrieved item. Only fields specified in the array are included in the response. If the array is empty, all fields are returned.
   *
   * > **Note:** The `_id` system field is always returned.
   */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter object.
   *
   * Learn more about filters in [API Query Language](https://dev.wix.com/docs/rest/articles/get-started/api-query-language#filters).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Options for limiting and skipping the number of retrieved items. */
  paging?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonPagingInput>;
  /** Text to search in the specified collection. */
  search?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonSearchDetailsInput>;
  /**
   * Sort object.
   *
   * Learn more about sorting in [API Query Language](https://dev.wix.com/docs/rest/articles/get-started/api-query-language#sorting).
   */
  sort?: InputMaybe<Array<InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonSortingInput>>>;
};

export enum ComWixpressCloudDataApiDataUpstreamWixCommonSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type ComWixpressCloudDataApiDataUpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<ComWixpressCloudDataApiDataUpstreamWixCommonSortOrder>;
};

export enum ComWixpressCloudDataApiEnvironment {
  /** Collection [live environment](https://support.wix.com/en/article/cms-about-sandbox-and-live-collections-and-syncing#live-collections). */
  LIVE = 'LIVE',
  /** Collection [sandbox environment](https://support.wix.com/en/article/cms-about-sandbox-and-live-collections-and-syncing#sandbox-collections). */
  SANDBOX = 'SANDBOX',
  /** If the [collection's sandbox environment is enabled](https://support.wix.com/en/article/cms-accessing-and-syncing-your-sandbox-and-live-collections#enabling-sandbox-collections), run the task in the collection's sandbox environment. If not, run the task in the collection's live environment. */
  SANDBOX_PREFERRED = 'SANDBOX_PREFERRED',
  /** Place holder. Never returned by the service. */
  UNKNOWN_ENVIRONMENT = 'UNKNOWN_ENVIRONMENT'
}

export type ComWixpressContactsCoreApiV4ActivityIcon = {
  /** Icon name */
  name?: Maybe<Scalars['String']>;
  /** Icon url */
  url?: Maybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4ActivityIconInput = {
  /** Icon name */
  name?: InputMaybe<Scalars['String']>;
  /** Icon url */
  url?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4AssigneesWrapper = {
  /** List of site contributor user IDs. */
  items?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixpressContactsCoreApiV4AssigneesWrapperInput = {
  /** List of site contributor user IDs. */
  items?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressContactsCoreApiV4BulkAddSegmentToContactsRequestInput = {
  /** List of Contact ids */
  contactIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** List of existing segment ids */
  existsSegmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Segment id */
  segmentId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4BulkAddSegmentToContactsResponse = {
  /** Metadata on the bulk action */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** List of action results */
  results?: Maybe<Array<Maybe<WixCommonItemMetadata>>>;
};

export type ComWixpressContactsCoreApiV4BulkDeleteContactsRequestInput = {
  /**
   * Indicates whether to delete the contact that is a member. If set to `true`, the contact is deleted even
   * if it is a member and the member is also deleted. Default: `false`
   */
  deleteMember?: InputMaybe<Scalars['Boolean']>;
  /**
   * Filter object.
   *
   * Possible filters:
   * `$eq`, `$exists`, `$gt`, `$gte`, `$hasAll`, `$hasSome`, `$in`, `$lt`, `$lte`, `$ne`, `$startsWith`.
   *
   * See [Sort, Filter, and Search](https://dev.wix.com/docs/rest/crm/members-contacts/contacts/contacts/contact-v4/sort-filter-and-search)
   * for a detailed list of supported filters for contact properties, extended fields, and custom fields.
   *
   *
   * Example:
   * `{ "filter": { "info.name.last": "Smith" } }`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Plain text search for an exact match, up to 100 characters.
   *
   * Searchable fields:
   *
   * - `info.name.first`
   * - `info.name.last`
   * - `info.emails.email`
   * - `info.phones.phone`
   */
  search?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4BulkDeleteContactsResponse = {
  /**
   * Bulk job ID.
   * The job's status can be retrieved with Get Bulk Job.
   */
  jobId?: Maybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4BulkLabelAndUnlabelContactsRequestInput = {
  /**
   * Filter options.
   * Labels will be removed from contacts that meet the `filter` and `search` criteria.
   *
   * See
   * [Field Support for Filtering, Sorting, and Searching](https://dev.wix.com/docs/rest/crm/members-contacts/contacts/contacts/contact-v4/sort-filter-and-search)
   * for a list of supported filters and fields.
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * List of label keys to add to the contacts.
   *
   * Label keys must exist to be added to the contact.
   * Contact labels can be created or retrieved with
   * [Find or Create Label](https://dev.wix.com/api/rest/contacts/labels/find-or-create-label)
   * or
   * [List Labels](https://dev.wix.com/api/rest/contacts/labels/list-labels)
   */
  labelKeysToAdd?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** List of label keys to remove from the contacts. */
  labelKeysToRemove?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Plain text search for an exact match, up to 100 characters.
   * Labels will be removed from contacts that meet the `filter` and `search` criteria.
   *
   * See
   * [Field Support for Filtering, Sorting, and Searching](https://dev.wix.com/docs/rest/crm/members-contacts/contacts/contacts/contact-v4/sort-filter-and-search)
   * for a list of searchable fields.
   */
  search?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4BulkLabelAndUnlabelContactsResponse = {
  /**
   * Bulk job ID.
   * The job's status can be retrieved with Get Bulk Job.
   */
  jobId?: Maybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4BulkRemoveSegmentFromContactsRequestInput = {
  /** List of Contact ids */
  contactIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Segment id */
  segmentId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4BulkRemoveSegmentFromContactsResponse = {
  /** Metadata on the bulk action */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** List of action results */
  results?: Maybe<Array<Maybe<WixCommonItemMetadata>>>;
};

export type ComWixpressContactsCoreApiV4BulkUpdateContactsRequestInput = {
  /**
   * Set of fields to update.
   * Fields that aren't included in `fieldMask.paths` are ignored.
   * See
   * [Field Masks in Update Requests](https://dev.wix.com/api/rest/contacts/contacts/field-masks-in-update-requests)
   * for details on working with field masks.
   */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter object.
   *
   * Possible filters:
   * `$eq`, `$exists`, `$gt`, `$gte`, `$hasAll`, `$hasSome`, `$in`, `$lt`, `$lte`, `$ne`, `$startsWith`.
   *
   * See [Sort, Filter, and Search](https://dev.wix.com/docs/rest/crm/members-contacts/contacts/contacts/contact-v4/sort-filter-and-search)
   * for a detailed list of supported filters for contact properties, extended fields, and custom fields.
   *
   *
   * Example:
   * `{ "filter": { "info.name.last": "Smith" } }`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Contact info. */
  info?: InputMaybe<ComWixpressContactsCoreApiV4ContactInfoInput>;
  /**
   * Plain text search for an exact match, up to 100 characters.
   *
   * Searchable fields:
   *
   * - `info.name.first`
   * - `info.name.last`
   * - `info.emails.email`
   * - `info.phones.phone`
   */
  search?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4BulkUpdateContactsResponse = {
  /**
   * Bulk job ID.
   * The job's status can be retrieved with Get Bulk Job.
   */
  jobId?: Maybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4BulkUpsertContactsRequestInput = {
  info?: InputMaybe<Array<InputMaybe<ComWixpressContactsCoreApiV4ContactInfoInput>>>;
  returnFullEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressContactsCoreApiV4BulkUpsertContactsResponse = {
  metadata?: Maybe<ComWixpressContactsCoreApiV4BulkUpsertContactsResponseMetadata>;
  results?: Maybe<Array<Maybe<ComWixpressContactsCoreApiV4BulkUpsertContactsResponseItem>>>;
};

export type ComWixpressContactsCoreApiV4BulkUpsertContactsResponseItem = {
  contact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
  metadata?: Maybe<ComWixpressContactsCoreApiV4BulkUpsertContactsResponseItemMetadata>;
};

export type ComWixpressContactsCoreApiV4BulkUpsertContactsResponseItemMetadata = {
  action?: Maybe<ComWixpressContactsCoreApiV4BulkUpsertContactsResponseItemMetadataAction>;
  error?: Maybe<ComWixpressContactsCoreApiV4BulkUpsertContactsResponseItemMetadataError>;
  id?: Maybe<Scalars['String']>;
  originalIndex?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

export enum ComWixpressContactsCoreApiV4BulkUpsertContactsResponseItemMetadataAction {
  CREATED = 'CREATED',
  UNKNOWN = 'UNKNOWN',
  UPDATED = 'UPDATED'
}

export type ComWixpressContactsCoreApiV4BulkUpsertContactsResponseItemMetadataError = {
  /** Error code. */
  code?: Maybe<Scalars['String']>;
  /** Error details. */
  message?: Maybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4BulkUpsertContactsResponseMetadata = {
  totalCreated?: Maybe<Scalars['Int']>;
  totalFailure?: Maybe<Scalars['Int']>;
  totalSuccess?: Maybe<Scalars['Int']>;
  totalUpdated?: Maybe<Scalars['Int']>;
};

export type ComWixpressContactsCoreApiV4Contact = {
  /** Date and time the contact was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Contact ID. */
  id?: Maybe<Scalars['String']>;
  /** Contact's details. */
  info?: Maybe<ComWixpressContactsCoreApiV4ContactInfo>;
  /** Details about the contact's last action in the site. */
  lastActivity?: Maybe<ComWixpressContactsCoreApiV4ContactActivity>;
  /** Contact's member info. */
  memberInfo?: Maybe<ComWixpressContactsCoreApiV4MemberInfo>;
  /**
   * Contact's profile picture.
   * This can contain an image URL and a Wix Media image ID.
   *
   * > **Deprecation Notice:**
   * > This property has been replaced with
   * > `info.picture`
   * > and will be removed on March 31, 2022. If your app uses this property,
   * > we recommend updating your code as soon as possible.
   */
  picture?: Maybe<ComWixpressContactsCoreApiV4UpstreamWixCommonImage>;
  /** Contact's primary email details. */
  primaryEmail?: Maybe<ComWixpressContactsCoreApiV4PrimaryEmail>;
  /** Contact's primary phone and email. */
  primaryInfo?: Maybe<ComWixpressContactsCoreApiV4PrimaryContactInfo>;
  /** Contact's primary phone details. */
  primaryPhone?: Maybe<ComWixpressContactsCoreApiV4PrimaryPhone>;
  /**
   * Revision number, which increments by 1 each time the contact is updated.
   * To prevent conflicting changes,
   * the existing `revision` must be specified when updating a contact.
   */
  revision?: Maybe<Scalars['Int']>;
  /** Contact's segment IDs */
  segments?: Maybe<ComWixpressContactsCoreApiV4SegmentsWrapper>;
  /** Details about the contact's source. */
  source?: Maybe<ComWixpressContactsCoreApiV4ContactSource>;
  /** Date and time the contact was last updated. */
  updatedDate?: Maybe<Scalars['String']>;
  walletsVirtualReference?: Maybe<WixRiseV1QueryWalletsResponse>;
};


export type ComWixpressContactsCoreApiV4ContactWalletsVirtualReferenceArgs = {
  queryInput?: InputMaybe<WixRiseV1QueryWalletsRequestInput>;
};

export type ComWixpressContactsCoreApiV4ContactActivity = {
  /** Date and time of the last action. */
  activityDate?: Maybe<Scalars['String']>;
  /** Contact's last action in the site. */
  activityType?: Maybe<ComWixpressContactsCoreApiV4ContactActivityContactActivityType>;
  /** Date and time of the activity. */
  date?: Maybe<Scalars['String']>;
  /** Activity description. Translated. */
  description?: Maybe<Scalars['String']>;
  /** Activity Icon */
  icon?: Maybe<ComWixpressContactsCoreApiV4ActivityIcon>;
};

export enum ComWixpressContactsCoreApiV4ContactActivityContactActivityType {
  /** Became a new Wix Marketplace lead. */
  ARENA_NEW_LEAD = 'ARENA_NEW_LEAD',
  /** Booked an appointment. */
  BOOKINGS_APPOINTMENT = 'BOOKINGS_APPOINTMENT',
  /** Made a purchase with a pay button. */
  CASHIER_BUTTON_PURCHASE = 'CASHIER_BUTTON_PURCHASE',
  /** Became a new contact. */
  CONTACT_CREATED = 'CONTACT_CREATED',
  /** Merged with another contact. */
  CONTACT_MERGED = 'CONTACT_MERGED',
  /** Abandoned a shopping cart. */
  ECOM_CART_ABANDON = 'ECOM_CART_ABANDON',
  /** Checked out shopping cart and submitted buyer info (but didn’t complete the purchase yet). */
  ECOM_CHECKOUT_BUYER = 'ECOM_CHECKOUT_BUYER',
  /** Made a purchase. */
  ECOM_PURCHASE = 'ECOM_PURCHASE',
  /** RSVP'd to an event. */
  EVENTS_RSVP = 'EVENTS_RSVP',
  /** Submitted a form. */
  FORM_SUBMITTED = 'FORM_SUBMITTED',
  /** Visited the site. */
  GENERAL = 'GENERAL',
  /** Canceled a Wix Hotels reservation. */
  HOTELS_CANCEL = 'HOTELS_CANCEL',
  /** Confirmed a Wix Hotels reservation. */
  HOTELS_CONFIRMATION = 'HOTELS_CONFIRMATION',
  /** Paid for a Wix Hotels reservation. */
  HOTELS_PURCHASE = 'HOTELS_PURCHASE',
  /** Made a Wix Hotels reservation. */
  HOTELS_RESERVATION = 'HOTELS_RESERVATION',
  /** Started a chat. */
  INBOX_FORM_SUBMITTED = 'INBOX_FORM_SUBMITTED',
  /** Sent a new message to the site. */
  INBOX_MESSAGE_FROM_CUSTOMER = 'INBOX_MESSAGE_FROM_CUSTOMER',
  /** Received a message from the site. */
  INBOX_MESSAGE_TO_CUSTOMER = 'INBOX_MESSAGE_TO_CUSTOMER',
  /** Paid a payment request. */
  INBOX_PAYMENT_REQUEST_PAID = 'INBOX_PAYMENT_REQUEST_PAID',
  /** An invoice is now overdue. */
  INVOICE_OVERDUE = 'INVOICE_OVERDUE',
  /** Paid an invoice. */
  INVOICE_PAY = 'INVOICE_PAY',
  /** Logged in. */
  MEMBER_LOGIN = 'MEMBER_LOGIN',
  /** Requested a site membership. */
  MEMBER_REGISTER = 'MEMBER_REGISTER',
  /** Was approved, blocked, or unblocked. */
  MEMBER_STATUS_CHANGED = 'MEMBER_STATUS_CHANGED',
  /** Subscribed to a site newsletter through a form. */
  NEWSLETTER_SUBSCRIPTION_FORM_SUBMITTED = 'NEWSLETTER_SUBSCRIPTION_FORM_SUBMITTED',
  /** Subscription status to site newsletters is not set. */
  NEWSLETTER_SUBSCRIPTION_NOT_SET = 'NEWSLETTER_SUBSCRIPTION_NOT_SET',
  /** Subscription status to site newsletters is pending confirmation. */
  NEWSLETTER_SUBSCRIPTION_PENDING = 'NEWSLETTER_SUBSCRIPTION_PENDING',
  /** Subscribed to a site newsletter. */
  NEWSLETTER_SUBSCRIPTION_SUBSCRIBE = 'NEWSLETTER_SUBSCRIPTION_SUBSCRIBE',
  /** Unsubscribed from a site newsletter. */
  NEWSLETTER_SUBSCRIPTION_UNSUBSCRIBE = 'NEWSLETTER_SUBSCRIPTION_UNSUBSCRIBE',
  /** Subscription to phone notificatons is not set. */
  PHONE_SUBSCRIPTION_NOT_SET = 'PHONE_SUBSCRIPTION_NOT_SET',
  /** Subscription to phone notificatons is pending confirmation. */
  PHONE_SUBSCRIPTION_PENDING = 'PHONE_SUBSCRIPTION_PENDING',
  /** Subscribed to phone notifications. */
  PHONE_SUBSCRIPTION_SUBSCRIBE = 'PHONE_SUBSCRIPTION_SUBSCRIBE',
  /** Subscribed to phone notifications. */
  PHONE_SUBSCRIPTION_UNSUBSCRIBE = 'PHONE_SUBSCRIPTION_UNSUBSCRIBE',
  /** Accepted a price quote. */
  PRICE_QUOTE_ACCEPT = 'PRICE_QUOTE_ACCEPT',
  /** A price quote has expired. */
  PRICE_QUOTE_EXPIRE = 'PRICE_QUOTE_EXPIRE',
  /** Ordered food with Wix Restaurants. */
  RESTAURANTS_ORDER = 'RESTAURANTS_ORDER',
  /** Made a Wix Restaurants reservation. */
  RESTAURANTS_RESERVATION = 'RESTAURANTS_RESERVATION',
  /** Clicked a link in an email from the site. */
  SHOUTOUT_CLICK = 'SHOUTOUT_CLICK',
  /** Opened an email from the site. */
  SHOUTOUT_OPEN = 'SHOUTOUT_OPEN',
  /** Purchased a video. */
  VIDEO_PURCHASE = 'VIDEO_PURCHASE',
  /** Rented a video. */
  VIDEO_RENT = 'VIDEO_RENT'
}

export type ComWixpressContactsCoreApiV4ContactActivityInput = {
  /** Date and time of the last action. */
  activityDate?: InputMaybe<Scalars['String']>;
  /** Contact's last action in the site. */
  activityType?: InputMaybe<ComWixpressContactsCoreApiV4ContactActivityContactActivityType>;
  /** Date and time of the activity. */
  date?: InputMaybe<Scalars['String']>;
  /** Activity description. Translated. */
  description?: InputMaybe<Scalars['String']>;
  /** Activity Icon */
  icon?: InputMaybe<ComWixpressContactsCoreApiV4ActivityIconInput>;
};

export type ComWixpressContactsCoreApiV4ContactAddress = {
  /** Street address. */
  address?: Maybe<ComWixpressContactsCoreApiV4UpstreamWixCommonAddress>;
  /** Street address ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Address type.
   * `UNTAGGED` is shown as "Other" in the Contact List.
   */
  tag?: Maybe<ComWixpressContactsCoreApiV4ContactAddressAddressTag>;
};

export enum ComWixpressContactsCoreApiV4ContactAddressAddressTag {
  BILLING = 'BILLING',
  HOME = 'HOME',
  SHIPPING = 'SHIPPING',
  UNTAGGED = 'UNTAGGED',
  WORK = 'WORK'
}

export type ComWixpressContactsCoreApiV4ContactAddressInput = {
  /** Street address. */
  address?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixCommonAddressInput>;
  /** Street address ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Address type.
   * `UNTAGGED` is shown as "Other" in the Contact List.
   */
  tag?: InputMaybe<ComWixpressContactsCoreApiV4ContactAddressAddressTag>;
};

export type ComWixpressContactsCoreApiV4ContactAddressesWrapper = {
  /** List of up to 50 addresses. */
  items?: Maybe<Array<Maybe<ComWixpressContactsCoreApiV4ContactAddress>>>;
};

export type ComWixpressContactsCoreApiV4ContactAddressesWrapperInput = {
  /** List of up to 50 addresses. */
  items?: InputMaybe<Array<InputMaybe<ComWixpressContactsCoreApiV4ContactAddressInput>>>;
};

export type ComWixpressContactsCoreApiV4ContactEmail = {
  /** Email address. */
  email?: Maybe<Scalars['String']>;
  /** Email ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Indicates whether this is the contact's primary email address.
   * When changing `primary` to `true` for an email,
   * the contact's other emails become `false`.
   * Changing the primary email of a contact also affects the subscription status to marketing emails that are decided based on the primary email.
   */
  primary?: Maybe<Scalars['Boolean']>;
  /**
   * Email type.
   *
   * `UNTAGGED` is shown as "Other" in the Contact List.
   */
  tag?: Maybe<ComWixpressContactsCoreApiV4ContactEmailEmailTag>;
};

export enum ComWixpressContactsCoreApiV4ContactEmailEmailTag {
  HOME = 'HOME',
  MAIN = 'MAIN',
  UNTAGGED = 'UNTAGGED',
  WORK = 'WORK'
}

export type ComWixpressContactsCoreApiV4ContactEmailInput = {
  /** Email address. */
  email?: InputMaybe<Scalars['String']>;
  /** Email ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Indicates whether this is the contact's primary email address.
   * When changing `primary` to `true` for an email,
   * the contact's other emails become `false`.
   * Changing the primary email of a contact also affects the subscription status to marketing emails that are decided based on the primary email.
   */
  primary?: InputMaybe<Scalars['Boolean']>;
  /**
   * Email type.
   *
   * `UNTAGGED` is shown as "Other" in the Contact List.
   */
  tag?: InputMaybe<ComWixpressContactsCoreApiV4ContactEmailEmailTag>;
};

export type ComWixpressContactsCoreApiV4ContactEmailsWrapper = {
  /** List of up to 50 email addresses. */
  items?: Maybe<Array<Maybe<ComWixpressContactsCoreApiV4ContactEmail>>>;
};

export type ComWixpressContactsCoreApiV4ContactEmailsWrapperInput = {
  /** List of up to 50 email addresses. */
  items?: InputMaybe<Array<InputMaybe<ComWixpressContactsCoreApiV4ContactEmailInput>>>;
};

export enum ComWixpressContactsCoreApiV4ContactFieldSet {
  /** name, primaryEmail, primaryPhone */
  BASIC = 'BASIC',
  /** name, phones, emails, addresses */
  COMMUNICATION_DETAILS = 'COMMUNICATION_DETAILS',
  /** name, primaryInfo(email, phone), extendedFields */
  EXTENDED = 'EXTENDED',
  /** Full contact object */
  FULL = 'FULL'
}

export type ComWixpressContactsCoreApiV4ContactInfo = {
  /** Contact's street addresses. */
  addresses?: Maybe<ComWixpressContactsCoreApiV4ContactAddressesWrapper>;
  /**
   * Site contributors
   * who are assigned to manage communication with the contact.
   */
  assignedUserIds?: Maybe<ComWixpressContactsCoreApiV4AssigneesWrapper>;
  /** Birth date in `YYYY-MM-DD` format. For example, `2020-03-15`. */
  birthdate?: Maybe<Scalars['String']>;
  /** Contact's company name. */
  company?: Maybe<Scalars['String']>;
  /**
   * List of contact's labels.
   *
   * Labels are used to organize contacts. Labels can be
   * added and removed using Label Contact and Unlabel Contact, respectively.
   *
   * To view or manage contact labels, use the Labels API.
   */
  contactLabel?: Maybe<ComWixpressContactsLabelsV4ContactLabel>;
  /** Contact's email addresses. */
  emails?: Maybe<ComWixpressContactsCoreApiV4ContactEmailsWrapper>;
  /**
   * Additional custom fields.
   *
   * Empty fields are not returned.
   */
  extendedFields?: Maybe<ComWixpressContactsCoreApiV4ExtendedFieldsWrapper>;
  /** Contact's job title. */
  jobTitle?: Maybe<Scalars['String']>;
  /**
   * List of contact's labels.
   *
   * Labels are used to organize contacts. Labels can be
   * added and removed using Label Contact and Unlabel Contact, respectively.
   *
   * To view or manage contact labels, use the Labels API.
   */
  labelKeys?: Maybe<ComWixpressContactsCoreApiV4LabelsWrapper>;
  /**
   * Locale in
   * [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * Typically, this is a lowercase 2-letter language code,
   * followed by a hyphen, followed by an uppercase 2-letter country code.
   * For example, `en-US` for U.S. English, and `de-DE` for Germany German.
   */
  locale?: Maybe<Scalars['String']>;
  /** Contact locations. */
  locations?: Maybe<ComWixpressContactsCoreApiV4LocationsWrapper>;
  /** Contact's first and last name. */
  name?: Maybe<ComWixpressContactsCoreApiV4ContactName>;
  /** Contact's phone numbers. */
  phones?: Maybe<ComWixpressContactsCoreApiV4ContactPhonesWrapper>;
  /** Contact's profile picture. */
  picture?: Maybe<ComWixpressContactsCoreApiV4ContactPicture>;
};

export type ComWixpressContactsCoreApiV4ContactInfoInput = {
  /** Contact's street addresses. */
  addresses?: InputMaybe<ComWixpressContactsCoreApiV4ContactAddressesWrapperInput>;
  /**
   * Site contributors
   * who are assigned to manage communication with the contact.
   */
  assignedUserIds?: InputMaybe<ComWixpressContactsCoreApiV4AssigneesWrapperInput>;
  /** Birth date in `YYYY-MM-DD` format. For example, `2020-03-15`. */
  birthdate?: InputMaybe<Scalars['String']>;
  /** Contact's company name. */
  company?: InputMaybe<Scalars['String']>;
  /** Contact's email addresses. */
  emails?: InputMaybe<ComWixpressContactsCoreApiV4ContactEmailsWrapperInput>;
  /**
   * Additional custom fields.
   *
   * Empty fields are not returned.
   */
  extendedFields?: InputMaybe<ComWixpressContactsCoreApiV4ExtendedFieldsWrapperInput>;
  /** Contact's job title. */
  jobTitle?: InputMaybe<Scalars['String']>;
  /**
   * List of contact's labels.
   *
   * Labels are used to organize contacts. Labels can be
   * added and removed using Label Contact and Unlabel Contact, respectively.
   *
   * To view or manage contact labels, use the Labels API.
   */
  labelKeys?: InputMaybe<ComWixpressContactsCoreApiV4LabelsWrapperInput>;
  /**
   * Locale in
   * [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * Typically, this is a lowercase 2-letter language code,
   * followed by a hyphen, followed by an uppercase 2-letter country code.
   * For example, `en-US` for U.S. English, and `de-DE` for Germany German.
   */
  locale?: InputMaybe<Scalars['String']>;
  /** Contact locations. */
  locations?: InputMaybe<ComWixpressContactsCoreApiV4LocationsWrapperInput>;
  /** Contact's first and last name. */
  name?: InputMaybe<ComWixpressContactsCoreApiV4ContactNameInput>;
  /** Contact's phone numbers. */
  phones?: InputMaybe<ComWixpressContactsCoreApiV4ContactPhonesWrapperInput>;
  /** Contact's profile picture. */
  picture?: InputMaybe<ComWixpressContactsCoreApiV4ContactPictureInput>;
};

export type ComWixpressContactsCoreApiV4ContactName = {
  /** Contact's first name. */
  first?: Maybe<Scalars['String']>;
  /** Contact's last name. */
  last?: Maybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4ContactNameInput = {
  /** Contact's first name. */
  first?: InputMaybe<Scalars['String']>;
  /** Contact's last name. */
  last?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4ContactPhone = {
  /** [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) country code. */
  countryCode?: Maybe<Scalars['String']>;
  /**
   * [ITU E.164-formatted](https://www.itu.int/rec/T-REC-E.164/)
   * phone number.
   * Automatically generated using `phone` and `countryCode`, pending both values are valid.
   */
  e164Phone?: Maybe<Scalars['String']>;
  /** Formatted phone. Automatically generated using phone and countryCode. */
  formattedPhone?: Maybe<Scalars['String']>;
  /** Phone ID. */
  id?: Maybe<Scalars['String']>;
  /** Phone number. */
  phone?: Maybe<Scalars['String']>;
  /**
   * Indicates whether this is the contact's primary phone number.
   * When changing `primary` to `true` for a phone,
   * the contact's `primary` field for other phones becomes `false`.
   * Changing the primary phone number also affects the subscription status to SMS messages that are decided based on the primary phone.
   */
  primary?: Maybe<Scalars['Boolean']>;
  /**
   * Phone type.
   *
   * `UNTAGGED` is shown as "Other" in the Contact List.
   */
  tag?: Maybe<ComWixpressContactsCoreApiV4ContactPhonePhoneTag>;
};

export type ComWixpressContactsCoreApiV4ContactPhoneInput = {
  /** [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) country code. */
  countryCode?: InputMaybe<Scalars['String']>;
  /**
   * [ITU E.164-formatted](https://www.itu.int/rec/T-REC-E.164/)
   * phone number.
   * Automatically generated using `phone` and `countryCode`, pending both values are valid.
   */
  e164Phone?: InputMaybe<Scalars['String']>;
  /** Formatted phone. Automatically generated using phone and countryCode. */
  formattedPhone?: InputMaybe<Scalars['String']>;
  /** Phone ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Phone number. */
  phone?: InputMaybe<Scalars['String']>;
  /**
   * Indicates whether this is the contact's primary phone number.
   * When changing `primary` to `true` for a phone,
   * the contact's `primary` field for other phones becomes `false`.
   * Changing the primary phone number also affects the subscription status to SMS messages that are decided based on the primary phone.
   */
  primary?: InputMaybe<Scalars['Boolean']>;
  /**
   * Phone type.
   *
   * `UNTAGGED` is shown as "Other" in the Contact List.
   */
  tag?: InputMaybe<ComWixpressContactsCoreApiV4ContactPhonePhoneTag>;
};

export enum ComWixpressContactsCoreApiV4ContactPhonePhoneTag {
  FAX = 'FAX',
  HOME = 'HOME',
  MAIN = 'MAIN',
  MOBILE = 'MOBILE',
  UNTAGGED = 'UNTAGGED',
  WORK = 'WORK'
}

export type ComWixpressContactsCoreApiV4ContactPhonesWrapper = {
  /** List of up to 50 phone numbers. */
  items?: Maybe<Array<Maybe<ComWixpressContactsCoreApiV4ContactPhone>>>;
};

export type ComWixpressContactsCoreApiV4ContactPhonesWrapperInput = {
  /** List of up to 50 phone numbers. */
  items?: InputMaybe<Array<InputMaybe<ComWixpressContactsCoreApiV4ContactPhoneInput>>>;
};

export type ComWixpressContactsCoreApiV4ContactPicture = {
  /**
   * Image.
   * This can contain an image URL or a Wix Media image ID.
   */
  image?: Maybe<ComWixpressContactsCoreApiV4UpstreamWixCommonImage>;
  /**
   * Indicates whether the image is retrieved from Wix Media
   * or an external provider.
   *
   * - `EXTERNAL`: The image is retrieved from an external provider.
   * - `WIX_MEDIA`: The image is retrieved from Wix Media.
   */
  imageProvider?: Maybe<ComWixpressContactsCoreApiV4ContactPictureImageProvider>;
};

export enum ComWixpressContactsCoreApiV4ContactPictureImageProvider {
  /** Image stored outside Wix */
  EXTERNAL = 'EXTERNAL',
  UNKNOWN = 'UNKNOWN',
  /** Stored in wix media platform, Must be uploaded by using `GeneratePictureUploadUrl` */
  WIX_MEDIA = 'WIX_MEDIA'
}

export type ComWixpressContactsCoreApiV4ContactPictureInput = {
  /**
   * Image.
   * This can contain an image URL or a Wix Media image ID.
   */
  image?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixCommonImageInput>;
  /**
   * Indicates whether the image is retrieved from Wix Media
   * or an external provider.
   *
   * - `EXTERNAL`: The image is retrieved from an external provider.
   * - `WIX_MEDIA`: The image is retrieved from Wix Media.
   */
  imageProvider?: InputMaybe<ComWixpressContactsCoreApiV4ContactPictureImageProvider>;
};

export type ComWixpressContactsCoreApiV4ContactSource = {
  /** App ID, if the contact was created by an app. */
  appId?: Maybe<Scalars['String']>;
  /** Source type. */
  sourceType?: Maybe<ComWixpressContactsCoreApiV4ContactSourceContactSourceType>;
  /**
   * App ID, if the contact was created by a Wix app.
   *
   * > **Deprecation Notice:**
   * > This property has been replaced with
   * > `appId`
   * > and will be removed on March 31, 2022. If your app uses this property,
   * > we recommend updating your code as soon as possible.
   */
  wixAppId?: Maybe<Scalars['String']>;
};

export enum ComWixpressContactsCoreApiV4ContactSourceContactSourceType {
  ADMIN = 'ADMIN',
  HOPP = 'HOPP',
  IMPORT = 'IMPORT',
  OTHER = 'OTHER',
  THIRD_PARTY = 'THIRD_PARTY',
  WIX_APP = 'WIX_APP',
  WIX_BOOKINGS = 'WIX_BOOKINGS',
  WIX_CHAT = 'WIX_CHAT',
  WIX_CODE = 'WIX_CODE',
  WIX_EMAIL_MARKETING = 'WIX_EMAIL_MARKETING',
  WIX_EVENTS = 'WIX_EVENTS',
  WIX_FORMS = 'WIX_FORMS',
  WIX_GROUPS = 'WIX_GROUPS',
  WIX_HOTELS = 'WIX_HOTELS',
  WIX_MARKET_PLACE = 'WIX_MARKET_PLACE',
  WIX_MUSIC = 'WIX_MUSIC',
  WIX_RESTAURANTS = 'WIX_RESTAURANTS',
  WIX_SITE_MEMBERS = 'WIX_SITE_MEMBERS',
  WIX_STORES = 'WIX_STORES'
}

export type ComWixpressContactsCoreApiV4ContactsFacet = {
  /** Number of contacts the facet applies to. */
  count?: Maybe<Scalars['Int']>;
  /** Human-readable name. Shown in the Wix UI. */
  facetDisplayName?: Maybe<Scalars['String']>;
  /** Facet key, automatically generated. */
  facetKey?: Maybe<Scalars['String']>;
  /** Type of facet. */
  facetType?: Maybe<ComWixpressContactsCoreApiV4ContactsFacetContactsFacetType>;
  /** Legacy ID of the facet label */
  legacyId?: Maybe<Scalars['String']>;
  /**
   * Scope for facet keys.
   * When a facet key exists in a namespace,
   * each key is unique within that namespace.
   *
   * Currently, facets not created by Wix are in the `custom` namespace.
   */
  namespace?: Maybe<Scalars['String']>;
  /** Human-readable display name. */
  namespaceDisplayName?: Maybe<Scalars['String']>;
  /** Filter used to query contacts of this facet. */
  queryFilter?: Maybe<Scalars['JSON']>;
};

export enum ComWixpressContactsCoreApiV4ContactsFacetContactsFacetType {
  ALL_CONTACTS = 'ALL_CONTACTS',
  LABEL = 'LABEL',
  MEMBERSHIP_STATUS = 'MEMBERSHIP_STATUS',
  NOT_LABELED = 'NOT_LABELED',
  SUBSCRIPTION_STATUS = 'SUBSCRIPTION_STATUS',
  UNKNOWN = 'UNKNOWN'
}

export type ComWixpressContactsCoreApiV4CountContactsResponse = {
  count?: Maybe<Scalars['Int']>;
};

export type ComWixpressContactsCoreApiV4CreateContactRequestInput = {
  /**
   * Controls whether the call will succeed
   * if the new contact information contains an email or a phone number already used by another contact.
   *
   * If set to `true`,
   * the call will succeed even if an email address or phone number is used by another contact.
   * If set to `false`,
   * the call will fail if the given email address is used by another contact or,
   * if the email address is not given and the given phone number is used by another contact.
   *
   * Default: `false`
   */
  allowDuplicates?: InputMaybe<Scalars['Boolean']>;
  /** Contact info. */
  info?: InputMaybe<ComWixpressContactsCoreApiV4ContactInfoInput>;
  /** Language for localization. */
  language?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4CreateContactResponse = {
  /** Contact. */
  contact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
};

export type ComWixpressContactsCoreApiV4DeleteContactRequestInput = {
  /** ID of the contact to delete. */
  contactId?: InputMaybe<Scalars['String']>;
  /**
   * Indicates whether to delete the contact that is a member. If set to `true`, the contact is deleted even
   * if it is a member and the member is also deleted. Default: `false`
   */
  deleteMember?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressContactsCoreApiV4ExtendedFieldsWrapper = {
  /**
   * Contact's extended fields,
   * where each key is the field key,
   * and each value is the field's value for the contact.
   *
   * To view and manage extended fields, use the Extended Fields API.
   */
  items?: Maybe<Scalars['JSON']>;
};

export type ComWixpressContactsCoreApiV4ExtendedFieldsWrapperInput = {
  /**
   * Contact's extended fields,
   * where each key is the field key,
   * and each value is the field's value for the contact.
   *
   * To view and manage extended fields, use the Extended Fields API.
   */
  items?: InputMaybe<Scalars['JSON']>;
};

export type ComWixpressContactsCoreApiV4GeneratePictureUploadUrlRequestInput = {
  /** ID of the contact whose picture is being updated. */
  contactId?: InputMaybe<Scalars['String']>;
  /**
   * Mime Type. Must be one of:
   * `image/png`, `image/jpeg`.
   * Defaults to `image/png`.
   */
  mimeType?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4GeneratePictureUploadUrlResponse = {
  uploadId?: Maybe<Scalars['String']>;
  /** URL to upload the image */
  uploadUrl?: Maybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4GetContactRequestInput = {
  /**
   * List of projected fields to return.
   * If both `fields` and `fieldsets` are sent in the request,
   * the union of both lists is returned.
   * `id` and `revision` are always returned.
   *
   * Supported properties:
   * `source`, `createdDate`, `updatedDate`, `lastActivity`, `primaryInfo`,
   * `info.name`, `info.emails`, `info.phones`, `info.addresses`, `info.company`,
   * `info.jobTitle`, `info.picture`, `info.birthdate`, `info.locale`,
   * `info.labelKeys`, `info.locations`, `info.extendedFields`
   */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Predefined sets of fields to return.
   * If both `fields` and `fieldsets` are sent in the request,
   * the union of both lists is returned.
   *
   * - `BASIC`: Returns `id`, `revision`, `primaryInfo`, `info.name`.
   * - `COMMUNICATION_DETAILS`: Returns `id`, `revision`, `primaryInfo`, `info.name`, `info.emails`, `info.phones`, `info.addresses`.
   * - `EXTENDED`: Returns `id`, `revision`, `primaryInfo`, `info.name`, `info.extendedFields`.
   * - `FULL`: Returns all fields.
   *
   * Default: If `fields` is omitted from the request, `FULL`.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressContactsCoreApiV4ContactFieldSet>>>;
  id: Scalars['ID'];
  /** Language for localization. */
  language?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4GroupInfo = {
  /** Group IDs */
  groupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum ComWixpressContactsCoreApiV4IdentityInfoIdentityStatus {
  ACTIVE = 'ACTIVE',
  BLOCKED = 'BLOCKED',
  DELETED = 'DELETED',
  OFFLINE = 'OFFLINE',
  PENDING_ADMIN_APPROVAL = 'PENDING_ADMIN_APPROVAL',
  UNKNOWN_IDENTITY_STATUS = 'UNKNOWN_IDENTITY_STATUS'
}

export type ComWixpressContactsCoreApiV4LabelAndUnlabelContactRequestInput = {
  /** Contact ID. */
  contactId?: InputMaybe<Scalars['String']>;
  /**
   * List of label keys to add to the contact.
   *
   * Label keys must exist to be added to the contact.
   * Contact labels can be created or retrieved with
   * [Find or Create Label](https://dev.wix.com/api/rest/contacts/labels/find-or-create-label)
   * or
   * [List Labels](https://dev.wix.com/api/rest/contacts/labels/list-labels).
   */
  labelKeysToAdd?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** List of label keys to remove from the contact. */
  labelKeysToRemove?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Language for localization. */
  language?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4LabelAndUnlabelContactResponse = {
  /** Updated contact. */
  contact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
};

export type ComWixpressContactsCoreApiV4LabelContactRequestInput = {
  /** ID of the contact to add labels to. */
  contactId?: InputMaybe<Scalars['String']>;
  /**
   * List of label keys to add to the contact.
   *
   * Label keys must exist to be added to the contact.
   * Use the Labels API to create or retrieve labels.
   */
  labelKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Language for localization. */
  language?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4LabelContactResponse = {
  /** Updated contact. */
  contact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
};

export type ComWixpressContactsCoreApiV4LabelsWrapper = {
  /**
   * List of contact label keys.
   *
   * Contact labels help categorize contacts. Label keys must exist to be added to the contact.
   * Contact labels can be created or retrieved with Find or Create Label or List Labels.
   */
  items?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * List of contact label keys.
   *
   * Contact labels help categorize contacts. Label keys must exist to be added to the contact.
   * Contact labels can be created or retrieved with Find or Create Label or List Labels.
   */
  labels?: Maybe<ComWixpressContactsLabelsV4QueryLabelsResponse>;
};


export type ComWixpressContactsCoreApiV4LabelsWrapperLabelsArgs = {
  queryInput?: InputMaybe<ComWixpressContactsLabelsV4QueryLabelsRequestInput>;
};

export type ComWixpressContactsCoreApiV4LabelsWrapperInput = {
  /**
   * List of contact label keys.
   *
   * Contact labels help categorize contacts. Label keys must exist to be added to the contact.
   * Contact labels can be created or retrieved with Find or Create Label or List Labels.
   */
  items?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressContactsCoreApiV4ListContactIdsBySegmentRequestInput = {
  /** Cursor paging. */
  cursorPaging?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixCommonCursorPagingInput>;
  /** Segment id */
  segmentId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4ListContactIdsBySegmentResponse = {
  /** List of contact IDs */
  contactIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** List of contact IDs */
  contacts?: Maybe<ComWixpressContactsCoreApiV4QueryContactsResponse>;
  /** Paging metadata */
  cursorPagingMetadata?: Maybe<ComWixpressContactsCoreApiV4UpstreamWixCommonCursorPagingMetadata>;
};


export type ComWixpressContactsCoreApiV4ListContactIdsBySegmentResponseContactsArgs = {
  queryInput?: InputMaybe<ComWixpressContactsCoreApiV4QueryContactsRequestInput>;
};

export type ComWixpressContactsCoreApiV4ListContactsRequestInput = {
  /**
   * List of projected fields to return.
   * If both `fields` and `fieldsets` are sent in the request,
   * the union of both lists is returned.
   * `id` and `revision` are always returned.
   *
   * Supported properties:
   * `source`, `createdDate`, `updatedDate`, `lastActivity`, `primaryInfo`,
   * `info.name`, `info.emails`, `info.phones`, `info.addresses`, `info.company`,
   * `info.jobTitle`, `info.picture`, `info.birthdate`, `info.locale`,
   * `info.labelKeys`, `info.locations`, `info.extendedFields`
   */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressContactsCoreApiV4ContactFieldSet>>>;
  /** Language for localization. */
  language?: InputMaybe<Scalars['String']>;
  /** [Pagination](https://dev.wix.com/api/rest/getting-started/pagination), defaults to offset = 0 and limit = 50 (max limit 1,000). */
  paging?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixCommonPagingInput>;
  /** [Sort order](https://dev.wix.com/api/rest/contacts/contacts/sort-and-filter). */
  sort?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixCommonSortingInput>;
};

export type ComWixpressContactsCoreApiV4ListContactsResponse = {
  /** List of contacts. */
  contacts?: Maybe<Array<Maybe<ComWixpressContactsCoreApiV4Contact>>>;
  /** Details on the paged set of results returned. */
  pagingMetadata?: Maybe<ComWixpressContactsCoreApiV4UpstreamWixCommonPagingMetadata>;
};

export type ComWixpressContactsCoreApiV4ListFacetsRequestInput = {
  /** Language for localization. */
  language?: InputMaybe<Scalars['String']>;
  /** Whether to count the number of contacts per facet */
  omitCount?: InputMaybe<Scalars['Boolean']>;
  /** Pagination options. */
  paging?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixCommonPagingInput>;
};

export type ComWixpressContactsCoreApiV4ListFacetsResponse = {
  /** List of facets. */
  facets?: Maybe<Array<Maybe<ComWixpressContactsCoreApiV4ContactsFacet>>>;
  /** Details on the paged set of results returned. */
  pagingMetadata?: Maybe<ComWixpressContactsCoreApiV4UpstreamWixCommonPagingMetadata>;
};

export type ComWixpressContactsCoreApiV4LocationsWrapper = {
  /** List of location ids. */
  items?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixpressContactsCoreApiV4LocationsWrapperInput = {
  /** List of location ids. */
  items?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressContactsCoreApiV4MemberInfo = {
  /** Login email */
  email?: Maybe<Scalars['String']>;
  /** Indicates whether the member is required to verify their email */
  emailVerificationRequired?: Maybe<Scalars['Boolean']>;
  /** Indicate whether the email is verified */
  emailVerified?: Maybe<Scalars['Boolean']>;
  /** Group info */
  groupInfo?: Maybe<ComWixpressContactsCoreApiV4GroupInfo>;
  /** Member ID */
  member?: Maybe<ComWixpressMembersApiMember>;
  /** Member ID */
  memberId?: Maybe<Scalars['String']>;
  /** Profile info */
  profileInfo?: Maybe<ComWixpressContactsCoreApiV4ProfileInfo>;
  /** Session info */
  sessionInfo?: Maybe<ComWixpressContactsCoreApiV4SessionInfo>;
  /** Signup date */
  signupDate?: Maybe<Scalars['String']>;
  /**
   * Member status.
   * - `PENDING`: Member created and is waiting for approval by site owner.
   * - `ACTIVE`: Member can log in to the site.
   * - `OFFLINE`: Member is a [managed writer](https://support.wix.com/en/article/wix-blog-adding-managed-writers-to-your-blog) for the site blog and cannot log in to the site.
   * - `BLOCKED': Member is blocked and cannot log in to the site.
   */
  status?: Maybe<ComWixpressContactsCoreApiV4MemberInfoMemberStatus>;
  /** User info */
  userInfo?: Maybe<ComWixpressContactsCoreApiV4UserInfo>;
};

export enum ComWixpressContactsCoreApiV4MemberInfoMemberStatus {
  ACTIVE = 'ACTIVE',
  BLOCKED = 'BLOCKED',
  DELETED = 'DELETED',
  OFFLINE = 'OFFLINE',
  PENDING = 'PENDING',
  UNKNOWN_MEMBER_STATUS = 'UNKNOWN_MEMBER_STATUS'
}

export type ComWixpressContactsCoreApiV4MergeContactsRequestInput = {
  /** Language for localization. */
  language?: InputMaybe<Scalars['String']>;
  /**
   * IDs of up to 5 contacts to merge into the target contact.
   * When you merge more than one source contact,
   * the first source is given precedence, then the second, and so on.
   */
  sourceContactIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Target contact ID. */
  targetContactId?: InputMaybe<Scalars['String']>;
  /**
   * Target contact revision number, which increments by 1 each time the contact is updated.
   * To prevent conflicting changes,
   * the target contact's current `revision` must be specified.
   */
  targetContactRevision?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressContactsCoreApiV4MergeContactsResponse = {
  /** Updated target contact. */
  contact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
};

export type ComWixpressContactsCoreApiV4PreviewMergeContactsRequestInput = {
  /** Language for localization. */
  language?: InputMaybe<Scalars['String']>;
  /**
   * IDs of up to 5 contacts to merge into the target contact.
   * When you merge more than one source contact,
   * the first source is given precedence, then the second, and so on.
   */
  sourceContactIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Target contact ID. */
  targetContactId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4PreviewMergeContactsResponse = {
  /** Preview of the updated target contact. */
  contact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
};

export type ComWixpressContactsCoreApiV4PrimaryContactInfo = {
  /**
   * Primary email address.
   *
   * This property reflects the email address in `info.emails`
   * where `primary` is `true`.
   */
  email?: Maybe<Scalars['String']>;
  /**
   * Primary phone number.
   *
   * This property reflects the phone number in `info.phones`
   * where `primary` is `true`.
   */
  phone?: Maybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4PrimaryEmail = {
  /**
   * Indicates last reported status of sent emails.
   *
   * Default: `NOT_SET`
   */
  deliverabilityStatus?: Maybe<ComWixpressContactsCoreApiV4PrimaryEmailEmailDeliverabilityStatus>;
  /**
   * Primary email address.
   *
   * This field reflects the email address in `info.emails`
   * where `primary` is `true`.
   */
  email?: Maybe<Scalars['String']>;
  /**
   * Indicates the recipient's opt-in or opt-out status for marketing emails.
   *
   * Default: `NOT_SET`
   */
  subscriptionStatus?: Maybe<ComWixpressContactsCoreApiV4SubscriptionStatus>;
};

export enum ComWixpressContactsCoreApiV4PrimaryEmailEmailDeliverabilityStatus {
  /** The last email to the recipient bounced or was rejected. */
  BOUNCED = 'BOUNCED',
  /** Multiple emails have been delivered without any kind of engagement from the recipient. */
  INACTIVE = 'INACTIVE',
  /** No status reported. */
  NOT_SET = 'NOT_SET',
  /** Recipient registered a spam complaint with their email provider. */
  SPAM_COMPLAINT = 'SPAM_COMPLAINT',
  /** Unknown email deliverability status. */
  UNKNOWN_EMAIL_DELIVERABILITY_STATUS = 'UNKNOWN_EMAIL_DELIVERABILITY_STATUS',
  /** Emails are being successfully delivered. */
  VALID = 'VALID'
}

export type ComWixpressContactsCoreApiV4PrimaryPhone = {
  /** Country code of the primary phone number in [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) format. */
  countryCode?: Maybe<Scalars['String']>;
  /**
   * Indicates last reported status of sent SMS messages.
   *
   * Default:
   * - `NO_PHONE_DELIVERABILITY_STATUS` when the phone is not a valid E164 phone.
   * - `NOT_SET` when the phone is a valid E164 phone.
   */
  deliverabilityStatus?: Maybe<ComWixpressContactsCoreApiV4PrimaryPhonePhoneDeliverabilityStatus>;
  /**
   * Phone number in [ITU E.164](https://www.itu.int/rec/T-REC-E.164/) format.
   * Automatically generated using `phone` and `countryCode` when both values are valid.
   */
  e164Phone?: Maybe<Scalars['String']>;
  /** Formatted phone. Automatically generated using `phone` and `countryCode`. */
  formattedPhone?: Maybe<Scalars['String']>;
  /**
   * Primary phone number.
   *
   * This field reflects the phone number in `info.phones`
   * where `primary` is `true`.
   */
  phone?: Maybe<Scalars['String']>;
  /**
   * Indicates the recipient's opt-in or opt-out status for SMS messages.
   *
   * Default:
   * - `NOT_SET` when the phone is a valid E164 phone.
   * - `NO_SUBSCRIPTION_STATUS` when the phone is not a valid E164 phone.
   */
  subscriptionStatus?: Maybe<ComWixpressContactsCoreApiV4SubscriptionStatus>;
};

export enum ComWixpressContactsCoreApiV4PrimaryPhonePhoneDeliverabilityStatus {
  /** No status reported. */
  NOT_SET = 'NOT_SET',
  /** No status exists. */
  NO_PHONE_DELIVERABILITY_STATUS = 'NO_PHONE_DELIVERABILITY_STATUS'
}

export type ComWixpressContactsCoreApiV4ProfileInfo = {
  /** Indicate whether the member is muted */
  muted?: Maybe<Scalars['Boolean']>;
  /** Nickname */
  nickname?: Maybe<Scalars['String']>;
  /** Profile photo */
  photo?: Maybe<ComWixpressContactsCoreApiV4UpstreamWixCommonImage>;
  /** Privacy status */
  privacyStatus?: Maybe<ComWixpressContactsCoreApiV4ProfileInfoPrivacyStatus>;
  /** Indicate whether the member is reported */
  reported?: Maybe<Scalars['Boolean']>;
};

export enum ComWixpressContactsCoreApiV4ProfileInfoPrivacyStatus {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC',
  UNKNOWN_PRIVACY_STATUS = 'UNKNOWN_PRIVACY_STATUS'
}

export type ComWixpressContactsCoreApiV4QueryContactsRequestInput = {
  /** Language for localization. */
  language?: InputMaybe<Scalars['String']>;
  /** Whether to calculate the total count the number of contacts */
  omitTotal?: InputMaybe<Scalars['Boolean']>;
  /** Query options. */
  query?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixQueryQueryInput>;
  /**
   * Plain text search for an exact match.
   *
   * Supported properties:
   * `info.name.first`, `info.name.last`, `info.emails.email`, `info.phones.phone`
   *
   * Max: 100 characters
   */
  search?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4QueryContactsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressContactsCoreApiV4Contact>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressContactsCoreApiV4QueryFacetsRequestInput = {
  /**
   * Filterable fields:
   * - `'info.extendedFields.emailSubscriptions.effectiveEmail'` (`$exists`).
   * - `'info.extendedFields.emailSubscriptions.subscriptionStatus'` (`$eq`, `$ne`, `$in`, `$nin`).
   * - `'info.extendedFields.emailSubscriptions.deliverabilityStatus'` (`$eq`, `$ne`, `$in`, `$nin`).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Language for localization. */
  language?: InputMaybe<Scalars['String']>;
  /** Whether to count the number of contacts per facet */
  omitCount?: InputMaybe<Scalars['Boolean']>;
  /** Pagination options. */
  paging?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixCommonPagingInput>;
};

export type ComWixpressContactsCoreApiV4QueryFacetsResponse = {
  /** List of facets. */
  facets?: Maybe<Array<Maybe<ComWixpressContactsCoreApiV4ContactsFacet>>>;
  /** Details on the paged set of results returned. */
  pagingMetadata?: Maybe<ComWixpressContactsCoreApiV4UpstreamWixCommonPagingMetadata>;
};

export type ComWixpressContactsCoreApiV4SearchContactsRequestInput = {
  /** Language for localization. */
  language?: InputMaybe<Scalars['String']>;
  /** Search object. Encapsulates filter, sorting, paging and other details */
  search?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixQuerySearchInput>;
};

export type ComWixpressContactsCoreApiV4SearchContactsResponse = {
  /** List of contacts. */
  contacts?: Maybe<Array<Maybe<ComWixpressContactsCoreApiV4Contact>>>;
  /** Details on the paged set of results returned. */
  cursorPagingMetadata?: Maybe<ComWixpressContactsCoreApiV4UpstreamWixCommonCursorPagingMetadata>;
};

export type ComWixpressContactsCoreApiV4SegmentsWrapper = {
  /** List of Contact segment IDs */
  items?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixpressContactsCoreApiV4SessionInfo = {
  /** Last time the member logged in to one of the mobile apps */
  lastMobileLogin?: Maybe<Scalars['String']>;
  /** Last time the member logged in to the website */
  lastWebLogin?: Maybe<Scalars['String']>;
  /** List of mobile apps that the member has ever logged in to */
  mobileAppNames?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum ComWixpressContactsCoreApiV4SubscriptionStatus {
  /** No status specified. */
  NOT_SET = 'NOT_SET',
  /** No status exists. */
  NO_SUBSCRIPTION_STATUS = 'NO_SUBSCRIPTION_STATUS',
  /** Subscription confirmation was requested, but recipient hasn't confirmed yet. */
  PENDING = 'PENDING',
  /** Recipient has opted in to marketing emails or SMS messages. */
  SUBSCRIBED = 'SUBSCRIBED',
  /** Recipient has opted out of marketing emails or SMS messages. */
  UNSUBSCRIBED = 'UNSUBSCRIBED'
}

export type ComWixpressContactsCoreApiV4SyncSubmitContactRequestInput = {
  activity?: InputMaybe<ComWixpressContactsCoreApiV4ContactActivityInput>;
  contactId?: InputMaybe<Scalars['String']>;
  contactInfo?: InputMaybe<ComWixpressContactsCoreApiV4ContactInfoInput>;
  hideFromContactList?: InputMaybe<Scalars['Boolean']>;
  passThroughData?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  /** Need to resolve source in allocator, because of server sign */
  sourceType?: InputMaybe<ComWixpressContactsCoreApiV4ContactSourceContactSourceType>;
  submitOperation?: InputMaybe<ComWixpressContactsCoreApiV4SyncSubmitContactRequestSubmitOperation>;
};

export enum ComWixpressContactsCoreApiV4SyncSubmitContactRequestSubmitOperation {
  CREATE = 'CREATE',
  UNKNOWN = 'UNKNOWN',
  UPDATE = 'UPDATE'
}

export type ComWixpressContactsCoreApiV4UnlabelContactRequestInput = {
  /** ID of the contact to remove labels from. */
  contactId?: InputMaybe<Scalars['String']>;
  /** List of label keys to remove from the contact. */
  labelKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Language for localization. */
  language?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4UnlabelContactResponse = {
  /** Updated contact. */
  contact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
};

export type ComWixpressContactsCoreApiV4UpdateContactRequestInput = {
  /**
   * Controls whether the call will succeed
   * if the new contact information contains an email or a phone number already used by another contact.
   *
   * If set to `true`,
   * the call will succeed even if an email address or phone number is used by another contact.
   * If set to `false`,
   * the call will fail if the given email address is used by another contact or,
   * if the email address is not given and the given phone number is used by another contact.
   *
   * Default: `false`
   */
  allowDuplicates?: InputMaybe<Scalars['Boolean']>;
  /** ID of the contact to update. */
  contactId?: InputMaybe<Scalars['String']>;
  /**
   * Set of fields to update.
   * Fields that aren't included in `fieldMask.paths` are ignored.
   * See
   * [Field Masks in Update Requests](https://dev.wix.com/api/rest/contacts/contacts/field-masks-in-update-requests)
   * for details on working with field masks.
   */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Contact info. */
  info?: InputMaybe<ComWixpressContactsCoreApiV4ContactInfoInput>;
  /** Language for localization. */
  language?: InputMaybe<Scalars['String']>;
  /**
   * Revision number.
   * When updating, include the existing `revision`
   * to prevent conflicting updates.
   */
  revision?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressContactsCoreApiV4UpdateContactResponse = {
  /** Updated contact. */
  contact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
};

export type ComWixpressContactsCoreApiV4UpsertContactRequestInput = {
  info?: InputMaybe<ComWixpressContactsCoreApiV4ContactInfoInput>;
};

export type ComWixpressContactsCoreApiV4UpsertContactResponse = {
  action?: Maybe<ComWixpressContactsCoreApiV4UpsertContactResponseAction>;
  /** Upserted contact. */
  contact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
};

export enum ComWixpressContactsCoreApiV4UpsertContactResponseAction {
  CREATED = 'CREATED',
  UNKNOWN = 'UNKNOWN',
  UPDATED = 'UPDATED'
}

export type ComWixpressContactsCoreApiV4UpstreamWixCommonAddress = {
  /** Main address line, usually street and number, as free text. */
  addressLine?: Maybe<Scalars['String']>;
  /**
   * Free text providing more detailed address information,
   * such as apartment, suite, or floor.
   */
  addressLine2?: Maybe<Scalars['String']>;
  /** City name. */
  city?: Maybe<Scalars['String']>;
  /**
   * 2-letter country code in an
   * [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) format.
   */
  country?: Maybe<Scalars['String']>;
  /** Full country name. */
  countryFullname?: Maybe<Scalars['String']>;
  /**
   * Human-readable address string.
   * If not provided, the value is generated from the available address data.
   */
  formattedAddress?: Maybe<Scalars['String']>;
  /** Coordinates of the physical address. */
  geocode?: Maybe<ComWixpressContactsCoreApiV4UpstreamWixCommonAddressLocation>;
  /** Instructions to help someone find the address, such as landmarks or where the entrance is. */
  hint?: Maybe<Scalars['String']>;
  /** Postal or zip code. */
  postalCode?: Maybe<Scalars['String']>;
  /** Street address object, with number and name in separate fields. */
  streetAddress?: Maybe<ComWixpressContactsCoreApiV4UpstreamWixCommonStreetAddress>;
  /**
   * Code for a subdivision (such as state, prefecture, or province) in an
   * [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2) format.
   */
  subdivision?: Maybe<Scalars['String']>;
  /** Hierarchical list of subdivisions, where the first array item is the highest level of hierarchy, and so on. */
  subdivisions?: Maybe<Array<Maybe<ComWixpressContactsCoreApiV4UpstreamWixCommonSubdivision>>>;
};

export type ComWixpressContactsCoreApiV4UpstreamWixCommonAddressInput = {
  /** Main address line, usually street and number, as free text. */
  addressLine?: InputMaybe<Scalars['String']>;
  /**
   * Free text providing more detailed address information,
   * such as apartment, suite, or floor.
   */
  addressLine2?: InputMaybe<Scalars['String']>;
  /** City name. */
  city?: InputMaybe<Scalars['String']>;
  /**
   * 2-letter country code in an
   * [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) format.
   */
  country?: InputMaybe<Scalars['String']>;
  /** Full country name. */
  countryFullname?: InputMaybe<Scalars['String']>;
  /**
   * Human-readable address string.
   * If not provided, the value is generated from the available address data.
   */
  formattedAddress?: InputMaybe<Scalars['String']>;
  /** Coordinates of the physical address. */
  geocode?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixCommonAddressLocationInput>;
  /** Instructions to help someone find the address, such as landmarks or where the entrance is. */
  hint?: InputMaybe<Scalars['String']>;
  /** Postal or zip code. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** Street address object, with number and name in separate fields. */
  streetAddress?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixCommonStreetAddressInput>;
  /**
   * Code for a subdivision (such as state, prefecture, or province) in an
   * [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2) format.
   */
  subdivision?: InputMaybe<Scalars['String']>;
  /** Hierarchical list of subdivisions, where the first array item is the highest level of hierarchy, and so on. */
  subdivisions?: InputMaybe<Array<InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixCommonSubdivisionInput>>>;
};

export type ComWixpressContactsCoreApiV4UpstreamWixCommonAddressLocation = {
  /** Address's latitude. */
  latitude?: Maybe<Scalars['Float']>;
  /** Address's longitude. */
  longitude?: Maybe<Scalars['Float']>;
};

export type ComWixpressContactsCoreApiV4UpstreamWixCommonAddressLocationInput = {
  /** Address's latitude. */
  latitude?: InputMaybe<Scalars['Float']>;
  /** Address's longitude. */
  longitude?: InputMaybe<Scalars['Float']>;
};

export type ComWixpressContactsCoreApiV4UpstreamWixCommonCursorPagingInput = {
  /** Cursor returned in last query response. Should not be provided on first page request */
  cursor?: InputMaybe<Scalars['String']>;
  /** The number of contacts to load (default = 50, max = 1000) */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressContactsCoreApiV4UpstreamWixCommonCursorPagingMetadata = {
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Cursor strings that point to the next page, previous page, or both. */
  cursors?: Maybe<ComWixpressContactsCoreApiV4UpstreamWixCommonCursors>;
  /**
   * Whether there are more pages to retrieve following the current page.
   *
   * + `true`: Another page of results can be retrieved.
   * + `false`: This is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressContactsCoreApiV4UpstreamWixCommonCursors = {
  /** Cursor pointing to next result page */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to previous result page */
  prev?: Maybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4UpstreamWixCommonImage = {
  /** Image alt text (optional). */
  altText?: Maybe<Scalars['String']>;
  /** Height of the original image. */
  height?: Maybe<Scalars['Int']>;
  /**
   * WixMedia image ID.
   * This property is written by Wix when an image is uploaded to the Wix Media Manager.
   */
  id?: Maybe<Scalars['String']>;
  /** Image source: Either a Media Manager URL or external URL. */
  url?: Maybe<Scalars['String']>;
  /** Image URL expiration date (optional). */
  urlExpirationDate?: Maybe<Scalars['String']>;
  /** Width of the original image. */
  width?: Maybe<Scalars['Int']>;
};

export type ComWixpressContactsCoreApiV4UpstreamWixCommonImageInput = {
  /** Image alt text (optional). */
  altText?: InputMaybe<Scalars['String']>;
  /** Height of the original image. */
  height?: InputMaybe<Scalars['Int']>;
  /**
   * WixMedia image ID.
   * This property is written by Wix when an image is uploaded to the Wix Media Manager.
   */
  id?: InputMaybe<Scalars['String']>;
  /** Image source: Either a Media Manager URL or external URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Image URL expiration date (optional). */
  urlExpirationDate?: InputMaybe<Scalars['String']>;
  /** Width of the original image. */
  width?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressContactsCoreApiV4UpstreamWixCommonPagingInput = {
  /**
   * Number of items to return. Learn more about pagination in [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#paging).
   *
   * Default: `50`. <br>
   * Maximum: `1000`.
   */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the current sort order. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressContactsCoreApiV4UpstreamWixCommonPagingMetadata = {
  /** The number of items returned in this response. */
  count?: Maybe<Scalars['Int']>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
  /** The offset which was requested. */
  offset?: Maybe<Scalars['Int']>;
  /** A flag that indicates the server failed to calculate 'total' field. */
  tooManyToCount?: Maybe<Scalars['Boolean']>;
  /** The total number of items that match the query. */
  total?: Maybe<Scalars['Int']>;
};

export enum ComWixpressContactsCoreApiV4UpstreamWixCommonSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type ComWixpressContactsCoreApiV4UpstreamWixCommonSortingInput = {
  /**
   * Field to sort by.
   *
   * Supported properties:
   * `createdDate`, `lastActivity.activityDate`, `primaryInfo.email`, `info.name.first`, `info.name.last`, `info.company`,
   * `info.jobTitle`, `info.birthdate`
   */
  fieldName?: InputMaybe<Scalars['String']>;
  /**
   * Sort order.
   * Use `ASC` for ascending order or `DESC` for descending order.
   *
   * Defaults to `ASC`.
   */
  order?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixCommonSortOrder>;
};

export type ComWixpressContactsCoreApiV4UpstreamWixCommonStreetAddress = {
  /** Apartment number. */
  apt?: Maybe<Scalars['String']>;
  /** Optional address line 1 */
  formattedAddressLine?: Maybe<Scalars['String']>;
  /** Street name. */
  name?: Maybe<Scalars['String']>;
  /** Street number. */
  number?: Maybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4UpstreamWixCommonStreetAddressInput = {
  /** Apartment number. */
  apt?: InputMaybe<Scalars['String']>;
  /** Optional address line 1 */
  formattedAddressLine?: InputMaybe<Scalars['String']>;
  /** Street name. */
  name?: InputMaybe<Scalars['String']>;
  /** Street number. */
  number?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4UpstreamWixCommonSubdivision = {
  /** subdivision short code */
  code?: Maybe<Scalars['String']>;
  /** Full subdivision name. */
  name?: Maybe<Scalars['String']>;
  type?: Maybe<ComWixpressContactsCoreApiV4UpstreamWixCommonSubdivisionSubdivisionType>;
  /**
   * Free text that describes the subdivision type.
   *
   * Examples: `"state"`, `"province"`, `"prefecture"`.
   */
  typeInfo?: Maybe<Scalars['String']>;
};

export type ComWixpressContactsCoreApiV4UpstreamWixCommonSubdivisionInput = {
  /** subdivision short code */
  code?: InputMaybe<Scalars['String']>;
  /** Full subdivision name. */
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixCommonSubdivisionSubdivisionType>;
  /**
   * Free text that describes the subdivision type.
   *
   * Examples: `"state"`, `"province"`, `"prefecture"`.
   */
  typeInfo?: InputMaybe<Scalars['String']>;
};

export enum ComWixpressContactsCoreApiV4UpstreamWixCommonSubdivisionSubdivisionType {
  /** State */
  ADMINISTRATIVE_AREA_LEVEL_1 = 'ADMINISTRATIVE_AREA_LEVEL_1',
  /** County */
  ADMINISTRATIVE_AREA_LEVEL_2 = 'ADMINISTRATIVE_AREA_LEVEL_2',
  /** City/town */
  ADMINISTRATIVE_AREA_LEVEL_3 = 'ADMINISTRATIVE_AREA_LEVEL_3',
  /** Neighborhood/quarter */
  ADMINISTRATIVE_AREA_LEVEL_4 = 'ADMINISTRATIVE_AREA_LEVEL_4',
  /** Street/block */
  ADMINISTRATIVE_AREA_LEVEL_5 = 'ADMINISTRATIVE_AREA_LEVEL_5',
  /** ADMINISTRATIVE_AREA_LEVEL_0. Indicates the national political entity, and is typically the highest order type returned by the Geocoder. */
  COUNTRY = 'COUNTRY',
  UNKNOWN_SUBDIVISION_TYPE = 'UNKNOWN_SUBDIVISION_TYPE'
}

export type ComWixpressContactsCoreApiV4UpstreamWixQueryQueryInput = {
  /**
   * List of projected fields to return.
   * If both `fields` and `fieldsets` are sent in the request,
   * the union of both lists is returned.
   * `id` and `revision` are always returned.
   *
   * Supported properties:
   * `source`, `createdDate`, `updatedDate`, `lastActivity`, `primaryInfo`,
   * `info.name`, `info.emails`, `info.phones`, `info.addresses`, `info.company`,
   * `info.jobTitle`, `info.picture`, `info.birthdate`, `info.locale`,
   * `info.labelKeys`, `info.locations`, `info.extendedFields`
   */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Predefined sets of fields to return.
   * If both `fields` and `fieldsets` are sent in the request,
   * the union of both lists is returned.
   *
   * - `BASIC`: Returns `id`, `revision`, `primaryInfo`, `info.name`.
   * - `COMMUNICATION_DETAILS`: Returns `id`, `revision`, `primaryInfo`, `info.name`, `info.emails`, `info.phones`, `info.addresses`.
   * - `EXTENDED`: Returns `id`, `revision`, `primaryInfo`, `info.name`, `info.extendedFields`.
   * - `FULL`: Returns all fields.
   *
   * Default: If `fields` is omitted from the request, `FULL`.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressContactsCoreApiV4ContactFieldSet>>>;
  /**
   * Filter object.
   * See [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language)
   * for more information.
   *
   * For a detailed list of supported filters, see
   * [Supported Filters](https://dev.wix.com/api/rest/contacts/contacts/supported-filters).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Pagination options. */
  paging?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixCommonPagingInput>;
  /**
   * Sorting options.
   * See [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/pagination)
   * for more information.
   *
   * Max: 1 sort object
   */
  sort?: InputMaybe<Array<InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixCommonSortingInput>>>;
};

export type ComWixpressContactsCoreApiV4UpstreamWixQuerySearchDetailsInput = {
  /** search term or expression */
  expression?: InputMaybe<Scalars['String']>;
  /**
   * fields to search in. if empty - server will search in own default fieldsDefault searchable fields:
   *
   * - `info.name.first`
   * - `info.name.last`
   * - `info.emails.email`
   * - `info.phones.phone`
   */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** flag if should use auto fuzzy search (allowing typos by a managed proximity algorithm) */
  fuzzy?: InputMaybe<Scalars['Boolean']>;
  /** boolean search mode. Default is `OR` */
  mode?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixQuerySearchDetailsMode>;
};

export enum ComWixpressContactsCoreApiV4UpstreamWixQuerySearchDetailsMode {
  /** all */
  AND = 'AND',
  /** any */
  OR = 'OR'
}

export type ComWixpressContactsCoreApiV4UpstreamWixQuerySearchInput = {
  /** Cursor pointing to page of results. 'cursorPaging.cursor' can not be used together with 'filter' or 'sort' */
  cursorPaging?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixCommonCursorPagingInput>;
  /**
   * List of projected fields to return.
   *
   * If used in the request,
   * all the fields contained in `fields` and `fieldsets` are returned.
   * If left blank, `fieldsets` is used to determine which fields to return.
   *
   * For a list of valid projected fields, see
   * [Valid Contact Projection Fields](https://dev.wix.com/api/rest/contacts/contacts/fieldsets-and-projected-fields#contacts_contacts_fieldsets-and-projected-fields_valid-contact-projection-fields).
   */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Predefined sets of fields to return.
   *
   * Defaults to `FULL`.
   * Ignored if left empty when `fields` is used in the request.
   *
   * For more information,
   * see [Contact Fieldsets](https://dev.wix.com/api/rest/contacts/contacts/fieldsets-and-projected-fields#contacts_contacts_fieldsets-and-projected-fields_contact-fieldsets).
   */
  fieldsets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** A filter object. See documentation [here](https://bo.wix.com/wix-docs/rnd/platformization-guidelines/api-query-language#platformization-guidelines_api-query-language_defining-in-protobuf) */
  filter?: InputMaybe<Scalars['JSON']>;
  /** free text to match in searchable fields */
  search?: InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixQuerySearchDetailsInput>;
  /** Sort object in the form [{"fieldName":"sortField1"},{"fieldName":"sortField2","direction":"DESC"}] */
  sort?: InputMaybe<Array<InputMaybe<ComWixpressContactsCoreApiV4UpstreamWixCommonSortingInput>>>;
};

export type ComWixpressContactsCoreApiV4UserInfo = {
  /** The user's role on the website */
  role?: Maybe<ComWixpressContactsCoreApiV4UserInfoRole>;
  /** User ID */
  userId?: Maybe<Scalars['String']>;
};

export enum ComWixpressContactsCoreApiV4UserInfoRole {
  CONTRIBUTOR = 'CONTRIBUTOR',
  OWNER = 'OWNER',
  UNSPECIFIED_ROLE = 'UNSPECIFIED_ROLE'
}

export type ComWixpressContactsFieldsV4DeleteExtendedFieldRequestInput = {
  /** Extended field key. */
  key?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsFieldsV4ExtendedField = {
  /** Date and time the field was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Type of data the field holds. */
  dataType?: Maybe<ComWixpressContactsFieldsV4ExtendedFieldFieldDataType>;
  /** Field description, if the field is a system field. */
  description?: Maybe<Scalars['String']>;
  /** Display name shown in the contact list. */
  displayName?: Maybe<Scalars['String']>;
  /** Indicates whether the extended field is a system field or custom field. */
  fieldType?: Maybe<ComWixpressContactsFieldsV4ExtendedFieldFieldType>;
  /**
   * Extended field key.
   *
   * When accessing contact data,
   * extended field data is available at `extendedFields[key]`.
   * For example, if the key is "custom.notes",
   * the value can be accessed at `extendedFields["custom.notes"]`.
   *
   * `key` is generated when the extended field is created
   * and can't be modified, even if `displayName` changes.
   */
  key?: Maybe<Scalars['String']>;
  /** Legacy Id of field. For internal use. */
  legacyId?: Maybe<Scalars['String']>;
  /**
   * Extended field namespace.
   *
   * Extended fields created through by calling the Find Or Create Extended Field method
   * are automatically assigned to the `custom` namespace.
   */
  namespace?: Maybe<Scalars['String']>;
  /** Data Extensions Schema Field Id. Available only for v5 sites. For internal use. */
  schemaFieldId?: Maybe<Scalars['String']>;
  /** Date and time the field was last updated. */
  updatedDate?: Maybe<Scalars['String']>;
  /** Wix search field name. For internal use. */
  wixSearchColumn?: Maybe<Scalars['String']>;
};

export enum ComWixpressContactsFieldsV4ExtendedFieldFieldDataType {
  /** Accepts dates formatted as `YYYY-MM-DD`. */
  DATE = 'DATE',
  /** Accepts floats. */
  NUMBER = 'NUMBER',
  /** Accepts strings. */
  TEXT = 'TEXT',
  /** Undefined data type. */
  UNKNOWN_DATA_TYPE = 'UNKNOWN_DATA_TYPE',
  /** Accepts strings. Prepends `https://` if no protocol is included. */
  URL = 'URL'
}

export enum ComWixpressContactsFieldsV4ExtendedFieldFieldType {
  /** Field is a system field managed by Wix. System fields can't be modified by calling the Update Extended Field method. */
  SYSTEM = 'SYSTEM',
  /** Undefined field type. */
  UNKNOWN = 'UNKNOWN',
  /** Field is a custom field and can be modified by calling the Update Extended Field method. */
  USER_DEFINED = 'USER_DEFINED'
}

export type ComWixpressContactsFieldsV4ExtendedFieldInput = {
  /** Date and time the field was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Type of data the field holds. */
  dataType?: InputMaybe<ComWixpressContactsFieldsV4ExtendedFieldFieldDataType>;
  /** Field description, if the field is a system field. */
  description?: InputMaybe<Scalars['String']>;
  /** Display name shown in the contact list. */
  displayName?: InputMaybe<Scalars['String']>;
  /** Indicates whether the extended field is a system field or custom field. */
  fieldType?: InputMaybe<ComWixpressContactsFieldsV4ExtendedFieldFieldType>;
  /**
   * Extended field key.
   *
   * When accessing contact data,
   * extended field data is available at `extendedFields[key]`.
   * For example, if the key is "custom.notes",
   * the value can be accessed at `extendedFields["custom.notes"]`.
   *
   * `key` is generated when the extended field is created
   * and can't be modified, even if `displayName` changes.
   */
  key?: InputMaybe<Scalars['String']>;
  /** Legacy Id of field. For internal use. */
  legacyId?: InputMaybe<Scalars['String']>;
  /**
   * Extended field namespace.
   *
   * Extended fields created through by calling the Find Or Create Extended Field method
   * are automatically assigned to the `custom` namespace.
   */
  namespace?: InputMaybe<Scalars['String']>;
  /** Data Extensions Schema Field Id. Available only for v5 sites. For internal use. */
  schemaFieldId?: InputMaybe<Scalars['String']>;
  /** Date and time the field was last updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** Wix search field name. For internal use. */
  wixSearchColumn?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsFieldsV4FindOrCreateExtendedFieldRequestInput = {
  /**
   * Type of data the field holds.
   * Ignored if an existing field is an exact match
   * for the specified display name.
   */
  dataType?: InputMaybe<ComWixpressContactsFieldsV4ExtendedFieldFieldDataType>;
  /**
   * Display name to retrieve or create.
   *
   * If an existing custom field is an exact match
   * for the specified display name,
   * the existing field is returned.
   * If not, a new field is created and returned.
   */
  displayName?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsFieldsV4FindOrCreateExtendedFieldResponse = {
  /** Extended field that was found or created. */
  field?: Maybe<ComWixpressContactsFieldsV4ExtendedField>;
  /**
   * Indicates whether the extended field was just created or already existed.
   *
   * Returns `true` if the field was just created.
   */
  newField?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressContactsFieldsV4GdprListRequestInput = {
  /** Instance ID of the site. */
  instanceId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsFieldsV4GdprListResponse = {
  /** List of extended fields. */
  fields?: Maybe<Array<Maybe<ComWixpressContactsFieldsV4ExtendedField>>>;
};

export type ComWixpressContactsFieldsV4GetExtendedFieldByLegacyIdRequestInput = {
  /** Legacy ID of the extended field. */
  legacyId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsFieldsV4GetExtendedFieldByLegacyIdResponse = {
  /** The requested extended field. */
  field?: Maybe<ComWixpressContactsFieldsV4ExtendedField>;
};

export type ComWixpressContactsFieldsV4GetExtendedFieldRequestInput = {
  id: Scalars['ID'];
};

export type ComWixpressContactsFieldsV4ListExtendedFieldsRequestInput = {
  /** Filter for fields of the specified type. */
  fieldType?: InputMaybe<ComWixpressContactsFieldsV4ExtendedFieldFieldType>;
  /**
   * Filter for fields in the specified namespace.
   * Fields created by calling the Find Or Create Extended Field method
   * are automatically assigned to the `custom` namespace.
   */
  namespace?: InputMaybe<Scalars['String']>;
  /** Paging options. */
  paging?: InputMaybe<ComWixpressContactsFieldsV4UpstreamWixCommonPagingInput>;
  /** Sorting options. */
  sort?: InputMaybe<ComWixpressContactsFieldsV4UpstreamWixCommonSortingInput>;
  /** Filter for fields where `displayName` starts with the specified case-sensitive string. */
  startsWith?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsFieldsV4ListExtendedFieldsResponse = {
  /** List of extended fields. */
  fields?: Maybe<Array<Maybe<ComWixpressContactsFieldsV4ExtendedField>>>;
  /** Metadata for the page of results. */
  metadata?: Maybe<ComWixpressContactsFieldsV4UpstreamWixCommonPagingMetadata>;
};

export type ComWixpressContactsFieldsV4PurgeRequestInput = {
  /** Instance ID of the site. */
  instanceId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsFieldsV4PurgeResponse = {
  /** Number of items deleted. */
  deletedItems?: Maybe<Scalars['Int']>;
};

export type ComWixpressContactsFieldsV4QueryExtendedFieldsRequestInput = {
  /** Query options. */
  query?: InputMaybe<ComWixpressContactsFieldsV4UpstreamWixQueryQueryInput>;
};

export type ComWixpressContactsFieldsV4QueryExtendedFieldsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressContactsFieldsV4ExtendedField>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressContactsFieldsV4UpdateExtendedFieldRequestInput = {
  /** Extended field to rename. */
  field?: InputMaybe<ComWixpressContactsFieldsV4ExtendedFieldInput>;
};

export type ComWixpressContactsFieldsV4UpdateExtendedFieldResponse = {
  /** Renamed extended field. */
  field?: Maybe<ComWixpressContactsFieldsV4ExtendedField>;
};

export type ComWixpressContactsFieldsV4UpstreamWixCommonPagingInput = {
  /**
   * Number of items to return.
   *
   * Defaults to `100`.
   */
  limit?: InputMaybe<Scalars['Int']>;
  /**
   * Number of items to skip in the current sort order.
   *
   * Defaults to `0`.
   */
  offset?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressContactsFieldsV4UpstreamWixCommonPagingMetadata = {
  /** Number of items returned. */
  count?: Maybe<Scalars['Int']>;
  /** Requested offset. */
  offset?: Maybe<Scalars['Int']>;
  /**
   * Indicates if `total` calculation timed out before the response was sent.
   * Typically this happens if there is a large set of results.
   */
  tooManyToCount?: Maybe<Scalars['Boolean']>;
  /** Number of items that matched the query. */
  total?: Maybe<Scalars['Int']>;
};

export enum ComWixpressContactsFieldsV4UpstreamWixCommonSortOrder {
  /** Sort by ascending order. */
  ASC = 'ASC',
  /** Sort by descending order. */
  DESC = 'DESC'
}

export type ComWixpressContactsFieldsV4UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /**
   * Sort order.
   *
   * Default: `ASC`.
   */
  order?: InputMaybe<ComWixpressContactsFieldsV4UpstreamWixCommonSortOrder>;
};

export type ComWixpressContactsFieldsV4UpstreamWixQueryQueryInput = {
  /**
   * ilter object.
   *
   * Possible filters: `$eq`, `$gt`, `$gte`, `$in`, `$lt`, `$lte`, `$ne`, `$startsWith`.
   *
   * For a detailed list of supported filters, see [sorting and filtering for extended fields](https://dev.wix.com/api/rest/contacts/extended-fields/sort-and-filter).
   *
   * Example: `{ "filter": {
   * "displayName": {
   * "$startsWith": "Referral"
   * }
   * }
   * }`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Pagination options. */
  paging?: InputMaybe<ComWixpressContactsFieldsV4UpstreamWixCommonPagingInput>;
  /**
   * Sorting options. Currently supports sorting on one field only.
   *
   * Example: `{ "sort": [{"fieldName": "displayName", "order": "DESC"}] }`
   */
  sort?: InputMaybe<Array<InputMaybe<ComWixpressContactsFieldsV4UpstreamWixCommonSortingInput>>>;
};

export type ComWixpressContactsLabelsV4ContactLabel = {
  /** Date and time the label was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Label display name shown in the dashboard. */
  displayName?: Maybe<Scalars['String']>;
  /**
   * Label key.
   *
   * `key` is generated when the label is created.
   * It can't be modified, even if `displayName` is updated.
   */
  key?: Maybe<Scalars['String']>;
  /** Label type indicating how the label was created. */
  labelType?: Maybe<ComWixpressContactsLabelsV4ContactLabelLabelType>;
  /** Legacy ID of label. For internal use only. */
  legacyId?: Maybe<Scalars['String']>;
  /**
   * Label namespace.
   *
   * Labels created by calling the Find Or Create Label method
   * are automatically assigned to the `custom` namespace.
   */
  namespace?: Maybe<Scalars['String']>;
  /**
   * Display name for the namespace,
   * used to organize the list of labels in the site dashboard.
   */
  namespaceDisplayName?: Maybe<Scalars['String']>;
  /** ID of the parallel contacts-v5 tag. For internal use only. */
  tagId?: Maybe<Scalars['String']>;
  /** Date and time the label was last updated. */
  updatedDate?: Maybe<Scalars['String']>;
};

export type ComWixpressContactsLabelsV4ContactLabelInput = {
  /** Date and time the label was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Label display name shown in the dashboard. */
  displayName?: InputMaybe<Scalars['String']>;
  /**
   * Label key.
   *
   * `key` is generated when the label is created.
   * It can't be modified, even if `displayName` is updated.
   */
  key?: InputMaybe<Scalars['String']>;
  /** Label type indicating how the label was created. */
  labelType?: InputMaybe<ComWixpressContactsLabelsV4ContactLabelLabelType>;
  /** Legacy ID of label. For internal use only. */
  legacyId?: InputMaybe<Scalars['String']>;
  /**
   * Label namespace.
   *
   * Labels created by calling the Find Or Create Label method
   * are automatically assigned to the `custom` namespace.
   */
  namespace?: InputMaybe<Scalars['String']>;
  /**
   * Display name for the namespace,
   * used to organize the list of labels in the site dashboard.
   */
  namespaceDisplayName?: InputMaybe<Scalars['String']>;
  /** ID of the parallel contacts-v5 tag. For internal use only. */
  tagId?: InputMaybe<Scalars['String']>;
  /** Date and time the label was last updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export enum ComWixpressContactsLabelsV4ContactLabelLabelType {
  /** Default system label for the contact list. */
  SYSTEM = 'SYSTEM',
  /** Fetch all labels. */
  UNKNOWN = 'UNKNOWN',
  /** Label created by calling the Find Or Create Label method. */
  USER_DEFINED = 'USER_DEFINED',
  /** Label created by an app built by Wix. */
  WIX_APP_DEFINED = 'WIX_APP_DEFINED'
}

export type ComWixpressContactsLabelsV4ContactLabelNamespace = {
  /** Namespace display name */
  displayName?: Maybe<Scalars['String']>;
  /** Namespace key */
  key?: Maybe<Scalars['String']>;
};

export type ComWixpressContactsLabelsV4DeleteLabelRequestInput = {
  /** Label key to delete. */
  key?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsLabelsV4FindOrCreateLabelRequestInput = {
  /**
   * Display name to retrieve or create.
   *
   * If an existing label is an exact match
   * for the specified display name,
   * the existing label is returned.
   * If not, a new label is created and returned.
   */
  displayName?: InputMaybe<Scalars['String']>;
  /**
   * Label type.
   *
   * - `SYSTEM`: The label is a default system label for the Contact List.
   * - `USER_DEFINED`: The label was created by a site contributor or 3rd-party app.
   * - `WIX_APP_DEFINED`: The label was created by a Wix app.
   *
   * This field is read-only and will be ignored when creating a label.
   */
  labelType?: InputMaybe<ComWixpressContactsLabelsV4ContactLabelLabelType>;
  /**
   * Language for localization.
   * 2-letter language code in [ISO 639-1 alpha-2](https://en.wikipedia.org/wiki/List_of_ISO_639_language_codes) format.
   */
  language?: InputMaybe<Scalars['String']>;
  /**
   * Label namespace.
   * Labels created by calling the Find Or Create Label method
   * are automatically assigned to the `custom` namespace.
   *
   * This field is read-only and is ignored when creating a label.
   */
  namespace?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsLabelsV4FindOrCreateLabelResponse = {
  /** Label that was found or created. */
  label?: Maybe<ComWixpressContactsLabelsV4ContactLabel>;
  /**
   * Indicates whether the label was just created or already existed.
   *
   * Returns `true` if the label was just created.
   */
  newLabel?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressContactsLabelsV4GdprListRequestInput = {
  /** Contacts Instance ID of the site. */
  instanceId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsLabelsV4GdprListResponse = {
  /** List of labels */
  labels?: Maybe<Array<Maybe<ComWixpressContactsLabelsV4ContactLabel>>>;
};

export type ComWixpressContactsLabelsV4GetContactLabelRequestInput = {
  id: Scalars['ID'];
  /**
   * Language for localization.
   * 2-letter language code in [ISO 639-1 alpha-2](https://en.wikipedia.org/wiki/List_of_ISO_639_language_codes) format.
   */
  language?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsLabelsV4GetLabelByLegacyIdRequestInput = {
  /** Language for localization */
  language?: InputMaybe<Scalars['String']>;
  /** Legacy id of the label */
  legacyId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsLabelsV4GetLabelByLegacyIdResponse = {
  /** Requested label */
  label?: Maybe<ComWixpressContactsLabelsV4ContactLabel>;
};

export type ComWixpressContactsLabelsV4ListLabelNamespacesRequestInput = {
  /** Language for localization */
  language?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsLabelsV4ListLabelNamespacesResponse = {
  /** List of namespaces */
  namespaces?: Maybe<Array<Maybe<ComWixpressContactsLabelsV4ContactLabelNamespace>>>;
};

export type ComWixpressContactsLabelsV4ListLabelsRequestInput = {
  /** Filter for labels of the specified type. */
  labelType?: InputMaybe<ComWixpressContactsLabelsV4ContactLabelLabelType>;
  language?: InputMaybe<Scalars['String']>;
  /** Filter for labels in the specified namespace. */
  namespace?: InputMaybe<Scalars['String']>;
  /** Paging options. */
  paging?: InputMaybe<ComWixpressContactsLabelsV4UpstreamWixCommonPagingInput>;
  /** Sorting options. */
  sort?: InputMaybe<ComWixpressContactsLabelsV4UpstreamWixCommonSortingInput>;
  /** Filter for labels where `displayName` starts with the specified case-sensitive string. */
  startsWith?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsLabelsV4ListLabelsResponse = {
  /** List of labels. */
  labels?: Maybe<Array<Maybe<ComWixpressContactsLabelsV4ContactLabel>>>;
  /** Metadata for the page of results. */
  metadata?: Maybe<ComWixpressContactsLabelsV4UpstreamWixCommonPagingMetadata>;
};

export type ComWixpressContactsLabelsV4PurgeRequestInput = {
  /** Labels to exclude from the purge. */
  exludingLabelKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Contacts Instance ID of the site. */
  instanceId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsLabelsV4PurgeResponse = {
  /** Number of deleted items */
  deletedItems?: Maybe<Scalars['Int']>;
};

export type ComWixpressContactsLabelsV4QueryLabelsRequestInput = {
  /**
   * Language for localization.
   * 2-letter language code in [ISO 639-1 alpha-2](https://en.wikipedia.org/wiki/List_of_ISO_639_language_codes) format.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Query options. */
  query?: InputMaybe<ComWixpressContactsLabelsV4UpstreamWixQueryQueryInput>;
};

export type ComWixpressContactsLabelsV4QueryLabelsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressContactsLabelsV4ContactLabel>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressContactsLabelsV4UpdateLabelRequestInput = {
  /** Label to rename. */
  label?: InputMaybe<ComWixpressContactsLabelsV4ContactLabelInput>;
  /**
   * Language for localization.
   * 2-letter language code in [ISO 639-1 alpha-2](https://en.wikipedia.org/wiki/List_of_ISO_639_language_codes) format.
   */
  language?: InputMaybe<Scalars['String']>;
};

export type ComWixpressContactsLabelsV4UpdateLabelResponse = {
  /** Renamed label. */
  label?: Maybe<ComWixpressContactsLabelsV4ContactLabel>;
};

export type ComWixpressContactsLabelsV4UpstreamWixCommonPagingInput = {
  /**
   * Number of items to return.
   *
   * Defaults to `1000`. <br>
   * Maximum: `2000`.
   */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the current sort order. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressContactsLabelsV4UpstreamWixCommonPagingMetadata = {
  /** Number of items returned. */
  count?: Maybe<Scalars['Int']>;
  /** Requested offset. */
  offset?: Maybe<Scalars['Int']>;
  /**
   * Indicates if `total` calculation timed out before the response was sent.
   * Typically this happens if there is a large set of results.
   */
  tooManyToCount?: Maybe<Scalars['Boolean']>;
  /** Number of items that matched the query. */
  total?: Maybe<Scalars['Int']>;
};

export enum ComWixpressContactsLabelsV4UpstreamWixCommonSortOrder {
  /** Sort by ascending order. */
  ASC = 'ASC',
  /** Sort by descending order. */
  DESC = 'DESC'
}

export type ComWixpressContactsLabelsV4UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /**
   * Sort order.
   *
   * Default: `ASC`.
   */
  order?: InputMaybe<ComWixpressContactsLabelsV4UpstreamWixCommonSortOrder>;
};

export type ComWixpressContactsLabelsV4UpstreamWixQueryQueryInput = {
  /**
   * ilter object.
   *
   * Possible filters: `$eq`, `$gt`, `$gte`, `$in`, `$lt`, `$lte`, `$ne`, `$startsWith`.
   *
   * For a detailed list of supported filters, see [sorting and filtering for labels](https://dev.wix.com/api/rest/contacts/labels/sort-and-filter).
   *
   * Example: `{ "filter": {
   * "displayName": {
   * "$startsWith": "Referral"
   * }
   * }
   * }`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Pagination options. */
  paging?: InputMaybe<ComWixpressContactsLabelsV4UpstreamWixCommonPagingInput>;
  /**
   * Sorting options. For a list of fields that can be sorted, see [sorting and filtering for labels](https://dev.wix.com/api/rest/contacts/labels/sort-and-filter).
   *
   * Example: `{ "sort": [{"fieldName": "displayName", "order": "DESC"}] }`
   */
  sort?: InputMaybe<Array<InputMaybe<ComWixpressContactsLabelsV4UpstreamWixCommonSortingInput>>>;
};

export enum ComWixpressCrmFinancialCommonApiV1CustomFieldGroup {
  BUSINESS_DETAILS = 'BUSINESS_DETAILS',
  CUSTOMER_DETAILS = 'CUSTOMER_DETAILS',
  DOCUMENT = 'DOCUMENT',
  FOOTER = 'FOOTER',
  OTHER = 'OTHER',
  UNKNOWN_CUSTOM_FIELD_GROUP = 'UNKNOWN_CUSTOM_FIELD_GROUP'
}

export type ComWixpressCrmFinancialCommonApiV1CustomFieldValueInput = {
  /** The display name of the custom field value */
  displayName?: InputMaybe<Scalars['String']>;
  /** The group of the custom field indicates its intended placement in the financial document */
  group?: InputMaybe<ComWixpressCrmFinancialCommonApiV1CustomFieldGroup>;
  /** The unique id of the custom field value */
  id?: InputMaybe<Scalars['String']>;
  /** The optional namespace of the custom field value. This field may be used to indicate intended usage or source. */
  namespace?: InputMaybe<Scalars['String']>;
  /** The optional key of the custom field definition on which the custom field value is based */
  originCustomFieldKey?: InputMaybe<Scalars['String']>;
  /** The value of the custom field */
  value?: InputMaybe<ComWixpressCrmFinancialCommonApiV1ValueInput>;
};

export type ComWixpressCrmFinancialCommonApiV1ValueInput = {
  value?: InputMaybe<Scalars['String']>;
  valueType?: InputMaybe<ComWixpressCrmFinancialCommonApiV1ValueValueType>;
};

export enum ComWixpressCrmFinancialCommonApiV1ValueValueType {
  BOOLEAN = 'BOOLEAN',
  DATE = 'DATE',
  NUMBER = 'NUMBER',
  STRING = 'STRING',
  UNKNOWN_VALUE_TYPE = 'UNKNOWN_VALUE_TYPE'
}

export type ComWixpressHtmlEditorApiEventsHtmlSitePublishedInput = {
  /** Application instance ID */
  appInstanceId?: InputMaybe<Scalars['String']>;
  /** Application type */
  appType?: InputMaybe<Scalars['String']>;
  /** optional branch id if publish is done from branch */
  branchId?: InputMaybe<Scalars['String']>;
  /** The site's last transactionId */
  lastTransactionId?: InputMaybe<Scalars['Long']>;
  /** MSID */
  metaSiteId?: InputMaybe<Scalars['String']>;
  /** Determine if this message was produced by editor-deployments service */
  originatedFromDeploymentsService?: InputMaybe<Scalars['Boolean']>;
  /** A list of the site's pages */
  pages?: InputMaybe<Array<InputMaybe<ComWixpressHtmlEditorApiEventsPageInput>>>;
  /** Site's publish date */
  publishDate?: InputMaybe<Scalars['Long']>;
  /** Revision */
  revision?: InputMaybe<Scalars['Long']>;
};

export type ComWixpressHtmlEditorApiEventsPageInput = {
  /** Page's Id */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressLocationsAddLocationTypeRequestInput = {
  /** Location id to add type */
  id?: InputMaybe<Scalars['String']>;
  locationType?: InputMaybe<ComWixpressLocationsLocationType>;
};

export type ComWixpressLocationsAddLocationTypeResponse = {
  /** Full location with the new type */
  location?: Maybe<ComWixpressLocationsLocation>;
};

export type ComWixpressLocationsAddTypeToLocationRequestInput = {
  /** ID of the location where the type will be added. */
  id?: InputMaybe<Scalars['String']>;
  /** Location type to add. */
  locationType?: InputMaybe<ComWixpressLocationsLocationType>;
};

export type ComWixpressLocationsAddTypeToLocationResponse = {
  /** Updated location. */
  location?: Maybe<ComWixpressLocationsLocation>;
};

export type ComWixpressLocationsAddress = {
  /** City name. */
  city?: Maybe<Scalars['String']>;
  /** 2-letter country code in an [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) format. */
  country?: Maybe<Scalars['String']>;
  /** Full address of the location. */
  formattedAddress?: Maybe<Scalars['String']>;
  /** Geographic coordinates of location. */
  geocode?: Maybe<ComWixpressLocationsAddressLocation>;
  /** Extra information that helps finding the location. */
  hint?: Maybe<Scalars['String']>;
  /** Postal or zip code. */
  postalCode?: Maybe<Scalars['String']>;
  /** Street address. Includes street name, number, and apartment number in separate fields. */
  streetAddress?: Maybe<ComWixpressLocationsStreetAddress>;
  /** Code for a subdivision (such as state, prefecture, or province) in [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2) format. */
  subdivision?: Maybe<Scalars['String']>;
};

export type ComWixpressLocationsAddressInput = {
  /** City name. */
  city?: InputMaybe<Scalars['String']>;
  /** 2-letter country code in an [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) format. */
  country?: InputMaybe<Scalars['String']>;
  /** Full address of the location. */
  formattedAddress?: InputMaybe<Scalars['String']>;
  /** Geographic coordinates of location. */
  geocode?: InputMaybe<ComWixpressLocationsAddressLocationInput>;
  /** Extra information that helps finding the location. */
  hint?: InputMaybe<Scalars['String']>;
  /** Postal or zip code. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** Street address. Includes street name, number, and apartment number in separate fields. */
  streetAddress?: InputMaybe<ComWixpressLocationsStreetAddressInput>;
  /** Code for a subdivision (such as state, prefecture, or province) in [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2) format. */
  subdivision?: InputMaybe<Scalars['String']>;
};

export type ComWixpressLocationsAddressLocation = {
  /** Latitude of the location. Must be between -90 and 90. */
  latitude?: Maybe<Scalars['Float']>;
  /** Longitude of the location. Must be between -180 and 180. */
  longitude?: Maybe<Scalars['Float']>;
};

export type ComWixpressLocationsAddressLocationInput = {
  /** Latitude of the location. Must be between -90 and 90. */
  latitude?: InputMaybe<Scalars['Float']>;
  /** Longitude of the location. Must be between -180 and 180. */
  longitude?: InputMaybe<Scalars['Float']>;
};

export type ComWixpressLocationsArchiveLocationRequestInput = {
  /** ID of the location to archive. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressLocationsArchiveLocationResponse = {
  /** Archived location. */
  location?: Maybe<ComWixpressLocationsLocation>;
};

export type ComWixpressLocationsBulkCreateLocationRequestInput = {
  /** Locations to create. */
  locations?: InputMaybe<Array<InputMaybe<ComWixpressLocationsLocationInput>>>;
};

export type ComWixpressLocationsBulkCreateLocationResponse = {
  /** Locations that failed. */
  failedLocations?: Maybe<Array<Maybe<ComWixpressLocationsFailedCreateLocation>>>;
  /** Locations that were created. */
  successfulLocations?: Maybe<Array<Maybe<ComWixpressLocationsLocation>>>;
};

export type ComWixpressLocationsBulkUpdateLocationRequestInput = {
  /** Locations to update. */
  locations?: InputMaybe<Array<InputMaybe<ComWixpressLocationsLocationInput>>>;
};

export type ComWixpressLocationsBulkUpdateLocationResponse = {
  /** Locations that failed. */
  failedLocations?: Maybe<Array<Maybe<ComWixpressLocationsFailedUpdateLocation>>>;
  /** Locations that were updated. */
  successfulLocations?: Maybe<Array<Maybe<ComWixpressLocationsLocation>>>;
};

export type ComWixpressLocationsCreateLocationRequestInput = {
  /** Location to create. */
  location?: InputMaybe<ComWixpressLocationsLocationInput>;
};

export type ComWixpressLocationsCreateLocationResponse = {
  /** Created location. */
  location?: Maybe<ComWixpressLocationsLocation>;
};

export type ComWixpressLocationsFailedCreateLocation = {
  /** Error message. */
  errorMessage?: Maybe<Scalars['String']>;
  /** Location that couldn't be created. */
  location?: Maybe<ComWixpressLocationsLocation>;
};

export type ComWixpressLocationsFailedUpdateLocation = {
  /** Error message. */
  errorMessage?: Maybe<Scalars['String']>;
  /** Location that couldn't be updated. */
  id?: Maybe<Scalars['String']>;
};

export type ComWixpressLocationsGetLocationRequestInput = {
  id: Scalars['ID'];
};

export type ComWixpressLocationsListLocationsRequestInput = {
  /** Whether to filter only authorized locations */
  filterAuthorizedLocationEntities?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to include `archived` locations in the response.
   *
   * Default: `false`
   */
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  /**
   * Pagination.
   *
   * Default values:
   * `offset`: 0
   * `limit`: 50 (Max: 1000)
   */
  paging?: InputMaybe<WixCommonPagingInput>;
  /** Sort order. */
  sort?: InputMaybe<WixCommonSortingInput>;
};

export type ComWixpressLocationsListLocationsResponse = {
  /** Ids of the locations that the requesting entity can manage */
  authorizedLocationEntities?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Retrieved locations. */
  locations?: Maybe<Array<Maybe<ComWixpressLocationsLocation>>>;
  /** Paging info. */
  pagingMetadata?: Maybe<ComWixpressLocationsPagingMetadata>;
};

export type ComWixpressLocationsLocation = {
  /** Address. */
  address?: Maybe<ComWixpressLocationsAddress>;
  /**
   * Whether the location is archived. Archived locations can't be updated.
   * __Note:__ [Archiving a location](https://dev.wix.com/api/rest/business-info/locations/archive-location)
   * doesn't affect its `status`.
   */
  archived?: Maybe<Scalars['Boolean']>;
  /**
   * Business schedule. Array of weekly recurring time periods when the location is open for business. Limited to 100 time periods.
   *
   * __Note:__ Not supported by Wix Bookings.
   */
  businessSchedule?: Maybe<ComWixpressSitepropertiesApiV4BusinessSchedule>;
  /** Whether this is the default location. There can only be one default location per site. The default location can't be archived. */
  default?: Maybe<Scalars['Boolean']>;
  /** Location description. */
  description?: Maybe<Scalars['String']>;
  /** Email address. */
  email?: Maybe<Scalars['String']>;
  /** Extended fields for data extensions. */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** Fax number. */
  fax?: Maybe<Scalars['String']>;
  /** Location ID. */
  id?: Maybe<Scalars['String']>;
  itemsVirtualReference?: Maybe<ComWixpressRestaurantsMenusItemV1QueryItemsResponse>;
  /**
   * Location type.
   *
   * **Note:** Currently not supported.
   */
  locationType?: Maybe<ComWixpressLocationsLocationType>;
  /** Location types. */
  locationTypes?: Maybe<Array<Maybe<ComWixpressLocationsLocationType>>>;
  modifierGroupsVirtualReference?: Maybe<WixRestaurantsMenusV1QueryModifierGroupsResponse>;
  modifiersVirtualReference?: Maybe<WixRestaurantsMenusItemModifierV1QueryModifiersResponse>;
  /** Location name. */
  name?: Maybe<Scalars['String']>;
  /** Phone number. */
  phone?: Maybe<Scalars['String']>;
  /**
   * Revision number, which increments by 1 each time the location is updated.
   * To prevent conflicting changes, the existing revision must be used when updating a location.
   */
  revision?: Maybe<Scalars['Long']>;
  sectionsVirtualReference?: Maybe<ComWixpressRestaurantsMenusSectionV1QuerySectionsResponse>;
  /**
   * Location status. Defaults to `ACTIVE`.
   * __Notes:__
   * - [Archiving a location](https://dev.wix.com/api/rest/business-info/locations/archive-location)
   * doesn't affect the location's status.
   * - `INACTIVE` status is currently not supported.
   */
  status?: Maybe<ComWixpressLocationsLocationStatus>;
  /** Timezone in `America/New_York` format. */
  timeZone?: Maybe<Scalars['String']>;
  variantsVirtualReference?: Maybe<WixRestaurantsMenusItemVariantV1QueryVariantsResponse>;
};


export type ComWixpressLocationsLocationItemsVirtualReferenceArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusItemV1QueryItemsRequestInput>;
};


export type ComWixpressLocationsLocationModifierGroupsVirtualReferenceArgs = {
  queryInput?: InputMaybe<WixRestaurantsMenusV1QueryModifierGroupsRequestInput>;
};


export type ComWixpressLocationsLocationModifiersVirtualReferenceArgs = {
  queryInput?: InputMaybe<WixRestaurantsMenusItemModifierV1QueryModifiersRequestInput>;
};


export type ComWixpressLocationsLocationSectionsVirtualReferenceArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusSectionV1QuerySectionsRequestInput>;
};


export type ComWixpressLocationsLocationVariantsVirtualReferenceArgs = {
  queryInput?: InputMaybe<WixRestaurantsMenusItemVariantV1QueryVariantsRequestInput>;
};

export type ComWixpressLocationsLocationInput = {
  /** Address. */
  address?: InputMaybe<ComWixpressLocationsAddressInput>;
  /**
   * Whether the location is archived. Archived locations can't be updated.
   * __Note:__ [Archiving a location](https://dev.wix.com/api/rest/business-info/locations/archive-location)
   * doesn't affect its `status`.
   */
  archived?: InputMaybe<Scalars['Boolean']>;
  /**
   * Business schedule. Array of weekly recurring time periods when the location is open for business. Limited to 100 time periods.
   *
   * __Note:__ Not supported by Wix Bookings.
   */
  businessSchedule?: InputMaybe<ComWixpressSitepropertiesApiV4BusinessScheduleInput>;
  /** Whether this is the default location. There can only be one default location per site. The default location can't be archived. */
  default?: InputMaybe<Scalars['Boolean']>;
  /** Location description. */
  description?: InputMaybe<Scalars['String']>;
  /** Email address. */
  email?: InputMaybe<Scalars['String']>;
  /** Extended fields for data extensions. */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** Fax number. */
  fax?: InputMaybe<Scalars['String']>;
  /** Location ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Location type.
   *
   * **Note:** Currently not supported.
   */
  locationType?: InputMaybe<ComWixpressLocationsLocationType>;
  /** Location types. */
  locationTypes?: InputMaybe<Array<InputMaybe<ComWixpressLocationsLocationType>>>;
  /** Location name. */
  name?: InputMaybe<Scalars['String']>;
  /** Phone number. */
  phone?: InputMaybe<Scalars['String']>;
  /**
   * Revision number, which increments by 1 each time the location is updated.
   * To prevent conflicting changes, the existing revision must be used when updating a location.
   */
  revision?: InputMaybe<Scalars['Long']>;
  /**
   * Location status. Defaults to `ACTIVE`.
   * __Notes:__
   * - [Archiving a location](https://dev.wix.com/api/rest/business-info/locations/archive-location)
   * doesn't affect the location's status.
   * - `INACTIVE` status is currently not supported.
   */
  status?: InputMaybe<ComWixpressLocationsLocationStatus>;
  /** Timezone in `America/New_York` format. */
  timeZone?: InputMaybe<Scalars['String']>;
};

export enum ComWixpressLocationsLocationStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export enum ComWixpressLocationsLocationType {
  BRANCH = 'BRANCH',
  HEADQUARTERS = 'HEADQUARTERS',
  INVENTORY = 'INVENTORY',
  OFFICES = 'OFFICES',
  RECEPTION = 'RECEPTION',
  UNKNOWN = 'UNKNOWN'
}

export type ComWixpressLocationsPagingMetadata = {
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
  /** Offset that was requested. */
  offset?: Maybe<Scalars['Int']>;
};

export type ComWixpressLocationsQueryLocationsRequestInput = {
  /** Whether to filter only authorized locations */
  filterAuthorizedLocationEntities?: InputMaybe<Scalars['Boolean']>;
  /** Information about the filters, sorting, and paging. */
  query?: InputMaybe<WixCommonQueryInput>;
};

export type ComWixpressLocationsQueryLocationsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressLocationsLocation>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressLocationsRemoveLocationTypeRequestInput = {
  /** Location id to add type */
  id?: InputMaybe<Scalars['String']>;
  locationType?: InputMaybe<ComWixpressLocationsLocationType>;
};

export type ComWixpressLocationsRemoveLocationTypeResponse = {
  /** Full location with the new type */
  location?: Maybe<ComWixpressLocationsLocation>;
};

export type ComWixpressLocationsRemoveTypeFromLocationRequestInput = {
  /** ID of the location where the type will be removed. */
  id?: InputMaybe<Scalars['String']>;
  /** Location type to remove. */
  locationType?: InputMaybe<ComWixpressLocationsLocationType>;
};

export type ComWixpressLocationsRemoveTypeFromLocationResponse = {
  /** Updated location. */
  location?: Maybe<ComWixpressLocationsLocation>;
};

export type ComWixpressLocationsSetDefaultLocationRequestInput = {
  /** ID of the location to set as the default location. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressLocationsSetDefaultLocationResponse = {
  /** New default location. */
  location?: Maybe<ComWixpressLocationsLocation>;
};

export type ComWixpressLocationsStreetAddress = {
  /** Apartment number. */
  apt?: Maybe<Scalars['String']>;
  /** Street name. */
  name?: Maybe<Scalars['String']>;
  /** Street number. */
  number?: Maybe<Scalars['String']>;
};

export type ComWixpressLocationsStreetAddressInput = {
  /** Apartment number. */
  apt?: InputMaybe<Scalars['String']>;
  /** Street name. */
  name?: InputMaybe<Scalars['String']>;
  /** Street number. */
  number?: InputMaybe<Scalars['String']>;
};

export type ComWixpressLocationsUnarchiveLocationRequestInput = {
  /** ID of the location to unarchive. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressLocationsUnarchiveLocationResponse = {
  /** Unarchived location. */
  location?: Maybe<ComWixpressLocationsLocation>;
};

export type ComWixpressLocationsUpdateLocationRequestInput = {
  /** Location to update. */
  location?: InputMaybe<ComWixpressLocationsLocationInput>;
};

export type ComWixpressLocationsUpdateLocationResponse = {
  /** Updated location. */
  location?: Maybe<ComWixpressLocationsLocation>;
};

export enum ComWixpressMembersApiAccessStatusStatus {
  /** Member can log in to the site. */
  APPROVED = 'APPROVED',
  /** Member is blocked and can't log in to the site. */
  BLOCKED = 'BLOCKED',
  /** Member is a [guest author](https://support.wix.com/en/article/wix-blog-adding-managed-writers-to-your-blog) for the site blog and can't log in to the site. */
  OFFLINE = 'OFFLINE',
  /** Member is created and is waiting for approval by a Wix user. */
  PENDING = 'PENDING',
  /** Insufficient permissions to get the status. */
  UNKNOWN = 'UNKNOWN'
}

export enum ComWixpressMembersApiActivityStatusStatus {
  /** Member can write forum posts and blog comments. */
  ACTIVE = 'ACTIVE',
  /** Member can't write forum posts or blog comments. */
  MUTED = 'MUTED',
  /** Insufficient permissions to get the status. */
  UNKNOWN = 'UNKNOWN'
}

export type ComWixpressMembersApiAddress = {
  /** Main address line, usually street and number, as free text. */
  addressLine?: Maybe<Scalars['String']>;
  /**
   * Free text providing more detailed address information,
   * such as apartment, suite, or floor.
   */
  addressLine2?: Maybe<Scalars['String']>;
  /** City name. */
  city?: Maybe<Scalars['String']>;
  /**
   * 2-letter country code in an
   * [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) format.
   */
  country?: Maybe<Scalars['String']>;
  /** Street address ID. */
  id?: Maybe<Scalars['String']>;
  /** Postal code. */
  postalCode?: Maybe<Scalars['String']>;
  /** Street address object, with number and name in separate fields. */
  streetAddress?: Maybe<ComWixpressMembersApiStreetAddress>;
  /**
   * Code for a subdivision (such as state, prefecture, or province) in an
   * [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2) format.
   */
  subdivision?: Maybe<Scalars['String']>;
};

export type ComWixpressMembersApiAddressInput = {
  /** Main address line, usually street and number, as free text. */
  addressLine?: InputMaybe<Scalars['String']>;
  /**
   * Free text providing more detailed address information,
   * such as apartment, suite, or floor.
   */
  addressLine2?: InputMaybe<Scalars['String']>;
  /** City name. */
  city?: InputMaybe<Scalars['String']>;
  /**
   * 2-letter country code in an
   * [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) format.
   */
  country?: InputMaybe<Scalars['String']>;
  /** Street address ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Postal code. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** Street address object, with number and name in separate fields. */
  streetAddress?: InputMaybe<ComWixpressMembersApiStreetAddressInput>;
  /**
   * Code for a subdivision (such as state, prefecture, or province) in an
   * [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2) format.
   */
  subdivision?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembersApiApproveMemberRequestInput = {
  /** ID of the member to approve. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembersApiApproveMemberResponse = {
  /** Approved member. */
  member?: Maybe<ComWixpressMembersApiMember>;
};

export type ComWixpressMembersApiBlockMemberRequestInput = {
  /** ID of a member to block. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembersApiBlockMemberResponse = {
  /** Blocked member. */
  member?: Maybe<ComWixpressMembersApiMember>;
};

export type ComWixpressMembersApiBulkApproveMembersRequestInput = {
  /** Query options. See [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language) for more details. */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type ComWixpressMembersApiBulkApproveMembersResponse = {
  /**
   * Job ID.
   * Specify this ID when calling [Get Async Job](https://dev.wix.com/docs/rest/business-management/async-job/introduction) to retrieve job details and metadata.
   */
  jobId?: Maybe<Scalars['String']>;
};

export type ComWixpressMembersApiBulkBlockMembersRequestInput = {
  /** Query options. See [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language) for more details. */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type ComWixpressMembersApiBulkBlockMembersResponse = {
  /**
   * Job ID.
   * Specify this ID when calling [Get Async Job](https://dev.wix.com/docs/rest/business-management/async-job/introduction) to retrieve job details and metadata.
   */
  jobId?: Maybe<Scalars['String']>;
};

export type ComWixpressMembersApiBulkDeleteMembersByFilterRequestInput = {
  /** ID of a member receiving the deleted member's content. */
  contentAssigneeId?: InputMaybe<Scalars['String']>;
  /** Query options. See [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language) for more details. */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Plain text search. */
  search?: InputMaybe<ComWixpressMembersApiSearchInput>;
};

export type ComWixpressMembersApiBulkDeleteMembersByFilterResponse = {
  /**
   * Job ID.
   * Specify this ID when calling [Get Async Job](https://dev.wix.com/docs/rest/business-management/async-job/introduction) to retrieve job details and metadata.
   */
  jobId?: Maybe<Scalars['String']>;
};

export type ComWixpressMembersApiBulkDeleteMembersRequestInput = {
  /** IDs of members to be deleted. */
  memberIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressMembersApiBulkDeleteMembersResponse = {
  /** Bulk action result metadata. */
  bulkActionMetadata?: Maybe<ComWixpressMembersApiUpstreamWixCommonBulkActionMetadata>;
  /** Result. */
  results?: Maybe<Array<Maybe<ComWixpressMembersApiBulkDeleteMembersResponseBulkMemberResult>>>;
};

export type ComWixpressMembersApiBulkDeleteMembersResponseBulkMemberResult = {
  itemMetadata?: Maybe<ComWixpressMembersApiUpstreamWixCommonItemMetadata>;
};

export type ComWixpressMembersApiContact = {
  /** List of street addresses. */
  addresses?: Maybe<Array<Maybe<ComWixpressMembersApiAddress>>>;
  /**
   * Contact's birthdate, formatted as `"YYYY-MM-DD"`.
   *
   * Example: `"2020-03-15"` for March 15, 2020.
   */
  birthdate?: Maybe<Scalars['String']>;
  /** Contact's company name. */
  company?: Maybe<Scalars['String']>;
  /**
   * Contact ID.
   *
   * > **Deprecation notice:**
   * > This property has been replaced with `member.contactId`
   * > and will be removed on June 11, 2021.
   */
  contactId?: Maybe<Scalars['String']>;
  /**
   * Custom fields,
   * where each key is the field key,
   * and each value is the field's value for the member.
   */
  customFields?: Maybe<ComWixpressMembersApiCustomField>;
  /** List of email addresses. */
  emails?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Contact's first name. */
  firstName?: Maybe<Scalars['String']>;
  /** Contact's job title. */
  jobTitle?: Maybe<Scalars['String']>;
  /** Contact's last name. */
  lastName?: Maybe<Scalars['String']>;
  /** List of phone numbers. */
  phones?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixpressMembersApiContactInput = {
  /** List of street addresses. */
  addresses?: InputMaybe<Array<InputMaybe<ComWixpressMembersApiAddressInput>>>;
  /**
   * Contact's birthdate, formatted as `"YYYY-MM-DD"`.
   *
   * Example: `"2020-03-15"` for March 15, 2020.
   */
  birthdate?: InputMaybe<Scalars['String']>;
  /** Contact's company name. */
  company?: InputMaybe<Scalars['String']>;
  /**
   * Contact ID.
   *
   * > **Deprecation notice:**
   * > This property has been replaced with `member.contactId`
   * > and will be removed on June 11, 2021.
   */
  contactId?: InputMaybe<Scalars['String']>;
  /**
   * Custom fields,
   * where each key is the field key,
   * and each value is the field's value for the member.
   */
  customFields?: InputMaybe<ComWixpressMembersApiCustomFieldInput>;
  /** List of email addresses. */
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Contact's first name. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Contact's job title. */
  jobTitle?: InputMaybe<Scalars['String']>;
  /** Contact's last name. */
  lastName?: InputMaybe<Scalars['String']>;
  /** List of phone numbers. */
  phones?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressMembersApiCreateMemberRequestInput = {
  /** Member to create. */
  member?: InputMaybe<ComWixpressMembersApiMemberInput>;
};

export type ComWixpressMembersApiCreateMemberResponse = {
  /** New member. */
  member?: Maybe<ComWixpressMembersApiMember>;
};

export type ComWixpressMembersApiCustomField = {
  /** Custom field name. */
  name?: Maybe<Scalars['String']>;
  /** Custom field value. */
  value?: Maybe<Scalars['JSON']>;
};

export type ComWixpressMembersApiCustomFieldInput = {
  /** Custom field name. */
  name?: InputMaybe<Scalars['String']>;
  /** Custom field value. */
  value?: InputMaybe<Scalars['JSON']>;
};

export type ComWixpressMembersApiDeleteMemberAddressesRequestInput = {
  /** ID of the member whose street addresses will be deleted. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembersApiDeleteMemberAddressesResponse = {
  /** Updated member. */
  member?: Maybe<ComWixpressMembersApiMember>;
};

export type ComWixpressMembersApiDeleteMemberEmailsRequestInput = {
  /** ID of the member whose email addresses will be deleted. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembersApiDeleteMemberEmailsResponse = {
  /** Updated member. */
  member?: Maybe<ComWixpressMembersApiMember>;
};

export type ComWixpressMembersApiDeleteMemberPhonesRequestInput = {
  /** ID of the member whose phone numbers will be deleted. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembersApiDeleteMemberPhonesResponse = {
  /** Updated member. */
  member?: Maybe<ComWixpressMembersApiMember>;
};

export type ComWixpressMembersApiDeleteMemberRequestInput = {
  /** ID of a member receiving the deleted member's content. */
  contentAssigneeId?: InputMaybe<Scalars['String']>;
  /** ID of a member to delete. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembersApiDeleteMyMemberRequestInput = {
  /** ID of a member receiving the deleted member's content. */
  contentAssigneeId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembersApiDisconnectMemberRequestInput = {
  /** ID of a member to disconnect. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembersApiDisconnectMemberResponse = {
  /** Disconnected member. */
  member?: Maybe<ComWixpressMembersApiMember>;
};

export enum ComWixpressMembersApiFieldSetSet {
  /** Includes `id`, `loginEmail`, `status`, `contactId`, `createdDate`, `updatedDate`, `privacyStatus`, `activityStatus` and the `profile` object. */
  EXTENDED = 'EXTENDED',
  /** Includes all fields. */
  FULL = 'FULL',
  /**
   * Includes `id`, `contactId`, `createdDate`, `updatedDate` and the `profile` object.
   * `status`, `privacyStatus`, and `activityStatus` are returned as `UNKNOWN`.
   */
  PUBLIC = 'PUBLIC'
}

export type ComWixpressMembersApiGetMemberRequestInput = {
  /**
   * Predefined set of fields to return.
   *
   * Defaults to `"PUBLIC"`.
   *
   * __Deprecated.__ Use `fieldsets` instead.
   * This property will be removed on March 31, 2023.
   */
  fieldSet?: InputMaybe<ComWixpressMembersApiFieldSetSet>;
  /**
   * Predefined set of fields to return.
   *
   * Defaults to `"PUBLIC"`.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressMembersApiFieldSetSet>>>;
  id: Scalars['ID'];
};

export type ComWixpressMembersApiGetMyMemberRequestInput = {
  /**
   * *Deprecated:** Use `fieldsets` instead.
   *
   * Predefined set of fields to return.
   */
  fieldSet?: InputMaybe<ComWixpressMembersApiFieldSetSet>;
  /**
   * Predefined set of fields to return.
   *
   * Default: `"PUBLIC"`.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressMembersApiFieldSetSet>>>;
};

export type ComWixpressMembersApiGetMyMemberResponse = {
  /** The retrieved member. */
  member?: Maybe<ComWixpressMembersApiMember>;
};

export type ComWixpressMembersApiJoinCommunityResponse = {
  /** The updated member. */
  member?: Maybe<ComWixpressMembersApiMember>;
};

export type ComWixpressMembersApiLeaveCommunityResponse = {
  /** The updated member. */
  member?: Maybe<ComWixpressMembersApiMember>;
};

export type ComWixpressMembersApiListMembersRequestInput = {
  /**
   * Cursor paging.
   *
   * Priority over paging property
   */
  cursorPaging?: InputMaybe<ComWixpressMembersApiUpstreamWixCommonCursorPagingInput>;
  /**
   * Predefined sets of fields to return.
   *
   * Defaults to `"PUBLIC"`.
   *
   * __Deprecated.__ Use `fieldsets` instead.
   * This property will be removed on March 31, 2023.
   */
  fieldSet?: InputMaybe<ComWixpressMembersApiFieldSetSet>;
  /**
   * Predefined sets of fields to return.
   *
   * Default: `"PUBLIC"`.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressMembersApiFieldSetSet>>>;
  paging?: InputMaybe<WixCommonPagingInput>;
  sorting?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type ComWixpressMembersApiListMembersResponse = {
  /** Cursor metadata for paginated results. */
  cursorPagingMetadata?: Maybe<ComWixpressMembersApiUpstreamWixCommonCursorPagingMetadata>;
  /** List of members. */
  members?: Maybe<Array<Maybe<ComWixpressMembersApiMember>>>;
  /** Metadata for the paginated results. */
  metadata?: Maybe<WixCommonPagingMetadata>;
};

export type ComWixpressMembersApiMember = {
  /** Member activity status. */
  activityStatus?: Maybe<ComWixpressMembersApiActivityStatusStatus>;
  /**
   * Member's contact information. Contact information is stored in the
   * [Contact List](https://www.wix.com/my-account/site-selector/?buttonText=Select%20Site&title=Select%20a%20Site&autoSelectOnSingleSite=true&actionUrl=https:%2F%2Fwww.wix.com%2Fdashboard%2F%7B%7BmetaSiteId%7D%7D%2Fcontacts).
   *
   * The full set of contact data can be accessed and managed with the
   * [Contacts API](https://dev.wix.com/docs/rest/crm/members-contacts/contacts/contacts/introduction).
   */
  contact?: Maybe<ComWixpressMembersApiContact>;
  /** Contact ID. */
  contactId?: Maybe<Scalars['String']>;
  /** Date and time when the member was created. */
  createdDate?: Maybe<Scalars['String']>;
  /**
   * Extended fields.
   * @deprecated Extended fields. Removal date: 2024-06-01.
   */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** Member ID. */
  id?: Maybe<Scalars['String']>;
  /** Date and time when the member last logged in to the site. */
  lastLoginDate?: Maybe<Scalars['String']>;
  /** Email used by a member to log in to the site. */
  loginEmail?: Maybe<Scalars['String']>;
  /** Whether the email used by a member has been verified. */
  loginEmailVerified?: Maybe<Scalars['Boolean']>;
  participantsVirtualReference?: Maybe<WixOnlineprogramsParticipantsV3QueryParticipantsResponse>;
  /** Member privacy status. */
  privacyStatus?: Maybe<ComWixpressMembersApiPrivacyStatusStatus>;
  /** Profile display details. */
  profile?: Maybe<ComWixpressMembersApiProfile>;
  /** Member site access status. */
  status?: Maybe<ComWixpressMembersApiAccessStatusStatus>;
  /** Date and time when the member was updated. */
  updatedDate?: Maybe<Scalars['String']>;
};


export type ComWixpressMembersApiMemberParticipantsVirtualReferenceArgs = {
  queryInput?: InputMaybe<WixOnlineprogramsParticipantsV3QueryParticipantsRequestInput>;
};

export type ComWixpressMembersApiMemberInput = {
  /** Member activity status. */
  activityStatus?: InputMaybe<ComWixpressMembersApiActivityStatusStatus>;
  /**
   * Member's contact information. Contact information is stored in the
   * [Contact List](https://www.wix.com/my-account/site-selector/?buttonText=Select%20Site&title=Select%20a%20Site&autoSelectOnSingleSite=true&actionUrl=https:%2F%2Fwww.wix.com%2Fdashboard%2F%7B%7BmetaSiteId%7D%7D%2Fcontacts).
   *
   * The full set of contact data can be accessed and managed with the
   * [Contacts API](https://dev.wix.com/docs/rest/crm/members-contacts/contacts/contacts/introduction).
   */
  contact?: InputMaybe<ComWixpressMembersApiContactInput>;
  /** Contact ID. */
  contactId?: InputMaybe<Scalars['String']>;
  /** Date and time when the member was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Member ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Date and time when the member last logged in to the site. */
  lastLoginDate?: InputMaybe<Scalars['String']>;
  /** Email used by a member to log in to the site. */
  loginEmail?: InputMaybe<Scalars['String']>;
  /** Whether the email used by a member has been verified. */
  loginEmailVerified?: InputMaybe<Scalars['Boolean']>;
  /** Member privacy status. */
  privacyStatus?: InputMaybe<ComWixpressMembersApiPrivacyStatusStatus>;
  /** Profile display details. */
  profile?: InputMaybe<ComWixpressMembersApiProfileInput>;
  /** Member site access status. */
  status?: InputMaybe<ComWixpressMembersApiAccessStatusStatus>;
  /** Date and time when the member was updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembersApiMuteMemberRequestInput = {
  /** ID of the member to mute. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembersApiMuteMemberResponse = {
  /** Muted member. */
  member?: Maybe<ComWixpressMembersApiMember>;
};

export enum ComWixpressMembersApiPrivacyStatusStatus {
  /** Member is hidden from site visitors and other site members. Member is returned only to Wix users. */
  PRIVATE = 'PRIVATE',
  /** Member is visible to everyone. */
  PUBLIC = 'PUBLIC',
  /** Insufficient permissions to get the status. */
  UNKNOWN = 'UNKNOWN'
}

export type ComWixpressMembersApiProfile = {
  /**
   * Member's cover photo,
   * used as a background picture in a member's profile page.
   *
   * Cover positioning can be altered with `cover.offsetX` and `cover.offsetY`.
   * When left empty, the values default to `0`.
   */
  cover?: Maybe<ComWixpressMembersCommonImage>;
  /**
   * Name that identifies the member to other members.
   * Displayed on the member's profile page
   * and interactions in the forum or blog.
   */
  nickname?: Maybe<Scalars['String']>;
  /** Member's profile photo. */
  photo?: Maybe<ComWixpressMembersCommonImage>;
  /** Slug that determines the member's profile page URL. */
  slug?: Maybe<Scalars['String']>;
  /** Member title. */
  title?: Maybe<Scalars['String']>;
};

export type ComWixpressMembersApiProfileInput = {
  /**
   * Member's cover photo,
   * used as a background picture in a member's profile page.
   *
   * Cover positioning can be altered with `cover.offsetX` and `cover.offsetY`.
   * When left empty, the values default to `0`.
   */
  cover?: InputMaybe<ComWixpressMembersCommonImageInput>;
  /**
   * Name that identifies the member to other members.
   * Displayed on the member's profile page
   * and interactions in the forum or blog.
   */
  nickname?: InputMaybe<Scalars['String']>;
  /** Member's profile photo. */
  photo?: InputMaybe<ComWixpressMembersCommonImageInput>;
  /** Slug that determines the member's profile page URL. */
  slug?: InputMaybe<Scalars['String']>;
  /** Member title. */
  title?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembersApiQueryInput = {
  /**
   * Cursor paging.
   *
   * Priority over paging property
   */
  cursorPaging?: InputMaybe<ComWixpressMembersApiUpstreamWixCommonCursorPagingInput>;
  /** Query options. See [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language) for more details. */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Limit number of results */
  paging?: InputMaybe<WixCommonPagingInput>;
  /** Sort the results */
  sorting?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type ComWixpressMembersApiQueryMembersRequestInput = {
  /**
   * Predefined sets of fields to return.
   *
   * Defaults to `"PUBLIC"`.
   *
   * __Deprecated.__ Use `fieldsets` instead.
   * This property will be removed on March 31, 2023.
   */
  fieldSet?: InputMaybe<ComWixpressMembersApiFieldSetSet>;
  /**
   * Predefined sets of fields to return.
   *
   * Default: `"PUBLIC"`.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressMembersApiFieldSetSet>>>;
  /** Query options. */
  query?: InputMaybe<ComWixpressMembersApiQueryInput>;
  /** Plain text search. */
  search?: InputMaybe<ComWixpressMembersApiSearchInput>;
};

export type ComWixpressMembersApiQueryMembersResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressMembersApiMember>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressMembersApiSearchInput = {
  /** Search term or expression. */
  expression?: InputMaybe<Scalars['String']>;
  /**
   * Currently supported fields for search:
   *
   * - `loginEmail`
   * - `contact.firstName`
   * - `contact.lastName`
   * - `profile.title`
   * - `profile.nickname`
   * - `profile.slug`
   *
   * Default: `profile.nickname`.
   */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressMembersApiStreetAddress = {
  /** Street name. */
  name?: Maybe<Scalars['String']>;
  /** Street number. */
  number?: Maybe<Scalars['String']>;
};

export type ComWixpressMembersApiStreetAddressInput = {
  /** Street name. */
  name?: InputMaybe<Scalars['String']>;
  /** Street number. */
  number?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembersApiUnmuteMemberRequestInput = {
  /** ID of the member to unmute. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembersApiUnmuteMemberResponse = {
  /** Unmuted member. */
  member?: Maybe<ComWixpressMembersApiMember>;
};

export type ComWixpressMembersApiUpdateMemberRequestInput = {
  /** Member info to update. */
  member?: InputMaybe<ComWixpressMembersApiMemberInput>;
};

export type ComWixpressMembersApiUpdateMemberResponse = {
  /** Updated member. */
  member?: Maybe<ComWixpressMembersApiMember>;
};

export type ComWixpressMembersApiUpdateMemberSlugRequestInput = {
  /** Member ID. */
  id?: InputMaybe<Scalars['String']>;
  /** New slug. */
  slug?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembersApiUpdateMemberSlugResponse = {
  /** Updated member. */
  member?: Maybe<ComWixpressMembersApiMember>;
};

export type ComWixpressMembersApiUpdateMySlugRequestInput = {
  /** New slug. */
  slug?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembersApiUpdateMySlugResponse = {
  /** Updated member. */
  member?: Maybe<ComWixpressMembersApiMember>;
};

export type ComWixpressMembersApiUpstreamWixCommonBulkActionMetadata = {
  /** Number of items that couldn't be processed. */
  totalFailures?: Maybe<Scalars['Int']>;
  /** Number of items that were successfully processed. */
  totalSuccesses?: Maybe<Scalars['Int']>;
  /** Number of failures without details because detailed failure threshold was exceeded. */
  undetailedFailures?: Maybe<Scalars['Int']>;
};

export type ComWixpressMembersApiUpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * Pass the relevant cursor token from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Maximum number of items to return in the results. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressMembersApiUpstreamWixCommonCursorPagingMetadata = {
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Cursor strings that point to the next page, previous page, or both. */
  cursors?: Maybe<ComWixpressMembersApiUpstreamWixCommonCursors>;
  /**
   * Whether there are more pages to retrieve following the current page.
   *
   * + `true`: Another page of results can be retrieved.
   * + `false`: This is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressMembersApiUpstreamWixCommonCursors = {
  /** Cursor string pointing to the next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to the previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export type ComWixpressMembersApiUpstreamWixCommonItemMetadata = {
  /** Details about the error in case of failure. */
  error?: Maybe<WixApiApplicationError>;
  /** Item ID. Should always be available, unless it's impossible (for example, when failing to create an item). */
  id?: Maybe<Scalars['String']>;
  /** Index of the item within the request array. Allows for correlation between request and response items. */
  originalIndex?: Maybe<Scalars['Int']>;
  /** Whether the requested action was successful for this item. When `false`, the `error` field is populated. */
  success?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressMembersCommonImage = {
  /** Original image width. */
  height?: Maybe<Scalars['Int']>;
  /**
   * Wix Media image ID,
   * set when the member selects an image from Wix Media.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * X-axis offset.
   *
   * Default: `0`.
   */
  offsetX?: Maybe<Scalars['Int']>;
  /**
   * Y-axis offset.
   *
   * Default: `0`.
   */
  offsetY?: Maybe<Scalars['Int']>;
  /** Image URL. */
  url?: Maybe<Scalars['String']>;
  /** Original image height. */
  width?: Maybe<Scalars['Int']>;
};

export type ComWixpressMembersCommonImageInput = {
  /** Original image width. */
  height?: InputMaybe<Scalars['Int']>;
  /**
   * Wix Media image ID,
   * set when the member selects an image from Wix Media.
   */
  id?: InputMaybe<Scalars['String']>;
  /**
   * X-axis offset.
   *
   * Default: `0`.
   */
  offsetX?: InputMaybe<Scalars['Int']>;
  /**
   * Y-axis offset.
   *
   * Default: `0`.
   */
  offsetY?: InputMaybe<Scalars['Int']>;
  /** Image URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Original image height. */
  width?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressMembershipV1MoneyInput = {
  /** Monetary amount i.e. 3.99. */
  amount?: InputMaybe<Scalars['String']>;
  /** Currency in ISO 4217 format i.e. USD. */
  currency?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembershipV1PeriodInput = {
  /** The amount of Days, Months, Weeks or Years. */
  amount?: InputMaybe<Scalars['Int']>;
  unit?: InputMaybe<ComWixpressMembershipV1PeriodUnit>;
};

export enum ComWixpressMembershipV1PeriodUnit {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  YEAR = 'YEAR'
}

export type ComWixpressMembershipV1PlansPaymentOptionsInput = {
  /** Free trial period for the plan is in days only. It’s available only for recurring plans. */
  freeTrialDays?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<ComWixpressMembershipV1MoneyInput>;
  /** Recurring payments are payments billed Weekly, Monthly or Yearly. False - payment is one time; true - price is deducted from UoU every week, month or year. */
  recurring?: InputMaybe<Scalars['Boolean']>;
  validFor?: InputMaybe<ComWixpressMembershipV1ValidityInput>;
};

export type ComWixpressMembershipV1PlansPlanArchivedInput = {
  plan?: InputMaybe<ComWixpressMembershipV1PlansPlanInput>;
};

export type ComWixpressMembershipV1PlansPlanCreatedInput = {
  plan?: InputMaybe<ComWixpressMembershipV1PlansPlanInput>;
};

export type ComWixpressMembershipV1PlansPlanDetailsInput = {
  /** Plan benefits. */
  benefits?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  clientData?: InputMaybe<Scalars['JSON']>;
  /** Plan description. */
  description?: InputMaybe<Scalars['String']>;
  /** Any terms & conditions that apply to the plan. This information will be displayed on the plan’s checkout screen. */
  disclaimer?: InputMaybe<Scalars['String']>;
  /** Plan name. */
  name?: InputMaybe<Scalars['String']>;
  /** Plan ribbon allows to show additional information for the plan i.e. ‘Best deal’. */
  ribbon?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembershipV1PlansPlanEventInput = {
  archived?: InputMaybe<ComWixpressMembershipV1PlansPlanArchivedInput>;
  created?: InputMaybe<ComWixpressMembershipV1PlansPlanCreatedInput>;
  updated?: InputMaybe<ComWixpressMembershipV1PlansPlanUpdatedInput>;
};

export type ComWixpressMembershipV1PlansPlanInput = {
  /** Indicates whether plan is archived. */
  archived?: InputMaybe<Scalars['Boolean']>;
  /** Buyer can pick a later start date than the time of purchase. */
  buyerCanPickFutureStartDate?: InputMaybe<Scalars['Boolean']>;
  /** Date when plan was created. */
  dateCreated?: InputMaybe<Scalars['String']>;
  /** Date when plan was last updated. */
  dateUpdated?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<ComWixpressMembershipV1PlansPlanDetailsInput>;
  /** Indicates whether plan has orders. */
  hasOrders?: InputMaybe<Scalars['Boolean']>;
  /** Plan id. */
  id?: InputMaybe<Scalars['String']>;
  /** Member is allowed to cancel his/her plan. If no value is given it's set to true. */
  memberCanCancel?: InputMaybe<Scalars['Boolean']>;
  paymentOptions?: InputMaybe<ComWixpressMembershipV1PlansPaymentOptionsInput>;
  /** If true, the plan is marked as primary. */
  primary?: InputMaybe<Scalars['Boolean']>;
  /** Limits on the possible purchase */
  purchaseLimitations?: InputMaybe<ComWixpressMembershipV1PurchaseLimitationsInput>;
  /** Id of role/group in groups and permissions for service that is provided for the plan subscriber. */
  roleId?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  /** The plan is created from the templates (meaning it was created automatically with the site’s creation, not by the site owner). */
  template?: InputMaybe<Scalars['Boolean']>;
  /** If true, the plan is visible. */
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressMembershipV1PlansPlanUpdatedInput = {
  plan?: InputMaybe<ComWixpressMembershipV1PlansPlanInput>;
  previousPlan?: InputMaybe<ComWixpressMembershipV1PlansPlanInput>;
};

export type ComWixpressMembershipV1PurchaseLimitationsInput = {
  /** Number of times plan can be purchased. If plan has no limits value should be NULL */
  amount?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressMembershipV1ValidityInput = {
  /** If true, plan is valid until canceled. */
  forever?: InputMaybe<Scalars['Boolean']>;
  period?: InputMaybe<ComWixpressMembershipV1PeriodInput>;
};

export type ComWixpressMembershipV2CommonMoney = {
  /** Currency code. Three-letter currency code in [ISO-4217 alphabetic](https://en.wikipedia.org/wiki/ISO_4217#Active_codes) format. For example, `'USD'`. */
  currency?: Maybe<Scalars['String']>;
  /** Monetary amount. Decimal string with a period as a decimal separator. For example, `'3.99'`. Can't be negative. */
  value?: Maybe<Scalars['String']>;
};

export type ComWixpressMembershipV2CommonMoneyInput = {
  /** Currency code. Three-letter currency code in [ISO-4217 alphabetic](https://en.wikipedia.org/wiki/ISO_4217#Active_codes) format. For example, `'USD'`. */
  currency?: InputMaybe<Scalars['String']>;
  /** Monetary amount. Decimal string with a period as a decimal separator. For example, `'3.99'`. Can't be negative. */
  value?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembershipV2CommonQueryV2Input = {
  /** A filter object. See [supported fields and operators](https://dev.wix.com/api/rest/wix-pricing-plans/pricing-plans/plans/filter-and-sort#wix-pricing-plans_pricing-plans_plans_filter-and-sort_query-public-plans). */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Pointer to page of results using offset. Can't be used together with 'cursorPaging'. */
  paging?: InputMaybe<WixCommonPagingInput>;
  /** Sort object in the form [{"fieldName":"sortField1"},{"fieldName":"sortField2","direction":"DESC"}]. */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type ComWixpressMembershipV2Duration = {
  /** Number of days, months, weeks, or years in a single payment cycle. Currently limited to support only `1`. */
  count?: Maybe<Scalars['Int']>;
  /** Unit of time for the cycle duration. */
  unit?: Maybe<ComWixpressMembershipV2PeriodUnitEnumPeriodUnit>;
};

export type ComWixpressMembershipV2DurationInput = {
  /** Number of days, months, weeks, or years in a single payment cycle. Currently limited to support only `1`. */
  count?: InputMaybe<Scalars['Int']>;
  /** Unit of time for the cycle duration. */
  unit?: InputMaybe<ComWixpressMembershipV2PeriodUnitEnumPeriodUnit>;
};

export type ComWixpressMembershipV2Fee = {
  /** Amount of fee to be charged */
  amount?: Maybe<Scalars['String']>;
  /** Fee name */
  name?: Maybe<Scalars['String']>;
};

export type ComWixpressMembershipV2FeeConfig = {
  /** The time this fee will be charged. */
  appliedAt?: Maybe<ComWixpressMembershipV2FeeConfigAppliedAt>;
  /** Fee configuration. */
  fee?: Maybe<ComWixpressMembershipV2Fee>;
};

export enum ComWixpressMembershipV2FeeConfigAppliedAt {
  /** Will charge the fee on the first payment. If the order has a free trial, it will charge after the free trial. */
  FIRST_PAYMENT = 'FIRST_PAYMENT',
  UNKNOWN_CHARGE_EVENT = 'UNKNOWN_CHARGE_EVENT'
}

export type ComWixpressMembershipV2FeeConfigInput = {
  /** The time this fee will be charged. */
  appliedAt?: InputMaybe<ComWixpressMembershipV2FeeConfigAppliedAt>;
  /** Fee configuration. */
  fee?: InputMaybe<ComWixpressMembershipV2FeeInput>;
};

export type ComWixpressMembershipV2FeeInput = {
  /** Amount of fee to be charged */
  amount?: InputMaybe<Scalars['String']>;
  /** Fee name */
  name?: InputMaybe<Scalars['String']>;
};

export enum ComWixpressMembershipV2PeriodUnitEnumPeriodUnit {
  /** Time unit is a day. */
  DAY = 'DAY',
  /** Time unit is a month. */
  MONTH = 'MONTH',
  /** Not defined. */
  UNDEFINED = 'UNDEFINED',
  /** Time unit is a week. */
  WEEK = 'WEEK',
  /** Time unit is a year. */
  YEAR = 'YEAR'
}

export type ComWixpressMembershipV2PlansArchivePlanRequestInput = {
  /** ID of the active plan to archive. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembershipV2PlansArchivePlanResponse = {
  /** Archived plan. */
  plan?: Maybe<ComWixpressMembershipV2PlansPlan>;
};

export enum ComWixpressMembershipV2PlansArchivedFilterEnumArchivedFilter {
  /** Returns all plans that are active. */
  ACTIVE = 'ACTIVE',
  /** Returns all plans that are archived. */
  ARCHIVED = 'ARCHIVED',
  /** Returns all plans that are active and archived. */
  ARCHIVED_AND_ACTIVE = 'ARCHIVED_AND_ACTIVE'
}

export type ComWixpressMembershipV2PlansArrangePlansRequestInput = {
  /** IDs of all non-archived plans in the order you want them arranged. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressMembershipV2PlansBulkArchivePlanRequestInput = {
  /** List of Plan IDs to archive. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Set to `true` to return the `Plan` entity in the response. */
  returnFullEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressMembershipV2PlansBulkArchivePlanResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Plans to be archived. */
  results?: Maybe<Array<Maybe<ComWixpressMembershipV2PlansBulkPlanResult>>>;
};

export type ComWixpressMembershipV2PlansBulkPlanResult = {
  /** Item metadata. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
  /** Pricing plan. */
  plan?: Maybe<ComWixpressMembershipV2PlansPlan>;
};

export type ComWixpressMembershipV2PlansCountPlansRequestInput = {
  /** The filter. */
  filter?: InputMaybe<Scalars['JSON']>;
  /** If true, counts only visible plans (visible and not archived). If no value is specified, all plans are counted. */
  visibility?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressMembershipV2PlansCountPlansResponse = {
  /** Number of plans in the response. */
  count?: Maybe<Scalars['Int']>;
};

export type ComWixpressMembershipV2PlansCreatePlanRequestInput = {
  /** Plan details. */
  plan?: InputMaybe<ComWixpressMembershipV2PlansPlanInput>;
};

export type ComWixpressMembershipV2PlansCreatePlanResponse = {
  /** Created plan. */
  plan?: Maybe<ComWixpressMembershipV2PlansPlan>;
};

export type ComWixpressMembershipV2PlansGetPlanRequestInput = {
  id: Scalars['ID'];
};

export type ComWixpressMembershipV2PlansGetPlanStatsResponse = {
  /** Total number of plans created, including active plans (both public and hidden) and archived plans. */
  totalPlans?: Maybe<Scalars['Int']>;
};

export type ComWixpressMembershipV2PlansListPlansRequestInput = {
  /** Archived filter. Defaults to `ACTIVE` (not archived) only. */
  archived?: InputMaybe<ComWixpressMembershipV2PlansArchivedFilterEnumArchivedFilter>;
  /** Filters for free plans only. */
  free?: InputMaybe<Scalars['Boolean']>;
  /** Number of pricing plans to list. Defaults to `75`. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Plan name for filtering. Also checks for and includes partial matches. */
  name?: InputMaybe<Scalars['String']>;
  /** Number of pricing plans to skip. Defaults to `0`. */
  offset?: InputMaybe<Scalars['Int']>;
  /** IDs of plans to list. If non-existent IDs are specified, they are ignored and don't cause errors. If no IDs are specified, all public and hidden plans are listed according to the order displayed in a site's dashboard (which you can set with Arrange Plans). You can specify a maximum of 100 IDs. */
  planIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Visibility filter. Defaults to `PUBLIC_AND_HIDDEN` (meaning, both are listed). */
  public?: InputMaybe<ComWixpressMembershipV2PlansPublicFilterEnumPublicFilter>;
};

export type ComWixpressMembershipV2PlansListPlansResponse = {
  /** Object containing paging-related data (such as the number of plans returned, the offset, and so on). */
  pagingMetadata?: Maybe<WixCommonPagingMetadataV2>;
  /** List of all public and hidden pricing plans. */
  plans?: Maybe<Array<Maybe<ComWixpressMembershipV2PlansPlan>>>;
};

export type ComWixpressMembershipV2PlansListPublicPlansRequestInput = {
  /** Number of items to list. Defaults to `75`. See [limits](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-the-wix-api-query-language#paging). */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip. Defaults to `0`. See [paging](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-the-wix-api-query-language#paging). */
  offset?: InputMaybe<Scalars['Int']>;
  /** IDs of plans to list. Non-existent IDs are ignored and don't cause errors. You can specify a maximum of 100 IDs. */
  planIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressMembershipV2PlansListPublicPlansResponse = {
  /** Object containing paging-related data (such as the number of plans returned, the offset, and so on). */
  pagingMetadata?: Maybe<WixCommonPagingMetadataV2>;
  /** List of public pricing plans. */
  plans?: Maybe<Array<Maybe<ComWixpressMembershipV2PlansPublicPlan>>>;
};

export type ComWixpressMembershipV2PlansMakePlanPrimaryRequestInput = {
  /** Pricing plan ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembershipV2PlansMakePlanPrimaryResponse = {
  /** Pricing plan. */
  plan?: Maybe<ComWixpressMembershipV2PlansPlan>;
};

export type ComWixpressMembershipV2PlansPlan = {
  /** Whether the buyer can start the plan at a later date. Defaults to false. */
  allowFutureStartDate?: Maybe<Scalars['Boolean']>;
  /** Whether the plan is archived. Archived plans are not visible and can't be purchased anymore, but existing purchases remain in effect. */
  archived?: Maybe<Scalars['Boolean']>;
  /**
   * Whether the buyer is allowed to cancel their plan. Defaults to false.
   * If false, calling Request Cancellation returns an error.
   */
  buyerCanCancel?: Maybe<Scalars['Boolean']>;
  /** Client data such as the plan's cover image, terms & conditions settings. */
  clientData?: Maybe<Scalars['JSON']>;
  /** Date plan was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Plan description. */
  description?: Maybe<Scalars['String']>;
  /**
   * ID of the form associated with the plan at checkout.
   *
   * Learn more about [forms](https://support.wix.com/en/article/wix-forms-an-overview).
   */
  form?: Maybe<WixFormsV4Form>;
  /**
   * ID of the form associated with the plan at checkout.
   *
   * Learn more about [forms](https://support.wix.com/en/article/wix-forms-an-overview).
   */
  formId?: Maybe<Scalars['String']>;
  /** Whether the plan has any orders (including pending and unpaid orders). */
  hasOrders?: Maybe<Scalars['Boolean']>;
  /** Plan ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Number of times the same buyer can purchase the plan. Currently limited to support:
   * - Empty value or a value of `0`, meaning no limitation.
   * - Value of `1`, meaning limited to 1 purchase per buyer.
   */
  maxPurchasesPerBuyer?: Maybe<Scalars['Int']>;
  /** Plan name. */
  name?: Maybe<Scalars['String']>;
  /** List of text strings that promote what is included with this plan. For example, "Plenty of parking" or "Free gift on your birthday." */
  perks?: Maybe<ComWixpressMembershipV2StringList>;
  /** Plan price, payment schedule, and expiration. */
  pricing?: Maybe<ComWixpressMembershipV2Pricing>;
  /** Whether the plan is marked as primary. */
  primary?: Maybe<Scalars['Boolean']>;
  /** Whether the plan is public (visible to site visitors and members). */
  public?: Maybe<Scalars['Boolean']>;
  /** URL-friendly version of plan name. Unique across all plans in the same site. */
  slug?: Maybe<Scalars['String']>;
  /** Any terms and conditions that apply to the plan. This information is displayed during checkout. */
  termsAndConditions?: Maybe<Scalars['String']>;
  /** Date plan was last updated. */
  updatedDate?: Maybe<Scalars['String']>;
};

export type ComWixpressMembershipV2PlansPlanInput = {
  /** Whether the buyer can start the plan at a later date. Defaults to false. */
  allowFutureStartDate?: InputMaybe<Scalars['Boolean']>;
  /** Whether the plan is archived. Archived plans are not visible and can't be purchased anymore, but existing purchases remain in effect. */
  archived?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether the buyer is allowed to cancel their plan. Defaults to false.
   * If false, calling Request Cancellation returns an error.
   */
  buyerCanCancel?: InputMaybe<Scalars['Boolean']>;
  /** Client data such as the plan's cover image, terms & conditions settings. */
  clientData?: InputMaybe<Scalars['JSON']>;
  /** Date plan was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Plan description. */
  description?: InputMaybe<Scalars['String']>;
  /**
   * ID of the form associated with the plan at checkout.
   *
   * Learn more about [forms](https://support.wix.com/en/article/wix-forms-an-overview).
   */
  formId?: InputMaybe<Scalars['String']>;
  /** Whether the plan has any orders (including pending and unpaid orders). */
  hasOrders?: InputMaybe<Scalars['Boolean']>;
  /** Plan ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Number of times the same buyer can purchase the plan. Currently limited to support:
   * - Empty value or a value of `0`, meaning no limitation.
   * - Value of `1`, meaning limited to 1 purchase per buyer.
   */
  maxPurchasesPerBuyer?: InputMaybe<Scalars['Int']>;
  /** Plan name. */
  name?: InputMaybe<Scalars['String']>;
  /** List of text strings that promote what is included with this plan. For example, "Plenty of parking" or "Free gift on your birthday." */
  perks?: InputMaybe<ComWixpressMembershipV2StringListInput>;
  /** Plan price, payment schedule, and expiration. */
  pricing?: InputMaybe<ComWixpressMembershipV2PricingInput>;
  /** Whether the plan is marked as primary. */
  primary?: InputMaybe<Scalars['Boolean']>;
  /** Whether the plan is public (visible to site visitors and members). */
  public?: InputMaybe<Scalars['Boolean']>;
  /** URL-friendly version of plan name. Unique across all plans in the same site. */
  slug?: InputMaybe<Scalars['String']>;
  /** Any terms and conditions that apply to the plan. This information is displayed during checkout. */
  termsAndConditions?: InputMaybe<Scalars['String']>;
  /** Date plan was last updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export enum ComWixpressMembershipV2PlansPublicFilterEnumPublicFilter {
  /** Returns only hidden plans. */
  HIDDEN = 'HIDDEN',
  /** Returns only public plans. */
  PUBLIC = 'PUBLIC',
  /** Returns all public and hidden plans. */
  PUBLIC_AND_HIDDEN = 'PUBLIC_AND_HIDDEN'
}

export type ComWixpressMembershipV2PlansPublicPlan = {
  /** Whether the buyer can start the plan at a later date. Defaults to false. */
  allowFutureStartDate?: Maybe<Scalars['Boolean']>;
  /** Whether the buyer is allowed to cancel their plan. Defaults to false. */
  buyerCanCancel?: Maybe<Scalars['Boolean']>;
  /** Client data such as the plan's cover image, terms & conditions settings. */
  clientData?: Maybe<Scalars['JSON']>;
  /** Date plan was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Plan description. */
  description?: Maybe<Scalars['String']>;
  /**
   * ID of the form associated with the plan at checkout.
   *
   * Learn more about [forms](https://support.wix.com/en/article/wix-forms-an-overview).
   */
  form?: Maybe<WixFormsV4Form>;
  /**
   * ID of the form associated with the plan at checkout.
   *
   * Learn more about [forms](https://support.wix.com/en/article/wix-forms-an-overview).
   */
  formId?: Maybe<Scalars['String']>;
  /** Plan ID. */
  id?: Maybe<Scalars['String']>;
  /** Number of times the same buyer can purchase the plan. An empty value or a value of 0 means no limitation. */
  maxPurchasesPerBuyer?: Maybe<Scalars['Int']>;
  /** Plan name. */
  name?: Maybe<Scalars['String']>;
  /** What is included with this plan (for example, 1 weekly entrance to a specific class). */
  perks?: Maybe<ComWixpressMembershipV2StringList>;
  /** Plan price, payment schedule, and expiration. */
  pricing?: Maybe<ComWixpressMembershipV2Pricing>;
  /** Whether the plan is marked as primary. */
  primary?: Maybe<Scalars['Boolean']>;
  /** URL-friendly version of plan name. Unique across all plans in the same site. */
  slug?: Maybe<Scalars['String']>;
  /** Any terms and conditions that apply to the plan. This information is displayed during checkout. */
  termsAndConditions?: Maybe<Scalars['String']>;
  /** Date plan was last updated. */
  updatedDate?: Maybe<Scalars['String']>;
};

export type ComWixpressMembershipV2PlansQueryPublicPlansRequestInput = {
  /** Query options. */
  query?: InputMaybe<ComWixpressMembershipV2CommonQueryV2Input>;
};

export type ComWixpressMembershipV2PlansQueryPublicPlansResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressMembershipV2PlansPlan>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressMembershipV2PlansSearchPlansRequestInput = {
  /** Query options. */
  query?: InputMaybe<ComWixpressMembershipV2CommonQueryV2Input>;
  /** Search phrase for the plan name. */
  searchPhrase?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMembershipV2PlansSearchPlansResponse = {
  /** Object containing paging-related data (such as the number of plans returned, the offset, and so on). */
  pagingMetadata?: Maybe<WixCommonPagingMetadataV2>;
  /** List of pricing plans that match the specified filter and search phrase. */
  plans?: Maybe<Array<Maybe<ComWixpressMembershipV2PlansPlan>>>;
};

export type ComWixpressMembershipV2PlansSetPlanVisibilityRequestInput = {
  /** The ID of the plan to either display or hide on a site page. */
  id?: InputMaybe<Scalars['String']>;
  /** Whether a plan is visible to members and site visitors. Updates the `public` field. */
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressMembershipV2PlansSetPlanVisibilityResponse = {
  /** Pricing plan. */
  plan?: Maybe<ComWixpressMembershipV2PlansPlan>;
};

export type ComWixpressMembershipV2PlansUpdatePlanRequestInput = {
  /** Explicit list of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** ID of the plan to update. */
  plan?: InputMaybe<ComWixpressMembershipV2PlansPlanInput>;
};

export type ComWixpressMembershipV2PlansUpdatePlanResponse = {
  /** Updated plan. */
  plan?: Maybe<ComWixpressMembershipV2PlansPlan>;
};

export type ComWixpressMembershipV2Pricing = {
  /** Additional fees that would apply to the order, one of which might be a setup fee. */
  feeConfigs?: Maybe<Array<Maybe<ComWixpressMembershipV2FeeConfig>>>;
  /** Free trial period for the plan in days. Available only for recurring plans, meaning plans whose pricing model is `subscription`. Set to `0` to remove the free trial. */
  freeTrialDays?: Maybe<Scalars['Int']>;
  /** Amount for a single payment. For subscriptions, this is the amount to pay each payment cycle and it is required. For plans that are not recurring plans, it is the single payment amount for the whole subscription. */
  price?: Maybe<ComWixpressMembershipV2CommonMoney>;
  /** Pricing model indicating a single payment per cycle and the length of the cycle. The cycle is the duration of the plan, not a payment cycle. */
  singlePaymentForDuration?: Maybe<ComWixpressMembershipV2Duration>;
  /** Pricing model indicating the plan is paid in a single payment. The plan is valid until canceled. */
  singlePaymentUnlimited?: Maybe<Scalars['Boolean']>;
  /** Pricing model indicating that the plan has recurring payments. This type of subscription is not a "Wix subscription," which encompasses various types of subscriptions, such as Wix Stores subscriptions, Wix invoice subscriptions, and all pricing plan models. */
  subscription?: Maybe<ComWixpressMembershipV2Recurrence>;
};

export type ComWixpressMembershipV2PricingInput = {
  /** Additional fees that would apply to the order, one of which might be a setup fee. */
  feeConfigs?: InputMaybe<Array<InputMaybe<ComWixpressMembershipV2FeeConfigInput>>>;
  /** Free trial period for the plan in days. Available only for recurring plans, meaning plans whose pricing model is `subscription`. Set to `0` to remove the free trial. */
  freeTrialDays?: InputMaybe<Scalars['Int']>;
  /** Amount for a single payment. For subscriptions, this is the amount to pay each payment cycle and it is required. For plans that are not recurring plans, it is the single payment amount for the whole subscription. */
  price?: InputMaybe<ComWixpressMembershipV2CommonMoneyInput>;
  /** Pricing model indicating a single payment per cycle and the length of the cycle. The cycle is the duration of the plan, not a payment cycle. */
  singlePaymentForDuration?: InputMaybe<ComWixpressMembershipV2DurationInput>;
  /** Pricing model indicating the plan is paid in a single payment. The plan is valid until canceled. */
  singlePaymentUnlimited?: InputMaybe<Scalars['Boolean']>;
  /** Pricing model indicating that the plan has recurring payments. This type of subscription is not a "Wix subscription," which encompasses various types of subscriptions, such as Wix Stores subscriptions, Wix invoice subscriptions, and all pricing plan models. */
  subscription?: InputMaybe<ComWixpressMembershipV2RecurrenceInput>;
};

export type ComWixpressMembershipV2Recurrence = {
  /**
   * Length of a payment cycle. For example, 1 month to have monthly payments.
   * Multiply `cycleDuration`'s `count` by `cycleCount` to get the subscription duration.
   * Currently, only a value of `1` is supported.
   */
  cycleCount?: Maybe<Scalars['Int']>;
  /**
   * Number of payment cycles the subscription is valid for.
   * `0` for unlimited plans or for plans that are valid until canceled.
   */
  cycleDuration?: Maybe<ComWixpressMembershipV2Duration>;
};

export type ComWixpressMembershipV2RecurrenceInput = {
  /**
   * Length of a payment cycle. For example, 1 month to have monthly payments.
   * Multiply `cycleDuration`'s `count` by `cycleCount` to get the subscription duration.
   * Currently, only a value of `1` is supported.
   */
  cycleCount?: InputMaybe<Scalars['Int']>;
  /**
   * Number of payment cycles the subscription is valid for.
   * `0` for unlimited plans or for plans that are valid until canceled.
   */
  cycleDuration?: InputMaybe<ComWixpressMembershipV2DurationInput>;
};

export type ComWixpressMembershipV2StringList = {
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixpressMembershipV2StringListInput = {
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressMetasiteApiV1App = {
  /**
   * Identifier of application type (application definition id).
   *
   * Can be both UUID and non-UUID, for example: SiteMembers, Onboarding, CloudSiteExtension etc.
   */
  appDefId?: Maybe<Scalars['String']>;
  /**
   * Identifier of the instance (concrete application, installed on a site).
   *
   * Mostly UUID, but for some specific legacy cases might be something else.
   */
  instanceId?: Maybe<Scalars['String']>;
  /**
   * Identifier of the originating application. For example, if this app was part of a template,
   * then an app will get instance_id of that app as origin instance id.
   *
   * If application was provisioned not from some template, it should be empty.
   *
   * Note, it could be == to instance_id (for old sites).
   */
  originInstanceId?: Maybe<Scalars['String']>;
  /** State of this app (see docs for state). */
  state?: Maybe<ComWixpressMetasiteApiV1AppState>;
};

export enum ComWixpressMetasiteApiV1AppState {
  /** App is removed from a site (but we preserve it just in case). */
  DISABLED = 'DISABLED',
  /** App is installed on a site. */
  ENABLED = 'ENABLED',
  /** App is not installed, there is a user intention for it only (user will see the pimpl in the editor). */
  PENDING = 'PENDING',
  /** App is in "demo" mode, meaning that it's in read-only mode (it's in a template OR not installed yet). */
  TEMPLATE = 'TEMPLATE',
  UNKNOWN = 'UNKNOWN'
}

export type ComWixpressMetasiteApiV1HtmlApplication = {
  /** Indicates whether this site is managed by EditorX. */
  editorX?: Maybe<Scalars['Boolean']>;
  /** Identifier of the instance. */
  instanceId?: Maybe<Scalars['String']>;
  /** Legacy, don't use it if you can. */
  intId?: Maybe<Scalars['Int']>;
  /** Language of this site. */
  languageCode?: Maybe<Scalars['String']>;
  /** Indicates that site is managed by Odeditor */
  odeditor?: Maybe<Scalars['Boolean']>;
  /** Indicates that site is managed by Picasso */
  picasso?: Maybe<Scalars['Boolean']>;
  seoData?: Maybe<ComWixpressMetasiteEventApiSeoData>;
  /** Indicates whether this site is managed by Wix Studio. */
  studio?: Maybe<Scalars['Boolean']>;
  /** File name for thumbnail. */
  thumbnail?: Maybe<Scalars['String']>;
};

export type ComWixpressMetasiteApiV1MetaSite = {
  /** Date and time when the account that owns this meta site was created. */
  accountCreatedDate?: Maybe<Scalars['String']>;
  /**
   * Indicates whether this site is managed by ADI editor
   *
   * Values:
   * None - not managed.
   * Some(false) - site was created via ADI editor, but later on user switched to regular editor.
   * Some(true) - site was created and still is managed by ADI editor.
   *
   * In old MetaSiteDTO: embeddedService[embeddedServiceType=Onboarding].attributes.isInUse.
   */
  adi?: Maybe<Scalars['Boolean']>;
  /**
   * All "applications" of this meta site.
   *
   * In old MetaSiteDTO -- embeddedServices.
   */
  apps?: Maybe<Array<Maybe<ComWixpressMetasiteApiV1App>>>;
  /** Indicates meta site blocked from publishing and added additional filtering in listing API (MSS). READ_ONLY. */
  blocked?: Maybe<Scalars['Boolean']>;
  /** Indicates the site is used as critical asset and as such is protected. You would be only able to provision applications to this meta site. READ_ONLY. */
  criticalAsset?: Maybe<Scalars['Boolean']>;
  /** Date and time when meta site was created. */
  dateCreated?: Maybe<Scalars['String']>;
  /** Date and time when meta site was updated for the last time. */
  dateUpdated?: Maybe<Scalars['String']>;
  defaultSeoData?: Maybe<ComWixpressMetasiteEventApiSeoData>;
  /**
   * If true - default meta site routing (connected domains, free url, ML) is not used for this meta site.
   *
   * Meaning, that if `example.org` is connected to this meta site, `router-server` will return 404 for `example.org`
   * anyway.
   *
   * This flag is set for some sites that have custom mapping in Routes API / wix-pages-bo.
   */
  dontUseDefaultRouting?: Maybe<Scalars['Boolean']>;
  externalUriMappings?: Maybe<Array<Maybe<ComWixpressMetasiteEventApiExternalUriMapping>>>;
  /**
   * Information about HTML application.
   *
   * In old MetaSiteDTO -- appplications.find(_.applicationType == HtmlWeb).
   */
  htmlApp?: Maybe<ComWixpressMetasiteApiV1HtmlApplication>;
  /** Identifier of meta site. */
  metaSiteId?: Maybe<Scalars['String']>;
  /**
   * The name of meta site.
   *
   * Matches this regular expression: [a-z0-9_\-]{4,20} (but for some legacy sites might be shorted/longer).
   */
  name?: Maybe<Scalars['String']>;
  /** Namespace of meta site. */
  namespace?: Maybe<ComWixpressMetasiteEventApiMetaSiteNamespace>;
  /**
   * Identifier of a template (meta site) from which this site was created.
   *
   * If it's empty it either means that site wasn't created from a template OR it's very old, so we didn't store
   * it back then.
   *
   * For example, if "site" was created from "template", then "template"'s id will be in origin_template_id.
   * When "site" is cloned, clone will also have "template"'s id in origin_instance_id.
   */
  originTemplateId?: Maybe<Scalars['String']>;
  /** Identifier of account that owns this meta site. */
  ownerId?: Maybe<Scalars['String']>;
  /** Indicates whether meta site was published. If true - site should be accessible for viewing. */
  published?: Maybe<Scalars['Boolean']>;
  /**
   * Indicates whether this meta site is template.
   *
   * In old MetaSiteDTO: documentType == Template.
   */
  template?: Maybe<Scalars['Boolean']>;
  /**
   * Indicates whether https should be used for viewing a site.
   *
   * In old MetaSiteDTO -- flags.UseHttps.
   */
  useHttps?: Maybe<Scalars['Boolean']>;
  /**
   * Internal version of meta site. Monotonically increasing number.
   *
   * If passed within update request, it will be used for optimistic locking. In this case,
   * StaleStateException will be thrown if current version doesn't match.
   *
   * In old MetaSiteDTO -- revision.
   */
  version?: Maybe<Scalars['Long']>;
};

export type ComWixpressMetasiteEventApiAssetInput = {
  /** An application definition id (app_id in dev-center). For legacy reasons may be UUID or a string (from Java Enum). */
  appDefId?: InputMaybe<Scalars['String']>;
  /** An instance id. For legacy reasons may be UUID or a string. */
  instanceId?: InputMaybe<Scalars['String']>;
  /** An application state. */
  state?: InputMaybe<ComWixpressMetasiteEventApiAssetState>;
};

export enum ComWixpressMetasiteEventApiAssetState {
  DEMO = 'DEMO',
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
  PENDING = 'PENDING',
  UNKNOWN = 'UNKNOWN'
}

export enum ComWixpressMetasiteEventApiDeleteContextDeleteStatus {
  DELETED = 'DELETED',
  PENDING_PURGE = 'PENDING_PURGE',
  PURGED_EXTERNALLY = 'PURGED_EXTERNALLY',
  TRASH = 'TRASH',
  UNKNOWN = 'UNKNOWN'
}

export type ComWixpressMetasiteEventApiDeleteContextInput = {
  /** When the meta site was deleted. */
  dateDeleted?: InputMaybe<Scalars['String']>;
  /** A reason (flow). */
  deleteOrigin?: InputMaybe<Scalars['String']>;
  /** A status. */
  deleteStatus?: InputMaybe<ComWixpressMetasiteEventApiDeleteContextDeleteStatus>;
  /** A service that deleted it. */
  initiatorId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMetasiteEventApiExternalUriMapping = {
  /** Deprecated. */
  fromExternalUri?: Maybe<Scalars['String']>;
  /** Deprecated. */
  oldToWixUri?: Maybe<Scalars['String']>;
  /** Deprecated. */
  requireDomain?: Maybe<Scalars['Boolean']>;
  /** Deprecated. */
  toWixUri?: Maybe<Scalars['String']>;
};

export enum ComWixpressMetasiteEventApiMetaSiteNamespace {
  /**
   * Namespace for master site that will exist in parent account that will be referenced by subaccounts
   * The site will be used for account level CSM feature for enterprise
   */
  ACCOUNT_MASTER_CMS = 'ACCOUNT_MASTER_CMS',
  /** MetaSites created by the Albums product, they appear as part of the Albums app. MetaSites with this namespace will *not* be shown in a user's site list by default. */
  ALBUMS = 'ALBUMS',
  /** Bookings business flow with no site. */
  ANYWHERE = 'ANYWHERE',
  /**
   * As part of the branded app new funnel, users now can create a meta site that will be branded app first.
   * There's a blank site behind the scene but it's blank).
   * The Mobile company will be the owner of this namespace.
   */
  BRANDED_FIRST = 'BRANDED_FIRST',
  /** Clubs siteless MetaSites, a club without a wix website. MetaSites with this namespace will *not* be shown in a user's site list by default. */
  CLUBS = 'CLUBS',
  /** Codux Headless Sites */
  CODUX = 'CODUX',
  /** Belongs to "strategic products" company. Supports new product in the creator's economy space. */
  CREATOR_ECONOMY = 'CREATOR_ECONOMY',
  /** It is to be used in the Business First efforts. */
  DASHBOARD_FIRST = 'DASHBOARD_FIRST',
  /** MetaSites with this namespace will *not* be shown in a user's site list by default. */
  DEV_CENTER_COMPANY = 'DEV_CENTER_COMPANY',
  /** AppBuilder for AppStudio / shmite (c). MetaSites with this namespace will *not* be shown in a user's site list by default. */
  DEV_SITE = 'DEV_SITE',
  /** Namespace for Headless Backoffice with no editor */
  HEADLESS = 'HEADLESS',
  /** Hotels standalone (siteless). MetaSites with this namespace will *not* be shown in a user's site list by default. */
  HOTELS = 'HOTELS',
  /**
   * A draft created by HTML editor on open. Upon "first save" it will be moved to be of WIX domain.
   *
   * Meta site with this namespace will *not* be shown in a user's site list by default.
   */
  HTML_DRAFT = 'HTML_DRAFT',
  /** LogoMaker websites offered to the user after logo purchase. MetaSites with this namespace will *not* be shown in a user's site list by default. */
  LOGOS = 'LOGOS',
  /** Bobb - AI Design Creator. */
  MEDIA_DESIGN_CREATOR = 'MEDIA_DESIGN_CREATOR',
  /** MIMIR - Siteless account for MIMIR Ai Job runner. */
  MIMIR = 'MIMIR',
  /** Wix Nano. */
  NANO = 'NANO',
  /** Nownia.com Siteless account management for Ai Scheduling Assistant. */
  NOWNIA = 'NOWNIA',
  /** A partially created ADI website. MetaSites with this namespace will *not* be shown in a user's site list by default. */
  ONBOARDING_DRAFT = 'ONBOARDING_DRAFT',
  /** MetaSites with this namespace will *not* be shown in a user's site list by default. */
  PARTNER_DASHBOARD = 'PARTNER_DASHBOARD',
  /** Rise.ai Siteless account management for Gift Cards and Store Credit. */
  RISE = 'RISE',
  /**
   * Shared Blog Site is a unique single site across Enterprise account,
   * This site will hold all Blog posts related to the Marketing product.
   */
  SHARED_BLOG_ENTERPRISE = 'SHARED_BLOG_ENTERPRISE',
  /** ShoutOut stand alone product. These are siteless (no actual Wix site, no HtmlWeb). MetaSites with this namespace will *not* be shown in a user's site list by default. */
  SHOUT_OUT = 'SHOUT_OUT',
  /**
   * the user-journey for Fitness users who want to start from managing their business instead of designing their website.
   * Will be accessible from Site List and will not have a website app.
   * Once the user attaches a site, the site will become a regular wixsite.
   */
  SITELESS_BUSINESS = 'SITELESS_BUSINESS',
  /** Standalone events (siteless). MetaSites with this namespace will *not* be shown in a user's site list by default. */
  STANDALONE_EVENTS = 'STANDALONE_EVENTS',
  /** Standalone forms (siteless). MetaSites with this namespace will *not* be shown in a user's site list by default. */
  STANDALONE_FORMS = 'STANDALONE_FORMS',
  /** Wix Twins platform. */
  TWINS = 'TWINS',
  /**
   * UGC Templates are templates that are created by users for personal use and to sale to other users.
   * The Partners company owns this namespace.
   */
  UGC_TEMPLATE = 'UGC_TEMPLATE',
  UNKNOWN_NAMESPACE = 'UNKNOWN_NAMESPACE',
  /** VideoMaker websites offered to the user after video purchase. MetaSites with this namespace will *not* be shown in a user's site list by default. */
  VIDEO_MAKER = 'VIDEO_MAKER',
  /** Default namespace for UGC sites. MetaSites with this namespace will be shown in a user's site list by default. */
  WIX = 'WIX',
  /** Part of the WixStores migration flow, a user tries to migrate and gets this site to view and if the user likes it then stores removes this namespace and deletes the old site with the old stores. MetaSites with this namespace will *not* be shown in a user's site list by default. */
  WIX_STORES_TEST_DRIVE = 'WIX_STORES_TEST_DRIVE'
}

export type ComWixpressMetasiteEventApiMetaSiteSpecialEventInput = {
  /**
   * TODO(meta-site): Change validation once validations are disabled for consumers
   * More context: https://wix.slack.com/archives/C0UHEBPFT/p1720957844413149 and https://wix.slack.com/archives/CFWKX325T/p1728892152855659
   */
  assets?: InputMaybe<Array<InputMaybe<ComWixpressMetasiteEventApiAssetInput>>>;
  /** Emitted when meta site was permanently deleted. */
  hardDeleted?: InputMaybe<ComWixpressMetasiteEventApiSiteHardDeletedInput>;
  /** A meta site id. */
  metaSiteId?: InputMaybe<Scalars['String']>;
  /** Emitted on a namespace change. */
  namespaceChanged?: InputMaybe<ComWixpressMetasiteEventApiNamespaceChangedInput>;
  /** Emitted when Odeditor is attached. */
  odeditorAssigned?: InputMaybe<Scalars['Void']>;
  /** Emitted when Odeditor is detached. */
  odeditorUnassigned?: InputMaybe<Scalars['Void']>;
  /** Emitted when Picasso is attached. */
  picassoAssigned?: InputMaybe<Scalars['Void']>;
  /** Emitted when Picasso is detached. */
  picassoUnassigned?: InputMaybe<Scalars['Void']>;
  /** Emitted when an application is provisioned (installed). */
  serviceProvisioned?: InputMaybe<ComWixpressMetasiteEventApiServiceProvisionedInput>;
  /** Emitted when an application is removed (uninstalled). */
  serviceRemoved?: InputMaybe<ComWixpressMetasiteEventApiServiceRemovedInput>;
  /** Emitted on a meta site creation. */
  siteCreated?: InputMaybe<ComWixpressMetasiteEventApiSiteCreatedInput>;
  /** Emitted on a meta site deletion. */
  siteDeleted?: InputMaybe<ComWixpressMetasiteEventApiSiteDeletedInput>;
  /** Emitted when meta site is marked as template. */
  siteMarkedAsTemplate?: InputMaybe<Scalars['Void']>;
  /** Emitted when meta site is marked as a WixSite. */
  siteMarkedAsWixSite?: InputMaybe<Scalars['Void']>;
  /** Emitted on the first* publish of the meta site (* switching from unpublished to published state). */
  sitePublished?: InputMaybe<Scalars['Void']>;
  /** Site is marked as PurgedExternally */
  sitePurgedExternally?: InputMaybe<ComWixpressMetasiteEventApiSitePurgedExternallyInput>;
  /** Emitted when meta site name (URL slug) is changed. */
  siteRenamedPayload?: InputMaybe<ComWixpressMetasiteEventApiSiteRenamedInput>;
  /** Emitted on a meta site transfer completion. */
  siteTransferred?: InputMaybe<ComWixpressMetasiteEventApiSiteTransferredInput>;
  /** Emitted on a meta site restoration. */
  siteUndeleted?: InputMaybe<Scalars['Void']>;
  /** Emitted on a meta site unpublish. */
  siteUnpublished?: InputMaybe<ComWixpressMetasiteEventApiSiteUnpublishedInput>;
  /** Emitted when Studio is attached. */
  studioAssigned?: InputMaybe<Scalars['Void']>;
  /** Emitted when StudioTwo is attached. */
  studioTwoAssigned?: InputMaybe<Scalars['Void']>;
  /** Emitted when StudioTwo is detached. */
  studioTwoUnassigned?: InputMaybe<Scalars['Void']>;
  /** Emitted when Studio is detached. */
  studioUnassigned?: InputMaybe<Scalars['Void']>;
  /** A timestamp of the event. */
  timestamp?: InputMaybe<Scalars['Long']>;
  /**
   * Emitted when one of the URLs is changed. After this event you may call `urls-server` to fetch
   * the actual URL.
   *
   * See: https://wix.slack.com/archives/C0UHEBPFT/p1732520791210559?thread_ts=1732027914.294059&cid=C0UHEBPFT
   * See: https://wix.slack.com/archives/C0UHEBPFT/p1744115197619459
   */
  urlChanged?: InputMaybe<Scalars['Void']>;
  /** A meta site version. Monotonically increasing. */
  version?: InputMaybe<Scalars['Long']>;
  /** Emitted when Wixel is attached. */
  wixelAssigned?: InputMaybe<Scalars['Void']>;
  /** Emitted when Wixel is detached. */
  wixelUnassigned?: InputMaybe<Scalars['Void']>;
};

export type ComWixpressMetasiteEventApiMetaTag = {
  /** A name. */
  name?: Maybe<Scalars['String']>;
  /** Indicates whether should be rendered as property. */
  property?: Maybe<Scalars['Boolean']>;
  /** A value. */
  value?: Maybe<Scalars['String']>;
};

export type ComWixpressMetasiteEventApiNamespaceChangedInput = {
  /** A new namespace. */
  newNamespace?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteNamespace>;
  /** A previous namespace. */
  oldNamespace?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteNamespace>;
};

export type ComWixpressMetasiteEventApiSeoData = {
  /** A canonical URL for a site. */
  canonicalUrl?: Maybe<Scalars['String']>;
  /** Indicates whether the site should be indexable by bots. */
  indexable?: Maybe<Scalars['Boolean']>;
  /** A list of meta tags. */
  metaTags?: Maybe<Array<Maybe<ComWixpressMetasiteEventApiMetaTag>>>;
  /** TDB. */
  ogImage?: Maybe<Scalars['String']>;
  /** TDB. */
  suppressTrackingCookies?: Maybe<Scalars['Boolean']>;
  /** A title. */
  title?: Maybe<Scalars['String']>;
};

export type ComWixpressMetasiteEventApiServiceProvisionedInput = {
  /** Either UUID or EmbeddedServiceType. */
  appDefId?: InputMaybe<Scalars['String']>;
  /** Not only UUID. Something here could be something weird. */
  instanceId?: InputMaybe<Scalars['String']>;
  /** An instance id from which this instance is originated. */
  originInstanceId?: InputMaybe<Scalars['String']>;
  /** The origin meta site id */
  originMetaSiteId?: InputMaybe<Scalars['String']>;
  /** A version. */
  version?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMetasiteEventApiServiceRemovedInput = {
  /** Either UUID or EmbeddedServiceType. */
  appDefId?: InputMaybe<Scalars['String']>;
  /** Not only UUID. Something here could be something weird. */
  instanceId?: InputMaybe<Scalars['String']>;
  /** A version. */
  version?: InputMaybe<Scalars['String']>;
};

export enum ComWixpressMetasiteEventApiSiteCreatedContext {
  /** A copy of existing meta site. */
  DUPLICATE = 'DUPLICATE',
  /** A meta site was created by copying of the transfferred meta site. */
  DUPLICATE_BY_SITE_TRANSFER = 'DUPLICATE_BY_SITE_TRANSFER',
  /** deprecated A meta site was created for Flash editor. */
  FLASH = 'FLASH',
  /** A meta site was created from template. */
  FROM_TEMPLATE = 'FROM_TEMPLATE',
  /** A meta site was created as a transfferred site (copy of the original), old flow, should die soon. */
  OLD_SITE_TRANSFER = 'OLD_SITE_TRANSFER',
  /** A valid option, we don't expose all reasons why site might be created. */
  OTHER = 'OTHER'
}

export type ComWixpressMetasiteEventApiSiteCreatedInput = {
  /** A context in which meta site was created. */
  context?: InputMaybe<ComWixpressMetasiteEventApiSiteCreatedContext>;
  /** A namespace. */
  namespace?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteNamespace>;
  /**
   * A meta site id from which this site was created.
   *
   * In case of a creation from a template it's a template id.
   * In case of a site duplication ("Save As" in dashboard or duplicate in UM) it's an id of a source site.
   */
  originMetaSiteId?: InputMaybe<Scalars['String']>;
  /** A template identifier (empty if not created from a template). */
  originTemplateId?: InputMaybe<Scalars['String']>;
  /** An account id of the owner. */
  ownerId?: InputMaybe<Scalars['String']>;
  /** A meta site name (URL slug). */
  siteName?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMetasiteEventApiSiteDeletedInput = {
  /** A deletion context. */
  deleteContext?: InputMaybe<ComWixpressMetasiteEventApiDeleteContextInput>;
};

export type ComWixpressMetasiteEventApiSiteHardDeletedInput = {
  /** A deletion context. */
  deleteContext?: InputMaybe<ComWixpressMetasiteEventApiDeleteContextInput>;
};

export type ComWixpressMetasiteEventApiSitePurgedExternallyInput = {
  appDefId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressMetasiteEventApiSiteRenamedInput = {
  /** A new meta site name (URL slug). */
  newSiteName?: InputMaybe<Scalars['String']>;
  /** A previous meta site name (URL slug). */
  oldSiteName?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMetasiteEventApiSiteTransferredInput = {
  /** A new owner id (user that accepts meta site). */
  newOwnerId?: InputMaybe<Scalars['String']>;
  /** A previous owner id (user that transfers meta site). */
  oldOwnerId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressMetasiteEventApiSiteUnpublishedInput = {
  /** A list of URLs previously associated with the meta site. */
  urls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogBlogPagingInput = {
  /** Pointer to the next or previous page in the list of results. */
  cursor?: InputMaybe<Scalars['String']>;
  /**
   * Number of items to return.
   *
   *
   * Default:`50`
   */
  limit?: InputMaybe<Scalars['Int']>;
  /**
   * Number of items to skip in the current sort order.
   *
   *
   * Default: `0`
   */
  offset?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogBulkCreateTagsRequestInput = {
  /**
   * List of tag fields to be included if entities are present in the response.
   * Base fieldset, which is default, will return all core tag properties.
   * Example: When URL fieldset is selected, returned tag will have a set of base properties and tag url.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogTagFieldField>>>;
  /** Whether to return the full created tag entities in the response. */
  returnFullEntity?: InputMaybe<Scalars['Boolean']>;
  /** Tags to create. */
  tags?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogTagInput>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogBulkCreateTagsResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Tags created by bulk action. */
  results?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogBulkTagResult>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogBulkDeleteTagRequestInput = {
  /** Should delete bypassing the trash-bin. */
  permanent?: InputMaybe<Scalars['Boolean']>;
  /** Tag IDs. */
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogBulkTagResult = {
  /** Optional created tag. */
  item?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogTag>;
  /** Bulk actions metadata for tag. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogCreateTagRequestInput = {
  /**
   * List of additional tag fields to include in the response. For example, use the `URL` fieldset to retrieve the url field in
   * the response in addition to the tag's base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the tag's base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogTagFieldField>>>;
  /** Tag label. The label for each tag in a blog must be unique. */
  label?: InputMaybe<Scalars['String']>;
  /**
   * Tag language.
   *
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   */
  language?: InputMaybe<Scalars['String']>;
  /** SEO data. */
  seoData?: InputMaybe<ComWixpressAdvancedSeoSeoSchemaInput>;
  /** Preferred tag slug. For example, `'tag-slug'`. */
  slug?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogCreateTagResponse = {
  /** Created tag. */
  tag?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogTag>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogDeleteTagRequestInput = {
  /** Tag ID. */
  tagId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogEmbedMedia = {
  /** Thumbnail details. */
  thumbnail?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogEmbedThumbnail>;
  /** Video details. */
  video?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogEmbedVideo>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogEmbedThumbnail = {
  /** Thumbnail height. */
  height?: Maybe<Scalars['Int']>;
  /** Thumbnail url. */
  url?: Maybe<Scalars['String']>;
  /** Thumbnail width. */
  width?: Maybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogEmbedVideo = {
  /** Video height. */
  height?: Maybe<Scalars['Int']>;
  /** Video url. */
  url?: Maybe<Scalars['String']>;
  /** Video width. */
  width?: Maybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogGetOrCreateTagRequestInput = {
  /**
   * List of tag fields to be included if entities are present in the response.
   * Base fieldset, which is default, will return all core tag properties.
   * Example: When URL fieldset is selected, returned tag will have a set of base properties and tag url.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogTagFieldField>>>;
  /** Tag name. Unique per blog. */
  label?: InputMaybe<Scalars['String']>;
  /** Tag language. */
  language?: InputMaybe<Scalars['String']>;
  /** SEO data. */
  seoData?: InputMaybe<ComWixpressAdvancedSeoSeoSchemaInput>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogGetOrCreateTagResponse = {
  /** Tag info. */
  tag?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogTag>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogGetTagByLabelRequestInput = {
  /**
   * List of additional tag fields to include in the response. For example, use the `URL` fieldset to retrieve the url field in
   * the response in addition to the tag's base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the tag's base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogTagFieldField>>>;
  /** Tag label. */
  label?: InputMaybe<Scalars['String']>;
  /**
   * Tag language.
   *
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * If omitted, tags in all languages are returned.
   */
  language?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogGetTagByLabelResponse = {
  /** Retrieved tag. */
  tag?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogTag>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogGetTagBySlugRequestInput = {
  /**
   * List of additional tag fields to include in the response. For example, use the `URL` fieldset to retrieve the url field in
   * the response in addition to the tag's base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the tag's base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogTagFieldField>>>;
  /**
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * Language of the tag to retrieve.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Slug of the tag to retrieve. */
  slug?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogGetTagBySlugResponse = {
  /** Retrieved tag. */
  tag?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogTag>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogGetTagRequestInput = {
  /**
   * List of additional tag fields to include in the response. For example, use the `URL` fieldset to retrieve the url field in
   * the response in addition to the tag's base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the tag's base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogTagFieldField>>>;
  id: Scalars['ID'];
};

export type ComWixpressNpmCommunitiesPlatformizedBlogGetTagsCountByLanguageResponse = {
  /** The language and it's count. */
  tagsLanguageCount?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogTagLanguageCount>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogGetTotalPostsRequestInput = {
  /**
   * Language filter.
   *
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * Pass a language to receive the total amount of posts in that specified language.
   */
  language?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogGetTotalPostsResponse = {
  /** Total amount of published posts. */
  total?: Maybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogGetTotalPublicationsRequestInput = {
  /** Language filter */
  language?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogGetTotalPublicationsResponse = {
  /** Total amount of publications. */
  total?: Maybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogListTagsRequestInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `sort`. */
  cursorPaging?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedUpstreamTagCursorPagingInput>;
  /**
   * List of tag fields to be included if entities are present in the response.
   * Base fieldset, which is default, will return all core tag properties.
   * Example: When URL fieldset is selected, returned tag will have a set of base properties and tag url.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogTagFieldField>>>;
  /** Paging options to limit and skip the number of items. */
  paging?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedUpstreamTagPagingInput>;
  /** Sorting options. For a list of sortable fields, see [Field Support for Filtering and Sorting](https://dev.wix.com/api/rest/community/blog/filter-and-sort). */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogListTagsResponse = {
  /** Details on the paged set of results returned. */
  metaData?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogMetaData>;
  /** List of tags. */
  tags?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogTag>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogMedia = {
  /** Media alternative text. */
  altText?: Maybe<Scalars['String']>;
  /** Whether custom cover media has been specified. If `false`, the first media item in the post's content serves as cover media. */
  custom?: Maybe<Scalars['Boolean']>;
  /** Whether cover media is displayed. */
  displayed?: Maybe<Scalars['Boolean']>;
  /** Embed media details. */
  embedMedia?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogEmbedMedia>;
  /** Wix Media details. */
  wixMedia?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogWixMedia>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogMetaData = {
  /** Number of items returned in this response. */
  count?: Maybe<Scalars['Int']>;
  /** Pointer to the next or previous page in the list of results. */
  cursor?: Maybe<Scalars['String']>;
  /** Requested offset. */
  offset?: Maybe<Scalars['Int']>;
  /** Total number of items that match the query. */
  total?: Maybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogPeriodPostCount = {
  /** Start of time range in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) date and time format. */
  periodStart?: Maybe<Scalars['String']>;
  /** Number of posts published during this month. */
  postCount?: Maybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogPeriodPublicationsCount = {
  /** Start of time range in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) date and time format. */
  periodStart?: Maybe<Scalars['String']>;
  /** Number of posts published during this month. */
  publicationsCount?: Maybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogQueryPostCountStatsRequestInput = {
  /**
   * Language filter.
   *
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * Pass a language to only receive the period post count for that specified language.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Number of months to include in response. */
  months?: InputMaybe<Scalars['Int']>;
  /**
   * Order of returned results.
   *
   * - `OLDEST`: posts by date in ascending order.
   * - `NEWEST`: posts by date in descending order.
   *
   * Default: `OLDEST`
   */
  order?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogQueryPostCountStatsRequestOrder>;
  /** Start of time range to return, in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) date and time format. */
  rangeStart?: InputMaybe<Scalars['String']>;
  /**
   * Time zone to use when calculating the start of the month.
   *
   * [UTC timezone offset](https://en.wikipedia.org/wiki/List_of_UTC_offsets) format. For example, New York time zone is `-05`.
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export enum ComWixpressNpmCommunitiesPlatformizedBlogQueryPostCountStatsRequestOrder {
  NEWEST = 'NEWEST',
  OLDEST = 'OLDEST',
  UNKNOWN = 'UNKNOWN'
}

export type ComWixpressNpmCommunitiesPlatformizedBlogQueryPostCountStatsResponse = {
  /** List of published post counts by month. */
  stats?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogPeriodPostCount>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogQueryPublicationsCountStatsRequestInput = {
  /**
   * Language filter
   *
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Number of months to include in the response. */
  months?: InputMaybe<Scalars['Int']>;
  /** Order of the returned results. */
  order?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogQueryPublicationsCountStatsRequestOrder>;
  /** Non-inclusive end of time range to return, in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) date and time format. */
  rangeEnd?: InputMaybe<Scalars['String']>;
  /** Start of time range to return, in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) date and time format. */
  rangeStart?: InputMaybe<Scalars['String']>;
  /** Timezone of the client. */
  timeZone?: InputMaybe<Scalars['String']>;
};

export enum ComWixpressNpmCommunitiesPlatformizedBlogQueryPublicationsCountStatsRequestOrder {
  NEWEST = 'NEWEST',
  OLDEST = 'OLDEST',
  UNKNOWN = 'UNKNOWN'
}

export type ComWixpressNpmCommunitiesPlatformizedBlogQueryPublicationsCountStatsResponse = {
  /** Chronologically ordered list of publications. */
  stats?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogPeriodPublicationsCount>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogQueryTagsRequestInput = {
  /**
   * List of additional tag fields to include in the response. For example, use the `URL` fieldset to retrieve the url field in
   * the response in addition to the tag's base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the tag's base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogTagFieldField>>>;
  /** Query options. */
  query?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPlatformQueryInput>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogQueryTagsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogTag>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogTag = {
  /** Date the tag was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Tag ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Tag label.
   *
   * A blog can't have two tags with the same label.
   */
  label?: Maybe<Scalars['String']>;
  /**
   * Tag language.
   *
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   */
  language?: Maybe<Scalars['String']>;
  /** Number of posts with this tag. Includes unpublished draft posts. */
  postCount?: Maybe<Scalars['Int']>;
  /** Number of published posts with this tag. */
  publishedPostCount?: Maybe<Scalars['Int']>;
  /** SEO data. */
  seoData?: Maybe<ComWixpressAdvancedSeoSeoSchema>;
  /**
   * Part of a tag's URL that refers to a specific tag.
   *
   * For example, `'https:/example.com/tags/{my-tag-slug}'`
   */
  slug?: Maybe<Scalars['String']>;
  /**
   * ID of the tag's translations when [Wix Multilingual](https://support.wix.com/en/article/wix-multilingual-translating-your-blog) is installed on a site.
   *
   * All translations of a single tag share the same `translationId`.
   */
  translationId?: Maybe<Scalars['String']>;
  /** Date the tag was last updated. */
  updatedDate?: Maybe<Scalars['String']>;
  /**
   * Tag URL.
   *
   * The `url` directs you to a page that lists every post with the specified tag.
   */
  url?: Maybe<WixCommonPageUrl>;
};

export enum ComWixpressNpmCommunitiesPlatformizedBlogTagFieldField {
  /** Includes SEO data. */
  SEO = 'SEO',
  UNKNOWN = 'UNKNOWN',
  /** Includes Tag URL when present. */
  URL = 'URL'
}

export type ComWixpressNpmCommunitiesPlatformizedBlogTagInput = {
  /** Date the tag was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Tag ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Tag label.
   *
   * A blog can't have two tags with the same label.
   */
  label?: InputMaybe<Scalars['String']>;
  /**
   * Tag language.
   *
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Number of posts with this tag. Includes unpublished draft posts. */
  postCount?: InputMaybe<Scalars['Int']>;
  /** Number of published posts with this tag. */
  publishedPostCount?: InputMaybe<Scalars['Int']>;
  /** SEO data. */
  seoData?: InputMaybe<ComWixpressAdvancedSeoSeoSchemaInput>;
  /**
   * Part of a tag's URL that refers to a specific tag.
   *
   * For example, `'https:/example.com/tags/{my-tag-slug}'`
   */
  slug?: InputMaybe<Scalars['String']>;
  /**
   * ID of the tag's translations when [Wix Multilingual](https://support.wix.com/en/article/wix-multilingual-translating-your-blog) is installed on a site.
   *
   * All translations of a single tag share the same `translationId`.
   */
  translationId?: InputMaybe<Scalars['String']>;
  /** Date the tag was last updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
  /**
   * Tag URL.
   *
   * The `url` directs you to a page that lists every post with the specified tag.
   */
  url?: InputMaybe<WixCommonPageUrlInput>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogTagLanguageCount = {
  /** 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format. */
  languageCode?: Maybe<Scalars['String']>;
  /** The count of tags for the language. */
  tagCount?: Maybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogUpdateTagRequestInput = {
  /** Field mask of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * List of tag fields to be included if entities are present in the response.
   * Base fieldset, which is default, will return all core tag properties.
   * Example: When URL fieldset is selected, returned tag will have a set of base properties and tag url.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogTagFieldField>>>;
  /** Tag info to update. */
  tag?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogTagInput>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogUpdateTagResponse = {
  /** Updated tag. */
  tag?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogTag>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3BulkCategoryResult = {
  /** Optional created category. */
  item?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Category>;
  /** Bulk actions metadata for category. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3BulkCreateCategoriesRequestInput = {
  /** Categories to create. */
  categories?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryInput>>>;
  /**
   * List of additional category fields to include in the response. By default
   * only the category’s base fields are returned. Base fields are all category fields that don't appear in the fieldset enum.
   *
   * To retrieve a field, pass the relevant fieldset in the enum in the `fieldsets` array. For example, add the `URL` fieldset to `fieldsets` to
   * retrieve the url field in the response in addition to the category’s base fields.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryFieldField>>>;
  /** Whether to return the full created category entities in the response. */
  returnFullEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3BulkCreateCategoriesResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Categories created by bulk action. */
  results?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3BulkCategoryResult>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3BulkDeleteCategoryRequestInput = {
  /** Category IDs. */
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Should delete bypassing the trash-bin. */
  permanent?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostMetricsRequestInput = {
  /** Post IDs. */
  postIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostMetricsResponse = {
  /** Map of post.id to metrics */
  metrics?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Metrics>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostReactionsRequestInput = {
  /** Post IDs. */
  postIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostReactionsResponse = {
  /** Map of post.id to reactions */
  reactionsMap?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Reactions>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3BulkUpdateCategoriesRequestInput = {
  /** Categories to update. */
  categories?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3MaskedCategoryInput>>>;
  /**
   * List of additional category fields to include in the response. By default
   * only the category’s base fields are returned. Base fields are all category fields that don't appear in the fieldset enum.
   *
   * To retrieve a field, pass the relevant fieldset in the enum in the `fieldsets` array. For example, add the `URL` fieldset to `fieldsets` to
   * retrieve the url field in the response in addition to the category’s base fields.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryFieldField>>>;
  /** Whether to return the full created category entities in the response. */
  returnFullEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3BulkUpdateCategoriesResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Categories updated by bulk action. */
  results?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3BulkCategoryResult>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3Category = {
  /** Category cover image. */
  coverImage?: Maybe<WixCommonImage>;
  /** Category description. */
  description?: Maybe<Scalars['String']>;
  /**
   * Position of the category in the [Category Menu](https://support.wix.com/en/article/wix-blog-adding-and-customizing-a-category-menu).
   * Categories are displayed in ascending order. Categories with a position of `-1` appear at the end of the sequence.
   *
   * Default: `-1`
   */
  displayPosition?: Maybe<Scalars['Int']>;
  /** Category ID. */
  id?: Maybe<Scalars['String']>;
  /** Reserved for internal use. */
  internalId?: Maybe<Scalars['String']>;
  /** Category label. Displayed in the Category Menu. */
  label?: Maybe<Scalars['String']>;
  /**
   * Category language.
   *
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   */
  language?: Maybe<Scalars['String']>;
  /** Number of posts in the category. */
  postCount?: Maybe<Scalars['Int']>;
  /** SEO data. */
  seoData?: Maybe<ComWixpressAdvancedSeoSeoSchema>;
  /** Part of a category's URL that refers to a specific category. For example, the slug of `https:/example.com/blog/category/famous-cats` is `famous-cats`. */
  slug?: Maybe<Scalars['String']>;
  /**
   * Category title.
   * @deprecated Category title. Removal date: 2025-07-16.
   */
  title?: Maybe<Scalars['String']>;
  /** ID of the category's translations. All translations of a single category share the same `translationId`. */
  translationId?: Maybe<Scalars['String']>;
  /** Category translations. */
  translations?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryTranslation>>>;
  /** Date and time the Category was last updated. */
  updatedDate?: Maybe<Scalars['String']>;
  /** The `url` of the page that lists every post with the specified category. */
  url?: Maybe<WixCommonPageUrl>;
};

export enum ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryFieldField {
  /**
   * Includes internal id field.
   * Reserved for internal use
   */
  INTERNAL_ID = 'INTERNAL_ID',
  /** Includes SEO data. */
  SEO = 'SEO',
  /** Includes translations. */
  TRANSLATIONS = 'TRANSLATIONS',
  UNKNOWN = 'UNKNOWN',
  /** Includes category URL. */
  URL = 'URL'
}

export type ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryInput = {
  /** Category cover image. */
  coverImage?: InputMaybe<WixCommonImageInput>;
  /** Category description. */
  description?: InputMaybe<Scalars['String']>;
  /**
   * Position of the category in the [Category Menu](https://support.wix.com/en/article/wix-blog-adding-and-customizing-a-category-menu).
   * Categories are displayed in ascending order. Categories with a position of `-1` appear at the end of the sequence.
   *
   * Default: `-1`
   */
  displayPosition?: InputMaybe<Scalars['Int']>;
  /** Category ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Reserved for internal use. */
  internalId?: InputMaybe<Scalars['String']>;
  /** Category label. Displayed in the Category Menu. */
  label?: InputMaybe<Scalars['String']>;
  /**
   * Category language.
   *
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Number of posts in the category. */
  postCount?: InputMaybe<Scalars['Int']>;
  /** SEO data. */
  seoData?: InputMaybe<ComWixpressAdvancedSeoSeoSchemaInput>;
  /** Part of a category's URL that refers to a specific category. For example, the slug of `https:/example.com/blog/category/famous-cats` is `famous-cats`. */
  slug?: InputMaybe<Scalars['String']>;
  /** ID of the category's translations. All translations of a single category share the same `translationId`. */
  translationId?: InputMaybe<Scalars['String']>;
  /** Category translations. */
  translations?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryTranslationInput>>>;
  /** Date and time the Category was last updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** The `url` of the page that lists every post with the specified category. */
  url?: InputMaybe<WixCommonPageUrlInput>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryLanguageCount = {
  /** The count of Categories for the language. */
  categoryCount?: Maybe<Scalars['Int']>;
  /** 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format. */
  languageCode?: Maybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryTranslation = {
  /** Category ID. */
  id?: Maybe<Scalars['String']>;
  /** Label displayed in the categories menu on the site. */
  label?: Maybe<Scalars['String']>;
  /** Language of the category. */
  language?: Maybe<Scalars['String']>;
  /** URL of this category page. */
  url?: Maybe<WixCommonPageUrl>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryTranslationInput = {
  /** Category ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Label displayed in the categories menu on the site. */
  label?: InputMaybe<Scalars['String']>;
  /** Language of the category. */
  language?: InputMaybe<Scalars['String']>;
  /** URL of this category page. */
  url?: InputMaybe<WixCommonPageUrlInput>;
};

export enum ComWixpressNpmCommunitiesPlatformizedBlogV3ChangeOriginOrigin {
  /** Categories were changed */
  ADD_CATEGORIES = 'ADD_CATEGORIES',
  /** Changed by admin */
  ADMIN = 'ADMIN',
  /** Saved automatically by AI tool. */
  AI_AUTO_SAVE = 'AI_AUTO_SAVE',
  /** Was approved in moderation */
  APPROVE_IN_MODERATION = 'APPROVE_IN_MODERATION',
  /** Saved automatically */
  AUTO_SAVE = 'AUTO_SAVE',
  /** Copied from template */
  COPY_TEMPLATE = 'COPY_TEMPLATE',
  /** Tag was deleted */
  DELETE_TAG = 'DELETE_TAG',
  /** Imported */
  IMPORT = 'IMPORT',
  /** Imported in bulk */
  IMPORT_BULK = 'IMPORT_BULK',
  /** Imported with html import */
  IMPORT_HTML = 'IMPORT_HTML',
  /** Patch import */
  IMPORT_PATCH = 'IMPORT_PATCH',
  /** Changed language */
  LANGUAGE_CHANGE = 'LANGUAGE_CHANGE',
  /** Saved manually */
  MANUAL_SAVE = 'MANUAL_SAVE',
  /** Affected by migration */
  MIGRATION = 'MIGRATION',
  /** Affected by moderation */
  MODERATION = 'MODERATION',
  /** Moved to trash */
  MOVE_TO_TRASH = 'MOVE_TO_TRASH',
  /** New edit session started which updated editing_session_id id */
  NEW_EDIT_SESSION = 'NEW_EDIT_SESSION',
  /** Post was pinned */
  PIN = 'PIN',
  /** Pricing plans were changed */
  PRICING_PLANS_CHANGE = 'PRICING_PLANS_CHANGE',
  /** Was provisioned */
  PROVISION = 'PROVISION',
  /** Was published */
  PUBLISH = 'PUBLISH',
  /** Owner was reassigned */
  REASSIGN_OWNER = 'REASSIGN_OWNER',
  /** Was reblogged */
  REBLOG = 'REBLOG',
  /** Was rejected from moderation */
  REJECT_FROM_MODERATION = 'REJECT_FROM_MODERATION',
  /** Was removed from moderation */
  REMOVE_FROM_MODERATION = 'REMOVE_FROM_MODERATION',
  /** Was restored */
  RESTORE = 'RESTORE',
  /** Reverted to draft */
  REVERT_TO_DRAFT = 'REVERT_TO_DRAFT',
  /** Was scheduled */
  SCHEDULE = 'SCHEDULE',
  /** Was published by Later */
  SCHEDULING_SERVICE_PUBLISH = 'SCHEDULING_SERVICE_PUBLISH',
  /** Was scheduled by Later */
  SCHEDULING_SERVICE_SCHEDULE = 'SCHEDULING_SERVICE_SCHEDULE',
  /** Was unscheduled by Later */
  SCHEDULING_SERVICE_UNSCHEDULE = 'SCHEDULING_SERVICE_UNSCHEDULE',
  /** Was translated */
  TRANSLATION = 'TRANSLATION',
  UNKNOWN = 'UNKNOWN',
  /** Post was unpinned */
  UNPIN = 'UNPIN',
  /** Was unpublished */
  UNPUBLISH = 'UNPUBLISH',
  /** Was unscheduled */
  UNSCHEDULE = 'UNSCHEDULE'
}

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ConvertDraftJsToRichContentRequestInput = {
  /** DraftJs content to convert to Rich content. */
  content?: InputMaybe<Scalars['JSON']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ConvertDraftJsToRichContentResponse = {
  /** Rich content converted from DraftJs content. */
  richContent?: Maybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ConvertRichContentToDraftJsRequestInput = {
  /** Rich content to convert to DraftJs content. */
  richContent?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ConvertRichContentToDraftJsResponse = {
  /** DraftJs content converted from Rich content. */
  content?: Maybe<Scalars['JSON']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3CreateCategoryRequestInput = {
  /** Category info. */
  category?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryInput>;
  /**
   * List of additional category fields to include in the response. By default
   * only the category’s base fields are returned. Base fields are all category fields that don't appear in the fieldset enum.
   *
   * To retrieve a field, pass the relevant fieldset in the enum in the `fieldsets` array. For example, add the `URL` fieldset to `fieldsets` to
   * retrieve the url field in the response in addition to the category’s base fields.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryFieldField>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3CreateCategoryResponse = {
  /** Category info. */
  category?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Category>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3CreateDraftPostFromTemplateRequestInput = {
  /** Post template id */
  postTemplateId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3CreateDraftPostFromTemplateResponse = {
  /** Created draft post */
  draftPost?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3DraftPost>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3DeleteCategoryRequestInput = {
  /** Category ID. */
  categoryId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3DraftPost = {
  /** Category IDs of the draft post. */
  categoryIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Reserved for internal use. */
  changeOrigin?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ChangeOriginOrigin>;
  /** Whether commenting on the draft post is enabled. */
  commentingEnabled?: Maybe<Scalars['Boolean']>;
  /** Reserved for internal use. */
  content?: Maybe<Scalars['JSON']>;
  /** Reserved for internal use. */
  contentId?: Maybe<Scalars['String']>;
  /** Date the draft post was first created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Date the draft post was last edited. */
  editedDate?: Maybe<Scalars['String']>;
  /** Reserved for internal use. */
  editingSessionId?: Maybe<Scalars['String']>;
  /**
   * Draft post excerpt.
   *
   * If no excerpt has been manually set, an excerpt is automatically generated from the post's text.
   * This can be retrieved using the `GENERATED_EXCERPT` fieldset.
   */
  excerpt?: Maybe<Scalars['String']>;
  /** Whether the draft post is marked as featured. */
  featured?: Maybe<Scalars['Boolean']>;
  /** Date the post was first published. */
  firstPublishedDate?: Maybe<Scalars['String']>;
  /** Indicates if there are changes made to the draft post that have not yet been published. */
  hasUnpublishedChanges?: Maybe<Scalars['Boolean']>;
  /** Hashtags in the post. */
  hashtags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Image placed at the top of the blog page. */
  heroImage?: Maybe<WixCommonImage>;
  /** Draft post ID. */
  id?: Maybe<Scalars['String']>;
  /** Reserved for internal use. */
  internalId?: Maybe<Scalars['String']>;
  /**
   * Language the draft post is written in.
   *
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   */
  language?: Maybe<Scalars['String']>;
  /** Post cover media. */
  media?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogMedia>;
  /** Draft post owner's member ID. */
  memberId?: Maybe<Scalars['String']>;
  /** Estimated reading time of the draft post (calculated automatically). */
  minutesToRead?: Maybe<Scalars['Int']>;
  /** Details of the draft post in review. Only relevant to posts submitted by guest writers. */
  moderationDetails?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ModerationDetails>;
  /** Reserved for internal use. */
  mostRecentContributorId?: Maybe<Scalars['String']>;
  /** Reserved for internal use, not included in base response. */
  originPostId?: Maybe<Scalars['String']>;
  /** Reserved for internal use, not included in base response. */
  originPostInstanceId?: Maybe<Scalars['String']>;
  /** Number of paragraphs to display in a paid content preview for non-paying users. */
  previewTextParagraph?: Maybe<Scalars['Int']>;
  /** Pricing plan IDs. Only relevant if a post is assigned to a specific pricing plan. See the Pricing Plans API for more info. */
  pricingPlanIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** IDs of posts related to this draft post. */
  relatedPostIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Draft Post rich content.
   *
   * <widget src="https://apps.wix.com/_serverless/ricos-playground-services/goto/api-component" plugins="image.gallery.video.audio.divider.linkButton.html.giphy.codeBlock.file.hashtag.lineSpacing.indent.link.textColor.textHighlight.heading.verticalEmbed.table.collapsibleList.poll" exampleid="72c23a25-524f-4f70-a260-4a2777b6f5d5">
   * <a href="https://dev.wix.com/docs/ricos/api-reference/ricos-document">See Ricos document reference</a>
   * </widget>
   */
  richContent?: Maybe<WixRichContentV1RichContent>;
  /** Date the draft post is scheduled to be published. */
  scheduledPublishDate?: Maybe<Scalars['String']>;
  /** SEO data. */
  seoData?: Maybe<ComWixpressAdvancedSeoSeoSchema>;
  /** SEO slug. */
  seoSlug?: Maybe<Scalars['String']>;
  /** Reserved for internal use. */
  slugs?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Status of the draft post. */
  status?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostStatusStatus>;
  /** Tag IDs the draft post is tagged with. */
  tagIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Draft post title. */
  title?: Maybe<Scalars['String']>;
  /**
   * ID of the draft post's translations.
   *
   * All translations of a single post share the same `translationId`.
   * Available only if the [Multilingual](https://support.wix.com/en/article/wix-multilingual-an-overview) app is installed.
   */
  translationId?: Maybe<Scalars['String']>;
  /** List of the post's translated posts. */
  translations?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostTranslation>>>;
  /** Draft post URL preview. What the URL will look like once the post is published. */
  url?: Maybe<WixCommonPageUrl>;
};

export enum ComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostStatusStatus {
  /** Status indicating the draft post is deleted. */
  DELETED = 'DELETED',
  /**
   * Deprecated. Use `IN_REVIEW` instead. Status indicating the draft post is in review.
   * Target removal date 2024-06-30
   * Reserved for internal use.
   */
  IN_MODERATION = 'IN_MODERATION',
  /** Status indicating the draft post is in review. */
  IN_REVIEW = 'IN_REVIEW',
  /** Status indicating the draft post is published. */
  PUBLISHED = 'PUBLISHED',
  /** Status indicating the draft post is scheduled for publication. */
  SCHEDULED = 'SCHEDULED',
  UNKNOWN = 'UNKNOWN',
  /** Status indicating the draft post is unpublished. */
  UNPUBLISHED = 'UNPUBLISHED'
}

export type ComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostTranslation = {
  /** Post ID. */
  id?: Maybe<Scalars['String']>;
  /** Language the post is written in. */
  language?: Maybe<Scalars['String']>;
  /** SEO data. */
  seoData?: Maybe<ComWixpressAdvancedSeoSeoSchema>;
  /** Post slug. For example, 'post-slug'. */
  slug?: Maybe<Scalars['String']>;
  /** Post status. */
  status?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostStatusStatus>;
  /** Post URL. */
  url?: Maybe<WixCommonPageUrl>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3GetCategoriesCountByLanguageResponse = {
  /** The language and it's count. */
  categoriesLanguageCount?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryLanguageCount>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3GetCategoryBySlugRequestInput = {
  /**
   * List of additional category fields to include in the response. By default
   * only the category’s base fields are returned. Base fields are all category fields that don't appear in the fieldset enum.
   *
   * To retrieve a field, pass the relevant fieldset in the enum in the `fieldsets` array. For example, add the `URL` fieldset to `fieldsets` to
   * retrieve the url field in the response in addition to the category’s base fields.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryFieldField>>>;
  /**
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * Language of the category to retrieve.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Slug of the category to retrieve. */
  slug?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3GetCategoryBySlugResponse = {
  /** Category info. */
  category?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Category>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3GetCategoryRequestInput = {
  /**
   * List of additional category fields to include in the response. By default
   * only the category’s base fields are returned. Base fields are all category fields that don't appear in the fieldset enum.
   *
   * To retrieve a field, pass the relevant fieldset in the enum in the `fieldsets` array. For example, add the `URL` fieldset to `fieldsets` to
   * retrieve the url field in the response in addition to the category’s base fields.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryFieldField>>>;
  id: Scalars['ID'];
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostBySlugRequestInput = {
  /**
   * List of additional post fields to include in the response. For example, use the `URL` fieldset to retrieve the url field in
   * the response in addition to the post’s base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the post’s base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PostFieldField>>>;
  /** Language of the post. */
  language?: InputMaybe<Scalars['String']>;
  /** Slug of the post to retrieve. */
  slug?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostBySlugResponse = {
  /** Retrieved post info. */
  post?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Post>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostCountPerMonthRequestInput = {
  /** Optional post language filter. */
  language?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostCountPerMonthResponse = {
  /** Post count per month information. */
  postCountInfo?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PostCountPerMonth>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostMetricsRequestInput = {
  /** Post ID to retrieve metrics for. */
  postId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostMetricsResponse = {
  /** Retrieved post metrics. */
  metrics?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Metrics>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostRequestInput = {
  /**
   * List of additional post fields to include in the response. For example, use the `URL` fieldset to retrieve the url field in
   * the response in addition to the post’s base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the post’s base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PostFieldField>>>;
  id: Scalars['ID'];
};

export enum ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostsSort {
  /** Ordered by `firstPublishedDate` in descending order with pinned posts first. */
  FEED = 'FEED',
  /** Ordered by total number of likes in descending order. */
  LIKE_COUNT = 'LIKE_COUNT',
  /** Ordered by `firstPublishedDate` in ascending order. */
  PUBLISHED_DATE_ASC = 'PUBLISHED_DATE_ASC',
  /** Ordered by `firstPublishedDate` in descending order. */
  PUBLISHED_DATE_DESC = 'PUBLISHED_DATE_DESC',
  /** Sorting by post rating descending. */
  RATING = 'RATING',
  /** Ordered by `title` in ascending order. */
  TITLE_ASC = 'TITLE_ASC',
  /** Ordered by `title` in descending order. */
  TITLE_DESC = 'TITLE_DESC',
  /** Ordered by total number of views in descending order. */
  VIEW_COUNT = 'VIEW_COUNT'
}

export type ComWixpressNpmCommunitiesPlatformizedBlogV3GetTemplateRequestInput = {
  /** Post template id */
  postTemplateId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3GetTemplateResponse = {
  /** Post template */
  postTemplate?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Post>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3GetTotalLikesPerMemberRequestInput = {
  /** Member ID. */
  memberId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3GetTotalLikesPerMemberResponse = {
  /** The total number of likes of the member. */
  total?: Maybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3LikePostRequestInput = {
  /**
   * List of additional post fields to include in the response. For example, use the `URL` fieldset to retrieve the url field in
   * the response in addition to the post’s base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the post’s base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PostFieldField>>>;
  /** Post ID. */
  postId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3LikePostResponse = {
  /** Post info. */
  post?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Post>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ListCategoriesRequestInput = {
  /**
   * List of additional category fields to include in the response. By default
   * only the category’s base fields are returned. Base fields are all category fields that don't appear in the fieldset enum.
   *
   * To retrieve a field, pass the relevant fieldset in the enum in the `fieldsets` array. For example, add the `URL` fieldset to `fieldsets` to
   * retrieve the url field in the response in addition to the category’s base fields.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryFieldField>>>;
  /**
   * Language filter.
   *
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * Pass a language to only receive categories that are in that language.
   * If omitted, categories in all languages are returned.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Pagination options. */
  paging?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogBlogPagingInput>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ListCategoriesResponse = {
  /** List of categories. */
  categories?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Category>>>;
  /** Details on the paged set of results returned. */
  metaData?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogMetaData>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ListDemoPostsRequestInput = {
  /**
   * Category filter.
   *
   * Pass an array of category IDs to return only posts with any of the provided categories.
   * If omitted, all posts with or without associated categories are returned.
   */
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Whether to return only featured posts.
   *
   * Default: `false`
   */
  featured?: InputMaybe<Scalars['Boolean']>;
  /**
   * List of additional post fields to include in the response. For example, use the `URL` fieldset to retrieve the url field in
   * the response in addition to the post’s base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the post’s base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PostFieldField>>>;
  /**
   * Hashtag filter.
   *
   * Pass an array of hashtags to return only posts containing any of the provided hashtags.
   * If omitted, all posts with or without hashtags are returned.
   */
  hashtags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Language filter.
   *
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * Pass a language to only receive posts that are in that language.
   * If omitted, posts in all languages are returned.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Post owner's member ID. */
  memberId?: InputMaybe<Scalars['String']>;
  /** Pagination options. */
  paging?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogBlogPagingInput>;
  /**
   * Sorting options.
   *
   * - `FEED`: Ordered by `firstPublishedDate` in descending order with pinned posts first.
   * - `VIEW_COUNT`: Ordered by total number of views in descending order.
   * - `LIKE_COUNT`: Ordered by total number of likes in descending order.
   * - `PUBLISHED_DATE_ASC`: Ordered by `firstPublishedDate` in ascending order.
   * - `PUBLISHED_DATE_DESC`: Ordered by `firstPublishedDate` in descending order.
   * - `TITLE_ASC`: Ordered by `title` in ascening order.
   * - `TITLE_DESC`: Ordered by `title` in descending order.
   * - `RATING`: reserved for internal use.
   *
   * Default: `FEED`
   */
  sort?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostsSort>;
  /**
   * Tag filter.
   *
   * Pass an array of tag IDs to return only posts with any of the provided tags.
   * If omitted, all posts with or without tags are returned.
   */
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ListDemoPostsResponse = {
  /** Details on the paged set of results returned. */
  metaData?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogMetaData>;
  /** List of posts. */
  posts?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Post>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ListPostsArchiveRequestInput = {
  /**
   * List of additional post fields to include in the response. For example, use the `URL` fieldset to retrieve the url field in
   * the response in addition to the post’s base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the post’s base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PostFieldField>>>;
  /**
   * Language filter.
   *
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * Pass a language to only receive posts that are in that language.
   * If omitted, posts in all languages are returned.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Month */
  month?: InputMaybe<Scalars['Int']>;
  /** Pagination options. */
  paging?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogBlogPagingInput>;
  /** Time zone */
  timeZone?: InputMaybe<Scalars['String']>;
  /** Year */
  year?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ListPostsArchiveResponse = {
  /** Details on the paged set of results returned. */
  metaData?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogMetaData>;
  /** Details on the paged set of results returned. */
  pagingMetadata?: Maybe<ComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPagingMetadataV2>;
  /** List of posts. */
  posts?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Post>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ListPostsRequestInput = {
  /**
   * Category filter.
   *
   * Pass an array of category IDs to return only posts with any of the provided categories.
   * If omitted, all posts with or without associated categories are returned.
   */
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Whether to return only featured posts.
   *
   * Default: `false`
   */
  featured?: InputMaybe<Scalars['Boolean']>;
  /**
   * List of additional post fields to include in the response. For example, use the `URL` fieldset to retrieve the url field in
   * the response in addition to the post’s base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the post’s base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PostFieldField>>>;
  /**
   * Hashtag filter.
   *
   * Pass an array of hashtags to return only posts containing any of the provided hashtags.
   * If omitted, all posts with or without hashtags are returned.
   */
  hashtags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Language filter.
   *
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   * Pass a language to only receive posts that are in that language.
   * If omitted, posts in all languages are returned.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Post owner's member ID. */
  memberId?: InputMaybe<Scalars['String']>;
  /** Pagination options. */
  paging?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogBlogPagingInput>;
  /**
   * Sorting options.
   *
   * Default: `FEED`
   */
  sort?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostsSort>;
  /**
   * Tag filter.
   *
   * Pass an array of tag IDs to return only posts with any of the provided tags.
   * If omitted, all posts with or without tags are returned.
   */
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ListPostsResponse = {
  /** Details on the paged set of results returned. */
  metaData?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogMetaData>;
  /** List of retrieved posts. */
  posts?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Post>>>;
};

export enum ComWixpressNpmCommunitiesPlatformizedBlogV3ListTemplatesRequestGetPostTemplatesSort {
  /** Sort by ascending publishing date. */
  PUBLISHED_DATE_ASC = 'PUBLISHED_DATE_ASC',
  /** Sort by descending publishing date. */
  PUBLISHED_DATE_DESC = 'PUBLISHED_DATE_DESC'
}

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ListTemplatesRequestInput = {
  /** Filter post templates by given template category ids */
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter post templates by provided language */
  language?: InputMaybe<Scalars['String']>;
  /** Returns post template categories when set to TRUE */
  listTemplateCategories?: InputMaybe<Scalars['Boolean']>;
  /** Pagination options. */
  paging?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogBlogPagingInput>;
  /** Sort order by ascending/descending publish date. Default is ascending publish date sort */
  sort?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ListTemplatesRequestGetPostTemplatesSort>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ListTemplatesResponse = {
  /** Available post templates */
  postTemplates?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Post>>>;
  /** Details on the paged set of posts templates returned. */
  postTemplatesMetaData?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogMetaData>;
  /** Post template categories. This value is returned empty unless asked explicitly */
  templateCategories?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Category>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3MaskedCategoryInput = {
  /** Category */
  category?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryInput>;
  /** Field mask of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3Metrics = {
  /** Average rating of post from 1 to 5. */
  averageRating?: Maybe<Scalars['Float']>;
  /** Total number of post comments. */
  comments?: Maybe<Scalars['Int']>;
  /** Total number of post likes. */
  likes?: Maybe<Scalars['Int']>;
  /** Total number of post ratings. */
  totalRatings?: Maybe<Scalars['Int']>;
  /** Total number of post views. */
  views?: Maybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ModerationDetails = {
  /** Member ID of the person who approved or rejected the post. */
  moderatedBy?: Maybe<Scalars['String']>;
  /** Date the post was approved or rejected. */
  moderationDate?: Maybe<Scalars['String']>;
  /** Status indicating whether the submission was approved or rejected by the moderator. */
  status?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ModerationStatusStatus>;
  /** Member ID of the person submitting the draft post for review. */
  submittedBy?: Maybe<Scalars['String']>;
  /** Date the post was submitted for review. */
  submittedDate?: Maybe<Scalars['String']>;
};

export enum ComWixpressNpmCommunitiesPlatformizedBlogV3ModerationStatusStatus {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  UNKNOWN = 'UNKNOWN'
}

export type ComWixpressNpmCommunitiesPlatformizedBlogV3PinPostRequestInput = {
  /**
   * List of additional post fields to include in the response. For example, use the `URL` fieldset to retrieve the url field in
   * the response in addition to the post’s base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the post’s base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PostFieldField>>>;
  /** Post ID. */
  postId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3PinPostResponse = {
  /** Post info. */
  post?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Post>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3Post = {
  /** Category IDs of the post. See Blog Category API for more info. */
  categoryIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Whether commenting on the post is enabled. */
  commentingEnabled?: Maybe<Scalars['Boolean']>;
  /** Contact ID of the post's owner. See the Contacts API for more info. */
  contactId?: Maybe<Scalars['String']>;
  /** Reserved for internal use. */
  content?: Maybe<Scalars['String']>;
  /** Reserved for internal use. */
  contentId?: Maybe<Scalars['String']>;
  /** The post's content in plain text. */
  contentText?: Maybe<Scalars['String']>;
  /**
   * Identifies whether excerpt was set by contributor.
   * True - excerpt was set by contributor.
   * False - excerpt was generated from content.
   */
  customExcerpt?: Maybe<Scalars['Boolean']>;
  /**
   * Post excerpt.
   * Can be selected by a site contributor. By default, it is extracted from the content text's first characters.
   *
   * Max: 500 characters
   */
  excerpt?: Maybe<Scalars['String']>;
  /** Whether the post is marked as featured. */
  featured?: Maybe<Scalars['Boolean']>;
  /** Date the post was first published. */
  firstPublishedDate?: Maybe<Scalars['String']>;
  /** Indicates if there is a draft post with changes that have not yet been published. */
  hasUnpublishedChanges?: Maybe<Scalars['Boolean']>;
  /** Hashtags in the post. */
  hashtags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Image placed at the top of the blog page. Only displays on mobile devices. */
  heroImage?: Maybe<WixCommonImage>;
  /** Post ID. */
  id?: Maybe<Scalars['String']>;
  /** Reserved for internal use. */
  internalCategoryIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Reserved for internal use. */
  internalId?: Maybe<Scalars['String']>;
  /** Reserved for internal use. */
  internalRelatedPostIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Identifies if post is created from template
   * Reserved for internal use.
   */
  isDemo?: Maybe<Scalars['Boolean']>;
  /**
   * Language the post is written in.
   *
   * 2-or-4-letter language code in [IETF BCP 47 language tag](https://en.wikipedia.org/wiki/IETF_language_tag) format.
   */
  language?: Maybe<Scalars['String']>;
  /** Date the post was last published. */
  lastPublishedDate?: Maybe<Scalars['String']>;
  /** Post cover media. */
  media?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogMedia>;
  /** Member ID of the post's owner. */
  memberId?: Maybe<Scalars['String']>;
  /**
   * Post metrics.
   * Deprecated on '2022-02-15', data can be inconsistent, for consistent data please use 'PostService#GetPostMetrics' API instead
   */
  metrics?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Metrics>;
  /** Estimated reading time (calculated automatically). */
  minutesToRead?: Maybe<Scalars['Int']>;
  /**
   * Post moderation details. Only relevant to posts submitted by [guest writers](https://support.wix.com/en/article/wix-blog-moderating-blog-posts-from-your-guest-writers).
   *
   * Guest writers have the ability to write posts but not publish them. These posts can be rejected or approved for publishing by a blog editor or Wix user.
   */
  moderationDetails?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ModerationDetails>;
  /** Reserved for internal use. */
  mostRecentContributorId?: Maybe<Scalars['String']>;
  /** Whether the post is pinned. If `true`, the post is placed at the top of the post list. */
  pinned?: Maybe<Scalars['Boolean']>;
  /**
   * Dynamic post count info Comment Count, Like Count, View Count.
   * @deprecated Dynamic post count info Comment Count, Like Count, View Count. Replaced by: metrics. Removal date: 2024-06-30.
   */
  postCountInfo?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PostCountInfo>;
  /**
   * Whether the returned content is a preview of premium content. Defaults to `false`.
   * A preview displays a limited number of paragraphs of paid content to non-subscribed users.
   */
  preview?: Maybe<Scalars['Boolean']>;
  /**
   * Pricing plan IDs. See the Pricing Plans API for more info.
   *
   * Only relevant if a post is assigned to a specific pricing plan.
   */
  pricingPlanIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Post reference ID. You can reference the post from other entities, for example, comments. */
  referenceId?: Maybe<Scalars['String']>;
  /** IDs of posts related to the post. */
  relatedPostIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Post rich content
   *
   * <widget src="https://apps.wix.com/_serverless/ricos-playground-services/goto/api-component" plugins="image.gallery.video.audio.divider.linkButton.html.giphy.codeBlock.file.hashtag.lineSpacing.indent.link.textColor.textHighlight.heading.verticalEmbed.table.collapsibleList.poll" exampleid="72c23a25-524f-4f70-a260-4a2777b6f5d5">
   * <a href="https://dev.wix.com/docs/ricos/api-reference/ricos-document">See Ricos document reference</a>
   * </widget>
   */
  richContent?: Maybe<WixRichContentV1RichContent>;
  /** Post rich content as compressed binary data */
  richContentCompressed?: Maybe<Array<Maybe<Scalars['Byte']>>>;
  /** Post rich content as a string. */
  richContentString?: Maybe<Scalars['String']>;
  /** SEO data. */
  seoData?: Maybe<ComWixpressAdvancedSeoSeoSchema>;
  /** Post slug. For example, `'post-slug'`. */
  slug?: Maybe<Scalars['String']>;
  /** IDs of tags the post is tagged with. See Blog Tags API for more info. */
  tagIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Post title. */
  title?: Maybe<Scalars['String']>;
  /** ID of the translations of this post. All translations of a single post share the same `translationId`. */
  translationId?: Maybe<Scalars['String']>;
  /** List of the post's translated posts. */
  translations?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PostTranslation>>>;
  /** Post URL. */
  url?: Maybe<WixCommonPageUrl>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3PostCountInfo = {
  /** Total number of post comments. */
  comments?: Maybe<Scalars['Int']>;
  /** Total number of post likes. */
  likes?: Maybe<Scalars['Int']>;
  /** Total number of post views. */
  views?: Maybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3PostCountPerMonth = {
  /** Latest firstPublishedDate in the month. */
  latestFirstPublishedDate?: Maybe<Scalars['String']>;
  /** Month in a YYYY-MM format, for example "2025-04". */
  month?: Maybe<Scalars['String']>;
  /** Number of posts published in the month. */
  posts?: Maybe<Scalars['Int']>;
};

export enum ComWixpressNpmCommunitiesPlatformizedBlogV3PostCountersUpdatedFieldField {
  /** Like count field. */
  LIKE_COUNT = 'LIKE_COUNT',
  /** Rating count field */
  RATING_COUNT = 'RATING_COUNT',
  /** Total comments field. */
  TOTAL_COMMENTS = 'TOTAL_COMMENTS',
  UNKNOWN = 'UNKNOWN',
  /** View count field. */
  VIEW_COUNT = 'VIEW_COUNT'
}

export type ComWixpressNpmCommunitiesPlatformizedBlogV3PostCountersUpdatedInput = {
  /** Visitor ID if person that liked the post is not logged in */
  anonymousVisitorId?: InputMaybe<Scalars['String']>;
  /** New counter value. */
  counter?: InputMaybe<Scalars['Int']>;
  /** Member ID of person who triggered the counter update */
  memberId?: InputMaybe<Scalars['String']>;
  /** ID of the post which counters were updated. */
  postId?: InputMaybe<Scalars['String']>;
  /** Internal ID of the post which counters were updated. */
  postInternalId?: InputMaybe<Scalars['String']>;
  /** Field of the updated counter. */
  updatedCounterField?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PostCountersUpdatedFieldField>;
};

export enum ComWixpressNpmCommunitiesPlatformizedBlogV3PostFieldField {
  /** Includes post owner's contact ID. */
  CONTACT_ID = 'CONTACT_ID',
  /**
   * Includes post content as a stringified DraftJS document.
   * Reserved for internal use.
   */
  CONTENT = 'CONTENT',
  /** Includes post content text string when present. */
  CONTENT_TEXT = 'CONTENT_TEXT',
  /** Deprecated use `METRICS` instead. */
  COUNTERS = 'COUNTERS',
  /** If provided, all content fields exclude paid content. */
  EXCLUDE_PAID_CONTENT = 'EXCLUDE_PAID_CONTENT',
  /** Needed for post proxy to work correctly. */
  HAS_UNPUBLISHED_CHANGES = 'HAS_UNPUBLISHED_CHANGES',
  /** Needed for post proxy to work correctly. */
  HEADING = 'HEADING',
  /** Needed for post proxy to work correctly. */
  IMAGE = 'IMAGE',
  /**
   * Includes internal ID field.
   * Reserved for internal use.
   */
  INTERNAL_ID = 'INTERNAL_ID',
  /** Includes post metrics when present. */
  METRICS = 'METRICS',
  /** Needed for post proxy to work correctly. */
  OWNER = 'OWNER',
  /** Includes post reference ID field. */
  REFERENCE_ID = 'REFERENCE_ID',
  /** Includes post rich content. */
  RICH_CONTENT = 'RICH_CONTENT',
  /** Includes compressed post rich content string. */
  RICH_CONTENT_COMPRESSED = 'RICH_CONTENT_COMPRESSED',
  /** Includes post rich content string. */
  RICH_CONTENT_STRING = 'RICH_CONTENT_STRING',
  /** Includes SEO data. */
  SEO = 'SEO',
  /** Needed for post proxy to work correctly. */
  SEO_DATA = 'SEO_DATA',
  /** Includes post translations. */
  TRANSLATIONS = 'TRANSLATIONS',
  UNKNOWN = 'UNKNOWN',
  /** Includes post URL when present. */
  URL = 'URL'
}

export type ComWixpressNpmCommunitiesPlatformizedBlogV3PostLikedInput = {
  /** Visitor ID of person who liked the post when they are not logged in. */
  anonymousVisitorId?: InputMaybe<Scalars['String']>;
  /** Member ID of person who liked the post (only returned when the member was logged in when liking the post). */
  memberId?: InputMaybe<Scalars['String']>;
  /** ID of the liked post. */
  postId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3PostTranslation = {
  /** Post ID. */
  id?: Maybe<Scalars['String']>;
  /** Language the post is written in. */
  language?: Maybe<Scalars['String']>;
  /** SEO data. */
  seoData?: Maybe<ComWixpressAdvancedSeoSeoSchema>;
  /**
   * Post slug.
   *
   * The slug is the end of a post's URL that refers to a specific post.
   * For example, if a post's URL is `https:/example.com/blog/post/my-post-slug`,
   * the slug is `my-post-slug`. The slug is case-sensitive.
   */
  slug?: Maybe<Scalars['String']>;
  /** Post URL. */
  url?: Maybe<WixCommonPageUrl>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3QueryCategoriesRequestInput = {
  /**
   * List of additional category fields to include in the response. By default
   * only the category’s base fields are returned. Base fields are all category fields that don't appear in the fieldset enum.
   *
   * To retrieve a field, pass the relevant fieldset in the enum in the `fieldsets` array. For example, add the `URL` fieldset to `fieldsets` to
   * retrieve the url field in the response in addition to the category’s base fields.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryFieldField>>>;
  /** Query options. */
  query?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPlatformQueryInput>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3QueryCategoriesResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Category>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3QueryPostsRequestInput = {
  /**
   * List of additional post fields to include in the response. For example, use the `URL` fieldset to retrieve the url field in
   * the response in addition to the post’s base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the post’s base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PostFieldField>>>;
  /** Query options. */
  query?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPlatformQueryInput>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3QueryPostsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Post>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3Reactions = {
  /** Is post liked by the current user */
  liked?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3UnlikePostRequestInput = {
  /**
   * List of additional post fields to include in the response. For example, use the `URL` fieldset to retrieve the url field in
   * the response in addition to the post’s base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the post’s base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PostFieldField>>>;
  /** Post ID. */
  postId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3UnlikePostResponse = {
  /** Post info. */
  post?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Post>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3UnpinPostRequestInput = {
  /**
   * List of additional post fields to include in the response. For example, use the `URL` fieldset to retrieve the url field in
   * the response in addition to the post’s base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the post’s base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PostFieldField>>>;
  /** Post ID. */
  postId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3UnpinPostResponse = {
  /** Post info. */
  post?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Post>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3UpdateCategoryRequestInput = {
  /** Category info. */
  category?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryInput>;
  /** Field mask of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * List of additional category fields to include in the response. By default
   * only the category’s base fields are returned. Base fields are all category fields that don't appear in the fieldset enum.
   *
   * To retrieve a field, pass the relevant fieldset in the enum in the `fieldsets` array. For example, add the `URL` fieldset to `fieldsets` to
   * retrieve the url field in the response in addition to the category’s base fields.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CategoryFieldField>>>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3UpdateCategoryResponse = {
  /** Category info. */
  category?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Category>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ViewPostRequestInput = {
  /** Post ID. */
  postId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogV3ViewPostResponse = {
  /** Total number of post views */
  views?: Maybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedBlogWixMedia = {
  /** Image details. */
  image?: Maybe<WixCommonImage>;
  /** Video details. */
  videoV2?: Maybe<WixCommonVideoV2>;
};

export type ComWixpressNpmCommunitiesPlatformizedUpstreamTagCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedUpstreamTagPagingInput = {
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the current sort order. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonCursors = {
  /** Cursor pointing to next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export type ComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPagingInput = {
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the current sort order. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPagingMetadataV2 = {
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Cursors to navigate through the result pages using `next` and `prev`. Returned if cursor paging is used. */
  cursors?: Maybe<ComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonCursors>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
  /** Offset that was requested. */
  offset?: Maybe<Scalars['Int']>;
  /** Flag that indicates the server failed to calculate the `total` field. */
  tooManyToCount?: Maybe<Scalars['Boolean']>;
  /** Total number of items that match the query. Returned if offset paging is used and the `tooManyToCount` flag is not set. */
  total?: Maybe<Scalars['Int']>;
};

export type ComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPlatformQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Paging options to limit and skip the number of items. */
  paging?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedUpstreamWixCommonPagingInput>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type ComWixpressPortfolioCollectionsCollection = {
  /** Collection's cover photo */
  coverImage?: Maybe<ComWixpressPortfolioCommonImage>;
  /** Represents the time this Collection was created */
  createdDate?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** Indicates if the collection is hidden from Portfolio */
  hidden?: Maybe<Scalars['Boolean']>;
  /** Collection ID */
  id?: Maybe<Scalars['String']>;
  projectVirtualReference?: Maybe<Array<Maybe<ComWixpressPortfolioProjectsProject>>>;
  /** Represents the current state of an item. Each time the item is modified, its `revision` changes. for an update operation to succeed, you MUST pass the latest revision */
  revision?: Maybe<Scalars['Int']>;
  seoData?: Maybe<ComWixpressAdvancedSeoSeoSchema>;
  /** Url of Collection */
  slug?: Maybe<Scalars['String']>;
  /** if not present in an update it means the collection will be added as currentTimestamp - as the last collection */
  sortOrder?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
  /** Represents the time this Collection was last updated */
  updatedDate?: Maybe<Scalars['String']>;
  /** Url and relative url of Collection - in order to receive this field in READ requests you will need to pass the `include_page_url` field as part of request */
  url?: Maybe<WixCommonPageUrlV2>;
};

export type ComWixpressPortfolioCollectionsCollectionInput = {
  /** Collection's cover photo */
  coverImage?: InputMaybe<ComWixpressPortfolioCommonImageInput>;
  /** Represents the time this Collection was created */
  createdDate?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  /** Indicates if the collection is hidden from Portfolio */
  hidden?: InputMaybe<Scalars['Boolean']>;
  /** Collection ID */
  id?: InputMaybe<Scalars['String']>;
  /** Represents the current state of an item. Each time the item is modified, its `revision` changes. for an update operation to succeed, you MUST pass the latest revision */
  revision?: InputMaybe<Scalars['Int']>;
  seoData?: InputMaybe<ComWixpressAdvancedSeoSeoSchemaInput>;
  /** Url of Collection */
  slug?: InputMaybe<Scalars['String']>;
  /** if not present in an update it means the collection will be added as currentTimestamp - as the last collection */
  sortOrder?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
  /** Represents the time this Collection was last updated */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** Url and relative url of Collection - in order to receive this field in READ requests you will need to pass the `include_page_url` field as part of request */
  url?: InputMaybe<WixCommonPageUrlV2Input>;
};

export type ComWixpressPortfolioCollectionsCreateCollectionRequestInput = {
  /** Collection to be created */
  collection?: InputMaybe<ComWixpressPortfolioCollectionsCollectionInput>;
};

export type ComWixpressPortfolioCollectionsCreateCollectionResponse = {
  /** The created Collection */
  collection?: Maybe<ComWixpressPortfolioCollectionsCollection>;
};

export type ComWixpressPortfolioCollectionsDeleteCollectionRequestInput = {
  /** Id of the Collection to delete */
  collectionId?: InputMaybe<Scalars['String']>;
  /** The revision of the Collection */
  revision?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressPortfolioCollectionsDeleteCollectionResponse = {
  /** Id of the Deleted Collection */
  collectionId?: Maybe<Scalars['String']>;
};

export type ComWixpressPortfolioCollectionsListCollectionsRequestInput = {
  includePageUrl?: InputMaybe<Scalars['Boolean']>;
  /** Maximum limit per response is 100, in first request cursor is None */
  paging?: InputMaybe<WixCommonCursorPagingInput>;
};

export type ComWixpressPortfolioCollectionsListCollectionsResponse = {
  /** Retrieved Collections */
  collections?: Maybe<Array<Maybe<ComWixpressPortfolioCollectionsCollection>>>;
  /** Paging metadata */
  metadata?: Maybe<WixCommonPagingMetadataV2>;
  /** Paging metadata */
  pagingMetadataV2?: Maybe<WixCommonPagingMetadataV2>;
};

export type ComWixpressPortfolioCollectionsQueryCollectionsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressPortfolioCollectionsCollection>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressPortfolioCollectionsUpdateCollectionRequestInput = {
  /** Collection to be updated, may be partial */
  collection?: InputMaybe<ComWixpressPortfolioCollectionsCollectionInput>;
  /** Explicit list of fields to update */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressPortfolioCollectionsUpdateCollectionResponse = {
  /** The updated Collection */
  collection?: Maybe<ComWixpressPortfolioCollectionsCollection>;
};

export type ComWixpressPortfolioCommonImage = {
  /** Set of key-value pairs describing the media in [Exchangeable Image File format](https://en.wikipedia.org/wiki/Exif). */
  exif?: Maybe<Scalars['JSON']>;
  /** Focal point of the image. */
  focalPoint?: Maybe<ComWixpressPortfolioCommonPoint>;
  /** Image info - Wix Media Image. */
  imageInfo?: Maybe<UpstreamWixCommonPortfolioCommonImage>;
  /**
   * Image compression level. <br />
   *
   * Min: `30` <br />
   * Max: `100`
   */
  quality?: Maybe<Scalars['Int']>;
  /** Whether the image is saved in secure media. */
  secure?: Maybe<Scalars['Boolean']>;
  /** When image is saved in secure media, token is generated. */
  token?: Maybe<Scalars['String']>;
  type?: Maybe<ComWixpressPortfolioCommonImageImageType>;
  /** [Unsharp masking](https://en.wikipedia.org/wiki/Unsharp_masking) values of the image. */
  unsharpMasking?: Maybe<ComWixpressPortfolioCommonUnsharpMasking>;
};

export enum ComWixpressPortfolioCommonImageImageType {
  EXTERNAL = 'EXTERNAL',
  UNDEFINED = 'UNDEFINED',
  WIX_MEDIA = 'WIX_MEDIA'
}

export type ComWixpressPortfolioCommonImageInput = {
  /** Set of key-value pairs describing the media in [Exchangeable Image File format](https://en.wikipedia.org/wiki/Exif). */
  exif?: InputMaybe<Scalars['JSON']>;
  /** Focal point of the image. */
  focalPoint?: InputMaybe<ComWixpressPortfolioCommonPointInput>;
  /** Image info - Wix Media Image. */
  imageInfo?: InputMaybe<UpstreamWixCommonPortfolioCommonImageInput>;
  /**
   * Image compression level. <br />
   *
   * Min: `30` <br />
   * Max: `100`
   */
  quality?: InputMaybe<Scalars['Int']>;
  /** Whether the image is saved in secure media. */
  secure?: InputMaybe<Scalars['Boolean']>;
  /** When image is saved in secure media, token is generated. */
  token?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ComWixpressPortfolioCommonImageImageType>;
  /** [Unsharp masking](https://en.wikipedia.org/wiki/Unsharp_masking) values of the image. */
  unsharpMasking?: InputMaybe<ComWixpressPortfolioCommonUnsharpMaskingInput>;
};

export type ComWixpressPortfolioCommonPoint = {
  /** X-coordinate of the focal point. */
  x?: Maybe<Scalars['Float']>;
  /** Y-coordinate of the focal point. */
  y?: Maybe<Scalars['Float']>;
};

export type ComWixpressPortfolioCommonPointInput = {
  /** X-coordinate of the focal point. */
  x?: InputMaybe<Scalars['Float']>;
  /** Y-coordinate of the focal point. */
  y?: InputMaybe<Scalars['Float']>;
};

export type ComWixpressPortfolioCommonUnsharpMasking = {
  /**
   * Unsharp masking amount. Controls the sharpening strength. <br />
   *
   * Min: `0` <br />
   * Max: `5`
   */
  amount?: Maybe<Scalars['Float']>;
  /** Unsharp masking radius in pixels. Controls the sharpening width. */
  radius?: Maybe<Scalars['Float']>;
  /**
   * Unsharp masking threshold. Controls how different neighboring pixels must be for shapening to apply. <br />
   *
   * Min: `0` <br />
   * Max: `1`
   */
  threshold?: Maybe<Scalars['Float']>;
};

export type ComWixpressPortfolioCommonUnsharpMaskingInput = {
  /**
   * Unsharp masking amount. Controls the sharpening strength. <br />
   *
   * Min: `0` <br />
   * Max: `5`
   */
  amount?: InputMaybe<Scalars['Float']>;
  /** Unsharp masking radius in pixels. Controls the sharpening width. */
  radius?: InputMaybe<Scalars['Float']>;
  /**
   * Unsharp masking threshold. Controls how different neighboring pixels must be for shapening to apply. <br />
   *
   * Min: `0` <br />
   * Max: `1`
   */
  threshold?: InputMaybe<Scalars['Float']>;
};

export type ComWixpressPortfolioCommonVideo = {
  /** Manually defined Video duration in milliseconds. */
  durationInMillis?: Maybe<Scalars['Int']>;
  /** Video info - Wix Media Image. */
  videoInfo?: Maybe<UpstreamWixCommonPortfolioCommonVideoV2>;
};

export type ComWixpressPortfolioCommonVideoInput = {
  /** Manually defined Video duration in milliseconds. */
  durationInMillis?: InputMaybe<Scalars['Int']>;
  /** Video info - Wix Media Image. */
  videoInfo?: InputMaybe<UpstreamWixCommonPortfolioCommonVideoV2Input>;
};

export type ComWixpressPortfolioPortfolioappAdminRemoveMenuItemsResponse = {
  /** number of items queried for deletion */
  numItems?: Maybe<Scalars['Int']>;
  /** number of items sucessfully deleted */
  numItemsSuccessfullyDeleted?: Maybe<Scalars['Int']>;
};

export type ComWixpressPortfolioPortfolioappGenerateTokenForProjectItemsRequestInput = {
  /** Media ids of requested project items */
  mediaIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressPortfolioPortfolioappGenerateTokenForProjectItemsResponse = {
  mediaTokens?: Maybe<Array<Maybe<ComWixpressPortfolioPortfolioappProjectItemMediaToken>>>;
};

export type ComWixpressPortfolioPortfolioappGetProjectPageDataRequestInput = {
  /** Slug of the project's current collection */
  collectionSlug?: InputMaybe<Scalars['String']>;
  /** Project's slug */
  projectSlug?: InputMaybe<Scalars['String']>;
};

export type ComWixpressPortfolioPortfolioappGetProjectPageDataResponse = {
  nextProject?: Maybe<ComWixpressPortfolioPortfolioappProjectSlug>;
  previousProject?: Maybe<ComWixpressPortfolioPortfolioappProjectSlug>;
  project?: Maybe<ComWixpressPortfolioProjectsProject>;
};

export type ComWixpressPortfolioPortfolioappProjectItemMediaToken = {
  /** Media id of project item */
  mediaId?: Maybe<Scalars['String']>;
  /** Generated media token for project item */
  mediaToken?: Maybe<Scalars['String']>;
};

export type ComWixpressPortfolioPortfolioappProjectSlug = {
  /** Project id */
  projectId?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectitemsBulkCreateProjectItemResult = {
  item?: Maybe<ComWixpressPortfolioProjectitemsItem>;
  /** Holds information about an item in bulk create - id, index in original request array, action successful, error (if failed) */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressPortfolioProjectitemsBulkCreateProjectItemsRequestInput = {
  /** items to be created. */
  items?: InputMaybe<Array<InputMaybe<ComWixpressPortfolioProjectitemsItemInput>>>;
  /**
   * Id of the Project the items are part of
   * Project must exist before adding items to it. project can be created/updated/deleted using this //TODO
   */
  projectId?: InputMaybe<Scalars['String']>;
  returnFullEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressPortfolioProjectitemsBulkCreateProjectItemsResponse = {
  /** Holds metadata of the entire bulk create operation */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Id of the Project the item is part of */
  projectId?: Maybe<Scalars['String']>;
  /** Array with all created items results. */
  results?: Maybe<Array<Maybe<ComWixpressPortfolioProjectitemsBulkCreateProjectItemResult>>>;
};

export type ComWixpressPortfolioProjectitemsBulkDeleteProjectItemResult = {
  /** Id of the ProjectItem */
  itemId?: Maybe<Scalars['String']>;
  /** Holds information about an item in bulk delete - id, index in original request array, action successful, error (if failed) */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressPortfolioProjectitemsBulkDeleteProjectItemsRequestInput = {
  /** Ids of the items to be deleted */
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Id of the project */
  projectId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectitemsBulkDeleteProjectItemsResponse = {
  /** Holds metadata of the entire bulk delete operation */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Id of the Project the item is part of */
  projectId?: Maybe<Scalars['String']>;
  /** Array with all deleted items results */
  results?: Maybe<Array<Maybe<ComWixpressPortfolioProjectitemsBulkDeleteProjectItemResult>>>;
};

export type ComWixpressPortfolioProjectitemsBulkUpdateProjectItemResult = {
  item?: Maybe<ComWixpressPortfolioProjectitemsItem>;
  /** Holds information about an item in bulk update - id, index in original request array, action successful, error (if failed). */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressPortfolioProjectitemsBulkUpdateProjectItemsRequestInput = {
  /** items to be updated. */
  items?: InputMaybe<Array<InputMaybe<ComWixpressPortfolioProjectitemsMaskedItemInput>>>;
  /** Id of the Project the items are part of */
  projectId?: InputMaybe<Scalars['String']>;
  returnFullEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressPortfolioProjectitemsBulkUpdateProjectItemsResponse = {
  /** Holds metadata of the entire bulk update operation */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Id of the Project the item is part of */
  projectId?: Maybe<Scalars['String']>;
  /** Array with all updated items results. */
  results?: Maybe<Array<Maybe<ComWixpressPortfolioProjectitemsBulkUpdateProjectItemResult>>>;
};

export type ComWixpressPortfolioProjectitemsCreateProjectGalleryRequestInput = {
  /** Id of Project to create */
  projectId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectitemsCreateProjectGalleryResponse = {
  /** Id of created gallery */
  galleryId?: Maybe<Scalars['String']>;
  /** Id of created Project */
  projectId?: Maybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectitemsCreateProjectItemRequestInput = {
  /** Item to be created */
  item?: InputMaybe<ComWixpressPortfolioProjectitemsItemInput>;
};

export type ComWixpressPortfolioProjectitemsCreateProjectItemResponse = {
  /** The created item */
  item?: Maybe<ComWixpressPortfolioProjectitemsItem>;
  projectId?: Maybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectitemsDeleteProjectItemRequestInput = {
  /** Id of the Item to delete */
  itemId?: InputMaybe<Scalars['String']>;
  /** Id of the Project the item is part of */
  projectId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectitemsDeleteProjectItemResponse = {
  /** Id of deleted item */
  itemId?: Maybe<Scalars['String']>;
  /** Id of the Project the item is part of */
  projectId?: Maybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectitemsDuplicateProjectItemsRequestInput = {
  /** Id of Project to duplicate */
  originProjectId?: InputMaybe<Scalars['String']>;
  /** Target project ID to duplicate to (same instance as request) */
  targetProjectId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectitemsDuplicateProjectItemsResponse = {
  /** Result metadata */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Id of target project */
  projectId?: Maybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectitemsItem = {
  /** Date and time the item was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Item description. */
  description?: Maybe<Scalars['String']>;
  /** Item ID. */
  id?: Maybe<Scalars['String']>;
  /** Information about the image. */
  image?: Maybe<ComWixpressPortfolioCommonImage>;
  /** Link from the item. */
  link?: Maybe<ComWixpressPortfolioProjectitemsLink>;
  /**
   * Id of the Project the items are part of
   * Project must exist before adding items to it. project can be created/updated/deleted using this //TODO
   */
  project?: Maybe<ComWixpressPortfolioProjectsProject>;
  /**
   * Id of the Project the items are part of
   * Project must exist before adding items to it. project can be created/updated/deleted using this //TODO
   */
  projectId?: Maybe<Scalars['String']>;
  /**
   * Index that determines which position a media item is displayed in the gallery. <br />
   *
   * Default: [Epoch](https://www.epoch101.com/) timestamp. <br /> //TODO: decide if needed, what happens if user add an item without sortOrder? do we give it the default timestamp? if not, does sorting by sortOrder will work when no sortOrder?
   */
  sortOrder?: Maybe<Scalars['Float']>;
  /** Item tags. */
  tags?: Maybe<ComWixpressPortfolioProjectitemsTags>;
  /** Item title. */
  title?: Maybe<Scalars['String']>;
  /**
   * Item data type. One of:
   * <br />
   * +`"IMAGE"`
   * <br />
   * +`"VIDEO"`
   */
  type?: Maybe<ComWixpressPortfolioProjectitemsItemType>;
  /** Date and time the item was last updated. */
  updatedDate?: Maybe<Scalars['String']>;
  /** Information about the video. */
  video?: Maybe<ComWixpressPortfolioCommonVideo>;
};

export type ComWixpressPortfolioProjectitemsItemInput = {
  /** Date and time the item was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Item description. */
  description?: InputMaybe<Scalars['String']>;
  /** Item ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Information about the image. */
  image?: InputMaybe<ComWixpressPortfolioCommonImageInput>;
  /** Link from the item. */
  link?: InputMaybe<ComWixpressPortfolioProjectitemsLinkInput>;
  /**
   * Id of the Project the items are part of
   * Project must exist before adding items to it. project can be created/updated/deleted using this //TODO
   */
  projectId?: InputMaybe<Scalars['String']>;
  /**
   * Index that determines which position a media item is displayed in the gallery. <br />
   *
   * Default: [Epoch](https://www.epoch101.com/) timestamp. <br /> //TODO: decide if needed, what happens if user add an item without sortOrder? do we give it the default timestamp? if not, does sorting by sortOrder will work when no sortOrder?
   */
  sortOrder?: InputMaybe<Scalars['Float']>;
  /** Item tags. */
  tags?: InputMaybe<ComWixpressPortfolioProjectitemsTagsInput>;
  /** Item title. */
  title?: InputMaybe<Scalars['String']>;
  /**
   * Item data type. One of:
   * <br />
   * +`"IMAGE"`
   * <br />
   * +`"VIDEO"`
   */
  type?: InputMaybe<ComWixpressPortfolioProjectitemsItemType>;
  /** Date and time the item was last updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** Information about the video. */
  video?: InputMaybe<ComWixpressPortfolioCommonVideoInput>;
};

export enum ComWixpressPortfolioProjectitemsItemType {
  IMAGE = 'IMAGE',
  UNDEFINED = 'UNDEFINED',
  VIDEO = 'VIDEO'
}

export type ComWixpressPortfolioProjectitemsLink = {
  /**
   * Whether the link opens in a new tab or window. One of:
   * * `'_blank'`: The link opens in a new tab or window.
   * * `'_self'`: The link opens in the same tab or window.
   */
  target?: Maybe<Scalars['String']>;
  /** Display text of the link. */
  text?: Maybe<Scalars['String']>;
  /** Target URL of the link. */
  url?: Maybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectitemsLinkInput = {
  /**
   * Whether the link opens in a new tab or window. One of:
   * * `'_blank'`: The link opens in a new tab or window.
   * * `'_self'`: The link opens in the same tab or window.
   */
  target?: InputMaybe<Scalars['String']>;
  /** Display text of the link. */
  text?: InputMaybe<Scalars['String']>;
  /** Target URL of the link. */
  url?: InputMaybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectitemsListProjectItemsRequestInput = {
  /** limit and offset for ProjectItems - maximum limit is 200 per request, default is 50 */
  paging?: InputMaybe<WixCommonPagingInput>;
  /** Id of the Project the item is part of */
  projectId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectitemsListProjectItemsResponse = {
  /** ProjectItems retrieved */
  items?: Maybe<Array<Maybe<ComWixpressPortfolioProjectitemsItem>>>;
  /** Paging metadata */
  metadata?: Maybe<WixCommonPagingMetadataV2>;
  /** Paging metadata */
  pagingMetadataV2?: Maybe<WixCommonPagingMetadataV2>;
  /** Id of the Project the item is part of */
  projectId?: Maybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectitemsMaskedItemInput = {
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  item?: InputMaybe<ComWixpressPortfolioProjectitemsItemInput>;
};

export type ComWixpressPortfolioProjectitemsQueryProjectItemsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressPortfolioProjectitemsItem>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressPortfolioProjectitemsTags = {
  /** List of tags assigned to the media item. */
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixpressPortfolioProjectitemsTagsInput = {
  /** List of tags assigned to the media item. */
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressPortfolioProjectitemsUpdateProjectItemRequestInput = {
  /** ProjectItem to be updated, may be partial */
  item?: InputMaybe<ComWixpressPortfolioProjectitemsItemInput>;
  /** Explicit list of fields to update */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressPortfolioProjectitemsUpdateProjectItemResponse = {
  /** The updated ProjectItem */
  item?: Maybe<ComWixpressPortfolioProjectitemsItem>;
  /** Id of the Project the item is part of */
  projectId?: Maybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectsCreateProjectRequestInput = {
  /** Project to be created */
  project?: InputMaybe<ComWixpressPortfolioProjectsProjectInput>;
};

export type ComWixpressPortfolioProjectsCreateProjectResponse = {
  /** The created Project */
  project?: Maybe<ComWixpressPortfolioProjectsProject>;
};

export type ComWixpressPortfolioProjectsDeleteProjectRequestInput = {
  /** Id of the Project to delete */
  projectId?: InputMaybe<Scalars['String']>;
  /** The revision of the Project */
  revision?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressPortfolioProjectsDeleteProjectResponse = {
  /** Id of the deleted Project */
  projectId?: Maybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectsDetailsLink = {
  /**
   * Whether the link opens in a new tab or window. One of:
   * * `'_blank'`: The link opens in a new tab or window.
   * * `'_self'`: The link opens in the same tab or window.
   */
  target?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  /** link to external source */
  url?: Maybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectsDetailsLinkInput = {
  /**
   * Whether the link opens in a new tab or window. One of:
   * * `'_blank'`: The link opens in a new tab or window.
   * * `'_self'`: The link opens in the same tab or window.
   */
  target?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  /** link to external source */
  url?: InputMaybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectsListProjectsRequestInput = {
  includePageUrl?: InputMaybe<Scalars['Boolean']>;
  /** Projects limit per response is maximum 100, In the first request the cursor is None */
  paging?: InputMaybe<WixCommonCursorPagingInput>;
};

export type ComWixpressPortfolioProjectsListProjectsResponse = {
  /** Paging metadata */
  metadata?: Maybe<WixCommonPagingMetadataV2>;
  /** Paging metadata */
  pagingMetadataV2?: Maybe<WixCommonPagingMetadataV2>;
  /** The retrieved Projects */
  projects?: Maybe<Array<Maybe<ComWixpressPortfolioProjectsProject>>>;
};

export type ComWixpressPortfolioProjectsProject = {
  /** Collections must exist to be added to a project. can be created/updated/deleted using this //TODO */
  collectionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Collections must exist to be added to a project. can be created/updated/deleted using this //TODO */
  collections?: Maybe<Array<Maybe<ComWixpressPortfolioCollectionsCollection>>>;
  /** project's cover photo */
  coverImage?: Maybe<ComWixpressPortfolioCommonImage>;
  /** project's cover video */
  coverVideo?: Maybe<ComWixpressPortfolioCommonVideo>;
  /** Represents the time this Project was created */
  createdDate?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** Custom project details */
  details?: Maybe<Array<Maybe<ComWixpressPortfolioProjectsProjectDetail>>>;
  /** indicates if the project should be hidden from Portfolio */
  hidden?: Maybe<Scalars['Boolean']>;
  /** Project ID */
  id?: Maybe<Scalars['String']>;
  itemsVirtualReference?: Maybe<Array<Maybe<ComWixpressPortfolioProjectitemsItem>>>;
  /** Represents the current state of an item. Each time the item is modified, its `revision` changes. for an update operation to succeed, you MUST pass the latest revision */
  revision?: Maybe<Scalars['Int']>;
  seoData?: Maybe<ComWixpressAdvancedSeoSeoSchema>;
  slug?: Maybe<Scalars['String']>;
  /** project source - When project is synced from external platform, this field will represent the app & source the projects synced from. */
  source?: Maybe<ComWixpressPortfolioProjectsProjectSource>;
  /** indicates if the project is synced from external platform (via integration page) and therefore will be updated from the external platform on daily basis */
  syncedProject?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  /** Represents the time this Project was last updated */
  updatedDate?: Maybe<Scalars['String']>;
  /** Url and relative url of Project - in order to receive this field in READ requests you will need to pass the `include_page_url` field as part of request */
  url?: Maybe<WixCommonPageUrlV2>;
};


export type ComWixpressPortfolioProjectsProjectCollectionsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<WixCommonQueryV2Input>;
};

export type ComWixpressPortfolioProjectsProjectDetail = {
  label?: Maybe<Scalars['String']>;
  link?: Maybe<ComWixpressPortfolioProjectsDetailsLink>;
  text?: Maybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectsProjectDetailInput = {
  label?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<ComWixpressPortfolioProjectsDetailsLinkInput>;
  text?: InputMaybe<Scalars['String']>;
};

export type ComWixpressPortfolioProjectsProjectInCollection = {
  /** Collection ID */
  collectionId?: Maybe<Scalars['String']>;
  /** Project */
  project?: Maybe<ComWixpressPortfolioProjectsProject>;
  /** The sort order of the project in the given Collection */
  sortOrder?: Maybe<Scalars['Float']>;
};

export type ComWixpressPortfolioProjectsProjectInput = {
  /** Collections must exist to be added to a project. can be created/updated/deleted using this //TODO */
  collectionIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** project's cover photo */
  coverImage?: InputMaybe<ComWixpressPortfolioCommonImageInput>;
  /** project's cover video */
  coverVideo?: InputMaybe<ComWixpressPortfolioCommonVideoInput>;
  /** Represents the time this Project was created */
  createdDate?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  /** Custom project details */
  details?: InputMaybe<Array<InputMaybe<ComWixpressPortfolioProjectsProjectDetailInput>>>;
  /** indicates if the project should be hidden from Portfolio */
  hidden?: InputMaybe<Scalars['Boolean']>;
  /** Project ID */
  id?: InputMaybe<Scalars['String']>;
  /** Represents the current state of an item. Each time the item is modified, its `revision` changes. for an update operation to succeed, you MUST pass the latest revision */
  revision?: InputMaybe<Scalars['Int']>;
  seoData?: InputMaybe<ComWixpressAdvancedSeoSeoSchemaInput>;
  slug?: InputMaybe<Scalars['String']>;
  /** project source - When project is synced from external platform, this field will represent the app & source the projects synced from. */
  source?: InputMaybe<ComWixpressPortfolioProjectsProjectSourceInput>;
  /** indicates if the project is synced from external platform (via integration page) and therefore will be updated from the external platform on daily basis */
  syncedProject?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  /** Represents the time this Project was last updated */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** Url and relative url of Project - in order to receive this field in READ requests you will need to pass the `include_page_url` field as part of request */
  url?: InputMaybe<WixCommonPageUrlV2Input>;
};

export type ComWixpressPortfolioProjectsProjectSource = {
  appDefId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  /** last date the project was synced */
  lastSync?: Maybe<Scalars['String']>;
  /** link to external source */
  link?: Maybe<Scalars['String']>;
  /** fields that are synced from external source, should be blocked to update in UI */
  notEditableFields?: Maybe<Array<Maybe<Scalars['String']>>>;
  sourceName?: Maybe<Scalars['String']>;
  syncStatus?: Maybe<ComWixpressPortfolioProjectsProjectSourceSyncStatus>;
};

export type ComWixpressPortfolioProjectsProjectSourceInput = {
  appDefId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  /** last date the project was synced */
  lastSync?: InputMaybe<Scalars['String']>;
  /** link to external source */
  link?: InputMaybe<Scalars['String']>;
  /** fields that are synced from external source, should be blocked to update in UI */
  notEditableFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceName?: InputMaybe<Scalars['String']>;
  syncStatus?: InputMaybe<ComWixpressPortfolioProjectsProjectSourceSyncStatus>;
};

export enum ComWixpressPortfolioProjectsProjectSourceSyncStatus {
  NOT_SYNCED = 'NOT_SYNCED',
  SYNCED = 'SYNCED',
  SYNCING = 'SYNCING'
}

export type ComWixpressPortfolioProjectsQueryProjectWithCollectionInfoRequestInput = {
  includePageUrl?: InputMaybe<Scalars['Boolean']>;
  /** WQL expression */
  query?: InputMaybe<WixCommonQueryV2Input>;
};

export type ComWixpressPortfolioProjectsQueryProjectWithCollectionInfoResponse = {
  /** Paging metadata */
  metadata?: Maybe<WixCommonPagingMetadataV2>;
  /** Paging metadata */
  pagingMetadataV2?: Maybe<WixCommonPagingMetadataV2>;
  /** The retrieved Projects in Collection */
  projects?: Maybe<Array<Maybe<ComWixpressPortfolioProjectsProjectInCollection>>>;
};

export type ComWixpressPortfolioProjectsQueryProjectsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressPortfolioProjectsProject>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressPortfolioProjectsUpdateProjectOrderInCollectionRequestInput = {
  /** Id of the collection in which the project will be re-ordered */
  collectionId?: InputMaybe<Scalars['String']>;
  /** Id of the Project to update its order */
  projectId?: InputMaybe<Scalars['String']>;
  /** The new sort order of the project in the given collection */
  sortOrder?: InputMaybe<Scalars['Float']>;
};

export type ComWixpressPortfolioProjectsUpdateProjectOrderInCollectionResponse = {
  project?: Maybe<ComWixpressPortfolioProjectsProjectInCollection>;
  /** project with new sort order set */
  projectInCollection?: Maybe<ComWixpressPortfolioProjectsProjectInCollection>;
};

export type ComWixpressPortfolioProjectsUpdateProjectRequestInput = {
  /** Explicit list of fields to update */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Project to be updated, may be partial */
  project?: InputMaybe<ComWixpressPortfolioProjectsProjectInput>;
};

export type ComWixpressPortfolioProjectsUpdateProjectResponse = {
  /** The updated Project */
  project?: Maybe<ComWixpressPortfolioProjectsProject>;
};

export enum ComWixpressPremiumDomainsNotificationsCrudType {
  CREATE = 'CREATE',
  /** Unfortunately this action is used by hibernate save in wix-war */
  CREATE_OR_UPDATE = 'CREATE_OR_UPDATE',
  DELETE = 'DELETE',
  INVALID_CRUD_TYPE = 'INVALID_CRUD_TYPE',
  UPDATE = 'UPDATE'
}

export type ComWixpressPremiumDomainsNotificationsUserDomainInfoChangedEventInput = {
  changeTime?: InputMaybe<Scalars['String']>;
  crudType?: InputMaybe<ComWixpressPremiumDomainsNotificationsCrudType>;
  domainName?: InputMaybe<Scalars['String']>;
  metaSiteId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressQuotesAddressDescriptionInput = {
  content?: InputMaybe<Scalars['String']>;
  placement?: InputMaybe<ComWixpressQuotesAddressDescriptionPlacement>;
};

export enum ComWixpressQuotesAddressDescriptionPlacement {
  After = 'After',
  Before = 'Before',
  Replace = 'Replace',
  Unknown = 'Unknown'
}

export type ComWixpressQuotesAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<ComWixpressQuotesAddressDescriptionInput>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type ComWixpressQuotesApiEventsInvoicePaidEventInput = {
  data?: InputMaybe<ComWixpressQuotesInvoicesInvoiceFieldsInput>;
  id?: InputMaybe<ComWixpressQuotesIdAndVersionInput>;
  status?: InputMaybe<ComWixpressQuotesInvoicesInvoiceStatus>;
};

export type ComWixpressQuotesApiEventsInvoiceSentEventInput = {
  data?: InputMaybe<ComWixpressQuotesInvoicesInvoiceFieldsInput>;
  id?: InputMaybe<ComWixpressQuotesIdAndVersionInput>;
  status?: InputMaybe<ComWixpressQuotesInvoicesInvoiceStatus>;
};

export type ComWixpressQuotesBigDecimalWrapperInput = {
  serializedValue?: InputMaybe<Scalars['Float']>;
};

export type ComWixpressQuotesCalculatedTaxInput = {
  code?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  rate?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
  /** the costs on which the taxes are applied */
  taxable?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
  /** the taxes as a result of the */
  taxed?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
};

export type ComWixpressQuotesCalculatedTaxesInput = {
  /** consider calculated or not - cannot enforce set */
  taxes?: InputMaybe<Array<InputMaybe<ComWixpressQuotesCalculatedTaxInput>>>;
};

export type ComWixpressQuotesCompanyInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type ComWixpressQuotesCustomerInput = {
  address?: InputMaybe<ComWixpressQuotesAddressInput>;
  billingAddress?: InputMaybe<WixCommonAddressInput>;
  company?: InputMaybe<ComWixpressQuotesCompanyInput>;
  contactId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<ComWixpressQuotesEmailInput>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<ComWixpressQuotesPhoneInput>;
  shippingAddress?: InputMaybe<WixCommonAddressInput>;
};

export type ComWixpressQuotesDiscountInput = {
  /** Discount as fixed value. Currently only for internal use. */
  fixed?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
  /** Discount as percentage value. */
  percentage?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
};

export type ComWixpressQuotesEmailInput = {
  address?: InputMaybe<Scalars['String']>;
};

export type ComWixpressQuotesIdAndVersionInput = {
  id?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

export enum ComWixpressQuotesInvoicesDepositDepositType {
  FLAT = 'FLAT',
  PERCENTAGE = 'PERCENTAGE',
  UNKNOWN = 'UNKNOWN'
}

export type ComWixpressQuotesInvoicesDepositInput = {
  /** The flat amount of the deposit. The flat amount of the deposit must be less than the invoice total. */
  flatAmount?: InputMaybe<Scalars['String']>;
  /**
   * The read-only percentage value of the deposit.
   * It is computed according to the flat_amount and the invoice total and is rounded to 2 digits precision.
   */
  percentage?: InputMaybe<Scalars['String']>;
  /** The type of the deposit. The default is FLAT. */
  type?: InputMaybe<ComWixpressQuotesInvoicesDepositDepositType>;
};

export type ComWixpressQuotesInvoicesInvoiceDatesInput = {
  /** use UTC midnight date to set the due date according to the site time zone */
  dueDate?: InputMaybe<Scalars['String']>;
  /** use UTC midnight date to set the issue date according to the site time zone */
  issueDate?: InputMaybe<Scalars['String']>;
  /** ignored in request use in response to get the site time zone */
  lastSeenDate?: InputMaybe<Scalars['String']>;
  /** <a href="http://joda-time.sourceforge.net/timezones.html">Valid time zones</a> */
  timeZoneCode?: InputMaybe<Scalars['String']>;
};

export type ComWixpressQuotesInvoicesInvoiceDynamicPriceTotalsInput = {
  balance?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
  paidAmount?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
};

export type ComWixpressQuotesInvoicesInvoiceFieldsInput = {
  /** Not used */
  createOrder?: InputMaybe<Scalars['Boolean']>;
  /** Not used */
  creationAdditional_BIInformation?: InputMaybe<Scalars['String']>;
  /** The invoice 3-letter currency code in [ISO-4217 alphabetic](https://www.iso.org/iso-4217-currency-codes.html) format. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Invoice custom fields */
  customFields?: InputMaybe<Array<InputMaybe<ComWixpressCrmFinancialCommonApiV1CustomFieldValueInput>>>;
  /** The invoice customer. The customer must be a contact of the site, with an email. */
  customer?: InputMaybe<ComWixpressQuotesCustomerInput>;
  /**
   * Invoice dates: issue date and due date are mandatory and provided when the invoice is created.
   * Last seen date is the optional date when the invoice was last seen be UoU.
   */
  dates?: InputMaybe<ComWixpressQuotesInvoicesInvoiceDatesInput>;
  /**
   * Deduct taxes from line items.
   * Used in cases where line items already include taxes.
   */
  deductTaxes?: InputMaybe<Scalars['Boolean']>;
  /** The optional deposit of the invoice */
  deposit?: InputMaybe<ComWixpressQuotesInvoicesDepositInput>;
  /** Not used */
  designTemplateId?: InputMaybe<Scalars['String']>;
  /** An optional discount on the invoice. */
  discount?: InputMaybe<ComWixpressQuotesDiscountInput>;
  /**
   * The balance and amount paid on the invoice.
   * This read-only field is calculated based on the invoice totals and payments.
   */
  dynamicTotals?: InputMaybe<ComWixpressQuotesInvoicesInvoiceDynamicPriceTotalsInput>;
  /** Associated checkout for this invoice */
  ecomCheckoutId?: InputMaybe<Scalars['String']>;
  /**
   * Line items containing the details of the products or services relevant to the invoice, with their name, prices,
   * and quantity. There must be at least one line item on the invoice.
   */
  lineItems?: InputMaybe<ComWixpressQuotesLineItemsInput>;
  /**
   * Locale of the invoice, containing the language.
   * This field is not mandatory but is used for display purposes, to determine the appearance of numbers and dates
   * on the invoice.
   */
  locale?: InputMaybe<ComWixpressQuotesLocaleInput>;
  /** Invoice metadata */
  metaData?: InputMaybe<ComWixpressQuotesMetaDataInput>;
  /** The invoice number allocated the invoice by the server. The number is limited to at most 11 digits. */
  number?: InputMaybe<Scalars['String']>;
  /** The payments on the invoice. The invoice has status paid if its payments cover the invoice total. */
  payments?: InputMaybe<ComWixpressQuotesInvoicesPaymentsInput>;
  /** The taxes of the invoice. */
  taxes?: InputMaybe<ComWixpressQuotesCalculatedTaxesInput>;
  /** The invoice title */
  title?: InputMaybe<Scalars['String']>;
  /**
   * The totals on the invoice.
   * The totals.subtotal, totals.total and totals.taxed_amount are calculated by the server based on the line items.
   * Alternatively, these fields can be provided in the invoice creation request, in this case, these values are fixed.
   * The totals contain fees and a discount, that apply to the invoice.
   */
  totals?: InputMaybe<ComWixpressQuotesTotalPriceInput>;
};

export enum ComWixpressQuotesInvoicesInvoiceStatus {
  Deleted = 'Deleted',
  Draft = 'Draft',
  Overdue = 'Overdue',
  Paid = 'Paid',
  PartialAndOverdue = 'PartialAndOverdue',
  PartiallyPaid = 'PartiallyPaid',
  Processing = 'Processing',
  Sent = 'Sent',
  Void = 'Void'
}

export type ComWixpressQuotesInvoicesPaymentInput = {
  amount?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
  date?: InputMaybe<Scalars['String']>;
  /** document */
  id?: InputMaybe<Scalars['String']>;
  /**
   * The orderId of the order in cashier associated with the payment.
   * This field is populated for external payments that are charged by invoices via AddPayment endpoint.
   */
  orderId?: InputMaybe<Scalars['String']>;
  /**
   * The transactionId corresponding to the orderId of the payment which are returned by cashier.
   * This field is populated for external payments that are charged by invoices via AddPayment endpoint as well.
   */
  transactionId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type ComWixpressQuotesInvoicesPaymentsInput = {
  payments?: InputMaybe<Array<InputMaybe<ComWixpressQuotesInvoicesPaymentInput>>>;
};

export type ComWixpressQuotesItemizedFeeInput = {
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
};

export type ComWixpressQuotesLineItemInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  /** The line-item level metadata. */
  metadata?: InputMaybe<ComWixpressQuotesLineItemMetaDataInput>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
  quantity?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
  /** The source of the line item */
  source?: InputMaybe<WixCrmCommonSourceInput>;
  taxedTotal?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
  taxes?: InputMaybe<Array<InputMaybe<ComWixpressQuotesLineItemTaxInput>>>;
};

export type ComWixpressQuotesLineItemMetaDataInput = {
  metadata?: InputMaybe<Scalars['JSON']>;
};

export type ComWixpressQuotesLineItemTaxInput = {
  code?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  rate?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
};

export type ComWixpressQuotesLineItemsInput = {
  lineItems?: InputMaybe<Array<InputMaybe<ComWixpressQuotesLineItemInput>>>;
};

export type ComWixpressQuotesLocaleInput = {
  /** An ISO 3166 alpha-2 country code or a UN M.49 numeric-3 area code. */
  country?: InputMaybe<Scalars['String']>;
  invariant?: InputMaybe<Scalars['String']>;
  /** ISO 639 alpha-2 or alpha-3 language code, or a language subtag */
  language?: InputMaybe<Scalars['String']>;
};

export type ComWixpressQuotesMetaDataInput = {
  /** Optional indicator whether to allow editing of the invoice by other applications other than the source. Default is true. */
  allowEditByOthers?: InputMaybe<Scalars['Boolean']>;
  legalTerms?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  sourceProperties?: InputMaybe<Scalars['JSON']>;
  sourceRefId?: InputMaybe<Scalars['String']>;
  sourceUrl?: InputMaybe<Scalars['String']>;
};

export type ComWixpressQuotesPhoneInput = {
  number?: InputMaybe<Scalars['String']>;
};

export type ComWixpressQuotesTotalPriceInput = {
  discountAmount?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
  fees?: InputMaybe<Array<InputMaybe<ComWixpressQuotesItemizedFeeInput>>>;
  /** the subtotal of the line items without the tax reduction */
  subtotal?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
  taxedAmount?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
  /** the total price taking into account the itemized fees and the taxes */
  total?: InputMaybe<ComWixpressQuotesBigDecimalWrapperInput>;
};

export type ComWixpressRestHeadersEntry = {
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type ComWixpressRestHeadersEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestPathParametersEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestQueryParametersEntryInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestRawHttpRequestInput = {
  body?: InputMaybe<Array<InputMaybe<Scalars['Byte']>>>;
  headers?: InputMaybe<Array<InputMaybe<ComWixpressRestHeadersEntryInput>>>;
  method?: InputMaybe<Scalars['String']>;
  pathParams?: InputMaybe<Array<InputMaybe<ComWixpressRestPathParametersEntryInput>>>;
  queryParams?: InputMaybe<Array<InputMaybe<ComWixpressRestQueryParametersEntryInput>>>;
  rawPath?: InputMaybe<Scalars['String']>;
  rawQuery?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestRawHttpResponse = {
  body?: Maybe<Array<Maybe<Scalars['Byte']>>>;
  headers?: Maybe<Array<Maybe<ComWixpressRestHeadersEntry>>>;
  statusCode?: Maybe<Scalars['Int']>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1BulkDeleteLabelsRequestInput = {
  /** Item Label IDs. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1BulkDeleteLabelsResponse = {
  /** Metadata for the API call. */
  bulkActionMetadata?: Maybe<ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonBulkActionMetadata>;
  /** Information about the deleted labels. */
  results?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemLabelsV1BulkDeleteLabelsResult>>>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1BulkDeleteLabelsResult = {
  /** Metadata for labels deletion. */
  itemMetadata?: Maybe<ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonItemMetadata>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1CloneLabelsRequestInput = {
  /** The MetaSiteId to clone from. */
  metaSiteId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1CountLabelsRequestInput = {
  /** Filter for counting labels. */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1CountLabelsResponse = {
  /** Counted labels. */
  count?: Maybe<Scalars['Int']>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1CreateLabelRequestInput = {
  /** Item label details. */
  label?: InputMaybe<ComWixpressRestaurantsMenusItemLabelsV1LabelInput>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1CreateLabelResponse = {
  /** Item label. */
  label?: Maybe<ComWixpressRestaurantsMenusItemLabelsV1Label>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1DeleteLabelRequestInput = {
  /** ID of the item label. */
  labelId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1ExternalReferenceInfo = {
  /** Whether the connection to the external system is currently active. */
  connected?: Maybe<Scalars['Boolean']>;
  /** ID of the external integrator app\system associated with this object. */
  externalAppId?: Maybe<Scalars['String']>;
  /** Reference to an external resource ID. Used to link this object to a specific entity in an external system. */
  externalEntityId?: Maybe<Scalars['String']>;
  /** Last time this item label was synced with the external app. */
  lastSyncDate?: Maybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1ExternalReferenceInfoInput = {
  /** Whether the connection to the external system is currently active. */
  connected?: InputMaybe<Scalars['Boolean']>;
  /** ID of the external integrator app\system associated with this object. */
  externalAppId?: InputMaybe<Scalars['String']>;
  /** Reference to an external resource ID. Used to link this object to a specific entity in an external system. */
  externalEntityId?: InputMaybe<Scalars['String']>;
  /** Last time this item label was synced with the external app. */
  lastSyncDate?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1GetLabelRequestInput = {
  id: Scalars['ID'];
};

export type ComWixpressRestaurantsMenusItemLabelsV1Label = {
  /** Date and time the item label was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Extended fields. */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** References to an external app and resource associated with this object. Used for integration and tracking across different platforms. */
  externalReferenceInfo?: Maybe<ComWixpressRestaurantsMenusItemLabelsV1ExternalReferenceInfo>;
  /** Item label icon. */
  icon?: Maybe<ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonImage>;
  /** Item label ID. */
  id?: Maybe<Scalars['String']>;
  /** Item label name. */
  name?: Maybe<Scalars['String']>;
  /** Revision number, which increments by 1 each time the item label is updated. To prevent conflicting changes, the current revision must be passed when updating the item label. Ignored when creating a item label. */
  revision?: Maybe<Scalars['Long']>;
  /** Date and time the item label was updated. */
  updatedDate?: Maybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1LabelInput = {
  /** Date and time the item label was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Extended fields. */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** References to an external app and resource associated with this object. Used for integration and tracking across different platforms. */
  externalReferenceInfo?: InputMaybe<ComWixpressRestaurantsMenusItemLabelsV1ExternalReferenceInfoInput>;
  /** Item label icon. */
  icon?: InputMaybe<ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonImageInput>;
  /** Item label ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Item label name. */
  name?: InputMaybe<Scalars['String']>;
  /** Revision number, which increments by 1 each time the item label is updated. To prevent conflicting changes, the current revision must be passed when updating the item label. Ignored when creating a item label. */
  revision?: InputMaybe<Scalars['Long']>;
  /** Date and time the item label was updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1ListLabelsResponse = {
  /** Retrieved item labels. */
  labels?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemLabelsV1Label>>>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1QueryLabelsRequestInput = {
  /** Query options. */
  query?: InputMaybe<ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonCursorQueryInput>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1QueryLabelsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemLabelsV1Label>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1SyncContentToMultilingualRequestInput = {
  /** MetaSite ID */
  metaSiteId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1UpdateLabelRequestInput = {
  /** Item label to update. */
  label?: InputMaybe<ComWixpressRestaurantsMenusItemLabelsV1LabelInput>;
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1UpdateLabelResponse = {
  /** Updated item label. */
  label?: Maybe<ComWixpressRestaurantsMenusItemLabelsV1Label>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonBulkActionMetadata = {
  /** Number of items that couldn't be processed. */
  totalFailures?: Maybe<Scalars['Int']>;
  /** Number of items that were successfully processed. */
  totalSuccesses?: Maybe<Scalars['Int']>;
  /** Number of failures without details because detailed failure threshold was exceeded. */
  undetailedFailures?: Maybe<Scalars['Int']>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonImage = {
  /** Image alt text. */
  altText?: Maybe<Scalars['String']>;
  /** Image filename. */
  filename?: Maybe<Scalars['String']>;
  /** Original image height. */
  height?: Maybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: Maybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: Maybe<Scalars['String']>;
  /** Image URL. */
  url?: Maybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: Maybe<Scalars['String']>;
  /** Original image width. */
  width?: Maybe<Scalars['Int']>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonImageInput = {
  /** Image alt text. */
  altText?: InputMaybe<Scalars['String']>;
  /** Image filename. */
  filename?: InputMaybe<Scalars['String']>;
  /** Original image height. */
  height?: InputMaybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: InputMaybe<Scalars['String']>;
  /** Image URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: InputMaybe<Scalars['String']>;
  /** Original image width. */
  width?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressRestaurantsMenusItemLabelsV1UpstreamWixCommonItemMetadata = {
  /** Details about the error in case of failure. */
  error?: Maybe<WixApiApplicationError>;
  /** Item ID. Should always be available, unless it's impossible (for example, when failing to create an item). */
  id?: Maybe<Scalars['String']>;
  /** Index of the item within the request array. Allows for correlation between request and response items. */
  originalIndex?: Maybe<Scalars['Int']>;
  /** Whether the requested action was successful for this item. When `false`, the `error` field is populated. */
  success?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressRestaurantsMenusItemV1BulkCreateItemResult = {
  /** Created item. */
  item?: Maybe<ComWixpressRestaurantsMenusItemV1Item>;
  /** Metadata for item update. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressRestaurantsMenusItemV1BulkCreateItemsRequestInput = {
  /** Items details. */
  items?: InputMaybe<Array<InputMaybe<ComWixpressRestaurantsMenusItemV1ItemInput>>>;
  /** Whether to return entity in the response. */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /** The source of this request. */
  source?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1BulkCreateItemsResponse = {
  /** Metadata for the API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Information about the created items. */
  results?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemV1BulkCreateItemResult>>>;
};

export type ComWixpressRestaurantsMenusItemV1BulkDeleteItemResult = {
  /** Metadata for item delete. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressRestaurantsMenusItemV1BulkDeleteItemsRequestInput = {
  /** Item IDs. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The source of this request. */
  source?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1BulkDeleteItemsResponse = {
  /** Metadata for the API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Information about the deleted items. */
  results?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemV1BulkDeleteItemResult>>>;
};

export type ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsPerEntityRequestInput = {
  itemIdLocationIds?: InputMaybe<Array<InputMaybe<ComWixpressRestaurantsMenusItemV1ItemIdLocationIdsInput>>>;
};

export type ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsPerEntityResponse = {
  /** Information about the updated items. */
  results?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult>>>;
};

export type ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult = {
  /** Metadata for item update. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsRequestInput = {
  /** Business Location Ids. */
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** item ids */
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsResponse = {
  /** Information about the updated items. */
  results?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsResponseBulkItemResult>>>;
};

export type ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsResponseBulkItemResult = {
  /** Metadata for item update. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressRestaurantsMenusItemV1BulkUpdateItemRequestInput = {
  /** Items to update. */
  items?: InputMaybe<Array<InputMaybe<ComWixpressRestaurantsMenusItemV1BulkUpdateItemRequestMaskedItemInput>>>;
  /** Whether to return entity in the response. */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /** The source of this request. */
  source?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1BulkUpdateItemRequestMaskedItemInput = {
  /** Item to update. */
  item?: InputMaybe<ComWixpressRestaurantsMenusItemV1ItemInput>;
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressRestaurantsMenusItemV1BulkUpdateItemResponse = {
  /** Metadata for the API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Information about the updated items. */
  results?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemV1BulkUpdateItemResponseBulkItemResult>>>;
};

export type ComWixpressRestaurantsMenusItemV1BulkUpdateItemResponseBulkItemResult = {
  /** Updated item. Only returned if `returnEntity` is set to `true`. */
  item?: Maybe<ComWixpressRestaurantsMenusItemV1Item>;
  /** Metadata for item update. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressRestaurantsMenusItemV1CloneItemsRequestInput = {
  /** The MetaSiteId to clone from. */
  metaSiteId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1CountItemsRequestInput = {
  /** Filter for counting items. */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Search details. */
  searchDetails?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonSearchDetailsInput>;
};

export type ComWixpressRestaurantsMenusItemV1CountItemsResponse = {
  /** Counted items. */
  count?: Maybe<Scalars['Int']>;
};

export type ComWixpressRestaurantsMenusItemV1CreateItemRequestInput = {
  /** Item details. */
  item?: InputMaybe<ComWixpressRestaurantsMenusItemV1ItemInput>;
  /** The source of this request. */
  source?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1CreateItemResponse = {
  /** Item. */
  item?: Maybe<ComWixpressRestaurantsMenusItemV1Item>;
};

export type ComWixpressRestaurantsMenusItemV1DeleteItemRequestInput = {
  /** Item ID. */
  itemId?: InputMaybe<Scalars['String']>;
  /** The source of this request. */
  source?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1DeleteLocationIdsFromModifierGroupsInput = {
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifierGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressRestaurantsMenusItemV1DeleteLocationIdsFromVariantsInput = {
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  variantIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressRestaurantsMenusItemV1ExternalReferenceInfo = {
  /** ID of the external integrator app\system associated with this object. */
  externalAppId?: Maybe<Scalars['String']>;
  /** Reference to an external resource ID. Used to link this object to a specific entity in an external system. */
  externalEntityId?: Maybe<Scalars['String']>;
  /** Last time this item was synced with the external app. */
  lastSyncDate?: Maybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1ExternalReferenceInfoInput = {
  /** ID of the external integrator app\system associated with this object. */
  externalAppId?: InputMaybe<Scalars['String']>;
  /** Reference to an external resource ID. Used to link this object to a specific entity in an external system. */
  externalEntityId?: InputMaybe<Scalars['String']>;
  /** Last time this item was synced with the external app. */
  lastSyncDate?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1GetItemRequestInput = {
  id: Scalars['ID'];
};

export type ComWixpressRestaurantsMenusItemV1Item = {
  /** Additional item images. */
  additionalImages?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonImage>>>;
  /** IDs of the business locations ([SDK](https://dev.wix.com/docs/sdk/backend-modules/restaurants/wix-restaurants-new/about-business-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/restaurants/wix-restaurants-new/about-business-locations)) where these items are available. */
  businessLocationIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Date and time the item was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Item description. */
  description?: Maybe<Scalars['String']>;
  /** Extended fields. */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** References to an external app and resource associated with this object. Used for integration and tracking across different platforms. */
  externalReferenceInfo?: Maybe<ComWixpressRestaurantsMenusItemV1ExternalReferenceInfo>;
  /**
   * Whether the item is marked as featured/best seller.
   * Default: `false`.
   */
  featured?: Maybe<Scalars['Boolean']>;
  /** Item ID. */
  id?: Maybe<Scalars['String']>;
  /** Main item image. */
  image?: Maybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonImage>;
  /** Item labels. */
  labels?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemV1Label>>>;
  /** IDs of the business locations ([SDK](https://dev.wix.com/docs/sdk/backend-modules/restaurants/wix-restaurants-new/about-business-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/restaurants/wix-restaurants-new/about-business-locations)) where these items are available. */
  locations?: Maybe<ComWixpressLocationsQueryLocationsResponse>;
  /** Item modifier groups. */
  modifierGroups?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemV1ModifierGroup>>>;
  /** Item name. */
  name?: Maybe<Scalars['String']>;
  oloMigrationItemId?: Maybe<Scalars['String']>;
  /** Online order settings. */
  orderSettings?: Maybe<ComWixpressRestaurantsMenusItemV1OrderSettings>;
  /** Item price info. */
  priceInfo?: Maybe<ComWixpressRestaurantsMenusItemV1PriceInfo>;
  /** Item price variants. */
  priceVariants?: Maybe<ComWixpressRestaurantsMenusItemV1PriceVariants>;
  /** Revision number, which increments by 1 each time the item is updated. To prevent conflicting changes, the current revision must be passed when updating the item. Ignored when creating a item. */
  revision?: Maybe<Scalars['Long']>;
  sectionsVirtualReference?: Maybe<ComWixpressRestaurantsMenusSectionV1QuerySectionsResponse>;
  /** Date and time the item was updated. */
  updatedDate?: Maybe<Scalars['String']>;
  /** Whether the item is visible in the menu for site visitors. */
  visible?: Maybe<Scalars['Boolean']>;
};


export type ComWixpressRestaurantsMenusItemV1ItemLocationsArgs = {
  queryInput?: InputMaybe<ComWixpressLocationsQueryLocationsRequestInput>;
};


export type ComWixpressRestaurantsMenusItemV1ItemSectionsVirtualReferenceArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusSectionV1QuerySectionsRequestInput>;
};

export type ComWixpressRestaurantsMenusItemV1ItemIdLocationIdsInput = {
  /** Business Location IDs */
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** item ID */
  itemId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1ItemInput = {
  /** Additional item images. */
  additionalImages?: InputMaybe<Array<InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonImageInput>>>;
  /** IDs of the business locations ([SDK](https://dev.wix.com/docs/sdk/backend-modules/restaurants/wix-restaurants-new/about-business-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/restaurants/wix-restaurants-new/about-business-locations)) where these items are available. */
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Date and time the item was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Item description. */
  description?: InputMaybe<Scalars['String']>;
  /** Extended fields. */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** References to an external app and resource associated with this object. Used for integration and tracking across different platforms. */
  externalReferenceInfo?: InputMaybe<ComWixpressRestaurantsMenusItemV1ExternalReferenceInfoInput>;
  /**
   * Whether the item is marked as featured/best seller.
   * Default: `false`.
   */
  featured?: InputMaybe<Scalars['Boolean']>;
  /** Item ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Main item image. */
  image?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonImageInput>;
  /** Item labels. */
  labels?: InputMaybe<Array<InputMaybe<ComWixpressRestaurantsMenusItemV1LabelInput>>>;
  /** Item modifier groups. */
  modifierGroups?: InputMaybe<Array<InputMaybe<ComWixpressRestaurantsMenusItemV1ModifierGroupInput>>>;
  /** Item name. */
  name?: InputMaybe<Scalars['String']>;
  oloMigrationItemId?: InputMaybe<Scalars['String']>;
  /** Online order settings. */
  orderSettings?: InputMaybe<ComWixpressRestaurantsMenusItemV1OrderSettingsInput>;
  /** Item price info. */
  priceInfo?: InputMaybe<ComWixpressRestaurantsMenusItemV1PriceInfoInput>;
  /** Item price variants. */
  priceVariants?: InputMaybe<ComWixpressRestaurantsMenusItemV1PriceVariantsInput>;
  /** Revision number, which increments by 1 each time the item is updated. To prevent conflicting changes, the current revision must be passed when updating the item. Ignored when creating a item. */
  revision?: InputMaybe<Scalars['Long']>;
  /** Date and time the item was updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** Whether the item is visible in the menu for site visitors. */
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressRestaurantsMenusItemV1Label = {
  /** Item label ID. */
  id?: Maybe<Scalars['String']>;
  /** Item label ID. */
  label?: Maybe<ComWixpressRestaurantsMenusItemLabelsV1Label>;
};

export type ComWixpressRestaurantsMenusItemV1LabelInput = {
  /** Item label ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1ListItemsRequestInput = {
  /** Item IDs. */
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Whether to return only items that are visible to site visitors. */
  onlyVisible?: InputMaybe<Scalars['Boolean']>;
  /** The metadata of the paginated results. */
  paging?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorPagingInput>;
};

export type ComWixpressRestaurantsMenusItemV1ListItemsResponse = {
  /** Items. */
  items?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemV1Item>>>;
  /** The metadata of the paginated results. */
  pagingMetadata?: Maybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorPagingMetadata>;
};

export type ComWixpressRestaurantsMenusItemV1ModifierGroup = {
  /** Modifier group ID. */
  id?: Maybe<Scalars['String']>;
  /** Modifier group ID. */
  modifierGroup?: Maybe<WixRestaurantsMenusV1ModifierGroup>;
};

export type ComWixpressRestaurantsMenusItemV1ModifierGroupInput = {
  /** Modifier group ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1OrderSettings = {
  /**
   * Whether a customer can add a special request when ordering this item.
   * Default: `true`.
   */
  acceptSpecialRequests?: Maybe<Scalars['Boolean']>;
  /**
   * Whether the item is in stock.
   * Default: `true`.
   */
  inStock?: Maybe<Scalars['Boolean']>;
  /** E-com defined tax group for the product. */
  taxGroupId?: Maybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1OrderSettingsInput = {
  /**
   * Whether a customer can add a special request when ordering this item.
   * Default: `true`.
   */
  acceptSpecialRequests?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether the item is in stock.
   * Default: `true`.
   */
  inStock?: InputMaybe<Scalars['Boolean']>;
  /** E-com defined tax group for the product. */
  taxGroupId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1PriceInfo = {
  /** Formatted price. */
  formattedPrice?: Maybe<Scalars['String']>;
  /** Price. */
  price?: Maybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1PriceInfoInput = {
  /** Formatted price. */
  formattedPrice?: InputMaybe<Scalars['String']>;
  /** Price. */
  price?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1PriceVariant = {
  /**
   * Price of a variant.
   * @deprecated Price of a variant. Replaced by: pricing.price_variants.variants.price_info. Removal date: 2024-08-01.
   */
  price?: Maybe<Scalars['String']>;
  /** Price info of a variant. */
  priceInfo?: Maybe<ComWixpressRestaurantsMenusItemV1PriceInfo>;
  /** Price variant ID. */
  variant?: Maybe<WixRestaurantsMenusItemVariantV1Variant>;
  /** Price variant ID. */
  variantId?: Maybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1PriceVariantInput = {
  /** Price info of a variant. */
  priceInfo?: InputMaybe<ComWixpressRestaurantsMenusItemV1PriceInfoInput>;
  /** Price variant ID. */
  variantId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1PriceVariants = {
  /** List of price variants. */
  variants?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemV1PriceVariant>>>;
};

export type ComWixpressRestaurantsMenusItemV1PriceVariantsInput = {
  /** List of price variants. */
  variants?: InputMaybe<Array<InputMaybe<ComWixpressRestaurantsMenusItemV1PriceVariantInput>>>;
};

export type ComWixpressRestaurantsMenusItemV1QueryItemsRequestInput = {
  /** Query options. */
  query?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorQueryInput>;
};

export type ComWixpressRestaurantsMenusItemV1QueryItemsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemV1Item>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressRestaurantsMenusItemV1RestaurantsDuplicateItemDuplicateItemRequestInput = {
  /** Business location ids to duplicate the item to. */
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Item id to be duplicated. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1RestaurantsDuplicateItemDuplicateItemResponse = {
  itemId?: Maybe<Array<Maybe<Scalars['String']>>>;
  items?: Maybe<ComWixpressRestaurantsMenusItemV1QueryItemsResponse>;
};


export type ComWixpressRestaurantsMenusItemV1RestaurantsDuplicateItemDuplicateItemResponseItemsArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusItemV1QueryItemsRequestInput>;
};

export type ComWixpressRestaurantsMenusItemV1SearchItemsRequestInput = {
  /** Search options. */
  search?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorSearchInput>;
};

export type ComWixpressRestaurantsMenusItemV1SearchItemsResponse = {
  /** The metadata of the search results. */
  aggregationData?: Maybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationData>;
  /** Retrieved items. */
  items?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemV1Item>>>;
  /** The metadata of the paginated results. */
  pagingMetadata?: Maybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorPagingMetadata>;
};

export type ComWixpressRestaurantsMenusItemV1UpdateItemRequestInput = {
  /** Item to update. */
  item?: InputMaybe<ComWixpressRestaurantsMenusItemV1ItemInput>;
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The source of this request. */
  source?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1UpdateItemResponse = {
  /** Updated item. */
  item?: Maybe<ComWixpressRestaurantsMenusItemV1Item>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationData = {
  /** List of the aggregated data results. */
  results?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResults>>>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResults = {
  /** Aggregation name, returned in `aggregations.results.name`. */
  name?: Maybe<Scalars['String']>;
  /** Range aggregation results. */
  ranges?: Maybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsRangeResults>;
  /** Scalar aggregation results. */
  scalar?: Maybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsScalarResult>;
  /** Type of aggregation to perform. Must align with the corresponding aggregation field. */
  type?: Maybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationType>;
  /** Value aggregation results. */
  values?: Maybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsValueResults>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsRangeResults = {
  /** List of ranges returned in the same order as requested. */
  results?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult>>>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult = {
  /** Total number of entities in this range. */
  count?: Maybe<Scalars['Int']>;
  /** Inclusive lower bound of the range. */
  from?: Maybe<Scalars['Float']>;
  /** Exclusive upper bound of the range. */
  to?: Maybe<Scalars['Float']>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsScalarResult = {
  /** Type of scalar aggregation. */
  type?: Maybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonScalarType>;
  /** Value of the scalar aggregation. */
  value?: Maybe<Scalars['Float']>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsValueResults = {
  /** List of value aggregations. */
  results?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult>>>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult = {
  /** Number of entities with this value. */
  count?: Maybe<Scalars['Int']>;
  /** Value of the field. */
  value?: Maybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationInput = {
  /** Field to aggreg   ate by. Use dot notation to specify a JSON path. For example, `order.address.streetName`. */
  fieldPath?: InputMaybe<Scalars['String']>;
  /** Aggregation name, returned in `aggregations.results.name`. */
  name?: InputMaybe<Scalars['String']>;
  /** A range aggregation calculates the count of the values from the specified field in the dataset that fall within the range of each bucket you define. For example, use a range aggregation to compare the number of reservations made for parties of 4 or less to the number of reservations made for parties with 5 or more. */
  range?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationRangeAggregationInput>;
  /** A scalar aggregation calculates a single numerical value from a dataset, summarizing the dataset into one key metric: `COUNT_DISTINCT`, `SUM`, `AVG`, `MIN`, or `MAX`. */
  scalar?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationScalarAggregationInput>;
  /** Type of aggregation to perform. Must align with the corresponding aggregation field. */
  type?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationType>;
  /** A value aggregation calculates metrics such as count for specific fields within a dataset, providing insights into the overall distribution and key statistics of those values. For example, use a value aggregation to get the number (count) of products for each price listed in the store. */
  value?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationValueAggregationInput>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationRangeAggregationInput = {
  /** List of range buckets. During aggregation each entity is placed in the first bucket its value falls into, based on the provided range bounds. */
  buckets?: InputMaybe<Array<InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationRangeAggregationRangeBucketInput>>>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationRangeAggregationRangeBucketInput = {
  /** Inclusive lower bound of the range. Required if `to` is not provided. */
  from?: InputMaybe<Scalars['Float']>;
  /** Exclusive upper bound of the range. Required if `from` is not provided. */
  to?: InputMaybe<Scalars['Float']>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationScalarAggregationInput = {
  /** Type of scalar aggregation. */
  type?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonScalarType>;
};

export enum ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationType {
  /** Calculates the count of the values from the specified field in the dataset that fall within the range of each bucket you define. */
  RANGE = 'RANGE',
  /** Calculates a single numerical value from a dataset, summarizing the dataset into one key metric: `COUNT_DISTINCT`, `SUM`, `AVG`, `MIN`, or `MAX`. */
  SCALAR = 'SCALAR',
  UNKNOWN_AGGREGATION_TYPE = 'UNKNOWN_AGGREGATION_TYPE',
  /** Calculates the distribution of a specific field's values within a dataset, providing insights into the overall distribution and key statistics of those values. */
  VALUE = 'VALUE'
}

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationValueAggregationInput = {
  /**
   * Number of aggregation results to return.
   * Min: `1`
   * Max: `250`
   * Default: `10`
   */
  limit?: InputMaybe<Scalars['Int']>;
  /** Sort direction. */
  sortDirection?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationValueAggregationSortDirection>;
  /** Sort type. */
  sortType?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationValueAggregationSortType>;
};

export enum ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationValueAggregationSortDirection {
  /** Ascending order. */
  ASC = 'ASC',
  /** Descending order. */
  DESC = 'DESC'
}

export enum ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationValueAggregationSortType {
  /** Number of matches in the results. */
  COUNT = 'COUNT',
  /** Alphabetically by the field value. */
  VALUE = 'VALUE'
}

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorPagingMetadata = {
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Offset that was requested. */
  cursors?: Maybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursors>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorSearchInput = {
  /** Logical groupings of data into facets, with summaries for each facet. For example, use aggregations to allow site visitors to narrow down their search results by selecting specific categories. */
  aggregations?: InputMaybe<Array<InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonAggregationInput>>>;
  /**
   * Cursor paging options.
   *
   * Learn more about cursor paging ([SDK](https://dev.wix.com/docs/sdk/articles/work-with-the-sdk/api-query-language#cursor-paging) | [REST](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#cursor-paging)).
   */
  cursorPaging?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object.
   *
   * Learn more about filtering ([SDK](https://dev.wix.com/docs/sdk/articles/work-with-the-sdk/api-query-language#the-filter-object) | [REST](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#filters)).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Free text to match in searchable fields. */
  search?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonSearchDetailsInput>;
  /**
   * Sort object.
   *
   * Learn more about sorting ([SDK](https://dev.wix.com/docs/sdk/articles/work-with-the-sdk/api-query-language#the-sort-array) | [REST](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#sorting)).
   */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonCursors = {
  /** Cursor pointing to next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonImage = {
  /** Image alt text. */
  altText?: Maybe<Scalars['String']>;
  /** Image filename. */
  filename?: Maybe<Scalars['String']>;
  /** Original image height. */
  height?: Maybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: Maybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: Maybe<Scalars['String']>;
  /** Image URL. */
  url?: Maybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: Maybe<Scalars['String']>;
  /** Original image width. */
  width?: Maybe<Scalars['Int']>;
};

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonImageInput = {
  /** Image alt text. */
  altText?: InputMaybe<Scalars['String']>;
  /** Image filename. */
  filename?: InputMaybe<Scalars['String']>;
  /** Original image height. */
  height?: InputMaybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: InputMaybe<Scalars['String']>;
  /** Image URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: InputMaybe<Scalars['String']>;
  /** Original image width. */
  width?: InputMaybe<Scalars['Int']>;
};

export enum ComWixpressRestaurantsMenusItemV1UpstreamWixCommonScalarType {
  /** Average of values. */
  AVG = 'AVG',
  /** Total number of distinct values. */
  COUNT_DISTINCT = 'COUNT_DISTINCT',
  /** Maximum value. */
  MAX = 'MAX',
  /** Minimum value. */
  MIN = 'MIN',
  /** Sum of values. */
  SUM = 'SUM',
  UNKNOWN_SCALAR_TYPE = 'UNKNOWN_SCALAR_TYPE'
}

export type ComWixpressRestaurantsMenusItemV1UpstreamWixCommonSearchDetailsInput = {
  /** Search term or expression. */
  expression?: InputMaybe<Scalars['String']>;
  /** Fields to search in. If the array is empty, all searchable fields are searched. Use dot notation to specify a JSON path. For example, `order.address.streetName`. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Whether to enable the search function to use an algorithm to automatically find results that are close to the search expression, such as typos and declensions. */
  fuzzy?: InputMaybe<Scalars['Boolean']>;
  /** Search mode. Defines the search logic for combining multiple terms in the `expression`. */
  mode?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpstreamWixCommonSearchDetailsMode>;
};

export enum ComWixpressRestaurantsMenusItemV1UpstreamWixCommonSearchDetailsMode {
  /** All search terms must be present. */
  AND = 'AND',
  /** At least one of the search terms must be present. */
  OR = 'OR'
}

export type ComWixpressRestaurantsMenusMenuV1BulkCreateMenuResult = {
  /** Created menu. */
  menu?: Maybe<ComWixpressRestaurantsMenusMenuV1Menu>;
  /** Whether to receive the created menus in the response. */
  menuMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressRestaurantsMenusMenuV1BulkCreateMenusRequestInput = {
  /** Menu details. */
  menus?: InputMaybe<Array<InputMaybe<ComWixpressRestaurantsMenusMenuV1MenuInput>>>;
  /** Whether to receive the created menus in the response. */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressRestaurantsMenusMenuV1BulkCreateMenusResponse = {
  /** Metadata for the API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Information about the created menus. */
  results?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusMenuV1BulkCreateMenuResult>>>;
};

export type ComWixpressRestaurantsMenusMenuV1BulkUpdateMenuRequestInput = {
  /** Menus to update. */
  menus?: InputMaybe<Array<InputMaybe<ComWixpressRestaurantsMenusMenuV1BulkUpdateMenuRequestMaskedMenuInput>>>;
  /** Whether to receive the entity in the response. */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressRestaurantsMenusMenuV1BulkUpdateMenuRequestMaskedMenuInput = {
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Menu to updated. */
  menu?: InputMaybe<ComWixpressRestaurantsMenusMenuV1MenuInput>;
};

export type ComWixpressRestaurantsMenusMenuV1BulkUpdateMenuResponse = {
  /** Metadata for the API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Results of bulk menu update. */
  results?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusMenuV1BulkUpdateMenuResponseBulkMenuResult>>>;
};

export type ComWixpressRestaurantsMenusMenuV1BulkUpdateMenuResponseBulkMenuResult = {
  /** Updated menu. Only returned if `returnEntity` is set to `true`. */
  menu?: Maybe<ComWixpressRestaurantsMenusMenuV1Menu>;
  /** Metadata for menu update. */
  menuMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressRestaurantsMenusMenuV1CloneMenusRequestInput = {
  /** The MetaSiteId to clone from. */
  metaSiteId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusMenuV1CreateMenuRequestInput = {
  /** Menu details. */
  menu?: InputMaybe<ComWixpressRestaurantsMenusMenuV1MenuInput>;
};

export type ComWixpressRestaurantsMenusMenuV1CreateMenuResponse = {
  /** Menu. */
  menu?: Maybe<ComWixpressRestaurantsMenusMenuV1Menu>;
};

export type ComWixpressRestaurantsMenusMenuV1DeleteMenuRequestInput = {
  /** Menu ID. */
  menuId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusMenuV1DeleteOrphanSectionsInput = {
  /** Menu id */
  menuId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusMenuV1GetMenuRequestInput = {
  id: Scalars['ID'];
};

export type ComWixpressRestaurantsMenusMenuV1GetMenuResponse = {
  /** Menu. */
  menu?: Maybe<ComWixpressRestaurantsMenusMenuV1Menu>;
};

export type ComWixpressRestaurantsMenusMenuV1ListMenusRequestInput = {
  /** Menu IDs. */
  menuIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The metadata of the paginated results. */
  paging?: InputMaybe<ComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingInput>;
};

export type ComWixpressRestaurantsMenusMenuV1ListMenusResponse = {
  /** Retrieved menus. */
  menus?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusMenuV1Menu>>>;
  /** The metadata of the paginated results. */
  pagingMetadata?: Maybe<ComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingMetadata>;
};

export type ComWixpressRestaurantsMenusMenuV1Menu = {
  /** Date and time the menu was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Menu description. */
  description?: Maybe<Scalars['String']>;
  /** Extended fields. */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** Menu ID. */
  id?: Maybe<Scalars['String']>;
  /** Menu name. */
  name?: Maybe<Scalars['String']>;
  /** Revision number, which increments by 1 each time the menu is updated. To prevent conflicting changes, the current revision must be passed when updating the menu. Ignored when creating a menu. */
  revision?: Maybe<Scalars['Long']>;
  /** Menu section IDs. */
  sectionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Menu section IDs. */
  sections?: Maybe<ComWixpressRestaurantsMenusSectionV1QuerySectionsResponse>;
  /** Date and time the menu was updated. */
  updatedDate?: Maybe<Scalars['String']>;
  /** Part of the site URL, that redirects to the menu. For example, in the URL `www.mywebsite.com/our-menus/dinner-menu`, `dinner-menu` is the field value. */
  urlQueryParam?: Maybe<Scalars['String']>;
  /** Is the menu visible to site visitors. */
  visible?: Maybe<Scalars['Boolean']>;
};


export type ComWixpressRestaurantsMenusMenuV1MenuSectionsArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusSectionV1QuerySectionsRequestInput>;
};

export type ComWixpressRestaurantsMenusMenuV1MenuInput = {
  /** Date and time the menu was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Menu description. */
  description?: InputMaybe<Scalars['String']>;
  /** Extended fields. */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** Menu ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Menu name. */
  name?: InputMaybe<Scalars['String']>;
  /** Revision number, which increments by 1 each time the menu is updated. To prevent conflicting changes, the current revision must be passed when updating the menu. Ignored when creating a menu. */
  revision?: InputMaybe<Scalars['Long']>;
  /** Menu section IDs. */
  sectionIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Date and time the menu was updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** Part of the site URL, that redirects to the menu. For example, in the URL `www.mywebsite.com/our-menus/dinner-menu`, `dinner-menu` is the field value. */
  urlQueryParam?: InputMaybe<Scalars['String']>;
  /** Is the menu visible to site visitors. */
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressRestaurantsMenusMenuV1QueryMenusRequestInput = {
  /** Query options. */
  query?: InputMaybe<ComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorQueryInput>;
};

export type ComWixpressRestaurantsMenusMenuV1QueryMenusResponse = {
  /** Retrieved menus. */
  menus?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusMenuV1Menu>>>;
  /** The metadata of the paginated results. */
  pagingMetadata?: Maybe<ComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingMetadata>;
};

export type ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlGetMenuSiteUrlRequestInput = {
  /** Menu ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Whether the full Menu entity is returned. Defaults to `false`. */
  returnFullEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlGetMenuSiteUrlResponse = {
  /** Retrieved menuInfo with path url. */
  menuSiteUrl?: Maybe<ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlMenuSiteUrl>;
};

export type ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlListMenusSiteUrlRequestInput = {
  /** The query by which to select menus. */
  paging?: InputMaybe<ComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingInput>;
  /** Whether the full Menu entity is returned. Defaults to `false`. */
  returnFullEntity?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlListMenusSiteUrlResponse = {
  /** The retrieved menu site info. */
  menusSiteUrls?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlMenuSiteUrl>>>;
  /** The metadata of the paginated results. */
  pagingMetadata?: Maybe<ComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingMetadata>;
};

export type ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlMenuSiteUrl = {
  /** Menu ID. */
  menu?: Maybe<ComWixpressRestaurantsMenusMenuV1Menu>;
  /** Menu ID. */
  menuId?: Maybe<Scalars['String']>;
  /** Path URL. */
  path?: Maybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlQueryMenusSiteUrlRequestInput = {
  /** Query options */
  query?: InputMaybe<ComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorQueryInput>;
};

export type ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlQueryMenusSiteUrlResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusMenuV1Menu>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressRestaurantsMenusMenuV1UpdateExtendedFieldsResponse = {
  /** Namespace of the app. */
  namespace?: Maybe<Scalars['String']>;
  /** Updated extended fields data. */
  namespaceData?: Maybe<Scalars['JSON']>;
};

export type ComWixpressRestaurantsMenusMenuV1UpdateMenuRequestInput = {
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Menu to update. */
  menu?: InputMaybe<ComWixpressRestaurantsMenusMenuV1MenuInput>;
};

export type ComWixpressRestaurantsMenusMenuV1UpdateMenuResponse = {
  /** Updated menu. */
  menu?: Maybe<ComWixpressRestaurantsMenusMenuV1Menu>;
};

export type ComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingMetadata = {
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Offset that was requested. */
  cursors?: Maybe<ComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursors>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<ComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type ComWixpressRestaurantsMenusMenuV1UpstreamWixCommonCursors = {
  /** Cursor pointing to next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusSectionV1BulkCreateSectionResult = {
  /** Created section. Only returned if `returnEntity` is set to `true`. */
  item?: Maybe<ComWixpressRestaurantsMenusSectionV1Section>;
  /** Metadata for created sections. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressRestaurantsMenusSectionV1BulkCreateSectionsRequestInput = {
  /** Whether to receive the created sections in the response. */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /** Sections details. */
  sections?: InputMaybe<Array<InputMaybe<ComWixpressRestaurantsMenusSectionV1SectionInput>>>;
};

export type ComWixpressRestaurantsMenusSectionV1BulkCreateSectionsResponse = {
  /** Metadata for the API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Information about the created sections. */
  results?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusSectionV1BulkCreateSectionResult>>>;
};

export type ComWixpressRestaurantsMenusSectionV1BulkDeleteSectionResult = {
  /** Metadata for deleted sections. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressRestaurantsMenusSectionV1BulkDeleteSectionsRequestInput = {
  /** Section IDs. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressRestaurantsMenusSectionV1BulkDeleteSectionsResponse = {
  /** Metadata for the API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Information about the deleted sections. */
  results?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusSectionV1BulkDeleteSectionResult>>>;
};

export type ComWixpressRestaurantsMenusSectionV1BulkUpdateBusinessLocationIdRequestInput = {
  /** Business Location Id. */
  businessLocationId?: InputMaybe<Scalars['String']>;
  /** section ids */
  sectionIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressRestaurantsMenusSectionV1BulkUpdateBusinessLocationIdResponse = {
  /** Information about the updated sections. */
  results?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusSectionV1BulkUpdateBusinessLocationIdResponseBulkItemResult>>>;
};

export type ComWixpressRestaurantsMenusSectionV1BulkUpdateBusinessLocationIdResponseBulkItemResult = {
  /** Metadata for item update. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressRestaurantsMenusSectionV1BulkUpdateSectionRequestInput = {
  /** Whether to receive the updated sections in the response. */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /** Sections to update. */
  sections?: InputMaybe<Array<InputMaybe<ComWixpressRestaurantsMenusSectionV1BulkUpdateSectionRequestMaskedSectionInput>>>;
};

export type ComWixpressRestaurantsMenusSectionV1BulkUpdateSectionRequestMaskedSectionInput = {
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Section update. */
  section?: InputMaybe<ComWixpressRestaurantsMenusSectionV1SectionInput>;
};

export type ComWixpressRestaurantsMenusSectionV1BulkUpdateSectionResponse = {
  /** Metadata for the API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Information about the updated sections. */
  results?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusSectionV1BulkUpdateSectionResponseBulkSectionResult>>>;
};

export type ComWixpressRestaurantsMenusSectionV1BulkUpdateSectionResponseBulkSectionResult = {
  /** Updated section. Only returned if `returnEntity` is set to `true`. */
  section?: Maybe<ComWixpressRestaurantsMenusSectionV1Section>;
  /** Whether to receive the updated sections in the response. */
  sectionMetadata?: Maybe<WixCommonItemMetadata>;
};

export type ComWixpressRestaurantsMenusSectionV1CloneSectionsRequestInput = {
  /** The MetaSiteId to clone from. */
  metaSiteId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusSectionV1CreateSectionRequestInput = {
  /** Section details. */
  section?: InputMaybe<ComWixpressRestaurantsMenusSectionV1SectionInput>;
};

export type ComWixpressRestaurantsMenusSectionV1CreateSectionResponse = {
  /** Section. */
  section?: Maybe<ComWixpressRestaurantsMenusSectionV1Section>;
};

export type ComWixpressRestaurantsMenusSectionV1DeleteLocationIdFromItemsInput = {
  businessLocationId?: InputMaybe<Scalars['String']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressRestaurantsMenusSectionV1DeleteOrphanItemsInput = {
  sectionId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusSectionV1DeleteSectionRequestInput = {
  /** Section ID. */
  sectionId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusSectionV1ExternalReferenceInfo = {
  /** ID of the external integrator app\system associated with this object. */
  externalAppId?: Maybe<Scalars['String']>;
  /** Reference to an external resource ID. Used to link this object to a specific entity in an external system. */
  externalEntityId?: Maybe<Scalars['String']>;
  /** Last time this section was synced with the external app. */
  lastSyncDate?: Maybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusSectionV1ExternalReferenceInfoInput = {
  /** ID of the external integrator app\system associated with this object. */
  externalAppId?: InputMaybe<Scalars['String']>;
  /** Reference to an external resource ID. Used to link this object to a specific entity in an external system. */
  externalEntityId?: InputMaybe<Scalars['String']>;
  /** Last time this section was synced with the external app. */
  lastSyncDate?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusSectionV1GetSectionRequestInput = {
  id: Scalars['ID'];
};

export type ComWixpressRestaurantsMenusSectionV1ListSectionsRequestInput = {
  /** Whether to return only sections that are visible to site visitors. */
  onlyVisible?: InputMaybe<Scalars['Boolean']>;
  /** The metadata of the paginated results. */
  paging?: InputMaybe<ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursorPagingInput>;
  /** Section IDs. */
  sectionIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressRestaurantsMenusSectionV1ListSectionsResponse = {
  /** The metadata of the paginated results. */
  pagingMetadata?: Maybe<ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursorPagingMetadata>;
  /** Retrieved sections. */
  sections?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusSectionV1Section>>>;
};

export type ComWixpressRestaurantsMenusSectionV1QuerySectionsRequestInput = {
  /** Query options. */
  query?: InputMaybe<ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursorQueryInput>;
};

export type ComWixpressRestaurantsMenusSectionV1QuerySectionsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusSectionV1Section>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type ComWixpressRestaurantsMenusSectionV1RestaurantsDuplicateSectionDuplicateSectionRequestInput = {
  /** Business location ids to duplicate the section to. */
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Indicates whether sub-entities (such as items) should be duplicated as well. */
  duplicateSubEntities?: InputMaybe<Scalars['Boolean']>;
  /** Section id to be duplicated. */
  id?: InputMaybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusSectionV1RestaurantsDuplicateSectionDuplicateSectionResponse = {
  sectionId?: Maybe<Array<Maybe<Scalars['String']>>>;
  sections?: Maybe<ComWixpressRestaurantsMenusSectionV1QuerySectionsResponse>;
};


export type ComWixpressRestaurantsMenusSectionV1RestaurantsDuplicateSectionDuplicateSectionResponseSectionsArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusSectionV1QuerySectionsRequestInput>;
};

export type ComWixpressRestaurantsMenusSectionV1Section = {
  /** Additional section images. */
  additionalImages?: Maybe<Array<Maybe<ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonImage>>>;
  /** ID of the business location ([SDK](https://dev.wix.com/docs/sdk/backend-modules/restaurants/wix-restaurants-new/about-business-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/restaurants/wix-restaurants-new/about-business-locations)) where this section is available. */
  businessLocationId?: Maybe<Scalars['String']>;
  /** Date and time the section was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Section description. */
  description?: Maybe<Scalars['String']>;
  /** Extended fields. */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** References to an external app and resource associated with this object. Used for integration and tracking across different platforms. */
  externalReferenceInfo?: Maybe<ComWixpressRestaurantsMenusSectionV1ExternalReferenceInfo>;
  /** Section ID. */
  id?: Maybe<Scalars['String']>;
  /** Main section image. */
  image?: Maybe<ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonImage>;
  /** Item IDs. */
  itemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Item IDs. */
  items?: Maybe<ComWixpressRestaurantsMenusItemV1QueryItemsResponse>;
  /** ID of the business location ([SDK](https://dev.wix.com/docs/sdk/backend-modules/restaurants/wix-restaurants-new/about-business-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/restaurants/wix-restaurants-new/about-business-locations)) where this section is available. */
  location?: Maybe<ComWixpressLocationsLocation>;
  menusVirtualReference?: Maybe<ComWixpressRestaurantsMenusMenuV1QueryMenusResponse>;
  /** Section name. */
  name?: Maybe<Scalars['String']>;
  oloMigrationSectionId?: Maybe<Scalars['String']>;
  /** Revision number, which increments by 1 each time the section is updated. To prevent conflicting changes, the current revision must be passed when updating the section. Ignored when creating a section. */
  revision?: Maybe<Scalars['Long']>;
  /** Date and time the section was updated. */
  updatedDate?: Maybe<Scalars['String']>;
  /** Whether the section is visible in the menu for site visitors. */
  visible?: Maybe<Scalars['Boolean']>;
};


export type ComWixpressRestaurantsMenusSectionV1SectionItemsArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusItemV1QueryItemsRequestInput>;
};


export type ComWixpressRestaurantsMenusSectionV1SectionMenusVirtualReferenceArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusMenuV1QueryMenusRequestInput>;
};

export type ComWixpressRestaurantsMenusSectionV1SectionInput = {
  /** Additional section images. */
  additionalImages?: InputMaybe<Array<InputMaybe<ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonImageInput>>>;
  /** ID of the business location ([SDK](https://dev.wix.com/docs/sdk/backend-modules/restaurants/wix-restaurants-new/about-business-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/restaurants/wix-restaurants-new/about-business-locations)) where this section is available. */
  businessLocationId?: InputMaybe<Scalars['String']>;
  /** Date and time the section was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Section description. */
  description?: InputMaybe<Scalars['String']>;
  /** Extended fields. */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** References to an external app and resource associated with this object. Used for integration and tracking across different platforms. */
  externalReferenceInfo?: InputMaybe<ComWixpressRestaurantsMenusSectionV1ExternalReferenceInfoInput>;
  /** Section ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Main section image. */
  image?: InputMaybe<ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonImageInput>;
  /** Item IDs. */
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Section name. */
  name?: InputMaybe<Scalars['String']>;
  oloMigrationSectionId?: InputMaybe<Scalars['String']>;
  /** Revision number, which increments by 1 each time the section is updated. To prevent conflicting changes, the current revision must be passed when updating the section. Ignored when creating a section. */
  revision?: InputMaybe<Scalars['Long']>;
  /** Date and time the section was updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** Whether the section is visible in the menu for site visitors. */
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressRestaurantsMenusSectionV1UpdateSectionRequestInput = {
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Section update. */
  section?: InputMaybe<ComWixpressRestaurantsMenusSectionV1SectionInput>;
};

export type ComWixpressRestaurantsMenusSectionV1UpdateSectionResponse = {
  /** Updated section. */
  section?: Maybe<ComWixpressRestaurantsMenusSectionV1Section>;
};

export type ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursorPagingMetadata = {
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Offset that was requested. */
  cursors?: Maybe<ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursors>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonCursors = {
  /** Cursor pointing to next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export type ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonImage = {
  /** Image alt text. */
  altText?: Maybe<Scalars['String']>;
  /** Image filename. */
  filename?: Maybe<Scalars['String']>;
  /** Original image height. */
  height?: Maybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: Maybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: Maybe<Scalars['String']>;
  /** Image URL. */
  url?: Maybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: Maybe<Scalars['String']>;
  /** Original image width. */
  width?: Maybe<Scalars['Int']>;
};

export type ComWixpressRestaurantsMenusSectionV1UpstreamWixCommonImageInput = {
  /** Image alt text. */
  altText?: InputMaybe<Scalars['String']>;
  /** Image filename. */
  filename?: InputMaybe<Scalars['String']>;
  /** Original image height. */
  height?: InputMaybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: InputMaybe<Scalars['String']>;
  /** Image URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: InputMaybe<Scalars['String']>;
  /** Original image width. */
  width?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressSitepropertiesApiV4Address = {
  /** Apartment number. */
  apartmentNumber?: Maybe<Scalars['String']>;
  /** City name. */
  city?: Maybe<Scalars['String']>;
  /** Geographic coordinates of location. */
  coordinates?: Maybe<ComWixpressSitepropertiesApiV4GeoCoordinates>;
  /** Two-letter country code in an [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) format. */
  country?: Maybe<Scalars['String']>;
  /** Google-formatted version of this address. */
  googleFormattedAddress?: Maybe<Scalars['String']>;
  /** Extra information to be displayed in the address. */
  hint?: Maybe<ComWixpressSitepropertiesApiV4AddressHint>;
  /** Whether this address represents a physical location. */
  isPhysical?: Maybe<Scalars['Boolean']>;
  /** State. */
  state?: Maybe<Scalars['String']>;
  /** Street name. */
  street?: Maybe<Scalars['String']>;
  /** Street number. */
  streetNumber?: Maybe<Scalars['String']>;
  /** Zip or postal code. */
  zip?: Maybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4AddressHint = {
  /** Where the extra text should be displayed. */
  placement?: Maybe<ComWixpressSitepropertiesApiV4PlacementType>;
  /** Extra text displayed next to, or instead of, the actual address. */
  text?: Maybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4AddressHintInput = {
  /** Where the extra text should be displayed. */
  placement?: InputMaybe<ComWixpressSitepropertiesApiV4PlacementType>;
  /** Extra text displayed next to, or instead of, the actual address. */
  text?: InputMaybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4AddressInput = {
  /** Apartment number. */
  apartmentNumber?: InputMaybe<Scalars['String']>;
  /** City name. */
  city?: InputMaybe<Scalars['String']>;
  /** Geographic coordinates of location. */
  coordinates?: InputMaybe<ComWixpressSitepropertiesApiV4GeoCoordinatesInput>;
  /** Two-letter country code in an [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) format. */
  country?: InputMaybe<Scalars['String']>;
  /** Google-formatted version of this address. */
  googleFormattedAddress?: InputMaybe<Scalars['String']>;
  /** Extra information to be displayed in the address. */
  hint?: InputMaybe<ComWixpressSitepropertiesApiV4AddressHintInput>;
  /** Whether this address represents a physical location. */
  isPhysical?: InputMaybe<Scalars['Boolean']>;
  /** State. */
  state?: InputMaybe<Scalars['String']>;
  /** Street name. */
  street?: InputMaybe<Scalars['String']>;
  /** Street number. */
  streetNumber?: InputMaybe<Scalars['String']>;
  /** Zip or postal code. */
  zip?: InputMaybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4BulkPropertiesReadRequestInput = {
  /** Site IDs. */
  sites?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressSitepropertiesApiV4BulkPropertiesReadResponse = {
  /** The ID of the resolved MetaSite for the request. */
  sites?: Maybe<ComWixpressSitepropertiesApiV4PropertiesReadResponse>;
};

export type ComWixpressSitepropertiesApiV4BusinessContactDataInput = {
  /** Publicly-available business address. */
  address?: InputMaybe<ComWixpressSitepropertiesApiV4AddressInput>;
  /** Publicly-available business email address. */
  email?: InputMaybe<Scalars['String']>;
  /** Publicly-available business fax number. */
  fax?: InputMaybe<Scalars['String']>;
  /** Publicly-available business phone number. */
  phone?: InputMaybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4BusinessProfileDataInput = {
  /** Business name. */
  businessName?: InputMaybe<Scalars['String']>;
  /** Site description. */
  description?: InputMaybe<Scalars['String']>;
  /** Path to the site's logo in Wix Media (without Wix Media base URL). */
  logo?: InputMaybe<Scalars['String']>;
  /** Site display name. */
  siteDisplayName?: InputMaybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4BusinessSchedule = {
  /** Weekly recurring time periods when the business is regularly open or the service is available. Limited to 100 time periods. */
  periods?: Maybe<Array<Maybe<ComWixpressSitepropertiesApiV4TimePeriod>>>;
  /** Exceptions to the business's regular hours. The business can be open or closed during the exception. */
  specialHourPeriod?: Maybe<Array<Maybe<ComWixpressSitepropertiesApiV4SpecialHourPeriod>>>;
};

export type ComWixpressSitepropertiesApiV4BusinessScheduleInput = {
  /** Weekly recurring time periods when the business is regularly open or the service is available. Limited to 100 time periods. */
  periods?: InputMaybe<Array<InputMaybe<ComWixpressSitepropertiesApiV4TimePeriodInput>>>;
  /** Exceptions to the business's regular hours. The business can be open or closed during the exception. */
  specialHourPeriod?: InputMaybe<Array<InputMaybe<ComWixpressSitepropertiesApiV4SpecialHourPeriodInput>>>;
};

export type ComWixpressSitepropertiesApiV4Categories = {
  /** Business Term Id */
  businessTermId?: Maybe<Scalars['String']>;
  /** Primary site category. */
  primary?: Maybe<Scalars['String']>;
  /** Secondary site category. */
  secondary?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComWixpressSitepropertiesApiV4CategoriesInput = {
  /** Business Term Id */
  businessTermId?: InputMaybe<Scalars['String']>;
  /** Primary site category. */
  primary?: InputMaybe<Scalars['String']>;
  /** Secondary site category. */
  secondary?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressSitepropertiesApiV4ChangeContextInput = {
  /** Properties were updated. */
  propertiesChange?: InputMaybe<Scalars['Void']>;
  /** Properties were cloned on site cloning. */
  siteCloned?: InputMaybe<ComWixpressSitepropertiesApiV4SiteClonedInput>;
  /** Default properties were created on site creation. */
  siteCreated?: InputMaybe<ComWixpressSitepropertiesApiV4SiteCreatedInput>;
};

export type ComWixpressSitepropertiesApiV4ConsentPolicy = {
  /** Whether the site uses cookies that collect information allowing better customization of the experience for a current visitor. */
  advertising?: Maybe<Scalars['Boolean']>;
  /** Whether the site uses cookies that collect analytics about how the site is used (in order to improve it). */
  analytics?: Maybe<Scalars['Boolean']>;
  /** CCPA compliance flag. */
  dataToThirdParty?: Maybe<Scalars['Boolean']>;
  /** Whether the site uses cookies that are essential to site operation. Always `true`. */
  essential?: Maybe<Scalars['Boolean']>;
  /** Whether the site uses cookies that affect site performance and other functional measurements. */
  functional?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressSitepropertiesApiV4ConsentPolicyInput = {
  /** Whether the site uses cookies that collect information allowing better customization of the experience for a current visitor. */
  advertising?: InputMaybe<Scalars['Boolean']>;
  /** Whether the site uses cookies that collect analytics about how the site is used (in order to improve it). */
  analytics?: InputMaybe<Scalars['Boolean']>;
  /** CCPA compliance flag. */
  dataToThirdParty?: InputMaybe<Scalars['Boolean']>;
  /** Whether the site uses cookies that are essential to site operation. Always `true`. */
  essential?: InputMaybe<Scalars['Boolean']>;
  /** Whether the site uses cookies that affect site performance and other functional measurements. */
  functional?: InputMaybe<Scalars['Boolean']>;
};

export enum ComWixpressSitepropertiesApiV4DayOfWeek {
  FRIDAY = 'FRIDAY',
  MONDAY = 'MONDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
  THURSDAY = 'THURSDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY'
}

export type ComWixpressSitepropertiesApiV4GeoCoordinates = {
  /** Latitude of the location. Must be between -90 and 90. */
  latitude?: Maybe<Scalars['Float']>;
  /** Longitude of the location. Must be between -180 and 180. */
  longitude?: Maybe<Scalars['Float']>;
};

export type ComWixpressSitepropertiesApiV4GeoCoordinatesInput = {
  /** Latitude of the location. Must be between -90 and 90. */
  latitude?: InputMaybe<Scalars['Float']>;
  /** Longitude of the location. Must be between -180 and 180. */
  longitude?: InputMaybe<Scalars['Float']>;
};

export type ComWixpressSitepropertiesApiV4Locale = {
  /** Two-letter country code in [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2#Officially_assigned_code_elements) format. */
  country?: Maybe<Scalars['String']>;
  /** Two-letter language code in [ISO 639-1 alpha-2](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format. */
  languageCode?: Maybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4LocaleInput = {
  /** Two-letter country code in [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2#Officially_assigned_code_elements) format. */
  country?: InputMaybe<Scalars['String']>;
  /** Two-letter language code in [ISO 639-1 alpha-2](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format. */
  languageCode?: InputMaybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4Multilingual = {
  /** Whether to redirect to user language. */
  autoRedirect?: Maybe<Scalars['Boolean']>;
  /** Supported languages list. */
  supportedLanguages?: Maybe<Array<Maybe<ComWixpressSitepropertiesApiV4SupportedLanguage>>>;
};

export type ComWixpressSitepropertiesApiV4MultilingualInput = {
  /** Whether to redirect to user language. */
  autoRedirect?: InputMaybe<Scalars['Boolean']>;
  /** Supported languages list. */
  supportedLanguages?: InputMaybe<Array<InputMaybe<ComWixpressSitepropertiesApiV4SupportedLanguageInput>>>;
};

export enum ComWixpressSitepropertiesApiV4PlacementType {
  AFTER = 'AFTER',
  BEFORE = 'BEFORE',
  REPLACE = 'REPLACE'
}

export type ComWixpressSitepropertiesApiV4Properties = {
  /** Address. */
  address?: Maybe<ComWixpressSitepropertiesApiV4Address>;
  /**
   * Supported values: `FITNESS SERVICE`, `RESTAURANT`, `BLOG`, `STORE`, `EVENT`, `UNKNOWN`.
   *
   * Site business type.
   */
  businessConfig?: Maybe<Scalars['String']>;
  /** Business name. */
  businessName?: Maybe<Scalars['String']>;
  /**
   * Business schedule. Regular and exceptional time periods when the business is open or the service is available.
   *
   * __Note:__ Not supported by Wix Bookings.
   */
  businessSchedule?: Maybe<ComWixpressSitepropertiesApiV4BusinessSchedule>;
  /** Site categories. */
  categories?: Maybe<ComWixpressSitepropertiesApiV4Categories>;
  /** Cookie policy the Wix user defined for their site (before the site visitor interacts with/limits it). */
  consentPolicy?: Maybe<ComWixpressSitepropertiesApiV4ConsentPolicy>;
  /** Site description. */
  description?: Maybe<Scalars['String']>;
  /** Email address. */
  email?: Maybe<Scalars['String']>;
  /** External site URL that uses Wix as its headless business solution. */
  externalSiteUrl?: Maybe<Scalars['String']>;
  /** Fax number. */
  fax?: Maybe<Scalars['String']>;
  /**
   * Site language.
   *
   * Two-letter language code in [ISO 639-1 alpha-2](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format.
   */
  language?: Maybe<Scalars['String']>;
  /** Site locale. */
  locale?: Maybe<ComWixpressSitepropertiesApiV4Locale>;
  /** Path to the site's logo in Wix Media (without Wix Media base URL). */
  logo?: Maybe<Scalars['String']>;
  /** Supported languages of a site and the primary language. */
  multilingual?: Maybe<ComWixpressSitepropertiesApiV4Multilingual>;
  /**
   * Site currency format used to bill customers.
   *
   * Three-letter currency code in [ISO-4217 alphabetic](https://en.wikipedia.org/wiki/ISO_4217#Active_codes) format.
   */
  paymentCurrency?: Maybe<Scalars['String']>;
  /** Phone number. */
  phone?: Maybe<Scalars['String']>;
  /** Site display name. */
  siteDisplayName?: Maybe<Scalars['String']>;
  /** Timezone in `America/New_York` format. */
  timeZone?: Maybe<Scalars['String']>;
  /** Track clicks analytics. */
  trackClicksAnalytics?: Maybe<Scalars['Boolean']>;
};

export type ComWixpressSitepropertiesApiV4PropertiesInput = {
  /** Address. */
  address?: InputMaybe<ComWixpressSitepropertiesApiV4AddressInput>;
  /**
   * Supported values: `FITNESS SERVICE`, `RESTAURANT`, `BLOG`, `STORE`, `EVENT`, `UNKNOWN`.
   *
   * Site business type.
   */
  businessConfig?: InputMaybe<Scalars['String']>;
  /** Business name. */
  businessName?: InputMaybe<Scalars['String']>;
  /**
   * Business schedule. Regular and exceptional time periods when the business is open or the service is available.
   *
   * __Note:__ Not supported by Wix Bookings.
   */
  businessSchedule?: InputMaybe<ComWixpressSitepropertiesApiV4BusinessScheduleInput>;
  /** Site categories. */
  categories?: InputMaybe<ComWixpressSitepropertiesApiV4CategoriesInput>;
  /** Cookie policy the Wix user defined for their site (before the site visitor interacts with/limits it). */
  consentPolicy?: InputMaybe<ComWixpressSitepropertiesApiV4ConsentPolicyInput>;
  /** Site description. */
  description?: InputMaybe<Scalars['String']>;
  /** Email address. */
  email?: InputMaybe<Scalars['String']>;
  /** External site URL that uses Wix as its headless business solution. */
  externalSiteUrl?: InputMaybe<Scalars['String']>;
  /** Fax number. */
  fax?: InputMaybe<Scalars['String']>;
  /**
   * Site language.
   *
   * Two-letter language code in [ISO 639-1 alpha-2](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Site locale. */
  locale?: InputMaybe<ComWixpressSitepropertiesApiV4LocaleInput>;
  /** Path to the site's logo in Wix Media (without Wix Media base URL). */
  logo?: InputMaybe<Scalars['String']>;
  /** Supported languages of a site and the primary language. */
  multilingual?: InputMaybe<ComWixpressSitepropertiesApiV4MultilingualInput>;
  /**
   * Site currency format used to bill customers.
   *
   * Three-letter currency code in [ISO-4217 alphabetic](https://en.wikipedia.org/wiki/ISO_4217#Active_codes) format.
   */
  paymentCurrency?: InputMaybe<Scalars['String']>;
  /** Phone number. */
  phone?: InputMaybe<Scalars['String']>;
  /** Site display name. */
  siteDisplayName?: InputMaybe<Scalars['String']>;
  /** Timezone in `America/New_York` format. */
  timeZone?: InputMaybe<Scalars['String']>;
  /** Track clicks analytics. */
  trackClicksAnalytics?: InputMaybe<Scalars['Boolean']>;
};

export type ComWixpressSitepropertiesApiV4PropertiesReadRequestInput = {
  /**
   * List of fields to return.
   * If omitted, all fields are returned.
   */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressSitepropertiesApiV4PropertiesReadResponse = {
  /** Properties for the requested site. */
  properties?: Maybe<ComWixpressSitepropertiesApiV4Properties>;
  /** Current version of the stored property site. For internal use. */
  version?: Maybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4PropertiesUpdateRequestInput = {
  /** The properties to be updated. Properties not explicitly specified here are ignored. Properties included here but excluded from `properties` are cleared. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  properties?: InputMaybe<ComWixpressSitepropertiesApiV4PropertiesInput>;
};

export type ComWixpressSitepropertiesApiV4PropertiesUpdateResponse = {
  /** The new version of the stored properties after the update. For internal use. */
  version?: Maybe<Scalars['String']>;
};

export enum ComWixpressSitepropertiesApiV4ResolutionMethod {
  QUERY_PARAM = 'QUERY_PARAM',
  SUBDIRECTORY = 'SUBDIRECTORY',
  SUBDOMAIN = 'SUBDOMAIN'
}

export type ComWixpressSitepropertiesApiV4SiteClonedInput = {
  /** Origin site id. */
  originMetaSiteId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4SiteCreatedInput = {
  /** Origin template site id. */
  originTemplateId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4SitePropertiesEventInput = {
  /** Set of properties that were updated - corresponds to the fields in "properties". */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Updated properties. */
  properties?: InputMaybe<ComWixpressSitepropertiesApiV4PropertiesInput>;
  /** Version of the site's properties represented by this update. */
  version?: InputMaybe<Scalars['Int']>;
};

export type ComWixpressSitepropertiesApiV4SitePropertiesNotificationInput = {
  /** Context of the notification */
  changeContext?: InputMaybe<ComWixpressSitepropertiesApiV4ChangeContextInput>;
  /** The actual update event. */
  event?: InputMaybe<ComWixpressSitepropertiesApiV4SitePropertiesEventInput>;
  /** The site ID for which this update notification applies. */
  metasiteId?: InputMaybe<Scalars['String']>;
  /** A convenience set of mappings from the MetaSite ID to its constituent services. */
  translations?: InputMaybe<Array<InputMaybe<ComWixpressSitepropertiesApiV4TranslationInput>>>;
};

export type ComWixpressSitepropertiesApiV4SitePropertiesUpdatedInput = {
  /** Update details. */
  event?: InputMaybe<ComWixpressSitepropertiesApiV4SitePropertiesEventInput>;
  /** ID of the Wix site that has been updated. */
  metasiteId?: InputMaybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4SpecialHourPeriod = {
  /** Additional info about the exception. For example, "We close earlier on New Year's Eve." */
  comment?: Maybe<Scalars['String']>;
  /** End date and time of the exception in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) format and [Coordinated Universal Time (UTC)](https://en.wikipedia.org/wiki/Coordinated_Universal_Time). */
  endDate?: Maybe<Scalars['String']>;
  /**
   * Whether the business is closed (or the service is not available) during the exception.
   *
   * Default: `true`.
   */
  isClosed?: Maybe<Scalars['Boolean']>;
  /** Start date and time of the exception in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) format and [Coordinated Universal Time (UTC)](https://en.wikipedia.org/wiki/Coordinated_Universal_Time). */
  startDate?: Maybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4SpecialHourPeriodInput = {
  /** Additional info about the exception. For example, "We close earlier on New Year's Eve." */
  comment?: InputMaybe<Scalars['String']>;
  /** End date and time of the exception in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) format and [Coordinated Universal Time (UTC)](https://en.wikipedia.org/wiki/Coordinated_Universal_Time). */
  endDate?: InputMaybe<Scalars['String']>;
  /**
   * Whether the business is closed (or the service is not available) during the exception.
   *
   * Default: `true`.
   */
  isClosed?: InputMaybe<Scalars['Boolean']>;
  /** Start date and time of the exception in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) format and [Coordinated Universal Time (UTC)](https://en.wikipedia.org/wiki/Coordinated_Universal_Time). */
  startDate?: InputMaybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4SupportedLanguage = {
  /** Language icon. */
  countryCode?: Maybe<Scalars['String']>;
  /** Whether the supported language is the primary language for the site. */
  isPrimary?: Maybe<Scalars['Boolean']>;
  /** Whether the supported language is the primary language for site visitors. */
  isVisitorPrimary?: Maybe<Scalars['Boolean']>;
  /** Two-letter language code in [ISO 639-1 alpha-2](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format. */
  languageCode?: Maybe<Scalars['String']>;
  /** Locale. */
  locale?: Maybe<ComWixpressSitepropertiesApiV4Locale>;
  /** How the language will be resolved. For internal use. */
  resolutionMethod?: Maybe<ComWixpressSitepropertiesApiV4ResolutionMethod>;
};

export type ComWixpressSitepropertiesApiV4SupportedLanguageInput = {
  /** Language icon. */
  countryCode?: InputMaybe<Scalars['String']>;
  /** Whether the supported language is the primary language for the site. */
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  /** Whether the supported language is the primary language for site visitors. */
  isVisitorPrimary?: InputMaybe<Scalars['Boolean']>;
  /** Two-letter language code in [ISO 639-1 alpha-2](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format. */
  languageCode?: InputMaybe<Scalars['String']>;
  /** Locale. */
  locale?: InputMaybe<ComWixpressSitepropertiesApiV4LocaleInput>;
  /** How the language will be resolved. For internal use. */
  resolutionMethod?: InputMaybe<ComWixpressSitepropertiesApiV4ResolutionMethod>;
};

export type ComWixpressSitepropertiesApiV4TimePeriod = {
  /** Day of the week the period ends on. */
  closeDay?: Maybe<ComWixpressSitepropertiesApiV4DayOfWeek>;
  /**
   * Time the period ends in 24-hour [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) extended format. Valid values are `00:00` to `24:00`, where `24:00` represents
   * midnight at the end of the specified day.
   *
   * __Note:__ If `openDay` and `closeDay` specify the same day of the week `closeTime` must be later than `openTime`.
   */
  closeTime?: Maybe<Scalars['String']>;
  /** Day of the week the period starts on. */
  openDay?: Maybe<ComWixpressSitepropertiesApiV4DayOfWeek>;
  /**
   * Time the period starts in 24-hour [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) extended format. Valid values are `00:00` to `24:00`, where `24:00` represents
   * midnight at the end of the specified day.
   */
  openTime?: Maybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4TimePeriodInput = {
  /** Day of the week the period ends on. */
  closeDay?: InputMaybe<ComWixpressSitepropertiesApiV4DayOfWeek>;
  /**
   * Time the period ends in 24-hour [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) extended format. Valid values are `00:00` to `24:00`, where `24:00` represents
   * midnight at the end of the specified day.
   *
   * __Note:__ If `openDay` and `closeDay` specify the same day of the week `closeTime` must be later than `openTime`.
   */
  closeTime?: InputMaybe<Scalars['String']>;
  /** Day of the week the period starts on. */
  openDay?: InputMaybe<ComWixpressSitepropertiesApiV4DayOfWeek>;
  /**
   * Time the period starts in 24-hour [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) extended format. Valid values are `00:00` to `24:00`, where `24:00` represents
   * midnight at the end of the specified day.
   */
  openTime?: InputMaybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4TranslationInput = {
  /** The application definition ID; this only applies to services of type ThirdPartyApps. */
  appDefId?: InputMaybe<Scalars['String']>;
  /** The instance ID of the service. */
  instanceId?: InputMaybe<Scalars['String']>;
  /** The service type. */
  serviceType?: InputMaybe<Scalars['String']>;
};

export type ComWixpressSitepropertiesApiV4UpdateBusinessContactRequestInput = {
  /** The site's business contact information. */
  businessContact?: InputMaybe<ComWixpressSitepropertiesApiV4BusinessContactDataInput>;
  /** The properties of `businessContact` to be updated. Properties not explicitly specified here are ignored. Properties included here but excluded from `businessContact` are cleared. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressSitepropertiesApiV4UpdateBusinessProfileRequestInput = {
  /** The site's business profile. */
  businessProfile?: InputMaybe<ComWixpressSitepropertiesApiV4BusinessProfileDataInput>;
  /** The properties of `businessProfile` to be updated. Properties not explicitly specified here are ignored. Properties included here but excluded from `businessProfile` are cleared. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComWixpressSitepropertiesApiV4UpdateBusinessScheduleRequestInput = {
  /** The site's business schedule in the site time zone. */
  businessSchedule?: InputMaybe<ComWixpressSitepropertiesApiV4BusinessScheduleInput>;
};

export type ComWixpressSitepropertiesApiV4UpdateConsentPolicyRequestInput = {
  /** Default consent policy defined by the Wix user. Can be further limited by site visitors. */
  consentPolicy?: InputMaybe<ComWixpressSitepropertiesApiV4ConsentPolicyInput>;
};

export type EcomCheckoutV1AddToCheckoutRequestInput = {
  /**
   * Custom line items. Custom line items don't trigger the Catalog service plugin.
   *
   * To access and manage custom line items, your app must have the permission scope named "Manage eCommerce - Admin Permissions".
   * Learn more about [permission scopes](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions).
   */
  customLineItems?: InputMaybe<Array<InputMaybe<ComWixEcomCartCheckoutCommonApiV1CustomLineItemInput>>>;
  /** Checkout ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Catalog line items. */
  lineItems?: InputMaybe<Array<InputMaybe<EcomCheckoutV1LineItemInput>>>;
};

export type EcomCheckoutV1AddToCheckoutResponse = {
  /** Updated checkout. */
  checkout?: Maybe<EcomCheckoutV1Checkout>;
};

export type EcomCheckoutV1AddressWithContact = {
  /** Address. */
  address?: Maybe<ComWixEcommercePlatformCommonApiAddress>;
  /** Reference to address service. */
  addressesServiceId?: Maybe<Scalars['String']>;
  /** Contact details. */
  contactDetails?: Maybe<ComWixEcommercePlatformCommonApiFullAddressContactDetails>;
};

export type EcomCheckoutV1AddressWithContactInput = {
  /** Address. */
  address?: InputMaybe<ComWixEcommercePlatformCommonApiAddressInput>;
  /** Reference to address service. */
  addressesServiceId?: InputMaybe<Scalars['String']>;
  /** Contact details. */
  contactDetails?: InputMaybe<ComWixEcommercePlatformCommonApiFullAddressContactDetailsInput>;
};

export type EcomCheckoutV1BuyerInfo = {
  /** Contact ID. Auto-created if one does not yet exist. For more information, see the Contacts API. */
  contact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
  /** Contact ID. Auto-created if one does not yet exist. For more information, see the Contacts API. */
  contactId?: Maybe<Scalars['String']>;
  /** Buyer email address. */
  email?: Maybe<Scalars['String']>;
  /** Member ID (if site visitor is a site member). */
  member?: Maybe<ComWixpressMembersApiMember>;
  /** Member ID (if site visitor is a site member). */
  memberId?: Maybe<Scalars['String']>;
  /**
   * + If `true`, the checkout doesn't have an owner yet and anyone can access it. The first to access it will be the new owner.
   * + If `false`, the value in `checkout.createdBy` is the owner.
   */
  openAccess?: Maybe<Scalars['Boolean']>;
  /** Visitor ID (if site visitor is **not** a member). */
  visitorId?: Maybe<Scalars['String']>;
};

export type EcomCheckoutV1BuyerInfoInput = {
  /** Contact ID. Auto-created if one does not yet exist. For more information, see the Contacts API. */
  contactId?: InputMaybe<Scalars['String']>;
  /** Buyer email address. */
  email?: InputMaybe<Scalars['String']>;
  /** Member ID (if site visitor is a site member). */
  memberId?: InputMaybe<Scalars['String']>;
  /**
   * + If `true`, the checkout doesn't have an owner yet and anyone can access it. The first to access it will be the new owner.
   * + If `false`, the value in `checkout.createdBy` is the owner.
   */
  openAccess?: InputMaybe<Scalars['Boolean']>;
  /** Visitor ID (if site visitor is **not** a member). */
  visitorId?: InputMaybe<Scalars['String']>;
};

export type EcomCheckoutV1Charge = {
  /** The billing date from which the charge starts. */
  cycleBillingDate?: Maybe<Scalars['String']>;
  /** The number of cycles for which the charge is applicable. */
  cycleCount?: Maybe<Scalars['Int']>;
  /** The cycle number from which the charge starts. */
  cycleFrom?: Maybe<Scalars['Int']>;
  /** Charge summary. */
  priceSummary?: Maybe<ComWixEcomTotalsCalculatorV1PriceSummary>;
};

export type EcomCheckoutV1ChargeInput = {
  /** The billing date from which the charge starts. */
  cycleBillingDate?: InputMaybe<Scalars['String']>;
  /** The number of cycles for which the charge is applicable. */
  cycleCount?: InputMaybe<Scalars['Int']>;
  /** The cycle number from which the charge starts. */
  cycleFrom?: InputMaybe<Scalars['Int']>;
  /** Charge summary. */
  priceSummary?: InputMaybe<ComWixEcomTotalsCalculatorV1PriceSummaryInput>;
};

export type EcomCheckoutV1Checkout = {
  /** Additional Fees. */
  additionalFees?: Maybe<Array<Maybe<ComWixEcomTotalsCalculatorV1AdditionalFee>>>;
  /** Applied discounts. */
  appliedDiscounts?: Maybe<Array<Maybe<ComWixEcomTotalsCalculatorV1AppliedDiscount>>>;
  /** Billing information. */
  billingInfo?: Maybe<EcomCheckoutV1AddressWithContact>;
  /**
   * The business location ID associated with the checkout.
   *
   * To learn more, see the Locations API.
   */
  businessLocationId?: Maybe<Scalars['String']>;
  /** Buyer information. */
  buyerInfo?: Maybe<EcomCheckoutV1BuyerInfo>;
  /**
   * Language for communication with the buyer. Defaults to the site language.
   *
   * For a site that supports multiple languages, this is the language the buyer selected.
   */
  buyerLanguage?: Maybe<Scalars['String']>;
  /** [Buyer note](https://support.wix.com/en/article/collecting-and-viewing-buyer-notes) left by the customer. */
  buyerNote?: Maybe<Scalars['String']>;
  /** Errors when calculating totals. */
  calculationErrors?: Maybe<ComWixEcomTotalsCalculatorV1CalculationErrors>;
  /** Cart ID that this checkout was created from. Empty if this checkout wasn't created from a cart. */
  cartId?: Maybe<Scalars['String']>;
  /** Sales channel that submitted the order. */
  channelType?: Maybe<ComWixEcommercePlatformCommonApiChannelType>;
  /**
   * Whether an order was successfully created from this checkout.
   *
   * For an order to be successful, it must be successfully paid for (unless the total is 0).
   */
  completed?: Maybe<Scalars['Boolean']>;
  /**
   * The currency [selected by the customer](https://support.wix.com/en/article/multicurrency-an-overview) during the purchase flow, in three-letter [ISO-4217 alphabetic](https://en.wikipedia.org/wiki/ISO_4217#Active_codes) format.
   *
   * This reflects the customer’s preferred display currency and may differ from the site’s default currency.
   * When no specific currency is selected by the customer, this matches the `currency` property.
   */
  conversionCurrency?: Maybe<Scalars['String']>;
  /** Information about the currency conversion that took place if at all. Empty if no conversion took place. */
  conversionInfo?: Maybe<EcomCheckoutV1ConversionInfo>;
  /** ID of the checkout's initiator. */
  createdBy?: Maybe<EcomCheckoutV1CreatedBy>;
  /** Date and time the checkout was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** The site’s default currency, in three-letter [ISO-4217 alphabetic](https://en.wikipedia.org/wiki/ISO_4217#Active_codes) format. This represents the base currency configured for the site and remains constant regardless of the customer’s currency selection. */
  currency?: Maybe<Scalars['String']>;
  /**
   * Reference IDs for the app and component providing custom checkout page content.
   *
   * To access and manage custom checkout page content, your app must have the permission scope named "Manage eCommerce - Admin Permissions".
   * Learn more about [permission scopes](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions).
   */
  customContentReference?: Maybe<ComWixEcomCartCheckoutCommonApiV1CustomContentReference>;
  /** Custom fields. */
  customFields?: Maybe<Array<Maybe<ComWixEcomOrdersV1CustomField>>>;
  /**
   * Additional settings for customization of the checkout process.
   *
   * > **Notes:**
   * > * Custom settings can only be set when creating a checkout.
   * > * To access and manage custom checkout page content, your app must have the permission scope named "Manage eCommerce - Admin Permissions". Learn more about [permission scopes](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions).
   */
  customSettings?: Maybe<EcomCheckoutV1CustomSettings>;
  /**
   * __Deprecated.__ Use `purchaseFlowId` instead.
   * @deprecated __Deprecated.__ Use `purchaseFlowId` instead. Removal date: 2025-04-01.
   */
  ecomId?: Maybe<Scalars['String']>;
  /**
   * Custom field data for the checkout object.
   *
   * [Extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields) must be configured in the app dashboard before they can be accessed with API calls.
   */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  externalEnrichedLineItems?: Maybe<ComWixEcomLineItemsEnricherSpiHostApiV1EnrichLineItemsForCheckoutResponse>;
  /**
   * References to an external app and resource associated with this checkout.
   * Used for integration and tracking across different platforms.
   */
  externalReference?: Maybe<ComWixEcommercePlatformCommonApiExternalReference>;
  /**
   * Applied gift card details.
   *
   * >**Note:** Gift cards are supported through the Wix UI, though the service plugin is not currently available. Learn more about [Wix Gift Cards](https://support.wix.com/en/article/setting-up-wix-gift-cards-9451439).
   */
  giftCard?: Maybe<ComWixEcomTotalsCalculatorV1GiftCard>;
  /** Checkout ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Line items.
   *
   * Max: 300 items
   */
  lineItems?: Maybe<Array<Maybe<EcomCheckoutV1LineItem>>>;
  /** Sum of all line items in the checkout. */
  lineItemsSubtotal?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /**
   * The business location ID associated with the checkout.
   *
   * To learn more, see the Locations API.
   */
  location?: Maybe<ComWixpressLocationsLocation>;
  /** Indicates whether this cart is managed by Cart V2. */
  managedByV2?: Maybe<Scalars['Boolean']>;
  /** Memberships to apply when creating the order. */
  membershipOptions?: Maybe<EcomCheckoutV1MembershipOptions>;
  /**
   * Order ID.
   *
   * This field is empty until the checkout completes and becomes an order.
   */
  orderId?: Maybe<Scalars['String']>;
  /** Payment for subscriptions after free trial period. */
  payAfterFreeTrial?: Maybe<ComWixEcomTotalsCalculatorV1PriceSummary>;
  /** Remaining amount for the order to be fully paid. */
  payLater?: Maybe<ComWixEcomTotalsCalculatorV1PriceSummary>;
  /** Minimal amount to pay in order to place the order. */
  payNow?: Maybe<ComWixEcomTotalsCalculatorV1PriceSummary>;
  /** The pay now total amount after gift card reduction */
  payNowTotalAfterGiftCard?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /**
   * The currency used for payment, in three-letter [ISO-4217 alphabetic](https://en.wikipedia.org/wiki/ISO_4217#Active_codes) format.
   *
   * This is determined by the [customer's selected currency](https://support.wix.com/en/article/multicurrency-an-overview) and the site’s supported payment currencies.
   * If the customer’s selected currency is supported for payment, this matches the `conversionCurrency` property. If not supported, this falls back to the `currency` property.
   */
  paymentCurrency?: Maybe<Scalars['String']>;
  /**
   * Whether payment is required to create an order.
   *
   * Payment is required if any of the following conditions are met:
   * 1. At least one item requires a payment method. This can be because the item has the `savePaymentMethod` field set to `true`, or the item is a subscription with a price greater than zero.
   * 2. The calculated total amount due for immediate payment is greater than zero - `checkout.payNow > 0`.
   */
  paymentRequired?: Maybe<Scalars['Boolean']>;
  /** Calculated price summary for the checkout. */
  priceSummary?: Maybe<ComWixEcomTotalsCalculatorV1PriceSummary>;
  /** Persistent ID that correlates between the various eCommerce elements: cart, checkout, and order. */
  purchaseFlowId?: Maybe<Scalars['String']>;
  /** Shipping information. */
  shippingInfo?: Maybe<EcomCheckoutV1ShippingInfo>;
  /** Site language in which original values are shown. */
  siteLanguage?: Maybe<Scalars['String']>;
  /** Charges information for each subscription in the checkout. */
  subscriptionCharges?: Maybe<Array<Maybe<EcomCheckoutV1SubscriptionCharges>>>;
  /** Tax exempt group ID to use for tax exemptions. */
  taxExemptGroup?: Maybe<WixBillingV1TaxExemptGroup>;
  /** Tax exempt group ID to use for tax exemptions. */
  taxExemptGroupId?: Maybe<Scalars['String']>;
  /** Whether tax is included in line item prices. */
  taxIncludedInPrice?: Maybe<Scalars['Boolean']>;
  /** Tax summary. */
  taxSummary?: Maybe<ComWixEcomTotalsCalculatorV1TaxSummary>;
  /** The total payment amount after gift card reduction */
  totalAfterGiftCard?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Date and time the checkout was updated. */
  updatedDate?: Maybe<Scalars['String']>;
  /** List of validation violations raised by the [Validations service plugin](https://dev.wix.com/docs/rest/business-solutions/e-commerce/service-plugins/validations-integration-service-plugin/introduction). */
  violations?: Maybe<Array<Maybe<ComWixEcommerceValidationsSpiV1Violation>>>;
  /** Weight measurement unit. Defaults to a site's weight unit. */
  weightUnit?: Maybe<ComWixEcommercePlatformCommonApiWeightUnit>;
};

export type EcomCheckoutV1CheckoutInput = {
  /** Additional Fees. */
  additionalFees?: InputMaybe<Array<InputMaybe<ComWixEcomTotalsCalculatorV1AdditionalFeeInput>>>;
  /** Applied discounts. */
  appliedDiscounts?: InputMaybe<Array<InputMaybe<ComWixEcomTotalsCalculatorV1AppliedDiscountInput>>>;
  /** Billing information. */
  billingInfo?: InputMaybe<EcomCheckoutV1AddressWithContactInput>;
  /**
   * The business location ID associated with the checkout.
   *
   * To learn more, see the Locations API.
   */
  businessLocationId?: InputMaybe<Scalars['String']>;
  /** Buyer information. */
  buyerInfo?: InputMaybe<EcomCheckoutV1BuyerInfoInput>;
  /**
   * Language for communication with the buyer. Defaults to the site language.
   *
   * For a site that supports multiple languages, this is the language the buyer selected.
   */
  buyerLanguage?: InputMaybe<Scalars['String']>;
  /** [Buyer note](https://support.wix.com/en/article/collecting-and-viewing-buyer-notes) left by the customer. */
  buyerNote?: InputMaybe<Scalars['String']>;
  /** Errors when calculating totals. */
  calculationErrors?: InputMaybe<ComWixEcomTotalsCalculatorV1CalculationErrorsInput>;
  /** Cart ID that this checkout was created from. Empty if this checkout wasn't created from a cart. */
  cartId?: InputMaybe<Scalars['String']>;
  /** Sales channel that submitted the order. */
  channelType?: InputMaybe<ComWixEcommercePlatformCommonApiChannelType>;
  /**
   * Whether an order was successfully created from this checkout.
   *
   * For an order to be successful, it must be successfully paid for (unless the total is 0).
   */
  completed?: InputMaybe<Scalars['Boolean']>;
  /**
   * The currency [selected by the customer](https://support.wix.com/en/article/multicurrency-an-overview) during the purchase flow, in three-letter [ISO-4217 alphabetic](https://en.wikipedia.org/wiki/ISO_4217#Active_codes) format.
   *
   * This reflects the customer’s preferred display currency and may differ from the site’s default currency.
   * When no specific currency is selected by the customer, this matches the `currency` property.
   */
  conversionCurrency?: InputMaybe<Scalars['String']>;
  /** Information about the currency conversion that took place if at all. Empty if no conversion took place. */
  conversionInfo?: InputMaybe<EcomCheckoutV1ConversionInfoInput>;
  /** ID of the checkout's initiator. */
  createdBy?: InputMaybe<EcomCheckoutV1CreatedByInput>;
  /** Date and time the checkout was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** The site’s default currency, in three-letter [ISO-4217 alphabetic](https://en.wikipedia.org/wiki/ISO_4217#Active_codes) format. This represents the base currency configured for the site and remains constant regardless of the customer’s currency selection. */
  currency?: InputMaybe<Scalars['String']>;
  /**
   * Reference IDs for the app and component providing custom checkout page content.
   *
   * To access and manage custom checkout page content, your app must have the permission scope named "Manage eCommerce - Admin Permissions".
   * Learn more about [permission scopes](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions).
   */
  customContentReference?: InputMaybe<ComWixEcomCartCheckoutCommonApiV1CustomContentReferenceInput>;
  /** Custom fields. */
  customFields?: InputMaybe<Array<InputMaybe<ComWixEcomOrdersV1CustomFieldInput>>>;
  /**
   * Additional settings for customization of the checkout process.
   *
   * > **Notes:**
   * > * Custom settings can only be set when creating a checkout.
   * > * To access and manage custom checkout page content, your app must have the permission scope named "Manage eCommerce - Admin Permissions". Learn more about [permission scopes](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions).
   */
  customSettings?: InputMaybe<EcomCheckoutV1CustomSettingsInput>;
  /**
   * Custom field data for the checkout object.
   *
   * [Extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields) must be configured in the app dashboard before they can be accessed with API calls.
   */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /**
   * References to an external app and resource associated with this checkout.
   * Used for integration and tracking across different platforms.
   */
  externalReference?: InputMaybe<ComWixEcommercePlatformCommonApiExternalReferenceInput>;
  /**
   * Applied gift card details.
   *
   * >**Note:** Gift cards are supported through the Wix UI, though the service plugin is not currently available. Learn more about [Wix Gift Cards](https://support.wix.com/en/article/setting-up-wix-gift-cards-9451439).
   */
  giftCard?: InputMaybe<ComWixEcomTotalsCalculatorV1GiftCardInput>;
  /** Checkout ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Line items.
   *
   * Max: 300 items
   */
  lineItems?: InputMaybe<Array<InputMaybe<EcomCheckoutV1LineItemInput>>>;
  /** Sum of all line items in the checkout. */
  lineItemsSubtotal?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Indicates whether this cart is managed by Cart V2. */
  managedByV2?: InputMaybe<Scalars['Boolean']>;
  /** Memberships to apply when creating the order. */
  membershipOptions?: InputMaybe<EcomCheckoutV1MembershipOptionsInput>;
  /**
   * Order ID.
   *
   * This field is empty until the checkout completes and becomes an order.
   */
  orderId?: InputMaybe<Scalars['String']>;
  /** Payment for subscriptions after free trial period. */
  payAfterFreeTrial?: InputMaybe<ComWixEcomTotalsCalculatorV1PriceSummaryInput>;
  /** Remaining amount for the order to be fully paid. */
  payLater?: InputMaybe<ComWixEcomTotalsCalculatorV1PriceSummaryInput>;
  /** Minimal amount to pay in order to place the order. */
  payNow?: InputMaybe<ComWixEcomTotalsCalculatorV1PriceSummaryInput>;
  /** The pay now total amount after gift card reduction */
  payNowTotalAfterGiftCard?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /**
   * The currency used for payment, in three-letter [ISO-4217 alphabetic](https://en.wikipedia.org/wiki/ISO_4217#Active_codes) format.
   *
   * This is determined by the [customer's selected currency](https://support.wix.com/en/article/multicurrency-an-overview) and the site’s supported payment currencies.
   * If the customer’s selected currency is supported for payment, this matches the `conversionCurrency` property. If not supported, this falls back to the `currency` property.
   */
  paymentCurrency?: InputMaybe<Scalars['String']>;
  /**
   * Whether payment is required to create an order.
   *
   * Payment is required if any of the following conditions are met:
   * 1. At least one item requires a payment method. This can be because the item has the `savePaymentMethod` field set to `true`, or the item is a subscription with a price greater than zero.
   * 2. The calculated total amount due for immediate payment is greater than zero - `checkout.payNow > 0`.
   */
  paymentRequired?: InputMaybe<Scalars['Boolean']>;
  /** Calculated price summary for the checkout. */
  priceSummary?: InputMaybe<ComWixEcomTotalsCalculatorV1PriceSummaryInput>;
  /** Persistent ID that correlates between the various eCommerce elements: cart, checkout, and order. */
  purchaseFlowId?: InputMaybe<Scalars['String']>;
  /** Shipping information. */
  shippingInfo?: InputMaybe<EcomCheckoutV1ShippingInfoInput>;
  /** Site language in which original values are shown. */
  siteLanguage?: InputMaybe<Scalars['String']>;
  /** Charges information for each subscription in the checkout. */
  subscriptionCharges?: InputMaybe<Array<InputMaybe<EcomCheckoutV1SubscriptionChargesInput>>>;
  /** Tax exempt group ID to use for tax exemptions. */
  taxExemptGroupId?: InputMaybe<Scalars['String']>;
  /** Whether tax is included in line item prices. */
  taxIncludedInPrice?: InputMaybe<Scalars['Boolean']>;
  /** Tax summary. */
  taxSummary?: InputMaybe<ComWixEcomTotalsCalculatorV1TaxSummaryInput>;
  /** The total payment amount after gift card reduction */
  totalAfterGiftCard?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Date and time the checkout was updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** List of validation violations raised by the [Validations service plugin](https://dev.wix.com/docs/rest/business-solutions/e-commerce/service-plugins/validations-integration-service-plugin/introduction). */
  violations?: InputMaybe<Array<InputMaybe<ComWixEcommerceValidationsSpiV1ViolationInput>>>;
  /** Weight measurement unit. Defaults to a site's weight unit. */
  weightUnit?: InputMaybe<ComWixEcommercePlatformCommonApiWeightUnit>;
};

export type EcomCheckoutV1ConversionInfo = {
  /** The rate used when converting from the site currency to the checkout currency. */
  conversionRate?: Maybe<Scalars['String']>;
  /** The site currency. */
  siteCurrency?: Maybe<Scalars['String']>;
};

export type EcomCheckoutV1ConversionInfoInput = {
  /** The rate used when converting from the site currency to the checkout currency. */
  conversionRate?: InputMaybe<Scalars['String']>;
  /** The site currency. */
  siteCurrency?: InputMaybe<Scalars['String']>;
};

export type EcomCheckoutV1CreateCheckoutRequestInput = {
  /** Sales channel that submitted the order. */
  channelType?: InputMaybe<ComWixEcommercePlatformCommonApiChannelType>;
  /** Checkout information. */
  checkoutInfo?: InputMaybe<EcomCheckoutV1CheckoutInput>;
  /** Coupon code. */
  couponCode?: InputMaybe<Scalars['String']>;
  /**
   * Custom line items to add to the checkout. Custom line items don't trigger the Catalog service plugin.
   *
   * To access and manage custom line items, your app must have the permission scope named "Manage eCommerce - Admin Permissions".
   * Learn more about [permission scopes](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions).
   */
  customLineItems?: InputMaybe<Array<InputMaybe<ComWixEcomCartCheckoutCommonApiV1CustomLineItemInput>>>;
  /**
   * Gift card code.
   *
   * The checkout can only hold 1 `giftCardCode` at a time. If an additional `giftCardCode` is added, it will override the existing `giftCardCode`.
   *
   * >**Note:** Gift cards are supported through the Wix UI, though the service plugin is not currently available. Learn more about [Wix Gift Cards](https://support.wix.com/en/article/setting-up-wix-gift-cards-9451439).
   */
  giftCardCode?: InputMaybe<Scalars['String']>;
  /** Amount to redeem from the gift card referenced in `gift_card_code`. */
  giftCardRedeemAmount?: InputMaybe<Scalars['String']>;
  /** Catalog line items to add to the checkout. */
  lineItems?: InputMaybe<Array<InputMaybe<EcomCheckoutV1LineItemInput>>>;
  /**
   * `overrideCheckoutUrl` allows the flexibility to redirect customers to a customized checkout page.
   *
   * This field overrides the `checkoutUrl` in a cart or checkout. `checkoutUrl` is used in the Abandoned Checkout API
   * to send customers back to their checkouts. By default, a `checkoutUrl` generates for a checkout and directs to a
   * standard Wix checkout page. When `overrideCheckoutUrl` has a value, it will replace and set the value of `checkoutUrl`.
   */
  overrideCheckoutUrl?: InputMaybe<Scalars['String']>;
};

export type EcomCheckoutV1CreateCheckoutResponse = {
  /** Newly created checkout. */
  checkout?: Maybe<EcomCheckoutV1Checkout>;
};

export type EcomCheckoutV1CreateOrderAndChargeRequestInput = {
  /** Whether to authorize the payment and delay the capture. */
  delayCapture?: InputMaybe<Scalars['Boolean']>;
  /** Checkout ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Payment token. */
  paymentToken?: InputMaybe<Scalars['String']>;
  /** Whether the payment method should be saved on the order. */
  savePaymentMethod?: InputMaybe<Scalars['Boolean']>;
  /** Custom URL params to be added to redirect URLs. */
  urlParams?: InputMaybe<Scalars['JSON']>;
};

export type EcomCheckoutV1CreateOrderAndChargeResponse = {
  /** Whether an order was successfully created from this checkout and the payment transaction was completed */
  checkoutCompleted?: Maybe<Scalars['Boolean']>;
  /** ID of newly created order. */
  orderId?: Maybe<Scalars['String']>;
  /**
   * The payment gateway is cashier.
   * payment_gateway_order_id will be returned given that money was charged.
   * In some cases, money will not be charged:
   * If the total price is 0 - For example, could be a free item or a an item with 100% discount
   * If the total price is not 0, but the payment is covered by alternative payment methods such as gift card
   */
  paymentGatewayOrderId?: Maybe<Scalars['String']>;
  /** Payment response token. */
  paymentResponseToken?: Maybe<Scalars['String']>;
  /** ID of newly created subscription. */
  subscriptionId?: Maybe<Scalars['String']>;
};

export type EcomCheckoutV1CreateOrderRequestInput = {
  /** Whether to authorize the payment and delay the capture. */
  delayCapture?: InputMaybe<Scalars['Boolean']>;
  /** Checkout ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Whether the payment method should be saved on the order. */
  savePaymentMethod?: InputMaybe<Scalars['Boolean']>;
  /** Custom URL params to be added to redirect URLs. */
  urlParams?: InputMaybe<Scalars['JSON']>;
};

export type EcomCheckoutV1CreateOrderResponse = {
  /** ID of newly created order. */
  orderId?: Maybe<Scalars['String']>;
  /**
   * Payment gateway order ID.
   *
   * For online orders, pass this value as the `paymentId` parameter to the Wix Pay [`startPayment()`](https://www.wix.com/velo/reference/wix-pay-frontend/startpayment) function so your customer can pay for the order.
   * `paymentGatewayOrderId` will be returned if money needs to be charged.
   *
   * In some cases, money cannot be charged:
   * + When the total price (the `priceSummary.total.amount` field in the checkout/order objects) is `0`. For example, in the case of a free item or an item with a 100% discount.
   * + If the total price is not `0`, but the payment is covered by alternative payment methods, such as a gift card.
   */
  paymentGatewayOrderId?: Maybe<Scalars['String']>;
  /** ID of newly created subscription. Learn more about your site's [Subscriptions](https://support.wix.com/en/article/wix-stores-managing-product-subscriptions). */
  subscriptionId?: Maybe<Scalars['String']>;
};

export type EcomCheckoutV1CreatedBy = {
  /** App ID. When the order was created by an external application or Wix service. */
  appId?: Maybe<Scalars['String']>;
  /** Member ID. When the order was created by a **logged in** site visitor. */
  member?: Maybe<ComWixpressMembersApiMember>;
  /** Member ID. When the order was created by a **logged in** site visitor. */
  memberId?: Maybe<Scalars['String']>;
  /**
   * User ID. When the order was created by a Wix user on behalf of a buyer.
   * For example, via POS (point of service).
   */
  userId?: Maybe<Scalars['String']>;
  /** Visitor ID. When the order was created by a site visitor that was **not** logged in. */
  visitorId?: Maybe<Scalars['String']>;
};

export type EcomCheckoutV1CreatedByInput = {
  /** App ID. When the order was created by an external application or Wix service. */
  appId?: InputMaybe<Scalars['String']>;
  /** Member ID. When the order was created by a **logged in** site visitor. */
  memberId?: InputMaybe<Scalars['String']>;
  /**
   * User ID. When the order was created by a Wix user on behalf of a buyer.
   * For example, via POS (point of service).
   */
  userId?: InputMaybe<Scalars['String']>;
  /** Visitor ID. When the order was created by a site visitor that was **not** logged in. */
  visitorId?: InputMaybe<Scalars['String']>;
};

export type EcomCheckoutV1CustomSettings = {
  /**
   * Whether to disable manual payment option for this checkout.
   *
   * Default: `false`
   */
  disabledManualPayment?: Maybe<Scalars['Boolean']>;
  /**
   * Whether to disable policy agreement checkout in the checkout page
   *
   * Default: `false`
   */
  disabledPolicyAgreementCheckbox?: Maybe<Scalars['Boolean']>;
  /**
   * Whether to restrict the option to add or remove a coupon code on the checkout page.
   *
   * Default: `false`
   */
  lockCouponCode?: Maybe<Scalars['Boolean']>;
  /**
   * Whether to restrict the option to add or remove a gift card on the checkout page.
   *
   * Default: `false`
   */
  lockGiftCard?: Maybe<Scalars['Boolean']>;
};

export type EcomCheckoutV1CustomSettingsInput = {
  /**
   * Whether to disable manual payment option for this checkout.
   *
   * Default: `false`
   */
  disabledManualPayment?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to disable policy agreement checkout in the checkout page
   *
   * Default: `false`
   */
  disabledPolicyAgreementCheckbox?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to restrict the option to add or remove a coupon code on the checkout page.
   *
   * Default: `false`
   */
  lockCouponCode?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to restrict the option to add or remove a gift card on the checkout page.
   *
   * Default: `false`
   */
  lockGiftCard?: InputMaybe<Scalars['Boolean']>;
};

export type EcomCheckoutV1DeleteCheckoutRequestInput = {
  /** ID of the checkout to delete. */
  id?: InputMaybe<Scalars['String']>;
};

export type EcomCheckoutV1GetCheckoutByCartIdRequestInput = {
  /** Cart ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type EcomCheckoutV1GetCheckoutByCartIdResponse = {
  /** Retrieved checkout. */
  checkout?: Maybe<EcomCheckoutV1Checkout>;
};

export type EcomCheckoutV1GetCheckoutPaymentSettingsRequestInput = {
  /** Checkout ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type EcomCheckoutV1GetCheckoutPaymentSettingsResponse = {
  blockedPaymentOptions?: Maybe<Array<Maybe<EcomCheckoutV1PaymentOption>>>;
};

export type EcomCheckoutV1GetCheckoutRequestInput = {
  id: Scalars['ID'];
  /** Whether to refresh the checkout from external sources. Defaults to true. */
  refresh?: InputMaybe<Scalars['Boolean']>;
};

export type EcomCheckoutV1GetCheckoutResponse = {
  /** The requested checkout. */
  checkout?: Maybe<EcomCheckoutV1Checkout>;
};

export type EcomCheckoutV1GetCheckoutUrlRequestInput = {
  /** Checkout currency parameter to append as a query param */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checkout ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type EcomCheckoutV1GetCheckoutUrlResponse = {
  /** Checkout URL. */
  checkoutUrl?: Maybe<Scalars['String']>;
};

export type EcomCheckoutV1GetCheckoutWithAllExtendedFieldsRequestInput = {
  /** Checkout ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Whether to refresh the checkout from external sources. Defaults to true. */
  refresh?: InputMaybe<Scalars['Boolean']>;
};

export type EcomCheckoutV1GetCheckoutWithAllExtendedFieldsResponse = {
  /** Retrieved checkout. */
  checkout?: Maybe<EcomCheckoutV1Checkout>;
};

export type EcomCheckoutV1GetWixCheckoutUrlRequestInput = {
  /** cart id to compare with for migration period */
  cartId?: InputMaybe<Scalars['String']>;
  /** checkout currency parameter to append */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Checkout ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type EcomCheckoutV1GetWixCheckoutUrlResponse = {
  /** Checkout URL. */
  checkoutUrl?: Maybe<Scalars['String']>;
};

export type EcomCheckoutV1ItemAvailabilityInfo = {
  /** Quantity available. */
  quantityAvailable?: Maybe<Scalars['Int']>;
  /** Item availability status. */
  status?: Maybe<EcomCheckoutV1ItemAvailabilityStatus>;
};

export type EcomCheckoutV1ItemAvailabilityInfoInput = {
  /** Quantity available. */
  quantityAvailable?: InputMaybe<Scalars['Int']>;
  /** Item availability status. */
  status?: InputMaybe<EcomCheckoutV1ItemAvailabilityStatus>;
};

export enum EcomCheckoutV1ItemAvailabilityStatus {
  AVAILABLE = 'AVAILABLE',
  /** Item is not in stock. */
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  /** Item does not exist. */
  NOT_FOUND = 'NOT_FOUND',
  /** Available quantity is less than requested. */
  PARTIALLY_AVAILABLE = 'PARTIALLY_AVAILABLE'
}

export type EcomCheckoutV1LineItem = {
  /** Item availability details. */
  availability?: Maybe<EcomCheckoutV1ItemAvailabilityInfo>;
  /**
   * Overriding values for catalog item properties.
   *
   * To override catalog fields, your app must have the permission scope named "Manage eCommerce - Admin Permissions".
   * Learn more about [permission scopes](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions).
   */
  catalogOverrideFields?: Maybe<ComWixEcomCartCheckoutCommonApiV1CatalogOverrideFields>;
  /** Catalog and item reference. Includes IDs for the item and the catalog it came from, as well as further optional info. Optional for custom line items, which don't trigger the Catalog service plugin. */
  catalogReference?: Maybe<ComWixEcommerceCatalogSpiApiV1CatalogReference>;
  /** Item payment policy that requires customer consent to complete purchase. The payment policy will be displayed on the checkout page. */
  consentRequiredPaymentPolicy?: Maybe<Scalars['String']>;
  /**
   * Coupon scopes - which app and items a coupon applies to.
   * This field is internal to Wix, and should be used by Bookings, Stores and Events as used by the Coupons API.
   */
  couponScopes?: Maybe<Array<Maybe<WixCouponsApiV2Scope>>>;
  /** Whether the line item is a custom line item. Custom line items don't trigger the Catalog service plugin. */
  customLineItem?: Maybe<Scalars['Boolean']>;
  /** Delivery profile ID. */
  deliveryProfileId?: Maybe<Scalars['String']>;
  /** Partial payment to be paid upfront during the checkout. Eligible for catalog items with `lineItem.paymentOption` type `DEPOSIT_ONLINE` only. */
  depositAmount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Line item description lines. Used for display purposes for the cart, checkout and order. */
  descriptionLines?: Maybe<Array<Maybe<ComWixEcommerceCatalogSpiApiV1DescriptionLine>>>;
  /** Digital file identifier, relevant only for items with type `DIGITAL`. */
  digitalFile?: Maybe<ComWixEcommerceCatalogSpiApiV1SecuredMedia>;
  /** Discount for this line item's entire quantity. */
  discount?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /**
   * Custom extended fields for the line item object.
   *
   * [Extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields) must be configured using the 'Checkout & Orders - Line Items Schema Plugin' in the app dashboard before they can be accessed with API calls.
   */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** Whether the line item quantity is fixed and cannot be changed. */
  fixedQuantity?: Maybe<Scalars['Boolean']>;
  /** Fulfiller ID for this item. Field is empty when the item is self-fulfilled. */
  fulfillerId?: Maybe<Scalars['String']>;
  /** Item price **before** catalog-defined discount. Defaults to `price` when not provided. */
  fullPrice?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Line item ID. */
  id?: Maybe<Scalars['String']>;
  /** ID of the app managing the inventory. */
  inventoryAppId?: Maybe<Scalars['String']>;
  /** Item type. Either a preset type or custom. */
  itemType?: Maybe<ComWixEcommerceCatalogSpiApiV1ItemType>;
  /** Total line item price **after** catalog-defined discount and line item discounts. */
  lineItemPrice?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Line item image details. */
  media?: Maybe<WixCommonImage>;
  /**
   * Whether the item can only be purchased by site members.
   *
   * Default: `false`
   */
  membersOnly?: Maybe<Scalars['Boolean']>;
  /** Modifier groups that were added to the item. */
  modifierGroups?: Maybe<Array<Maybe<ComWixEcomCartCheckoutCommonApiV1ModifierGroup>>>;
  /** Total price of all item modifiers. Included in the item price. */
  modifiersTotalPrice?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Original item full price. */
  originalFullPrice?: Maybe<Scalars['String']>;
  /** Original item price. */
  originalPrice?: Maybe<Scalars['String']>;
  /**
   * Type of selected payment option for current item.
   *
   * Default: `FULL_PAYMENT_ONLINE`
   */
  paymentOption?: Maybe<ComWixEcommerceCatalogSpiApiV1PaymentOptionType>;
  /** Physical properties of the item. When relevant, contains information such as SKU, item weight, and shippability. */
  physicalProperties?: Maybe<ComWixEcommerceCatalogSpiApiV1PhysicalProperties>;
  /** Policies to be displayed to the customer on the checkout page. */
  policies?: Maybe<Array<Maybe<ComWixEcommerceCatalogSpiApiV1Policy>>>;
  /** Item price **after** catalog-defined discount and line item discounts. */
  price?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Item price **before** line item discounts and **after** catalog-defined discount. Defaults to `price` when not provided. */
  priceBeforeDiscounts?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Item price before line item discounts and tax. */
  priceBeforeDiscountsAndTax?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Additional description for the price. For example, when price is 0 but additional details about the actual price are needed - "Starts at $67". */
  priceDescription?: Maybe<ComWixEcommerceCatalogSpiApiV1PriceDescription>;
  /** Whether the price is not yet defined, and will be updated after the order is created. */
  priceUndetermined?: Maybe<Scalars['Boolean']>;
  /**
   * Item name.
   * + Stores - `product.name`
   * + Bookings - `service.info.name`
   * + Events - `ticket.name`
   */
  productName?: Maybe<ComWixEcommerceCatalogSpiApiV1ProductName>;
  /**
   * Item quantity.
   *
   * Min: `"1"`
   * Max: `"100000"`
   */
  quantity?: Maybe<Scalars['Int']>;
  /**
   * In cases where `catalogReference.catalogItemId` is NOT the actual catalog item ID, this field will return the true item's ID.
   * + For example, for Wix Bookings, `catalogReference.catalogItemId` is the booking ID. Therefore this value is set to the service ID.
   * + In most cases, this field has the same value as `catalogReference.catalogItemId`.
   * + Used in membership validation.
   */
  rootCatalogItemId?: Maybe<Scalars['String']>;
  /**
   * Whether to save the payment method on the order.
   *
   * Default: `false`
   */
  savePaymentMethod?: Maybe<Scalars['Boolean']>;
  /** Service properties. When relevant, this contains information such as date and number of participants. */
  serviceProperties?: Maybe<ComWixEcommerceCatalogSpiApiV1ServiceProperties>;
  /** Shipping group ID. */
  shippingGroupId?: Maybe<Scalars['String']>;
  /** Subscription option information. */
  subscriptionOptionInfo?: Maybe<ComWixEcommerceCatalogSpiApiV1SubscriptionOptionInfo>;
  /** Tax details for this line item. */
  taxDetails?: Maybe<ComWixEcomTotalsCalculatorV1ItemTaxFullDetails>;
  /** Address to use for tax calculation purposes. */
  taxableAddress?: Maybe<ComWixEcommercePlatformCommonApiTaxableAddress>;
  /** Total price after all discounts and tax. */
  totalPriceAfterTax?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** Total price after discounts, and before tax. */
  totalPriceBeforeTax?: Maybe<ComWixEcommercePlatformCommonApiMultiCurrencyPrice>;
  /** URL to the item's page on the site. */
  url?: Maybe<WixCommonPageUrlV2>;
};

export type EcomCheckoutV1LineItemInput = {
  /** Item availability details. */
  availability?: InputMaybe<EcomCheckoutV1ItemAvailabilityInfoInput>;
  /**
   * Overriding values for catalog item properties.
   *
   * To override catalog fields, your app must have the permission scope named "Manage eCommerce - Admin Permissions".
   * Learn more about [permission scopes](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions).
   */
  catalogOverrideFields?: InputMaybe<ComWixEcomCartCheckoutCommonApiV1CatalogOverrideFieldsInput>;
  /** Catalog and item reference. Includes IDs for the item and the catalog it came from, as well as further optional info. Optional for custom line items, which don't trigger the Catalog service plugin. */
  catalogReference?: InputMaybe<ComWixEcommerceCatalogSpiApiV1CatalogReferenceInput>;
  /** Item payment policy that requires customer consent to complete purchase. The payment policy will be displayed on the checkout page. */
  consentRequiredPaymentPolicy?: InputMaybe<Scalars['String']>;
  /**
   * Coupon scopes - which app and items a coupon applies to.
   * This field is internal to Wix, and should be used by Bookings, Stores and Events as used by the Coupons API.
   */
  couponScopes?: InputMaybe<Array<InputMaybe<WixCouponsApiV2ScopeInput>>>;
  /** Whether the line item is a custom line item. Custom line items don't trigger the Catalog service plugin. */
  customLineItem?: InputMaybe<Scalars['Boolean']>;
  /** Delivery profile ID. */
  deliveryProfileId?: InputMaybe<Scalars['String']>;
  /** Partial payment to be paid upfront during the checkout. Eligible for catalog items with `lineItem.paymentOption` type `DEPOSIT_ONLINE` only. */
  depositAmount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Line item description lines. Used for display purposes for the cart, checkout and order. */
  descriptionLines?: InputMaybe<Array<InputMaybe<ComWixEcommerceCatalogSpiApiV1DescriptionLineInput>>>;
  /** Digital file identifier, relevant only for items with type `DIGITAL`. */
  digitalFile?: InputMaybe<ComWixEcommerceCatalogSpiApiV1SecuredMediaInput>;
  /** Discount for this line item's entire quantity. */
  discount?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /**
   * Custom extended fields for the line item object.
   *
   * [Extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields) must be configured using the 'Checkout & Orders - Line Items Schema Plugin' in the app dashboard before they can be accessed with API calls.
   */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** Whether the line item quantity is fixed and cannot be changed. */
  fixedQuantity?: InputMaybe<Scalars['Boolean']>;
  /** Fulfiller ID for this item. Field is empty when the item is self-fulfilled. */
  fulfillerId?: InputMaybe<Scalars['String']>;
  /** Item price **before** catalog-defined discount. Defaults to `price` when not provided. */
  fullPrice?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Line item ID. */
  id?: InputMaybe<Scalars['String']>;
  /** ID of the app managing the inventory. */
  inventoryAppId?: InputMaybe<Scalars['String']>;
  /** Item type. Either a preset type or custom. */
  itemType?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ItemTypeInput>;
  /** Total line item price **after** catalog-defined discount and line item discounts. */
  lineItemPrice?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Line item image details. */
  media?: InputMaybe<WixCommonImageInput>;
  /**
   * Whether the item can only be purchased by site members.
   *
   * Default: `false`
   */
  membersOnly?: InputMaybe<Scalars['Boolean']>;
  /** Modifier groups that were added to the item. */
  modifierGroups?: InputMaybe<Array<InputMaybe<ComWixEcomCartCheckoutCommonApiV1ModifierGroupInput>>>;
  /** Total price of all item modifiers. Included in the item price. */
  modifiersTotalPrice?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Original item full price. */
  originalFullPrice?: InputMaybe<Scalars['String']>;
  /** Original item price. */
  originalPrice?: InputMaybe<Scalars['String']>;
  /**
   * Type of selected payment option for current item.
   *
   * Default: `FULL_PAYMENT_ONLINE`
   */
  paymentOption?: InputMaybe<ComWixEcommerceCatalogSpiApiV1PaymentOptionType>;
  /** Physical properties of the item. When relevant, contains information such as SKU, item weight, and shippability. */
  physicalProperties?: InputMaybe<ComWixEcommerceCatalogSpiApiV1PhysicalPropertiesInput>;
  /** Policies to be displayed to the customer on the checkout page. */
  policies?: InputMaybe<Array<InputMaybe<ComWixEcommerceCatalogSpiApiV1PolicyInput>>>;
  /** Item price **after** catalog-defined discount and line item discounts. */
  price?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Item price **before** line item discounts and **after** catalog-defined discount. Defaults to `price` when not provided. */
  priceBeforeDiscounts?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Item price before line item discounts and tax. */
  priceBeforeDiscountsAndTax?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Additional description for the price. For example, when price is 0 but additional details about the actual price are needed - "Starts at $67". */
  priceDescription?: InputMaybe<ComWixEcommerceCatalogSpiApiV1PriceDescriptionInput>;
  /** Whether the price is not yet defined, and will be updated after the order is created. */
  priceUndetermined?: InputMaybe<Scalars['Boolean']>;
  /**
   * Item name.
   * + Stores - `product.name`
   * + Bookings - `service.info.name`
   * + Events - `ticket.name`
   */
  productName?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ProductNameInput>;
  /**
   * Item quantity.
   *
   * Min: `"1"`
   * Max: `"100000"`
   */
  quantity?: InputMaybe<Scalars['Int']>;
  /**
   * In cases where `catalogReference.catalogItemId` is NOT the actual catalog item ID, this field will return the true item's ID.
   * + For example, for Wix Bookings, `catalogReference.catalogItemId` is the booking ID. Therefore this value is set to the service ID.
   * + In most cases, this field has the same value as `catalogReference.catalogItemId`.
   * + Used in membership validation.
   */
  rootCatalogItemId?: InputMaybe<Scalars['String']>;
  /**
   * Whether to save the payment method on the order.
   *
   * Default: `false`
   */
  savePaymentMethod?: InputMaybe<Scalars['Boolean']>;
  /** Service properties. When relevant, this contains information such as date and number of participants. */
  serviceProperties?: InputMaybe<ComWixEcommerceCatalogSpiApiV1ServicePropertiesInput>;
  /** Shipping group ID. */
  shippingGroupId?: InputMaybe<Scalars['String']>;
  /** Subscription option information. */
  subscriptionOptionInfo?: InputMaybe<ComWixEcommerceCatalogSpiApiV1SubscriptionOptionInfoInput>;
  /** Tax details for this line item. */
  taxDetails?: InputMaybe<ComWixEcomTotalsCalculatorV1ItemTaxFullDetailsInput>;
  /** Address to use for tax calculation purposes. */
  taxableAddress?: InputMaybe<ComWixEcommercePlatformCommonApiTaxableAddressInput>;
  /** Total price after all discounts and tax. */
  totalPriceAfterTax?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** Total price after discounts, and before tax. */
  totalPriceBeforeTax?: InputMaybe<ComWixEcommercePlatformCommonApiMultiCurrencyPriceInput>;
  /** URL to the item's page on the site. */
  url?: InputMaybe<WixCommonPageUrlV2Input>;
};

export type EcomCheckoutV1LineItemQuantityUpdateInput = {
  /** ID of the line item to update. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * New total amount of the line item,
   * not the amount to add to the current `quantity`.
   *
   * Min: `1`
   *
   * Max: `100000`
   */
  quantity?: InputMaybe<Scalars['Int']>;
};

export type EcomCheckoutV1MarkCheckoutAsCompletedAndRedirectToUrlRequestInput = {
  /** Server-signed JWT token with required information to complete checkout */
  token?: InputMaybe<Scalars['String']>;
};

export type EcomCheckoutV1MarkCheckoutAsCompletedRequestInput = {
  /** Checkout ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Order ID. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type EcomCheckoutV1MembershipOptions = {
  /** Reserved for internal use. */
  eligibleMemberships?: Maybe<Array<Maybe<ComWixEcomMembershipsSpiV1HostMembership>>>;
  /** Reserved for internal use. */
  invalidMemberships?: Maybe<Array<Maybe<ComWixEcomMembershipsSpiV1HostInvalidMembership>>>;
  /** Selected membership to apply to this checkout. */
  selectedMemberships?: Maybe<ComWixEcomMembershipsSpiV1HostSelectedMemberships>;
};

export type EcomCheckoutV1MembershipOptionsInput = {
  /** Reserved for internal use. */
  eligibleMemberships?: InputMaybe<Array<InputMaybe<ComWixEcomMembershipsSpiV1HostMembershipInput>>>;
  /** Reserved for internal use. */
  invalidMemberships?: InputMaybe<Array<InputMaybe<ComWixEcomMembershipsSpiV1HostInvalidMembershipInput>>>;
  /** Selected membership to apply to this checkout. */
  selectedMemberships?: InputMaybe<ComWixEcomMembershipsSpiV1HostSelectedMembershipsInput>;
};

export enum EcomCheckoutV1PaymentOption {
  MANUAL = 'MANUAL',
  UNKNOWN_PAYMENT_OPTION = 'UNKNOWN_PAYMENT_OPTION'
}

export type EcomCheckoutV1RemoveCouponRequestInput = {
  /** ID of the checkout to remove the coupon from. */
  id?: InputMaybe<Scalars['String']>;
};

export type EcomCheckoutV1RemoveCouponResponse = {
  /** Updated checkout after removal of coupon. */
  checkout?: Maybe<EcomCheckoutV1Checkout>;
};

export type EcomCheckoutV1RemoveGiftCardRequestInput = {
  /** ID of the checkout to remove the gift card from. */
  id?: InputMaybe<Scalars['String']>;
};

export type EcomCheckoutV1RemoveGiftCardResponse = {
  /** Updated checkout after removal of gift card. */
  checkout?: Maybe<EcomCheckoutV1Checkout>;
};

export type EcomCheckoutV1RemoveLineItemsRequestInput = {
  /** ID of the checkout to remove line items from. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * IDs of the line items to remove from the checkout.
   *
   * To find the IDs of the checkout line items you'd like to remove,
   * pass the checkout ID to Get Checkout and look for the IDs under
   * `lineItems`.
   */
  lineItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EcomCheckoutV1RemoveLineItemsResponse = {
  /** Updated checkout after removal of line items. */
  checkout?: Maybe<EcomCheckoutV1Checkout>;
};

export type EcomCheckoutV1RemoveOverrideCheckoutUrlRequestInput = {
  /** ID of the checkout to remove the override checkout url from. */
  id?: InputMaybe<Scalars['String']>;
};

export type EcomCheckoutV1RemoveOverrideCheckoutUrlResponse = {
  /** Updated checkout after removal of override checkout url. */
  checkout?: Maybe<EcomCheckoutV1Checkout>;
};

export type EcomCheckoutV1ShippingInfo = {
  /** All carrier options for this shipping rule. */
  carrierServiceOptions?: Maybe<Array<Maybe<ComWixEcomTotalsCalculatorV1CarrierServiceOption>>>;
  /** Shipping region. Based on the address provided. */
  region?: Maybe<ComWixEcomTotalsCalculatorV1ShippingRegion>;
  /** Selected option out of the options allowed for the `region`. */
  selectedCarrierServiceOption?: Maybe<ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOption>;
  /** Shipping address and contact details. */
  shippingDestination?: Maybe<EcomCheckoutV1AddressWithContact>;
};

export type EcomCheckoutV1ShippingInfoInput = {
  /** All carrier options for this shipping rule. */
  carrierServiceOptions?: InputMaybe<Array<InputMaybe<ComWixEcomTotalsCalculatorV1CarrierServiceOptionInput>>>;
  /** Shipping region. Based on the address provided. */
  region?: InputMaybe<ComWixEcomTotalsCalculatorV1ShippingRegionInput>;
  /** Selected option out of the options allowed for the `region`. */
  selectedCarrierServiceOption?: InputMaybe<ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionInput>;
  /** Shipping address and contact details. */
  shippingDestination?: InputMaybe<EcomCheckoutV1AddressWithContactInput>;
};

export type EcomCheckoutV1SubscriptionCharges = {
  /** Charges for subscription. */
  charges?: Maybe<Array<Maybe<EcomCheckoutV1Charge>>>;
  /**
   * Generated description explaining future charges amount and schedule.
   * Translated to subscription order buyer language, or to site language if was not provided.
   */
  description?: Maybe<Scalars['String']>;
  /** ids of the items the subscription is defined on */
  lineItemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type EcomCheckoutV1SubscriptionChargesInput = {
  /** Charges for subscription. */
  charges?: InputMaybe<Array<InputMaybe<EcomCheckoutV1ChargeInput>>>;
  /**
   * Generated description explaining future charges amount and schedule.
   * Translated to subscription order buyer language, or to site language if was not provided.
   */
  description?: InputMaybe<Scalars['String']>;
  /** ids of the items the subscription is defined on */
  lineItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EcomCheckoutV1UpdateCheckoutRequestInput = {
  /** Checkout information. */
  checkout?: InputMaybe<EcomCheckoutV1CheckoutInput>;
  /**
   * Coupon code.
   *
   * The checkout can only hold 1 `couponCode` at a time. If an additional `couponCode` is added, it will override the existing `couponCode`.
   */
  couponCode?: InputMaybe<Scalars['String']>;
  /**
   * Custom line items. Custom line items don't trigger the Catalog service plugin.
   *
   * To access and manage custom line items, your app must have the permission scope named "Manage eCommerce - Admin Permissions".
   * Learn more about [permission scopes](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions).
   */
  customLineItems?: InputMaybe<Array<InputMaybe<ComWixEcomCartCheckoutCommonApiV1CustomLineItemInput>>>;
  /** Set of fields to update. Fields are inferred. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Gift card code. */
  giftCardCode?: InputMaybe<Scalars['String']>;
  /** Amount to redeem from the gift card referenced in `gift_card_code`. */
  giftCardRedeemAmount?: InputMaybe<Scalars['String']>;
  /** When true, calculation errors won't fail the update request. When empty or false, the update won't happen and relevant error will return */
  ignoreCalculationErrors?: InputMaybe<Scalars['Boolean']>;
  /** Catalog line items. */
  lineItems?: InputMaybe<Array<InputMaybe<EcomCheckoutV1LineItemInput>>>;
  /**
   * `overrideCheckoutUrl` allows the flexibility to redirect customers to a customized checkout page.
   *
   * This field overrides the `checkoutUrl` in a cart or checkout. `checkoutUrl` is used in the Abandoned Checkout API
   * to send customers back to their checkouts. By default, a `checkoutUrl` generates for a checkout and directs to a
   * standard Wix checkout page. When `overrideCheckoutUrl` has a value, it will replace and set the value of `checkoutUrl`.
   */
  overrideCheckoutUrl?: InputMaybe<Scalars['String']>;
};

export type EcomCheckoutV1UpdateCheckoutResponse = {
  /** Updated checkout. */
  checkout?: Maybe<EcomCheckoutV1Checkout>;
};

export type EcomCheckoutV1UpdateLineItemsQuantityRequestInput = {
  /** Checkout ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Line item info to update. */
  lineItems?: InputMaybe<Array<InputMaybe<EcomCheckoutV1LineItemQuantityUpdateInput>>>;
};

export type EcomCheckoutV1UpdateLineItemsQuantityResponse = {
  /** Updated checkout. */
  checkout?: Maybe<EcomCheckoutV1Checkout>;
};

export type EcomCheckoutV1UpdatedCheckoutMessageInput = {
  /** Previous checkout. */
  oldCheckout?: InputMaybe<EcomCheckoutV1CheckoutInput>;
  /** Updated checkout. */
  updatedCheckout?: InputMaybe<EcomCheckoutV1CheckoutInput>;
};

export type ExternalEchoInput = {
  /** 2nd part of the message */
  arg2?: InputMaybe<Scalars['String']>;
};

export type GoogleProtobufStructInput = {
  fields?: InputMaybe<Scalars['JSON']>;
};

export type MetroinspectorV1CollectionsCollection = {
  id?: Maybe<Scalars['String']>;
  productIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  products?: Maybe<MetroinspectorV1ProductsQueryProductsResponse>;
  title?: Maybe<Scalars['String']>;
};


export type MetroinspectorV1CollectionsCollectionProductsArgs = {
  queryInput?: InputMaybe<MetroinspectorV1ProductsQueryProductsRequestInput>;
};

export type MetroinspectorV1CollectionsGetCollectionRequestInput = {
  id: Scalars['ID'];
};

export type MetroinspectorV1CollectionsQueryCollectionsRequestInput = {
  query?: InputMaybe<WixCommonQueryV2Input>;
};

export type MetroinspectorV1CollectionsQueryCollectionsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<MetroinspectorV1CollectionsCollection>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type MetroinspectorV1ProductsBulkCreateProductsRequestInput = {
  products?: InputMaybe<Array<InputMaybe<MetroinspectorV1ProductsProductInput>>>;
  /** set to `true` if you wish to receive back the created products in the response */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type MetroinspectorV1ProductsBulkCreateProductsResponse = {
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  results?: Maybe<Array<Maybe<MetroinspectorV1ProductsBulkProductResult>>>;
};

export type MetroinspectorV1ProductsBulkDeleteProductsRequestInput = {
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MetroinspectorV1ProductsBulkDeleteProductsResponse = {
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  results?: Maybe<Array<Maybe<MetroinspectorV1ProductsBulkProductResult>>>;
};

export type MetroinspectorV1ProductsBulkProductResult = {
  /** Only exists if `returnEntity` was set to true in the request */
  item?: Maybe<MetroinspectorV1ProductsProduct>;
  /** Defined in wix.commons */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type MetroinspectorV1ProductsBulkUpdateProductsRequestInput = {
  products?: InputMaybe<Array<InputMaybe<MetroinspectorV1ProductsMaskedProductInput>>>;
  /** set to `true` if you wish to receive back the updated products in the response */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type MetroinspectorV1ProductsBulkUpdateProductsResponse = {
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  results?: Maybe<Array<Maybe<MetroinspectorV1ProductsBulkProductResult>>>;
};

export type MetroinspectorV1ProductsCountProductsRequestInput = {
  filter?: InputMaybe<Scalars['JSON']>;
  /** Whether hidden products should be included in the response. Requires permissions to manage products. */
  includeHiddenProducts?: InputMaybe<Scalars['Boolean']>;
  /** Whether merchant specific data should be included in the response. Requires permissions to manage products. */
  includeMerchantSpecificData?: InputMaybe<Scalars['Boolean']>;
  /** Whether variants should be included in the response. */
  includeVariants?: InputMaybe<Scalars['Boolean']>;
};

export type MetroinspectorV1ProductsCountProductsResponse = {
  count?: Maybe<Scalars['Int']>;
};

export type MetroinspectorV1ProductsCreateProductRequestInput = {
  product?: InputMaybe<MetroinspectorV1ProductsProductInput>;
};

export type MetroinspectorV1ProductsCreateProductResponse = {
  product?: Maybe<MetroinspectorV1ProductsProduct>;
};

export type MetroinspectorV1ProductsDeleteProductRequestInput = {
  productId?: InputMaybe<Scalars['String']>;
};

export type MetroinspectorV1ProductsGetProductRequestInput = {
  id: Scalars['ID'];
};

export type MetroinspectorV1ProductsGetProductsStartWithRequestInput = {
  addressLine2?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type MetroinspectorV1ProductsGetProductsStartWithResponse = {
  products?: Maybe<Array<Maybe<MetroinspectorV1ProductsProduct>>>;
};

export type MetroinspectorV1ProductsMaskedProductInput = {
  /** Explicit list of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Product to be updated, may be partial */
  product?: InputMaybe<MetroinspectorV1ProductsProductInput>;
};

export type MetroinspectorV1ProductsMyAddress = {
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  formattedAddress?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<WixCommonStreetAddress>;
  subdivision?: Maybe<Scalars['String']>;
};

export type MetroinspectorV1ProductsMyAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  formattedAddress?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<WixCommonStreetAddressInput>;
  subdivision?: InputMaybe<Scalars['String']>;
};

export type MetroinspectorV1ProductsProduct = {
  address?: Maybe<WixCommonAddress>;
  audio?: Maybe<WixCommonAudio>;
  collection?: Maybe<MetroinspectorV1CollectionsCollection>;
  collectionId?: Maybe<Scalars['String']>;
  collectionsVirtualReference?: Maybe<MetroinspectorV1CollectionsQueryCollectionsResponse>;
  color?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  customAddress?: Maybe<MetroinspectorV1ProductsMyAddress>;
  document?: Maybe<WixCommonDocument>;
  externalEcho?: Maybe<WixCoreservicesMetroinspectorV1EchoResponse>;
  guid?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<WixCommonImage>;
  localDate?: Maybe<Scalars['String']>;
  localDateTime?: Maybe<Scalars['String']>;
  localTime?: Maybe<Scalars['String']>;
  mainVariant?: Maybe<MetroinspectorV1ProductsVariant>;
  modifiedDate?: Maybe<Scalars['String']>;
  pageLink?: Maybe<WixCommonPageLink>;
  title?: Maybe<Scalars['String']>;
  variants?: Maybe<Array<Maybe<MetroinspectorV1ProductsVariant>>>;
  video?: Maybe<WixCommonVideoV2>;
};


export type MetroinspectorV1ProductsProductCollectionsVirtualReferenceArgs = {
  queryInput?: InputMaybe<MetroinspectorV1CollectionsQueryCollectionsRequestInput>;
};


export type MetroinspectorV1ProductsProductExternalEchoArgs = {
  input?: InputMaybe<ExternalEchoInput>;
};

export type MetroinspectorV1ProductsProductInput = {
  address?: InputMaybe<WixCommonAddressInput>;
  audio?: InputMaybe<WixCommonAudioInput>;
  collectionId?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  createdDate?: InputMaybe<Scalars['String']>;
  customAddress?: InputMaybe<MetroinspectorV1ProductsMyAddressInput>;
  document?: InputMaybe<WixCommonDocumentInput>;
  guid?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<WixCommonImageInput>;
  localDate?: InputMaybe<Scalars['String']>;
  localDateTime?: InputMaybe<Scalars['String']>;
  localTime?: InputMaybe<Scalars['String']>;
  mainVariant?: InputMaybe<MetroinspectorV1ProductsVariantInput>;
  modifiedDate?: InputMaybe<Scalars['String']>;
  pageLink?: InputMaybe<WixCommonPageLinkInput>;
  title?: InputMaybe<Scalars['String']>;
  variants?: InputMaybe<Array<InputMaybe<MetroinspectorV1ProductsVariantInput>>>;
  video?: InputMaybe<WixCommonVideoV2Input>;
};

export type MetroinspectorV1ProductsQueryProductsRequestInput = {
  /** Whether hidden products should be included in the response. Requires permissions to manage products. */
  includeHiddenProducts?: InputMaybe<Scalars['Boolean']>;
  /** Whether merchant specific data should be included in the response. Requires permissions to manage products. */
  includeMerchantSpecificData?: InputMaybe<Scalars['Boolean']>;
  /** Whether variants should be included in the response. */
  includeVariants?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<WixCommonQueryV2Input>;
};

export type MetroinspectorV1ProductsQueryProductsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<MetroinspectorV1ProductsProduct>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type MetroinspectorV1ProductsUpdateProductRequestInput = {
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  product?: InputMaybe<MetroinspectorV1ProductsProductInput>;
  productId?: InputMaybe<Scalars['String']>;
};

export type MetroinspectorV1ProductsUpdateProductResponse = {
  product?: Maybe<MetroinspectorV1ProductsProduct>;
};

export type MetroinspectorV1ProductsVariant = {
  image?: Maybe<WixCommonImage>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type MetroinspectorV1ProductsVariantInput = {
  image?: InputMaybe<WixCommonImageInput>;
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type Mutation = {
  comWixBookingsSchedulesApiV1Cache?: Maybe<WixBookingsCalendarV2CacheResponse>;
  /**
   * Creates a session.
   *
   * A session is one of the following:
   * + `"EVENT"`: Reserved period of time on any [schedule](wix-bookings-backend.sessions/introduction#schedules). For example, an appointment, class, or course. Events are visible in the Dashboard in the Bookings app's [**Booking Calendar**](https://support.wix.com/en/article/wix-bookings-about-the-wix-bookings-calendar) page. Set `type` to `"EVENT"` when creating sessions that reserve time on a service's schedule, or when creating a blocked time for a resource.
   * + `"WORKING_HOURS"`: Placeholder for available time on a resource’s schedule. Set `type` to `"WORKING_HOURS"` when creating sessions for resource availability.
   *
   * Sessions belong to a schedule. Schedules are owned by a resource or a service.
   *
   * A session may be an individual session or a recurring session.
   * An individual session has a discrete start and end date, while a recurring session defines a series of repeating sessions. An instance of a recurring session is a specific session in a series of repeating sessions, generated according to the recurrence rule.
   * The `start` and `end` properties set the time and duration of the session. For non-recurring sessions, you can use either the `timestamp` or `localDateTime` properties.
   * For recurring sessions, use the `localDateTime` property only. For recurring sessions, the `start` property sets the date and time of the first recurring session, subject to the recurrence rule. For example, if you set the `start` to Saturday, May 1 and your recurrence rule says every second Monday, then the first session will only be on Monday, May 10.
   *
   * The `year`, `monthOfYear` and `dayOfMonth` properties in the `end` property are used with the `hourOfDay` and `minutesOfHour` properties to set the duration of each session relative to the `start`.
   * The `UNTIL` keyword in the `recurrence` property sets the date for the last recurring session.
   *
   * You can create a session that blocks hours on the resource's calendar, making the resource unavailable.
   * Create a non-recurring session of type `"EVENT"`, and add `"Blocked"` to the `tags` array.
   *
   * >**Notes:**
   * > + For properties where there is no explicit time zone information, the time zone used is the business’s time zone.
   * > + Only users with **[Bookings Admin](https://support.wix.com/en/article/roles-permissions-overview#bookings-admin)** permissions can create a session. You can override the permissions by setting the `suppressAuth` option to `true`.
   */
  comWixBookingsSchedulesApiV1CreateSession?: Maybe<ComWixBookingsSchedulesVeloV2CreateSessionResponse>;
  /**
   * Deletes a session.
   *
   * Use the `participantNotification` property to send an email to the participants when the session is deleted.
   * When deleting a session of type `"EVENT"` where a booking exists, the booking's status is updated to `"CANCELED"`.
   * To delete a set of recurring sessions, specify the session's `recurringSessionId` in the `sessionId` property in the parameters.
   * When deleting a recurrence, only future instances of the recurrence are deleted.
   *
   * >**Note:** Only users with **[Bookings Admin](https://support.wix.com/en/article/roles-permissions-overview#bookings-admin)** permissions can delete a session. You can override the permissions by setting the `suppressAuth` option to `true`.
   */
  comWixBookingsSchedulesApiV1DeleteSession?: Maybe<Scalars['Void']>;
  comWixBookingsSchedulesApiV1GetCacheInfo?: Maybe<WixBookingsCalendarV2GetCacheInfoResponse>;
  /** Calendar Feed handler. */
  comWixBookingsSchedulesApiV1HandleFeedMessage?: Maybe<Scalars['Void']>;
  /** Calendar Feed handler. */
  comWixBookingsSchedulesApiV1HandleFeedReplayMessage?: Maybe<Scalars['Void']>;
  /**
   * Retrieves a list of sessions by their IDs.
   *
   *
   * By default, session objects are returned with the fields specified in the `NO_PI` fieldset. This means they don't contain personal information.
   * To retrieve full session objects including all personal information, use the `ALL_PI` fieldset. This requires the CALENDAR.SESSION_READ_PI permission scope.
   */
  comWixBookingsSchedulesApiV1ListSessions?: Maybe<WixBookingsCalendarV2ListSessionsResponse>;
  /**
   * Retrieves a list of event session instances, given the provided paging and filtering.
   *
   *
   * By default session objects without any personal information are returned.
   * This means without `participants`, `location`, `calendarConference`, and
   * `externalCalendarOverrides`. You can retrieve full session objects by passing
   * `ALL_PI` in the `fieldsets` array. It isn't possible to retrieve sessions
   * with personal information just for specific participants.
   *
   * > __Note:__ Sessions are sorted by `start.timestamp`, in ascending order.
   * > Other sorting options aren't supported.
   *
   *
   * For a detailed list of supported operations in the Bookings Calendar V2 API, see
   * [filtering](https://dev.wix.com/api/rest/wix-bookings/calendar-v2/filters).
   *
   *
   * To learn about working with _Query_ endpoints, see
   * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language)
   * and [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/sorting-and-paging).
   */
  comWixBookingsSchedulesApiV1QueryEventSessionInstances?: Maybe<WixBookingsCalendarV2QueryEventSessionInstancesResponse>;
  comWixBookingsSchedulesApiV1ShortenCache?: Maybe<WixBookingsCalendarV2ShortenCacheResponse>;
  comWixBookingsSchedulesApiV1Uncache?: Maybe<Scalars['Void']>;
  /**
   * Updates a session.
   *
   * When you update a recurring session, only the future instances of the recurrence will be updated. Changing an individual instance's `start` or `end` time will change the way updates to `start` and `end` on the recurring session affect the session instance:
   * |Change made to the instance | Effect of changes made to the recurrence
   * |--|--|
   * |Instance `start` time changed.|Changes to the recurring session's `start` or `end` time will not update the instance.|
   * |Instance `end` time changed, changing the session's duration| Changes made to the recurring session's start time will be updated on the instance while keeping the new duration, but changes to the recurring session's `end` time not be updated on the instance.
   * |Updating a changed `start` time for an instance back to the recurring session's value.|Future changes to the recurring session `start` and `end` times will update the instance's `starts` and `end` time.
   *
   * Changes to properties on the recurring session, other than `start` and `end`, are always updated on the recurrence instance.
   *
   * Use the `options.participantNotification` object to notify participants if the session has been booked.
   *
   * >**Notes:**
   * > + Where there is no explicit timezone information, the timezone used is the business’s timezone.
   * > + Only users with **[Bookings Admin](https://support.wix.com/en/article/roles-permissions-overview#bookings-admin)** permissions can update a session. You can override the permissions by setting the `suppressAuth` option to `true`.
   */
  comWixBookingsSchedulesApiV1UpdateSession?: Maybe<ComWixBookingsSchedulesVeloV2UpdateSessionResponse>;
  /** ML: once multilingual installed on store, we'd like to create the relevant keys */
  comWixEcomDiscountsConsumeLocaleCreated?: Maybe<Scalars['Void']>;
  /** Discount rule usage counter is incremented once an order with discount rules is approved */
  comWixEcomDiscountsConsumeOrderPaid?: Maybe<Scalars['Void']>;
  /** Creates a new discount rule. */
  comWixEcomDiscountsCreateDiscountRule?: Maybe<ComWixEcomDiscountsCreateDiscountRuleResponse>;
  /** Deletes a discount rule. */
  comWixEcomDiscountsDeleteDiscountRule?: Maybe<Scalars['Void']>;
  /** Retrieve all discounts that can be applied to the given line items. */
  comWixEcomDiscountsGetAppliedDiscounts?: Maybe<ComWixEcomDiscountsGetAppliedDiscountsResponse>;
  /**
   * Updates a discount rule.
   *
   * Each time the discount rule is updated, `revision` increments by 1. The existing `revision` must be included when updating the discount rule.
   * This ensures you're working with the latest discount rule information, and it prevents unintended overwrites.
   */
  comWixEcomDiscountsUpdateDiscountRule?: Maybe<ComWixEcomDiscountsUpdateDiscountRuleResponse>;
  /**
   * Authorizes a payment using an order's saved payment method.
   *
   * Use the `delayedCaptureSettings` field to specify whether the payment should also be captured/voided immediately or at a later time.
   * Alternatively, the payment can be manually captured or voided using the Capture Authorized Payments or Void Authorized Payments methods.
   */
  comWixEcomOrdersBillingV1AuthorizeChargeWithSavedPaymentMethod?: Maybe<ComWixEcomOrdersBillingV1AuthorizeChargeWithSavedPaymentMethodResponse>;
  /**
   * Creates an authorized payment with requested amount using saved payment method associated with order.
   * Later this payment can be:
   * - Captured, using CaptureAuthorizedPayments endpoint.
   * - Voided, using VoidAuthorizedPayments endpoint.
   * If none of these actions is performed manually, after some period of time (determined either by request.delayed_capture_settings.delay_duration, or by provider defaults), one of them will be performed automatically.
   */
  comWixEcomOrdersBillingV1AuthorizePaymentWithSavedPaymentMethod?: Maybe<ComWixEcomOrdersBillingV1AuthorizePaymentWithSavedPaymentMethodResponse>;
  /** Calculates refund amounts for a given list of an order's line items, shipping, and additional fees. */
  comWixEcomOrdersBillingV1CalculateRefund?: Maybe<ComWixEcomOrdersBillingV1CalculateRefundResponse>;
  /** Captures an order's authorized payments. */
  comWixEcomOrdersBillingV1CaptureAuthorizedPayments?: Maybe<ComWixEcomOrdersBillingV1CaptureAuthorizedPaymentsResponse>;
  /** Generates receipts for an order's specified payments. */
  comWixEcomOrdersBillingV1GenerateReceipts?: Maybe<ComWixEcomOrdersBillingV1GenerateReceiptsResponse>;
  /**
   * Retrieves refund information about an order's payments, line items, shipping, and additional fees.
   *
   * The following information is returned:
   * - Whether a payment is refundable; previously refunded amounts; possible refund amounts for each payment.
   * - Refundable and previously refunded quantities for each line item, as well as shipping and additional fees.
   */
  comWixEcomOrdersBillingV1GetOrderRefundability?: Maybe<ComWixEcomOrdersBillingV1GetOrderRefundabilityResponse>;
  /**
   * *DEPRECATED** - Use GetOrderRefundability instead.
   *
   * Provides refund related information about order, such as:
   * - refundability status, previously refunded amount, possible refund amount for each payment
   * - previously refunded quantity and available for refund quantities for each line item
   * - previously refunded amount and available for refund amount for shipping and each additional fee
   */
  comWixEcomOrdersBillingV1GetRefundOptions?: Maybe<ComWixEcomOrdersBillingV1GetRefundOptionsResponse>;
  /** Redeems a gift card as payment for an order. */
  comWixEcomOrdersBillingV1RedeemGiftCard?: Maybe<ComWixEcomOrdersBillingV1RedeemGiftCardResponse>;
  /**
   * Calls relevant payment providers and creates refund transactions for the requested payments.
   *
   * Refunds marked with `paymentRefunds.externalRefund = true` do not call payment providers and
   * only update the order's transactions records.
   */
  comWixEcomOrdersBillingV1RefundPayments?: Maybe<ComWixEcomOrdersBillingV1RefundPaymentsResponse>;
  /** Voids an order's authorized payments. */
  comWixEcomOrdersBillingV1VoidAuthorizedPayments?: Maybe<ComWixEcomOrdersBillingV1VoidAuthorizedPaymentsResponse>;
  /** Creates multiple fulfillments for one or more orders. */
  comWixEcomOrdersFulfillmentsV1BulkCreateFulfillment?: Maybe<ComWixEcomOrdersFulfillmentsV1BulkCreateFulfillmentResponse>;
  /** Creates an order fulfillment. */
  comWixEcomOrdersFulfillmentsV1CreateFulfillment?: Maybe<ComWixEcomOrdersFulfillmentsV1CreateFulfillmentResponse>;
  /** Deletes an existing order fulfillment. */
  comWixEcomOrdersFulfillmentsV1DeleteFulfillment?: Maybe<ComWixEcomOrdersFulfillmentsV1DeleteFulfillmentResponse>;
  /** Retrieves fulfillments associated with multiple specified orders. */
  comWixEcomOrdersFulfillmentsV1ListFulfillmentsForMultipleOrders?: Maybe<ComWixEcomOrdersFulfillmentsV1ListFulfillmentsForMultipleOrdersResponse>;
  /** Retrieves fulfillments associated with a specified order. */
  comWixEcomOrdersFulfillmentsV1ListFulfillmentsForSingleOrder?: Maybe<ComWixEcomOrdersFulfillmentsV1ListFulfillmentsForSingleOrderResponse>;
  /**
   * Updates a fulfillment's properties.
   *
   * To update a field's value, include the new value in the `fulfillment` field in the body params.
   * To remove a field's value, pass `null`.
   *
   * > **Note:** Updating line item IDs or fulfilled quantities is not allowed. To update line item IDs or quantities, delete the fulfillment and create it again.
   */
  comWixEcomOrdersFulfillmentsV1UpdateFulfillment?: Maybe<ComWixEcomOrdersFulfillmentsV1UpdateFulfillmentResponse>;
  /** Adds an invoice to a specified order. */
  comWixEcomOrdersInvoicesV1AddInvoiceToOrder?: Maybe<ComWixEcomOrdersInvoicesV1AddInvoiceToOrderResponse>;
  /** Generates and adds invoices to all specified orders. */
  comWixEcomOrdersInvoicesV1BulkGenerateInvoices?: Maybe<ComWixEcomOrdersInvoicesV1BulkGenerateInvoicesResponse>;
  comWixEcomOrdersInvoicesV1ConsumeOrderDomainEvents?: Maybe<Scalars['Void']>;
  /** Generates and adds an invoice to a specified order. */
  comWixEcomOrdersInvoicesV1GenerateInvoice?: Maybe<ComWixEcomOrdersInvoicesV1GenerateInvoiceResponse>;
  /** Generates and adds an invoice to a specified order. */
  comWixEcomOrdersInvoicesV1GenerateInvoiceWithNumber?: Maybe<ComWixEcomOrdersInvoicesV1GenerateInvoiceWithNumberResponse>;
  comWixEcomOrdersInvoicesV1GetOrderInvoice?: Maybe<ComWixEcomOrdersInvoicesV1GetOrderInvoiceResponse>;
  /** Retrieves the IDs of invoices associated with all specified orders. */
  comWixEcomOrdersInvoicesV1ListInvoicesForMultipleOrders?: Maybe<ComWixEcomOrdersInvoicesV1ListInvoicesForMultipleOrdersResponse>;
  /**
   * Retrieves invoices associated with all specified orders.
   * !!! Deprecated !!!
   */
  comWixEcomOrdersInvoicesV1ListInvoicesForMultipleOrdersOld?: Maybe<ComWixEcomOrdersInvoicesV1ListInvoicesForMultipleOrdersResponse>;
  /** Retrieves the IDs of invoices associated with a specified order. */
  comWixEcomOrdersInvoicesV1ListInvoicesForSingleOrder?: Maybe<ComWixEcomOrdersInvoicesV1ListInvoicesForSingleOrderResponse>;
  /** Adds chargeback for payment to order transactions and updates payment status accordingly. */
  comWixEcomOrdersPaymentsV1AddChargeback?: Maybe<ComWixEcomOrdersPaymentsV1AddChargebackResponse>;
  /** Adds an invoice to a specified order. */
  comWixEcomOrdersPaymentsV1AddInvoiceToOrder?: Maybe<ComWixEcomOrdersPaymentsV1AddInvoiceToOrderResponse>;
  /**
   * Adds up to 50 payment records to an order.
   *
   * > **Note:** This does **NOT** perform the actual charging - the order is only updated with records of the payments.
   */
  comWixEcomOrdersPaymentsV1AddPayments?: Maybe<ComWixEcomOrdersPaymentsV1AddPaymentsResponse>;
  /** Add refunds for payments for an order and changes payments statuses accordingly */
  comWixEcomOrdersPaymentsV1AddRefund?: Maybe<ComWixEcomOrdersPaymentsV1AddRefundResponse>;
  /** Generates and adds invoices to all specified orders. */
  comWixEcomOrdersPaymentsV1BulkGenerateInvoices?: Maybe<ComWixEcomOrdersPaymentsV1BulkGenerateInvoicesResponse>;
  /** Updates multiple order payments with a specified status. */
  comWixEcomOrdersPaymentsV1BulkUpdatePaymentStatuses?: Maybe<ComWixEcomOrdersPaymentsV1BulkUpdatePaymentStatusesResponse>;
  /** Calculates what amount can still be refunded on this order. */
  comWixEcomOrdersPaymentsV1CalculateRefund?: Maybe<ComWixEcomOrdersPaymentsV1CalculateRefundResponse>;
  /** Generates and adds an invoice to a specified order. */
  comWixEcomOrdersPaymentsV1GenerateInvoice?: Maybe<ComWixEcomOrdersPaymentsV1GenerateInvoiceResponse>;
  /** Checks whether this order can be refunded. */
  comWixEcomOrdersPaymentsV1GetRefundabilityStatus?: Maybe<ComWixEcomOrdersPaymentsV1GetRefundabilityStatusResponse>;
  /**
   * Retrieves invoices associated with all specified orders.
   * !!! Deprecated !!!
   */
  comWixEcomOrdersPaymentsV1ListInvoicesForMultipleOrders?: Maybe<ComWixEcomOrdersPaymentsV1ListInvoicesForMultipleOrdersResponse>;
  /**
   * Retrieves invoices associated with all specified orders.
   * !!! Deprecated !!!
   */
  comWixEcomOrdersPaymentsV1ListInvoicesForMultipleOrdersOld?: Maybe<ComWixEcomOrdersPaymentsV1ListInvoicesForMultipleOrdersResponse>;
  /**
   * Retrieves invoices associated with a specified order.
   * !!! Deprecated !!!
   */
  comWixEcomOrdersPaymentsV1ListInvoicesForSingleOrder?: Maybe<ComWixEcomOrdersPaymentsV1ListInvoicesForSingleOrderResponse>;
  /** Retrieves information about payments and refunds associated with all specified orders. */
  comWixEcomOrdersPaymentsV1ListTransactionsForMultipleOrders?: Maybe<ComWixEcomOrdersPaymentsV1ListTransactionsForMultipleOrdersResponse>;
  /** Retrieves information about payments and refunds associated with a specified order. */
  comWixEcomOrdersPaymentsV1ListTransactionsForSingleOrder?: Maybe<ComWixEcomOrdersPaymentsV1ListTransactionsForSingleOrderResponse>;
  /** Reverses chargeback. */
  comWixEcomOrdersPaymentsV1ReverseChargeback?: Maybe<ComWixEcomOrdersPaymentsV1ReverseChargebackResponse>;
  /**
   * Retrieves a list of order transactions, given the provided paging, filtering, and sorting.
   *
   * To learn about working with _Search_ endpoints, see
   * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language), and
   * [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).
   */
  comWixEcomOrdersPaymentsV1SearchOrderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1SearchOrderTransactionsResponse>;
  /** Triggers one or more refunds on an order and updates the order's transactions record. */
  comWixEcomOrdersPaymentsV1TriggerRefund?: Maybe<ComWixEcomOrdersPaymentsV1TriggerRefundResponse>;
  /** Updates chargeback. */
  comWixEcomOrdersPaymentsV1UpdateChargeback?: Maybe<ComWixEcomOrdersPaymentsV1UpdateChargebackResponse>;
  /** Updates the status of an order's payment. */
  comWixEcomOrdersPaymentsV1UpdatePaymentStatus?: Maybe<ComWixEcomOrdersPaymentsV1UpdatePaymentStatusResponse>;
  /**
   * Updates properties of payments associated to order.
   *
   * Currently, the following fields can be updated:
   * + `payment.payment_details.regular_payment_details.provider_transaction_id`
   * + `payment.payment_details.regular_payment_details.status`
   * + `payment.payment_details.regular_payment_details.payment_method_details.credit_card_details`
   * + `payment.payment_details.regular_payment_details.authorization_details`
   * + `payment.payment_details.regular_payment_details.authorization_details.scheduled_action`
   * + `payment.payment_details.regular_payment_details.authorization_details.authorized_date`
   * + `payment.payment_details.regular_payment_details.authorization_details.captures`
   * + `payment.payment_details.regular_payment_details.authorization_details.captures.status`
   * + `payment.payment_details.regular_payment_details.authorization_details.captures.created_date`
   * + `payment.payment_details.regular_payment_details.authorization_details.captures.failure_details`
   * + `payment.payment_details.regular_payment_details.authorization_details.void`
   * + `payment.payment_details.regular_payment_details.authorization_details.void.status`
   * + `payment.payment_details.regular_payment_details.authorization_details.void.voided_date`
   * + `payment.payment_details.regular_payment_details.authorization_details.void.reason`
   * + `payment.payment_details.regular_payment_details.authorization_details.void.failure_details`
   * + `payment.receipt_info`
   * + `payment.receipt_info.wix_receipt`
   * + `payment.receipt_info.wix_receipt.receipt_id`
   * + `payment.receipt_info.wix_receipt.display_number`
   * + `payment.receipt_info.external_receipt`
   * + `payment.receipt_info.external_receipt.receipt_id`
   * + `payment.receipt_info.external_receipt.display_number`
   * + `payment.receipt_info.external_receipt.app_id`
   *
   * To update a field's value, include the new value in the `payment` object in the body params.
   *
   * > **Note:** Removing fields value results in an error.
   */
  comWixEcomOrdersPaymentsV1UpdatePayments?: Maybe<ComWixEcomOrdersPaymentsV1UpdatePaymentsResponse>;
  /**
   * Updates OrderTransactions.refunds properties, except OrderTransactions.refunds.transactions, which are updated
   * via UpdateRefundTransaction endpoint
   */
  comWixEcomOrdersPaymentsV1UpdateRefund?: Maybe<ComWixEcomOrdersPaymentsV1UpdateRefundResponse>;
  /** Updates OrderTransactions.refunds.transactions properties */
  comWixEcomOrdersPaymentsV1UpdateRefundTransaction?: Maybe<ComWixEcomOrdersPaymentsV1UpdateRefundTransactionResponse>;
  /**
   * Adds merchant comments to an order.
   * > **Note:** Activities with type CustomActivity not supported
   */
  comWixEcomOrdersV1AddActivities?: Maybe<ComWixEcomOrdersV1AddActivitiesResponse>;
  /**
   * Adds a merchant comment to an order.
   * > **Note:** Activities with type CustomActivity not supported
   */
  comWixEcomOrdersV1AddActivity?: Maybe<ComWixEcomOrdersV1AddActivityResponse>;
  comWixEcomOrdersV1AddInternalActivity?: Maybe<ComWixEcomOrdersV1AddInternalActivityResponse>;
  comWixEcomOrdersV1AggregateOrders?: Maybe<ComWixEcomOrdersV1AggregateOrdersResponse>;
  /** Archives an order. `order.archived` field changes to `true`. */
  comWixEcomOrdersV1ArchiveOrder?: Maybe<ComWixEcomOrdersV1ArchiveOrderResponse>;
  /** Archives multiple orders. `order.archived` field changes to `true`. */
  comWixEcomOrdersV1BulkArchiveOrders?: Maybe<ComWixEcomOrdersV1BulkArchiveOrdersResponse>;
  /** Archives multiple orders, selected by filter. `order.archived` field changes to `true`. */
  comWixEcomOrdersV1BulkArchiveOrdersByFilter?: Maybe<ComWixEcomOrdersV1BulkArchiveOrdersByFilterResponse>;
  /**
   * Bulk deletes previously imported orders. Only works on orders
   * that were created through the import process.
   */
  comWixEcomOrdersV1BulkDeleteImportedOrders?: Maybe<ComWixEcomOrdersImporterV1BulkDeleteImportedOrdersResponse>;
  /** Marks multiple orders as fulfilled. `order.fulfillmentStatus` field changes to `FULFILLED`. */
  comWixEcomOrdersV1BulkMarkAsFulfilled?: Maybe<ComWixEcomOrdersV1BulkMarkAsFulfilledResponse>;
  /** Marks multiple orders as fulfilled, selected by filter. `order.fulfillmentStatus` field changes to `FULFILLED`. */
  comWixEcomOrdersV1BulkMarkAsFulfilledByFilter?: Maybe<ComWixEcomOrdersV1BulkMarkAsFulfilledByFilterResponse>;
  /** Marks multiple orders as not fulfilled. `order.fulfillmentStatus` field changes to `NOT_FULFILLED`. */
  comWixEcomOrdersV1BulkMarkAsUnfulfilled?: Maybe<ComWixEcomOrdersV1BulkMarkAsUnfulfilledResponse>;
  /** Marks multiple orders as not fulfilled, selected by filter. `order.fulfillmentStatus` field changes to `NOT_FULFILLED`. */
  comWixEcomOrdersV1BulkMarkAsUnfulfilledByFilter?: Maybe<ComWixEcomOrdersV1BulkMarkAsUnfulfilledByFilterResponse>;
  /** Marks multiple orders as paid. `order.paymentStatus` field *eventually* changes to `PAID`. */
  comWixEcomOrdersV1BulkMarkOrdersAsPaid?: Maybe<ComWixEcomOrdersV1BulkMarkOrdersAsPaidResponse>;
  comWixEcomOrdersV1BulkSendBuyerPickupConfirmationEmails?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1BulkSendBuyerShippingConfirmationEmails?: Maybe<Scalars['Void']>;
  /**
   * For INTERNAL use only.
   * Set business location for the multiple orders
   */
  comWixEcomOrdersV1BulkSetBusinessLocation?: Maybe<ComWixEcomOrdersV1BulkSetBusinessLocationResponse>;
  /** Unarchives multiple orders. `order.archived` field changes to `false`. */
  comWixEcomOrdersV1BulkUnArchiveOrders?: Maybe<ComWixEcomOrdersV1BulkUnArchiveOrdersResponse>;
  /** Unarchives multiple orders, selected by filter. `order.archived` field changes to `false`. */
  comWixEcomOrdersV1BulkUnArchiveOrdersByFilter?: Maybe<ComWixEcomOrdersV1BulkUnArchiveOrdersByFilterResponse>;
  comWixEcomOrdersV1BulkUpdateOrder?: Maybe<ComWixEcomOrdersV1BulkUpdateOrderResponse>;
  /**
   * Synchronously update tags on multiple orders, by list of order IDs.
   *
   * > **Note:** If the same tag is passed to both the `assignTags` and `unassignTags` fields, it will be assigned.
   */
  comWixEcomOrdersV1BulkUpdateOrderTags?: Maybe<ComWixEcomOrdersV1BulkUpdateOrderTagsResponse>;
  /**
   * Updates properties of up to 100 orders.
   *
   * <blockquote class="important">
   *
   * __Currently, only the following fields can be updated:__
   * + `order.buyerInfo.email`
   * + `order.buyerLanguage`
   * + `order.weightUnit`
   * + `order.billingInfo.address`
   * + `order.billingInfo.contactDetails`
   * + `order.archived`
   * + `order.attributionSource`
   * + `order.seenByAHuman`
   * + `order.recipientInfo.address`
   * + `order.recipientInfo.contactDetails`
   * + `order.shippingInfo.logistics.shippingDestination.address`
   * + `order.shippingInfo.logistics.shippingDestination.contactDetails`
   * + `order.extendedFields`
   *
   * </blockquote>
   *
   *
   * To update a field's value, include the new value in the `order` object in the body params.
   * To remove a field's value, pass `null`.
   *
   * > **Note:** Removing (passing `null` to) `buyerInfo` or `contactDetails` results in an error.
   *
   * To update an order's payment status, use [Update Payment Status](https://dev.wix.com/docs/rest/business-solutions/e-commerce/order-transactions/update-payment-status).
   */
  comWixEcomOrdersV1BulkUpdateOrders?: Maybe<ComWixEcomOrdersV1BulkUpdateOrdersResponse>;
  /** Calculates refundable amount for order items specified in request. */
  comWixEcomOrdersV1CalculateRefund?: Maybe<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundResponse>;
  /**
   * Calculates refundable amount for order items specified in request.
   * This is a copy of existing CalculateRefund endpoint.
   * Later "CalculateRefund" endpoint name will be used for V2 refund.
   * Clients of existing CalculateRefund will be migrated to CalculateRefundV1
   */
  comWixEcomOrdersV1CalculateRefundV1?: Maybe<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundV1Response>;
  /** Calculates refund amount for given list of order line items, shipping and additional fees. */
  comWixEcomOrdersV1CalculateRefundV2?: Maybe<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundV2Response>;
  comWixEcomOrdersV1CanMigrate?: Maybe<ComWixEcomOrdersRolloutManagerV1CanMigrateResponse>;
  /** Cancels an order. The `order.status` field changes to `CANCELED`. */
  comWixEcomOrdersV1CancelOrder?: Maybe<ComWixEcomOrdersV1CancelOrderResponse>;
  /** Capture authorized payment */
  comWixEcomOrdersV1CaptureAuthorizedPayment?: Maybe<Scalars['Void']>;
  /**
   * Capture authorized payments
   * Transaction statuses for related payments will be updated in async way
   */
  comWixEcomOrdersV1CaptureAuthorizedPayments?: Maybe<ComWixEcomOrdersPaymentsCollectorV1CaptureAuthorizedPaymentsResponse>;
  comWixEcomOrdersV1ChargeMemberships?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ChargeSavedPaymentMethod?: Maybe<ComWixEcomOrdersPaymentsCollectorV1ChargeSavedPaymentMethodResponse>;
  comWixEcomOrdersV1CommitDeltas?: Maybe<ComWixEcomOrdersV1CommitDeltasResponse>;
  comWixEcomOrdersV1ConsumeBiAnalyticsTransactionSourceEvents?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumeBiTransactionSourceEvents?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumeBiTransactionSourceReviveEvents?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumeFileDescriptorEvent?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumeFulfillmentEvents?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumeFulfillmentWrapperEvents?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumeGiftCardTransactionVoidedV1?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumeInternalSideEffectsProduceDomainEvents?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumeInvoicePaidEvent?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumeInvoiceSentEvent?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumeMergeContactsFilteredEvents?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumeMetaSiteSpecialEvents?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumeOrderDomainEvents?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumeOrderEvents?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumeOrderReindexRequest?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumePaymentEvents?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumePaymentStatusUpdateEvents?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumePaymentsEvents?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1ConsumeTriggerReindexRequest?: Maybe<Scalars['Void']>;
  /**
   * Creates an order.
   *
   *
   * > **Notes:**
   * > + If an item is digital - `lineItems[i].itemType.preset: DIGITAL` - then `lineItems[i].digitalFile` must be provided.
   * > + If `lineItems[i].id` is passed, it must be either a valid GUID, or empty.
   */
  comWixEcomOrdersV1CreateOrder?: Maybe<ComWixEcomOrdersV1CreateOrderResponse>;
  /**
   * Call this endpoint to create an order in the payment gateway system. The amount of the order would be either:
   * 1. An explicit amount provided in the request, or;
   * 2. If an explicit amount is not provided - the remaining amount to complete the payment of that eCom order.
   * As a result, an ID of the created payment gateway order would be returned.
   * You can then use Wix Payments APIs to approve that order or collect payment, which will eventually change the eCom order state (e.g mark it as paid).
   */
  comWixEcomOrdersV1CreatePaymentGatewayOrder?: Maybe<ComWixEcomOrdersV1CreatePaymentGatewayOrderResponse>;
  comWixEcomOrdersV1CreateSiteRolloutStatus?: Maybe<ComWixEcomOrdersRolloutManagerV1CreateSiteRolloutStatusResponse>;
  /** Restock items on order - temporary solution for POS */
  comWixEcomOrdersV1DecrementItemsQuantity?: Maybe<ComWixEcomOrdersV1DecrementItemsQuantityResponse>;
  /**
   * Delete's an order's activity.
   *
   * Only custom activities and merchant comments can be deleted.
   */
  comWixEcomOrdersV1DeleteActivity?: Maybe<ComWixEcomOrdersV1DeleteActivityResponse>;
  comWixEcomOrdersV1EpBackofficeTestUrlAdditionalBindings?: Maybe<WixEcomOrdersBackofficeV1TestUrlAdditionalBindingsResponse>;
  comWixEcomOrdersV1EpBackofficeUpdateOrder?: Maybe<WixEcomOrdersBackofficeV1UpdateOrderResponse>;
  comWixEcomOrdersV1EpBackofficeUpsertRefund?: Maybe<WixEcomOrdersBackofficeV1UpsertRefundResponse>;
  /** ******** SUBSCRIPTIONS ********* */
  comWixEcomOrdersV1EpOrdersIndexerConsumeOrderEvents?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1EpOrdersIndexerConsumePaymentsEvents?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1EpOrdersIndexerConsumeTriggerReindexRequest?: Maybe<Scalars['Void']>;
  /**
   * Uses explicitly provided metasite ID or implicit ecom instance ID from Callscope
   * to query legacy v1 Orders service and verify if any amount of ecom orders are present in an old (event-source based) system.
   */
  comWixEcomOrdersV1EpOrdersRolloutManagerHasOrdersInOldSystem?: Maybe<ComWixEcomOrdersRolloutManagerV1HasOrdersInOldSystemResponse>;
  /**
   * Retrieves metadata for given metasiteID using metasiteReadApi get RPC call
   * Target msid must be provided
   */
  comWixEcomOrdersV1GetMetasiteData?: Maybe<WixEcomOrdersBackofficeV1GetMetasiteDataResponse>;
  comWixEcomOrdersV1GetOrderAgc?: Maybe<WixEcomOrdersBackofficeV1GetOrderAgcResponse>;
  /**
   * Retrieves order for given metasiteId and orderId using ep-orders getOrder RPC call
   * Target msid and orderId must be provided
   */
  comWixEcomOrdersV1GetOrderForMetasite?: Maybe<WixEcomOrdersBackofficeV1GetOrderForMetasiteResponse>;
  comWixEcomOrdersV1GetOrderOutOfBox?: Maybe<WixEcomOrdersBackofficeV1GetOrderOutOfBoxResponse>;
  comWixEcomOrdersV1GetOrderWithFilterByLocation?: Maybe<WixEcomOrdersBackofficeV1GetOrderWithFilterByLocationResponse>;
  /**
   * Provides payment collectability status for given order. If payment collection is possible
   * response will contain collectable amount for given ecom order. If not - response will contain
   * reason why payment collection is not possible.
   */
  comWixEcomOrdersV1GetPaymentCollectabilityStatus?: Maybe<ComWixEcomOrdersPaymentsCollectorV1GetPaymentCollectabilityStatusResponse>;
  /**
   * Provides refund related information about order, such as:
   * - refundability status, previously refunded amount, possible refund amount for each payment
   * - previously refunded quantity and available for refund quantities for each line item
   * - previously refunded amount and available for refund amount for shipping and each additional fee
   */
  comWixEcomOrdersV1GetRefundOptions?: Maybe<ComWixEcomOrdersPaymentsCollectorV1GetRefundOptionsResponse>;
  /** Checks whether this order can be refunded. */
  comWixEcomOrdersV1GetRefundabilityStatus?: Maybe<ComWixEcomOrdersPaymentsCollectorV1GetRefundabilityStatusResponse>;
  /** returns shipping label ids - temporarily until fully modeled in fulfillments service */
  comWixEcomOrdersV1GetShipments?: Maybe<ComWixEcomOrdersV1GetShipmentsResponse>;
  comWixEcomOrdersV1GetSiteRolloutStatus?: Maybe<ComWixEcomOrdersRolloutManagerV1GetSiteRolloutStatusResponse>;
  comWixEcomOrdersV1HandleRetryMergeContactsTask?: Maybe<WixApiLoomTimecapsuleTaskAction>;
  /**
   * Uses explicitly provided metasite ID to query legacy v1 Orders service
   * and verify if any amount of ecom orders are present in an old (event-source based) system.
   */
  comWixEcomOrdersV1HasOrdersInOldSystem?: Maybe<ComWixEcomOrdersRolloutManagerV1HasOrdersInOldSystemResponse>;
  /**
   * Imports a single order with historical data while preserving original details and controlling side effects.
   * Can be used for initial import or update (delete-insert).
   * Only imported via ImportOrder API orders can be updated, Order.id used as key for update.
   * Order will be fully overridden.
   */
  comWixEcomOrdersV1ImportOrder?: Maybe<ComWixEcomOrdersImporterV1ImportOrderResponse>;
  /**
   * Bulk deletes previously imported orders. Only works on orders
   * that were created through the import process.
   */
  comWixEcomOrdersV1ImportsBulkDeleteImportedOrders?: Maybe<ComWixEcomOrdersImporterV1BulkDeleteImportedOrdersResponse>;
  /**
   * Imports a single order with historical data while preserving original details and controlling side effects.
   * Can be used for initial import or update (delete-insert).
   * Only imported via ImportOrder API orders can be updated, Order.id used as key for update.
   * Order will be fully overridden.
   */
  comWixEcomOrdersV1ImportsImportOrder?: Maybe<ComWixEcomOrdersImporterV1ImportOrderResponse>;
  /**
   * Sets the current order increment ID for a site. This defines the starting number
   * for subsequent new orders created after migration.
   */
  comWixEcomOrdersV1ImportsSetOrderNumberCounter?: Maybe<ComWixEcomOrdersImporterV1SetOrderNumberCounterResponse>;
  /**
   * <!--ONLY:REST-->
   * Internal query orders endpoint without additional logic to hide INIT orders.
   * Returns a list of up to 100 orders, given the provided paging, filtering and sorting.
   *
   * To learn how to query orders, see
   * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
   * <!--END:ONLY:REST-->
   */
  comWixEcomOrdersV1InternalQueryOrders?: Maybe<ComWixEcomOrdersV1InternalQueryOrdersResponse>;
  /**
   * Retrieves order transactions for given metasiteId and orderId using ep-payments listTransactionsForSingleOrder RPC call
   * Target msid and orderId must be provided
   */
  comWixEcomOrdersV1ListOrderTransactionsForMetasite?: Maybe<WixEcomOrdersBackofficeV1ListOrderTransactionsForMetasiteResponse>;
  /**
   * Retrieves orders for store sorted by createdDate ASC.
   * If ListOrdersRequest.ids is empty will return list of all orders
   * else will be filtered by ids
   */
  comWixEcomOrdersV1ListOrders?: Maybe<ComWixEcomOrdersV1ListOrdersResponse>;
  /**
   * Retrieves orders for given metasiteID using ep-orders listOrders RPC call
   * Target msid must be provided
   * TODO: deprecated, remove me!
   */
  comWixEcomOrdersV1ListOrdersForMetasite?: Maybe<WixEcomOrdersBackofficeV1ListOrdersForMetasiteResponse>;
  /** Marks an order as fulfilled. `order.fulfillmentStatus` field changes to `FULFILLED`. */
  comWixEcomOrdersV1MarkAsFulfilled?: Maybe<ComWixEcomOrdersV1MarkAsFulfilledResponse>;
  /** Marks an order as not fulfilled. `order.fulfillmentStatus` field changes to `NOT_FULFILLED`. */
  comWixEcomOrdersV1MarkAsUnfulfilled?: Maybe<ComWixEcomOrdersV1MarkAsUnfulfilledResponse>;
  comWixEcomOrdersV1MarkEmptyAndOpenNewFlow?: Maybe<ComWixEcomOrdersRolloutManagerV1MarkEmptyAndOpenNewFlowResponse>;
  /**
   * Marks the order as paid. `order.paymentStatus` field *eventually* changes to `PAID`.
   * In case the order already has an offline payment transaction associated with it (usually when manual payment method is chosen at checkout) - This transaction will become approved.
   * In case the order has no payment transactions associated with it (usually when the item is set to be paid offline after checkout or when an order is created from the backoffice) - A payment transaction will be created and approved.
   */
  comWixEcomOrdersV1MarkOrderAsPaid?: Maybe<ComWixEcomOrdersV1MarkOrderAsPaidResponse>;
  /** Marks an order as read in the dashboard. `order.seenByAHuman` field changes to `true`. */
  comWixEcomOrdersV1MarkOrderAsSeenByHuman?: Maybe<ComWixEcomOrdersV1MarkOrderAsSeenByHumanResponse>;
  comWixEcomOrdersV1OnTriggerSideEffectsFromLegacy?: Maybe<Scalars['Void']>;
  /** Marks multiple orders as paid. `order.paymentStatus` field *eventually* changes to `PAID`. */
  comWixEcomOrdersV1PaymentCollectionBulkMarkOrdersAsPaid?: Maybe<ComWixEcomOrdersPaymentsCollectorV1BulkMarkOrdersAsPaidResponse>;
  /**
   * Calculates refundable amount for order items specified in request.
   * This is a copy of existing CalculateRefund endpoint.
   * Later "CalculateRefund" endpoint name will be used for V2 refund.
   * Clients of existing CalculateRefund will be migrated to CalculateRefundV1
   */
  comWixEcomOrdersV1PaymentCollectionCalculateRefundV1?: Maybe<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundV1Response>;
  /** Calculates refund amount for given list of order line items, shipping and additional fees. */
  comWixEcomOrdersV1PaymentCollectionCalculateRefundV2?: Maybe<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundV2Response>;
  /** Capture authorized payment */
  comWixEcomOrdersV1PaymentCollectionCaptureAuthorizedPayment?: Maybe<Scalars['Void']>;
  /**
   * Capture authorized payments
   * Transaction statuses for related payments will be updated in async way
   */
  comWixEcomOrdersV1PaymentCollectionCaptureAuthorizedPayments?: Maybe<ComWixEcomOrdersPaymentsCollectorV1CaptureAuthorizedPaymentsResponse>;
  comWixEcomOrdersV1PaymentCollectionConsumeGiftCardTransactionVoidedV2?: Maybe<Scalars['Void']>;
  /**
   * Call this endpoint to create an order in the payment gateway system. The amount of the order would be either:
   * 1. An explicit amount provided in the request, or;
   * 2. If an explicit amount is not provided - the remaining amount to complete the payment of that eCom order.
   * As a result, an ID of the created payment gateway order would be returned.
   * You can then use Wix Payments APIs to approve that order or collect payment, which will eventually change the eCom order state (e.g mark it as paid).
   */
  comWixEcomOrdersV1PaymentCollectionCreatePaymentGatewayOrder?: Maybe<ComWixEcomOrdersPaymentsCollectorV1CreatePaymentGatewayOrderResponse>;
  /**
   * Provides refund related information about order, such as:
   * - refundability status, previously refunded amount, possible refund amount for each payment
   * - previously refunded quantity and available for refund quantities for each line item
   * - previously refunded amount and available for refund amount for shipping and each additional fee
   */
  comWixEcomOrdersV1PaymentCollectionGetRefundOptions?: Maybe<ComWixEcomOrdersPaymentsCollectorV1GetRefundOptionsResponse>;
  /**
   * Marks the order as paid. `order.paymentStatus` field *eventually* changes to `PAID`.
   * In case the order already has an offline payment transaction associated with it
   * (usually when manual payment method is chosen at checkout) - This transaction will become approved.
   * In case the order has no payment transactions associated with it
   * (usually when the item is set to be paid offline after checkout or when an order is created from the backoffice) - A payment transaction
   * will be created and approved.
   */
  comWixEcomOrdersV1PaymentCollectionMarkOrderAsPaid?: Maybe<ComWixEcomOrdersPaymentsCollectorV1MarkOrderAsPaidResponse>;
  /**
   * Calls corresponding payment providers and creates refund transactions for requested payments.
   * Updates order transactions based on refund results.
   * For requested payments with `RefundRequest.payments.external_refund = true` will not call payment providers and
   * will only update order transactions.
   */
  comWixEcomOrdersV1PaymentCollectionRefund?: Maybe<ComWixEcomOrdersPaymentsCollectorV1RefundResponse>;
  /** Void authorized payment */
  comWixEcomOrdersV1PaymentCollectionVoidAuthorizedPayment?: Maybe<Scalars['Void']>;
  /**
   * Void authorized payments
   * Transaction statuses for related payments will be updated in async way
   */
  comWixEcomOrdersV1PaymentCollectionVoidAuthorizedPayments?: Maybe<ComWixEcomOrdersPaymentsCollectorV1VoidAuthorizedPaymentsResponse>;
  /**
   * Prepares payment collection for given ecom order. This is the first of 2-step process of payment collection.
   * Here we ensure that payment collection is possible for given order and store and prepare payment gateway order for future charge.
   * 2nd step is an actual charge of prepared payment gateway order. This could be done either
   * via Wix-Cashier's API (https://bo.wix.com/wix-docs/rest/wix-cashier/pay/charge/charge-for-order)
   * or using Cashier Payments Widget (https://github.com/wix-private/cashier-client/tree/master/packages/cashier-payments-widget)
   */
  comWixEcomOrdersV1PreparePaymentCollection?: Maybe<ComWixEcomOrdersPaymentsCollectorV1PreparePaymentCollectionResponse>;
  /** Deprecated, use PreviewEmailByType with ORDER_PLACED type instead */
  comWixEcomOrdersV1PreviewBuyerConfirmationEmail?: Maybe<ComWixEcomOrdersNotificationsV1PreviewBuyerConfirmationEmailResponse>;
  comWixEcomOrdersV1PreviewBuyerPaymentsReceivedEmail?: Maybe<ComWixEcomOrdersNotificationsV1PreviewBuyerPaymentsReceivedEmailResponse>;
  /** Deprecated, use PreviewEmailByType with ORDER_READY_FOR_PICKUP type instead */
  comWixEcomOrdersV1PreviewBuyerPickupConfirmationEmail?: Maybe<ComWixEcomOrdersNotificationsV1PreviewBuyerPickupConfirmationEmailResponse>;
  comWixEcomOrdersV1PreviewCancelEmail?: Maybe<ComWixEcomOrdersNotificationsV1PreviewCancelEmailResponse>;
  comWixEcomOrdersV1PreviewCancelRefundEmail?: Maybe<ComWixEcomOrdersNotificationsV1PreviewCancelRefundEmailResponse>;
  comWixEcomOrdersV1PreviewEmailByType?: Maybe<ComWixEcomOrdersNotificationsV1PreviewEmailByTypeResponse>;
  comWixEcomOrdersV1PreviewRefundEmail?: Maybe<ComWixEcomOrdersNotificationsV1PreviewRefundEmailResponse>;
  /** Deprecated, use PreviewEmailByType with DOWNLOAD_LINKS type instead */
  comWixEcomOrdersV1PreviewResendDownloadLinksEmail?: Maybe<ComWixEcomOrdersNotificationsV1PreviewResendDownloadLinksEmailResponse>;
  /** Deprecated, use PreviewEmailByType with ORDER_SHIPPED type instead */
  comWixEcomOrdersV1PreviewShippingConfirmationEmail?: Maybe<ComWixEcomOrdersNotificationsV1PreviewShippingConfirmationEmailResponse>;
  /**
   * Retrieves orders for given metasiteID using ep-orders internalQueryOrders RPC call
   * Target msid must be provided
   */
  comWixEcomOrdersV1QueryOrdersForMetasite?: Maybe<WixEcomOrdersBackofficeV1QueryOrdersForMetasiteResponse>;
  /**
   * Records and approves new manual payment with provided custom amount on given order.
   * Existing pending payments are ignored.
   * Custom amount is expected to be less or equal remaining amount to be paid on order (affected by approved payments, refunds and gift card payments)
   */
  comWixEcomOrdersV1RecordManuallyCollectedPayment?: Maybe<Scalars['Void']>;
  /**
   * Calls corresponding payment providers and creates refund transactions for requested payments.
   * Updates order transactions based on refund results.
   * For requested payments with `RefundRequest.payments.external_refund = true` will not call payment providers and
   * will only update order transactions.
   */
  comWixEcomOrdersV1Refund?: Maybe<ComWixEcomOrdersPaymentsCollectorV1RefundResponse>;
  /**
   * Retrieves a list of orders, given the provided paging, filtering, and sorting.
   *
   *
   * Search Orders runs with these defaults, which you can override:
   *
   * - `createdDate` is sorted in `DESC` order
   * - `cursorPaging.limit` is `100`
   * - `filter: {"status": {"$ne": "INITIALIZED"}}` - other order statuses can be queried, but orders with `status: "INITIALIZED"` are never returned
   *
   * For field support for filters and sorting, see [Orders: Supported Filters and Sorting](https://dev.wix.com/docs/rest/api-reference/wix-e-commerce/orders/supported-filters-and-sorting).
   *
   * To learn about working with _Search_ endpoints, see
   * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language), and
   * [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).
   */
  comWixEcomOrdersV1SearchOrders?: Maybe<ComWixEcomOrdersV1SearchOrdersResponse>;
  comWixEcomOrdersV1SendBuyerConfirmationEmail?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1SendBuyerPaymentsReceivedEmail?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1SendBuyerPickupConfirmationEmail?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1SendBuyerShippingConfirmationEmail?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1SendCancelRefundEmail?: Maybe<Scalars['Void']>;
  /** this will send notification to merchant via both email and via Notification Hub */
  comWixEcomOrdersV1SendMerchantOrderReceivedNotification?: Maybe<Scalars['Void']>;
  comWixEcomOrdersV1SendMerchantOrderReceivedPush?: Maybe<Scalars['Void']>;
  /** Sends "order refunded" buyer email. */
  comWixEcomOrdersV1SendRefundEmail?: Maybe<Scalars['Void']>;
  /**
   * Sets the current order increment ID for a site. This defines the starting number
   * for subsequent new orders created after migration.
   */
  comWixEcomOrdersV1SetOrderNumberCounter?: Maybe<ComWixEcomOrdersImporterV1SetOrderNumberCounterResponse>;
  comWixEcomOrdersV1TestUrlAdditionalBindings?: Maybe<WixEcomOrdersBackofficeV1TestUrlAdditionalBindingsResponse>;
  /**
   * Calls corresponding payment providers and creates refund transactions for requested payments.
   * Updates order transactions based on refund results.
   * For requested payments with `TriggerRefundRequest.payments.external_refund = true` will not call payment providers and
   * will only update order transactions.
   */
  comWixEcomOrdersV1TriggerRefund?: Maybe<ComWixEcomOrdersPaymentsCollectorV1TriggerRefundResponse>;
  comWixEcomOrdersV1TriggerReindex?: Maybe<Scalars['Void']>;
  /** Unarchives an order. `order.archived` field changes to `false`. */
  comWixEcomOrdersV1UnArchiveOrder?: Maybe<ComWixEcomOrdersV1UnArchiveOrderResponse>;
  /** Updates an order's activity. */
  comWixEcomOrdersV1UpdateActivity?: Maybe<ComWixEcomOrdersV1UpdateActivityResponse>;
  comWixEcomOrdersV1UpdateAllowLazyMigration?: Maybe<ComWixEcomOrdersRolloutManagerV1UpdateAllowLazyMigrationResponse>;
  /** Updates an order's billing contact details. */
  comWixEcomOrdersV1UpdateBillingContactDetails?: Maybe<ComWixEcomOrdersV1UpdateBillingContactDetailsResponse>;
  comWixEcomOrdersV1UpdateBuyerEmail?: Maybe<ComWixEcomOrdersV1UpdateBuyerEmailResponse>;
  /**
   * Updates an order's contact ID and/or email.
   * > **Note:** Neither `email`, nor `contactId` can be removed, only updated.
   */
  comWixEcomOrdersV1UpdateBuyerInfo?: Maybe<ComWixEcomOrdersV1UpdateBuyerInfoResponse>;
  comWixEcomOrdersV1UpdateComparisonStatus?: Maybe<ComWixEcomOrdersRolloutManagerV1UpdateComparisonStatusResponse>;
  /** Updates an order's line item descriptions. */
  comWixEcomOrdersV1UpdateLineItemsDescriptionLines?: Maybe<ComWixEcomOrdersV1UpdateLineItemsDescriptionLinesResponse>;
  comWixEcomOrdersV1UpdateMigrationFailed?: Maybe<ComWixEcomOrdersRolloutManagerV1UpdateMigrationFailedResponse>;
  comWixEcomOrdersV1UpdateNewFlowOpen?: Maybe<ComWixEcomOrdersRolloutManagerV1UpdateNewFlowOpenResponse>;
  comWixEcomOrdersV1UpdateNoDataToMigrate?: Maybe<ComWixEcomOrdersRolloutManagerV1UpdateNoDataToMigrateResponse>;
  /**
   * Updates an order's properties.
   *
   * <blockquote class="important">
   *
   * <strong>Currently, only the following fields can be updated:</strong>
   * + `order.buyerInfo.email`
   * + `order.buyerLanguage`
   * + `order.weightUnit`
   * + `order.billingInfo.address`
   * + `order.billingInfo.contactDetails`
   * + `order.archived`
   * + `order.attributionSource`
   * + `order.seenByAHuman`
   * + `order.recipientInfo.address`
   * + `order.recipientInfo.contactDetails`
   * + `order.shippingInfo.logistics.shippingDestination.address`
   * + `order.shippingInfo.logistics.shippingDestination.contactDetails`
   * + `order.extendedFields`
   *
   * </blockquote>
   *
   * To update a field's value, include the new value in the `order` object in the body params.
   * To remove a field's value, pass `null`.
   *
   * > **Note:** Removing `buyerInfo` or `contactDetails` results in an error.
   *
   * To update an order's payment status, use [Update Payment Status](https://dev.wix.com/docs/rest/business-solutions/e-commerce/order-transactions/update-payment-status).
   */
  comWixEcomOrdersV1UpdateOrder?: Maybe<ComWixEcomOrdersV1UpdateOrderResponse>;
  comWixEcomOrdersV1UpdateOrderLineItem?: Maybe<ComWixEcomOrdersV1UpdateOrderLineItemResponse>;
  /**
   * Updates multiple items of an order.
   * Currently, the following fields can be updated:
   * + `lineItem.productName`
   * + `lineItem.descriptionLines` (full replacement)
   * + `lineItem.digitalFile`
   * + `lineItem.priceDescription`
   */
  comWixEcomOrdersV1UpdateOrderLineItems?: Maybe<ComWixEcomOrdersV1UpdateOrderLineItemsResponse>;
  /**
   * Updates an order's shipping address and/or contact details.
   * > **Notes:**
   * > + Original order must have existing address to update - `order.shippingInfo.logistics.shippingDestination.address` must have existing value.
   * > + Neither `address`, nor `contactDetails` can be removed, only updated.
   */
  comWixEcomOrdersV1UpdateOrderShippingAddress?: Maybe<ComWixEcomOrdersV1UpdateOrderShippingAddressResponse>;
  /**
   * Updates order status.
   *
   * >CANCELED and REJECTED are final statuses. Update from either of those will fail.
   * >Updates into INITIALIZED are not supported.
   *
   * Approving order:
   * APPROVED status can be set while order has one of [INITIALIZED, PENDING] statuses.
   *
   * Approving an order which was created with CreateOrderRequest.settings.order_approval_strategy = PAYMENT_METHOD_SAVED
   * will cause an error.
   *
   * Setting PENDING status:
   * Only orders in INITIALIZED status can be updated into PENDING.
   */
  comWixEcomOrdersV1UpdateOrderStatus?: Maybe<ComWixEcomOrdersV1UpdateOrderStatusResponse>;
  comWixEcomOrdersV1UpsertRefund?: Maybe<WixEcomOrdersBackofficeV1UpsertRefundResponse>;
  /** Void authorized payment */
  comWixEcomOrdersV1VoidAuthorizedPayment?: Maybe<Scalars['Void']>;
  /**
   * Void authorized payments
   * Transaction statuses for related payments will be updated in async way
   */
  comWixEcomOrdersV1VoidAuthorizedPayments?: Maybe<ComWixEcomOrdersPaymentsCollectorV1VoidAuthorizedPaymentsResponse>;
  /**
   * Sets information about whether a booking's session was attended for multiple bookings
   *
   *
   * See [SetAttendance](https://dev.wix.com/docs/rest/api-reference/wix-bookings/attendance/set-attendance) documentation for more information.
   *
   * If any of the attendance list required fields were not passed on the request or if the caller doesn't have the required permissions to set the attendance, the call fails.
   * If the request contains attendance info for unavailable sessions, the call completes successfully but the attendance info for the unavailable sessions are not created and are not considered as failures in the response.
   */
  comWixpressBookingsAttendanceV2AttendanceBulkSetAttendance?: Maybe<ComWixpressBookingsAttendanceV2BulkSetAttendanceResponse>;
  /**
   * Sets or updates attendance information for multiple booking sessions.
   *
   *
   * Refer to Set Attendance for detailed behavior of individual attendance
   * entries.
   *
   * The call fails entirely if any entry in `attendanceDetails` is missing a
   * required field.
   *
   * If attendance details are provided for a non-existent session, the call
   * succeeds for valid sessions while marking the unavailable session as a
   * failure in the response.
   */
  comWixpressBookingsAttendanceV2BulkSetAttendance?: Maybe<ComWixpressBookingsAttendanceV2BulkSetAttendanceResponse>;
  /**
   * Counts attendance records by contact.
   *
   * Returns the total number of attendance records for the contact,
   * with optional filtering by attendance status and service IDs.
   *
   * Filtering options:
   * + **attendance_status**: Filter by attendance status (ATTENDED, NOT_ATTENDED)
   * + **service_id**: Filter by one or more service IDs from the bookings
   *
   * If no filters are provided, returns the total count of all attendance records
   * for the contact.
   */
  comWixpressBookingsAttendanceV2CountAttendances?: Maybe<ComWixpressBookingsAttendanceV2CountAttendancesResponse>;
  /**
   * Sets or updates attendance information for a booking session. This
   * information is stored in an `attendance` object.
   *
   * If an `attendance` object already exists for the session, it's updated.
   * Otherwise, a new object is created.
   *
   * By default, `numberOfAttendees` is set to `1`, but you can specify a higher
   * number if multiple participants attended. Do not set `numberOfAttendees` to
   * `0` to indicate no attendance, instead specify `{"status": "NOT_ATTENDED"}`.
   *
   * Validation guidelines:
   *
   * + The call succeeds for mismatches between `numberOfAttendees`
   * and `status`. For example, make sure that your code doesn't specify
   * `{"status": "NOT_ATTENDED"}` with `{"numberOfAttendees": 5}`.
   * + The API also allows `numberOfAttendees` to exceed the booking's
   * `numberOfParticipants`. Use higher values only when scenarios like
   * walk-ins justify the exception.
   */
  comWixpressBookingsAttendanceV2SetAttendance?: Maybe<ComWixpressBookingsAttendanceV2SetAttendanceResponse>;
  /** Creates multiple resources with corresponding schedules. */
  comWixpressBookingsResourcesCoreApiV1ResourceBatchCreate?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceBatchCreateResourceResponse>;
  comWixpressBookingsResourcesCoreApiV1ResourceBatchDelete?: Maybe<Scalars['Void']>;
  comWixpressBookingsResourcesCoreApiV1ResourceBatchForceDelete?: Maybe<Scalars['Void']>;
  /**
   * Creates a resource.
   *
   *
   * Bookings resources are created with a schedule. The schedule and its sessions determine the resource's availability. Note that the schedule must contain a start date in the `availability.start` property.
   * For resources that are available during the business's default hours, add the business's schedule as a linked schedule in the resource's schedule. For resources that have their own hours, create sessions with type `"WORKING_HOURS"` using the resource's schedule.
   * You can use both individual and recurring sessions to define resource availability. You cannot use availability constraints for resource schedules.
   *
   * Use the following steps to create resources:
   * - Create the resource using including schedule information.
   * - If the resource uses the default business hours, get the business resource's schedule ID  and include it in the `scheduleInfo.availability.linkedSchedules` array in the schedule parameters.
   * - If the resource has its own custom working hours, create sessions of type `"WORKING_HOURS"`. Use the `scheduleId` of the new resource when creating the sessions. These session can be single sessions or recurring sessions. You can have both business hours and custom hours for the same resource schedule.
   *
   * >**Notes:**
   * > + A resource can have one schedule only.
   * > + You can have up to 135 active resources and an additional 135 deleted resources.
   * > + The `businessLocation.businessSchedule` object in the `schedule.location` object is not supported.
   *
   * >**Permissions:**
   * > This endpoint requires the Manage Bookings [permission scope](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions).
   */
  comWixpressBookingsResourcesCoreApiV1ResourceCreate?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceCreateResourceResponse>;
  /**
   * Deletes a resource.
   *
   * Deleting a resource updates its `status` to `"DELETED"`.
   *
   * You cannot delete a resource if it has booked sessions.
   *
   * >**Notes:**
   * > + The Bookings app creates a resource with `"business"` in name and tag values. This resource is used for the business's schedule and working hours and cannot be deleted.
   * > + You can have up to 135 active resources and an additional 135 deleted resources.
   *
   * >**Permissions:**
   * > This endpoint requires the Manage Bookings [permission scope](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions).
   */
  comWixpressBookingsResourcesCoreApiV1ResourceDelete?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceDeleteResourceResponse>;
  /**
   * Returns the Business Resource.
   *
   * This endpoint is only implemented in the Resources V2 proxy.
   * When called for a site that is not rolled out to V2 an error is returned.
   */
  comWixpressBookingsResourcesCoreApiV1ResourceGetBusinessResource?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceGetBusinessResourceResponse>;
  /**
   * Links a resource to a Wix user.
   * The user will be assigned with the `Bookings Staff Member` role, via the `SitePoliciesManagement.AssignPolicies` API.
   *
   * Preconditions:
   * - The resource must not be linked to a user, or an active invite.
   * - The user must be a site contributor
   * - The user must not be linked to another resource.
   *
   * Note:
   * The site owner may be linked to a resource, but will not be assigned with the 'Bookings Staff Member' role.
   */
  comWixpressBookingsResourcesCoreApiV1ResourceLinkResourceToUser?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceLinkResourceToUserResponse>;
  /**
   * > **Deprecation Notice**
   * >
   * > **This endpoint has been replaced with [Query Resource](https://dev.wix.com/api/rest/wix-bookings/resources/list-resources/query-resource) and will be removed on March 31, 2022.**
   * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
   *
   * Retrieves a list of the resources according to the provided filters and paging.
   * Resources that are in a resource group (i.e. the group_id property contains an ID) are excluded from the result for backwards compatibility.
   * This query is optional. If no query is provided than all non-deleted resources are returned.
   *
   * |Property|Is supported|
   * |--|--|
   * |filter | supports `resource.id`, `resource.tag`, `resource.status`|
   * |paging | supported |
   * |fields | supported |
   * |fieldsets | **not supported** |
   * |sort| **not supported** |
   *
   * > **Permissions**
   * > This endpoint requires the Read Bookings Calendar, Read Bookings - Public Data, Read Bookings - Including Participants or Manage Bookings permission scope.
   */
  comWixpressBookingsResourcesCoreApiV1ResourceList?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceListResourcesResponse>;
  /**
   * Retrieves a list of the resources according to the specified filters and paging.
   *
   * The query parameter is optional. If no query is provided then all non-deleted resources are returned.
   * Resources that are in a resource group (i.e. the group_id property contains an ID) are excluded from the result for backwards compatibility unless the `include_resources_with_groups` request field is set to true.
   *
   * |Property|Is supported|
   * |--|--|
   * |filter | supported fields: `resource.id`, `resource.tags`, `resource.status`|
   * |paging | supported |
   * |fields | supported |
   * |fieldsets | **not supported**  |
   * |sort | **not supported**  |
   *
   *
   * >**Notes:**
   * > + The following objects in the `query` parameter are not supported for this query:
   * >    - `sort`
   * >    - `fieldsets`
   *
   * > **Permissions**
   * > This endpoint requires the Read Bookings Calendar, Read Bookings - Public Data, Read Bookings - Including Participants or Manage Bookings permission scope.
   */
  comWixpressBookingsResourcesCoreApiV1ResourceQuery?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceQueryResourcesResponse>;
  /** Unlink a resource from the site owner. */
  comWixpressBookingsResourcesCoreApiV1ResourceUnLinkResourceFromOwner?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceUnLinkResourceFromOwnerResponse>;
  /**
   * Updates a resource.
   *
   *
   * Use this endpoint to update all resource information except for the resource's schedule. To update a resource's schedule use
   * the [Update Schedule](https://dev.wix.com/api/rest/wix-bookings/resources/update-schedule) endpoint.
   *
   * >**Notes:**
   * > + When updating a resource you cannot change the system tags used by the Wix Bookings app. Tags used by the app have the values `"business"` and `"staff"`.
   * > + When updating a resource's schedule you cannot change the resource tag used by the Wix Bookings app. Tags used by the app have the values `"INDIVIDUAL"`, `"GROUP"`, and `"COURSE”`.
   * > + The `businessLocation.businessSchedule` object in the `schedule.location` object is not supported.
   *
   * >**Permissions:**
   * > This endpoint requires the Manage Bookings [permission scope](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions).
   */
  comWixpressBookingsResourcesCoreApiV1ResourceUpdate?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceUpdateResourceResponse>;
  /**
   * Updates a resource's schedule
   *
   *
   * To update a resource's schedule to remove business hours and add custom hours:
   * + Update the resource's schedule to remove the business's `scheduleId` from the `availability.linkedSchedules` array.
   * + Create a set of recurring sessions of type `"WORKING_HOURS"` to define the resource's new hours.
   *
   *
   *
   * To update a resource's schedule to add default business hours, and keep or remove custom hours:
   * + Update the resource's schedule to add the business resource's `scheduleId` to the `availability.linkedSchedules` array.
   * + If you want to remove the custom sessions, delete the resource's sessions of type `"WORKING_HOURS"`.
   * You do not have to delete exiting custom sessions. Custom session that are not deleted will continue to be included in availability  calculations and can still be booked.
   *
   * >**Notes:**
   * > + A resource can have one schedule only.
   * > + A resource can have both default business hours and custom hours in its schedule.
   * > + When updating a resource's schedule you cannot change the system tags used by the Wix Bookings app. Tags used by the app have the   values `"INDIVIDUAL"`, `"GROUP"`, and `"COURSE”`.
   * > + The `businessLocation.businessSchedule` object in the `schedule.location` object is not supported.
   *
   * >**Permissions:**
   * > This endpoint requires the Manage Bookings [permission scope](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions).
   */
  comWixpressBookingsResourcesCoreApiV1ResourceUpdateSchedule?: Maybe<ComWixpressBookingsResourcesCoreApiV1ResourceUpdateScheduleResponse>;
  /**
   * Runs an aggregation on a data collection and returns the resulting list of items.
   *
   *
   * An aggregation enables you to perform certain calculations on your collection data, or on groups of items that you define, to retrieve meaningful summaries.
   * You can also add paging, filtering, and sorting preferences to your aggregation to retrieve exactly what you need.
   */
  comWixpressCloudDataApiDataAggregateDataItems?: Maybe<ComWixpressCloudDataApiDataAggregateDataItemsResponse>;
  /**
   * Runs an aggregation pipeline on a data collection and returns the results.
   *
   * Aggregations enable you to perform advanced data calculations, transformations, and groupings. While [Aggregate Data Items](https://dev.wix.com/docs/rest/business-solutions/cms/data-items/aggregate-data-items) allows you to perform basic aggregations, Aggregate Pipeline Data Items allows you to perform advanced aggregations sequentially in stages, with each stage transforming the results of the previous stage.
   */
  comWixpressCloudDataApiDataAggregatePipelineDataItems?: Maybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsResponse>;
  /**
   * Inserts one or more references in the specified fields of items in a collection.
   *
   *
   * This method adds one or more references to a collection.
   * Each new reference in the `dataItemReferences` field specifies a referring item's ID, the field in which to insert the reference, and the ID of the referenced item.
   */
  comWixpressCloudDataApiDataBulkInsertDataItemReferences?: Maybe<ComWixpressCloudDataApiDataBulkInsertDataItemReferencesResponse>;
  /**
   * Adds multiple items to a collection.
   *
   *
   * To add a single item, call Insert Data Item instead.
   *
   * When each item is inserted into a collection, its ID is automatically assigned a random value.
   * You can optionally provide your own ID when inserting the item. If you specify an ID that already exists in the collection, the insertion will fail.
   */
  comWixpressCloudDataApiDataBulkInsertDataItems?: Maybe<ComWixpressCloudDataApiDataBulkInsertDataItemsResponse>;
  /**
   * Patches one or more items in a collection.
   *
   *
   * This method modifies the existing data of one or more items. Unlike [`Bulk Update Data Item`](https://dev.wix.com/docs/rest/business-solutions/cms/data-items/bulk-update-data-items), only the fields specified in the request are modified. Data that isn't explicitly modified remains unchanged.
   *
   * To patch items, specify the ID of the collection that contains them. For each item, specify its ID and the modifications you want to apply. If the item is found in the specified collection with the specified ID, that item is patched. If no such item is found, the response's `results` array contains a corresponding item whose `itemMetadata.error` property contains details about the error.
   *
   * Learn more about [Wix Data error codes](https://dev.wix.com/docs/rest/business-solutions/cms/wix-data-error-codes).
   *
   * > **Notes**:
   * > - When an item is patched, its `data._updatedDate` property is updated to the current date and time.
   * > - You can only patch items in [collections created by Wix users](https://support.wix.com/en/article/cms-formerly-content-manager-creating-a-collection). Items in [Wix app collections](https://dev.wix.com/docs/develop-websites/articles/databases/wix-data/collections/working-with-wix-app-collections-and-code) cannot be patched.
   * > - Calling the `Bulk Patch Data Items` method triggers the [`Data Item Updated`](https://dev.wix.com/docs/rest/business-solutions/cms/data-items/data-item-updated) event for each patched item.
   */
  comWixpressCloudDataApiDataBulkPatchDataItems?: Maybe<ComWixpressCloudDataApiDataBulkPatchDataItemsResponse>;
  /** Removes one or more references. */
  comWixpressCloudDataApiDataBulkRemoveDataItemReferences?: Maybe<ComWixpressCloudDataApiDataBulkRemoveDataItemReferencesResponse>;
  /**
   * Removes multiple items from a collection.
   *
   *
   * If any items in other collections reference the removed items in reference or multi-reference fields, those fields are cleared.
   *
   * > **Note:** Once an item has been removed from a collection, it can't be restored.
   */
  comWixpressCloudDataApiDataBulkRemoveDataItems?: Maybe<ComWixpressCloudDataApiDataBulkRemoveDataItemsResponse>;
  /**
   * Inserts or updates multiple items in a collection.
   *
   *
   * The Bulk Save Data Items method inserts or updates each item provided, depending on whether it already exists in the collection. For each item:
   *
   * + If you don't provide an ID, a new item is created.
   *
   * + If you provide an ID that doesn't exist in the collection, a new item is created with that ID.
   *
   * + If an item with the ID you provide already exists in the collection, that item is updated. When an item is updated, its `data._updatedDate` field is changed to the current date and time.
   *
   * > **Note:** When you provide an item with an ID that already exists in the collection, the item you provide completely replaces the existing item with that ID.
   * > This means that all of the item's previous fields and values are lost.
   */
  comWixpressCloudDataApiDataBulkSaveDataItems?: Maybe<ComWixpressCloudDataApiDataBulkSaveDataItemsResponse>;
  /**
   * Updates multiple items in a collection.
   *
   *
   * This method replaces each specified data item's existing data with the payload provided in the request.
   *
   * Each item in the request must include an ID. If an item is found in the specified collection with
   * the same ID, that item is updated. If the collection doesn't contain an item with that ID, the update fails.
   *
   * When an item is updated, its `data._updatedDate` field is changed to the current date and time.
   *
   * > **Note:**
   * > After each item is updated, it only contains the fields included in the request. If the existing item has fields with values and those fields
   * > aren't included in the updated item, their values are lost.
   */
  comWixpressCloudDataApiDataBulkUpdateDataItems?: Maybe<ComWixpressCloudDataApiDataBulkUpdateDataItemsResponse>;
  /** Counts the number of items in a data collection that match the provided filtering preferences. */
  comWixpressCloudDataApiDataCountDataItems?: Maybe<ComWixpressCloudDataApiDataCountDataItemsResponse>;
  /**
   * Adds an item to a collection.
   *
   *
   * To add multiple items, call Bulk Insert Data Items instead.
   *
   * An item can only be inserted into an existing collection.
   * You can create a new collection using the [Data Collections API](https://dev.wix.com/api/rest/wix-data/wix-data/data-collections).
   *
   * When an item is inserted into a collection, the item's ID is automatically assigned a random value.
   * You can optionally provide a custom ID in `dataItem.id` when inserting the item.
   * If you specify an ID that already exists in the collection, the insertion will fail.
   *
   * If `dataItem.data` is empty, a new item is created with no data fields.
   */
  comWixpressCloudDataApiDataInsertDataItem?: Maybe<ComWixpressCloudDataApiDataInsertDataItemResponse>;
  /**
   * Inserts a reference in the specified field in an item in a collection.
   *
   *
   * A reference in the `dataItemReference` field specifies a referring item's ID, the field in which to insert the reference, and the ID of the referenced item.
   */
  comWixpressCloudDataApiDataInsertDataItemReference?: Maybe<ComWixpressCloudDataApiDataInsertDataItemReferenceResponse>;
  /** Checks whether a field in a referring item contains a reference to a specified item. */
  comWixpressCloudDataApiDataIsReferencedDataItem?: Maybe<ComWixpressCloudDataApiDataIsReferencedDataItemResponse>;
  /**
   * Patches an item in a collection.
   *
   * This method modifies the specified item's existing data. Unlike [`Update Data Item`](https://dev.wix.com/docs/rest/business-solutions/cms/data-items/update-data-item), only the fields specified in the request are modified. Data that isn't explicitly modified remains unchanged.
   *
   * To patch an item, specify its ID, the ID of the collection that contains it, and the modifications you want to apply. If an item is found in the specified collection with the specified ID, that item is patched. If the collection doesn't contain an item with that ID, the request fails.
   *
   * > **Notes**:
   * > - When an item is patched, its `data._updatedDate` property is updated to the current date and time.
   * > - You can only patch items in [collections created by Wix users](https://support.wix.com/en/article/cms-formerly-content-manager-creating-a-collection). Items in [Wix app collections](https://dev.wix.com/docs/develop-websites/articles/databases/wix-data/collections/working-with-wix-app-collections-and-code) cannot be patched.
   */
  comWixpressCloudDataApiDataPatchDataItem?: Maybe<ComWixpressCloudDataApiDataPatchDataItemResponse>;
  /**
   * Retrieves a list of distinct values for a given field in all items that match a query, without duplicates.
   *
   *
   * As with the [Query Data Items](https://dev.wix.com/api/rest/wix-data/wix-data/data-items/query-data-items) method, this method retrieves items based on the filtering, sorting, and paging preferences you provide.
   * However, the Query Distinct Values method doesn't return all of the full items that match the query.
   * Rather, it returns all unique values of the field you specify in `fieldName` for items that match the query.
   * If more than one item has the same value for that field, that value appears only once.
   *
   * Learn more about [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
   */
  comWixpressCloudDataApiDataQueryDistinctValues?: Maybe<ComWixpressCloudDataApiDataQueryDistinctValuesResponse>;
  /**
   * Retrieves the full items referenced in the specified field of an item.
   *
   *
   * Reference and multi-reference fields refer to items in different collections.
   * Use this method to retrieve the full details of the referenced items themselves.
   *
   * For example, suppose you have a **Movies** collection with an **Actors** field that contains references to items in a **People** collection.
   * Querying the **Movies** collection using the Query Referenced Data Items method returns the relevant **People** items referenced in the **Actors** field of the specified **Movie** item.
   * This gives you information from the **People** collection about each of the actors in the specified movie.
   */
  comWixpressCloudDataApiDataQueryReferencedDataItems?: Maybe<ComWixpressCloudDataApiDataQueryReferencedDataItemsResponse>;
  /**
   * Removes an item from a collection.
   *
   *
   * If any items in other collections reference the removed item in reference or multi-reference fields, those fields are cleared.
   *
   * > **Note:**
   * > Once an item has been removed from a collection, it can't be restored.
   */
  comWixpressCloudDataApiDataRemoveDataItem?: Maybe<ComWixpressCloudDataApiDataRemoveDataItemResponse>;
  /** Removes the specified reference from the specified field. */
  comWixpressCloudDataApiDataRemoveDataItemReference?: Maybe<ComWixpressCloudDataApiDataRemoveDataItemReferenceResponse>;
  /**
   * Replaces references in a specified field of a specified data item.
   *
   *
   * This method replaces the existing reference or references contained in the field specified in `referringItemFieldName` within the data item specified in `referringItemId`.
   * The method removes existing references and in their place it adds references to the items specified in `newReferencedItemIds`.
   *
   * > **Note:** If you pass an empty array in `newReferencedItemIds`, all existing references are removed.
   */
  comWixpressCloudDataApiDataReplaceDataItemReferences?: Maybe<ComWixpressCloudDataApiDataReplaceDataItemReferencesResponse>;
  /**
   * Inserts or updates an item in a collection.
   *
   *
   * The Save Data Item method inserts or updates the specified item, depending on whether it already exists in the collection.
   *
   * + If you don't provide an ID, a new item is created.
   *
   * + If you provide an ID that does not exist in the collection, a new item is created with that ID.
   *
   * + If an item with the ID you provide already exists in the collection, that item is updated. When an item is updated, its `data._updatedDate` field is changed to the current date and time.
   *
   * > **Note:** When you provide an item with an ID that already exists in the collection, the payload you provide in `dataItem.data` replaces the existing item with that ID.
   * > This means that the item's previous fields and values are lost.
   */
  comWixpressCloudDataApiDataSaveDataItem?: Maybe<ComWixpressCloudDataApiDataSaveDataItemResponse>;
  /**
   * Searches for items in a collection on the basis of the filtering, sorting, searching, and paging preferences you provide.
   *
   * Learn more about [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
   *
   * > **Notes:**
   * > - You can only search collections [created in the CMS](https://support.wix.com/en/article/cms-formerly-content-manager-creating-a-collection) or with the [Data Collections API](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/introduction). Searching isn't currently supported for [Wix app collections](https://support.wix.com/en/article/cms-formerly-content-manager-working-with-wix-app-collections), [external collections](https://dev.wix.com/docs/develop-websites/articles/databases/external-databases/overview/integrating-external-databases-with-your-wix-site) or [Wix Blocks](https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/wix-blocks/about-wix-blocks).
   * > - Filtering is only supported for fields explicitly defined in the [data collection structure](https://dev.wix.com/docs/rest/business-solutions/cms/data-collections/introduction#data-collections-and-their-structure). Fields not defined in the collection structure cannot be used for filtering.
   * > - Searching for data items is always [eventually consistent](https://dev.wix.com/docs/rest/business-solutions/cms/eventual-consistency).
   *
   * ### Supported filter operators by field type
   *
   * Each [field type](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#field-type) supports a specific set of [filter operators](https://dev.wix.com/docs/rest/articles/get-started/api-query-language#operators). Using a filter operator that's not supported for a given field type causes the search to fail.
   *
   * | Field Type | Supported Filter Operators |
   * |------------|----------------------------|
   * | Text, Image, Document, URL, Video, Audio, Time, Reference, [Page Link](https://support.wix.com/en/article/cms-formerly-content-manager-about-your-collection-fields#page-link-fields), [Rich Text](https://dev.wix.com/docs/rest/articles/get-started/rich-text), [Rich Content](https://dev.wix.com/docs/ricos/getting-started/introduction), Address | `$in`, `$eq`, `$ne`, `$gt`, `$gte`, `$lt`, `$lte`, `$isEmpty`, `$startsWith` |
   * | Number, Date, Date and Time | `$eq`, `$ne`, `$gt`, `$gte`, `$lt`, `$lte`, `$exists` |
   * | Boolean | `$eq`, `$ne`, `$exists` |
   * | Array of strings | `$hasSome`, `$hasAll`, `$exists` |
   * | Array, Document Array, Object, Any, Media Gallery | `$exists` |
   *
   * Learn more about [data types in Wix Data](https://dev.wix.com/docs/rest/business-solutions/cms/data-types-in-wix-data).
   */
  comWixpressCloudDataApiDataSearchDataItems?: Maybe<ComWixpressCloudDataApiDataSearchDataItemsResponse>;
  /**
   * Removes all items from a collection.
   *
   *
   * If any items in other collections reference the removed items in reference or multi-reference fields, those fields are cleared.
   *
   * > **Note:**
   * > Once items have been removed from a collection, they can't be restored.
   */
  comWixpressCloudDataApiDataTruncateDataItems?: Maybe<Scalars['Void']>;
  /**
   * Updates an item in a collection.
   *
   *
   * This method replaces the data item's existing data with the payload provided in `dataItem.data` in the request.
   *
   * To update an item, you need to specify an item ID and a collection ID.
   * If an item is found in the specified collection with the specified ID, that item is updated.
   * If the collection doesn't contain an item with that ID, the request fails.
   *
   * When an item is updated, its `data._updatedDate` field is changed to the current date and time.
   *
   * > **Note:**
   * > After an item is updated, it only contains the fields included in the `dataItem.data` payload in Update Data Item request. If the existing item has fields with values and those fields aren't included in the updated item, their values are lost.
   */
  comWixpressCloudDataApiDataUpdateDataItem?: Maybe<ComWixpressCloudDataApiDataUpdateDataItemResponse>;
  /** Add a segment to contacts */
  comWixpressContactsCoreApiV4BulkAddSegmentToContacts?: Maybe<ComWixpressContactsCoreApiV4BulkAddSegmentToContactsResponse>;
  /**
   * Deletes multiple contacts.
   *
   * All contacts that meet the specified `filter` and `search` criteria are deleted.
   * The request should contain a `filter` value or a `search` value, or both.
   * To perform a dry run, call Query Contacts with the intended filter options.
   *
   * When this method is called, a bulk job is started and the job ID is returned.
   * The job might not complete right away, depending on its size.
   * The job's status can be retrieved with Get Bulk Job.
   *
   * The following errors might occur during the bulk processing and will appear in the bulk job:
   * - `CANNOT_DELETE_SITE_MEMBERS` - Contact is a site member and can't be deleted. Member must be deleted first.
   * - `CANNOT_DELETE_CONTACT_WITH_BILLING_SUBSCRIPTION` - Contact has a valid billing subscription and can't be deleted.
   * - `CANNOT_DELETE_MEMBER_OWNER_OR_CONTRIBUTOR` - Member is a Wix user and can't be deleted. This can happen only if the request indicated to delete the member.
   * - `FAILED_DELETE_CONTACT_AFTER_MEMBER_DELETION` - Member was deleted, but contact was not. This can happen only if the request indicated to delete the member.
   * - `FAILED_DELETE_CONTACT` - Contact could not be deleted.
   */
  comWixpressContactsCoreApiV4BulkDeleteContacts?: Maybe<ComWixpressContactsCoreApiV4BulkDeleteContactsResponse>;
  /**
   * Adds and removes labels from multiple contacts.
   *
   * Labels are added to and removed from all contacts that meet the specified
   * `filter` and `search` criteria.
   * The request should specify a `filter` value, a `search` value, or both.
   * To perform a dry run, call Query Contacts with the intended filter options.
   *
   * When this method is used, a bulk job is started and the job ID is returned.
   * The job might not complete right away, depending on its size.
   * The job's status can be retrieved with Get Bulk Job.
   */
  comWixpressContactsCoreApiV4BulkLabelAndUnlabelContacts?: Maybe<ComWixpressContactsCoreApiV4BulkLabelAndUnlabelContactsResponse>;
  /** Remove a segment from contacts */
  comWixpressContactsCoreApiV4BulkRemoveSegmentFromContacts?: Maybe<ComWixpressContactsCoreApiV4BulkRemoveSegmentFromContactsResponse>;
  /**
   * Updates the specified properties for multiple contacts.
   * Fields that are included in fieldMask.paths are updated,
   * while all other fields stay the same.
   *
   * All contacts that meet the specified `filter` and `search` criteria are updated.
   * To perform a dry run, call Query Contacts with the intended filter options.
   *
   * When this method is used, a bulk job is started and the job ID is returned.
   * The job may not complete right away, depending on its size.
   * The job's status can be retrieved with Get Bulk Job.
   */
  comWixpressContactsCoreApiV4BulkUpdateContacts?: Maybe<ComWixpressContactsCoreApiV4BulkUpdateContactsResponse>;
  /** Upserts multiple contacts. */
  comWixpressContactsCoreApiV4BulkUpsertContacts?: Maybe<ComWixpressContactsCoreApiV4BulkUpsertContactsResponse>;
  comWixpressContactsCoreApiV4CountContacts?: Maybe<ComWixpressContactsCoreApiV4CountContactsResponse>;
  /**
   * Creates a new contact.
   *
   * The `info` object must include at least one of the following:
   * - Name
   * - Phone number
   * - Email address
   *
   * By default, if the call contains an email already in use by another contact,
   * the new contact won't be created. To override this behavior, set `allowDuplicates` to `true`.
   */
  comWixpressContactsCoreApiV4CreateContact?: Maybe<ComWixpressContactsCoreApiV4CreateContactResponse>;
  /**
   * Deletes a contact.
   *
   * Deleting a contact permanently removes it from the contact list.
   * If a contact is also a site member or Wix user, or has a valid billing subscription,
   * the contact can't be deleted. The related site member or Wix user must first be deleted
   * and any valid billing subscriptions must be canceled, before the contact can be deleted.
   *
   * Members are typically linked to contacts, and while they share a relationship, the member ID and contact ID are distinct identifiers.
   * Make sure to specify the contact ID when calling Delete Contact.
   */
  comWixpressContactsCoreApiV4DeleteContact?: Maybe<Scalars['Void']>;
  /** Generates an URL that can be used to upload a contact picture */
  comWixpressContactsCoreApiV4GeneratePictureUploadUrl?: Maybe<ComWixpressContactsCoreApiV4GeneratePictureUploadUrlResponse>;
  /**
   * Adds and removes labels from a contact.
   * The requested labels must already exist for the site.
   * To create new labels, use
   * [Find or Create Label](https://dev.wix.com/api/rest/contacts/labels/find-or-create-label)
   * (in the Contact Labels API) before running this request.
   */
  comWixpressContactsCoreApiV4LabelAndUnlabelContact?: Maybe<ComWixpressContactsCoreApiV4LabelAndUnlabelContactResponse>;
  /**
   * Adds labels to a contact.
   *
   * Use the Labels API to create or retrieve labels.
   *
   * Members are typically linked to contacts, and while they share a relationship, the member ID and contact ID are distinct identifiers.
   * Make sure to specify the contact ID when calling Label Contact.
   */
  comWixpressContactsCoreApiV4LabelContact?: Maybe<ComWixpressContactsCoreApiV4LabelContactResponse>;
  /** Query contact ids by segment id */
  comWixpressContactsCoreApiV4ListContactIdsBySegment?: Maybe<ComWixpressContactsCoreApiV4ListContactIdsBySegmentResponse>;
  /** Retrieves a list of up to 1,000 contacts per request. */
  comWixpressContactsCoreApiV4ListContacts?: Maybe<ComWixpressContactsCoreApiV4ListContactsResponse>;
  /**
   * Lists facets from the site’s contact list.
   * Facets include labels and subscription statuses.
   */
  comWixpressContactsCoreApiV4ListFacets?: Maybe<ComWixpressContactsCoreApiV4ListFacetsResponse>;
  /**
   * Merges source contacts into a target contact.
   *
   * Merging contacts has the following effects on the target contact:
   *
   * - No target contact data is overwritten or deleted.
   * - Arrays (emails, phone numbers, addresses, and labels) from the source contacts are added to the target contact's arrays.
   * - If you merge more than one source contact, the 1st source contact specified is added first, then the 2nd, and so on.
   * - If there is duplicate information between the target contact and the source contact, the information isn't duplicated in the target contact's arrays.
   *
   * <blockquote class="important">
   *
   * __Important:__
   * Merges cannot be undone.
   * In REST, call Preview Merge Contacts to test before merging.
   *
   * </blockquote>
   *
   * When you merge contacts, source contacts are typically deleted.
   * However, if a source contact is a site member or a Wix user,
   * the merge will fail because site members and Wix users can't be deleted.
   * This means that site members and Wix users can only be specified as target contacts in a merge.
   *
   * After merging, calling Get Contact with a deleted source contact ID returns the target contact ID.
   * Specifying a deleted source contact ID is not supported on any other method.
   *
   * When contacts are merged:
   *
   * - The Contact Merged event is triggered.
   * - The Contact Updated event is triggered for the target contact. `originatedFrom` is set to `merge`.
   * - The Contact Deleted event is triggered for each source contact. `originatedFrom` is set to `merge`.
   */
  comWixpressContactsCoreApiV4MergeContacts?: Maybe<ComWixpressContactsCoreApiV4MergeContactsResponse>;
  /**
   * Previews merging source contacts into a target contact.
   *
   * This method performs a dry run without deleting or updating any contacts.
   * A preview of the updated target contact is returned,
   * but no data is changed in the contact list.
   *
   * To perform the actual merge, use Merge Contacts.
   */
  comWixpressContactsCoreApiV4PreviewMergeContacts?: Maybe<ComWixpressContactsCoreApiV4PreviewMergeContactsResponse>;
  /**
   * Retrieves facets from the site’s contact list by filter.
   * Facets include labels and subscription statuses.
   */
  comWixpressContactsCoreApiV4QueryFacets?: Maybe<ComWixpressContactsCoreApiV4QueryFacetsResponse>;
  /**
   * Retrieves a list of contacts, given the provided cursorPaging, [filtering, and sorting](https://dev.wix.com/api/rest/contacts/contacts/sorting,-filtering,-and-searching).
   * Up to 1,000 contacts can be returned per request.
   *
   * For a detailed list of supported operations, see
   * filtering and sorting for
   * [contact properties](https://dev.wix.com/api/rest/contacts/contacts/sorting,-filtering,-and-searching#contact-properties-filtering-sorting-and-searching),
   * [extended fields](https://dev.wix.com/api/rest/contacts/contacts/sorting,-filtering,-and-searching#extended-fields-filtering-sorting-and-searching),
   * and [custom fields](https://dev.wix.com/api/rest/contacts/contacts/sorting,-filtering,-and-searching#custom-fields-filtering-sorting-and-searching).
   * To learn how to query contacts, see
   * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
   */
  comWixpressContactsCoreApiV4SearchContacts?: Maybe<ComWixpressContactsCoreApiV4SearchContactsResponse>;
  comWixpressContactsCoreApiV4SyncSubmitContact?: Maybe<Scalars['Void']>;
  /**
   * Removes labels from a contact.
   *
   * If a label is no longer needed
   * and you want to remove it from all contacts,
   * you can delete by calling Delete Label from the Labels API.
   *
   * Members are typically linked to contacts, and while they share a relationship, the member ID and contact ID are distinct identifiers.
   * Make sure to specify the contact ID when calling Unlabel Contact.
   */
  comWixpressContactsCoreApiV4UnlabelContact?: Maybe<ComWixpressContactsCoreApiV4UnlabelContactResponse>;
  /**
   * Updates a contact.
   *
   * Each time the contact is updated,
   * `revision` increments by 1.
   * The existing `revision` must be included when updating the contact.
   * This ensures you're working with the latest contact information,
   * and it prevents unintended overwrites.
   *
   * You can't call Update Contact to update the `primaryEmail` of a contact who is also a member.
   * Instead, use the Members API to update the member's login email, which will also update the contact's primary email.
   *
   * Members are typically linked to contacts, and while they share a relationship, the member ID and contact ID are distinct identifiers. Make sure to specify the contact ID when calling Update Contact.
   */
  comWixpressContactsCoreApiV4UpdateContact?: Maybe<ComWixpressContactsCoreApiV4UpdateContactResponse>;
  /** Update the requested contact, when found by given email and/or phone, otherwise create the contact. */
  comWixpressContactsCoreApiV4UpsertContact?: Maybe<ComWixpressContactsCoreApiV4UpsertContactResponse>;
  /**
   * Deletes an extended field.
   *
   * When an extended field is deleted,
   * any contact data stored in the field is also permanently deleted.
   */
  comWixpressContactsFieldsV4DeleteExtendedField?: Maybe<Scalars['Void']>;
  /**
   * Retrieves a custom field with a specified name, or creates one if it doesn't exist.
   * The number of custom fields is limited to 100.
   *
   * Successful calls to this method always return a field,
   * which can be specified in subsequent calls.
   *
   * To find an existing custom field without potentially creating a new one, call Get Extended Field or
   * Query Extended Fields.
   */
  comWixpressContactsFieldsV4FindOrCreateExtendedField?: Maybe<ComWixpressContactsFieldsV4FindOrCreateExtendedFieldResponse>;
  comWixpressContactsFieldsV4GdprList?: Maybe<ComWixpressContactsFieldsV4GdprListResponse>;
  /** Get field by legacy id. */
  comWixpressContactsFieldsV4GetExtendedFieldByLegacyId?: Maybe<ComWixpressContactsFieldsV4GetExtendedFieldByLegacyIdResponse>;
  /** Retrieves a list of extended fields. */
  comWixpressContactsFieldsV4ListExtendedFields?: Maybe<ComWixpressContactsFieldsV4ListExtendedFieldsResponse>;
  comWixpressContactsFieldsV4Purge?: Maybe<ComWixpressContactsFieldsV4PurgeResponse>;
  /** Renames an extended field. */
  comWixpressContactsFieldsV4UpdateExtendedField?: Maybe<ComWixpressContactsFieldsV4UpdateExtendedFieldResponse>;
  /** Deletes the specified label from a site and removes it from the contacts it applies to. */
  comWixpressContactsLabelsV4DeleteLabel?: Maybe<Scalars['Void']>;
  /**
   * Retrieves a label with a specified name, or creates one if it doesn't exist.
   *
   * Successful calls to this method always return a label,
   * which can be specified in subsequent calls.
   *
   * For example, in the Contacts API, Label Contact and Unlabel Contact
   * calls will fail if you include a non-existent label.
   * To ensure successful calls, you can call this method first,
   * and then use the response in the Label Contact and Unlabel Contact calls.
   *
   * To find an existing label without potentially creating a new one, call
   * Get Label or Query Labels.
   */
  comWixpressContactsLabelsV4FindOrCreateLabel?: Maybe<ComWixpressContactsLabelsV4FindOrCreateLabelResponse>;
  comWixpressContactsLabelsV4GdprList?: Maybe<ComWixpressContactsLabelsV4GdprListResponse>;
  /** Get label */
  comWixpressContactsLabelsV4GetLabelByLegacyId?: Maybe<ComWixpressContactsLabelsV4GetLabelByLegacyIdResponse>;
  /** Lists Namespaces. */
  comWixpressContactsLabelsV4ListLabelNamespaces?: Maybe<ComWixpressContactsLabelsV4ListLabelNamespacesResponse>;
  /** Lists all contact labels for a site. */
  comWixpressContactsLabelsV4ListLabels?: Maybe<ComWixpressContactsLabelsV4ListLabelsResponse>;
  comWixpressContactsLabelsV4Purge?: Maybe<ComWixpressContactsLabelsV4PurgeResponse>;
  /** Renames a label. */
  comWixpressContactsLabelsV4UpdateLabel?: Maybe<ComWixpressContactsLabelsV4UpdateLabelResponse>;
  /**
   * Add location type to a specific location.
   *
   * > **Notes:**
   * > + Add one the location type (UNKNOWN, BRANCH, OFFICES, RECEPTION, HEADQUARTERS, INVENTORY) to a specific location by id.
   * > + This EP is deprecated - Please use AddTypeFromLocation instead.
   */
  comWixpressLocationsAddLocationType?: Maybe<ComWixpressLocationsAddLocationTypeResponse>;
  /** Adds a location type to the specified location. */
  comWixpressLocationsAddTypeToLocation?: Maybe<ComWixpressLocationsAddTypeToLocationResponse>;
  /**
   * Archives a location.
   *
   *
   * > **Notes:**
   * > + Changes the `archived` boolean of a location to `true`.
   * > + You can't change a location's `status` using this endpoint.
   * > + Archived locations can't be updated.
   * > + The `default` location can't be archived.
   */
  comWixpressLocationsArchiveLocation?: Maybe<ComWixpressLocationsArchiveLocationResponse>;
  /** Creates locations in bulk. */
  comWixpressLocationsBulkCreateLocation?: Maybe<ComWixpressLocationsBulkCreateLocationResponse>;
  /**
   * Replaces locations in bulk.
   *
   *
   * > **Note:** Currently, it isn't possible to partially update a location. Therefore, you'll need to pass the full location object in the body of the call.
   */
  comWixpressLocationsBulkUpdateLocation?: Maybe<ComWixpressLocationsBulkUpdateLocationResponse>;
  /** Creates a location. */
  comWixpressLocationsCreateLocation?: Maybe<ComWixpressLocationsCreateLocationResponse>;
  /** Retrieves locations, given the specified filters, sorting, and paging. */
  comWixpressLocationsListLocations?: Maybe<ComWixpressLocationsListLocationsResponse>;
  /**
   * Remove location type from a specific location.
   *
   * > **Notes:**
   * > + Remove location type (UNKNOWN, BRANCH, OFFICES, RECEPTION, HEADQUARTERS, INVENTORY) from a specific location by id.
   * > + This EP is deprecated - Please use RemoveTypeFromLocation instead.
   */
  comWixpressLocationsRemoveLocationType?: Maybe<ComWixpressLocationsRemoveLocationTypeResponse>;
  /** Removes a location type from the specified location. */
  comWixpressLocationsRemoveTypeFromLocation?: Maybe<ComWixpressLocationsRemoveTypeFromLocationResponse>;
  /**
   * Sets a new default location.
   *
   *
   * > **Notes:**
   * > + There can only be one default location per site.
   * > + The default location can't be archived.
   */
  comWixpressLocationsSetDefaultLocation?: Maybe<ComWixpressLocationsSetDefaultLocationResponse>;
  /**
   * Unarchives a location.
   *
   * > **Notes:**
   * > + Changes the `archived` boolean of a location to `false`.
   * > + You can't change a location's `status` using this endpoint.
   */
  comWixpressLocationsUnarchiveLocation?: Maybe<ComWixpressLocationsUnarchiveLocationResponse>;
  /**
   * Overrides an existing location.
   *
   *
   * > **Note:** Currently, it isn't possible to partially update a location. Therefore, you'll need to pass the full location object in the body of the call.
   */
  comWixpressLocationsUpdateLocation?: Maybe<ComWixpressLocationsUpdateLocationResponse>;
  /**
   * Changes member status to `"APPROVED"` and gives access to members-only pages.
   *
   * Call this API to:
   * - Approve a pending member.
   * - Unblock a blocked member.
   */
  comWixpressMembersApiApproveMember?: Maybe<ComWixpressMembersApiApproveMemberResponse>;
  /**
   * Blocks a member.
   *
   * A blocked member can't log in to members-only pages.
   *
   * To unblock a member, call Approve Member.
   */
  comWixpressMembersApiBlockMember?: Maybe<ComWixpressMembersApiBlockMemberResponse>;
  /**
   * Changes status of multiple members to `"APPROVED"`, and gives access to members-only pages.
   *
   * Call this API to:
   * - Approve pending members.
   * - Unblock blocked members.
   */
  comWixpressMembersApiBulkApproveMembers?: Maybe<ComWixpressMembersApiBulkApproveMembersResponse>;
  /**
   * Blocks multiple members by a specified filter.
   *
   * Blocked members can't log in to members-only pages.
   *
   * To unblock multiple members, call Bulk Approve Members.
   */
  comWixpressMembersApiBulkBlockMembers?: Maybe<ComWixpressMembersApiBulkBlockMembersResponse>;
  /**
   * Deletes multiple members by `memberId`.
   *
   * All content created by these members is transferred to a site owner's account. For example, if Wix users had blog posts, those posts are transferred to the site owner's account, which then becomes the owner of those posts.
   */
  comWixpressMembersApiBulkDeleteMembers?: Maybe<ComWixpressMembersApiBulkDeleteMembersResponse>;
  /**
   * Deletes multiple members by the specified filter.
   *
   * All content created by these members is transferred to a site owner's account. For example, if Wix users had blog posts, those posts are transferred to the site owner's account, which then becomes the owner of those posts.
   */
  comWixpressMembersApiBulkDeleteMembersByFilter?: Maybe<ComWixpressMembersApiBulkDeleteMembersByFilterResponse>;
  comWixpressMembersApiConsumeAddActivityToContactMessageV2?: Maybe<Scalars['Void']>;
  comWixpressMembersApiConsumeIdentityDomainEvents?: Maybe<Scalars['Void']>;
  comWixpressMembersApiConsumeMemberPiiDataExchangeDomainEvents?: Maybe<Scalars['Void']>;
  comWixpressMembersApiConsumeMetaSiteSpecialNoProvisioningEvents?: Maybe<Scalars['Void']>;
  comWixpressMembersApiConsumeProfileDomainEvents?: Maybe<Scalars['Void']>;
  comWixpressMembersApiConsumeSiteMemberProfileUpdate?: Maybe<Scalars['Void']>;
  /**
   * Creates a site member.
   *
   * After creation, you can call
   * [Send Set Password Email](https://dev.wix.com/docs/rest/crm/members-contacts/members/member-authentication/send-set-password-email)
   * to email the member with a link to set their password.
   * The member can log in to the site
   * when they set their password for the first time.
   *
   * > **Note:**
   * > When creating multiple members,
   * > set your requests at least 1 second apart to keep below rate limits.
   */
  comWixpressMembersApiCreateMember?: Maybe<ComWixpressMembersApiCreateMemberResponse>;
  /**
   * Deletes a member by ID.
   *
   * All content created by this member is transferred to a site owner's account. For example, if a Wix user had blog posts, those posts are transferred to the site owner's account, which then becomes the owner of those posts.
   */
  comWixpressMembersApiDeleteMember?: Maybe<Scalars['Void']>;
  /**
   * Clears a member's street addresses.
   *
   * Members are typically associated with a contact, each having a distinct member ID and contact ID. When specifying the ID as a parameter, don't presume the IDs are identical since they represent separate entities.
   */
  comWixpressMembersApiDeleteMemberAddresses?: Maybe<ComWixpressMembersApiDeleteMemberAddressesResponse>;
  /**
   * Clears a member's email addresses.
   *
   * Members are typically associated with a contact, each having a distinct member ID and contact ID. When specifying the ID as a parameter, don't presume the IDs are identical since they represent separate entities.
   *
   * > Note: A member can still log in with their `loginEmail`, which is not cleared when this method is called.
   */
  comWixpressMembersApiDeleteMemberEmails?: Maybe<ComWixpressMembersApiDeleteMemberEmailsResponse>;
  /**
   * Clears a member's phone numbers.
   *
   * Members are typically associated with a contact, each having a distinct member ID and contact ID. When specifying the ID as a parameter, don't presume the IDs are identical since they represent separate entities.
   */
  comWixpressMembersApiDeleteMemberPhones?: Maybe<ComWixpressMembersApiDeleteMemberPhonesResponse>;
  /**
   * Deletes the current member.
   *
   * After calling this method, the member is logged out of the site.
   *
   * All content created by this member is transferred to another account. For example, if a Wix user had blog posts, those posts are transferred to the account specified in `contentAssignedId`, which then becomes the owner of those posts.
   *
   * >**Note:**
   * >This method requires [visitor or member authentication](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities).
   */
  comWixpressMembersApiDeleteMyMember?: Maybe<Scalars['Void']>;
  /**
   * Disconnects a member.
   *
   * A disconnected member can't log in to members-only pages, and the member isn't visible in the dashboard.
   *
   * >**Note:** This action is irreversible. To connect the same member again, you have to create a member with a new slug.
   */
  comWixpressMembersApiDisconnectMember?: Maybe<ComWixpressMembersApiDisconnectMemberResponse>;
  /**
   * Retrieves the current member.
   *
   * >**Note:**
   * >This method requires [visitor or member authentication](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities).
   */
  comWixpressMembersApiGetMyMember?: Maybe<ComWixpressMembersApiGetMyMemberResponse>;
  /**
   * Joins the currently logged-in member to the site community and sets their profile to public.
   *
   * When a member's profile is public, they have access to the site's
   * [Members Area](https://support.wix.com/en/article/about-members-area)
   * features — such as chat, forum, and followers —
   * and their profile is visible to other members and site visitors.
   *
   * >**Note:**
   * >This method requires [visitor or member authentication](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities).
   */
  comWixpressMembersApiJoinCommunity?: Maybe<ComWixpressMembersApiJoinCommunityResponse>;
  /**
   * Removes the currently logged-in member from the site community and sets their profile to private.
   *
   * When a member's profile is private,
   * they do not have access to the site's
   * [Members Area](https://support.wix.com/en/article/about-members-area)
   * features — such as chat, forum, and followers —
   * and their profile is hidden from other members and site visitors.
   *
   * > **Notes:**
   * > - If a member leaves the site's community, their content (such as forum posts and blog comments) remain publicly visible.
   * > - This method requires [visitor or member authentication](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities).
   */
  comWixpressMembersApiLeaveCommunity?: Maybe<ComWixpressMembersApiLeaveCommunityResponse>;
  /**
   * Lists site members, given the provided paging and fieldsets.
   *
   * A member's default privacy status is `"PRIVATE"`. Private members aren't returned in the response if a [site visitor](https://dev.wix.com/docs/api-reference/articles/authentication/about-identities#site-visitor) or [site member](https://dev.wix.com/docs/api-reference/articles/authentication/about-identities#site-member) identity calls this method. Learn more about [managing your member privacy settings](https://support.wix.com/en/article/site-members-managing-your-member-privacy-settings).
   */
  comWixpressMembersApiListMembers?: Maybe<ComWixpressMembersApiListMembersResponse>;
  /**
   * Mutes a member.
   *
   * Muted members can't engage with a community. For example, they can't leave comments, like posts or comments, or share content.
   *
   * You can mute members in [Wix Blog](https://dev.wix.com/docs/rest/business-solutions/blog/introduction) and [Wix Forum](https://dev.wix.com/docs/rest/business-solutions/forum/introduction).
   */
  comWixpressMembersApiMuteMember?: Maybe<ComWixpressMembersApiMuteMemberResponse>;
  /**
   * Unmutes a member.
   *
   * Unmuted members can engage with the community. For example, leave comments, like posts or comments, and share content.
   *
   * You can unmute members in [Wix Blog](https://dev.wix.com/docs/rest/business-solutions/blog/introduction) and [Wix Forum](https://dev.wix.com/docs/rest/business-solutions/forum/introduction).
   */
  comWixpressMembersApiUnmuteMember?: Maybe<ComWixpressMembersApiUnmuteMemberResponse>;
  /**
   * Updates a member's properties.
   *
   * Members are typically associated with a contact, each having a distinct member ID and contact ID. When specifying the ID as a parameter, don't presume the IDs are identical since they represent separate entities.
   *
   * `privacyStatus` can't be updated with Update Member. A member can call Leave Community or Join Community to update their `privacyStatus`.
   *
   * To clear a field's value, set an empty value with an empty string `""`.
   *
   * Note that updating the `contact.addresses`, `contact.emails`, or `contact.phones` array overwrites
   * the entire array, so any existing values you want to retain should be specified in the Update Member call
   * along with the new values to add. However, passing an empty array will have no effect and the following
   * methods must be called to clear all the data from these respective arrays:
   * - To clear `contact.addresses`, call Delete Member Addresses.
   * - To clear `contact.emails`, call Delete Member Emails.
   * - To clear `contact.phones`, call Delete Member Phones.
   */
  comWixpressMembersApiUpdateMember?: Maybe<ComWixpressMembersApiUpdateMemberResponse>;
  /** Updates a member's slug. */
  comWixpressMembersApiUpdateMemberSlug?: Maybe<ComWixpressMembersApiUpdateMemberSlugResponse>;
  /**
   * Updates the current member's slug.
   *
   * >**Note:**
   * >This method requires [visitor or member authentication](https://dev.wix.com/docs/go-headless/coding/rest-api/visitors-and-members/make-api-calls-with-oauth).
   */
  comWixpressMembersApiUpdateMySlug?: Maybe<ComWixpressMembersApiUpdateMySlugResponse>;
  /**
   * Archives a single plan.
   * When a plan is archived, it's no longer visible as a public plan that can be chosen by site members or visitors.
   * This is because the plan's `public` property is automatically set to `false`.
   * Archived plans can't be purchased or reactivated.
   * Plan archiving doesn't impact existing orders made for the plan. All orders for the plan are still active and keep their perks, payment options, and terms.
   * Wix users can see archived plans in a site's dashboard under **Pricing Plans -> Archived Plans**.
   * > **Note:** An attempt to archive an already-archived plan throws an error.
   */
  comWixpressMembershipV2PlansArchivePlan?: Maybe<ComWixpressMembershipV2PlansArchivePlanResponse>;
  /**
   * Changes the display order of the plans on a site and in a site's dashboard.
   * To rearrange the order of the plans, provide a list of plan IDs in the desired order.
   * Include all public and hidden plans in the list you provide.
   * Make sure to provide **all** non-archived plan IDs to avoid unpredictable results.
   */
  comWixpressMembershipV2PlansArrangePlans?: Maybe<Scalars['Void']>;
  /**
   * Archives multiple plans.
   * See "Archives a single plan" for more information.
   */
  comWixpressMembershipV2PlansBulkArchivePlan?: Maybe<ComWixpressMembershipV2PlansBulkArchivePlanResponse>;
  /** Sets all pricing plans as not primary. When viewing pricing plans on the site, no plan is highlighted with a customizable ribbon. */
  comWixpressMembershipV2PlansClearPrimary?: Maybe<Scalars['Void']>;
  /** Returns a count of plans for a site. */
  comWixpressMembershipV2PlansCountPlans?: Maybe<ComWixpressMembershipV2PlansCountPlansResponse>;
  /**
   * Creates a pricing plan. The specified `plan` object must contain a pricing model. A pricing model can be 1 of the following:
   * - **A subscription**: A subscription with recurring payments and how often the plan occurs. Subscriptions can have free trial days.
   * - **A plan that doesn't renew**: A single payment for a specific duration that doesn't renew.
   * - **An unlimited plan**: A single payment for an unlimited amount of time (until canceled).
   * Pricing plans are available to the Wix user in the Pricing Plans section in a site's dashboard.
   */
  comWixpressMembershipV2PlansCreatePlan?: Maybe<ComWixpressMembershipV2PlansCreatePlanResponse>;
  /** Gets statistics about the pricing plans. Currently providing only the total number of pricing plans. */
  comWixpressMembershipV2PlansGetPlanStats?: Maybe<ComWixpressMembershipV2PlansGetPlanStatsResponse>;
  /** Retrieves a list of up to 100 pricing plans (including public, hidden, and archived plans). */
  comWixpressMembershipV2PlansListPlans?: Maybe<ComWixpressMembershipV2PlansListPlansResponse>;
  /** Retrieves a list of up to 100 public pricing plans. Public plans are visible plans that are available to site visitors and can be purchased. */
  comWixpressMembershipV2PlansListPublicPlans?: Maybe<ComWixpressMembershipV2PlansListPublicPlansResponse>;
  /** Marks a pricing plan as the primary pricing plan. When viewing pricing plans on a site, the primary plan is highlighted with a customizable ribbon. Only a single plan can be marked as a primary plan at any given time. If there is an existing plan marked as primary, calling Make Plan Primary causes the existing primary plan to lose its primary status. */
  comWixpressMembershipV2PlansMakePlanPrimary?: Maybe<ComWixpressMembershipV2PlansMakePlanPrimaryResponse>;
  /** Retrieves a list of plans matching the filter and search phrase for the name. */
  comWixpressMembershipV2PlansSearchPlans?: Maybe<ComWixpressMembershipV2PlansSearchPlansResponse>;
  /**
   * Sets visibility for pricing plans. Visible plans are considered public plans.
   * By default, pricing plans are public, meaning they are visible. Plans can be hidden so that site members and visitors can't choose them.
   * As opposed to archiving, setting visibility can be reversed. This means that a public plan can be hidden, and a hidden plan can be made public (visible). (An archived plan always remains archived and can't be made active again.)
   * Changing a plan’s visibility doesn't impact existing orders for the plan. All orders for hidden plans are still active and keep their perks.
   */
  comWixpressMembershipV2PlansSetPlanVisibility?: Maybe<ComWixpressMembershipV2PlansSetPlanVisibilityResponse>;
  /**
   * Updates a pricing plan.
   * Updating a plan doesn't impact existing orders made for the plan. All orders keep the details of the original plan that was active at the time of purchase.
   */
  comWixpressMembershipV2PlansUpdatePlan?: Maybe<ComWixpressMembershipV2PlansUpdatePlanResponse>;
  /** Creates multiple tags. */
  comWixpressNpmCommunitiesPlatformizedBlogBulkCreateTags?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogBulkCreateTagsResponse>;
  /** Bulk delete for tags */
  comWixpressNpmCommunitiesPlatformizedBlogBulkDeleteTag?: Maybe<Scalars['Void']>;
  /** Creates a new tag with the provided label if a tag with the same label doesn't already exist. */
  comWixpressNpmCommunitiesPlatformizedBlogCreateTag?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogCreateTagResponse>;
  /** Deletes a tag. Deleting a tag removes that tag from all blog posts that contain it. */
  comWixpressNpmCommunitiesPlatformizedBlogDeleteTag?: Maybe<Scalars['Void']>;
  /** If a tag already exists with the provided label, returns this tag. Otherwise, the request creates a new tag with the provided label. */
  comWixpressNpmCommunitiesPlatformizedBlogGetOrCreateTag?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogGetOrCreateTagResponse>;
  /**
   * Retrieves a tag by the provided label.
   *
   * Sub-labels can also be specified using a `/`. For example, you can have `'dessert/icecream'` and `'dessert/pie'` as two different tag labels.
   *
   * > **Note:** The full URL path following `labels/` is counted as 1 label. Adding a `/` to a label does _not_ create multiple labels. This means that `'dessert/icecream'` is a single label.
   */
  comWixpressNpmCommunitiesPlatformizedBlogGetTagByLabel?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogGetTagByLabelResponse>;
  /**
   * Retrieves a tag with the provided slug.
   *
   * The `slug` is the end of a tag's URL that refers to a specific tag.
   * For example, if a tag's URL is `https://example.com/blog/tag/{my-tag-slug}`,
   * the slug is `my-tag-slug`. The `slug` is case-sensitive and derived from the tag's `label`.
   */
  comWixpressNpmCommunitiesPlatformizedBlogGetTagBySlug?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogGetTagBySlugResponse>;
  /** Retrieves a count of tags for every site language. */
  comWixpressNpmCommunitiesPlatformizedBlogGetTagsCountByLanguage?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogGetTagsCountByLanguageResponse>;
  /** Lists tags. Default sort is descending by post count and default tag size is 50. */
  comWixpressNpmCommunitiesPlatformizedBlogListTags?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogListTagsResponse>;
  /** Updates a tag. */
  comWixpressNpmCommunitiesPlatformizedBlogUpdateTag?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogUpdateTagResponse>;
  /** Creates multiple categories. */
  comWixpressNpmCommunitiesPlatformizedBlogV3BulkCreateCategories?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3BulkCreateCategoriesResponse>;
  /** Bulk delete for categories */
  comWixpressNpmCommunitiesPlatformizedBlogV3BulkDeleteCategory?: Maybe<Scalars['Void']>;
  /** Retrieves metrics for specified posts. */
  comWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostMetrics?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostMetricsResponse>;
  /** Retrieves reactions of the current user for specified posts. */
  comWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostReactions?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostReactionsResponse>;
  /** Updates multiple categories. */
  comWixpressNpmCommunitiesPlatformizedBlogV3BulkUpdateCategories?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3BulkUpdateCategoriesResponse>;
  /** Converts DraftJs content to Rich content. */
  comWixpressNpmCommunitiesPlatformizedBlogV3ConvertDraftJsToRichContent?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ConvertDraftJsToRichContentResponse>;
  /** Converts Rich content to DraftJs content. */
  comWixpressNpmCommunitiesPlatformizedBlogV3ConvertRichContentToDraftJs?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ConvertRichContentToDraftJsResponse>;
  /** Creates a category. */
  comWixpressNpmCommunitiesPlatformizedBlogV3CreateCategory?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CreateCategoryResponse>;
  /** Creates draft post from specified post template */
  comWixpressNpmCommunitiesPlatformizedBlogV3CreateDraftPostFromTemplate?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CreateDraftPostFromTemplateResponse>;
  /** Deletes a category. */
  comWixpressNpmCommunitiesPlatformizedBlogV3DeleteCategory?: Maybe<Scalars['Void']>;
  /** Retrieves a count of categories for every site language. */
  comWixpressNpmCommunitiesPlatformizedBlogV3GetCategoriesCountByLanguage?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3GetCategoriesCountByLanguageResponse>;
  /**
   * Gets a category with the specified slug.
   *
   * The slug is at the end of the URL of a specific category.
   * For example, if a category's URL is `https://example.com/blog/categories/famous-cats`, the slug is `famous-cats`.
   * The slug is a case-sensitive string that is derived from the category's label, unless specified otherwise.
   */
  comWixpressNpmCommunitiesPlatformizedBlogV3GetCategoryBySlug?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3GetCategoryBySlugResponse>;
  /**
   * Retrieves a post with the provided slug.
   *
   * The slug is the end of a post's URL that refers to a specific post.
   * For example, if a post's URL is `https:/example.com/blog/post/my-post-slug`,
   * the slug is `my-post-slug`. The slug is case-sensitive, and is generally derived from the post title,
   * unless specified otherwise.
   */
  comWixpressNpmCommunitiesPlatformizedBlogV3GetPostBySlug?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostBySlugResponse>;
  comWixpressNpmCommunitiesPlatformizedBlogV3GetPostCountPerMonth?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostCountPerMonthResponse>;
  /**
   * Retrieves a post's metrics.
   *
   * A post's metrics include the comments, likes, and views the post receives.
   */
  comWixpressNpmCommunitiesPlatformizedBlogV3GetPostMetrics?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostMetricsResponse>;
  /** Gets post template by given id */
  comWixpressNpmCommunitiesPlatformizedBlogV3GetTemplate?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3GetTemplateResponse>;
  /** Retrieves total likes of a member. */
  comWixpressNpmCommunitiesPlatformizedBlogV3GetTotalLikesPerMember?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3GetTotalLikesPerMemberResponse>;
  /** Retrieves the total amount of published posts of the blog. */
  comWixpressNpmCommunitiesPlatformizedBlogV3GetTotalPosts?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogGetTotalPostsResponse>;
  /** Retrieves the amount of published posts for the current blog. */
  comWixpressNpmCommunitiesPlatformizedBlogV3GetTotalPublications?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogGetTotalPublicationsResponse>;
  /** Likes a post. */
  comWixpressNpmCommunitiesPlatformizedBlogV3LikePost?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3LikePostResponse>;
  /**
   * Retrieves a list of up to 100 categories per request.
   *
   * If you pass a language filter to the method, it returns a list of up to 100 categories in the requested language.
   *
   * The categoies are displayed in order of their `displayPosition`, starting with `0`. The `displayPosition` is the position in which the categories
   * are displayed in the Category Menu page. By default, categories get added to the bottom of the Category Menu page with a `displayPosition` of `-1`.
   *
   * List Categories runs with these defaults, which you can override:
   * - `paging.limit` is `50`.
   * - `paging.offset` is `0`.
   *
   * List Categories is sorted by `displayPosition` in descending order. This cannot be overridden.
   */
  comWixpressNpmCommunitiesPlatformizedBlogV3ListCategories?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ListCategoriesResponse>;
  /** Retrieves a list of published demo posts. */
  comWixpressNpmCommunitiesPlatformizedBlogV3ListDemoPosts?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ListDemoPostsResponse>;
  /**
   * Retrieves a list of up to 100 published posts per request.
   *
   * List Posts runs with these defaults, which you can override:
   * - `firstPublishedDate` is sorted in descending order, with pinned posts first.
   * - `paging.limit` is `50`.
   * - `paging.offset` is `0`.
   */
  comWixpressNpmCommunitiesPlatformizedBlogV3ListPosts?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ListPostsResponse>;
  /** Retrieves a post's archive. */
  comWixpressNpmCommunitiesPlatformizedBlogV3ListPostsArchive?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ListPostsArchiveResponse>;
  /** Retrieves available post templates and template categories if asked */
  comWixpressNpmCommunitiesPlatformizedBlogV3ListTemplates?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ListTemplatesResponse>;
  /** Pins a post in the feed. */
  comWixpressNpmCommunitiesPlatformizedBlogV3PinPost?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PinPostResponse>;
  /**
   * Retrieves the number of published posts per month within a specified time range.
   *
   * The time range is set using the `rangeStart` and `months` properties.
   * The time range always starts on the 1st day of the month set in `rangeStart` and
   * includes the number of `months` following `rangeStart`.
   * For example, if `rangeStart` is set to `'2022-03-13'` and `months` is set to `4`,
   * the time range will be from `'2022-03-01'` until `'2022-06-30'`. The time range always ends on the last day of the month.
   * > Note: If there are no published posts in a month within the time range, that month is not included in the response. For example, let's say a blog has `0` posts dated in February 2022. If `rangeStart` is set to `'2022-01-01'` and `months` is set to `3`, the response includes `postCount` values for January and March, but not February.
   */
  comWixpressNpmCommunitiesPlatformizedBlogV3QueryPostCountStats?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogQueryPostCountStatsResponse>;
  /**
   * Retrieves the number of posts per month published within a specified time span, from first day of a month - ignoring days value in period start field.
   * If `periodStart` value is set to `2018-11-10` and `months` value is set to `1`, the day value is ignored and statistic are returned for one month from
   * `2018-11-01` until `2018-11-30` and not between `2018-11-10` and `2018-12-10`.
   */
  comWixpressNpmCommunitiesPlatformizedBlogV3QueryPublicationsCountStats?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogQueryPublicationsCountStatsResponse>;
  comWixpressNpmCommunitiesPlatformizedBlogV3SendActionEvent?: Maybe<Scalars['Void']>;
  /** Unlikes a post. */
  comWixpressNpmCommunitiesPlatformizedBlogV3UnlikePost?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3UnlikePostResponse>;
  /** Unpins a post in the feed. */
  comWixpressNpmCommunitiesPlatformizedBlogV3UnpinPost?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3UnpinPostResponse>;
  /** Updates a category. */
  comWixpressNpmCommunitiesPlatformizedBlogV3UpdateCategory?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3UpdateCategoryResponse>;
  /** Increment view counter of a post. */
  comWixpressNpmCommunitiesPlatformizedBlogV3ViewPost?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ViewPostResponse>;
  comWixpressPortfolioCollectionsAdminRemoveMenuItems?: Maybe<ComWixpressPortfolioPortfolioappAdminRemoveMenuItemsResponse>;
  comWixpressPortfolioCollectionsConsumeCollectionDomainEvents?: Maybe<Scalars['Void']>;
  comWixpressPortfolioCollectionsConsumeLocaleEvent?: Maybe<Scalars['Void']>;
  /** Creates a new Collection */
  comWixpressPortfolioCollectionsCreateCollection?: Maybe<ComWixpressPortfolioCollectionsCreateCollectionResponse>;
  /** Delete a Collection */
  comWixpressPortfolioCollectionsDeleteCollection?: Maybe<ComWixpressPortfolioCollectionsDeleteCollectionResponse>;
  /** List all Collections in portfolio */
  comWixpressPortfolioCollectionsListCollections?: Maybe<ComWixpressPortfolioCollectionsListCollectionsResponse>;
  /**
   * Update a Collection, supports partial update
   * Pass the latest `revision` for a successful update
   */
  comWixpressPortfolioCollectionsUpdateCollection?: Maybe<ComWixpressPortfolioCollectionsUpdateCollectionResponse>;
  /** Create items in bulk */
  comWixpressPortfolioProjectitemsBulkCreateProjectItems?: Maybe<ComWixpressPortfolioProjectitemsBulkCreateProjectItemsResponse>;
  /** Delete items in bulk */
  comWixpressPortfolioProjectitemsBulkDeleteProjectItems?: Maybe<ComWixpressPortfolioProjectitemsBulkDeleteProjectItemsResponse>;
  /** Update ProjectItems in bulk */
  comWixpressPortfolioProjectitemsBulkUpdateProjectItems?: Maybe<ComWixpressPortfolioProjectitemsBulkUpdateProjectItemsResponse>;
  comWixpressPortfolioProjectitemsConsumeLocaleEvent?: Maybe<Scalars['Void']>;
  /**
   * Consume Project (wix.portfolio.projects.v1.project) DomainEvent in order to delete any ProjectItems in a deleted
   * project.
   */
  comWixpressPortfolioProjectitemsConsumeProjectDomainEvents?: Maybe<Scalars['Void']>;
  /** Creates a default gallery */
  comWixpressPortfolioProjectitemsCreateProjectGallery?: Maybe<ComWixpressPortfolioProjectitemsCreateProjectGalleryResponse>;
  /** Creates a new ProjectItem */
  comWixpressPortfolioProjectitemsCreateProjectItem?: Maybe<ComWixpressPortfolioProjectitemsCreateProjectItemResponse>;
  /** Delete a ProjectItem */
  comWixpressPortfolioProjectitemsDeleteProjectItem?: Maybe<ComWixpressPortfolioProjectitemsDeleteProjectItemResponse>;
  /** Given an 'origin' Project and 'target' Project, copy all ProjectItems in 'origin' Project to 'target' Project. */
  comWixpressPortfolioProjectitemsDuplicateProjectItems?: Maybe<ComWixpressPortfolioProjectitemsDuplicateProjectItemsResponse>;
  comWixpressPortfolioProjectitemsGenerateTokenForProjectItems?: Maybe<ComWixpressPortfolioPortfolioappGenerateTokenForProjectItemsResponse>;
  /** List all items in project */
  comWixpressPortfolioProjectitemsListProjectItems?: Maybe<ComWixpressPortfolioProjectitemsListProjectItemsResponse>;
  /** Update a ProjectItem, supports partial update */
  comWixpressPortfolioProjectitemsUpdateProjectItem?: Maybe<ComWixpressPortfolioProjectitemsUpdateProjectItemResponse>;
  /**
   * Consume Collection (wix.portfolio.collections.v1.collection) DomainEvent in order to delete any projects assigned to
   * a deleted collection.
   */
  comWixpressPortfolioProjectsConsumeCollectionDomainEvents?: Maybe<Scalars['Void']>;
  comWixpressPortfolioProjectsConsumeLocaleEvent?: Maybe<Scalars['Void']>;
  comWixpressPortfolioProjectsConsumeMetaSiteSpecialEvent?: Maybe<Scalars['Void']>;
  /** create default Portfolio data */
  comWixpressPortfolioProjectsCreateNewPortfolioApp?: Maybe<Scalars['Void']>;
  /** Creates a new Project */
  comWixpressPortfolioProjectsCreateProject?: Maybe<ComWixpressPortfolioProjectsCreateProjectResponse>;
  /** Delete a Project */
  comWixpressPortfolioProjectsDeleteProject?: Maybe<ComWixpressPortfolioProjectsDeleteProjectResponse>;
  comWixpressPortfolioProjectsGetProjectPageData?: Maybe<ComWixpressPortfolioPortfolioappGetProjectPageDataResponse>;
  /** List all projects in portfolio by creation date */
  comWixpressPortfolioProjectsListProjects?: Maybe<ComWixpressPortfolioProjectsListProjectsResponse>;
  /**
   * Deprecated - please use ProjectsInCollectionsService.QueryProjectsInCollections instead
   * our Client still use it
   */
  comWixpressPortfolioProjectsQueryProjectsWithCollectionInfo?: Maybe<ComWixpressPortfolioProjectsQueryProjectWithCollectionInfoResponse>;
  /**
   * Update a Project, supports partial update
   * Pass the latest `revision` for a successful update
   */
  comWixpressPortfolioProjectsUpdateProject?: Maybe<ComWixpressPortfolioProjectsUpdateProjectResponse>;
  /**
   * Deprecated - please use ProjectsInCollectionsService.UpdateProjectOrderInCollection instead
   * our Client still use it
   */
  comWixpressPortfolioProjectsUpdateProjectOrderInCollection?: Maybe<ComWixpressPortfolioProjectsUpdateProjectOrderInCollectionResponse>;
  /**
   * > **Note:** The Label API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Deletes multiple item labels at once.
   */
  comWixpressRestaurantsMenusItemLabelsV1BulkDeleteLabels?: Maybe<ComWixpressRestaurantsMenusItemLabelsV1BulkDeleteLabelsResponse>;
  /** Clone labels from a different metasite */
  comWixpressRestaurantsMenusItemLabelsV1CloneLabels?: Maybe<Scalars['Void']>;
  comWixpressRestaurantsMenusItemLabelsV1ConsumeLabelDomainEvents?: Maybe<Scalars['Void']>;
  /**
   * > **Note:** The Label API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves the number of labels that match a specified filter.
   *
   * If a filter isn't passed in the request, the endpoint returns the count of all labels.
   */
  comWixpressRestaurantsMenusItemLabelsV1CountLabels?: Maybe<ComWixpressRestaurantsMenusItemLabelsV1CountLabelsResponse>;
  /**
   * > **Note:** The Label API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Creates an item label.
   */
  comWixpressRestaurantsMenusItemLabelsV1CreateLabel?: Maybe<ComWixpressRestaurantsMenusItemLabelsV1CreateLabelResponse>;
  /**
   * > **Note:** The Label API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Deletes an item label.
   */
  comWixpressRestaurantsMenusItemLabelsV1DeleteLabel?: Maybe<Scalars['Void']>;
  /**
   * > **Note:** The Label API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a list of up to 500 item labels.
   */
  comWixpressRestaurantsMenusItemLabelsV1ListLabels?: Maybe<ComWixpressRestaurantsMenusItemLabelsV1ListLabelsResponse>;
  comWixpressRestaurantsMenusItemLabelsV1SyncContentToMultilingual?: Maybe<Scalars['Void']>;
  /**
   * > **Note:** The Label API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Updates an item Label.
   *
   * Each time an item label is updated, its revision increments by 1. The existing revision must be included when updating the item labels. This ensures you're working with the latest item labels information, and it prevents unintended overwrites.
   */
  comWixpressRestaurantsMenusItemLabelsV1UpdateLabel?: Maybe<ComWixpressRestaurantsMenusItemLabelsV1UpdateLabelResponse>;
  /**
   * > **Note:** The Items API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Creates multiple items at once.
   */
  comWixpressRestaurantsMenusItemV1BulkCreateItems?: Maybe<ComWixpressRestaurantsMenusItemV1BulkCreateItemsResponse>;
  /**
   * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Deletes multiple items at once.
   */
  comWixpressRestaurantsMenusItemV1BulkDeleteItems?: Maybe<ComWixpressRestaurantsMenusItemV1BulkDeleteItemsResponse>;
  /** update business location ids */
  comWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIds?: Maybe<ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsResponse>;
  /** update business location ids per entity */
  comWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsPerEntity?: Maybe<ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsPerEntityResponse>;
  /**
   * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Updates up to 100 multiple items at once.
   *
   * Each time an item is updated, its revision increments by 1. The existing revision must be included when updating item. This ensures you're working with the latest item information, and it prevents unintended overwrites.
   */
  comWixpressRestaurantsMenusItemV1BulkUpdateItem?: Maybe<ComWixpressRestaurantsMenusItemV1BulkUpdateItemResponse>;
  /** Clone items from a different metasite. */
  comWixpressRestaurantsMenusItemV1CloneItems?: Maybe<Scalars['Void']>;
  comWixpressRestaurantsMenusItemV1ConsumeDeleteLocationIdsFromModifierGroups?: Maybe<Scalars['Void']>;
  comWixpressRestaurantsMenusItemV1ConsumeDeleteLocationIdsFromVariants?: Maybe<Scalars['Void']>;
  comWixpressRestaurantsMenusItemV1ConsumeItemDomainEvents?: Maybe<Scalars['Void']>;
  comWixpressRestaurantsMenusItemV1ConsumeItemLabelDomainEvents?: Maybe<Scalars['Void']>;
  /** Reindex menus items to Site Search upon SearchIndexingNotification event */
  comWixpressRestaurantsMenusItemV1ConsumeSearchServicesNotificationEvents?: Maybe<Scalars['Void']>;
  comWixpressRestaurantsMenusItemV1ConsumeTaxGroupsDomainEvents?: Maybe<Scalars['Void']>;
  /**
   * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves the number of items that match a specified filter.
   *
   * If a filter isn't passed in the request, the endpoint returns the count of all items.
   */
  comWixpressRestaurantsMenusItemV1CountItems?: Maybe<ComWixpressRestaurantsMenusItemV1CountItemsResponse>;
  /**
   * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Creates an item.
   *
   * To create multiple items at once, use [Bulk Create Items](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item/bulk-create-items).
   */
  comWixpressRestaurantsMenusItemV1CreateItem?: Maybe<ComWixpressRestaurantsMenusItemV1CreateItemResponse>;
  /**
   * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Deletes an item.
   */
  comWixpressRestaurantsMenusItemV1DeleteItem?: Maybe<Scalars['Void']>;
  comWixpressRestaurantsMenusItemV1DuplicateItem?: Maybe<ComWixpressRestaurantsMenusItemV1RestaurantsDuplicateItemDuplicateItemResponse>;
  /**
   * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a list of up to 500 items.
   */
  comWixpressRestaurantsMenusItemV1ListItems?: Maybe<ComWixpressRestaurantsMenusItemV1ListItemsResponse>;
  /** Index menus item to Site Search upon sitePropertiesUpdated event */
  comWixpressRestaurantsMenusItemV1MenusItemsSiteSearchConsumeSitePropertiesUpdatedEvents?: Maybe<Scalars['Void']>;
  /**
   * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a list of items given the provided filtering, paging, and sorting.
   *
   * ## Defaults
   * Search Items has the following default settings, which you can override:
   *
   * - Sorted by `createdDate` in ascending order.
   * - `paging.limit` set to `500`.
   * - `paging.offset` set to `0`.
   */
  comWixpressRestaurantsMenusItemV1SearchItems?: Maybe<ComWixpressRestaurantsMenusItemV1SearchItemsResponse>;
  /**
   * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Updates an item.
   *
   * To update multiple items at once, use [Bulk Update Item](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item/bulk-update-item)
   *
   * Each time an item is updated, its revision increments by 1. The existing revision must be included when updating the item. This ensures you're working with the latest item information, and it prevents unintended overwrites.
   */
  comWixpressRestaurantsMenusItemV1UpdateItem?: Maybe<ComWixpressRestaurantsMenusItemV1UpdateItemResponse>;
  /**
   * > **Note:** The Menu API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Creates multiple menus at once.
   */
  comWixpressRestaurantsMenusMenuV1BulkCreateMenus?: Maybe<ComWixpressRestaurantsMenusMenuV1BulkCreateMenusResponse>;
  /**
   * > **Note:** The Menu API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Updates multiple menus at once.
   *
   * Each time a menu is updated, revision increments by 1. The existing revision must be included when updating the menu. This ensures you're working with the latest menu information, and it prevents unintended overwrites.
   */
  comWixpressRestaurantsMenusMenuV1BulkUpdateMenu?: Maybe<ComWixpressRestaurantsMenusMenuV1BulkUpdateMenuResponse>;
  /** Clone menus from a different metasite */
  comWixpressRestaurantsMenusMenuV1CloneMenus?: Maybe<Scalars['Void']>;
  comWixpressRestaurantsMenusMenuV1ConsumeDeleteOrphanSections?: Maybe<Scalars['Void']>;
  comWixpressRestaurantsMenusMenuV1ConsumeMenuDomainEvents?: Maybe<Scalars['Void']>;
  comWixpressRestaurantsMenusMenuV1ConsumeSectionDomainEvents?: Maybe<Scalars['Void']>;
  /**
   * > **Note:** The Menus API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Creates a menu.
   *
   * To create multiple menus at once, use [Bulk Create Menus](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/menu/bulk-create-menus).
   */
  comWixpressRestaurantsMenusMenuV1CreateMenu?: Maybe<ComWixpressRestaurantsMenusMenuV1CreateMenuResponse>;
  /**
   * > **Note:** The Menu API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Deletes a menu.
   */
  comWixpressRestaurantsMenusMenuV1DeleteMenu?: Maybe<Scalars['Void']>;
  /**
   * > **Note:** The Menu API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieve a menu by ID.
   */
  comWixpressRestaurantsMenusMenuV1GetMenu?: Maybe<ComWixpressRestaurantsMenusMenuV1GetMenuResponse>;
  /** Get menu details and path URL by menu ID. */
  comWixpressRestaurantsMenusMenuV1GetMenuSiteUrl?: Maybe<ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlGetMenuSiteUrlResponse>;
  /**
   * > **Note:** The Menu API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a list of up to 500 menus.
   */
  comWixpressRestaurantsMenusMenuV1ListMenus?: Maybe<ComWixpressRestaurantsMenusMenuV1ListMenusResponse>;
  /** Retrieve a list of menu details along with their corresponding path URLs. */
  comWixpressRestaurantsMenusMenuV1ListMenusSiteUrl?: Maybe<ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlListMenusSiteUrlResponse>;
  /**
   * > **Note:** The Menu API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a list of menus given the provided paging, filtering, and sorting. Up to 500 menus can be returned per request.
   *
   * For a detailed list of supported operations, see the [Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/menu/supported-filters-and-sorting) article. To learn how to query menus, see [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language).
   */
  comWixpressRestaurantsMenusMenuV1QueryMenus?: Maybe<ComWixpressRestaurantsMenusMenuV1QueryMenusResponse>;
  /**
   * > **Note:** The Menu API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Updates only the `extendedFields` field.
   *
   * Updates only the `extendedFields` field.
   */
  comWixpressRestaurantsMenusMenuV1UpdateExtendedFields?: Maybe<ComWixpressRestaurantsMenusMenuV1UpdateExtendedFieldsResponse>;
  /**
   * > **Note:** The Menu API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Updates a menu.
   *
   * To update multiple menus at once, use [Bulk Update Menu](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/menu/bulk-update-menu).
   *
   * Each time a menu is updated, revision increments by 1. The existing revision must be included when updating a menu. This ensures you're working with the latest menu information, and it prevents unintended overwrites.
   */
  comWixpressRestaurantsMenusMenuV1UpdateMenu?: Maybe<ComWixpressRestaurantsMenusMenuV1UpdateMenuResponse>;
  /**
   * > **Note:** The Section API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Creates multiple sections at once.
   */
  comWixpressRestaurantsMenusSectionV1BulkCreateSections?: Maybe<ComWixpressRestaurantsMenusSectionV1BulkCreateSectionsResponse>;
  /**
   * > **Note:** The Section API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Deletes multiple sections at once.
   */
  comWixpressRestaurantsMenusSectionV1BulkDeleteSections?: Maybe<ComWixpressRestaurantsMenusSectionV1BulkDeleteSectionsResponse>;
  comWixpressRestaurantsMenusSectionV1BulkUpdateBusinessLocationId?: Maybe<ComWixpressRestaurantsMenusSectionV1BulkUpdateBusinessLocationIdResponse>;
  /**
   * > **Note:** The Section API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Updates multiple sections at once.
   *
   * Each time a section is updated, its revision increments by 1. The existing revision must be included when updating a section. This ensures you're working with the latest section information, and it prevents unintended overwrites.
   */
  comWixpressRestaurantsMenusSectionV1BulkUpdateSection?: Maybe<ComWixpressRestaurantsMenusSectionV1BulkUpdateSectionResponse>;
  /** Clone sections from a different metasite */
  comWixpressRestaurantsMenusSectionV1CloneSections?: Maybe<Scalars['Void']>;
  comWixpressRestaurantsMenusSectionV1ConsumeDeleteLocationIdFromItems?: Maybe<Scalars['Void']>;
  comWixpressRestaurantsMenusSectionV1ConsumeDeleteOrphanItems?: Maybe<Scalars['Void']>;
  comWixpressRestaurantsMenusSectionV1ConsumeItemDomainEvents?: Maybe<Scalars['Void']>;
  comWixpressRestaurantsMenusSectionV1ConsumeSectionDomainEvents?: Maybe<Scalars['Void']>;
  /**
   * > **Note:** The Sections API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Creates a section.
   *
   * To create multiple sections at once, use [Bulk Create Sections](/sections/bulk-create-sections).
   */
  comWixpressRestaurantsMenusSectionV1CreateSection?: Maybe<ComWixpressRestaurantsMenusSectionV1CreateSectionResponse>;
  /**
   * > **Note:** The Section API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Deletes a section.
   */
  comWixpressRestaurantsMenusSectionV1DeleteSection?: Maybe<Scalars['Void']>;
  comWixpressRestaurantsMenusSectionV1DuplicateSection?: Maybe<ComWixpressRestaurantsMenusSectionV1RestaurantsDuplicateSectionDuplicateSectionResponse>;
  /**
   * > **Note:** The Section API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a list of up to 500 sections.
   */
  comWixpressRestaurantsMenusSectionV1ListSections?: Maybe<ComWixpressRestaurantsMenusSectionV1ListSectionsResponse>;
  /**
   * > **Note:** The Section API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Updates a section.
   *
   * Each time a section is updated, its revision increments by 1. The existing revision must be included when updating a section. This ensures you're working with the latest section information, and it prevents unintended overwrites.
   */
  comWixpressRestaurantsMenusSectionV1UpdateSection?: Maybe<ComWixpressRestaurantsMenusSectionV1UpdateSectionResponse>;
  /** Retrieves a current snapshot of a site's properties. */
  comWixpressSitepropertiesApiV4Read?: Maybe<ComWixpressSitepropertiesApiV4PropertiesReadResponse>;
  /** Retrieves current snapshots of multiple sites' properties. */
  comWixpressSitepropertiesApiV4ReadWithoutDefaultProperties?: Maybe<ComWixpressSitepropertiesApiV4BulkPropertiesReadResponse>;
  /** Updates one or more of a site's properties. The site ID is resolved via the Identification Service. */
  comWixpressSitepropertiesApiV4Update?: Maybe<ComWixpressSitepropertiesApiV4PropertiesUpdateResponse>;
  /** Updates a site's business contact information. */
  comWixpressSitepropertiesApiV4UpdateBusinessContact?: Maybe<Scalars['Void']>;
  /** Updates a site's business profile. */
  comWixpressSitepropertiesApiV4UpdateBusinessProfile?: Maybe<Scalars['Void']>;
  /**
   * Updates a site's business schedule.
   *
   * > **Note:** This method overwrites the current business schedule. `businessSchedule` is an array, so it must be written in its entirety. Therefore, you must modify the existing array and specify it in the API call.
   */
  comWixpressSitepropertiesApiV4UpdateBusinessSchedule?: Maybe<Scalars['Void']>;
  /**
   * Updates a site's default consent policy.
   *
   * Read more about [Consent Apps](https://dev.wix.com/docs/build-apps/launch-your-app/legal-and-security/about-consent-apps#about-consent-apps).
   */
  comWixpressSitepropertiesApiV4UpdateConsentPolicy?: Maybe<Scalars['Void']>;
  /**
   * Adds catalog line items and/or custom line items to a checkout.
   *
   * When adding [catalog](https://dev.wix.com/docs/rest/business-solutions/stores/catalog/e-commerce-integration) items
   * to a checkout, the `lineItems.catalogReference.appId` and `lineItems.catalogReference.catalogItemId` fields are required.
   */
  ecomCheckoutV1AddToCheckout?: Maybe<EcomCheckoutV1AddToCheckoutResponse>;
  ecomCheckoutV1ConsumeCheckoutDomainEvents?: Maybe<Scalars['Void']>;
  ecomCheckoutV1ConsumeOrderApprovedEvents?: Maybe<Scalars['Void']>;
  ecomCheckoutV1ConsumeOrderCreatedV2Events?: Maybe<Scalars['Void']>;
  ecomCheckoutV1ConsumeSubscriptionCreatedEvents?: Maybe<Scalars['Void']>;
  ecomCheckoutV1ConsumeUpdatedCheckoutEvents?: Maybe<Scalars['Void']>;
  /**
   * Creates a checkout.
   *
   * A checkout must include at least 1 item in `lineItems` or `customLineItems`.
   *
   * If passing `checkoutInfo.customFields`, then `checkoutInfo.customFields.value` is a required field.
   */
  ecomCheckoutV1CreateCheckout?: Maybe<EcomCheckoutV1CreateCheckoutResponse>;
  ecomCheckoutV1CreateCheckoutStream?: Maybe<EcomCheckoutV1CreateCheckoutResponse>;
  /**
   * Creates an order from a specified checkout.
   *
   * For an order to be created from a checkout, the following requirements must be met:
   * + A checkout cannot have calculation errors. Pass the checkout ID to Get Checkout and review the `calculationErrors` field.
   * + A checkout must have at least 1 line item or custom line item.
   * + All of the line Items have an `availability.status` of `"AVAILABLE"` or `"PARTIALLY_AVAILABLE"`.
   * + If there is a payment to be made, meaning that `priceSummary.total` is greater than `0`, the `billingInfo.address` field are required.
   * + When a checkout has line items to be shipped, the `shippingInfo.shippingDestination.address` and `shippingInfo.selectedCarrierServiceOption` fields are required.
   * + When a checkout has line items for pickup, the `shippingInfo.selectedCarrierServiceOption.logistics.pickupDetails` field are required.
   */
  ecomCheckoutV1CreateOrder?: Maybe<EcomCheckoutV1CreateOrderResponse>;
  /** Deprecated (use createOrder instead) */
  ecomCheckoutV1CreateOrderAndCharge?: Maybe<EcomCheckoutV1CreateOrderAndChargeResponse>;
  /** Deletes a checkout. */
  ecomCheckoutV1DeleteCheckout?: Maybe<Scalars['Void']>;
  /** Retrieves a checkout. */
  ecomCheckoutV1GetCheckout?: Maybe<EcomCheckoutV1GetCheckoutResponse>;
  /** Retrieves the checkout associated with a specified cart. */
  ecomCheckoutV1GetCheckoutByCartId?: Maybe<EcomCheckoutV1GetCheckoutByCartIdResponse>;
  ecomCheckoutV1GetCheckoutPaymentSettings?: Maybe<EcomCheckoutV1GetCheckoutPaymentSettingsResponse>;
  /**
   * Retrieves the checkout page URL of a specified checkout.
   *
   * By default, a `checkoutUrl` generates for a checkout and directs to a standard Wix checkout page.
   * However, if `overrideCheckoutUrl` has a value, it will replace and set the value of `checkoutUrl`.
   */
  ecomCheckoutV1GetCheckoutUrl?: Maybe<EcomCheckoutV1GetCheckoutUrlResponse>;
  /** Retrieves a checkout with all extended fields. This is temporarily to solve the subscription bug. for use by ecom subscriptions only */
  ecomCheckoutV1GetCheckoutWithAllExtendedFields?: Maybe<EcomCheckoutV1GetCheckoutWithAllExtendedFieldsResponse>;
  /** Deprecated and will be removed soon, use GetCheckoutURL */
  ecomCheckoutV1GetWixCheckoutUrl?: Maybe<EcomCheckoutV1GetWixCheckoutUrlResponse>;
  /**
   * Sets `completed` to `true` to mark a checkout as completed.
   *
   * When an order is completed through Wix, the `completed` field in the associated checkout object
   * will automatically be updated to `true`. If an order is completed through a separate system,
   * use this method to manually mark the checkout as completed.
   */
  ecomCheckoutV1MarkCheckoutAsCompleted?: Maybe<Scalars['Void']>;
  /** Marks a checkout as completed and redirects to a specified URL. */
  ecomCheckoutV1MarkCheckoutAsCompletedAndRedirectToUrl?: Maybe<ComWixpressRestRawHttpResponse>;
  /** Removes the coupon from a specified checkout. */
  ecomCheckoutV1RemoveCoupon?: Maybe<EcomCheckoutV1RemoveCouponResponse>;
  /**
   * Removes the gift card from a specified checkout.
   *
   * A checkout can only hold 1 gift card.
   */
  ecomCheckoutV1RemoveGiftCard?: Maybe<EcomCheckoutV1RemoveGiftCardResponse>;
  /** Removes line items from the specified checkout. */
  ecomCheckoutV1RemoveLineItems?: Maybe<EcomCheckoutV1RemoveLineItemsResponse>;
  /**
   * Removes the `overrideCheckoutUrl` from a specified checkout.
   *
   * When `overrideCheckoutUrl` is removed, the `checkoutUrl` will be set to the default, standard
   * Wix checkout page URL.
   */
  ecomCheckoutV1RemoveOverrideCheckoutUrl?: Maybe<EcomCheckoutV1RemoveOverrideCheckoutUrlResponse>;
  /**
   * Updates a checkout.
   *
   * Use this method to update checkout fields such as billing and shipping info, or to add a coupon code or gift card.
   *
   * To update a checkout's `lineItems`, `completed` status, or to remove coupons and gift cards, see these methods:
   * + Add to Checkout: Add line items to the checkout.
   * + Update Line Items Quantity: Update the quantity of 1 or more line items in the checkout.
   * + Remove Line Items: Remove a line item from the checkout.
   * + Mark Checkout As Completed: To update `completed` to `true` if the checkout was completed through a non-Wix orders or payments system.
   * + Remove Coupon: To remove an applied coupon from the checkout.
   * + Remove Gift Card: To remove an applied gift card from the checkout.
   *
   * >**Notes:**
   * > + If nothing is passed in the request, the call will fail.
   * > + The `checkout.buyerInfo.email` may not be removed once it is set.
   */
  ecomCheckoutV1UpdateCheckout?: Maybe<EcomCheckoutV1UpdateCheckoutResponse>;
  /**
   * Updates the quantity of one or more line items in a checkout.
   *
   * This method is only for updating the quantity of line items. To entirely remove a line item from
   * the checkout, use the Remove Line Items method.
   * To add a new line item to the checkout, use the Add to Checkout method.
   *
   * This method checks the amount of stock remaining for this line item. If the specified `quantity`
   * is greater than the remaining stock, then the `quantity` returned in the response is the total amount
   * of remaining stock.
   */
  ecomCheckoutV1UpdateLineItemsQuantity?: Maybe<EcomCheckoutV1UpdateLineItemsQuantityResponse>;
  /** create multiple products in a single request. Works synchronously */
  metroinspectorV1ProductsBulkCreateProducts?: Maybe<MetroinspectorV1ProductsBulkCreateProductsResponse>;
  /** deletes multiple products in a single request. Works synchronously. */
  metroinspectorV1ProductsBulkDeleteProducts?: Maybe<MetroinspectorV1ProductsBulkDeleteProductsResponse>;
  /** update multiple products in a single request. Works synchronously. */
  metroinspectorV1ProductsBulkUpdateProducts?: Maybe<MetroinspectorV1ProductsBulkUpdateProductsResponse>;
  metroinspectorV1ProductsCountProducts?: Maybe<MetroinspectorV1ProductsCountProductsResponse>;
  /** Creating a product */
  metroinspectorV1ProductsCreateProduct?: Maybe<MetroinspectorV1ProductsCreateProductResponse>;
  metroinspectorV1ProductsDeleteProduct?: Maybe<Scalars['Void']>;
  metroinspectorV1ProductsGetProductsStartWith?: Maybe<MetroinspectorV1ProductsGetProductsStartWithResponse>;
  metroinspectorV1ProductsResetProductsDb?: Maybe<Scalars['Void']>;
  metroinspectorV1ProductsUpdateProduct?: Maybe<MetroinspectorV1ProductsUpdateProductResponse>;
  /** Create multiple TaxExemptGroups in a single request. Works synchronously. */
  wixBillingV1BulkCreateTaxExemptGroups?: Maybe<WixBillingV1BulkCreateTaxExemptGroupsResponse>;
  /** Delete multiple TaxExemptGroups in a single request. Works synchronously. */
  wixBillingV1BulkDeleteTaxExemptGroups?: Maybe<WixBillingV1BulkDeleteTaxExemptGroupsResponse>;
  /**
   * Synchronously update tags on multiple TaxExemptGroups, by list of TaxExemptGroups ids
   * A tag that appears both in the list of assign and unassign tags, will be assigned
   */
  wixBillingV1BulkUpdateTaxExemptGroupTags?: Maybe<WixBillingV1BulkUpdateTaxExemptGroupTagsResponse>;
  /**
   * Asynchronously update tags on multiple TaxExemptGroups, by provided filter
   * An empty filter will update all TaxExemptGroups
   * A tag that appears both in the list of assign and unassign tags, will be assigned
   */
  wixBillingV1BulkUpdateTaxExemptGroupTagsByFilter?: Maybe<WixBillingV1BulkUpdateTaxExemptGroupTagsByFilterResponse>;
  /** Update multiple TaxExemptGroups in a single request. Works synchronously. */
  wixBillingV1BulkUpdateTaxExemptGroups?: Maybe<WixBillingV1BulkUpdateTaxExemptGroupsResponse>;
  /**
   * Creates a TaxExemptGroup.
   *
   * The request body must include name.
   */
  wixBillingV1CreateTaxExemptGroup?: Maybe<WixBillingV1CreateTaxExemptGroupResponse>;
  /** Deletes a TaxExemptGroup. */
  wixBillingV1DeleteTaxExemptGroup?: Maybe<Scalars['Void']>;
  /** Updates a TaxExemptGroup. */
  wixBillingV1UpdateTaxExemptGroup?: Maybe<WixBillingV1UpdateTaxExemptGroupResponse>;
  /**
   * Clones a `serviceOptionsAndVariants` object and connects it to a [service](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/introduction).
   *
   *
   * The call fails if the service already has a connected
   * `serviceOptionsAndVariants` object.
   *
   * The cloned `serviceOptionsAndVariants` object gets a new, unique option ID.
   * The option ID of the existing `serviceOptionsAndVariants` object isn't reused.
   *
   * For example, you may call this method after [cloning a service](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/clone-service).
   */
  wixBookingsCatalogV1CloneServiceOptionsAndVariants?: Maybe<WixBookingsCatalogV1CloneServiceOptionsAndVariantsResponse>;
  /** Consume Internal Events For Bi */
  wixBookingsCatalogV1ConsumeInternalEventsForBi?: Maybe<Scalars['Void']>;
  /** Consume Resource notification */
  wixBookingsCatalogV1ConsumeResourceNotification?: Maybe<Scalars['Void']>;
  /** Consume schedules notification that updates options and variants */
  wixBookingsCatalogV1ConsumeScheduleNotification?: Maybe<Scalars['Void']>;
  /** Consume schedules notification that deletes options and variants */
  wixBookingsCatalogV1ConsumeScheduleNotificationWithDeleteEffect?: Maybe<Scalars['Void']>;
  /** Consume Services notification */
  wixBookingsCatalogV1ConsumeServicesNotification?: Maybe<Scalars['Void']>;
  /** Consume site-properties notification */
  wixBookingsCatalogV1ConsumeSitePropertiesNotification?: Maybe<Scalars['Void']>;
  /**
   * Creates a `serviceOptionsAndVariants` object and for a service.
   *
   *
   * ### Calculate variants
   *
   * Before creating a `serviceOptionsAndVariants` object, you need to
   * anticipate and manually define all its variants, since Wix Bookings doesn't
   * automatically calculate them. For the actual
   * Create Service Options And Variants* call, specify both the `options` and
   * `variants` arrays.
   *
   * ### Limitations
   *
   * Wix Bookings allows you to connect only a single `serviceOptionsAndVariants`
   * object to a service. *Create Service Options And Variants* fails, if the
   * service already has a connected `serviceOptionsAndVariants` object.
   *
   * Currently, you can include only a single option per
   * `serviceOptionsAndVariants` object. Taken together, this means that services
   * are limited to a single option.
   *
   * ### Option ID
   *
   * When creating a`serviceOptionsAndVariants` object, you must specify an ID in
   * [UUID format](https://en.wikipedia.org/wiki/Universally_unique_identifier)
   * for its only option. You must reference this option ID for each variant as
   * `variants.values.choices.optionId`.
   *
   * ### Staff member option
   *
   * To create an option based on the [staff member](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members/introduction)
   * providing the service, you need to specify `STAFF_MEMBER` as `options.values.type`.
   * Also, specify all staff member IDs as `variants.values.choices.staffMemberId`.
   * You could follow this [sample flow](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/service-options-and-variants/sample-flows#create-staff-member-based-service-variants).
   *
   * ### Custom option
   *
   * To create an option based on a custom parameter, specify `CUSTOM` as
   * `options.values.type`. Provide descriptive names for all custom choices as
   * `variants.values.choices.custom`. These names are displayed to customers
   * during the book flow. You could follow this [sample flow](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/service-options-and-variants/sample-flows#create-service-variants-based-on-the-booked-equipment).
   *
   * ### Duration option
   *
   * To create an option based on appointment duration, specify `DURATION` as
   * `options.values.type` and set a descriptive name in `options.values.durationData.name`.
   * Also, indicate the appointment length in `minutes` and provide a descriptive
   * `name` for each duration choice in `variants.values.choices.duration`.
   */
  wixBookingsCatalogV1CreateServiceOptionsAndVariants?: Maybe<WixBookingsCatalogV1CreateServiceOptionsAndVariantsResponse>;
  /**
   * Deletes a `serviceOptionsAndVariants` object.
   *
   *
   * Because each service can be connected to only a single `serviceOptionsAndVariants`
   * object, the service doesn't support [varied pricing](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/about-service-payments)
   * after deleting a `serviceOptionsAndVariants` object. Instead, Wix Bookings
   * uses its standard price calculation.
   */
  wixBookingsCatalogV1DeleteServiceOptionsAndVariants?: Maybe<Scalars['Void']>;
  /** Retrieves a `serviceOptionsAndVariants` object by [service ID](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/introduction). */
  wixBookingsCatalogV1GetServiceOptionsAndVariantsByServiceId?: Maybe<WixBookingsCatalogV1GetServiceOptionsAndVariantsByServiceIdResponse>;
  /**
   * Updates a `serviceOptionsAndVariants` object.
   *
   *
   * Currently, only a single option is supported per `serviceOptionsAndVariants` object.
   *
   * If you want to update `variants`, you must pass the entire list of supported
   * variants, not only newly added variants.
   *
   * If you want to update `options`, you must pass the entire list of supported
   * options, not only newly added options.
   */
  wixBookingsCatalogV1UpdateServiceOptionsAndVariants?: Maybe<WixBookingsCatalogV1UpdateServiceOptionsAndVariantsResponse>;
  wixBookingsCategoriesV2ConsumeMetaSiteSpecialEvent?: Maybe<Scalars['Void']>;
  wixBookingsCategoriesV2ConsumePopulationElementCreatedDomainEvents?: Maybe<Scalars['Void']>;
  /**
   * Counts categories, given the specified filtering.
   *
   *
   * Refer to the [Supported Filters article](https://dev.wix.com/docs/rest/business-solutions/bookings/services/categories-v2/filtering-and-sorting) for a complete list of supported filters.
   */
  wixBookingsCategoriesV2CountCategories?: Maybe<WixBookingsCategoriesV2CountCategoriesResponse>;
  /** Creates a category. */
  wixBookingsCategoriesV2CreateCategory?: Maybe<WixBookingsCategoriesV2CreateCategoryResponse>;
  /**
   * Deletes a category.
   *
   *
   * ### Impact on connected services
   *
   * When you delete a category, any services linked to it remain associated with the now-deleted category. Wix Bookings still displays these services to business owners in the dashboard, but they aren't visible to customers on the live site.
   * Attempting to call [Update Service](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/update-service) for a service that's linked to a deleted category fails, unless you specify a different, existing category ID in `service.category.id`.
   */
  wixBookingsCategoriesV2DeleteCategory?: Maybe<Scalars['Void']>;
  /** Bulk create v2 categories from v1 preserving the IDs */
  wixBookingsCategoriesV2ImportCategories?: Maybe<Scalars['Void']>;
  /**
   * Moves a category to the start, end, or immediately after a specified category by updating its `sortOrder` field.
   *
   * Wix Bookings assigns `sortOrder` values with large gaps between categories, allowing efficient reordering without updating the entire list. When gaps become too small, the system automatically reassigns new values to restore larger gaps.
   */
  wixBookingsCategoriesV2MoveCategory?: Maybe<WixBookingsCategoriesV2MoveCategoryResponse>;
  /** Publish "updated" domain events for all categories of the site to trigger a re-fetch of materialized data */
  wixBookingsCategoriesV2PublishCategoriesUpdated?: Maybe<Scalars['Void']>;
  /**
   * Updates a category.
   *
   *
   * Each time the category is updated, `revision` increments by 1.
   * You must specify the current `revision` to prevent unintended overwrites.
   *
   * You can't adjust a categories `sortOrder` with this method, call [Move Category](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/categories-v2/move-category) instead.
   */
  wixBookingsCategoriesV2UpdateCategory?: Maybe<WixBookingsCategoriesV2UpdateCategoryResponse>;
  /**
   * Create a new AddOns group.
   * An AddOns group defines a collection of AddOns that can be linked to a Service,
   * with constraints such as minimum and maximum selections.
   */
  wixBookingsServicesV2AddOnGroupsServiceCreateAddOnGroup?: Maybe<WixBookingsServicesV2CreateAddOnGroupResponse>;
  /**
   * Delete an existing AddOns group.
   * This will remove the group and unlink all associated AddOns.
   */
  wixBookingsServicesV2AddOnGroupsServiceDeleteAddOnGroup?: Maybe<Scalars['Void']>;
  /**
   * Retrieves a list of AddOnGroups including enriched AddOn details in the correct order.
   * If the group_id is specified, only the AddOns for the specified group will be returned,
   * otherwise all groups will be returned.
   */
  wixBookingsServicesV2AddOnGroupsServiceListAddOnGroupsByServiceId?: Maybe<WixBookingsServicesV2ListAddOnGroupsByServiceIdResponse>;
  /**
   * Sets the AddOns for a specific group.
   * The order of the AddOns in the list will be used to determine their display order.
   */
  wixBookingsServicesV2AddOnGroupsServiceSetAddOnsForGroup?: Maybe<WixBookingsServicesV2SetAddOnsForGroupResponse>;
  /**
   * Update an existing AddOns group.
   * This allows modifying group settings such as its name, constraints, or associated AddOns.
   */
  wixBookingsServicesV2AddOnGroupsServiceUpdateAddOnGroup?: Maybe<WixBookingsServicesV2UpdateAddOnGroupResponse>;
  /** Validates the selection of AddOns for a given group based on the group's settings. */
  wixBookingsServicesV2AddOnGroupsServiceValidateAddOnsSelection?: Maybe<WixBookingsServicesV2ValidateAddOnsSelectionResponse>;
  /**
   * Creates multiple services.
   *
   *
   * See [Create Service](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/create-service) for more details.
   */
  wixBookingsServicesV2BulkCreateServices?: Maybe<WixBookingsServicesV2BulkCreateServicesResponse>;
  /**
   * Deletes multiple services.
   *
   *
   * See [Delete Service](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/delete-service)
   * for more details about deleting a service.
   *
   * The call succeeds even if one or more individual services can't be deleted.
   * Information about failures is returned in `bulkActionMetadata`.
   */
  wixBookingsServicesV2BulkDeleteServices?: Maybe<WixBookingsServicesV2BulkDeleteServicesResponse>;
  /**
   * Deletes multiple services by filter.
   *
   *
   * See [Delete Service](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/delete-service)
   * for more details about deleting a service.
   *
   * The call succeeds even if one or more individual services can't be deleted.
   * Information about failures is returned in `bulkActionMetadata`.
   *
   * Refer to the [supported filters article](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/introduction#services-filtering-and-sorting)
   * for more details.
   *
   * To learn about working with filters in general, see
   * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#filters).
   */
  wixBookingsServicesV2BulkDeleteServicesByFilter?: Maybe<WixBookingsServicesV2BulkDeleteServicesByFilterResponse>;
  /**
   * Updates up to 100 services.
   *
   *
   * See [Update Service](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/update-service)
   * for more details.
   *
   * The call succeeds even if one or more individual services can't be updated.
   * Information about failures is returned in `bulkActionMetadata`.
   */
  wixBookingsServicesV2BulkUpdateServices?: Maybe<WixBookingsServicesV2BulkUpdateServicesResponse>;
  /**
   * Updates multiple services by filter.
   *
   *
   * Refer to the [supported filters article](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/filtering-and-sorting) for more details.
   *
   * See [Update Service](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/update-service) for more details about updating a service.
   *
   * The call succeeds even if one or more individual services can't be updated.
   * Information about failures is returned in `bulkActionMetadata`.
   */
  wixBookingsServicesV2BulkUpdateServicesByFilter?: Maybe<WixBookingsServicesV2BulkUpdateServicesByFilterResponse>;
  /**
   * Clones a service.
   *
   *
   * ### Connected entities
   *
   * By default, not all entities connected to the service are cloned.
   *
   * #### Schedule
   *
   * Wix Bookings automatically creates a new active [schedule](https://dev.wix.com/docs/api-reference/business-management/calendar/schedules-v3/introduction)
   * for the cloned service. If Wix Bookings can't create this schedule, the
   * Clone Service call fails.
   *
   * - __For appointment-based services__: Future appointments aren't added to the
   * cloned service's schedule. Use the [Events API](https://dev.wix.com/docs/api-reference/business-management/calendar/events-v3/introduction) to add them as needed.
   * - __For classes and courses__: Future one-time events aren't added to the
   * cloned service's schedule, while future recurring events are added
   * asynchronously. The Clone Service call always succeeds, whether or not
   * recurring events are added.
   * If the response includes `RECURRING_EVENTS` in the `errors` array, it means the
   * cloned service doesn't have future recurring events, even though the original
   * service does. You can either delete the cloned service and try again or use
   * the [Events API](https://dev.wix.com/docs/api-reference/business-management/calendar/events-v3/introduction) to add missing events to the schedule.
   *
   * Wix Bookings never adds past events to the cloned service's schedule.
   *
   * #### Service options and variants
   *
   * If the original service has [variants](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/service-options-and-variants/introduction),
   * they're cloned asynchronously. The Clone Service call always succeeds,
   * regardless of whether variants were cloned.
   *
   * If the response includes `OPTIONS_AND_VARIANTS` in the `errors` array, the cloned
   * service doesn't have variants, even though the original service does. You can
   * delete the cloned service and call Clone Service again, or use the
   * [Service Options And Variants API](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/service-options-and-variants/introduction) to add variants.
   *
   * #### Booking form
   *
   * The original service's booking form isn't cloned, whether it's
   * the default or a custom booking form.
   *
   * #### Pricing plans
   *
   * If the original service's accepts payments via [pricing plans](https://dev.wix.com/docs/api-reference/business-solutions/pricing-plans/introduction/),
   * the cloned service's `payment.options.pricingPlan` is also set to `true`. To
   * accept specific pricing plans, call [Enable Pricing Plans For Service](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/enable-pricing-plans-for-service),
   * after cloning the service. If the original service accepts only
   * pricing plan payments and you don't call Enable Pricing Plans For Service
   * after cloning the service, customers will be unable to book the service.
   */
  wixBookingsServicesV2CloneService?: Maybe<WixBookingsServicesV2CloneServiceResponse>;
  /** Consumes benefits notification. */
  wixBookingsServicesV2ConsumeBenefitNotification?: Maybe<Scalars['Void']>;
  wixBookingsServicesV2ConsumeCalendarEventDomainEvents?: Maybe<Scalars['Void']>;
  /** Consumes category notification. */
  wixBookingsServicesV2ConsumeCategoryNotification?: Maybe<Scalars['Void']>;
  /** Consume duplicate slugs notification */
  wixBookingsServicesV2ConsumeDuplicateSlugsNotification?: Maybe<Scalars['Void']>;
  wixBookingsServicesV2ConsumeHtmlSitePublished?: Maybe<Scalars['Void']>;
  wixBookingsServicesV2ConsumeLocationDomainEvents?: Maybe<Scalars['Void']>;
  wixBookingsServicesV2ConsumeMembershipPlanDomainEvents?: Maybe<Scalars['Void']>;
  /**
   * Workaround for beauty flow - re-fetches services whenever multi service
   * appointments are enabled
   */
  wixBookingsServicesV2ConsumeMultiServiceEnabledEvent?: Maybe<Scalars['Void']>;
  wixBookingsServicesV2ConsumePaidPlanEvent?: Maybe<Scalars['Void']>;
  /** Consumes Booking policy notification. */
  wixBookingsServicesV2ConsumePolicyNotification?: Maybe<Scalars['Void']>;
  /** Consumes resources (V1) notification. */
  wixBookingsServicesV2ConsumeResourceNotification?: Maybe<Scalars['Void']>;
  /** Consumes resource type notification. */
  wixBookingsServicesV2ConsumeResourceTypeNotification?: Maybe<Scalars['Void']>;
  /** Consumes schedules notification. */
  wixBookingsServicesV2ConsumeScheduleNotification?: Maybe<Scalars['Void']>;
  /** Consumes ScheduleTimeFrame notifications. */
  wixBookingsServicesV2ConsumeScheduleTimeFrameNotifications?: Maybe<Scalars['Void']>;
  wixBookingsServicesV2ConsumeServiceDomainEvents?: Maybe<Scalars['Void']>;
  /** Consumes service options and variant notification. */
  wixBookingsServicesV2ConsumeServiceOptionsAndVariantsNotification?: Maybe<Scalars['Void']>;
  /** Consume site-properties notification */
  wixBookingsServicesV2ConsumeSitePropertiesNotification?: Maybe<Scalars['Void']>;
  wixBookingsServicesV2ConsumeUserDomainInfoChangedEvent?: Maybe<Scalars['Void']>;
  /**
   * Counts how many services match the given filter.
   *
   *
   * Refer to the supported filters article
   * ([REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/filtering-and-sorting#filtering))
   * for more details.
   *
   * To learn about working with filters in general, see
   * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#filters)
   */
  wixBookingsServicesV2CountServices?: Maybe<WixBookingsServicesV2CountServicesResponse>;
  /** Creates a new add-on group for a service and updates the service's `addOnGroups` array. */
  wixBookingsServicesV2CreateAddOnGroup?: Maybe<WixBookingsServicesV2CreateAddOnGroupResponse>;
  /**
   * Create a new AddOns group.
   * An AddOns group defines a collection of AddOns that can be linked to a Service,
   * with constraints such as minimum and maximum selections.
   */
  wixBookingsServicesV2CreateAddOnsGroup?: Maybe<WixBookingsServicesV2CreateAddOnsGroupResponse>;
  /**
   * Creates a service.
   *
   *
   * ### Required fields
   *
   * When creating a service you must specify the following fields:
   * - [`type`](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/about-service-types):
   * Whether it's an appointment-based service, class, or course.
   * - `name`: Service name that's displayed to customers.
   * - `onlineBooking`:
   * Settings determining whether customers can book online, whether the business
   * must manually confirm bookings, and whether customers can request to book an
   * appointment time slot that already has a booking request awaiting business
   * confirmation.
   * - [`payment`](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/about-service-payments):
   * How customers can pay when signing up for the service.
   * - `defaultCapacity`: The maximum number of customers that can book the service. Required for all service types. For appointment-based services, it must be `1`.
   *
   * #### Session durations
   *
   * Depending on which type of service you're creating, you may also need to specify
   * supported session durations.
   *
   * __Classes and courses__
   *
   * Don't specify `schedule.availabilityConstraints.sessionDurations`.
   *
   * __Appointment-based services without varied pricing based on session length__
   *
   * Specify the single supported session duration in the
   * `schedule.availabilityConstraints.sessionDurations` array.
   *
   * __Appointment-based services with varied pricing based on session length__
   *
   * - Specify all supported session durations in `schedule.availabilityConstraints.sessionDurations`.
   * - Note that Wix Bookings doesn't display these values to customers and
   * ignores them in pricing and availability calculations. Instead session
   * durations are retrieved from the relevant [service variants](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/service-options-and-variants/introduction).
   * - It is mandatory to specify `schedule.availabilityConstraints.sessionDurations`,
   * even though these values are ignored.
   *
   * ### Add-on groups
   *
   * Don't specify existing add-on groups when calling Create Service.
   * Instead, use dedicated add-on group and add-on creation methods to ensure proper validation and maintain referential integrity between services and their optional extras.
   * You can follow this sample flow ([SDK](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/add-ons/sample-flows#create-bookable-add-ons-for-a-new-group?apiView=SDK) | [REST](https://dev. wix.com/docs/api-reference/business-solutions/bookings/services/add-ons/sample-flows#create-bookable-add-ons-for-a-new-group)) to create bookable add-ons.
   */
  wixBookingsServicesV2CreateService?: Maybe<WixBookingsServicesV2CreateServiceResponse>;
  /**
   * Deletes an add-on group.
   *
   *
   * Deleting the group doesn't delete individual add-ons.
   * Any add-on not associated with another group isn't available for customers to book.
   */
  wixBookingsServicesV2DeleteAddOnGroup?: Maybe<Scalars['Void']>;
  /**
   * Delete an existing AddOns group.
   * This will remove the group and unlink all associated AddOns.
   */
  wixBookingsServicesV2DeleteAddOnsGroup?: Maybe<Scalars['Void']>;
  /**
   * Deletes a service.
   *
   *
   * Specify `{"preserveFutureSessionsWithParticipants": true}` to retain all
   * future sessions for the service. By default, all future sessions are canceled.
   */
  wixBookingsServicesV2DeleteService?: Maybe<Scalars['Void']>;
  /**
   * Removes a list of [pricing plan IDs](https://dev.wix.com/docs/api-reference/business-solutions/pricing-plans/pricing-plans/plans/introduction) from a service's `payment.pricingPlanIds` array.
   *
   *
   * If you remove all pricing plan IDs from `payment.pricingPlanIds` and the
   * service supports only payments by pricing plan, customers will no longer be
   * able to book the service, as they will have no payment options available.
   */
  wixBookingsServicesV2DisablePricingPlansForService?: Maybe<WixBookingsServicesV2DisablePricingPlansForServiceResponse>;
  /**
   * Adds a list of [pricing plan IDs](https://dev.wix.com/docs/api-reference/business-solutions/pricing-plans/plans/plans-v3/introduction) to a service's `payment.pricingPlanIds` array.
   *
   *
   * The call doesn't validate whether the service's `payment.options.pricingPlan`
   * is set to `true`. If it's set to `false`, customers aren't able to pay
   * for their bookings using pricing plans. You can call [Update Service](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/update-service) to change a service's supported payment methods.
   */
  wixBookingsServicesV2EnablePricingPlansForService?: Maybe<WixBookingsServicesV2EnablePricingPlansForServiceResponse>;
  /** Retrieves the service constraints for availability calculation */
  wixBookingsServicesV2GetServiceAvailabilityConstraints?: Maybe<WixBookingsServicesV2GetServiceAvailabilityConstraintsResponse>;
  /**
   * Retrieves add-on groups for a service with enriched add-on details.
   *
   *
   * Add-on details are returned based on their display order.
   *
   * If you specify `groupIds`, only those groups are returned.
   * By default, all groups associated with the service are returned.
   */
  wixBookingsServicesV2ListAddOnGroupsByServiceId?: Maybe<WixBookingsServicesV2ListAddOnGroupsByServiceIdResponse>;
  /**
   * Retrieves a list of AddOnsGroups including enriched AddOn details in the correct order.
   * If the group_id is specified, only the AddOns for the specified group will be returned,
   * otherwise all groups will be returned.
   */
  wixBookingsServicesV2ListAddOnsGroupsByServiceId?: Maybe<WixBookingsServicesV2ListAddOnsGroupsByServiceIdResponse>;
  /**
   * Retrieves a list of up to 100 booking [forms](https://dev.wix.com/docs/api-reference/crm/forms/form-schemas/form-object),
   * and information about the services that are connected to them,
   * given the provided filtering, paging, and sorting.
   *
   *
   * ### Defaults
   *
   * Query Booking Forms has the following default settings, which you can override:
   *
   * + Sorted by `id` in ascending order.
   * + `cursorPaging.limit` set to `100`.
   *
   * ### Filters
   *
   * For a complete list of supported filters, refer to Forms API: [Supported Filters](https://dev.wix.com/docs/rest/crm/forms/form-schemas/form-object).
   *
   * When using date filters, you must use
   * [UTC time](https://en.wikipedia.org/wiki/Coordinated_Universal_Time).
   *
   * ### Returned services
   *
   * If a booking policy is connected to more than 5 services, only a subset of
   * these service IDs and names is returned. The `bookingForms.totalServiceCount`
   * values indicate the total number of services linked to each form. You can call [Query Services](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/query-services)
   * and specify the relevant form ID in the filter to retrieve all services
   * connected to the booking form.
   *
   * ### Default booking forms
   *
   * By default, all Wix Bookings services use a standard booking form. To retrieve
   * a site's default booking form with Query Booking Forms, specify
   * `{"conditionalFields": ["DEFAULT_BOOKING_FORM"]}`.
   *
   * ### See also
   *
   * To learn about working with Query methods, see
   * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language)
   * and [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).
   */
  wixBookingsServicesV2QueryBookingForms?: Maybe<WixBookingsServicesV2QueryBookingFormsResponse>;
  /**
   * Retrieves a list of [service categories](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/categories-v2/introduction), given the provided filtering.
   *
   *
   * ### Defaults
   *
   * Query Categories has the following default setting, which you can't override:
   * Sorted by `id` in ascending order.
   *
   * ### Filters
   *
   * For a complete list of supported filters, refer to the [supported filters article](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/filtering-and-sorting).
   *
   * When using date filters, you must use
   * [UTC time](https://en.wikipedia.org/wiki/Coordinated_Universal_Time).
   *
   * ### See also
   *
   * To learn about working with Query methods, see
   * [API Query Language](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-the-wix-api-query-language)
   * and [Sorting and Paging](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-sorting-and-paging).
   */
  wixBookingsServicesV2QueryCategories?: Maybe<WixBookingsServicesV2QueryCategoriesResponse>;
  /**
   * Retrieves 3 separate lists of business, custom, and customer [locations](https://dev.wix.com/docs/api-reference/business-management/locations/introduction),
   * given the provided filtering, and whether each location is connected to at
   * least one of the site's services.
   *
   *
   * ### Defaults
   *
   * Query Locations has the following default setting, which you can't override:
   * Sorted by `id` in ascending order.
   *
   * ### Filters
   *
   * For a complete list of supported filters, refer to the `location` object
   * ([REST](https://dev.wix.com/docs/rest/business-management/locations/location-object)).
   *
   * When using date filters, you must use
   * [UTC time](https://en.wikipedia.org/wiki/Coordinated_Universal_Time).
   *
   * ### See also
   *
   * To learn about working with Query methods, see
   * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language)
   * and [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).
   */
  wixBookingsServicesV2QueryLocations?: Maybe<WixBookingsServicesV2QueryLocationsResponse>;
  /**
   * Retrieves a list of up to 100 [booking policies](https://dev.wix.com/docs/api-reference/business-solutions/bookings/policies/booking-policies/introduction),
   * and information about the services that are connected to them,
   * given the provided filtering, paging, and sorting.
   *
   * ### Defaults
   *
   * Query Policies has the following default settings, which you can override:
   *
   * + Sorted by `id` in ascending order.
   * + `cursorPaging.limit` set to `100`.
   *
   * ### Filters
   *
   * For a complete list of supported filters, refer to Booking Policies API: [Supported Filters](https://dev.wix.com/docs/rest/business-solutions/bookings/policies/booking-policies/supported-filters).
   *
   * When using date filters, you must use
   * [UTC time](https://en.wikipedia.org/wiki/Coordinated_Universal_Time).
   *
   * ### Returned services
   *
   * If a booking policy is connected to more than 5 services, only a subset of
   * those services is returned. The `bookingPolicies.totalServiceCount` values
   * indicate the total number of services linked to each policy. You can call [Search Services](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/search-services)
   * and specify the relevant policy ID in the filter to retrieve all services
   * connected to the booking policy.
   *
   * ### See also
   *
   * To learn about working with Query methods, see
   * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language)
   * and [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).
   */
  wixBookingsServicesV2QueryPolicies?: Maybe<WixBookingsServicesV2QueryPoliciesResponse>;
  /** Query services in both the main language and the provided language according to the linguist aspect. */
  wixBookingsServicesV2QueryServicesMultiLanguage?: Maybe<WixBookingsServicesV2QueryServicesMultiLanguageResponse>;
  /**
   * Retrieves a list of up to 100 services, given the provided filtering, paging,
   * and sorting.
   *
   *
   * ### Defaults
   *
   * Search Services has the following default settings, which you can override:
   * + Sorted by `createdDate` in ascending order.
   * + `paging.limit` set to `100`.
   * + `paging.offset` set to `0`.
   *
   * ### Filters
   *
   * When using filters for dates, you must use
   * [UTC time](https://en.wikipedia.org/wiki/Coordinated_Universal_Time).
   *
   * Refer to the [supported filters](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/filtering-and-sorting) article
   * for a complete list of supported filters and sorting options.
   *
   * ### See also
   *
   * To learn about working with Search methods, see [API Query Language](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-the-wix-api-query-language) and [Sorting and Paging](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-sorting-and-paging).
   */
  wixBookingsServicesV2SearchServices?: Maybe<WixBookingsServicesV2SearchServicesResponse>;
  /**
   * Sets the add-ons for a specific group, replacing any existing add-ons in the group.
   *
   *
   * Call this method when you want to:
   * - Add new add-ons to a group.
   * - Remove add-ons from a group.
   * - Reorder existing add-ons for optimal customer presentation.
   *
   * The order of add-ons in the request determines their display sequence to customers.
   * All specified add-ons must already exist before adding them to a group.
   *
   * For updating other add-on group properties, for example `name`, `prompt`, or `constraints`, call [Update Add On Group](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/update-add-on-group) instead.
   */
  wixBookingsServicesV2SetAddOnsForGroup?: Maybe<WixBookingsServicesV2SetAddOnsForGroupResponse>;
  /**
   * Sets a new active slug for the service.
   *
   *
   * The call fails if at least one of these conditions is met:
   * - The slug doesn't adheres to the supported format.
   * - Another service is currently using the slug.
   * - Another service has used the slug in the past.
   */
  wixBookingsServicesV2SetCustomSlug?: Maybe<WixBookingsServicesV2SetCustomSlugResponse>;
  /**
   * Replaces the list of the [locations](https://dev.wix.com/docs/api-reference/business-management/locations/introduction) where the business offers the service.
   *
   *
   * ### Consequences for customers
   *
   * Removing a service location may impact existing sessions and their
   * participants. If you remove at least one service location, you must
   * specify `removedLocationSessionsAction` to indicate what happens to all
   * future sessions scheduled at this location.
   *
   * - **Keep existing location**: If you want to retain future sessions at their
   * originally scheduled location, specify
   * `{"removedLocationSessionsAction.action": "KEEP_AT_CURRENT_LOCATION"}`.
   * This ensures nothing changes for the customer, but the business must be
   * able to provide access to the removed location in the future.
   * - **Update location**: If you want to update the location for future sessions
   * scheduled at the removed location, specify
   * `{"removedLocationSessionsAction.action": "MOVE_TO_LOCATION"}` and
   * `moveToLocationOptions.newLocation`.
   *
   * You can't mix and match to keep some sessions at the previous location while
   * moving other sessions to an updated location.
   *
   * Past session details aren't changed, no matter which option you choose for
   * future sessions.
   *
   * Future sessions scheduled for a location defined by the customer are also not
   * updated.
   *
   * ### Specify location details
   *
   * Depending on whether the new or updated location is a business or custom location,
   * you need to specify different fields.
   *
   * - **Business location**: Specify the relevant [location ID](https://dev.wix.com/docs/api-reference/business-management/locations/introduction) in `locations.business.id`.
   * - **Custom location**: Specify the complete address object as
   * `locations.custom.address`.
   *
   * ### Participant notifications
   *
   * You can specify a `participantNotification.message` that's immediately send
   * to all customers who had booked at a changed location. Ensure
   * `participantNotification.notifyParticipants` is set to `true` to send the
   * message.
   */
  wixBookingsServicesV2SetServiceLocations?: Maybe<WixBookingsServicesV2SetServiceLocationsResponse>;
  /**
   * Updates an add-on group.
   *
   *
   * To update only the display order for add-ons, call [Set Add Ons For Group](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/set-add-ons-for-group) instead.
   *
   * You can't change which service an add-on group belongs to.
   * Each add-on group is permanently associated with the service it was created for.
   * To use the same add-ons with a different service, create a new add-on group for that service.
   */
  wixBookingsServicesV2UpdateAddOnGroup?: Maybe<WixBookingsServicesV2UpdateAddOnGroupResponse>;
  /**
   * Update an existing AddOns group.
   * This allows modifying group settings such as its name, constraints, or associated AddOns.
   */
  wixBookingsServicesV2UpdateAddOnsGroup?: Maybe<WixBookingsServicesV2UpdateAddOnsGroupResponse>;
  /**
   * Updates a service.
   *
   *
   * Each time the service is updated, `revision` increments by 1. You must
   * include the number of the existing revision when updating the service.
   * This ensures you're working with the latest service information and
   * prevents unintended overwrites.
   *
   * ### Session durations
   *
   * Specify `schedule.availabilityConstraints.sessionDurations`
   * only if you want to update it for appointment-based services without varied
   * pricing based on session length. Don't specify `schedule.availabilityConstraints.sessionDurations`
   * for all other appointment-based services, classes, or courses. See [Create Service](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/create-service#session-durations) for more details.
   *
   * ### Service locations
   *
   * Don't call Update Service to adjust service locations, call [Set Service Locations](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/set-service-locations) instead.
   *
   * ### Add-on groups
   *
   * Don't use Update Service to modify service add-on groups. Use these dedicated methods instead:
   * - **Update add-on group properties**: Call Update Add On Group ([SDK](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/update-add-on-group?apiView=SDK) | [REST](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/update-add-on-group)).
   * - **Update add-on display order**: Call Set Add Ons For Group ([SDK](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/set-add-ons-for-group?apiView=SDK) | [REST](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/set-add-ons-for-group)).
   */
  wixBookingsServicesV2UpdateService?: Maybe<WixBookingsServicesV2UpdateServiceResponse>;
  /** Validates the selection of AddOns for a given group based on the group's settings. */
  wixBookingsServicesV2ValidateAddOnsSelection?: Maybe<WixBookingsServicesV2ValidateAddOnsSelectionResponse>;
  /**
   * Validates a service.
   *
   *
   * ### Required fields
   *
   * A valid service must include the following fields:
   * - []`type`]API Reference(https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/about-service-types):
   * Whether it's an appointment-based service, class, or course.
   * - `name`: Service name that's displayed to customers.
   * - `onlineBooking`:
   * Settings determining whether customer can book online, whether the business
   * must manually confirm bookings,
   * and whether customers can request to book an appointment time slot that
   * already has a booking request awaiting business confirmation.
   * - [`payment`](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/about-service-payments):
   * How customers can pay when signing up for the service.
   */
  wixBookingsServicesV2ValidateService?: Maybe<WixBookingsServicesV2ValidateServiceResponse>;
  /**
   * Checks whether a custom slug is validate for the service.
   *
   *
   * The checks include:
   * - The slug adheres to the supported format.
   * - No other service is currently using the slug.
   * - No other service has used the slug in the past.
   *
   * The call fails if at least one of the checks fails.
   */
  wixBookingsServicesV2ValidateSlug?: Maybe<WixBookingsServicesV2ValidateSlugResponse>;
  /** Assigns the business schedule to the StaffMember */
  wixBookingsStaffV1AssignBusinessSchedule?: Maybe<WixBookingsStaffV1AssignBusinessScheduleResponse>;
  /** Assigns the provided schedule to the StaffMember */
  wixBookingsStaffV1AssignCustomSchedule?: Maybe<WixBookingsStaffV1AssignCustomScheduleResponse>;
  /** Connects staff member to a Wix user */
  wixBookingsStaffV1ConnectStaffMemberToUser?: Maybe<WixBookingsStaffV1ConnectStaffMemberToUserResponse>;
  /** Connects staff member to a Wix user */
  wixBookingsStaffV1ConnectToUser?: Maybe<WixBookingsStaffV1ConnectToUserResponse>;
  /** Counts staff members according to given criteria. */
  wixBookingsStaffV1CountStaffMembers?: Maybe<WixBookingsStaffV1CountStaffMembersResponse>;
  /** Creates a StaffMember. */
  wixBookingsStaffV1CreateStaffMember?: Maybe<WixBookingsStaffV1CreateStaffMemberResponse>;
  /** Deletes a StaffMember. */
  wixBookingsStaffV1DeleteStaffMember?: Maybe<Scalars['Void']>;
  /** Disconnects a staff member from the Wix user. */
  wixBookingsStaffV1DisconnectStaffMemberFromUser?: Maybe<WixBookingsStaffV1DisconnectStaffMemberFromUserResponse>;
  /** Connects staff member to a Wix user */
  wixBookingsStaffV1DisconnectUser?: Maybe<WixBookingsStaffV1DisconnectUserResponse>;
  wixBookingsStaffV1HandleFileDescriptorDomainEvent?: Maybe<Scalars['Void']>;
  wixBookingsStaffV1HandleMemberDomainEvent?: Maybe<Scalars['Void']>;
  wixBookingsStaffV1HandlePolicyRemovedFromContributor?: Maybe<Scalars['Void']>;
  wixBookingsStaffV1HandlePolicyUpdatedForContributor?: Maybe<Scalars['Void']>;
  wixBookingsStaffV1HandleResourceDomainEvent?: Maybe<Scalars['Void']>;
  wixBookingsStaffV1HandleScheduleNotification?: Maybe<Scalars['Void']>;
  wixBookingsStaffV1HandleStaffConnectedToUser?: Maybe<Scalars['Void']>;
  wixBookingsStaffV1HandleStaffDomainEvent?: Maybe<Scalars['Void']>;
  /**
   * This is a private, temporary endpoint to import a staff member.
   * It should only be used for migration from Resources V1 or when cloning from a Resources V1 site.
   *
   * Callers should provide the Resource ID, working hours schedule ID and the events schedule ID in the `resource` field
   * of staff member. If the staff member works according to the business hours then the working hours schedule ID
   * must be set to the business schedule ID. Otherwise the working hours schedule ID must have the same value as the
   * events schedule ID.
   */
  wixBookingsStaffV1ImportStaffMember?: Maybe<WixBookingsStaffV1ImportStaffMemberResponse>;
  /**
   * For internal use only
   * Restores a deleted StaffMember
   */
  wixBookingsStaffV1RestoreStaff?: Maybe<WixBookingsStaffV1RestoreStaffResponse>;
  /**
   * Update a StaffMember, supports partial update
   * Pass the latest `revision` for a successful update
   */
  wixBookingsStaffV1UpdateStaffMember?: Maybe<WixBookingsStaffV1UpdateStaffMemberResponse>;
  wixBookingsV1ConsumeBookingPolicyDomainEvents?: Maybe<Scalars['Void']>;
  wixBookingsV1ConsumeMetaSiteSpecialEvent?: Maybe<Scalars['Void']>;
  /** Consume site-properties notification */
  wixBookingsV1ConsumeSitePropertiesNotification?: Maybe<Scalars['Void']>;
  /**
   * Counts booking policies, given the provided filtering.
   *
   *
   * See [supported filters](https://dev.wix.com/docs/rest/business-solutions/bookings/policies/booking-policies/supported-filters)
   * for a complete list of supported filters.
   */
  wixBookingsV1CountBookingPolicies?: Maybe<WixBookingsV1CountBookingPoliciesResponse>;
  /** Creates a booking policy. */
  wixBookingsV1CreateBookingPolicy?: Maybe<WixBookingsV1CreateBookingPolicyResponse>;
  /** Create a default policy if it does not exist yet */
  wixBookingsV1CreateMissingDefaultPolicy?: Maybe<WixBookingsV1CreateMissingDefaultPolicyResponse>;
  /**
   * Deletes a booking policy.
   *
   *
   * You can't delete the default policy without first [setting a different policy as default](https://dev.wix.com/docs/api-reference/business-solutions/bookings/policies/booking-policies/set-default-booking-policy).
   */
  wixBookingsV1DeleteBookingPolicy?: Maybe<Scalars['Void']>;
  wixBookingsV1Get?: Maybe<ComWixpressBookingsServicesApiV1GetPolicyResponse>;
  /**
   * Retrieves the strictest version of each policy rule from a list of booking
   * policies.
   *
   *
   * Returns a hypothetical `bookingPolicy` object that combines the strictest
   * version of each rule. The `id` of the returned policy is `null` and no
   * corresponding `bookingPolicy` object is created. To create a new policy, you
   * can call [Create Booking Policy](https://dev.wix.com/docs/rest/business-solutions/bookings/policies/booking-policies/create-booking-policy).
   */
  wixBookingsV1GetStrictestBookingPolicy?: Maybe<WixBookingsV1GetStrictestBookingPolicyResponse>;
  /**
   * Sets a booking policy as the default.
   *
   *
   * Also updates the site's current default policy by setting its `default`
   * attribute to `false`. If the provided policy is already the site's
   * default, the call succeeds without changing any `bookingPolicy` object.
   */
  wixBookingsV1SetDefaultBookingPolicy?: Maybe<WixBookingsV1SetDefaultBookingPolicyResponse>;
  wixBookingsV1Update?: Maybe<Scalars['Void']>;
  /**
   * Updates all policies of the meta site with requested fields. Used for migration only.
   * Supported fields (including nested fields): `customPolicyDescription`, `limitEarlyBookingPolicy`, `limitLateBookingPolicy`,
   * `bookAfterStartPolicy`, `cancellationPolicy`, `reschedulePolicy`, `waitlistPolicy`, `participantsPolicy`, `intakeFormPolicy`.
   */
  wixBookingsV1UpdateAllPolicies?: Maybe<Scalars['Void']>;
  /**
   * Updates a booking policy.
   *
   *
   * Each time the booking policy is updated, `revision` increments by 1.
   * The current `revision` must be specified when updating the booking policy.
   * This ensures you're working with the latest booking policy and prevents unintended overwrites.
   */
  wixBookingsV1UpdateBookingPolicy?: Maybe<WixBookingsV1UpdateBookingPolicyResponse>;
  /** Cancels multiple events in bulk. */
  wixCalendarEventsV3BulkCancelEvent?: Maybe<WixCalendarEventsV3BulkCancelEventResponse>;
  /**
   * Creates multiple events in bulk.
   *
   *
   * If you provide `recurrenceRule`, an event with `{"recurrenceType": "MASTER"}` is
   * created. Then, you can't set `start.localDate` to a past date, though the time can be
   * earlier on the same day. You can, however, create single-occurrence events for
   * past dates.
   *
   * You can't create an event with `recurrenceType` set to `INSTANCE` or `EXCEPTION`.
   * `INSTANCE` events are generated automatically based on the recurrence rule in the
   * relevant `MASTER` event. `EXCEPTION` events are automatically created when you
   * [update](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/update-event)
   * an `INSTANCE` event, which changes its `recurrenceType` to `EXCEPTION`.
   */
  wixCalendarEventsV3BulkCreateEvent?: Maybe<WixCalendarEventsV3BulkCreateEventResponse>;
  /**
   * Updates multiple events in bulk.
   *
   *
   * When updating an event with `{"recurrenceType": "INSTANCE"}`, the
   * `recurrenceType` automatically changes to `EXCEPTION`.
   *
   * When updating an event with `{"recurrenceType": "MASTER"}`:
   * + Past `INSTANCE` and `EXCEPTION` events remain unchanged.
   * + For future `INSTANCE` events, all relevant fields are updated.
   * + For future `EXCEPTION` events, only changes to the `inheritedFields` are
   * applied, while other fields remain unchanged.
   */
  wixCalendarEventsV3BulkUpdateEvent?: Maybe<WixCalendarEventsV3BulkUpdateEventResponse>;
  /** Cancels an event. */
  wixCalendarEventsV3CancelEvent?: Maybe<WixCalendarEventsV3CancelEventResponse>;
  /**
   * Creates an event.
   *
   *
   * If you provide `recurrenceRule`, an event with `{"recurrenceType": "MASTER"}` is
   * created. Then, you can't set `start.localDate` to a past date, though the time can be
   * earlier on the same day. You can, however, create single-occurrence events for
   * past dates.
   *
   * You can't create an event with `recurrenceType` set to `INSTANCE` or `EXCEPTION`.
   * `INSTANCE` events are generated automatically based on the recurrence rule in the
   * relevant `MASTER` event. `EXCEPTION` events are automatically created when you
   * [update](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/update-event)
   * an `INSTANCE` event, which changes its `recurrenceType` to `EXCEPTION`.
   */
  wixCalendarEventsV3CreateEvent?: Maybe<WixCalendarEventsV3CreateEventResponse>;
  /**
   * Deletes the target DBs given a list of Meta Site IDs.
   * Sites which were already rolled out will not be deleted.
   *
   * By default:
   * - Nothing is deleted unless requested.
   * - Concurrency limit is 1.
   */
  wixCalendarEventsV3DeleteTargets?: Maybe<Scalars['Void']>;
  /** Being used by Immigrator. If you wish to delete this endpoint, first delete the immigrator task to avoid breaking velocity-infra. */
  wixCalendarEventsV3FixSched38956?: Maybe<WixCalendarMigrationV3FixSched38956Response>;
  wixCalendarEventsV3HandleBusinessLocationDomainEvents?: Maybe<Scalars['Void']>;
  wixCalendarEventsV3HandleContactMergedDomainEvent?: Maybe<Scalars['Void']>;
  wixCalendarEventsV3HandleEventDomainEvent?: Maybe<Scalars['Void']>;
  wixCalendarEventsV3HandleGdprUoUAccessRequest?: Maybe<Scalars['Void']>;
  wixCalendarEventsV3HandleGdprUoUDeleteRequest?: Maybe<Scalars['Void']>;
  wixCalendarEventsV3HandleMetaSiteEvent?: Maybe<Scalars['Void']>;
  wixCalendarEventsV3HandleParticipationDomainEvent?: Maybe<Scalars['Void']>;
  wixCalendarEventsV3HandleResourceDomainEvent?: Maybe<Scalars['Void']>;
  wixCalendarEventsV3HandleScheduleDomainEvent?: Maybe<Scalars['Void']>;
  wixCalendarEventsV3HandleScheduleTimeFrameDomainEvent?: Maybe<Scalars['Void']>;
  wixCalendarEventsV3HandleSelfDomainEvent?: Maybe<Scalars['Void']>;
  wixCalendarEventsV3HandleSitePropertiesNotification?: Maybe<Scalars['Void']>;
  /** Retrieves a list of events by their IDs. */
  wixCalendarEventsV3ListEvents?: Maybe<WixCalendarEventsV3ListEventsResponse>;
  /**
   * Retrieves a list of events filtered by the participant's
   * [contact](https://dev.wix.com/docs/rest/crm/members-contacts/contacts/introduction)
   * ID.
   *
   *
   * You can't set `toLocalDate` to a value that's more than a full year after
   * `fromLocalDate`.
   */
  wixCalendarEventsV3ListEventsByContactId?: Maybe<WixCalendarParticipanteventsV3ListEventsByContactIdResponse>;
  /**
   * Retrieves a list of events filtered by the participant's
   * [member](https://dev.wix.com/docs/rest/crm/members-contacts/members/members/introduction)
   * ID.
   *
   *
   * You can't set `toLocalDate` to a value that's more than a full year after
   * `fromLocalDate`.
   */
  wixCalendarEventsV3ListEventsByMemberId?: Maybe<WixCalendarParticipanteventsV3ListEventsByMemberIdResponse>;
  /**
   * Retrieves a list of a participant's events by time.
   *
   * Limits:
   * - Max time range is 1 year.
   */
  wixCalendarEventsV3ListParticipantEvents?: Maybe<WixCalendarParticipanteventsV3ListParticipantEventsResponse>;
  /**
   * Lists the non exceptional instances of a recurring event by revision,
   * to enable a consumer to determine the changes made to the instances of a recurring event.
   *
   * Currently this API is `PRIVATE` and restricted to the Events View service!
   * Consumers which wish to determine changes made to the Calendar should use the Events View service.
   *
   * Why only non exceptional instances?
   * Since the Events service will send domain events for changes made to exceptional recurring instances.
   *
   * The default `cursorPaging.limit` is 50.
   * Instances are always sorted by their start date.
   *
   * > **Note**
   * > The response is eventually consistent. A `NOT_FOUND` error will be thrown in case a revision was yet to be replicated. Consumers are expected to retry.
   */
  wixCalendarEventsV3ListRecurringEventInstancesHistory?: Maybe<WixCalendarEventsV3ListRecurringEventInstancesHistoryResponse>;
  wixCalendarEventsV3MigrateSite?: Maybe<WixCalendarMigrationV3MigrateSiteResponse>;
  wixCalendarEventsV3ParticipantEventsHandleMetaSiteEvent?: Maybe<Scalars['Void']>;
  wixCalendarEventsV3ParticipantEventsHandleSitePropertiesNotification?: Maybe<Scalars['Void']>;
  /**
   * Restores the event's default values from the relevant schedule or `MASTER`
   * event.
   *
   *
   * You must provide `fields` to specify which `inheritedFields` are restored.
   *
   * For example, if you've created an event that takes place in a non-default
   * location with a custom title and capacity, but you want to reset only title
   * and capacity to default values without affecting the location, provide the
   * event ID and set `fields` to `["TITLE", "CAPACITY"]`.
   *
   * Refer to the [default values article](https://dev.wix.com/docs/rest/business-management/calendar/default-values)
   * for more information.
   */
  wixCalendarEventsV3RestoreEventDefaults?: Maybe<WixCalendarEventsV3RestoreEventDefaultsResponse>;
  /**
   * Splits a recurring `MASTER` event into 2 separate `MASTER` events.
   *
   *
   * You must provide a `splitLocalDate` that's in the future and after the `start`
   * date of the next `INSTANCE` or `EXCEPTION` event in the series. Additionally,
   * there must be another `INSTANCE` or `EXCEPTION` event following this next event,
   * as the changes wouldn't affect any event without a subsequent occurrence.
   *
   * If you want to modify a `MASTER` event with the changes already applying to
   * the very next event, use
   * [Update Event](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/update-event)
   * instead, as this preserves past events and only modifies future events.
   *
   * The main consequences are:
   * - **The original `MASTER` event is shortened**. Its `recurrenceRule.until.localDate`
   * is updated to `end.localDate` of the latest `INSTANCE` or `EXCEPTION`
   * event starting before `splitLocalDate`. If an `INSTANCE` or `EXCEPTION` event
   * starts before but ends after `splitLocalDate`, `until.localDate` is set
   * to value that's later than `splitLocalDate`.
   * - **A new `MASTER` event is created**, starting from the first event that
   * begins after `splitLocalDate`.
   * - **Existing `INSTANCE` and `EXCEPTION` events that occur after the split are updated**.
   * Their `recurringEventId` is set to the ID of the newly created `MASTER` event.
   */
  wixCalendarEventsV3SplitRecurringEvent?: Maybe<WixCalendarEventsV3SplitRecurringEventResponse>;
  /**
   * Updates an event.
   *
   *
   * When updating an event with `{"recurrenceType": "INSTANCE"}`, the
   * `recurrenceType` automatically changes to `EXCEPTION`.
   *
   * When updating an event with `{"recurrenceType": "MASTER"}`:
   * + Past `INSTANCE` and `EXCEPTION` events remain unchanged.
   * + For future `INSTANCE` events, all relevant fields are updated.
   * + For future `EXCEPTION` events, only changes to the `inheritedFields` are
   * applied, while other fields remain unchanged.
   */
  wixCalendarEventsV3UpdateEvent?: Maybe<WixCalendarEventsV3UpdateEventResponse>;
  /**
   * Updates an event participants.
   *
   * Currently this API is `PRIVATE`.
   * Consumers wishing to update an event participants should use the Participations API.
   */
  wixCalendarEventsV3UpdateEventParticipants?: Maybe<WixCalendarEventsV3UpdateEventParticipantsResponse>;
  /**
   * Sets a schedule's `status` to `CANCELLED`.
   *
   *
   * Also cancels future events belonging to the schedule.
   *
   * Once a schedule is marked as `CANCELLED`, you can't reactivate it, update it,
   * or assign new events.
   */
  wixCalendarSchedulesV3CancelSchedule?: Maybe<WixCalendarSchedulesV3CancelScheduleResponse>;
  /** Clones a schedule. */
  wixCalendarSchedulesV3CloneSchedule?: Maybe<WixCalendarSchedulesV3CloneScheduleResponse>;
  /** subscription to location changes */
  wixCalendarSchedulesV3ConsumeLocationDomainEvents?: Maybe<Scalars['Void']>;
  /** subscription to site Properties changes */
  wixCalendarSchedulesV3ConsumeSitePropertiesEvents?: Maybe<Scalars['Void']>;
  /**
   * Creates a schedule.
   *
   *
   * If you want the schedule's events to appear in the
   * [Bookings calendar](https://support.wix.com/en/article/wix-bookings-about-the-wix-booking-calendar),
   * you must set `appId` to the ID of the Wix Bookings app by providing
   * `{"appId": "13d21c63-b5ec-5912-8397-c3a5ddb27a97"}`.
   */
  wixCalendarSchedulesV3CreateSchedule?: Maybe<WixCalendarSchedulesV3CreateScheduleResponse>;
  /** subscription to meta-site-special events to deal with provisioning */
  wixCalendarSchedulesV3HandleMetaSiteEvent?: Maybe<Scalars['Void']>;
  /**
   * Updates a schedule.
   *
   *
   * Each time the schedule is updated,
   * `revision` increments by 1.
   * The current `revision` must be passed when updating the schedule.
   * This ensures you're working with the latest schedule
   * and prevents unintended overwrites.
   */
  wixCalendarSchedulesV3UpdateSchedule?: Maybe<WixCalendarSchedulesV3UpdateScheduleResponse>;
  /** Adds media items to a specified product, either via URL or existing media ID. */
  wixCatalogApiV1AddProductMedia?: Maybe<Scalars['Void']>;
  /**
   * Links media items that are already associated with a specific product to a choice within the same product.
   *
   * Media items can only be set for choices within one option at a time - e.g., if you set media items for some or all of the choices within the Colors option (blue, green, and red), you won't be able to also assign media items to choices within the Size option (S, M, and L).
   *
   * To remove all existing media items, call the [Remove Product Media From Choices](https://dev.wix.com/api/rest/wix-stores/catalog/products/remove-product-media-from-choices) endpoint.
   */
  wixCatalogApiV1AddProductMediaToChoices?: Maybe<Scalars['Void']>;
  /** Adds products to a specified collection. */
  wixCatalogApiV1AddProductsToCollection?: Maybe<Scalars['Void']>;
  /**
   * Before open to users we should support group by field which will impact all aggregations
   * Group by field is optional, in case you want to count all, max on all etc
   * Issue: for count we allow 2-dimensional aggregation which will not be supported when group by single field
   * To support group by we need to add support of it in object-search library
   * This is exposed only to internal since it has limitations and there isn't an aggregate spec yet
   */
  wixCatalogApiV1AggregateProducts?: Maybe<WixCatalogApiV1AggregateProductsResponse>;
  /**
   * Adjusts a specified numerical property for up to 100 products at a time.
   * The property can be increased or decreased either by percentage or amount.
   */
  wixCatalogApiV1BulkAdjustProductProperties?: Maybe<WixCatalogApiV1BulkAdjustProductPropertiesResponse>;
  /**
   * Adjust property for multiple products, selected by filter.
   * The number of products that can be updated by filter is limited to 1000.
   * Internal only. Will be replaced at some point.
   */
  wixCatalogApiV1BulkAdjustProductPropertiesByFilterSync?: Maybe<WixCatalogApiV1BulkAdjustProductPropertiesByFilterSyncResponse>;
  /** Deletes a bulk of products. */
  wixCatalogApiV1BulkDeleteProducts?: Maybe<Scalars['Void']>;
  /**
   * Retrieves a list of up to 100 productId to CustomFields, given the provided paging, sorting and filtering.
   * See [Stores Pagination](https://dev.wix.com/api/rest/wix-stores/pagination) for more information.
   * This is exposed only to internal since it's a partial solution that doesn't cover the data extensions use case
   */
  wixCatalogApiV1BulkQueryCustomFields?: Maybe<WixCatalogApiV1BulkQueryCustomFieldsResponse>;
  wixCatalogApiV1BulkRemoveCustomFields?: Maybe<Scalars['Void']>;
  wixCatalogApiV1BulkSetCustomFields?: Maybe<Scalars['Void']>;
  /** Updates a specified property for up to 100 products at a time. */
  wixCatalogApiV1BulkUpdateProducts?: Maybe<WixCatalogApiV1BulkUpdateProductsResponse>;
  /**
   * Updates a bulk of products, selected by filter.
   * The number of products that can be updated by filter is limited to 1000.
   * Internal only. Will be replaced in some point.
   */
  wixCatalogApiV1BulkUpdateProductsByFilterSync?: Maybe<WixCatalogApiV1BulkUpdateProductsByFilterSyncResponse>;
  /** Creates a new collection. */
  wixCatalogApiV1CreateCollection?: Maybe<WixCatalogApiV1CreateCollectionResponse>;
  /** Creates a new digital product. */
  wixCatalogApiV1CreateDigitalProduct?: Maybe<WixCatalogApiV1CreateDigitalProductResponse>;
  /** Creates a new product. */
  wixCatalogApiV1CreateProduct?: Maybe<WixCatalogApiV1CreateProductResponse>;
  /** Creates a new product. */
  wixCatalogApiV1CreateProductPlatformized?: Maybe<WixCatalogApiV1CreateProductPlatformizedResponse>;
  /** Deletes a collection. */
  wixCatalogApiV1DeleteCollection?: Maybe<Scalars['Void']>;
  /** Deletes a product. */
  wixCatalogApiV1DeleteProduct?: Maybe<Scalars['Void']>;
  /** Delete all options from a specific product. Only available when [variant management](https://support.wix.com/en/article/wix-stores-adding-and-customizing-product-options#setting-different-prices-for-variants) is disabled. */
  wixCatalogApiV1DeleteProductOptions?: Maybe<Scalars['Void']>;
  /** Deletes a product. */
  wixCatalogApiV1DeleteProductPlatformized?: Maybe<Scalars['Void']>;
  /** Retrieves a collection with the provided ID. */
  wixCatalogApiV1GetCollection?: Maybe<WixCatalogApiV1GetCollectionResponse>;
  /** Retrieves a collection with the provided slug. */
  wixCatalogApiV1GetCollectionBySlug?: Maybe<WixCatalogApiV1GetCollectionBySlugResponse>;
  /** Retrieves a product with the provided ID. */
  wixCatalogApiV1GetProduct?: Maybe<WixCatalogApiV1GetProductResponse>;
  /** Returns a list of up to 250 products, given the provided ids. */
  wixCatalogApiV1GetProducts?: Maybe<WixCatalogApiV1GetProductsResponse>;
  /** Retrieves a store variant with the provided ID. */
  wixCatalogApiV1GetStoreVariant?: Maybe<WixCatalogApiV1GetStoreVariantResponse>;
  /** Gets the availability of relevant product variants based on the product ID and selections provided. See [Use Cases](https://dev.wix.com/api/rest/wix-stores/catalog/use-cases) for an example. */
  wixCatalogApiV1ProductOptionsAvailability?: Maybe<WixCatalogApiV1ProductOptionsAvailabilityResponse>;
  /**
   * Retrieves a list of up to 100 collections, given the provided paging, sorting and filtering.
   * See [Stores Pagination](https://dev.wix.com/api/rest/wix-stores/pagination) for more information.
   */
  wixCatalogApiV1QueryCollections?: Maybe<WixCatalogApiV1QueryCollectionsResponse>;
  /**
   * Retrieves a list of up to 100 collections, given the provided paging, sorting and filtering.
   * See [Stores Pagination](https://dev.wix.com/api/rest/wix-stores/pagination) for more information.
   */
  wixCatalogApiV1QueryCollectionsPlatformized?: Maybe<WixCatalogApiV1QueryCollectionsPlatformizedResponse>;
  wixCatalogApiV1QueryCustomFields?: Maybe<WixCatalogApiV1QueryCustomFieldsResponse>;
  /**
   * Retrieves product variants, based on either choices (option-choice key-value pairs) or variant IDs.
   * See [Stores Pagination](https://dev.wix.com/api/rest/wix-stores/pagination) for more information.
   */
  wixCatalogApiV1QueryProductVariants?: Maybe<WixCatalogApiV1QueryProductVariantsResponse>;
  /**
   * Returns a list of up to 100 products, given the provided paging, sorting and filtering.
   * See [Stores Pagination](https://dev.wix.com/api/rest/wix-stores/pagination) for more information.
   */
  wixCatalogApiV1QueryProducts?: Maybe<WixCatalogApiV1QueryProductsResponse>;
  /**
   * Returns a list of up to 600 products, given the provided paging, sorting and filtering.
   * See [Stores Pagination](https://dev.wix.com/api/rest/wix-stores/pagination) for more information.
   */
  wixCatalogApiV1QueryProductsWithBigPageLimit?: Maybe<WixCatalogApiV1QueryProductsResponse>;
  /** Retrieves up to 100 store variants, given the provided paging, filtering, and sorting. */
  wixCatalogApiV1QueryStoreVariants?: Maybe<WixCatalogApiV1QueryStoreVariantsResponse>;
  /** Retrieves up to 1000 store variants, given the provided paging, filtering, and sorting. */
  wixCatalogApiV1QueryStoreVariantsWithBigLimit?: Maybe<WixCatalogApiV1QueryStoreVariantsResponse>;
  wixCatalogApiV1ReCloneStore?: Maybe<Scalars['Void']>;
  /** Deletes a product's brand. */
  wixCatalogApiV1RemoveBrand?: Maybe<Scalars['Void']>;
  wixCatalogApiV1RemoveCustomFields?: Maybe<Scalars['Void']>;
  /**
   * Removes specified media items from a product.
   * Pass an empty array to remove all media items.
   */
  wixCatalogApiV1RemoveProductMedia?: Maybe<Scalars['Void']>;
  /**
   * Removes media items from all or some of a product's choices.
   * (Media items can only be set for choices within one option at a time - e.g., if you set media items for some or all of the choices within the Colors option (blue, green, and red), you won't be able to also assign media items to choices within the Size option (S, M, and L).)
   */
  wixCatalogApiV1RemoveProductMediaFromChoices?: Maybe<Scalars['Void']>;
  /** Deletes products from a specified collection. */
  wixCatalogApiV1RemoveProductsFromCollection?: Maybe<Scalars['Void']>;
  /** Deletes a product's ribbon. */
  wixCatalogApiV1RemoveRibbon?: Maybe<Scalars['Void']>;
  /** Resets the data (such as the price and the weight) of all variants for a given product to their default values. */
  wixCatalogApiV1ResetAllVariantData?: Maybe<Scalars['Void']>;
  wixCatalogApiV1SetCustomFields?: Maybe<Scalars['Void']>;
  /**
   * Updates specified properties of a collection.
   * To add products to a collection, call the [Add Products to Collection](https://dev.wix.com/api/rest/wix-stores/catalog/collections/add-products-to-collection) endpoint.
   */
  wixCatalogApiV1UpdateCollection?: Maybe<WixCatalogApiV1UpdateCollectionResponse>;
  /**
   * Updates specified fields in a product.
   *
   * To update a single field across multiple products, use [Bulk Update Product Property](https://dev.wix.com/docs/rest/business-solutions/stores/catalog/bulk-update-product-property).
   */
  wixCatalogApiV1UpdateProduct?: Maybe<WixCatalogApiV1UpdateProductResponse>;
  /** Updates specified fields in a product. */
  wixCatalogApiV1UpdateProductPlatformized?: Maybe<WixCatalogApiV1UpdateProductPlatformizedResponse>;
  /** Updates variants of a specified product. */
  wixCatalogApiV1UpdateVariants?: Maybe<WixCatalogApiV1UpdateVariantsResponse>;
  /** Creates a new product. */
  wixCatalogApiV1WriteProxyCreateProductPlatformized?: Maybe<WixCatalogWriteProxyV1CreateProductPlatformizedResponse>;
  /** Deletes a product. */
  wixCatalogApiV1WriteProxyDeleteProductPlatformized?: Maybe<Scalars['Void']>;
  /** Updates specified fields in a product. */
  wixCatalogApiV1WriteProxyUpdateProductPlatformized?: Maybe<WixCatalogWriteProxyV1UpdateProductPlatformizedResponse>;
  /** echo given arg1 and arg2 */
  wixCoreservicesMetroinspectorV1Echo?: Maybe<WixCoreservicesMetroinspectorV1EchoResponse>;
  wixDevcenterAppsV1ActivateSecondarySecret?: Maybe<WixDevcenterAppsV1ActivateSecondarySecretResponse>;
  /** Lazy migration - Updating new service with old service slugs */
  wixDevcenterAppsV1ConsumeAppSlugChanged?: Maybe<Scalars['Void']>;
  /** consume events where app urls changed */
  wixDevcenterAppsV1ConsumeAppUrlsChangedMessage?: Maybe<Scalars['Void']>;
  /** Consume app version state change event (app market events) */
  wixDevcenterAppsV1ConsumeAppVersionStateChanged?: Maybe<Scalars['Void']>;
  /** Lazy migration - Updating new service with old service changes */
  wixDevcenterAppsV1ConsumeOldAppChanged?: Maybe<Scalars['Void']>;
  /** Creates a new App */
  wixDevcenterAppsV1CreateApp?: Maybe<WixDevcenterAppsV1CreateAppResponse>;
  wixDevcenterAppsV1CreateSecondarySecret?: Maybe<WixDevcenterAppsV1CreateSecondarySecretResponse>;
  /** Delete an App */
  wixDevcenterAppsV1DeleteApp?: Maybe<Scalars['Void']>;
  /** Set the slug of the app */
  wixDevcenterAppsV1GenerateSlug?: Maybe<WixDevcenterAppsV1GenerateSlugResponse>;
  /**
   * Get namespace suggestion using the Application's Account or Company.
   * When using Company and the Company Name is empty, fallback to Account Name.
   */
  wixDevcenterAppsV1GetNamespaceSuggestion?: Maybe<WixDevcenterAppsV1GetNamespaceSuggestionResponse>;
  /**
   * Get namespace suggestion using the Application's Account or Company.
   * When using Company and the Company Name is empty, fallback to Account Name.
   */
  wixDevcenterAppsV1GetNamespaceSuggestionByName?: Maybe<WixDevcenterAppsV1GetNamespaceSuggestionByNameResponse>;
  wixDevcenterAppsV1RollbackSecret?: Maybe<WixDevcenterAppsV1RollbackSecretResponse>;
  wixDevcenterAppsV1RotateSecret?: Maybe<WixDevcenterAppsV1RotateSecretResponse>;
  /** Sets the account of the app */
  wixDevcenterAppsV1SetAppOwner?: Maybe<WixDevcenterAppsV1SetAppOwnerResponse>;
  /** Sets the app as cacheable */
  wixDevcenterAppsV1SetCacheableApp?: Maybe<WixDevcenterAppsV1SetCacheableAppResponse>;
  /** Sets the app as HIPAA compliant */
  wixDevcenterAppsV1SetHipaaCompliant?: Maybe<WixDevcenterAppsV1SetHipaaCompliantResponse>;
  /**
   * Set the app namespace using the Application's Account or Company.
   * The namespace can ONLY be set once so it will fail if the namespace already exist.
   */
  wixDevcenterAppsV1SetNamespace?: Maybe<WixDevcenterAppsV1SetNamespaceResponse>;
  /** Sets the ownership tag of the app */
  wixDevcenterAppsV1SetOwnershipTag?: Maybe<Scalars['Void']>;
  /** Sets an app as private */
  wixDevcenterAppsV1SetPrivateApp?: Maybe<WixDevcenterAppsV1SetPrivateAppResponse>;
  /**
   * Update an App, supports partial update
   * Pass the latest `revision` for a successful update
   */
  wixDevcenterAppsV1UpdateApp?: Maybe<WixDevcenterAppsV1UpdateAppResponse>;
  /**
   * > **Deprecation Notice**
   * >
   * > **This endpoint has been replaced with Events V3's [Bulk Cancel Events By Filter](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/bulk-cancel-events-by-filter) and will be removed on November 6, 2024.**
   * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
   *
   * Cancels events by filter.
   * If event cancellation notifications are enabled, canceling an event automatically sends cancellation emails and/or push notifications to registered guests.
   *
   * > **Note:**
   * > This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
   */
  wixEventsBulkCancelEvents?: Maybe<Scalars['Void']>;
  /**
   * > **Deprecation Notice**
   * >
   * > **This endpoint has been replaced with Events V3's [Bulk Delete Events By Filter](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/bulk-delete-events-by-filter) and will be removed on November 6, 2024.**
   * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
   *
   * Deletes events by filter.
   * Deleted events are not returned via API. The only way to retrieve them is via GDPR access request.
   *
   * > **Note:**
   * > This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
   */
  wixEventsBulkDeleteEvents?: Maybe<Scalars['Void']>;
  /**
   * > **Deprecation Notice**
   * >
   * > **This endpoint has been replaced with Events V3's [Cancel Event](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/cancel-event) and will be removed on November 6, 2024.**
   * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
   *
   * Cancels an event and closes registration.
   * If event cancellation notifications are enabled, canceling an event automatically sends cancellation emails and/or push notifications to registered guests.
   */
  wixEventsCancelEvent?: Maybe<WixEventsCancelEventResponse>;
  /**
   * Copies an event, including its registration form, notifications and tickets configuration - scheduled two weeks from the original event.
   * Multilingual translations are also copied to the new event.
   *
   * When an event with same title already exists, appends (1), (2), ... to it. For example, copying an event titled "My Event" creates "My Event (1)".
   * Very long event titles are cropped: "Daily stand-up ev... (2)".
   */
  wixEventsCopy?: Maybe<WixEventsCopyEventResponse>;
  /**
   * Copies event from other site.
   * The event id is changed. This action is not idempotent - every call results in a new event.
   * Dedicated for lite events
   */
  wixEventsCopyEventFromOtherSite?: Maybe<WixEventsCopyEventFromOtherSiteResponse>;
  /**
   * > **Deprecation Notice**
   * >
   * > **This endpoint has been replaced with Events V3's [Clone Event](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/clone-event) and will be removed on November 6, 2024.**
   * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
   *
   * Copies an event, including its registration form, notifications and tickets configuration - scheduled two weeks from the original event.
   * Multilingual translations are also copied to the new event.
   * Supports partial update of the original event fields. See [Partial Updates](https://dev.wix.com/api/rest/wix-events/wix-events/partial-updates) for more information.
   *
   * When an event with same title already exists, appends (1), (2), ... to it. For example, copying an event titled "My Event" creates "My Event (1)".
   * Very long event titles are cropped: "Daily stand-up ev... (2)".
   */
  wixEventsCopyEventV2?: Maybe<WixEventsCopyEventV2Response>;
  /**
   * > **Deprecation Notice**
   * >
   * > **This endpoint has been replaced with Events V3's [Create Event](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/create-event) and will be removed on November 6, 2024.**
   * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
   *
   * Creates a new event, with a default registration form in the given language.
   * Default registration form includes first name, last name, and email inputs.
   * To learn more about registration form and customize it, see [Registration Form](https://dev.wix.com/api/rest/wix-events/wix-events/registration-form/about-the-registration-form-api).
   * The event is automatically configured to send daily summary reports of new registrations to site business email.
   * RegistrationConfig.initialType is required - allowed value when creating is RSVP or TICKETS.
   */
  wixEventsCreateEventV2?: Maybe<WixEventsCreateEventV2Response>;
  /**
   * > **Deprecation Notice**
   * >
   * > **This endpoint has been replaced with Events V3's [Delete Event](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/delete-event) and will be removed on November 6, 2024.**
   * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
   *
   * Deletes an event.
   * Deleted events are not returned via API. The only way to retrieve them is via GDPR access request.
   */
  wixEventsDeleteEvent?: Maybe<WixEventsDeleteEventResponse>;
  /**
   * > **Deprecation Notice**
   * >
   * > **This endpoint has been replaced with Events V3's [Get Event](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/get-event) and will be removed on November 6, 2024.**
   * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
   *
   * Finds an event by ID or URL slug. In contrast to Get Event endpoint which returns not found error,
   * Find Event returns empty response when an event is not found.
   *
   * > **Note:**
   * > This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
   */
  wixEventsFindEvent?: Maybe<WixEventsFindEventResponse>;
  wixEventsFindOnlineConferenceSession?: Maybe<WixEventsFindOnlineConferenceSessionResponse>;
  wixEventsGetRecurringEventState?: Maybe<WixEventsGetRecurringEventStateResponse>;
  wixEventsGetTicketingSummary?: Maybe<WixEventsGetTicketingSummaryResponse>;
  /**
   * > **Deprecation Notice**
   * >
   * > **This endpoint has been replaced with Events V3's [Query Events](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/query-events) and will be removed on November 6, 2024.**
   * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
   *
   * Retrieves a list of up to 100 events, given the provided [paging](https://dev.wix.com/api/rest/getting-started/pagination) and category_id.
   * Events are sorted by the sort index defined by CategoryManagement.
   * > **Note:**
   * > This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
   */
  wixEventsListCategoryEvents?: Maybe<WixEventsListCategoryEventsResponse>;
  /**
   * > **Deprecation Notice**
   * >
   * > **This endpoint has been replaced with Events V3's [Query Events](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/query-events) and will be removed on November 6, 2024.**
   * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
   *
   * Retrieves a list of up to 100 events, given the provided [paging](https://dev.wix.com/api/rest/getting-started/pagination), [filtering & sorting](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events).
   *
   * > **Note:**
   * > This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
   */
  wixEventsListEvents?: Maybe<WixEventsListEventsResponse>;
  /** Retrieves a list of up to 100 user related events, given the provided [paging](https://dev.wix.com/api/rest/getting-started/pagination), [filtering & sorting](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events). */
  wixEventsListUserEvents?: Maybe<WixEventsListUserEventsResponse>;
  /**
   * > **Deprecation Notice**
   * >
   * > **This endpoint has been replaced with Events V3's [Update Event](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/publish-draft-event) and will be removed on November 6, 2024.**
   * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
   *
   * Publishes draft event so that it becomes available to site visitors.
   * If recurring events are set, category with state RECURRING_EVENT will be created.
   * All recurring events will be assigned to this category.
   *
   * >**Note:**
   * >This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
   */
  wixEventsPublishDraftEvent?: Maybe<WixEventsPublishDraftEventResponse>;
  /** Retrieves a list of up to 1,000 events, given the provided [paging](https://dev.wix.com/api/rest/getting-started/pagination), [filtering and sorting](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events). */
  wixEventsQuery?: Maybe<WixEventsQueryEventsResponse>;
  /** Adds schedule item to the draft schedule. Draft items are not publicly available unless published. */
  wixEventsScheduleAddScheduleItem?: Maybe<WixEventsScheduleAddScheduleItemResponse>;
  /** Bookmarks schedule item for current member. */
  wixEventsScheduleCreateBookmark?: Maybe<Scalars['Void']>;
  /** Removes schedule item bookmark from current member. */
  wixEventsScheduleDeleteBookmark?: Maybe<Scalars['Void']>;
  /** Deletes schedule item from draft schedule. */
  wixEventsScheduleDeleteScheduleItem?: Maybe<Scalars['Void']>;
  /** Clears all changes to the draft schedule. (Does not affect the published schedule.) */
  wixEventsScheduleDiscardDraft?: Maybe<Scalars['Void']>;
  /** Retrieves schedule item by ID. */
  wixEventsScheduleGetScheduleItem?: Maybe<WixEventsScheduleGetScheduleItemResponse>;
  /** Retrieves a list of bookmarked schedule items for current member. */
  wixEventsScheduleListBookmarks?: Maybe<WixEventsScheduleListBookmarksResponse>;
  /** Retrieves a list of up to 100 schedule items, with basic filter support. */
  wixEventsScheduleListScheduleItems?: Maybe<WixEventsScheduleListScheduleItemsResponse>;
  /** Publishes the draft schedule. */
  wixEventsSchedulePublishDraft?: Maybe<Scalars['Void']>;
  /** Adjusts time of all draft schedule items (per event). */
  wixEventsScheduleRescheduleDraft?: Maybe<Scalars['Void']>;
  /**
   * Updates existing schedule item.
   * All modifications are performed on a draft schedule, even if schedule item has already been published.
   */
  wixEventsScheduleUpdateScheduleItem?: Maybe<WixEventsScheduleUpdateScheduleItemResponse>;
  /**
   * > **Deprecation Notice**
   * >
   * > **This endpoint has been replaced with Events V3's [Update Event](https://dev.wix.com/docs/rest/business-solutions/events/events/event/update-event) and will be removed on November 6, 2024.**
   * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
   *
   * Updates an event's parameters. See [Partial Updates](https://dev.wix.com/api/rest/wix-events/wix-events/partial-updates) for more information.
   */
  wixEventsUpdateEvent?: Maybe<WixEventsUpdateEventResponse>;
  wixEventsUpdateRecurringStatus?: Maybe<Scalars['Void']>;
  /** Consumes EventCopied event and clones policies */
  wixEventsV2ConsumeEventCopied?: Maybe<Scalars['Void']>;
  /**
   * Creates a policy.
   *
   * An event may have up to 3 policies.
   * Attempts to create more than 3 returns a `"POLICIES_LIMIT_REACHED"` error.
   */
  wixEventsV2CreatePolicy?: Maybe<WixEventsV2CreatePolicyResponse>;
  /**
   * Permanently deletes a policy.
   *
   * Deleted policies are not returned by the Get Policy or Query Policy methods.
   */
  wixEventsV2DeletePolicy?: Maybe<Scalars['Void']>;
  /** Retrieves a deleted policy. Used in bg-service. */
  wixEventsV2GetPolicyFromTrashBin?: Maybe<WixEventsV2GetPolicyFromTrashBinResponse>;
  /**
   * Changes policy order in an event dashboard and agreement checkbox on the checkout form.
   * By default, policies are arranged by the created date in descending order.
   *
   * > **Note:** It is possible to use both `beforePolicyId` and `afterPolicyId` at the same time but only the last one defined will be executed.
   */
  wixEventsV2ReorderEventPolicies?: Maybe<WixEventsV2ReorderEventPoliciesResponse>;
  /**
   * Updates a policy.
   *
   * Each time the policy is updated, `revision` increments by 1. The existing `revision` must be included when updating the policy.
   * This ensures you're working with the latest policy and prevents unintended overwrites.
   */
  wixEventsV2UpdatePolicy?: Maybe<WixEventsV2UpdatePolicyResponse>;
  wixEventsV2UpdatePolicySortIndex?: Maybe<WixEventsV2UpdatePolicySortIndexResponse>;
  /** Clone form from template metaSite */
  wixFormsV1CloneFormFromTemplateMetaSite?: Maybe<WixFormsV1CloneFormFromTemplateMetaSiteResponse>;
  wixFormsV1ConsumeMetaSiteSpecialEvent?: Maybe<Scalars['Void']>;
  wixFormsV1ConsumeSitePropertiesEvent?: Maybe<Scalars['Void']>;
  wixFormsV1CreateStandaloneForm?: Maybe<WixFormsV1CreateStandaloneFormResponse>;
  wixFormsV1DeleteStandaloneForm?: Maybe<Scalars['Void']>;
  /** Gets OAuth client ID for 'Forms & Checkout integration' app */
  wixFormsV1GetCheckoutOAuthClientId?: Maybe<WixFormsV1GetCheckoutOAuthClientIdResponse>;
  wixFormsV1GetDeletedStandaloneForm?: Maybe<WixFormsV1GetDeletedStandaloneFormResponse>;
  /** Gets client spec map for user-of-user (including unpublished sites) */
  wixFormsV1GetPublicClientSpecMap?: Maybe<WixFormsV1GetPublicClientSpecMapResponse>;
  wixFormsV1ListDeletedStandaloneForms?: Maybe<WixFormsV1ListDeletedStandaloneFormsResponse>;
  wixFormsV1MoveStandaloneFormToMetaSite?: Maybe<WixFormsV1MoveStandaloneFormToMetaSiteResponse>;
  wixFormsV1QueryStandaloneForms?: Maybe<WixFormsV1QueryStandaloneFormsResponse>;
  wixFormsV1RedirectToStandaloneFormEditor?: Maybe<ComWixpressRestRawHttpResponse>;
  wixFormsV1RedirectToStandaloneFormEditorDashboard?: Maybe<ComWixpressRestRawHttpResponse>;
  wixFormsV1RemoveStandaloneFormFromTrashBin?: Maybe<Scalars['Void']>;
  wixFormsV1RestoreStandaloneFormFromTrashBin?: Maybe<WixFormsV1RestoreStandaloneFormFromTrashBinResponse>;
  /** Creates copies of multiple form schemas in a single request. */
  wixFormsV4BulkCloneForm?: Maybe<WixFormsV4BulkCloneFormResponse>;
  /** Creates multiple form schemas in a single request. */
  wixFormsV4BulkCreateForm?: Maybe<WixFormsV4BulkCreateFormResponse>;
  /**
   * Deletes multiple form schemas at once.
   *
   * The schemas are moved to the trash bin where they're stored for 90 days before permanent deletion.
   * When permanently deleted, all associated form submissions are also deleted.
   */
  wixFormsV4BulkDeleteForm?: Maybe<WixFormsV4BulkDeleteFormResponse>;
  /** Permanently removes deleted fields from a form schema. */
  wixFormsV4BulkRemoveDeletedField?: Maybe<WixFormsV4BulkRemoveDeletedFieldResponse>;
  /** Bulk update tags on forms. */
  wixFormsV4BulkUpdateFormTags?: Maybe<WixFormsV4BulkUpdateFormTagsResponse>;
  /** Bulk update tags on forms by filter. */
  wixFormsV4BulkUpdateFormTagsByFilter?: Maybe<WixFormsV4BulkUpdateFormTagsByFilterResponse>;
  /** Creates a copy of an existing form schema with a new ID. */
  wixFormsV4CloneForm?: Maybe<WixFormsV4CloneFormResponse>;
  /** Creates a form schema from a template. */
  wixFormsV4CloneFormFromTemplate?: Maybe<WixFormsV4CloneFormFromTemplateResponse>;
  /** Consume form domain events. */
  wixFormsV4ConsumeFormDomainEvents?: Maybe<Scalars['Void']>;
  /** Consume form template domain events. */
  wixFormsV4ConsumeFormTemplateDomainEvents?: Maybe<Scalars['Void']>;
  /**
   * Returns the total number of deleted form schemas in the specified namespace that match the specified filter criteria.
   * This counts form schemas in the trash bin, not permanently deleted form schemas.
   */
  wixFormsV4CountDeletedForms?: Maybe<WixFormsV4CountDeletedFormsResponse>;
  /** Deprecated on '2025-04-10'. Use CountFormsByFilter. */
  wixFormsV4CountForms?: Maybe<WixFormsV4CountFormsResponse>;
  /** Returns the total number of form schemas in the specified namespace that match the specified filter criteria. */
  wixFormsV4CountFormsByFilter?: Maybe<WixFormsV4CountFormsByFilterResponse>;
  /**
   * Creates a form schema.
   *
   * Each form schema defines the structure, fields, validation rules, and layout for forms.
   * The form schema serves as a blueprint that can be used by an app to generate actual forms. The app that can use the schema is determined by the specified `namespace`.
   */
  wixFormsV4CreateForm?: Maybe<WixFormsV4CreateFormResponse>;
  /**
   * Creates form with migrated=true state
   * Used only for old forms migrations
   */
  wixFormsV4CreateMigratedForm?: Maybe<WixFormsV4CreateMigratedFormResponse>;
  /**
   * Deletes a form schema.
   *
   * The schema is moved to the trash bin where it's stored for 90 days before permanent deletion.
   * When permanently deleted, all associated form submissions are also deleted.
   */
  wixFormsV4DeleteForm?: Maybe<Scalars['Void']>;
  /**
   * Deletes a form. It is stored in trash for 90 days.
   * On form permanent deletion, all submissions are also deleted.
   */
  wixFormsV4DeleteFormFromTrashBin?: Maybe<Scalars['Void']>;
  /**
   * Retrieves a deleted form schema by ID.
   *
   * This method retrieves form schemas that have been deleted and are in the trash bin but haven't yet been permanently removed.
   */
  wixFormsV4GetDeletedForm?: Maybe<WixFormsV4GetDeletedFormResponse>;
  /**
   * Retrieves a summary of a form schema containing information about its fields.
   *
   * Use this method to get an overview of a form schema without all the detailed configuration information.
   */
  wixFormsV4GetFormSummary?: Maybe<WixFormsV4GetFormSummaryResponse>;
  /** Retrieves a list of deleted form schemas. */
  wixFormsV4ListDeletedForms?: Maybe<WixFormsV4ListDeletedFormsResponse>;
  /** Retrieves a list of form schemas that meet the specified criteria. */
  wixFormsV4ListForms?: Maybe<WixFormsV4ListFormsResponse>;
  /**
   * Lists template extension as forms, filtered by namespace, its disabled status and name.
   * If specified, sorts forms in the desired order.
   */
  wixFormsV4ListTemplateExtensions?: Maybe<WixFormsV4ListTemplateExtensionsResponse>;
  /**
   * Retrieves a list of deleted form schemas given the provided paging, filtering, and sorting.
   *
   * This method lists form schemas that have were deleted and are in the trash bin but haven't yet been permanently removed.
   *
   * You must specify a namespace equality filter. For example, `"namespace:{"$eq":"<your_namespace>"}`.
   *
   * Refer to the [supported filters and sorting article](https://dev.wix.com/docs/api-reference/crm/forms/form-schemas/supported-filters-and-sorting) for a complete list of supported filters and sorting options.
   */
  wixFormsV4QueryDeletedForms?: Maybe<WixFormsV4QueryDeletedFormsResponse>;
  /** Query forms using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language). */
  wixFormsV4QueryForms?: Maybe<WixFormsV4QueryFormsResponse>;
  /** Removes a form schema from the trash bin, permanently deleting it. */
  wixFormsV4RemoveFormFromTrashBin?: Maybe<Scalars['Void']>;
  /** Restores a form schema from the trash bin. It will no longer be deleted after 90 days. */
  wixFormsV4RestoreFromTrashBin?: Maybe<WixFormsV4RestoreFromTrashBinResponse>;
  /** Update extended fields of the form schema. */
  wixFormsV4UpdateExtendedFields?: Maybe<WixFormsV4UpdateExtendedFieldsResponse>;
  /** Updates a form schema. */
  wixFormsV4UpdateForm?: Maybe<WixFormsV4UpdateFormResponse>;
  /** Consume Gift Cards & Store Credit Apps Provisioned events */
  wixGiftCardsGiftCardV1ConsumeGiftCardsAndStoreCreditAppsProvisionedEvents?: Maybe<Scalars['Void']>;
  /** Consume Gift Cards App Provisioned events */
  wixGiftCardsGiftCardV1ConsumeGiftCardsAppProvisionedEvents?: Maybe<Scalars['Void']>;
  /** Consume site currency updates */
  wixGiftCardsGiftCardV1ConsumeSiteCurrencyUpdates?: Maybe<Scalars['Void']>;
  /** Consume site properties updates */
  wixGiftCardsGiftCardV1ConsumeSitePropertiesUpdates?: Maybe<Scalars['Void']>;
  /** Consume requests for triggering gift cards app installation flow */
  wixGiftCardsGiftCardV1ConsumeTriggerGiftCardsAppInstallationFlowEvents?: Maybe<Scalars['Void']>;
  /** Counts the total number of gift cards matching the specified filter criteria. */
  wixGiftCardsGiftCardV1CountGiftCards?: Maybe<WixGiftCardsGiftCardV1CountGiftCardsResponse>;
  /**
   * Creates a gift card with an initial value and optional recipient notification settings.
   *
   * Gift card codes can be custom-provided or automatically generated by the system.
   * When notification info is included, the gift card can be sent via email to recipients with personalized messaging.
   */
  wixGiftCardsGiftCardV1CreateGiftCard?: Maybe<WixGiftCardsGiftCardV1CreateGiftCardResponse>;
  /**
   * Disables a gift card, preventing it from being used for purchases.
   *
   * Use this method for customer service actions, fraud prevention, or when
   * gift cards need to be deactivated due to policy violations. Disabled
   * gift cards cannot be re-enabled and their balance becomes inaccessible.
   */
  wixGiftCardsGiftCardV1DisableGiftCard?: Maybe<WixGiftCardsGiftCardV1DisableGiftCardResponse>;
  wixGiftCardsGiftCardV1FulfillGiftCardOrder?: Maybe<Scalars['Void']>;
  /** Retrieves gift cards associated with a specific email address. */
  wixGiftCardsGiftCardV1ListGiftCardsByEmail?: Maybe<WixGiftCardsGiftCardV1ListGiftCardsByEmailResponse>;
  /**
   * Retrieves a list of gift cards that match the provided search options, paging, and filtering.
   *
   * Learn about working with [Search, Query and List Methods](https://dev.wix.com/docs/rest/articles/get-started/search-query-and-list-methods).
   */
  wixGiftCardsGiftCardV1SearchGiftCards?: Maybe<WixGiftCardsGiftCardV1SearchGiftCardsResponse>;
  /**
   * Sends a gift card notification email to the recipient.
   *
   * Use this method to deliver gift cards via email, either immediately after creation
   * or at a scheduled time. The recipient email can be specified in the request to
   * override the gift card's stored recipient information.
   *
   * > **Note:** Premium site is a requirement for this functionality.
   */
  wixGiftCardsGiftCardV1SendGiftCardEmail?: Maybe<Scalars['Void']>;
  /**
   * Creates a new OAuth app for a Wix Headless client.
   *
   * Use this API to enable headless functionality for a Wix site. An OAuth app allows external sites or apps to securely access your site's data and services using Wix APIs.
   */
  wixHeadlessV1CreateOAuthApp?: Maybe<WixHeadlessV1CreateOAuthAppResponse>;
  /**
   * Deletes an OAuth app by ID.
   *
   *
   * > **Note:** After you delete an OAuth app, an external client can no longer make API calls by authenticating with its client ID.
   */
  wixHeadlessV1DeleteOAuthApp?: Maybe<Scalars['Void']>;
  /**
   * Generates a secret for an existing OAuth app.
   *
   *
   * > **Note:** You can only generate a secret once for each OAuth app, and the secret can't be retrieved later. Store the secret securely.
   */
  wixHeadlessV1GenerateOAuthAppSecret?: Maybe<WixHeadlessV1GenerateOAuthAppSecretResponse>;
  wixHeadlessV1QueryOAuthApp?: Maybe<WixHeadlessV1QueryOAuthAppsResponse>;
  wixHeadlessV1SiteCloned?: Maybe<Scalars['Void']>;
  wixHeadlessV1SitePublished?: Maybe<Scalars['Void']>;
  /**
   * Updates an OAuth app.
   *
   *
   * Only fields provided in `mask.paths` are updated.
   *
   * You can update the following fields:
   * + `name`
   * + `description`
   * + `allowedDomain`
   * + `loginUrl`
   * + `logoutUrl`
   * + `technology`
   */
  wixHeadlessV1UpdateOAuthApp?: Maybe<WixHeadlessV1UpdateOAuthAppResponse>;
  /** Apply coupon to order */
  wixOnlineprogramsParticipantsV3ApplyCoupon?: Maybe<WixOnlineprogramsParticipantsV3ApplyCouponResponse>;
  /**
   * Bulk adds all site members to program, but not more then 1000.
   * Participant will be either created in state Joined, or updated to that state
   * from pending one.
   */
  wixOnlineprogramsParticipantsV3BulkAddAllToProgram?: Maybe<WixOnlineprogramsParticipantsV3BulkAddAllToProgramResponse>;
  /**
   * Bulk adds participants to program.
   * Participant will be either created in state Joined, or updated to that state
   * from pending one.
   */
  wixOnlineprogramsParticipantsV3BulkAddToProgram?: Maybe<WixOnlineprogramsParticipantsV3BulkAddToProgramResponse>;
  /**
   * Bulk approves all pending participants, who asked to join private program (aka
   * in state `APPROVAL_PENDING`).
   */
  wixOnlineprogramsParticipantsV3BulkApproveAllParticipant?: Maybe<WixOnlineprogramsParticipantsV3BulkApproveAllParticipantResponse>;
  /**
   * Bulk approves participants, who asked to join private program (aka in
   * state `APPROVAL_PENDING`). If participant was in other state, no effect and
   * error returned.
   */
  wixOnlineprogramsParticipantsV3BulkApproveParticipant?: Maybe<WixOnlineprogramsParticipantsV3BulkApproveParticipantResponse>;
  /** Create resolved steps in batches, needed for migration of participant steps from v1 */
  wixOnlineprogramsParticipantsV3BulkCreateResolvedStepMigration?: Maybe<WixOnlineprogramsParticipantsV3BulkCreateResolvedStepMigrationResponse>;
  /**
   * Bulk invites all participants to program, but not more then 1000.
   * For each member participant in Invited state is created.
   */
  wixOnlineprogramsParticipantsV3BulkInviteAllToProgram?: Maybe<WixOnlineprogramsParticipantsV3BulkInviteAllToProgramResponse>;
  /**
   * Bulk invites participants to program.
   * For each member participant in Invited state is created.
   */
  wixOnlineprogramsParticipantsV3BulkInviteToProgram?: Maybe<WixOnlineprogramsParticipantsV3BulkInviteToProgramResponse>;
  /** Complete participant */
  wixOnlineprogramsParticipantsV3CompleteParticipant?: Maybe<WixOnlineprogramsParticipantsV3CompleteParticipantResponse>;
  /** Handle events from benefits (settings of paid plan). */
  wixOnlineprogramsParticipantsV3ConsumeBenefitsEvents?: Maybe<Scalars['Void']>;
  wixOnlineprogramsParticipantsV3ConsumeParticipantsBulkCompleteEvent?: Maybe<Scalars['Void']>;
  wixOnlineprogramsParticipantsV3ConsumeParticipantsBulkDeleteEvent?: Maybe<Scalars['Void']>;
  /** Handle payment events. */
  wixOnlineprogramsParticipantsV3ConsumePaymentEvents?: Maybe<Scalars['Void']>;
  wixOnlineprogramsParticipantsV3DeleteAllParticipantResolvedSteps?: Maybe<WixOnlineprogramsParticipantsV3DeleteAllParticipantResolvedStepsResponse>;
  /**
   * Delete participant from program by owner will. Removes participant from member
   * group. Leaves him in Social Group.
   */
  wixOnlineprogramsParticipantsV3DeleteParticipant?: Maybe<Scalars['Void']>;
  /** Exports data about participants as well as resolved steps in program. */
  wixOnlineprogramsParticipantsV3ExportParticipantsStats?: Maybe<Scalars['Void']>;
  /** Get access status */
  wixOnlineprogramsParticipantsV3GetAccessStatus?: Maybe<WixOnlineprogramsParticipantsV3GetAccessStatusResponse>;
  /** Get program's completion stats */
  wixOnlineprogramsParticipantsV3GetCompletionStats?: Maybe<WixOnlineprogramsParticipantsV3GetCompletionStatsResponse>;
  /** Get premium stats */
  wixOnlineprogramsParticipantsV3GetPremiumStats?: Maybe<WixOnlineprogramsParticipantsV3GetPremiumStatsResponse>;
  /** Get summary about participants interacting with the program */
  wixOnlineprogramsParticipantsV3GetProgramSummaries?: Maybe<WixOnlineprogramsParticipantsV3GetProgramSummariesResponse>;
  wixOnlineprogramsParticipantsV3GetResolvedStep?: Maybe<WixOnlineprogramsParticipantsV3GetResolvedStepResponse>;
  /** Get statistics about participants interacting with the program */
  wixOnlineprogramsParticipantsV3GetStatistics?: Maybe<WixOnlineprogramsParticipantsV3GetStatisticsResponse>;
  /** Issue certificate by site admin */
  wixOnlineprogramsParticipantsV3IssueCertificate?: Maybe<WixOnlineprogramsParticipantsV3IssueCertificateResponse>;
  /**
   * Member joins the program. By the type of program, participant in corresponding
   * state will be created.
   */
  wixOnlineprogramsParticipantsV3JoinProgram?: Maybe<WixOnlineprogramsParticipantsV3JoinProgramResponse>;
  /** Participant leaves program. Entity will be deleted. Idempotent call. */
  wixOnlineprogramsParticipantsV3LeaveProgram?: Maybe<Scalars['Void']>;
  wixOnlineprogramsParticipantsV3ListResolvedSteps?: Maybe<WixOnlineprogramsParticipantsV3ListResolvedStepsResponse>;
  wixOnlineprogramsParticipantsV3QueryProgramSummaries?: Maybe<WixOnlineprogramsParticipantsV3QueryProgramSummariesResponse>;
  wixOnlineprogramsParticipantsV3QueryResolvedSteps?: Maybe<WixOnlineprogramsParticipantsV3QueryResolvedStepsResponse>;
  wixOnlineprogramsParticipantsV3ResolveStep?: Maybe<WixOnlineprogramsParticipantsV3ResolveStepResponse>;
  /** Remove coupon from order */
  wixOnlineprogramsParticipantsV3RevertCoupon?: Maybe<WixOnlineprogramsParticipantsV3RevertCouponResponse>;
  wixOnlineprogramsParticipantsV3UndoStep?: Maybe<Scalars['Void']>;
  /** Archives program */
  wixOnlineprogramsProgramsV3ArchiveProgram?: Maybe<WixOnlineprogramsProgramsV3ArchiveProgramResponse>;
  /** Internal endpoint to create program for data migration */
  wixOnlineprogramsProgramsV3BulkCreateProgramsMigration?: Maybe<WixOnlineprogramsProgramsV3BulkCreateProgramsMigrationResponse>;
  /** Update multiple Programs in a single request. Works synchronously. */
  wixOnlineprogramsProgramsV3BulkUpdatePrograms?: Maybe<WixOnlineprogramsProgramsV3BulkUpdateProgramsResponse>;
  /** Consumes meta site special events for service provisioning */
  wixOnlineprogramsProgramsV3ConsumeMetaSiteSpecialEvents?: Maybe<Scalars['Void']>;
  wixOnlineprogramsProgramsV3ConsumeSitePropertiesUpdatedEvents?: Maybe<Scalars['Void']>;
  wixOnlineprogramsProgramsV3ConsumeSiteSearchIndexingEvents?: Maybe<Scalars['Void']>;
  /** Counts programs matching the filter */
  wixOnlineprogramsProgramsV3CountPrograms?: Maybe<WixOnlineprogramsProgramsV3CountProgramsResponse>;
  /** Creates a Program. */
  wixOnlineprogramsProgramsV3CreateProgram?: Maybe<WixOnlineprogramsProgramsV3CreateProgramResponse>;
  /**
   * Deletes a Program.
   * Deleting a Program permanently removes them from the Program List.
   */
  wixOnlineprogramsProgramsV3DeleteProgram?: Maybe<Scalars['Void']>;
  /** Duplicates the Program. Leaves certificate template, but removes social group. */
  wixOnlineprogramsProgramsV3DuplicateProgram?: Maybe<WixOnlineprogramsProgramsV3DuplicateProgramResponse>;
  /** Ends program. */
  wixOnlineprogramsProgramsV3EndProgram?: Maybe<WixOnlineprogramsProgramsV3EndProgramResponse>;
  /** Get program membership for UoU. */
  wixOnlineprogramsProgramsV3GetProgramMembership?: Maybe<WixOnlineprogramsProgramsV3GetProgramMembershipResponse>;
  /** List program membership for UoU. */
  wixOnlineprogramsProgramsV3ListProgramMemberships?: Maybe<WixOnlineprogramsProgramsV3ListProgramMembershipsResponse>;
  /** Returns list of sample programs. */
  wixOnlineprogramsProgramsV3ListSamplePrograms?: Maybe<WixOnlineprogramsProgramsV3ListSampleProgramsResponse>;
  /** Publishes draft program. In other state returns program as is. */
  wixOnlineprogramsProgramsV3PublishProgram?: Maybe<WixOnlineprogramsProgramsV3PublishProgramResponse>;
  /** Retrieve program id given slug */
  wixOnlineprogramsProgramsV3ResolveProgramSlug?: Maybe<WixOnlineprogramsProgramsV3ResolveProgramSlugResponse>;
  /** Retrieves a list of programs according to search criteria */
  wixOnlineprogramsProgramsV3SearchPrograms?: Maybe<WixOnlineprogramsProgramsV3SearchProgramsResponse>;
  /** Updates a Program. */
  wixOnlineprogramsProgramsV3UpdateProgram?: Maybe<WixOnlineprogramsProgramsV3UpdateProgramResponse>;
  /** Clones all steps of prototype program */
  wixOnlineprogramsStepsV3BulkCloneStep?: Maybe<WixOnlineprogramsStepsV3BulkCloneStepResponse>;
  /** Creates steps in bulk. */
  wixOnlineprogramsStepsV3BulkCreateStep?: Maybe<WixOnlineprogramsStepsV3BulkCreateStepResponse>;
  /** Internal endpoint to create steps in bulk for migration. Need to supply full entities which will be inserted in db as is. */
  wixOnlineprogramsStepsV3BulkCreateStepMigration?: Maybe<WixOnlineprogramsStepsV3BulkCreateStepMigrationResponse>;
  /** Clone Step. */
  wixOnlineprogramsStepsV3CloneStep?: Maybe<WixOnlineprogramsStepsV3CloneStepResponse>;
  /** Creates a Step. */
  wixOnlineprogramsStepsV3CreateStep?: Maybe<WixOnlineprogramsStepsV3CreateStepResponse>;
  /** Delete all program steps */
  wixOnlineprogramsStepsV3DeleteAllProgramSteps?: Maybe<WixOnlineprogramsStepsV3DeleteAllProgramStepsResponse>;
  /**
   * Deletes a Step.
   * Deleting a Step permanently removes them from the Step List.
   */
  wixOnlineprogramsStepsV3DeleteStep?: Maybe<Scalars['Void']>;
  /** List all program steps without paging */
  wixOnlineprogramsStepsV3ListAllProgramSteps?: Maybe<WixOnlineprogramsStepsV3ListAllProgramStepsResponse>;
  /** Change Step position. */
  wixOnlineprogramsStepsV3MoveStep?: Maybe<WixOnlineprogramsStepsV3MoveStepResponse>;
  /** Query steps. */
  wixOnlineprogramsStepsV3QuerySteps?: Maybe<WixOnlineprogramsStepsV3QueryStepsResponse>;
  /** Query steps without paging */
  wixOnlineprogramsStepsV3QueryStepsWithoutPaging?: Maybe<WixOnlineprogramsStepsV3QueryStepsWithoutPagingResponse>;
  /** Update Step. */
  wixOnlineprogramsStepsV3UpdateStep?: Maybe<WixOnlineprogramsStepsV3UpdateStepResponse>;
  /**
   * Creates a PaymentAgreement.
   *
   * The request body must include lorem_uppercase and business address. Ipsum is optional.
   */
  wixPaymentsPaymentAgreementsV1CreatePaymentAgreement?: Maybe<WixPaymentsPaymentAgreementsV1CreatePaymentAgreementResponse>;
  /**
   * Deletes a PaymentAgreement.
   *
   *
   * Deleting a PaymentAgreement permanently removes them from the PaymentAgreement List.
   */
  wixPaymentsPaymentAgreementsV1DeletePaymentAgreement?: Maybe<Scalars['Void']>;
  /** Finalizes payment agreement. */
  wixPaymentsPaymentAgreementsV1FinalizePaymentAgreement?: Maybe<Scalars['Void']>;
  /** Updates extended fields of a PaymentAgreement without incrementing revision */
  wixPaymentsPaymentAgreementsV1UpdateExtendedFields?: Maybe<WixPaymentsPaymentAgreementsV1UpdateExtendedFieldsResponse>;
  /**
   * Updates a PaymentAgreement.
   *
   *
   * Each time the PaymentAgreement is updated,
   * `revision` increments by 1.
   * The current `revision` must be passed when updating the PaymentAgreement.
   * This ensures you're working with the latest PaymentAgreement
   * and prevents unintended overwrites.
   */
  wixPaymentsPaymentAgreementsV1UpdatePaymentAgreement?: Maybe<WixPaymentsPaymentAgreementsV1UpdatePaymentAgreementResponse>;
  /**
   * Creates a refund.
   *
   * The refunding process starts immediately after a refund entity is created.
   *
   * If you specify an `amount`, you must also specify a `currency_code`. This currency should be the same as the currency of the charge.
   * If `amount` and `currency_code` are not specified, the refund is created for the full charge amount. If the charge was already partially refunded, this refund will fail.
   */
  wixPaymentsRefundsV1CreateRefund?: Maybe<WixPaymentsRefundsV1CreateRefundResponse>;
  /**
   * @deprecated: Not accessible publicly.
   *
   * Calculates the refundability of a charge.
   */
  wixPaymentsRefundsV1GetRefundability?: Maybe<WixPaymentsRefundsV1GetRefundabilityResponse>;
  /**
   * Handles webhooks from PSP.
   * Called by payment-services-web when it receives a webhook.
   * Creates provider-initiated refund or updates existing refund.
   */
  wixPaymentsRefundsV1SyncRefund?: Maybe<WixPaymentsRefundsV1InternalSyncRefundResponse>;
  /** Updates the extended fields of a refund without incrementing the revision number. */
  wixPaymentsRefundsV1UpdateExtendedFields?: Maybe<WixPaymentsRefundsV1UpdateExtendedFieldsResponse>;
  /** Deletes SavedPaymentMethod by ID. */
  wixPaymentsSavedPaymentMethodsV1DeleteSavedPaymentMethod?: Maybe<Scalars['Void']>;
  wixPaymentsSavedPaymentMethodsV1FindSavedCreditCard?: Maybe<WixPaymentsSavedPaymentMethodsV1FindSavedCreditCardResponse>;
  /** Lists SavedPaymentMethods ordered by update date descending. */
  wixPaymentsSavedPaymentMethodsV1ListSavedPaymentMethods?: Maybe<WixPaymentsSavedPaymentMethodsV1ListSavedPaymentMethodsResponse>;
  /**
   * Marks SavedPaymentMethod as primary for site member who's the owner of this SavedPaymentMethod.
   * Primary SavedPaymentMethod is selected by default during the checkout.
   * For every site member there can be at most one primary SavedPaymentMethod,
   * so when one SavedPaymentMethod is marked as primary previous one is automatically unmarked.
   */
  wixPaymentsSavedPaymentMethodsV1MarkSavedPaymentMethodPrimary?: Maybe<Scalars['Void']>;
  /** Updates SavedPaymentMethod. Only fields listed in field_mask are updated. */
  wixPaymentsSavedPaymentMethodsV1UpdateSavedPaymentMethod?: Maybe<WixPaymentsSavedPaymentMethodsV1UpdateSavedPaymentMethodResponse>;
  /**
   * Creates a new SavedPaymentMethod or updates existing one if SavedPaymentMethod already exists for the same site member.
   * To check uniqueness SavedPaymentMethods are compared by credit card expiration year/month, last four digits and bin.
   * If sensitiveInfo.cardSensitiveInfo.temporaryToken was passed than service will eventually create a persi from it.
   */
  wixPaymentsSavedPaymentMethodsV1UpsertSavedPaymentMethod?: Maybe<WixPaymentsSavedPaymentMethodsV1UpsertSavedPaymentMethodResponse>;
  /**
   * Retrieves a list of payment method types.
   *
   * If an `ids` array is specified, only payment method types with matching IDs or legacy IDs are returned.
   * If no `ids` are specified, all payment method types available in the caller's country are returned, with some fields localized according to the caller's language and country.
   *
   * The caller's language and country are taken from the `languageCode` or `countryCode` parameters in the request.
   * If `languageCode` or `countryCode` are not specified, the values are taken from context of the call if possible. For example, if this method is called from a Wix site, the selected language on that site will be used.
   * If language or country can't be determined, the method doesn't perform any filtering or localization.
   *
   * Language and country are used to determine localized values for the `displayName`, `description` fields.
   * Country is used to determine localized values for the `priority` and `promoted` fields in `merchantFlow` and `buyerFlow`.
   * `currencyCode` is used to determine the eligibility of payment method types for the provided currency.
   */
  wixPaymentsSitePaymentMethodTypesV1ListSitePaymentMethodTypes?: Maybe<WixPaymentsSitePaymentMethodTypesV1ListSitePaymentMethodTypesResponse>;
  /** Consumes GenerateReceiptDocument events. */
  wixReceiptsV1ConsumeGenerateReceiptDocumentEvents?: Maybe<Scalars['Void']>;
  /** Consumes ReceiptDocumentHandled events. */
  wixReceiptsV1ConsumeReceiptDocumentHandledEvents?: Maybe<Scalars['Void']>;
  /** Consumes ReceiptNumberingProcess events. */
  wixReceiptsV1ConsumeReceiptNumberingProcessEvents?: Maybe<Scalars['Void']>;
  /**
   * Creates a receipt.
   *
   * Receipt number is assigned later and will be provided in the Get Receipt response.
   */
  wixReceiptsV1CreateReceipt?: Maybe<WixReceiptsV1CreateReceiptResponse>;
  /**
   * Retrieves the highest receipt number currently in use (the sequential identifier displayed between the prefix and suffix in receipt display numbers).
   * Can be filtered by prefix.
   *
   * Receipt numbering is managed in the Receipts Settings API.
   */
  wixReceiptsV1GetLatestReceiptNumber?: Maybe<WixReceiptsV1GetLatestReceiptNumberResponse>;
  /**
   * Retries generating a receipt document that has a `FAILED` status.
   *
   * Note that you can access a receipt document with an `AVAILABLE` status with the URL provided in `document.downloadUrl` without regenerating.
   */
  wixReceiptsV1RegenerateReceiptDocument?: Maybe<Scalars['Void']>;
  /**
   * Sends the receipt to the specified recipient in an email.
   *
   * Specifying a contact ID is required only when no contact ID was specified upon receipt creation.
   *
   * Note that if the specified contact ID doesn't have an associated email address, the call will fail.
   */
  wixReceiptsV1SendReceiptEmail?: Maybe<Scalars['Void']>;
  /** Updates extended fields of a receipt, without incrementing revision. */
  wixReceiptsV1UpdateExtendedFields?: Maybe<WixReceiptsV1UpdateExtendedFieldsResponse>;
  /** Receipts Management Backoffice */
  wixReceiptsV1UpdateReceipt?: Maybe<WixReceiptsV1BackofficeUpdateReceiptResponse>;
  /**
   * > **Note:** The Item Modifier API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Creates multiple item modifiers.
   */
  wixRestaurantsMenusItemModifierV1BulkCreateModifiers?: Maybe<WixRestaurantsMenusItemModifierV1BulkCreateModifiersResponse>;
  /**
   * > **Note:** The Item Modifier API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Deletes multiple item Modifiers at once.
   */
  wixRestaurantsMenusItemModifierV1BulkDeleteModifiers?: Maybe<WixRestaurantsMenusItemModifierV1BulkDeleteModifiersResponse>;
  /** update attached to orphan item */
  wixRestaurantsMenusItemModifierV1BulkUpdateAttachedToOrphanItem?: Maybe<WixRestaurantsMenusItemModifierV1BulkUpdateAttachedToOrphanItemResponse>;
  /** Update business location ids */
  wixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIds?: Maybe<WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsResponse>;
  /** update business location ids per entity */
  wixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsPerEntity?: Maybe<WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsPerEntityResponse>;
  /**
   * > **Note:** The Item modifier API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Updates multiple item modifiers at once.
   * Each time an item modifier is updated, its revision increments by 1. The existing revision must be included when updating the item modifier. This ensures you're working with the latest item modifier information, and prevents unintended overwrites.
   */
  wixRestaurantsMenusItemModifierV1BulkUpdateModifiers?: Maybe<WixRestaurantsMenusItemModifierV1BulkUpdateModifiersResponse>;
  /** Clone item modifiers from a different metasite. */
  wixRestaurantsMenusItemModifierV1CloneModifiers?: Maybe<Scalars['Void']>;
  wixRestaurantsMenusItemModifierV1ConsumeModifiersDomainEvents?: Maybe<Scalars['Void']>;
  /**
   * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves the number of modifiers that match a specified filter.
   *
   * If a filter isn't passed in the request, the endpoint returns the count of all modifiers.
   */
  wixRestaurantsMenusItemModifierV1CountModifiers?: Maybe<WixRestaurantsMenusItemModifierV1CountModifiersResponse>;
  /**
   * > **Note:** The Item Modifiers API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Creates an item modifier.
   *
   * To create multiple item modifiers at once, use [Bulk Create Modifiers](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item-modifiers/bulk-create-modifiers).
   */
  wixRestaurantsMenusItemModifierV1CreateModifier?: Maybe<WixRestaurantsMenusItemModifierV1CreateModifierResponse>;
  /**
   * > **Note:** The Item modifier API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   * Deletes an item modifier.
   */
  wixRestaurantsMenusItemModifierV1DeleteModifier?: Maybe<Scalars['Void']>;
  /**
   * > **Note:** The Item Modifier API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a list of up to 500 item modifiers.
   */
  wixRestaurantsMenusItemModifierV1ListModifiers?: Maybe<WixRestaurantsMenusItemModifierV1ListModifiersResponse>;
  /** Sync content to multilingual */
  wixRestaurantsMenusItemModifierV1SyncContentToMultilingual?: Maybe<Scalars['Void']>;
  /**
   * > **Note:** The Item Modifier API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Updates an item modifier.
   *
   * To update multiple item modifiers at once, use [Bulk Update Item Modifiers](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item-modifiers/bulk-update-modifiers).
   *
   * Each time an item modifier is updated, its revision increments by 1. The existing revision must be included when updating an item modifier. This ensures you're working with the latest item modifier information, and it prevents unintended overwrites.
   */
  wixRestaurantsMenusItemModifierV1UpdateModifier?: Maybe<WixRestaurantsMenusItemModifierV1UpdateModifierResponse>;
  /**
   * > **Note:** The Item Variants API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Creates multiple item variants.
   */
  wixRestaurantsMenusItemVariantV1BulkCreateVariants?: Maybe<WixRestaurantsMenusItemVariantV1BulkCreateVariantsResponse>;
  /**
   * > **Note:** The Item Variants API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Deletes multiple item variants at once.
   */
  wixRestaurantsMenusItemVariantV1BulkDeleteVariants?: Maybe<WixRestaurantsMenusItemVariantV1BulkDeleteVariantsResponse>;
  /** update attached to orphan item */
  wixRestaurantsMenusItemVariantV1BulkUpdateAttachedToOrphanItem?: Maybe<WixRestaurantsMenusItemVariantV1BulkUpdateAttachedToOrphanItemResponse>;
  /** update business location ids */
  wixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIds?: Maybe<WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsResponse>;
  /** update business location ids per entity */
  wixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsPerEntity?: Maybe<WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsPerEntityResponse>;
  /**
   * > **Note:** The Item Variants API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Updates multiple item variants.
   *
   * Each time an item variant is updated, its revision increments by 1. The existing revision must be included when updating variant. This ensures you're working with the latest item information, and it prevents unintended overwrites.
   *
   * Up to 100 item variants can be returned per request.
   */
  wixRestaurantsMenusItemVariantV1BulkUpdateVariants?: Maybe<WixRestaurantsMenusItemVariantV1BulkUpdateVariantsResponse>;
  /** Clone item variants from a different metasite. */
  wixRestaurantsMenusItemVariantV1CloneVariants?: Maybe<Scalars['Void']>;
  wixRestaurantsMenusItemVariantV1ConsumeVariantsDomainEvents?: Maybe<Scalars['Void']>;
  /**
   * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves the number of item variants that match a specified filter.
   *
   * If a filter isn't passed in the request, the endpoint returns the count of all item variants.
   */
  wixRestaurantsMenusItemVariantV1CountVariants?: Maybe<WixRestaurantsMenusItemVariantV1CountVariantsResponse>;
  /**
   * > **Note:** The Item Variants API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Creates an item variant.
   *
   * To create multiple item variants at once, use [Bulk Create Variants](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item-variant/bulk-create-variants).
   */
  wixRestaurantsMenusItemVariantV1CreateVariant?: Maybe<WixRestaurantsMenusItemVariantV1CreateVariantResponse>;
  /**
   * > **Note:** The Item Variants API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Permanently deletes an item variant.
   */
  wixRestaurantsMenusItemVariantV1DeleteVariant?: Maybe<Scalars['Void']>;
  /**
   * > **Note:** The Item Variants API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a list of up to 500 item variants.
   */
  wixRestaurantsMenusItemVariantV1ListVariants?: Maybe<WixRestaurantsMenusItemVariantV1ListVariantsResponse>;
  /**
   * > **Note:** The Item Variants API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Updates an item variant.
   *
   * To update multiple item variants at once, use [Bulk Update Variants](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item-variant/bulk-update-variants).
   *
   * Each time an item variant is updated, its revision increments by 1. The existing revision must be included when updating the variant. This ensures you're working with the latest variant information, and it prevents unintended overwrites.
   */
  wixRestaurantsMenusItemVariantV1UpdateVariant?: Maybe<WixRestaurantsMenusItemVariantV1UpdateVariantResponse>;
  /** Adds up to 500 modifier IDs to a modifier group, bypassing the standard modifier list limits. */
  wixRestaurantsMenusV1AddModifiersToGroupUnlimited?: Maybe<WixRestaurantsMenusV1AddModifiersToGroupUnlimitedResponse>;
  /**
   * > **Note:** The Item Modifier Groups API only works with the Wix Restaurants Menus (New) app. Make sure you downloaded this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Creates multiple modifier groups.
   */
  wixRestaurantsMenusV1BulkCreateModifierGroups?: Maybe<WixRestaurantsMenusV1BulkCreateModifierGroupsResponse>;
  wixRestaurantsMenusV1BulkDeleteModifierGroups?: Maybe<WixRestaurantsMenusV1BulkDeleteModifierGroupsResponse>;
  /** update attached to orphan item */
  wixRestaurantsMenusV1BulkUpdateAttachedToOrphanItem?: Maybe<WixRestaurantsMenusV1BulkUpdateAttachedToOrphanItemResponse>;
  /** update business location ids */
  wixRestaurantsMenusV1BulkUpdateBusinessLocationIds?: Maybe<WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsResponse>;
  /** update business location ids per entity */
  wixRestaurantsMenusV1BulkUpdateBusinessLocationIdsPerEntity?: Maybe<WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsPerEntityResponse>;
  /**
   * > **Note:** The Item Modifier Groups API only works with the Wix Restaurants Menus (New) app. Make sure you downloaded this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Updates multiple item modifier groups at once. This function supports partial updates.
   * Each time a modifier group is updated, its revision increments by 1. The existing revision must be included when updating an item modifier group. This ensures you're working with the latest item information, and prevents unintended overwrites.
   * Up to 100 modifier groups can be returned per request.
   */
  wixRestaurantsMenusV1BulkUpdateModifierGroups?: Maybe<WixRestaurantsMenusV1BulkUpdateModifierGroupsResponse>;
  /** Clone modifier groups from a different metasite. */
  wixRestaurantsMenusV1CloneModifierGroups?: Maybe<Scalars['Void']>;
  wixRestaurantsMenusV1ConsumeDeleteLocationIdsFromModifiers?: Maybe<Scalars['Void']>;
  wixRestaurantsMenusV1ConsumeModifierGroupsDomainEvents?: Maybe<Scalars['Void']>;
  /**
   * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves the number of modifier groups that match a specified filter.
   *
   * If a filter isn't passed in the request, the endpoint returns the count of all modifier groups.
   */
  wixRestaurantsMenusV1CountModifierGroups?: Maybe<WixRestaurantsMenusV1CountModifierGroupsResponse>;
  /**
   * > **Note:** The Item Modifier Groups API only works with the Wix Restaurants Menus (New) app. Make sure you downloaded this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Creates a modifier group.
   *
   * To create multiple modifier groups at once, use [Bulk Create Modifiers](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item-modifier-groups/bulk-create-modifier-groups).
   */
  wixRestaurantsMenusV1CreateModifierGroup?: Maybe<WixRestaurantsMenusV1CreateModifierGroupResponse>;
  /**
   * > **Note:** The Item Modifier Groups API only works with the Wix Restaurants Menus (New) app. Make sure you downloaded this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Deletes a modifier group.
   */
  wixRestaurantsMenusV1DeleteModifierGroup?: Maybe<Scalars['Void']>;
  /**
   * > **Note:** The Item Modifier Groups API only works with the Wix Restaurants Menus (New) app. Make sure you downloaded this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a list of up to 500 modifier groups.
   */
  wixRestaurantsMenusV1ListModifierGroups?: Maybe<WixRestaurantsMenusV1ListModifierGroupResponse>;
  /** Sync content to multilingual */
  wixRestaurantsMenusV1SyncContentToMultilingual?: Maybe<Scalars['Void']>;
  /**
   * > **Note:** The Item Modifier Groups API only works with the Wix Restaurants Menus (New) app. Make sure you downloaded this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Updates a modifier group.
   *
   * Each time a modifier group is updated, its revision increments by 1. The existing revision must be included when updating the modifier group. This ensures you're working with the latest modifier group information, and it prevents unintended overwrites.
   */
  wixRestaurantsMenusV1UpdateModifierGroup?: Maybe<WixRestaurantsMenusV1UpdateModifierGroupResponse>;
  /** Add a new CustomerReference to an existing wallet. */
  wixRiseV1AddCustomerReference?: Maybe<WixRiseV1AddCustomerReferenceResponse>;
  /**
   * Creates multiple transactions for a single gift card in bulk.
   * All transactions must have the same operation type (either all ADD or all SUBTRACT).
   * Must be used for migration purposes only.
   * If any transaction fails, the entire request fails.
   */
  wixRiseV1BulkCreateMigrationTransactions?: Maybe<WixRiseV1BulkCreateMigrationTransactionsResponse>;
  /**
   * Create multiple wallet actions in bulk for specific gift card id. Must be used for migration purposes only.
   * This endpoint processes wallet actions in batches, creating transactions and scheduling
   * as needed.
   */
  wixRiseV1BulkCreateMigrationWalletActions?: Maybe<WixRiseV1BulkCreateMigrationWalletActionsResponse>;
  wixRiseV1BulkDeleteGiftCardsByFilter?: Maybe<WixRiseV1BulkDeleteGiftCardsByFilterResponse>;
  /**
   * End wallet actions in bulk. Must be used for migration purposes only.
   * This endpoint processes wallet actions in batches, creating end transactions and wallet actions.
   */
  wixRiseV1BulkEndMigrationWalletActions?: Maybe<WixRiseV1BulkEndMigrationWalletActionsResponse>;
  /**
   * Synchronously update tags on multiple Wallet-Actions, by list of Wallet-Actions ids
   * A tag that appears both in the list of assign and unassign tags, will be assigned
   */
  wixRiseV1BulkUpdateWalletActionTags?: Maybe<WixRiseV1BulkUpdateWalletActionTagsResponse>;
  /**
   * Asynchronously update tags on multiple Wallet-Actions, by provided filter
   * An empty filter will update all Wallet-Actions
   * A tag that appears both in the list of assign and unassign tags, will be assigned
   */
  wixRiseV1BulkUpdateWalletActionTagsByFilter?: Maybe<WixRiseV1BulkUpdateWalletActionTagsByFilterResponse>;
  wixRiseV1ConsumeGiftCardEvent?: Maybe<Scalars['Void']>;
  /** Consumes WalletAction wallet_actions, creating matching BI wallet_actions. */
  wixRiseV1ConsumeWalletActionEvent?: Maybe<Scalars['Void']>;
  wixRiseV1ConsumeWalletEvent?: Maybe<Scalars['Void']>;
  /**
   * TODO: change to Rise domain when it's ready
   * Count GiftCards that match the given [API Query Language](https://platform.rise.ai/docs/#tag/About-API-Query-Language) filter.
   */
  wixRiseV1CountGiftCards?: Maybe<WixRiseV1CountGiftCardsResponse>;
  /** Count wallets based on the given filter. */
  wixRiseV1CountWallets?: Maybe<WixRiseV1CountWalletsResponse>;
  /**
   * Creates a new CustomerReference.
   * - If a wallet with the provided email address already exists - adds the customer reference to the wallet.
   * - If a wallet with the provided email address doesn't exist - creates a new wallet with the provided customer reference.
   */
  wixRiseV1CreateCustomerReference?: Maybe<WixRiseV1CreateCustomerReferenceResponse>;
  /** Creates a new GiftCard. */
  wixRiseV1CreateGiftCard?: Maybe<WixRiseV1CreateGiftCardResponse>;
  /** Creates a gift card. Must be used for migration purposes only. */
  wixRiseV1CreateMigrationGiftCard?: Maybe<WixRiseV1CreateMigrationGiftCardResponse>;
  /** Creates a transaction associated with some gift card. Must be used for migration purposes only. */
  wixRiseV1CreateMigrationTransaction?: Maybe<WixRiseV1CreateMigrationTransactionResponse>;
  /** Create a wallet action. Must be used for migration purposes only. */
  wixRiseV1CreateMigrationWalletAction?: Maybe<WixRiseV1CreateMigrationWalletActionResponse>;
  /** Creates a new Wallet. */
  wixRiseV1CreateWallet?: Maybe<WixRiseV1CreateWalletResponse>;
  /** Creates a new WalletAction. */
  wixRiseV1CreateWalletAction?: Maybe<WixRiseV1CreateWalletActionResponse>;
  /**
   * Creates a new WalletAction by customer reference instead of wallet ID.
   * If the customer already has a wallet, the action will be created on that wallet.
   * If the customer does not have a wallet, a new wallet will be created for them.
   */
  wixRiseV1CreateWalletActionByCustomerReference?: Maybe<WixRiseV1CreateWalletActionByCustomerReferenceResponse>;
  /** V2 of Creating a new Wallet. */
  wixRiseV1CreateWalletV2?: Maybe<WixRiseV1CreateWalletV2Response>;
  /** Subtracts from the GiftCard balance and creates a balance Transaction. */
  wixRiseV1DecreaseBalance?: Maybe<WixRiseV1DecreaseBalanceResponse>;
  /** Delete a CustomerReference. The customer reference is identified by source (i.e. source channel, tenant, and customer IDs). */
  wixRiseV1DeleteCustomerReference?: Maybe<Scalars['Void']>;
  /** Delete a WalletAction. Only available for walletActions that are not active. */
  wixRiseV1DeleteWalletAction?: Maybe<Scalars['Void']>;
  /** Disable a GiftCard. It cannot be re-enabled. */
  wixRiseV1DisableGiftCard?: Maybe<WixRiseV1DisableGiftCardResponse>;
  /** Disable a WalletAction immediately and deduct the remaining balance from the wallet. */
  wixRiseV1DisableWalletAction?: Maybe<WixRiseV1DisableWalletActionResponse>;
  /** End a migration wallet action that should be expired or disabled. */
  wixRiseV1EndMigrationWalletAction?: Maybe<WixRiseV1EndMigrationWalletActionResponse>;
  /** Get a CustomerReference by source (i.e. source channel, tenant, and customer IDs). */
  wixRiseV1GetCustomerReference?: Maybe<WixRiseV1GetCustomerReferenceResponse>;
  /** Get a GiftCard by ID using consistent read. */
  wixRiseV1GetGiftCardConsistent?: Maybe<WixRiseV1GetGiftCardConsistentResponse>;
  /**
   * Retrieves or creates a Wallet for the provided customer reference.
   *
   * - In case the Wallet doesn't exist - creates a new Wallet with the provided customer reference.
   * - In case the Wallet already exists - returns the existing Wallet.
   * - If the provided customer reference doesn't exist yet - adds it to the wallet.
   * - If the provided customer reference already exists - doesn't update anything.
   */
  wixRiseV1GetOrCreateWallet?: Maybe<WixRiseV1GetOrCreateWalletResponse>;
  /**
   * Retrieves or creates a Wallet.
   * - In case the Wallet doesn't exist - creates a new Wallet with 0 balance based on the provided Contact Details.
   * - In case the Wallet already exists - returns the existing Wallet.
   * - If the provided customer reference doesn't exist yet - adds it to the wallet.
   * - If the provided customer reference already exists - doesn't update anything.
   */
  wixRiseV1GetOrCreateWalletV2?: Maybe<WixRiseV1GetOrCreateWalletV2Response>;
  wixRiseV1GetRefundableAmounts?: Maybe<WixRiseV1GetRefundableAmountsResponse>;
  /** Get a Wallet by ID, email, or a customer reference in the wallet. */
  wixRiseV1GetWallet?: Maybe<WixRiseV1GetWalletResponse>;
  /** Get a Wallet's Gift Card by ID, email, or a customer reference in the wallet. */
  wixRiseV1GetWalletGiftCard?: Maybe<WixRiseV1GetWalletGiftCardResponse>;
  /** Get a Wallet by ID, email, or a customer reference in the wallet. */
  wixRiseV1GetWalletV2?: Maybe<WixRiseV1GetWalletV2Response>;
  /** Handle wallet_action expiration tasks from TimeCapsule. */
  wixRiseV1HandleEvenExpirationTask?: Maybe<Scalars['Void']>;
  /** Handle wallet_action start tasks from TimeCapsule. */
  wixRiseV1HandleEvenStartTask?: Maybe<Scalars['Void']>;
  /** Handles WalletAction wallet_actions, creating matching BI wallet_actions. */
  wixRiseV1HandleWalletActionEvent?: Maybe<Scalars['Void']>;
  /** Adds to the GiftCard balance and creates a balance Transaction. */
  wixRiseV1IncreaseBalance?: Maybe<WixRiseV1IncreaseBalanceResponse>;
  /**
   * Creates a new WalletAction by one of the following identifiers:
   * contact details, customer reference, wallet id.
   * If the customer already has a wallet, the action will be created on that wallet.
   * If the customer does not have a wallet, a new wallet will be created for them.
   */
  wixRiseV1IssueStoreCredit?: Maybe<WixRiseV1IssueStoreCreditResponse>;
  /** Migrate a new wallet */
  wixRiseV1MigrateWallet?: Maybe<WixRiseV1MigrateWalletResponse>;
  /**
   * Re-triggers Transaction Added Action event
   * [For Internal Rise use only, use with caution]
   */
  wixRiseV1ProduceTransactionAddedEvent?: Maybe<Scalars['Void']>;
  /** Query GiftCards using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) */
  wixRiseV1QueryGiftCards?: Maybe<WixRiseV1QueryGiftCardsResponse>;
  /** Query Transactions using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) */
  wixRiseV1QueryTransactions?: Maybe<WixRiseV1QueryTransactionsResponse>;
  wixRiseV1QueryTransactionsInternal?: Maybe<WixRiseV1QueryTransactionsInternalResponse>;
  /**
   * Query wallet actions that have not been entirely redeemed using [API Query Language](https://platform.rise.ai/docs/#tag/About-API-Query-Language).
   * Results are enriched with the remaining balance of each wallet action.
   * Note:
   * The returned result may contain fewer items than the requested page limit—or even be empty—while still providing a next cursor, because of in memory filtering.
   * Always check the next cursor to determine if there are more items to fetch.
   */
  wixRiseV1QueryUnredeemedWalletActions?: Maybe<WixRiseV1QueryUnredeemedWalletActionsResponse>;
  /** Query WalletActions using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) */
  wixRiseV1QueryWalletActions?: Maybe<WixRiseV1QueryWalletActionResponse>;
  /**
   * Query all WalletActions using [API Query Language](https://platform.rise.ai/docs/#tag/About-API-Query-Language).
   * Results are enriched with the remaining balance of each WalletAction.
   */
  wixRiseV1QueryWalletActionsBalances?: Maybe<WixRiseV1QueryWalletActionBalancesResponse>;
  /**
   * Query wallets by contact using [API Query Language](https://platform.rise.ai/docs/#tag/About-API-Query-Language).
   * The result is a list of wallets with gift card and contact information.
   */
  wixRiseV1QueryWalletsByContact?: Maybe<WixRiseV1QueryWalletsByContactResponse>;
  wixRiseV1RefundTransaction?: Maybe<Scalars['Void']>;
  /** Regenerates the code of a GiftCard. */
  wixRiseV1RegenerateCode?: Maybe<WixRiseV1RegenerateCodeResponse>;
  /** Search for GiftCards by field. */
  wixRiseV1SearchGiftCards?: Maybe<WixRiseV1SearchGiftCardsResponse>;
  /** Update PII of a CustomerReference. The customer reference is identified by rise ID or source (i.e. source channel, tenant, and customer IDs). */
  wixRiseV1UpdateCustomerReference?: Maybe<WixRiseV1UpdateCustomerReferenceResponse>;
  /**
   * Update a GiftCard, supports partial update.
   * Pass the latest `revision` for a successful update.
   */
  wixRiseV1UpdateGiftCard?: Maybe<WixRiseV1UpdateGiftCardResponse>;
  wixRiseV1UpdateLastActivityForReminders?: Maybe<WixRiseV1UpdateLastActivityForRemindersResponse>;
  /**
   * Update a WalletAction, supports partial update.
   * Pass the latest `revision` for a successful update.
   */
  wixRiseV1UpdateWalletAction?: Maybe<WixRiseV1UpdateWalletActionResponse>;
  wixRiseV1VoidTransaction?: Maybe<WixRiseV1VoidTransactionResponse>;
  /** Creates a Workflow. */
  wixRiseWorkflowV1CreateWorkflow?: Maybe<WixRiseWorkflowV1CreateWorkflowResponse>;
  /** Deletes a Workflow. */
  wixRiseWorkflowV1DeleteWorkflow?: Maybe<Scalars['Void']>;
  /** Retrieves a list of Workflows, given the provided [paging, filtering, and sorting][1]. */
  wixRiseWorkflowV1ListTriggers?: Maybe<WixRiseWorkflowV1ListTriggersResponse>;
  /** Report a Trigger. */
  wixRiseWorkflowV1ReportTrigger?: Maybe<Scalars['Void']>;
  /**
   * Updates a Workflow.
   *
   * Each time the Workflow is updated,
   * `revision` increments by 1.
   * The current `revision` must be passed when updating the Workflow.
   * This ensures you're working with the latest Workflow
   * and prevents unintended overwrites.
   */
  wixRiseWorkflowV1UpdateWorkflow?: Maybe<WixRiseWorkflowV1UpdateWorkflowResponse>;
};


export type MutationComWixBookingsSchedulesApiV1CacheArgs = {
  input?: InputMaybe<WixBookingsCalendarV2CacheRequestInput>;
};


export type MutationComWixBookingsSchedulesApiV1CreateSessionArgs = {
  input?: InputMaybe<ComWixBookingsSchedulesVeloV2CreateSessionRequestInput>;
};


export type MutationComWixBookingsSchedulesApiV1DeleteSessionArgs = {
  input?: InputMaybe<ComWixBookingsSchedulesVeloV2DeleteSessionRequestInput>;
};


export type MutationComWixBookingsSchedulesApiV1GetCacheInfoArgs = {
  input?: InputMaybe<WixBookingsCalendarV2GetCacheInfoRequestInput>;
};


export type MutationComWixBookingsSchedulesApiV1HandleFeedMessageArgs = {
  input?: InputMaybe<WixBookingsCalendarfeedV2FeedEventInput>;
};


export type MutationComWixBookingsSchedulesApiV1HandleFeedReplayMessageArgs = {
  input?: InputMaybe<WixBookingsCalendarfeedV2FeedReplayEventInput>;
};


export type MutationComWixBookingsSchedulesApiV1ListSessionsArgs = {
  input?: InputMaybe<WixBookingsCalendarV2ListSessionsRequestInput>;
};


export type MutationComWixBookingsSchedulesApiV1QueryEventSessionInstancesArgs = {
  input?: InputMaybe<WixBookingsCalendarV2QueryEventSessionInstancesRequestInput>;
};


export type MutationComWixBookingsSchedulesApiV1ShortenCacheArgs = {
  input?: InputMaybe<WixBookingsCalendarV2ShortenCacheRequestInput>;
};


export type MutationComWixBookingsSchedulesApiV1UncacheArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixBookingsSchedulesApiV1UpdateSessionArgs = {
  input?: InputMaybe<ComWixBookingsSchedulesVeloV2UpdateSessionRequestInput>;
};


export type MutationComWixEcomDiscountsConsumeLocaleCreatedArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixEcomDiscountsConsumeOrderPaidArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixEcomDiscountsCreateDiscountRuleArgs = {
  input?: InputMaybe<ComWixEcomDiscountsCreateDiscountRuleRequestInput>;
};


export type MutationComWixEcomDiscountsDeleteDiscountRuleArgs = {
  input?: InputMaybe<ComWixEcomDiscountsDeleteDiscountRuleRequestInput>;
};


export type MutationComWixEcomDiscountsGetAppliedDiscountsArgs = {
  input?: InputMaybe<ComWixEcomDiscountsGetAppliedDiscountsRequestInput>;
};


export type MutationComWixEcomDiscountsUpdateDiscountRuleArgs = {
  input?: InputMaybe<ComWixEcomDiscountsUpdateDiscountRuleRequestInput>;
};


export type MutationComWixEcomOrdersBillingV1AuthorizeChargeWithSavedPaymentMethodArgs = {
  input?: InputMaybe<ComWixEcomOrdersBillingV1AuthorizeChargeWithSavedPaymentMethodRequestInput>;
};


export type MutationComWixEcomOrdersBillingV1AuthorizePaymentWithSavedPaymentMethodArgs = {
  input?: InputMaybe<ComWixEcomOrdersBillingV1AuthorizePaymentWithSavedPaymentMethodRequestInput>;
};


export type MutationComWixEcomOrdersBillingV1CalculateRefundArgs = {
  input?: InputMaybe<ComWixEcomOrdersBillingV1CalculateRefundRequestInput>;
};


export type MutationComWixEcomOrdersBillingV1CaptureAuthorizedPaymentsArgs = {
  input?: InputMaybe<ComWixEcomOrdersBillingV1CaptureAuthorizedPaymentsRequestInput>;
};


export type MutationComWixEcomOrdersBillingV1GenerateReceiptsArgs = {
  input?: InputMaybe<ComWixEcomOrdersBillingV1GenerateReceiptsRequestInput>;
};


export type MutationComWixEcomOrdersBillingV1GetOrderRefundabilityArgs = {
  input?: InputMaybe<ComWixEcomOrdersBillingV1GetOrderRefundabilityRequestInput>;
};


export type MutationComWixEcomOrdersBillingV1GetRefundOptionsArgs = {
  input?: InputMaybe<ComWixEcomOrdersBillingV1GetRefundOptionsRequestInput>;
};


export type MutationComWixEcomOrdersBillingV1RedeemGiftCardArgs = {
  input?: InputMaybe<ComWixEcomOrdersBillingV1RedeemGiftCardRequestInput>;
};


export type MutationComWixEcomOrdersBillingV1RefundPaymentsArgs = {
  input?: InputMaybe<ComWixEcomOrdersBillingV1RefundPaymentsRequestInput>;
};


export type MutationComWixEcomOrdersBillingV1VoidAuthorizedPaymentsArgs = {
  input?: InputMaybe<ComWixEcomOrdersBillingV1VoidAuthorizedPaymentsRequestInput>;
};


export type MutationComWixEcomOrdersFulfillmentsV1BulkCreateFulfillmentArgs = {
  input?: InputMaybe<ComWixEcomOrdersFulfillmentsV1BulkCreateFulfillmentRequestInput>;
};


export type MutationComWixEcomOrdersFulfillmentsV1CreateFulfillmentArgs = {
  input?: InputMaybe<ComWixEcomOrdersFulfillmentsV1CreateFulfillmentRequestInput>;
};


export type MutationComWixEcomOrdersFulfillmentsV1DeleteFulfillmentArgs = {
  input?: InputMaybe<ComWixEcomOrdersFulfillmentsV1DeleteFulfillmentRequestInput>;
};


export type MutationComWixEcomOrdersFulfillmentsV1ListFulfillmentsForMultipleOrdersArgs = {
  input?: InputMaybe<ComWixEcomOrdersFulfillmentsV1ListFulfillmentsForMultipleOrdersRequestInput>;
};


export type MutationComWixEcomOrdersFulfillmentsV1ListFulfillmentsForSingleOrderArgs = {
  input?: InputMaybe<ComWixEcomOrdersFulfillmentsV1ListFulfillmentsForSingleOrderRequestInput>;
};


export type MutationComWixEcomOrdersFulfillmentsV1UpdateFulfillmentArgs = {
  input?: InputMaybe<ComWixEcomOrdersFulfillmentsV1UpdateFulfillmentRequestInput>;
};


export type MutationComWixEcomOrdersInvoicesV1AddInvoiceToOrderArgs = {
  input?: InputMaybe<ComWixEcomOrdersInvoicesV1AddInvoiceToOrderRequestInput>;
};


export type MutationComWixEcomOrdersInvoicesV1BulkGenerateInvoicesArgs = {
  input?: InputMaybe<ComWixEcomOrdersInvoicesV1BulkGenerateInvoicesRequestInput>;
};


export type MutationComWixEcomOrdersInvoicesV1ConsumeOrderDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixEcomOrdersInvoicesV1GenerateInvoiceArgs = {
  input?: InputMaybe<ComWixEcomOrdersInvoicesV1GenerateInvoiceRequestInput>;
};


export type MutationComWixEcomOrdersInvoicesV1GenerateInvoiceWithNumberArgs = {
  input?: InputMaybe<ComWixEcomOrdersInvoicesV1GenerateInvoiceWithNumberRequestInput>;
};


export type MutationComWixEcomOrdersInvoicesV1GetOrderInvoiceArgs = {
  input?: InputMaybe<ComWixEcomOrdersInvoicesV1GetOrderInvoiceRequestInput>;
};


export type MutationComWixEcomOrdersInvoicesV1ListInvoicesForMultipleOrdersArgs = {
  input?: InputMaybe<ComWixEcomOrdersInvoicesV1ListInvoicesForMultipleOrdersRequestInput>;
};


export type MutationComWixEcomOrdersInvoicesV1ListInvoicesForMultipleOrdersOldArgs = {
  input?: InputMaybe<ComWixEcomOrdersInvoicesV1ListInvoicesForMultipleOrdersRequestInput>;
};


export type MutationComWixEcomOrdersInvoicesV1ListInvoicesForSingleOrderArgs = {
  input?: InputMaybe<ComWixEcomOrdersInvoicesV1ListInvoicesForSingleOrderRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1AddChargebackArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1AddChargebackRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1AddInvoiceToOrderArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1AddInvoiceToOrderRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1AddPaymentsArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1AddPaymentsRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1AddRefundArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1AddRefundRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1BulkGenerateInvoicesArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1BulkGenerateInvoicesRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1BulkUpdatePaymentStatusesArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1BulkUpdatePaymentStatusesRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1CalculateRefundArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1CalculateRefundRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1GenerateInvoiceArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1GenerateInvoiceRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1GetRefundabilityStatusArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1GetRefundabilityStatusRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1ListInvoicesForMultipleOrdersArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1ListInvoicesForMultipleOrdersRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1ListInvoicesForMultipleOrdersOldArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1ListInvoicesForMultipleOrdersRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1ListInvoicesForSingleOrderArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1ListInvoicesForSingleOrderRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1ListTransactionsForMultipleOrdersArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1ListTransactionsForMultipleOrdersRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1ListTransactionsForSingleOrderArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1ListTransactionsForSingleOrderRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1ReverseChargebackArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1ReverseChargebackRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1SearchOrderTransactionsArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1SearchOrderTransactionsRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1TriggerRefundArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1TriggerRefundRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1UpdateChargebackArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1UpdateChargebackRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1UpdatePaymentStatusArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1UpdatePaymentStatusRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1UpdatePaymentsArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1UpdatePaymentsRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1UpdateRefundArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1UpdateRefundRequestInput>;
};


export type MutationComWixEcomOrdersPaymentsV1UpdateRefundTransactionArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsV1UpdateRefundTransactionRequestInput>;
};


export type MutationComWixEcomOrdersV1AddActivitiesArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1AddActivitiesRequestInput>;
};


export type MutationComWixEcomOrdersV1AddActivityArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1AddActivityRequestInput>;
};


export type MutationComWixEcomOrdersV1AddInternalActivityArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1AddInternalActivityRequestInput>;
};


export type MutationComWixEcomOrdersV1AggregateOrdersArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1AggregateOrdersRequestInput>;
};


export type MutationComWixEcomOrdersV1ArchiveOrderArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1ArchiveOrderRequestInput>;
};


export type MutationComWixEcomOrdersV1BulkArchiveOrdersArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1BulkArchiveOrdersRequestInput>;
};


export type MutationComWixEcomOrdersV1BulkArchiveOrdersByFilterArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1BulkArchiveOrdersByFilterRequestInput>;
};


export type MutationComWixEcomOrdersV1BulkDeleteImportedOrdersArgs = {
  input?: InputMaybe<ComWixEcomOrdersImporterV1BulkDeleteImportedOrdersRequestInput>;
};


export type MutationComWixEcomOrdersV1BulkMarkAsFulfilledArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1BulkMarkAsFulfilledRequestInput>;
};


export type MutationComWixEcomOrdersV1BulkMarkAsFulfilledByFilterArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1BulkMarkAsFulfilledByFilterRequestInput>;
};


export type MutationComWixEcomOrdersV1BulkMarkAsUnfulfilledArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1BulkMarkAsUnfulfilledRequestInput>;
};


export type MutationComWixEcomOrdersV1BulkMarkAsUnfulfilledByFilterArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1BulkMarkAsUnfulfilledByFilterRequestInput>;
};


export type MutationComWixEcomOrdersV1BulkMarkOrdersAsPaidArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1BulkMarkOrdersAsPaidRequestInput>;
};


export type MutationComWixEcomOrdersV1BulkSendBuyerPickupConfirmationEmailsArgs = {
  input?: InputMaybe<ComWixEcomOrdersNotificationsV1BulkSendBuyerPickupConfirmationEmailsRequestInput>;
};


export type MutationComWixEcomOrdersV1BulkSendBuyerShippingConfirmationEmailsArgs = {
  input?: InputMaybe<ComWixEcomOrdersNotificationsV1BulkSendBuyerShippingConfirmationEmailsRequestInput>;
};


export type MutationComWixEcomOrdersV1BulkSetBusinessLocationArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1BulkSetBusinessLocationRequestInput>;
};


export type MutationComWixEcomOrdersV1BulkUnArchiveOrdersArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1BulkUnArchiveOrdersRequestInput>;
};


export type MutationComWixEcomOrdersV1BulkUnArchiveOrdersByFilterArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1BulkUnArchiveOrdersByFilterRequestInput>;
};


export type MutationComWixEcomOrdersV1BulkUpdateOrderArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1BulkUpdateOrderRequestInput>;
};


export type MutationComWixEcomOrdersV1BulkUpdateOrderTagsArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1BulkUpdateOrderTagsRequestInput>;
};


export type MutationComWixEcomOrdersV1BulkUpdateOrdersArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1BulkUpdateOrdersRequestInput>;
};


export type MutationComWixEcomOrdersV1CalculateRefundArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundRequestInput>;
};


export type MutationComWixEcomOrdersV1CalculateRefundV1Args = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundV1RequestInput>;
};


export type MutationComWixEcomOrdersV1CalculateRefundV2Args = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundV2RequestInput>;
};


export type MutationComWixEcomOrdersV1CanMigrateArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixEcomOrdersV1CancelOrderArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1CancelOrderRequestInput>;
};


export type MutationComWixEcomOrdersV1CaptureAuthorizedPaymentArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1CaptureAuthorizedPaymentRequestInput>;
};


export type MutationComWixEcomOrdersV1CaptureAuthorizedPaymentsArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1CaptureAuthorizedPaymentsRequestInput>;
};


export type MutationComWixEcomOrdersV1ChargeMembershipsArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1ChargeMembershipsRequestInput>;
};


export type MutationComWixEcomOrdersV1ChargeSavedPaymentMethodArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1ChargeSavedPaymentMethodRequestInput>;
};


export type MutationComWixEcomOrdersV1CommitDeltasArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1CommitDeltasRequestInput>;
};


export type MutationComWixEcomOrdersV1ConsumeBiAnalyticsTransactionSourceEventsArgs = {
  input?: InputMaybe<GoogleProtobufStructInput>;
};


export type MutationComWixEcomOrdersV1ConsumeBiTransactionSourceEventsArgs = {
  input?: InputMaybe<ComWixpressBiOctopusApiV1BiEventInput>;
};


export type MutationComWixEcomOrdersV1ConsumeBiTransactionSourceReviveEventsArgs = {
  input?: InputMaybe<ComWixpressBiOctopusApiV1BiEventInput>;
};


export type MutationComWixEcomOrdersV1ConsumeFileDescriptorEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixEcomOrdersV1ConsumeFulfillmentEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixEcomOrdersV1ConsumeFulfillmentWrapperEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixEcomOrdersV1ConsumeGiftCardTransactionVoidedV1Args = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixEcomOrdersV1ConsumeInternalSideEffectsProduceDomainEventsArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1PaymentStatusUpdatedInput>;
};


export type MutationComWixEcomOrdersV1ConsumeInvoicePaidEventArgs = {
  input?: InputMaybe<ComWixpressQuotesApiEventsInvoicePaidEventInput>;
};


export type MutationComWixEcomOrdersV1ConsumeInvoiceSentEventArgs = {
  input?: InputMaybe<ComWixpressQuotesApiEventsInvoiceSentEventInput>;
};


export type MutationComWixEcomOrdersV1ConsumeMergeContactsFilteredEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixEcomOrdersV1ConsumeMetaSiteSpecialEventsArgs = {
  input?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteSpecialEventInput>;
};


export type MutationComWixEcomOrdersV1ConsumeOrderDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixEcomOrdersV1ConsumeOrderEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixEcomOrdersV1ConsumeOrderReindexRequestArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1OrderReindexRequestInput>;
};


export type MutationComWixEcomOrdersV1ConsumePaymentEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixEcomOrdersV1ConsumePaymentStatusUpdateEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixEcomOrdersV1ConsumePaymentsEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixEcomOrdersV1ConsumeTriggerReindexRequestArgs = {
  input?: InputMaybe<ComWixEcomOrdersIndexerV1BatchOfTriggerReindexOrderRequestInput>;
};


export type MutationComWixEcomOrdersV1CreateOrderArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1CreateOrderRequestInput>;
};


export type MutationComWixEcomOrdersV1CreatePaymentGatewayOrderArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1CreatePaymentGatewayOrderRequestInput>;
};


export type MutationComWixEcomOrdersV1CreateSiteRolloutStatusArgs = {
  input?: InputMaybe<ComWixEcomOrdersRolloutManagerV1CreateSiteRolloutStatusRequestInput>;
};


export type MutationComWixEcomOrdersV1DecrementItemsQuantityArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1DecrementItemsQuantityRequestInput>;
};


export type MutationComWixEcomOrdersV1DeleteActivityArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1DeleteActivityRequestInput>;
};


export type MutationComWixEcomOrdersV1EpBackofficeTestUrlAdditionalBindingsArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixEcomOrdersV1EpBackofficeUpdateOrderArgs = {
  input?: InputMaybe<WixEcomOrdersBackofficeV1UpdateOrderRequestInput>;
};


export type MutationComWixEcomOrdersV1EpBackofficeUpsertRefundArgs = {
  input?: InputMaybe<WixEcomOrdersBackofficeV1UpsertRefundRequestInput>;
};


export type MutationComWixEcomOrdersV1EpOrdersIndexerConsumeOrderEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixEcomOrdersV1EpOrdersIndexerConsumePaymentsEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixEcomOrdersV1EpOrdersIndexerConsumeTriggerReindexRequestArgs = {
  input?: InputMaybe<ComWixEcomOrdersIndexerV1TriggerReindexRequestInput>;
};


export type MutationComWixEcomOrdersV1EpOrdersRolloutManagerHasOrdersInOldSystemArgs = {
  input?: InputMaybe<ComWixEcomOrdersRolloutManagerV1HasOrdersInOldSystemRequestInput>;
};


export type MutationComWixEcomOrdersV1GetMetasiteDataArgs = {
  input?: InputMaybe<WixEcomOrdersBackofficeV1GetMetasiteDataRequestInput>;
};


export type MutationComWixEcomOrdersV1GetOrderAgcArgs = {
  input?: InputMaybe<WixEcomOrdersBackofficeV1GetOrderAgcRequestInput>;
};


export type MutationComWixEcomOrdersV1GetOrderForMetasiteArgs = {
  input?: InputMaybe<WixEcomOrdersBackofficeV1GetOrderForMetasiteRequestInput>;
};


export type MutationComWixEcomOrdersV1GetOrderOutOfBoxArgs = {
  input?: InputMaybe<WixEcomOrdersBackofficeV1GetOrderOutOfBoxRequestInput>;
};


export type MutationComWixEcomOrdersV1GetOrderWithFilterByLocationArgs = {
  input?: InputMaybe<WixEcomOrdersBackofficeV1GetOrderWithFilterByLocationRequestInput>;
};


export type MutationComWixEcomOrdersV1GetPaymentCollectabilityStatusArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1GetPaymentCollectabilityStatusRequestInput>;
};


export type MutationComWixEcomOrdersV1GetRefundOptionsArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1GetRefundOptionsRequestInput>;
};


export type MutationComWixEcomOrdersV1GetRefundabilityStatusArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1GetRefundabilityStatusRequestInput>;
};


export type MutationComWixEcomOrdersV1GetShipmentsArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1GetShipmentsRequestInput>;
};


export type MutationComWixEcomOrdersV1GetSiteRolloutStatusArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixEcomOrdersV1HandleRetryMergeContactsTaskArgs = {
  input?: InputMaybe<WixApiLoomTimecapsuleTaskInput>;
};


export type MutationComWixEcomOrdersV1HasOrdersInOldSystemArgs = {
  input?: InputMaybe<ComWixEcomOrdersRolloutManagerV1HasOrdersInOldSystemRequestInput>;
};


export type MutationComWixEcomOrdersV1ImportOrderArgs = {
  input?: InputMaybe<ComWixEcomOrdersImporterV1ImportOrderRequestInput>;
};


export type MutationComWixEcomOrdersV1ImportsBulkDeleteImportedOrdersArgs = {
  input?: InputMaybe<ComWixEcomOrdersImporterV1BulkDeleteImportedOrdersRequestInput>;
};


export type MutationComWixEcomOrdersV1ImportsImportOrderArgs = {
  input?: InputMaybe<ComWixEcomOrdersImporterV1ImportOrderRequestInput>;
};


export type MutationComWixEcomOrdersV1ImportsSetOrderNumberCounterArgs = {
  input?: InputMaybe<ComWixEcomOrdersImporterV1SetOrderNumberCounterRequestInput>;
};


export type MutationComWixEcomOrdersV1InternalQueryOrdersArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1InternalQueryOrdersRequestInput>;
};


export type MutationComWixEcomOrdersV1ListOrderTransactionsForMetasiteArgs = {
  input?: InputMaybe<WixEcomOrdersBackofficeV1ListOrderTransactionsForMetasiteRequestInput>;
};


export type MutationComWixEcomOrdersV1ListOrdersArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1ListOrdersRequestInput>;
};


export type MutationComWixEcomOrdersV1ListOrdersForMetasiteArgs = {
  input?: InputMaybe<WixEcomOrdersBackofficeV1ListOrdersForMetasiteRequestInput>;
};


export type MutationComWixEcomOrdersV1MarkAsFulfilledArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1MarkAsFulfilledRequestInput>;
};


export type MutationComWixEcomOrdersV1MarkAsUnfulfilledArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1MarkAsUnfulfilledRequestInput>;
};


export type MutationComWixEcomOrdersV1MarkEmptyAndOpenNewFlowArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixEcomOrdersV1MarkOrderAsPaidArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1MarkOrderAsPaidRequestInput>;
};


export type MutationComWixEcomOrdersV1MarkOrderAsSeenByHumanArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1MarkOrderAsSeenByHumanRequestInput>;
};


export type MutationComWixEcomOrdersV1OnTriggerSideEffectsFromLegacyArgs = {
  input?: InputMaybe<ComWixEcomOrdersSideEffectsMigrationApiTriggerSideEffectsFromLegacyDataInput>;
};


export type MutationComWixEcomOrdersV1PaymentCollectionBulkMarkOrdersAsPaidArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1BulkMarkOrdersAsPaidRequestInput>;
};


export type MutationComWixEcomOrdersV1PaymentCollectionCalculateRefundV1Args = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundV1RequestInput>;
};


export type MutationComWixEcomOrdersV1PaymentCollectionCalculateRefundV2Args = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1CalculateRefundV2RequestInput>;
};


export type MutationComWixEcomOrdersV1PaymentCollectionCaptureAuthorizedPaymentArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1CaptureAuthorizedPaymentRequestInput>;
};


export type MutationComWixEcomOrdersV1PaymentCollectionCaptureAuthorizedPaymentsArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1CaptureAuthorizedPaymentsRequestInput>;
};


export type MutationComWixEcomOrdersV1PaymentCollectionConsumeGiftCardTransactionVoidedV2Args = {
  input?: InputMaybe<GoogleProtobufStructInput>;
};


export type MutationComWixEcomOrdersV1PaymentCollectionCreatePaymentGatewayOrderArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1CreatePaymentGatewayOrderRequestInput>;
};


export type MutationComWixEcomOrdersV1PaymentCollectionGetRefundOptionsArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1GetRefundOptionsRequestInput>;
};


export type MutationComWixEcomOrdersV1PaymentCollectionMarkOrderAsPaidArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1MarkOrderAsPaidRequestInput>;
};


export type MutationComWixEcomOrdersV1PaymentCollectionRefundArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1RefundRequestInput>;
};


export type MutationComWixEcomOrdersV1PaymentCollectionVoidAuthorizedPaymentArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1VoidAuthorizedPaymentRequestInput>;
};


export type MutationComWixEcomOrdersV1PaymentCollectionVoidAuthorizedPaymentsArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1VoidAuthorizedPaymentsRequestInput>;
};


export type MutationComWixEcomOrdersV1PreparePaymentCollectionArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1PreparePaymentCollectionRequestInput>;
};


export type MutationComWixEcomOrdersV1PreviewBuyerConfirmationEmailArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixEcomOrdersV1PreviewBuyerPaymentsReceivedEmailArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixEcomOrdersV1PreviewBuyerPickupConfirmationEmailArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixEcomOrdersV1PreviewCancelEmailArgs = {
  input?: InputMaybe<ComWixEcomOrdersNotificationsV1PreviewCancelEmailRequestInput>;
};


export type MutationComWixEcomOrdersV1PreviewCancelRefundEmailArgs = {
  input?: InputMaybe<ComWixEcomOrdersNotificationsV1PreviewCancelRefundEmailRequestInput>;
};


export type MutationComWixEcomOrdersV1PreviewEmailByTypeArgs = {
  input?: InputMaybe<ComWixEcomOrdersNotificationsV1PreviewEmailByTypeRequestInput>;
};


export type MutationComWixEcomOrdersV1PreviewRefundEmailArgs = {
  input?: InputMaybe<ComWixEcomOrdersNotificationsV1PreviewRefundEmailRequestInput>;
};


export type MutationComWixEcomOrdersV1PreviewResendDownloadLinksEmailArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixEcomOrdersV1PreviewShippingConfirmationEmailArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixEcomOrdersV1QueryOrdersForMetasiteArgs = {
  input?: InputMaybe<WixEcomOrdersBackofficeV1QueryOrdersForMetasiteRequestInput>;
};


export type MutationComWixEcomOrdersV1RecordManuallyCollectedPaymentArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1RecordManuallyCollectedPaymentRequestInput>;
};


export type MutationComWixEcomOrdersV1RefundArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1RefundRequestInput>;
};


export type MutationComWixEcomOrdersV1SearchOrdersArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1SearchOrdersRequestInput>;
};


export type MutationComWixEcomOrdersV1SendBuyerConfirmationEmailArgs = {
  input?: InputMaybe<ComWixEcomOrdersNotificationsV1SendBuyerConfirmationEmailRequestInput>;
};


export type MutationComWixEcomOrdersV1SendBuyerPaymentsReceivedEmailArgs = {
  input?: InputMaybe<ComWixEcomOrdersNotificationsV1SendBuyerPaymentsReceivedEmailRequestInput>;
};


export type MutationComWixEcomOrdersV1SendBuyerPickupConfirmationEmailArgs = {
  input?: InputMaybe<ComWixEcomOrdersNotificationsV1SendBuyerPickupConfirmationEmailRequestInput>;
};


export type MutationComWixEcomOrdersV1SendBuyerShippingConfirmationEmailArgs = {
  input?: InputMaybe<ComWixEcomOrdersNotificationsV1SendBuyerShippingConfirmationEmailRequestInput>;
};


export type MutationComWixEcomOrdersV1SendCancelRefundEmailArgs = {
  input?: InputMaybe<ComWixEcomOrdersNotificationsV1SendCancelRefundEmailRequestInput>;
};


export type MutationComWixEcomOrdersV1SendMerchantOrderReceivedNotificationArgs = {
  input?: InputMaybe<ComWixEcomOrdersNotificationsV1SendMerchantOrderReceivedNotificationRequestInput>;
};


export type MutationComWixEcomOrdersV1SendMerchantOrderReceivedPushArgs = {
  input?: InputMaybe<ComWixEcomOrdersNotificationsV1SendMerchantOrderReceivedPushRequestInput>;
};


export type MutationComWixEcomOrdersV1SendRefundEmailArgs = {
  input?: InputMaybe<ComWixEcomOrdersNotificationsV1SendRefundEmailRequestInput>;
};


export type MutationComWixEcomOrdersV1SetOrderNumberCounterArgs = {
  input?: InputMaybe<ComWixEcomOrdersImporterV1SetOrderNumberCounterRequestInput>;
};


export type MutationComWixEcomOrdersV1TestUrlAdditionalBindingsArgs = {
  input?: InputMaybe<WixEcomOrdersBackofficeV1TestUrlAdditionalBindingsRequestInput>;
};


export type MutationComWixEcomOrdersV1TriggerRefundArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1TriggerRefundRequestInput>;
};


export type MutationComWixEcomOrdersV1TriggerReindexArgs = {
  input?: InputMaybe<ComWixEcomOrdersIndexerV1TriggerReindexRequestInput>;
};


export type MutationComWixEcomOrdersV1UnArchiveOrderArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1UnArchiveOrderRequestInput>;
};


export type MutationComWixEcomOrdersV1UpdateActivityArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1UpdateActivityRequestInput>;
};


export type MutationComWixEcomOrdersV1UpdateAllowLazyMigrationArgs = {
  input?: InputMaybe<ComWixEcomOrdersRolloutManagerV1UpdateAllowLazyMigrationRequestInput>;
};


export type MutationComWixEcomOrdersV1UpdateBillingContactDetailsArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1UpdateBillingContactDetailsRequestInput>;
};


export type MutationComWixEcomOrdersV1UpdateBuyerEmailArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1UpdateBuyerEmailRequestInput>;
};


export type MutationComWixEcomOrdersV1UpdateBuyerInfoArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1UpdateBuyerInfoRequestInput>;
};


export type MutationComWixEcomOrdersV1UpdateComparisonStatusArgs = {
  input?: InputMaybe<ComWixEcomOrdersRolloutManagerV1UpdateComparisonStatusRequestInput>;
};


export type MutationComWixEcomOrdersV1UpdateLineItemsDescriptionLinesArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1UpdateLineItemsDescriptionLinesRequestInput>;
};


export type MutationComWixEcomOrdersV1UpdateMigrationFailedArgs = {
  input?: InputMaybe<ComWixEcomOrdersRolloutManagerV1UpdateMigrationFailedRequestInput>;
};


export type MutationComWixEcomOrdersV1UpdateNewFlowOpenArgs = {
  input?: InputMaybe<ComWixEcomOrdersRolloutManagerV1UpdateNewFlowOpenRequestInput>;
};


export type MutationComWixEcomOrdersV1UpdateNoDataToMigrateArgs = {
  input?: InputMaybe<ComWixEcomOrdersRolloutManagerV1UpdateNoDataToMigrateRequestInput>;
};


export type MutationComWixEcomOrdersV1UpdateOrderArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1UpdateOrderRequestInput>;
};


export type MutationComWixEcomOrdersV1UpdateOrderLineItemArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1UpdateOrderLineItemRequestInput>;
};


export type MutationComWixEcomOrdersV1UpdateOrderLineItemsArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1UpdateOrderLineItemsRequestInput>;
};


export type MutationComWixEcomOrdersV1UpdateOrderShippingAddressArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1UpdateOrderShippingAddressRequestInput>;
};


export type MutationComWixEcomOrdersV1UpdateOrderStatusArgs = {
  input?: InputMaybe<ComWixEcomOrdersV1UpdateOrderStatusRequestInput>;
};


export type MutationComWixEcomOrdersV1UpsertRefundArgs = {
  input?: InputMaybe<WixEcomOrdersBackofficeV1UpsertRefundRequestInput>;
};


export type MutationComWixEcomOrdersV1VoidAuthorizedPaymentArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1VoidAuthorizedPaymentRequestInput>;
};


export type MutationComWixEcomOrdersV1VoidAuthorizedPaymentsArgs = {
  input?: InputMaybe<ComWixEcomOrdersPaymentsCollectorV1VoidAuthorizedPaymentsRequestInput>;
};


export type MutationComWixpressBookingsAttendanceV2AttendanceBulkSetAttendanceArgs = {
  input?: InputMaybe<ComWixpressBookingsAttendanceV2BulkSetAttendanceRequestInput>;
};


export type MutationComWixpressBookingsAttendanceV2BulkSetAttendanceArgs = {
  input?: InputMaybe<ComWixpressBookingsAttendanceV2BulkSetAttendanceRequestInput>;
};


export type MutationComWixpressBookingsAttendanceV2CountAttendancesArgs = {
  input?: InputMaybe<ComWixpressBookingsAttendanceV2CountAttendancesRequestInput>;
};


export type MutationComWixpressBookingsAttendanceV2SetAttendanceArgs = {
  input?: InputMaybe<ComWixpressBookingsAttendanceV2SetAttendanceRequestInput>;
};


export type MutationComWixpressBookingsResourcesCoreApiV1ResourceBatchCreateArgs = {
  input?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceBatchCreateResourceRequestInput>;
};


export type MutationComWixpressBookingsResourcesCoreApiV1ResourceBatchDeleteArgs = {
  input?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceBatchDeleteResourceRequestInput>;
};


export type MutationComWixpressBookingsResourcesCoreApiV1ResourceBatchForceDeleteArgs = {
  input?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceBatchDeleteResourceRequestInput>;
};


export type MutationComWixpressBookingsResourcesCoreApiV1ResourceCreateArgs = {
  input?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceCreateResourceRequestInput>;
};


export type MutationComWixpressBookingsResourcesCoreApiV1ResourceDeleteArgs = {
  input?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceDeleteResourceRequestInput>;
};


export type MutationComWixpressBookingsResourcesCoreApiV1ResourceGetBusinessResourceArgs = {
  input?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceGetBusinessResourceRequestInput>;
};


export type MutationComWixpressBookingsResourcesCoreApiV1ResourceLinkResourceToUserArgs = {
  input?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceLinkResourceToUserRequestInput>;
};


export type MutationComWixpressBookingsResourcesCoreApiV1ResourceListArgs = {
  input?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceListResourcesRequestInput>;
};


export type MutationComWixpressBookingsResourcesCoreApiV1ResourceQueryArgs = {
  input?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceQueryResourcesRequestInput>;
};


export type MutationComWixpressBookingsResourcesCoreApiV1ResourceUnLinkResourceFromOwnerArgs = {
  input?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceUnLinkResourceFromOwnerRequestInput>;
};


export type MutationComWixpressBookingsResourcesCoreApiV1ResourceUpdateArgs = {
  input?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceUpdateResourceRequestInput>;
};


export type MutationComWixpressBookingsResourcesCoreApiV1ResourceUpdateScheduleArgs = {
  input?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceUpdateScheduleRequestInput>;
};


export type MutationComWixpressCloudDataApiDataAggregateDataItemsArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataAggregateDataItemsRequestInput>;
};


export type MutationComWixpressCloudDataApiDataAggregatePipelineDataItemsArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataAggregatePipelineDataItemsRequestInput>;
};


export type MutationComWixpressCloudDataApiDataBulkInsertDataItemReferencesArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataBulkInsertDataItemReferencesRequestInput>;
};


export type MutationComWixpressCloudDataApiDataBulkInsertDataItemsArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataBulkInsertDataItemsRequestInput>;
};


export type MutationComWixpressCloudDataApiDataBulkPatchDataItemsArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataBulkPatchDataItemsRequestInput>;
};


export type MutationComWixpressCloudDataApiDataBulkRemoveDataItemReferencesArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataBulkRemoveDataItemReferencesRequestInput>;
};


export type MutationComWixpressCloudDataApiDataBulkRemoveDataItemsArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataBulkRemoveDataItemsRequestInput>;
};


export type MutationComWixpressCloudDataApiDataBulkSaveDataItemsArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataBulkSaveDataItemsRequestInput>;
};


export type MutationComWixpressCloudDataApiDataBulkUpdateDataItemsArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataBulkUpdateDataItemsRequestInput>;
};


export type MutationComWixpressCloudDataApiDataCountDataItemsArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataCountDataItemsRequestInput>;
};


export type MutationComWixpressCloudDataApiDataInsertDataItemArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataInsertDataItemRequestInput>;
};


export type MutationComWixpressCloudDataApiDataInsertDataItemReferenceArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataInsertDataItemReferenceRequestInput>;
};


export type MutationComWixpressCloudDataApiDataIsReferencedDataItemArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataIsReferencedDataItemRequestInput>;
};


export type MutationComWixpressCloudDataApiDataPatchDataItemArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataPatchDataItemRequestInput>;
};


export type MutationComWixpressCloudDataApiDataQueryDistinctValuesArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataQueryDistinctValuesRequestInput>;
};


export type MutationComWixpressCloudDataApiDataQueryReferencedDataItemsArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataQueryReferencedDataItemsRequestInput>;
};


export type MutationComWixpressCloudDataApiDataRemoveDataItemArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataRemoveDataItemRequestInput>;
};


export type MutationComWixpressCloudDataApiDataRemoveDataItemReferenceArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataRemoveDataItemReferenceRequestInput>;
};


export type MutationComWixpressCloudDataApiDataReplaceDataItemReferencesArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataReplaceDataItemReferencesRequestInput>;
};


export type MutationComWixpressCloudDataApiDataSaveDataItemArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataSaveDataItemRequestInput>;
};


export type MutationComWixpressCloudDataApiDataSearchDataItemsArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataSearchDataItemsRequestInput>;
};


export type MutationComWixpressCloudDataApiDataTruncateDataItemsArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataTruncateDataItemsRequestInput>;
};


export type MutationComWixpressCloudDataApiDataUpdateDataItemArgs = {
  input?: InputMaybe<ComWixpressCloudDataApiDataUpdateDataItemRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4BulkAddSegmentToContactsArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4BulkAddSegmentToContactsRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4BulkDeleteContactsArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4BulkDeleteContactsRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4BulkLabelAndUnlabelContactsArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4BulkLabelAndUnlabelContactsRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4BulkRemoveSegmentFromContactsArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4BulkRemoveSegmentFromContactsRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4BulkUpdateContactsArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4BulkUpdateContactsRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4BulkUpsertContactsArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4BulkUpsertContactsRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4CountContactsArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixpressContactsCoreApiV4CreateContactArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4CreateContactRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4DeleteContactArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4DeleteContactRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4GeneratePictureUploadUrlArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4GeneratePictureUploadUrlRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4LabelAndUnlabelContactArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4LabelAndUnlabelContactRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4LabelContactArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4LabelContactRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4ListContactIdsBySegmentArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4ListContactIdsBySegmentRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4ListContactsArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4ListContactsRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4ListFacetsArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4ListFacetsRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4MergeContactsArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4MergeContactsRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4PreviewMergeContactsArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4PreviewMergeContactsRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4QueryFacetsArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4QueryFacetsRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4SearchContactsArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4SearchContactsRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4SyncSubmitContactArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4SyncSubmitContactRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4UnlabelContactArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4UnlabelContactRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4UpdateContactArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4UpdateContactRequestInput>;
};


export type MutationComWixpressContactsCoreApiV4UpsertContactArgs = {
  input?: InputMaybe<ComWixpressContactsCoreApiV4UpsertContactRequestInput>;
};


export type MutationComWixpressContactsFieldsV4DeleteExtendedFieldArgs = {
  input?: InputMaybe<ComWixpressContactsFieldsV4DeleteExtendedFieldRequestInput>;
};


export type MutationComWixpressContactsFieldsV4FindOrCreateExtendedFieldArgs = {
  input?: InputMaybe<ComWixpressContactsFieldsV4FindOrCreateExtendedFieldRequestInput>;
};


export type MutationComWixpressContactsFieldsV4GdprListArgs = {
  input?: InputMaybe<ComWixpressContactsFieldsV4GdprListRequestInput>;
};


export type MutationComWixpressContactsFieldsV4GetExtendedFieldByLegacyIdArgs = {
  input?: InputMaybe<ComWixpressContactsFieldsV4GetExtendedFieldByLegacyIdRequestInput>;
};


export type MutationComWixpressContactsFieldsV4ListExtendedFieldsArgs = {
  input?: InputMaybe<ComWixpressContactsFieldsV4ListExtendedFieldsRequestInput>;
};


export type MutationComWixpressContactsFieldsV4PurgeArgs = {
  input?: InputMaybe<ComWixpressContactsFieldsV4PurgeRequestInput>;
};


export type MutationComWixpressContactsFieldsV4UpdateExtendedFieldArgs = {
  input?: InputMaybe<ComWixpressContactsFieldsV4UpdateExtendedFieldRequestInput>;
};


export type MutationComWixpressContactsLabelsV4DeleteLabelArgs = {
  input?: InputMaybe<ComWixpressContactsLabelsV4DeleteLabelRequestInput>;
};


export type MutationComWixpressContactsLabelsV4FindOrCreateLabelArgs = {
  input?: InputMaybe<ComWixpressContactsLabelsV4FindOrCreateLabelRequestInput>;
};


export type MutationComWixpressContactsLabelsV4GdprListArgs = {
  input?: InputMaybe<ComWixpressContactsLabelsV4GdprListRequestInput>;
};


export type MutationComWixpressContactsLabelsV4GetLabelByLegacyIdArgs = {
  input?: InputMaybe<ComWixpressContactsLabelsV4GetLabelByLegacyIdRequestInput>;
};


export type MutationComWixpressContactsLabelsV4ListLabelNamespacesArgs = {
  input?: InputMaybe<ComWixpressContactsLabelsV4ListLabelNamespacesRequestInput>;
};


export type MutationComWixpressContactsLabelsV4ListLabelsArgs = {
  input?: InputMaybe<ComWixpressContactsLabelsV4ListLabelsRequestInput>;
};


export type MutationComWixpressContactsLabelsV4PurgeArgs = {
  input?: InputMaybe<ComWixpressContactsLabelsV4PurgeRequestInput>;
};


export type MutationComWixpressContactsLabelsV4UpdateLabelArgs = {
  input?: InputMaybe<ComWixpressContactsLabelsV4UpdateLabelRequestInput>;
};


export type MutationComWixpressLocationsAddLocationTypeArgs = {
  input?: InputMaybe<ComWixpressLocationsAddLocationTypeRequestInput>;
};


export type MutationComWixpressLocationsAddTypeToLocationArgs = {
  input?: InputMaybe<ComWixpressLocationsAddTypeToLocationRequestInput>;
};


export type MutationComWixpressLocationsArchiveLocationArgs = {
  input?: InputMaybe<ComWixpressLocationsArchiveLocationRequestInput>;
};


export type MutationComWixpressLocationsBulkCreateLocationArgs = {
  input?: InputMaybe<ComWixpressLocationsBulkCreateLocationRequestInput>;
};


export type MutationComWixpressLocationsBulkUpdateLocationArgs = {
  input?: InputMaybe<ComWixpressLocationsBulkUpdateLocationRequestInput>;
};


export type MutationComWixpressLocationsCreateLocationArgs = {
  input?: InputMaybe<ComWixpressLocationsCreateLocationRequestInput>;
};


export type MutationComWixpressLocationsListLocationsArgs = {
  input?: InputMaybe<ComWixpressLocationsListLocationsRequestInput>;
};


export type MutationComWixpressLocationsRemoveLocationTypeArgs = {
  input?: InputMaybe<ComWixpressLocationsRemoveLocationTypeRequestInput>;
};


export type MutationComWixpressLocationsRemoveTypeFromLocationArgs = {
  input?: InputMaybe<ComWixpressLocationsRemoveTypeFromLocationRequestInput>;
};


export type MutationComWixpressLocationsSetDefaultLocationArgs = {
  input?: InputMaybe<ComWixpressLocationsSetDefaultLocationRequestInput>;
};


export type MutationComWixpressLocationsUnarchiveLocationArgs = {
  input?: InputMaybe<ComWixpressLocationsUnarchiveLocationRequestInput>;
};


export type MutationComWixpressLocationsUpdateLocationArgs = {
  input?: InputMaybe<ComWixpressLocationsUpdateLocationRequestInput>;
};


export type MutationComWixpressMembersApiApproveMemberArgs = {
  input?: InputMaybe<ComWixpressMembersApiApproveMemberRequestInput>;
};


export type MutationComWixpressMembersApiBlockMemberArgs = {
  input?: InputMaybe<ComWixpressMembersApiBlockMemberRequestInput>;
};


export type MutationComWixpressMembersApiBulkApproveMembersArgs = {
  input?: InputMaybe<ComWixpressMembersApiBulkApproveMembersRequestInput>;
};


export type MutationComWixpressMembersApiBulkBlockMembersArgs = {
  input?: InputMaybe<ComWixpressMembersApiBulkBlockMembersRequestInput>;
};


export type MutationComWixpressMembersApiBulkDeleteMembersArgs = {
  input?: InputMaybe<ComWixpressMembersApiBulkDeleteMembersRequestInput>;
};


export type MutationComWixpressMembersApiBulkDeleteMembersByFilterArgs = {
  input?: InputMaybe<ComWixpressMembersApiBulkDeleteMembersByFilterRequestInput>;
};


export type MutationComWixpressMembersApiConsumeAddActivityToContactMessageV2Args = {
  input?: InputMaybe<GoogleProtobufStructInput>;
};


export type MutationComWixpressMembersApiConsumeIdentityDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressMembersApiConsumeMemberPiiDataExchangeDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressMembersApiConsumeMetaSiteSpecialNoProvisioningEventsArgs = {
  input?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteSpecialEventInput>;
};


export type MutationComWixpressMembersApiConsumeProfileDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressMembersApiConsumeSiteMemberProfileUpdateArgs = {
  input?: InputMaybe<GoogleProtobufStructInput>;
};


export type MutationComWixpressMembersApiCreateMemberArgs = {
  input?: InputMaybe<ComWixpressMembersApiCreateMemberRequestInput>;
};


export type MutationComWixpressMembersApiDeleteMemberArgs = {
  input?: InputMaybe<ComWixpressMembersApiDeleteMemberRequestInput>;
};


export type MutationComWixpressMembersApiDeleteMemberAddressesArgs = {
  input?: InputMaybe<ComWixpressMembersApiDeleteMemberAddressesRequestInput>;
};


export type MutationComWixpressMembersApiDeleteMemberEmailsArgs = {
  input?: InputMaybe<ComWixpressMembersApiDeleteMemberEmailsRequestInput>;
};


export type MutationComWixpressMembersApiDeleteMemberPhonesArgs = {
  input?: InputMaybe<ComWixpressMembersApiDeleteMemberPhonesRequestInput>;
};


export type MutationComWixpressMembersApiDeleteMyMemberArgs = {
  input?: InputMaybe<ComWixpressMembersApiDeleteMyMemberRequestInput>;
};


export type MutationComWixpressMembersApiDisconnectMemberArgs = {
  input?: InputMaybe<ComWixpressMembersApiDisconnectMemberRequestInput>;
};


export type MutationComWixpressMembersApiGetMyMemberArgs = {
  input?: InputMaybe<ComWixpressMembersApiGetMyMemberRequestInput>;
};


export type MutationComWixpressMembersApiJoinCommunityArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixpressMembersApiLeaveCommunityArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixpressMembersApiListMembersArgs = {
  input?: InputMaybe<ComWixpressMembersApiListMembersRequestInput>;
};


export type MutationComWixpressMembersApiMuteMemberArgs = {
  input?: InputMaybe<ComWixpressMembersApiMuteMemberRequestInput>;
};


export type MutationComWixpressMembersApiUnmuteMemberArgs = {
  input?: InputMaybe<ComWixpressMembersApiUnmuteMemberRequestInput>;
};


export type MutationComWixpressMembersApiUpdateMemberArgs = {
  input?: InputMaybe<ComWixpressMembersApiUpdateMemberRequestInput>;
};


export type MutationComWixpressMembersApiUpdateMemberSlugArgs = {
  input?: InputMaybe<ComWixpressMembersApiUpdateMemberSlugRequestInput>;
};


export type MutationComWixpressMembersApiUpdateMySlugArgs = {
  input?: InputMaybe<ComWixpressMembersApiUpdateMySlugRequestInput>;
};


export type MutationComWixpressMembershipV2PlansArchivePlanArgs = {
  input?: InputMaybe<ComWixpressMembershipV2PlansArchivePlanRequestInput>;
};


export type MutationComWixpressMembershipV2PlansArrangePlansArgs = {
  input?: InputMaybe<ComWixpressMembershipV2PlansArrangePlansRequestInput>;
};


export type MutationComWixpressMembershipV2PlansBulkArchivePlanArgs = {
  input?: InputMaybe<ComWixpressMembershipV2PlansBulkArchivePlanRequestInput>;
};


export type MutationComWixpressMembershipV2PlansClearPrimaryArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixpressMembershipV2PlansCountPlansArgs = {
  input?: InputMaybe<ComWixpressMembershipV2PlansCountPlansRequestInput>;
};


export type MutationComWixpressMembershipV2PlansCreatePlanArgs = {
  input?: InputMaybe<ComWixpressMembershipV2PlansCreatePlanRequestInput>;
};


export type MutationComWixpressMembershipV2PlansGetPlanStatsArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixpressMembershipV2PlansListPlansArgs = {
  input?: InputMaybe<ComWixpressMembershipV2PlansListPlansRequestInput>;
};


export type MutationComWixpressMembershipV2PlansListPublicPlansArgs = {
  input?: InputMaybe<ComWixpressMembershipV2PlansListPublicPlansRequestInput>;
};


export type MutationComWixpressMembershipV2PlansMakePlanPrimaryArgs = {
  input?: InputMaybe<ComWixpressMembershipV2PlansMakePlanPrimaryRequestInput>;
};


export type MutationComWixpressMembershipV2PlansSearchPlansArgs = {
  input?: InputMaybe<ComWixpressMembershipV2PlansSearchPlansRequestInput>;
};


export type MutationComWixpressMembershipV2PlansSetPlanVisibilityArgs = {
  input?: InputMaybe<ComWixpressMembershipV2PlansSetPlanVisibilityRequestInput>;
};


export type MutationComWixpressMembershipV2PlansUpdatePlanArgs = {
  input?: InputMaybe<ComWixpressMembershipV2PlansUpdatePlanRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogBulkCreateTagsArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogBulkCreateTagsRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogBulkDeleteTagArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogBulkDeleteTagRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogCreateTagArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogCreateTagRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogDeleteTagArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogDeleteTagRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogGetOrCreateTagArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogGetOrCreateTagRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogGetTagByLabelArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogGetTagByLabelRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogGetTagBySlugArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogGetTagBySlugRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogGetTagsCountByLanguageArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogListTagsArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogListTagsRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogUpdateTagArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogUpdateTagRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3BulkCreateCategoriesArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3BulkCreateCategoriesRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3BulkDeleteCategoryArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3BulkDeleteCategoryRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostMetricsArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostMetricsRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostReactionsArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3BulkGetPostReactionsRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3BulkUpdateCategoriesArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3BulkUpdateCategoriesRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3ConvertDraftJsToRichContentArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ConvertDraftJsToRichContentRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3ConvertRichContentToDraftJsArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ConvertRichContentToDraftJsRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3CreateCategoryArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CreateCategoryRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3CreateDraftPostFromTemplateArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3CreateDraftPostFromTemplateRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3DeleteCategoryArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3DeleteCategoryRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3GetCategoriesCountByLanguageArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3GetCategoryBySlugArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3GetCategoryBySlugRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3GetPostBySlugArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostBySlugRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3GetPostCountPerMonthArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostCountPerMonthRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3GetPostMetricsArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostMetricsRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3GetTemplateArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3GetTemplateRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3GetTotalLikesPerMemberArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3GetTotalLikesPerMemberRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3GetTotalPostsArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogGetTotalPostsRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3GetTotalPublicationsArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogGetTotalPublicationsRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3LikePostArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3LikePostRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3ListCategoriesArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ListCategoriesRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3ListDemoPostsArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ListDemoPostsRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3ListPostsArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ListPostsRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3ListPostsArchiveArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ListPostsArchiveRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3ListTemplatesArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ListTemplatesRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3PinPostArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PinPostRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3QueryPostCountStatsArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogQueryPostCountStatsRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3QueryPublicationsCountStatsArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogQueryPublicationsCountStatsRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3SendActionEventArgs = {
  input?: InputMaybe<WixBlogKafkaProducerV1SendActionEventRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3UnlikePostArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3UnlikePostRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3UnpinPostArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3UnpinPostRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3UpdateCategoryArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3UpdateCategoryRequestInput>;
};


export type MutationComWixpressNpmCommunitiesPlatformizedBlogV3ViewPostArgs = {
  input?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3ViewPostRequestInput>;
};


export type MutationComWixpressPortfolioCollectionsAdminRemoveMenuItemsArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixpressPortfolioCollectionsConsumeCollectionDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressPortfolioCollectionsConsumeLocaleEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressPortfolioCollectionsCreateCollectionArgs = {
  input?: InputMaybe<ComWixpressPortfolioCollectionsCreateCollectionRequestInput>;
};


export type MutationComWixpressPortfolioCollectionsDeleteCollectionArgs = {
  input?: InputMaybe<ComWixpressPortfolioCollectionsDeleteCollectionRequestInput>;
};


export type MutationComWixpressPortfolioCollectionsListCollectionsArgs = {
  input?: InputMaybe<ComWixpressPortfolioCollectionsListCollectionsRequestInput>;
};


export type MutationComWixpressPortfolioCollectionsUpdateCollectionArgs = {
  input?: InputMaybe<ComWixpressPortfolioCollectionsUpdateCollectionRequestInput>;
};


export type MutationComWixpressPortfolioProjectitemsBulkCreateProjectItemsArgs = {
  input?: InputMaybe<ComWixpressPortfolioProjectitemsBulkCreateProjectItemsRequestInput>;
};


export type MutationComWixpressPortfolioProjectitemsBulkDeleteProjectItemsArgs = {
  input?: InputMaybe<ComWixpressPortfolioProjectitemsBulkDeleteProjectItemsRequestInput>;
};


export type MutationComWixpressPortfolioProjectitemsBulkUpdateProjectItemsArgs = {
  input?: InputMaybe<ComWixpressPortfolioProjectitemsBulkUpdateProjectItemsRequestInput>;
};


export type MutationComWixpressPortfolioProjectitemsConsumeLocaleEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressPortfolioProjectitemsConsumeProjectDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressPortfolioProjectitemsCreateProjectGalleryArgs = {
  input?: InputMaybe<ComWixpressPortfolioProjectitemsCreateProjectGalleryRequestInput>;
};


export type MutationComWixpressPortfolioProjectitemsCreateProjectItemArgs = {
  input?: InputMaybe<ComWixpressPortfolioProjectitemsCreateProjectItemRequestInput>;
};


export type MutationComWixpressPortfolioProjectitemsDeleteProjectItemArgs = {
  input?: InputMaybe<ComWixpressPortfolioProjectitemsDeleteProjectItemRequestInput>;
};


export type MutationComWixpressPortfolioProjectitemsDuplicateProjectItemsArgs = {
  input?: InputMaybe<ComWixpressPortfolioProjectitemsDuplicateProjectItemsRequestInput>;
};


export type MutationComWixpressPortfolioProjectitemsGenerateTokenForProjectItemsArgs = {
  input?: InputMaybe<ComWixpressPortfolioPortfolioappGenerateTokenForProjectItemsRequestInput>;
};


export type MutationComWixpressPortfolioProjectitemsListProjectItemsArgs = {
  input?: InputMaybe<ComWixpressPortfolioProjectitemsListProjectItemsRequestInput>;
};


export type MutationComWixpressPortfolioProjectitemsUpdateProjectItemArgs = {
  input?: InputMaybe<ComWixpressPortfolioProjectitemsUpdateProjectItemRequestInput>;
};


export type MutationComWixpressPortfolioProjectsConsumeCollectionDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressPortfolioProjectsConsumeLocaleEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressPortfolioProjectsConsumeMetaSiteSpecialEventArgs = {
  input?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteSpecialEventInput>;
};


export type MutationComWixpressPortfolioProjectsCreateNewPortfolioAppArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixpressPortfolioProjectsCreateProjectArgs = {
  input?: InputMaybe<ComWixpressPortfolioProjectsCreateProjectRequestInput>;
};


export type MutationComWixpressPortfolioProjectsDeleteProjectArgs = {
  input?: InputMaybe<ComWixpressPortfolioProjectsDeleteProjectRequestInput>;
};


export type MutationComWixpressPortfolioProjectsGetProjectPageDataArgs = {
  input?: InputMaybe<ComWixpressPortfolioPortfolioappGetProjectPageDataRequestInput>;
};


export type MutationComWixpressPortfolioProjectsListProjectsArgs = {
  input?: InputMaybe<ComWixpressPortfolioProjectsListProjectsRequestInput>;
};


export type MutationComWixpressPortfolioProjectsQueryProjectsWithCollectionInfoArgs = {
  input?: InputMaybe<ComWixpressPortfolioProjectsQueryProjectWithCollectionInfoRequestInput>;
};


export type MutationComWixpressPortfolioProjectsUpdateProjectArgs = {
  input?: InputMaybe<ComWixpressPortfolioProjectsUpdateProjectRequestInput>;
};


export type MutationComWixpressPortfolioProjectsUpdateProjectOrderInCollectionArgs = {
  input?: InputMaybe<ComWixpressPortfolioProjectsUpdateProjectOrderInCollectionRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemLabelsV1BulkDeleteLabelsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemLabelsV1BulkDeleteLabelsRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemLabelsV1CloneLabelsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemLabelsV1CloneLabelsRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemLabelsV1ConsumeLabelDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressRestaurantsMenusItemLabelsV1CountLabelsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemLabelsV1CountLabelsRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemLabelsV1CreateLabelArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemLabelsV1CreateLabelRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemLabelsV1DeleteLabelArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemLabelsV1DeleteLabelRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemLabelsV1ListLabelsArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationComWixpressRestaurantsMenusItemLabelsV1SyncContentToMultilingualArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemLabelsV1SyncContentToMultilingualRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemLabelsV1UpdateLabelArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemLabelsV1UpdateLabelRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1BulkCreateItemsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemV1BulkCreateItemsRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1BulkDeleteItemsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemV1BulkDeleteItemsRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsPerEntityArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemV1BulkUpdateBusinessLocationIdsPerEntityRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1BulkUpdateItemArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemV1BulkUpdateItemRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1CloneItemsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemV1CloneItemsRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1ConsumeDeleteLocationIdsFromModifierGroupsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemV1DeleteLocationIdsFromModifierGroupsInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1ConsumeDeleteLocationIdsFromVariantsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemV1DeleteLocationIdsFromVariantsInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1ConsumeItemDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1ConsumeItemLabelDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1ConsumeSearchServicesNotificationEventsArgs = {
  input?: InputMaybe<WixSearchV1SearchIndexingNotificationInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1ConsumeTaxGroupsDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1CountItemsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemV1CountItemsRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1CreateItemArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemV1CreateItemRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1DeleteItemArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemV1DeleteItemRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1DuplicateItemArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemV1RestaurantsDuplicateItemDuplicateItemRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1ListItemsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemV1ListItemsRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1MenusItemsSiteSearchConsumeSitePropertiesUpdatedEventsArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4SitePropertiesNotificationInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1SearchItemsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemV1SearchItemsRequestInput>;
};


export type MutationComWixpressRestaurantsMenusItemV1UpdateItemArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusItemV1UpdateItemRequestInput>;
};


export type MutationComWixpressRestaurantsMenusMenuV1BulkCreateMenusArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusMenuV1BulkCreateMenusRequestInput>;
};


export type MutationComWixpressRestaurantsMenusMenuV1BulkUpdateMenuArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusMenuV1BulkUpdateMenuRequestInput>;
};


export type MutationComWixpressRestaurantsMenusMenuV1CloneMenusArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusMenuV1CloneMenusRequestInput>;
};


export type MutationComWixpressRestaurantsMenusMenuV1ConsumeDeleteOrphanSectionsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusMenuV1DeleteOrphanSectionsInput>;
};


export type MutationComWixpressRestaurantsMenusMenuV1ConsumeMenuDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressRestaurantsMenusMenuV1ConsumeSectionDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressRestaurantsMenusMenuV1CreateMenuArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusMenuV1CreateMenuRequestInput>;
};


export type MutationComWixpressRestaurantsMenusMenuV1DeleteMenuArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusMenuV1DeleteMenuRequestInput>;
};


export type MutationComWixpressRestaurantsMenusMenuV1GetMenuArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusMenuV1GetMenuRequestInput>;
};


export type MutationComWixpressRestaurantsMenusMenuV1GetMenuSiteUrlArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlGetMenuSiteUrlRequestInput>;
};


export type MutationComWixpressRestaurantsMenusMenuV1ListMenusArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusMenuV1ListMenusRequestInput>;
};


export type MutationComWixpressRestaurantsMenusMenuV1ListMenusSiteUrlArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlListMenusSiteUrlRequestInput>;
};


export type MutationComWixpressRestaurantsMenusMenuV1QueryMenusArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusMenuV1QueryMenusRequestInput>;
};


export type MutationComWixpressRestaurantsMenusMenuV1UpdateExtendedFieldsArgs = {
  input?: InputMaybe<WixCommonDataDataextensionsUpdateExtendedFieldsRequestInput>;
};


export type MutationComWixpressRestaurantsMenusMenuV1UpdateMenuArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusMenuV1UpdateMenuRequestInput>;
};


export type MutationComWixpressRestaurantsMenusSectionV1BulkCreateSectionsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusSectionV1BulkCreateSectionsRequestInput>;
};


export type MutationComWixpressRestaurantsMenusSectionV1BulkDeleteSectionsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusSectionV1BulkDeleteSectionsRequestInput>;
};


export type MutationComWixpressRestaurantsMenusSectionV1BulkUpdateBusinessLocationIdArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusSectionV1BulkUpdateBusinessLocationIdRequestInput>;
};


export type MutationComWixpressRestaurantsMenusSectionV1BulkUpdateSectionArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusSectionV1BulkUpdateSectionRequestInput>;
};


export type MutationComWixpressRestaurantsMenusSectionV1CloneSectionsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusSectionV1CloneSectionsRequestInput>;
};


export type MutationComWixpressRestaurantsMenusSectionV1ConsumeDeleteLocationIdFromItemsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusSectionV1DeleteLocationIdFromItemsInput>;
};


export type MutationComWixpressRestaurantsMenusSectionV1ConsumeDeleteOrphanItemsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusSectionV1DeleteOrphanItemsInput>;
};


export type MutationComWixpressRestaurantsMenusSectionV1ConsumeItemDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressRestaurantsMenusSectionV1ConsumeSectionDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationComWixpressRestaurantsMenusSectionV1CreateSectionArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusSectionV1CreateSectionRequestInput>;
};


export type MutationComWixpressRestaurantsMenusSectionV1DeleteSectionArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusSectionV1DeleteSectionRequestInput>;
};


export type MutationComWixpressRestaurantsMenusSectionV1DuplicateSectionArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusSectionV1RestaurantsDuplicateSectionDuplicateSectionRequestInput>;
};


export type MutationComWixpressRestaurantsMenusSectionV1ListSectionsArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusSectionV1ListSectionsRequestInput>;
};


export type MutationComWixpressRestaurantsMenusSectionV1UpdateSectionArgs = {
  input?: InputMaybe<ComWixpressRestaurantsMenusSectionV1UpdateSectionRequestInput>;
};


export type MutationComWixpressSitepropertiesApiV4ReadArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4PropertiesReadRequestInput>;
};


export type MutationComWixpressSitepropertiesApiV4ReadWithoutDefaultPropertiesArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4BulkPropertiesReadRequestInput>;
};


export type MutationComWixpressSitepropertiesApiV4UpdateArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4PropertiesUpdateRequestInput>;
};


export type MutationComWixpressSitepropertiesApiV4UpdateBusinessContactArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4UpdateBusinessContactRequestInput>;
};


export type MutationComWixpressSitepropertiesApiV4UpdateBusinessProfileArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4UpdateBusinessProfileRequestInput>;
};


export type MutationComWixpressSitepropertiesApiV4UpdateBusinessScheduleArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4UpdateBusinessScheduleRequestInput>;
};


export type MutationComWixpressSitepropertiesApiV4UpdateConsentPolicyArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4UpdateConsentPolicyRequestInput>;
};


export type MutationEcomCheckoutV1AddToCheckoutArgs = {
  input?: InputMaybe<EcomCheckoutV1AddToCheckoutRequestInput>;
};


export type MutationEcomCheckoutV1ConsumeCheckoutDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationEcomCheckoutV1ConsumeOrderApprovedEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationEcomCheckoutV1ConsumeOrderCreatedV2EventsArgs = {
  input?: InputMaybe<WixOrdersApiV2OrderCreatedInput>;
};


export type MutationEcomCheckoutV1ConsumeSubscriptionCreatedEventsArgs = {
  input?: InputMaybe<WixSubscriptionsApiV1SubscriptionCreatedInput>;
};


export type MutationEcomCheckoutV1ConsumeUpdatedCheckoutEventsArgs = {
  input?: InputMaybe<EcomCheckoutV1UpdatedCheckoutMessageInput>;
};


export type MutationEcomCheckoutV1CreateCheckoutArgs = {
  input?: InputMaybe<EcomCheckoutV1CreateCheckoutRequestInput>;
};


export type MutationEcomCheckoutV1CreateCheckoutStreamArgs = {
  input?: InputMaybe<EcomCheckoutV1CreateCheckoutRequestInput>;
};


export type MutationEcomCheckoutV1CreateOrderArgs = {
  input?: InputMaybe<EcomCheckoutV1CreateOrderRequestInput>;
};


export type MutationEcomCheckoutV1CreateOrderAndChargeArgs = {
  input?: InputMaybe<EcomCheckoutV1CreateOrderAndChargeRequestInput>;
};


export type MutationEcomCheckoutV1DeleteCheckoutArgs = {
  input?: InputMaybe<EcomCheckoutV1DeleteCheckoutRequestInput>;
};


export type MutationEcomCheckoutV1GetCheckoutArgs = {
  input?: InputMaybe<EcomCheckoutV1GetCheckoutRequestInput>;
};


export type MutationEcomCheckoutV1GetCheckoutByCartIdArgs = {
  input?: InputMaybe<EcomCheckoutV1GetCheckoutByCartIdRequestInput>;
};


export type MutationEcomCheckoutV1GetCheckoutPaymentSettingsArgs = {
  input?: InputMaybe<EcomCheckoutV1GetCheckoutPaymentSettingsRequestInput>;
};


export type MutationEcomCheckoutV1GetCheckoutUrlArgs = {
  input?: InputMaybe<EcomCheckoutV1GetCheckoutUrlRequestInput>;
};


export type MutationEcomCheckoutV1GetCheckoutWithAllExtendedFieldsArgs = {
  input?: InputMaybe<EcomCheckoutV1GetCheckoutWithAllExtendedFieldsRequestInput>;
};


export type MutationEcomCheckoutV1GetWixCheckoutUrlArgs = {
  input?: InputMaybe<EcomCheckoutV1GetWixCheckoutUrlRequestInput>;
};


export type MutationEcomCheckoutV1MarkCheckoutAsCompletedArgs = {
  input?: InputMaybe<EcomCheckoutV1MarkCheckoutAsCompletedRequestInput>;
};


export type MutationEcomCheckoutV1MarkCheckoutAsCompletedAndRedirectToUrlArgs = {
  input?: InputMaybe<EcomCheckoutV1MarkCheckoutAsCompletedAndRedirectToUrlRequestInput>;
};


export type MutationEcomCheckoutV1RemoveCouponArgs = {
  input?: InputMaybe<EcomCheckoutV1RemoveCouponRequestInput>;
};


export type MutationEcomCheckoutV1RemoveGiftCardArgs = {
  input?: InputMaybe<EcomCheckoutV1RemoveGiftCardRequestInput>;
};


export type MutationEcomCheckoutV1RemoveLineItemsArgs = {
  input?: InputMaybe<EcomCheckoutV1RemoveLineItemsRequestInput>;
};


export type MutationEcomCheckoutV1RemoveOverrideCheckoutUrlArgs = {
  input?: InputMaybe<EcomCheckoutV1RemoveOverrideCheckoutUrlRequestInput>;
};


export type MutationEcomCheckoutV1UpdateCheckoutArgs = {
  input?: InputMaybe<EcomCheckoutV1UpdateCheckoutRequestInput>;
};


export type MutationEcomCheckoutV1UpdateLineItemsQuantityArgs = {
  input?: InputMaybe<EcomCheckoutV1UpdateLineItemsQuantityRequestInput>;
};


export type MutationMetroinspectorV1ProductsBulkCreateProductsArgs = {
  input?: InputMaybe<MetroinspectorV1ProductsBulkCreateProductsRequestInput>;
};


export type MutationMetroinspectorV1ProductsBulkDeleteProductsArgs = {
  input?: InputMaybe<MetroinspectorV1ProductsBulkDeleteProductsRequestInput>;
};


export type MutationMetroinspectorV1ProductsBulkUpdateProductsArgs = {
  input?: InputMaybe<MetroinspectorV1ProductsBulkUpdateProductsRequestInput>;
};


export type MutationMetroinspectorV1ProductsCountProductsArgs = {
  input?: InputMaybe<MetroinspectorV1ProductsCountProductsRequestInput>;
};


export type MutationMetroinspectorV1ProductsCreateProductArgs = {
  input?: InputMaybe<MetroinspectorV1ProductsCreateProductRequestInput>;
};


export type MutationMetroinspectorV1ProductsDeleteProductArgs = {
  input?: InputMaybe<MetroinspectorV1ProductsDeleteProductRequestInput>;
};


export type MutationMetroinspectorV1ProductsGetProductsStartWithArgs = {
  input?: InputMaybe<MetroinspectorV1ProductsGetProductsStartWithRequestInput>;
};


export type MutationMetroinspectorV1ProductsResetProductsDbArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationMetroinspectorV1ProductsUpdateProductArgs = {
  input?: InputMaybe<MetroinspectorV1ProductsUpdateProductRequestInput>;
};


export type MutationWixBillingV1BulkCreateTaxExemptGroupsArgs = {
  input?: InputMaybe<WixBillingV1BulkCreateTaxExemptGroupsRequestInput>;
};


export type MutationWixBillingV1BulkDeleteTaxExemptGroupsArgs = {
  input?: InputMaybe<WixBillingV1BulkDeleteTaxExemptGroupsRequestInput>;
};


export type MutationWixBillingV1BulkUpdateTaxExemptGroupTagsArgs = {
  input?: InputMaybe<WixBillingV1BulkUpdateTaxExemptGroupTagsRequestInput>;
};


export type MutationWixBillingV1BulkUpdateTaxExemptGroupTagsByFilterArgs = {
  input?: InputMaybe<WixBillingV1BulkUpdateTaxExemptGroupTagsByFilterRequestInput>;
};


export type MutationWixBillingV1BulkUpdateTaxExemptGroupsArgs = {
  input?: InputMaybe<WixBillingV1BulkUpdateTaxExemptGroupsRequestInput>;
};


export type MutationWixBillingV1CreateTaxExemptGroupArgs = {
  input?: InputMaybe<WixBillingV1CreateTaxExemptGroupRequestInput>;
};


export type MutationWixBillingV1DeleteTaxExemptGroupArgs = {
  input?: InputMaybe<WixBillingV1DeleteTaxExemptGroupRequestInput>;
};


export type MutationWixBillingV1UpdateTaxExemptGroupArgs = {
  input?: InputMaybe<WixBillingV1UpdateTaxExemptGroupRequestInput>;
};


export type MutationWixBookingsCatalogV1CloneServiceOptionsAndVariantsArgs = {
  input?: InputMaybe<WixBookingsCatalogV1CloneServiceOptionsAndVariantsRequestInput>;
};


export type MutationWixBookingsCatalogV1ConsumeInternalEventsForBiArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixBookingsCatalogV1ConsumeResourceNotificationArgs = {
  input?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceResourceNotificationInput>;
};


export type MutationWixBookingsCatalogV1ConsumeScheduleNotificationArgs = {
  input?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleNotificationInput>;
};


export type MutationWixBookingsCatalogV1ConsumeScheduleNotificationWithDeleteEffectArgs = {
  input?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleNotificationInput>;
};


export type MutationWixBookingsCatalogV1ConsumeServicesNotificationArgs = {
  input?: InputMaybe<ComWixpressBookingsServicesApiV1ServiceNotificationInput>;
};


export type MutationWixBookingsCatalogV1ConsumeSitePropertiesNotificationArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4SitePropertiesNotificationInput>;
};


export type MutationWixBookingsCatalogV1CreateServiceOptionsAndVariantsArgs = {
  input?: InputMaybe<WixBookingsCatalogV1CreateServiceOptionsAndVariantsRequestInput>;
};


export type MutationWixBookingsCatalogV1DeleteServiceOptionsAndVariantsArgs = {
  input?: InputMaybe<WixBookingsCatalogV1DeleteServiceOptionsAndVariantsRequestInput>;
};


export type MutationWixBookingsCatalogV1GetServiceOptionsAndVariantsByServiceIdArgs = {
  input?: InputMaybe<WixBookingsCatalogV1GetServiceOptionsAndVariantsByServiceIdRequestInput>;
};


export type MutationWixBookingsCatalogV1UpdateServiceOptionsAndVariantsArgs = {
  input?: InputMaybe<WixBookingsCatalogV1UpdateServiceOptionsAndVariantsRequestInput>;
};


export type MutationWixBookingsCategoriesV2ConsumeMetaSiteSpecialEventArgs = {
  input?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteSpecialEventInput>;
};


export type MutationWixBookingsCategoriesV2ConsumePopulationElementCreatedDomainEventsArgs = {
  input?: InputMaybe<WixPopulationV2CreatedElementsEventInput>;
};


export type MutationWixBookingsCategoriesV2CountCategoriesArgs = {
  input?: InputMaybe<WixBookingsCategoriesV2CountCategoriesRequestInput>;
};


export type MutationWixBookingsCategoriesV2CreateCategoryArgs = {
  input?: InputMaybe<WixBookingsCategoriesV2CreateCategoryRequestInput>;
};


export type MutationWixBookingsCategoriesV2DeleteCategoryArgs = {
  input?: InputMaybe<WixBookingsCategoriesV2DeleteCategoryRequestInput>;
};


export type MutationWixBookingsCategoriesV2ImportCategoriesArgs = {
  input?: InputMaybe<WixBookingsCategoriesV2ImportCategoriesRequestInput>;
};


export type MutationWixBookingsCategoriesV2MoveCategoryArgs = {
  input?: InputMaybe<WixBookingsCategoriesV2MoveCategoryRequestInput>;
};


export type MutationWixBookingsCategoriesV2PublishCategoriesUpdatedArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationWixBookingsCategoriesV2UpdateCategoryArgs = {
  input?: InputMaybe<WixBookingsCategoriesV2UpdateCategoryRequestInput>;
};


export type MutationWixBookingsServicesV2AddOnGroupsServiceCreateAddOnGroupArgs = {
  input?: InputMaybe<WixBookingsServicesV2CreateAddOnGroupRequestInput>;
};


export type MutationWixBookingsServicesV2AddOnGroupsServiceDeleteAddOnGroupArgs = {
  input?: InputMaybe<WixBookingsServicesV2DeleteAddOnGroupRequestInput>;
};


export type MutationWixBookingsServicesV2AddOnGroupsServiceListAddOnGroupsByServiceIdArgs = {
  input?: InputMaybe<WixBookingsServicesV2ListAddOnGroupsByServiceIdRequestInput>;
};


export type MutationWixBookingsServicesV2AddOnGroupsServiceSetAddOnsForGroupArgs = {
  input?: InputMaybe<WixBookingsServicesV2SetAddOnsForGroupRequestInput>;
};


export type MutationWixBookingsServicesV2AddOnGroupsServiceUpdateAddOnGroupArgs = {
  input?: InputMaybe<WixBookingsServicesV2UpdateAddOnGroupRequestInput>;
};


export type MutationWixBookingsServicesV2AddOnGroupsServiceValidateAddOnsSelectionArgs = {
  input?: InputMaybe<WixBookingsServicesV2ValidateAddOnsSelectionRequestInput>;
};


export type MutationWixBookingsServicesV2BulkCreateServicesArgs = {
  input?: InputMaybe<WixBookingsServicesV2BulkCreateServicesRequestInput>;
};


export type MutationWixBookingsServicesV2BulkDeleteServicesArgs = {
  input?: InputMaybe<WixBookingsServicesV2BulkDeleteServicesRequestInput>;
};


export type MutationWixBookingsServicesV2BulkDeleteServicesByFilterArgs = {
  input?: InputMaybe<WixBookingsServicesV2BulkDeleteServicesByFilterRequestInput>;
};


export type MutationWixBookingsServicesV2BulkUpdateServicesArgs = {
  input?: InputMaybe<WixBookingsServicesV2BulkUpdateServicesRequestInput>;
};


export type MutationWixBookingsServicesV2BulkUpdateServicesByFilterArgs = {
  input?: InputMaybe<WixBookingsServicesV2BulkUpdateServicesByFilterRequestInput>;
};


export type MutationWixBookingsServicesV2CloneServiceArgs = {
  input?: InputMaybe<WixBookingsServicesV2CloneServiceRequestInput>;
};


export type MutationWixBookingsServicesV2ConsumeBenefitNotificationArgs = {
  input?: InputMaybe<ComWixPricingplansBenefitsApiV2BenefitNotificationInput>;
};


export type MutationWixBookingsServicesV2ConsumeCalendarEventDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixBookingsServicesV2ConsumeCategoryNotificationArgs = {
  input?: InputMaybe<ComWixpressBookingsServicesApiV1CategoryNotificationInput>;
};


export type MutationWixBookingsServicesV2ConsumeDuplicateSlugsNotificationArgs = {
  input?: InputMaybe<GoogleProtobufStructInput>;
};


export type MutationWixBookingsServicesV2ConsumeHtmlSitePublishedArgs = {
  input?: InputMaybe<ComWixpressHtmlEditorApiEventsHtmlSitePublishedInput>;
};


export type MutationWixBookingsServicesV2ConsumeLocationDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixBookingsServicesV2ConsumeMembershipPlanDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixBookingsServicesV2ConsumeMultiServiceEnabledEventArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationWixBookingsServicesV2ConsumePaidPlanEventArgs = {
  input?: InputMaybe<ComWixpressMembershipV1PlansPlanEventInput>;
};


export type MutationWixBookingsServicesV2ConsumePolicyNotificationArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixBookingsServicesV2ConsumeResourceNotificationArgs = {
  input?: InputMaybe<ComWixpressBookingsResourcesCoreApiV1ResourceResourceNotificationInput>;
};


export type MutationWixBookingsServicesV2ConsumeResourceTypeNotificationArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixBookingsServicesV2ConsumeScheduleNotificationArgs = {
  input?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleNotificationInput>;
};


export type MutationWixBookingsServicesV2ConsumeScheduleTimeFrameNotificationsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixBookingsServicesV2ConsumeServiceDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixBookingsServicesV2ConsumeServiceOptionsAndVariantsNotificationArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixBookingsServicesV2ConsumeSitePropertiesNotificationArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4SitePropertiesNotificationInput>;
};


export type MutationWixBookingsServicesV2ConsumeUserDomainInfoChangedEventArgs = {
  input?: InputMaybe<ComWixpressPremiumDomainsNotificationsUserDomainInfoChangedEventInput>;
};


export type MutationWixBookingsServicesV2CountServicesArgs = {
  input?: InputMaybe<WixBookingsServicesV2CountServicesRequestInput>;
};


export type MutationWixBookingsServicesV2CreateAddOnGroupArgs = {
  input?: InputMaybe<WixBookingsServicesV2CreateAddOnGroupRequestInput>;
};


export type MutationWixBookingsServicesV2CreateAddOnsGroupArgs = {
  input?: InputMaybe<WixBookingsServicesV2CreateAddOnsGroupRequestInput>;
};


export type MutationWixBookingsServicesV2CreateServiceArgs = {
  input?: InputMaybe<WixBookingsServicesV2CreateServiceRequestInput>;
};


export type MutationWixBookingsServicesV2DeleteAddOnGroupArgs = {
  input?: InputMaybe<WixBookingsServicesV2DeleteAddOnGroupRequestInput>;
};


export type MutationWixBookingsServicesV2DeleteAddOnsGroupArgs = {
  input?: InputMaybe<WixBookingsServicesV2DeleteAddOnsGroupRequestInput>;
};


export type MutationWixBookingsServicesV2DeleteServiceArgs = {
  input?: InputMaybe<WixBookingsServicesV2DeleteServiceRequestInput>;
};


export type MutationWixBookingsServicesV2DisablePricingPlansForServiceArgs = {
  input?: InputMaybe<WixBookingsServicesV2DisablePricingPlansForServiceRequestInput>;
};


export type MutationWixBookingsServicesV2EnablePricingPlansForServiceArgs = {
  input?: InputMaybe<WixBookingsServicesV2EnablePricingPlansForServiceRequestInput>;
};


export type MutationWixBookingsServicesV2GetServiceAvailabilityConstraintsArgs = {
  input?: InputMaybe<WixBookingsServicesV2GetServiceAvailabilityConstraintsRequestInput>;
};


export type MutationWixBookingsServicesV2ListAddOnGroupsByServiceIdArgs = {
  input?: InputMaybe<WixBookingsServicesV2ListAddOnGroupsByServiceIdRequestInput>;
};


export type MutationWixBookingsServicesV2ListAddOnsGroupsByServiceIdArgs = {
  input?: InputMaybe<WixBookingsServicesV2ListAddOnsGroupsByServiceIdRequestInput>;
};


export type MutationWixBookingsServicesV2QueryBookingFormsArgs = {
  input?: InputMaybe<WixBookingsServicesV2QueryBookingFormsRequestInput>;
};


export type MutationWixBookingsServicesV2QueryCategoriesArgs = {
  input?: InputMaybe<WixBookingsServicesV2QueryCategoriesRequestInput>;
};


export type MutationWixBookingsServicesV2QueryLocationsArgs = {
  input?: InputMaybe<WixBookingsServicesV2QueryLocationsRequestInput>;
};


export type MutationWixBookingsServicesV2QueryPoliciesArgs = {
  input?: InputMaybe<WixBookingsServicesV2QueryPoliciesRequestInput>;
};


export type MutationWixBookingsServicesV2QueryServicesMultiLanguageArgs = {
  input?: InputMaybe<WixBookingsServicesV2QueryServicesMultiLanguageRequestInput>;
};


export type MutationWixBookingsServicesV2SearchServicesArgs = {
  input?: InputMaybe<WixBookingsServicesV2SearchServicesRequestInput>;
};


export type MutationWixBookingsServicesV2SetAddOnsForGroupArgs = {
  input?: InputMaybe<WixBookingsServicesV2SetAddOnsForGroupRequestInput>;
};


export type MutationWixBookingsServicesV2SetCustomSlugArgs = {
  input?: InputMaybe<WixBookingsServicesV2SetCustomSlugRequestInput>;
};


export type MutationWixBookingsServicesV2SetServiceLocationsArgs = {
  input?: InputMaybe<WixBookingsServicesV2SetServiceLocationsRequestInput>;
};


export type MutationWixBookingsServicesV2UpdateAddOnGroupArgs = {
  input?: InputMaybe<WixBookingsServicesV2UpdateAddOnGroupRequestInput>;
};


export type MutationWixBookingsServicesV2UpdateAddOnsGroupArgs = {
  input?: InputMaybe<WixBookingsServicesV2UpdateAddOnsGroupRequestInput>;
};


export type MutationWixBookingsServicesV2UpdateServiceArgs = {
  input?: InputMaybe<WixBookingsServicesV2UpdateServiceRequestInput>;
};


export type MutationWixBookingsServicesV2ValidateAddOnsSelectionArgs = {
  input?: InputMaybe<WixBookingsServicesV2ValidateAddOnsSelectionRequestInput>;
};


export type MutationWixBookingsServicesV2ValidateServiceArgs = {
  input?: InputMaybe<WixBookingsServicesV2ValidateServiceRequestInput>;
};


export type MutationWixBookingsServicesV2ValidateSlugArgs = {
  input?: InputMaybe<WixBookingsServicesV2ValidateSlugRequestInput>;
};


export type MutationWixBookingsStaffV1AssignBusinessScheduleArgs = {
  input?: InputMaybe<WixBookingsStaffV1AssignBusinessScheduleRequestInput>;
};


export type MutationWixBookingsStaffV1AssignCustomScheduleArgs = {
  input?: InputMaybe<WixBookingsStaffV1AssignCustomScheduleRequestInput>;
};


export type MutationWixBookingsStaffV1ConnectStaffMemberToUserArgs = {
  input?: InputMaybe<WixBookingsStaffV1ConnectStaffMemberToUserRequestInput>;
};


export type MutationWixBookingsStaffV1ConnectToUserArgs = {
  input?: InputMaybe<WixBookingsStaffV1ConnectToUserRequestInput>;
};


export type MutationWixBookingsStaffV1CountStaffMembersArgs = {
  input?: InputMaybe<WixBookingsStaffV1CountStaffMembersRequestInput>;
};


export type MutationWixBookingsStaffV1CreateStaffMemberArgs = {
  input?: InputMaybe<WixBookingsStaffV1CreateStaffMemberRequestInput>;
};


export type MutationWixBookingsStaffV1DeleteStaffMemberArgs = {
  input?: InputMaybe<WixBookingsStaffV1DeleteStaffMemberRequestInput>;
};


export type MutationWixBookingsStaffV1DisconnectStaffMemberFromUserArgs = {
  input?: InputMaybe<WixBookingsStaffV1DisconnectStaffMemberFromUserRequestInput>;
};


export type MutationWixBookingsStaffV1DisconnectUserArgs = {
  input?: InputMaybe<WixBookingsStaffV1DisconnectUserRequestInput>;
};


export type MutationWixBookingsStaffV1HandleFileDescriptorDomainEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixBookingsStaffV1HandleMemberDomainEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixBookingsStaffV1HandlePolicyRemovedFromContributorArgs = {
  input?: InputMaybe<ComWixpressAuthorizationAbacManagementEventsPolicyRemovedFromContributorInput>;
};


export type MutationWixBookingsStaffV1HandlePolicyUpdatedForContributorArgs = {
  input?: InputMaybe<ComWixpressAuthorizationAbacManagementEventsPolicyUpdatedForContributorInput>;
};


export type MutationWixBookingsStaffV1HandleResourceDomainEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixBookingsStaffV1HandleScheduleNotificationArgs = {
  input?: InputMaybe<ComWixBookingsSchedulesApiV1ScheduleNotificationInput>;
};


export type MutationWixBookingsStaffV1HandleStaffConnectedToUserArgs = {
  input?: InputMaybe<GoogleProtobufStructInput>;
};


export type MutationWixBookingsStaffV1HandleStaffDomainEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixBookingsStaffV1ImportStaffMemberArgs = {
  input?: InputMaybe<WixBookingsStaffV1ImportStaffMemberRequestInput>;
};


export type MutationWixBookingsStaffV1RestoreStaffArgs = {
  input?: InputMaybe<WixBookingsStaffV1RestoreStaffRequestInput>;
};


export type MutationWixBookingsStaffV1UpdateStaffMemberArgs = {
  input?: InputMaybe<WixBookingsStaffV1UpdateStaffMemberRequestInput>;
};


export type MutationWixBookingsV1ConsumeBookingPolicyDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixBookingsV1ConsumeMetaSiteSpecialEventArgs = {
  input?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteSpecialEventInput>;
};


export type MutationWixBookingsV1ConsumeSitePropertiesNotificationArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4SitePropertiesNotificationInput>;
};


export type MutationWixBookingsV1CountBookingPoliciesArgs = {
  input?: InputMaybe<WixBookingsV1CountBookingPoliciesRequestInput>;
};


export type MutationWixBookingsV1CreateBookingPolicyArgs = {
  input?: InputMaybe<WixBookingsV1CreateBookingPolicyRequestInput>;
};


export type MutationWixBookingsV1CreateMissingDefaultPolicyArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationWixBookingsV1DeleteBookingPolicyArgs = {
  input?: InputMaybe<WixBookingsV1DeleteBookingPolicyRequestInput>;
};


export type MutationWixBookingsV1GetArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationWixBookingsV1GetStrictestBookingPolicyArgs = {
  input?: InputMaybe<WixBookingsV1GetStrictestBookingPolicyRequestInput>;
};


export type MutationWixBookingsV1SetDefaultBookingPolicyArgs = {
  input?: InputMaybe<WixBookingsV1SetDefaultBookingPolicyRequestInput>;
};


export type MutationWixBookingsV1UpdateArgs = {
  input?: InputMaybe<ComWixpressBookingsServicesApiV1UpdatePolicyRequestInput>;
};


export type MutationWixBookingsV1UpdateAllPoliciesArgs = {
  input?: InputMaybe<WixBookingsV1UpdateAllPoliciesRequestInput>;
};


export type MutationWixBookingsV1UpdateBookingPolicyArgs = {
  input?: InputMaybe<WixBookingsV1UpdateBookingPolicyRequestInput>;
};


export type MutationWixCalendarEventsV3BulkCancelEventArgs = {
  input?: InputMaybe<WixCalendarEventsV3BulkCancelEventRequestInput>;
};


export type MutationWixCalendarEventsV3BulkCreateEventArgs = {
  input?: InputMaybe<WixCalendarEventsV3BulkCreateEventRequestInput>;
};


export type MutationWixCalendarEventsV3BulkUpdateEventArgs = {
  input?: InputMaybe<WixCalendarEventsV3BulkUpdateEventRequestInput>;
};


export type MutationWixCalendarEventsV3CancelEventArgs = {
  input?: InputMaybe<WixCalendarEventsV3CancelEventRequestInput>;
};


export type MutationWixCalendarEventsV3CreateEventArgs = {
  input?: InputMaybe<WixCalendarEventsV3CreateEventRequestInput>;
};


export type MutationWixCalendarEventsV3DeleteTargetsArgs = {
  input?: InputMaybe<WixCalendarMigrationV3DeleteTargetsRequestInput>;
};


export type MutationWixCalendarEventsV3FixSched38956Args = {
  input?: InputMaybe<WixCalendarMigrationV3FixSched38956RequestInput>;
};


export type MutationWixCalendarEventsV3HandleBusinessLocationDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixCalendarEventsV3HandleContactMergedDomainEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixCalendarEventsV3HandleEventDomainEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixCalendarEventsV3HandleGdprUoUAccessRequestArgs = {
  input?: InputMaybe<GoogleProtobufStructInput>;
};


export type MutationWixCalendarEventsV3HandleGdprUoUDeleteRequestArgs = {
  input?: InputMaybe<GoogleProtobufStructInput>;
};


export type MutationWixCalendarEventsV3HandleMetaSiteEventArgs = {
  input?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteSpecialEventInput>;
};


export type MutationWixCalendarEventsV3HandleParticipationDomainEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixCalendarEventsV3HandleResourceDomainEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixCalendarEventsV3HandleScheduleDomainEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixCalendarEventsV3HandleScheduleTimeFrameDomainEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixCalendarEventsV3HandleSelfDomainEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixCalendarEventsV3HandleSitePropertiesNotificationArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4SitePropertiesNotificationInput>;
};


export type MutationWixCalendarEventsV3ListEventsArgs = {
  input?: InputMaybe<WixCalendarEventsV3ListEventsRequestInput>;
};


export type MutationWixCalendarEventsV3ListEventsByContactIdArgs = {
  input?: InputMaybe<WixCalendarParticipanteventsV3ListEventsByContactIdRequestInput>;
};


export type MutationWixCalendarEventsV3ListEventsByMemberIdArgs = {
  input?: InputMaybe<WixCalendarParticipanteventsV3ListEventsByMemberIdRequestInput>;
};


export type MutationWixCalendarEventsV3ListParticipantEventsArgs = {
  input?: InputMaybe<WixCalendarParticipanteventsV3ListParticipantEventsRequestInput>;
};


export type MutationWixCalendarEventsV3ListRecurringEventInstancesHistoryArgs = {
  input?: InputMaybe<WixCalendarEventsV3ListRecurringEventInstancesHistoryRequestInput>;
};


export type MutationWixCalendarEventsV3MigrateSiteArgs = {
  input?: InputMaybe<WixCalendarMigrationV3MigrateSiteRequestInput>;
};


export type MutationWixCalendarEventsV3ParticipantEventsHandleMetaSiteEventArgs = {
  input?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteSpecialEventInput>;
};


export type MutationWixCalendarEventsV3ParticipantEventsHandleSitePropertiesNotificationArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4SitePropertiesNotificationInput>;
};


export type MutationWixCalendarEventsV3RestoreEventDefaultsArgs = {
  input?: InputMaybe<WixCalendarEventsV3RestoreEventDefaultsRequestInput>;
};


export type MutationWixCalendarEventsV3SplitRecurringEventArgs = {
  input?: InputMaybe<WixCalendarEventsV3SplitRecurringEventRequestInput>;
};


export type MutationWixCalendarEventsV3UpdateEventArgs = {
  input?: InputMaybe<WixCalendarEventsV3UpdateEventRequestInput>;
};


export type MutationWixCalendarEventsV3UpdateEventParticipantsArgs = {
  input?: InputMaybe<WixCalendarEventsV3UpdateEventParticipantsRequestInput>;
};


export type MutationWixCalendarSchedulesV3CancelScheduleArgs = {
  input?: InputMaybe<WixCalendarSchedulesV3CancelScheduleRequestInput>;
};


export type MutationWixCalendarSchedulesV3CloneScheduleArgs = {
  input?: InputMaybe<WixCalendarSchedulesV3CloneScheduleRequestInput>;
};


export type MutationWixCalendarSchedulesV3ConsumeLocationDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixCalendarSchedulesV3ConsumeSitePropertiesEventsArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4SitePropertiesNotificationInput>;
};


export type MutationWixCalendarSchedulesV3CreateScheduleArgs = {
  input?: InputMaybe<WixCalendarSchedulesV3CreateScheduleRequestInput>;
};


export type MutationWixCalendarSchedulesV3HandleMetaSiteEventArgs = {
  input?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteSpecialEventInput>;
};


export type MutationWixCalendarSchedulesV3UpdateScheduleArgs = {
  input?: InputMaybe<WixCalendarSchedulesV3UpdateScheduleRequestInput>;
};


export type MutationWixCatalogApiV1AddProductMediaArgs = {
  input?: InputMaybe<WixCatalogApiV1AddProductMediaRequestInput>;
};


export type MutationWixCatalogApiV1AddProductMediaToChoicesArgs = {
  input?: InputMaybe<WixCatalogApiV1AddProductMediaToChoicesRequestInput>;
};


export type MutationWixCatalogApiV1AddProductsToCollectionArgs = {
  input?: InputMaybe<WixCatalogApiV1AddProductsToCollectionRequestInput>;
};


export type MutationWixCatalogApiV1AggregateProductsArgs = {
  input?: InputMaybe<WixCatalogApiV1AggregateProductsRequestInput>;
};


export type MutationWixCatalogApiV1BulkAdjustProductPropertiesArgs = {
  input?: InputMaybe<WixCatalogApiV1BulkAdjustProductPropertiesRequestInput>;
};


export type MutationWixCatalogApiV1BulkAdjustProductPropertiesByFilterSyncArgs = {
  input?: InputMaybe<WixCatalogApiV1BulkAdjustProductPropertiesByFilterSyncRequestInput>;
};


export type MutationWixCatalogApiV1BulkDeleteProductsArgs = {
  input?: InputMaybe<WixCatalogApiV1BulkDeleteProductsRequestInput>;
};


export type MutationWixCatalogApiV1BulkQueryCustomFieldsArgs = {
  input?: InputMaybe<WixCatalogApiV1BulkQueryCustomFieldsRequestInput>;
};


export type MutationWixCatalogApiV1BulkRemoveCustomFieldsArgs = {
  input?: InputMaybe<WixCatalogApiV1BulkRemoveCustomFieldsRequestInput>;
};


export type MutationWixCatalogApiV1BulkSetCustomFieldsArgs = {
  input?: InputMaybe<WixCatalogApiV1BulkSetCustomFieldsRequestInput>;
};


export type MutationWixCatalogApiV1BulkUpdateProductsArgs = {
  input?: InputMaybe<WixCatalogApiV1BulkUpdateProductsRequestInput>;
};


export type MutationWixCatalogApiV1BulkUpdateProductsByFilterSyncArgs = {
  input?: InputMaybe<WixCatalogApiV1BulkUpdateProductsByFilterSyncRequestInput>;
};


export type MutationWixCatalogApiV1CreateCollectionArgs = {
  input?: InputMaybe<WixCatalogApiV1CreateCollectionRequestInput>;
};


export type MutationWixCatalogApiV1CreateDigitalProductArgs = {
  input?: InputMaybe<WixCatalogApiV1CreateDigitalProductRequestInput>;
};


export type MutationWixCatalogApiV1CreateProductArgs = {
  input?: InputMaybe<WixCatalogApiV1CreateProductRequestInput>;
};


export type MutationWixCatalogApiV1CreateProductPlatformizedArgs = {
  input?: InputMaybe<WixCatalogApiV1CreateProductPlatformizedRequestInput>;
};


export type MutationWixCatalogApiV1DeleteCollectionArgs = {
  input?: InputMaybe<WixCatalogApiV1DeleteCollectionRequestInput>;
};


export type MutationWixCatalogApiV1DeleteProductArgs = {
  input?: InputMaybe<WixCatalogApiV1DeleteProductRequestInput>;
};


export type MutationWixCatalogApiV1DeleteProductOptionsArgs = {
  input?: InputMaybe<WixCatalogApiV1DeleteProductOptionsRequestInput>;
};


export type MutationWixCatalogApiV1DeleteProductPlatformizedArgs = {
  input?: InputMaybe<WixCatalogApiV1DeleteProductPlatformizedRequestInput>;
};


export type MutationWixCatalogApiV1GetCollectionArgs = {
  input?: InputMaybe<WixCatalogApiV1GetCollectionRequestInput>;
};


export type MutationWixCatalogApiV1GetCollectionBySlugArgs = {
  input?: InputMaybe<WixCatalogApiV1GetCollectionBySlugRequestInput>;
};


export type MutationWixCatalogApiV1GetProductArgs = {
  input?: InputMaybe<WixCatalogApiV1GetProductRequestInput>;
};


export type MutationWixCatalogApiV1GetProductsArgs = {
  input?: InputMaybe<WixCatalogApiV1GetProductsRequestInput>;
};


export type MutationWixCatalogApiV1GetStoreVariantArgs = {
  input?: InputMaybe<WixCatalogApiV1GetStoreVariantRequestInput>;
};


export type MutationWixCatalogApiV1ProductOptionsAvailabilityArgs = {
  input?: InputMaybe<WixCatalogApiV1ProductOptionsAvailabilityRequestInput>;
};


export type MutationWixCatalogApiV1QueryCollectionsArgs = {
  input?: InputMaybe<WixCatalogApiV1QueryCollectionsRequestInput>;
};


export type MutationWixCatalogApiV1QueryCollectionsPlatformizedArgs = {
  input?: InputMaybe<WixCatalogApiV1QueryCollectionsPlatformizedRequestInput>;
};


export type MutationWixCatalogApiV1QueryCustomFieldsArgs = {
  input?: InputMaybe<WixCatalogApiV1QueryCustomFieldsRequestInput>;
};


export type MutationWixCatalogApiV1QueryProductVariantsArgs = {
  input?: InputMaybe<WixCatalogApiV1QueryProductVariantsRequestInput>;
};


export type MutationWixCatalogApiV1QueryProductsArgs = {
  input?: InputMaybe<WixCatalogApiV1QueryProductsRequestInput>;
};


export type MutationWixCatalogApiV1QueryProductsWithBigPageLimitArgs = {
  input?: InputMaybe<WixCatalogApiV1QueryProductsWithBigPageLimitRequestInput>;
};


export type MutationWixCatalogApiV1QueryStoreVariantsArgs = {
  input?: InputMaybe<WixCatalogApiV1QueryStoreVariantsRequestInput>;
};


export type MutationWixCatalogApiV1QueryStoreVariantsWithBigLimitArgs = {
  input?: InputMaybe<WixCatalogApiV1QueryStoreVariantsWithBigLimitRequestInput>;
};


export type MutationWixCatalogApiV1ReCloneStoreArgs = {
  input?: InputMaybe<WixCatalogApiV1ReCloneStoreRequestInput>;
};


export type MutationWixCatalogApiV1RemoveBrandArgs = {
  input?: InputMaybe<WixCatalogApiV1RemoveProductBrandRequestInput>;
};


export type MutationWixCatalogApiV1RemoveCustomFieldsArgs = {
  input?: InputMaybe<WixCatalogApiV1RemoveCustomFieldsRequestInput>;
};


export type MutationWixCatalogApiV1RemoveProductMediaArgs = {
  input?: InputMaybe<WixCatalogApiV1RemoveProductMediaRequestInput>;
};


export type MutationWixCatalogApiV1RemoveProductMediaFromChoicesArgs = {
  input?: InputMaybe<WixCatalogApiV1RemoveProductMediaFromChoicesRequestInput>;
};


export type MutationWixCatalogApiV1RemoveProductsFromCollectionArgs = {
  input?: InputMaybe<WixCatalogApiV1RemoveProductsFromCollectionRequestInput>;
};


export type MutationWixCatalogApiV1RemoveRibbonArgs = {
  input?: InputMaybe<WixCatalogApiV1RemoveProductRibbonRequestInput>;
};


export type MutationWixCatalogApiV1ResetAllVariantDataArgs = {
  input?: InputMaybe<WixCatalogApiV1ResetAllVariantDataRequestInput>;
};


export type MutationWixCatalogApiV1SetCustomFieldsArgs = {
  input?: InputMaybe<WixCatalogApiV1SetCustomFieldsRequestInput>;
};


export type MutationWixCatalogApiV1UpdateCollectionArgs = {
  input?: InputMaybe<WixCatalogApiV1UpdateCollectionRequestInput>;
};


export type MutationWixCatalogApiV1UpdateProductArgs = {
  input?: InputMaybe<WixCatalogApiV1UpdateProductRequestInput>;
};


export type MutationWixCatalogApiV1UpdateProductPlatformizedArgs = {
  input?: InputMaybe<WixCatalogApiV1UpdateProductPlatformizedRequestInput>;
};


export type MutationWixCatalogApiV1UpdateVariantsArgs = {
  input?: InputMaybe<WixCatalogApiV1UpdateVariantsRequestInput>;
};


export type MutationWixCatalogApiV1WriteProxyCreateProductPlatformizedArgs = {
  input?: InputMaybe<WixCatalogWriteProxyV1CreateProductPlatformizedRequestInput>;
};


export type MutationWixCatalogApiV1WriteProxyDeleteProductPlatformizedArgs = {
  input?: InputMaybe<WixCatalogWriteProxyV1DeleteProductPlatformizedRequestInput>;
};


export type MutationWixCatalogApiV1WriteProxyUpdateProductPlatformizedArgs = {
  input?: InputMaybe<WixCatalogWriteProxyV1UpdateProductPlatformizedRequestInput>;
};


export type MutationWixCoreservicesMetroinspectorV1EchoArgs = {
  input?: InputMaybe<WixCoreservicesMetroinspectorV1EchoRequestInput>;
};


export type MutationWixDevcenterAppsV1ActivateSecondarySecretArgs = {
  input?: InputMaybe<WixDevcenterAppsV1ActivateSecondarySecretRequestInput>;
};


export type MutationWixDevcenterAppsV1ConsumeAppSlugChangedArgs = {
  input?: InputMaybe<ComWixpressAppserviceApiAppSlugChangedInput>;
};


export type MutationWixDevcenterAppsV1ConsumeAppUrlsChangedMessageArgs = {
  input?: InputMaybe<WixDevcenterAppsV1AppUrlsChangedInOldServiceEventInput>;
};


export type MutationWixDevcenterAppsV1ConsumeAppVersionStateChangedArgs = {
  input?: InputMaybe<ComWixpressAppserviceApiAppVersionStateChangedInput>;
};


export type MutationWixDevcenterAppsV1ConsumeOldAppChangedArgs = {
  input?: InputMaybe<ComWixpressAppserviceApiAppChangedEventInput>;
};


export type MutationWixDevcenterAppsV1CreateAppArgs = {
  input?: InputMaybe<WixDevcenterAppsV1CreateAppRequestInput>;
};


export type MutationWixDevcenterAppsV1CreateSecondarySecretArgs = {
  input?: InputMaybe<WixDevcenterAppsV1CreateSecondarySecretRequestInput>;
};


export type MutationWixDevcenterAppsV1DeleteAppArgs = {
  input?: InputMaybe<WixDevcenterAppsV1DeleteAppRequestInput>;
};


export type MutationWixDevcenterAppsV1GenerateSlugArgs = {
  input?: InputMaybe<WixDevcenterAppsV1GenerateSlugRequestInput>;
};


export type MutationWixDevcenterAppsV1GetNamespaceSuggestionArgs = {
  input?: InputMaybe<WixDevcenterAppsV1GetNamespaceSuggestionRequestInput>;
};


export type MutationWixDevcenterAppsV1GetNamespaceSuggestionByNameArgs = {
  input?: InputMaybe<WixDevcenterAppsV1GetNamespaceSuggestionByNameRequestInput>;
};


export type MutationWixDevcenterAppsV1RollbackSecretArgs = {
  input?: InputMaybe<WixDevcenterAppsV1RollbackSecretRequestInput>;
};


export type MutationWixDevcenterAppsV1RotateSecretArgs = {
  input?: InputMaybe<WixDevcenterAppsV1RotateSecretRequestInput>;
};


export type MutationWixDevcenterAppsV1SetAppOwnerArgs = {
  input?: InputMaybe<WixDevcenterAppsV1SetAppOwnerRequestInput>;
};


export type MutationWixDevcenterAppsV1SetCacheableAppArgs = {
  input?: InputMaybe<WixDevcenterAppsV1SetCacheableAppRequestInput>;
};


export type MutationWixDevcenterAppsV1SetHipaaCompliantArgs = {
  input?: InputMaybe<WixDevcenterAppsV1SetHipaaCompliantRequestInput>;
};


export type MutationWixDevcenterAppsV1SetNamespaceArgs = {
  input?: InputMaybe<WixDevcenterAppsV1SetNamespaceRequestInput>;
};


export type MutationWixDevcenterAppsV1SetOwnershipTagArgs = {
  input?: InputMaybe<WixDevcenterAppsV1SetOwnershipTagRequestInput>;
};


export type MutationWixDevcenterAppsV1SetPrivateAppArgs = {
  input?: InputMaybe<WixDevcenterAppsV1SetPrivateAppRequestInput>;
};


export type MutationWixDevcenterAppsV1UpdateAppArgs = {
  input?: InputMaybe<WixDevcenterAppsV1UpdateAppRequestInput>;
};


export type MutationWixEventsBulkCancelEventsArgs = {
  input?: InputMaybe<WixEventsBulkCancelEventsRequestInput>;
};


export type MutationWixEventsBulkDeleteEventsArgs = {
  input?: InputMaybe<WixEventsBulkDeleteEventsRequestInput>;
};


export type MutationWixEventsCancelEventArgs = {
  input?: InputMaybe<WixEventsCancelEventRequestInput>;
};


export type MutationWixEventsCopyArgs = {
  input?: InputMaybe<WixEventsCopyEventRequestInput>;
};


export type MutationWixEventsCopyEventFromOtherSiteArgs = {
  input?: InputMaybe<WixEventsCopyEventFromOtherSiteRequestInput>;
};


export type MutationWixEventsCopyEventV2Args = {
  input?: InputMaybe<WixEventsCopyEventV2RequestInput>;
};


export type MutationWixEventsCreateEventV2Args = {
  input?: InputMaybe<WixEventsCreateEventV2RequestInput>;
};


export type MutationWixEventsDeleteEventArgs = {
  input?: InputMaybe<WixEventsDeleteEventRequestInput>;
};


export type MutationWixEventsFindEventArgs = {
  input?: InputMaybe<WixEventsFindEventRequestInput>;
};


export type MutationWixEventsFindOnlineConferenceSessionArgs = {
  input?: InputMaybe<WixEventsFindOnlineConferenceSessionRequestInput>;
};


export type MutationWixEventsGetRecurringEventStateArgs = {
  input?: InputMaybe<WixEventsGetRecurringEventStateRequestInput>;
};


export type MutationWixEventsGetTicketingSummaryArgs = {
  input?: InputMaybe<WixEventsGetTicketingSummaryRequestInput>;
};


export type MutationWixEventsListCategoryEventsArgs = {
  input?: InputMaybe<WixEventsListCategoryEventsRequestInput>;
};


export type MutationWixEventsListEventsArgs = {
  input?: InputMaybe<WixEventsListEventsRequestInput>;
};


export type MutationWixEventsListUserEventsArgs = {
  input?: InputMaybe<WixEventsListUserEventsRequestInput>;
};


export type MutationWixEventsPublishDraftEventArgs = {
  input?: InputMaybe<WixEventsPublishDraftEventRequestInput>;
};


export type MutationWixEventsQueryArgs = {
  input?: InputMaybe<WixEventsQueryEventsRequestInput>;
};


export type MutationWixEventsScheduleAddScheduleItemArgs = {
  input?: InputMaybe<WixEventsScheduleAddScheduleItemRequestInput>;
};


export type MutationWixEventsScheduleCreateBookmarkArgs = {
  input?: InputMaybe<WixEventsScheduleCreateBookmarkRequestInput>;
};


export type MutationWixEventsScheduleDeleteBookmarkArgs = {
  input?: InputMaybe<WixEventsScheduleDeleteBookmarkRequestInput>;
};


export type MutationWixEventsScheduleDeleteScheduleItemArgs = {
  input?: InputMaybe<WixEventsScheduleDeleteScheduleItemRequestInput>;
};


export type MutationWixEventsScheduleDiscardDraftArgs = {
  input?: InputMaybe<WixEventsScheduleDiscardDraftRequestInput>;
};


export type MutationWixEventsScheduleGetScheduleItemArgs = {
  input?: InputMaybe<WixEventsScheduleGetScheduleItemRequestInput>;
};


export type MutationWixEventsScheduleListBookmarksArgs = {
  input?: InputMaybe<WixEventsScheduleListBookmarksRequestInput>;
};


export type MutationWixEventsScheduleListScheduleItemsArgs = {
  input?: InputMaybe<WixEventsScheduleListScheduleItemsRequestInput>;
};


export type MutationWixEventsSchedulePublishDraftArgs = {
  input?: InputMaybe<WixEventsSchedulePublishDraftRequestInput>;
};


export type MutationWixEventsScheduleRescheduleDraftArgs = {
  input?: InputMaybe<WixEventsScheduleRescheduleDraftRequestInput>;
};


export type MutationWixEventsScheduleUpdateScheduleItemArgs = {
  input?: InputMaybe<WixEventsScheduleUpdateScheduleItemRequestInput>;
};


export type MutationWixEventsUpdateEventArgs = {
  input?: InputMaybe<WixEventsUpdateEventRequestInput>;
};


export type MutationWixEventsUpdateRecurringStatusArgs = {
  input?: InputMaybe<WixEventsUpdateRecurringStatusRequestInput>;
};


export type MutationWixEventsV2ConsumeEventCopiedArgs = {
  input?: InputMaybe<WixEventsEventsEventCopiedInput>;
};


export type MutationWixEventsV2CreatePolicyArgs = {
  input?: InputMaybe<WixEventsV2CreatePolicyRequestInput>;
};


export type MutationWixEventsV2DeletePolicyArgs = {
  input?: InputMaybe<WixEventsV2DeletePolicyRequestInput>;
};


export type MutationWixEventsV2GetPolicyFromTrashBinArgs = {
  input?: InputMaybe<WixEventsV2GetPolicyFromTrashBinRequestInput>;
};


export type MutationWixEventsV2ReorderEventPoliciesArgs = {
  input?: InputMaybe<WixEventsV2ReorderEventPoliciesRequestInput>;
};


export type MutationWixEventsV2UpdatePolicyArgs = {
  input?: InputMaybe<WixEventsV2UpdatePolicyRequestInput>;
};


export type MutationWixEventsV2UpdatePolicySortIndexArgs = {
  input?: InputMaybe<WixEventsV2UpdatePolicySortIndexRequestInput>;
};


export type MutationWixFormsV1CloneFormFromTemplateMetaSiteArgs = {
  input?: InputMaybe<WixFormsV1CloneFormFromTemplateMetaSiteRequestInput>;
};


export type MutationWixFormsV1ConsumeMetaSiteSpecialEventArgs = {
  input?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteSpecialEventInput>;
};


export type MutationWixFormsV1ConsumeSitePropertiesEventArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4SitePropertiesNotificationInput>;
};


export type MutationWixFormsV1CreateStandaloneFormArgs = {
  input?: InputMaybe<WixFormsV1CreateStandaloneFormRequestInput>;
};


export type MutationWixFormsV1DeleteStandaloneFormArgs = {
  input?: InputMaybe<WixFormsV1DeleteStandaloneFormRequestInput>;
};


export type MutationWixFormsV1GetCheckoutOAuthClientIdArgs = {
  input?: InputMaybe<WixFormsV1GetCheckoutOAuthClientIdRequestInput>;
};


export type MutationWixFormsV1GetDeletedStandaloneFormArgs = {
  input?: InputMaybe<WixFormsV1GetDeletedStandaloneFormRequestInput>;
};


export type MutationWixFormsV1GetPublicClientSpecMapArgs = {
  input?: InputMaybe<WixFormsV1GetPublicClientSpecMapRequestInput>;
};


export type MutationWixFormsV1ListDeletedStandaloneFormsArgs = {
  input?: InputMaybe<WixFormsV1ListDeletedStandaloneFormsRequestInput>;
};


export type MutationWixFormsV1MoveStandaloneFormToMetaSiteArgs = {
  input?: InputMaybe<WixFormsV1MoveStandaloneFormToMetaSiteRequestInput>;
};


export type MutationWixFormsV1QueryStandaloneFormsArgs = {
  input?: InputMaybe<WixFormsV1QueryStandaloneFormsRequestInput>;
};


export type MutationWixFormsV1RedirectToStandaloneFormEditorArgs = {
  input?: InputMaybe<ComWixpressRestRawHttpRequestInput>;
};


export type MutationWixFormsV1RedirectToStandaloneFormEditorDashboardArgs = {
  input?: InputMaybe<ComWixpressRestRawHttpRequestInput>;
};


export type MutationWixFormsV1RemoveStandaloneFormFromTrashBinArgs = {
  input?: InputMaybe<WixFormsV1RemoveStandaloneFormFromTrashBinRequestInput>;
};


export type MutationWixFormsV1RestoreStandaloneFormFromTrashBinArgs = {
  input?: InputMaybe<WixFormsV1RestoreStandaloneFormFromTrashBinRequestInput>;
};


export type MutationWixFormsV4BulkCloneFormArgs = {
  input?: InputMaybe<WixFormsV4BulkCloneFormRequestInput>;
};


export type MutationWixFormsV4BulkCreateFormArgs = {
  input?: InputMaybe<WixFormsV4BulkCreateFormRequestInput>;
};


export type MutationWixFormsV4BulkDeleteFormArgs = {
  input?: InputMaybe<WixFormsV4BulkDeleteFormRequestInput>;
};


export type MutationWixFormsV4BulkRemoveDeletedFieldArgs = {
  input?: InputMaybe<WixFormsV4BulkRemoveDeletedFieldRequestInput>;
};


export type MutationWixFormsV4BulkUpdateFormTagsArgs = {
  input?: InputMaybe<WixFormsV4BulkUpdateFormTagsRequestInput>;
};


export type MutationWixFormsV4BulkUpdateFormTagsByFilterArgs = {
  input?: InputMaybe<WixFormsV4BulkUpdateFormTagsByFilterRequestInput>;
};


export type MutationWixFormsV4CloneFormArgs = {
  input?: InputMaybe<WixFormsV4CloneFormRequestInput>;
};


export type MutationWixFormsV4CloneFormFromTemplateArgs = {
  input?: InputMaybe<WixFormsV4CloneFormFromTemplateRequestInput>;
};


export type MutationWixFormsV4ConsumeFormDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixFormsV4ConsumeFormTemplateDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixFormsV4CountDeletedFormsArgs = {
  input?: InputMaybe<WixFormsV4CountDeletedFormsRequestInput>;
};


export type MutationWixFormsV4CountFormsArgs = {
  input?: InputMaybe<WixFormsV4CountFormsRequestInput>;
};


export type MutationWixFormsV4CountFormsByFilterArgs = {
  input?: InputMaybe<WixFormsV4CountFormsByFilterRequestInput>;
};


export type MutationWixFormsV4CreateFormArgs = {
  input?: InputMaybe<WixFormsV4CreateFormRequestInput>;
};


export type MutationWixFormsV4CreateMigratedFormArgs = {
  input?: InputMaybe<WixFormsV4CreateMigratedFormRequestInput>;
};


export type MutationWixFormsV4DeleteFormArgs = {
  input?: InputMaybe<WixFormsV4DeleteFormRequestInput>;
};


export type MutationWixFormsV4DeleteFormFromTrashBinArgs = {
  input?: InputMaybe<WixFormsV4DeleteFormFromTrashBinRequestInput>;
};


export type MutationWixFormsV4GetDeletedFormArgs = {
  input?: InputMaybe<WixFormsV4GetDeletedFormRequestInput>;
};


export type MutationWixFormsV4GetFormSummaryArgs = {
  input?: InputMaybe<WixFormsV4GetFormSummaryRequestInput>;
};


export type MutationWixFormsV4ListDeletedFormsArgs = {
  input?: InputMaybe<WixFormsV4ListDeletedFormsRequestInput>;
};


export type MutationWixFormsV4ListFormsArgs = {
  input?: InputMaybe<WixFormsV4ListFormsRequestInput>;
};


export type MutationWixFormsV4ListTemplateExtensionsArgs = {
  input?: InputMaybe<WixFormsV4ListTemplateExtensionsRequestInput>;
};


export type MutationWixFormsV4QueryDeletedFormsArgs = {
  input?: InputMaybe<WixFormsV4QueryDeletedFormsRequestInput>;
};


export type MutationWixFormsV4QueryFormsArgs = {
  input?: InputMaybe<WixFormsV4QueryFormsRequestInput>;
};


export type MutationWixFormsV4RemoveFormFromTrashBinArgs = {
  input?: InputMaybe<WixFormsV4RemoveFormFromTrashBinRequestInput>;
};


export type MutationWixFormsV4RestoreFromTrashBinArgs = {
  input?: InputMaybe<WixFormsV4RestoreFromTrashBinRequestInput>;
};


export type MutationWixFormsV4UpdateExtendedFieldsArgs = {
  input?: InputMaybe<WixCommonDataDataextensionsUpdateExtendedFieldsRequestInput>;
};


export type MutationWixFormsV4UpdateFormArgs = {
  input?: InputMaybe<WixFormsV4UpdateFormRequestInput>;
};


export type MutationWixGiftCardsGiftCardV1ConsumeGiftCardsAndStoreCreditAppsProvisionedEventsArgs = {
  input?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteSpecialEventInput>;
};


export type MutationWixGiftCardsGiftCardV1ConsumeGiftCardsAppProvisionedEventsArgs = {
  input?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteSpecialEventInput>;
};


export type MutationWixGiftCardsGiftCardV1ConsumeSiteCurrencyUpdatesArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4SitePropertiesNotificationInput>;
};


export type MutationWixGiftCardsGiftCardV1ConsumeSitePropertiesUpdatesArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4SitePropertiesNotificationInput>;
};


export type MutationWixGiftCardsGiftCardV1ConsumeTriggerGiftCardsAppInstallationFlowEventsArgs = {
  input?: InputMaybe<WixGiftCardsGiftCardV1TriggerGiftCardsAppInstallationFlowEventInput>;
};


export type MutationWixGiftCardsGiftCardV1CountGiftCardsArgs = {
  input?: InputMaybe<WixGiftCardsGiftCardV1CountGiftCardsRequestInput>;
};


export type MutationWixGiftCardsGiftCardV1CreateGiftCardArgs = {
  input?: InputMaybe<WixGiftCardsGiftCardV1CreateGiftCardRequestInput>;
};


export type MutationWixGiftCardsGiftCardV1DisableGiftCardArgs = {
  input?: InputMaybe<WixGiftCardsGiftCardV1DisableGiftCardRequestInput>;
};


export type MutationWixGiftCardsGiftCardV1FulfillGiftCardOrderArgs = {
  input?: InputMaybe<WixGiftCardsGiftCardV1FulfillGiftCardOrderRequestInput>;
};


export type MutationWixGiftCardsGiftCardV1ListGiftCardsByEmailArgs = {
  input?: InputMaybe<WixGiftCardsGiftCardV1ListGiftCardsByEmailRequestInput>;
};


export type MutationWixGiftCardsGiftCardV1SearchGiftCardsArgs = {
  input?: InputMaybe<WixGiftCardsGiftCardV1SearchGiftCardsRequestInput>;
};


export type MutationWixGiftCardsGiftCardV1SendGiftCardEmailArgs = {
  input?: InputMaybe<WixGiftCardsGiftCardV1SendGiftCardEmailRequestInput>;
};


export type MutationWixHeadlessV1CreateOAuthAppArgs = {
  input?: InputMaybe<WixHeadlessV1CreateOAuthAppRequestInput>;
};


export type MutationWixHeadlessV1DeleteOAuthAppArgs = {
  input?: InputMaybe<WixHeadlessV1DeleteOAuthAppRequestInput>;
};


export type MutationWixHeadlessV1GenerateOAuthAppSecretArgs = {
  input?: InputMaybe<WixHeadlessV1GenerateOAuthAppSecretRequestInput>;
};


export type MutationWixHeadlessV1QueryOAuthAppArgs = {
  input?: InputMaybe<WixHeadlessV1QueryOAuthAppsRequestInput>;
};


export type MutationWixHeadlessV1SiteClonedArgs = {
  input?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteSpecialEventInput>;
};


export type MutationWixHeadlessV1SitePublishedArgs = {
  input?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteSpecialEventInput>;
};


export type MutationWixHeadlessV1UpdateOAuthAppArgs = {
  input?: InputMaybe<WixHeadlessV1UpdateOAuthAppRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3ApplyCouponArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3ApplyCouponRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3BulkAddAllToProgramArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3BulkAddAllToProgramRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3BulkAddToProgramArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3BulkAddToProgramRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3BulkApproveAllParticipantArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3BulkApproveAllParticipantRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3BulkApproveParticipantArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3BulkApproveParticipantRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3BulkCreateResolvedStepMigrationArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3BulkCreateResolvedStepMigrationRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3BulkInviteAllToProgramArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3BulkInviteAllToProgramRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3BulkInviteToProgramArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3BulkInviteToProgramRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3CompleteParticipantArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3CompleteParticipantRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3ConsumeBenefitsEventsArgs = {
  input?: InputMaybe<ComWixPricingplansBenefitsApiV2BenefitNotificationInput>;
};


export type MutationWixOnlineprogramsParticipantsV3ConsumeParticipantsBulkCompleteEventArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3ParticipantsBulkCompleteEventInput>;
};


export type MutationWixOnlineprogramsParticipantsV3ConsumeParticipantsBulkDeleteEventArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3ParticipantsBulkDeleteEventInput>;
};


export type MutationWixOnlineprogramsParticipantsV3ConsumePaymentEventsArgs = {
  input?: InputMaybe<WixPaymentApiPayV3PaymentEventInput>;
};


export type MutationWixOnlineprogramsParticipantsV3DeleteAllParticipantResolvedStepsArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3DeleteAllParticipantResolvedStepsRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3DeleteParticipantArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3DeleteParticipantRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3ExportParticipantsStatsArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3ExportParticipantsStatsRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3GetAccessStatusArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationWixOnlineprogramsParticipantsV3GetCompletionStatsArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3GetCompletionStatsRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3GetPremiumStatsArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationWixOnlineprogramsParticipantsV3GetProgramSummariesArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3GetProgramSummariesRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3GetResolvedStepArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3GetResolvedStepRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3GetStatisticsArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3GetStatisticsRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3IssueCertificateArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3IssueCertificateRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3JoinProgramArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3JoinProgramRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3LeaveProgramArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3LeaveProgramRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3ListResolvedStepsArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3ListResolvedStepsRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3QueryProgramSummariesArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3QueryProgramSummariesRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3QueryResolvedStepsArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3QueryResolvedStepsRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3ResolveStepArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3ResolveStepRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3RevertCouponArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3RevertCouponRequestInput>;
};


export type MutationWixOnlineprogramsParticipantsV3UndoStepArgs = {
  input?: InputMaybe<WixOnlineprogramsParticipantsV3UndoStepRequestInput>;
};


export type MutationWixOnlineprogramsProgramsV3ArchiveProgramArgs = {
  input?: InputMaybe<WixOnlineprogramsProgramsV3ArchiveProgramRequestInput>;
};


export type MutationWixOnlineprogramsProgramsV3BulkCreateProgramsMigrationArgs = {
  input?: InputMaybe<WixOnlineprogramsProgramsV3BulkCreateProgramsMigrationRequestInput>;
};


export type MutationWixOnlineprogramsProgramsV3BulkUpdateProgramsArgs = {
  input?: InputMaybe<WixOnlineprogramsProgramsV3BulkUpdateProgramsRequestInput>;
};


export type MutationWixOnlineprogramsProgramsV3ConsumeMetaSiteSpecialEventsArgs = {
  input?: InputMaybe<ComWixpressMetasiteEventApiMetaSiteSpecialEventInput>;
};


export type MutationWixOnlineprogramsProgramsV3ConsumeSitePropertiesUpdatedEventsArgs = {
  input?: InputMaybe<ComWixpressSitepropertiesApiV4SitePropertiesUpdatedInput>;
};


export type MutationWixOnlineprogramsProgramsV3ConsumeSiteSearchIndexingEventsArgs = {
  input?: InputMaybe<WixSearchV1SearchIndexingNotificationInput>;
};


export type MutationWixOnlineprogramsProgramsV3CountProgramsArgs = {
  input?: InputMaybe<WixOnlineprogramsProgramsV3CountProgramsRequestInput>;
};


export type MutationWixOnlineprogramsProgramsV3CreateProgramArgs = {
  input?: InputMaybe<WixOnlineprogramsProgramsV3CreateProgramRequestInput>;
};


export type MutationWixOnlineprogramsProgramsV3DeleteProgramArgs = {
  input?: InputMaybe<WixOnlineprogramsProgramsV3DeleteProgramRequestInput>;
};


export type MutationWixOnlineprogramsProgramsV3DuplicateProgramArgs = {
  input?: InputMaybe<WixOnlineprogramsProgramsV3DuplicateProgramRequestInput>;
};


export type MutationWixOnlineprogramsProgramsV3EndProgramArgs = {
  input?: InputMaybe<WixOnlineprogramsProgramsV3EndProgramRequestInput>;
};


export type MutationWixOnlineprogramsProgramsV3GetProgramMembershipArgs = {
  input?: InputMaybe<WixOnlineprogramsProgramsV3GetProgramMembershipRequestInput>;
};


export type MutationWixOnlineprogramsProgramsV3ListProgramMembershipsArgs = {
  input?: InputMaybe<WixOnlineprogramsProgramsV3ListProgramMembershipsRequestInput>;
};


export type MutationWixOnlineprogramsProgramsV3ListSampleProgramsArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationWixOnlineprogramsProgramsV3PublishProgramArgs = {
  input?: InputMaybe<WixOnlineprogramsProgramsV3PublishProgramRequestInput>;
};


export type MutationWixOnlineprogramsProgramsV3ResolveProgramSlugArgs = {
  input?: InputMaybe<WixOnlineprogramsProgramsV3ResolveProgramSlugRequestInput>;
};


export type MutationWixOnlineprogramsProgramsV3SearchProgramsArgs = {
  input?: InputMaybe<WixOnlineprogramsProgramsV3SearchProgramsRequestInput>;
};


export type MutationWixOnlineprogramsProgramsV3UpdateProgramArgs = {
  input?: InputMaybe<WixOnlineprogramsProgramsV3UpdateProgramRequestInput>;
};


export type MutationWixOnlineprogramsStepsV3BulkCloneStepArgs = {
  input?: InputMaybe<WixOnlineprogramsStepsV3BulkCloneStepRequestInput>;
};


export type MutationWixOnlineprogramsStepsV3BulkCreateStepArgs = {
  input?: InputMaybe<WixOnlineprogramsStepsV3BulkCreateStepRequestInput>;
};


export type MutationWixOnlineprogramsStepsV3BulkCreateStepMigrationArgs = {
  input?: InputMaybe<WixOnlineprogramsStepsV3BulkCreateStepMigrationRequestInput>;
};


export type MutationWixOnlineprogramsStepsV3CloneStepArgs = {
  input?: InputMaybe<WixOnlineprogramsStepsV3CloneStepRequestInput>;
};


export type MutationWixOnlineprogramsStepsV3CreateStepArgs = {
  input?: InputMaybe<WixOnlineprogramsStepsV3CreateStepRequestInput>;
};


export type MutationWixOnlineprogramsStepsV3DeleteAllProgramStepsArgs = {
  input?: InputMaybe<WixOnlineprogramsStepsV3DeleteAllProgramStepsRequestInput>;
};


export type MutationWixOnlineprogramsStepsV3DeleteStepArgs = {
  input?: InputMaybe<WixOnlineprogramsStepsV3DeleteStepRequestInput>;
};


export type MutationWixOnlineprogramsStepsV3ListAllProgramStepsArgs = {
  input?: InputMaybe<WixOnlineprogramsStepsV3ListAllProgramStepsRequestInput>;
};


export type MutationWixOnlineprogramsStepsV3MoveStepArgs = {
  input?: InputMaybe<WixOnlineprogramsStepsV3MoveStepRequestInput>;
};


export type MutationWixOnlineprogramsStepsV3QueryStepsArgs = {
  input?: InputMaybe<WixOnlineprogramsStepsV3QueryStepsRequestInput>;
};


export type MutationWixOnlineprogramsStepsV3QueryStepsWithoutPagingArgs = {
  input?: InputMaybe<WixOnlineprogramsStepsV3QueryStepsWithoutPagingRequestInput>;
};


export type MutationWixOnlineprogramsStepsV3UpdateStepArgs = {
  input?: InputMaybe<WixOnlineprogramsStepsV3UpdateStepRequestInput>;
};


export type MutationWixPaymentsPaymentAgreementsV1CreatePaymentAgreementArgs = {
  input?: InputMaybe<WixPaymentsPaymentAgreementsV1CreatePaymentAgreementRequestInput>;
};


export type MutationWixPaymentsPaymentAgreementsV1DeletePaymentAgreementArgs = {
  input?: InputMaybe<WixPaymentsPaymentAgreementsV1DeletePaymentAgreementRequestInput>;
};


export type MutationWixPaymentsPaymentAgreementsV1FinalizePaymentAgreementArgs = {
  input?: InputMaybe<WixPaymentsPaymentAgreementsV1FinalizePaymentAgreementRequestInput>;
};


export type MutationWixPaymentsPaymentAgreementsV1UpdateExtendedFieldsArgs = {
  input?: InputMaybe<WixPaymentsPaymentAgreementsV1UpdateExtendedFieldsRequestInput>;
};


export type MutationWixPaymentsPaymentAgreementsV1UpdatePaymentAgreementArgs = {
  input?: InputMaybe<WixPaymentsPaymentAgreementsV1UpdatePaymentAgreementRequestInput>;
};


export type MutationWixPaymentsRefundsV1CreateRefundArgs = {
  input?: InputMaybe<WixPaymentsRefundsV1CreateRefundRequestInput>;
};


export type MutationWixPaymentsRefundsV1GetRefundabilityArgs = {
  input?: InputMaybe<WixPaymentsRefundsV1GetRefundabilityRequestInput>;
};


export type MutationWixPaymentsRefundsV1SyncRefundArgs = {
  input?: InputMaybe<WixPaymentsRefundsV1InternalSyncRefundRequestInput>;
};


export type MutationWixPaymentsRefundsV1UpdateExtendedFieldsArgs = {
  input?: InputMaybe<WixCommonDataDataextensionsUpdateExtendedFieldsRequestInput>;
};


export type MutationWixPaymentsSavedPaymentMethodsV1DeleteSavedPaymentMethodArgs = {
  input?: InputMaybe<WixPaymentsSavedPaymentMethodsV1DeleteSavedPaymentMethodRequestInput>;
};


export type MutationWixPaymentsSavedPaymentMethodsV1FindSavedCreditCardArgs = {
  input?: InputMaybe<WixPaymentsSavedPaymentMethodsV1FindSavedCreditCardRequestInput>;
};


export type MutationWixPaymentsSavedPaymentMethodsV1ListSavedPaymentMethodsArgs = {
  input?: InputMaybe<WixPaymentsSavedPaymentMethodsV1ListSavedPaymentMethodsRequestInput>;
};


export type MutationWixPaymentsSavedPaymentMethodsV1MarkSavedPaymentMethodPrimaryArgs = {
  input?: InputMaybe<WixPaymentsSavedPaymentMethodsV1MarkSavedPaymentMethodPrimaryRequestInput>;
};


export type MutationWixPaymentsSavedPaymentMethodsV1UpdateSavedPaymentMethodArgs = {
  input?: InputMaybe<WixPaymentsSavedPaymentMethodsV1UpdateSavedPaymentMethodRequestInput>;
};


export type MutationWixPaymentsSavedPaymentMethodsV1UpsertSavedPaymentMethodArgs = {
  input?: InputMaybe<WixPaymentsSavedPaymentMethodsV1UpsertSavedPaymentMethodRequestInput>;
};


export type MutationWixPaymentsSitePaymentMethodTypesV1ListSitePaymentMethodTypesArgs = {
  input?: InputMaybe<WixPaymentsSitePaymentMethodTypesV1ListSitePaymentMethodTypesRequestInput>;
};


export type MutationWixReceiptsV1ConsumeGenerateReceiptDocumentEventsArgs = {
  input?: InputMaybe<WixReceiptsV1EventsGenerateReceiptDocumentInput>;
};


export type MutationWixReceiptsV1ConsumeReceiptDocumentHandledEventsArgs = {
  input?: InputMaybe<WixReceiptsV1EventsReceiptDocumentHandledInput>;
};


export type MutationWixReceiptsV1ConsumeReceiptNumberingProcessEventsArgs = {
  input?: InputMaybe<WixReceiptsV1EventsReceiptNumberingProcessInput>;
};


export type MutationWixReceiptsV1CreateReceiptArgs = {
  input?: InputMaybe<WixReceiptsV1CreateReceiptRequestInput>;
};


export type MutationWixReceiptsV1GetLatestReceiptNumberArgs = {
  input?: InputMaybe<WixReceiptsV1GetLatestReceiptNumberRequestInput>;
};


export type MutationWixReceiptsV1RegenerateReceiptDocumentArgs = {
  input?: InputMaybe<WixReceiptsV1RegenerateReceiptDocumentRequestInput>;
};


export type MutationWixReceiptsV1SendReceiptEmailArgs = {
  input?: InputMaybe<WixReceiptsV1SendReceiptEmailRequestInput>;
};


export type MutationWixReceiptsV1UpdateExtendedFieldsArgs = {
  input?: InputMaybe<WixCommonDataDataextensionsUpdateExtendedFieldsRequestInput>;
};


export type MutationWixReceiptsV1UpdateReceiptArgs = {
  input?: InputMaybe<WixReceiptsV1BackofficeUpdateReceiptRequestInput>;
};


export type MutationWixRestaurantsMenusItemModifierV1BulkCreateModifiersArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemModifierV1BulkCreateModifiersRequestInput>;
};


export type MutationWixRestaurantsMenusItemModifierV1BulkDeleteModifiersArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemModifierV1BulkDeleteModifiersRequestInput>;
};


export type MutationWixRestaurantsMenusItemModifierV1BulkUpdateAttachedToOrphanItemArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemModifierV1BulkUpdateAttachedToOrphanItemRequestInput>;
};


export type MutationWixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsRequestInput>;
};


export type MutationWixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsPerEntityArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsPerEntityRequestInput>;
};


export type MutationWixRestaurantsMenusItemModifierV1BulkUpdateModifiersArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemModifierV1BulkUpdateModifiersRequestInput>;
};


export type MutationWixRestaurantsMenusItemModifierV1CloneModifiersArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemModifierV1CloneModifiersRequestInput>;
};


export type MutationWixRestaurantsMenusItemModifierV1ConsumeModifiersDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixRestaurantsMenusItemModifierV1CountModifiersArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemModifierV1CountModifiersRequestInput>;
};


export type MutationWixRestaurantsMenusItemModifierV1CreateModifierArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemModifierV1CreateModifierRequestInput>;
};


export type MutationWixRestaurantsMenusItemModifierV1DeleteModifierArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemModifierV1DeleteModifierRequestInput>;
};


export type MutationWixRestaurantsMenusItemModifierV1ListModifiersArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemModifierV1ListModifiersRequestInput>;
};


export type MutationWixRestaurantsMenusItemModifierV1SyncContentToMultilingualArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemModifierV1SyncContentToMultilingualRequestInput>;
};


export type MutationWixRestaurantsMenusItemModifierV1UpdateModifierArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemModifierV1UpdateModifierRequestInput>;
};


export type MutationWixRestaurantsMenusItemVariantV1BulkCreateVariantsArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemVariantV1BulkCreateVariantsRequestInput>;
};


export type MutationWixRestaurantsMenusItemVariantV1BulkDeleteVariantsArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemVariantV1BulkDeleteVariantsRequestInput>;
};


export type MutationWixRestaurantsMenusItemVariantV1BulkUpdateAttachedToOrphanItemArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemVariantV1BulkUpdateAttachedToOrphanItemRequestInput>;
};


export type MutationWixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsRequestInput>;
};


export type MutationWixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsPerEntityArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsPerEntityRequestInput>;
};


export type MutationWixRestaurantsMenusItemVariantV1BulkUpdateVariantsArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemVariantV1BulkUpdateVariantsRequestInput>;
};


export type MutationWixRestaurantsMenusItemVariantV1CloneVariantsArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemVariantV1CloneVariantsRequestInput>;
};


export type MutationWixRestaurantsMenusItemVariantV1ConsumeVariantsDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixRestaurantsMenusItemVariantV1CountVariantsArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemVariantV1CountVariantsRequestInput>;
};


export type MutationWixRestaurantsMenusItemVariantV1CreateVariantArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemVariantV1CreateVariantRequestInput>;
};


export type MutationWixRestaurantsMenusItemVariantV1DeleteVariantArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemVariantV1DeleteVariantRequestInput>;
};


export type MutationWixRestaurantsMenusItemVariantV1ListVariantsArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemVariantV1ListVariantsRequestInput>;
};


export type MutationWixRestaurantsMenusItemVariantV1UpdateVariantArgs = {
  input?: InputMaybe<WixRestaurantsMenusItemVariantV1UpdateVariantRequestInput>;
};


export type MutationWixRestaurantsMenusV1AddModifiersToGroupUnlimitedArgs = {
  input?: InputMaybe<WixRestaurantsMenusV1AddModifiersToGroupUnlimitedRequestInput>;
};


export type MutationWixRestaurantsMenusV1BulkCreateModifierGroupsArgs = {
  input?: InputMaybe<WixRestaurantsMenusV1BulkCreateModifierGroupsRequestInput>;
};


export type MutationWixRestaurantsMenusV1BulkDeleteModifierGroupsArgs = {
  input?: InputMaybe<WixRestaurantsMenusV1BulkDeleteModifierGroupsRequestInput>;
};


export type MutationWixRestaurantsMenusV1BulkUpdateAttachedToOrphanItemArgs = {
  input?: InputMaybe<WixRestaurantsMenusV1BulkUpdateAttachedToOrphanItemRequestInput>;
};


export type MutationWixRestaurantsMenusV1BulkUpdateBusinessLocationIdsArgs = {
  input?: InputMaybe<WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsRequestInput>;
};


export type MutationWixRestaurantsMenusV1BulkUpdateBusinessLocationIdsPerEntityArgs = {
  input?: InputMaybe<WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsPerEntityRequestInput>;
};


export type MutationWixRestaurantsMenusV1BulkUpdateModifierGroupsArgs = {
  input?: InputMaybe<WixRestaurantsMenusV1BulkUpdateModifierGroupsRequestInput>;
};


export type MutationWixRestaurantsMenusV1CloneModifierGroupsArgs = {
  input?: InputMaybe<WixRestaurantsMenusV1CloneModifierGroupsRequestInput>;
};


export type MutationWixRestaurantsMenusV1ConsumeDeleteLocationIdsFromModifiersArgs = {
  input?: InputMaybe<WixRestaurantsMenusV1DeleteLocationIdsFromModifiersInput>;
};


export type MutationWixRestaurantsMenusV1ConsumeModifierGroupsDomainEventsArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixRestaurantsMenusV1CountModifierGroupsArgs = {
  input?: InputMaybe<WixRestaurantsMenusV1CountModifierGroupsRequestInput>;
};


export type MutationWixRestaurantsMenusV1CreateModifierGroupArgs = {
  input?: InputMaybe<WixRestaurantsMenusV1CreateModifierGroupRequestInput>;
};


export type MutationWixRestaurantsMenusV1DeleteModifierGroupArgs = {
  input?: InputMaybe<WixRestaurantsMenusV1DeleteModifierGroupRequestInput>;
};


export type MutationWixRestaurantsMenusV1ListModifierGroupsArgs = {
  input?: InputMaybe<WixRestaurantsMenusV1ListModifierGroupRequestInput>;
};


export type MutationWixRestaurantsMenusV1SyncContentToMultilingualArgs = {
  input?: InputMaybe<WixRestaurantsMenusV1SyncContentToMultilingualRequestInput>;
};


export type MutationWixRestaurantsMenusV1UpdateModifierGroupArgs = {
  input?: InputMaybe<WixRestaurantsMenusV1UpdateModifierGroupRequestInput>;
};


export type MutationWixRiseV1AddCustomerReferenceArgs = {
  input?: InputMaybe<WixRiseV1AddCustomerReferenceRequestInput>;
};


export type MutationWixRiseV1BulkCreateMigrationTransactionsArgs = {
  input?: InputMaybe<WixRiseV1BulkCreateMigrationTransactionsRequestInput>;
};


export type MutationWixRiseV1BulkCreateMigrationWalletActionsArgs = {
  input?: InputMaybe<WixRiseV1BulkCreateMigrationWalletActionsRequestInput>;
};


export type MutationWixRiseV1BulkDeleteGiftCardsByFilterArgs = {
  input?: InputMaybe<WixRiseV1BulkDeleteGiftCardsByFilterRequestInput>;
};


export type MutationWixRiseV1BulkEndMigrationWalletActionsArgs = {
  input?: InputMaybe<WixRiseV1BulkEndMigrationWalletActionsRequestInput>;
};


export type MutationWixRiseV1BulkUpdateWalletActionTagsArgs = {
  input?: InputMaybe<WixRiseV1BulkUpdateWalletActionTagsRequestInput>;
};


export type MutationWixRiseV1BulkUpdateWalletActionTagsByFilterArgs = {
  input?: InputMaybe<WixRiseV1BulkUpdateWalletActionTagsByFilterRequestInput>;
};


export type MutationWixRiseV1ConsumeGiftCardEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixRiseV1ConsumeWalletActionEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixRiseV1ConsumeWalletEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixRiseV1CountGiftCardsArgs = {
  input?: InputMaybe<WixRiseV1CountGiftCardsRequestInput>;
};


export type MutationWixRiseV1CountWalletsArgs = {
  input?: InputMaybe<WixRiseV1CountWalletsRequestInput>;
};


export type MutationWixRiseV1CreateCustomerReferenceArgs = {
  input?: InputMaybe<WixRiseV1CreateCustomerReferenceRequestInput>;
};


export type MutationWixRiseV1CreateGiftCardArgs = {
  input?: InputMaybe<WixRiseV1CreateGiftCardRequestInput>;
};


export type MutationWixRiseV1CreateMigrationGiftCardArgs = {
  input?: InputMaybe<WixRiseV1CreateMigrationGiftCardRequestInput>;
};


export type MutationWixRiseV1CreateMigrationTransactionArgs = {
  input?: InputMaybe<WixRiseV1CreateMigrationTransactionRequestInput>;
};


export type MutationWixRiseV1CreateMigrationWalletActionArgs = {
  input?: InputMaybe<WixRiseV1CreateMigrationWalletActionRequestInput>;
};


export type MutationWixRiseV1CreateWalletArgs = {
  input?: InputMaybe<WixRiseV1CreateWalletRequestInput>;
};


export type MutationWixRiseV1CreateWalletActionArgs = {
  input?: InputMaybe<WixRiseV1CreateWalletActionRequestInput>;
};


export type MutationWixRiseV1CreateWalletActionByCustomerReferenceArgs = {
  input?: InputMaybe<WixRiseV1CreateWalletActionByCustomerReferenceRequestInput>;
};


export type MutationWixRiseV1CreateWalletV2Args = {
  input?: InputMaybe<WixRiseV1CreateWalletV2RequestInput>;
};


export type MutationWixRiseV1DecreaseBalanceArgs = {
  input?: InputMaybe<WixRiseV1DecreaseBalanceRequestInput>;
};


export type MutationWixRiseV1DeleteCustomerReferenceArgs = {
  input?: InputMaybe<WixRiseV1DeleteCustomerReferenceRequestInput>;
};


export type MutationWixRiseV1DeleteWalletActionArgs = {
  input?: InputMaybe<WixRiseV1DeleteWalletActionRequestInput>;
};


export type MutationWixRiseV1DisableGiftCardArgs = {
  input?: InputMaybe<WixRiseV1DisableGiftCardRequestInput>;
};


export type MutationWixRiseV1DisableWalletActionArgs = {
  input?: InputMaybe<WixRiseV1DisableWalletActionRequestInput>;
};


export type MutationWixRiseV1EndMigrationWalletActionArgs = {
  input?: InputMaybe<WixRiseV1EndMigrationWalletActionRequestInput>;
};


export type MutationWixRiseV1GetCustomerReferenceArgs = {
  input?: InputMaybe<WixRiseV1GetCustomerReferenceRequestInput>;
};


export type MutationWixRiseV1GetGiftCardConsistentArgs = {
  input?: InputMaybe<WixRiseV1GetGiftCardConsistentRequestInput>;
};


export type MutationWixRiseV1GetOrCreateWalletArgs = {
  input?: InputMaybe<WixRiseV1GetOrCreateWalletRequestInput>;
};


export type MutationWixRiseV1GetOrCreateWalletV2Args = {
  input?: InputMaybe<WixRiseV1GetOrCreateWalletV2RequestInput>;
};


export type MutationWixRiseV1GetRefundableAmountsArgs = {
  input?: InputMaybe<WixRiseV1GetRefundableAmountsRequestInput>;
};


export type MutationWixRiseV1GetWalletArgs = {
  input?: InputMaybe<WixRiseV1GetWalletRequestInput>;
};


export type MutationWixRiseV1GetWalletGiftCardArgs = {
  input?: InputMaybe<WixRiseV1GetWalletGiftCardRequestInput>;
};


export type MutationWixRiseV1GetWalletV2Args = {
  input?: InputMaybe<WixRiseV1GetWalletV2RequestInput>;
};


export type MutationWixRiseV1HandleEvenExpirationTaskArgs = {
  input?: InputMaybe<WixInfraTimecapsuleV2TaskInput>;
};


export type MutationWixRiseV1HandleEvenStartTaskArgs = {
  input?: InputMaybe<WixInfraTimecapsuleV2TaskInput>;
};


export type MutationWixRiseV1HandleWalletActionEventArgs = {
  input?: InputMaybe<WixCommonDomaineventsDomainEventInput>;
};


export type MutationWixRiseV1IncreaseBalanceArgs = {
  input?: InputMaybe<WixRiseV1IncreaseBalanceRequestInput>;
};


export type MutationWixRiseV1IssueStoreCreditArgs = {
  input?: InputMaybe<WixRiseV1IssueStoreCreditRequestInput>;
};


export type MutationWixRiseV1MigrateWalletArgs = {
  input?: InputMaybe<WixRiseV1MigrateWalletRequestInput>;
};


export type MutationWixRiseV1ProduceTransactionAddedEventArgs = {
  input?: InputMaybe<WixRiseV1ProduceTransactionAddedEventRequestInput>;
};


export type MutationWixRiseV1QueryGiftCardsArgs = {
  input?: InputMaybe<WixRiseV1QueryGiftCardsRequestInput>;
};


export type MutationWixRiseV1QueryTransactionsArgs = {
  input?: InputMaybe<WixRiseV1QueryTransactionsRequestInput>;
};


export type MutationWixRiseV1QueryTransactionsInternalArgs = {
  input?: InputMaybe<WixRiseV1QueryTransactionsInternalRequestInput>;
};


export type MutationWixRiseV1QueryUnredeemedWalletActionsArgs = {
  input?: InputMaybe<WixRiseV1QueryUnredeemedWalletActionsRequestInput>;
};


export type MutationWixRiseV1QueryWalletActionsArgs = {
  input?: InputMaybe<WixRiseV1QueryWalletActionRequestInput>;
};


export type MutationWixRiseV1QueryWalletActionsBalancesArgs = {
  input?: InputMaybe<WixRiseV1QueryWalletActionBalancesRequestInput>;
};


export type MutationWixRiseV1QueryWalletsByContactArgs = {
  input?: InputMaybe<WixRiseV1QueryWalletsByContactRequestInput>;
};


export type MutationWixRiseV1RefundTransactionArgs = {
  input?: InputMaybe<WixRiseV1RefundTransactionRequestInput>;
};


export type MutationWixRiseV1RegenerateCodeArgs = {
  input?: InputMaybe<WixRiseV1RegenerateCodeRequestInput>;
};


export type MutationWixRiseV1SearchGiftCardsArgs = {
  input?: InputMaybe<WixRiseV1SearchGiftCardsRequestInput>;
};


export type MutationWixRiseV1UpdateCustomerReferenceArgs = {
  input?: InputMaybe<WixRiseV1UpdateCustomerReferenceRequestInput>;
};


export type MutationWixRiseV1UpdateGiftCardArgs = {
  input?: InputMaybe<WixRiseV1UpdateGiftCardRequestInput>;
};


export type MutationWixRiseV1UpdateLastActivityForRemindersArgs = {
  input?: InputMaybe<WixRiseV1UpdateLastActivityForRemindersRequestInput>;
};


export type MutationWixRiseV1UpdateWalletActionArgs = {
  input?: InputMaybe<WixRiseV1UpdateWalletActionRequestInput>;
};


export type MutationWixRiseV1VoidTransactionArgs = {
  input?: InputMaybe<WixRiseV1VoidTransactionRequestInput>;
};


export type MutationWixRiseWorkflowV1CreateWorkflowArgs = {
  input?: InputMaybe<WixRiseWorkflowV1CreateWorkflowRequestInput>;
};


export type MutationWixRiseWorkflowV1DeleteWorkflowArgs = {
  input?: InputMaybe<WixRiseWorkflowV1DeleteWorkflowRequestInput>;
};


export type MutationWixRiseWorkflowV1ListTriggersArgs = {
  input?: InputMaybe<Scalars['Void']>;
};


export type MutationWixRiseWorkflowV1ReportTriggerArgs = {
  input?: InputMaybe<WixRiseWorkflowV1ReportTriggerRequestInput>;
};


export type MutationWixRiseWorkflowV1UpdateWorkflowArgs = {
  input?: InputMaybe<WixRiseWorkflowV1UpdateWorkflowRequestInput>;
};

export type PageInfo = {
  /** Number of items returned in the response */
  count?: Maybe<Scalars['Int']>;
  /** An indication if we have next page */
  hasNext?: Maybe<Scalars['Boolean']>;
  /** Cursor to next */
  nextCursor?: Maybe<Scalars['String']>;
  /** Offset that was requested */
  offset?: Maybe<Scalars['Int']>;
  /** Cursor to prev */
  prevCursor?: Maybe<Scalars['String']>;
  /** Flag that indicates the server failed to calculate the `total` field */
  tooManyToCount?: Maybe<Scalars['Boolean']>;
  /** Total number of items that match the query. Returned if offset paging is used and the `tooManyToCount` flag is not set */
  total?: Maybe<Scalars['Int']>;
};

export type Query = {
  /**
   * Retrieves a session by ID.
   *
   *
   * By default, a session object is returned with the fields specified in the `NO_PI` fieldset. This means it doesn't contain personal information.
   * To retrieve a full session object including all personal information, use the `ALL_PI` fieldset. This requires the CALENDAR.SESSION_READ_PI permission scope.
   * @deprecated Deprecated
   */
  comWixBookingsSchedulesApiV1GetSession?: Maybe<ComWixBookingsSchedulesApiV1Session>;
  /**
   * Retrieves a session by ID.
   *
   *
   * By default, a session object is returned with the fields specified in the `NO_PI` fieldset. This means it doesn't contain personal information.
   * To retrieve a full session object including all personal information, use the `ALL_PI` fieldset. This requires the CALENDAR.SESSION_READ_PI permission scope.
   */
  comWixBookingsSchedulesApiV1Session?: Maybe<ComWixBookingsSchedulesApiV1Session>;
  /**
   * Retrieves a list of sessions, given the provided time range, filtering, and paging.
   *
   *
   * <blockquote class='warning'>
   *
   * __Deprecation Notice:__
   *
   * This endpoint has been replaced with
   * Calendar V3 [Query Events](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/query-events)
   * and External Calendar V2 [List Events](https://dev.wix.com/docs/rest/business-solutions/bookings/calendar/external-calendar-v2/list-events)
   * and will be removed on June 30, 2025.
   *
   * </blockquote>
   *
   * To query for event instances within a specified time range of up to 1 year, provide a `startDate` and `endDate`.
   *
   * Query Sessions runs with these defaults, which you can override:
   * - Only sessions of type `EVENT` are returned. An event is a single or recurring session that appears in a calendar, for example an appointment or a class.
   * - `instances` is true. This means only single session instances and instances of recurring sessions are returned.
   * - `includeExternal` is false. This means that sessions imported from connected external calendars are not returned.
   * - Session objects are returned with the fields specified in the `NO_PI` fieldset. This means they don't contain personal information.
   * - `query.cursorPaging.limit` is `100`.
   *
   * Note the following limitations, which you can't override:
   * - Sessions are always sorted by `start.timestamp` in `ASC` order.
   * - The maximum time range you can query for session instances is 1 year. If you are querying for recurring session definitions, rather than session instances, this limit doesn't apply.
   * - Pagination is not supported for recurring session definition queries.
   *
   * To query only for working hours sessions, set `type` to `WORKING_HOURS`. A working hours session is a single or recurring session that defines availability in a schedule.
   *
   * To query for all session types, including events and working hours sessions, set `type` to `ALL`.
   *
   * To query for recurring session pattern definitions, set `instances` to `false`. In this case, `fromDate` and `toDate` may be more than 1 year apart.
   *
   * To return session objects including personal information, use the `ALL_PI` fieldset. This requires the Read Bookings Calendar - Including Participants or the Manage Bookings Services and Settings or the Manage Business Calendar [permission scope](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/about-permissions).
   *
   * For details on fieldsets, see [Sessions: Supported Fieldsets](https://dev.wix.com/api/rest/wix-bookings/calendar/supported-fieldsets).
   *
   * For field support for filters, see [Sessions: Supported Filters](https://dev.wix.com/api/rest/wix-bookings/calendar/supported-filters).
   *
   * To learn about working with _Query_ endpoints in general, see
   * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) and
   * [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
   * @deprecated Deprecated
   */
  comWixBookingsSchedulesApiV1Sessions?: Maybe<ComWixBookingsCalendarApiV2QuerySessionsResponse>;
  /** Retrieves a discount rule. */
  comWixEcomDiscountsDiscountRule?: Maybe<ComWixEcomDiscountsDiscountRule>;
  /**
   * Query discount rules using [WQL (Wix Query Language)](https://dev.wix.com/api/rest/getting-started/api-query-language).
   * Total entries (`pagingMetadata.total`) will be returned only for the first page.
   *
   * > **Note:** `discountRule.status` can't be used for querying.
   */
  comWixEcomDiscountsDiscountRules?: Maybe<ComWixEcomDiscountsQueryDiscountRulesResponse>;
  /** Retrieves a discount rule. */
  comWixEcomDiscountsGetDiscountRule?: Maybe<ComWixEcomDiscountsDiscountRule>;
  comWixEcomOrdersPaymentsV1GetOrderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
  /**
   * Retrieves a list of order transactions, given the provided paging, filtering, and sorting.
   *
   * To learn about working with _Query_ endpoints, see
   * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language), and
   * [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).
   */
  comWixEcomOrdersPaymentsV1OrderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1QueryOrderTransactionsResponse>;
  /**
   * Retrieves an order with the provided ID.
   *
   * To retrieve an order's payment and refund details, including amounts, payment methods, and payment statuses,
   * pass the order ID to [List Transactions For Single Order](https://dev.wix.com/docs/rest/business-solutions/e-commerce/order-transactions/list-transactions-for-single-order).
   */
  comWixEcomOrdersV1GetOrder?: Maybe<ComWixEcomOrdersV1Order>;
  /** Retrieves an order with the provided ID. */
  comWixEcomOrdersV1Order?: Maybe<ComWixEcomOrdersV1Order>;
  /**
   * > **Note:** Use SearchOrders instead
   * Retrieves a list of orders, given the provided paging, filtering, and sorting.
   *
   *
   * Query Orders runs with these defaults, which you can override:
   *
   * - `createdDate` is sorted in `DESC` order
   * - `paging.limit` is `100`
   * - `paging.offset` is `0`
   * - `filter: {"status": {"$ne": "INITIALIZED"}}` - other order statuses can be queried, but orders with `status: "INITIALIZED"` are never returned
   *
   * For field support for filters and sorting, see [Orders: Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-solutions/e-commerce/orders/supported-filters-and-sorting).
   *
   * To learn about working with _Query_ endpoints, see
   * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language), and
   * [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).
   * @deprecated Deprecated
   */
  comWixEcomOrdersV1Orders?: Maybe<ComWixEcomOrdersV1QueryOrderResponse>;
  /** Retrieves attendance information by ID. */
  comWixpressBookingsAttendanceV2Attendance?: Maybe<ComWixpressBookingsAttendanceV2Attendance>;
  /**
   * Retrieves up to 100 `attendance` objects, given the specified
   * paging, filtering, and sorting.
   *
   *
   * When querying attendance information, you can query from the perspective of:
   * + **A booking.** Specify a booking ID to retrieve attendance information
   * for all sessions related to that booking. For example, query by `bookingId`
   * for a course booking to retrieve a participant's attendance for all course
   * sessions.
   * + **A session.** Specify a session ID to retrieve attendance information
   * for all bookings related to that session.
   *
   * Query Attendance runs with the following defaults, which you can override:
   * - `id` sorted in `ASC` order.
   * - `cursorPaging.limit` set to `50`.
   *
   * For field support, see [supported filters](https://dev.wix.com/api/rest/wix-bookings/attendance/supported-filters).
   *
   * Only a single filter is supported per query. If you define multiple filters
   * in the same query, only the first is processed.
   *
   * To learn about working with query methods, see
   * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
   */
  comWixpressBookingsAttendanceV2Attendances?: Maybe<ComWixpressBookingsAttendanceV2QueryAttendanceResponse>;
  /** Retrieves attendance information. */
  comWixpressBookingsAttendanceV2GetAttendance?: Maybe<ComWixpressBookingsAttendanceV2Attendance>;
  /** Retrieves an item from a collection. */
  comWixpressCloudDataApiDataDataItem?: Maybe<ComWixpressCloudDataApiDataDataItem>;
  /**
   * Retrieves a list of items, on the basis of the filtering, sorting, and paging preferences you provide.
   *
   *
   * Learn more about [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
   */
  comWixpressCloudDataApiDataDataItems?: Maybe<ComWixpressCloudDataApiDataQueryDataItemsResponse>;
  /** Retrieves an item from a collection. */
  comWixpressCloudDataApiDataGetDataItem?: Maybe<ComWixpressCloudDataApiDataDataItem>;
  /**
   * Retrieves a list of contacts, given the provided [paging](https://dev.wix.com/api/rest/getting-started/sorting-and-paging#getting-started_sorting-and-paging_paging), [filtering, and sorting](https://dev.wix.com/docs/rest/crm/members-contacts/contacts/contacts/contact-v4/sort-filter-and-search).
   *
   * Up to 1,000 contacts can be returned per request.
   * Query Contacts runs with these defaults, which you can override:
   *
   * - `createdDate` is sorted in `ASC` order
   * - `paging.limit` is `50`
   * - `paging.offset` is `0`
   *
   *
   * For field support for filters and sorting, see
   * [Contacts: Supported Filters and Sorting](https://dev.wix.com/docs/rest/crm/members-contacts/contacts/contacts/contact-v4/sort-filter-and-search).
   *
   * To learn about working with _Query_ methods, see
   * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language),
   * [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging),
   * and [Field Projection](https://dev.wix.com/docs/rest/articles/getting-started/field-projection).
   */
  comWixpressContactsCoreApiV4Contacts?: Maybe<ComWixpressContactsCoreApiV4QueryContactsResponse>;
  /**
   * Retrieves a contact.
   *
   * #### Getting Merged Contacts
   *
   * When a source contact is merged
   * with a target contact, the source contact is deleted.
   * When calling Get Contact for a merged contact,
   * you can use the source or target contact ID.
   * In both bases, the target contact is returned.
   *
   * This is supported only when calling Get Contact on merged contacts.
   * Previously deleted source contact IDs can't be used for any other method.
   */
  comWixpressContactsCoreApiV4GetContact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
  /** Retrieves an extended field. */
  comWixpressContactsFieldsV4ExtendedField?: Maybe<ComWixpressContactsFieldsV4ExtendedField>;
  /**
   * Retrieves a list of extended fields.
   *
   * For a detailed list of supported operations, see [sorting and filtering for extended fields](https://dev.wix.com/api/rest/contacts/extended-fields/sort-and-filter). To learn more about query language, see
   * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
   */
  comWixpressContactsFieldsV4Fields?: Maybe<ComWixpressContactsFieldsV4QueryExtendedFieldsResponse>;
  /** Retrieves an extended field by the specified extended field key. */
  comWixpressContactsFieldsV4GetExtendedField?: Maybe<ComWixpressContactsFieldsV4ExtendedField>;
  /** Retrieves a label. */
  comWixpressContactsLabelsV4ContactLabel?: Maybe<ComWixpressContactsLabelsV4ContactLabel>;
  /** Retrieves a label by the specified label key. */
  comWixpressContactsLabelsV4GetContactLabel?: Maybe<ComWixpressContactsLabelsV4ContactLabel>;
  /**
   * Retrieves a list of contact labels. Up to 1,000 labels can be returned per request.
   *
   * For a detailed list of supported operations, see [sorting and filtering for labels](https://dev.wix.com/api/rest/contacts/labels/sort-and-filter). To learn how to query labels, see
   * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
   */
  comWixpressContactsLabelsV4Labels?: Maybe<ComWixpressContactsLabelsV4QueryLabelsResponse>;
  /** Retrieves a location. */
  comWixpressLocationsGetLocation?: Maybe<ComWixpressLocationsLocation>;
  /** Retrieves a location. */
  comWixpressLocationsLocation?: Maybe<ComWixpressLocationsLocation>;
  /** Retrieves locations, given the specified filters, sorting, and paging. */
  comWixpressLocationsLocations?: Maybe<ComWixpressLocationsQueryLocationsResponse>;
  /**
   * Retrieves a member by ID.
   *
   * Members are typically associated with a contact, each having a distinct member ID and contact ID. When specifying the ID as a parameter, don't presume the IDs are identical since they represent separate entities.
   *
   * A member's default privacy status is `"PRIVATE"`. Private members aren't returned in the response if a [site visitor](https://dev.wix.com/docs/api-reference/articles/authentication/about-identities#site-visitor) or [site member](https://dev.wix.com/docs/api-reference/articles/authentication/about-identities#site-member) identity calls this method. Learn more about [managing your member privacy settings](https://support.wix.com/en/article/site-members-managing-your-member-privacy-settings).
   */
  comWixpressMembersApiGetMember?: Maybe<ComWixpressMembersApiMember>;
  /**
   * Retrieves a member by ID.
   *
   * - `PUBLIC` fieldset returns `id`, `contactId`, and the `profile` object. `status`, `privacyStatus` and `activityStatus` are returned as `UNKNOWN`.
   * - `EXTENDED` fieldset returns `id`, `loginEmail`, `status`, `contactId`, `privacyStatus`, `activityStatus`, and the `profile` object.
   * - `FULL` fieldset returns all fields.
   */
  comWixpressMembersApiMember?: Maybe<ComWixpressMembersApiMember>;
  /**
   * Retrieves a list of up to 100 members, given the specified filters, fieldsets, sorting, and paging.
   *
   * For field support for filters and sorting, see [Members: Supported Filters and Sorting](https://dev.wix.com/docs/rest/crm/members-contacts/members/members/filter-and-sort).
   *
   * To learn about working with _Query_ methods, see [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language),
   * [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging),
   * and [Field Projection](https://dev.wix.com/docs/rest/articles/getting-started/field-projection).
   */
  comWixpressMembersApiMembers?: Maybe<ComWixpressMembersApiQueryMembersResponse>;
  /**
   * Retrieves a pricing plan by ID.
   * @deprecated Deprecated
   */
  comWixpressMembershipV2PlansGetPlan?: Maybe<ComWixpressMembershipV2PlansPlan>;
  /** Retrieves a pricing plan by ID. */
  comWixpressMembershipV2PlansPlan?: Maybe<ComWixpressMembershipV2PlansPlan>;
  /**
   * Retrieves a list of up to 1,000 public pricing plans, given the provided [pagination, sorting, and filtering](https://dev.wix.com/api/rest/wix-pricing-plans/pricing-plans/plans/filter-and-sort).
   * @deprecated Deprecated
   */
  comWixpressMembershipV2PlansPlans?: Maybe<ComWixpressMembershipV2PlansQueryPublicPlansResponse>;
  /** Retrieves a tag with the provided ID. */
  comWixpressNpmCommunitiesPlatformizedBlogGetTag?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogTag>;
  /** Gets a tag with the provided ID. */
  comWixpressNpmCommunitiesPlatformizedBlogTag?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogTag>;
  /**
   * Retrieves a list of up to 500 tags, given the provided paging, filtering, and sorting.
   *
   * Query Posts runs with these defaults, which you can override:
   * - `postCount` is sorted in `DESC` order.
   * - `paging.limit` is `50`.
   * - `paging.offset` is `0`.
   *
   * For field support for filters and sorting, see
   * [Field Support for Filtering and Sorting](https://dev.wix.com/docs/rest/business-solutions/blog/tags/filter-and-sort).
   *
   * To learn about working with _Query_ endpoints, see
   * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
   * [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/sorting-and-paging), and
   * [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
   * For a detailed list of supported filters and sortable fields, see
   * [Field Support for Filtering and Sorting](https://dev.wix.com/docs/rest/business-solutions/blog/posts-stats/filter-and-sort).
   */
  comWixpressNpmCommunitiesPlatformizedBlogTags?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogQueryTagsResponse>;
  /**
   * Retrieves a list of up to 100 categories, given the provided paging, filtering, and sorting.
   * Query Categories runs with these defaults, which you can override.
   * - `displayPosition` is sorted in `DESC` order.
   * - `paging.limit` is `50`.
   * - `paging.offset` is `0`.
   *
   * For field support for filters and sorting, see
   * [Field Support for Filtering and Sorting](https://dev.wix.com/docs/rest/business-solutions/blog/category/filter-and-sort).
   *
   * To learn about working with _Query_ endpoints, see
   * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
   * [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/sorting-and-paging), and
   * [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
   */
  comWixpressNpmCommunitiesPlatformizedBlogV3Categories?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3QueryCategoriesResponse>;
  /** Gets a category with the provided ID. */
  comWixpressNpmCommunitiesPlatformizedBlogV3Category?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Category>;
  /** Gets a category with the specified ID. */
  comWixpressNpmCommunitiesPlatformizedBlogV3GetCategory?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Category>;
  /** Retrieves a post by the specified ID. */
  comWixpressNpmCommunitiesPlatformizedBlogV3GetPost?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Post>;
  /** Gets a post by the specified ID. */
  comWixpressNpmCommunitiesPlatformizedBlogV3Post?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3Post>;
  /**
   * Retrieves a list of up to 100 posts, given the provided paging, filtering, and sorting.
   *
   * Query Posts runs with these defaults, which you can override:
   * - `firstPublishedDate` is sorted in descending order, with pinned posts first.
   * - `paging.limit` is `50`.
   * - `paging.offset` is `0`.
   *
   * For field support for filters and sorting, see
   * [Field Support for Filtering and Sorting](https://dev.wix.com/docs/rest/business-solutions/blog/posts-stats/filter-and-sort).
   *
   * To learn about working with _Query_ endpoints, see
   * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
   * [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/sorting-and-paging), and
   * [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
   * For a detailed list of supported filters and sortable fields, see
   * [Field Support for Filtering and Sorting](https://dev.wix.com/docs/rest/business-solutions/blog/posts-stats/filter-and-sort).
   */
  comWixpressNpmCommunitiesPlatformizedBlogV3Posts?: Maybe<ComWixpressNpmCommunitiesPlatformizedBlogV3QueryPostsResponse>;
  /** Get a Collection by id */
  comWixpressPortfolioCollectionsCollection?: Maybe<ComWixpressPortfolioCollectionsCollection>;
  /** Query Collections using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) */
  comWixpressPortfolioCollectionsCollections?: Maybe<ComWixpressPortfolioCollectionsQueryCollectionsResponse>;
  /** Get a ProjectItem by id */
  comWixpressPortfolioProjectitemsItem?: Maybe<ComWixpressPortfolioProjectitemsItem>;
  /**
   * Query Collections using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language)
   * supported only by projectId & id
   * internal usage only - should not be used, created for auto-db-driver only
   */
  comWixpressPortfolioProjectitemsItems?: Maybe<ComWixpressPortfolioProjectitemsQueryProjectItemsResponse>;
  /** Get a Project by id */
  comWixpressPortfolioProjectsProject?: Maybe<ComWixpressPortfolioProjectsProject>;
  /** Query Projects using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) */
  comWixpressPortfolioProjectsProjects?: Maybe<ComWixpressPortfolioProjectsQueryProjectsResponse>;
  /**
   * > **Note:** The Labels API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves an item label by ID.
   */
  comWixpressRestaurantsMenusItemLabelsV1GetLabel?: Maybe<ComWixpressRestaurantsMenusItemLabelsV1Label>;
  /** Get a Label by id */
  comWixpressRestaurantsMenusItemLabelsV1Label?: Maybe<ComWixpressRestaurantsMenusItemLabelsV1Label>;
  /**
   * > **Note:** The Label API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a list of item labels given the provided paging, filtering, and sorting. Up to 500 labels can be returned per request.
   *
   * For a detailed list of supported operations, see the [Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item-label/supported-filters-and-sorting) article. To learn how to query menus, see [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language).
   */
  comWixpressRestaurantsMenusItemLabelsV1Labels?: Maybe<ComWixpressRestaurantsMenusItemLabelsV1QueryLabelsResponse>;
  /**
   * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves an item by ID.
   */
  comWixpressRestaurantsMenusItemV1GetItem?: Maybe<ComWixpressRestaurantsMenusItemV1Item>;
  /** Get an Item by id */
  comWixpressRestaurantsMenusItemV1Item?: Maybe<ComWixpressRestaurantsMenusItemV1Item>;
  /**
   * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a list of items given the provided paging, filtering, and sorting. Up to 500 items can be returned per request.
   *
   * For a detailed list of supported operations, see the [Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item/supported-filters-and-sorting) article. To learn how to query items, see [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language).
   */
  comWixpressRestaurantsMenusItemV1Items?: Maybe<ComWixpressRestaurantsMenusItemV1QueryItemsResponse>;
  /** Get menu details and path URL by menu ID. */
  comWixpressRestaurantsMenusMenuV1GetMenu?: Maybe<ComWixpressRestaurantsMenusMenuV1Menu>;
  /** Get a Menu by id */
  comWixpressRestaurantsMenusMenuV1Menu?: Maybe<ComWixpressRestaurantsMenusMenuV1Menu>;
  /** Query menu details and path URL */
  comWixpressRestaurantsMenusMenuV1MenuSiteUrls?: Maybe<ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlQueryMenusSiteUrlResponse>;
  /**
   * Retrieves a list of menus by a given query.
   *
   * To learn how to query menus, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
   *
   * Up to 500 menus can be returned per request.
   */
  comWixpressRestaurantsMenusMenuV1Menus?: Maybe<ComWixpressRestaurantsMenusMenuV1QueryMenusResponse>;
  /**
   * > **Note:** The Section API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a section by ID.
   */
  comWixpressRestaurantsMenusSectionV1GetSection?: Maybe<ComWixpressRestaurantsMenusSectionV1Section>;
  /** Get a Section by id */
  comWixpressRestaurantsMenusSectionV1Section?: Maybe<ComWixpressRestaurantsMenusSectionV1Section>;
  /**
   * > **Note:** The Section API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a list of sections given the provided paging, filtering, and sorting. Up to 500 sections can be returned per request.
   *
   * For a detailed list of supported operations, see the [Supported Filters and Sorting](/sections/supported-filters-and-sorting) article. To learn how to query sections, see [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language).
   */
  comWixpressRestaurantsMenusSectionV1Sections?: Maybe<ComWixpressRestaurantsMenusSectionV1QuerySectionsResponse>;
  /** Retrieves a checkout. */
  ecomCheckoutV1Checkout?: Maybe<EcomCheckoutV1Checkout>;
  /** Retrieves a checkout. */
  ecomCheckoutV1GetCheckout?: Maybe<EcomCheckoutV1Checkout>;
  metroinspectorV1CollectionsCollection?: Maybe<MetroinspectorV1CollectionsCollection>;
  metroinspectorV1CollectionsCollections?: Maybe<MetroinspectorV1CollectionsQueryCollectionsResponse>;
  metroinspectorV1CollectionsGetCollection?: Maybe<MetroinspectorV1CollectionsCollection>;
  metroinspectorV1ProductsGetProduct?: Maybe<MetroinspectorV1ProductsProduct>;
  metroinspectorV1ProductsProduct?: Maybe<MetroinspectorV1ProductsProduct>;
  metroinspectorV1ProductsProducts?: Maybe<MetroinspectorV1ProductsQueryProductsResponse>;
  /** Retrieves a TaxExemptGroup. */
  wixBillingV1GetTaxExemptGroup?: Maybe<WixBillingV1TaxExemptGroup>;
  /**
   * Retrieves a list of TaxExemptGroups, given the provided [paging, filtering, and sorting][1].
   *
   * Up to 1,000 TaxExemptGroups can be returned per request.
   *
   * To learn how to query TaxExemptGroups, see [API Query Language][2].
   *
   * [1]: https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging
   * [2]: https://dev.wix.com/docs/rest/articles/getting-started/api-query-language
   */
  wixBillingV1TaxExemptGroups?: Maybe<WixBillingV1QueryTaxExemptGroupsResponse>;
  /** Retrieves a `serviceOptionsAndVariants` object by its ID. */
  wixBookingsCatalogV1GetServiceOptionsAndVariants?: Maybe<WixBookingsCatalogV1ServiceOptionsAndVariants>;
  /** Retrieves a `serviceOptionsAndVariants` object by `service_options_and_variants_id`. */
  wixBookingsCatalogV1ServiceOptionsAndVariants?: Maybe<WixBookingsCatalogV1ServiceOptionsAndVariants>;
  /**
   * Retrieves a list of `serviceOptionsAndVariants` objects, given the provided
   * paging, filtering, and sorting.
   *
   *
   * Query Service Options And Variants* runs with these defaults, which you can override:
   *
   * - `id` sorted in `ASC` order.
   * - `cursorPaging.limit` set to `100`.
   *
   * For a detailed list of supported filtering operations refer to the [supported filters article](https://dev.wix.com/docs/rest/business-solutions/bookings/services/service-options-and-variants/supported-filters).
   *
   * To learn about working with _Query_ endpoints, see
   * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language),
   * [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging),
   * and [Field Projection](https://dev.wix.com/docs/rest/articles/getting-started/field-projection).
   */
  wixBookingsCatalogV1ServiceOptionsAndVariantsList?: Maybe<WixBookingsCatalogV1QueryServiceOptionsAndVariantsResponse>;
  /**
   * Retrieves up to 1000 categories, given the specified paging, filtering, and sorting.
   *
   *
   * ### Defaults
   *
   * Query Categories has the following default settings, which you can override:
   *
   * - Most responses are sorted by `id` in ascending order.
   * __Tip__: Always specify a sort order to ensure consistent results.
   * - `cursorPaging.limit` set to `50`.
   *
   * ### Filters
   *
   * Refer to the [Supported Filters article](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/categories-v2/filtering-and-sorting) for a complete list of supported filters and sorting options.
   *
   * ### See also
   *
   * To learn about working with Query methods in general, see:
   *
   * - [API Query Language](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-the-wix-api-query-language).
   * - [Sorting](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-sorting-and-paging).
   * - [Paging](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-sorting-and-paging#paging).
   */
  wixBookingsCategoriesV2Categories?: Maybe<WixBookingsCategoriesV2QueryCategoriesResponse>;
  /** Retrieves a category. */
  wixBookingsCategoriesV2GetCategory?: Maybe<WixBookingsCategoriesV2Category>;
  /** Retrieves a service. */
  wixBookingsServicesV2GetService?: Maybe<WixBookingsServicesV2Service>;
  /** Retrieves a service. */
  wixBookingsServicesV2Service?: Maybe<WixBookingsServicesV2Service>;
  /**
   * Retrieves a list of up to 100 services, given the provided paging,
   * filtering, and sorting.
   *
   *
   * ### Defaults
   *
   * Query Services has the following default settings, which you can override:
   * + Sorted by `createdDate` in ascending order.
   * + `paging.limit` set to `100`.
   * + `paging.offset` set to `0`.
   *
   * ### Filters
   *
   * When using filters for dates, you must use
   * [UTC time](https://en.wikipedia.org/wiki/Coordinated_Universal_Time).
   *
   * Refer to the [supported filters article](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/filtering-and-sorting) for a complete list of supported filters and sorting options.
   *
   * ### See also
   *
   * To learn about working with Query methods, see
   * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language)
   * and [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).
   */
  wixBookingsServicesV2Services?: Maybe<WixBookingsServicesV2QueryServicesResponse>;
  /** Retrieves a StaffMember by id. */
  wixBookingsStaffV1GetStaffMember?: Maybe<WixBookingsStaffV1StaffMember>;
  /** Query StaffMembers using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) */
  wixBookingsStaffV1StaffMembers?: Maybe<WixBookingsStaffV1QueryStaffMembersResponse>;
  /**
   * Retrieves a list of booking policies, given the provided paging, filtering, and sorting.
   *
   *
   * Query Booking Policies runs with these defaults, which you can override:
   *
   * - Sorted by `createdDate` in ascending order.
   * - `cursorPaging.limit` set to `100`.
   *
   * For details about all supported filters and sorting options, see
   * [supported filters](https://dev.wix.com/docs/rest/business-solutions/bookings/policies/booking-policies/supported-filters).
   *
   * To learn about working with _Query_ endpoints, see
   * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
   * [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/pagination),
   * and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
   */
  wixBookingsV1BookingPolicies?: Maybe<WixBookingsV1QueryBookingPoliciesResponse>;
  /** Retrieves a booking policy. */
  wixBookingsV1GetBookingPolicy?: Maybe<WixBookingsV1BookingPolicy>;
  /** Retrieves an event by ID. */
  wixCalendarEventsV3Event?: Maybe<WixCalendarEventsV3Event>;
  /**
   * Retrieves a list of events, given the provided paging, filtering, and sorting.
   *
   *
   * Query Events runs with these defaults, which you can override:
   * - sorted by `start` in `ASC` order
   * - `cursorPaging.limit` is `50`
   *
   * You can't filter by event ID. To query by event ID, use
   * [Get Event](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/get-event)
   * or [List Events](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/list-events).
   *
   * You can't filter by contact or member ID. To query by a participant's contact
   * or member ID, use
   * [List Events by Contact ID](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/list-events-by-contact-id)
   * or [List Events by Member ID](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/list-events-by-member-id).
   *
   * For field support for filters and sorting,
   * see [Calendar Events V3: Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/supported-filters-and-sorting).
   *
   * To learn about working with _Query_ endpoints, see
   * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language),
   * [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging),
   * and [Field Projection](https://dev.wix.com/docs/rest/articles/getting-started/field-projection).
   */
  wixCalendarEventsV3Events?: Maybe<WixCalendarEventsV3QueryEventsResponse>;
  /** Retrieves an event. */
  wixCalendarEventsV3GetEvent?: Maybe<WixCalendarEventsV3Event>;
  /** Retrieves a schedule. */
  wixCalendarSchedulesV3GetSchedule?: Maybe<WixCalendarSchedulesV3Schedule>;
  /** Retrieves a schedule by ID. */
  wixCalendarSchedulesV3Schedule?: Maybe<WixCalendarSchedulesV3Schedule>;
  /**
   * Retrieves a list of schedules, given the provided paging and filtering.
   *
   *
   *
   * By default only `ACTIVE` schedules are returned, unless you provide a different
   * `status` filter.
   *
   * Currently, you can't sort the response.
   *
   * Query schedules runs with these defaults, which you can override:
   * - `cursorPaging.limit` is `50`
   *
   * For field support for filters, see
   * [Schedules V3: Supported Filters](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/supported-filters).
   *
   * To learn about working with _Query_ endpoints, see
   * [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language)
   * and [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging).
   */
  wixCalendarSchedulesV3Schedules?: Maybe<WixCalendarSchedulesV3QuerySchedulesResponse>;
  /** Retrieves a collection with the provided ID. */
  wixCatalogApiV1Collection?: Maybe<WixCatalogApiV1Collection>;
  /**
   * Retrieves a list of up to 100 collections, given the provided paging, sorting and filtering.
   * See [Stores Pagination](https://dev.wix.com/api/rest/wix-stores/pagination) for more information.
   */
  wixCatalogApiV1Collections?: Maybe<WixCatalogApiV2QueryCollectionsResponse>;
  /** Retrieves a product with the provided ID. */
  wixCatalogApiV1GetProduct?: Maybe<WixCatalogApiV1Product>;
  wixCatalogApiV1Product?: Maybe<WixCatalogApiV1Product>;
  /** Returns a list of up to 100 products, given the provided paging, sorting and filtering. */
  wixCatalogApiV1Products?: Maybe<WixCatalogApiV1QueryProductsPlatformizedResponse>;
  /** Query Apps using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) */
  wixDevcenterAppsV1Apps?: Maybe<WixDevcenterAppsV1QueryAppResponse>;
  /** Get an App by id */
  wixDevcenterAppsV1GetApp?: Maybe<WixDevcenterAppsV1App>;
  /**
   * > **Deprecation Notice**
   * >
   * > **This endpoint has been replaced with Events V3's [Query Events](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/query-events) and will be removed on November 6, 2024.**
   * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
   *
   * Retrieves a list of up to 1,000 events, given the provided paging, filtering and sorting.
   *
   * ** Important **:
   * - All results are for one specific business, resolved from the request context.
   *
   * Query object support:
   * - `filter` - supported, see [filtering and sorting](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events).
   * - `sort` - supported, see [filtering and sorting](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events).
   * - `paging` - supported, see [paging](https://dev.wix.com/api/rest/getting-started/pagination).
   * - `fields` - not supported.
   * - `fieldsets` - not supported, use request-level `fieldset` instead.
   * - `cursorPaging` - not supported, use offset pagination instead.
   *
   * Defaults:
   * - When filter is not specified, returns all events that caller is authorized to read.
   * - When sorting is not specified, defaults to `created` in `DESC` order.
   * - When limit is not specified, defaults to 0.
   */
  wixEventsEvents?: Maybe<WixEventsQueryEventsV2Response>;
  /**
   * > **Deprecation Notice**
   * >
   * > **This endpoint has been replaced with Events V3's [Get Event](https://dev.wix.com/docs/rest/business-solutions/events/events-v3/get-event) and will be removed on November 6, 2024.**
   * > **If your app uses this endpoint, we recommend updating your code as soon as possible.**
   *
   * Retrieves an event by ID or URL slug.
   */
  wixEventsGetEvent?: Maybe<WixEventsEvent>;
  /** Retrieves schedule item by ID. */
  wixEventsScheduleGetScheduleItem?: Maybe<WixEventsScheduleScheduleItem>;
  /**
   * Retrieves a list of up to 100 schedule items, given the provided [paging](https://dev.wix.com/api/rest/getting-started/pagination), filtering.
   *
   * * Important **:
   * - All results are for one specific business, resolved from the request context.
   *
   * Query object support:
   * - `filter` - supported, see filtering and sorting.
   * - `sort` - supported, see filtering and sorting.
   * - `paging` - supported, see [paging](https://dev.wix.com/api/rest/getting-started/pagination).
   * - `fields` - not supported.
   * - `fieldsets` - not supported.
   * - `cursorPaging` - not supported, use offset pagination instead.
   *
   * Defaults:
   * - When filter is not specified, returns all schedule items that caller is authorized to read.
   * - When sorting is not specified, defaults to `time_slot.start` and `time_slot.end` in `ASC` order.
   */
  wixEventsScheduleItems?: Maybe<WixEventsScheduleQueryScheduleItemsResponse>;
  wixEventsScheduleScheduleItem?: Maybe<WixEventsScheduleScheduleItem>;
  /** Retrieves a policy. */
  wixEventsV2GetPolicy?: Maybe<WixEventsV2Policy>;
  /** Retrieves a list of policies according to the provided filters and paging. */
  wixEventsV2Policies?: Maybe<WixEventsV2QueryPoliciesResponse>;
  /** Retrieves a policy. */
  wixEventsV2Policy?: Maybe<WixEventsV2Policy>;
  wixFormsV1GetStandaloneForm?: Maybe<WixFormsV1StandaloneForm>;
  /** Gets a form by id. */
  wixFormsV4Form?: Maybe<WixFormsV4Form>;
  /**
   * Retrieves a list of form schemas given the provided paging, filtering, and sorting.
   *
   * You must specify a namespace equality filter. For example, `"namespace:{"$eq":"<your_namespace>"}`.
   */
  wixFormsV4Forms?: Maybe<WixFormsV4QueryFormsResponse>;
  /** Retrieves a form schema by ID. */
  wixFormsV4GetForm?: Maybe<WixFormsV4Form>;
  /**
   * Retrieves a gift card by ID.
   *
   * Use this method to get current gift card details including balance, status, and metadata.
   * The gift card code is obfuscated in the response for security.
   */
  wixGiftCardsGiftCardV1GetGiftCard?: Maybe<WixGiftCardsGiftCardV1GiftCard>;
  wixGiftCardsGiftCardV1GetTransaction?: Maybe<WixGiftCardsGiftCardV1Transaction>;
  /**
   * Retrieves a list of gift cards, given the provided paging, filtering, and sorting.
   *
   * For field support, see [supported filters and sorting](https://dev.wix.com/docs/rest/business-solutions/gift-cards/gift-cards/supported-filters-and-sorting).
   * Learn about working with [Search, Query and List Methods](https://dev.wix.com/docs/rest/articles/get-started/search-query-and-list-methods).
   */
  wixGiftCardsGiftCardV1GiftCards?: Maybe<WixGiftCardsGiftCardV1QueryGiftCardsResponse>;
  /**
   * Retrieves the transaction history for a specific gift card with filtering, sorting, and paging options.
   *
   * Use this method to implement transaction history displays, generate audit reports,
   * or investigate gift card balance changes. Transactions are automatically created
   * for all gift card activities including redemptions, refunds, and manual adjustments.
   *
   * To learn how to query gift card transactions, see [API Query Language][2].
   *
   * [1]: https://dev.wix.com/api/rest/getting-started/sorting-and-paging
   * [2]: https://dev.wix.com/api/rest/getting-started/api-query-language
   */
  wixGiftCardsGiftCardV1Transactions?: Maybe<WixGiftCardsGiftCardV1QueryGiftCardTransactionsResponse>;
  /** Retrieves an OAuth app by ID. */
  wixHeadlessV1GetOAuthApp?: Maybe<WixHeadlessV1OAuthApp>;
  /** Retrieves an OAuth app by ID. */
  wixHeadlessV1OAuthApp?: Maybe<WixHeadlessV1OAuthApp>;
  /**
   * Retrieves a list of OAuth apps, given the provided paging, filtering, and sorting.
   *
   *
   * Query OAuth Apps runs with these defaults, which you can override:
   * + Results are sorted by `id` in descending order.
   * + `paging.offset` is `0`.
   *
   * For field support for filters and sorting, see [OAuth Apps: Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-management/headless-authentication/oauth-apps/filters-sorting)
   *
   * To learn about working with _Query_ endpoints in general, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
   */
  wixHeadlessV1OAuthApps?: Maybe<WixHeadlessV1QueryOAuthAppsResponse>;
  /** Returns participant. */
  wixOnlineprogramsParticipantsV3GetParticipant?: Maybe<WixOnlineprogramsParticipantsV3Participant>;
  /** Query existing participants */
  wixOnlineprogramsParticipantsV3Participants?: Maybe<WixOnlineprogramsParticipantsV3QueryParticipantsResponse>;
  /** Retrieves a Program. */
  wixOnlineprogramsProgramsV3GetProgram?: Maybe<WixOnlineprogramsProgramsV3Program>;
  /** Retrieves a list of Programs */
  wixOnlineprogramsProgramsV3Programs?: Maybe<WixOnlineprogramsProgramsV3QueryProgramsResponse>;
  /** Retrieves a Step. */
  wixOnlineprogramsStepsV3GetStep?: Maybe<WixOnlineprogramsStepsV3Step>;
  /** Query steps. */
  wixOnlineprogramsStepsV3Steps?: Maybe<WixOnlineprogramsStepsV3QueryStepsResponse>;
  /** Retrieves a PaymentAgreement. */
  wixPaymentsPaymentAgreementsV1GetPaymentAgreement?: Maybe<WixPaymentsPaymentAgreementsV1PaymentAgreement>;
  /**
   * Retrieves a list of PaymentAgreements, given the provided [paging, filtering, and sorting][1].
   *
   * Up to 1,000 PaymentAgreements can be returned per request.
   *
   * To learn how to query PaymentAgreements, see [API Query Language][2].
   *
   * [1]: https://dev.wix.com/api/rest/getting-started/sorting-and-paging
   * [2]: https://dev.wix.com/api/rest/getting-started/api-query-language
   */
  wixPaymentsPaymentAgreementsV1PaymentAgreements?: Maybe<WixPaymentsPaymentAgreementsV1QueryPaymentAgreementsResponse>;
  /** Retrieves a refund. */
  wixPaymentsRefundsV1GetRefund?: Maybe<WixPaymentsRefundsV1Refund>;
  /**
   * Retrieves a list of refunds given the provided paging, filtering, and sorting. Up to 100 Refunds can be returned per request.
   *
   * For a detailed list of supported operations, see the [Sorting and Filtering](https://dev.wix.com/docs/rest/business-management/payments/refunds/sorting-and-filtering) article.
   * To learn how to query refunds, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
   */
  wixPaymentsRefundsV1Refunds?: Maybe<WixPaymentsRefundsV1QueryRefundsResponse>;
  /** Returns SavedPaymentMethod by ID. */
  wixPaymentsSavedPaymentMethodsV1GetSavedPaymentMethod?: Maybe<WixPaymentsSavedPaymentMethodsV1SavedPaymentMethod>;
  /**
   * Retrieves a payment method type, with some fields localized according to the caller's language and country.
   *
   * The callers language and country are taken from the `languageCode` or `countryCode` parameters in the request.
   * If these parameters are not specified, the values are taken from context of the call if possible. For example, if this method is called from a Wix site, the selected language on that site will be used.
   * If language or country can't be determined, the method doesn't perform any filtering or localization.
   *
   * Language and country are used to determine localized values for the `displayName`, `description` fields.
   * Country is used to determine localized values for the `priority` and `promoted` fields in `merchantFlow` and `buyerFlow`.
   * `currencyCode` is used to determine the eligibility of payment method types for the provided currency.
   */
  wixPaymentsSitePaymentMethodTypesV1GetSitePaymentMethodType?: Maybe<WixPaymentsSitePaymentMethodTypesV1SitePaymentMethodType>;
  /** Retrieves a receipt. */
  wixReceiptsV1GetReceipt?: Maybe<WixReceiptsV1Receipt>;
  /** Retrieves a list of up to 100 receipts, given the specified filtering, paging, and sorting ([SDK](https://dev.wix.com/docs/sdk/articles/work-with-the-sdk/api-query-language) | [REST](https://dev.wix.com/api/rest/getting-started/api-query-language)). */
  wixReceiptsV1Receipts?: Maybe<WixReceiptsV1QueryReceiptsResponse>;
  /**
   * > **Note:** The Item Modifier API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves an item modifier by ID.
   */
  wixRestaurantsMenusItemModifierV1GetModifier?: Maybe<WixRestaurantsMenusItemModifierV1Modifier>;
  /** Get a Modifier by id */
  wixRestaurantsMenusItemModifierV1Modifier?: Maybe<WixRestaurantsMenusItemModifierV1Modifier>;
  /**
   * > **Note:** The Item Modifier API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a list of item modifiers given the provided paging, filtering, and sorting. Up to 500 item modifiers can be returned per request.
   * For a detailed list of supported operations, see the [Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item-modifiers/supported-filters-and-sorting) article. To learn how to query menus, see [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language).
   */
  wixRestaurantsMenusItemModifierV1Modifiers?: Maybe<WixRestaurantsMenusItemModifierV1QueryModifiersResponse>;
  /**
   * > **Note:** The Item Variants API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves an item variant by ID.
   */
  wixRestaurantsMenusItemVariantV1GetVariant?: Maybe<WixRestaurantsMenusItemVariantV1Variant>;
  /**
   * > **Note:** The Item Variants API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a list of item variants given the provided paging, filtering, and sorting. Up to 500 item variants can be returned per request.
   *
   * For a detailed list of supported operations, see the [Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item-variant/supported-filters-and-sorting) article. To learn how to query item variants, see [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language)
   */
  wixRestaurantsMenusItemVariantV1Variants?: Maybe<WixRestaurantsMenusItemVariantV1QueryVariantsResponse>;
  /**
   * > **Note:** The Item Modifier Groups API only works with the Wix Restaurants Menus (New) app. Make sure you downloaded this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a modifier group by the ID.
   */
  wixRestaurantsMenusV1GetModifierGroup?: Maybe<WixRestaurantsMenusV1ModifierGroup>;
  /** Query ModifierGroups */
  wixRestaurantsMenusV1Items?: Maybe<WixRestaurantsMenusV1QueryModifierGroupsResponse>;
  /** Get a ModifierGroup by id */
  wixRestaurantsMenusV1ModifierGroup?: Maybe<WixRestaurantsMenusV1ModifierGroup>;
  /**
   * > **Note:** The Item Modifier Groups API only works with the Wix Restaurants Menus (New) app. Make sure you downloaded this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
   *
   * Retrieves a list of modifier groups given the provided paging, filtering, and sorting. Up to 500 modifier groups can be returned per request.
   * For a detailed list of supported operations, see the [Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item-modifier-groups/supported-filters-and-sorting) article. To learn how to query modifier groups, see [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language).
   */
  wixRestaurantsMenusV1ModifierGroups?: Maybe<WixRestaurantsMenusV1QueryModifierGroupsResponse>;
  /** Get a GiftCard by ID. */
  wixRiseV1GetGiftCard?: Maybe<WixRiseV1GiftCard>;
  wixRiseV1GetTransaction?: Maybe<WixRiseV1Transaction>;
  wixRiseV1GetWallet?: Maybe<WixRiseV1Wallet>;
  /** Retrieve a WalletAction by ID. */
  wixRiseV1GetWalletAction?: Maybe<WixRiseV1WalletAction>;
  /** Query GiftCards using [API Query Language](https://platform.rise.ai/docs/#tag/About-API-Query-Language). */
  wixRiseV1GiftCards?: Maybe<WixRiseV1QueryGiftCardsResponse>;
  /** Query Transactions using [API Query Language](https://platform.rise.ai/docs/#tag/About-API-Query-Language). */
  wixRiseV1Transactions?: Maybe<WixRiseV1QueryTransactionsResponse>;
  /** Query WalletActions using [API Query Language](https://platform.rise.ai/docs/#tag/About-API-Query-Language). */
  wixRiseV1WalletActions?: Maybe<WixRiseV1QueryWalletActionResponse>;
  /** Query wallets enriched with gift card and contact information. See [API Query Language](https://platform.rise.ai/docs/#tag/About-API-Query-Language). */
  wixRiseV1Wallets?: Maybe<WixRiseV1QueryWalletsResponse>;
  /** Retrieves a Workflow. */
  wixRiseWorkflowV1GetWorkflow?: Maybe<WixRiseWorkflowV1Workflow>;
  /** Retrieves a list of Workflows, given the provided [paging, filtering, and sorting][1]. */
  wixRiseWorkflowV1Workflows?: Maybe<WixRiseWorkflowV1QueryWorkflowsResponse>;
};


export type QueryComWixBookingsSchedulesApiV1GetSessionArgs = {
  queryInput?: InputMaybe<ComWixBookingsSchedulesApiV1GetSessionRequestInput>;
};


export type QueryComWixBookingsSchedulesApiV1SessionArgs = {
  id: Scalars['ID'];
};


export type QueryComWixBookingsSchedulesApiV1SessionsArgs = {
  queryInput?: InputMaybe<ComWixBookingsCalendarApiV2QuerySessionsRequestInput>;
};


export type QueryComWixEcomDiscountsDiscountRuleArgs = {
  id: Scalars['ID'];
};


export type QueryComWixEcomDiscountsDiscountRulesArgs = {
  queryInput?: InputMaybe<ComWixEcomDiscountsQueryDiscountRulesRequestInput>;
};


export type QueryComWixEcomDiscountsGetDiscountRuleArgs = {
  queryInput?: InputMaybe<ComWixEcomDiscountsGetDiscountRuleRequestInput>;
};


export type QueryComWixEcomOrdersPaymentsV1GetOrderTransactionsArgs = {
  queryInput?: InputMaybe<ComWixEcomOrdersPaymentsV1GetOrderTransactionsRequestInput>;
};


export type QueryComWixEcomOrdersPaymentsV1OrderTransactionsArgs = {
  queryInput?: InputMaybe<ComWixEcomOrdersPaymentsV1QueryOrderTransactionsRequestInput>;
};


export type QueryComWixEcomOrdersV1GetOrderArgs = {
  queryInput?: InputMaybe<ComWixEcomOrdersV1GetOrderRequestInput>;
};


export type QueryComWixEcomOrdersV1OrderArgs = {
  id: Scalars['ID'];
};


export type QueryComWixEcomOrdersV1OrdersArgs = {
  queryInput?: InputMaybe<ComWixEcomOrdersV1QueryOrderRequestInput>;
};


export type QueryComWixpressBookingsAttendanceV2AttendanceArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressBookingsAttendanceV2AttendancesArgs = {
  queryInput?: InputMaybe<ComWixpressBookingsAttendanceV2QueryAttendanceRequestInput>;
};


export type QueryComWixpressBookingsAttendanceV2GetAttendanceArgs = {
  queryInput?: InputMaybe<ComWixpressBookingsAttendanceV2GetAttendanceRequestInput>;
};


export type QueryComWixpressCloudDataApiDataDataItemArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressCloudDataApiDataDataItemsArgs = {
  queryInput?: InputMaybe<ComWixpressCloudDataApiDataQueryDataItemsRequestInput>;
};


export type QueryComWixpressCloudDataApiDataGetDataItemArgs = {
  queryInput?: InputMaybe<ComWixpressCloudDataApiDataGetDataItemRequestInput>;
};


export type QueryComWixpressContactsCoreApiV4ContactsArgs = {
  queryInput?: InputMaybe<ComWixpressContactsCoreApiV4QueryContactsRequestInput>;
};


export type QueryComWixpressContactsCoreApiV4GetContactArgs = {
  queryInput?: InputMaybe<ComWixpressContactsCoreApiV4GetContactRequestInput>;
};


export type QueryComWixpressContactsFieldsV4ExtendedFieldArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressContactsFieldsV4FieldsArgs = {
  queryInput?: InputMaybe<ComWixpressContactsFieldsV4QueryExtendedFieldsRequestInput>;
};


export type QueryComWixpressContactsFieldsV4GetExtendedFieldArgs = {
  queryInput?: InputMaybe<ComWixpressContactsFieldsV4GetExtendedFieldRequestInput>;
};


export type QueryComWixpressContactsLabelsV4ContactLabelArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressContactsLabelsV4GetContactLabelArgs = {
  queryInput?: InputMaybe<ComWixpressContactsLabelsV4GetContactLabelRequestInput>;
};


export type QueryComWixpressContactsLabelsV4LabelsArgs = {
  queryInput?: InputMaybe<ComWixpressContactsLabelsV4QueryLabelsRequestInput>;
};


export type QueryComWixpressLocationsGetLocationArgs = {
  queryInput?: InputMaybe<ComWixpressLocationsGetLocationRequestInput>;
};


export type QueryComWixpressLocationsLocationArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressLocationsLocationsArgs = {
  queryInput?: InputMaybe<ComWixpressLocationsQueryLocationsRequestInput>;
};


export type QueryComWixpressMembersApiGetMemberArgs = {
  queryInput?: InputMaybe<ComWixpressMembersApiGetMemberRequestInput>;
};


export type QueryComWixpressMembersApiMemberArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressMembersApiMembersArgs = {
  queryInput?: InputMaybe<ComWixpressMembersApiQueryMembersRequestInput>;
};


export type QueryComWixpressMembershipV2PlansGetPlanArgs = {
  queryInput?: InputMaybe<ComWixpressMembershipV2PlansGetPlanRequestInput>;
};


export type QueryComWixpressMembershipV2PlansPlanArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressMembershipV2PlansPlansArgs = {
  queryInput?: InputMaybe<ComWixpressMembershipV2PlansQueryPublicPlansRequestInput>;
};


export type QueryComWixpressNpmCommunitiesPlatformizedBlogGetTagArgs = {
  queryInput?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogGetTagRequestInput>;
};


export type QueryComWixpressNpmCommunitiesPlatformizedBlogTagArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressNpmCommunitiesPlatformizedBlogTagsArgs = {
  queryInput?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogQueryTagsRequestInput>;
};


export type QueryComWixpressNpmCommunitiesPlatformizedBlogV3CategoriesArgs = {
  queryInput?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3QueryCategoriesRequestInput>;
};


export type QueryComWixpressNpmCommunitiesPlatformizedBlogV3CategoryArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressNpmCommunitiesPlatformizedBlogV3GetCategoryArgs = {
  queryInput?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3GetCategoryRequestInput>;
};


export type QueryComWixpressNpmCommunitiesPlatformizedBlogV3GetPostArgs = {
  queryInput?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3GetPostRequestInput>;
};


export type QueryComWixpressNpmCommunitiesPlatformizedBlogV3PostArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressNpmCommunitiesPlatformizedBlogV3PostsArgs = {
  queryInput?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3QueryPostsRequestInput>;
};


export type QueryComWixpressPortfolioCollectionsCollectionArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressPortfolioCollectionsCollectionsArgs = {
  query?: InputMaybe<WixCommonQueryV2Input>;
};


export type QueryComWixpressPortfolioProjectitemsItemArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressPortfolioProjectitemsItemsArgs = {
  query?: InputMaybe<WixCommonQueryV2Input>;
};


export type QueryComWixpressPortfolioProjectsProjectArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressPortfolioProjectsProjectsArgs = {
  query?: InputMaybe<WixCommonQueryV2Input>;
};


export type QueryComWixpressRestaurantsMenusItemLabelsV1GetLabelArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusItemLabelsV1GetLabelRequestInput>;
};


export type QueryComWixpressRestaurantsMenusItemLabelsV1LabelArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressRestaurantsMenusItemLabelsV1LabelsArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusItemLabelsV1QueryLabelsRequestInput>;
};


export type QueryComWixpressRestaurantsMenusItemV1GetItemArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusItemV1GetItemRequestInput>;
};


export type QueryComWixpressRestaurantsMenusItemV1ItemArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressRestaurantsMenusItemV1ItemsArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusItemV1QueryItemsRequestInput>;
};


export type QueryComWixpressRestaurantsMenusMenuV1GetMenuArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusMenuV1GetMenuRequestInput>;
};


export type QueryComWixpressRestaurantsMenusMenuV1MenuArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressRestaurantsMenusMenuV1MenuSiteUrlsArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlQueryMenusSiteUrlRequestInput>;
};


export type QueryComWixpressRestaurantsMenusMenuV1MenusArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusMenuV1QueryMenusRequestInput>;
};


export type QueryComWixpressRestaurantsMenusSectionV1GetSectionArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusSectionV1GetSectionRequestInput>;
};


export type QueryComWixpressRestaurantsMenusSectionV1SectionArgs = {
  id: Scalars['ID'];
};


export type QueryComWixpressRestaurantsMenusSectionV1SectionsArgs = {
  queryInput?: InputMaybe<ComWixpressRestaurantsMenusSectionV1QuerySectionsRequestInput>;
};


export type QueryEcomCheckoutV1CheckoutArgs = {
  id: Scalars['ID'];
};


export type QueryEcomCheckoutV1GetCheckoutArgs = {
  queryInput?: InputMaybe<EcomCheckoutV1GetCheckoutRequestInput>;
};


export type QueryMetroinspectorV1CollectionsCollectionArgs = {
  id: Scalars['ID'];
};


export type QueryMetroinspectorV1CollectionsCollectionsArgs = {
  queryInput?: InputMaybe<MetroinspectorV1CollectionsQueryCollectionsRequestInput>;
};


export type QueryMetroinspectorV1CollectionsGetCollectionArgs = {
  queryInput?: InputMaybe<MetroinspectorV1CollectionsGetCollectionRequestInput>;
};


export type QueryMetroinspectorV1ProductsGetProductArgs = {
  queryInput?: InputMaybe<MetroinspectorV1ProductsGetProductRequestInput>;
};


export type QueryMetroinspectorV1ProductsProductArgs = {
  id: Scalars['ID'];
};


export type QueryMetroinspectorV1ProductsProductsArgs = {
  queryInput?: InputMaybe<MetroinspectorV1ProductsQueryProductsRequestInput>;
};


export type QueryWixBillingV1GetTaxExemptGroupArgs = {
  queryInput?: InputMaybe<WixBillingV1GetTaxExemptGroupRequestInput>;
};


export type QueryWixBillingV1TaxExemptGroupsArgs = {
  queryInput?: InputMaybe<WixBillingV1QueryTaxExemptGroupsRequestInput>;
};


export type QueryWixBookingsCatalogV1GetServiceOptionsAndVariantsArgs = {
  queryInput?: InputMaybe<WixBookingsCatalogV1GetServiceOptionsAndVariantsRequestInput>;
};


export type QueryWixBookingsCatalogV1ServiceOptionsAndVariantsArgs = {
  id: Scalars['ID'];
};


export type QueryWixBookingsCatalogV1ServiceOptionsAndVariantsListArgs = {
  queryInput?: InputMaybe<WixBookingsCatalogV1QueryServiceOptionsAndVariantsRequestInput>;
};


export type QueryWixBookingsCategoriesV2CategoriesArgs = {
  queryInput?: InputMaybe<WixBookingsCategoriesV2QueryCategoriesRequestInput>;
};


export type QueryWixBookingsCategoriesV2GetCategoryArgs = {
  queryInput?: InputMaybe<WixBookingsCategoriesV2GetCategoryRequestInput>;
};


export type QueryWixBookingsServicesV2GetServiceArgs = {
  queryInput?: InputMaybe<WixBookingsServicesV2GetServiceRequestInput>;
};


export type QueryWixBookingsServicesV2ServiceArgs = {
  id: Scalars['ID'];
};


export type QueryWixBookingsServicesV2ServicesArgs = {
  queryInput?: InputMaybe<WixBookingsServicesV2QueryServicesRequestInput>;
};


export type QueryWixBookingsStaffV1GetStaffMemberArgs = {
  queryInput?: InputMaybe<WixBookingsStaffV1GetStaffMemberRequestInput>;
};


export type QueryWixBookingsStaffV1StaffMembersArgs = {
  queryInput?: InputMaybe<WixBookingsStaffV1QueryStaffMembersRequestInput>;
};


export type QueryWixBookingsV1BookingPoliciesArgs = {
  queryInput?: InputMaybe<WixBookingsV1QueryBookingPoliciesRequestInput>;
};


export type QueryWixBookingsV1GetBookingPolicyArgs = {
  queryInput?: InputMaybe<WixBookingsV1GetBookingPolicyRequestInput>;
};


export type QueryWixCalendarEventsV3EventArgs = {
  id: Scalars['ID'];
};


export type QueryWixCalendarEventsV3EventsArgs = {
  queryInput?: InputMaybe<WixCalendarEventsV3QueryEventsRequestInput>;
};


export type QueryWixCalendarEventsV3GetEventArgs = {
  queryInput?: InputMaybe<WixCalendarEventsV3GetEventRequestInput>;
};


export type QueryWixCalendarSchedulesV3GetScheduleArgs = {
  queryInput?: InputMaybe<WixCalendarSchedulesV3GetScheduleRequestInput>;
};


export type QueryWixCalendarSchedulesV3ScheduleArgs = {
  id: Scalars['ID'];
};


export type QueryWixCalendarSchedulesV3SchedulesArgs = {
  queryInput?: InputMaybe<WixCalendarSchedulesV3QuerySchedulesRequestInput>;
};


export type QueryWixCatalogApiV1CollectionArgs = {
  id: Scalars['ID'];
};


export type QueryWixCatalogApiV1CollectionsArgs = {
  query?: InputMaybe<ComWixEcommerceCommonsApiPlatformQueryInput>;
};


export type QueryWixCatalogApiV1GetProductArgs = {
  queryInput?: InputMaybe<WixCatalogApiV1GetProductRequestInput>;
};


export type QueryWixCatalogApiV1ProductArgs = {
  id: Scalars['ID'];
};


export type QueryWixCatalogApiV1ProductsArgs = {
  queryInput?: InputMaybe<WixCatalogApiV1QueryProductsPlatformizedRequestInput>;
};


export type QueryWixDevcenterAppsV1AppsArgs = {
  queryInput?: InputMaybe<WixDevcenterAppsV1QueryAppRequestInput>;
};


export type QueryWixDevcenterAppsV1GetAppArgs = {
  queryInput?: InputMaybe<WixDevcenterAppsV1GetAppRequestInput>;
};


export type QueryWixEventsEventsArgs = {
  queryInput?: InputMaybe<WixEventsQueryEventsV2RequestInput>;
};


export type QueryWixEventsGetEventArgs = {
  queryInput?: InputMaybe<WixEventsGetEventRequestInput>;
};


export type QueryWixEventsScheduleGetScheduleItemArgs = {
  queryInput?: InputMaybe<WixEventsScheduleGetScheduleItemRequestInput>;
};


export type QueryWixEventsScheduleItemsArgs = {
  queryInput?: InputMaybe<WixEventsScheduleQueryScheduleItemsRequestInput>;
};


export type QueryWixEventsScheduleScheduleItemArgs = {
  id: Scalars['ID'];
};


export type QueryWixEventsV2GetPolicyArgs = {
  queryInput?: InputMaybe<WixEventsV2GetPolicyRequestInput>;
};


export type QueryWixEventsV2PoliciesArgs = {
  queryInput?: InputMaybe<WixEventsV2QueryPoliciesRequestInput>;
};


export type QueryWixEventsV2PolicyArgs = {
  id: Scalars['ID'];
};


export type QueryWixFormsV1GetStandaloneFormArgs = {
  queryInput?: InputMaybe<WixFormsV1GetStandaloneFormRequestInput>;
};


export type QueryWixFormsV4FormArgs = {
  id: Scalars['ID'];
};


export type QueryWixFormsV4FormsArgs = {
  queryInput?: InputMaybe<WixFormsV4QueryFormsRequestInput>;
};


export type QueryWixFormsV4GetFormArgs = {
  queryInput?: InputMaybe<WixFormsV4GetFormRequestInput>;
};


export type QueryWixGiftCardsGiftCardV1GetGiftCardArgs = {
  queryInput?: InputMaybe<WixGiftCardsGiftCardV1GetGiftCardRequestInput>;
};


export type QueryWixGiftCardsGiftCardV1GetTransactionArgs = {
  queryInput?: InputMaybe<WixGiftCardsGiftCardV1GetTransactionRequestInput>;
};


export type QueryWixGiftCardsGiftCardV1GiftCardsArgs = {
  queryInput?: InputMaybe<WixGiftCardsGiftCardV1QueryGiftCardsRequestInput>;
};


export type QueryWixGiftCardsGiftCardV1TransactionsArgs = {
  queryInput?: InputMaybe<WixGiftCardsGiftCardV1QueryGiftCardTransactionsRequestInput>;
};


export type QueryWixHeadlessV1GetOAuthAppArgs = {
  queryInput?: InputMaybe<WixHeadlessV1GetOAuthAppRequestInput>;
};


export type QueryWixHeadlessV1OAuthAppArgs = {
  id: Scalars['ID'];
};


export type QueryWixHeadlessV1OAuthAppsArgs = {
  queryInput?: InputMaybe<WixHeadlessV1QueryOAuthAppsRequestInput>;
};


export type QueryWixOnlineprogramsParticipantsV3GetParticipantArgs = {
  queryInput?: InputMaybe<WixOnlineprogramsParticipantsV3GetParticipantRequestInput>;
};


export type QueryWixOnlineprogramsParticipantsV3ParticipantsArgs = {
  queryInput?: InputMaybe<WixOnlineprogramsParticipantsV3QueryParticipantsRequestInput>;
};


export type QueryWixOnlineprogramsProgramsV3GetProgramArgs = {
  queryInput?: InputMaybe<WixOnlineprogramsProgramsV3GetProgramRequestInput>;
};


export type QueryWixOnlineprogramsProgramsV3ProgramsArgs = {
  queryInput?: InputMaybe<WixOnlineprogramsProgramsV3QueryProgramsRequestInput>;
};


export type QueryWixOnlineprogramsStepsV3GetStepArgs = {
  queryInput?: InputMaybe<WixOnlineprogramsStepsV3GetStepRequestInput>;
};


export type QueryWixOnlineprogramsStepsV3StepsArgs = {
  queryInput?: InputMaybe<WixOnlineprogramsStepsV3QueryStepsRequestInput>;
};


export type QueryWixPaymentsPaymentAgreementsV1GetPaymentAgreementArgs = {
  queryInput?: InputMaybe<WixPaymentsPaymentAgreementsV1GetPaymentAgreementRequestInput>;
};


export type QueryWixPaymentsPaymentAgreementsV1PaymentAgreementsArgs = {
  queryInput?: InputMaybe<WixPaymentsPaymentAgreementsV1QueryPaymentAgreementsRequestInput>;
};


export type QueryWixPaymentsRefundsV1GetRefundArgs = {
  queryInput?: InputMaybe<WixPaymentsRefundsV1GetRefundRequestInput>;
};


export type QueryWixPaymentsRefundsV1RefundsArgs = {
  queryInput?: InputMaybe<WixPaymentsRefundsV1QueryRefundsRequestInput>;
};


export type QueryWixPaymentsSavedPaymentMethodsV1GetSavedPaymentMethodArgs = {
  queryInput?: InputMaybe<WixPaymentsSavedPaymentMethodsV1GetSavedPaymentMethodRequestInput>;
};


export type QueryWixPaymentsSitePaymentMethodTypesV1GetSitePaymentMethodTypeArgs = {
  queryInput?: InputMaybe<WixPaymentsSitePaymentMethodTypesV1GetSitePaymentMethodTypeRequestInput>;
};


export type QueryWixReceiptsV1GetReceiptArgs = {
  queryInput?: InputMaybe<WixReceiptsV1GetReceiptRequestInput>;
};


export type QueryWixReceiptsV1ReceiptsArgs = {
  queryInput?: InputMaybe<WixReceiptsV1QueryReceiptsRequestInput>;
};


export type QueryWixRestaurantsMenusItemModifierV1GetModifierArgs = {
  queryInput?: InputMaybe<WixRestaurantsMenusItemModifierV1GetModifierRequestInput>;
};


export type QueryWixRestaurantsMenusItemModifierV1ModifierArgs = {
  id: Scalars['ID'];
};


export type QueryWixRestaurantsMenusItemModifierV1ModifiersArgs = {
  queryInput?: InputMaybe<WixRestaurantsMenusItemModifierV1QueryModifiersRequestInput>;
};


export type QueryWixRestaurantsMenusItemVariantV1GetVariantArgs = {
  queryInput?: InputMaybe<WixRestaurantsMenusItemVariantV1GetVariantRequestInput>;
};


export type QueryWixRestaurantsMenusItemVariantV1VariantsArgs = {
  queryInput?: InputMaybe<WixRestaurantsMenusItemVariantV1QueryVariantsRequestInput>;
};


export type QueryWixRestaurantsMenusV1GetModifierGroupArgs = {
  queryInput?: InputMaybe<WixRestaurantsMenusV1GetModifierGroupRequestInput>;
};


export type QueryWixRestaurantsMenusV1ItemsArgs = {
  queryInput?: InputMaybe<WixRestaurantsMenusV1QueryModifierGroupsRequestInput>;
};


export type QueryWixRestaurantsMenusV1ModifierGroupArgs = {
  id: Scalars['ID'];
};


export type QueryWixRestaurantsMenusV1ModifierGroupsArgs = {
  queryInput?: InputMaybe<WixRestaurantsMenusV1QueryModifierGroupsRequestInput>;
};


export type QueryWixRiseV1GetGiftCardArgs = {
  queryInput?: InputMaybe<WixRiseV1GetGiftCardRequestInput>;
};


export type QueryWixRiseV1GetTransactionArgs = {
  queryInput?: InputMaybe<WixRiseV1GetTransactionRequestInput>;
};


export type QueryWixRiseV1GetWalletArgs = {
  queryInput?: InputMaybe<WixRiseV1GetWalletRequestInput>;
};


export type QueryWixRiseV1GetWalletActionArgs = {
  queryInput?: InputMaybe<WixRiseV1GetWalletActionRequestInput>;
};


export type QueryWixRiseV1GiftCardsArgs = {
  queryInput?: InputMaybe<WixRiseV1QueryGiftCardsRequestInput>;
};


export type QueryWixRiseV1TransactionsArgs = {
  queryInput?: InputMaybe<WixRiseV1QueryTransactionsRequestInput>;
};


export type QueryWixRiseV1WalletActionsArgs = {
  queryInput?: InputMaybe<WixRiseV1QueryWalletActionRequestInput>;
};


export type QueryWixRiseV1WalletsArgs = {
  queryInput?: InputMaybe<WixRiseV1QueryWalletsRequestInput>;
};


export type QueryWixRiseWorkflowV1GetWorkflowArgs = {
  queryInput?: InputMaybe<WixRiseWorkflowV1GetWorkflowRequestInput>;
};


export type QueryWixRiseWorkflowV1WorkflowsArgs = {
  queryInput?: InputMaybe<WixRiseWorkflowV1QueryWorkflowsRequestInput>;
};

/** SpectaQL directive options */
export type SpectaQlOption = {
  /** key to use, for example "undocumented" */
  key: Scalars['String'];
  /** key value to set, for example "true" */
  value: Scalars['String'];
};

export type UpstreamWixCommonPortfolioCommonImage = {
  /** Image alt text. */
  altText?: Maybe<Scalars['String']>;
  /** Image filename. */
  filename?: Maybe<Scalars['String']>;
  /** Original image height. Required. */
  height?: Maybe<Scalars['Int']>;
  /** WixMedia image ID. Required. */
  id?: Maybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: Maybe<Scalars['String']>;
  /** Image URL. */
  url?: Maybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: Maybe<Scalars['String']>;
  /** Original image width. Required. */
  width?: Maybe<Scalars['Int']>;
};

export type UpstreamWixCommonPortfolioCommonImageInput = {
  /** Image alt text. */
  altText?: InputMaybe<Scalars['String']>;
  /** Image filename. */
  filename?: InputMaybe<Scalars['String']>;
  /** Original image height. Required. */
  height?: InputMaybe<Scalars['Int']>;
  /** WixMedia image ID. Required. */
  id?: InputMaybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: InputMaybe<Scalars['String']>;
  /** Image URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: InputMaybe<Scalars['String']>;
  /** Original image width. Required. */
  width?: InputMaybe<Scalars['Int']>;
};

export type UpstreamWixCommonPortfolioCommonVideoResolution = {
  /** Video filename. */
  filename?: Maybe<Scalars['String']>;
  /** Video format for example, mp4, hls.  Required. */
  format?: Maybe<Scalars['String']>;
  /** Video height. Required. */
  height?: Maybe<Scalars['Int']>;
  /** Video poster. Deprecated, please use the `posters` property in the parent entity */
  poster?: Maybe<UpstreamWixCommonPortfolioCommonImage>;
  /** Video quality for example 480p, 720p. */
  quality?: Maybe<Scalars['String']>;
  /** Video URL.  Required. */
  url?: Maybe<Scalars['String']>;
  /** Video width.  Required. */
  width?: Maybe<Scalars['Int']>;
};

export type UpstreamWixCommonPortfolioCommonVideoResolutionInput = {
  /** Video filename. */
  filename?: InputMaybe<Scalars['String']>;
  /** Video format for example, mp4, hls.  Required. */
  format?: InputMaybe<Scalars['String']>;
  /** Video height. Required. */
  height?: InputMaybe<Scalars['Int']>;
  /** Video poster. Deprecated, please use the `posters` property in the parent entity */
  poster?: InputMaybe<UpstreamWixCommonPortfolioCommonImageInput>;
  /** Video quality for example 480p, 720p. */
  quality?: InputMaybe<Scalars['String']>;
  /** Video URL.  Required. */
  url?: InputMaybe<Scalars['String']>;
  /** Video width.  Required. */
  width?: InputMaybe<Scalars['Int']>;
};

export type UpstreamWixCommonPortfolioCommonVideoV2 = {
  /** Video filename. */
  filename?: Maybe<Scalars['String']>;
  /** WixMedia ID. Required. */
  id?: Maybe<Scalars['String']>;
  /** Video posters. */
  posters?: Maybe<Array<Maybe<UpstreamWixCommonPortfolioCommonImage>>>;
  /** Available resolutions for the video, starting with the optimal resolution. */
  resolutions?: Maybe<Array<Maybe<UpstreamWixCommonPortfolioCommonVideoResolution>>>;
  /** Original video size in bytes. */
  sizeInBytes?: Maybe<Scalars['String']>;
  /** Video URL. */
  url?: Maybe<Scalars['String']>;
  /** Video URL expiration date (when relevant). */
  urlExpirationDate?: Maybe<Scalars['String']>;
};

export type UpstreamWixCommonPortfolioCommonVideoV2Input = {
  /** Video filename. */
  filename?: InputMaybe<Scalars['String']>;
  /** WixMedia ID. Required. */
  id?: InputMaybe<Scalars['String']>;
  /** Video posters. */
  posters?: InputMaybe<Array<InputMaybe<UpstreamWixCommonPortfolioCommonImageInput>>>;
  /** Available resolutions for the video, starting with the optimal resolution. */
  resolutions?: InputMaybe<Array<InputMaybe<UpstreamWixCommonPortfolioCommonVideoResolutionInput>>>;
  /** Original video size in bytes. */
  sizeInBytes?: InputMaybe<Scalars['String']>;
  /** Video URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Video URL expiration date (when relevant). */
  urlExpirationDate?: InputMaybe<Scalars['String']>;
};

export type WixApiApplicationError = {
  /** Error code. */
  code?: Maybe<Scalars['String']>;
  /** Data related to the error. */
  data?: Maybe<Scalars['JSON']>;
  /** Description of the error. */
  description?: Maybe<Scalars['String']>;
};

export type WixApiApplicationErrorInput = {
  /** Error code. */
  code?: InputMaybe<Scalars['String']>;
  /** Data related to the error. */
  data?: InputMaybe<Scalars['JSON']>;
  /** Description of the error. */
  description?: InputMaybe<Scalars['String']>;
};

export type WixApiDetails = {
  applicationError?: Maybe<WixApiApplicationError>;
  systemError?: Maybe<WixApiSystemError>;
  /** deprecated in API's - to enable migration from rendering arbitrary tracing to rest response */
  tracing?: Maybe<Scalars['JSON']>;
  validationError?: Maybe<WixApiValidationError>;
};

export type WixApiDetailsInput = {
  applicationError?: InputMaybe<WixApiApplicationErrorInput>;
  systemError?: InputMaybe<WixApiSystemErrorInput>;
  /** deprecated in API's - to enable migration from rendering arbitrary tracing to rest response */
  tracing?: InputMaybe<Scalars['JSON']>;
  validationError?: InputMaybe<WixApiValidationErrorInput>;
};

export type WixApiLoomTimecapsuleReschedule = {
  executeAt?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['String']>;
};

export type WixApiLoomTimecapsuleTaskAction = {
  cancel?: Maybe<Scalars['Void']>;
  complete?: Maybe<Scalars['Void']>;
  reschedule?: Maybe<WixApiLoomTimecapsuleReschedule>;
};

export type WixApiLoomTimecapsuleTaskInput = {
  executeAt?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<WixApiLoomTimecapsuleTaskKeyInput>;
  payload?: InputMaybe<Scalars['String']>;
};

export type WixApiLoomTimecapsuleTaskKeyInput = {
  appId?: InputMaybe<Scalars['String']>;
  instanceId?: InputMaybe<Scalars['String']>;
  subjectId?: InputMaybe<Scalars['String']>;
};

export type WixApiSystemError = {
  /** Error code. */
  errorCode?: Maybe<Scalars['String']>;
};

export type WixApiSystemErrorInput = {
  /** Error code. */
  errorCode?: InputMaybe<Scalars['String']>;
};

export type WixApiValidationError = {
  fieldViolations?: Maybe<Array<Maybe<WixApiValidationErrorFieldViolation>>>;
};

export type WixApiValidationErrorFieldViolation = {
  data?: Maybe<Scalars['JSON']>;
  description?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  /** applicable when violated_rule=OTHER */
  ruleName?: Maybe<Scalars['String']>;
  violatedRule?: Maybe<WixApiValidationErrorRuleType>;
};

export type WixApiValidationErrorFieldViolationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  description?: InputMaybe<Scalars['String']>;
  field?: InputMaybe<Scalars['String']>;
  /** applicable when violated_rule=OTHER */
  ruleName?: InputMaybe<Scalars['String']>;
  violatedRule?: InputMaybe<WixApiValidationErrorRuleType>;
};

export type WixApiValidationErrorInput = {
  fieldViolations?: InputMaybe<Array<InputMaybe<WixApiValidationErrorFieldViolationInput>>>;
};

export enum WixApiValidationErrorRuleType {
  DECIMAL_GT = 'DECIMAL_GT',
  DECIMAL_GTE = 'DECIMAL_GTE',
  DECIMAL_LT = 'DECIMAL_LT',
  DECIMAL_LTE = 'DECIMAL_LTE',
  DECIMAL_MAX_SCALE = 'DECIMAL_MAX_SCALE',
  EXACT_LENGTH = 'EXACT_LENGTH',
  EXACT_SIZE = 'EXACT_SIZE',
  FIELD_NOT_ALLOWED = 'FIELD_NOT_ALLOWED',
  FORMAT = 'FORMAT',
  INVALID_ENUM_VALUE = 'INVALID_ENUM_VALUE',
  MAX = 'MAX',
  MAX_LENGTH = 'MAX_LENGTH',
  MAX_SIZE = 'MAX_SIZE',
  MIN = 'MIN',
  MIN_LENGTH = 'MIN_LENGTH',
  MIN_SIZE = 'MIN_SIZE',
  ONE_OF_ALIGNMENT = 'ONE_OF_ALIGNMENT',
  OTHER = 'OTHER',
  REQUIRED_FIELD = 'REQUIRED_FIELD',
  REQUIRED_ONE_OF_FIELD = 'REQUIRED_ONE_OF_FIELD',
  VALIDATION = 'VALIDATION'
}

export type WixBillingV1BulkCreateTaxExemptGroupsRequestInput = {
  /** set to `true` if you wish to receive back the created TaxExemptGroups in the response */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /** List of TaxExemptGroups to be created */
  taxExemptGroups?: InputMaybe<Array<InputMaybe<WixBillingV1TaxExemptGroupInput>>>;
};

export type WixBillingV1BulkCreateTaxExemptGroupsResponse = {
  /** Metadata regarding the bulk create operation */
  bulkActionMetadata?: Maybe<WixBillingV1UpstreamWixCommonBulkActionMetadata>;
  /** List of the bulk create operation results including the TaxExemptGroups and metadata. */
  results?: Maybe<Array<Maybe<WixBillingV1BulkCreateTaxExemptGroupsResponseBulkTaxExemptGroupResult>>>;
};

export type WixBillingV1BulkCreateTaxExemptGroupsResponseBulkTaxExemptGroupResult = {
  /** Only exists if `returnEntity` was set to true in the request */
  item?: Maybe<WixBillingV1TaxExemptGroup>;
  /** Metadata regarding the specific single create operation */
  itemMetadata?: Maybe<WixBillingV1UpstreamWixCommonItemMetadata>;
};

export type WixBillingV1BulkDeleteTaxExemptGroupsRequestInput = {
  /** TaxExemptGroup ids to be deleted */
  taxExemptGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixBillingV1BulkDeleteTaxExemptGroupsResponse = {
  /** Metadata regarding the bulk delete operation */
  bulkActionMetadata?: Maybe<WixBillingV1UpstreamWixCommonBulkActionMetadata>;
  /** Results */
  results?: Maybe<Array<Maybe<WixBillingV1BulkDeleteTaxExemptGroupsResponseBulkTaxExemptGroupResult>>>;
};

export type WixBillingV1BulkDeleteTaxExemptGroupsResponseBulkTaxExemptGroupResult = {
  /** Metadata regarding the specific single delete operation */
  itemMetadata?: Maybe<WixBillingV1UpstreamWixCommonItemMetadata>;
};

export type WixBillingV1BulkUpdateTaxExemptGroupTagsByFilterRequestInput = {
  /** List of Tags to assign */
  assignTags?: InputMaybe<WixBillingV1UpstreamWixCommonTagsInput>;
  /** Filter */
  filter?: InputMaybe<Scalars['JSON']>;
  /** List of Tags to unAssign */
  unassignTags?: InputMaybe<WixBillingV1UpstreamWixCommonTagsInput>;
};

export type WixBillingV1BulkUpdateTaxExemptGroupTagsByFilterResponse = {
  /** Job ID */
  jobId?: Maybe<Scalars['String']>;
};

export type WixBillingV1BulkUpdateTaxExemptGroupTagsRequestInput = {
  /** List of Tags to assign */
  assignTags?: InputMaybe<WixBillingV1UpstreamWixCommonTagsInput>;
  /** List of NileProtoTagsEntities that their tags will update. */
  taxExemptGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** List of Tags to unAssign */
  unassignTags?: InputMaybe<WixBillingV1UpstreamWixCommonTagsInput>;
};

export type WixBillingV1BulkUpdateTaxExemptGroupTagsResponse = {
  /** Metadata regarding the bulk update operation */
  bulkActionMetadata?: Maybe<WixBillingV1UpstreamWixCommonBulkActionMetadata>;
  /** Results */
  results?: Maybe<Array<Maybe<WixBillingV1BulkUpdateTaxExemptGroupTagsResponseBulkUpdateTaxExemptGroupTagsResult>>>;
};

export type WixBillingV1BulkUpdateTaxExemptGroupTagsResponseBulkUpdateTaxExemptGroupTagsResult = {
  /** Metadata regarding the specific single update operation */
  itemMetadata?: Maybe<WixBillingV1UpstreamWixCommonItemMetadata>;
};

export type WixBillingV1BulkUpdateTaxExemptGroupsRequestInput = {
  /** set to `true` if you wish to receive back the updated TaxExemptGroups in the response */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /** List of TaxExemptGroups to be updated. */
  taxExemptGroups?: InputMaybe<Array<InputMaybe<WixBillingV1BulkUpdateTaxExemptGroupsRequestMaskedTaxExemptGroupInput>>>;
};

export type WixBillingV1BulkUpdateTaxExemptGroupsRequestMaskedTaxExemptGroupInput = {
  /** Explicit list of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** TaxExemptGroup to be updated, may be partial */
  taxExemptGroup?: InputMaybe<WixBillingV1TaxExemptGroupInput>;
};

export type WixBillingV1BulkUpdateTaxExemptGroupsResponse = {
  /** Metadata regarding the bulk update operation */
  bulkActionMetadata?: Maybe<WixBillingV1UpstreamWixCommonBulkActionMetadata>;
  /** Results */
  results?: Maybe<Array<Maybe<WixBillingV1BulkUpdateTaxExemptGroupsResponseBulkTaxExemptGroupResult>>>;
};

export type WixBillingV1BulkUpdateTaxExemptGroupsResponseBulkTaxExemptGroupResult = {
  /** Only exists if `returnEntity` was set to true in the request */
  item?: Maybe<WixBillingV1TaxExemptGroup>;
  /** Metadata regarding the specific single update operation */
  itemMetadata?: Maybe<WixBillingV1UpstreamWixCommonItemMetadata>;
};

export type WixBillingV1CreateTaxExemptGroupRequestInput = {
  /** TaxExemptGroup to be created. */
  taxExemptGroup?: InputMaybe<WixBillingV1TaxExemptGroupInput>;
};

export type WixBillingV1CreateTaxExemptGroupResponse = {
  /** The created TaxExemptGroup. */
  taxExemptGroup?: Maybe<WixBillingV1TaxExemptGroup>;
};

export type WixBillingV1DeleteTaxExemptGroupRequestInput = {
  /** Id of the TaxExemptGroup to delete. */
  taxExemptGroupId?: InputMaybe<Scalars['String']>;
};

export type WixBillingV1GetTaxExemptGroupRequestInput = {
  id: Scalars['ID'];
};

export type WixBillingV1QueryTaxExemptGroupsRequestInput = {
  /** WQL expression. */
  query?: InputMaybe<WixBillingV1UpstreamWixCommonCursorQueryInput>;
};

export type WixBillingV1QueryTaxExemptGroupsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<WixBillingV1TaxExemptGroup>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixBillingV1TaxExemptGroup = {
  /** Date and time the TaxExemptGroup was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Data Extensions */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** TaxExemptGroup ID. */
  id?: Maybe<Scalars['String']>;
  /** Exempt group name. */
  name?: Maybe<Scalars['String']>;
  /**
   * Revision number, which increments by 1 each time the TaxExemptGroup is updated.
   * To prevent conflicting changes,
   * the current revision must be passed when updating the TaxExemptGroup.
   *
   * Ignored when creating a TaxExemptGroup.
   */
  revision?: Maybe<Scalars['Long']>;
  /** Tags */
  tags?: Maybe<WixBillingV1UpstreamWixCommonTags>;
  /** Date and time the TaxExemptGroup was last updated. */
  updatedDate?: Maybe<Scalars['String']>;
};

export type WixBillingV1TaxExemptGroupInput = {
  /** Date and time the TaxExemptGroup was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Data Extensions */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** TaxExemptGroup ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Exempt group name. */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Revision number, which increments by 1 each time the TaxExemptGroup is updated.
   * To prevent conflicting changes,
   * the current revision must be passed when updating the TaxExemptGroup.
   *
   * Ignored when creating a TaxExemptGroup.
   */
  revision?: InputMaybe<Scalars['Long']>;
  /** Tags */
  tags?: InputMaybe<WixBillingV1UpstreamWixCommonTagsInput>;
  /** Date and time the TaxExemptGroup was last updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export type WixBillingV1UpdateTaxExemptGroupRequestInput = {
  /** Set of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** TaxExemptGroup to be updated, may be partial. */
  taxExemptGroup?: InputMaybe<WixBillingV1TaxExemptGroupInput>;
};

export type WixBillingV1UpdateTaxExemptGroupResponse = {
  /** Updated TaxExemptGroup. */
  taxExemptGroup?: Maybe<WixBillingV1TaxExemptGroup>;
};

export type WixBillingV1UpstreamWixCommonBulkActionMetadata = {
  /** Number of items that couldn't be processed. */
  totalFailures?: Maybe<Scalars['Int']>;
  /** Number of items that were successfully processed. */
  totalSuccesses?: Maybe<Scalars['Int']>;
  /** Number of failures without details because detailed failure threshold was exceeded. */
  undetailedFailures?: Maybe<Scalars['Int']>;
};

export type WixBillingV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * Pass the relevant cursor token from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Maximum number of items to return in the results. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixBillingV1UpstreamWixCommonCursorQueryInput = {
  /**
   * Cursor paging options.
   *
   * Learn more about [cursor paging](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#cursor-paging).
   */
  cursorPaging?: InputMaybe<WixBillingV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object.
   *
   * Learn more about the [filter section](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#the-filter-section).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object.
   *
   * Learn more about the [sort section](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#the-sort-section).
   */
  sort?: InputMaybe<Array<InputMaybe<WixBillingV1UpstreamWixCommonSortingInput>>>;
};

export type WixBillingV1UpstreamWixCommonItemMetadata = {
  /** Details about the error in case of failure. */
  error?: Maybe<WixApiApplicationError>;
  /** Item ID. Provided only whenever possible. For example, `itemId` can't be provided when item creation has failed. */
  id?: Maybe<Scalars['String']>;
  /** Index of the item within the request array. Allows for correlation between request and response items. */
  originalIndex?: Maybe<Scalars['Int']>;
  /** Whether the requested action for this item was successful. When `false`, the `error` field is returned. */
  success?: Maybe<Scalars['Boolean']>;
};

export enum WixBillingV1UpstreamWixCommonSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type WixBillingV1UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixBillingV1UpstreamWixCommonSortOrder>;
};

export type WixBillingV1UpstreamWixCommonTags = {
  /** Tags that require an additional permission in order to access them, normally not given to site members or visitors. */
  privateTags?: Maybe<WixBillingV1UpstreamWixCommonTagsTagList>;
  /** Tags that are exposed to anyone who has access to the labeled entity itself, including site members and visitors. */
  publicTags?: Maybe<WixBillingV1UpstreamWixCommonTagsTagList>;
};

export type WixBillingV1UpstreamWixCommonTagsInput = {
  /** Tags that require an additional permission in order to access them, normally not given to site members or visitors. */
  privateTags?: InputMaybe<WixBillingV1UpstreamWixCommonTagsTagListInput>;
  /** Tags that are exposed to anyone who has access to the labeled entity itself, including site members and visitors. */
  publicTags?: InputMaybe<WixBillingV1UpstreamWixCommonTagsTagListInput>;
};

export type WixBillingV1UpstreamWixCommonTagsTagList = {
  /** List of tag IDs. */
  tagIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type WixBillingV1UpstreamWixCommonTagsTagListInput = {
  /** List of tag IDs. */
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixBlogKafkaProducerV1SendActionEventRequestInput = {
  entityId?: InputMaybe<Scalars['String']>;
  postCountersUpdated?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PostCountersUpdatedInput>;
  postLikedAction?: InputMaybe<ComWixpressNpmCommunitiesPlatformizedBlogV3PostLikedInput>;
};

export type WixBookingsCalendarUpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /**
   * Number of sessions to return.
   * Defaults to `50`. Maximum `1000`.
   */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsCalendarUpstreamWixCommonQueryV2Input = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `query.filter`. */
  cursorPaging?: InputMaybe<WixBookingsCalendarUpstreamWixCommonCursorPagingInput>;
  /**
   * Supported values: `ALL_PI`.
   *
   * Predefined sets of fields to return.
   *
   * - `ALL_PI`: Returns complete session objects.
   *
   * If you don't pass a value in the `fieldsets` array, session objects without
   * personal information are returned by default. This means without `participants`,
   * `location`, `calendarConference`, and `externalCalendarOverrides`.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter object.
   * See [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language)
   * for more information.
   *
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`.
   *
   * For a detailed list of supported filters, see
   * [Supported Filters](https://dev.wix.com/api/rest/wix-bookings/calendar-v2/filters).
   */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type WixBookingsCalendarV2CacheInfo = {
  cachedDate?: Maybe<Scalars['String']>;
  feedReplayId?: Maybe<Scalars['String']>;
  fromDate?: Maybe<Scalars['String']>;
  sessionCount?: Maybe<Scalars['Int']>;
  status?: Maybe<WixBookingsCalendarV2CacheInfoStatus>;
  toDate?: Maybe<Scalars['String']>;
};

export enum WixBookingsCalendarV2CacheInfoStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  IN_PROGRESS = 'IN_PROGRESS',
  UNDEFINED = 'UNDEFINED'
}

export type WixBookingsCalendarV2CacheRequestInput = {
  fromDate?: InputMaybe<Scalars['String']>;
};

export type WixBookingsCalendarV2CacheResponse = {
  cacheInfo?: Maybe<WixBookingsCalendarV2CacheInfo>;
};

export type WixBookingsCalendarV2GetCacheInfoRequestInput = {
  includeSessionCount?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsCalendarV2GetCacheInfoResponse = {
  cacheInfo?: Maybe<WixBookingsCalendarV2CacheInfo>;
};

export type WixBookingsCalendarV2ListSessionsRequestInput = {
  /**
   * Predefined sets of fields to return.
   * - `NO_PI`: Returns session objects without personal information.
   * - `ALL_PI`: Returns complete session objects, including personal information. Requires the CALENDAR.SESSION_READ_PI permission scope.
   *
   * Default: `NO_PI`
   */
  fieldsets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** IDs of the sessions to retrieve. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixBookingsCalendarV2ListSessionsResponse = {
  /** Paging metadata. */
  pagingMetadata?: Maybe<WixCommonPagingMetadataV2>;
  /** Retrieved sessions. */
  sessions?: Maybe<Array<Maybe<ComWixBookingsSchedulesApiV1Session>>>;
};

export type WixBookingsCalendarV2QueryEventSessionInstancesRequestInput = {
  /**
   * Start of the time range for which sessions are returned
   * in [ISO 8601 format](https://en.wikipedia.org/wiki/ISO_8601#Coordinated_Universal_Time_(UTC)).
   * Required, if `query.cursorPaging` is omitted.
   * `end.timestamp` of all returned sessions is greater than or equal to `fromDate`.
   */
  fromDate?: InputMaybe<Scalars['String']>;
  /** Information about filters, paging, and returned fields. */
  query?: InputMaybe<WixBookingsCalendarUpstreamWixCommonQueryV2Input>;
  /**
   * End of the time range for which sessions are returned
   * in [ISO 8601 format](https://en.wikipedia.org/wiki/ISO_8601#Coordinated_Universal_Time_(UTC)).
   * Required, if `query.cursorPaging` is omitted.
   * `start.timestamp` of all returned sessions is less than or equal to `toDate`.
   */
  toDate?: InputMaybe<Scalars['String']>;
};

export type WixBookingsCalendarV2QueryEventSessionInstancesResponse = {
  /** Paging metadata. */
  pagingMetadata?: Maybe<WixCommonPagingMetadataV2>;
  /** Retrieved sessions. */
  sessions?: Maybe<Array<Maybe<ComWixBookingsSchedulesApiV1Session>>>;
};

export type WixBookingsCalendarV2ShortenCacheRequestInput = {
  /**
   * The new cache from date to set.
   * Must be after than the current from date.
   */
  fromDate?: InputMaybe<Scalars['String']>;
};

export type WixBookingsCalendarV2ShortenCacheResponse = {
  /** The updated cache. */
  cacheInfo?: Maybe<WixBookingsCalendarV2CacheInfo>;
};

export type WixBookingsCalendarfeedV2FeedEventInput = {
  /** Session has been added or updated within the feed window. */
  sessionAddedOrUpdated?: InputMaybe<WixBookingsCalendarfeedV2SessionAddedOrUpdatedInput>;
  /** Session has been removed from the feed. */
  sessionRemoved?: InputMaybe<WixBookingsCalendarfeedV2SessionRemovedInput>;
  /** The feed window has been extended. */
  windowExtended?: InputMaybe<WixBookingsCalendarfeedV2WindowExtendedInput>;
  /** Deprecated. Please use `window_extended` instead. */
  windowMoved?: InputMaybe<WixBookingsCalendarfeedV2WindowMovedInput>;
};

export type WixBookingsCalendarfeedV2FeedReplayEventInput = {
  /** Sessions replay completed. */
  replayCompleted?: InputMaybe<WixBookingsCalendarfeedV2ReplayCompletedInput>;
  replayId?: InputMaybe<Scalars['String']>;
  /** Session has been added within the feed window. */
  sessionAdded?: InputMaybe<WixBookingsCalendarfeedV2SessionAddedInput>;
};

export type WixBookingsCalendarfeedV2ReplayCompletedInput = {
  /** The (minimum) number of sessions that were replayed. */
  totalSessions?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsCalendarfeedV2SessionAddedInput = {
  /** The session which was added within the feed window. */
  session?: InputMaybe<ComWixBookingsSchedulesApiV1SessionInput>;
  /** Deprecated. Please use `session.version.number` instead. */
  sessionVersion?: InputMaybe<Scalars['Long']>;
};

export type WixBookingsCalendarfeedV2SessionAddedOrUpdatedInput = {
  /** Deprecated. Please use `previous_session.affected_schedules[*].schedule_id` instead. */
  previousAffectedScheduleIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Optionally, the previous session. */
  previousSession?: InputMaybe<ComWixBookingsSchedulesApiV1SessionInput>;
  /** The session which was added or updated within the view. */
  session?: InputMaybe<ComWixBookingsSchedulesApiV1SessionInput>;
  /** Deprecated. Please use `session.version.number` instead. */
  sessionVersion?: InputMaybe<Scalars['Long']>;
};

export type WixBookingsCalendarfeedV2SessionRemovedInput = {
  /** Deprecated. Please use `session.affectedSchedules[*].scheduleId` instead. */
  affectedScheduleIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Optionally, the previous session. */
  previousSession?: InputMaybe<ComWixBookingsSchedulesApiV1SessionInput>;
  /** Deprecated. Please use `session.schedule_id` instead. */
  scheduleId?: InputMaybe<Scalars['String']>;
  /** The updated session which was removed from the view. */
  session?: InputMaybe<ComWixBookingsSchedulesApiV1SessionInput>;
  /** Deprecated. Please use `session.id` instead. */
  sessionId?: InputMaybe<Scalars['String']>;
  /** Deprecated. Please use `session_version.number` instead. */
  sessionVersion?: InputMaybe<Scalars['Long']>;
};

export type WixBookingsCalendarfeedV2WindowExtendedInput = {
  /** The updated window end date. */
  windowEndDate?: InputMaybe<Scalars['String']>;
};

export type WixBookingsCalendarfeedV2WindowMovedInput = {
  /** The updated window edge. */
  edge?: InputMaybe<Scalars['String']>;
  /** The window version. */
  windowVersion?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsCatalogV1CloneServiceOptionsAndVariantsRequestInput = {
  /** ID of the `serviceOptionsAndVariants` object to clone. */
  cloneFromId?: InputMaybe<Scalars['String']>;
  /**
   * ID of the service to which the cloned `serviceOptionsAndVariants` are
   * connected.
   */
  targetServiceId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsCatalogV1CloneServiceOptionsAndVariantsResponse = {
  /** Cloned `serviceOptionsAndVariants` object. */
  serviceOptionsAndVariants?: Maybe<WixBookingsCatalogV1ServiceOptionsAndVariants>;
};

export type WixBookingsCatalogV1CreateServiceOptionsAndVariantsRequestInput = {
  /** Service options and variants to create. */
  serviceOptionsAndVariants?: InputMaybe<WixBookingsCatalogV1ServiceOptionsAndVariantsInput>;
};

export type WixBookingsCatalogV1CreateServiceOptionsAndVariantsResponse = {
  /** Information about the created service options and variants. */
  serviceOptionsAndVariants?: Maybe<WixBookingsCatalogV1ServiceOptionsAndVariants>;
};

export type WixBookingsCatalogV1CustomServiceOption = {
  /**
   * Available choices for the service option. For example, `child`, `student`,
   * `adult`, and `senior` for a service option named `Age group`. Each value must
   * be unique. The value's case is ignored, meaning `Child` and `child` are
   * considered to be identical. Currently, only a single choice is supported
   * because a service can have only a single option.
   *
   * Max: 1 choice
   */
  choices?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Name of the service option. For example, `Age group`, `Location`, `Equipment`,
   * or `Time`.
   */
  name?: Maybe<Scalars['String']>;
};

export type WixBookingsCatalogV1CustomServiceOptionInput = {
  /**
   * Available choices for the service option. For example, `child`, `student`,
   * `adult`, and `senior` for a service option named `Age group`. Each value must
   * be unique. The value's case is ignored, meaning `Child` and `child` are
   * considered to be identical. Currently, only a single choice is supported
   * because a service can have only a single option.
   *
   * Max: 1 choice
   */
  choices?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Name of the service option. For example, `Age group`, `Location`, `Equipment`,
   * or `Time`.
   */
  name?: InputMaybe<Scalars['String']>;
};

export type WixBookingsCatalogV1DeleteServiceOptionsAndVariantsRequestInput = {
  /** Revision of the `serviceOptionsAndVariants` object to delete. */
  revision?: InputMaybe<Scalars['Long']>;
  /** ID of the `serviceOptionsAndVariants` object to delete. */
  serviceOptionsAndVariantsId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsCatalogV1Duration = {
  /**
   * Duration of the service in minutes.
   *
   * Min: `1` minute
   * Max: `44639` minutes (30 days, 23 hours, and 59 minutes)
   */
  minutes?: Maybe<Scalars['Int']>;
  /**
   * Name of the duration option.
   *
   * Default: Human-readable text of `minutes`. For example, `1 hr 30 min`.
   */
  name?: Maybe<Scalars['String']>;
};

export type WixBookingsCatalogV1DurationInput = {
  /**
   * Duration of the service in minutes.
   *
   * Min: `1` minute
   * Max: `44639` minutes (30 days, 23 hours, and 59 minutes)
   */
  minutes?: InputMaybe<Scalars['Int']>;
  /**
   * Name of the duration option.
   *
   * Default: Human-readable text of `minutes`. For example, `1 hr 30 min`.
   */
  name?: InputMaybe<Scalars['String']>;
};

export type WixBookingsCatalogV1DurationServiceOption = {
  /**
   * Optional name of the duration option. For example, `Short Class`, or
   * `Extended Class`.
   */
  name?: Maybe<Scalars['String']>;
};

export type WixBookingsCatalogV1DurationServiceOptionInput = {
  /**
   * Optional name of the duration option. For example, `Short Class`, or
   * `Extended Class`.
   */
  name?: InputMaybe<Scalars['String']>;
};

export type WixBookingsCatalogV1GetServiceOptionsAndVariantsByServiceIdRequestInput = {
  /** ID of the service to retrieve options and variants for. */
  serviceId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsCatalogV1GetServiceOptionsAndVariantsByServiceIdResponse = {
  /** Retrieved `serviceOptionsAndVariants` object. */
  serviceVariants?: Maybe<WixBookingsCatalogV1ServiceOptionsAndVariants>;
};

export type WixBookingsCatalogV1GetServiceOptionsAndVariantsRequestInput = {
  id: Scalars['ID'];
};

export type WixBookingsCatalogV1QueryServiceOptionsAndVariantsRequestInput = {
  /** Information about filters, paging, and returned fields. */
  query?: InputMaybe<WixBookingsCatalogV1UpstreamWixCommonQueryV2Input>;
};

export type WixBookingsCatalogV1QueryServiceOptionsAndVariantsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<WixBookingsCatalogV1ServiceOptionsAndVariants>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixBookingsCatalogV1ServiceChoice = {
  /** Name of the custom choice. */
  custom?: Maybe<Scalars['String']>;
  /** Information about the option's duration. */
  duration?: Maybe<WixBookingsCatalogV1Duration>;
  /**
   * ID of the service choice.
   * Used by multilingual translations.
   */
  id?: Maybe<Scalars['String']>;
  /** ID of the service option. */
  optionId?: Maybe<Scalars['String']>;
  /**
   * ID of the [staff member](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members/introduction)
   * providing the service.
   */
  staffMemberId?: Maybe<Scalars['String']>;
};

export type WixBookingsCatalogV1ServiceChoiceInput = {
  /** Name of the custom choice. */
  custom?: InputMaybe<Scalars['String']>;
  /** Information about the option's duration. */
  duration?: InputMaybe<WixBookingsCatalogV1DurationInput>;
  /**
   * ID of the service choice.
   * Used by multilingual translations.
   */
  id?: InputMaybe<Scalars['String']>;
  /** ID of the service option. */
  optionId?: InputMaybe<Scalars['String']>;
  /**
   * ID of the [staff member](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members/introduction)
   * providing the service.
   */
  staffMemberId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsCatalogV1ServiceOption = {
  /** Details about the custom option. Available only for `CUSTOM` options. */
  customData?: Maybe<WixBookingsCatalogV1CustomServiceOption>;
  durationData?: Maybe<WixBookingsCatalogV1DurationServiceOption>;
  /** ID of the service option. */
  id?: Maybe<Scalars['String']>;
  /** Type of the service option. */
  type?: Maybe<WixBookingsCatalogV1ServiceOptionTypeEnumServiceOptionType>;
};

export type WixBookingsCatalogV1ServiceOptionInput = {
  /** Details about the custom option. Available only for `CUSTOM` options. */
  customData?: InputMaybe<WixBookingsCatalogV1CustomServiceOptionInput>;
  durationData?: InputMaybe<WixBookingsCatalogV1DurationServiceOptionInput>;
  /** ID of the service option. */
  id?: InputMaybe<Scalars['String']>;
  /** Type of the service option. */
  type?: InputMaybe<WixBookingsCatalogV1ServiceOptionTypeEnumServiceOptionType>;
};

export enum WixBookingsCatalogV1ServiceOptionTypeEnumServiceOptionType {
  /**
   * The service option is based on a custom parameter. For example, age group,
   * booked equipment, or appointment timing.
   */
  CUSTOM = 'CUSTOM',
  /** It's a duration-based option. */
  DURATION = 'DURATION',
  /**
   * It's a [staff member](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members/introduction)
   * based option.
   */
  STAFF_MEMBER = 'STAFF_MEMBER',
  /** There is no information about the option type. */
  UNKNOWN = 'UNKNOWN'
}

export type WixBookingsCatalogV1ServiceOptionsAndVariants = {
  /** Extensions enabling users to save custom data related to service options and variants. */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** ID of the `serviceOptionsAndVariants` object. */
  id?: Maybe<Scalars['String']>;
  /** Price of the most expensive service variant. */
  maxPrice?: Maybe<WixBookingsCatalogV1UpstreamWixCommonMoney>;
  /** Price of the cheapest service variant. */
  minPrice?: Maybe<WixBookingsCatalogV1UpstreamWixCommonMoney>;
  /** Service options. Note that currently only a single option is supported per service. */
  options?: Maybe<WixBookingsCatalogV1ServiceOptionsAndVariantsServiceOptions>;
  /**
   * Revision number, which increments by 1 each time the `serviceOptionsAndVariants` object is updated.
   * To prevent conflicting changes,
   * the current revision must be passed when updating and deleting the `serviceOptionsAndVariants` object.
   *
   * Ignored when creating a `serviceOptionsAndVariants` object.
   */
  revision?: Maybe<Scalars['Long']>;
  /** ID of the service related to these options and variants. */
  serviceId?: Maybe<Scalars['String']>;
  /** Information about the service's variants. */
  variants?: Maybe<WixBookingsCatalogV1ServiceOptionsAndVariantsServiceVariants>;
};

export type WixBookingsCatalogV1ServiceOptionsAndVariantsInput = {
  /** Extensions enabling users to save custom data related to service options and variants. */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** ID of the `serviceOptionsAndVariants` object. */
  id?: InputMaybe<Scalars['String']>;
  /** Price of the most expensive service variant. */
  maxPrice?: InputMaybe<WixBookingsCatalogV1UpstreamWixCommonMoneyInput>;
  /** Price of the cheapest service variant. */
  minPrice?: InputMaybe<WixBookingsCatalogV1UpstreamWixCommonMoneyInput>;
  /** Service options. Note that currently only a single option is supported per service. */
  options?: InputMaybe<WixBookingsCatalogV1ServiceOptionsAndVariantsServiceOptionsInput>;
  /**
   * Revision number, which increments by 1 each time the `serviceOptionsAndVariants` object is updated.
   * To prevent conflicting changes,
   * the current revision must be passed when updating and deleting the `serviceOptionsAndVariants` object.
   *
   * Ignored when creating a `serviceOptionsAndVariants` object.
   */
  revision?: InputMaybe<Scalars['Long']>;
  /** ID of the service related to these options and variants. */
  serviceId?: InputMaybe<Scalars['String']>;
  /** Information about the service's variants. */
  variants?: InputMaybe<WixBookingsCatalogV1ServiceOptionsAndVariantsServiceVariantsInput>;
};

export type WixBookingsCatalogV1ServiceOptionsAndVariantsServiceOptions = {
  /**
   * Values of the service options.
   *
   * Max: 1 service option
   */
  values?: Maybe<Array<Maybe<WixBookingsCatalogV1ServiceOption>>>;
};

export type WixBookingsCatalogV1ServiceOptionsAndVariantsServiceOptionsInput = {
  /**
   * Values of the service options.
   *
   * Max: 1 service option
   */
  values?: InputMaybe<Array<InputMaybe<WixBookingsCatalogV1ServiceOptionInput>>>;
};

export type WixBookingsCatalogV1ServiceOptionsAndVariantsServiceVariants = {
  /** Values of the service variants. */
  values?: Maybe<Array<Maybe<WixBookingsCatalogV1ServiceVariant>>>;
};

export type WixBookingsCatalogV1ServiceOptionsAndVariantsServiceVariantsInput = {
  /** Values of the service variants. */
  values?: InputMaybe<Array<InputMaybe<WixBookingsCatalogV1ServiceVariantInput>>>;
};

export type WixBookingsCatalogV1ServiceVariant = {
  /**
   * Choices for the service option. Currently, only a single choice is supported
   * because a service can have only a single option.
   *
   * Max: 1 choice
   */
  choices?: Maybe<Array<Maybe<WixBookingsCatalogV1ServiceChoice>>>;
  /**
   * ID of the service variant.
   * Used by multilingual translations.
   */
  id?: Maybe<Scalars['String']>;
  /** Information about the service variant's price. */
  price?: Maybe<WixBookingsCatalogV1UpstreamWixCommonMoney>;
};

export type WixBookingsCatalogV1ServiceVariantInput = {
  /**
   * Choices for the service option. Currently, only a single choice is supported
   * because a service can have only a single option.
   *
   * Max: 1 choice
   */
  choices?: InputMaybe<Array<InputMaybe<WixBookingsCatalogV1ServiceChoiceInput>>>;
  /**
   * ID of the service variant.
   * Used by multilingual translations.
   */
  id?: InputMaybe<Scalars['String']>;
  /** Information about the service variant's price. */
  price?: InputMaybe<WixBookingsCatalogV1UpstreamWixCommonMoneyInput>;
};

export type WixBookingsCatalogV1UpdateServiceOptionsAndVariantsRequestInput = {
  /** Field mask containing information about the fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** `ServiceOptionsAndVariants` object to update. */
  serviceOptionsAndVariants?: InputMaybe<WixBookingsCatalogV1ServiceOptionsAndVariantsInput>;
};

export type WixBookingsCatalogV1UpdateServiceOptionsAndVariantsResponse = {
  /** Updated `serviceOptionsAndVariants` object. */
  serviceOptionsAndVariants?: Maybe<WixBookingsCatalogV1ServiceOptionsAndVariants>;
};

export type WixBookingsCatalogV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * Pass the relevant cursor token from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Maximum number of items to return in the results. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsCatalogV1UpstreamWixCommonMoney = {
  /** Currency code. Must be valid ISO 4217 currency code (e.g., USD). */
  currency?: Maybe<Scalars['String']>;
  /** Monetary amount. Decimal string in local format (e.g., 1 000,30). Optionally, a single (-), to indicate that the amount is negative. */
  formattedValue?: Maybe<Scalars['String']>;
  /** Monetary amount. Decimal string with a period as a decimal separator (e.g., 3.99). Optionally, a single (-), to indicate that the amount is negative. */
  value?: Maybe<Scalars['String']>;
};

export type WixBookingsCatalogV1UpstreamWixCommonMoneyInput = {
  /** Currency code. Must be valid ISO 4217 currency code (e.g., USD). */
  currency?: InputMaybe<Scalars['String']>;
  /** Monetary amount. Decimal string in local format (e.g., 1 000,30). Optionally, a single (-), to indicate that the amount is negative. */
  formattedValue?: InputMaybe<Scalars['String']>;
  /** Monetary amount. Decimal string with a period as a decimal separator (e.g., 3.99). Optionally, a single (-), to indicate that the amount is negative. */
  value?: InputMaybe<Scalars['String']>;
};

export type WixBookingsCatalogV1UpstreamWixCommonPagingInput = {
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the current sort order. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsCatalogV1UpstreamWixCommonQueryV2Input = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixBookingsCatalogV1UpstreamWixCommonCursorPagingInput>;
  /** Array of projected fields. A list of specific field names to return. If `fieldsets` are also specified, the union of `fieldsets` and `fields` is returned. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of named, predefined sets of projected fields. A array of predefined named sets of fields to be returned. Specifying multiple `fieldsets` will return the union of fields from all sets. If `fields` are also specified, the union of `fieldsets` and `fields` is returned. */
  fieldsets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter object.
   *
   * Learn more about the [filter section](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#the-filter-section).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Paging options to limit and skip the number of items. */
  paging?: InputMaybe<WixBookingsCatalogV1UpstreamWixCommonPagingInput>;
  /**
   * Sort object.
   *
   * Learn more about the [sort section](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#the-sort-section).
   */
  sort?: InputMaybe<Array<InputMaybe<WixBookingsCatalogV1UpstreamWixCommonSortingInput>>>;
};

export enum WixBookingsCatalogV1UpstreamWixCommonSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type WixBookingsCatalogV1UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixBookingsCatalogV1UpstreamWixCommonSortOrder>;
  /**
   * When `field_name` is a property of repeated field that is marked as `MATCH_ITEMS` and sort should be done by
   * a specific element from a collection, filter can/should be provided to ensure correct sort value is picked.
   *
   * If multiple filters are provided, they are combined with AND operator.
   *
   * Example:
   * Given we have document like {"id": "1", "nestedField": [{"price": 10, "region": "EU"}, {"price": 20, "region": "US"}]}
   * and `nestedField` is marked as `MATCH_ITEMS`, to ensure that sorting is done by correct region, filter should be
   * { fieldName: "nestedField.price", "select_items_by": [{"nestedField.region": "US"}] }
   */
  selectItemsBy?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type WixBookingsCategoriesV2Category = {
  /** Date and time the category was created in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  createdDate?: Maybe<Scalars['String']>;
  /**
   * Custom field data for the category object.
   *
   * [Extended fields](https://dev.wix.com/docs/build-apps/develop-your-app/extensions/backend-extensions/schema-plugins/about-schema-plugin-extensions) must be configured in the app dashboard before they can be accessed with API calls.
   */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** Category ID. */
  id?: Maybe<Scalars['String']>;
  /** Category name. */
  name?: Maybe<Scalars['String']>;
  /**
   * Revision number, which increments by 1 each time the category is updated.
   * To prevent conflicting changes, you must specify the current revision when updating the category.
   *
   * Ignored when creating a category.
   */
  revision?: Maybe<Scalars['Long']>;
  /**
   * Defines the category's position in the categories list relative to other categories.
   * Wix Bookings assigns `sortOrder` values with large gaps between adjacent categories, allowing efficient reordering without updating the entire list. When gaps become too small, the system automatically reassigns new `sortOrder` values to restore larger gaps.
   */
  sortOrder?: Maybe<Scalars['Int']>;
  /** Date and time the Category was last updated in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  updatedDate?: Maybe<Scalars['String']>;
};

export type WixBookingsCategoriesV2CategoryInput = {
  /** Date and time the category was created in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  createdDate?: InputMaybe<Scalars['String']>;
  /**
   * Custom field data for the category object.
   *
   * [Extended fields](https://dev.wix.com/docs/build-apps/develop-your-app/extensions/backend-extensions/schema-plugins/about-schema-plugin-extensions) must be configured in the app dashboard before they can be accessed with API calls.
   */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** Category ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Category name. */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Revision number, which increments by 1 each time the category is updated.
   * To prevent conflicting changes, you must specify the current revision when updating the category.
   *
   * Ignored when creating a category.
   */
  revision?: InputMaybe<Scalars['Long']>;
  /**
   * Defines the category's position in the categories list relative to other categories.
   * Wix Bookings assigns `sortOrder` values with large gaps between adjacent categories, allowing efficient reordering without updating the entire list. When gaps become too small, the system automatically reassigns new `sortOrder` values to restore larger gaps.
   */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Date and time the Category was last updated in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export type WixBookingsCategoriesV2CountCategoriesRequestInput = {
  /** Filter to base the count on. */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type WixBookingsCategoriesV2CountCategoriesResponse = {
  /** Number of categories matching the filter. */
  count?: Maybe<Scalars['Int']>;
};

export type WixBookingsCategoriesV2CreateCategoryRequestInput = {
  /** Category to create. */
  category?: InputMaybe<WixBookingsCategoriesV2CategoryInput>;
};

export type WixBookingsCategoriesV2CreateCategoryResponse = {
  /** Created category. */
  category?: Maybe<WixBookingsCategoriesV2Category>;
};

export type WixBookingsCategoriesV2DeleteCategoryRequestInput = {
  /** ID of the category to delete. */
  categoryId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsCategoriesV2GetCategoryRequestInput = {
  id: Scalars['ID'];
};

export type WixBookingsCategoriesV2ImportCategoriesRequestInput = {
  /** List of categories to import. */
  categories?: InputMaybe<Array<InputMaybe<WixBookingsCategoriesV2CategoryInput>>>;
};

export type WixBookingsCategoriesV2MoveCategoryRequestInput = {
  /**
   * ID of the reference category.
   * Specify only for `{"position": "AFTER_CATEGORY"}`.
   */
  afterCategoryId?: InputMaybe<Scalars['String']>;
  /** ID of the category to move. */
  categoryId?: InputMaybe<Scalars['String']>;
  /** New position of the category. */
  position?: InputMaybe<WixBookingsCategoriesV2MoveCategoryRequestPosition>;
};

export enum WixBookingsCategoriesV2MoveCategoryRequestPosition {
  /** Place the category immediately after a specific category. */
  AFTER_CATEGORY = 'AFTER_CATEGORY',
  /** Place the category at the beginning of the list. */
  FIRST = 'FIRST',
  /** Place the category at the end of the list. */
  LAST = 'LAST',
  UNKNOWN_POSITION = 'UNKNOWN_POSITION'
}

export type WixBookingsCategoriesV2MoveCategoryResponse = {
  /** Updated category. */
  category?: Maybe<WixBookingsCategoriesV2Category>;
};

export type WixBookingsCategoriesV2QueryCategoriesRequestInput = {
  /** WQL expression. */
  query?: InputMaybe<WixBookingsCategoriesV2UpstreamWixCommonCursorQueryInput>;
};

export type WixBookingsCategoriesV2QueryCategoriesResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<WixBookingsCategoriesV2Category>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixBookingsCategoriesV2UpdateCategoryRequestInput = {
  /** Category to update. */
  category?: InputMaybe<WixBookingsCategoriesV2CategoryInput>;
  /**
   * Set of fields to update.
   *
   * Fields that aren't included in `fieldMask.paths` are ignored.
   */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixBookingsCategoriesV2UpdateCategoryResponse = {
  /** Updated category. */
  category?: Maybe<WixBookingsCategoriesV2Category>;
};

export type WixBookingsCategoriesV2UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * Pass the relevant cursor token from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Maximum number of items to return in the results. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsCategoriesV2UpstreamWixCommonCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixBookingsCategoriesV2UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixBookingsCategoriesV2UpstreamWixCommonSortingInput>>>;
};

export enum WixBookingsCategoriesV2UpstreamWixCommonSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type WixBookingsCategoriesV2UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixBookingsCategoriesV2UpstreamWixCommonSortOrder>;
};

export type WixBookingsServicesV2AddOnDetails = {
  /** ID of the add-on. */
  addOnId?: Maybe<Scalars['String']>;
  /**
   * Duration in minutes for add-ons that extend service time.
   * Empty for [quantity-based add-ons](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/add-ons/introduction#terminology).
   */
  durationInMinutes?: Maybe<Scalars['Int']>;
};

export type WixBookingsServicesV2AddOnDetailsInput = {
  /** ID of the add-on. */
  addOnId?: InputMaybe<Scalars['String']>;
  /**
   * Duration in minutes for add-ons that extend service time.
   * Empty for [quantity-based add-ons](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/add-ons/introduction#terminology).
   */
  durationInMinutes?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsServicesV2AddOnGroup = {
  /** List of IDs of all [add-ons](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/add-ons/introduction) included in the group. */
  addOnIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * ID of the add-on group.
   * Wix Bookings automatically populates this field when creating or updating an add-on group.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * Maximum number of different [add-ons](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/add-ons/introduction) from the group customers can add when booking the service.
   * When empty, there's no upper limit.
   */
  maxNumberOfAddOns?: Maybe<Scalars['Int']>;
  /** Name of the add-on group. */
  name?: Maybe<Scalars['String']>;
  /** Description or instructional prompt of the add-on group that's displayed to customers when booking the service. */
  prompt?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2AddOnGroupInput = {
  /** List of IDs of all [add-ons](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/add-ons/introduction) included in the group. */
  addOnIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * ID of the add-on group.
   * Wix Bookings automatically populates this field when creating or updating an add-on group.
   */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Maximum number of different [add-ons](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/add-ons/introduction) from the group customers can add when booking the service.
   * When empty, there's no upper limit.
   */
  maxNumberOfAddOns?: InputMaybe<Scalars['Int']>;
  /** Name of the add-on group. */
  name?: InputMaybe<Scalars['String']>;
  /** Description or instructional prompt of the add-on group that's displayed to customers when booking the service. */
  prompt?: InputMaybe<Scalars['String']>;
};

export enum WixBookingsServicesV2AddOnPaymentOptionsEnumAddOnPaymentOptions {
  /** Customers are required to pay in person for add-ons when the booking is paid for with a pricing plan. */
  IN_PERSON = 'IN_PERSON',
  /** Customers are required to pay online for add-ons when the booking is paid for with a pricing plan. */
  ONLINE = 'ONLINE',
  /** There is no information about how customers are required to pay for add-ons when the booking is paid for with a pricing plan. */
  UNKNOWN_ADD_ON_PAYMENT_OPTIONS = 'UNKNOWN_ADD_ON_PAYMENT_OPTIONS'
}

export type WixBookingsServicesV2AddOnsGroup = {
  /** List of AddOn IDs that are part of this group. */
  addOnIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** ID of the group. */
  id?: Maybe<Scalars['String']>;
  /**
   * The maximum number of AddOns that can be selected from this group.
   * If not set, there is no upper limit.
   */
  maxNumberOfAddOns?: Maybe<Scalars['Int']>;
  /** The name of the group. */
  name?: Maybe<Scalars['String']>;
  /** The group prompt. */
  prompt?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2AddOnsGroupInput = {
  /** List of AddOn IDs that are part of this group. */
  addOnIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** ID of the group. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * The maximum number of AddOns that can be selected from this group.
   * If not set, there is no upper limit.
   */
  maxNumberOfAddOns?: InputMaybe<Scalars['Int']>;
  /** The name of the group. */
  name?: InputMaybe<Scalars['String']>;
  /** The group prompt. */
  prompt?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2AvailabilityConstraints = {
  /**
   * Calculated list of all supported session durations for the service. For
   * appointment-based services without varied pricing based on session length, it
   * matches the single value in the `sessionDurations` array. For appointment-based
   * services with varied pricing based on session length, it includes session
   * durations for all [variants](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/service-options-and-variants/introduction),
   * while ignoring `sessionDurations`.
   * For courses and classes, it includes durations for all future
   * recurring sessions but excludes durations for one-off or past recurring sessions.
   */
  durations?: Maybe<Array<Maybe<WixBookingsServicesV2Duration>>>;
  /**
   * List of supported session durations in minutes.
   *
   * - For appointment-based services, specify `sessionDurations` when creating a service.
   * - For appointment-based services with varied pricing by session length, you must still specify `sessionDurations`, but the values are ignored. Actual durations are taken from the [service variants](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/service-options-and-variants/introduction).
   * - For classes or courses, don't specify `sessionDurations` when creating a service.
   *
   * Min: `1` minute
   * Max: `44639` minutes (30 days, 23 hours, and 59 minutes)
   */
  sessionDurations?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /**
   * The number of minutes between the end of a session and the start of the next.
   *
   *
   * Min: `0` minutes
   * Max: `720` minutes
   */
  timeBetweenSessions?: Maybe<Scalars['Int']>;
};

export type WixBookingsServicesV2AvailabilityConstraintsInput = {
  /**
   * Calculated list of all supported session durations for the service. For
   * appointment-based services without varied pricing based on session length, it
   * matches the single value in the `sessionDurations` array. For appointment-based
   * services with varied pricing based on session length, it includes session
   * durations for all [variants](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/service-options-and-variants/introduction),
   * while ignoring `sessionDurations`.
   * For courses and classes, it includes durations for all future
   * recurring sessions but excludes durations for one-off or past recurring sessions.
   */
  durations?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2DurationInput>>>;
  /**
   * List of supported session durations in minutes.
   *
   * - For appointment-based services, specify `sessionDurations` when creating a service.
   * - For appointment-based services with varied pricing by session length, you must still specify `sessionDurations`, but the values are ignored. Actual durations are taken from the [service variants](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/service-options-and-variants/introduction).
   * - For classes or courses, don't specify `sessionDurations` when creating a service.
   *
   * Min: `1` minute
   * Max: `44639` minutes (30 days, 23 hours, and 59 minutes)
   */
  sessionDurations?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /**
   * The number of minutes between the end of a session and the start of the next.
   *
   *
   * Min: `0` minutes
   * Max: `720` minutes
   */
  timeBetweenSessions?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsServicesV2BookingForm = {
  /**
   * Up to 5 services connected to the booking form. If `totalServiceCount` is
   * greater than 5, there are additional services connected to the policy.
   * You can call [Search Services](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/search-services)
   * specifying the relevant policy ID in the filter, to retrieve all services that are
   * connected to a booking policy.
   */
  connectedServices?: Maybe<Array<Maybe<WixBookingsServicesV2BookingFormConnectedService>>>;
  /** Information about the retrieved booking form. */
  formDetails?: Maybe<WixBookingsServicesV2BookingFormFormDetails>;
  /** Total number of services connected to the booking form. */
  totalServiceCount?: Maybe<Scalars['Int']>;
};

export type WixBookingsServicesV2BookingFormConnectedService = {
  /** ID of the service connected to the booking form. */
  id?: Maybe<Scalars['String']>;
  /** Name of the service connected to the booking form. */
  name?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2BookingFormFormDetails = {
  /** Form ID. */
  form?: Maybe<WixFormsV4Form>;
  /** Form ID. */
  formId?: Maybe<Scalars['String']>;
  /** Form name. */
  name?: Maybe<Scalars['String']>;
  /**
   * Revision number, which increments by 1 each time the form is updated.
   * To prevent conflicting changes,
   * the current revision must be passed when updating the form.
   */
  revision?: Maybe<Scalars['Long']>;
};

export type WixBookingsServicesV2BookingPolicyWithServices = {
  /** Retrieved booking policy. */
  bookingPolicy?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1BookingPolicy>;
  /**
   * Up to 5 services connected to the booking policy. If `totalServiceCount` is
   * greater than 5, there are additional services connected to the policy.
   * You can call [Search Services](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/search-services)
   * specifying the relevant policy ID in the filter, to retrieve all services that are
   * connected to a booking policy.
   */
  connectedServices?: Maybe<Array<Maybe<WixBookingsServicesV2Service>>>;
  /**
   * The number of services connected to the booking policy.
   * @deprecated The number of services connected to the booking policy. Replaced by: total_service_count. Removal date: 2025-03-01.
   */
  countOfServices?: Maybe<Scalars['Int']>;
  /**
   * Whether there are more services associated with the booking policy.
   * @deprecated Whether there are more services associated with the booking policy. Removal date: 2025-03-01.
   */
  hasMoreServices?: Maybe<Scalars['Boolean']>;
  /**
   * The services connected to the booking policy. Up to 5 services are returned per policy.
   * @deprecated The services connected to the booking policy. Up to 5 services are returned per policy. Replaced by: connected_services. Removal date: 2025-03-01.
   */
  services?: Maybe<Array<Maybe<WixBookingsServicesV2Service>>>;
  /** Total number of services connected to the booking policy. */
  totalServiceCount?: Maybe<Scalars['Int']>;
};

export type WixBookingsServicesV2BulkCreateServicesRequestInput = {
  /** Whether to return the created service objects. */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /** Services to create. */
  services?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2ServiceInput>>>;
  /**
   * Used to provision services from V1, Should be removed
   * when deprecating services V1
   */
  skipScheduleCreation?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2BulkCreateServicesResponse = {
  /** Create statistics. */
  bulkActionMetadata?: Maybe<WixBookingsServicesV2UpstreamWixCommonBulkActionMetadata>;
  /** The result of each service creation. */
  results?: Maybe<Array<Maybe<WixBookingsServicesV2BulkServiceResult>>>;
};

export type WixBookingsServicesV2BulkDeleteServicesByFilterRequestInput = {
  /** Filter to identify the services that need to be deleted. */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Whether to notify participants about the change and an optional custom message. */
  participantNotification?: InputMaybe<WixBookingsServicesV2ParticipantNotificationInput>;
  /**
   * Whether to preserve future sessions with participants.
   *
   * Default: `false`.
   */
  preserveFutureSessionsWithParticipants?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2BulkDeleteServicesByFilterResponse = {
  /**
   * ID of the service deletion job.
   *
   * Pass this ID to [Get Async Job](https://dev.wix.com/docs/rest/business-management/async-job/introduction) to retrieve job details and metadata.
   */
  jobId?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2BulkDeleteServicesRequestInput = {
  /** IDs of the services to delete. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Whether to notify participants about the change and an optional
   * custom message.
   */
  participantNotification?: InputMaybe<WixBookingsServicesV2ParticipantNotificationInput>;
  /**
   * Whether to preserve future sessions with participants.
   *
   * Default: `false`.
   */
  preserveFutureSessionsWithParticipants?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2BulkDeleteServicesResponse = {
  /** Delete statistics. */
  bulkActionMetadata?: Maybe<WixBookingsServicesV2UpstreamWixCommonBulkActionMetadata>;
  /** The result of each service removal. */
  results?: Maybe<Array<Maybe<WixBookingsServicesV2BulkServiceResult>>>;
};

export type WixBookingsServicesV2BulkServiceResult = {
  /** Updated service. */
  item?: Maybe<WixBookingsServicesV2Service>;
  /** Update metadata. */
  itemMetadata?: Maybe<WixBookingsServicesV2UpstreamWixCommonItemMetadata>;
};

export type WixBookingsServicesV2BulkUpdateServicesByFilterRequestInput = {
  /** Filter to identify the services to update. */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Service to update. */
  service?: InputMaybe<WixBookingsServicesV2ServiceInput>;
};

export type WixBookingsServicesV2BulkUpdateServicesByFilterResponse = {
  /**
   * ID of the service update job.
   *
   * Pass this ID to [Get Async Job](https://dev.wix.com/docs/rest/business-management/async-job/introduction) to retrieve job details and metadata.
   */
  jobId?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2BulkUpdateServicesRequestInput = {
  /** When true, uses the currency from the services parameter instead of preserving the existing service's currency. Default: `false` */
  overrideCurrency?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include the updated services in the response. Default: `false` */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /** Services to update. */
  services?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2BulkUpdateServicesRequestMaskedServiceInput>>>;
};

export type WixBookingsServicesV2BulkUpdateServicesRequestMaskedServiceInput = {
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Service to update. */
  service?: InputMaybe<WixBookingsServicesV2ServiceInput>;
};

export type WixBookingsServicesV2BulkUpdateServicesResponse = {
  /** Update statistics. */
  bulkActionMetadata?: Maybe<WixBookingsServicesV2UpstreamWixCommonBulkActionMetadata>;
  /** The result of each service update. */
  results?: Maybe<Array<Maybe<WixBookingsServicesV2BulkServiceResult>>>;
};

export type WixBookingsServicesV2BusinessLocationOptions = {
  /** Business location address. */
  address?: Maybe<WixBookingsServicesV2UpstreamWixCommonAddress>;
  /** Whether this is the default location. There can only be a single default location per site. */
  default?: Maybe<Scalars['Boolean']>;
  /** Business location email. */
  email?: Maybe<Scalars['String']>;
  /**
   * ID of the business [location](https://dev.wix.com/docs/api-reference/business-management/locations/introduction).
   * When setting a business location, specify only the location ID. Other location details are overwritten.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * ID of the business [location](https://dev.wix.com/docs/api-reference/business-management/locations/introduction).
   * When setting a business location, specify only the location ID. Other location details are overwritten.
   */
  location?: Maybe<ComWixpressLocationsLocation>;
  /** Business location name. */
  name?: Maybe<Scalars['String']>;
  /** Business location phone. */
  phone?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2BusinessLocationOptionsInput = {
  /** Business location address. */
  address?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAddressInput>;
  /** Whether this is the default location. There can only be a single default location per site. */
  default?: InputMaybe<Scalars['Boolean']>;
  /** Business location email. */
  email?: InputMaybe<Scalars['String']>;
  /**
   * ID of the business [location](https://dev.wix.com/docs/api-reference/business-management/locations/introduction).
   * When setting a business location, specify only the location ID. Other location details are overwritten.
   */
  id?: InputMaybe<Scalars['String']>;
  /** Business location name. */
  name?: InputMaybe<Scalars['String']>;
  /** Business location phone. */
  phone?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2BusinessLocations = {
  /**
   * Whether at least one service matching the filter is connected to any of the
   * retrieved business locations.
   */
  exists?: Maybe<Scalars['Boolean']>;
  /** Retrieved business locations. */
  locations?: Maybe<Array<Maybe<WixBookingsServicesV2Location>>>;
};

export type WixBookingsServicesV2Category = {
  /** Category ID. */
  category?: Maybe<WixBookingsCategoriesV2Category>;
  /** Category ID. */
  id?: Maybe<Scalars['String']>;
  /** Category name. */
  name?: Maybe<Scalars['String']>;
  /** Order of a category within a category list. */
  sortOrder?: Maybe<Scalars['Int']>;
};

export type WixBookingsServicesV2CategoryInput = {
  /** Category ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Category name. */
  name?: InputMaybe<Scalars['String']>;
  /** Order of a category within a category list. */
  sortOrder?: InputMaybe<Scalars['Int']>;
};

export enum WixBookingsServicesV2CloneErrorsEnumCloneErrors {
  /** Failed to clone the original service's *booking form*. */
  FORM = 'FORM',
  /** Failed to clone the original service's [options and variants](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/service-options-and-variants/introduction). */
  OPTIONS_AND_VARIANTS = 'OPTIONS_AND_VARIANTS',
  /** Failed to add [pricing plans](https://dev.wix.com/docs/api-reference/business-solutions/pricing-plans/pricing-plans/introduction) as supported payment methods for the cloned service. */
  PRICING_PLANS = 'PRICING_PLANS',
  /**
   * Failed to clone sessions belonging to the original service's active
   * schedule.
   */
  SESSIONS = 'SESSIONS',
  /** Unknown error. */
  UNKNOWN_CLONE_ERROR = 'UNKNOWN_CLONE_ERROR'
}

export type WixBookingsServicesV2CloneServiceRequestInput = {
  /**
   * Name of the cloned service.
   * The `title` of cloned service's active [schedule](https://dev.wix.com/docs/api-reference/business-management/calendar/schedules-v3/introduction)
   * is also set to this name.
   * The default name and schedule title of the cloned service are exact matches
   * of the corresponding fields from the service to clone.
   */
  cloneServiceName?: InputMaybe<Scalars['String']>;
  /**
   * Whether to copy the original service's `payment.pricingPlanIds` array.
   * A maximum of 120 pricing plans is copied.
   */
  copyPricingPlans?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to copy future recurring [events](https://dev.wix.com/docs/api-reference/business-management/calendar/events-v3/introduction)
   * belonging to the service's active schedule. Relevant only for classes and
   * courses.
   */
  copyRecurringSessions?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to hide the cloned service from customers. Specifying an
   * empty value means that the original service's `hidden` value is used.
   */
  hideService?: InputMaybe<Scalars['Boolean']>;
  /** ID of the service to clone. */
  sourceServiceId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2CloneServiceResponse = {
  /**
   * Information about connected entities that couldn't be cloned. For example,
   * future recurring events, the booking form, service variants, and connected
   * pricing plans.
   */
  errors?: Maybe<Array<Maybe<WixBookingsServicesV2CloneErrorsEnumCloneErrors>>>;
  /** Cloned service. */
  service?: Maybe<WixBookingsServicesV2Service>;
};

export type WixBookingsServicesV2Conferencing = {
  /** Whether a conference link is generated for the service's sessions. */
  enabled?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2ConferencingInput = {
  /** Whether a conference link is generated for the service's sessions. */
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2CountServicesRequestInput = {
  /**
   * Query filter to base the count on. See supported filters
   * ([REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/filtering-and-sorting#filtering))
   * for more details.
   */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type WixBookingsServicesV2CountServicesResponse = {
  /** Number of services matching the specified filter. */
  count?: Maybe<Scalars['Int']>;
};

export type WixBookingsServicesV2CreateAddOnGroupRequestInput = {
  /** Add-on group to create. */
  addOnGroup?: InputMaybe<WixBookingsServicesV2AddOnGroupInput>;
  /** ID of the service to create the add-on group for. */
  serviceId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2CreateAddOnGroupResponse = {
  /** Created add-on group. */
  addOnGroup?: Maybe<WixBookingsServicesV2AddOnGroup>;
};

export type WixBookingsServicesV2CreateAddOnsGroupRequestInput = {
  /** AddOnsGroup to create. */
  addOnsGroup?: InputMaybe<WixBookingsServicesV2AddOnsGroupInput>;
  /** ID of the service to create the AddOnsGroup for. */
  serviceId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2CreateAddOnsGroupResponse = {
  /** Created AddOnsGroup. */
  addOnsGroup?: Maybe<WixBookingsServicesV2AddOnsGroup>;
};

export type WixBookingsServicesV2CreateServiceRequestInput = {
  /** Service to create. */
  service?: InputMaybe<WixBookingsServicesV2ServiceInput>;
};

export type WixBookingsServicesV2CreateServiceResponse = {
  /** Created service. */
  service?: Maybe<WixBookingsServicesV2Service>;
};

export type WixBookingsServicesV2CustomLocationOptions = {
  /** Address of the custom location. */
  address?: Maybe<WixBookingsServicesV2UpstreamWixCommonAddress>;
  /** ID of the custom location. */
  id?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2CustomLocationOptionsInput = {
  /** Address of the custom location. */
  address?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAddressInput>;
  /** ID of the custom location. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2CustomLocations = {
  /**
   * Whether at least one service matching the filter is connected to any of the
   * retrieved custom locations.
   */
  exists?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2CustomPayment = {
  /** A custom description explaining to the customer how to pay for the service. */
  description?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2CustomPaymentInput = {
  /** A custom description explaining to the customer how to pay for the service. */
  description?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2CustomerLocations = {
  /**
   * Whether at least one service matching the filter is connected to any of the
   * retrieved customer locations.
   */
  exists?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2DeleteAddOnGroupRequestInput = {
  /** ID of the add-on group to delete. */
  addOnGroupId?: InputMaybe<Scalars['String']>;
  /** ID of the service from which to delete the add-on group. */
  serviceId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2DeleteAddOnsGroupRequestInput = {
  /** ID of the AddOnsGroup to delete. */
  addOnsGroupId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2DeleteServiceRequestInput = {
  /**
   * Whether to notify participants about the change and an optional
   * custom message.
   */
  participantNotification?: InputMaybe<WixBookingsServicesV2ParticipantNotificationInput>;
  /**
   * Whether to preserve future sessions with participants.
   *
   * Default: `false`
   */
  preserveFutureSessionsWithParticipants?: InputMaybe<Scalars['Boolean']>;
  /** ID of the service to delete. */
  serviceId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2DisablePricingPlansForServiceRequestInput = {
  /**
   * IDs of the [pricing plans](https://dev.wix.com/docs/api-reference/business-solutions/pricing-plans/pricing-plans/plans/introduction)
   * to remove from the service's `payment.pricingPlanIds` array.
   */
  pricingPlanIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** ID of the service to update. */
  serviceId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2DisablePricingPlansForServiceResponse = {
  /** Updated service. */
  service?: Maybe<WixBookingsServicesV2Service>;
};

export type WixBookingsServicesV2Duration = {
  /**
   * The duration of the service in minutes.
   *
   * Min: `1` minute
   * Max: `44639` minutes (30 days, 23 hours, and 59 minutes)
   */
  minutes?: Maybe<Scalars['Int']>;
};

export type WixBookingsServicesV2DurationInput = {
  /**
   * The duration of the service in minutes.
   *
   * Min: `1` minute
   * Max: `44639` minutes (30 days, 23 hours, and 59 minutes)
   */
  minutes?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsServicesV2EnablePricingPlansForServiceRequestInput = {
  /**
   * IDs of the [pricing plans](https://dev.wix.com/docs/api-reference/business-solutions/pricing-plans/pricing-plans/plans/introduction)
   * to add to the service's `payment.pricingPlanIds` array.
   */
  pricingPlanIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** ID of the service to update. */
  serviceId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2EnablePricingPlansForServiceResponse = {
  /** Updated service. */
  service?: Maybe<WixBookingsServicesV2Service>;
};

export type WixBookingsServicesV2FieldViolation = {
  /** Description of the error. */
  description?: Maybe<Scalars['String']>;
  /** Path to the invalid field. */
  fieldName?: Maybe<Scalars['String']>;
  /** Rule name of the violation */
  ruleName?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2FixedPayment = {
  /** Whether the price is a base price. */
  basePrice?: Maybe<Scalars['Boolean']>;
  /**
   * The deposit price required to book the service.
   *
   * Required when: `rateType` is `FIXED` and `paymentOptions.deposit` is `true`
   */
  deposit?: Maybe<WixBookingsServicesV2UpstreamWixCommonMoney>;
  /**
   * The fixed price required to book the service.
   *
   * Required when: `rateType` is `FIXED`
   */
  price?: Maybe<WixBookingsServicesV2UpstreamWixCommonMoney>;
};

export type WixBookingsServicesV2FixedPaymentInput = {
  /** Whether the price is a base price. */
  basePrice?: InputMaybe<Scalars['Boolean']>;
  /**
   * The deposit price required to book the service.
   *
   * Required when: `rateType` is `FIXED` and `paymentOptions.deposit` is `true`
   */
  deposit?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonMoneyInput>;
  /**
   * The fixed price required to book the service.
   *
   * Required when: `rateType` is `FIXED`
   */
  price?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonMoneyInput>;
};

export type WixBookingsServicesV2Form = {
  /**
   * ID of the form associated with the service.
   * The form information that you submit when booking includes contact details, participants, and other form fields set up for the service.
   * You can manage the service booking form fields using the Bookings Forms API.
   */
  id?: Maybe<Scalars['String']>;
  /** Settings that apply to the service booking form on mobile clients. */
  mobileSettings?: Maybe<WixBookingsServicesV2FormSettings>;
};

export type WixBookingsServicesV2FormInput = {
  /**
   * ID of the form associated with the service.
   * The form information that you submit when booking includes contact details, participants, and other form fields set up for the service.
   * You can manage the service booking form fields using the Bookings Forms API.
   */
  id?: InputMaybe<Scalars['String']>;
  /** Settings that apply to the service booking form on mobile clients. */
  mobileSettings?: InputMaybe<WixBookingsServicesV2FormSettingsInput>;
};

export type WixBookingsServicesV2FormSettings = {
  /** Whether the service booking form should be hidden from the site. */
  hidden?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2FormSettingsInput = {
  /** Whether the service booking form should be hidden from the site. */
  hidden?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2GetServiceAvailabilityConstraintsRequestInput = {
  /** ID of the service to retrieve. */
  serviceId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2GetServiceAvailabilityConstraintsResponse = {
  /** The retrieved availability constraints of the service. */
  constraints?: Maybe<WixBookingsServicesV2ServiceAvailabilityConstraints>;
};

export type WixBookingsServicesV2GetServiceRequestInput = {
  /** Conditional fields to return. Currently only 1 is supported */
  conditionalFields?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2RequestedFields>>>;
  /**
   * Whether to perform an eventually consistent call using
   * catalog reader (only for dbV1)
   */
  eventuallyConsistent?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};

export enum WixBookingsServicesV2InvalidSlugErrorEnumInvalidSlugError {
  /** Slug is already associated with another service. */
  SLUG_ALREADY_EXISTS = 'SLUG_ALREADY_EXISTS',
  /** Slug contains illegal characters. */
  SLUG_CONTAINS_ILLEGAL_CHARACTERS = 'SLUG_CONTAINS_ILLEGAL_CHARACTERS',
  /** Unknown slug error. */
  UNKNOWN_SLUG_ERROR = 'UNKNOWN_SLUG_ERROR'
}

export type WixBookingsServicesV2ListAddOnGroupsByServiceIdRequestInput = {
  /** List of group IDs to return. By default, all groups are returned. */
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** ID of the service to retrieve add-on groups for. */
  serviceId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2ListAddOnGroupsByServiceIdResponse = {
  /** List of group details with their linked add-ons. */
  addOnGroupsDetails?: Maybe<Array<Maybe<WixBookingsServicesV2ListAddOnGroupsByServiceIdResponseAddOnGroupDetail>>>;
};

export type WixBookingsServicesV2ListAddOnGroupsByServiceIdResponseAddOn = {
  /** Add-on ID. */
  addOnId?: Maybe<Scalars['String']>;
  /** Duration in minutes for duration-based add-ons that extend booking service time. */
  durationInMinutes?: Maybe<Scalars['Int']>;
  /** Maximum quantity customers can purchase for quantity-based add-ons. */
  maxQuantity?: Maybe<Scalars['Int']>;
  /** Add-on name displayed to customers. */
  name?: Maybe<Scalars['String']>;
  /** Translated add-on name. */
  nameTranslated?: Maybe<Scalars['String']>;
  /** Add-on price. */
  price?: Maybe<WixBookingsServicesV2UpstreamWixCommonMoney>;
};

export type WixBookingsServicesV2ListAddOnGroupsByServiceIdResponseAddOnGroupDetail = {
  /** Add-ons linked to this group in display order. */
  addOns?: Maybe<Array<Maybe<WixBookingsServicesV2ListAddOnGroupsByServiceIdResponseAddOn>>>;
  /** Group ID. */
  groupId?: Maybe<Scalars['String']>;
  /** Group name displayed to customers. */
  groupName?: Maybe<Scalars['String']>;
  /** Translated group name. */
  groupNameTranslated?: Maybe<Scalars['String']>;
  /** Maximum number of add-ons customers can select from this group. */
  maxNumberOfAddOns?: Maybe<Scalars['Int']>;
  /** Instructional prompt displayed to customers. For example, `Choose up to 2 relaxing spa treatments to enhance your experience`. You can also use this field as a group description. For example, `Beginner-friendly rental equipment`. */
  prompt?: Maybe<Scalars['String']>;
  /** Instructional translated prompt displayed to customers. For example, `Choose up to 2 relaxing spa treatments to enhance your experience`. You can also use this field as a group description. For example, `Beginner-friendly rental equipment`. */
  promptTranslated?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2ListAddOnsGroupsByServiceIdRequestInput = {
  /** List of group ids to return. If not provided, all groups are returned. */
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** ID of the service to retrieve AddOns for. */
  serviceId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2ListAddOnsGroupsByServiceIdResponse = {
  /** List of group IDs and their linked AddOns. */
  addOnsGroupsDetails?: Maybe<Array<Maybe<WixBookingsServicesV2ListAddOnsGroupsByServiceIdResponseAddOnsGroupDetail>>>;
};

export type WixBookingsServicesV2ListAddOnsGroupsByServiceIdResponseAddOn = {
  /** The AddOn ID. */
  addOnId?: Maybe<Scalars['String']>;
  /** The AddOn description. */
  durationInMinutes?: Maybe<Scalars['Int']>;
  /** The AddOn price. */
  formattedAmount?: Maybe<Scalars['String']>;
  /** The AddOn max quantity. */
  maxQuantity?: Maybe<Scalars['Int']>;
  /** The AddOn name. */
  name?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2ListAddOnsGroupsByServiceIdResponseAddOnsGroupDetail = {
  /** The AddOns information linked to the group. */
  addOns?: Maybe<Array<Maybe<WixBookingsServicesV2ListAddOnsGroupsByServiceIdResponseAddOn>>>;
  /** The group ID. */
  groupId?: Maybe<Scalars['String']>;
  /** The group name. */
  groupName?: Maybe<Scalars['String']>;
  /** The group max number of AddOns. */
  maxNumberOfAddOns?: Maybe<Scalars['Int']>;
  /** The group prompt. */
  prompt?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2Location = {
  /** Information about business locations. */
  business?: Maybe<WixBookingsServicesV2BusinessLocationOptions>;
  /** Location address. Empty for `{"type": "CUSTOMER"}`. */
  calculatedAddress?: Maybe<WixBookingsServicesV2UpstreamWixCommonAddress>;
  /** Information about custom locations. */
  custom?: Maybe<WixBookingsServicesV2CustomLocationOptions>;
  /** Location ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Location type.
   *
   * Default: `CUSTOM`
   */
  type?: Maybe<WixBookingsServicesV2LocationTypeEnumLocationType>;
};

export type WixBookingsServicesV2LocationInput = {
  /** Information about business locations. */
  business?: InputMaybe<WixBookingsServicesV2BusinessLocationOptionsInput>;
  /** Location address. Empty for `{"type": "CUSTOMER"}`. */
  calculatedAddress?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAddressInput>;
  /** Information about custom locations. */
  custom?: InputMaybe<WixBookingsServicesV2CustomLocationOptionsInput>;
  /** Location ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Location type.
   *
   * Default: `CUSTOM`
   */
  type?: InputMaybe<WixBookingsServicesV2LocationTypeEnumLocationType>;
};

export enum WixBookingsServicesV2LocationTypeEnumLocationType {
  /** Business [location](https://dev.wix.com/docs/api-reference/business-management/locations/introduction). */
  BUSINESS = 'BUSINESS',
  /** Location set by the business that is not a standard business [location](https://dev.wix.com/docs/api-reference/business-management/locations/introduction). */
  CUSTOM = 'CUSTOM',
  /**
   * The customer specifies any address when booking. Available only for
   * appointment-based services.
   */
  CUSTOMER = 'CUSTOMER',
  UNKNOWN_LOCATION_TYPE = 'UNKNOWN_LOCATION_TYPE'
}

export type WixBookingsServicesV2Media = {
  /** Cover media associated with the service. */
  coverMedia?: Maybe<WixBookingsServicesV2MediaItem>;
  /** Media items associated with the service. */
  items?: Maybe<Array<Maybe<WixBookingsServicesV2MediaItem>>>;
  /** Primary media associated with the service. */
  mainMedia?: Maybe<WixBookingsServicesV2MediaItem>;
};

export type WixBookingsServicesV2MediaInput = {
  /** Cover media associated with the service. */
  coverMedia?: InputMaybe<WixBookingsServicesV2MediaItemInput>;
  /** Media items associated with the service. */
  items?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2MediaItemInput>>>;
  /** Primary media associated with the service. */
  mainMedia?: InputMaybe<WixBookingsServicesV2MediaItemInput>;
};

export type WixBookingsServicesV2MediaItem = {
  /** Details of the image associated with the service, such as URL and size. */
  image?: Maybe<WixBookingsServicesV2UpstreamWixCommonImage>;
};

export type WixBookingsServicesV2MediaItemInput = {
  /** Details of the image associated with the service, such as URL and size. */
  image?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonImageInput>;
};

export type WixBookingsServicesV2MoveToNewLocationsOptionsInput = {
  /** The new location to move existing sessions currently set to a removed location, used when `action` is `MOVE_TO_LOCATION`. */
  newLocation?: InputMaybe<WixBookingsServicesV2LocationInput>;
};

export type WixBookingsServicesV2OnlineBooking = {
  /** Multiple customers can request to book the same time slot. This is relevant when `requireManualApproval` is `true`. */
  allowMultipleRequests?: Maybe<Scalars['Boolean']>;
  /**
   * Whether the service can be booked online.
   * When set to `true`, customers can book the service online. Configure the payment options via the `service.payment` property.
   * When set to `false`, customers cannot book the service online, and the service can only be paid for in person.
   */
  enabled?: Maybe<Scalars['Boolean']>;
  /** Booking the service requires approval by the Wix user. */
  requireManualApproval?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2OnlineBookingInput = {
  /** Multiple customers can request to book the same time slot. This is relevant when `requireManualApproval` is `true`. */
  allowMultipleRequests?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether the service can be booked online.
   * When set to `true`, customers can book the service online. Configure the payment options via the `service.payment` property.
   * When set to `false`, customers cannot book the service online, and the service can only be paid for in person.
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Booking the service requires approval by the Wix user. */
  requireManualApproval?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2ParticipantNotificationInput = {
  /** Custom message to send to the participants about the changes to the booking. */
  message?: InputMaybe<Scalars['String']>;
  /**
   * Whether to send a message about the changes to the customer.
   *
   * Default: `false`
   */
  notifyParticipants?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2Payment = {
  /**
   * How customers can pay for add-ons when paying for the related booking with a [pricing plan](https://dev.wix.com/docs/api-reference/business-solutions/pricing-plans/pricing-plans/introduction).
   * If customers pay for the booking using any method other than a pricing plan, the value of this field is ignored.
   */
  addOnOption?: Maybe<WixBookingsServicesV2AddOnPaymentOptionsEnumAddOnPaymentOptions>;
  /**
   * The details for the custom price of the service.
   *
   * Required when: `rateType` is `CUSTOM`
   */
  custom?: Maybe<WixBookingsServicesV2CustomPayment>;
  /**
   * The details for the fixed price of the service.
   *
   * Required when: `rateType` is `FIXED`
   */
  fixed?: Maybe<WixBookingsServicesV2FixedPayment>;
  /** The payment options a customer can use to pay for the service. */
  options?: Maybe<WixBookingsServicesV2PaymentOptions>;
  /** IDs of pricing plans that can be used as payment for the service. */
  pricingPlanIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The rate the customer is expected to pay for the service. */
  rateType?: Maybe<WixBookingsServicesV2RateTypeEnumRateType>;
  /**
   * The details for the varied pricing of the service.
   * Read more about [varied price options](https://support.wix.com/en/article/wix-bookings-about-getting-paid-online#offering-varied-price-options).
   *
   * Required when: `rateType` is `VARIED`
   */
  varied?: Maybe<WixBookingsServicesV2VariedPayment>;
};

export type WixBookingsServicesV2PaymentInput = {
  /**
   * How customers can pay for add-ons when paying for the related booking with a [pricing plan](https://dev.wix.com/docs/api-reference/business-solutions/pricing-plans/pricing-plans/introduction).
   * If customers pay for the booking using any method other than a pricing plan, the value of this field is ignored.
   */
  addOnOption?: InputMaybe<WixBookingsServicesV2AddOnPaymentOptionsEnumAddOnPaymentOptions>;
  /**
   * The details for the custom price of the service.
   *
   * Required when: `rateType` is `CUSTOM`
   */
  custom?: InputMaybe<WixBookingsServicesV2CustomPaymentInput>;
  /**
   * The details for the fixed price of the service.
   *
   * Required when: `rateType` is `FIXED`
   */
  fixed?: InputMaybe<WixBookingsServicesV2FixedPaymentInput>;
  /** The payment options a customer can use to pay for the service. */
  options?: InputMaybe<WixBookingsServicesV2PaymentOptionsInput>;
  /** IDs of pricing plans that can be used as payment for the service. */
  pricingPlanIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The rate the customer is expected to pay for the service. */
  rateType?: InputMaybe<WixBookingsServicesV2RateTypeEnumRateType>;
  /**
   * The details for the varied pricing of the service.
   * Read more about [varied price options](https://support.wix.com/en/article/wix-bookings-about-getting-paid-online#offering-varied-price-options).
   *
   * Required when: `rateType` is `VARIED`
   */
  varied?: InputMaybe<WixBookingsServicesV2VariedPaymentInput>;
};

export type WixBookingsServicesV2PaymentOptions = {
  /**
   * This service requires a deposit to be made online in order to book it.
   * When `true`:
   * + `rateType` must be `VARIED` or `FIXED`.
   * + A `deposit` must be specified.
   */
  deposit?: Maybe<Scalars['Boolean']>;
  /** Customers can pay for the service in person. */
  inPerson?: Maybe<Scalars['Boolean']>;
  /**
   * Customers can pay for the service online.
   * When `true`:
   * + `rateType` must be either `FIXED` or `VARIED`.
   * + `fixed.price` or `varied.default_price` must be specified respectively. Read more about [getting paid online](https://support.wix.com/en/article/wix-bookings-about-getting-paid-online).
   */
  online?: Maybe<Scalars['Boolean']>;
  /** Customers can pay for the service using a pricing plan. */
  pricingPlan?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2PaymentOptionsInput = {
  /**
   * This service requires a deposit to be made online in order to book it.
   * When `true`:
   * + `rateType` must be `VARIED` or `FIXED`.
   * + A `deposit` must be specified.
   */
  deposit?: InputMaybe<Scalars['Boolean']>;
  /** Customers can pay for the service in person. */
  inPerson?: InputMaybe<Scalars['Boolean']>;
  /**
   * Customers can pay for the service online.
   * When `true`:
   * + `rateType` must be either `FIXED` or `VARIED`.
   * + `fixed.price` or `varied.default_price` must be specified respectively. Read more about [getting paid online](https://support.wix.com/en/article/wix-bookings-about-getting-paid-online).
   */
  online?: InputMaybe<Scalars['Boolean']>;
  /** Customers can pay for the service using a pricing plan. */
  pricingPlan?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2PhoneCall = {
  /** Whether the service is delivered via phone call. */
  enabled?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2PhoneCallInput = {
  /** Whether the service is delivered via phone call. */
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2QueryBookingFormsRequestInput = {
  /** Conditional fields to return. */
  conditionalFields?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2QueryBookingFormsRequestRequestedFields>>>;
  /**
   * Information about filters, paging, and sorting. See the article about
   * form filters ([REST](https://dev.wix.com/docs/rest/crm/forms/form-schemas/form-object))
   * for all supported filters and sorting options.
   */
  query?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonCursorQueryInput>;
};

export enum WixBookingsServicesV2QueryBookingFormsRequestRequestedFields {
  /** Whether to return the site's default booking form. */
  DEFAULT_BOOKING_FORM = 'DEFAULT_BOOKING_FORM',
  /** Unknown requested conditional field. */
  UNKNOWN_REQUESTED_FIELD = 'UNKNOWN_REQUESTED_FIELD'
}

export type WixBookingsServicesV2QueryBookingFormsResponse = {
  /** Retrieved booking forms and information about connected services. */
  bookingForms?: Maybe<Array<Maybe<WixBookingsServicesV2BookingForm>>>;
  /** The site's default booking form and information about connected services. */
  defaultBookingForm?: Maybe<WixBookingsServicesV2BookingForm>;
  /** Paging metadata. */
  pagingMetadata?: Maybe<WixBookingsServicesV2UpstreamWixCommonCursorPagingMetadata>;
};

export type WixBookingsServicesV2QueryCategoriesFilterInput = {
  /** List of category IDs to filter by. */
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Service filter. See supported filters
   * ([REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/filtering-and-sorting#filtering))
   * for more details.
   */
  services?: InputMaybe<Scalars['JSON']>;
};

export type WixBookingsServicesV2QueryCategoriesRequestInput = {
  /** Filter. */
  filter?: InputMaybe<WixBookingsServicesV2QueryCategoriesFilterInput>;
};

export type WixBookingsServicesV2QueryCategoriesResponse = {
  /** Retrieved categories. */
  categories?: Maybe<Array<Maybe<WixBookingsServicesV2Category>>>;
};

export type WixBookingsServicesV2QueryLocationsFilterInput = {
  /** List of business IDs to filter by. */
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Service filter. See supported filters
   * ([REST](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/filtering-and-sorting#filtering))
   * for more details.
   */
  services?: InputMaybe<Scalars['JSON']>;
};

export type WixBookingsServicesV2QueryLocationsRequestInput = {
  /** Filter. */
  filter?: InputMaybe<WixBookingsServicesV2QueryLocationsFilterInput>;
};

export type WixBookingsServicesV2QueryLocationsResponse = {
  /**
   * Retrieved business locations and whether each location is connected to at
   * least one service.
   */
  businessLocations?: Maybe<WixBookingsServicesV2BusinessLocations>;
  /**
   * Retrieved custom locations and whether each location is connected to at
   * least one service.
   */
  customLocations?: Maybe<WixBookingsServicesV2CustomLocations>;
  /**
   * Retrieved customer locations and whether each location is connected to at
   * least one service.
   */
  customerLocations?: Maybe<WixBookingsServicesV2CustomerLocations>;
};

export type WixBookingsServicesV2QueryPoliciesRequestInput = {
  /**
   * Information about filters, paging, and sorting. See the article about
   * booking policy filters
   * ([REST](https://dev.wix.com/docs/rest/business-solutions/bookings/policies/booking-policies/supported-filters))
   * for all supported filters and sorting options.
   */
  query?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonCursorQueryInput>;
};

export type WixBookingsServicesV2QueryPoliciesResponse = {
  /** Retrieved booking policies and information about the services using them. */
  bookingPolicies?: Maybe<Array<Maybe<WixBookingsServicesV2BookingPolicyWithServices>>>;
  /** Paging metadata. */
  pagingMetadata?: Maybe<WixBookingsServicesV2UpstreamWixCommonCursorPagingMetadata>;
};

export type WixBookingsServicesV2QueryServicesMultiLanguageRequestInput = {
  /** Conditional fields to return. Currently only 1 is supported. */
  conditionalFields?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2RequestedFields>>>;
  /** WQL expression. */
  query?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonQueryV2Input>;
};

export type WixBookingsServicesV2QueryServicesMultiLanguageResponse = {
  /** Paging metadata, including offset and count. */
  pagingMetadata?: Maybe<WixBookingsServicesV2UpstreamWixCommonPagingMetadataV2>;
  /** The retrieved services in the main language */
  services?: Maybe<Array<Maybe<WixBookingsServicesV2Service>>>;
  /**
   * the retrieved services in the requested language according to the
   * provided linguist aspect
   */
  translatedServices?: Maybe<Array<Maybe<WixBookingsServicesV2Service>>>;
};

export type WixBookingsServicesV2QueryServicesRequestInput = {
  /** Conditional fields to return. Currently only 1 is supported */
  conditionalFields?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2RequestedFields>>>;
  /**
   * Whether to perform an eventually consistent call using
   * catalog reader (only for dbV1)
   */
  eventuallyConsistent?: InputMaybe<Scalars['Boolean']>;
  /** WQL expression. */
  query?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonQueryV2Input>;
};

export type WixBookingsServicesV2QueryServicesResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<WixBookingsServicesV2Service>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export enum WixBookingsServicesV2RateTypeEnumRateType {
  /** The service has a custom price, expressed as a price description. */
  CUSTOM = 'CUSTOM',
  /** The service has a fixed price. */
  FIXED = 'FIXED',
  /** This service is offered free of charge. */
  NO_FEE = 'NO_FEE',
  /** Unknown rate type. */
  UNKNOWN_RATE_TYPE = 'UNKNOWN_RATE_TYPE',
  /** This service is offered with a set of different prices based on different terms. */
  VARIED = 'VARIED'
}

export enum WixBookingsServicesV2RemovedLocationSessionsActionAction {
  /**
   * Cancel all future events at the removed location.
   * Currently not supported.
   */
  DELETE = 'DELETE',
  /** Retain all future sessions at their current location. This is the default. */
  KEEP_AT_CURRENT_LOCATION = 'KEEP_AT_CURRENT_LOCATION',
  /** Move future events to a new location. */
  MOVE_TO_LOCATION = 'MOVE_TO_LOCATION',
  UNKNOWN_ACTION_TYPE = 'UNKNOWN_ACTION_TYPE'
}

export type WixBookingsServicesV2RemovedLocationSessionsActionInput = {
  /** Information about what to do with future events at the removed location. */
  action?: InputMaybe<WixBookingsServicesV2RemovedLocationSessionsActionAction>;
  /**
   * Details about the new location of future events that were scheduled to take
   * place at a removed location.
   */
  moveToLocationOptions?: InputMaybe<WixBookingsServicesV2MoveToNewLocationsOptionsInput>;
};

export enum WixBookingsServicesV2RequestedFields {
  /** When passed, `service.service_resources.resource_type.name` is returned. */
  RESOURCE_TYPE_DETAILS = 'RESOURCE_TYPE_DETAILS',
  /** When passed, `service.staff_members` is returned. */
  STAFF_MEMBER_DETAILS = 'STAFF_MEMBER_DETAILS',
  /** Unknown requested field. */
  UNKNOWN_REQUESTED_FIELD = 'UNKNOWN_REQUESTED_FIELD'
}

export type WixBookingsServicesV2ResourceGroup = {
  /**
   * Specifies how many resources in the group / resource IDs are required to book the service.
   * Defaults to 1.
   */
  requiredResourcesNumber?: Maybe<Scalars['Int']>;
  /**
   * An optional resource group ID. If specified, it references a resource group in the resource groups API.
   * TODO - referenced_entity annotation
   */
  resourceGroupId?: Maybe<Scalars['String']>;
  /**
   * Resource IDs. Each ID references a resource in the resources API and may be a subset of resources within a resource group.
   * TODO - referenced_entity annotation
   */
  resourceIds?: Maybe<WixBookingsServicesV2ResourceIds>;
  /**
   * If set to `true`, the customer can select the specific resources while booking the service.
   * If set to `false`, the resources required to book the service will be auto-selected at the time of the booking.
   * Defaults to false.
   */
  selectableResource?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2ResourceGroupInput = {
  /**
   * Specifies how many resources in the group / resource IDs are required to book the service.
   * Defaults to 1.
   */
  requiredResourcesNumber?: InputMaybe<Scalars['Int']>;
  /**
   * An optional resource group ID. If specified, it references a resource group in the resource groups API.
   * TODO - referenced_entity annotation
   */
  resourceGroupId?: InputMaybe<Scalars['String']>;
  /**
   * Resource IDs. Each ID references a resource in the resources API and may be a subset of resources within a resource group.
   * TODO - referenced_entity annotation
   */
  resourceIds?: InputMaybe<WixBookingsServicesV2ResourceIdsInput>;
  /**
   * If set to `true`, the customer can select the specific resources while booking the service.
   * If set to `false`, the resources required to book the service will be auto-selected at the time of the booking.
   * Defaults to false.
   */
  selectableResource?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2ResourceIds = {
  /** Values of the resource IDs. */
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type WixBookingsServicesV2ResourceIdsInput = {
  /** Values of the resource IDs. */
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixBookingsServicesV2ResourceType = {
  /** The type of the resource. */
  id?: Maybe<Scalars['String']>;
  /** The name of the resource type. */
  name?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2ResourceTypeInput = {
  /** The type of the resource. */
  id?: InputMaybe<Scalars['String']>;
  /** The name of the resource type. */
  name?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2Schedule = {
  /** Limitations affecting the service availability. */
  availabilityConstraints?: Maybe<WixBookingsServicesV2AvailabilityConstraints>;
  /** Start time of the first session in the schedule. For courses only. */
  firstSessionStart?: Maybe<Scalars['String']>;
  /**
   * ID of the [schedule](https://dev.wix.com/docs/api-reference/business-management/calendar/schedules-v3/introduction)
   * to which the service's events belong.
   */
  id?: Maybe<Scalars['String']>;
  /** End time of the last session in the schedule. For courses only. */
  lastSessionEnd?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2ScheduleInput = {
  /** Limitations affecting the service availability. */
  availabilityConstraints?: InputMaybe<WixBookingsServicesV2AvailabilityConstraintsInput>;
  /** Start time of the first session in the schedule. For courses only. */
  firstSessionStart?: InputMaybe<Scalars['String']>;
  /**
   * ID of the [schedule](https://dev.wix.com/docs/api-reference/business-management/calendar/schedules-v3/introduction)
   * to which the service's events belong.
   */
  id?: InputMaybe<Scalars['String']>;
  /** End time of the last session in the schedule. For courses only. */
  lastSessionEnd?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2SearchServicesRequestInput = {
  /**
   * Search criteria including filter, sort, aggregations, and paging options.
   *
   * Refer to the [supported filters article](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/filtering-and-sorting) for complete filter and sorting options.
   */
  search?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonCursorSearchInput>;
};

export type WixBookingsServicesV2SearchServicesResponse = {
  /**
   * Aggregation results based on the aggregations specified in the search request.
   *
   * Provides categorized data summaries such as service counts by type, location distribution,
   * payment method statistics, or custom aggregations. Available only when aggregations
   * are requested in the search criteria.
   */
  aggregationData?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationData>;
  /**
   * Cursor-based paging metadata for navigating search results.
   *
   * Contains the current page's cursor information, whether there are more results available,
   * and count details. Use the `next` cursor to retrieve subsequent pages of results.
   */
  pagingMetadata?: Maybe<WixBookingsServicesV2UpstreamWixCommonCursorPagingMetadata>;
  /**
   * Retrieved services that match the search criteria specified in the request.
   *
   * Each service includes all standard service information including name, description,
   * pricing details, location options, schedule information, and payment configuration.
   */
  services?: Maybe<Array<Maybe<WixBookingsServicesV2Service>>>;
};

export type WixBookingsServicesV2Service = {
  /** Details about all [add-ons](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/add-ons/introduction) customers can choose when booking the service. */
  addOnDetails?: Maybe<Array<Maybe<WixBookingsServicesV2AddOnDetails>>>;
  /** Information about the [add-on groups](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/about-add-on-groups) associated with the service. */
  addOnGroups?: Maybe<Array<Maybe<WixBookingsServicesV2AddOnGroup>>>;
  /**
   * ID of the app that's associated with the service. You can't update `appId`.
   * If the app ID is not specified, the service will be associated with the [Wix Bookings app](https://dev.wix.com/docs/rest/articles/getting-started/wix-business-solutions) by default.
   */
  app?: Maybe<WixDevcenterAppsV1App>;
  /**
   * ID of the app that's associated with the service. You can't update `appId`.
   * If the app ID is not specified, the service will be associated with the [Wix Bookings app](https://dev.wix.com/docs/rest/articles/getting-started/wix-business-solutions) by default.
   */
  appId?: Maybe<Scalars['String']>;
  /**
   * [Policy](https://dev.wix.com/docs/rest/business-solutions/bookings/policies/booking-policies/introduction)
   * determining under what conditions this service can be booked. For example, whether the service can only be booked up to 30 minutes before it begins.
   */
  bookingPolicy?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1BookingPolicy>;
  /**
   * [Category](https://dev.wix.com/docs/rest/business-solutions/bookings/services/categories-v1/category-object)
   * the service is associated with.
   */
  category?: Maybe<WixBookingsServicesV2Category>;
  /** Conferencing options for the service. */
  conferencing?: Maybe<WixBookingsServicesV2Conferencing>;
  /**
   * ID of the app in dev-center that created the service.
   * If the createByAppId is not specified, the service will be associated with the appId, and if the appId is not specified, it will be associated to [Wix Bookings app](https://dev.wix.com/docs/rest/articles/getting-started/wix-business-solutions) by default.
   */
  createdByAppId?: Maybe<Scalars['String']>;
  /** Date and time the service was created in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  createdDate?: Maybe<Scalars['String']>;
  /** Default maximum number of customers that can book the service. The service cannot be booked beyond this capacity. */
  defaultCapacity?: Maybe<Scalars['Int']>;
  /** Service description. For example, `High-class hair styling, cuts, straightening and color`. */
  description?: Maybe<Scalars['String']>;
  /** Extensions enabling users to save custom data related to the service. */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** Form the customer filled out when booking the service. */
  form?: Maybe<WixBookingsServicesV2Form>;
  /** Whether the service is hidden from Wix Bookings pages and widgets. */
  hidden?: Maybe<Scalars['Boolean']>;
  /** Service ID. */
  id?: Maybe<Scalars['String']>;
  /** The locations this service is offered at. Read more about [service locations](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/about-service-locations). */
  locations?: Maybe<Array<Maybe<WixBookingsServicesV2Location>>>;
  /**
   * Active slug for the service.
   * Learn more about [service slugs](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/about-service-slugs).
   */
  mainSlug?: Maybe<WixBookingsServicesV2Slug>;
  /** Media associated with the service. */
  media?: Maybe<WixBookingsServicesV2Media>;
  /** Service name. */
  name?: Maybe<Scalars['String']>;
  /** Online booking settings. */
  onlineBooking?: Maybe<WixBookingsServicesV2OnlineBooking>;
  /**
   * Payment options for booking the service.
   * Learn more about [service payments](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/about-service-payments).
   */
  payment?: Maybe<WixBookingsServicesV2Payment>;
  /** Phone call options for the service. */
  phoneCall?: Maybe<WixBookingsServicesV2PhoneCall>;
  /**
   * Resource groups required to book the service. For example, to book this service, you must book a room out of the resource group named "rooms".
   * @deprecated Resource groups required to book the service. For example, to book this service, you must book a room out of the resource group named "rooms". Replaced by: service_resources. Removal date: 2024-08-19.
   */
  resourceGroups?: Maybe<Array<Maybe<WixBookingsServicesV2ResourceGroup>>>;
  /**
   * Revision number, which increments by 1 each time the service is updated. To
   * prevent conflicting changes, the existing revision must be used when updating
   * a service.
   */
  revision?: Maybe<Scalars['Long']>;
  /**
   * The service's [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/introduction),
   * which can be used to manage the service's [events](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/introduction).
   */
  schedule?: Maybe<WixBookingsServicesV2Schedule>;
  /** Custom SEO data for the service. */
  seoData?: Maybe<ComWixpressAdvancedSeoSeoSchema>;
  /**
   * Information about which resources must be available so customers can book the service.
   * For example, a meeting room or equipment.
   */
  serviceResources?: Maybe<Array<Maybe<WixBookingsServicesV2ServiceResource>>>;
  /** Order of the service within a [category](https://dev.wix.com/docs/rest/business-solutions/bookings/services/categories-v1/category-object). */
  sortOrder?: Maybe<Scalars['Int']>;
  /** Staff members details. Returned only if `STAFF_MEMBER_DETAILS` conditional field was specified. */
  staffMemberDetails?: Maybe<WixBookingsServicesV2StaffMemberDetails>;
  /**
   * IDs of the [staff members](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members/introduction)
   * providing the service. Available only for appointment-based services.
   */
  staffMemberIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Staff members providing the service. For appointments only. Returned only if `STAFF_MEMBER_DETAILS` conditional field was specified.
   * @deprecated Staff members providing the service. For appointments only. Returned only if `STAFF_MEMBER_DETAILS` conditional field was specified. Replaced by: staff_member_details.staff_members. Removal date: 2025-01-01.
   */
  staffMembers?: Maybe<Array<Maybe<WixBookingsServicesV2StaffMember>>>;
  /**
   * A slug is the last part of the URL address that serves as a unique identifier of the service.
   * The list of supported slugs includes past service names for backwards compatibility, and a custom slug if one was set by the business owner.
   */
  supportedSlugs?: Maybe<Array<Maybe<WixBookingsServicesV2Slug>>>;
  /** Short service description, such as `Hair styling`. */
  tagLine?: Maybe<Scalars['String']>;
  /** Taxable address used to calculate tax */
  taxableAddress?: Maybe<WixBookingsServicesV2TaxableAddress>;
  /**
   * Service type.
   * Learn more about [service types](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/about-service-types).
   */
  type?: Maybe<WixBookingsServicesV2ServiceTypeEnumServiceType>;
  /** Date and time the service was updated in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  updatedDate?: Maybe<Scalars['String']>;
  /** URLs to various service-related pages, such as the calendar page and the booking page. */
  urls?: Maybe<WixBookingsServicesV2UrLs>;
};

export type WixBookingsServicesV2ServiceAvailabilityConstraints = {
  /** The booking policy. */
  bookingPolicy?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1BookingPolicy>;
  /**
   * The locations this service is offered at.
   * Only multiple locations of type `BUSINESS` are supported. Multiple locations of type `CUSTOM` or `CUSTOMER` are not supported.
   * For courses only: Currently, only one location is supported for all location types.
   * Use the `Set Service Locations` method to change the locations this service is offered at.
   */
  locations?: Maybe<Array<Maybe<WixBookingsServicesV2Location>>>;
  /** Online booking settings. */
  onlineBooking?: Maybe<WixBookingsServicesV2OnlineBooking>;
  /**
   * Resource groups required to book the service. For backward compatibility only. Use `Service Resources` instead.
   * @deprecated Resource groups required to book the service. For backward compatibility only. Use `Service Resources` instead. Replaced by: service_resources. Removal date: 2024-08-19.
   */
  resourceGroups?: Maybe<Array<Maybe<WixBookingsServicesV2ResourceGroup>>>;
  /** The service schedule, including the schedule ID and availability constraints. */
  schedule?: Maybe<WixBookingsServicesV2Schedule>;
  /** Resource groups required to book the service. */
  serviceResources?: Maybe<Array<Maybe<WixBookingsServicesV2ServiceResource>>>;
  /**
   * The time between available slots' start times.
   * For example, for 5-minute slots: 3:00, 3:05, 3:10 etc. For 1-hour slots: 3:00, 4:00, 5:00 etc.
   * Applied to all schedules of the site.
   * For appointments only.
   */
  slotsSplitInterval?: Maybe<WixBookingsServicesV2UpstreamWixBookingsSchedulesV1SplitInterval>;
};

export type WixBookingsServicesV2ServiceInput = {
  /** Details about all [add-ons](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/add-ons/introduction) customers can choose when booking the service. */
  addOnDetails?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2AddOnDetailsInput>>>;
  /** Information about the [add-on groups](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/about-add-on-groups) associated with the service. */
  addOnGroups?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2AddOnGroupInput>>>;
  /**
   * ID of the app that's associated with the service. You can't update `appId`.
   * If the app ID is not specified, the service will be associated with the [Wix Bookings app](https://dev.wix.com/docs/rest/articles/getting-started/wix-business-solutions) by default.
   */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * [Policy](https://dev.wix.com/docs/rest/business-solutions/bookings/policies/booking-policies/introduction)
   * determining under what conditions this service can be booked. For example, whether the service can only be booked up to 30 minutes before it begins.
   */
  bookingPolicy?: InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1BookingPolicyInput>;
  /**
   * [Category](https://dev.wix.com/docs/rest/business-solutions/bookings/services/categories-v1/category-object)
   * the service is associated with.
   */
  category?: InputMaybe<WixBookingsServicesV2CategoryInput>;
  /** Conferencing options for the service. */
  conferencing?: InputMaybe<WixBookingsServicesV2ConferencingInput>;
  /**
   * ID of the app in dev-center that created the service.
   * If the createByAppId is not specified, the service will be associated with the appId, and if the appId is not specified, it will be associated to [Wix Bookings app](https://dev.wix.com/docs/rest/articles/getting-started/wix-business-solutions) by default.
   */
  createdByAppId?: InputMaybe<Scalars['String']>;
  /** Date and time the service was created in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Default maximum number of customers that can book the service. The service cannot be booked beyond this capacity. */
  defaultCapacity?: InputMaybe<Scalars['Int']>;
  /** Service description. For example, `High-class hair styling, cuts, straightening and color`. */
  description?: InputMaybe<Scalars['String']>;
  /** Extensions enabling users to save custom data related to the service. */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** Form the customer filled out when booking the service. */
  form?: InputMaybe<WixBookingsServicesV2FormInput>;
  /** Whether the service is hidden from Wix Bookings pages and widgets. */
  hidden?: InputMaybe<Scalars['Boolean']>;
  /** Service ID. */
  id?: InputMaybe<Scalars['String']>;
  /** The locations this service is offered at. Read more about [service locations](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/about-service-locations). */
  locations?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2LocationInput>>>;
  /**
   * Active slug for the service.
   * Learn more about [service slugs](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/about-service-slugs).
   */
  mainSlug?: InputMaybe<WixBookingsServicesV2SlugInput>;
  /** Media associated with the service. */
  media?: InputMaybe<WixBookingsServicesV2MediaInput>;
  /** Service name. */
  name?: InputMaybe<Scalars['String']>;
  /** Online booking settings. */
  onlineBooking?: InputMaybe<WixBookingsServicesV2OnlineBookingInput>;
  /**
   * Payment options for booking the service.
   * Learn more about [service payments](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/about-service-payments).
   */
  payment?: InputMaybe<WixBookingsServicesV2PaymentInput>;
  /** Phone call options for the service. */
  phoneCall?: InputMaybe<WixBookingsServicesV2PhoneCallInput>;
  /**
   * Revision number, which increments by 1 each time the service is updated. To
   * prevent conflicting changes, the existing revision must be used when updating
   * a service.
   */
  revision?: InputMaybe<Scalars['Long']>;
  /**
   * The service's [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/introduction),
   * which can be used to manage the service's [events](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/introduction).
   */
  schedule?: InputMaybe<WixBookingsServicesV2ScheduleInput>;
  /** Custom SEO data for the service. */
  seoData?: InputMaybe<ComWixpressAdvancedSeoSeoSchemaInput>;
  /**
   * Information about which resources must be available so customers can book the service.
   * For example, a meeting room or equipment.
   */
  serviceResources?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2ServiceResourceInput>>>;
  /** Order of the service within a [category](https://dev.wix.com/docs/rest/business-solutions/bookings/services/categories-v1/category-object). */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Staff members details. Returned only if `STAFF_MEMBER_DETAILS` conditional field was specified. */
  staffMemberDetails?: InputMaybe<WixBookingsServicesV2StaffMemberDetailsInput>;
  /**
   * IDs of the [staff members](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members/introduction)
   * providing the service. Available only for appointment-based services.
   */
  staffMemberIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * A slug is the last part of the URL address that serves as a unique identifier of the service.
   * The list of supported slugs includes past service names for backwards compatibility, and a custom slug if one was set by the business owner.
   */
  supportedSlugs?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2SlugInput>>>;
  /** Short service description, such as `Hair styling`. */
  tagLine?: InputMaybe<Scalars['String']>;
  /** Taxable address used to calculate tax */
  taxableAddress?: InputMaybe<WixBookingsServicesV2TaxableAddressInput>;
  /**
   * Service type.
   * Learn more about [service types](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/about-service-types).
   */
  type?: InputMaybe<WixBookingsServicesV2ServiceTypeEnumServiceType>;
  /** Date and time the service was updated in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** URLs to various service-related pages, such as the calendar page and the booking page. */
  urls?: InputMaybe<WixBookingsServicesV2UrLsInput>;
};

export type WixBookingsServicesV2ServiceResource = {
  /** The unique identifier for the service resource. If not specified, it defaults to the resource type ID. */
  id?: Maybe<Scalars['String']>;
  /** The number of resources required to book the service. Defaults to 1. */
  requiredResourcesNumber?: Maybe<Scalars['Int']>;
  /** Resource IDs, each referencing a resource in the Resources API. Must be a subset of resources within the specified resource type. */
  resourceIds?: Maybe<WixBookingsServicesV2ResourceIds>;
  /** Details about the required [resource type](https://dev.wix.com/docs/api-reference/business-solutions/bookings/resources/resource-types-v2/introduction). */
  resourceType?: Maybe<WixBookingsServicesV2ResourceType>;
  /**
   * If set to `true`, the customer can select specific resources while booking the service.
   * If set to `false`, the resources required to book the service will be auto-selected at the time of booking. Defaults to false.
   */
  selectableResource?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2ServiceResourceInput = {
  /** The unique identifier for the service resource. If not specified, it defaults to the resource type ID. */
  id?: InputMaybe<Scalars['String']>;
  /** The number of resources required to book the service. Defaults to 1. */
  requiredResourcesNumber?: InputMaybe<Scalars['Int']>;
  /** Resource IDs, each referencing a resource in the Resources API. Must be a subset of resources within the specified resource type. */
  resourceIds?: InputMaybe<WixBookingsServicesV2ResourceIdsInput>;
  /** Details about the required [resource type](https://dev.wix.com/docs/api-reference/business-solutions/bookings/resources/resource-types-v2/introduction). */
  resourceType?: InputMaybe<WixBookingsServicesV2ResourceTypeInput>;
  /**
   * If set to `true`, the customer can select specific resources while booking the service.
   * If set to `false`, the resources required to book the service will be auto-selected at the time of booking. Defaults to false.
   */
  selectableResource?: InputMaybe<Scalars['Boolean']>;
};

export enum WixBookingsServicesV2ServiceTypeEnumServiceType {
  /** Appointment-based service. */
  APPOINTMENT = 'APPOINTMENT',
  /** Class service. */
  CLASS = 'CLASS',
  /** Course service. */
  COURSE = 'COURSE',
  UNKNOWN_SERVICE_TYPE = 'UNKNOWN_SERVICE_TYPE'
}

export type WixBookingsServicesV2SetAddOnsForGroupRequestInput = {
  /** IDs of add-ons to set for the group in display order. */
  addOnIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Group ID to set add-ons for. */
  groupId?: InputMaybe<Scalars['String']>;
  /** Service ID containing the group. */
  serviceId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2SetAddOnsForGroupResponse = {
  /** Updated add-on group. */
  addOnGroup?: Maybe<WixBookingsServicesV2AddOnGroup>;
};

export type WixBookingsServicesV2SetCustomSlugRequestInput = {
  /** ID of the service for which to update the active slug. */
  serviceId?: InputMaybe<Scalars['String']>;
  /** Slug to set as the active service slug. */
  slug?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2SetCustomSlugResponse = {
  /** Updated service. */
  service?: Maybe<WixBookingsServicesV2Service>;
  /** Updated active service slug. */
  slug?: Maybe<WixBookingsServicesV2Slug>;
};

export type WixBookingsServicesV2SetServiceLocationsRequestInput = {
  /** List of locations replacing existing service locations. Omitting an existing location removes it from the service. Specify `removedLocationSessionsAction` to determine the handling of future sessions scheduled at that location. */
  locations?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2LocationInput>>>;
  /**
   * Whether to notify participants about the change of location, and an
   * Optional custom message. The notification is sent only to participants of sessions that are affected by the change.
   */
  participantNotification?: InputMaybe<WixBookingsServicesV2ParticipantNotificationInput>;
  /**
   * The action to perform on sessions currently set to a removed location. For
   * example, move existing sessions to a new specified location.
   * If not specified, sessions will not be moved to a new location.
   */
  removedLocationSessionsAction?: InputMaybe<WixBookingsServicesV2RemovedLocationSessionsActionInput>;
  /** ID of the service. */
  serviceId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2SetServiceLocationsResponse = {
  /** The updated service with the newly set locations. */
  service?: Maybe<WixBookingsServicesV2Service>;
};

export type WixBookingsServicesV2Slug = {
  /** Date and time the slug was created. This is a system field. */
  createdDate?: Maybe<Scalars['String']>;
  /** Whether the slug was generated or customized. If `true`, the slug was customized manually by the business owner. Otherwise, the slug was automatically generated from the service name. */
  custom?: Maybe<Scalars['Boolean']>;
  /** The unique part of service's URL that identifies the service's information page. For example, `service-1` in `https:/example.com/services/service-1`. */
  name?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2SlugInput = {
  /** Date and time the slug was created. This is a system field. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Whether the slug was generated or customized. If `true`, the slug was customized manually by the business owner. Otherwise, the slug was automatically generated from the service name. */
  custom?: InputMaybe<Scalars['Boolean']>;
  /** The unique part of service's URL that identifies the service's information page. For example, `service-1` in `https:/example.com/services/service-1`. */
  name?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2StaffMediaItem = {
  /** Details of the image associated with the staff, such as URL and size. */
  image?: Maybe<WixBookingsServicesV2UpstreamWixCommonImage>;
};

export type WixBookingsServicesV2StaffMediaItemInput = {
  /** Details of the image associated with the staff, such as URL and size. */
  image?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonImageInput>;
};

export type WixBookingsServicesV2StaffMember = {
  /** ID of the staff member events schedule, can be used to retrieve schedule information using wix-bookings-backend schedules API. */
  eventsScheduleId?: Maybe<Scalars['String']>;
  /** Main media associated with the service. */
  mainMedia?: Maybe<WixBookingsServicesV2StaffMediaItem>;
  /** Name of the staff member */
  name?: Maybe<Scalars['String']>;
  /** ID of the staff member providing the service, can be used to retrieve resource information using wix-bookings-backend resources API. */
  staffMemberId?: Maybe<Scalars['String']>;
  /** IDs of the staff member working hours schedules, can be used to retrieve schedule information using wix-bookings-backend schedules API. */
  workingHoursScheduleIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type WixBookingsServicesV2StaffMemberDetails = {
  /** Staff members providing the service. For appointments only. */
  staffMembers?: Maybe<Array<Maybe<WixBookingsServicesV2StaffMember>>>;
};

export type WixBookingsServicesV2StaffMemberDetailsInput = {
  /** Staff members providing the service. For appointments only. */
  staffMembers?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2StaffMemberInput>>>;
};

export type WixBookingsServicesV2StaffMemberInput = {
  /** ID of the staff member events schedule, can be used to retrieve schedule information using wix-bookings-backend schedules API. */
  eventsScheduleId?: InputMaybe<Scalars['String']>;
  /** Main media associated with the service. */
  mainMedia?: InputMaybe<WixBookingsServicesV2StaffMediaItemInput>;
  /** Name of the staff member */
  name?: InputMaybe<Scalars['String']>;
  /** ID of the staff member providing the service, can be used to retrieve resource information using wix-bookings-backend resources API. */
  staffMemberId?: InputMaybe<Scalars['String']>;
  /** IDs of the staff member working hours schedules, can be used to retrieve schedule information using wix-bookings-backend schedules API. */
  workingHoursScheduleIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixBookingsServicesV2TaxableAddress = {
  /** Taxable address type. */
  taxableAddressType?: Maybe<WixBookingsServicesV2TaxableAddressTaxableAddressType>;
};

export type WixBookingsServicesV2TaxableAddressInput = {
  /** Taxable address type. */
  taxableAddressType?: InputMaybe<WixBookingsServicesV2TaxableAddressTaxableAddressType>;
};

export enum WixBookingsServicesV2TaxableAddressTaxableAddressType {
  BILLING = 'BILLING',
  BUSINESS = 'BUSINESS',
  UNKNOWN_TAXABLE_ADDRESS_TYPE = 'UNKNOWN_TAXABLE_ADDRESS_TYPE'
}

export type WixBookingsServicesV2UrLs = {
  /** The URL for the booking entry point. It can be either to the calendar or to the service page. */
  bookingPage?: Maybe<WixBookingsServicesV2UpstreamWixCommonPageUrlV2>;
  /** The URL for the calendar. Can be empty if no calendar exists. */
  calendarPage?: Maybe<WixBookingsServicesV2UpstreamWixCommonPageUrlV2>;
  /** The URL for the service page. */
  servicePage?: Maybe<WixBookingsServicesV2UpstreamWixCommonPageUrlV2>;
};

export type WixBookingsServicesV2UrLsInput = {
  /** The URL for the booking entry point. It can be either to the calendar or to the service page. */
  bookingPage?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonPageUrlV2Input>;
  /** The URL for the calendar. Can be empty if no calendar exists. */
  calendarPage?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonPageUrlV2Input>;
  /** The URL for the service page. */
  servicePage?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonPageUrlV2Input>;
};

export type WixBookingsServicesV2UpdateAddOnGroupRequestInput = {
  /** Add-on group to update. */
  addOnGroup?: InputMaybe<WixBookingsServicesV2AddOnGroupInput>;
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** ID of the service that contains the add-on group. */
  serviceId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2UpdateAddOnGroupResponse = {
  /** Updated add-on group. */
  addOnGroup?: Maybe<WixBookingsServicesV2AddOnGroup>;
};

export type WixBookingsServicesV2UpdateAddOnsGroupRequestInput = {
  /** AddOnsGroup to update. */
  addOnsGroup?: InputMaybe<WixBookingsServicesV2AddOnsGroupInput>;
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixBookingsServicesV2UpdateAddOnsGroupResponse = {
  /** Updated AddOnsGroup */
  addOnsGroup?: Maybe<WixBookingsServicesV2AddOnsGroup>;
};

export type WixBookingsServicesV2UpdateServiceRequestInput = {
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Service to update. */
  service?: InputMaybe<WixBookingsServicesV2ServiceInput>;
};

export type WixBookingsServicesV2UpdateServiceResponse = {
  /** Updated service. */
  service?: Maybe<WixBookingsServicesV2Service>;
};

export type WixBookingsServicesV2UpstreamWixBookingsSchedulesV1SplitInterval = {
  /**
   * Whether the slot duration is used as the split interval value.
   * If `same_as_duration` is `true`, the `value_in_minutes` is the sum of the first duration in
   * `schedule.availabilityConstraints.SlotDurations` field, and `schedule.availabilityConstraints.TimeBetweenSlots` field.
   */
  sameAsDuration?: Maybe<Scalars['Boolean']>;
  /** Number of minutes between available slots' start times when `same_as_duration` is `false`. */
  valueInMinutes?: Maybe<Scalars['Int']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1BookAfterStartPolicy = {
  /**
   * Whether booking is allowed after the start of the schedule. When `true`,
   * customers can book after the start of the schedule.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1BookAfterStartPolicyInput = {
  /**
   * Whether booking is allowed after the start of the schedule. When `true`,
   * customers can book after the start of the schedule.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1BookingPolicy = {
  /** ID of the app that's associated with the service. */
  appId?: Maybe<Scalars['String']>;
  /** Policy on booking an entity after the start of the schedule. */
  bookAfterStartPolicy?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1BookAfterStartPolicy>;
  /** The ID to the policy for the booking. */
  bookingPolicy?: Maybe<WixBookingsV1BookingPolicy>;
  /** Rules for cancellation fees. */
  cancellationFeePolicy?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicy>;
  /** Policy for canceling a booked entity. */
  cancellationPolicy?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1CancellationPolicy>;
  /** Date and time the policy was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Custom description for the policy. This policy is displayed to the participant. */
  customPolicyDescription?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1PolicyDescription>;
  /** Whether the policy is the default for the meta site. */
  default?: Maybe<Scalars['Boolean']>;
  /** The ID to the policy for the booking. */
  id?: Maybe<Scalars['String']>;
  /** Rules for Intake form integration */
  intakeFormPolicy?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1IntakeFormPolicy>;
  /** Policy for limiting early bookings. */
  limitEarlyBookingPolicy?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1LimitEarlyBookingPolicy>;
  /** Policy for limiting late bookings. */
  limitLateBookingPolicy?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1LimitLateBookingPolicy>;
  /** Name of the policy. */
  name?: Maybe<Scalars['String']>;
  /** Policy regarding the participants per booking. */
  participantsPolicy?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1ParticipantsPolicy>;
  /** Policy for rescheduling a booked entity. */
  reschedulePolicy?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1ReschedulePolicy>;
  /** Policy for allocating resources. */
  resourcesPolicy?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1ResourcesPolicy>;
  /** Revision number, which increments by 1 each time the policy is updated. To prevent conflicting changes, the existing revision must be used when updating a policy. Can be empty after the service was cloned as part of site clone. */
  revision?: Maybe<Scalars['Long']>;
  /** Rule for saving credit card. */
  saveCreditCardPolicy?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1SaveCreditCardPolicy>;
  /**
   * Rules for sorting staff.
   * The sorting will affect which staff is chosen during the book flow, if needed.
   */
  staffSortingPolicy?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1StaffSortingPolicy>;
  /** Date and time the policy was updated. */
  updatedDate?: Maybe<Scalars['String']>;
  /** Waitlist policy for the service. */
  waitlistPolicy?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1WaitlistPolicy>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1BookingPolicyInput = {
  /** ID of the app that's associated with the service. */
  appId?: InputMaybe<Scalars['String']>;
  /** Policy on booking an entity after the start of the schedule. */
  bookAfterStartPolicy?: InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1BookAfterStartPolicyInput>;
  /** Rules for cancellation fees. */
  cancellationFeePolicy?: InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicyInput>;
  /** Policy for canceling a booked entity. */
  cancellationPolicy?: InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1CancellationPolicyInput>;
  /** Date and time the policy was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Custom description for the policy. This policy is displayed to the participant. */
  customPolicyDescription?: InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1PolicyDescriptionInput>;
  /** Whether the policy is the default for the meta site. */
  default?: InputMaybe<Scalars['Boolean']>;
  /** The ID to the policy for the booking. */
  id?: InputMaybe<Scalars['String']>;
  /** Rules for Intake form integration */
  intakeFormPolicy?: InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1IntakeFormPolicyInput>;
  /** Policy for limiting early bookings. */
  limitEarlyBookingPolicy?: InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1LimitEarlyBookingPolicyInput>;
  /** Policy for limiting late bookings. */
  limitLateBookingPolicy?: InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1LimitLateBookingPolicyInput>;
  /** Name of the policy. */
  name?: InputMaybe<Scalars['String']>;
  /** Policy regarding the participants per booking. */
  participantsPolicy?: InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1ParticipantsPolicyInput>;
  /** Policy for rescheduling a booked entity. */
  reschedulePolicy?: InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1ReschedulePolicyInput>;
  /** Policy for allocating resources. */
  resourcesPolicy?: InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1ResourcesPolicyInput>;
  /** Revision number, which increments by 1 each time the policy is updated. To prevent conflicting changes, the existing revision must be used when updating a policy. Can be empty after the service was cloned as part of site clone. */
  revision?: InputMaybe<Scalars['Long']>;
  /** Rule for saving credit card. */
  saveCreditCardPolicy?: InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1SaveCreditCardPolicyInput>;
  /**
   * Rules for sorting staff.
   * The sorting will affect which staff is chosen during the book flow, if needed.
   */
  staffSortingPolicy?: InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1StaffSortingPolicyInput>;
  /** Date and time the policy was updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** Waitlist policy for the service. */
  waitlistPolicy?: InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1WaitlistPolicyInput>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicy = {
  /**
   * Whether the cancellation fee should not be automatically collected when customer cancels the booking.
   *
   * Default: `true`
   */
  autoCollectFeeEnabled?: Maybe<Scalars['Boolean']>;
  /** Cancellation windows describing the time of cancellation and the fee to charge. */
  cancellationWindows?: Maybe<Array<Maybe<WixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicyCancellationWindow>>>;
  /**
   * Whether canceling a booking will result in a cancellation fee
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicyCancellationWindow = {
  /** Amount to be charged as a cancellation fee. */
  amount?: Maybe<WixBookingsServicesV2UpstreamWixCommonMoney>;
  /** Percentage of the original price to be charged as a cancellation fee. */
  percentage?: Maybe<Scalars['String']>;
  /** The fee will be applied if the booked session starts within this start time in minutes. */
  startInMinutes?: Maybe<Scalars['Int']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicyCancellationWindowInput = {
  /** Amount to be charged as a cancellation fee. */
  amount?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonMoneyInput>;
  /** Percentage of the original price to be charged as a cancellation fee. */
  percentage?: InputMaybe<Scalars['String']>;
  /** The fee will be applied if the booked session starts within this start time in minutes. */
  startInMinutes?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicyInput = {
  /**
   * Whether the cancellation fee should not be automatically collected when customer cancels the booking.
   *
   * Default: `true`
   */
  autoCollectFeeEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Cancellation windows describing the time of cancellation and the fee to charge. */
  cancellationWindows?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1CancellationFeePolicyCancellationWindowInput>>>;
  /**
   * Whether canceling a booking will result in a cancellation fee
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1CancellationPolicy = {
  /**
   * Whether canceling a booking is allowed. When `true`, customers
   * can cancel the booking.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
  /**
   * Minimum number of minutes before the start of the booked session that the booking can be canceled.
   *
   * Default: 1440 minutes (1 day)
   * Min: 1 minute
   */
  latestCancellationInMinutes?: Maybe<Scalars['Int']>;
  /**
   * Whether there is a limit on the latest cancellation time. When `true`,
   * a time limit is enforced.
   *
   * Default: `false`
   */
  limitLatestCancellation?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1CancellationPolicyInput = {
  /**
   * Whether canceling a booking is allowed. When `true`, customers
   * can cancel the booking.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * Minimum number of minutes before the start of the booked session that the booking can be canceled.
   *
   * Default: 1440 minutes (1 day)
   * Min: 1 minute
   */
  latestCancellationInMinutes?: InputMaybe<Scalars['Int']>;
  /**
   * Whether there is a limit on the latest cancellation time. When `true`,
   * a time limit is enforced.
   *
   * Default: `false`
   */
  limitLatestCancellation?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1IntakeFormPolicy = {
  completionRequirement?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1IntakeFormPolicyCompletionRequirement>;
  /**
   * Whether intake form integration is enabled for the service.
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
  /** ID of the intake form to integrate with the service. */
  form?: Maybe<WixFormsV4Form>;
  /** ID of the intake form to integrate with the service. */
  formId?: Maybe<Scalars['String']>;
  /** When to present the intake form to the customer. */
  timing?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1IntakeFormPolicyTiming>;
};

export enum WixBookingsServicesV2UpstreamWixBookingsV1IntakeFormPolicyCompletionRequirement {
  /** Form completion is optional and can be skipped entirely. */
  OPTIONAL = 'OPTIONAL',
  /**
   * Form must be completed before the booking can be finalized.
   * can used only if timing is BEFORE_BOOKING.
   */
  REQUIRED_BEFORE_BOOKING = 'REQUIRED_BEFORE_BOOKING',
  UNKNOWN_COMPLETION_REQUIREMENT = 'UNKNOWN_COMPLETION_REQUIREMENT'
}

export type WixBookingsServicesV2UpstreamWixBookingsV1IntakeFormPolicyInput = {
  completionRequirement?: InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1IntakeFormPolicyCompletionRequirement>;
  /**
   * Whether intake form integration is enabled for the service.
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** ID of the intake form to integrate with the service. */
  formId?: InputMaybe<Scalars['String']>;
  /** When to present the intake form to the customer. */
  timing?: InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1IntakeFormPolicyTiming>;
};

export enum WixBookingsServicesV2UpstreamWixBookingsV1IntakeFormPolicyTiming {
  /** Send form after booking. */
  AFTER_BOOKING = 'AFTER_BOOKING',
  /** Show form during booking flow. */
  BEFORE_BOOKING = 'BEFORE_BOOKING',
  UNKNOWN_TIMING = 'UNKNOWN_TIMING'
}

export type WixBookingsServicesV2UpstreamWixBookingsV1LimitEarlyBookingPolicy = {
  /**
   * Maximum number of minutes before the start of the session that a booking can be made. This value must be greater
   * than `latest_booking_in_minutes` in the `LimitLateBookingPolicy` policy.
   *
   * Default: 10080 minutes (7 days)
   * Min: 1 minute
   */
  earliestBookingInMinutes?: Maybe<Scalars['Int']>;
  /**
   * Whether there is a limit on how early a customer
   * can book. When `false`, there is no limit on the earliest
   * booking time and customers can book in advance, as early as they like.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1LimitEarlyBookingPolicyInput = {
  /**
   * Maximum number of minutes before the start of the session that a booking can be made. This value must be greater
   * than `latest_booking_in_minutes` in the `LimitLateBookingPolicy` policy.
   *
   * Default: 10080 minutes (7 days)
   * Min: 1 minute
   */
  earliestBookingInMinutes?: InputMaybe<Scalars['Int']>;
  /**
   * Whether there is a limit on how early a customer
   * can book. When `false`, there is no limit on the earliest
   * booking time and customers can book in advance, as early as they like.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1LimitLateBookingPolicy = {
  /**
   * Whether there is a limit on how late a customer
   * can book. When `false`, there is no limit on the latest
   * booking time and customers can book up to the last minute.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
  /**
   * Minimum number of minutes before the start of the session that a booking can be made.
   * For a schedule, this is relative to the start time of the next booked session, excluding past-booked sessions.
   * This value must be less than `earliest_booking_in_minutes` in the `LimitEarlyBookingPolicy` policy.
   *
   * Default: 1440 minutes (1 day)
   * Min: 1 minute
   */
  latestBookingInMinutes?: Maybe<Scalars['Int']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1LimitLateBookingPolicyInput = {
  /**
   * Whether there is a limit on how late a customer
   * can book. When `false`, there is no limit on the latest
   * booking time and customers can book up to the last minute.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * Minimum number of minutes before the start of the session that a booking can be made.
   * For a schedule, this is relative to the start time of the next booked session, excluding past-booked sessions.
   * This value must be less than `earliest_booking_in_minutes` in the `LimitEarlyBookingPolicy` policy.
   *
   * Default: 1440 minutes (1 day)
   * Min: 1 minute
   */
  latestBookingInMinutes?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1ParticipantsPolicy = {
  /**
   * Whether the maximum number of participants applies. When `false`, there is
   * no maximum.
   *
   * Default: `false`
   * Private because not limiting participants per booking is not supported by Bookings flows today
   */
  enabled?: Maybe<Scalars['Boolean']>;
  /**
   * Maximum number of participants allowed.
   *
   * Default: 1 participant
   * Min: 1 participant
   */
  maxParticipantsPerBooking?: Maybe<Scalars['Int']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1ParticipantsPolicyInput = {
  /**
   * Whether the maximum number of participants applies. When `false`, there is
   * no maximum.
   *
   * Default: `false`
   * Private because not limiting participants per booking is not supported by Bookings flows today
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * Maximum number of participants allowed.
   *
   * Default: 1 participant
   * Min: 1 participant
   */
  maxParticipantsPerBooking?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1PolicyDescription = {
  /**
   * The description to display.
   *
   * Default: Empty
   * Max length: 2500 characters
   */
  description?: Maybe<Scalars['String']>;
  /**
   * Whether the description should be displayed. If `true`, the description is displayed.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1PolicyDescriptionInput = {
  /**
   * The description to display.
   *
   * Default: Empty
   * Max length: 2500 characters
   */
  description?: InputMaybe<Scalars['String']>;
  /**
   * Whether the description should be displayed. If `true`, the description is displayed.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1ReschedulePolicy = {
  /**
   * Whether rescheduling a booking is allowed. When `true`, customers
   * can reschedule the booking.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
  /**
   * Minimum number of minutes before the start of the booked session that the booking can be rescheduled.
   *
   * Default: 1440 minutes (1 day)
   * Min: 1 minute
   */
  latestRescheduleInMinutes?: Maybe<Scalars['Int']>;
  /**
   * Whether there is a limit on the latest reschedule time. When `true`,
   * a time limit is enforced.
   *
   * Default: `false`
   */
  limitLatestReschedule?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1ReschedulePolicyInput = {
  /**
   * Whether rescheduling a booking is allowed. When `true`, customers
   * can reschedule the booking.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * Minimum number of minutes before the start of the booked session that the booking can be rescheduled.
   *
   * Default: 1440 minutes (1 day)
   * Min: 1 minute
   */
  latestRescheduleInMinutes?: InputMaybe<Scalars['Int']>;
  /**
   * Whether there is a limit on the latest reschedule time. When `true`,
   * a time limit is enforced.
   *
   * Default: `false`
   */
  limitLatestReschedule?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1ResourcesPolicy = {
  /**
   * `true`, if it is allowed to automatically assign a resource when booking an appointment,
   * `false`, if the client must always select a resource.
   *
   * Default: `false`
   */
  autoAssignAllowed?: Maybe<Scalars['Boolean']>;
  /**
   * `true` if this policy is enabled, `false` otherwise.
   * When `false` then the client must always select a resource when booking an appointment.
   */
  enabled?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1ResourcesPolicyInput = {
  /**
   * `true`, if it is allowed to automatically assign a resource when booking an appointment,
   * `false`, if the client must always select a resource.
   *
   * Default: `false`
   */
  autoAssignAllowed?: InputMaybe<Scalars['Boolean']>;
  /**
   * `true` if this policy is enabled, `false` otherwise.
   * When `false` then the client must always select a resource when booking an appointment.
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1SaveCreditCardPolicy = {
  /** Default: `false` */
  enabled?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1SaveCreditCardPolicyInput = {
  /** Default: `false` */
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1StaffSortingPolicy = {
  customOptions?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1StaffSortingPolicyCustomOptions>;
  rankingOptions?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1StaffSortingPolicyRankingOptions>;
  /**
   * Method used for sorting and selecting staff members.
   *
   * Default: `RANDOM`
   */
  sortingMethodType?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1StaffSortingPolicySortingMethodType>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1StaffSortingPolicyCustomOptions = {
  /** ID of the app that provides the custom sorting method. */
  appId?: Maybe<Scalars['String']>;
  /**
   * ID of the custom sorting method implemented in SortStaffSPI.
   * This identifies which custom sorting algorithm to use.
   */
  implementationId?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1StaffSortingPolicyCustomOptionsInput = {
  /** ID of the app that provides the custom sorting method. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * ID of the custom sorting method implemented in SortStaffSPI.
   * This identifies which custom sorting algorithm to use.
   */
  implementationId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1StaffSortingPolicyInput = {
  customOptions?: InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1StaffSortingPolicyCustomOptionsInput>;
  rankingOptions?: InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1StaffSortingPolicyRankingOptionsInput>;
  /**
   * Method used for sorting and selecting staff members.
   *
   * Default: `RANDOM`
   */
  sortingMethodType?: InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1StaffSortingPolicySortingMethodType>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1StaffSortingPolicyRankingOptions = {
  /**
   * Order in which staff members are sorted by their priority ranking.
   *
   * Default: `LOWEST_TO_HIGHEST`
   */
  order?: Maybe<WixBookingsServicesV2UpstreamWixBookingsV1StaffSortingPolicyRankingOrder>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1StaffSortingPolicyRankingOptionsInput = {
  /**
   * Order in which staff members are sorted by their priority ranking.
   *
   * Default: `LOWEST_TO_HIGHEST`
   */
  order?: InputMaybe<WixBookingsServicesV2UpstreamWixBookingsV1StaffSortingPolicyRankingOrder>;
};

export enum WixBookingsServicesV2UpstreamWixBookingsV1StaffSortingPolicyRankingOrder {
  /** Staff members with higher priority values are selected first. */
  HIGHEST_TO_LOWEST = 'HIGHEST_TO_LOWEST',
  /** Staff members with lower priority values are selected first. */
  LOWEST_TO_HIGHEST = 'LOWEST_TO_HIGHEST',
  UNKNOWN_RANKING_ORDER = 'UNKNOWN_RANKING_ORDER'
}

export enum WixBookingsServicesV2UpstreamWixBookingsV1StaffSortingPolicySortingMethodType {
  /**
   * Staff members are selected using a custom implementation provided by SortStaffSPI.
   * This allows third-party apps to implement custom staff sorting logic.
   */
  CUSTOM = 'CUSTOM',
  /** Staff members are selected randomly from available options. */
  RANDOM = 'RANDOM',
  /** Staff members are selected based on their priority ranking. */
  RANKING = 'RANKING',
  UNKNOWN_SORTING_METHOD_TYPE = 'UNKNOWN_SORTING_METHOD_TYPE'
}

export type WixBookingsServicesV2UpstreamWixBookingsV1WaitlistPolicy = {
  /**
   * Number of spots available in the waitlist.
   *
   * Default: 10 spots
   * Min: 1 spot
   */
  capacity?: Maybe<Scalars['Int']>;
  /**
   * Whether the session has a waitlist. If `true`, there is a waitlist.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
  /**
   * Amount of time a participant is given to book, once notified that a spot is available.
   *
   * Default: 10 minutes
   * Min: 1 spot
   */
  reservationTimeInMinutes?: Maybe<Scalars['Int']>;
};

export type WixBookingsServicesV2UpstreamWixBookingsV1WaitlistPolicyInput = {
  /**
   * Number of spots available in the waitlist.
   *
   * Default: 10 spots
   * Min: 1 spot
   */
  capacity?: InputMaybe<Scalars['Int']>;
  /**
   * Whether the session has a waitlist. If `true`, there is a waitlist.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * Amount of time a participant is given to book, once notified that a spot is available.
   *
   * Default: 10 minutes
   * Min: 1 spot
   */
  reservationTimeInMinutes?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsServicesV2UpstreamWixCommonAddress = {
  addressLine?: Maybe<Scalars['String']>;
  /** City name. */
  city?: Maybe<Scalars['String']>;
  /** 2-letter country code in an [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) format. */
  country?: Maybe<Scalars['String']>;
  /** Full address of the location. */
  formattedAddress?: Maybe<Scalars['String']>;
  /** Coordinates of the physical address. */
  geocode?: Maybe<WixBookingsServicesV2UpstreamWixCommonAddressLocation>;
  /** Free text to help find the address. */
  hint?: Maybe<Scalars['String']>;
  /** Postal or zip code. */
  postalCode?: Maybe<Scalars['String']>;
  /** Street name and number. */
  streetAddress?: Maybe<WixBookingsServicesV2UpstreamWixCommonStreetAddress>;
  /** Code for a subdivision (such as state, prefecture, or province) in [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2) format. */
  subdivision?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2UpstreamWixCommonAddressInput = {
  addressLine?: InputMaybe<Scalars['String']>;
  /** City name. */
  city?: InputMaybe<Scalars['String']>;
  /** 2-letter country code in an [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) format. */
  country?: InputMaybe<Scalars['String']>;
  /** Full address of the location. */
  formattedAddress?: InputMaybe<Scalars['String']>;
  /** Coordinates of the physical address. */
  geocode?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAddressLocationInput>;
  /** Free text to help find the address. */
  hint?: InputMaybe<Scalars['String']>;
  /** Postal or zip code. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** Street name and number. */
  streetAddress?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonStreetAddressInput>;
  /** Code for a subdivision (such as state, prefecture, or province) in [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2) format. */
  subdivision?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2UpstreamWixCommonAddressLocation = {
  /** Address latitude. */
  latitude?: Maybe<Scalars['Float']>;
  /** Address longitude. */
  longitude?: Maybe<Scalars['Float']>;
};

export type WixBookingsServicesV2UpstreamWixCommonAddressLocationInput = {
  /** Address latitude. */
  latitude?: InputMaybe<Scalars['Float']>;
  /** Address longitude. */
  longitude?: InputMaybe<Scalars['Float']>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationData = {
  /** Array of aggregation results, each containing the aggregation metadata and its calculated values for the specified search criteria. */
  results?: Maybe<Array<Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResults>>>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResults = {
  /** Date histogram aggregation results. */
  dateHistogram?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResults>;
  /** Path to the field to aggregate by in dot notation. For example `name` or `paymentOptions.online`. */
  fieldPath?: Maybe<Scalars['String']>;
  /** Group by value aggregation results. */
  groupedByValue?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResults>;
  /** User-defined name of aggregation as derived from search request. */
  name?: Maybe<Scalars['String']>;
  /** Nested aggregation results. */
  nested?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResults>;
  /** Range aggregation results. */
  ranges?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsRangeResults>;
  /** Scalar aggregation results. */
  scalar?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsScalarResult>;
  /** Type of aggregation that must match specified kind as derived from search request. */
  type?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationType>;
  /** Value aggregation results. */
  values?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsValueResults>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResults = {
  /** Array of date histogram aggregation results, each containing a date bucket and its count. */
  results?: Maybe<Array<Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult>>>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult = {
  /** Count of documents in the bucket. */
  count?: Maybe<Scalars['Int']>;
  /** Date in [ISO 8601 format](https://en.wikipedia.org/wiki/ISO_8601). */
  value?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResults = {
  /** Array of nested value aggregation results, each containing a field value and the associated nested aggregation data. */
  results?: Maybe<Array<Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult>>>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult = {
  /** Nested aggregations. */
  nestedResults?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedAggregationResults>;
  /** Value of the field. */
  value?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedAggregationResults = {
  /** Path to the field to aggregate by in dot notation. For example `name` or `paymentOptions.online`. */
  fieldPath?: Maybe<Scalars['String']>;
  /** User-defined name of aggregation, matches the one specified in request. */
  name?: Maybe<Scalars['String']>;
  /** Range aggregation results. */
  ranges?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsRangeResults>;
  /** Scalar aggregation results. */
  scalar?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsScalarResult>;
  /** Type of aggregation that matches result. */
  type?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationType>;
  /** Value aggregation results. */
  values?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsValueResults>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResults = {
  /** Array of nested aggregation result groups, each containing multiple aggregation results. */
  results?: Maybe<Array<Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsResults>>>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue = {
  /** Date histogram aggregation result. */
  dateHistogram?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult>;
  /** Range aggregation result. */
  range?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsRangeResult>;
  /** Scalar aggregation result. */
  scalar?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsScalarResult>;
  /** Value aggregation result. */
  value?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsRangeResult = {
  /** Count of entities in this range. */
  count?: Maybe<Scalars['Int']>;
  /** Inclusive lower bound of the range. */
  from?: Maybe<Scalars['Float']>;
  /** Exclusive upper bound of the range. */
  to?: Maybe<Scalars['Float']>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsResults = {
  /** Map of nested aggregation results, keyed by aggregation name. */
  results?: Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsScalarResult = {
  /** Value of the scalar aggregation. */
  value?: Maybe<Scalars['Float']>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult = {
  /** Count of entities with this value. */
  count?: Maybe<Scalars['Int']>;
  /** Value of the field. */
  value?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsRangeResults = {
  /** Array of range aggregation results returned in the same order as requested, each containing range bounds and count of entities within that range. */
  results?: Maybe<Array<Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult>>>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult = {
  /** Count of entities in this range. */
  count?: Maybe<Scalars['Int']>;
  /** Inclusive lower bound of the range. */
  from?: Maybe<Scalars['Float']>;
  /** Exclusive upper bound of the range. */
  to?: Maybe<Scalars['Float']>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsScalarResult = {
  /** Type of scalar aggregation. */
  type?: Maybe<WixBookingsServicesV2UpstreamWixCommonScalarType>;
  /** Value of the scalar aggregation. */
  value?: Maybe<Scalars['Float']>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsValueResults = {
  /** Array of value aggregation results, each containing a field value and the count of entities with that value. */
  results?: Maybe<Array<Maybe<WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult>>>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult = {
  /** Count of entities with this value. */
  count?: Maybe<Scalars['Int']>;
  /** Value of the field. */
  value?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationDateHistogramAggregationInput = {
  /** Time interval for date histogram aggregation, for example `DAY`, `HOUR`, `MONTH`. */
  interval?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationDateHistogramAggregationInterval>;
};

export enum WixBookingsServicesV2UpstreamWixCommonAggregationDateHistogramAggregationInterval {
  /** Daily interval. */
  DAY = 'DAY',
  /** Hourly interval. */
  HOUR = 'HOUR',
  /** Minute interval. */
  MINUTE = 'MINUTE',
  /** Monthly interval. */
  MONTH = 'MONTH',
  /** Second interval. */
  SECOND = 'SECOND',
  /** Unknown interval. */
  UNKNOWN_INTERVAL = 'UNKNOWN_INTERVAL',
  /** Weekly interval. */
  WEEK = 'WEEK',
  /** Yearly interval. */
  YEAR = 'YEAR'
}

export type WixBookingsServicesV2UpstreamWixCommonAggregationGroupByAggregationInput = {
  /** Path to the field to aggregate by in dot notation. For example `name` or `paymentOptions.online`. */
  fieldPath?: InputMaybe<Scalars['String']>;
  /** User-defined name of aggregation. Must be unique and will appear in aggregation results. */
  name?: InputMaybe<Scalars['String']>;
  /** Value aggregation configuration. */
  value?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationInput>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationInput = {
  /** Date histogram aggregation configuration. */
  dateHistogram?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationDateHistogramAggregationInput>;
  /** Path to the field to aggregate by in dot notation. For example `name` or `paymentOptions.online`. */
  fieldPath?: InputMaybe<Scalars['String']>;
  /** User-defined name of aggregation. Must be unique and will appear in aggregation results. */
  name?: InputMaybe<Scalars['String']>;
  /** Nested aggregation configuration. */
  nested?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationNestedAggregationInput>;
  /** Range aggregation configuration. */
  range?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationRangeAggregationInput>;
  /** Scalar aggregation configuration. */
  scalar?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationScalarAggregationInput>;
  /** Type of aggregation. Client must specify matching aggregation field below. */
  type?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationType>;
  /** Value aggregation configuration. */
  value?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationInput>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationNestedAggregationInput = {
  /** Flattened list of aggregations where each next aggregation is nested within the previous 1. */
  nestedAggregations?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationNestedAggregationNestedAggregationItemInput>>>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationNestedAggregationNestedAggregationItemInput = {
  /** Date histogram aggregation configuration. Calculates counts within time intervals. */
  dateHistogram?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationDateHistogramAggregationInput>;
  /** Path to the field to aggregate by in dot notation. For example `name` or `paymentOptions.online`. */
  fieldPath?: InputMaybe<Scalars['String']>;
  /** User-defined name of aggregation. Must be unique and will appear in aggregation results. */
  name?: InputMaybe<Scalars['String']>;
  /** Range aggregation configuration. Calculates counts within user-defined value ranges. */
  range?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationRangeAggregationInput>;
  /** Scalar aggregation configuration. Calculates single numerical metrics like count, min, max, sum, or average. */
  scalar?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationScalarAggregationInput>;
  /** Type of aggregation. Client must specify matching aggregation field below. */
  type?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationNestedAggregationNestedAggregationType>;
  /** Value aggregation configuration. Calculates the distribution of field values within the dataset. */
  value?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationInput>;
};

export enum WixBookingsServicesV2UpstreamWixCommonAggregationNestedAggregationNestedAggregationType {
  /** Calculates the count of time values from the specified field in the dataset that fall within each time interval you define (hour, day, week, etc.). */
  DATE_HISTOGRAM = 'DATE_HISTOGRAM',
  /** Calculates the count of the values from the specified field in the dataset that fall within the range of each bucket you define. */
  RANGE = 'RANGE',
  /** Calculates a single numerical value from a dataset, summarizing the dataset into 1 key metric: `COUNT_DISTINCT`, `SUM`, `AVG`, `MIN`, or `MAX`. */
  SCALAR = 'SCALAR',
  UNKNOWN_AGGREGATION_TYPE = 'UNKNOWN_AGGREGATION_TYPE',
  /** Calculates the distribution of a specific field's values within a dataset, providing insights into the overall distribution and key statistics of those values. */
  VALUE = 'VALUE'
}

export type WixBookingsServicesV2UpstreamWixCommonAggregationRangeAggregationInput = {
  /** List of range buckets defining the ranges for aggregation. During aggregation, each entity is placed in the first bucket where its value falls within the specified range bounds. */
  buckets?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationRangeAggregationRangeBucketInput>>>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationRangeAggregationRangeBucketInput = {
  /** Inclusive lower bound of the range. Required if `to` isn't specified. */
  from?: InputMaybe<Scalars['Float']>;
  /** Exclusive upper bound of the range. Required if `from` isn't specified. */
  to?: InputMaybe<Scalars['Float']>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationScalarAggregationInput = {
  /** Operator for the scalar aggregation, for example `COUNT_DISTINCT`, `MIN`, `MAX`. */
  type?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonScalarType>;
};

export enum WixBookingsServicesV2UpstreamWixCommonAggregationType {
  /** Calculates the count of time values from the specified field in the dataset that fall within each time interval you define (hour, day, week, etc.). */
  DATE_HISTOGRAM = 'DATE_HISTOGRAM',
  /** Flattened list of aggregations, where each aggregation is nested within previous 1. */
  NESTED = 'NESTED',
  /** Calculates the count of the values from the specified field in the dataset that fall within the range of each bucket you define. */
  RANGE = 'RANGE',
  /** Calculates a single numerical value from a dataset, summarizing the dataset into 1 key metric: `COUNT_DISTINCT`, `SUM`, `AVG`, `MIN`, or `MAX`. */
  SCALAR = 'SCALAR',
  UNKNOWN_AGGREGATION_TYPE = 'UNKNOWN_AGGREGATION_TYPE',
  /** Calculates the distribution of a specific field's values within a dataset, providing insights into the overall distribution and key statistics of those values. */
  VALUE = 'VALUE'
}

export type WixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationIncludeMissingValuesOptionsInput = {
  /**
   * Custom bucket name for missing values.
   *
   * Default values:
   * - string: `N/A`
   * - int: `0`
   * - bool: `false`
   */
  addToBucket?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationInput = {
  /** Options for including missing values in the aggregation results. */
  includeOptions?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationIncludeMissingValuesOptionsInput>;
  /**
   * Number of aggregations to return.
   *
   * Min: `1`
   * Max: `250`
   * Default: `10`
   */
  limit?: InputMaybe<Scalars['Int']>;
  /**
   * Whether missing values should be included or excluded from the aggregation results.
   *
   * Default: `EXCLUDE`
   */
  missingValues?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationMissingValues>;
  /** Whether to sort in ascending or descending order. */
  sortDirection?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationSortDirection>;
  /** Whether to sort by number of matches or value of the field. */
  sortType?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationSortType>;
};

export enum WixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationMissingValues {
  EXCLUDE = 'EXCLUDE',
  INCLUDE = 'INCLUDE'
}

export enum WixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationSortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum WixBookingsServicesV2UpstreamWixCommonAggregationValueAggregationSortType {
  COUNT = 'COUNT',
  VALUE = 'VALUE'
}

export type WixBookingsServicesV2UpstreamWixCommonBulkActionMetadata = {
  /** Number of items that couldn't be processed. */
  totalFailures?: Maybe<Scalars['Int']>;
  /** Number of items that were successfully processed. */
  totalSuccesses?: Maybe<Scalars['Int']>;
  /** Number of failures without details because detailed failure threshold was exceeded. */
  undetailedFailures?: Maybe<Scalars['Int']>;
};

export type WixBookingsServicesV2UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsServicesV2UpstreamWixCommonCursorPagingMetadata = {
  /**
   * Number of items returned in the current response page.
   *
   * This count reflects the actual number of items in the current result set,
   * which may be less than the requested limit if fewer items are available.
   */
  count?: Maybe<Scalars['Int']>;
  /**
   * Navigation cursors for moving between result pages.
   *
   * Contains `next` and `prev` cursor tokens for pagination. Use the `next` cursor
   * to retrieve subsequent pages and `prev` cursor to go back to previous pages.
   * Learn more about cursor paging in the [API Query Language guide](https://dev.wix.com/api/rest/getting-started/api-query-language#getting-started_api-query-language_cursor-paging).
   */
  cursors?: Maybe<WixBookingsServicesV2UpstreamWixCommonCursors>;
  /**
   * Indicates whether additional results are available beyond the current page.
   *
   * - `true`: More results exist and can be retrieved using the `next` cursor.
   * - `false`: This is the final page of results.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixCommonCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2UpstreamWixCommonSortingInput>>>;
};

export type WixBookingsServicesV2UpstreamWixCommonCursorSearchInput = {
  /**
   * Aggregations for grouping data into categories (facets) and providing summaries for each category.
   * For example, use aggregations to categorize search results by service type, payment options, or locations.
   */
  aggregations?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2UpstreamWixCommonAggregationInput>>>;
  /**
   * Cursor-based paging for result navigation. When requesting `cursor_paging.cursor`,
   * `filter`, `sort`, or `search` can't be specified.
   */
  cursorPaging?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object for narrowing search results. For example, to return only services with specific payment options: `"filter": {"payment.options.online": true, "payment.options.in_person": false}`.
   *
   * Learn more about the filter format in the [supported filters article](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/filtering-and-sorting).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Free text to match in searchable fields. */
  search?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonSearchDetailsInput>;
  /**
   * Array of sort objects specifying result order. For example, to sort by creation date in descending order: `"sort": [{"fieldName": "createdDate", "order": "DESC"}]`.
   *
   * Learn more about the sort format in the [supported filters article](https://dev.wix.com/docs/api-reference/business-solutions/bookings/services/services-v2/filtering-and-sorting).
   */
  sort?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2UpstreamWixCommonSortingInput>>>;
  /**
   * Time zone in [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database) or [ISO 8601 UTC offset format](https://en.wikipedia.org/wiki/ISO_8601#Time_offsets_from_UTC) for adjusting time fields in the specified filters and returned aggregation data. For example, `America/New_York`, `UTC`, or `+02:00`.
   *
   * Default: Time zone specified in the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2UpstreamWixCommonCursors = {
  /**
   * Cursor token for retrieving the next page of results.
   *
   * Use this token in subsequent requests to continue pagination forward.
   * Value is `null` when on the last page of results.
   */
  next?: Maybe<Scalars['String']>;
  /**
   * Cursor token for retrieving the previous page of results.
   *
   * Use this token to navigate backwards through result pages.
   * Value is `null` when on the first page of results.
   */
  prev?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2UpstreamWixCommonImage = {
  /** Image alt text. */
  altText?: Maybe<Scalars['String']>;
  /** Image file name. */
  filename?: Maybe<Scalars['String']>;
  /** Original image height. */
  height?: Maybe<Scalars['Int']>;
  /** WixMedia image ID. (e.g. "4b3901ffcb8d7ad81a613779d92c9702.jpg") */
  id?: Maybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: Maybe<Scalars['String']>;
  /** Image URL. (similar to image.id e.g. "4b3901ffcb8d7ad81a613779d92c9702.jpg") */
  url?: Maybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: Maybe<Scalars['String']>;
  /** Original image width. */
  width?: Maybe<Scalars['Int']>;
};

export type WixBookingsServicesV2UpstreamWixCommonImageInput = {
  /** Image alt text. */
  altText?: InputMaybe<Scalars['String']>;
  /** Image file name. */
  filename?: InputMaybe<Scalars['String']>;
  /** Original image height. */
  height?: InputMaybe<Scalars['Int']>;
  /** WixMedia image ID. (e.g. "4b3901ffcb8d7ad81a613779d92c9702.jpg") */
  id?: InputMaybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: InputMaybe<Scalars['String']>;
  /** Image URL. (similar to image.id e.g. "4b3901ffcb8d7ad81a613779d92c9702.jpg") */
  url?: InputMaybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: InputMaybe<Scalars['String']>;
  /** Original image width. */
  width?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsServicesV2UpstreamWixCommonItemMetadata = {
  /** Details about the error in case of failure. */
  error?: Maybe<WixApiApplicationError>;
  /** Item ID. Should always be available, unless it's impossible (for example, when failing to create an item). */
  id?: Maybe<Scalars['String']>;
  /** Index of the item within the request array. Allows for correlation between request and response items. */
  originalIndex?: Maybe<Scalars['Int']>;
  /** Whether the requested action was successful for this item. When `false`, the `error` field is populated. */
  success?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2UpstreamWixCommonMoney = {
  /** Currency code in [ISO 4217 format](https://en.wikipedia.org/wiki/ISO_4217). For example, `USD`. */
  currency?: Maybe<Scalars['String']>;
  /** Monetary amount. Decimal string in local format. For example, `1 000,30`. */
  formattedValue?: Maybe<Scalars['String']>;
  /** Monetary amount. Decimal string with a period as a decimal separator. For example `25.05`. */
  value?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2UpstreamWixCommonMoneyInput = {
  /** Currency code in [ISO 4217 format](https://en.wikipedia.org/wiki/ISO_4217). For example, `USD`. */
  currency?: InputMaybe<Scalars['String']>;
  /** Monetary amount. Decimal string in local format. For example, `1 000,30`. */
  formattedValue?: InputMaybe<Scalars['String']>;
  /** Monetary amount. Decimal string with a period as a decimal separator. For example `25.05`. */
  value?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2UpstreamWixCommonPageUrlV2 = {
  /** The relative path for the page within the site. For example, `/product-page/a-product`. */
  relativePath?: Maybe<Scalars['String']>;
  /** The page's full URL. For example, `https://mysite.com/product-page/a-product`. */
  url?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2UpstreamWixCommonPageUrlV2Input = {
  /** The relative path for the page within the site. For example, `/product-page/a-product`. */
  relativePath?: InputMaybe<Scalars['String']>;
  /** The page's full URL. For example, `https://mysite.com/product-page/a-product`. */
  url?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2UpstreamWixCommonPagingInput = {
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the current sort order. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsServicesV2UpstreamWixCommonPagingMetadataV2 = {
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Cursors to navigate through the result pages using `next` and `prev`. Returned if cursor paging is used. */
  cursors?: Maybe<WixBookingsServicesV2UpstreamWixCommonCursors>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
  /** Offset that was requested. */
  offset?: Maybe<Scalars['Int']>;
  /** Flag that indicates the server failed to calculate the `total` field. */
  tooManyToCount?: Maybe<Scalars['Boolean']>;
  /** Total number of items that match the query. Returned if offset paging is used and the `tooManyToCount` flag is not set. */
  total?: Maybe<Scalars['Int']>;
};

export type WixBookingsServicesV2UpstreamWixCommonQueryV2Input = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonCursorPagingInput>;
  /** Array of projected fields. A list of specific field names to return. If `fieldsets` are also specified, the union of `fieldsets` and `fields` is returned. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of named, predefined sets of projected fields. A array of predefined named sets of fields to be returned. Specifying multiple `fieldsets` will return the union of fields from all sets. If `fields` are also specified, the union of `fieldsets` and `fields` is returned. */
  fieldsets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter object in the following format:
   *
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   *
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`
   *
   * Read more about [supported fields and operators](https://dev.wix.com/api/rest/wix-bookings/services-v2/filtering-and-sorting).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Paging options to limit and skip the number of items. */
  paging?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonPagingInput>;
  /**
   * Sort object in the following format:
   * `[ {"fieldName":"sortField1","order":"ASC"},
   * {"fieldName":"sortField2","order":"DESC"} ]`
   *
   * Read more about [sorting](https://dev.wix.com/api/rest/wix-bookings/services-v2/filtering-and-sorting#wix-bookings_services-v2_filtering-and-sorting_sorting).
   */
  sort?: InputMaybe<Array<InputMaybe<WixBookingsServicesV2UpstreamWixCommonSortingInput>>>;
};

export enum WixBookingsServicesV2UpstreamWixCommonScalarType {
  /** Average of values. */
  AVG = 'AVG',
  /** Total number of distinct values. */
  COUNT_DISTINCT = 'COUNT_DISTINCT',
  /** Maximum value. */
  MAX = 'MAX',
  /** Minimum value. */
  MIN = 'MIN',
  /** Sum of values. */
  SUM = 'SUM',
  UNKNOWN_SCALAR_TYPE = 'UNKNOWN_SCALAR_TYPE'
}

export type WixBookingsServicesV2UpstreamWixCommonSearchDetailsInput = {
  /** Search term or expression. */
  expression?: InputMaybe<Scalars['String']>;
  /** Fields to search in. If the array is empty, all searchable fields are searched. Use dot notation to specify a JSON path. For example, `order.address.streetName`. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Whether to enable the search function to use an algorithm to automatically find results that are close to the search expression, such as typos and declensions. */
  fuzzy?: InputMaybe<Scalars['Boolean']>;
  /** Search mode. Defines the search logic for combining multiple terms in the `expression`. */
  mode?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonSearchDetailsMode>;
};

export enum WixBookingsServicesV2UpstreamWixCommonSearchDetailsMode {
  /** All search terms must be present. */
  AND = 'AND',
  /** At least 1 of the search terms must be present. */
  OR = 'OR'
}

export enum WixBookingsServicesV2UpstreamWixCommonSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type WixBookingsServicesV2UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonSortOrder>;
};

export type WixBookingsServicesV2UpstreamWixCommonStreetAddress = {
  /** Apartment number. */
  apt?: Maybe<Scalars['String']>;
  /** Street name. */
  name?: Maybe<Scalars['String']>;
  /** Street number. */
  number?: Maybe<Scalars['String']>;
};

export type WixBookingsServicesV2UpstreamWixCommonStreetAddressInput = {
  /** Apartment number. */
  apt?: InputMaybe<Scalars['String']>;
  /** Street name. */
  name?: InputMaybe<Scalars['String']>;
  /** Street number. */
  number?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2ValidateAddOnsSelectionRequestInput = {
  /** The IDs of AddOns to validate. */
  addOnIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The group ID to validate AddOns against. */
  groupId?: InputMaybe<Scalars['String']>;
  /** The service ID to validate AddOns against. */
  serviceId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2ValidateAddOnsSelectionResponse = {
  /** The validation result. */
  result?: Maybe<WixBookingsServicesV2ValidateAddOnsSelectionResponseValidationResult>;
};

export type WixBookingsServicesV2ValidateAddOnsSelectionResponseValidationResult = {
  /**
   * A validation error message.
   * This field should populated when `valid` is `false`.
   */
  message?: Maybe<Scalars['String']>;
  /** Whether the AddOns selection is valid. */
  valid?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2ValidateServiceRequestInput = {
  /** Service to validate. */
  service?: InputMaybe<WixBookingsServicesV2ServiceInput>;
};

export type WixBookingsServicesV2ValidateServiceResponse = {
  /** Field violations. */
  fieldViolations?: Maybe<Array<Maybe<WixBookingsServicesV2FieldViolation>>>;
  /** Whether the service is valid. */
  valid?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2ValidateSlugRequestInput = {
  /** IO of the service to check custom slug validity for. */
  serviceId?: InputMaybe<Scalars['String']>;
  /** Custom slug to validate. */
  slug?: InputMaybe<Scalars['String']>;
};

export type WixBookingsServicesV2ValidateSlugResponse = {
  /** Reasons why the slug is invalid. Available only if `{"valid": false}`. */
  errors?: Maybe<Array<Maybe<WixBookingsServicesV2InvalidSlugErrorEnumInvalidSlugError>>>;
  /** Valid slug. Available only if `{"valid": true}`. */
  slug?: Maybe<Scalars['String']>;
  /**
   * The requested custom slug name to validate. If valid, the slug name can
   * be set as a slug for the service and is populated with the requested
   * slug. Otherwise, `slugName` is empty.
   * @deprecated The requested custom slug name to validate. If valid, the slug name can
   * be set as a slug for the service and is populated with the requested
   * slug. Otherwise, `slugName` is empty. Replaced by: slug. Removal date: 2025-03-01.
   */
  slugName?: Maybe<Scalars['String']>;
  /** Whether the slug is valid. */
  valid?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsServicesV2VariedPayment = {
  /** The default price for the service without any variants. It will also be used as the default price for any new variant. */
  defaultPrice?: Maybe<WixBookingsServicesV2UpstreamWixCommonMoney>;
  /**
   * The deposit price required to book the service.
   *
   * Required when: `rateType` is `VARIED` and `paymentOptions.deposit` is `true`
   */
  deposit?: Maybe<WixBookingsServicesV2UpstreamWixCommonMoney>;
  /** The maximum price a customer may pay for this service, based on its variants. */
  maxPrice?: Maybe<WixBookingsServicesV2UpstreamWixCommonMoney>;
  /** The minimal price a customer may pay for this service, based on its variants. */
  minPrice?: Maybe<WixBookingsServicesV2UpstreamWixCommonMoney>;
};

export type WixBookingsServicesV2VariedPaymentInput = {
  /** The default price for the service without any variants. It will also be used as the default price for any new variant. */
  defaultPrice?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonMoneyInput>;
  /**
   * The deposit price required to book the service.
   *
   * Required when: `rateType` is `VARIED` and `paymentOptions.deposit` is `true`
   */
  deposit?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonMoneyInput>;
  /** The maximum price a customer may pay for this service, based on its variants. */
  maxPrice?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonMoneyInput>;
  /** The minimal price a customer may pay for this service, based on its variants. */
  minPrice?: InputMaybe<WixBookingsServicesV2UpstreamWixCommonMoneyInput>;
};

export type WixBookingsStaffV1AssignBusinessScheduleRequestInput = {
  /** Conditional fields to return. */
  fields?: InputMaybe<Array<InputMaybe<WixBookingsStaffV1RequestedFieldsEnumRequestedFields>>>;
  /** Id of the StaffMember to assign to. */
  staffMemberId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsStaffV1AssignBusinessScheduleResponse = {
  /** Updated StaffMember. */
  staffMember?: Maybe<WixBookingsStaffV1StaffMember>;
};

export type WixBookingsStaffV1AssignCustomScheduleRequestInput = {
  /** Conditional fields to return. */
  fields?: InputMaybe<Array<InputMaybe<WixBookingsStaffV1RequestedFieldsEnumRequestedFields>>>;
  /** Id of a schedule to assign. */
  scheduleId?: InputMaybe<Scalars['String']>;
  /** Id of the StaffMember to assign to. */
  staffMemberId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsStaffV1AssignCustomScheduleResponse = {
  /** Updated StaffMember. */
  staffMember?: Maybe<WixBookingsStaffV1StaffMember>;
};

export type WixBookingsStaffV1AssociatedConferencingProvider = {
  /** Conferencing account email. Might not match staff email. */
  accountEmail?: Maybe<Scalars['String']>;
  /** Connection status. */
  connectionStatus?: Maybe<WixBookingsStaffV1AssociatedConferencingProviderConnectionStatusStatusEnumConnectionStatus>;
  /** Conferencing provider id, e.g. Zoom integration identifier. */
  id?: Maybe<Scalars['String']>;
  /** Provider name, e.g. Zoom. */
  name?: Maybe<Scalars['String']>;
};

export enum WixBookingsStaffV1AssociatedConferencingProviderConnectionStatusStatusEnumConnectionStatus {
  /** Provider is connected to site and user is authenticated. */
  CONNECTED = 'CONNECTED',
  /** Provider is not connected to site or user is not authenticated. */
  DISCONNECTED = 'DISCONNECTED',
  UNKNOWN = 'UNKNOWN'
}

export type WixBookingsStaffV1AssociatedConferencingProviderInput = {
  /** Conferencing account email. Might not match staff email. */
  accountEmail?: InputMaybe<Scalars['String']>;
  /** Connection status. */
  connectionStatus?: InputMaybe<WixBookingsStaffV1AssociatedConferencingProviderConnectionStatusStatusEnumConnectionStatus>;
  /** Conferencing provider id, e.g. Zoom integration identifier. */
  id?: InputMaybe<Scalars['String']>;
  /** Provider name, e.g. Zoom. */
  name?: InputMaybe<Scalars['String']>;
};

export type WixBookingsStaffV1AssociatedConferencingProviders = {
  /** Conferencing accounts that are connected to this staff. */
  items?: Maybe<Array<Maybe<WixBookingsStaffV1AssociatedConferencingProvider>>>;
};

export type WixBookingsStaffV1AssociatedConferencingProvidersInput = {
  /** Conferencing accounts that are connected to this staff. */
  items?: InputMaybe<Array<InputMaybe<WixBookingsStaffV1AssociatedConferencingProviderInput>>>;
};

export type WixBookingsStaffV1AssociatedWixIdentity = {
  /** Staff members connection status to the user. */
  connectionStatus?: Maybe<WixBookingsStaffV1AssociatedWixIdentityConnectionStatusEnumConnectionStatus>;
  /** Users identification data, if the resource is associated with the user. */
  identificationData?: Maybe<WixBookingsStaffV1UpstreamWixCommonIdentificationData>;
};

export enum WixBookingsStaffV1AssociatedWixIdentityConnectionStatusEnumConnectionStatus {
  /** User is connected to the staff member. */
  CONNECTED = 'CONNECTED',
  /** User is disconnected from the staff member. */
  DISCONNECTED = 'DISCONNECTED',
  /** Pending connections invite has expired. */
  EXPIRED = 'EXPIRED',
  /** User connection is pending. */
  PENDING = 'PENDING',
  /** User connection status is unknown. Only returned when conditional field for status is not selected. */
  UNKNOWN = 'UNKNOWN'
}

export type WixBookingsStaffV1AssociatedWixIdentityInput = {
  /** Staff members connection status to the user. */
  connectionStatus?: InputMaybe<WixBookingsStaffV1AssociatedWixIdentityConnectionStatusEnumConnectionStatus>;
  /** Users identification data, if the resource is associated with the user. */
  identificationData?: InputMaybe<WixBookingsStaffV1UpstreamWixCommonIdentificationDataInput>;
};

export type WixBookingsStaffV1ConnectStaffMemberToUserRequestInput = {
  /** Email of the user to send invitation to. The staff existing email would be used if not provided. */
  email?: InputMaybe<Scalars['String']>;
  /** Conditional fields to return. */
  fields?: InputMaybe<Array<InputMaybe<WixBookingsStaffV1RequestedFieldsEnumRequestedFields>>>;
  /** Id of the StaffMember to connect to. */
  staffMemberId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsStaffV1ConnectStaffMemberToUserResponse = {
  /** Updated StaffMember. */
  staffMember?: Maybe<WixBookingsStaffV1StaffMember>;
};

export type WixBookingsStaffV1ConnectToUserRequestInput = {
  /** Email of the user to send invitation to. The staff existing email would be used if not provided. */
  email?: InputMaybe<Scalars['String']>;
  /** Conditional fields to return. */
  fields?: InputMaybe<Array<InputMaybe<WixBookingsStaffV1RequestedFieldsEnumRequestedFields>>>;
  /** Id of the StaffMember to connect to. */
  staffMemberId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsStaffV1ConnectToUserResponse = {
  /** Updated StaffMember. */
  staffMember?: Maybe<WixBookingsStaffV1StaffMember>;
};

export type WixBookingsStaffV1CountStaffMembersRequestInput = {
  /** Filter to apply on staff members to count */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type WixBookingsStaffV1CountStaffMembersResponse = {
  /** The number of staff members matching the given filter. */
  count?: Maybe<Scalars['Int']>;
};

export type WixBookingsStaffV1CreateStaffMemberRequestInput = {
  /** Conditional fields to return. */
  fields?: InputMaybe<Array<InputMaybe<WixBookingsStaffV1RequestedFieldsEnumRequestedFields>>>;
  /** StaffMember to be created. */
  staffMember?: InputMaybe<WixBookingsStaffV1StaffMemberInput>;
};

export type WixBookingsStaffV1CreateStaffMemberResponse = {
  /** The created StaffMember. */
  staffMember?: Maybe<WixBookingsStaffV1StaffMember>;
};

export type WixBookingsStaffV1DeleteStaffMemberRequestInput = {
  /** Id of the StaffMember to delete. */
  staffMemberId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsStaffV1DisconnectStaffMemberFromUserRequestInput = {
  /** Conditional fields to return. */
  fields?: InputMaybe<Array<InputMaybe<WixBookingsStaffV1RequestedFieldsEnumRequestedFields>>>;
  /** Id of the StaffMember to disconnect. */
  staffMemberId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsStaffV1DisconnectStaffMemberFromUserResponse = {
  /** Updated StaffMember. */
  staffMember?: Maybe<WixBookingsStaffV1StaffMember>;
};

export type WixBookingsStaffV1DisconnectUserRequestInput = {
  /** Conditional fields to return. */
  fields?: InputMaybe<Array<InputMaybe<WixBookingsStaffV1RequestedFieldsEnumRequestedFields>>>;
  /** Id of the StaffMember to disconnect. */
  staffMemberId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsStaffV1DisconnectUserResponse = {
  /** Updated StaffMember. */
  staffMember?: Maybe<WixBookingsStaffV1StaffMember>;
};

export type WixBookingsStaffV1EventSchedule = {
  /** The related schedule ID */
  id?: Maybe<Scalars['String']>;
  /** The related schedule ID */
  schedule?: Maybe<WixCalendarSchedulesV3Schedule>;
};

export type WixBookingsStaffV1EventScheduleInput = {
  /** The related schedule ID */
  id?: InputMaybe<Scalars['String']>;
};

export type WixBookingsStaffV1GetStaffMemberRequestInput = {
  /** Conditional fields to return. */
  fields?: InputMaybe<Array<InputMaybe<WixBookingsStaffV1RequestedFieldsEnumRequestedFields>>>;
  id: Scalars['ID'];
};

export type WixBookingsStaffV1ImportStaffMemberRequestInput = {
  /** Conditional fields to return. */
  fields?: InputMaybe<Array<InputMaybe<WixBookingsStaffV1RequestedFieldsEnumRequestedFields>>>;
  /** StaffMember to be created. */
  staffMember?: InputMaybe<WixBookingsStaffV1StaffMemberInput>;
};

export type WixBookingsStaffV1ImportStaffMemberResponse = {
  /** The imported StaffMember. */
  staffMember?: Maybe<WixBookingsStaffV1StaffMember>;
};

export type WixBookingsStaffV1MediaItem = {
  /** Staff members cover image. */
  image?: Maybe<WixBookingsStaffV1UpstreamWixCommonImage>;
};

export type WixBookingsStaffV1MediaItemInput = {
  /** Staff members cover image. */
  image?: InputMaybe<WixBookingsStaffV1UpstreamWixCommonImageInput>;
};

export type WixBookingsStaffV1QueryStaffMembersRequestInput = {
  /** Conditional fields to return. */
  fields?: InputMaybe<Array<InputMaybe<WixBookingsStaffV1RequestedFieldsEnumRequestedFields>>>;
  /** WQL expression. */
  query?: InputMaybe<WixBookingsStaffV1UpstreamWixCommonCursorQueryInput>;
};

export type WixBookingsStaffV1QueryStaffMembersResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<WixBookingsStaffV1StaffMember>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export enum WixBookingsStaffV1RequestedFieldsEnumRequestedFields {
  /** Fields inside `associatedConferencingProviders` */
  ASSOCIATED_CONFERENCING_PROVIDERS = 'ASSOCIATED_CONFERENCING_PROVIDERS',
  /** `associatedWixIdentity.connectionStatus` */
  ASSOCIATED_IDENTITY_STATUS = 'ASSOCIATED_IDENTITY_STATUS',
  /** Fields inside `resource` */
  RESOURCE_DETAILS = 'RESOURCE_DETAILS',
  UNKNOWN_REQUESTED_FIELD = 'UNKNOWN_REQUESTED_FIELD'
}

export type WixBookingsStaffV1Resource = {
  /** this schedule contains the sessions in which this resource is booked. */
  eventsSchedule?: Maybe<WixBookingsStaffV1EventSchedule>;
  /** The related calendar resource id, same as `resourceId`. */
  id?: Maybe<Scalars['String']>;
  /** True if any `resource.workingHoursSchedules.shared` is true */
  usesDefaultWorkingHours?: Maybe<Scalars['Boolean']>;
  /** this schedule contains the sessions in which this resource is available for booking. */
  workingHoursSchedules?: Maybe<Array<Maybe<WixBookingsStaffV1WorkingHoursSchedule>>>;
};

export type WixBookingsStaffV1ResourceInput = {
  /** this schedule contains the sessions in which this resource is booked. */
  eventsSchedule?: InputMaybe<WixBookingsStaffV1EventScheduleInput>;
  /** The related calendar resource id, same as `resourceId`. */
  id?: InputMaybe<Scalars['String']>;
  /** True if any `resource.workingHoursSchedules.shared` is true */
  usesDefaultWorkingHours?: InputMaybe<Scalars['Boolean']>;
  /** this schedule contains the sessions in which this resource is available for booking. */
  workingHoursSchedules?: InputMaybe<Array<InputMaybe<WixBookingsStaffV1WorkingHoursScheduleInput>>>;
};

export type WixBookingsStaffV1RestoreStaffRequestInput = {
  /** Conditional fields to return. */
  fields?: InputMaybe<Array<InputMaybe<WixBookingsStaffV1RequestedFieldsEnumRequestedFields>>>;
  /** Id of the StaffMember to restore. */
  staffMemberId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsStaffV1RestoreStaffResponse = {
  /** Restored staff member. */
  staffMember?: Maybe<WixBookingsStaffV1StaffMember>;
};

export type WixBookingsStaffV1StaffMember = {
  /** A staff member conferencing providers */
  associatedConferencingProviders?: Maybe<WixBookingsStaffV1AssociatedConferencingProviders>;
  /**
   * Wix user details, if the resource is associated with the Wix user.
   * A staff member resource can be associated with a Wix user via assignment of a permissions role in the business manager.
   */
  associatedWixIdentity?: Maybe<WixBookingsStaffV1AssociatedWixIdentity>;
  /** Represents the time this StaffMember was created */
  createdDate?: Maybe<Scalars['String']>;
  /** `true` - if staff was auto created default staff */
  default?: Maybe<Scalars['Boolean']>;
  /** Description, For example: "The best masseuse in all of the land" */
  description?: Maybe<Scalars['String']>;
  /** Staff member's email address. */
  email?: Maybe<Scalars['String']>;
  /** Extensions enabling users to save custom data related to the staff members. */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** StaffMember ID */
  id?: Maybe<Scalars['String']>;
  /** Main media of the staff */
  mainMedia?: Maybe<WixBookingsStaffV1MediaItem>;
  /** Staff member's name. */
  name?: Maybe<Scalars['String']>;
  /** Staff member's phone number. */
  phone?: Maybe<Scalars['String']>;
  /** The related calendar resource */
  resource?: Maybe<WixBookingsStaffV1Resource>;
  /** The related calendar resource id, same as `resource.id` */
  resourceId?: Maybe<Scalars['String']>;
  /** Represents the current state of an item. Each time the item is modified, its `revision` changes by the server. for an update operation to succeed, you MUST pass the latest revision */
  revision?: Maybe<Scalars['Int']>;
  /** Represents the time this StaffMember was last updated */
  updatedDate?: Maybe<Scalars['String']>;
};

export type WixBookingsStaffV1StaffMemberInput = {
  /** A staff member conferencing providers */
  associatedConferencingProviders?: InputMaybe<WixBookingsStaffV1AssociatedConferencingProvidersInput>;
  /**
   * Wix user details, if the resource is associated with the Wix user.
   * A staff member resource can be associated with a Wix user via assignment of a permissions role in the business manager.
   */
  associatedWixIdentity?: InputMaybe<WixBookingsStaffV1AssociatedWixIdentityInput>;
  /** Represents the time this StaffMember was created */
  createdDate?: InputMaybe<Scalars['String']>;
  /** `true` - if staff was auto created default staff */
  default?: InputMaybe<Scalars['Boolean']>;
  /** Description, For example: "The best masseuse in all of the land" */
  description?: InputMaybe<Scalars['String']>;
  /** Staff member's email address. */
  email?: InputMaybe<Scalars['String']>;
  /** Extensions enabling users to save custom data related to the staff members. */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** StaffMember ID */
  id?: InputMaybe<Scalars['String']>;
  /** Main media of the staff */
  mainMedia?: InputMaybe<WixBookingsStaffV1MediaItemInput>;
  /** Staff member's name. */
  name?: InputMaybe<Scalars['String']>;
  /** Staff member's phone number. */
  phone?: InputMaybe<Scalars['String']>;
  /** The related calendar resource */
  resource?: InputMaybe<WixBookingsStaffV1ResourceInput>;
  /** The related calendar resource id, same as `resource.id` */
  resourceId?: InputMaybe<Scalars['String']>;
  /** Represents the current state of an item. Each time the item is modified, its `revision` changes by the server. for an update operation to succeed, you MUST pass the latest revision */
  revision?: InputMaybe<Scalars['Int']>;
  /** Represents the time this StaffMember was last updated */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export type WixBookingsStaffV1UpdateStaffMemberRequestInput = {
  /**
   * Set of fields to update.
   *
   * Fields that aren't included in `fieldMask.paths` are ignored.
   */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Conditional fields to return. */
  fields?: InputMaybe<Array<InputMaybe<WixBookingsStaffV1RequestedFieldsEnumRequestedFields>>>;
  /** StaffMember to be updated, may be partial. */
  staffMember?: InputMaybe<WixBookingsStaffV1StaffMemberInput>;
};

export type WixBookingsStaffV1UpdateStaffMemberResponse = {
  /** Updated StaffMember. */
  staffMember?: Maybe<WixBookingsStaffV1StaffMember>;
};

export type WixBookingsStaffV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsStaffV1UpstreamWixCommonCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixBookingsStaffV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixBookingsStaffV1UpstreamWixCommonSortingInput>>>;
};

export type WixBookingsStaffV1UpstreamWixCommonIdentificationData = {
  /** ID of a site visitor that has not logged in to the site. */
  anonymousVisitorId?: Maybe<Scalars['String']>;
  /** ID of an app. */
  appId?: Maybe<Scalars['String']>;
  /** ID of of a contact in the site's [CRM by Ascend](https://www.wix.com/ascend/crm) system. */
  contact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
  /** ID of of a contact in the site's [CRM by Ascend](https://www.wix.com/ascend/crm) system. */
  contactId?: Maybe<Scalars['String']>;
  identityType?: Maybe<WixBookingsStaffV1UpstreamWixCommonIdentificationDataIdentityType>;
  /** ID of a site visitor that has logged in to the site. */
  member?: Maybe<ComWixpressMembersApiMember>;
  /** ID of a site visitor that has logged in to the site. */
  memberId?: Maybe<Scalars['String']>;
  /** ID of a Wix user (site owner, contributor, etc.). */
  wixUserId?: Maybe<Scalars['String']>;
};

export enum WixBookingsStaffV1UpstreamWixCommonIdentificationDataIdentityType {
  ANONYMOUS_VISITOR = 'ANONYMOUS_VISITOR',
  APP = 'APP',
  MEMBER = 'MEMBER',
  UNKNOWN = 'UNKNOWN',
  WIX_USER = 'WIX_USER'
}

export type WixBookingsStaffV1UpstreamWixCommonIdentificationDataInput = {
  /** ID of a site visitor that has not logged in to the site. */
  anonymousVisitorId?: InputMaybe<Scalars['String']>;
  /** ID of an app. */
  appId?: InputMaybe<Scalars['String']>;
  /** ID of of a contact in the site's [CRM by Ascend](https://www.wix.com/ascend/crm) system. */
  contactId?: InputMaybe<Scalars['String']>;
  identityType?: InputMaybe<WixBookingsStaffV1UpstreamWixCommonIdentificationDataIdentityType>;
  /** ID of a site visitor that has logged in to the site. */
  memberId?: InputMaybe<Scalars['String']>;
  /** ID of a Wix user (site owner, contributor, etc.). */
  wixUserId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsStaffV1UpstreamWixCommonImage = {
  /** Image alt text. */
  altText?: Maybe<Scalars['String']>;
  /** Image filename. */
  filename?: Maybe<Scalars['String']>;
  /** Original image height. */
  height?: Maybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: Maybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: Maybe<Scalars['String']>;
  /** Image URL. */
  url?: Maybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: Maybe<Scalars['String']>;
  /** Original image width. */
  width?: Maybe<Scalars['Int']>;
};

export type WixBookingsStaffV1UpstreamWixCommonImageInput = {
  /** Image alt text. */
  altText?: InputMaybe<Scalars['String']>;
  /** Image filename. */
  filename?: InputMaybe<Scalars['String']>;
  /** Original image height. */
  height?: InputMaybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: InputMaybe<Scalars['String']>;
  /** Image URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: InputMaybe<Scalars['String']>;
  /** Original image width. */
  width?: InputMaybe<Scalars['Int']>;
};

export enum WixBookingsStaffV1UpstreamWixCommonSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type WixBookingsStaffV1UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixBookingsStaffV1UpstreamWixCommonSortOrder>;
};

export type WixBookingsStaffV1WorkingHoursSchedule = {
  /** The related schedule ID */
  id?: Maybe<Scalars['String']>;
  /** The related schedule ID */
  schedule?: Maybe<WixCalendarSchedulesV3Schedule>;
  /** `true` if it is a shared schedule (e.g. from a business or location), `false` or empty if this is a custom schedule specific to the resource. */
  shared?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsStaffV1WorkingHoursScheduleInput = {
  /** The related schedule ID */
  id?: InputMaybe<Scalars['String']>;
  /** `true` if it is a shared schedule (e.g. from a business or location), `false` or empty if this is a custom schedule specific to the resource. */
  shared?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsV1BookAfterStartPolicy = {
  /**
   * Whether customers can book after the session has started. `true` means
   * customers can book after the session has started. For courses, this refers to
   * the start of the last course session. If specified as `true`,
   * `limitLateBookingPolicy.enabled` must be `false`.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsV1BookAfterStartPolicyInput = {
  /**
   * Whether customers can book after the session has started. `true` means
   * customers can book after the session has started. For courses, this refers to
   * the start of the last course session. If specified as `true`,
   * `limitLateBookingPolicy.enabled` must be `false`.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsV1BookingPolicy = {
  /**
   * ID of the app in dev-center that created the policy.
   * If the createByAppId is not specified, the policy will be associated with the appId, and if the appId is not specified, it will be associated to [Wix Bookings app](https://dev.wix.com/docs/rest/articles/getting-started/wix-business-solutions) by default.
   */
  app?: Maybe<WixDevcenterAppsV1App>;
  /**
   * ID of the app that's associated with the service. You can't update `appId`.
   * If you don't specify an app ID, the service is associated with the
   * [Wix Bookings app](https://dev.wix.com/docs/rest/articles/getting-started/wix-business-solutions)
   * by default.
   */
  appId?: Maybe<Scalars['String']>;
  /**
   * Rule for booking after the start of a session or course. This rule and
   * `limitLateBookingPolicy` can't be both enabled at the same time.
   */
  bookAfterStartPolicy?: Maybe<WixBookingsV1BookAfterStartPolicy>;
  /** Rules for cancellation fees. */
  cancellationFeePolicy?: Maybe<WixBookingsV1CancellationFeePolicy>;
  /** Rule for canceling a booking. */
  cancellationPolicy?: Maybe<WixBookingsV1CancellationPolicy>;
  /**
   * ID of the app in dev-center that created the policy.
   * If the createByAppId is not specified, the policy will be associated with the appId, and if the appId is not specified, it will be associated to [Wix Bookings app](https://dev.wix.com/docs/rest/articles/getting-started/wix-business-solutions) by default.
   */
  createdByAppId?: Maybe<Scalars['String']>;
  /** Date and time the booking policy was created in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  createdDate?: Maybe<Scalars['String']>;
  /**
   * Custom description for the booking policy and whether it's displayed to the
   * participant.
   */
  customPolicyDescription?: Maybe<WixBookingsV1PolicyDescription>;
  /** Whether the booking policy is the default. */
  default?: Maybe<Scalars['Boolean']>;
  /** Extensions enabling users to save custom data related to the booking policies. */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** ID of the booking policy. */
  id?: Maybe<Scalars['String']>;
  /** Rules for Intake form integration */
  intakeFormPolicy?: Maybe<WixBookingsV1IntakeFormPolicy>;
  /** Rule for limiting early bookings. */
  limitEarlyBookingPolicy?: Maybe<WixBookingsV1LimitEarlyBookingPolicy>;
  /**
   * Rule for limiting late bookings. This rule and `bookAfterStartPolicy` can't
   * be both enabled at the same time.
   */
  limitLateBookingPolicy?: Maybe<WixBookingsV1LimitLateBookingPolicy>;
  /** Name of the booking policy. */
  name?: Maybe<Scalars['String']>;
  /** Rule for participants per booking. */
  participantsPolicy?: Maybe<WixBookingsV1ParticipantsPolicy>;
  /** Rule for rescheduling a booking. */
  reschedulePolicy?: Maybe<WixBookingsV1ReschedulePolicy>;
  /** Rule for allocating resources. */
  resourcesPolicy?: Maybe<WixBookingsV1ResourcesPolicy>;
  /**
   * Revision number, which increments by 1 each time the booking policy is updated.
   * To prevent conflicting changes, the current `revision` must be passed when
   * updating the booking policy.
   */
  revision?: Maybe<Scalars['Long']>;
  /** Rule for saving credit card details. */
  saveCreditCardPolicy?: Maybe<WixBookingsV1SaveCreditCardPolicy>;
  /**
   * Rules for sorting staff.
   * The sorting will affect which staff is chosen during the book flow, if needed.
   */
  staffSortingPolicy?: Maybe<WixBookingsV1StaffSortingPolicy>;
  /** Date and time the booking policy was updated in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  updatedDate?: Maybe<Scalars['String']>;
  /** Waitlist rule for the service. */
  waitlistPolicy?: Maybe<WixBookingsV1WaitlistPolicy>;
};

export type WixBookingsV1BookingPolicyInput = {
  /**
   * ID of the app that's associated with the service. You can't update `appId`.
   * If you don't specify an app ID, the service is associated with the
   * [Wix Bookings app](https://dev.wix.com/docs/rest/articles/getting-started/wix-business-solutions)
   * by default.
   */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Rule for booking after the start of a session or course. This rule and
   * `limitLateBookingPolicy` can't be both enabled at the same time.
   */
  bookAfterStartPolicy?: InputMaybe<WixBookingsV1BookAfterStartPolicyInput>;
  /** Rules for cancellation fees. */
  cancellationFeePolicy?: InputMaybe<WixBookingsV1CancellationFeePolicyInput>;
  /** Rule for canceling a booking. */
  cancellationPolicy?: InputMaybe<WixBookingsV1CancellationPolicyInput>;
  /**
   * ID of the app in dev-center that created the policy.
   * If the createByAppId is not specified, the policy will be associated with the appId, and if the appId is not specified, it will be associated to [Wix Bookings app](https://dev.wix.com/docs/rest/articles/getting-started/wix-business-solutions) by default.
   */
  createdByAppId?: InputMaybe<Scalars['String']>;
  /** Date and time the booking policy was created in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  createdDate?: InputMaybe<Scalars['String']>;
  /**
   * Custom description for the booking policy and whether it's displayed to the
   * participant.
   */
  customPolicyDescription?: InputMaybe<WixBookingsV1PolicyDescriptionInput>;
  /** Whether the booking policy is the default. */
  default?: InputMaybe<Scalars['Boolean']>;
  /** Extensions enabling users to save custom data related to the booking policies. */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** ID of the booking policy. */
  id?: InputMaybe<Scalars['String']>;
  /** Rules for Intake form integration */
  intakeFormPolicy?: InputMaybe<WixBookingsV1IntakeFormPolicyInput>;
  /** Rule for limiting early bookings. */
  limitEarlyBookingPolicy?: InputMaybe<WixBookingsV1LimitEarlyBookingPolicyInput>;
  /**
   * Rule for limiting late bookings. This rule and `bookAfterStartPolicy` can't
   * be both enabled at the same time.
   */
  limitLateBookingPolicy?: InputMaybe<WixBookingsV1LimitLateBookingPolicyInput>;
  /** Name of the booking policy. */
  name?: InputMaybe<Scalars['String']>;
  /** Rule for participants per booking. */
  participantsPolicy?: InputMaybe<WixBookingsV1ParticipantsPolicyInput>;
  /** Rule for rescheduling a booking. */
  reschedulePolicy?: InputMaybe<WixBookingsV1ReschedulePolicyInput>;
  /** Rule for allocating resources. */
  resourcesPolicy?: InputMaybe<WixBookingsV1ResourcesPolicyInput>;
  /**
   * Revision number, which increments by 1 each time the booking policy is updated.
   * To prevent conflicting changes, the current `revision` must be passed when
   * updating the booking policy.
   */
  revision?: InputMaybe<Scalars['Long']>;
  /** Rule for saving credit card details. */
  saveCreditCardPolicy?: InputMaybe<WixBookingsV1SaveCreditCardPolicyInput>;
  /**
   * Rules for sorting staff.
   * The sorting will affect which staff is chosen during the book flow, if needed.
   */
  staffSortingPolicy?: InputMaybe<WixBookingsV1StaffSortingPolicyInput>;
  /** Date and time the booking policy was updated in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** Waitlist rule for the service. */
  waitlistPolicy?: InputMaybe<WixBookingsV1WaitlistPolicyInput>;
};

export type WixBookingsV1CancellationFeePolicy = {
  /**
   * Whether Wix automatically charges the cancellation fee from the customer once
   * they cancel their booking.
   *
   * Default: `true`
   */
  autoCollectFeeEnabled?: Maybe<Scalars['Boolean']>;
  /**
   * Time windows relative to the session start during which customers can cancel
   * their booking. Each window includes details about the fee for canceling within it.
   */
  cancellationWindows?: Maybe<Array<Maybe<WixBookingsV1CancellationFeePolicyCancellationWindow>>>;
  /**
   * Whether customers must pay a cancellation fee when canceling a booking.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsV1CancellationFeePolicyCancellationWindow = {
  /** Fixed amount customers must pay when canceling the booking within this window. */
  amount?: Maybe<WixBookingsV1UpstreamWixCommonMoney>;
  /**
   * Percentage of the booking price customers must pay when canceling within
   * this window.
   *
   * Min: `0.01` percent
   * Max: `100` percent
   */
  percentage?: Maybe<Scalars['String']>;
  /**
   * Start of the cancellation window in minutes before the session start. For
   * courses, this refers to the start of the first course session.
   */
  startInMinutes?: Maybe<Scalars['Int']>;
};

export type WixBookingsV1CancellationFeePolicyCancellationWindowInput = {
  /** Fixed amount customers must pay when canceling the booking within this window. */
  amount?: InputMaybe<WixBookingsV1UpstreamWixCommonMoneyInput>;
  /**
   * Percentage of the booking price customers must pay when canceling within
   * this window.
   *
   * Min: `0.01` percent
   * Max: `100` percent
   */
  percentage?: InputMaybe<Scalars['String']>;
  /**
   * Start of the cancellation window in minutes before the session start. For
   * courses, this refers to the start of the first course session.
   */
  startInMinutes?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsV1CancellationFeePolicyInput = {
  /**
   * Whether Wix automatically charges the cancellation fee from the customer once
   * they cancel their booking.
   *
   * Default: `true`
   */
  autoCollectFeeEnabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * Time windows relative to the session start during which customers can cancel
   * their booking. Each window includes details about the fee for canceling within it.
   */
  cancellationWindows?: InputMaybe<Array<InputMaybe<WixBookingsV1CancellationFeePolicyCancellationWindowInput>>>;
  /**
   * Whether customers must pay a cancellation fee when canceling a booking.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsV1CancellationPolicy = {
  /**
   * Whether customers can cancel the booking. `true` means customers can cancel
   * the booking.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
  /**
   * Minimum number of minutes before the start of the session customers can cancel.
   * For courses, this refers to the start of the first course session.
   *
   * Default: `1440` minutes (1 day)
   * Min: `1` minute
   */
  latestCancellationInMinutes?: Maybe<Scalars['Int']>;
  /**
   * Whether there's a limit on the latest cancellation time. `false` means customers
   * can cancel the booking until the last minute before the course or session starts.
   *
   * Default: `false`
   */
  limitLatestCancellation?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsV1CancellationPolicyInput = {
  /**
   * Whether customers can cancel the booking. `true` means customers can cancel
   * the booking.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * Minimum number of minutes before the start of the session customers can cancel.
   * For courses, this refers to the start of the first course session.
   *
   * Default: `1440` minutes (1 day)
   * Min: `1` minute
   */
  latestCancellationInMinutes?: InputMaybe<Scalars['Int']>;
  /**
   * Whether there's a limit on the latest cancellation time. `false` means customers
   * can cancel the booking until the last minute before the course or session starts.
   *
   * Default: `false`
   */
  limitLatestCancellation?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsV1CountBookingPoliciesRequestInput = {
  /**
   * Filter to base the count on. See
   * [supported filters](https://dev.wix.com/docs/rest/business-solutions/bookings/policies/booking-policies/supported-filters)
   * for details.
   */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type WixBookingsV1CountBookingPoliciesResponse = {
  /** Number of booking policies matching the provided filter. */
  count?: Maybe<Scalars['Int']>;
};

export type WixBookingsV1CreateBookingPolicyRequestInput = {
  /** Booking policy to create. */
  bookingPolicy?: InputMaybe<WixBookingsV1BookingPolicyInput>;
};

export type WixBookingsV1CreateBookingPolicyResponse = {
  /** Created booking policy. */
  bookingPolicy?: Maybe<WixBookingsV1BookingPolicy>;
};

export type WixBookingsV1CreateMissingDefaultPolicyResponse = {
  /** The default booking policy. */
  defaultBookingPolicy?: Maybe<WixBookingsV1BookingPolicy>;
  /** Whether a new default policy was created. */
  wasANewPolicyCreated?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsV1DeleteBookingPolicyRequestInput = {
  /** ID of the booking policy to delete. */
  bookingPolicyId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsV1GetBookingPolicyRequestInput = {
  /**
   * Bypass the extended field permission validations when getting the policy.
   * When set to `true`, the extended fields from all namespaces will be returned.
   */
  bypassExtendedFieldPermissionsValidations?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};

export type WixBookingsV1GetStrictestBookingPolicyRequestInput = {
  /** IDs of the booking policies for which to retrieve the strictest rules for. */
  bookingPolicyIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixBookingsV1GetStrictestBookingPolicyResponse = {
  /**
   * Hypothetical `bookingPolicy` object that combines the strictest version of
   * each rule. `bookingPolicy.id` is `null` and the returned object isn't actually
   * created. To create a new policy, you can call [Create Booking Policy](https://dev.wix.com/docs/api-reference/business-solutions/bookings/policies/booking-policies/create-booking-policy).
   */
  bookingPolicy?: Maybe<WixBookingsV1BookingPolicy>;
};

export type WixBookingsV1IntakeFormPolicy = {
  completionRequirement?: Maybe<WixBookingsV1IntakeFormPolicyCompletionRequirement>;
  /**
   * Whether intake form integration is enabled for the service.
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
  /** ID of the intake form to integrate with the service. */
  form?: Maybe<WixFormsV4Form>;
  /** ID of the intake form to integrate with the service. */
  formId?: Maybe<Scalars['String']>;
  /** When to present the intake form to the customer. */
  timing?: Maybe<WixBookingsV1IntakeFormPolicyTiming>;
};

export enum WixBookingsV1IntakeFormPolicyCompletionRequirement {
  /** Form completion is optional and can be skipped entirely. */
  OPTIONAL = 'OPTIONAL',
  /**
   * Form must be completed before the booking can be finalized.
   * can used only if timing is BEFORE_BOOKING.
   */
  REQUIRED_BEFORE_BOOKING = 'REQUIRED_BEFORE_BOOKING',
  UNKNOWN_COMPLETION_REQUIREMENT = 'UNKNOWN_COMPLETION_REQUIREMENT'
}

export type WixBookingsV1IntakeFormPolicyInput = {
  completionRequirement?: InputMaybe<WixBookingsV1IntakeFormPolicyCompletionRequirement>;
  /**
   * Whether intake form integration is enabled for the service.
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** ID of the intake form to integrate with the service. */
  formId?: InputMaybe<Scalars['String']>;
  /** When to present the intake form to the customer. */
  timing?: InputMaybe<WixBookingsV1IntakeFormPolicyTiming>;
};

export enum WixBookingsV1IntakeFormPolicyTiming {
  /** Send form after booking. */
  AFTER_BOOKING = 'AFTER_BOOKING',
  /** Show form during booking flow. */
  BEFORE_BOOKING = 'BEFORE_BOOKING',
  UNKNOWN_TIMING = 'UNKNOWN_TIMING'
}

export type WixBookingsV1LimitEarlyBookingPolicy = {
  /**
   * Maximum number of minutes before the start of a session or course customers can book.
   * Must be greater than `limitLateBookingPolicy.latestBookingInMinutes`.
   *
   * Default: `10080` minutes (7 days)
   * Min: `1` minute
   */
  earliestBookingInMinutes?: Maybe<Scalars['Int']>;
  /**
   * Whether there's a limit about how early a customer can book. `false` means there's
   * no limit to the earliest supported booking time.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsV1LimitEarlyBookingPolicyInput = {
  /**
   * Maximum number of minutes before the start of a session or course customers can book.
   * Must be greater than `limitLateBookingPolicy.latestBookingInMinutes`.
   *
   * Default: `10080` minutes (7 days)
   * Min: `1` minute
   */
  earliestBookingInMinutes?: InputMaybe<Scalars['Int']>;
  /**
   * Whether there's a limit about how early a customer can book. `false` means there's
   * no limit to the earliest supported booking time.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsV1LimitLateBookingPolicy = {
  /**
   * Whether there's a limit about how late customers can book. `false` means
   * customers can book up to the last minute. If specified as `true`,
   * `bookAfterStartPolicy.enabled` must be `false`.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
  /**
   * Minimum number of minutes before the start of the session customers can book.
   * For courses, this is relative to the start time of the next session and doesn't
   * consider course sessions in the past. This value must be less than
   * `limitEarlyBookingPolicy.earliestBookingInMinutes`.
   *
   * Default: `1440` minutes (1 day)
   * Min: `1` minute
   */
  latestBookingInMinutes?: Maybe<Scalars['Int']>;
};

export type WixBookingsV1LimitLateBookingPolicyInput = {
  /**
   * Whether there's a limit about how late customers can book. `false` means
   * customers can book up to the last minute. If specified as `true`,
   * `bookAfterStartPolicy.enabled` must be `false`.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * Minimum number of minutes before the start of the session customers can book.
   * For courses, this is relative to the start time of the next session and doesn't
   * consider course sessions in the past. This value must be less than
   * `limitEarlyBookingPolicy.earliestBookingInMinutes`.
   *
   * Default: `1440` minutes (1 day)
   * Min: `1` minute
   */
  latestBookingInMinutes?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsV1ParticipantsPolicy = {
  /**
   * Whether there's a maximum number of participants per booking. `false` means
   * there is no maximum.
   *
   * Default: `false`
   * Private because not limiting participants per booking is not supported by Bookings flows today
   */
  enabled?: Maybe<Scalars['Boolean']>;
  /**
   * Maximum number of participants per booking.
   *
   * Default: `1` participant
   * Min: `1` participant
   */
  maxParticipantsPerBooking?: Maybe<Scalars['Int']>;
};

export type WixBookingsV1ParticipantsPolicyInput = {
  /**
   * Whether there's a maximum number of participants per booking. `false` means
   * there is no maximum.
   *
   * Default: `false`
   * Private because not limiting participants per booking is not supported by Bookings flows today
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * Maximum number of participants per booking.
   *
   * Default: `1` participant
   * Min: `1` participant
   */
  maxParticipantsPerBooking?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsV1PolicyDescription = {
  /**
   * Description of the booking policy.
   *
   * Default: Empty
   * Max length: 2500 characters
   */
  description?: Maybe<Scalars['String']>;
  /**
   * Whether the description is displayed to the participant. `true` means the
   * description is displayed.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsV1PolicyDescriptionInput = {
  /**
   * Description of the booking policy.
   *
   * Default: Empty
   * Max length: 2500 characters
   */
  description?: InputMaybe<Scalars['String']>;
  /**
   * Whether the description is displayed to the participant. `true` means the
   * description is displayed.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsV1QueryBookingPoliciesRequestInput = {
  /**
   * The query by which to select booking policies. See
   * [the supported filters article](https://dev.wix.com/docs/rest/business-solutions/bookings/services/booking-policy/supported-filters)
   * for details.
   */
  query?: InputMaybe<WixBookingsV1UpstreamWixCommonCursorQueryInput>;
};

export type WixBookingsV1QueryBookingPoliciesResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<WixBookingsV1BookingPolicy>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixBookingsV1ReschedulePolicy = {
  /**
   * Whether customers can reschedule a booking for an appointment-based service.
   * `true` means customers can reschedule.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
  /**
   * Minimum number of minutes before the session start session customers can
   * reschedule their booking.
   *
   * Default: `1440` minutes (1 day)
   * Min: `1` minute
   */
  latestRescheduleInMinutes?: Maybe<Scalars['Int']>;
  /**
   * Whether there's a limit on the latest supported rescheduling time. `false`
   * means customers can reschedule until the last minute before the session start.
   *
   * Default: `false`
   */
  limitLatestReschedule?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsV1ReschedulePolicyInput = {
  /**
   * Whether customers can reschedule a booking for an appointment-based service.
   * `true` means customers can reschedule.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * Minimum number of minutes before the session start session customers can
   * reschedule their booking.
   *
   * Default: `1440` minutes (1 day)
   * Min: `1` minute
   */
  latestRescheduleInMinutes?: InputMaybe<Scalars['Int']>;
  /**
   * Whether there's a limit on the latest supported rescheduling time. `false`
   * means customers can reschedule until the last minute before the session start.
   *
   * Default: `false`
   */
  limitLatestReschedule?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsV1ResourcesPolicy = {
  /**
   * Whether Wix Bookings automatically assigns a resource, for example a [staff member](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members/introduction),
   * to the booking. `false` means the customer must select the resource
   * themselves and Wix Bookings doesn't assign it automatically.
   *
   * Default: `false`
   */
  autoAssignAllowed?: Maybe<Scalars['Boolean']>;
  /**
   * Whether the customer must select a resource, for example a staff member, when
   * booking. `false` means the customer can book without selecting a resource.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsV1ResourcesPolicyInput = {
  /**
   * Whether Wix Bookings automatically assigns a resource, for example a [staff member](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members/introduction),
   * to the booking. `false` means the customer must select the resource
   * themselves and Wix Bookings doesn't assign it automatically.
   *
   * Default: `false`
   */
  autoAssignAllowed?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether the customer must select a resource, for example a staff member, when
   * booking. `false` means the customer can book without selecting a resource.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsV1SaveCreditCardPolicy = {
  /**
   * Whether Wix stores credit card details of the customer. Storing the details
   * allows Wix to prefill the [eCommerce checkout](https://dev.wix.com/docs/api-reference/business-solutions/e-commerce/checkout/introduction)
   * and thus increases the likelihood that the customer completes the booking
   * process.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
};

export type WixBookingsV1SaveCreditCardPolicyInput = {
  /**
   * Whether Wix stores credit card details of the customer. Storing the details
   * allows Wix to prefill the [eCommerce checkout](https://dev.wix.com/docs/api-reference/business-solutions/e-commerce/checkout/introduction)
   * and thus increases the likelihood that the customer completes the booking
   * process.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type WixBookingsV1SetDefaultBookingPolicyRequestInput = {
  /** ID of the booking policy that's set as default. */
  bookingPolicyId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsV1SetDefaultBookingPolicyResponse = {
  /** New default booking policy. */
  currentDefaultBookingPolicy?: Maybe<WixBookingsV1BookingPolicy>;
  /**
   * Previous default booking policy. Not available if the provided booking policy
   * was already the default.
   */
  previousDefaultBookingPolicy?: Maybe<WixBookingsV1BookingPolicy>;
};

export type WixBookingsV1StaffSortingPolicy = {
  customOptions?: Maybe<WixBookingsV1StaffSortingPolicyCustomOptions>;
  rankingOptions?: Maybe<WixBookingsV1StaffSortingPolicyRankingOptions>;
  /**
   * Method used for sorting and selecting staff members.
   *
   * Default: `RANDOM`
   */
  sortingMethodType?: Maybe<WixBookingsV1StaffSortingPolicySortingMethodType>;
};

export type WixBookingsV1StaffSortingPolicyCustomOptions = {
  /** ID of the app that provides the custom sorting method. */
  appId?: Maybe<Scalars['String']>;
  /**
   * ID of the custom sorting method implemented in SortStaffSPI.
   * This identifies which custom sorting algorithm to use.
   */
  implementationId?: Maybe<Scalars['String']>;
};

export type WixBookingsV1StaffSortingPolicyCustomOptionsInput = {
  /** ID of the app that provides the custom sorting method. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * ID of the custom sorting method implemented in SortStaffSPI.
   * This identifies which custom sorting algorithm to use.
   */
  implementationId?: InputMaybe<Scalars['String']>;
};

export type WixBookingsV1StaffSortingPolicyInput = {
  customOptions?: InputMaybe<WixBookingsV1StaffSortingPolicyCustomOptionsInput>;
  rankingOptions?: InputMaybe<WixBookingsV1StaffSortingPolicyRankingOptionsInput>;
  /**
   * Method used for sorting and selecting staff members.
   *
   * Default: `RANDOM`
   */
  sortingMethodType?: InputMaybe<WixBookingsV1StaffSortingPolicySortingMethodType>;
};

export type WixBookingsV1StaffSortingPolicyRankingOptions = {
  /**
   * Order in which staff members are sorted by their priority ranking.
   *
   * Default: `LOWEST_TO_HIGHEST`
   */
  order?: Maybe<WixBookingsV1StaffSortingPolicyRankingOrder>;
};

export type WixBookingsV1StaffSortingPolicyRankingOptionsInput = {
  /**
   * Order in which staff members are sorted by their priority ranking.
   *
   * Default: `LOWEST_TO_HIGHEST`
   */
  order?: InputMaybe<WixBookingsV1StaffSortingPolicyRankingOrder>;
};

export enum WixBookingsV1StaffSortingPolicyRankingOrder {
  /** Staff members with higher priority values are selected first. */
  HIGHEST_TO_LOWEST = 'HIGHEST_TO_LOWEST',
  /** Staff members with lower priority values are selected first. */
  LOWEST_TO_HIGHEST = 'LOWEST_TO_HIGHEST',
  UNKNOWN_RANKING_ORDER = 'UNKNOWN_RANKING_ORDER'
}

export enum WixBookingsV1StaffSortingPolicySortingMethodType {
  /**
   * Staff members are selected using a custom implementation provided by SortStaffSPI.
   * This allows third-party apps to implement custom staff sorting logic.
   */
  CUSTOM = 'CUSTOM',
  /** Staff members are selected randomly from available options. */
  RANDOM = 'RANDOM',
  /** Staff members are selected based on their priority ranking. */
  RANKING = 'RANKING',
  UNKNOWN_SORTING_METHOD_TYPE = 'UNKNOWN_SORTING_METHOD_TYPE'
}

export type WixBookingsV1UpdateAllPoliciesRequestInput = {
  /** Fields to set to all booking policies. */
  bookingPolicy?: InputMaybe<WixBookingsV1BookingPolicyInput>;
  /** List of fields to update */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixBookingsV1UpdateBookingPolicyRequestInput = {
  /** Booking policy to update. */
  bookingPolicy?: InputMaybe<WixBookingsV1BookingPolicyInput>;
  /** Explicit list of fields to update */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixBookingsV1UpdateBookingPolicyResponse = {
  /** Updated booking policy. */
  bookingPolicy?: Maybe<WixBookingsV1BookingPolicy>;
};

export type WixBookingsV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixBookingsV1UpstreamWixCommonCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixBookingsV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixBookingsV1UpstreamWixCommonSortingInput>>>;
};

export type WixBookingsV1UpstreamWixCommonMoney = {
  /** Currency code. Must be valid ISO 4217 currency code (e.g., USD). */
  currency?: Maybe<Scalars['String']>;
  /** Monetary amount. Decimal string in local format (e.g., 1 000,30). Optionally, a single (-), to indicate that the amount is negative. */
  formattedValue?: Maybe<Scalars['String']>;
  /** Monetary amount. Decimal string with a period as a decimal separator (e.g., 3.99). Optionally, a single (-), to indicate that the amount is negative. */
  value?: Maybe<Scalars['String']>;
};

export type WixBookingsV1UpstreamWixCommonMoneyInput = {
  /** Currency code. Must be valid ISO 4217 currency code (e.g., USD). */
  currency?: InputMaybe<Scalars['String']>;
  /** Monetary amount. Decimal string in local format (e.g., 1 000,30). Optionally, a single (-), to indicate that the amount is negative. */
  formattedValue?: InputMaybe<Scalars['String']>;
  /** Monetary amount. Decimal string with a period as a decimal separator (e.g., 3.99). Optionally, a single (-), to indicate that the amount is negative. */
  value?: InputMaybe<Scalars['String']>;
};

export enum WixBookingsV1UpstreamWixCommonSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type WixBookingsV1UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixBookingsV1UpstreamWixCommonSortOrder>;
};

export type WixBookingsV1WaitlistPolicy = {
  /**
   * Number of spots in the waitlist.
   *
   * Default: `10` spots
   * Min: `1` spot
   */
  capacity?: Maybe<Scalars['Int']>;
  /**
   * Whether the service has a waitlist. `true` means there's a waitlist.
   *
   * Default: `false`
   */
  enabled?: Maybe<Scalars['Boolean']>;
  /**
   * Time in minutes the potential customer is given to book after they've been
   * notified that a spot has opened up for them. If they don't respond in time,
   * the open spot is offered to the next potential customer on the waitlist.
   *
   * Default: `10` minutes
   * Min: `1` minute
   */
  reservationTimeInMinutes?: Maybe<Scalars['Int']>;
};

export type WixBookingsV1WaitlistPolicyInput = {
  /**
   * Number of spots in the waitlist.
   *
   * Default: `10` spots
   * Min: `1` spot
   */
  capacity?: InputMaybe<Scalars['Int']>;
  /**
   * Whether the service has a waitlist. `true` means there's a waitlist.
   *
   * Default: `false`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * Time in minutes the potential customer is given to book after they've been
   * notified that a spot has opened up for them. If they don't respond in time,
   * the open spot is offered to the next potential customer on the waitlist.
   *
   * Default: `10` minutes
   * Min: `1` minute
   */
  reservationTimeInMinutes?: InputMaybe<Scalars['Int']>;
};

export type WixCalendarEventsV3BulkCancelEventRequestInput = {
  /** IDs of the events to cancel. */
  eventIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Information about whether participants of the canceled events are notified and
   * the message they receive.
   */
  participantNotification?: InputMaybe<WixCalendarSchedulesV3ParticipantNotificationInput>;
  /**
   * Whether to return the canceled events.
   *
   * Default: `false`
   */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /**
   * Time zone in [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database)
   * for calculating `adjustedStart` and `adjustedEnd`. For example,
   * `America/New_York` or `UTC`.
   *
   * Default: `timeZone` specified in the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type WixCalendarEventsV3BulkCancelEventResponse = {
  /** Total successes and failures. */
  bulkActionMetadata?: Maybe<WixCalendarEventsV3UpstreamWixCommonBulkActionMetadata>;
  /** The result for each event, containing the event and whether the action was successful. */
  results?: Maybe<Array<Maybe<WixCalendarEventsV3BulkEventResult>>>;
};

export type WixCalendarEventsV3BulkCreateEventRequestInput = {
  /** Events to create. */
  events?: InputMaybe<Array<InputMaybe<WixCalendarEventsV3BulkCreateEventRequestMaskedEventInput>>>;
  /**
   * Whether to return created events.
   *
   * Default: `false`.
   */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /**
   * Time zone in [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database)
   * for calculating `adjustedStart` and `adjustedEnd`. For example,
   * `America/New_York` or `UTC`.
   *
   * Default: `timeZone` specified in the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type WixCalendarEventsV3BulkCreateEventRequestMaskedEventInput = {
  /** Event to create. */
  event?: InputMaybe<WixCalendarEventsV3EventInput>;
  /**
   * Optional list of fields to create or override.
   *
   * For example, to set empty values for fields that would otherwise be inherited from the schedule.
   */
  fieldmask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixCalendarEventsV3BulkCreateEventResponse = {
  /** Total successes and failures. */
  bulkActionMetadata?: Maybe<WixCalendarEventsV3UpstreamWixCommonBulkActionMetadata>;
  /** The result for each event, containing the event and whether the action was successful. */
  results?: Maybe<Array<Maybe<WixCalendarEventsV3BulkEventResult>>>;
};

export type WixCalendarEventsV3BulkEventResult = {
  /** The event. */
  item?: Maybe<WixCalendarEventsV3Event>;
  /** Whether the requested action was successful. */
  itemMetadata?: Maybe<WixCalendarEventsV3UpstreamWixCommonItemMetadata>;
};

export type WixCalendarEventsV3BulkUpdateEventRequestInput = {
  /**
   * Events to update.
   *
   * Min: 1 event
   * Max: 50 events
   */
  events?: InputMaybe<Array<InputMaybe<WixCalendarEventsV3BulkUpdateEventRequestMaskedEventInput>>>;
  /**
   * Information about whether participants of the updated event are notified and
   * the message they receive.
   */
  participantNotification?: InputMaybe<WixCalendarSchedulesV3ParticipantNotificationInput>;
  /**
   * Whether to return the updated events.
   *
   * Default: `false`
   */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /**
   * Time zone in [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database)
   * for calculating `adjustedStart` and `adjustedEnd`. For example,
   * `America/New_York` or `UTC`.
   *
   * Default: `timeZone` specified in the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type WixCalendarEventsV3BulkUpdateEventRequestMaskedEventInput = {
  /** Event to update. */
  event?: InputMaybe<WixCalendarEventsV3EventInput>;
  /**
   * Optional list of fields to update or override.
   *
   * For example, to set empty values for fields that would otherwise be inherited from the schedule.
   */
  fieldmask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixCalendarEventsV3BulkUpdateEventResponse = {
  /** Total successes and failures. */
  bulkActionMetadata?: Maybe<WixCalendarEventsV3UpstreamWixCommonBulkActionMetadata>;
  /** The result for each event, containing the event and whether the action was successful. */
  results?: Maybe<Array<Maybe<WixCalendarEventsV3BulkEventResult>>>;
};

export type WixCalendarEventsV3CancelEventRequestInput = {
  /** ID of the event to cancel. */
  eventId?: InputMaybe<Scalars['String']>;
  /**
   * Information about whether participants of the canceled event are notified and
   * the message they receive.
   */
  participantNotification?: InputMaybe<WixCalendarSchedulesV3ParticipantNotificationInput>;
  /**
   * Time zone in [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database)
   * for calculating `adjustedStart` and `adjustedEnd`. For example,
   * `America/New_York` or `UTC`.
   *
   * Default: `timeZone` specified in the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type WixCalendarEventsV3CancelEventResponse = {
  /** Canceled event. */
  event?: Maybe<WixCalendarEventsV3Event>;
};

export type WixCalendarEventsV3CreateEventRequestInput = {
  /** Event to create. */
  event?: InputMaybe<WixCalendarEventsV3EventInput>;
  /**
   * Optional list of fields to create or override.
   *
   * For example, to set empty values for fields that would otherwise be inherited from the schedule.
   */
  fieldmask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Idempotency key guaranteeing that you don't create the same event more
   * than once.
   */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /**
   * Time zone in [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database)
   * for calculating `adjustedStart` and `adjustedEnd`. For example,
   * `America/New_York` or `UTC`.
   *
   * Default: `timeZone` specified in the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type WixCalendarEventsV3CreateEventResponse = {
  /** Created event. */
  event?: Maybe<WixCalendarEventsV3Event>;
};

export type WixCalendarEventsV3Event = {
  /**
   * Information about when the event ends adjusted to the `timeZone` of the
   * business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/properties-object)
   * or a different `timeZone` you provide in the call's request.
   */
  adjustedEnd?: Maybe<WixCalendarEventsV3ZonedDate>;
  /**
   * Information about when the event starts adjusted to the `timeZone` of the
   * business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/properties-object)
   * or a different `timeZone` you provide in the call's request.
   */
  adjustedStart?: Maybe<WixCalendarEventsV3ZonedDate>;
  /**
   * ID of the app that owns the event. Identical to `appId` of the
   * [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object)
   * to which the event belongs.
   */
  appId?: Maybe<Scalars['String']>;
  /**
   * Information about the event's online conferencing.
   * Returned only if explicitly requested. For more details, see the [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions#retrieve-personal-information).
   *
   * Default: `defaultConferencingDetails` of the [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object) the event belongs to
   */
  conferencingDetails?: Maybe<WixCalendarSchedulesV3ConferencingDetails>;
  /** Date the event was created in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  createdDate?: Maybe<Scalars['String']>;
  /**
   * Information about when the event ends.
   *
   * Maximum allowed date: Year 2100, or up to 100 years from the event's start date (whichever comes first).
   */
  end?: Maybe<WixCalendarEventsV3ZonedDate>;
  /** Extensions enabling applications or users to save custom data related to the event. */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /**
   * ID of the external schedule the event belongs to.
   *
   * For example, if the event belongs to a Bookings staff member, identical to
   * the ID of the [resource](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members-and-resources/resource-v2/resource-object).
   * If the schedule belongs to a Bookings service,
   * identical to the ID of the [service](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/service-object).
   */
  externalScheduleId?: Maybe<Scalars['String']>;
  /** Event ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * List of fields whose values are inherited.
   * + For single-occurrence events, values are inherited from the [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object).
   * + For `INSTANCE` and `EXCEPTION` events, values are inherited from the related `MASTER` event.
   */
  inheritedFields?: Maybe<Array<Maybe<WixCalendarEventsV3FieldEnumField>>>;
  /**
   * Event location.
   *
   * Default: `defaultLocation` of the [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object) the event belongs to
   */
  location?: Maybe<WixCalendarSchedulesV3Location>;
  /**
   * Additional notes about the event.
   * Returned only if explicitly requested. For more details, see the [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions#retrieve-personal-information).
   *
   * Min: 1 character
   * Max: 5000 characters
   */
  notes?: Maybe<Scalars['String']>;
  /**
   * Information about the event's participants.
   * Returned only if explicitly requested. For more details, see the [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions#retrieve-personal-information).
   */
  participants?: Maybe<WixCalendarEventsV3Participants>;
  /**
   * List of permissions associated with the event. Refer to the
   * [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions#roles)
   * for more information.
   */
  permissions?: Maybe<Array<Maybe<WixCalendarSchedulesV3Permission>>>;
  /**
   * Recurrence pattern for a series of events. This field is required when
   * creating a `MASTER` event and isn't available for non-recurring events.
   * You can't update the recurrence rule for `INSTANCE` or `EXCEPTION` events.
   *
   * For example, an event that repeats every second Monday until January 7, 2026,
   * at 8:00 AM has the following `recurrenceRule`:
   * - `frequency = WEEKLY`
   * - `interval = 2`
   * - `days = [MONDAY]`
   * - `until = 20260107T08:00:00Z`
   */
  recurrenceRule?: Maybe<WixCalendarEventsV3RecurrenceRule>;
  /**
   * Information about whether the event is a single occurrence or part of a
   * recurring series.
   *
   * Supported values:
   * + `NONE`: The event occurs only once and doesn't repeat.
   * + `MASTER`: Defines the recurrence pattern for a series of recurring events.
   * + `INSTANCE`: A specific occurrence of a recurring event. You can't create an event with `{"recurrenceType": "INSTANCE"}`, instead it's automatically generated based on the recurrence rule. If you update an `INSTANCE` event, `recurrenceType` automatically changes to `EXCEPTION`.
   * + `EXCEPTION`: A modified instance of a recurring event that differs from the recurrence pattern. For example, an event with a different time or location. You can't create an `EXCEPTION` event directly, instead it's set automatically when you update an `INSTANCE` event.
   *
   * Default: `NONE`
   */
  recurrenceType?: Maybe<WixCalendarEventsV3RecurrenceTypeEnumRecurrenceType>;
  /**
   * ID of the `MASTER` event the event belongs to. Available only for `INSTANCE`
   * and `EXCEPTION` events.
   */
  recurringEventId?: Maybe<Scalars['String']>;
  /** Number of participants who can still be added to the event. */
  remainingCapacity?: Maybe<Scalars['Int']>;
  /**
   * List of [Wix Bookings resources](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members-and-resources/resource-v2/resource-object)
   * affected by the event. This could include, for example, the
   * [Wix Bookings staff member](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members-and-resources/staff-member-v1/staff-member-object)
   * providing the service or the room where the appointment takes place.
   *
   * Max: 100 resources
   */
  resources?: Maybe<Array<Maybe<WixCalendarEventsV3Resource>>>;
  /**
   * Revision number, which increments each time the event is updated.
   * To prevent conflicting changes, the current revision must be passed when updating the event.
   * Ignored when creating an event.
   */
  revision?: Maybe<Scalars['Long']>;
  /**
   * ID of the [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object)
   * the event belongs to.
   * After creating an event, you can't assign it to a different schedule.
   */
  schedule?: Maybe<WixCalendarSchedulesV3Schedule>;
  /**
   * ID of the [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object)
   * the event belongs to.
   * After creating an event, you can't assign it to a different schedule.
   */
  scheduleId?: Maybe<Scalars['String']>;
  /** Schedule name. */
  scheduleName?: Maybe<Scalars['String']>;
  sessionsVirtualReference?: Maybe<ComWixBookingsCalendarApiV2QuerySessionsResponse>;
  /** Information about when the event starts. */
  start?: Maybe<WixCalendarEventsV3ZonedDate>;
  /**
   * Event status.
   *
   * Supported values:
   * + `CONFIRMED`: Event is scheduled to happen or has happened.
   * + `CANCELLED`: Event has been canceled.
   *
   * Default: `CONFIRMED`
   */
  status?: Maybe<WixCalendarEventsV3EventStatus>;
  /**
   * Time zone the event is associated with in
   * [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database).
   * Only regional time zones and UTC are supported.
   * For example, `America/New_York` or `UTC`.
   *
   * Default: `timeZone` of the [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object).
   */
  timeZone?: Maybe<Scalars['String']>;
  /**
   * Event title.
   *
   * Min: 1 character
   * Max: 200 characters
   */
  title?: Maybe<Scalars['String']>;
  /**
   * Maximum number of participants who can participate in the event.
   *
   * Default: `defaultCapacity` of the [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object) the event belongs to
   */
  totalCapacity?: Maybe<Scalars['Int']>;
  /**
   * Specifies whether the event blocks time in the schedule it belongs to.
   *
   * Supported values:
   * + `OPAQUE`:  The schedule is blocked during the event, preventing other events that involve the same entities (for example, Booking staff members) from being scheduled at the same time.
   * + `TRANSPARENT`: The schedule remains open during the event, allowing other events to be scheduled concurrently.
   *
   * Default: `OPAQUE`
   */
  transparency?: Maybe<WixCalendarEventsV3Transparency>;
  /**
   * Event type. You can set the event type but you can't update it.
   *
   * Supported values:
   * + `DEFAULT`: A standard event that's not further specified.
   * + `WORKING_HOURS`: The event adds working hours to a schedule. By default not returned in [Query Events](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/query-events).
   *
   * Additional supported values, if Wix Bookings is installed:
   * + `APPOINTMENT`: Bookings appointment event.
   * + `CLASS`: Bookings class event.
   * + `COURSE`: Bookings course event.
   */
  type?: Maybe<Scalars['String']>;
  /** Date the event was last updated in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  updatedDate?: Maybe<Scalars['String']>;
};


export type WixCalendarEventsV3EventSessionsVirtualReferenceArgs = {
  queryInput?: InputMaybe<ComWixBookingsCalendarApiV2QuerySessionsRequestInput>;
};

export type WixCalendarEventsV3EventInput = {
  /**
   * Information about when the event ends adjusted to the `timeZone` of the
   * business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/properties-object)
   * or a different `timeZone` you provide in the call's request.
   */
  adjustedEnd?: InputMaybe<WixCalendarEventsV3ZonedDateInput>;
  /**
   * Information about when the event starts adjusted to the `timeZone` of the
   * business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/properties-object)
   * or a different `timeZone` you provide in the call's request.
   */
  adjustedStart?: InputMaybe<WixCalendarEventsV3ZonedDateInput>;
  /**
   * ID of the app that owns the event. Identical to `appId` of the
   * [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object)
   * to which the event belongs.
   */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Information about the event's online conferencing.
   * Returned only if explicitly requested. For more details, see the [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions#retrieve-personal-information).
   *
   * Default: `defaultConferencingDetails` of the [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object) the event belongs to
   */
  conferencingDetails?: InputMaybe<WixCalendarSchedulesV3ConferencingDetailsInput>;
  /** Date the event was created in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  createdDate?: InputMaybe<Scalars['String']>;
  /**
   * Information about when the event ends.
   *
   * Maximum allowed date: Year 2100, or up to 100 years from the event's start date (whichever comes first).
   */
  end?: InputMaybe<WixCalendarEventsV3ZonedDateInput>;
  /** Extensions enabling applications or users to save custom data related to the event. */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /**
   * ID of the external schedule the event belongs to.
   *
   * For example, if the event belongs to a Bookings staff member, identical to
   * the ID of the [resource](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members-and-resources/resource-v2/resource-object).
   * If the schedule belongs to a Bookings service,
   * identical to the ID of the [service](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/service-object).
   */
  externalScheduleId?: InputMaybe<Scalars['String']>;
  /** Event ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * List of fields whose values are inherited.
   * + For single-occurrence events, values are inherited from the [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object).
   * + For `INSTANCE` and `EXCEPTION` events, values are inherited from the related `MASTER` event.
   */
  inheritedFields?: InputMaybe<Array<InputMaybe<WixCalendarEventsV3FieldEnumField>>>;
  /**
   * Event location.
   *
   * Default: `defaultLocation` of the [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object) the event belongs to
   */
  location?: InputMaybe<WixCalendarSchedulesV3LocationInput>;
  /**
   * Additional notes about the event.
   * Returned only if explicitly requested. For more details, see the [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions#retrieve-personal-information).
   *
   * Min: 1 character
   * Max: 5000 characters
   */
  notes?: InputMaybe<Scalars['String']>;
  /**
   * Information about the event's participants.
   * Returned only if explicitly requested. For more details, see the [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions#retrieve-personal-information).
   */
  participants?: InputMaybe<WixCalendarEventsV3ParticipantsInput>;
  /**
   * List of permissions associated with the event. Refer to the
   * [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions#roles)
   * for more information.
   */
  permissions?: InputMaybe<Array<InputMaybe<WixCalendarSchedulesV3PermissionInput>>>;
  /**
   * Recurrence pattern for a series of events. This field is required when
   * creating a `MASTER` event and isn't available for non-recurring events.
   * You can't update the recurrence rule for `INSTANCE` or `EXCEPTION` events.
   *
   * For example, an event that repeats every second Monday until January 7, 2026,
   * at 8:00 AM has the following `recurrenceRule`:
   * - `frequency = WEEKLY`
   * - `interval = 2`
   * - `days = [MONDAY]`
   * - `until = 20260107T08:00:00Z`
   */
  recurrenceRule?: InputMaybe<WixCalendarEventsV3RecurrenceRuleInput>;
  /**
   * Information about whether the event is a single occurrence or part of a
   * recurring series.
   *
   * Supported values:
   * + `NONE`: The event occurs only once and doesn't repeat.
   * + `MASTER`: Defines the recurrence pattern for a series of recurring events.
   * + `INSTANCE`: A specific occurrence of a recurring event. You can't create an event with `{"recurrenceType": "INSTANCE"}`, instead it's automatically generated based on the recurrence rule. If you update an `INSTANCE` event, `recurrenceType` automatically changes to `EXCEPTION`.
   * + `EXCEPTION`: A modified instance of a recurring event that differs from the recurrence pattern. For example, an event with a different time or location. You can't create an `EXCEPTION` event directly, instead it's set automatically when you update an `INSTANCE` event.
   *
   * Default: `NONE`
   */
  recurrenceType?: InputMaybe<WixCalendarEventsV3RecurrenceTypeEnumRecurrenceType>;
  /**
   * ID of the `MASTER` event the event belongs to. Available only for `INSTANCE`
   * and `EXCEPTION` events.
   */
  recurringEventId?: InputMaybe<Scalars['String']>;
  /** Number of participants who can still be added to the event. */
  remainingCapacity?: InputMaybe<Scalars['Int']>;
  /**
   * List of [Wix Bookings resources](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members-and-resources/resource-v2/resource-object)
   * affected by the event. This could include, for example, the
   * [Wix Bookings staff member](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members-and-resources/staff-member-v1/staff-member-object)
   * providing the service or the room where the appointment takes place.
   *
   * Max: 100 resources
   */
  resources?: InputMaybe<Array<InputMaybe<WixCalendarEventsV3ResourceInput>>>;
  /**
   * Revision number, which increments each time the event is updated.
   * To prevent conflicting changes, the current revision must be passed when updating the event.
   * Ignored when creating an event.
   */
  revision?: InputMaybe<Scalars['Long']>;
  /**
   * ID of the [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object)
   * the event belongs to.
   * After creating an event, you can't assign it to a different schedule.
   */
  scheduleId?: InputMaybe<Scalars['String']>;
  /** Schedule name. */
  scheduleName?: InputMaybe<Scalars['String']>;
  /** Information about when the event starts. */
  start?: InputMaybe<WixCalendarEventsV3ZonedDateInput>;
  /**
   * Event status.
   *
   * Supported values:
   * + `CONFIRMED`: Event is scheduled to happen or has happened.
   * + `CANCELLED`: Event has been canceled.
   *
   * Default: `CONFIRMED`
   */
  status?: InputMaybe<WixCalendarEventsV3EventStatus>;
  /**
   * Time zone the event is associated with in
   * [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database).
   * Only regional time zones and UTC are supported.
   * For example, `America/New_York` or `UTC`.
   *
   * Default: `timeZone` of the [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object).
   */
  timeZone?: InputMaybe<Scalars['String']>;
  /**
   * Event title.
   *
   * Min: 1 character
   * Max: 200 characters
   */
  title?: InputMaybe<Scalars['String']>;
  /**
   * Maximum number of participants who can participate in the event.
   *
   * Default: `defaultCapacity` of the [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object) the event belongs to
   */
  totalCapacity?: InputMaybe<Scalars['Int']>;
  /**
   * Specifies whether the event blocks time in the schedule it belongs to.
   *
   * Supported values:
   * + `OPAQUE`:  The schedule is blocked during the event, preventing other events that involve the same entities (for example, Booking staff members) from being scheduled at the same time.
   * + `TRANSPARENT`: The schedule remains open during the event, allowing other events to be scheduled concurrently.
   *
   * Default: `OPAQUE`
   */
  transparency?: InputMaybe<WixCalendarEventsV3Transparency>;
  /**
   * Event type. You can set the event type but you can't update it.
   *
   * Supported values:
   * + `DEFAULT`: A standard event that's not further specified.
   * + `WORKING_HOURS`: The event adds working hours to a schedule. By default not returned in [Query Events](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/query-events).
   *
   * Additional supported values, if Wix Bookings is installed:
   * + `APPOINTMENT`: Bookings appointment event.
   * + `CLASS`: Bookings class event.
   * + `COURSE`: Bookings course event.
   */
  type?: InputMaybe<Scalars['String']>;
  /** Date the event was last updated in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export enum WixCalendarEventsV3EventStatus {
  /** Event has been canceled. */
  CANCELLED = 'CANCELLED',
  /** Event is scheduled to happen or has happened. */
  CONFIRMED = 'CONFIRMED',
  /** DEPRECATED! AND WILL BE REMOVED SOON */
  PENDING_CONFIRMATION = 'PENDING_CONFIRMATION',
  UNKNOWN_STATUS = 'UNKNOWN_STATUS'
}

export enum WixCalendarEventsV3FieldEnumField {
  /** `capacity` is inherited from the schedule or `MASTER` event. */
  CAPACITY = 'CAPACITY',
  /** `conferencingDetails` is inherited from the schedule or `MASTER` event. */
  CONFERENCING_DETAILS = 'CONFERENCING_DETAILS',
  /** `location` is inherited from the schedule or `MASTER` event. */
  LOCATION = 'LOCATION',
  /** `participants` is inherited from the `MASTER` event. */
  PARTICIPANTS = 'PARTICIPANTS',
  /** `resources` is inherited from the `MASTER` event. */
  RESOURCES = 'RESOURCES',
  /** `start` and `end` are inherited from the `MASTER` event. */
  TIME = 'TIME',
  /** `timeZone` is inherited from the schedule or `MASTER` event. */
  TIME_ZONE = 'TIME_ZONE',
  /** `title` is inherited from the schedule or `MASTER` event. */
  TITLE = 'TITLE',
  UNKNOWN_FIELD = 'UNKNOWN_FIELD'
}

export type WixCalendarEventsV3GetEventRequestInput = {
  /**
   * Whether to return consistent response.
   * Please consult with us at #bookings-calendar-platform if you think your case requires consistent reads.
   */
  consistent?: InputMaybe<Scalars['Boolean']>;
  /**
   * Information about which fields containing personal data to return. Refer to the
   * [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions)
   * for more information.
   *
   * Supported values:
   * + `PI_FIELDS`: Returns all fields with personal data. Your app must have `Read Calendars - Including PI` or `Manage Calendars` permission scope.
   * + `OWN_PI_FIELDS`: Returns only fields containing your own personal data.
   *
   * Max: 1 field
   * Default: No personal data is returned.
   */
  fields?: InputMaybe<Array<InputMaybe<WixCalendarEventsV3RequestedFieldsEnumRequestedFields>>>;
  id: Scalars['ID'];
  /**
   * Time zone in [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database)
   * for calculating `adjustedStart` and `adjustedEnd`. For example,
   * `America/New_York` or `UTC`.
   *
   * Default: `timeZone` specified in the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type WixCalendarEventsV3ListEventsRequestInput = {
  /**
   * Whether to return consistent response.
   * Please consult with us at #bookings-calendar-platform if you think your case requires consistent reads.
   */
  consistent?: InputMaybe<Scalars['Boolean']>;
  /**
   * IDs of the events to retrieve.
   *
   * Min: 1 event ID
   * Min: 100 event IDs
   */
  eventIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Information about which fields containing personal data to return. Refer to the
   * [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions)
   * for more information.
   *
   * Supported values:
   * + `PI_FIELDS`: Returns all fields with personal data. Your app must have `Read Calendars - Including PI` or `Manage Calendars` permission scope.
   * + `OWN_PI_FIELDS`: Returns only fields containing your own personal data.
   *
   * Max: 1 field
   * Default: No personal data is returned.
   */
  fields?: InputMaybe<Array<InputMaybe<WixCalendarEventsV3RequestedFieldsEnumRequestedFields>>>;
  /**
   * Time zone in [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database)
   * for calculating `adjustedStart` and `adjustedEnd`. For example,
   * `America/New_York` or `UTC`.
   *
   * Default: `timeZone` specified in the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type WixCalendarEventsV3ListEventsResponse = {
  /** Retrieved events matching the provided IDs. */
  events?: Maybe<Array<Maybe<WixCalendarEventsV3Event>>>;
};

export type WixCalendarEventsV3ListRecurringEventInstancesHistoryRequestInput = {
  /** Optional cursor pointing to the next page of events. */
  cursorPaging?: InputMaybe<WixCalendarEventsV3UpstreamWixCommonCursorPagingInput>;
  /**
   * Inclusive start date for which events are returned, in ISO-8601 format.
   * Events that begin at or after the `fromDate` are included in the results.
   * Required, unless `cursorPaging` is provided.
   */
  fromDate?: InputMaybe<Scalars['String']>;
  /**
   * The ID of the recurring event.
   * Required, unless `cursorPaging` is provided.
   */
  recurringEventId?: InputMaybe<Scalars['String']>;
  /**
   * The revision of the recurring event.
   * Required, unless `cursorPaging` is provided.
   */
  revision?: InputMaybe<Scalars['Long']>;
  /**
   * Exclusive end date for which events are returned, in ISO-8601 format.
   * Events that begin before the `toDate` are included in the results.
   * Required, unless `cursorPaging` is provided.
   */
  toDate?: InputMaybe<Scalars['String']>;
};

export type WixCalendarEventsV3ListRecurringEventInstancesHistoryResponse = {
  /** Paging metadata. */
  pagingMetadata?: Maybe<WixCalendarEventsV3UpstreamWixCommonCursorPagingMetadata>;
  /** The recurring event instances. */
  recurringEventInstances?: Maybe<Array<Maybe<WixCalendarEventsV3Event>>>;
};

export type WixCalendarEventsV3Participant = {
  /**
   * [Contact](https://dev.wix.com/docs/rest/crm/members-contacts/contacts/contacts/contact-v4/contact-object)
   * ID of the participant.
   */
  contact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
  /**
   * [Contact](https://dev.wix.com/docs/rest/crm/members-contacts/contacts/contacts/contact-v4/contact-object)
   * ID of the participant.
   */
  contactId?: Maybe<Scalars['String']>;
  /** Participant's email address. */
  email?: Maybe<Scalars['String']>;
  /**
   * Participant name.
   *
   * Min: 1 character
   * Max: 200 characters
   */
  name?: Maybe<Scalars['String']>;
  /** Participant's phone number. */
  phone?: Maybe<Scalars['String']>;
};

export type WixCalendarEventsV3ParticipantInput = {
  /**
   * [Contact](https://dev.wix.com/docs/rest/crm/members-contacts/contacts/contacts/contact-v4/contact-object)
   * ID of the participant.
   */
  contactId?: InputMaybe<Scalars['String']>;
  /** Participant's email address. */
  email?: InputMaybe<Scalars['String']>;
  /**
   * Participant name.
   *
   * Min: 1 character
   * Max: 200 characters
   */
  name?: InputMaybe<Scalars['String']>;
  /** Participant's phone number. */
  phone?: InputMaybe<Scalars['String']>;
};

export type WixCalendarEventsV3Participants = {
  /**
   * Whether there are more participants for the event than listed.
   *
   * + `false`: The list includes all participants.
   * + `true`: The list doesn't include all participants.
   */
  hasMore?: Maybe<Scalars['Boolean']>;
  /**
   * Full or partial list of the participants.
   *
   * Max: 50 participants
   */
  list?: Maybe<Array<Maybe<WixCalendarEventsV3Participant>>>;
  /**
   * Participant's status.
   *
   * Supported values:
   * + `CONFIRMED`: All participants are confirmed.
   * + `PENDING_CONFIRMATION`: At least one participant isn't confirmed yet.
   */
  status?: Maybe<WixCalendarEventsV3ParticipantsStatus>;
  /**
   * Total number of participants.
   *
   * Min: `0`
   */
  total?: Maybe<Scalars['Int']>;
};

export type WixCalendarEventsV3ParticipantsInput = {
  /**
   * Whether there are more participants for the event than listed.
   *
   * + `false`: The list includes all participants.
   * + `true`: The list doesn't include all participants.
   */
  hasMore?: InputMaybe<Scalars['Boolean']>;
  /**
   * Full or partial list of the participants.
   *
   * Max: 50 participants
   */
  list?: InputMaybe<Array<InputMaybe<WixCalendarEventsV3ParticipantInput>>>;
  /**
   * Participant's status.
   *
   * Supported values:
   * + `CONFIRMED`: All participants are confirmed.
   * + `PENDING_CONFIRMATION`: At least one participant isn't confirmed yet.
   */
  status?: InputMaybe<WixCalendarEventsV3ParticipantsStatus>;
  /**
   * Total number of participants.
   *
   * Min: `0`
   */
  total?: InputMaybe<Scalars['Int']>;
};

export enum WixCalendarEventsV3ParticipantsStatus {
  /** All participants are confirmed. */
  CONFIRMED = 'CONFIRMED',
  /** At least one participant isn't confirmed yet. */
  PENDING_CONFIRMATION = 'PENDING_CONFIRMATION',
  UNKNOWN_STATUS = 'UNKNOWN_STATUS'
}

export type WixCalendarEventsV3QueryEventsRequestInput = {
  /**
   * Whether to return consistent response.
   * Please consult with us at #bookings-calendar-platform if you think your case requires consistent reads.
   */
  consistent?: InputMaybe<Scalars['Boolean']>;
  /**
   * Information about which fields containing personal data to return. Refer to the
   * [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions)
   * for more information.
   *
   * Supported values:
   * + `PI_FIELDS`: Returns all fields with personal data. Your app must have `Read Calendars - Including PI` or `Manage Calendars` permission scope.
   * + `OWN_PI_FIELDS`: Returns only fields containing your own personal data.
   *
   * Max: 1 field
   * Default: No personal data is returned.
   */
  fields?: InputMaybe<Array<InputMaybe<WixCalendarEventsV3RequestedFieldsEnumRequestedFields>>>;
  /**
   * Local start date and time from which events are returned in
   * [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) format. For example,
   * `2024-01-30T13:30:00`.
   *
   * Events that start before the `fromLocalDate` but end after it are included in
   * the results. Must be earlier than `toLocalDate` unless the sort order is
   * descending.
   */
  fromLocalDate?: InputMaybe<Scalars['String']>;
  /** Query containing filters and paging. */
  query?: InputMaybe<WixCalendarEventsV3UpstreamWixCommonCursorQueryInput>;
  /**
   * Filters events based on their `recurrenceType`.
   *
   * Max: 5 recurrence types can be specified.
   * Default: Events with `recurrenceType` of `NONE`, `INSTANCE`, and `EXCEPTION` are returned.
   */
  recurrenceType?: InputMaybe<Array<InputMaybe<WixCalendarEventsV3RecurrenceTypeEnumRecurrenceType>>>;
  /**
   * Time zone in [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database)
   * for `fromLocalDate`, `toLocalDate`, and for calculating `adjustedStart` and
   * `adjustedEnd`. For example, `America/New_York` or `UTC`.
   *
   * Default: `timeZone` specified in the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   */
  timeZone?: InputMaybe<Scalars['String']>;
  /**
   * Local end date and time up to which events are returned in
   * [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) format. For example,
   * `2024-01-30T13:30:00`.
   *
   * Events that start before `toLocalDate` but end after it are included in the
   * results. Must be later than `fromLocalDate` unless the sort order is
   * descending.
   */
  toLocalDate?: InputMaybe<Scalars['String']>;
};

export type WixCalendarEventsV3QueryEventsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<WixCalendarEventsV3Event>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export enum WixCalendarEventsV3RecurrenceEnumRecurrence {
  /** The event is an exceptional instance of a recurring event. Read only. */
  EXCEPTION = 'EXCEPTION',
  /** The event is an instance of a recurring event. Read only. */
  INSTANCE = 'INSTANCE',
  /** The event is the recurrence master defining the recurrence rule, which is the repeat pattern for the events. */
  MASTER = 'MASTER',
  /** No recurrence, i.e the event is a single event instance. Default. */
  NONE = 'NONE',
  UNKNOWN_RECURRENCE = 'UNKNOWN_RECURRENCE'
}

export type WixCalendarEventsV3RecurrenceRule = {
  /**
   * Date until when the event repeats
   * adjusted to the `timeZone` of the business
   * [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/properties-object)
   * or a different `timeZone` you provide in the call's request.
   */
  adjustedUntil?: Maybe<WixCalendarEventsV3ZonedDate>;
  /**
   * Days of the week when the recurring event takes place.
   * Currently, only a single day is supported.
   *
   * Min: 1 day
   * Max: 1 day
   */
  days?: Maybe<Array<Maybe<WixCalendarEventsV3RecurrenceRuleDay>>>;
  /**
   * Frequency how often the event repeats. Works together with `interval`.
   *
   * Supported values:
   * + `WEEKLY`: The event's recurrence pattern is based on weeks.
   */
  frequency?: Maybe<WixCalendarEventsV3RecurrenceRuleFrequency>;
  /**
   * Interval how often the event repeats. Works together with `frequency`.
   * For example, `frequency` set to `WEEKLY`  and `interval` set to `2` means
   * the event repeats every 2 weeks.
   *
   * Min: `1`
   * Max: `4`
   * Default: `1`
   */
  interval?: Maybe<Scalars['Int']>;
  /**
   * Date until when the event repeats.
   * If not specified, the event repeats forever.
   */
  until?: Maybe<WixCalendarEventsV3ZonedDate>;
};

export enum WixCalendarEventsV3RecurrenceRuleDay {
  /** The recurring event takes place on Fridays. */
  FRIDAY = 'FRIDAY',
  /** The recurring event takes place on Mondays. */
  MONDAY = 'MONDAY',
  /** The recurring event takes place on Saturdays. */
  SATURDAY = 'SATURDAY',
  /** The recurring event takes place on Sundays. */
  SUNDAY = 'SUNDAY',
  /** The recurring event takes place on Thursdays. */
  THURSDAY = 'THURSDAY',
  /** The recurring event takes place on Tuesdays. */
  TUESDAY = 'TUESDAY',
  /** The recurring event takes place on Wednesday. */
  WEDNESDAY = 'WEDNESDAY'
}

export enum WixCalendarEventsV3RecurrenceRuleFrequency {
  UNKNOWN_FREQUENCY = 'UNKNOWN_FREQUENCY',
  /** The event's recurrence pattern is based on weeks. */
  WEEKLY = 'WEEKLY'
}

export type WixCalendarEventsV3RecurrenceRuleInput = {
  /**
   * Date until when the event repeats
   * adjusted to the `timeZone` of the business
   * [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/properties-object)
   * or a different `timeZone` you provide in the call's request.
   */
  adjustedUntil?: InputMaybe<WixCalendarEventsV3ZonedDateInput>;
  /**
   * Days of the week when the recurring event takes place.
   * Currently, only a single day is supported.
   *
   * Min: 1 day
   * Max: 1 day
   */
  days?: InputMaybe<Array<InputMaybe<WixCalendarEventsV3RecurrenceRuleDay>>>;
  /**
   * Frequency how often the event repeats. Works together with `interval`.
   *
   * Supported values:
   * + `WEEKLY`: The event's recurrence pattern is based on weeks.
   */
  frequency?: InputMaybe<WixCalendarEventsV3RecurrenceRuleFrequency>;
  /**
   * Interval how often the event repeats. Works together with `frequency`.
   * For example, `frequency` set to `WEEKLY`  and `interval` set to `2` means
   * the event repeats every 2 weeks.
   *
   * Min: `1`
   * Max: `4`
   * Default: `1`
   */
  interval?: InputMaybe<Scalars['Int']>;
  /**
   * Date until when the event repeats.
   * If not specified, the event repeats forever.
   */
  until?: InputMaybe<WixCalendarEventsV3ZonedDateInput>;
};

export enum WixCalendarEventsV3RecurrenceTypeEnumRecurrenceType {
  /** A modified instance of a recurring event that differs from the recurrence pattern. For example, an event with a different time or location. You can't create an `EXCEPTION` event directly, instead it's set automatically when you update an `INSTANCE` event. */
  EXCEPTION = 'EXCEPTION',
  /** A specific occurrence of a recurring event. You can't create an event with `{"recurrenceType": "INSTANCE"}`, instead it's automatically generated based on the recurrence rule. If you update an `INSTANCE` event, `recurrenceType` automatically changes to `EXCEPTION`. */
  INSTANCE = 'INSTANCE',
  /** Defines the recurrence pattern for a series of recurring events. */
  MASTER = 'MASTER',
  /** The event occurs only once and doesn't repeat. */
  NONE = 'NONE',
  UNKNOWN_RECURRENCE_TYPE = 'UNKNOWN_RECURRENCE_TYPE'
}

export enum WixCalendarEventsV3RequestedFieldsEnumRequestedFields {
  /** Returns only fields containing your own personal data. */
  OWN_PI_FIELDS = 'OWN_PI_FIELDS',
  /** Returns all fields with personal data. Your app must have `Read Calendars - Including PI` or `Manage Calendars` permission scope. */
  PI_FIELDS = 'PI_FIELDS',
  UNKNOWN_REQUESTED_FIELDS = 'UNKNOWN_REQUESTED_FIELDS'
}

export type WixCalendarEventsV3Resource = {
  /** Resource ID. */
  id?: Maybe<Scalars['String']>;
  /** Resource name. */
  name?: Maybe<Scalars['String']>;
  /**
   * Permission role associated with the resource. Refer to the
   * [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions#roles)
   * for more information.
   */
  permissionRole?: Maybe<WixCalendarSchedulesV3PermissionRole>;
  /** ID of the resource's [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object). */
  schedule?: Maybe<WixCalendarSchedulesV3Schedule>;
  /** ID of the resource's [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object). */
  scheduleId?: Maybe<Scalars['String']>;
  /**
   * Specifies whether the event blocks time in the resource's schedule.
   *
   * Supported values:
   * + `OPAQUE`: The schedule is blocked during the event, preventing other events that involve the same resource from being scheduled at the same time.
   * + `TRANSPARENT`: The schedule remains open during the event, allowing other events to be scheduled concurrently.
   *
   * Default: `OPAQUE`.
   */
  transparency?: Maybe<WixCalendarEventsV3Transparency>;
  /** Resource type. */
  type?: Maybe<Scalars['String']>;
};

export type WixCalendarEventsV3ResourceInput = {
  /** Resource ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Resource name. */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Permission role associated with the resource. Refer to the
   * [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions#roles)
   * for more information.
   */
  permissionRole?: InputMaybe<WixCalendarSchedulesV3PermissionRole>;
  /** ID of the resource's [schedule](https://dev.wix.com/docs/rest/business-management/calendar/schedules-v3/schedule-object). */
  scheduleId?: InputMaybe<Scalars['String']>;
  /**
   * Specifies whether the event blocks time in the resource's schedule.
   *
   * Supported values:
   * + `OPAQUE`: The schedule is blocked during the event, preventing other events that involve the same resource from being scheduled at the same time.
   * + `TRANSPARENT`: The schedule remains open during the event, allowing other events to be scheduled concurrently.
   *
   * Default: `OPAQUE`.
   */
  transparency?: InputMaybe<WixCalendarEventsV3Transparency>;
  /** Resource type. */
  type?: InputMaybe<Scalars['String']>;
};

export type WixCalendarEventsV3RestoreEventDefaultsRequestInput = {
  /** ID of the event for which to restore default values. */
  eventId?: InputMaybe<Scalars['String']>;
  /**
   * Fields for which to restore default values.
   *
   * `TIME` restores default values for `start` and `end`.
   *
   * Min: 1 field
   */
  fields?: InputMaybe<Array<InputMaybe<WixCalendarEventsV3FieldEnumField>>>;
  /**
   * Information about whether participants of the updated event are notified and
   * the message they receive.
   */
  participantNotification?: InputMaybe<WixCalendarSchedulesV3ParticipantNotificationInput>;
  /**
   * Time zone in [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database)
   * for calculating `adjustedStart` and `adjustedEnd`. For example,
   * `America/New_York` or `UTC`.
   *
   * Default: `timeZone` specified in the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type WixCalendarEventsV3RestoreEventDefaultsResponse = {
  /** Updated event. */
  event?: Maybe<WixCalendarEventsV3Event>;
};

export type WixCalendarEventsV3SplitRecurringEventRequestInput = {
  /** ID of the `MASTER` event to split. */
  recurringEventId?: InputMaybe<Scalars['String']>;
  /**
   * Local date and time at which the `MASTER` event is split in
   * [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) format. For example,
   * `2025-03-11T09:00:00`.
   * Must be a future date that's after the `start` date of the next `INSTANCE` or
   * `EXCEPTION` event in the series. Additionally, there must be another
   * `INSTANCE` or `EXCEPTION` event following this next event, as the changes
   * wouldn't affect any event without a subsequent occurrence.
   */
  splitLocalDate?: InputMaybe<Scalars['String']>;
  /**
   * Time zone in [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database)
   * for calculating `adjustedStart` and `adjustedEnd`. For example,
   * `America/New_York` or `UTC`.
   *
   * Default: `timeZone` specified in the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type WixCalendarEventsV3SplitRecurringEventResponse = {
  /** New `MASTER` event starting with the first event after the split date. */
  newRecurringEventStartingFromSplit?: Maybe<WixCalendarEventsV3Event>;
  /** Original `MASTER` event that was shortened. */
  updatedRecurringEventEndingBeforeSplit?: Maybe<WixCalendarEventsV3Event>;
};

export enum WixCalendarEventsV3Transparency {
  /** The schedule is blocked during the event, preventing other events that involve the same entities (for example, Booking staff members) from being scheduled at the same time. */
  OPAQUE = 'OPAQUE',
  /** The schedule remains open during the event, allowing other events to be scheduled concurrently. */
  TRANSPARENT = 'TRANSPARENT',
  UNKNOWN_TRANSPARENCY = 'UNKNOWN_TRANSPARENCY'
}

export type WixCalendarEventsV3UpdateEventParticipantsRequestInput = {
  /**
   * ID of the event to update.
   *
   * Min: 36 characters
   * Max: 250 characters
   */
  eventId?: InputMaybe<Scalars['String']>;
  /** The participants to update. */
  participants?: InputMaybe<WixCalendarEventsV3ParticipantsInput>;
};

export type WixCalendarEventsV3UpdateEventParticipantsResponse = {
  /** Updated event. */
  event?: Maybe<WixCalendarEventsV3Event>;
};

export type WixCalendarEventsV3UpdateEventRequestInput = {
  /** Event to update. */
  event?: InputMaybe<WixCalendarEventsV3EventInput>;
  /**
   * Optional list of fields to update or override.
   *
   * For example, to set empty values for fields that would otherwise be inherited from the schedule.
   */
  fieldmask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Information about whether participants of the updated event are notified and
   * the message they receive.
   */
  participantNotification?: InputMaybe<WixCalendarSchedulesV3ParticipantNotificationInput>;
  /**
   * Time zone in [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database)
   * for calculating `adjustedStart` and `adjustedEnd`. For example,
   * `America/New_York` or `UTC`.
   *
   * Default: `timeZone` specified in the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type WixCalendarEventsV3UpdateEventResponse = {
  /** Updated event. */
  event?: Maybe<WixCalendarEventsV3Event>;
};

export type WixCalendarEventsV3UpstreamWixCommonBulkActionMetadata = {
  /** Number of events that couldn't be processed. */
  totalFailures?: Maybe<Scalars['Int']>;
  /** Number of events that were successfully processed. */
  totalSuccesses?: Maybe<Scalars['Int']>;
};

export type WixCalendarEventsV3UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /**
   * Number of events to return.
   * Defaults to `50`. Maximum `1000`.
   */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixCalendarEventsV3UpstreamWixCommonCursorPagingMetadata = {
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Use these cursor to paginate between results. [Read more](https://dev.wix.com/api/rest/getting-started/api-query-language#getting-started_api-query-language_cursor-paging). */
  cursors?: Maybe<WixCalendarEventsV3UpstreamWixCommonCursors>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
};

export type WixCalendarEventsV3UpstreamWixCommonCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter`. */
  cursorPaging?: InputMaybe<WixCalendarEventsV3UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object.
   * See [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language)
   * for more information.
   *
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`.
   *
   * For a detailed list of supported filters, see Supported Filters.
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Whether to sort events by their start date in ascending order or by their end date in descending order.
   * Default is start ascending.
   */
  sort?: InputMaybe<Array<InputMaybe<WixCalendarEventsV3UpstreamWixCommonSortingInput>>>;
};

export type WixCalendarEventsV3UpstreamWixCommonCursors = {
  /** Cursor pointing to next page in the list of results. */
  next?: Maybe<Scalars['String']>;
};

export type WixCalendarEventsV3UpstreamWixCommonItemMetadata = {
  /** Details about the error in case of failure. */
  error?: Maybe<WixApiApplicationError>;
  /**
   * Event ID.
   * Should always be available, unless it's impossible (for example, when failing to create an event).
   */
  id?: Maybe<Scalars['String']>;
  /** Index of the item within the request array, for correlation between request and response items. */
  originalIndex?: Maybe<Scalars['Int']>;
  /**
   * Whether the requested action was successful for this event.
   * When `false`, the `error` field is populated.
   */
  success?: Maybe<Scalars['Boolean']>;
};

export enum WixCalendarEventsV3UpstreamWixCommonSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type WixCalendarEventsV3UpstreamWixCommonSortingInput = {
  /**
   * The field to sort by.
   * Either `start` or `end`.
   * Default is `start`.
   */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixCalendarEventsV3UpstreamWixCommonSortOrder>;
};

export type WixCalendarEventsV3ZonedDate = {
  /**
   * Local date time in [ISO-8601 format](https://en.wikipedia.org/wiki/ISO_8601).
   * For example, `2024-01-30T13:30:00`.
   * Wix Calendar APIs ignore seconds.
   */
  localDate?: Maybe<Scalars['String']>;
  /**
   * Time zone in
   * [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database).
   * For example, `America/New_York`.
   */
  timeZone?: Maybe<Scalars['String']>;
  /**
   * UTC date time in [ISO-8601 format](https://en.wikipedia.org/wiki/ISO_8601).
   * For example, `2024-01-30T13:30:00`.
   * Not available for adjusted date fields.
   */
  utcDate?: Maybe<Scalars['String']>;
};

export type WixCalendarEventsV3ZonedDateInput = {
  /**
   * Local date time in [ISO-8601 format](https://en.wikipedia.org/wiki/ISO_8601).
   * For example, `2024-01-30T13:30:00`.
   * Wix Calendar APIs ignore seconds.
   */
  localDate?: InputMaybe<Scalars['String']>;
  /**
   * Time zone in
   * [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database).
   * For example, `America/New_York`.
   */
  timeZone?: InputMaybe<Scalars['String']>;
  /**
   * UTC date time in [ISO-8601 format](https://en.wikipedia.org/wiki/ISO_8601).
   * For example, `2024-01-30T13:30:00`.
   * Not available for adjusted date fields.
   */
  utcDate?: InputMaybe<Scalars['String']>;
};

export type WixCalendarMigrationV3DeleteTargetsRequestInput = {
  concurrencyLimit?: InputMaybe<Scalars['Int']>;
  deleteEvents?: InputMaybe<Scalars['Boolean']>;
  deleteParticipantEvents?: InputMaybe<Scalars['Boolean']>;
  deleteParticipations?: InputMaybe<Scalars['Boolean']>;
  deleteScheduleTimeframes?: InputMaybe<Scalars['Boolean']>;
  deleteSchedules?: InputMaybe<Scalars['Boolean']>;
  metaSiteIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixCalendarMigrationV3FixSched38956RequestInput = {
  /**
   * Whether to run in safe, dry run mode, and only print logs without applying any changes.
   * Default to `true`!.
   */
  dryRun?: InputMaybe<Scalars['Boolean']>;
  metaSiteId?: InputMaybe<Scalars['String']>;
};

export type WixCalendarMigrationV3FixSched38956Response = {
  affectedEventCount?: Maybe<Scalars['Int']>;
  dryRun?: Maybe<Scalars['Boolean']>;
  fixedEventCount?: Maybe<Scalars['Int']>;
};

export type WixCalendarMigrationV3MigrateSiteRequestInput = {
  /**
   * Whether to run in safe, dry run mode, and only print logs without applying any changes.
   * Default to `true`.
   */
  dryRun?: InputMaybe<Scalars['Boolean']>;
  metaSiteId?: InputMaybe<Scalars['String']>;
  /**
   * Whether to skip the migration if target data is already present.
   * Default to `true`.
   */
  skipIfTargetDataPresent?: InputMaybe<Scalars['Boolean']>;
};

export type WixCalendarMigrationV3MigrateSiteResponse = {
  dryRun?: Maybe<Scalars['Boolean']>;
  skipped?: Maybe<Scalars['Boolean']>;
};

export type WixCalendarParticipanteventsV3ListEventsByContactIdRequestInput = {
  /**
   * [App ID](https://dev.wix.com/docs/rest/articles/getting-started/wix-business-solutions)
   * to filter events by.
   */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * ID of the [contact](https://dev.wix.com/docs/rest/crm/members-contacts/contacts/contacts/contact-v4/contact-object)
   * to retrieve events for. Required, unless you provide `cursorPaging`.
   */
  contactId?: InputMaybe<Scalars['String']>;
  /** Cursor to retrieve the next page of the results. */
  cursorPaging?: InputMaybe<WixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingInput>;
  /**
   * Local start date and time from which events are returned in
   * [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) format. For example,
   * `2024-01-30T13:30:00`. Required if `cursorPaging` isn't provided.
   *
   * Events that start before the `fromLocalDate` but end after it are included in
   * the results. Must be earlier than `toLocalDate`.
   */
  fromLocalDate?: InputMaybe<Scalars['String']>;
  /**
   * Time zone in [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database)
   * for `fromLocalDate`, `toLocalDate`, and for calculating `adjustedStart` and
   * `adjustedEnd`. For example, `America/New_York` or `UTC`.
   *
   * Default: `timeZone` specified in the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   */
  timeZone?: InputMaybe<Scalars['String']>;
  /**
   * Local end date and time up to which events are returned in
   * [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) format. For example,
   * `2024-01-30T13:30:00`. Can't be more than a full year after
   * `2024-01-30T13:30:00`. Required if `cursorPaging` isn't provided.
   *
   * Events that start before `toLocalDate` but end after it are included in the
   * results. Must be later than `fromLocalDate`.
   */
  toLocalDate?: InputMaybe<Scalars['String']>;
};

export type WixCalendarParticipanteventsV3ListEventsByContactIdResponse = {
  /** Retrieved events. */
  events?: Maybe<Array<Maybe<WixCalendarEventsV3Event>>>;
  /** Paging metadata. */
  pagingMetadata?: Maybe<WixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingMetadata>;
};

export type WixCalendarParticipanteventsV3ListEventsByMemberIdRequestInput = {
  /**
   * [App ID](https://dev.wix.com/docs/rest/articles/getting-started/wix-business-solutions)
   * to filter events by.
   */
  appId?: InputMaybe<Scalars['String']>;
  /** Cursor to retrieve the next page of the results. */
  cursorPaging?: InputMaybe<WixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingInput>;
  /**
   * IDs of the events to retrieve.
   * If you provide a list of IDs, all other filters are ignored.
   *
   * Max: 100 `eventId`s
   */
  eventIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Local start date and time from which events are returned in
   * [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) format. For example,
   * `2024-01-30T13:30:00`. Required if neither `cursorPaging` is provided nor a non-empty `eventIds` array.
   *
   * Events that start before the `fromLocalDate` but end after it are included in
   * the results. Must be earlier than `toLocalDate`.
   */
  fromLocalDate?: InputMaybe<Scalars['String']>;
  /**
   * ID of the [member](https://dev.wix.com/docs/rest/crm/members-contacts/members/members/member-object)
   * to retrieve events for. Required, unless you provide `cursorPaging`.
   * Provide `me` to retrieve events for the currently logged-in member.
   * You must have the `Read Calendars - Including PI`
   * [permission scope](https://dev.wix.com/docs/build-apps/develop-your-app/access/authorization/configure-permissions-for-your-app)
   * to retrieve events for members who aren't the currently logged in member.
   */
  memberId?: InputMaybe<Scalars['String']>;
  /**
   * Time zone in [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database)
   * for `fromLocalDate`, `toLocalDate`, and for calculating `adjustedStart` and
   * `adjustedEnd`. For example, `America/New_York` or `UTC`.
   *
   * Default: `timeZone` specified in the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   */
  timeZone?: InputMaybe<Scalars['String']>;
  /**
   * Local end date and time up to which events are returned in
   * [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) format. For example,
   * `2024-01-30T13:30:00`. Can't be more than a full year after
   * `fromLocalDate`. Required if neither `cursorPaging` is provided nor a non-empty `eventIds` array.
   *
   * Events that start before `toLocalDate` but end after it are included in the
   * results. Must be later than `fromLocalDate`.
   */
  toLocalDate?: InputMaybe<Scalars['String']>;
};

export type WixCalendarParticipanteventsV3ListEventsByMemberIdResponse = {
  /** Retrieved events. */
  events?: Maybe<Array<Maybe<WixCalendarEventsV3Event>>>;
  /** Paging metadata. */
  pagingMetadata?: Maybe<WixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingMetadata>;
};

export type WixCalendarParticipanteventsV3ListParticipantEventsRequestInput = {
  /** Optional Wix app ID to filter events by. */
  appId?: InputMaybe<Scalars['String']>;
  /** The ID of the contact participating in the events. */
  contactId?: InputMaybe<Scalars['String']>;
  /** Optional cursor to the next events page. */
  cursorPaging?: InputMaybe<WixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingInput>;
  /**
   * Local start date for which events are returned, in ISO-8601 format.
   * E.g, `2024-01-01T00:00:00`.
   *
   * Required, unless `cursorPaging` is provided.
   */
  fromLocalDate?: InputMaybe<Scalars['String']>;
  /**
   * The ID of the member participating in the events.
   * Can be `me` for the currently logged-in member ID.
   */
  memberId?: InputMaybe<Scalars['String']>;
  /**
   * The time zone, in IANA time zone format.
   * Default is the Wix Business time zone.
   */
  timeZone?: InputMaybe<Scalars['String']>;
  /**
   * Local end date for which events are returned, in ISO-8601 format.
   * E.g, `2024-01-7T00:00:00`.
   *
   * Required, unless `cursorPaging` is provided.
   * Max: 1 year after `fromLocalDate`.
   */
  toLocalDate?: InputMaybe<Scalars['String']>;
};

export type WixCalendarParticipanteventsV3ListParticipantEventsResponse = {
  /** The participant events. */
  events?: Maybe<Array<Maybe<WixCalendarEventsV3Event>>>;
  /** Paging metadata. */
  pagingMetadata?: Maybe<WixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingMetadata>;
};

export type WixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /**
   * Number of events to return.
   * Defaults to `50`. Maximum `100`.
   */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixCalendarParticipanteventsV3UpstreamWixCommonCursorPagingMetadata = {
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Use these cursor to paginate between results. [Read more](https://dev.wix.com/api/rest/getting-started/api-query-language#getting-started_api-query-language_cursor-paging). */
  cursors?: Maybe<WixCalendarParticipanteventsV3UpstreamWixCommonCursors>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
};

export type WixCalendarParticipanteventsV3UpstreamWixCommonCursors = {
  /** Cursor pointing to next page in the list of results. */
  next?: Maybe<Scalars['String']>;
};

export type WixCalendarSchedulesV3CancelScheduleRequestInput = {
  /**
   * Information about whether participants of the schedule's updated events are
   * notified and the message they receive.
   */
  participantNotification?: InputMaybe<WixCalendarSchedulesV3ParticipantNotificationInput>;
  /**
   * Whether to preserve future events with participants.
   * Default: `false`.
   */
  preserveFutureEventsWithParticipants?: InputMaybe<Scalars['Boolean']>;
  /** ID of the schedule to cancel. */
  scheduleId?: InputMaybe<Scalars['String']>;
};

export type WixCalendarSchedulesV3CancelScheduleResponse = {
  /** Canceled schedule. */
  schedule?: Maybe<WixCalendarSchedulesV3Schedule>;
};

export type WixCalendarSchedulesV3CloneScheduleRequestInput = {
  /**
   * Optional fields to override.
   * For example, to set empty values for fields that would otherwise be cloned.
   */
  fieldmask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Fields to override in the cloned schedule. */
  schedule?: InputMaybe<WixCalendarSchedulesV3ScheduleInput>;
  /** ID of the schedule to clone. */
  scheduleId?: InputMaybe<Scalars['String']>;
};

export type WixCalendarSchedulesV3CloneScheduleResponse = {
  /** Cloned schedule. */
  schedule?: Maybe<WixCalendarSchedulesV3Schedule>;
};

export enum WixCalendarSchedulesV3ConferenceType {
  CUSTOM = 'CUSTOM',
  UNKNOWN_TYPE = 'UNKNOWN_TYPE',
  ZOOM = 'ZOOM'
}

export type WixCalendarSchedulesV3ConferencingDetails = {
  /**
   * Conference description.
   *
   * Min: 1 character
   * Max: 200 characters
   */
  description?: Maybe<Scalars['String']>;
  /**
   * Conference ID in an external system.
   *
   * Min: 1 character
   * Max: 150 characters
   */
  externalId?: Maybe<Scalars['String']>;
  /**
   * URL used by a guest to join the conference.
   *
   * Min: 1 character
   * Max: 2000 characters
   */
  guestUrl?: Maybe<Scalars['String']>;
  /**
   * URL used by the host to start the conference.
   *
   * Min: 1 character
   * Max: 2000 characters
   */
  hostUrl?: Maybe<Scalars['String']>;
  /**
   * Conference password.
   *
   * Min: 1 character
   * Max: 100 characters
   */
  password?: Maybe<Scalars['String']>;
  /** Conference type. For example, `Zoom`. */
  type?: Maybe<WixCalendarSchedulesV3ConferencingDetailsType>;
};

export type WixCalendarSchedulesV3ConferencingDetailsInput = {
  /**
   * Conference description.
   *
   * Min: 1 character
   * Max: 200 characters
   */
  description?: InputMaybe<Scalars['String']>;
  /**
   * Conference ID in an external system.
   *
   * Min: 1 character
   * Max: 150 characters
   */
  externalId?: InputMaybe<Scalars['String']>;
  /**
   * URL used by a guest to join the conference.
   *
   * Min: 1 character
   * Max: 2000 characters
   */
  guestUrl?: InputMaybe<Scalars['String']>;
  /**
   * URL used by the host to start the conference.
   *
   * Min: 1 character
   * Max: 2000 characters
   */
  hostUrl?: InputMaybe<Scalars['String']>;
  /**
   * Conference password.
   *
   * Min: 1 character
   * Max: 100 characters
   */
  password?: InputMaybe<Scalars['String']>;
  /** Conference type. For example, `Zoom`. */
  type?: InputMaybe<WixCalendarSchedulesV3ConferencingDetailsType>;
};

export enum WixCalendarSchedulesV3ConferencingDetailsType {
  CUSTOM = 'CUSTOM',
  UNKNOWN_TYPE = 'UNKNOWN_TYPE',
  ZOOM = 'ZOOM'
}

export type WixCalendarSchedulesV3CreateScheduleRequestInput = {
  /**
   * Idempotency key guaranteeing that you don't create the same schedule more
   * than once.
   */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** Schedule to create. */
  schedule?: InputMaybe<WixCalendarSchedulesV3ScheduleInput>;
};

export type WixCalendarSchedulesV3CreateScheduleResponse = {
  /** Created schedule. */
  schedule?: Maybe<WixCalendarSchedulesV3Schedule>;
};

export type WixCalendarSchedulesV3GetScheduleRequestInput = {
  /**
   * Information about which fields containing personal data to return. Refer to the
   * [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions)
   * for more information.
   *
   * Supported values:
   * + `PI_FIELDS`: Returns all fields with personal data. Your app must have `Read Calendars - Including PI` or `Manage Calendars` permission scope.
   * + `OWN_PI_FIELDS`: Returns only fields containing your own personal data.
   *
   * Max: 1 field
   * Default: No personal data is returned.
   */
  fields?: InputMaybe<Array<InputMaybe<WixCalendarSchedulesV3RequestedFieldsEnumRequestedFields>>>;
  id: Scalars['ID'];
};

export type WixCalendarSchedulesV3Location = {
  /**
   * Location address. For `BUSINESS` locations, it's identical to the
   * [location](https://dev.wix.com/docs/rest/business-management/locations/location-object)'s
   * `formattedAddress`.
   */
  address?: Maybe<Scalars['String']>;
  /**
   * [Location](https://dev.wix.com/docs/rest/business-management/locations/location-object)
   * ID. Available only for `BUSINESS` locations.
   */
  id?: Maybe<Scalars['String']>;
  /**
   * [Location](https://dev.wix.com/docs/rest/business-management/locations/location-object)
   * ID. Available only for `BUSINESS` locations.
   */
  location?: Maybe<ComWixpressLocationsLocation>;
  /**
   * Location name. For `BUSINESS` locations, it's identical to the
   * [location](https://dev.wix.com/docs/rest/business-management/locations/location-object)
   * `name`.
   *
   * Min: 1 character
   * Max: 150 characters
   */
  name?: Maybe<Scalars['String']>;
  /**
   * Location type.
   *
   * Supported values:
   * + `BUSINESS`: The event is held at a business location.
   * + `CUSTOMER`: The event is held at the customer's location, such as their home or office.
   * + `CUSTOM`: The event is held at an address or venue not tied to the business or customer.
   */
  type?: Maybe<WixCalendarSchedulesV3LocationType>;
};

export type WixCalendarSchedulesV3LocationInput = {
  /**
   * Location address. For `BUSINESS` locations, it's identical to the
   * [location](https://dev.wix.com/docs/rest/business-management/locations/location-object)'s
   * `formattedAddress`.
   */
  address?: InputMaybe<Scalars['String']>;
  /**
   * [Location](https://dev.wix.com/docs/rest/business-management/locations/location-object)
   * ID. Available only for `BUSINESS` locations.
   */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Location name. For `BUSINESS` locations, it's identical to the
   * [location](https://dev.wix.com/docs/rest/business-management/locations/location-object)
   * `name`.
   *
   * Min: 1 character
   * Max: 150 characters
   */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Location type.
   *
   * Supported values:
   * + `BUSINESS`: The event is held at a business location.
   * + `CUSTOMER`: The event is held at the customer's location, such as their home or office.
   * + `CUSTOM`: The event is held at an address or venue not tied to the business or customer.
   */
  type?: InputMaybe<WixCalendarSchedulesV3LocationType>;
};

export enum WixCalendarSchedulesV3LocationType {
  /** The event is held at a business location. */
  BUSINESS = 'BUSINESS',
  /** The event is held at an address or venue not tied to the business or customer. */
  CUSTOM = 'CUSTOM',
  /** The event is held at the customer's location, such as their home or office. */
  CUSTOMER = 'CUSTOMER',
  UNKNOWN_TYPE = 'UNKNOWN_TYPE'
}

export type WixCalendarSchedulesV3ParticipantNotificationInput = {
  /**
   * Message to send.
   *
   * Min: 1 character
   * Max: 5000 characters
   */
  message?: InputMaybe<Scalars['String']>;
  /**
   * Optional additional metadata.
   * Limits: max keys: `10`, max key length: `64`, max value length: `1000`.
   */
  metadata?: InputMaybe<Scalars['JSON']>;
  /**
   * Whether to notify the participants about changes made to the schedule or event.
   *
   * Default: `false`
   */
  notifyParticipants?: InputMaybe<Scalars['Boolean']>;
};

export type WixCalendarSchedulesV3Permission = {
  /**
   * [Wix user](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities#wix-users)
   * granted the permission.
   */
  identity?: Maybe<WixCalendarSchedulesV3UpstreamWixCommonIdentificationData>;
  /**
   * Permission role.
   *
   * Supported values:
   * + `WRITER`: Full read and write access.
   * + `COMMENTER`: Full read access, write access limited to `event.notes`.
   */
  role?: Maybe<WixCalendarSchedulesV3PermissionRole>;
};

export type WixCalendarSchedulesV3PermissionInput = {
  /**
   * [Wix user](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities#wix-users)
   * granted the permission.
   */
  identity?: InputMaybe<WixCalendarSchedulesV3UpstreamWixCommonIdentificationDataInput>;
  /**
   * Permission role.
   *
   * Supported values:
   * + `WRITER`: Full read and write access.
   * + `COMMENTER`: Full read access, write access limited to `event.notes`.
   */
  role?: InputMaybe<WixCalendarSchedulesV3PermissionRole>;
};

export enum WixCalendarSchedulesV3PermissionRole {
  /** Full read access, write access limited to `event.notes`. */
  COMMENTER = 'COMMENTER',
  UNKNOWN_ROLE = 'UNKNOWN_ROLE',
  /** Full read and write access. */
  WRITER = 'WRITER'
}

export type WixCalendarSchedulesV3QuerySchedulesRequestInput = {
  /**
   * Whether to return consistent response.
   * Please consult with us at #bookings-calendar-platform if you think your case requires consistent reads.
   */
  consistent?: InputMaybe<Scalars['Boolean']>;
  /**
   * Information about which fields containing personal data to return. Refer to the
   * [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions)
   * for more information.
   *
   * Supported values:
   * + `PI_FIELDS`: Returns all fields with personal data. Your app must have `Read Calendars - Including PI` or `Manage Calendars` permission scope.
   * + `OWN_PI_FIELDS`: Returns only fields containing your own personal data.
   *
   * Max: 1 field
   * Default: No personal data is returned.
   */
  fields?: InputMaybe<Array<InputMaybe<WixCalendarSchedulesV3RequestedFieldsEnumRequestedFields>>>;
  /** Query containing filters and paging. */
  query?: InputMaybe<WixCalendarSchedulesV3UpstreamWixCommonCursorQueryInput>;
};

export type WixCalendarSchedulesV3QuerySchedulesResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<WixCalendarSchedulesV3Schedule>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export enum WixCalendarSchedulesV3RequestedFieldsEnumRequestedFields {
  /** Returns only fields containing your own personal data. */
  OWN_PI_FIELDS = 'OWN_PI_FIELDS',
  /** Returns all fields with personal data. Your app must have `Read Calendars - Including PI` or `Manage Calendars` permission scope. */
  PI_FIELDS = 'PI_FIELDS',
  UNKNOWN_REQUESTED_FIELDS = 'UNKNOWN_REQUESTED_FIELDS'
}

export type WixCalendarSchedulesV3Schedule = {
  /**
   * ID of the app that's associated with the schedule. You can't update `appId`.
   * If you want to create a schedule and ensure its associated events appear
   * in the [Bookings calendar](https://support.wix.com/en/article/wix-bookings-about-the-wix-booking-calendar),
   * you must provide the [Wix Bookings app ID](https://dev.wix.com/docs/rest/articles/getting-started/wix-business-solutions)
   * `13d21c63-b5ec-5912-8397-c3a5ddb27a97`.
   */
  appId?: Maybe<Scalars['String']>;
  /**
   * Whether the schedule's `timeZone` is automatically synced from
   * `timeZone` of the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   *
   * Default: `true`
   */
  businessTimeZoneEnabled?: Maybe<Scalars['Boolean']>;
  /** Date the schedule was created in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  createdDate?: Maybe<Scalars['String']>;
  /**
   * Default `totalCapacity` for [events](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/event-object)
   * that are added to the schedule.
   *
   * Min: `0`
   */
  defaultCapacity?: Maybe<Scalars['Int']>;
  /**
   * Default `conferencingDetails` for [events](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/event-object)
   * that are added to the schedule.
   * Returned only if explicitly requested. For more details, see the [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions#retrieve-personal-information).
   */
  defaultConferencingDetails?: Maybe<WixCalendarSchedulesV3ConferencingDetails>;
  /**
   * Default `location` for [events](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/event-object)
   * that are added to the schedule.
   */
  defaultLocation?: Maybe<WixCalendarSchedulesV3Location>;
  /**
   * Default `title` for [events](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/event-object)
   * that are added to the schedule.
   *
   * Min: 1 character
   * Max: 200 characters
   */
  defaultTitle?: Maybe<Scalars['String']>;
  eventsVirtualReference?: Maybe<WixCalendarEventsV3QueryEventsResponse>;
  /** Extensions enabling applications or users to save custom data related to the schedule. */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /**
   * External ID. You can't update the external ID.
   *
   * If the schedule belongs to a Bookings staff member, identical to the ID of
   * the [resource](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members-and-resources/resource-v2/resource-object).
   * If the schedule belongs to a Bookings service, identical to the ID of
   * the [service](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/service-object).
   */
  externalId?: Maybe<Scalars['String']>;
  /** Schedule ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Schedule name.
   *
   * Min: 1 character
   * Max: 200 characters
   */
  name?: Maybe<Scalars['String']>;
  /**
   * List of permissions associated with the schedule. Refer to the
   * [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions#roles)
   * for more information.
   *
   * Max: 1 permission
   */
  permissions?: Maybe<Array<Maybe<WixCalendarSchedulesV3Permission>>>;
  /**
   * Revision number, which increments by 1 each time the schedule is updated.
   * To prevent conflicting changes, the current revision must be passed when updating the schedule.
   * Ignored when creating a schedule.
   */
  revision?: Maybe<Scalars['Long']>;
  /**
   * Schedule status.
   *
   * Supported values:
   * - `ACTIVE`: You can add events to the schedule or update its fields.
   * - `CANCELLED`: You can't add events to the schedule or update its fields.
   *
   * Default: `ACTIVE`
   */
  status?: Maybe<WixCalendarSchedulesV3ScheduleStatus>;
  /**
   * Time zone the schedule is associated with in
   * [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database).
   * For example, `America/New_York`.
   *
   * Default: `timeZone` specified in the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   *
   * Min: 1 character
   * Max: 150 characters
   */
  timeZone?: Maybe<Scalars['String']>;
  /** Date the schedule was last updated in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  updatedDate?: Maybe<Scalars['String']>;
};


export type WixCalendarSchedulesV3ScheduleEventsVirtualReferenceArgs = {
  queryInput?: InputMaybe<WixCalendarEventsV3QueryEventsRequestInput>;
};

export type WixCalendarSchedulesV3ScheduleInput = {
  /**
   * ID of the app that's associated with the schedule. You can't update `appId`.
   * If you want to create a schedule and ensure its associated events appear
   * in the [Bookings calendar](https://support.wix.com/en/article/wix-bookings-about-the-wix-booking-calendar),
   * you must provide the [Wix Bookings app ID](https://dev.wix.com/docs/rest/articles/getting-started/wix-business-solutions)
   * `13d21c63-b5ec-5912-8397-c3a5ddb27a97`.
   */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * Whether the schedule's `timeZone` is automatically synced from
   * `timeZone` of the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   *
   * Default: `true`
   */
  businessTimeZoneEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Date the schedule was created in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  createdDate?: InputMaybe<Scalars['String']>;
  /**
   * Default `totalCapacity` for [events](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/event-object)
   * that are added to the schedule.
   *
   * Min: `0`
   */
  defaultCapacity?: InputMaybe<Scalars['Int']>;
  /**
   * Default `conferencingDetails` for [events](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/event-object)
   * that are added to the schedule.
   * Returned only if explicitly requested. For more details, see the [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions#retrieve-personal-information).
   */
  defaultConferencingDetails?: InputMaybe<WixCalendarSchedulesV3ConferencingDetailsInput>;
  /**
   * Default `location` for [events](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/event-object)
   * that are added to the schedule.
   */
  defaultLocation?: InputMaybe<WixCalendarSchedulesV3LocationInput>;
  /**
   * Default `title` for [events](https://dev.wix.com/docs/rest/business-management/calendar/events-v3/event-object)
   * that are added to the schedule.
   *
   * Min: 1 character
   * Max: 200 characters
   */
  defaultTitle?: InputMaybe<Scalars['String']>;
  /** Extensions enabling applications or users to save custom data related to the schedule. */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /**
   * External ID. You can't update the external ID.
   *
   * If the schedule belongs to a Bookings staff member, identical to the ID of
   * the [resource](https://dev.wix.com/docs/rest/business-solutions/bookings/staff-members-and-resources/resource-v2/resource-object).
   * If the schedule belongs to a Bookings service, identical to the ID of
   * the [service](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/service-object).
   */
  externalId?: InputMaybe<Scalars['String']>;
  /** Schedule ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Schedule name.
   *
   * Min: 1 character
   * Max: 200 characters
   */
  name?: InputMaybe<Scalars['String']>;
  /**
   * List of permissions associated with the schedule. Refer to the
   * [permissions article](https://dev.wix.com/docs/rest/business-management/calendar/permissions#roles)
   * for more information.
   *
   * Max: 1 permission
   */
  permissions?: InputMaybe<Array<InputMaybe<WixCalendarSchedulesV3PermissionInput>>>;
  /**
   * Revision number, which increments by 1 each time the schedule is updated.
   * To prevent conflicting changes, the current revision must be passed when updating the schedule.
   * Ignored when creating a schedule.
   */
  revision?: InputMaybe<Scalars['Long']>;
  /**
   * Schedule status.
   *
   * Supported values:
   * - `ACTIVE`: You can add events to the schedule or update its fields.
   * - `CANCELLED`: You can't add events to the schedule or update its fields.
   *
   * Default: `ACTIVE`
   */
  status?: InputMaybe<WixCalendarSchedulesV3ScheduleStatus>;
  /**
   * Time zone the schedule is associated with in
   * [IANA tz database format](https://en.wikipedia.org/wiki/Tz_database).
   * For example, `America/New_York`.
   *
   * Default: `timeZone` specified in the business [site properties](https://dev.wix.com/docs/rest/business-management/site-properties/properties/get-site-properties).
   *
   * Min: 1 character
   * Max: 150 characters
   */
  timeZone?: InputMaybe<Scalars['String']>;
  /** Date the schedule was last updated in `YYYY-MM-DDThh:mm:ss.sssZ` format. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export enum WixCalendarSchedulesV3ScheduleStatus {
  /** You can add events to the schedule or update its fields. */
  ACTIVE = 'ACTIVE',
  /** You can't add events to the schedule or update its fields. */
  CANCELLED = 'CANCELLED',
  UNKNOWN_STATUS = 'UNKNOWN_STATUS'
}

export type WixCalendarSchedulesV3UpdateScheduleRequestInput = {
  /** Optional list of fields to update. */
  fieldmask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Information about whether participants of the schedule's updated events are
   * notified and the message they receive.
   */
  participantNotification?: InputMaybe<WixCalendarSchedulesV3ParticipantNotificationInput>;
  /** Schedule to update. */
  schedule?: InputMaybe<WixCalendarSchedulesV3ScheduleInput>;
};

export type WixCalendarSchedulesV3UpdateScheduleResponse = {
  /** Updated schedule. */
  schedule?: Maybe<WixCalendarSchedulesV3Schedule>;
};

export type WixCalendarSchedulesV3UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /**
   * Number of schedules to return.
   *
   * Min: `1`
   * Max: `100`
   * Default: `50`
   */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixCalendarSchedulesV3UpstreamWixCommonCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter`. */
  cursorPaging?: InputMaybe<WixCalendarSchedulesV3UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object.
   * See [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language)
   * for more information.
   *
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`.
   *
   * For a detailed list of supported filters, see Supported Filters.
   */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type WixCalendarSchedulesV3UpstreamWixCommonIdentificationData = {
  identityType?: Maybe<WixCalendarSchedulesV3UpstreamWixCommonIdentificationDataIdentityType>;
  /**
   * ID of a Wix user. For example, the site owner or a
   * [site collaborator](https://support.wix.com/en/article/inviting-people-to-contribute-to-your-site).
   */
  wixUserId?: Maybe<Scalars['String']>;
};

export enum WixCalendarSchedulesV3UpstreamWixCommonIdentificationDataIdentityType {
  UNKNOWN = 'UNKNOWN',
  WIX_USER = 'WIX_USER'
}

export type WixCalendarSchedulesV3UpstreamWixCommonIdentificationDataInput = {
  identityType?: InputMaybe<WixCalendarSchedulesV3UpstreamWixCommonIdentificationDataIdentityType>;
  /**
   * ID of a Wix user. For example, the site owner or a
   * [site collaborator](https://support.wix.com/en/article/inviting-people-to-contribute-to-your-site).
   */
  wixUserId?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1AddProductMediaRequestInput = {
  /** Product ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Sources of media items already uploaded to the Wix site. */
  media?: InputMaybe<Array<InputMaybe<WixCatalogApiV1MediaDataForWriteInput>>>;
};

export type WixCatalogApiV1AddProductMediaToChoicesRequestInput = {
  /** Product ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Product media items and the choices to add the media to. */
  media?: InputMaybe<Array<InputMaybe<WixCatalogApiV1MediaAssignmentToChoiceInput>>>;
};

export type WixCatalogApiV1AddProductsToCollectionRequestInput = {
  /** Collection ID. */
  id?: InputMaybe<Scalars['String']>;
  /** IDs of the products to add to the collection, separated by commas. */
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixCatalogApiV1AdditionalInfoSection = {
  /** Product info section description */
  description?: Maybe<Scalars['String']>;
  /** Product info section title */
  title?: Maybe<Scalars['String']>;
};

export type WixCatalogApiV1AdditionalInfoSectionInput = {
  /** Product info section description */
  description?: InputMaybe<Scalars['String']>;
  /** Product info section title */
  title?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1AdjustValueInput = {
  /**
   * Adjust product cost of goods.
   * If [variant management](https://support.wix.com/en/article/wix-stores-adding-and-customizing-product-options#setting-different-prices-for-variants) is enabled,
   * cost of goods will be adjusted per variant.
   */
  cost?: InputMaybe<WixCatalogApiV1PropertyAdjustmentDataInput>;
  /**
   * Adjust product price.
   * If [variant management](https://support.wix.com/en/article/wix-stores-adding-and-customizing-product-options#setting-different-prices-for-variants) is enabled,
   * variants prices will be calculated according to the adjusted price.
   * If variant price is negative after the adjustment, the update will fail.
   */
  price?: InputMaybe<WixCatalogApiV1PropertyAdjustmentDataInput>;
  /**
   * Adjust product weight.
   * If [variant management](https://support.wix.com/en/article/wix-stores-adding-and-customizing-product-options#setting-different-prices-for-variants) is enabled,
   * weight will be adjusted per variant.
   */
  weight?: InputMaybe<WixCatalogApiV1PropertyAdjustmentDataInput>;
};

export type WixCatalogApiV1AggregateProductsRequestInput = {
  /** This is an object defining aggregation itself */
  aggregation?: InputMaybe<Scalars['JSON']>;
  /** Filter applied to original data */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Whether hidden products should be considered. Requires permissions to manage products. */
  includeHiddenProducts?: InputMaybe<Scalars['Boolean']>;
  /** Whether merchant specific data should be included in the response. Requires permissions to manage products. */
  includeMerchantSpecificData?: InputMaybe<Scalars['Boolean']>;
};

export type WixCatalogApiV1AggregateProductsResponse = {
  aggregates?: Maybe<Scalars['JSON']>;
};

export type WixCatalogApiV1BulkAdjustProductPropertiesByFilterSyncRequestInput = {
  /** Numerical property to adjust. */
  adjust?: InputMaybe<WixCatalogApiV1AdjustValueInput>;
  /** Filter object. Learn more about supported filters [here](https://bo.wix.com/wix-docs/rest/stores/stores-catalog/filter-and-sort). */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type WixCatalogApiV1BulkAdjustProductPropertiesByFilterSyncResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Items updated by bulk action. */
  results?: Maybe<Array<Maybe<WixCatalogApiV1BulkProductResult>>>;
};

export type WixCatalogApiV1BulkAdjustProductPropertiesRequestInput = {
  /** Numerical property to adjust. */
  adjust?: InputMaybe<WixCatalogApiV1AdjustValueInput>;
  /** Product IDs. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixCatalogApiV1BulkAdjustProductPropertiesResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Bulk action results. */
  results?: Maybe<Array<Maybe<WixCatalogApiV1BulkProductResult>>>;
};

export type WixCatalogApiV1BulkDeleteProductsRequestInput = {
  /** IDs of the products to be deleted. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixCatalogApiV1BulkProductResult = {
  /** Item metadata. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixCatalogApiV1BulkQueryCustomFieldsRequestInput = {
  /** Requested field names. */
  names?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter string. */
  query?: InputMaybe<WixCatalogApiV1QueryInput>;
};

export type WixCatalogApiV1BulkQueryCustomFieldsResponse = {
  metadata?: Maybe<WixCatalogApiV1PagingMetadata>;
  /** ProductId to Custom Fields Map packed in container. */
  productIdToCustomFields?: Maybe<WixCatalogApiV1CustomFieldsContainer>;
  totalResults?: Maybe<Scalars['Int']>;
};

export type WixCatalogApiV1BulkRemoveCustomFieldsRequestInput = {
  /** Filter string. */
  filter?: InputMaybe<Scalars['String']>;
  /** Custom fields names. */
  names?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixCatalogApiV1BulkSetCustomFieldsRequestInput = {
  /** Custom field that will be added, if a custom field with same name already exists, the value of the custom field will be overridden. */
  customFields?: InputMaybe<Scalars['JSON']>;
  /** Filter string. */
  filter?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1BulkUpdateProductsByFilterSyncRequestInput = {
  /** Filter object. Learn more about supported filters [here](https://bo.wix.com/wix-docs/rest/stores/stores-catalog/filter-and-sort). */
  filter?: InputMaybe<Scalars['JSON']>;
  /** The field to update. */
  set?: InputMaybe<WixCatalogApiV1SetValueInput>;
};

export type WixCatalogApiV1BulkUpdateProductsByFilterSyncResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Items updated by bulk action. */
  results?: Maybe<Array<Maybe<WixCatalogApiV1BulkProductResult>>>;
};

export type WixCatalogApiV1BulkUpdateProductsRequestInput = {
  /** Product IDs. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field to update. */
  set?: InputMaybe<WixCatalogApiV1SetValueInput>;
};

export type WixCatalogApiV1BulkUpdateProductsResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Bulk action results. */
  results?: Maybe<Array<Maybe<WixCatalogApiV1BulkProductResult>>>;
};

export type WixCatalogApiV1Choice = {
  /** Choice description. */
  description?: Maybe<Scalars['String']>;
  /** Based on the customer’s choices, which (if any) variants that include the selected choices are in stock */
  inStock?: Maybe<Scalars['Boolean']>;
  /** Media items (images, videos) associated with this choice */
  media?: Maybe<WixCatalogApiV1Media>;
  /** Choice value. */
  value?: Maybe<Scalars['String']>;
  /** Based on the customer’s choices, which (if any) variants that include the selected choices are visible */
  visible?: Maybe<Scalars['Boolean']>;
};

export type WixCatalogApiV1ChoiceInput = {
  /** Choice description. */
  description?: InputMaybe<Scalars['String']>;
  /** Based on the customer’s choices, which (if any) variants that include the selected choices are in stock */
  inStock?: InputMaybe<Scalars['Boolean']>;
  /** Media items (images, videos) associated with this choice */
  media?: InputMaybe<WixCatalogApiV1MediaInput>;
  /** Choice value. */
  value?: InputMaybe<Scalars['String']>;
  /** Based on the customer’s choices, which (if any) variants that include the selected choices are visible */
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type WixCatalogApiV1Collection = {
  /** Collection description. */
  description?: Maybe<Scalars['String']>;
  /** Collection ID (generated automatically by the catalog). */
  id?: Maybe<Scalars['String']>;
  /** Date and time the collection was updated. */
  lastUpdated?: Maybe<Scalars['String']>;
  /** Media items (images, videos etc) associated with this collection. Read only. */
  media?: Maybe<WixCatalogApiV1Media>;
  /** Collection name. */
  name?: Maybe<Scalars['String']>;
  /** Number of products in the collection. Read only. */
  numberOfProducts?: Maybe<Scalars['Int']>;
  productsVirtualReference?: Maybe<WixCatalogApiV1QueryProductsPlatformizedResponse>;
  /** Custom SEO data for the collection. */
  seoSchema?: Maybe<ComWixpressAdvancedSeoSeoSchema>;
  /** Collection slug. */
  slug?: Maybe<Scalars['String']>;
  /** Collection visibility. Only impacts dynamic pages, no impact on static pages. Default: `true`. */
  visible?: Maybe<Scalars['Boolean']>;
};


export type WixCatalogApiV1CollectionProductsVirtualReferenceArgs = {
  queryInput?: InputMaybe<WixCatalogApiV1QueryProductsPlatformizedRequestInput>;
};

export type WixCatalogApiV1CollectionInput = {
  /** Collection description. */
  description?: InputMaybe<Scalars['String']>;
  /** Collection ID (generated automatically by the catalog). */
  id?: InputMaybe<Scalars['String']>;
  /** Date and time the collection was updated. */
  lastUpdated?: InputMaybe<Scalars['String']>;
  /** Media items (images, videos etc) associated with this collection. Read only. */
  media?: InputMaybe<WixCatalogApiV1MediaInput>;
  /** Collection name. */
  name?: InputMaybe<Scalars['String']>;
  /** Number of products in the collection. Read only. */
  numberOfProducts?: InputMaybe<Scalars['Int']>;
  /** Custom SEO data for the collection. */
  seoSchema?: InputMaybe<ComWixpressAdvancedSeoSeoSchemaInput>;
  /** Collection slug. */
  slug?: InputMaybe<Scalars['String']>;
  /** Collection visibility. Only impacts dynamic pages, no impact on static pages. Default: `true`. */
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type WixCatalogApiV1CostAndProfitData = {
  /** Item cost formatted with currency symbol. */
  formattedItemCost?: Maybe<Scalars['String']>;
  /** Profit formatted with currency symbol. */
  formattedProfit?: Maybe<Scalars['String']>;
  /** Item cost. */
  itemCost?: Maybe<Scalars['Float']>;
  /** Profit. Calculated by reducing `cost` from `discounted_price`. */
  profit?: Maybe<Scalars['Float']>;
  /**
   * Profit Margin. Calculated by dividing `profit` by `discounted_price`.
   * The result is rounded to 4 decimal places.
   */
  profitMargin?: Maybe<Scalars['Float']>;
};

export type WixCatalogApiV1CostAndProfitDataInput = {
  /** Item cost formatted with currency symbol. */
  formattedItemCost?: InputMaybe<Scalars['String']>;
  /** Profit formatted with currency symbol. */
  formattedProfit?: InputMaybe<Scalars['String']>;
  /** Item cost. */
  itemCost?: InputMaybe<Scalars['Float']>;
  /** Profit. Calculated by reducing `cost` from `discounted_price`. */
  profit?: InputMaybe<Scalars['Float']>;
  /**
   * Profit Margin. Calculated by dividing `profit` by `discounted_price`.
   * The result is rounded to 4 decimal places.
   */
  profitMargin?: InputMaybe<Scalars['Float']>;
};

export type WixCatalogApiV1CreateCollectionRequestInput = {
  /** Collection info. */
  collection?: InputMaybe<WixCatalogApiV1CollectionInput>;
};

export type WixCatalogApiV1CreateCollectionResponse = {
  /** Collection. */
  collection?: Maybe<WixCatalogApiV1Collection>;
};

export type WixCatalogApiV1CreateDigitalProductRequestInput = {
  /** Product information. */
  product?: InputMaybe<WixCatalogApiV1ProductInput>;
};

export type WixCatalogApiV1CreateDigitalProductResponse = {
  /** Created product. */
  product?: Maybe<WixCatalogApiV1Product>;
};

export type WixCatalogApiV1CreateProductPlatformizedRequestInput = {
  /** Product information. */
  product?: InputMaybe<WixCatalogApiV1ProductInput>;
};

export type WixCatalogApiV1CreateProductPlatformizedResponse = {
  product?: Maybe<WixCatalogApiV1Product>;
};

export type WixCatalogApiV1CreateProductRequestInput = {
  /** Product information. */
  product?: InputMaybe<WixCatalogApiV1ProductInput>;
};

export type WixCatalogApiV1CreateProductResponse = {
  product?: Maybe<WixCatalogApiV1Product>;
};

export type WixCatalogApiV1CustomFieldsContainer = {
  customFields?: Maybe<Scalars['JSON']>;
};

export type WixCatalogApiV1CustomTextField = {
  /** Whether this text box is mandatory */
  mandatory?: Maybe<Scalars['Boolean']>;
  /** Text box input max length */
  maxLength?: Maybe<Scalars['Int']>;
  /** Text box title */
  title?: Maybe<Scalars['String']>;
};

export type WixCatalogApiV1CustomTextFieldInput = {
  /** Whether this text box is mandatory */
  mandatory?: InputMaybe<Scalars['Boolean']>;
  /** Text box input max length */
  maxLength?: InputMaybe<Scalars['Int']>;
  /** Text box title */
  title?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1DeleteCollectionRequestInput = {
  /** ID of the collection to delete. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1DeleteProductOptionsRequestInput = {
  /** ID of the product with options to delete. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1DeleteProductPlatformizedRequestInput = {
  /** ID of the product to delete. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1DeleteProductRequestInput = {
  /** ID of the product to delete. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1Discount = {
  /**
   * Discount type:
   * + `"AMOUNT"`
   * + `"PERCENT"`
   */
  type?: Maybe<WixCatalogApiV1DiscountDiscountType>;
  /** Discount value */
  value?: Maybe<Scalars['Float']>;
};

export enum WixCatalogApiV1DiscountDiscountType {
  /** Discount by a fixed amount */
  AMOUNT = 'AMOUNT',
  /** No discount */
  NONE = 'NONE',
  /** Discount by a percentage */
  PERCENT = 'PERCENT',
  UNDEFINED = 'UNDEFINED'
}

export type WixCatalogApiV1DiscountInput = {
  /**
   * Discount type:
   * + `"AMOUNT"`
   * + `"PERCENT"`
   */
  type?: InputMaybe<WixCatalogApiV1DiscountDiscountType>;
  /** Discount value */
  value?: InputMaybe<Scalars['Float']>;
};

export type WixCatalogApiV1FormattedPrice = {
  /** Discounted product price formatted with the currency (if no discounted price is set, the product formatted price is returned) */
  discountedPrice?: Maybe<Scalars['String']>;
  /** Product price formatted with the currency */
  price?: Maybe<Scalars['String']>;
  /** Price per unit */
  pricePerUnit?: Maybe<Scalars['String']>;
};

export type WixCatalogApiV1FormattedPriceInput = {
  /** Discounted product price formatted with the currency (if no discounted price is set, the product formatted price is returned) */
  discountedPrice?: InputMaybe<Scalars['String']>;
  /** Product price formatted with the currency */
  price?: InputMaybe<Scalars['String']>;
  /** Price per unit */
  pricePerUnit?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1GetCollectionBySlugRequestInput = {
  /** Slug of the collection to retrieve. */
  slug?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1GetCollectionBySlugResponse = {
  /** The requested collection. */
  collection?: Maybe<WixCatalogApiV1Collection>;
};

export type WixCatalogApiV1GetCollectionRequestInput = {
  /** Requested collection ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Whether to return the `collection.numberOfProducts` field in the response.
   * Defaults to `false`, in which case the value of `collection.numberOfProducts` will be `0`.
   */
  includeNumberOfProducts?: InputMaybe<Scalars['Boolean']>;
};

export type WixCatalogApiV1GetCollectionResponse = {
  /** The requested collection. */
  collection?: Maybe<WixCatalogApiV1Collection>;
};

export type WixCatalogApiV1GetProductRequestInput = {
  id: Scalars['ID'];
  /** Whether merchant specific data, such as cost and profit data, should be included in the response. Requires permissions to manage products. */
  includeMerchantSpecificData?: InputMaybe<Scalars['Boolean']>;
};

export type WixCatalogApiV1GetProductResponse = {
  /** Requested product data. */
  product?: Maybe<WixCatalogApiV1Product>;
};

export type WixCatalogApiV1GetProductsRequestInput = {
  /** Requested product IDs. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixCatalogApiV1GetProductsResponse = {
  products?: Maybe<Array<Maybe<WixCatalogApiV1Product>>>;
};

export type WixCatalogApiV1GetStoreVariantRequestInput = {
  /** Store variant ID. Comprised of the `productId` and the `variantId`, separated by a hyphen. For example, `{productId}-{variantId}`. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1GetStoreVariantResponse = {
  /** The requested store variant. */
  variant?: Maybe<WixCatalogApiV1StoreVariant>;
};

export type WixCatalogApiV1Media = {
  /** Media (images, videos etc) associated with this product. */
  items?: Maybe<Array<Maybe<WixCatalogApiV1MediaItem>>>;
  /** Primary media (image, video etc) associated with this product. */
  mainMedia?: Maybe<WixCatalogApiV1MediaItem>;
};

export type WixCatalogApiV1MediaAssignmentToChoiceInput = {
  /** Choice name. */
  choice?: InputMaybe<Scalars['String']>;
  /** Media IDs (available via the Query Product endpoint). */
  mediaIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Option name. */
  option?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1MediaDataForWriteInput = {
  /**
   * Assign this media item to a specific product choice.
   * Note that you may set media items for choices under only one option (e.g., if Colors blue, green, and red have media items, Sizes S, M, and L can't have media items assigned to them).
   * You may clear existing media from choices with the [Remove Product Media From Choices](/catalog/products/remove-product-media-from-choices).
   */
  choice?: InputMaybe<WixCatalogApiV1MediaDataForWriteOptionAndChoiceInput>;
  /** Media ID. For media items previously saved in Wix Media, the media ID is returned in the Query Product response. */
  mediaId?: InputMaybe<Scalars['String']>;
  /** Media external URL (for new media items). */
  url?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1MediaDataForWriteOptionAndChoiceInput = {
  /** Choice to add the media to. */
  choice?: InputMaybe<Scalars['String']>;
  /** Option to add the media to. */
  option?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1MediaInput = {
  /** Media (images, videos etc) associated with this product. */
  items?: InputMaybe<Array<InputMaybe<WixCatalogApiV1MediaItemInput>>>;
  /** Primary media (image, video etc) associated with this product. */
  mainMedia?: InputMaybe<WixCatalogApiV1MediaItemInput>;
};

export type WixCatalogApiV1MediaItem = {
  /** Media ID (for example, `"nsplsh_306d666a123a4a74306459~mv2_d_4517_2992_s_4_2.jpg"`). */
  id?: Maybe<Scalars['String']>;
  /** Image data (URL, size). */
  image?: Maybe<WixCatalogApiV1MediaItemUrlAndSize>;
  /** Media item type (image, video, etc.). */
  mediaType?: Maybe<WixCatalogApiV1MediaItemType>;
  /** Media item thumbnail details. */
  thumbnail?: Maybe<WixCatalogApiV1MediaItemUrlAndSize>;
  /** Media item title. */
  title?: Maybe<Scalars['String']>;
  /** Video data (URL, size). */
  video?: Maybe<WixCatalogApiV1MediaItemVideo>;
};

export type WixCatalogApiV1MediaItemInput = {
  /** Media ID (for example, `"nsplsh_306d666a123a4a74306459~mv2_d_4517_2992_s_4_2.jpg"`). */
  id?: InputMaybe<Scalars['String']>;
  /** Image data (URL, size). */
  image?: InputMaybe<WixCatalogApiV1MediaItemUrlAndSizeInput>;
  /** Media item type (image, video, etc.). */
  mediaType?: InputMaybe<WixCatalogApiV1MediaItemType>;
  /** Media item thumbnail details. */
  thumbnail?: InputMaybe<WixCatalogApiV1MediaItemUrlAndSizeInput>;
  /** Media item title. */
  title?: InputMaybe<Scalars['String']>;
  /** Video data (URL, size). */
  video?: InputMaybe<WixCatalogApiV1MediaItemVideoInput>;
};

export enum WixCatalogApiV1MediaItemType {
  /** Audio media type. */
  audio = 'audio',
  /** Document media type. */
  document = 'document',
  /** Image media type. */
  image = 'image',
  unspecified_media_item_type = 'unspecified_media_item_type',
  /** Video media type. */
  video = 'video',
  /** Zip media type. */
  zip = 'zip'
}

export type WixCatalogApiV1MediaItemUrlAndSize = {
  /** Alt text. This text will be shown in case the image is not available. */
  altText?: Maybe<Scalars['String']>;
  /** Media format (mp4, png, etc.). */
  format?: Maybe<Scalars['String']>;
  /** Media item height. */
  height?: Maybe<Scalars['Int']>;
  /** Media item URL. */
  url?: Maybe<Scalars['String']>;
  /** Media item width. */
  width?: Maybe<Scalars['Int']>;
};

export type WixCatalogApiV1MediaItemUrlAndSizeInput = {
  /** Alt text. This text will be shown in case the image is not available. */
  altText?: InputMaybe<Scalars['String']>;
  /** Media format (mp4, png, etc.). */
  format?: InputMaybe<Scalars['String']>;
  /** Media item height. */
  height?: InputMaybe<Scalars['Int']>;
  /** Media item URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Media item width. */
  width?: InputMaybe<Scalars['Int']>;
};

export type WixCatalogApiV1MediaItemVideo = {
  /** Data (URL, size) about each resolution for which this video is available. */
  files?: Maybe<Array<Maybe<WixCatalogApiV1MediaItemUrlAndSize>>>;
  /** ID of an image taken from the video. Used primarily for Wix Search indexing. For example, `"nsplsh_306d666a123a4a74306459~mv2_d_4517_2992_s_4_2.jpg"`. */
  stillFrameMediaId?: Maybe<Scalars['String']>;
};

export type WixCatalogApiV1MediaItemVideoInput = {
  /** Data (URL, size) about each resolution for which this video is available. */
  files?: InputMaybe<Array<InputMaybe<WixCatalogApiV1MediaItemUrlAndSizeInput>>>;
  /** ID of an image taken from the video. Used primarily for Wix Search indexing. For example, `"nsplsh_306d666a123a4a74306459~mv2_d_4517_2992_s_4_2.jpg"`. */
  stillFrameMediaId?: InputMaybe<Scalars['String']>;
};

export enum WixCatalogApiV1OptionType {
  /** Color. */
  color = 'color',
  /** Drop down. */
  drop_down = 'drop_down',
  /** Unspecified option type. */
  unspecified_option_type = 'unspecified_option_type'
}

export type WixCatalogApiV1PageUrl = {
  /** Base URL. For premium sites, this is the domain. For free sites, this is the site URL (e.g mysite.wixsite.com/mysite). */
  base?: Maybe<Scalars['String']>;
  /** Path to the product page - e.g /product-page/a-product. */
  path?: Maybe<Scalars['String']>;
};

export type WixCatalogApiV1PageUrlInput = {
  /** Base URL. For premium sites, this is the domain. For free sites, this is the site URL (e.g mysite.wixsite.com/mysite). */
  base?: InputMaybe<Scalars['String']>;
  /** Path to the product page - e.g /product-page/a-product. */
  path?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1PagingInput = {
  /** Amount of items to load per page */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the display (relevant for all pages after the first) */
  offset?: InputMaybe<Scalars['Int']>;
};

export type WixCatalogApiV1PagingMetadata = {
  /** Amount of items to load per page */
  items?: Maybe<Scalars['Int']>;
  /** Number of items to skip in the display (relevant for all pages after the first) */
  offset?: Maybe<Scalars['Int']>;
};

export type WixCatalogApiV1PagingWithBigLimitInput = {
  /** Amount of items to load per page */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the display (relevant for all pages after the first) */
  offset?: InputMaybe<Scalars['Int']>;
};

export type WixCatalogApiV1PercentageDataInput = {
  /**
   * Percentage value, as a whole number (integer) between `-100` and `1000`.
   *
   * For example:
   * + Pass `100` to increase value by 100% (multiply original value by 2).
   * + Pass `1000` to increase value by 1000% (multiply original value by 10).
   * + Pass `-50` to decrease value by 50% (original value is halved).
   */
  rate?: InputMaybe<Scalars['Int']>;
  /**
   * If `true`, result will be rounded to the nearest whole number.
   * If `false`, result will be rounded to 2 places after the decimal point.
   */
  roundToInt?: InputMaybe<Scalars['Boolean']>;
};

export type WixCatalogApiV1PriceData = {
  /** Product price currency */
  currency?: Maybe<Scalars['String']>;
  /** Discounted product price (if no discounted price is set, the product price is returned) */
  discountedPrice?: Maybe<Scalars['Float']>;
  /** The product price and discounted price, formatted with the currency */
  formatted?: Maybe<WixCatalogApiV1FormattedPrice>;
  /** Product price */
  price?: Maybe<Scalars['Float']>;
  /** Price per unit */
  pricePerUnit?: Maybe<Scalars['Float']>;
};

export type WixCatalogApiV1PriceDataInput = {
  /** Product price currency */
  currency?: InputMaybe<Scalars['String']>;
  /** Discounted product price (if no discounted price is set, the product price is returned) */
  discountedPrice?: InputMaybe<Scalars['Float']>;
  /** The product price and discounted price, formatted with the currency */
  formatted?: InputMaybe<WixCatalogApiV1FormattedPriceInput>;
  /** Product price */
  price?: InputMaybe<Scalars['Float']>;
  /** Price per unit */
  pricePerUnit?: InputMaybe<Scalars['Float']>;
};

export type WixCatalogApiV1PricePerUnitData = {
  /** Base measurement unit */
  baseMeasurementUnit?: Maybe<ComWixEcommerceCommonsApiMeasurementUnitEnumMeasurementUnit>;
  /** Base quantity */
  baseQuantity?: Maybe<Scalars['Float']>;
  /** Total measurement unit */
  totalMeasurementUnit?: Maybe<ComWixEcommerceCommonsApiMeasurementUnitEnumMeasurementUnit>;
  /** Total quantity */
  totalQuantity?: Maybe<Scalars['Float']>;
};

export type WixCatalogApiV1PricePerUnitDataInput = {
  /** Base measurement unit */
  baseMeasurementUnit?: InputMaybe<ComWixEcommerceCommonsApiMeasurementUnitEnumMeasurementUnit>;
  /** Base quantity */
  baseQuantity?: InputMaybe<Scalars['Float']>;
  /** Total measurement unit */
  totalMeasurementUnit?: InputMaybe<ComWixEcommerceCommonsApiMeasurementUnitEnumMeasurementUnit>;
  /** Total quantity */
  totalQuantity?: InputMaybe<Scalars['Float']>;
};

export type WixCatalogApiV1Product = {
  /** Additional text that the store owner can assign to the product (e.g. shipping details, refund policy, etc.). */
  additionalInfoSections?: Maybe<Array<Maybe<WixCatalogApiV1AdditionalInfoSection>>>;
  /** Product brand. Including a brand name can help improve site and product [visibility on search engines](https://support.wix.com/en/article/adding-brand-names-to-boost-product-page-seo-in-wix-stores). */
  brand?: Maybe<Scalars['String']>;
  /** A list of all collection IDs that this product is included in (writable via the Catalog > Collection APIs). */
  collectionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A list of all collection IDs that this product is included in (writable via the Catalog > Collection APIs). */
  collections?: Maybe<WixCatalogApiV2QueryCollectionsResponse>;
  /** Price data, converted to the currency specified in request header. */
  convertedPriceData?: Maybe<WixCatalogApiV1PriceData>;
  /** Cost and profit data. */
  costAndProfitData?: Maybe<WixCatalogApiV1CostAndProfitData>;
  /** Product cost range. The minimum and maximum costs of all the variants. */
  costRange?: Maybe<ComWixEcommerceCatalogSpiApiV1NumericPropertyRange>;
  /** Date and time the product was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Text box for the customer to add a message to their order (e.g., customization request). Currently writable only from the UI. */
  customTextFields?: Maybe<Array<Maybe<WixCatalogApiV1CustomTextField>>>;
  /** Product description. Accepts [rich text](https://dev.wix.com/api/rest/wix-stores/rich-text). */
  description?: Maybe<Scalars['String']>;
  /** Digital file which will be downloaded by buyer after successful purchase. */
  digitalFile?: Maybe<ComWixEcommerceCatalogSpiApiV1SecuredMedia>;
  /** Discount deducted from the product's original price. */
  discount?: Maybe<WixCatalogApiV1Discount>;
  /** internal field used by import/export to know how to link products in csv file to product ids */
  exportProductId?: Maybe<Scalars['String']>;
  /** Product ID (generated automatically by the catalog). */
  id?: Maybe<Scalars['String']>;
  /** Inventory item ID - ID referencing the inventory system. */
  inventoryItemId?: Maybe<Scalars['String']>;
  /** Date and time the product was last updated. */
  lastUpdated?: Maybe<Scalars['String']>;
  /** Whether variants are being managed for this product - enables unique SKU, price and weight per variant. Also affects inventory data. */
  manageVariants?: Maybe<Scalars['Boolean']>;
  /** Media items (images, videos etc) associated with this product (writable via [Add Product Media](https://dev.wix.com/api/rest/wix-stores/catalog/products/add-product-media) endpoint). */
  media?: Maybe<WixCatalogApiV1Media>;
  /**
   * Product name.
   *
   * Min: 1 character
   * Max: 80 characters
   */
  name?: Maybe<Scalars['String']>;
  /**
   * Product’s unique numeric ID (assigned in ascending order).
   * Primarily used for sorting and filtering when crawling all products.
   */
  numericId?: Maybe<Scalars['Long']>;
  /** Deprecated (use `priceData` instead). */
  price?: Maybe<WixCatalogApiV1PriceData>;
  /** Price data. */
  priceData?: Maybe<WixCatalogApiV1PriceData>;
  /** Price per unit data. */
  pricePerUnitData?: Maybe<WixCatalogApiV1PricePerUnitData>;
  /** Product price range. The minimum and maximum prices of all the variants. */
  priceRange?: Maybe<ComWixEcommerceCatalogSpiApiV1NumericPropertyRange>;
  /** Options for this product. */
  productOptions?: Maybe<Array<Maybe<WixCatalogApiV1ProductOption>>>;
  /** Product page URL for this product (generated automatically by the server). */
  productPageUrl?: Maybe<WixCatalogApiV1PageUrl>;
  /** Currently, only creating physical products ( `"productType": "physical"` ) is supported via the API. */
  productType?: Maybe<WixCatalogApiV1ProductType>;
  /** Product ribbon. Used to highlight relevant information about a product. For example, "Sale", "New Arrival", "Sold Out". */
  ribbon?: Maybe<Scalars['String']>;
  /** Deprecated (use `ribbon` instead). */
  ribbons?: Maybe<Array<Maybe<WixCatalogApiV1Ribbon>>>;
  /** Custom SEO data for the product. */
  seoData?: Maybe<ComWixpressAdvancedSeoSeoSchema>;
  /** Stock keeping unit. If [variant management](https://support.wix.com/en/article/wix-stores-adding-and-customizing-product-options#setting-different-prices-for-variants) is enabled, SKUs will be set per variant, and this field will be empty. */
  sku?: Maybe<Scalars['String']>;
  /** A friendly URL name (generated automatically by the catalog when a product is created), can be updated. */
  slug?: Maybe<Scalars['String']>;
  /** Product inventory status (in future this will be writable via Inventory API). */
  stock?: Maybe<WixCatalogApiV1Stock>;
  /** tax group id */
  taxGroupId?: Maybe<Scalars['String']>;
  /**
   * Product variants, will be provided if the request was sent with the `includeVariants: true`.
   *
   * Max: 1,000 variants
   */
  variants?: Maybe<Array<Maybe<WixCatalogApiV1Variant>>>;
  /** Whether the product is visible to site visitors. */
  visible?: Maybe<Scalars['Boolean']>;
  /** Product weight. If [variant management](https://support.wix.com/en/article/wix-stores-adding-and-customizing-product-options#setting-different-prices-for-variants) is enabled, weight will be set per variant, and this field will be empty. */
  weight?: Maybe<Scalars['Float']>;
  /** Product weight range. The minimum and maximum weights of all the variants. */
  weightRange?: Maybe<ComWixEcommerceCatalogSpiApiV1NumericPropertyRange>;
};


export type WixCatalogApiV1ProductCollectionsArgs = {
  queryInput?: InputMaybe<WixCatalogApiV2QueryCollectionsRequestInput>;
};

export type WixCatalogApiV1ProductInput = {
  /** Additional text that the store owner can assign to the product (e.g. shipping details, refund policy, etc.). */
  additionalInfoSections?: InputMaybe<Array<InputMaybe<WixCatalogApiV1AdditionalInfoSectionInput>>>;
  /** Product brand. Including a brand name can help improve site and product [visibility on search engines](https://support.wix.com/en/article/adding-brand-names-to-boost-product-page-seo-in-wix-stores). */
  brand?: InputMaybe<Scalars['String']>;
  /** A list of all collection IDs that this product is included in (writable via the Catalog > Collection APIs). */
  collectionIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Price data, converted to the currency specified in request header. */
  convertedPriceData?: InputMaybe<WixCatalogApiV1PriceDataInput>;
  /** Cost and profit data. */
  costAndProfitData?: InputMaybe<WixCatalogApiV1CostAndProfitDataInput>;
  /** Product cost range. The minimum and maximum costs of all the variants. */
  costRange?: InputMaybe<ComWixEcommerceCatalogSpiApiV1NumericPropertyRangeInput>;
  /** Date and time the product was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Text box for the customer to add a message to their order (e.g., customization request). Currently writable only from the UI. */
  customTextFields?: InputMaybe<Array<InputMaybe<WixCatalogApiV1CustomTextFieldInput>>>;
  /** Product description. Accepts [rich text](https://dev.wix.com/api/rest/wix-stores/rich-text). */
  description?: InputMaybe<Scalars['String']>;
  /** Digital file which will be downloaded by buyer after successful purchase. */
  digitalFile?: InputMaybe<ComWixEcommerceCatalogSpiApiV1SecuredMediaInput>;
  /** Discount deducted from the product's original price. */
  discount?: InputMaybe<WixCatalogApiV1DiscountInput>;
  /** internal field used by import/export to know how to link products in csv file to product ids */
  exportProductId?: InputMaybe<Scalars['String']>;
  /** Product ID (generated automatically by the catalog). */
  id?: InputMaybe<Scalars['String']>;
  /** Inventory item ID - ID referencing the inventory system. */
  inventoryItemId?: InputMaybe<Scalars['String']>;
  /** Date and time the product was last updated. */
  lastUpdated?: InputMaybe<Scalars['String']>;
  /** Whether variants are being managed for this product - enables unique SKU, price and weight per variant. Also affects inventory data. */
  manageVariants?: InputMaybe<Scalars['Boolean']>;
  /** Media items (images, videos etc) associated with this product (writable via [Add Product Media](https://dev.wix.com/api/rest/wix-stores/catalog/products/add-product-media) endpoint). */
  media?: InputMaybe<WixCatalogApiV1MediaInput>;
  /**
   * Product name.
   *
   * Min: 1 character
   * Max: 80 characters
   */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Product’s unique numeric ID (assigned in ascending order).
   * Primarily used for sorting and filtering when crawling all products.
   */
  numericId?: InputMaybe<Scalars['Long']>;
  /** Deprecated (use `priceData` instead). */
  price?: InputMaybe<WixCatalogApiV1PriceDataInput>;
  /** Price data. */
  priceData?: InputMaybe<WixCatalogApiV1PriceDataInput>;
  /** Price per unit data. */
  pricePerUnitData?: InputMaybe<WixCatalogApiV1PricePerUnitDataInput>;
  /** Product price range. The minimum and maximum prices of all the variants. */
  priceRange?: InputMaybe<ComWixEcommerceCatalogSpiApiV1NumericPropertyRangeInput>;
  /** Options for this product. */
  productOptions?: InputMaybe<Array<InputMaybe<WixCatalogApiV1ProductOptionInput>>>;
  /** Product page URL for this product (generated automatically by the server). */
  productPageUrl?: InputMaybe<WixCatalogApiV1PageUrlInput>;
  /** Currently, only creating physical products ( `"productType": "physical"` ) is supported via the API. */
  productType?: InputMaybe<WixCatalogApiV1ProductType>;
  /** Product ribbon. Used to highlight relevant information about a product. For example, "Sale", "New Arrival", "Sold Out". */
  ribbon?: InputMaybe<Scalars['String']>;
  /** Deprecated (use `ribbon` instead). */
  ribbons?: InputMaybe<Array<InputMaybe<WixCatalogApiV1RibbonInput>>>;
  /** Custom SEO data for the product. */
  seoData?: InputMaybe<ComWixpressAdvancedSeoSeoSchemaInput>;
  /** Stock keeping unit. If [variant management](https://support.wix.com/en/article/wix-stores-adding-and-customizing-product-options#setting-different-prices-for-variants) is enabled, SKUs will be set per variant, and this field will be empty. */
  sku?: InputMaybe<Scalars['String']>;
  /** A friendly URL name (generated automatically by the catalog when a product is created), can be updated. */
  slug?: InputMaybe<Scalars['String']>;
  /** Product inventory status (in future this will be writable via Inventory API). */
  stock?: InputMaybe<WixCatalogApiV1StockInput>;
  /** tax group id */
  taxGroupId?: InputMaybe<Scalars['String']>;
  /**
   * Product variants, will be provided if the request was sent with the `includeVariants: true`.
   *
   * Max: 1,000 variants
   */
  variants?: InputMaybe<Array<InputMaybe<WixCatalogApiV1VariantInput>>>;
  /** Whether the product is visible to site visitors. */
  visible?: InputMaybe<Scalars['Boolean']>;
  /** Product weight. If [variant management](https://support.wix.com/en/article/wix-stores-adding-and-customizing-product-options#setting-different-prices-for-variants) is enabled, weight will be set per variant, and this field will be empty. */
  weight?: InputMaybe<Scalars['Float']>;
  /** Product weight range. The minimum and maximum weights of all the variants. */
  weightRange?: InputMaybe<ComWixEcommerceCatalogSpiApiV1NumericPropertyRangeInput>;
};

export type WixCatalogApiV1ProductOption = {
  /** Choices available for this option. */
  choices?: Maybe<Array<Maybe<WixCatalogApiV1Choice>>>;
  /** Option name. */
  name?: Maybe<Scalars['String']>;
  /** Option type. */
  optionType?: Maybe<WixCatalogApiV1OptionType>;
};

export type WixCatalogApiV1ProductOptionInput = {
  /** Choices available for this option. */
  choices?: InputMaybe<Array<InputMaybe<WixCatalogApiV1ChoiceInput>>>;
  /** Option name. */
  name?: InputMaybe<Scalars['String']>;
  /** Option type. */
  optionType?: InputMaybe<WixCatalogApiV1OptionType>;
};

export type WixCatalogApiV1ProductOptionsAvailabilityRequestInput = {
  /** Requested product ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Array containing the selected options. For example, `["color": "Blue", "size": "Large"]`. */
  options?: InputMaybe<Scalars['JSON']>;
};

export type WixCatalogApiV1ProductOptionsAvailabilityResponse = {
  /** Whether all the selected choices result in a visible, in-stock variant. */
  availableForPurchase?: Maybe<Scalars['Boolean']>;
  /** Whether the variant is managed or represents a product. */
  managedProduct?: Maybe<Scalars['Boolean']>;
  /** Information about media items (images, videos, etc.) associated with this choice. */
  media?: Maybe<WixCatalogApiV1Media>;
  /** Options information (color, size, etc.) for this product, with the inventory and visibility fields updated based on the provided choices. */
  productOptions?: Maybe<Array<Maybe<WixCatalogApiV1ProductOption>>>;
  /** Variant information, given that all the choices were provided. */
  selectedVariant?: Maybe<WixCatalogApiV1VariantData>;
};

export enum WixCatalogApiV1ProductType {
  digital = 'digital',
  physical = 'physical',
  unspecified_product_type = 'unspecified_product_type'
}

export type WixCatalogApiV1PropertyAdjustmentDataInput = {
  /** Adjust by amount. */
  amount?: InputMaybe<Scalars['Float']>;
  /** Adjust by percentage. */
  percentage?: InputMaybe<WixCatalogApiV1PercentageDataInput>;
};

export type WixCatalogApiV1QueryCollectionsPlatformizedRequestInput = {
  query?: InputMaybe<ComWixEcommerceCommonsApiPlatformQueryInput>;
};

export type WixCatalogApiV1QueryCollectionsPlatformizedResponse = {
  collections?: Maybe<Array<Maybe<WixCatalogApiV1Collection>>>;
  metadata?: Maybe<ComWixEcommerceCommonsApiPlatformPagingMetadata>;
};

export type WixCatalogApiV1QueryCollectionsRequestInput = {
  /** Wether to include collection description in the response. When `false` is passed, `collection.description` will return null. */
  includeDescription?: InputMaybe<Scalars['Boolean']>;
  /** Whether number of products should be included in the response. */
  includeNumberOfProducts?: InputMaybe<Scalars['Boolean']>;
  /** Include SeoSchema in response. When False, SeoSchema will be null */
  includeSeoSchema?: InputMaybe<Scalars['Boolean']>;
  /** Query options. */
  query?: InputMaybe<WixCatalogApiV1QueryInput>;
};

export type WixCatalogApiV1QueryCollectionsResponse = {
  /** List of collections. */
  collections?: Maybe<Array<Maybe<WixCatalogApiV1Collection>>>;
  /** Details on the paged set of results returned. */
  metadata?: Maybe<WixCatalogApiV1PagingMetadata>;
  /** Total number of results returned. */
  totalResults?: Maybe<Scalars['Int']>;
};

export type WixCatalogApiV1QueryCustomFieldsRequestInput = {
  /** Requested product ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Requested field names. */
  names?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixCatalogApiV1QueryCustomFieldsResponse = {
  customFields?: Maybe<Scalars['JSON']>;
};

export type WixCatalogApiV1QueryInput = {
  /** Filter string */
  filter?: InputMaybe<Scalars['String']>;
  paging?: InputMaybe<WixCatalogApiV1PagingInput>;
  /** Sort string */
  sort?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1QueryProductVariantsRequestInput = {
  /**
   * The specific choices available or chosen from within a selection (e.g., choosing the red Selection triggers the red Choice).
   * You may specify all the relevant choices for a specific variant, or only some of the options, which will return all corresponding variants (not relevant when passing variant IDs).
   */
  choices?: InputMaybe<Scalars['JSON']>;
  /** Requested product ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Whether merchant specific data should be included in the response. Requires permissions to manage products. */
  includeMerchantSpecificData?: InputMaybe<Scalars['Boolean']>;
  paging?: InputMaybe<WixCatalogApiV1PagingInput>;
  /** List of variant IDs (not relevant when passing choices). */
  variantIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixCatalogApiV1QueryProductVariantsResponse = {
  metadata?: Maybe<WixCatalogApiV1PagingMetadata>;
  totalResults?: Maybe<Scalars['Int']>;
  /** List of variants based on the specified filters and sorting. */
  variants?: Maybe<Array<Maybe<WixCatalogApiV1Variant>>>;
};

export type WixCatalogApiV1QueryProductsPlatformizedRequestInput = {
  query?: InputMaybe<ComWixEcommerceCommonsApiPlatformQueryInput>;
};

export type WixCatalogApiV1QueryProductsPlatformizedResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<WixCatalogApiV1Product>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixCatalogApiV1QueryProductsRequestInput = {
  /** Whether hidden products should be included in the response. Requires permissions to manage products. */
  includeHiddenProducts?: InputMaybe<Scalars['Boolean']>;
  /** Whether merchant specific data should be included in the response. Requires permissions to manage products. */
  includeMerchantSpecificData?: InputMaybe<Scalars['Boolean']>;
  /** Whether variants should be included in the response. */
  includeVariants?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<WixCatalogApiV1QueryInput>;
};

export type WixCatalogApiV1QueryProductsResponse = {
  metadata?: Maybe<WixCatalogApiV1PagingMetadata>;
  products?: Maybe<Array<Maybe<WixCatalogApiV1Product>>>;
  totalResults?: Maybe<Scalars['Int']>;
};

export type WixCatalogApiV1QueryProductsWithBigPageLimitRequestInput = {
  /** Whether hidden products should be included in the response. Requires permissions to manage products. */
  includeHiddenProducts?: InputMaybe<Scalars['Boolean']>;
  /** Whether merchant specific data should be included in the response. Requires permissions to manage products. */
  includeMerchantSpecificData?: InputMaybe<Scalars['Boolean']>;
  /** Whether variants should be included in the response. */
  includeVariants?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<WixCatalogApiV1QueryWithBigPageLimitInput>;
};

export type WixCatalogApiV1QueryStoreVariantsRequestInput = {
  /** Requested custom field names. */
  customFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Include variants for different locations */
  includeLocationVariants?: InputMaybe<Scalars['Boolean']>;
  /** Query options. */
  query?: InputMaybe<ComWixEcommerceCommonsApiPlatformQueryInput>;
};

export type WixCatalogApiV1QueryStoreVariantsResponse = {
  /** Details on the paged set of results returned. */
  metadata?: Maybe<ComWixEcommerceCommonsApiPlatformPagingMetadata>;
  /** List of variants based on the specified filters and sorting. */
  variants?: Maybe<Array<Maybe<WixCatalogApiV1StoreVariant>>>;
};

export type WixCatalogApiV1QueryStoreVariantsWithBigLimitRequestInput = {
  /** Requested custom field names. */
  customFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Include variants for different locations */
  includeLocationVariants?: InputMaybe<Scalars['Boolean']>;
  /** Query options. */
  query?: InputMaybe<ComWixEcommerceCommonsApiUnlimitedPlatformQueryInput>;
};

export type WixCatalogApiV1QueryWithBigPageLimitInput = {
  /** Filter string */
  filter?: InputMaybe<Scalars['String']>;
  paging?: InputMaybe<WixCatalogApiV1PagingWithBigLimitInput>;
  /** Sort string */
  sort?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1ReCloneStoreRequestInput = {
  /** Description of value */
  metasiteId?: InputMaybe<Scalars['String']>;
  originalMetasiteId?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1RemoveCustomFieldsRequestInput = {
  /** Product ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Custom fields to be removed (by name). */
  names?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixCatalogApiV1RemoveProductBrandRequestInput = {
  /** Product ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1RemoveProductMediaFromChoicesRequestInput = {
  /** Product ID from whose choices to remove media items. */
  id?: InputMaybe<Scalars['String']>;
  /** Media to remove from choices. If an empty array is passed, all media will be removed from all choices for the given product. */
  media?: InputMaybe<Array<InputMaybe<WixCatalogApiV1MediaAssignmentToChoiceInput>>>;
};

export type WixCatalogApiV1RemoveProductMediaRequestInput = {
  /** Product ID. */
  id?: InputMaybe<Scalars['String']>;
  /** List of media IDs to remove. Pass an empty array to delete all media items for the product. */
  mediaIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixCatalogApiV1RemoveProductRibbonRequestInput = {
  /** Product ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1RemoveProductsFromCollectionRequestInput = {
  /** Collection ID. */
  id?: InputMaybe<Scalars['String']>;
  /** IDs of the products to remove from the collection. */
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixCatalogApiV1ResetAllVariantDataRequestInput = {
  /** Product ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1Ribbon = {
  /** Ribbon text */
  text?: Maybe<Scalars['String']>;
};

export type WixCatalogApiV1RibbonInput = {
  /** Ribbon text */
  text?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1SetCustomFieldsRequestInput = {
  /** Custom field that will be added, if a custom field with the same name already exists, the value of the custom field will be overridden. */
  customFields?: InputMaybe<Scalars['JSON']>;
  /** Product ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixCatalogApiV1SetValueInput = {
  /** Set product brand. Pass empty string to remove existing brand. */
  brand?: InputMaybe<Scalars['String']>;
  /**
   * Set product cost of goods.
   * If [variant management](https://support.wix.com/en/article/wix-stores-adding-and-customizing-product-options#setting-different-prices-for-variants) is enabled,
   * cost of goods will be set per variant.
   */
  cost?: InputMaybe<Scalars['Float']>;
  /**
   * Set product price.
   * If [variant management](https://support.wix.com/en/article/wix-stores-adding-and-customizing-product-options#setting-different-prices-for-variants) is enabled,
   * variant prices will be calculated according to the set product price.
   * If variant price is negative after setting new price, the update will fail.
   */
  price?: InputMaybe<Scalars['Float']>;
  /** Set product ribbon. Pass empty string to remove existing ribbon. */
  ribbon?: InputMaybe<Scalars['String']>;
  /**
   * Set product weight.
   * If [variant management](https://support.wix.com/en/article/wix-stores-adding-and-customizing-product-options#setting-different-prices-for-variants) is enabled,
   * weight will be set per variant.
   */
  weight?: InputMaybe<Scalars['Float']>;
};

export type WixCatalogApiV1Stock = {
  /**
   * Whether the product is currently in stock (relevant only when tracking manually)
   * Deprecated (use `inventoryStatus` instead)
   */
  inStock?: Maybe<Scalars['Boolean']>;
  /**
   * The current status of the inventory
   * + `IN_STOCK` - In stock
   * + `OUT_OF_STOCK` - Not in stock
   * + `PARTIALLY_OUT_OF_STOCK` - Some of the variants are not in stock
   */
  inventoryStatus?: Maybe<WixCatalogApiV1StockInventoryStatus>;
  /** Quantity currently left in inventory */
  quantity?: Maybe<Scalars['Int']>;
  /** Whether inventory is being tracked */
  trackInventory?: Maybe<Scalars['Boolean']>;
};

export type WixCatalogApiV1StockInput = {
  /**
   * Whether the product is currently in stock (relevant only when tracking manually)
   * Deprecated (use `inventoryStatus` instead)
   */
  inStock?: InputMaybe<Scalars['Boolean']>;
  /**
   * The current status of the inventory
   * + `IN_STOCK` - In stock
   * + `OUT_OF_STOCK` - Not in stock
   * + `PARTIALLY_OUT_OF_STOCK` - Some of the variants are not in stock
   */
  inventoryStatus?: InputMaybe<WixCatalogApiV1StockInventoryStatus>;
  /** Quantity currently left in inventory */
  quantity?: InputMaybe<Scalars['Int']>;
  /** Whether inventory is being tracked */
  trackInventory?: InputMaybe<Scalars['Boolean']>;
};

export enum WixCatalogApiV1StockInventoryStatus {
  /** In stock */
  IN_STOCK = 'IN_STOCK',
  /** Not in stock */
  OUT_OF_STOCK = 'OUT_OF_STOCK',
  /** Some of the variants are not in stock */
  PARTIALLY_OUT_OF_STOCK = 'PARTIALLY_OUT_OF_STOCK'
}

export type WixCatalogApiV1StoreVariant = {
  /** The selected options of this variant. For example, `{"Color": "Blue", "Size": "Large"}`. */
  choices?: Maybe<Scalars['JSON']>;
  /** Collections that include this variant. */
  collectionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Collections that include this variant. */
  collections?: Maybe<WixCatalogApiV2QueryCollectionsResponse>;
  customFields?: Maybe<Scalars['JSON']>;
  /** Store variant ID. Comprised of the `productId` and the `variantId`, separated by a hyphen: {productId}.{variantId}. */
  id?: Maybe<Scalars['String']>;
  /** Whether the variant is managed or represents a product. */
  managedVariant?: Maybe<Scalars['Boolean']>;
  /** Media items (images, videos) associated with this variant. */
  media?: Maybe<ComWixEcommerceCommonsApiPlatformMedia>;
  /** Preorder information. */
  preorderInfo?: Maybe<WixInventoryApiV1PreorderInfo>;
  /** Product ID. */
  product?: Maybe<WixCatalogApiV1Product>;
  /** Product ID. */
  productId?: Maybe<Scalars['String']>;
  /** Product name. */
  productName?: Maybe<Scalars['String']>;
  /** Variant SKU (stock keeping unit). */
  sku?: Maybe<Scalars['String']>;
  /** Variant inventory status. */
  stock?: Maybe<WixCatalogApiV1VariantStock>;
  /** Variant ID. */
  variantId?: Maybe<Scalars['String']>;
  /** Variant name. */
  variantName?: Maybe<Scalars['String']>;
};


export type WixCatalogApiV1StoreVariantCollectionsArgs = {
  queryInput?: InputMaybe<WixCatalogApiV2QueryCollectionsRequestInput>;
};

export type WixCatalogApiV1UpdateCollectionRequestInput = {
  /** Collection info. */
  collection?: InputMaybe<WixCatalogApiV1CollectionInput>;
};

export type WixCatalogApiV1UpdateCollectionResponse = {
  /** Updated collection. */
  collection?: Maybe<WixCatalogApiV1Collection>;
};

export type WixCatalogApiV1UpdateProductPlatformizedRequestInput = {
  product?: InputMaybe<WixCatalogApiV1ProductInput>;
};

export type WixCatalogApiV1UpdateProductPlatformizedResponse = {
  product?: Maybe<WixCatalogApiV1Product>;
};

export type WixCatalogApiV1UpdateProductRequestInput = {
  product?: InputMaybe<WixCatalogApiV1ProductInput>;
};

export type WixCatalogApiV1UpdateProductResponse = {
  product?: Maybe<WixCatalogApiV1Product>;
};

export type WixCatalogApiV1UpdateVariantsRequestInput = {
  /** ID of the product with managed variants. */
  id?: InputMaybe<Scalars['String']>;
  /** Variant info to update. */
  variants?: InputMaybe<Array<InputMaybe<WixCatalogApiV1VariantOverrideInput>>>;
};

export type WixCatalogApiV1UpdateVariantsResponse = {
  /** List of the product's variants. */
  variants?: Maybe<Array<Maybe<WixCatalogApiV1Variant>>>;
};

export type WixCatalogApiV1Variant = {
  /** Specific choices within a selection, as option-choice key-value pairs */
  choices?: Maybe<Scalars['JSON']>;
  /** Requested Variant ID */
  id?: Maybe<Scalars['String']>;
  /** Variant inventory status. */
  stock?: Maybe<WixCatalogApiV1VariantStock>;
  variant?: Maybe<WixCatalogApiV1VariantDataWithNoStock>;
};

export type WixCatalogApiV1VariantData = {
  /** Variant price data converted to currency provided in header. */
  convertedPriceData?: Maybe<WixCatalogApiV1PriceData>;
  /** Whether the product is currently in stock (relevant only when tracking manually). */
  inStock?: Maybe<Scalars['Boolean']>;
  /** Variant price. */
  price?: Maybe<WixCatalogApiV1PriceData>;
  /** Quantity currently in inventory (relevant only when tracking by inventory). */
  quantity?: Maybe<Scalars['Int']>;
  /** Variant SKU (stock keeping unit). */
  sku?: Maybe<Scalars['String']>;
  /** Variant ID. */
  variantId?: Maybe<Scalars['String']>;
  /** Whether the variant is visible to customers. */
  visible?: Maybe<Scalars['Boolean']>;
  /** Variant weight. */
  weight?: Maybe<Scalars['Float']>;
};

export type WixCatalogApiV1VariantDataWithNoStock = {
  /** Variant price data, converted to currency requested in header. */
  convertedPriceData?: Maybe<WixCatalogApiV1PriceData>;
  /** Cost and profit data. */
  costAndProfitData?: Maybe<WixCatalogApiV1CostAndProfitData>;
  /** Variant price. */
  priceData?: Maybe<WixCatalogApiV1PriceData>;
  /** Variant SKU (stock keeping unit). */
  sku?: Maybe<Scalars['String']>;
  /** Whether the variant is visible to customers. */
  visible?: Maybe<Scalars['Boolean']>;
  /** Variant weight. */
  weight?: Maybe<Scalars['Float']>;
};

export type WixCatalogApiV1VariantDataWithNoStockInput = {
  /** Variant price data, converted to currency requested in header. */
  convertedPriceData?: InputMaybe<WixCatalogApiV1PriceDataInput>;
  /** Cost and profit data. */
  costAndProfitData?: InputMaybe<WixCatalogApiV1CostAndProfitDataInput>;
  /** Variant price. */
  priceData?: InputMaybe<WixCatalogApiV1PriceDataInput>;
  /** Variant SKU (stock keeping unit). */
  sku?: InputMaybe<Scalars['String']>;
  /** Whether the variant is visible to customers. */
  visible?: InputMaybe<Scalars['Boolean']>;
  /** Variant weight. */
  weight?: InputMaybe<Scalars['Float']>;
};

export type WixCatalogApiV1VariantInput = {
  /** Specific choices within a selection, as option-choice key-value pairs */
  choices?: InputMaybe<Scalars['JSON']>;
  /** Requested Variant ID */
  id?: InputMaybe<Scalars['String']>;
  /** Variant inventory status. */
  stock?: InputMaybe<WixCatalogApiV1VariantStockInput>;
  variant?: InputMaybe<WixCatalogApiV1VariantDataWithNoStockInput>;
};

export type WixCatalogApiV1VariantOverrideInput = {
  /** The specific choices available or chosen from within a selection (e.g., choosing the red Selection triggers the red Choice). You may specify all the relevant choices for a specific variant, or only some of the options, which will return all corresponding variants (Not relevant when passing variant IDs) */
  choices?: InputMaybe<Scalars['JSON']>;
  /** Variant cost of goods */
  cost?: InputMaybe<Scalars['Float']>;
  /** Variant price */
  price?: InputMaybe<Scalars['Float']>;
  /** Variant SKU (stock keeping unit) */
  sku?: InputMaybe<Scalars['String']>;
  /**
   * List of variant IDs
   * (Not relevant when passing choices)
   */
  variantIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Whether the variant is visible to  customers */
  visible?: InputMaybe<Scalars['Boolean']>;
  /** Variant weight */
  weight?: InputMaybe<Scalars['Float']>;
};

export type WixCatalogApiV1VariantStock = {
  /** Whether the product is currently in stock (relevant only when tracking manually). */
  inStock?: Maybe<Scalars['Boolean']>;
  /** The location of the inventory in question. None indicates the online-store default location. */
  locationId?: Maybe<Scalars['String']>;
  /** Quantity currently left in inventory. */
  quantity?: Maybe<Scalars['Int']>;
  /** Whether inventory is being tracked. */
  trackQuantity?: Maybe<Scalars['Boolean']>;
};

export type WixCatalogApiV1VariantStockInput = {
  /** Whether the product is currently in stock (relevant only when tracking manually). */
  inStock?: InputMaybe<Scalars['Boolean']>;
  /** The location of the inventory in question. None indicates the online-store default location. */
  locationId?: InputMaybe<Scalars['String']>;
  /** Quantity currently left in inventory. */
  quantity?: InputMaybe<Scalars['Int']>;
  /** Whether inventory is being tracked. */
  trackQuantity?: InputMaybe<Scalars['Boolean']>;
};

export type WixCatalogApiV2QueryCollectionsRequestInput = {
  query?: InputMaybe<ComWixEcommerceCommonsApiPlatformQueryInput>;
};

export type WixCatalogApiV2QueryCollectionsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<WixCatalogApiV1Collection>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixCatalogWriteProxyV1CreateProductPlatformizedRequestInput = {
  /** Product information. */
  product?: InputMaybe<WixCatalogApiV1ProductInput>;
};

export type WixCatalogWriteProxyV1CreateProductPlatformizedResponse = {
  product?: Maybe<WixCatalogApiV1Product>;
};

export type WixCatalogWriteProxyV1DeleteProductPlatformizedRequestInput = {
  /** ID of the product to delete. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixCatalogWriteProxyV1UpdateProductPlatformizedRequestInput = {
  product?: InputMaybe<WixCatalogApiV1ProductInput>;
};

export type WixCatalogWriteProxyV1UpdateProductPlatformizedResponse = {
  product?: Maybe<WixCatalogApiV1Product>;
};

export type WixCommonAddress = {
  /** Main address line, usually street and number as free text. */
  addressLine?: Maybe<Scalars['String']>;
  /** Free text providing more detailed address info. Usually contains Apt, Suite, and Floor. */
  addressLine2?: Maybe<Scalars['String']>;
  /** City name. */
  city?: Maybe<Scalars['String']>;
  /** Country code. */
  country?: Maybe<Scalars['String']>;
  /** Country full name. */
  countryFullname?: Maybe<Scalars['String']>;
  /** A string containing the full address of this location. */
  formattedAddress?: Maybe<Scalars['String']>;
  /** Coordinates of the physical address. */
  geocode?: Maybe<WixCommonAddressLocation>;
  /** Free text to help find the address. */
  hint?: Maybe<Scalars['String']>;
  /** Zip/postal code. */
  postalCode?: Maybe<Scalars['String']>;
  /** Street name and number. */
  streetAddress?: Maybe<WixCommonStreetAddress>;
  /** Subdivision shorthand. Usually, a short code (2 or 3 letters) that represents a state, region, prefecture, or province. e.g. NY */
  subdivision?: Maybe<Scalars['String']>;
  /** Subdivision full name. */
  subdivisionFullname?: Maybe<Scalars['String']>;
  /** Subdivision. Usually a state, region, prefecture, or province code, according to [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2), e.g. US-NY */
  subdivisionIso31662?: Maybe<Scalars['String']>;
  /** Multi-level subdivisions from top to bottom. */
  subdivisions?: Maybe<Array<Maybe<WixCommonSubdivision>>>;
};

export type WixCommonAddressInput = {
  /** Main address line, usually street and number as free text. */
  addressLine?: InputMaybe<Scalars['String']>;
  /** Free text providing more detailed address info. Usually contains Apt, Suite, and Floor. */
  addressLine2?: InputMaybe<Scalars['String']>;
  /** City name. */
  city?: InputMaybe<Scalars['String']>;
  /** Country code. */
  country?: InputMaybe<Scalars['String']>;
  /** Country full name. */
  countryFullname?: InputMaybe<Scalars['String']>;
  /** A string containing the full address of this location. */
  formattedAddress?: InputMaybe<Scalars['String']>;
  /** Coordinates of the physical address. */
  geocode?: InputMaybe<WixCommonAddressLocationInput>;
  /** Free text to help find the address. */
  hint?: InputMaybe<Scalars['String']>;
  /** Zip/postal code. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** Street name and number. */
  streetAddress?: InputMaybe<WixCommonStreetAddressInput>;
  /** Subdivision shorthand. Usually, a short code (2 or 3 letters) that represents a state, region, prefecture, or province. e.g. NY */
  subdivision?: InputMaybe<Scalars['String']>;
  /** Subdivision full name. */
  subdivisionFullname?: InputMaybe<Scalars['String']>;
  /** Subdivision. Usually a state, region, prefecture, or province code, according to [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2), e.g. US-NY */
  subdivisionIso31662?: InputMaybe<Scalars['String']>;
  /** Multi-level subdivisions from top to bottom. */
  subdivisions?: InputMaybe<Array<InputMaybe<WixCommonSubdivisionInput>>>;
};

export type WixCommonAddressLocation = {
  /** Address latitude. */
  latitude?: Maybe<Scalars['Float']>;
  /** Address longitude. */
  longitude?: Maybe<Scalars['Float']>;
};

export type WixCommonAddressLocationInput = {
  /** Address latitude. */
  latitude?: InputMaybe<Scalars['Float']>;
  /** Address longitude. */
  longitude?: InputMaybe<Scalars['Float']>;
};

export type WixCommonAggregationData = {
  /** List of the aggregated data results. */
  results?: Maybe<Array<Maybe<WixCommonAggregationDataAggregationResults>>>;
};

export type WixCommonAggregationDataAggregationResults = {
  /** Date histogram aggregation results. */
  dateHistogram?: Maybe<WixCommonAggregationDataAggregationResultsDateHistogramResults>;
  /** Field to aggregate by. Use dot notation to specify a JSON path. For example, `order.address.streetName`. */
  fieldPath?: Maybe<Scalars['String']>;
  /** Group by value aggregation results. */
  groupedByValue?: Maybe<WixCommonAggregationDataAggregationResultsGroupByValueResults>;
  /** Aggregation name, returned in `aggregations.results.name`. */
  name?: Maybe<Scalars['String']>;
  /** Nested aggregation results. */
  nested?: Maybe<WixCommonAggregationDataAggregationResultsNestedResults>;
  /** Range aggregation results. */
  ranges?: Maybe<WixCommonAggregationDataAggregationResultsRangeResults>;
  /** Scalar aggregation results. */
  scalar?: Maybe<WixCommonAggregationDataAggregationResultsScalarResult>;
  /** Date aggregation results. */
  scalarDate?: Maybe<WixCommonAggregationDataAggregationResultsScalarDateResult>;
  /** Aggregation type. Must align with the corresponding aggregation field. */
  type?: Maybe<WixCommonAggregationType>;
  /** Value aggregation results. */
  values?: Maybe<WixCommonAggregationDataAggregationResultsValueResults>;
};

export type WixCommonAggregationDataAggregationResultsDateHistogramResults = {
  /** List of date histogram aggregations. */
  results?: Maybe<Array<Maybe<WixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult>>>;
};

export type WixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult = {
  /** Number of entities in the bucket. */
  count?: Maybe<Scalars['Int']>;
  /** Date in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) format. */
  value?: Maybe<Scalars['String']>;
};

export type WixCommonAggregationDataAggregationResultsGroupByValueResults = {
  /** List of value aggregations. */
  results?: Maybe<Array<Maybe<WixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult>>>;
};

export type WixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult = {
  /** Nested aggregations. */
  nestedResults?: Maybe<WixCommonAggregationDataAggregationResultsNestedAggregationResults>;
  /** Value of the field. */
  value?: Maybe<Scalars['String']>;
};

export type WixCommonAggregationDataAggregationResultsNestedAggregationResults = {
  /** Field which the data was aggregated by. */
  fieldPath?: Maybe<Scalars['String']>;
  /** Unique, caller-defined aggregation name, identifiable by the requested aggregation `name`. */
  name?: Maybe<Scalars['String']>;
  /** Range aggregation results. */
  ranges?: Maybe<WixCommonAggregationDataAggregationResultsRangeResults>;
  /** Scalar aggregation results. */
  scalar?: Maybe<WixCommonAggregationDataAggregationResultsScalarResult>;
  /** Aggregation type. */
  type?: Maybe<WixCommonAggregationType>;
  /** Value aggregation results. */
  values?: Maybe<WixCommonAggregationDataAggregationResultsValueResults>;
};

export type WixCommonAggregationDataAggregationResultsNestedResults = {
  /** List of nested aggregations. */
  results?: Maybe<Array<Maybe<WixCommonAggregationDataAggregationResultsNestedResultsResults>>>;
};

export type WixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue = {
  /** Date histogram aggregation result. */
  dateHistogram?: Maybe<WixCommonAggregationDataAggregationResultsNestedResultsValueResult>;
  /** Range aggregation result. */
  range?: Maybe<WixCommonAggregationDataAggregationResultsNestedResultsRangeResult>;
  /** Scalar aggregation result. */
  scalar?: Maybe<WixCommonAggregationDataAggregationResultsNestedResultsScalarResult>;
  /** Scalar date aggregation result. */
  scalarDate?: Maybe<WixCommonAggregationDataAggregationResultsNestedResultsScalarDateResult>;
  /** Value aggregation result. */
  value?: Maybe<WixCommonAggregationDataAggregationResultsNestedResultsValueResult>;
};

export type WixCommonAggregationDataAggregationResultsNestedResultsRangeResult = {
  /** Number of entities in this range. */
  count?: Maybe<Scalars['Int']>;
  /** Inclusive lower bound of the range. */
  from?: Maybe<Scalars['Float']>;
  /** Exclusive upper bound of the range. */
  to?: Maybe<Scalars['Float']>;
};

export type WixCommonAggregationDataAggregationResultsNestedResultsResults = {
  /** List of nested aggregations. */
  results?: Maybe<WixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue>;
};

export type WixCommonAggregationDataAggregationResultsNestedResultsScalarDateResult = {
  /** Date in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) format. */
  value?: Maybe<Scalars['String']>;
};

export type WixCommonAggregationDataAggregationResultsNestedResultsScalarResult = {
  /** Value of the scalar aggregation. */
  value?: Maybe<Scalars['Float']>;
};

export type WixCommonAggregationDataAggregationResultsNestedResultsValueResult = {
  /** Number of entities with this value. */
  count?: Maybe<Scalars['Int']>;
  /** Value of the field. */
  value?: Maybe<Scalars['String']>;
};

export type WixCommonAggregationDataAggregationResultsRangeResults = {
  /** List of ranges returned in the same order as requested. */
  results?: Maybe<Array<Maybe<WixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult>>>;
};

export type WixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult = {
  /** Total number of entities in this range. */
  count?: Maybe<Scalars['Int']>;
  /** Inclusive lower bound of the range. */
  from?: Maybe<Scalars['Float']>;
  /** Exclusive upper bound of the range. */
  to?: Maybe<Scalars['Float']>;
};

export type WixCommonAggregationDataAggregationResultsScalarDateResult = {
  /** Type of scalar date aggregation. Possible values: `MIN`, `MAX`. */
  type?: Maybe<WixCommonScalarType>;
  /** Date in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) format. */
  value?: Maybe<Scalars['String']>;
};

export type WixCommonAggregationDataAggregationResultsScalarResult = {
  /** Type of scalar aggregation. */
  type?: Maybe<WixCommonScalarType>;
  /** Value of the scalar aggregation. */
  value?: Maybe<Scalars['Float']>;
};

export type WixCommonAggregationDataAggregationResultsValueResults = {
  /** List of value aggregations. */
  results?: Maybe<Array<Maybe<WixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult>>>;
};

export type WixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult = {
  /** Number of entities with this value. */
  count?: Maybe<Scalars['Int']>;
  /** Value of the field. */
  value?: Maybe<Scalars['String']>;
};

export type WixCommonAggregationDateHistogramAggregationInput = {
  /** Interval for date histogram aggregation. */
  interval?: InputMaybe<WixCommonAggregationDateHistogramAggregationInterval>;
};

export enum WixCommonAggregationDateHistogramAggregationInterval {
  DAY = 'DAY',
  HOUR = 'HOUR',
  MINUTE = 'MINUTE',
  MONTH = 'MONTH',
  SECOND = 'SECOND',
  UNKNOWN_INTERVAL = 'UNKNOWN_INTERVAL',
  WEEK = 'WEEK',
  YEAR = 'YEAR'
}

export type WixCommonAggregationGroupByAggregationInput = {
  /** Field to aggregate by. */
  fieldPath?: InputMaybe<Scalars['String']>;
  /** Unique, caller-defined aggregation name, returned in `aggregations.results`. */
  name?: InputMaybe<Scalars['String']>;
  /** Value aggregation configuration. */
  value?: InputMaybe<WixCommonAggregationValueAggregationInput>;
};

export type WixCommonAggregationInput = {
  /** A date histogram calculates the count of time values from the specified field in the dataset that fall within each time interval you define (hour, day, week, etc.) For example, use a date histogram to find how many reservations have been made at a restaurant each week. */
  dateHistogram?: InputMaybe<WixCommonAggregationDateHistogramAggregationInput>;
  /** Field to aggregate by. Use dot notation to specify a JSON path. For example, `order.address.streetName`. */
  fieldPath?: InputMaybe<Scalars['String']>;
  /** Aggregation name, returned in `aggregations.results.name`. */
  name?: InputMaybe<Scalars['String']>;
  /** A nested aggregation is applied within the results of another aggregation. Rather than aggregating directly on the primary dataset, first group data using one aggregation and then apply another aggregation within each group. It allows for more complex analyses where you can summarize data at different levels of detail or hierarchy. For example, to get the number of products that are in stock and out of stock for each price listed, first perform a value aggregation on `discountedPriceNumeric`, and a second value aggregation on `inStock`. */
  nested?: InputMaybe<WixCommonAggregationNestedAggregationInput>;
  /** A range aggregation calculates the count of the values from the specified field in the dataset that fall within the range of each bucket you define. For example, use a range aggregation to compare the number of reservations made for parties of 4 or less to the number of reservations made for parties with 5 or more. */
  range?: InputMaybe<WixCommonAggregationRangeAggregationInput>;
  /** A scalar aggregation calculates a single numerical value from a dataset, summarizing the dataset into one key metric: `COUNT_DISTINCT`, `SUM`, `AVG`, `MIN`, or `MAX`. */
  scalar?: InputMaybe<WixCommonAggregationScalarAggregationInput>;
  /** Type of aggregation to perform. Must align with the corresponding aggregation field. */
  type?: InputMaybe<WixCommonAggregationType>;
  /** A value aggregation calculates metrics such as count for specific fields within a dataset, providing insights into the overall distribution and key statistics of those values. For example, use a value aggregation to get the number (count) of products for each price listed in the store. */
  value?: InputMaybe<WixCommonAggregationValueAggregationInput>;
};

export type WixCommonAggregationNestedAggregationInput = {
  /** Flattened list of aggregations, where each aggregation is nested within previous one. */
  nestedAggregations?: InputMaybe<Array<InputMaybe<WixCommonAggregationNestedAggregationNestedAggregationItemInput>>>;
};

export type WixCommonAggregationNestedAggregationNestedAggregationItemInput = {
  /** A date histogram calculates the count of time values from the specified field in the dataset that fall within each time interval you define (hour, day, week, etc.). For example, use a date histogram to determine how many reservations have been made at a restaurant each week. If ranges overlap, a record that fits more than one range will only be counted in the first range that matches the criteria. */
  dateHistogram?: InputMaybe<WixCommonAggregationDateHistogramAggregationInput>;
  /** Field to aggregate by. Use dot notation to specify a JSON path. For example, `order.address.streetName`. */
  fieldPath?: InputMaybe<Scalars['String']>;
  /** Unique, caller-defined aggregation name, returned in `aggregations.results`. */
  name?: InputMaybe<Scalars['String']>;
  /** A range aggregation calculates the count of the values from the specified field in the dataset that fall within the range of each bucket you define. For example, use a range aggregation to compare the number of reservations made for parties of 4 or less to the number of reservations made for parties with 5 or more. If ranges overlap, a record that fits more than one range will only be counted in the first range that matches the criteria. */
  range?: InputMaybe<WixCommonAggregationRangeAggregationInput>;
  /** A scalar aggregation calculates a single numerical value from a dataset, summarizing the dataset into one key metric: `COUNT_DISTINCT`, `SUM`, `AVG`, `MIN`, or `MAX`. */
  scalar?: InputMaybe<WixCommonAggregationScalarAggregationInput>;
  /** Type of aggregation to perform. The matching aggregation field must be passed. */
  type?: InputMaybe<WixCommonAggregationNestedAggregationNestedAggregationType>;
  /** A value aggregation calculates the distribution of a specific field's values within a dataset, providing insights into the overall distribution and key statistics of those values. For example, use a value aggregation to get the number (count) of orders for each order status. */
  value?: InputMaybe<WixCommonAggregationValueAggregationInput>;
};

export enum WixCommonAggregationNestedAggregationNestedAggregationType {
  /** Calculates the count of time values from the specified field in the dataset that fall within each time interval you define (hour, day, week, etc.). */
  DATE_HISTOGRAM = 'DATE_HISTOGRAM',
  /** Calculates the count of the values from the specified field in the dataset that fall within the range of each bucket you define. */
  RANGE = 'RANGE',
  /** Calculates a single numerical value from a dataset, summarizing the dataset into one key metric: `COUNT_DISTINCT`, `SUM`, `AVG`, `MIN`, or `MAX`. */
  SCALAR = 'SCALAR',
  UNKNOWN_AGGREGATION_TYPE = 'UNKNOWN_AGGREGATION_TYPE',
  /** Calculates the distribution of a specific field's values within a dataset, providing insights into the overall distribution and key statistics of those values. */
  VALUE = 'VALUE'
}

export type WixCommonAggregationRangeAggregationInput = {
  /** List of range buckets. During aggregation each entity is placed in the first bucket its value falls into, based on the provided range bounds. */
  buckets?: InputMaybe<Array<InputMaybe<WixCommonAggregationRangeAggregationRangeBucketInput>>>;
};

export type WixCommonAggregationRangeAggregationRangeBucketInput = {
  /** Inclusive lower bound of the range. Required if `to` is not provided. */
  from?: InputMaybe<Scalars['Float']>;
  /** Exclusive upper bound of the range. Required if `from` is not provided. */
  to?: InputMaybe<Scalars['Float']>;
};

export type WixCommonAggregationScalarAggregationInput = {
  /** Operator type for the scalar aggregation. */
  type?: InputMaybe<WixCommonScalarType>;
};

export enum WixCommonAggregationType {
  /** Calculates the count of time values from the specified field in the dataset that fall within each time interval you define (hour, day, week, etc.). */
  DATE_HISTOGRAM = 'DATE_HISTOGRAM',
  /** Flattened list of aggregations, where each aggregation is nested within previous one. */
  NESTED = 'NESTED',
  /** Calculates the count of the values from the specified field in the dataset that fall within the range of each bucket you define. */
  RANGE = 'RANGE',
  /** Calculates a single numerical value from a dataset, summarizing the dataset into one key metric: `COUNT_DISTINCT`, `SUM`, `AVG`, `MIN`, or `MAX`. */
  SCALAR = 'SCALAR',
  UNKNOWN_AGGREGATION_TYPE = 'UNKNOWN_AGGREGATION_TYPE',
  /** Calculates the distribution of a specific field's values within a dataset, providing insights into the overall distribution and key statistics of those values. */
  VALUE = 'VALUE'
}

export type WixCommonAggregationValueAggregationIncludeMissingValuesOptionsInput = {
  /** Specify a custom name for the bucket containing the missing values. Defaults are `"N/A"` for strings, `0` for integers, and `false` for booleans. */
  addToBucket?: InputMaybe<Scalars['String']>;
};

export type WixCommonAggregationValueAggregationInput = {
  /** Options for including missing values in results. */
  includeOptions?: InputMaybe<WixCommonAggregationValueAggregationIncludeMissingValuesOptionsInput>;
  /**
   * Number of aggregation results to return.
   * Min: `1`
   * Max: `250`
   * Default: `10`
   */
  limit?: InputMaybe<Scalars['Int']>;
  /**
   * Whether to include or exclude missing values in the aggregation results.
   * Default: `EXCLUDE`.
   */
  missingValues?: InputMaybe<WixCommonAggregationValueAggregationMissingValues>;
  /** Sort direction. */
  sortDirection?: InputMaybe<WixCommonAggregationValueAggregationSortDirection>;
  /** Sort type. */
  sortType?: InputMaybe<WixCommonAggregationValueAggregationSortType>;
};

export enum WixCommonAggregationValueAggregationMissingValues {
  /** Exclude missing values from the aggregation results. */
  EXCLUDE = 'EXCLUDE',
  /** Include missing values in the aggregation results. */
  INCLUDE = 'INCLUDE'
}

export enum WixCommonAggregationValueAggregationSortDirection {
  /** Ascending order. */
  ASC = 'ASC',
  /** Descending order. */
  DESC = 'DESC'
}

export enum WixCommonAggregationValueAggregationSortType {
  /** Number of matches in the results. */
  COUNT = 'COUNT',
  /** Alphabetically by the field value. */
  VALUE = 'VALUE'
}

export type WixCommonAudio = {
  /**
   * Key to identify the object relationship to the original media in WixMedia.
   * Can be used to request a download for the specific asset.
   * For example: 128-30kbs.mp3, 320kbs.mp3, 128kbs.mp3
   */
  assetKey?: Maybe<Scalars['String']>;
  /** Audio duration in milliseconds. */
  duration?: Maybe<Scalars['Int']>;
  /** Audio filename. */
  filename?: Maybe<Scalars['String']>;
  /** Audio format. */
  format?: Maybe<Scalars['String']>;
  /** WixMedia ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * When true, this is a protected asset, and calling the URL will return a 403 error.
   * In order to access private assets, make a request to:
   * `GenerateFileDownloadUrl` with the WixMedia id and specify the asset_key in the request
   */
  private?: Maybe<Scalars['Boolean']>;
  /** Audio quality. */
  quality?: Maybe<Scalars['String']>;
  /** Audio size in bytes. */
  sizeInBytes?: Maybe<Scalars['String']>;
  /** Audio URL. */
  url?: Maybe<Scalars['String']>;
  /** Audio URL expiration date (when relevant). */
  urlExpirationDate?: Maybe<Scalars['String']>;
};

export type WixCommonAudioInput = {
  /**
   * Key to identify the object relationship to the original media in WixMedia.
   * Can be used to request a download for the specific asset.
   * For example: 128-30kbs.mp3, 320kbs.mp3, 128kbs.mp3
   */
  assetKey?: InputMaybe<Scalars['String']>;
  /** Audio duration in milliseconds. */
  duration?: InputMaybe<Scalars['Int']>;
  /** Audio filename. */
  filename?: InputMaybe<Scalars['String']>;
  /** Audio format. */
  format?: InputMaybe<Scalars['String']>;
  /** WixMedia ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * When true, this is a protected asset, and calling the URL will return a 403 error.
   * In order to access private assets, make a request to:
   * `GenerateFileDownloadUrl` with the WixMedia id and specify the asset_key in the request
   */
  private?: InputMaybe<Scalars['Boolean']>;
  /** Audio quality. */
  quality?: InputMaybe<Scalars['String']>;
  /** Audio size in bytes. */
  sizeInBytes?: InputMaybe<Scalars['String']>;
  /** Audio URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Audio URL expiration date (when relevant). */
  urlExpirationDate?: InputMaybe<Scalars['String']>;
};

export type WixCommonBulkActionMetadata = {
  /** Number of items that couldn't be processed. */
  totalFailures?: Maybe<Scalars['Int']>;
  /** Number of items that were successfully processed. */
  totalSuccesses?: Maybe<Scalars['Int']>;
  /** Number of failures without details because detailed failure threshold was exceeded. */
  undetailedFailures?: Maybe<Scalars['Int']>;
};

export enum WixCommonBulkActionType {
  DELETE = 'DELETE',
  INSERT = 'INSERT',
  UNKNOWN_ACTION_TYPE = 'UNKNOWN_ACTION_TYPE',
  UPDATE = 'UPDATE'
}

export type WixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * Pass the relevant cursor token from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Maximum number of items to return in the results. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixCommonCursorPagingMetadata = {
  /** Number of items returned in current page. */
  count?: Maybe<Scalars['Int']>;
  /** Cursor strings that point to the next page, previous page, or both. */
  cursors?: Maybe<WixCommonCursors>;
  /**
   * Whether there are more pages to retrieve following the current page.
   *
   * + `true`: Another page of results can be retrieved.
   * + `false`: This is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
  /**
   * Total number of items matching the filter.
   * Available only on the first page of *Search* results, not included in *Query* or *List* results.
   * If the Search results span multiple pages, the value of `total` will exceed the number of items returned on the first page.
   */
  total?: Maybe<Scalars['Int']>;
};

export type WixCommonCursorSearchInput = {
  /** Logical groupings of data into facets, with summaries for each facet. For example, use aggregations to allow site visitors to narrow down their search results by selecting specific categories. */
  aggregations?: InputMaybe<Array<InputMaybe<WixCommonAggregationInput>>>;
  /**
   * Cursor paging options.
   *
   * Learn more about [cursor paging](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#cursor-paging).
   */
  cursorPaging?: InputMaybe<WixCommonCursorPagingInput>;
  /**
   * Filter object.
   *
   * Learn more about [filtering](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#filters).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Free text to match in searchable fields. */
  search?: InputMaybe<WixCommonSearchDetailsInput>;
  /**
   * List of sort objects.
   *
   * Learn more about [sorting](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#sorting).
   */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
  /**
   * Time zone to adjust date-time-based filters and aggregations, in ISO 8601 (including offsets) or IANA time zone database (including time zone IDs) format.
   * Applies to all relevant filters and aggregations, unless overridden by providing timestamps including time zone. For example, "2023-12-20T10:52:34.795Z".
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type WixCommonCursors = {
  /** Cursor string pointing to the next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to the previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export type WixCommonDataDataextensionsExtendedFields = {
  /**
   * Extended field data. Each key corresponds to the namespace of the app that created the extended fields.
   * The value of each key is structured according to the schema defined when the extended fields were configured.
   *
   * You can only access fields for which you have the appropriate permissions.
   *
   * Learn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).
   */
  namespaces?: Maybe<Scalars['JSON']>;
};

export type WixCommonDataDataextensionsExtendedFieldsInput = {
  /**
   * Extended field data. Each key corresponds to the namespace of the app that created the extended fields.
   * The value of each key is structured according to the schema defined when the extended fields were configured.
   *
   * You can only access fields for which you have the appropriate permissions.
   *
   * Learn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).
   */
  namespaces?: InputMaybe<Scalars['JSON']>;
};

export type WixCommonDataDataextensionsUpdateExtendedFieldsRequestInput = {
  /** ID of the entity to update. */
  id?: InputMaybe<Scalars['String']>;
  /** Identifier for the app whose extended fields are being updated. */
  namespace?: InputMaybe<Scalars['String']>;
  /** Data to update. Structured according to the [schema](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields#json-schema-for-extended-fields) defined when the extended fields were configured. */
  namespaceData?: InputMaybe<Scalars['JSON']>;
};

export type WixCommonDocument = {
  /** Document filename. */
  filename?: Maybe<Scalars['String']>;
  /** WixMedia ID. */
  id?: Maybe<Scalars['String']>;
  /** Document size in bytes. */
  sizeInBytes?: Maybe<Scalars['String']>;
  /** Document thumbnail. */
  thumbnail?: Maybe<WixCommonImage>;
  /** Document URL. */
  url?: Maybe<Scalars['String']>;
  /** Document URL expiration date (when relevant). */
  urlExpirationDate?: Maybe<Scalars['String']>;
};

export type WixCommonDocumentInput = {
  /** Document filename. */
  filename?: InputMaybe<Scalars['String']>;
  /** WixMedia ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Document size in bytes. */
  sizeInBytes?: InputMaybe<Scalars['String']>;
  /** Document thumbnail. */
  thumbnail?: InputMaybe<WixCommonImageInput>;
  /** Document URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Document URL expiration date (when relevant). */
  urlExpirationDate?: InputMaybe<Scalars['String']>;
};

export type WixCommonDomaineventsActionEventInput = {
  bodyAsJson?: InputMaybe<Scalars['String']>;
};

export type WixCommonDomaineventsDomainEventInput = {
  actionEvent?: InputMaybe<WixCommonDomaineventsActionEventInput>;
  createdEvent?: InputMaybe<WixCommonDomaineventsEntityCreatedEventInput>;
  deletedEvent?: InputMaybe<WixCommonDomaineventsEntityDeletedEventInput>;
  /**
   * A sequence number defining the order of updates to the underlying entity.
   * For example, given that some entity was updated at 16:00 and than again at 16:01,
   * it is guaranteed that the sequence number of the second update is strictly higher than the first.
   * As the consumer, you can use this value to ensure that you handle messages in the correct order.
   * To do so, you will need to persist this number on your end, and compare the sequence number from the
   * message against the one you have stored. Given that the stored number is higher, you should ignore the message.
   */
  entityEventSequence?: InputMaybe<Scalars['Long']>;
  /**
   * Assumes actions are also always typed to an entity_type
   * Example: wix.stores.catalog.product, wix.bookings.session, wix.payments.transaction
   */
  entityFqdn?: InputMaybe<Scalars['String']>;
  /** ID of the entity associated with the event. */
  entityId?: InputMaybe<Scalars['String']>;
  /** Event timestamp. */
  eventTime?: InputMaybe<Scalars['String']>;
  /**
   * Unique event ID.
   * Allows clients to ignore duplicate webhooks.
   */
  id?: InputMaybe<Scalars['String']>;
  /** If present, indicates the action that triggered the event. */
  originatedFrom?: InputMaybe<Scalars['String']>;
  /**
   * This is top level to ease client code dispatching of messages (switch on entity_fqdn+slug)
   * This is although the created/updated/deleted notion is duplication of the oneof types
   * Example: created/updated/deleted/started/completed/email_opened
   */
  slug?: InputMaybe<Scalars['String']>;
  /**
   * Whether the event was triggered as a result of a privacy regulation application
   * (for example, GDPR).
   */
  triggeredByAnonymizeRequest?: InputMaybe<Scalars['Boolean']>;
  updatedEvent?: InputMaybe<WixCommonDomaineventsEntityUpdatedEventInput>;
};

export type WixCommonDomaineventsEntityCreatedEventInput = {
  entityAsJson?: InputMaybe<Scalars['String']>;
  /** Indicates the event was triggered by a restore-from-trashbin operation for a previously deleted entity */
  triggeredByUndelete?: InputMaybe<Scalars['Boolean']>;
};

export type WixCommonDomaineventsEntityDeletedEventInput = {
  /** Entity that was deleted */
  deletedEntityAsJson?: InputMaybe<Scalars['String']>;
  /** Indicates if the entity is sent to trash-bin. only available when trash-bin is enabled */
  movedToTrash?: InputMaybe<Scalars['Boolean']>;
};

export type WixCommonDomaineventsEntityUpdatedEventInput = {
  /**
   * Since platformized APIs only expose PATCH and not PUT we can't assume that the fields sent from the client are the actual diff.
   * This means that to generate a list of changed fields (as opposed to sent fields) one needs to traverse both objects.
   * We don't want to impose this on all developers and so we leave this traversal to the notification recipients which need it.
   */
  currentEntityAsJson?: InputMaybe<Scalars['String']>;
  /**
   * WIP - This property will hold both names and values of the updated fields of the entity.
   * For more details please see [adr](https://docs.google.com/document/d/1PdqsOM20Ph2HAkmx8zvUnzzk3Sekp3BR9h34wSvsRnI/edit#heading=h.phlw87mh2imx) or [issue](https://github.com/wix-private/nile-tracker/issues/363)
   */
  modifiedFields?: InputMaybe<Scalars['JSON']>;
  /**
   * This field is currently part of the of the EntityUpdatedEvent msg, but scala/node libraries which implements the domain events standard
   * wont populate it / have any reference to it in the API.
   * The main reason for it is that fetching the old entity from the DB will have a performance hit on an update operation so unless truly needed,
   * the developer should send only the new (current) entity.
   * An additional reason is not wanting to send this additional entity over the wire (kafka) since in some cases it can be really big
   * Developers that must reflect the old entity will have to implement their own domain event sender mechanism which will follow the DomainEvent proto message.
   */
  previousEntityAsJson?: InputMaybe<Scalars['String']>;
};

export type WixCommonFocalPoint = {
  /** crop by height */
  height?: Maybe<Scalars['Int']>;
  /** crop by width */
  width?: Maybe<Scalars['Int']>;
  /** X-coordinate of the focal point. */
  x?: Maybe<Scalars['Float']>;
  /** Y-coordinate of the focal point. */
  y?: Maybe<Scalars['Float']>;
};

export type WixCommonFocalPointInput = {
  /** crop by height */
  height?: InputMaybe<Scalars['Int']>;
  /** crop by width */
  width?: InputMaybe<Scalars['Int']>;
  /** X-coordinate of the focal point. */
  x?: InputMaybe<Scalars['Float']>;
  /** Y-coordinate of the focal point. */
  y?: InputMaybe<Scalars['Float']>;
};

export type WixCommonFullAddressContactDetailsInput = {
  /** Contact's company name. */
  company?: InputMaybe<Scalars['String']>;
  /** Email associated with the address. */
  email?: InputMaybe<Scalars['String']>;
  /** Contact's first name. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Contact's full name. */
  fullName?: InputMaybe<Scalars['String']>;
  /** Contact's last name. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Contact's phone number. */
  phone?: InputMaybe<Scalars['String']>;
  /** Tax info. Currently usable only in Brazil. */
  vatId?: InputMaybe<WixCommonVatIdInput>;
};

export type WixCommonImage = {
  /** Image alt text. */
  altText?: Maybe<Scalars['String']>;
  /** Image filename. */
  filename?: Maybe<Scalars['String']>;
  /** Focal point of the image. */
  focalPoint?: Maybe<WixCommonFocalPoint>;
  /** Original image height. */
  height?: Maybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: Maybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: Maybe<Scalars['String']>;
  /** Image URL. */
  url?: Maybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: Maybe<Scalars['String']>;
  /** Original image width. */
  width?: Maybe<Scalars['Int']>;
};

export type WixCommonImageInput = {
  /** Image alt text. */
  altText?: InputMaybe<Scalars['String']>;
  /** Image filename. */
  filename?: InputMaybe<Scalars['String']>;
  /** Focal point of the image. */
  focalPoint?: InputMaybe<WixCommonFocalPointInput>;
  /** Original image height. */
  height?: InputMaybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: InputMaybe<Scalars['String']>;
  /** Image URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: InputMaybe<Scalars['String']>;
  /** Original image width. */
  width?: InputMaybe<Scalars['Int']>;
};

export type WixCommonItemMetadata = {
  /** Details about the error in case of failure. */
  error?: Maybe<WixApiApplicationError>;
  /** Item ID. Should always be available, unless it's impossible (for example, when failing to create an item). */
  id?: Maybe<Scalars['String']>;
  /** Index of the item within the request array. Allows for correlation between request and response items. */
  originalIndex?: Maybe<Scalars['Int']>;
  /** Whether the requested action was successful for this item. When `false`, the `error` field is populated. */
  success?: Maybe<Scalars['Boolean']>;
};

export enum WixCommonLinkRel {
  /** Indicates that the current document's original author or publisher does not endorse the referenced document. */
  nofollow = 'nofollow',
  /** Instructs the browser to navigate to the target resource without granting the new browsing context access to the document that opened it. */
  noopener = 'noopener',
  /** No Referer header will be included. Additionally, has the same effect as noopener. */
  noreferrer = 'noreferrer',
  /** Indicates a link that resulted from advertisements or paid placements. */
  sponsored = 'sponsored',
  /** default (not implemented) */
  unknown_link_rel = 'unknown_link_rel'
}

export type WixCommonPageLink = {
  /** The page id we want from the site */
  pageId?: Maybe<Scalars['String']>;
  /** rel of link */
  rel?: Maybe<Array<Maybe<WixCommonLinkRel>>>;
  /** Where this link should open, supports _self and _blank or any name the user chooses. _self means same page, _blank means new page. */
  target?: Maybe<Scalars['String']>;
};

export type WixCommonPageLinkInput = {
  /** The page id we want from the site */
  pageId?: InputMaybe<Scalars['String']>;
  /** rel of link */
  rel?: InputMaybe<Array<InputMaybe<WixCommonLinkRel>>>;
  /** Where this link should open, supports _self and _blank or any name the user chooses. _self means same page, _blank means new page. */
  target?: InputMaybe<Scalars['String']>;
};

export type WixCommonPageUrl = {
  /** The base URL. For premium sites, this is the domain. For free sites, this is the site URL. For example, `mysite.wixsite.com/mysite`. */
  base?: Maybe<Scalars['String']>;
  /** The relative path for the page within the site. For example, `/product-page/a-product`. */
  path?: Maybe<Scalars['String']>;
};

export type WixCommonPageUrlInput = {
  /** The base URL. For premium sites, this is the domain. For free sites, this is the site URL. For example, `mysite.wixsite.com/mysite`. */
  base?: InputMaybe<Scalars['String']>;
  /** The relative path for the page within the site. For example, `/product-page/a-product`. */
  path?: InputMaybe<Scalars['String']>;
};

export type WixCommonPageUrlV2 = {
  /** The relative path for the page within the site. For example, `/product-page/a-product`. */
  relativePath?: Maybe<Scalars['String']>;
  /** The page's full URL. For example, `https://mysite.com/product-page/a-product`. */
  url?: Maybe<Scalars['String']>;
};

export type WixCommonPageUrlV2Input = {
  /** The relative path for the page within the site. For example, `/product-page/a-product`. */
  relativePath?: InputMaybe<Scalars['String']>;
  /** The page's full URL. For example, `https://mysite.com/product-page/a-product`. */
  url?: InputMaybe<Scalars['String']>;
};

export type WixCommonPagingInput = {
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the current sort order. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type WixCommonPagingMetadata = {
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
  /** Offset that was requested. */
  offset?: Maybe<Scalars['Int']>;
  /** Flag that indicates the server failed to calculate the `total` field. */
  tooManyToCount?: Maybe<Scalars['Boolean']>;
  /** Total number of items that match the query. */
  total?: Maybe<Scalars['Int']>;
};

export type WixCommonPagingMetadataV2 = {
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Cursors to navigate through the result pages using `next` and `prev`. Returned if cursor paging is used. */
  cursors?: Maybe<WixCommonCursors>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
  /** Offset that was requested. */
  offset?: Maybe<Scalars['Int']>;
  /** Flag that indicates the server failed to calculate the `total` field. */
  tooManyToCount?: Maybe<Scalars['Boolean']>;
  /** Total number of items that match the query. Returned if offset paging is used and the `tooManyToCount` flag is not set. */
  total?: Maybe<Scalars['Int']>;
};

export type WixCommonQueryInput = {
  /** Array of projected fields. A list of specific field names to return. If `fieldsets` are also specified, the union of `fieldsets` and `fields` is returned. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of named, predefined sets of projected fields. A array of predefined named sets of fields to be returned. Specifying multiple `fieldsets` will return the union of fields from all sets. If `fields` are also specified, the union of `fieldsets` and `fields` is returned. */
  fieldsets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Paging options to limit and skip the number of items. */
  paging?: InputMaybe<WixCommonPagingInput>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type WixCommonQueryV2Input = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixCommonCursorPagingInput>;
  /** Array of projected fields. A list of specific field names to return. If `fieldsets` are also specified, the union of `fieldsets` and `fields` is returned. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of named, predefined sets of projected fields. A array of predefined named sets of fields to be returned. Specifying multiple `fieldsets` will return the union of fields from all sets. If `fields` are also specified, the union of `fieldsets` and `fields` is returned. */
  fieldsets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter object.
   *
   * Learn more about [filtering](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#filters).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Paging options to limit and offset the number of items. */
  paging?: InputMaybe<WixCommonPagingInput>;
  /**
   * Sort object.
   *
   * Learn more about [sorting](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#sorting).
   */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export enum WixCommonScalarType {
  /** Average of values. */
  AVG = 'AVG',
  /** Total number of distinct values. */
  COUNT_DISTINCT = 'COUNT_DISTINCT',
  /** Maximum value. */
  MAX = 'MAX',
  /** Minimum value. */
  MIN = 'MIN',
  /** Sum of values. */
  SUM = 'SUM',
  UNKNOWN_SCALAR_TYPE = 'UNKNOWN_SCALAR_TYPE'
}

export type WixCommonSearchDetailsInput = {
  /** Search term or expression. */
  expression?: InputMaybe<Scalars['String']>;
  /** Fields to search in. If the array is empty, all searchable fields are searched. Use dot notation to specify a JSON path. For example, `order.address.streetName`. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Whether to enable the search function to use an algorithm to automatically find results that are close to the search expression, such as typos and declensions. */
  fuzzy?: InputMaybe<Scalars['Boolean']>;
  /** Search mode. Defines the search logic for combining multiple terms in the `expression`. */
  mode?: InputMaybe<WixCommonSearchDetailsMode>;
};

export enum WixCommonSearchDetailsMode {
  /** All search terms must be present. */
  AND = 'AND',
  /** At least one of the search terms must be present. */
  OR = 'OR'
}

export enum WixCommonSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type WixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixCommonSortOrder>;
  /**
   * When `field_name` is a property of repeated field that is marked as `MATCH_ITEMS` and sort should be done by
   * a specific element from a collection, filter can/should be provided to ensure correct sort value is picked.
   *
   * If multiple filters are provided, they are combined with AND operator.
   *
   * Example:
   * Given we have document like {"id": "1", "nestedField": [{"price": 10, "region": "EU"}, {"price": 20, "region": "US"}]}
   * and `nestedField` is marked as `MATCH_ITEMS`, to ensure that sorting is done by correct region, filter should be
   * { fieldName: "nestedField.price", "select_items_by": [{"nestedField.region": "US"}] }
   */
  selectItemsBy?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type WixCommonStreetAddress = {
  /** Apartment number. */
  apt?: Maybe<Scalars['String']>;
  /** Optional address line 1 */
  formattedAddressLine?: Maybe<Scalars['String']>;
  /** Street name. */
  name?: Maybe<Scalars['String']>;
  /** Street number. */
  number?: Maybe<Scalars['String']>;
};

export type WixCommonStreetAddressInput = {
  /** Apartment number. */
  apt?: InputMaybe<Scalars['String']>;
  /** Optional address line 1 */
  formattedAddressLine?: InputMaybe<Scalars['String']>;
  /** Street name. */
  name?: InputMaybe<Scalars['String']>;
  /** Street number. */
  number?: InputMaybe<Scalars['String']>;
};

export type WixCommonSubdivision = {
  /** Short subdivision code. */
  code?: Maybe<Scalars['String']>;
  /** Subdivision full name. */
  name?: Maybe<Scalars['String']>;
  /** Standard organizations details (e.g. ISO). */
  standardDetails?: Maybe<WixCommonSubdivisionStandardDetails>;
  /** Subdivision level */
  type?: Maybe<WixCommonSubdivisionSubdivisionType>;
  /** Free text description of subdivision type. */
  typeInfo?: Maybe<Scalars['String']>;
};

export type WixCommonSubdivisionInput = {
  /** Short subdivision code. */
  code?: InputMaybe<Scalars['String']>;
  /** Subdivision full name. */
  name?: InputMaybe<Scalars['String']>;
  /** Standard organizations details (e.g. ISO). */
  standardDetails?: InputMaybe<WixCommonSubdivisionStandardDetailsInput>;
  /** Subdivision level */
  type?: InputMaybe<WixCommonSubdivisionSubdivisionType>;
  /** Free text description of subdivision type. */
  typeInfo?: InputMaybe<Scalars['String']>;
};

export type WixCommonSubdivisionStandardDetails = {
  /** subdivision iso-3166-2 code according to [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2). e.g. US-NY, GB-SCT, NO-30 */
  iso31662?: Maybe<Scalars['String']>;
};

export type WixCommonSubdivisionStandardDetailsInput = {
  /** subdivision iso-3166-2 code according to [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2). e.g. US-NY, GB-SCT, NO-30 */
  iso31662?: InputMaybe<Scalars['String']>;
};

export enum WixCommonSubdivisionSubdivisionType {
  /** State */
  ADMINISTRATIVE_AREA_LEVEL_1 = 'ADMINISTRATIVE_AREA_LEVEL_1',
  /** County */
  ADMINISTRATIVE_AREA_LEVEL_2 = 'ADMINISTRATIVE_AREA_LEVEL_2',
  /** City/town */
  ADMINISTRATIVE_AREA_LEVEL_3 = 'ADMINISTRATIVE_AREA_LEVEL_3',
  /** Neighborhood/quarter */
  ADMINISTRATIVE_AREA_LEVEL_4 = 'ADMINISTRATIVE_AREA_LEVEL_4',
  /** Street/block */
  ADMINISTRATIVE_AREA_LEVEL_5 = 'ADMINISTRATIVE_AREA_LEVEL_5',
  /** ADMINISTRATIVE_AREA_LEVEL_0. Indicates the national political entity, and is typically the highest order type returned by the Geocoder. */
  COUNTRY = 'COUNTRY',
  UNKNOWN_SUBDIVISION_TYPE = 'UNKNOWN_SUBDIVISION_TYPE'
}

export type WixCommonTagsTags = {
  /** Tags that require an additional permission in order to access them, normally not given to site members or visitors. */
  privateTags?: Maybe<WixCommonTagsTagsTagList>;
  /** Tags that are exposed to anyone who has access to the labeled entity itself, including site members and visitors. */
  tags?: Maybe<WixCommonTagsTagsTagList>;
};

export type WixCommonTagsTagsInput = {
  /** Tags that require an additional permission in order to access them, normally not given to site members or visitors. */
  privateTags?: InputMaybe<WixCommonTagsTagsTagListInput>;
  /** Tags that are exposed to anyone who has access to the labeled entity itself, including site members and visitors. */
  tags?: InputMaybe<WixCommonTagsTagsTagListInput>;
};

export type WixCommonTagsTagsTagList = {
  /** List of tag IDs */
  tagIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type WixCommonTagsTagsTagListInput = {
  /** List of tag IDs */
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixCommonVatId = {
  /** Customer's tax ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Tax type.
   *
   * Supported values:
   * + `CPF`: for individual tax payers
   * + `CNPJ`: for corporations
   */
  type?: Maybe<WixCommonVatType>;
};

export type WixCommonVatIdInput = {
  /** Customer's tax ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Tax type.
   *
   * Supported values:
   * + `CPF`: for individual tax payers
   * + `CNPJ`: for corporations
   */
  type?: InputMaybe<WixCommonVatType>;
};

export enum WixCommonVatType {
  /** CNPJ - for corporations */
  CNPJ = 'CNPJ',
  /** CPF - for individual tax payers. */
  CPF = 'CPF',
  UNSPECIFIED = 'UNSPECIFIED'
}

export type WixCommonVideoResolution = {
  /**
   * Key to identify the video resolution's relationship to the original media in WixMedia.
   * Can be used to request a download for the specific video resolution.
   * For example: 480p.mp4, 720p.mp4, 1080p.mp4, trailer-720p.mp4, clip-720p.mp4
   */
  assetKey?: Maybe<Scalars['String']>;
  /** Video duration in milliseconds. */
  durationInMilliseconds?: Maybe<Scalars['Int']>;
  /**
   * Video duration in seconds.
   * @deprecated Video duration in seconds. Replaced by: duration_in_milliseconds. Removal date: 2024-08-01.
   */
  durationInSeconds?: Maybe<Scalars['Int']>;
  /** Video filename. */
  filename?: Maybe<Scalars['String']>;
  /** Video format for example, mp4, hls. */
  format?: Maybe<Scalars['String']>;
  /** Video height. */
  height?: Maybe<Scalars['Int']>;
  /** Deprecated. Use the `posters` property in the parent entity instead. */
  poster?: Maybe<WixCommonImage>;
  /**
   * When true, this is a protected asset, and calling the URL will return a 403 error.
   * In order to access private assets, make a request to:
   * `GenerateFileDownloadUrl` with the WixMedia id and specify the asset_key in the request
   */
  private?: Maybe<Scalars['Boolean']>;
  /** Video quality. For example: 480p, 720p. */
  quality?: Maybe<Scalars['String']>;
  /** Deprecated. Use the `sizeInBytes` property in the parent entity instead. Size cannot be provided per resolution. */
  sizeInBytes?: Maybe<Scalars['String']>;
  /** Video URL. */
  url?: Maybe<Scalars['String']>;
  /** Deprecated. Use the `urlExpirationDate` property in the parent entity instead. */
  urlExpirationDate?: Maybe<Scalars['String']>;
  /** Video width. */
  width?: Maybe<Scalars['Int']>;
};

export type WixCommonVideoResolutionInput = {
  /**
   * Key to identify the video resolution's relationship to the original media in WixMedia.
   * Can be used to request a download for the specific video resolution.
   * For example: 480p.mp4, 720p.mp4, 1080p.mp4, trailer-720p.mp4, clip-720p.mp4
   */
  assetKey?: InputMaybe<Scalars['String']>;
  /** Video duration in milliseconds. */
  durationInMilliseconds?: InputMaybe<Scalars['Int']>;
  /** Video filename. */
  filename?: InputMaybe<Scalars['String']>;
  /** Video format for example, mp4, hls. */
  format?: InputMaybe<Scalars['String']>;
  /** Video height. */
  height?: InputMaybe<Scalars['Int']>;
  /** Deprecated. Use the `posters` property in the parent entity instead. */
  poster?: InputMaybe<WixCommonImageInput>;
  /**
   * When true, this is a protected asset, and calling the URL will return a 403 error.
   * In order to access private assets, make a request to:
   * `GenerateFileDownloadUrl` with the WixMedia id and specify the asset_key in the request
   */
  private?: InputMaybe<Scalars['Boolean']>;
  /** Video quality. For example: 480p, 720p. */
  quality?: InputMaybe<Scalars['String']>;
  /** Deprecated. Use the `sizeInBytes` property in the parent entity instead. Size cannot be provided per resolution. */
  sizeInBytes?: InputMaybe<Scalars['String']>;
  /** Video URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Deprecated. Use the `urlExpirationDate` property in the parent entity instead. */
  urlExpirationDate?: InputMaybe<Scalars['String']>;
  /** Video width. */
  width?: InputMaybe<Scalars['Int']>;
};

export type WixCommonVideoV2 = {
  /** A long description for the video. will be used for SEO purposes. */
  description?: Maybe<Scalars['String']>;
  /** Original video duration in milliseconds. */
  durationInMilliseconds?: Maybe<Scalars['Int']>;
  /** Video filename. */
  filename?: Maybe<Scalars['String']>;
  /** Original video height. */
  height?: Maybe<Scalars['Int']>;
  /** WixMedia ID. */
  id?: Maybe<Scalars['String']>;
  /** Video posters. */
  posters?: Maybe<Array<Maybe<WixCommonImage>>>;
  /** Available resolutions for the video, starting with the optimal resolution. */
  resolutions?: Maybe<Array<Maybe<WixCommonVideoResolution>>>;
  /** Original video size in bytes. */
  sizeInBytes?: Maybe<Scalars['String']>;
  /** A short title for the video. will be used for SEO purposes. */
  title?: Maybe<Scalars['String']>;
  /** Original video URL. */
  url?: Maybe<Scalars['String']>;
  /** Video URL expiration date (when relevant). */
  urlExpirationDate?: Maybe<Scalars['String']>;
  /** Original video width. */
  width?: Maybe<Scalars['Int']>;
};

export type WixCommonVideoV2Input = {
  /** A long description for the video. will be used for SEO purposes. */
  description?: InputMaybe<Scalars['String']>;
  /** Original video duration in milliseconds. */
  durationInMilliseconds?: InputMaybe<Scalars['Int']>;
  /** Video filename. */
  filename?: InputMaybe<Scalars['String']>;
  /** Original video height. */
  height?: InputMaybe<Scalars['Int']>;
  /** WixMedia ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Video posters. */
  posters?: InputMaybe<Array<InputMaybe<WixCommonImageInput>>>;
  /** Available resolutions for the video, starting with the optimal resolution. */
  resolutions?: InputMaybe<Array<InputMaybe<WixCommonVideoResolutionInput>>>;
  /** Original video size in bytes. */
  sizeInBytes?: InputMaybe<Scalars['String']>;
  /** A short title for the video. will be used for SEO purposes. */
  title?: InputMaybe<Scalars['String']>;
  /** Original video URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Video URL expiration date (when relevant). */
  urlExpirationDate?: InputMaybe<Scalars['String']>;
  /** Original video width. */
  width?: InputMaybe<Scalars['Int']>;
};

export type WixCoreservicesMetroinspectorV1EchoMessage = {
  id?: Maybe<Scalars['String']>;
  /** message comment from EchoMessage proto def, with special comment */
  message?: Maybe<Scalars['String']>;
  /** messages_list comment from EchoMessage proto def */
  messagesList?: Maybe<Array<Maybe<WixCoreservicesMetroinspectorV1MessageItem>>>;
};

export type WixCoreservicesMetroinspectorV1EchoRequestInput = {
  /** 1st part of the message */
  arg1?: InputMaybe<Scalars['String']>;
  /** 2nd part of the message */
  arg2?: InputMaybe<Scalars['String']>;
  someDate?: InputMaybe<Scalars['String']>;
  someInt32?: InputMaybe<Scalars['Int']>;
  /** this field test translatable annotation */
  titleField?: InputMaybe<Scalars['String']>;
};

export type WixCoreservicesMetroinspectorV1EchoResponse = {
  /** message result as EchoMessage */
  echoMessage?: Maybe<WixCoreservicesMetroinspectorV1EchoMessage>;
  /** messge reseult as string */
  message?: Maybe<Scalars['String']>;
};

export type WixCoreservicesMetroinspectorV1MessageItem = {
  /** inner_message comment from EchoMessage proto def */
  innerMessage?: Maybe<Scalars['String']>;
};

export type WixCouponsApiV2Scope = {
  /** Coupon scope's applied group (e.g., event or ticket in Wix Events) */
  group?: Maybe<WixCouponsApiV2ScopeGroup>;
  /** Scope namespace (Wix Stores, Wix Bookings, Wix Events, Wix Pricing Plans) */
  namespace?: Maybe<Scalars['String']>;
};

export type WixCouponsApiV2ScopeGroup = {
  /** Item ID (when the coupon scope is limited to just one item). */
  entityId?: Maybe<Scalars['String']>;
  /** Coupon scope's group (e.g., product or collection in Wix Stores). See [valid scope values](https://dev.wix.com/api/rest/coupons/coupons/valid-scope-values). */
  name?: Maybe<Scalars['String']>;
};

export type WixCouponsApiV2ScopeGroupInput = {
  /** Item ID (when the coupon scope is limited to just one item). */
  entityId?: InputMaybe<Scalars['String']>;
  /** Coupon scope's group (e.g., product or collection in Wix Stores). See [valid scope values](https://dev.wix.com/api/rest/coupons/coupons/valid-scope-values). */
  name?: InputMaybe<Scalars['String']>;
};

export type WixCouponsApiV2ScopeInput = {
  /** Coupon scope's applied group (e.g., event or ticket in Wix Events) */
  group?: InputMaybe<WixCouponsApiV2ScopeGroupInput>;
  /** Scope namespace (Wix Stores, Wix Bookings, Wix Events, Wix Pricing Plans) */
  namespace?: InputMaybe<Scalars['String']>;
};

export type WixCrmCommonSourceInput = {
  /** Source app or service ID. */
  sourceId?: InputMaybe<Scalars['String']>;
  /** App or service type. */
  sourceType?: InputMaybe<WixCrmCommonSourceSourceType>;
};

export enum WixCrmCommonSourceSourceType {
  ADMIN = 'ADMIN',
  EXTERNAL = 'EXTERNAL',
  OTHER = 'OTHER',
  UNKNOWN_SOURCE_TYPE = 'UNKNOWN_SOURCE_TYPE',
  WIX_APP = 'WIX_APP'
}

export type WixCsmV2ClientSpec = {
  /** A OAuth access token for the application - provides API access. */
  accessToken?: Maybe<Scalars['String']>;
  /** deprecated */
  appDefId?: Maybe<Scalars['String']>;
  appDefinitionId?: Maybe<Scalars['String']>;
  appDefinitionName?: Maybe<Scalars['String']>;
  appFields?: Maybe<Scalars['JSON']>;
  appRequirements?: Maybe<WixCsmV2TpaAppRequirements>;
  appType?: Maybe<Scalars['String']>;
  appWorkerUrl?: Maybe<Scalars['String']>;
  /**
   * Deprecated. Represents so-called intId -- a "position" of the application in Site Pages (previously editor saved intId
   * instead of appDefId in pages to correlate with applications).
   */
  applicationId?: Maybe<Scalars['Int']>;
  collectionExposure?: Maybe<Scalars['String']>;
  collectionFormFace?: Maybe<Scalars['String']>;
  collectionType?: Maybe<Scalars['String']>;
  components?: Maybe<Scalars['JSON']>;
  dashboardDefaultHeight?: Maybe<Scalars['Int']>;
  dashboardUrl?: Maybe<Scalars['String']>;
  /** A data token for the application - provides data about the application user. */
  dataToken?: Maybe<Scalars['String']>;
  /** WLAClientSpec */
  datastoreId?: Maybe<Scalars['String']>;
  demoMode?: Maybe<Scalars['Boolean']>;
  editorPartDismissed?: Maybe<Scalars['Boolean']>;
  embeddedScriptUrl?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['String']>;
  gluedWidgets?: Maybe<WixCsmV2GluedWidget>;
  iconUrl?: Maybe<Scalars['String']>;
  inUse?: Maybe<Scalars['Boolean']>;
  installedAtDashboard?: Maybe<Scalars['Boolean']>;
  /** This field will be deprecated in the future. It currently contains either the access token or the data token. */
  instance?: Maybe<Scalars['String']>;
  instanceId?: Maybe<Scalars['String']>;
  /** TODO check serialization */
  isWixTPA?: Maybe<Scalars['Boolean']>;
  /** MetaSiteClientSpec */
  metaSiteId?: Maybe<Scalars['String']>;
  /** MobileAppClientSpec */
  name?: Maybe<Scalars['String']>;
  onboardingSettingsUrl?: Maybe<Scalars['String']>;
  openPremiumPage?: Maybe<Scalars['Boolean']>;
  originDatastoreId?: Maybe<Scalars['String']>;
  packageName?: Maybe<Scalars['String']>;
  permissions?: Maybe<WixCsmV2TpaPermissions>;
  pixelUrl?: Maybe<Scalars['String']>;
  preInstalled?: Maybe<Scalars['Boolean']>;
  provisionOnSaveSite?: Maybe<Scalars['Boolean']>;
  requiresEditorComponent?: Maybe<Scalars['Boolean']>;
  sectionDefaultPage?: Maybe<Scalars['String']>;
  sectionMobilePublished?: Maybe<Scalars['Boolean']>;
  sectionMobileUrl?: Maybe<Scalars['String']>;
  sectionPublished?: Maybe<Scalars['Boolean']>;
  sectionRefreshOnWidthChange?: Maybe<Scalars['Boolean']>;
  sectionSeoEnabled?: Maybe<Scalars['Boolean']>;
  sectionSettings?: Maybe<WixCsmV2TpaSettingsClientSpec>;
  sectionUrl?: Maybe<Scalars['String']>;
  settingsCompanyName?: Maybe<Scalars['String']>;
  settingsDialogBanner?: Maybe<Scalars['String']>;
  settingsHeight?: Maybe<Scalars['Int']>;
  /** TPAEditorClientSpec */
  settingsUrl?: Maybe<Scalars['String']>;
  settingsWidth?: Maybe<Scalars['Int']>;
  /** SiteMembersClientSpec */
  smcollectionId?: Maybe<Scalars['String']>;
  smtoken?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  /** OnboardingClientSpec */
  storyId?: Maybe<Scalars['String']>;
  /** Possible values: editor, public, wixapps, appbuilder, sitemembers, siteextension, mobileapp, onboarding, metasite or ignored. */
  type?: Maybe<Scalars['String']>;
  vendorProductId?: Maybe<Scalars['String']>;
  vendorProducts?: Maybe<Array<Maybe<Scalars['String']>>>;
  version?: Maybe<Scalars['String']>;
  /** BaseTPAClientSpec */
  versionFailure?: Maybe<Scalars['String']>;
  widgets?: Maybe<WixCsmV2Widget>;
};

export type WixCsmV2GluedWidget = {
  widgetId?: Maybe<Scalars['String']>;
  widgetUrl?: Maybe<Scalars['String']>;
};

export type WixCsmV2TpaAppRequirements = {
  requireSiteMembers?: Maybe<Scalars['Boolean']>;
};

export type WixCsmV2TpaPermissions = {
  revoked?: Maybe<Scalars['Boolean']>;
};

export type WixCsmV2TpaSettingsClientSpec = {
  abTest?: Maybe<Scalars['Boolean']>;
  height?: Maybe<Scalars['Int']>;
  onboardingUrl?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  urlV2?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
};

export type WixCsmV2Widget = {
  addOnlyOnce?: Maybe<Scalars['Boolean']>;
  appPage?: Maybe<WixCsmV2WidgetTpaAppPage>;
  autoAddToSite?: Maybe<Scalars['Boolean']>;
  canBeStretched?: Maybe<Scalars['Boolean']>;
  componentFields?: Maybe<Scalars['JSON']>;
  default?: Maybe<Scalars['Boolean']>;
  defaultHeight?: Maybe<Scalars['Int']>;
  defaultPosition?: Maybe<WixCsmV2WidgetTpaWidgetPosition>;
  defaultShowOnAllPages?: Maybe<Scalars['Boolean']>;
  /** TPAEditorClientWidget */
  defaultWidth?: Maybe<Scalars['Int']>;
  gluedOptions?: Maybe<WixCsmV2WidgetGluedOptions>;
  mobilePublished?: Maybe<Scalars['Boolean']>;
  mobileUrl?: Maybe<Scalars['String']>;
  preFetch?: Maybe<Scalars['Boolean']>;
  published?: Maybe<Scalars['Boolean']>;
  refreshOnWidthChange?: Maybe<Scalars['Boolean']>;
  santaEditorPublished?: Maybe<Scalars['Boolean']>;
  seoEnabled?: Maybe<Scalars['Boolean']>;
  settings?: Maybe<WixCsmV2TpaSettingsClientSpec>;
  shouldBeStretchedByDefault?: Maybe<Scalars['Boolean']>;
  shouldBeStretchedByDefaultMobile?: Maybe<Scalars['Boolean']>;
  tpaWidgetId?: Maybe<Scalars['String']>;
  /** BaseTPAClientWidget */
  widgetId?: Maybe<Scalars['String']>;
  widgetUrl?: Maybe<Scalars['String']>;
};

export type WixCsmV2WidgetGluedOptions = {
  horizontalMargin?: Maybe<Scalars['Float']>;
  placement?: Maybe<Scalars['String']>;
  verticalMargin?: Maybe<Scalars['Float']>;
};

export type WixCsmV2WidgetTpaAppPage = {
  defaultPage?: Maybe<Scalars['String']>;
  fullPage?: Maybe<Scalars['Boolean']>;
  hidden?: Maybe<Scalars['Boolean']>;
  hideFromMenu?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  indexable?: Maybe<Scalars['Boolean']>;
  landingPageInMobile?: Maybe<Scalars['Boolean']>;
  multiInstanceEnabled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
};

export type WixCsmV2WidgetTpaWidgetPosition = {
  placement?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
};

export type WixDevcenterAppsV1ActivateSecondarySecretRequestInput = {
  /** ID of the App you want to enable the secondary secret for */
  appId?: InputMaybe<Scalars['String']>;
};

export type WixDevcenterAppsV1ActivateSecondarySecretResponse = {
  /** The app with the new secrets state */
  app?: Maybe<WixDevcenterAppsV1App>;
};

export type WixDevcenterAppsV1App = {
  /** Account id contains multiple apps and used for app's sharing and contribution */
  accountId?: Maybe<Scalars['String']>;
  /** Secrets for auth and webhooks */
  appSecrets?: Maybe<WixDevcenterAppsV1AppSecrets>;
  /** The type of application */
  appType?: Maybe<WixDevcenterAppsV1AppType>;
  /** [OAuth urls](https://dev.wix.com/docs/build-apps/build-your-app/authentication/authentication-overview#oauth) of the app. [more info on OAuth](https://dev.wix.com/docs/build-apps/build-your-app/authentication/o-auth) */
  appUrls?: Maybe<WixDevcenterAppsV1AppUrls>;
  bookingPoliciesVirtualReference?: Maybe<WixBookingsV1QueryBookingPoliciesResponse>;
  /** Indicates if this app should be saved into runtime-cache */
  cacheable?: Maybe<Scalars['Boolean']>;
  /** Indicates if this app is a companion app assigned to a specific site */
  companionApp?: Maybe<Scalars['Boolean']>;
  /** The id and type of the entity which created the App (User, App, etc.) */
  createdBy?: Maybe<WixDevcenterAppsV1CreatedBy>;
  /** Represents the time this App was created */
  createdDate?: Maybe<Scalars['String']>;
  /** Indicates if the app is hipaa compliant - only for Wix Apps */
  hipaaCompliant?: Maybe<Scalars['Boolean']>;
  /** Application unique ID */
  id?: Maybe<Scalars['String']>;
  /** Installation preferences related to post installation flow */
  installationPreferences?: Maybe<WixDevcenterAppsV1InstallationPreferences>;
  /** TODO: How to handle the "Name" property? It is translatable and duplicated on the Market Listing Service as well */
  name?: Maybe<Scalars['String']>;
  /** The namespace of the application */
  namespace?: Maybe<Scalars['String']>;
  /** The ownership tag of the application */
  ownershipTag?: Maybe<Scalars['String']>;
  privateApp?: Maybe<Scalars['Boolean']>;
  /** Represents the current state of an item. Each time the item is modified, its `revision` changes. for an update operation to succeed, you MUST pass the latest revision */
  revision?: Maybe<Scalars['Long']>;
  servicesVirtualReference?: Maybe<WixBookingsServicesV2QueryServicesResponse>;
  /** The slug of the app. A human readable identifier of the app */
  slug?: Maybe<Scalars['String']>;
  /** The state of the application */
  status?: Maybe<WixDevcenterAppsV1Status>;
  /** Represent unreleased changes by type */
  unreleasedChanges?: Maybe<WixDevcenterAppsV1UnreleasedChanges>;
  /** Represents the time this App was last updated */
  updatedDate?: Maybe<Scalars['String']>;
  /** Is Wix owned the application */
  wixApp?: Maybe<Scalars['Boolean']>;
};


export type WixDevcenterAppsV1AppBookingPoliciesVirtualReferenceArgs = {
  queryInput?: InputMaybe<WixBookingsV1QueryBookingPoliciesRequestInput>;
};


export type WixDevcenterAppsV1AppServicesVirtualReferenceArgs = {
  queryInput?: InputMaybe<WixBookingsServicesV2QueryServicesRequestInput>;
};

export type WixDevcenterAppsV1AppInput = {
  /** Account id contains multiple apps and used for app's sharing and contribution */
  accountId?: InputMaybe<Scalars['String']>;
  /** Secrets for auth and webhooks */
  appSecrets?: InputMaybe<WixDevcenterAppsV1AppSecretsInput>;
  /** The type of application */
  appType?: InputMaybe<WixDevcenterAppsV1AppType>;
  /** [OAuth urls](https://dev.wix.com/docs/build-apps/build-your-app/authentication/authentication-overview#oauth) of the app. [more info on OAuth](https://dev.wix.com/docs/build-apps/build-your-app/authentication/o-auth) */
  appUrls?: InputMaybe<WixDevcenterAppsV1AppUrlsInput>;
  /** Indicates if this app should be saved into runtime-cache */
  cacheable?: InputMaybe<Scalars['Boolean']>;
  /** Indicates if this app is a companion app assigned to a specific site */
  companionApp?: InputMaybe<Scalars['Boolean']>;
  /** The id and type of the entity which created the App (User, App, etc.) */
  createdBy?: InputMaybe<WixDevcenterAppsV1CreatedByInput>;
  /** Represents the time this App was created */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Indicates if the app is hipaa compliant - only for Wix Apps */
  hipaaCompliant?: InputMaybe<Scalars['Boolean']>;
  /** Application unique ID */
  id?: InputMaybe<Scalars['String']>;
  /** Installation preferences related to post installation flow */
  installationPreferences?: InputMaybe<WixDevcenterAppsV1InstallationPreferencesInput>;
  /** TODO: How to handle the "Name" property? It is translatable and duplicated on the Market Listing Service as well */
  name?: InputMaybe<Scalars['String']>;
  /** The namespace of the application */
  namespace?: InputMaybe<Scalars['String']>;
  /** The ownership tag of the application */
  ownershipTag?: InputMaybe<Scalars['String']>;
  privateApp?: InputMaybe<Scalars['Boolean']>;
  /** Represents the current state of an item. Each time the item is modified, its `revision` changes. for an update operation to succeed, you MUST pass the latest revision */
  revision?: InputMaybe<Scalars['Long']>;
  /** The slug of the app. A human readable identifier of the app */
  slug?: InputMaybe<Scalars['String']>;
  /** The state of the application */
  status?: InputMaybe<WixDevcenterAppsV1Status>;
  /** Represent unreleased changes by type */
  unreleasedChanges?: InputMaybe<WixDevcenterAppsV1UnreleasedChangesInput>;
  /** Represents the time this App was last updated */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** Is Wix owned the application */
  wixApp?: InputMaybe<Scalars['Boolean']>;
};

export type WixDevcenterAppsV1AppSecrets = {
  /** A secondary auth secret of the application (in case of secret rotation) */
  appSecondarySecret?: Maybe<Scalars['String']>;
  /** Auth secret of the application */
  appSecret?: Maybe<Scalars['String']>;
  /** Indicates if the secondary secret is active */
  secondarySecretActive?: Maybe<Scalars['Boolean']>;
  /** The Webhook public key. It is used for decoding the Webhook event payload */
  webhookPublicKey?: Maybe<Scalars['String']>;
};

export type WixDevcenterAppsV1AppSecretsInput = {
  /** A secondary auth secret of the application (in case of secret rotation) */
  appSecondarySecret?: InputMaybe<Scalars['String']>;
  /** Auth secret of the application */
  appSecret?: InputMaybe<Scalars['String']>;
  /** Indicates if the secondary secret is active */
  secondarySecretActive?: InputMaybe<Scalars['Boolean']>;
  /** The Webhook public key. It is used for decoding the Webhook event payload */
  webhookPublicKey?: InputMaybe<Scalars['String']>;
};

export enum WixDevcenterAppsV1AppType {
  /** represents an account API KEY to access wix services */
  API_KEY = 'API_KEY',
  /** represents an app specific to a Meta Site that stores data about Activated Functions in that Meta Site */
  FUNCTION_ACTIVATION_APP = 'FUNCTION_ACTIVATION_APP',
  /** represents an External Headless (3rd party) App that has access to Wix Public Services */
  HEADLESS = 'HEADLESS',
  /** deprecated. Use private boolean instead */
  PRIVATE_APP = 'PRIVATE_APP',
  /** A Regular app entity - used to installed on sites */
  SITE_APP = 'SITE_APP',
  /** represents an app developed for Velo editor */
  VELO_APP = 'VELO_APP'
}

export type WixDevcenterAppsV1AppUrls = {
  /** the app url of OAuth */
  appUri?: Maybe<Scalars['String']>;
  /** list of redirect urls of OAuth */
  redirectUris?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type WixDevcenterAppsV1AppUrlsChangedInOldServiceEventAppUriMessageInput = {
  /** the app url of OAuth */
  appUri?: InputMaybe<Scalars['String']>;
};

export type WixDevcenterAppsV1AppUrlsChangedInOldServiceEventInput = {
  /** Id of the App to update */
  appId?: InputMaybe<Scalars['String']>;
  /** the app url of OAuth */
  appUriMessage?: InputMaybe<WixDevcenterAppsV1AppUrlsChangedInOldServiceEventAppUriMessageInput>;
  /** redirect uris */
  redirectUriMessage?: InputMaybe<WixDevcenterAppsV1AppUrlsChangedInOldServiceEventRedirectUrlMessageInput>;
};

export type WixDevcenterAppsV1AppUrlsChangedInOldServiceEventRedirectUrlMessageInput = {
  /** list of redirect urls of OAuth */
  redirectUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixDevcenterAppsV1AppUrlsInput = {
  /** the app url of OAuth */
  appUri?: InputMaybe<Scalars['String']>;
  /** list of redirect urls of OAuth */
  redirectUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixDevcenterAppsV1CreateAppRequestInput = {
  /** App to be created */
  app?: InputMaybe<WixDevcenterAppsV1AppInput>;
};

export type WixDevcenterAppsV1CreateAppResponse = {
  /** The created App */
  app?: Maybe<WixDevcenterAppsV1App>;
};

export type WixDevcenterAppsV1CreateSecondarySecretRequestInput = {
  /** ID of the App to update */
  appId?: InputMaybe<Scalars['String']>;
  /** The revision of the App */
  revision?: InputMaybe<Scalars['Long']>;
};

export type WixDevcenterAppsV1CreateSecondarySecretResponse = {
  /** The app with the new secondary secret */
  app?: Maybe<WixDevcenterAppsV1App>;
};

export type WixDevcenterAppsV1CreatedBy = {
  /** The id of the entity which created the App */
  id?: Maybe<Scalars['String']>;
  /** The type of the entity which created the App (User, App, etc.) */
  type?: Maybe<WixDevcenterAppsV1CreatedByCreatedByType>;
};

export enum WixDevcenterAppsV1CreatedByCreatedByType {
  APP = 'APP',
  CODE_GEN = 'CODE_GEN',
  USER = 'USER'
}

export type WixDevcenterAppsV1CreatedByInput = {
  /** The id of the entity which created the App */
  id?: InputMaybe<Scalars['String']>;
  /** The type of the entity which created the App (User, App, etc.) */
  type?: InputMaybe<WixDevcenterAppsV1CreatedByCreatedByType>;
};

export type WixDevcenterAppsV1DeleteAppRequestInput = {
  /** Id of the App to delete */
  appId?: InputMaybe<Scalars['String']>;
  /** The revision of the App */
  revision?: InputMaybe<Scalars['Long']>;
};

export type WixDevcenterAppsV1GenerateSlugRequestInput = {
  /** Id of the App to update */
  appId?: InputMaybe<Scalars['String']>;
};

export type WixDevcenterAppsV1GenerateSlugResponse = {
  /** The modified app */
  app?: Maybe<WixDevcenterAppsV1App>;
};

export type WixDevcenterAppsV1GetAppRequestInput = {
  /** Return consistent data */
  consistent?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  /** Deprecated!! Used only for supporting the "old" Apps Service //TODO: Remove this property when possible */
  withSecrets?: InputMaybe<Scalars['Boolean']>;
};

export type WixDevcenterAppsV1GetNamespaceSuggestionByNameRequestInput = {
  /** The name of the application */
  name?: InputMaybe<Scalars['String']>;
  /** Get Namespace by Account or Company */
  type?: InputMaybe<WixDevcenterAppsV1NamespaceType>;
};

export type WixDevcenterAppsV1GetNamespaceSuggestionByNameResponse = {
  /** The suggested namespace */
  namespace?: Maybe<Scalars['String']>;
};

export type WixDevcenterAppsV1GetNamespaceSuggestionRequestInput = {
  /** The id of the application */
  appId?: InputMaybe<Scalars['String']>;
  /** Get Namespace by Account or Company */
  type?: InputMaybe<WixDevcenterAppsV1NamespaceType>;
};

export type WixDevcenterAppsV1GetNamespaceSuggestionResponse = {
  /** The suggested namespace */
  namespace?: Maybe<Scalars['String']>;
};

export type WixDevcenterAppsV1InstallationPreferences = {
  /** Indicates the different consent options the app could define post installation */
  consentOptions?: Maybe<WixDevcenterAppsV1InstallationPreferencesConsentOptions>;
  /** The type of action the open button will have post installation */
  openButtonAction?: Maybe<WixDevcenterAppsV1InstallationPreferencesOpenButtonAction>;
  /** The object with the id of the component the user will be redirected by pressing the open button */
  openComponentIdOptions?: Maybe<WixDevcenterAppsV1InstallationPreferencesOpenComponentId>;
  /** Indicates where should the user be redirect after the app being installed */
  overridePostInstallationRedirect?: Maybe<WixDevcenterAppsV1InstallationPreferencesRedirectTarget>;
  /** The id of the component the user will be redirected to post installation */
  postInstallationComponentId?: Maybe<Scalars['String']>;
  /** Whether uninstalling should be blocked until further actions are taken */
  uninstallAction?: Maybe<WixDevcenterAppsV1InstallationPreferencesUninstallActions>;
};

export type WixDevcenterAppsV1InstallationPreferencesConsentOptions = {
  /** Indicates the different behaviours available for showing the consent form post installation */
  showConsentBehaviour?: Maybe<WixDevcenterAppsV1InstallationPreferencesShowConsentBehaviour>;
};

export type WixDevcenterAppsV1InstallationPreferencesConsentOptionsInput = {
  /** Indicates the different behaviours available for showing the consent form post installation */
  showConsentBehaviour?: InputMaybe<WixDevcenterAppsV1InstallationPreferencesShowConsentBehaviour>;
};

export type WixDevcenterAppsV1InstallationPreferencesInput = {
  /** Indicates the different consent options the app could define post installation */
  consentOptions?: InputMaybe<WixDevcenterAppsV1InstallationPreferencesConsentOptionsInput>;
  /** The type of action the open button will have post installation */
  openButtonAction?: InputMaybe<WixDevcenterAppsV1InstallationPreferencesOpenButtonAction>;
  /** The object with the id of the component the user will be redirected by pressing the open button */
  openComponentIdOptions?: InputMaybe<WixDevcenterAppsV1InstallationPreferencesOpenComponentIdInput>;
  /** Indicates where should the user be redirect after the app being installed */
  overridePostInstallationRedirect?: InputMaybe<WixDevcenterAppsV1InstallationPreferencesRedirectTarget>;
  /** The id of the component the user will be redirected to post installation */
  postInstallationComponentId?: InputMaybe<Scalars['String']>;
  /** Whether uninstalling should be blocked until further actions are taken */
  uninstallAction?: InputMaybe<WixDevcenterAppsV1InstallationPreferencesUninstallActions>;
};

export enum WixDevcenterAppsV1InstallationPreferencesOpenButtonAction {
  OPEN_COMPONENT_ID = 'OPEN_COMPONENT_ID',
  UNKNOWN_ACTION = 'UNKNOWN_ACTION'
}

export type WixDevcenterAppsV1InstallationPreferencesOpenComponentId = {
  /** The id of the component the user will be redirected by pressing the open button */
  componentId?: Maybe<Scalars['String']>;
};

export type WixDevcenterAppsV1InstallationPreferencesOpenComponentIdInput = {
  /** The id of the component the user will be redirected by pressing the open button */
  componentId?: InputMaybe<Scalars['String']>;
};

export enum WixDevcenterAppsV1InstallationPreferencesRedirectTarget {
  DASHBOARD = 'DASHBOARD',
  EDITOR = 'EDITOR',
  UNKNOWN_REDIRECT_TARGET = 'UNKNOWN_REDIRECT_TARGET'
}

export enum WixDevcenterAppsV1InstallationPreferencesShowConsentBehaviour {
  DEFAULT_BEHAVIOUR = 'DEFAULT_BEHAVIOUR',
  SHOW_CONSENT = 'SHOW_CONSENT',
  SKIP_CONSENT = 'SKIP_CONSENT'
}

export enum WixDevcenterAppsV1InstallationPreferencesUninstallActions {
  NONE_ACTION = 'NONE_ACTION',
  NO_ACTION = 'NO_ACTION',
  REMOVE_ALL_PRODUCT = 'REMOVE_ALL_PRODUCT',
  SHIPPING_RATES_REGION = 'SHIPPING_RATES_REGION'
}

export enum WixDevcenterAppsV1NamespaceType {
  ACCOUNT = 'ACCOUNT',
  COMPANY = 'COMPANY'
}

export type WixDevcenterAppsV1QueryAppRequestInput = {
  /** Using read-write connection? default "false" (using read connection) */
  consistent?: InputMaybe<Scalars['Boolean']>;
  /** Should also count the total numbers of results? (NOTICE: It will have slight impact on performance) */
  countResults?: InputMaybe<Scalars['Boolean']>;
  /** WQL expression */
  query?: InputMaybe<WixCommonQueryV2Input>;
};

export type WixDevcenterAppsV1QueryAppResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<WixDevcenterAppsV1App>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixDevcenterAppsV1RollbackSecretRequestInput = {
  /** ID of the App to update */
  appId?: InputMaybe<Scalars['String']>;
};

export type WixDevcenterAppsV1RollbackSecretResponse = {
  /** The app with the new secrets state */
  app?: Maybe<WixDevcenterAppsV1App>;
};

export type WixDevcenterAppsV1RotateSecretRequestInput = {
  /** ID of the App to update */
  appId?: InputMaybe<Scalars['String']>;
};

export type WixDevcenterAppsV1RotateSecretResponse = {
  /** The app with the new secrets state */
  app?: Maybe<WixDevcenterAppsV1App>;
};

export type WixDevcenterAppsV1SetAppOwnerRequestInput = {
  /** Id of the account to update */
  accountId?: InputMaybe<Scalars['String']>;
  /** Id of the App to update */
  appId?: InputMaybe<Scalars['String']>;
  /** The revision of the App */
  revision?: InputMaybe<Scalars['Long']>;
};

export type WixDevcenterAppsV1SetAppOwnerResponse = {
  /** The modified app */
  app?: Maybe<WixDevcenterAppsV1App>;
};

export type WixDevcenterAppsV1SetCacheableAppRequestInput = {
  /** App id of the app to update */
  appId?: InputMaybe<Scalars['String']>;
  /** Is the app cacheable */
  cacheable?: InputMaybe<Scalars['Boolean']>;
};

export type WixDevcenterAppsV1SetCacheableAppResponse = {
  /** The updated app */
  app?: Maybe<WixDevcenterAppsV1App>;
};

export type WixDevcenterAppsV1SetHipaaCompliantRequestInput = {
  /** App id of the app to update */
  appId?: InputMaybe<Scalars['String']>;
  /** Is the app HIPAA compliant */
  hipaaCompliant?: InputMaybe<Scalars['Boolean']>;
};

export type WixDevcenterAppsV1SetHipaaCompliantResponse = {
  /** The updated app */
  app?: Maybe<WixDevcenterAppsV1App>;
};

export type WixDevcenterAppsV1SetNamespaceRequestInput = {
  /** Id of the App to update */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * he name of the application. It MUST follow the following format:
   * Start with a letter
   * Contains ONLY letters and numbers or ("-", "_")
   */
  appName?: InputMaybe<Scalars['String']>;
  /** Set Namespace by Account or Company */
  type?: InputMaybe<WixDevcenterAppsV1NamespaceType>;
};

export type WixDevcenterAppsV1SetNamespaceResponse = {
  /** The updated namespace in Lower Case by the following format: "@{ACCOUNT_OR_COMPANY}/{APP_NAME}" */
  namespace?: Maybe<Scalars['String']>;
};

export type WixDevcenterAppsV1SetOwnershipTagRequestInput = {
  /** App id of the app to act on */
  appId?: InputMaybe<Scalars['String']>;
  /** Ownership tag to set */
  ownershipTag?: InputMaybe<Scalars['String']>;
};

export type WixDevcenterAppsV1SetPrivateAppRequestInput = {
  /** Id of the App to update */
  appId?: InputMaybe<Scalars['String']>;
  /** The value to set to private app */
  privateApp?: InputMaybe<Scalars['Boolean']>;
  /** The revision of the App */
  revision?: InputMaybe<Scalars['Long']>;
};

export type WixDevcenterAppsV1SetPrivateAppResponse = {
  /** The modified app */
  app?: Maybe<WixDevcenterAppsV1App>;
};

export enum WixDevcenterAppsV1Status {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  DEPRECATED = 'DEPRECATED'
}

export type WixDevcenterAppsV1UnreleasedChanges = {
  /** Indicate app permissions changes (create, update, delete) */
  appPermissionsChanges?: Maybe<Scalars['Boolean']>;
  /** Indicate app translations changes (create, update) */
  appTranslationsChanges?: Maybe<Scalars['Boolean']>;
  /** Indicate components changes (create, update, delete) */
  componentsChanges?: Maybe<Scalars['Boolean']>;
  /** Indicate components experiments changes (create, update, delete) */
  componentsExperimentsChanges?: Maybe<Scalars['Boolean']>;
  /** Indicate components translations changes (create, update) */
  componentsTranslationChanges?: Maybe<Scalars['Boolean']>;
};

export type WixDevcenterAppsV1UnreleasedChangesInput = {
  /** Indicate app permissions changes (create, update, delete) */
  appPermissionsChanges?: InputMaybe<Scalars['Boolean']>;
  /** Indicate app translations changes (create, update) */
  appTranslationsChanges?: InputMaybe<Scalars['Boolean']>;
  /** Indicate components changes (create, update, delete) */
  componentsChanges?: InputMaybe<Scalars['Boolean']>;
  /** Indicate components experiments changes (create, update, delete) */
  componentsExperimentsChanges?: InputMaybe<Scalars['Boolean']>;
  /** Indicate components translations changes (create, update) */
  componentsTranslationChanges?: InputMaybe<Scalars['Boolean']>;
};

export type WixDevcenterAppsV1UpdateAppRequestInput = {
  /** App to be updated, may be partial */
  app?: InputMaybe<WixDevcenterAppsV1AppInput>;
  /** Explicit list of fields to update */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixDevcenterAppsV1UpdateAppResponse = {
  /** The updated App */
  app?: Maybe<WixDevcenterAppsV1App>;
};

export type WixEcomOrdersBackofficeV1GetMetasiteDataRequestInput = {
  /** meta site Id for data to retrieve */
  metasiteId?: InputMaybe<Scalars['String']>;
};

export type WixEcomOrdersBackofficeV1GetMetasiteDataResponse = {
  /** is metasite added to new SDL population via population manager */
  isInNewPopulation?: Maybe<Scalars['Boolean']>;
  /** meta site data */
  metasite?: Maybe<ComWixpressMetasiteApiV1MetaSite>;
  /** metasite url */
  metasiteUrl?: Maybe<Scalars['String']>;
  /** owner data */
  userDataResponse?: Maybe<WixEcomOrdersBackofficeV1UserDataResponse>;
};

export type WixEcomOrdersBackofficeV1GetOrderAgcRequestInput = {
  /** Order Id for EP order to retrieve */
  id?: InputMaybe<Scalars['String']>;
};

export type WixEcomOrdersBackofficeV1GetOrderAgcResponse = {
  /** Order id if found */
  orderId?: Maybe<Scalars['String']>;
};

export type WixEcomOrdersBackofficeV1GetOrderForMetasiteRequestInput = {
  /** meta site Id for EP order to retrieve */
  metasiteId?: InputMaybe<Scalars['String']>;
  /** Order Id for EP order to retrieve */
  orderId?: InputMaybe<Scalars['String']>;
};

export type WixEcomOrdersBackofficeV1GetOrderForMetasiteResponse = {
  /** Existing EP order */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type WixEcomOrdersBackofficeV1GetOrderOutOfBoxRequestInput = {
  /** Order Id for EP order to retrieve */
  id?: InputMaybe<Scalars['String']>;
};

export type WixEcomOrdersBackofficeV1GetOrderOutOfBoxResponse = {
  /** Order id if found */
  orderId?: Maybe<Scalars['String']>;
};

export type WixEcomOrdersBackofficeV1GetOrderWithFilterByLocationRequestInput = {
  /** Order Id for EP order to retrieve */
  id?: InputMaybe<Scalars['String']>;
};

export type WixEcomOrdersBackofficeV1GetOrderWithFilterByLocationResponse = {
  /** Order id if found */
  orderId?: Maybe<Scalars['String']>;
};

export type WixEcomOrdersBackofficeV1ListOrderTransactionsForMetasiteRequestInput = {
  /** meta site Id for EP order transactions to retrieve */
  metasiteId?: InputMaybe<Scalars['String']>;
  /** Order Id for EP order transactions to retrieve */
  orderId?: InputMaybe<Scalars['String']>;
};

export type WixEcomOrdersBackofficeV1ListOrderTransactionsForMetasiteResponse = {
  /** Order ID and its associated transactions. */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
};

export type WixEcomOrdersBackofficeV1ListOrdersForMetasiteRequestInput = {
  /** paginated orders request */
  listOrderRequest?: InputMaybe<ComWixEcomOrdersV1ListOrdersRequestInput>;
  /** meta site Id for EP orders to retrieve */
  metasiteId?: InputMaybe<Scalars['String']>;
};

export type WixEcomOrdersBackofficeV1ListOrdersForMetasiteResponse = {
  /** found exisitng orders according to pagination provided. */
  orders?: Maybe<Array<Maybe<ComWixEcomOrdersV1Order>>>;
  /** Details on the paged set of results returned. */
  pagingMetadata?: Maybe<WixCommonCursorPagingMetadata>;
};

export type WixEcomOrdersBackofficeV1QueryOrdersForMetasiteRequestInput = {
  /** paginated internal orders query request */
  internalQueryOrdersRequest?: InputMaybe<ComWixEcomOrdersV1InternalQueryOrdersRequestInput>;
  /** meta site Id for EP orders to retrieve */
  metasiteId?: InputMaybe<Scalars['String']>;
};

export type WixEcomOrdersBackofficeV1QueryOrdersForMetasiteResponse = {
  /** found exisitng orders according to pagination and query provided. */
  orders?: Maybe<Array<Maybe<ComWixEcomOrdersV1Order>>>;
  /** Details on the paged set of results returned. */
  pagingMetadata?: Maybe<ComWixEcommerceCommonsApiPlatformPagingMetadata>;
};

export type WixEcomOrdersBackofficeV1TestUrlAdditionalBindingsRequestInput = {
  testId?: InputMaybe<Scalars['String']>;
};

export type WixEcomOrdersBackofficeV1TestUrlAdditionalBindingsResponse = {
  responseString?: Maybe<Scalars['String']>;
};

export type WixEcomOrdersBackofficeV1UpdateOrderRequestInput = {
  /** Field mask of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Order to be updated. */
  order?: InputMaybe<ComWixEcomOrdersV1OrderInput>;
};

export type WixEcomOrdersBackofficeV1UpdateOrderResponse = {
  /** Updated order. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
};

export type WixEcomOrdersBackofficeV1UpsertRefundRequestInput = {
  /** Meta site ID. */
  metasiteId?: InputMaybe<Scalars['String']>;
  /** Order ID associated with refund. */
  orderId?: InputMaybe<Scalars['String']>;
  /** Refund to upsert. */
  refund?: InputMaybe<ComWixEcomOrdersPaymentsV1RefundInput>;
};

export type WixEcomOrdersBackofficeV1UpsertRefundResponse = {
  /** Updated order transactions. */
  orderTransactions?: Maybe<ComWixEcomOrdersPaymentsV1OrderTransactions>;
};

export type WixEcomOrdersBackofficeV1UserDataResponse = {
  userEmail?: Maybe<Scalars['String']>;
  /** owner language */
  userLanguage?: Maybe<Scalars['String']>;
  /** owner name */
  userName?: Maybe<Scalars['String']>;
  /** owner status */
  userStatus?: Maybe<Scalars['String']>;
};

export enum WixEcommerceSubscriptionOptionApiV1DiscountDiscountType {
  /** No discount */
  AMOUNT = 'AMOUNT',
  PERCENT = 'PERCENT',
  UNDEFINED = 'UNDEFINED'
}

export type WixEcommerceSubscriptionOptionApiV1DiscountInput = {
  /** Discount type. */
  type?: InputMaybe<WixEcommerceSubscriptionOptionApiV1DiscountDiscountType>;
  /** Discount value. */
  value?: InputMaybe<Scalars['Float']>;
};

export type WixEcommerceSubscriptionOptionApiV1SubscriptionSettingsInput = {
  /** Whether subscription is renewed automatically at the end of each period. */
  autoRenewal?: InputMaybe<Scalars['Boolean']>;
  /** Number of billing cycles before subscription ends. Ignored if `autoRenewal: true`. */
  billingCycles?: InputMaybe<Scalars['Int']>;
  /** Frequency of recurring payment. */
  frequency?: InputMaybe<WixPaymentApiPayV2SubscriptionFrequency>;
  /** Interval of recurring payment (optional: default value 1 will be used if not provided) */
  interval?: InputMaybe<Scalars['Int']>;
};

export type WixEventsAgenda = {
  /** Whether the schedule is enabled for the event. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** Agenda page URL. */
  pageUrl?: Maybe<WixEventsSiteUrl>;
};

export type WixEventsAgendaInput = {
  /** Whether the schedule is enabled for the event. */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Agenda page URL. */
  pageUrl?: InputMaybe<WixEventsSiteUrlInput>;
};

export type WixEventsBadge = {
  /**
   * The date when function that yielded this badge was last edited.
   * Used to resolve priority when two or more badges have the same type.
   */
  functionUpdateDate?: Maybe<Scalars['String']>;
  /** Badge text. */
  text?: Maybe<Scalars['String']>;
  /** Badge type. */
  type?: Maybe<WixEventsBadgeTypeType>;
};

export enum WixEventsBadgeTypeType {
  /** 1st priority badge type. */
  FIRST_PRIORITY = 'FIRST_PRIORITY',
  /** 2nd priority badge type. */
  SECOND_PRIORITY = 'SECOND_PRIORITY',
  /** 3rd priority badge type. */
  THIRD_PRIORITY = 'THIRD_PRIORITY',
  /** Unknown badge type. */
  UNKNOWN_BADGE_TYPE = 'UNKNOWN_BADGE_TYPE'
}

export type WixEventsBulkCancelEventsRequestInput = {
  /** Filter. See [supported fields and operators](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events). */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type WixEventsBulkDeleteEventsRequestInput = {
  /** Filter. See [supported fields and operators](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events). */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type WixEventsCalendarLinks = {
  /** "Add to Google calendar" URL. */
  google?: Maybe<Scalars['String']>;
  /** "Download ICS calendar file" URL. */
  ics?: Maybe<Scalars['String']>;
};

export type WixEventsCancelEventRequestInput = {
  /** Event ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixEventsCancelEventResponse = {
  /** Canceled event. */
  event?: Maybe<WixEventsEvent>;
};

export type WixEventsCategoriesCategory = {
  /** Assigned events count. Deleted events are excluded. */
  assignedEventsCount?: Maybe<Scalars['Int']>;
  /** The total number of draft and published events assigned to the category. */
  counts?: Maybe<WixEventsCategoriesCategoryCounts>;
  /** Date and time when category was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Optionally client defined external ID. */
  externalId?: Maybe<Scalars['String']>;
  /** Category ID. */
  id?: Maybe<Scalars['String']>;
  /** Category name. */
  name?: Maybe<Scalars['String']>;
  /**
   * Category state. Possible values:
   *
   * `MANUAL`: Category is created manually by the user.
   * `AUTO`: Category is created automatically.
   * `RECURRING_EVENT`: Category is created automatically when publishing recurring events.
   * `HIDDEN`: Category can't be seen.
   *
   * Default: `MANUAL`.
   *
   * **Note:** The WIX_EVENTS.MANAGE_AUTO_CATEGORIES permission scope is required to use states other than `MANUAL`.
   */
  states?: Maybe<Array<Maybe<WixEventsCategoryStateState>>>;
};

export type WixEventsCategoriesCategoryCounts = {
  /** Total number of published events assigned to the category. Deleted events are excluded. */
  assignedDraftEventsCount?: Maybe<Scalars['Int']>;
  /** Total number of draft events assigned to the category. */
  assignedEventsCount?: Maybe<Scalars['Int']>;
};

export type WixEventsCategoryFilterInput = {
  /**
   * If true - only categorised events will be returned.
   * If false - only not categorised events will be returned.
   */
  categorised?: InputMaybe<Scalars['Boolean']>;
  /** Category id filter. */
  categoryId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Category states filter. Default - any state. */
  states?: InputMaybe<Array<InputMaybe<WixEventsCategoryStateState>>>;
};

export enum WixEventsCategoryStateState {
  /** Created automatically. */
  AUTO = 'AUTO',
  /** Category is used to store component events. */
  COMPONENT = 'COMPONENT',
  /** Category is hidden. */
  HIDDEN = 'HIDDEN',
  /** Created manually by the user. */
  MANUAL = 'MANUAL',
  /** Created when publishing recurring events. */
  RECURRING_EVENT = 'RECURRING_EVENT'
}

export enum WixEventsConferenceType {
  /** Everyone in the meeting can publish and subscribe video and audio. */
  MEETING = 'MEETING',
  /** Guests can only subscribe to video and audio. */
  WEBINAR = 'WEBINAR'
}

export type WixEventsCopyEventFromOtherSiteRequestInput = {
  /** Event ID. */
  eventId?: InputMaybe<Scalars['String']>;
  fieldset?: InputMaybe<Array<InputMaybe<WixEventsEventFieldset>>>;
  /** Wix Events Instance ID. */
  instanceId?: InputMaybe<Scalars['String']>;
};

export type WixEventsCopyEventFromOtherSiteResponse = {
  /** Copied event. */
  event?: Maybe<WixEventsEvent>;
};

export type WixEventsCopyEventRequestInput = {
  /**
   * If true, event will be copied as draft.
   * Otherwise copied event will be published, unless it is draft.
   */
  draft?: InputMaybe<Scalars['Boolean']>;
  /** Event ID. */
  eventId?: InputMaybe<Scalars['String']>;
};

export type WixEventsCopyEventResponse = {
  /** Copied event. */
  event?: Maybe<WixEventsEvent>;
};

export type WixEventsCopyEventV2RequestInput = {
  /**
   * If true, event will be copied as draft.
   * Otherwise copied event will be published, unless it is draft.
   */
  draft?: InputMaybe<Scalars['Boolean']>;
  /** Event data to update (partial) */
  event?: InputMaybe<WixEventsEventDataInput>;
  /**
   * Set of field paths to update.
   * <!--ONLY:REST-->
   * Fields will be auto-populated from the `event` entity unless added to the request explicitly.
   * <!--END:ONLY:REST-->
   * Behavior follows [google.protobuf.FieldMask](https://developers.google.com/protocol-buffers/docs/reference/google.protobuf#google.protobuf.FieldMask) semantics.
   */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Event ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixEventsCopyEventV2Response = {
  /** Copied event. */
  event?: Maybe<WixEventsEvent>;
};

export type WixEventsCreateEventV2RequestInput = {
  /** Whether event should be created as draft. Draft events are hidden from site visitors. */
  draft?: InputMaybe<Scalars['Boolean']>;
  /** Event data. */
  event?: InputMaybe<WixEventsEventDataInput>;
  /**
   * Content language code in ISO 639-1 format.
   * Used for translating ticket PDF labels, registration form, automatic emails, etc.
   * Supported languages: ar, bg, cs, da, de, el, en, es, fi, fr, he, hi, hu, id, it, ja, ko, ms, nl, no, pl, pt, ro, ru, sv, th, tl, tr, uk, zh.
   * Defaults to en.
   */
  language?: InputMaybe<Scalars['String']>;
};

export type WixEventsCreateEventV2Response = {
  /** Created event. */
  event?: Maybe<WixEventsEvent>;
};

export type WixEventsDashboard = {
  /** Guest RSVP summary. */
  rsvpSummary?: Maybe<WixEventsDashboardRsvpSummary>;
  /**
   * Summary of revenue and tickets sold.
   * (Archived orders are not included).
   */
  ticketingSummary?: Maybe<WixEventsDashboardTicketingSummary>;
};

export type WixEventsDashboardRsvpSummary = {
  /** Number of RSVPs with status `NO`. */
  no?: Maybe<Scalars['Int']>;
  /** Total number of RSVPs. */
  total?: Maybe<Scalars['Int']>;
  /** Number of RSVPs in waitlist. */
  waitlist?: Maybe<Scalars['Int']>;
  /** Number of RSVPs with status `YES`. */
  yes?: Maybe<Scalars['Int']>;
};

export type WixEventsDashboardTicketingSummary = {
  /** Whether currency is locked and cannot be changed (generally occurs after the first order in the specified currency has been created). */
  currencyLocked?: Maybe<Scalars['Boolean']>;
  /** Number of orders placed. */
  orders?: Maybe<Scalars['Int']>;
  /**
   * Total revenue, excluding fees.
   * (taxes and payment provider fees are not deducted.)
   */
  revenue?: Maybe<WixEventsMoney>;
  /** Number of tickets sold. */
  tickets?: Maybe<Scalars['Int']>;
  /** Total balance of confirmed transactions. */
  totalSales?: Maybe<WixEventsMoney>;
};

export type WixEventsDeleteEventRequestInput = {
  /** Event ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixEventsDeleteEventResponse = {
  /** Deleted event ID. */
  id?: Maybe<Scalars['String']>;
};

export type WixEventsEvent = {
  /** Rich-text content that are displayed in a site's "About Event" section (HTML). */
  about?: Maybe<Scalars['String']>;
  /** Agenda details. */
  agenda?: Maybe<WixEventsAgenda>;
  /** Assigned contacts label key. */
  assignedContactsLabel?: Maybe<Scalars['String']>;
  /** Event badges. */
  badges?: Maybe<Array<Maybe<WixEventsBadge>>>;
  /** "Add to calendar" URLs. */
  calendarLinks?: Maybe<WixEventsCalendarLinks>;
  /** Categories this event is assigned to. */
  categories?: Maybe<Array<Maybe<WixEventsCategoriesCategory>>>;
  /** Event creation timestamp. */
  created?: Maybe<Scalars['String']>;
  customizableTickets?: Maybe<Scalars['Boolean']>;
  /** Event dashboard summary of RSVP / ticket sales. */
  dashboard?: Maybe<WixEventsDashboard>;
  /** Event description. */
  description?: Maybe<Scalars['String']>;
  /** Visual settings for event. */
  eventDisplaySettings?: Maybe<WixEventsEventDisplaySettings>;
  /** Event page URL components. */
  eventPageUrl?: Maybe<WixEventsSiteUrl>;
  /** Event discussion feed. For internal use. */
  feed?: Maybe<WixEventsFeed>;
  /** Event registration form. */
  form?: Maybe<WixEventsFormForm>;
  /** Guest list configuration. */
  guestListConfig?: Maybe<WixEventsGuestListConfig>;
  /** Event ID. */
  id?: Maybe<Scalars['String']>;
  /** Instance ID of the site where event is hosted. */
  instanceId?: Maybe<Scalars['String']>;
  /** Labelling related data. */
  labellingSettings?: Maybe<WixEventsLabellingSettings>;
  /** ISO 639-1 language code of the event (used in content translations). */
  language?: Maybe<Scalars['String']>;
  /** Event location. */
  location?: Maybe<WixEventsLocation>;
  /** Rich content that are displayed in a site's "About Event" section. Successor to `about` field. */
  longDescription?: Maybe<WixRichContentV1RichContent>;
  /** Main event image. */
  mainImage?: Maybe<ComWixEventsUpstreamWixCommonImage>;
  /** Event modified timestamp. */
  modified?: Maybe<Scalars['String']>;
  /** Online conferencing details. */
  onlineConferencing?: Maybe<WixEventsOnlineConferencing>;
  policiesVirtualReference?: Maybe<WixEventsV2QueryPoliciesResponse>;
  /** Event publish timestamp. */
  publishedDate?: Maybe<Scalars['String']>;
  /** RSVP or ticketing registration details. */
  registration?: Maybe<WixEventsRegistration>;
  /** Event scheduling. */
  scheduling?: Maybe<WixEventsScheduling>;
  /** SEO settings. */
  seoSettings?: Maybe<WixEventsSeoSettings>;
  /** Event slug URL (generated from event title). */
  slug?: Maybe<Scalars['String']>;
  /** Event status. */
  status?: Maybe<WixEventsEventStatus>;
  /** Event title. */
  title?: Maybe<Scalars['String']>;
  /** Event creator user ID. */
  userId?: Maybe<Scalars['String']>;
};


export type WixEventsEventPoliciesVirtualReferenceArgs = {
  queryInput?: InputMaybe<WixEventsV2QueryPoliciesRequestInput>;
};

export type WixEventsEventDataInput = {
  /** Rich-text content for About Event section (HTML). */
  about?: InputMaybe<Scalars['String']>;
  /** Agenda configuration */
  agenda?: InputMaybe<WixEventsAgendaInput>;
  customizableTickets?: InputMaybe<Scalars['Boolean']>;
  /** Event description. */
  description?: InputMaybe<Scalars['String']>;
  /** Visual settings for event. */
  eventDisplaySettings?: InputMaybe<WixEventsEventDisplaySettingsInput>;
  /** Guest list configuration */
  guestListConfig?: InputMaybe<WixEventsGuestListConfigInput>;
  /**
   * Event location.
   * Address is required for non TBD event.
   * Location name is required for TBD event.
   */
  location?: InputMaybe<WixEventsLocationInput>;
  /** Rich content for About Event section. Successor to `about` field. */
  longDescription?: InputMaybe<WixRichContentV1RichContentInput>;
  /**
   * Main event image. Printed in ticket PDF.
   * Currently, only images previously saved in Wix Media are supported.
   */
  mainImage?: InputMaybe<ComWixEventsUpstreamWixCommonImageInput>;
  /** Online conferencing configuration */
  onlineConferencingConfig?: InputMaybe<WixEventsOnlineConferencingConfigInput>;
  /** Registration configuration */
  registrationConfig?: InputMaybe<WixEventsRegistrationConfigInput>;
  /** RSVP collection configuration. Can be used to set limits. */
  rsvpCollectionConfig?: InputMaybe<WixEventsRsvpCollectionConfigInput>;
  /** Event schedule configuration */
  scheduleConfig?: InputMaybe<WixEventsScheduleConfigInput>;
  /** SEO settings */
  seoSettings?: InputMaybe<WixEventsSeoSettingsInput>;
  /** Event title. */
  title?: InputMaybe<Scalars['String']>;
};

export type WixEventsEventDisplaySettings = {
  /** Whether event details button is hidden. Only available for events with no registration. */
  hideEventDetailsButton?: Maybe<Scalars['Boolean']>;
  /** Disables event details page visibility. If event has an external registration configured visitors will be redirected from this page. */
  hideEventDetailsPage?: Maybe<Scalars['Boolean']>;
};

export type WixEventsEventDisplaySettingsInput = {
  /** Whether event details button is hidden. Only available for events with no registration. */
  hideEventDetailsButton?: InputMaybe<Scalars['Boolean']>;
  /** Disables event details page visibility. If event has an external registration configured visitors will be redirected from this page. */
  hideEventDetailsPage?: InputMaybe<Scalars['Boolean']>;
};

export enum WixEventsEventFieldset {
  /** Include `agendaSettings` in the response. */
  AGENDA = 'AGENDA',
  /** Include badges in the response. */
  BADGES = 'BADGES',
  /** Include `categories` in the response. */
  CATEGORIES = 'CATEGORIES',
  CUSTOMIZABLE_TICKETS = 'CUSTOMIZABLE_TICKETS',
  /** Include `dashboard` in the response. */
  DASHBOARD = 'DASHBOARD',
  /** Include `description`, `mainImage` and `calendarLinks` in the response. */
  DETAILS = 'DETAILS',
  /** Include `feed` in the response. */
  FEED = 'FEED',
  /** Include `form` in the response. */
  FORM = 'FORM',
  FULL = 'FULL',
  /** Include `onlineConferencing` in the response. */
  ONLINE_CONFERENCING_SESSION = 'ONLINE_CONFERENCING_SESSION',
  /** Include `registration` in the response. */
  REGISTRATION = 'REGISTRATION',
  /** Include `seoSettings` in the response. */
  SEO_SETTINGS = 'SEO_SETTINGS',
  /** Include `about` event rich text in the response. */
  TEXTS = 'TEXTS',
  /** Include `eventPageUrl` in the response. */
  URLS = 'URLS'
}

export enum WixEventsEventStatus {
  /** Event was canceled */
  CANCELED = 'CANCELED',
  /** Event is not public and needs to be published */
  DRAFT = 'DRAFT',
  /** Event has ended */
  ENDED = 'ENDED',
  /** Event is public and scheduled to start */
  SCHEDULED = 'SCHEDULED',
  /** Event has started */
  STARTED = 'STARTED'
}

export enum WixEventsEventType {
  /** External registration */
  EXTERNAL = 'EXTERNAL',
  /** Type not available for this request fieldset */
  NA_EVENT_TYPE = 'NA_EVENT_TYPE',
  /** Registration not available */
  NO_REGISTRATION = 'NO_REGISTRATION',
  /** Registration via RSVP */
  RSVP = 'RSVP',
  /** Registration via ticket purchase */
  TICKETS = 'TICKETS'
}

export type WixEventsEventsEventCopiedInput = {
  /** Event ID. Indicates the original event which current event was derived from. */
  derivedFromEventId?: InputMaybe<Scalars['String']>;
  /** Instance ID. Indicates the original app instance which current event was derived from. */
  derivedFromInstanceId?: InputMaybe<Scalars['String']>;
  /** Event ID. */
  eventId?: InputMaybe<Scalars['String']>;
  /** Event location. */
  location?: InputMaybe<WixEventsLocationInput>;
  /** Event schedule configuration. */
  scheduleConfig?: InputMaybe<WixEventsScheduleConfigInput>;
  /** Event status. */
  status?: InputMaybe<WixEventsEventStatus>;
  /**
   * Map of copied ticket definitions from original event.
   * Key represents ticket def id in the original event.
   * Value represents ticket def id in the newly created event.
   */
  ticketDefinitions?: InputMaybe<Scalars['JSON']>;
  /** Event created timestamp in ISO UTC format. */
  timestamp?: InputMaybe<Scalars['String']>;
  /** Event title. */
  title?: InputMaybe<Scalars['String']>;
  /** Event creator user ID. */
  userId?: InputMaybe<Scalars['String']>;
};

export type WixEventsExternalEvent = {
  /** External event registration URL. */
  registration?: Maybe<Scalars['String']>;
};

export type WixEventsFacetCounts = {
  /** Facet counts aggregated per value. */
  counts?: Maybe<Scalars['JSON']>;
};

export type WixEventsFeed = {
  /** Event discussion feed token. */
  token?: Maybe<Scalars['String']>;
};

export type WixEventsFindEventRequestInput = {
  /** Consistent read. */
  consistentRead?: InputMaybe<Scalars['Boolean']>;
  /**
   * Controls which event properties are returned. See [Fieldset](https://dev.wix.com/api/rest/wix-events/wix-events/fieldset#wix-events_wix-events_fieldset_event-fieldset).
   * Some fields require additional computation that affects latency.
   * Use minimum set of required fieldset for best performance.
   */
  fieldset?: InputMaybe<Array<InputMaybe<WixEventsEventFieldset>>>;
  /** Event ID. */
  id?: InputMaybe<Scalars['String']>;
  /** URL slug. */
  slug?: InputMaybe<Scalars['String']>;
};

export type WixEventsFindEventResponse = {
  /** Event. */
  event?: Maybe<WixEventsEvent>;
};

export type WixEventsFindOnlineConferenceSessionRequestInput = {
  /** Event id. */
  eventId?: InputMaybe<Scalars['String']>;
  /** Provider id. */
  providerId?: InputMaybe<Scalars['String']>;
};

export type WixEventsFindOnlineConferenceSessionResponse = {
  /** Online Conferencing Session. */
  session?: Maybe<WixEventsOnlineConferencingSession>;
};

export type WixEventsFormCheckoutFormMessages = {
  /** Confirmation messages shown after checkout. */
  confirmation?: Maybe<WixEventsFormCheckoutFormMessagesResponseConfirmation>;
  /** Submit form call-to-action label text. */
  submitActionLabel?: Maybe<Scalars['String']>;
  /** Main form title for response. */
  title?: Maybe<Scalars['String']>;
};

export type WixEventsFormCheckoutFormMessagesResponseConfirmation = {
  /** "Add to calendar" call-to-action label text. */
  addToCalendarLabel?: Maybe<Scalars['String']>;
  /** "Download tickets" call-to-action label text. */
  downloadTicketsLabel?: Maybe<Scalars['String']>;
  /** Confirmation message text. */
  message?: Maybe<Scalars['String']>;
  /** "Share event" call-to-action label text. */
  shareEventLabel?: Maybe<Scalars['String']>;
  /** Confirmation message title. */
  title?: Maybe<Scalars['String']>;
};

export type WixEventsFormForm = {
  /** Nested fields as an ordered list. */
  controls?: Maybe<Array<Maybe<WixEventsFormInputControl>>>;
  /**
   * Set of defined form messages displayed in the UI before, during, and after a registration flow.
   * Includes the configuration of form titles, response labels, "thank you" messages, and call-to-action texts.
   */
  messages?: Maybe<WixEventsFormFormMessages>;
};

export type WixEventsFormFormMessages = {
  /** Checkout form messages. */
  checkout?: Maybe<WixEventsFormCheckoutFormMessages>;
  /** Messages shown when event registration is closed. */
  registrationClosed?: Maybe<WixEventsFormRegistrationClosedMessages>;
  /** RSVP form ([SDK](https://dev.wix.com/docs/sdk/backend-modules/events/rsvp-v2/introduction) | [REST](https://dev.wix.com/docs/rest/business-solutions/events/rsvp-v2/introduction)) messages. */
  rsvp?: Maybe<WixEventsFormRsvpFormMessages>;
  /** Messages shown when event tickets are unavailable. */
  ticketsUnavailable?: Maybe<WixEventsFormTicketsUnavailableMessages>;
};

export type WixEventsFormInput = {
  /** Additional labels for multi-valued fields such as address. */
  additionalLabels?: Maybe<Scalars['JSON']>;
  /** *Deprecated:** Use `controls.inputs.type.TEXT_ARRAY`. */
  array?: Maybe<Scalars['Boolean']>;
  /**
   * Default option initially selected when an input has multiple choices.
   *
   * Defaults to first (0th) option, if not configured.
   * Currently only applicable for `type.dropdown`.
   */
  defaultOptionSelection?: Maybe<WixEventsFormOptionSelection>;
  /** Main field label. */
  label?: Maybe<Scalars['String']>;
  /** Additional labels for multi-valued fields, such as address. */
  labels?: Maybe<Array<Maybe<WixEventsFormLabel>>>;
  /** Whether field is mandatory. */
  mandatory?: Maybe<Scalars['Boolean']>;
  /** Maximum number of accepted characters (relevant for text fields). */
  maxLength?: Maybe<Scalars['Int']>;
  /**
   * The maximum number of accepted values for array input.
   *
   * **Note:** Only applicable for `TEXT_ARRAY` input fields.
   */
  maxSize?: Maybe<Scalars['Int']>;
  /** Field name. */
  name?: Maybe<Scalars['String']>;
  /** Predefined choice options for fields, such as dropdown. */
  options?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Type which determines field format.
   * Used to validate submitted response.
   */
  type?: Maybe<WixEventsFormValueType>;
};

export type WixEventsFormInputControl = {
  /** Whether the input control is deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  /** Unique control ID. */
  id?: Maybe<Scalars['String']>;
  /** Child inputs. */
  inputs?: Maybe<Array<Maybe<WixEventsFormInput>>>;
  /** *Deprecated:** Use `controls.inputs.label`. */
  label?: Maybe<Scalars['String']>;
  /** Deprecated: Use `id` or `_id`. */
  name?: Maybe<Scalars['String']>;
  /** Field controls are sorted by this value in ascending order. */
  orderIndex?: Maybe<Scalars['Int']>;
  /** Whether the control is mandatory (such as `name` & `email`). When `true`, only the label can be changed. */
  system?: Maybe<Scalars['Boolean']>;
  /** Field control type. */
  type?: Maybe<WixEventsFormInputControlType>;
};

export enum WixEventsFormInputControlType {
  /** Full address field with multiple lines. */
  ADDRESS_FULL = 'ADDRESS_FULL',
  /** Single-line address field. */
  ADDRESS_SHORT = 'ADDRESS_SHORT',
  /** Multiple-choice field with predefined values. */
  CHECKBOX = 'CHECKBOX',
  /** Fields for entering year, month, and day. */
  DATE = 'DATE',
  /** Single-choice field with predefined values. */
  DROPDOWN = 'DROPDOWN',
  /** Fields for additional guests and their respective names. */
  GUEST_CONTROL = 'GUEST_CONTROL',
  /** Single text value field. */
  INPUT = 'INPUT',
  /** Fields for entering first and last names. */
  NAME = 'NAME',
  /** Single-choice field with predefined values. */
  RADIO = 'RADIO',
  /** Single text value field with multiple lines. */
  TEXTAREA = 'TEXTAREA'
}

export type WixEventsFormLabel = {
  /** Field label. */
  label?: Maybe<Scalars['String']>;
  /** Field name. */
  name?: Maybe<Scalars['String']>;
};

export type WixEventsFormOptionSelection = {
  /** 0-based index from predefined `controls.inputs.options` which is initial selection. */
  optionIndex?: Maybe<Scalars['Int']>;
  /**
   * Placeholder hint describing expected choices, such as "Please select".
   * Considered an empty choice.
   */
  placeholderText?: Maybe<Scalars['String']>;
};

export type WixEventsFormRegistrationClosedMessages = {
  /** "Explore other events" call-to-action label text. */
  exploreEventsActionLabel?: Maybe<Scalars['String']>;
  /** Message shown when event registration is closed. */
  message?: Maybe<Scalars['String']>;
};

export type WixEventsFormRsvpFormMessages = {
  /** Messages displayed when an RSVP's `status` is set to `"NO"`. */
  negativeMessages?: Maybe<WixEventsFormRsvpFormMessagesNegative>;
  /** Messages displayed when an RSVP's `status` is set to `"YES"`. */
  positiveMessages?: Maybe<WixEventsFormRsvpFormMessagesPositive>;
  /** Label text indicating RSVP's `status` is `"NO"`. */
  rsvpNoOption?: Maybe<Scalars['String']>;
  /** Label text indicating RSVP's `status` is `"YES"`. */
  rsvpYesOption?: Maybe<Scalars['String']>;
  /** "Submit form" call-to-action label text. */
  submitActionLabel?: Maybe<Scalars['String']>;
  /** Messages displayed when an RSVP's `status` is set to `"WAITLIST"`, for when the event is full and a waitlist is available). */
  waitlistMessages?: Maybe<WixEventsFormRsvpFormMessagesPositive>;
};

export type WixEventsFormRsvpFormMessagesNegative = {
  /** Confirmation messages shown after registration. */
  confirmation?: Maybe<WixEventsFormRsvpFormMessagesNegativeResponseConfirmation>;
  /** Main form title for negative response. */
  title?: Maybe<Scalars['String']>;
};

export type WixEventsFormRsvpFormMessagesNegativeResponseConfirmation = {
  /** "Share event" call-to-action label text. */
  shareActionLabel?: Maybe<Scalars['String']>;
  /** Confirmation message title. */
  title?: Maybe<Scalars['String']>;
};

export type WixEventsFormRsvpFormMessagesPositive = {
  /** Confirmation messages shown after registration. */
  confirmation?: Maybe<WixEventsFormRsvpFormMessagesPositiveResponseConfirmation>;
  /** Main form title for positive response. */
  title?: Maybe<Scalars['String']>;
};

export type WixEventsFormRsvpFormMessagesPositiveResponseConfirmation = {
  /** "Add to calendar" call-to-action label text. */
  addToCalendarActionLabel?: Maybe<Scalars['String']>;
  /** Confirmation message text. */
  message?: Maybe<Scalars['String']>;
  /** "Share event" call-to-action label text. */
  shareActionLabel?: Maybe<Scalars['String']>;
  /** Confirmation message title. */
  title?: Maybe<Scalars['String']>;
};

export type WixEventsFormTicketsUnavailableMessages = {
  /** "Explore other events" call-to-action label text. */
  exploreEventsActionLabel?: Maybe<Scalars['String']>;
  /** Message shown when event tickets are unavailable. */
  message?: Maybe<Scalars['String']>;
};

export enum WixEventsFormValueType {
  ADDRESS = 'ADDRESS',
  DATE_TIME = 'DATE_TIME',
  NUMBER = 'NUMBER',
  TEXT = 'TEXT',
  TEXT_ARRAY = 'TEXT_ARRAY'
}

export type WixEventsGetEventRequestInput = {
  /**
   * Controls which event properties are returned. See [Fieldset](https://dev.wix.com/api/rest/wix-events/wix-events/fieldset#wix-events_wix-events_fieldset_event-fieldset).
   * Some fields require additional computation that affects latency.
   * Use minimum set of required fieldset for best performance.
   */
  fieldset?: InputMaybe<Array<InputMaybe<WixEventsEventFieldset>>>;
  id: Scalars['ID'];
  /** indicates whether full_address should be resolved */
  resolveFullAddress?: InputMaybe<Scalars['Boolean']>;
  /** URL slug. */
  slug?: InputMaybe<Scalars['String']>;
};

export type WixEventsGetRecurringEventStateRequestInput = {
  /** Recurring event category id. */
  categoryId?: InputMaybe<Scalars['String']>;
};

export type WixEventsGetRecurringEventStateResponse = {
  actual?: Maybe<WixEventsRecurringEventState>;
  /** Recurring event category id. */
  categoryId?: Maybe<Scalars['String']>;
  desired?: Maybe<WixEventsRecurringEventState>;
  inconsistentState?: Maybe<Scalars['Boolean']>;
};

export type WixEventsGetTicketingSummaryRequestInput = {
  eventId?: InputMaybe<Scalars['String']>;
};

export type WixEventsGetTicketingSummaryResponse = {
  summary?: Maybe<WixEventsTicketing>;
};

export type WixEventsGuestListConfig = {
  /** Whether members can see other members attending the event (defaults to true). */
  publicGuestList?: Maybe<Scalars['Boolean']>;
};

export type WixEventsGuestListConfigInput = {
  /** Whether members can see other members attending the event (defaults to true). */
  publicGuestList?: InputMaybe<Scalars['Boolean']>;
};

export type WixEventsLabellingSettings = {
  assignedContactsLabelDeleted?: Maybe<Scalars['Boolean']>;
  assignedContactsLegacyLabelId?: Maybe<Scalars['String']>;
};

export type WixEventsListCategoryEventsRequestInput = {
  /** Category ID */
  categoryId?: InputMaybe<Scalars['String']>;
  /**
   * Controls which event properties are returned. See [Fieldset](https://dev.wix.com/api/rest/wix-events/wix-events/fieldset#wix-events_wix-events_fieldset_event-fieldset).
   * Some fields require additional computation that affects latency of the service.
   * Use minimum set of required fieldset for best performance.
   */
  fieldset?: InputMaybe<Array<InputMaybe<WixEventsEventFieldset>>>;
  paging?: InputMaybe<ComWixEventsUpstreamWixCommonPagingInput>;
};

export type WixEventsListCategoryEventsResponse = {
  /** Events list. */
  events?: Maybe<Array<Maybe<WixEventsEvent>>>;
  pagingMetadata?: Maybe<WixCommonPagingMetadataV2>;
};

export type WixEventsListEventsRequestInput = {
  /** Category filter. */
  categoryFilter?: InputMaybe<WixEventsCategoryFilterInput>;
  /**
   * Filter facets to include in the response.
   * See [supported facets](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events).
   */
  facet?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Controls which event properties are returned. See [Fieldset](https://dev.wix.com/api/rest/wix-events/wix-events/fieldset#wix-events_wix-events_fieldset_event-fieldset).
   * Some fields require additional computation that affects latency of the service.
   * Use minimum set of required fieldset for best performance.
   */
  fieldset?: InputMaybe<Array<InputMaybe<WixEventsEventFieldset>>>;
  /**
   * Whether draft events should be returned in the response.
   * Requires WIX_EVENTS.READ_DRAFT_EVENTS permission.
   */
  includeDrafts?: InputMaybe<Scalars['Boolean']>;
  /** Number of items to load per page. See [Pagination](https://dev.wix.com/api/rest/getting-started/pagination). */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip. See [Pagination](https://dev.wix.com/api/rest/getting-started/pagination). */
  offset?: InputMaybe<Scalars['Int']>;
  /** Recurrence status filter. */
  recurrenceStatus?: InputMaybe<Array<InputMaybe<WixEventsRecurrenceStatusStatus>>>;
  /** Recurring group id filter. */
  recurringGroupId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Event URL slug. */
  slug?: InputMaybe<Scalars['String']>;
  /**
   * Sort order, defaults to `"created:asc"`.
   * See [supported fields](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events).
   */
  sort?: InputMaybe<Scalars['String']>;
  /** Event status. */
  status?: InputMaybe<Array<InputMaybe<WixEventsEventStatus>>>;
  /**
   * Wix user filter, by default any.
   * Allows to filter events by user relation to the event (within the site).
   */
  userFilter?: InputMaybe<WixEventsUserFilterInput>;
  /** User ID filter, by default any */
  userId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixEventsListEventsResponse = {
  /** Events list. */
  events?: Maybe<Array<Maybe<WixEventsEvent>>>;
  /** Filter facets. */
  facets?: Maybe<WixEventsFacetCounts>;
  /** Limit. */
  limit?: Maybe<Scalars['Int']>;
  /** Offset. */
  offset?: Maybe<Scalars['Int']>;
  /** Total number of events that match the given filters. */
  total?: Maybe<Scalars['Int']>;
};

export type WixEventsListUserEventsRequestInput = {
  /**
   * Filter facets to include in the response.
   * See [supported facets](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events).
   */
  facet?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  paging?: InputMaybe<ComWixEventsUpstreamWixCommonPagingInput>;
  /**
   * Sort order, defaults to `"created:asc"`.
   * See [supported fields](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events).
   */
  sort?: InputMaybe<Array<InputMaybe<ComWixEventsUpstreamWixCommonSortingInput>>>;
  /** Event status. */
  status?: InputMaybe<Array<InputMaybe<WixEventsEventStatus>>>;
  /**
   * Wix user filter, by default any.
   * Allows to filter events by user relation to the event among all wix sites.
   */
  userFilter?: InputMaybe<WixEventsUserFilterInput>;
};

export type WixEventsListUserEventsResponse = {
  /** Events list. */
  events?: Maybe<Array<Maybe<WixEventsEvent>>>;
  /** Filter facets. */
  facets?: Maybe<WixEventsFacetCounts>;
  pagingMetadata?: Maybe<WixCommonPagingMetadataV2>;
};

export type WixEventsLocation = {
  /** Single line address representation. */
  address?: Maybe<Scalars['String']>;
  /** Location map coordinates. */
  coordinates?: Maybe<WixEventsMapCoordinates>;
  /**
   * Full address derived from formatted single line `address`.
   * When `full_address` is used to create or update the event, deprecated `address` and `coordinates` are ignored.
   * If provided `full_address` has empty `formatted_address` or `coordinates`, it will be auto-completed using Atlas service.
   *
   * Migration notes:
   * - `full_address.formatted_address` is equivalent to `address`.
   * - `full_address.geocode` is equivalent to `coordinates`.
   */
  fullAddress?: Maybe<ComWixEventsUpstreamWixCommonAddress>;
  /** Location name. */
  name?: Maybe<Scalars['String']>;
  /**
   * Defines event location as TBD (To Be Determined).
   * When event location is not yet defined, `name` is displayed instead of location address.
   * `coordinates`, `address`, `type` and `full_address` are not required when location is TBD.
   */
  tbd?: Maybe<Scalars['Boolean']>;
  /** Location type. */
  type?: Maybe<WixEventsLocationLocationType>;
};

export type WixEventsLocationInput = {
  /** Single line address representation. */
  address?: InputMaybe<Scalars['String']>;
  /** Location map coordinates. */
  coordinates?: InputMaybe<WixEventsMapCoordinatesInput>;
  /**
   * Full address derived from formatted single line `address`.
   * When `full_address` is used to create or update the event, deprecated `address` and `coordinates` are ignored.
   * If provided `full_address` has empty `formatted_address` or `coordinates`, it will be auto-completed using Atlas service.
   *
   * Migration notes:
   * - `full_address.formatted_address` is equivalent to `address`.
   * - `full_address.geocode` is equivalent to `coordinates`.
   */
  fullAddress?: InputMaybe<ComWixEventsUpstreamWixCommonAddressInput>;
  /** Location name. */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Defines event location as TBD (To Be Determined).
   * When event location is not yet defined, `name` is displayed instead of location address.
   * `coordinates`, `address`, `type` and `full_address` are not required when location is TBD.
   */
  tbd?: InputMaybe<Scalars['Boolean']>;
  /** Location type. */
  type?: InputMaybe<WixEventsLocationLocationType>;
};

export enum WixEventsLocationLocationType {
  ONLINE = 'ONLINE',
  VENUE = 'VENUE'
}

export type WixEventsMapCoordinates = {
  /** Latitude. */
  lat?: Maybe<Scalars['Float']>;
  /** Longitude. */
  lng?: Maybe<Scalars['Float']>;
};

export type WixEventsMapCoordinatesInput = {
  /** Latitude. */
  lat?: InputMaybe<Scalars['Float']>;
  /** Longitude. */
  lng?: InputMaybe<Scalars['Float']>;
};

export type WixEventsMoney = {
  /** *Deprecated:** Use `value` instead. */
  amount?: Maybe<Scalars['String']>;
  /** Three-letter currency code in [ISO-4217 alphabetic](https://en.wikipedia.org/wiki/ISO_4217#Active_codes) format. */
  currency?: Maybe<Scalars['String']>;
  /** Monetary amount. Decimal string with a period as a decimal separator (e.g., 3.99). Optionally, starts with a single (-), to indicate that the amount is negative. */
  value?: Maybe<Scalars['String']>;
};

export type WixEventsOccurrence = {
  /** Event end timestamp. */
  endDate?: Maybe<Scalars['String']>;
  /** Whether time zone is displayed in formatted schedule. */
  showTimeZone?: Maybe<Scalars['Boolean']>;
  /** Event start timestamp. */
  startDate?: Maybe<Scalars['String']>;
  /** Event time zone ID in TZ database format, e.g., `EST`, `America/Los_Angeles`. */
  timeZoneId?: Maybe<Scalars['String']>;
};

export type WixEventsOccurrenceInput = {
  /** Event end timestamp. */
  endDate?: InputMaybe<Scalars['String']>;
  /** Whether time zone is displayed in formatted schedule. */
  showTimeZone?: InputMaybe<Scalars['Boolean']>;
  /** Event start timestamp. */
  startDate?: InputMaybe<Scalars['String']>;
  /** Event time zone ID in TZ database format, e.g., `EST`, `America/Los_Angeles`. */
  timeZoneId?: InputMaybe<Scalars['String']>;
};

export type WixEventsOnlineConferencing = {
  config?: Maybe<WixEventsOnlineConferencingConfig>;
  /** Configured conferencing provider name. */
  providerName?: Maybe<Scalars['String']>;
  session?: Maybe<WixEventsOnlineConferencingSession>;
};

export type WixEventsOnlineConferencingConfig = {
  /** Conference type */
  conferenceType?: Maybe<WixEventsConferenceType>;
  /**
   * Whether online conferencing is enabled (not supported for TBD schedules).
   * When enabled, links to join conferencing are generated and provided to guests.
   */
  enabled?: Maybe<Scalars['Boolean']>;
  /** Conferencing provider ID. */
  providerId?: Maybe<Scalars['String']>;
};

export type WixEventsOnlineConferencingConfigInput = {
  /** Conference type */
  conferenceType?: InputMaybe<WixEventsConferenceType>;
  /**
   * Whether online conferencing is enabled (not supported for TBD schedules).
   * When enabled, links to join conferencing are generated and provided to guests.
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Conferencing provider ID. */
  providerId?: InputMaybe<Scalars['String']>;
};

export type WixEventsOnlineConferencingSession = {
  /** Link for guests to join the online conference session. */
  guestLink?: Maybe<Scalars['String']>;
  /** Link for event host to start the online conference session. */
  hostLink?: Maybe<Scalars['String']>;
  /** The password required to join online conferencing session (when relevant). */
  password?: Maybe<Scalars['String']>;
  /** Indicates that session was created successfully on providers side. */
  sessionCreated?: Maybe<Scalars['Boolean']>;
  /** Unique session id */
  sessionId?: Maybe<Scalars['String']>;
};

export type WixEventsPublishDraftEventRequestInput = {
  /** Event ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixEventsPublishDraftEventResponse = {
  /** Published event. */
  event?: Maybe<WixEventsEvent>;
};

export type WixEventsQueryEventsRequestInput = {
  /**
   * Filter facets to include in the response.
   * See [supported facets](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events).
   */
  facet?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Controls which event properties are returned. See [Fieldset](https://dev.wix.com/api/rest/wix-events/wix-events/fieldset#wix-events_wix-events_fieldset_event-fieldset).
   * Some fields require additional computation that affects latency.
   * Use minimum set of required fieldset for best performance.
   */
  fieldset?: InputMaybe<Array<InputMaybe<WixEventsEventFieldset>>>;
  /** Filter. See [supported fields and operators](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events). */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Whether draft events should be returned in the response.
   * Requires WIX_EVENTS.READ_DRAFT_EVENTS permission.
   */
  includeDrafts?: InputMaybe<Scalars['Boolean']>;
  /** Number of items to load per page. Default 0. See [Pagination](https://dev.wix.com/api/rest/getting-started/pagination). */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip. See [Pagination](https://dev.wix.com/api/rest/getting-started/pagination). */
  offset?: InputMaybe<Scalars['Int']>;
  /**
   * Sort order, defaults to `"created:asc"`.
   * See [supported fields](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events).
   */
  sort?: InputMaybe<Scalars['String']>;
  /** User ID filter, by default any */
  userId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixEventsQueryEventsResponse = {
  /** Events list */
  events?: Maybe<Array<Maybe<WixEventsEvent>>>;
  /** Filter facets. */
  facets?: Maybe<WixEventsFacetCounts>;
  /** Limit. */
  limit?: Maybe<Scalars['Int']>;
  /** Offset. */
  offset?: Maybe<Scalars['Int']>;
  /** Total number of events that match the given filters. */
  total?: Maybe<Scalars['Int']>;
};

export type WixEventsQueryEventsV2RequestInput = {
  /**
   * Filter facets to include in the response.
   * See [supported facets](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-query-events).
   */
  facet?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Controls which event properties are returned. See [Fieldset](https://dev.wix.com/api/rest/wix-events/wix-events/fieldset#wix-events_wix-events_fieldset_event-fieldset).
   * Some fields require additional computation that affects latency.
   * Use minimum set of required fieldset for best performance.
   */
  fieldset?: InputMaybe<Array<InputMaybe<WixEventsEventFieldset>>>;
  /**
   * Whether draft events should be returned in the response.
   * Requires WIX_EVENTS.READ_DRAFT_EVENTS permission.
   */
  includeDrafts?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<ComWixEventsUpstreamWixCommonQueryV2Input>;
};

export type WixEventsQueryEventsV2Response = {
  /** Query results */
  items?: Maybe<Array<Maybe<WixEventsEvent>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export enum WixEventsRecurrenceStatusStatus {
  /** Event occurs only once. */
  ONE_TIME = 'ONE_TIME',
  /** Event is recurring. */
  RECURRING = 'RECURRING',
  /** Marks the most recent canceled occurrence of the recurring event. */
  RECURRING_LAST_CANCELED = 'RECURRING_LAST_CANCELED',
  /** Marks the most recent ended occurrence of the recurring event. */
  RECURRING_LAST_ENDED = 'RECURRING_LAST_ENDED',
  /** Marks the next upcoming occurrence of the recurring event. */
  RECURRING_NEXT = 'RECURRING_NEXT'
}

export type WixEventsRecurrences = {
  /** Recurring event category ID. */
  categoryId?: Maybe<Scalars['String']>;
  /** Event occurrences. */
  occurrences?: Maybe<Array<Maybe<WixEventsOccurrence>>>;
  /** Recurrence status. */
  status?: Maybe<WixEventsRecurrenceStatusStatus>;
};

export type WixEventsRecurrencesInput = {
  /** Recurring event category ID. */
  categoryId?: InputMaybe<Scalars['String']>;
  /** Event occurrences. */
  occurrences?: InputMaybe<Array<InputMaybe<WixEventsOccurrenceInput>>>;
  /** Recurrence status. */
  status?: InputMaybe<WixEventsRecurrenceStatusStatus>;
};

export type WixEventsRecurringEventDetails = {
  /** Event end timestamp. */
  endDate?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  recurrenceStatus?: Maybe<WixEventsRecurrenceStatusStatus>;
  /** Event slug */
  slug?: Maybe<Scalars['String']>;
  /** Event start timestamp. */
  startDate?: Maybe<Scalars['String']>;
};

export type WixEventsRecurringEventState = {
  recurringLastCanceled?: Maybe<WixEventsRecurringEventDetails>;
  recurringLastEnded?: Maybe<WixEventsRecurringEventDetails>;
  recurringNext?: Maybe<WixEventsRecurringEventDetails>;
};

export type WixEventsRegistration = {
  /** External registration details. */
  external?: Maybe<WixEventsExternalEvent>;
  /** Initial event type which was set when creating an event. */
  initialType?: Maybe<WixEventsEventType>;
  /** Types of users allowed to register. */
  restrictedTo?: Maybe<WixEventsVisitorType>;
  /** RSVP collection details. */
  rsvpCollection?: Maybe<WixEventsRsvpCollection>;
  /** Event registration status. */
  status?: Maybe<WixEventsRegistrationStatus>;
  /** Ticketing details. */
  ticketing?: Maybe<WixEventsTicketing>;
  /** Event type. */
  type?: Maybe<WixEventsEventType>;
};

export type WixEventsRegistrationConfigInput = {
  /** Whether registration is disabled. */
  disabledRegistration?: InputMaybe<Scalars['Boolean']>;
  /** External event registration URL (for external events only). */
  externalRegistrationUrl?: InputMaybe<Scalars['String']>;
  /**
   * Initial event type. Only RSVP and TICKETS are allowed when creating an event.
   * Updating this field is not allowed.
   */
  initialType?: InputMaybe<WixEventsEventType>;
  /** Whether registration is closed. */
  pausedRegistration?: InputMaybe<Scalars['Boolean']>;
  /** Types of users allowed to register. */
  restrictedTo?: InputMaybe<WixEventsVisitorType>;
  /** Ticketing configuration. */
  ticketingConfig?: InputMaybe<WixEventsTicketingConfigInput>;
};

export enum WixEventsRegistrationStatus {
  /** Registration to event is closed */
  CLOSED = 'CLOSED',
  /** Registration to event is closed manually */
  CLOSED_MANUALLY = 'CLOSED_MANUALLY',
  /** Registration status is not applicable */
  NA_REGISTRATION_STATUS = 'NA_REGISTRATION_STATUS',
  /** Registration is open via external URL */
  OPEN_EXTERNAL = 'OPEN_EXTERNAL',
  /** Registration is open via RSVP */
  OPEN_RSVP = 'OPEN_RSVP',
  /** Registration to event waitlist is open via RSVP */
  OPEN_RSVP_WAITLIST = 'OPEN_RSVP_WAITLIST',
  /** Registration is open via ticket purchase */
  OPEN_TICKETS = 'OPEN_TICKETS',
  /** Registration will be open via RSVP */
  SCHEDULED_RSVP = 'SCHEDULED_RSVP'
}

export type WixEventsRsvpCollection = {
  /** RSVP collection configuration. */
  config?: Maybe<WixEventsRsvpCollectionConfig>;
};

export type WixEventsRsvpCollectionConfig = {
  /** Registration end timestamp. */
  endDate?: Maybe<Scalars['String']>;
  /**
   * Total guest limit available to register to the event.
   * Additional guests per RSVP are counted towards total guests.
   */
  limit?: Maybe<Scalars['Int']>;
  /** Defines the supported RSVP statuses. */
  rsvpStatusOptions?: Maybe<WixEventsRsvpCollectionConfigRsvpStatusOptions>;
  /** Registration start timestamp. */
  startDate?: Maybe<Scalars['String']>;
  /** Whether a waitlist is opened when total guest limit is reached, allowing guests to create RSVP with WAITING RSVP status. */
  waitlist?: Maybe<Scalars['Boolean']>;
};

export type WixEventsRsvpCollectionConfigInput = {
  /** Registration end timestamp. */
  endDate?: InputMaybe<Scalars['String']>;
  /**
   * Total guest limit available to register to the event.
   * Additional guests per RSVP are counted towards total guests.
   */
  limit?: InputMaybe<Scalars['Int']>;
  /** Defines the supported RSVP statuses. */
  rsvpStatusOptions?: InputMaybe<WixEventsRsvpCollectionConfigRsvpStatusOptions>;
  /** Registration start timestamp. */
  startDate?: InputMaybe<Scalars['String']>;
  /** Whether a waitlist is opened when total guest limit is reached, allowing guests to create RSVP with WAITING RSVP status. */
  waitlist?: InputMaybe<Scalars['Boolean']>;
};

export enum WixEventsRsvpCollectionConfigRsvpStatusOptions {
  /** YES and NO RSVP status options are available for the registration */
  YES_AND_NO = 'YES_AND_NO',
  /** Only YES RSVP status is available for RSVP registration */
  YES_ONLY = 'YES_ONLY'
}

export type WixEventsScheduleAddScheduleItemRequestInput = {
  /** Event ID. */
  eventId?: InputMaybe<Scalars['String']>;
  /** Schedule item. */
  item?: InputMaybe<WixEventsScheduleScheduleItemDataInput>;
};

export type WixEventsScheduleAddScheduleItemResponse = {
  /** Schedule item. */
  item?: Maybe<WixEventsScheduleScheduleItem>;
};

export type WixEventsScheduleConfig = {
  /** Event end timestamp. */
  endDate?: Maybe<Scalars['String']>;
  /** Whether end date is hidden in the formatted schedule. */
  endDateHidden?: Maybe<Scalars['Boolean']>;
  /** Event recurrences. */
  recurrences?: Maybe<WixEventsRecurrences>;
  /**
   * Defines event as TBD (To Be Determined) schedule.
   * When event time is not yet defined, TBD message is displayed instead of event start and end times.
   * `startDate`, `endDate` and `timeZoneId` are not required when schedule is TBD.
   */
  scheduleTbd?: Maybe<Scalars['Boolean']>;
  /** TBD message. */
  scheduleTbdMessage?: Maybe<Scalars['String']>;
  /** Whether time zone is displayed in formatted schedule. */
  showTimeZone?: Maybe<Scalars['Boolean']>;
  /** Event start timestamp. */
  startDate?: Maybe<Scalars['String']>;
  /** Event time zone ID in TZ database format, e.g., `EST`, `America/Los_Angeles`. */
  timeZoneId?: Maybe<Scalars['String']>;
};

export type WixEventsScheduleConfigInput = {
  /** Event end timestamp. */
  endDate?: InputMaybe<Scalars['String']>;
  /** Whether end date is hidden in the formatted schedule. */
  endDateHidden?: InputMaybe<Scalars['Boolean']>;
  /** Event recurrences. */
  recurrences?: InputMaybe<WixEventsRecurrencesInput>;
  /**
   * Defines event as TBD (To Be Determined) schedule.
   * When event time is not yet defined, TBD message is displayed instead of event start and end times.
   * `startDate`, `endDate` and `timeZoneId` are not required when schedule is TBD.
   */
  scheduleTbd?: InputMaybe<Scalars['Boolean']>;
  /** TBD message. */
  scheduleTbdMessage?: InputMaybe<Scalars['String']>;
  /** Whether time zone is displayed in formatted schedule. */
  showTimeZone?: InputMaybe<Scalars['Boolean']>;
  /** Event start timestamp. */
  startDate?: InputMaybe<Scalars['String']>;
  /** Event time zone ID in TZ database format, e.g., `EST`, `America/Los_Angeles`. */
  timeZoneId?: InputMaybe<Scalars['String']>;
};

export type WixEventsScheduleCreateBookmarkRequestInput = {
  /** Event ID. */
  eventId?: InputMaybe<Scalars['String']>;
  /** Schedule item ID. */
  itemId?: InputMaybe<Scalars['String']>;
};

export type WixEventsScheduleDeleteBookmarkRequestInput = {
  /** Event ID. */
  eventId?: InputMaybe<Scalars['String']>;
  /** Schedule item ID. */
  itemId?: InputMaybe<Scalars['String']>;
};

export type WixEventsScheduleDeleteScheduleItemRequestInput = {
  /** Event ID. */
  eventId?: InputMaybe<Scalars['String']>;
  /** Schedule items to delete. */
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixEventsScheduleDiscardDraftRequestInput = {
  /** Event ID. */
  eventId?: InputMaybe<Scalars['String']>;
};

export type WixEventsScheduleGetScheduleItemRequestInput = {
  /** Event ID. */
  eventId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  includeDraft?: InputMaybe<Scalars['Boolean']>;
};

export type WixEventsScheduleGetScheduleItemResponse = {
  /** Draft of the Schedule item. */
  draft?: Maybe<WixEventsScheduleScheduleItem>;
  /** Schedule item. */
  item?: Maybe<WixEventsScheduleScheduleItem>;
};

export type WixEventsScheduleListBookmarksRequestInput = {
  /** Event ID. */
  eventId?: InputMaybe<Scalars['String']>;
};

export type WixEventsScheduleListBookmarksResponse = {
  /** Schedule items. */
  items?: Maybe<Array<Maybe<WixEventsScheduleScheduleItem>>>;
};

export type WixEventsScheduleListScheduleItemsRequestInput = {
  /** Event ID. */
  eventId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter facets.
   * See [supported facets](https://dev.wix.com/api/rest/wix-events/wix-events/filter-and-sort#wix-events_wix-events_filter-and-sort_list-schedule-items).
   */
  facet?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Item IDs filter. */
  itemId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Deprecated, use `paging`.
   * Number of items to load per page. See [Pagination](https://dev.wix.com/api/rest/getting-started/pagination).
   */
  limit?: InputMaybe<Scalars['Int']>;
  /**
   * Deprecated, use `paging`.
   * Number of items to skip. See [Pagination](https://dev.wix.com/api/rest/getting-started/pagination).
   */
  offset?: InputMaybe<Scalars['Int']>;
  /**
   * Pointer to page of results using offset.
   * See [Pagination](https://dev.wix.com/api/rest/getting-started/pagination).
   */
  paging?: InputMaybe<ComWixEventsUpstreamWixCommonPagingInput>;
  /** Stage names filter. */
  stageName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filters schedule items starting before specified point in time. Non-inclusive. */
  startingBefore?: InputMaybe<Scalars['String']>;
  /** Filters schedule items starting on or after specified point in time. Inclusive. */
  startingFrom?: InputMaybe<Scalars['String']>;
  /**
   * Schedule item state filter.
   * Defaults to `[PUBLISHED, VISIBLE]` when no filters are specified.
   * If neither `PUBLISHED` nor `DRAFT` are specified, assumes `PUBLISHED`, for example: `[HIDDEN]` becomes `[HIDDEN, PUBLISHED]`.
   * If neither `VISIBLE` nor `HIDDEN` are specified, assumes `VISIBLE`, for example: `[DRAFT]` becomes `[DRAFT, VISIBLE]`.
   */
  state?: InputMaybe<Array<InputMaybe<WixEventsScheduleStateFilter>>>;
  /** Tags filter. */
  tag?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixEventsScheduleListScheduleItemsResponse = {
  /**
   * Whether there are draft changes which have not been published yet.
   * Returned only when filtering by single `event_id` with `WIX_EVENTS.MANAGE_AGENDA` permission.
   */
  draftNotPublished?: Maybe<Scalars['Boolean']>;
  /** Facets. */
  facets?: Maybe<WixEventsFacetCounts>;
  /** Schedule items. */
  items?: Maybe<Array<Maybe<WixEventsScheduleScheduleItem>>>;
  /**
   * Deprecated.
   * Limit.
   */
  limit?: Maybe<Scalars['Int']>;
  /**
   * Deprecated, use `paging_metadata.offset`.
   * Offset.
   */
  offset?: Maybe<Scalars['Int']>;
  pagingMetadata?: Maybe<WixCommonPagingMetadataV2>;
  /**
   * Deprecated, use `paging_metadata.total`.
   * Total schedule items matching the given filters.
   */
  total?: Maybe<Scalars['Int']>;
};

export type WixEventsSchedulePublishDraftRequestInput = {
  /** Event ID. */
  eventId?: InputMaybe<Scalars['String']>;
};

export type WixEventsScheduleQueryScheduleItemsRequestInput = {
  query?: InputMaybe<ComWixEventsUpstreamWixCommonQueryV2Input>;
};

export type WixEventsScheduleQueryScheduleItemsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<WixEventsScheduleScheduleItem>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixEventsScheduleRescheduleDraftRequestInput = {
  /** Event ID. */
  eventId?: InputMaybe<Scalars['String']>;
  /** Offset added or subtracted from schedule item start & end times. */
  timeSlotOffset?: InputMaybe<Scalars['JSON']>;
  /** Time zone ID in TZ database format, e.g., `EST`, `America/Los_Angeles`. */
  timeZoneId?: InputMaybe<Scalars['String']>;
};

export type WixEventsScheduleScheduleItem = {
  /** Schedule item created timestamp. */
  createdDate?: Maybe<Scalars['String']>;
  /** Rich-text content displayed in Wix UI when viewing schedule item details (HTML). */
  description?: Maybe<Scalars['String']>;
  /** Whether schedule item is draft. */
  draft?: Maybe<Scalars['Boolean']>;
  /** Event ID. */
  eventId?: Maybe<Scalars['String']>;
  /** Whether schedule item is hidden from guests. */
  hidden?: Maybe<Scalars['Boolean']>;
  /** Schedule item ID. */
  id?: Maybe<Scalars['String']>;
  /** Schedule item name. */
  name?: Maybe<Scalars['String']>;
  /** Stage or room name in which session takes place. */
  stageName?: Maybe<Scalars['String']>;
  /** Schedule item status. */
  status?: Maybe<WixEventsScheduleScheduleStatus>;
  /** Tags are used to organize schedule items by assigning them to a general theme or field of study. */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Time slot of an schedule item. */
  timeSlot?: Maybe<WixEventsTimeInterval>;
  /** Schedule item modified timestamp. */
  updatedDate?: Maybe<Scalars['String']>;
};

export type WixEventsScheduleScheduleItemDataInput = {
  /** Rich-text content displayed in Wix UI when viewing schedule item details (HTML). */
  description?: InputMaybe<Scalars['String']>;
  /** Whether schedule item is hidden from guests. */
  hidden?: InputMaybe<Scalars['Boolean']>;
  /** Schedule item name. */
  name?: InputMaybe<Scalars['String']>;
  /** Stage or room name in which session takes place. */
  stageName?: InputMaybe<Scalars['String']>;
  /** Schedule item status. */
  status?: InputMaybe<WixEventsScheduleScheduleStatus>;
  /** Tags are used to organize schedule items by assigning them to a general theme or field of study. */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Time slot */
  timeSlot?: InputMaybe<WixEventsTimeIntervalInput>;
};

export enum WixEventsScheduleScheduleStatus {
  /** Item is canceled. */
  CANCELED = 'CANCELED',
  /** Item is scheduled for a future date. */
  SCHEDULED = 'SCHEDULED'
}

export enum WixEventsScheduleStateFilter {
  /** Opposite of `PUBLISHED`. Requires `WIX_EVENTS.READ_HIDDEN_AGENDA` permission. */
  DRAFT = 'DRAFT',
  /** Opposite of `VISIBLE`. Requires `WIX_EVENTS.READ_HIDDEN_AGENDA` permission. */
  HIDDEN = 'HIDDEN',
  /** Schedule item is published. */
  PUBLISHED = 'PUBLISHED',
  /** Schedule item is visible to the public. */
  VISIBLE = 'VISIBLE'
}

export type WixEventsScheduleUpdateScheduleItemRequestInput = {
  /** Event ID. */
  eventId?: InputMaybe<Scalars['String']>;
  /**
   * Set of field paths to update.
   * When fields are empty, request is interpreted as full update.
   * Behavior follows [google.protobuf.FieldMask](https://developers.google.com/protocol-buffers/docs/reference/google.protobuf#google.protobuf.FieldMask) semantics.
   */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Schedule item. */
  item?: InputMaybe<WixEventsScheduleScheduleItemDataInput>;
  /** Schedule item ID. */
  itemId?: InputMaybe<Scalars['String']>;
};

export type WixEventsScheduleUpdateScheduleItemResponse = {
  /** Schedule item. */
  item?: Maybe<WixEventsScheduleScheduleItem>;
};

export type WixEventsScheduling = {
  /** Schedule configuration. */
  config?: Maybe<WixEventsScheduleConfig>;
  /** Formatted end date of the event (empty for TBD schedules or when end date is hidden). */
  endDateFormatted?: Maybe<Scalars['String']>;
  /** Formatted end time of the event (empty for TBD schedules or when end date is hidden). */
  endTimeFormatted?: Maybe<Scalars['String']>;
  /** Formatted schedule representation. */
  formatted?: Maybe<Scalars['String']>;
  /** Formatted start date of the event (empty for TBD schedules). */
  startDateFormatted?: Maybe<Scalars['String']>;
  /** Formatted start time of the event (empty for TBD schedules). */
  startTimeFormatted?: Maybe<Scalars['String']>;
};

export type WixEventsSeoSettings = {
  /** Advanced SEO data */
  advancedSeoData?: Maybe<ComWixpressAdvancedSeoSeoSchema>;
  /** Hidden from SEO Site Map */
  hidden?: Maybe<Scalars['Boolean']>;
  /** URL slug */
  slug?: Maybe<Scalars['String']>;
};

export type WixEventsSeoSettingsInput = {
  /** Advanced SEO data */
  advancedSeoData?: InputMaybe<ComWixpressAdvancedSeoSeoSchemaInput>;
  /** Hidden from SEO Site Map */
  hidden?: InputMaybe<Scalars['Boolean']>;
  /** URL slug */
  slug?: InputMaybe<Scalars['String']>;
};

export type WixEventsSiteUrl = {
  /**
   * Base URL. For premium sites, this will be the domain.
   * For free sites, this would be site URL (e.g `mysite.wixsite.com/mysite`)
   */
  base?: Maybe<Scalars['String']>;
  /** The path to that page - e.g `/my-events/weekly-meetup-2` */
  path?: Maybe<Scalars['String']>;
};

export type WixEventsSiteUrlInput = {
  /**
   * Base URL. For premium sites, this will be the domain.
   * For free sites, this would be site URL (e.g `mysite.wixsite.com/mysite`)
   */
  base?: InputMaybe<Scalars['String']>;
  /** The path to that page - e.g `/my-events/weekly-meetup-2` */
  path?: InputMaybe<Scalars['String']>;
};

export type WixEventsTaxConfig = {
  /** Applies taxes for donations, default true. */
  appliesToDonations?: Maybe<Scalars['Boolean']>;
  /** Tax name. */
  name?: Maybe<Scalars['String']>;
  /** Tax rate (e.g.,`21.55`). */
  rate?: Maybe<Scalars['String']>;
  /** Tax application settings. */
  type?: Maybe<WixEventsTaxType>;
};

export type WixEventsTaxConfigInput = {
  /** Applies taxes for donations, default true. */
  appliesToDonations?: InputMaybe<Scalars['Boolean']>;
  /** Tax name. */
  name?: InputMaybe<Scalars['String']>;
  /** Tax rate (e.g.,`21.55`). */
  rate?: InputMaybe<Scalars['String']>;
  /** Tax application settings. */
  type?: InputMaybe<WixEventsTaxType>;
};

export enum WixEventsTaxType {
  /** Tax is added to the order at the checkout. */
  ADDED = 'ADDED',
  /** Tax is added to the final total at the checkout. */
  ADDED_AT_CHECKOUT = 'ADDED_AT_CHECKOUT',
  /** Tax is included in the ticket price. */
  INCLUDED = 'INCLUDED'
}

export type WixEventsTicketing = {
  /** Ticketing configuration. */
  config?: Maybe<WixEventsTicketingConfig>;
  /** Currency used in event transactions. */
  currency?: Maybe<Scalars['String']>;
  /** Deprecated. */
  highestPrice?: Maybe<Scalars['String']>;
  /** Price of highest priced ticket. */
  highestTicketPrice?: Maybe<WixEventsMoney>;
  /** Formatted price of highest priced ticket. */
  highestTicketPriceFormatted?: Maybe<Scalars['String']>;
  /** Deprecated. */
  lowestPrice?: Maybe<Scalars['String']>;
  /** Price of lowest priced ticket. */
  lowestTicketPrice?: Maybe<WixEventsMoney>;
  /** Formatted price of lowest priced ticket. */
  lowestTicketPriceFormatted?: Maybe<Scalars['String']>;
  /** Whether all tickets are sold for this event. */
  soldOut?: Maybe<Scalars['Boolean']>;
};

export type WixEventsTicketingConfig = {
  /** Grace period for which ticket reservation is extended. */
  gracePeriodInMinutes?: Maybe<Scalars['Int']>;
  /** Whether the form must be filled out separately for each ticket. */
  guestAssignedTickets?: Maybe<Scalars['Boolean']>;
  /** Duration for which the tickets being bought are reserved. */
  reservationDurationInMinutes?: Maybe<Scalars['Int']>;
  /**
   * App Id for external ticket stock management.
   * By default tickets stock is defined in TicketDefinition object.
   * If defined then limitation from TicketDefinition is ignored.
   */
  stockManagerAppId?: Maybe<Scalars['String']>;
  /** Tax configuration. */
  taxConfig?: Maybe<WixEventsTaxConfig>;
  /** Limit of tickets that can be purchased per order, default 20. */
  ticketLimitPerOrder?: Maybe<Scalars['Int']>;
};

export type WixEventsTicketingConfigInput = {
  /** Grace period for which ticket reservation is extended. */
  gracePeriodInMinutes?: InputMaybe<Scalars['Int']>;
  /** Whether the form must be filled out separately for each ticket. */
  guestAssignedTickets?: InputMaybe<Scalars['Boolean']>;
  /** Duration for which the tickets being bought are reserved. */
  reservationDurationInMinutes?: InputMaybe<Scalars['Int']>;
  /**
   * App Id for external ticket stock management.
   * By default tickets stock is defined in TicketDefinition object.
   * If defined then limitation from TicketDefinition is ignored.
   */
  stockManagerAppId?: InputMaybe<Scalars['String']>;
  /** Tax configuration. */
  taxConfig?: InputMaybe<WixEventsTaxConfigInput>;
  /** Limit of tickets that can be purchased per order, default 20. */
  ticketLimitPerOrder?: InputMaybe<Scalars['Int']>;
};

export type WixEventsTimeInterval = {
  /** End of the interval. Non-inclusive. */
  end?: Maybe<Scalars['String']>;
  /** Start of the interval. Inclusive. */
  start?: Maybe<Scalars['String']>;
  /**
   * Time zone ID in TZ database format, e.g., `EST`, `America/Los_Angeles`.
   * Defaults to `Etc/UTC` when not set.
   */
  timeZoneId?: Maybe<Scalars['String']>;
};

export type WixEventsTimeIntervalInput = {
  /** End of the interval. Non-inclusive. */
  end?: InputMaybe<Scalars['String']>;
  /** Start of the interval. Inclusive. */
  start?: InputMaybe<Scalars['String']>;
  /**
   * Time zone ID in TZ database format, e.g., `EST`, `America/Los_Angeles`.
   * Defaults to `Etc/UTC` when not set.
   */
  timeZoneId?: InputMaybe<Scalars['String']>;
};

export type WixEventsUpdateEventRequestInput = {
  /** Event data to update (partial) */
  event?: InputMaybe<WixEventsEventDataInput>;
  /**
   * Set of field paths to update.
   * <!--ONLY:REST-->
   * Fields will be auto-populated from the `event` entity unless added to the request explicitly.
   * <!--END:ONLY:REST-->
   * Behavior follows [google.protobuf.FieldMask](https://developers.google.com/protocol-buffers/docs/reference/google.protobuf#google.protobuf.FieldMask) semantics.
   */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Event ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Content language code in ISO 639-1 format.
   * Used for translating ticket PDF labels, registration form, automatic emails, etc.
   * Supported languages: ar, bg, cs, da, de, el, en, es, fi, fr, he, hi, hu, id, it, ja, ko, ms, nl, no, pl, pt, ro, ru, sv, th, tl, tr, uk, zh.
   * Defaults to en.
   */
  language?: InputMaybe<Scalars['String']>;
};

export type WixEventsUpdateEventResponse = {
  /** Updated event. */
  event?: Maybe<WixEventsEvent>;
};

export type WixEventsUpdateRecurringStatusRequestInput = {
  /** Recurring event category id. */
  categoryId?: InputMaybe<Scalars['String']>;
};

export type WixEventsUserFilterInput = {
  /** Relation of user to event */
  relation?: InputMaybe<Array<InputMaybe<WixEventsUserFilterRelation>>>;
  /** User who is related to event */
  userId?: InputMaybe<Scalars['String']>;
};

export enum WixEventsUserFilterRelation {
  /**
   * User is attending the event.
   * User has RSVP with status YES or has ordered tickets.
   */
  ATTENDING = 'ATTENDING'
}

export type WixEventsV2CreatePolicyRequestInput = {
  /** Policy info. */
  policy?: InputMaybe<WixEventsV2PolicyInput>;
};

export type WixEventsV2CreatePolicyResponse = {
  /** Created policy. */
  policy?: Maybe<WixEventsV2Policy>;
};

export type WixEventsV2DeletePolicyRequestInput = {
  /** ID of the policy to delete. */
  policyId?: InputMaybe<Scalars['String']>;
};

export type WixEventsV2GetPolicyFromTrashBinRequestInput = {
  /** Policy ID. */
  policyId?: InputMaybe<Scalars['String']>;
};

export type WixEventsV2GetPolicyFromTrashBinResponse = {
  /** The requested policy. */
  policy?: Maybe<WixEventsV2Policy>;
};

export type WixEventsV2GetPolicyRequestInput = {
  id: Scalars['ID'];
};

export type WixEventsV2Policy = {
  /**
   * Policy body. Usually contains various terms and conditions.
   *
   * Min: 1 character
   * Max: 50,000 characters
   *
   * <b>Note:</b> You can format text using various HTML tags such as `<p>`, `<b>`, `<ul>`, etc.
   */
  body?: Maybe<Scalars['String']>;
  /** Date and time the policy was created in `yyyy-mm-ddThh:mm:sssZ` format. */
  createdDate?: Maybe<Scalars['String']>;
  /** ID of the event to which the policy belongs. */
  event?: Maybe<WixEventsEvent>;
  /** ID of the event to which the policy belongs. */
  eventId?: Maybe<Scalars['String']>;
  /** Policy ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Policy name that is visible in the dashboard and checkout form.
   *
   * Min: 1 character  <br/>
   * Max: 40 characters
   */
  name?: Maybe<Scalars['String']>;
  /**
   * Revision number, which increments by 1 each time the policy is updated.
   *
   * To prevent conflicting changes, the current revision must be used when updating a policy.
   */
  revision?: Maybe<Scalars['Long']>;
  /** Date and time the policy was updated in `yyyy-mm-ddThh:mm:sssZ` format. */
  updatedDate?: Maybe<Scalars['String']>;
};

export type WixEventsV2PolicyInput = {
  /**
   * Policy body. Usually contains various terms and conditions.
   *
   * Min: 1 character
   * Max: 50,000 characters
   *
   * <b>Note:</b> You can format text using various HTML tags such as `<p>`, `<b>`, `<ul>`, etc.
   */
  body?: InputMaybe<Scalars['String']>;
  /** Date and time the policy was created in `yyyy-mm-ddThh:mm:sssZ` format. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** ID of the event to which the policy belongs. */
  eventId?: InputMaybe<Scalars['String']>;
  /** Policy ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Policy name that is visible in the dashboard and checkout form.
   *
   * Min: 1 character  <br/>
   * Max: 40 characters
   */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Revision number, which increments by 1 each time the policy is updated.
   *
   * To prevent conflicting changes, the current revision must be used when updating a policy.
   */
  revision?: InputMaybe<Scalars['Long']>;
  /** Date and time the policy was updated in `yyyy-mm-ddThh:mm:sssZ` format. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export type WixEventsV2PolicyUpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load per page. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixEventsV2PolicyUpstreamWixCommonPagingInput = {
  /** Number of items to load per page. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the current sort order. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type WixEventsV2PolicyUpstreamWixCommonQueryV2Input = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixEventsV2PolicyUpstreamWixCommonCursorPagingInput>;
  /** Filter object in the following format: <br/> `"filter" : { "fieldName1": "value1", "fieldName2":{"$operator":"value2"} }`. <br/> <br/> **Example:** <br/> `"filter" : { "id": "2224a9d1-79e6-4549-a5c5-bf7ce5aac1a5", "revision": {"$ne":"1"} }` <br/> <br/> See [supported fields and operators](https://dev.wix.com/api/rest/wix-events/policy-v2/filter-and-sort) for more information. */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Pagination options. */
  paging?: InputMaybe<WixEventsV2PolicyUpstreamWixCommonPagingInput>;
  /** Sort object in the following format: <br/> `[{"fieldName":"sortField1"},{"fieldName":"sortField2","direction":"DESC"}]` <br/> <br/> **Example:** <br/> `[{"fieldName":"createdDate","direction":"DESC"}]` <br/> <br/> See [supported fields](https://dev.wix.com/api/rest/wix-events/policy-v2/filter-and-sort) for more information. */
  sort?: InputMaybe<Array<InputMaybe<WixEventsV2PolicyUpstreamWixCommonSortingInput>>>;
};

export type WixEventsV2PolicyUpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order (ASC/DESC). Defaults to ASC */
  order?: InputMaybe<WixCommonSortOrder>;
};

export type WixEventsV2QueryPoliciesRequestInput = {
  /** Query options. See [API Query Langauge](https://dev.wix.com/api/rest/getting-started/api-query-language) for more details. */
  query?: InputMaybe<WixEventsV2PolicyUpstreamWixCommonQueryV2Input>;
};

export type WixEventsV2QueryPoliciesResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<WixEventsV2Policy>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixEventsV2ReorderEventPoliciesRequestInput = {
  /** Move the given policy after this specified policy. */
  afterPolicyId?: InputMaybe<Scalars['String']>;
  /** Move the given policy before this specified policy. */
  beforePolicyId?: InputMaybe<Scalars['String']>;
  /** Event ID to which the policy belongs. */
  eventId?: InputMaybe<Scalars['String']>;
  /** ID of the policy to reorder. */
  policyId?: InputMaybe<Scalars['String']>;
};

export type WixEventsV2ReorderEventPoliciesResponse = {
  /** Policies in the new order. */
  policies?: Maybe<Array<Maybe<WixEventsV2Policy>>>;
};

export type WixEventsV2UpdatePolicyRequestInput = {
  /** List of exact fields to update. For example, if you define only `name`, then all other fields will be ignored. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Policy info to update. */
  policy?: InputMaybe<WixEventsV2PolicyInput>;
};

export type WixEventsV2UpdatePolicyResponse = {
  /** Updated policy. */
  policy?: Maybe<WixEventsV2Policy>;
};

export type WixEventsV2UpdatePolicySortIndexRequestInput = {
  /** ID of the policy. */
  policyId?: InputMaybe<Scalars['String']>;
  /** Current revision number of the policy. */
  revision?: InputMaybe<Scalars['Long']>;
  /** Index to sort of a policy. */
  sortIndex?: InputMaybe<Scalars['Int']>;
};

export type WixEventsV2UpdatePolicySortIndexResponse = {
  /** Updated policy. */
  policy?: Maybe<WixEventsV2Policy>;
};

export enum WixEventsVisitorType {
  /** Site member */
  MEMBER = 'MEMBER',
  /** Site visitor (including member) */
  VISITOR = 'VISITOR',
  /** Site visitor or member */
  VISITOR_OR_MEMBER = 'VISITOR_OR_MEMBER'
}

export type WixFormsV1CloneFormFromTemplateMetaSiteRequestInput = {
  /** Form id which can be copied */
  formId?: InputMaybe<Scalars['String']>;
};

export type WixFormsV1CloneFormFromTemplateMetaSiteResponse = {
  /** The cloned form. */
  form?: Maybe<WixFormsV4Form>;
  /** Standalone form */
  standaloneForm?: Maybe<WixFormsV1StandaloneForm>;
};

export type WixFormsV1CreateStandaloneFormRequestInput = {
  /** Standalone form */
  standaloneForm?: InputMaybe<WixFormsV1StandaloneFormInput>;
};

export type WixFormsV1CreateStandaloneFormResponse = {
  /** Standalone form */
  standaloneForm?: Maybe<WixFormsV1StandaloneForm>;
};

export type WixFormsV1DeleteStandaloneFormRequestInput = {
  /**
   * Whether to permanently delete a standalone form bypassing the trash bin.
   *
   * Default: `false`
   */
  permanent?: InputMaybe<Scalars['Boolean']>;
  /** Standalone form id */
  standaloneFormId?: InputMaybe<Scalars['String']>;
};

export type WixFormsV1GetCheckoutOAuthClientIdRequestInput = {
  /** MetaSiteId */
  metaSiteId?: InputMaybe<Scalars['String']>;
};

export type WixFormsV1GetCheckoutOAuthClientIdResponse = {
  /** OAuthId of 'Forms & Checkout integration' */
  clientId?: Maybe<Scalars['String']>;
};

export type WixFormsV1GetDeletedStandaloneFormRequestInput = {
  /** Standalone form id */
  standaloneFormId?: InputMaybe<Scalars['String']>;
};

export type WixFormsV1GetDeletedStandaloneFormResponse = {
  /** Standalone form */
  standaloneForm?: Maybe<WixFormsV1StandaloneForm>;
};

export type WixFormsV1GetPublicClientSpecMapRequestInput = {
  /** MetaSiteId */
  metaSiteId?: InputMaybe<Scalars['String']>;
};

export type WixFormsV1GetPublicClientSpecMapResponse = {
  /** Public client spec map for the given MetaSite. */
  clientSpecMap?: Maybe<WixCsmV2ClientSpec>;
};

export type WixFormsV1GetStandaloneFormRequestInput = {
  id: Scalars['ID'];
};

export type WixFormsV1ListDeletedStandaloneFormsRequestInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. */
  paging?: InputMaybe<ComWixFormsUpstreamWixCommonCursorPagingInput>;
  /** Standalone Form ids. */
  standaloneFormIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixFormsV1ListDeletedStandaloneFormsResponse = {
  /** Details on the paged set of results returned. */
  pagingMetadata?: Maybe<ComWixFormsUpstreamWixCommonCursorPagingMetadata>;
  /** The retrieved standalone forms */
  standaloneForms?: Maybe<Array<Maybe<WixFormsV1StandaloneForm>>>;
};

export type WixFormsV1MoveStandaloneFormToMetaSiteRequestInput = {
  /** Form id which can be copied */
  formId?: InputMaybe<Scalars['String']>;
  /** Target form id */
  targetFormId?: InputMaybe<Scalars['String']>;
  /** Target meta site id */
  targetMetaSiteId?: InputMaybe<Scalars['String']>;
};

export type WixFormsV1MoveStandaloneFormToMetaSiteResponse = {
  /** Standalone form */
  standaloneForm?: Maybe<WixFormsV1StandaloneForm>;
};

export type WixFormsV1QueryStandaloneFormsRequestInput = {
  /** WQL expression. */
  query?: InputMaybe<ComWixFormsUpstreamWixCommonCursorQueryInput>;
};

export type WixFormsV1QueryStandaloneFormsResponse = {
  /** Details on the paged set of results returned. */
  metadata?: Maybe<ComWixFormsUpstreamWixCommonCursorPagingMetadata>;
  /** The retrieved standalone forms */
  standaloneForms?: Maybe<Array<Maybe<WixFormsV1StandaloneForm>>>;
};

export type WixFormsV1RemoveStandaloneFormFromTrashBinRequestInput = {
  /** Standalone form id */
  standaloneFormId?: InputMaybe<Scalars['String']>;
};

export type WixFormsV1RestoreStandaloneFormFromTrashBinRequestInput = {
  /** Standalone form id */
  standaloneFormId?: InputMaybe<Scalars['String']>;
};

export type WixFormsV1RestoreStandaloneFormFromTrashBinResponse = {
  /** Standalone form */
  standaloneForm?: Maybe<WixFormsV1StandaloneForm>;
};

export type WixFormsV1StandaloneForm = {
  /** Date of creation. */
  createdDate?: Maybe<Scalars['String']>;
  /** Form id */
  formId?: Maybe<Scalars['String']>;
  /** Standalone form id */
  id?: Maybe<Scalars['String']>;
  /** MetaSiteId */
  metaSiteId?: Maybe<Scalars['String']>;
  /** Date of updatew. */
  updatedDate?: Maybe<Scalars['String']>;
};

export type WixFormsV1StandaloneFormInput = {
  /** Date of creation. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Form id */
  formId?: InputMaybe<Scalars['String']>;
  /** Standalone form id */
  id?: InputMaybe<Scalars['String']>;
  /** MetaSiteId */
  metaSiteId?: InputMaybe<Scalars['String']>;
  /** Date of updatew. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4BreakPoint = {
  /** Number of columns in the layout grid. */
  columns?: Maybe<Scalars['Int']>;
  /** Configuration for the layout of items in the breakpoint. */
  items?: Maybe<Array<Maybe<WixFormsV4ItemLayout>>>;
  /** Margin spacing configuration for the form elements. */
  margin?: Maybe<WixFormsV4BreakPointMargin>;
  /** Padding spacing inside form elements in pixels. */
  padding?: Maybe<WixFormsV4BreakPointMargin>;
  /** Height of each row in the layout grid, measured in pixels. */
  rowHeight?: Maybe<Scalars['Int']>;
  /** Sections that organize and constrain field placement within the layout. */
  sections?: Maybe<Array<Maybe<WixFormsV4BreakPointSection>>>;
};

export type WixFormsV4BreakPointInput = {
  /** Number of columns in the layout grid. */
  columns?: InputMaybe<Scalars['Int']>;
  /** Configuration for the layout of items in the breakpoint. */
  items?: InputMaybe<Array<InputMaybe<WixFormsV4ItemLayoutInput>>>;
  /** Margin spacing configuration for the form elements. */
  margin?: InputMaybe<WixFormsV4BreakPointMarginInput>;
  /** Padding spacing inside form elements in pixels. */
  padding?: InputMaybe<WixFormsV4BreakPointMarginInput>;
  /** Height of each row in the layout grid, measured in pixels. */
  rowHeight?: InputMaybe<Scalars['Int']>;
  /** Sections that organize and constrain field placement within the layout. */
  sections?: InputMaybe<Array<InputMaybe<WixFormsV4BreakPointSectionInput>>>;
};

export type WixFormsV4BreakPointMargin = {
  /** Horizontal spacing in pixels. */
  horizontal?: Maybe<Scalars['Int']>;
  /** Vertical spacing in pixels. */
  vertical?: Maybe<Scalars['Int']>;
};

export type WixFormsV4BreakPointMarginInput = {
  /** Horizontal spacing in pixels. */
  horizontal?: InputMaybe<Scalars['Int']>;
  /** Vertical spacing in pixels. */
  vertical?: InputMaybe<Scalars['Int']>;
};

export type WixFormsV4BreakPointSection = {
  /**
   * A list of field IDs that can be placed within the section.
   * The section only accepts fields with IDs specified in this list.
   * If the `$new` key is contained in this list, the section allows the inclusion of fields not explicitly listed, enabling dynamic addition of new fields.
   */
  allowedFieldIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Section ID. */
  id?: Maybe<Scalars['String']>;
  /** Row position where this section is placed in the grid. */
  row?: Maybe<Scalars['Int']>;
};

export type WixFormsV4BreakPointSectionInput = {
  /**
   * A list of field IDs that can be placed within the section.
   * The section only accepts fields with IDs specified in this list.
   * If the `$new` key is contained in this list, the section allows the inclusion of fields not explicitly listed, enabling dynamic addition of new fields.
   */
  allowedFieldIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Section ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Row position where this section is placed in the grid. */
  row?: InputMaybe<Scalars['Int']>;
};

export type WixFormsV4BulkCloneFormRequestInput = {
  /** IDs of the form schemas to clone. */
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Namespace of the form schema provider owning the cloned forms. */
  namespace?: InputMaybe<Scalars['String']>;
  /**
   * Whether to return the cloned form schemas in the response.
   *
   * Default: `false`
   */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4BulkCloneFormResponse = {
  /** Metadata about the bulk operation. */
  bulkActionMetadata?: Maybe<ComWixFormsUpstreamWixCommonBulkActionMetadata>;
  /** Results of the bulk clone operation, including cloned form schemas and metadata. */
  results?: Maybe<Array<Maybe<WixFormsV4BulkFormResult>>>;
};

export type WixFormsV4BulkCreateFormRequestInput = {
  /** Form schemas to create. */
  forms?: InputMaybe<Array<InputMaybe<WixFormsV4FormInput>>>;
  /**
   * Whether to return the created form schemas in the response.
   *
   * Default: `false`
   */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4BulkCreateFormResponse = {
  /** Metadata about the bulk operation. */
  bulkActionMetadata?: Maybe<ComWixFormsUpstreamWixCommonBulkActionMetadata>;
  /** Results of the bulk create operation, including created form schemas and metadata. */
  results?: Maybe<Array<Maybe<WixFormsV4BulkFormResult>>>;
};

export type WixFormsV4BulkDeleteFormRequestInput = {
  /** IDs of the form schemas to delete. */
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Whether to permanently delete the form schemas, bypassing the trash bin.
   *
   * Default: `false`
   */
  permanent?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4BulkDeleteFormResponse = {
  /** Metadata about the bulk operation. */
  bulkActionMetadata?: Maybe<ComWixFormsUpstreamWixCommonBulkActionMetadata>;
  /** Results of the bulk delete operation */
  results?: Maybe<Array<Maybe<WixFormsV4BulkFormResult>>>;
};

export type WixFormsV4BulkFormResult = {
  /** Deleted form schema. */
  item?: Maybe<WixFormsV4Form>;
  /** Metadata about the bulk operation result for this form schema. */
  itemMetadata?: Maybe<ComWixFormsUpstreamWixCommonItemMetadata>;
};

export type WixFormsV4BulkRemoveDeletedFieldRequestInput = {
  /** IDs of the deleted fields to remove. */
  fieldsIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** ID of the form schema to delete fields from. */
  formId?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4BulkRemoveDeletedFieldResponse = {
  /** Form schema with the fields removed. */
  form?: Maybe<WixFormsV4Form>;
};

export type WixFormsV4BulkUpdateFormTagsByFilterRequestInput = {
  /** Tags to be added to forms */
  assignTags?: InputMaybe<ComWixFormsUpstreamWixCommonPublicTagsInput>;
  /** Filter to select the form to update */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Namespace for filtering form schemas. */
  namespace?: InputMaybe<Scalars['String']>;
  /** Tags to be removed from forms */
  unassignTags?: InputMaybe<ComWixFormsUpstreamWixCommonPublicTagsInput>;
};

export type WixFormsV4BulkUpdateFormTagsByFilterResponse = {
  /** Job id for the bulk update operation */
  jobId?: Maybe<Scalars['String']>;
};

export type WixFormsV4BulkUpdateFormTagsRequestInput = {
  /** Tags to be added to forms */
  assignTags?: InputMaybe<ComWixFormsUpstreamWixCommonPublicTagsInput>;
  /** Form IDs to update tags for */
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Namespace for filtering form schemas. */
  namespace?: InputMaybe<Scalars['String']>;
  /** Tags to be removed from forms */
  unassignTags?: InputMaybe<ComWixFormsUpstreamWixCommonPublicTagsInput>;
};

export type WixFormsV4BulkUpdateFormTagsResponse = {
  /** Metadata of request */
  bulkActionMetadata?: Maybe<ComWixFormsUpstreamWixCommonBulkActionMetadata>;
  /** Updated forms with results */
  results?: Maybe<Array<Maybe<WixFormsV4BulkUpdateFormTagsResponseBulkUpdateFormTagsResult>>>;
};

export type WixFormsV4BulkUpdateFormTagsResponseBulkUpdateFormTagsResult = {
  /** Updated item metadata */
  itemMetadata?: Maybe<ComWixFormsUpstreamWixCommonItemMetadata>;
};

export type WixFormsV4CloneFormFromTemplateRequestInput = {
  /** Namespace of the form schema provider owning the cloned form schema. */
  namespace?: InputMaybe<Scalars['String']>;
  /** ID of the template to clone. */
  templateId?: InputMaybe<Scalars['String']>;
  /**
   * Whether to use the template ID as the form schema ID.
   *
   * When `true`, the cloned form schema uses the same ID as the template.
   * The operation fails if a form schema with that ID already exists.
   *
   * Default: `false`
   */
  useTemplateId?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4CloneFormFromTemplateResponse = {
  /** Cloned form schema. */
  form?: Maybe<WixFormsV4Form>;
};

export type WixFormsV4CloneFormRequestInput = {
  /** ID of the form schema to clone. */
  formId?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4CloneFormResponse = {
  /** Cloned form schema. */
  form?: Maybe<WixFormsV4Form>;
};

export type WixFormsV4ComponentsAppointment = {
  /** Additional description or instructions for the field. */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Duration of the appointment in minutes. */
  durationInMinutes?: Maybe<Scalars['Int']>;
  /** Appointment format. */
  format?: Maybe<WixFormsV4ComponentsAppointmentFormat>;
  /** Configuration for in-person appointments. */
  inPersonOptions?: Maybe<WixFormsV4ComponentsAppointmentInPersonOptions>;
  /** Field label. */
  label?: Maybe<Scalars['String']>;
  /** Whether appointments require manual approval before confirmation. */
  manualApprovalRequired?: Maybe<Scalars['Boolean']>;
  /** Appointment name. */
  name?: Maybe<Scalars['String']>;
  /** Configuration for phone appointments. */
  phoneOptions?: Maybe<WixFormsV4ComponentsAppointmentPhoneOptions>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: Maybe<Scalars['Boolean']>;
  /** IDs of staff members who provide this service. */
  staffIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Configuration for video conference appointments. */
  videoConferenceOptions?: Maybe<WixFormsV4ComponentsAppointmentVideoConferenceOptions>;
};

export enum WixFormsV4ComponentsAppointmentFormat {
  /** Face-to-face meeting at a physical location. */
  IN_PERSON = 'IN_PERSON',
  /** Appointment conducted over the phone. */
  PHONE = 'PHONE',
  UNKNOWN_FORMAT_TYPE = 'UNKNOWN_FORMAT_TYPE',
  /** Online meeting via video conference. */
  VIDEO_CONFERENCE = 'VIDEO_CONFERENCE'
}

export type WixFormsV4ComponentsAppointmentInPersonOptions = {
  /** Physical locations where the appointment can take place. */
  locations?: Maybe<Array<Maybe<WixFormsV4ComponentsAppointmentInPersonOptionsLocation>>>;
};

export type WixFormsV4ComponentsAppointmentInPersonOptionsInput = {
  /** Physical locations where the appointment can take place. */
  locations?: InputMaybe<Array<InputMaybe<WixFormsV4ComponentsAppointmentInPersonOptionsLocationInput>>>;
};

export type WixFormsV4ComponentsAppointmentInPersonOptionsLocation = {
  /** ID of a predefined business [location](https://dev.wix.com/docs/rest/crm/members-contacts/locations/locations/introduction). */
  businessLocationId?: Maybe<Scalars['String']>;
  /** Custom address specified as a text string. */
  customAddress?: Maybe<Scalars['String']>;
};

export type WixFormsV4ComponentsAppointmentInPersonOptionsLocationInput = {
  /** ID of a predefined business [location](https://dev.wix.com/docs/rest/crm/members-contacts/locations/locations/introduction). */
  businessLocationId?: InputMaybe<Scalars['String']>;
  /** Custom address specified as a text string. */
  customAddress?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4ComponentsAppointmentInput = {
  /** Additional description or instructions for the field. */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Duration of the appointment in minutes. */
  durationInMinutes?: InputMaybe<Scalars['Int']>;
  /** Appointment format. */
  format?: InputMaybe<WixFormsV4ComponentsAppointmentFormat>;
  /** Configuration for in-person appointments. */
  inPersonOptions?: InputMaybe<WixFormsV4ComponentsAppointmentInPersonOptionsInput>;
  /** Field label. */
  label?: InputMaybe<Scalars['String']>;
  /** Whether appointments require manual approval before confirmation. */
  manualApprovalRequired?: InputMaybe<Scalars['Boolean']>;
  /** Appointment name. */
  name?: InputMaybe<Scalars['String']>;
  /** Configuration for phone appointments. */
  phoneOptions?: InputMaybe<WixFormsV4ComponentsAppointmentPhoneOptionsInput>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
  /** IDs of staff members who provide this service. */
  staffIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Configuration for video conference appointments. */
  videoConferenceOptions?: InputMaybe<WixFormsV4ComponentsAppointmentVideoConferenceOptionsInput>;
};

export type WixFormsV4ComponentsAppointmentPhoneOptions = {
  /** Description or instructions for phone appointments. */
  description?: Maybe<Scalars['String']>;
};

export type WixFormsV4ComponentsAppointmentPhoneOptionsInput = {
  /** Description or instructions for phone appointments. */
  description?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4ComponentsAppointmentVideoConferenceOptions = {
  /** Description or instructions for video conference appointments. */
  description?: Maybe<Scalars['String']>;
};

export type WixFormsV4ComponentsAppointmentVideoConferenceOptionsInput = {
  /** Description or instructions for video conference appointments. */
  description?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4ComponentsCheckbox = {
  /**
   * Whether the checkbox is selected by default when the form loads.
   *
   * Default: `false`
   */
  checked?: Maybe<Scalars['Boolean']>;
  /** Field label. */
  label?: Maybe<WixRichContentV1RichContent>;
};

export type WixFormsV4ComponentsCheckboxGroup = {
  /** Custom option which can be specified by the submitter. */
  customOption?: Maybe<WixFormsV4ComponentsCommonCustomOption>;
  /** Additional description or instructions for the field. */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Field label. */
  label?: Maybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: Maybe<WixFormsV4ComponentsCommonMediaItem>;
  /** Configuration for the media content. */
  mediaSettings?: Maybe<WixFormsV4ComponentsCommonMediaSettings>;
  /**
   * Specifies the number of columns used to display the selections within the component.
   *
   * Default: `ONE`
   */
  numberOfColumns?: Maybe<WixFormsV4ComponentsCommonNumberOfColumnsEnumNumberOfColumns>;
  /** List of options the submitter can select from. */
  options?: Maybe<Array<Maybe<WixFormsV4ComponentsCheckboxGroupOption>>>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsCheckboxGroupInput = {
  /** Custom option which can be specified by the submitter. */
  customOption?: InputMaybe<WixFormsV4ComponentsCommonCustomOptionInput>;
  /** Additional description or instructions for the field. */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Field label. */
  label?: InputMaybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: InputMaybe<WixFormsV4ComponentsCommonMediaItemInput>;
  /** Configuration for the media content. */
  mediaSettings?: InputMaybe<WixFormsV4ComponentsCommonMediaSettingsInput>;
  /**
   * Specifies the number of columns used to display the selections within the component.
   *
   * Default: `ONE`
   */
  numberOfColumns?: InputMaybe<WixFormsV4ComponentsCommonNumberOfColumnsEnumNumberOfColumns>;
  /** List of options the submitter can select from. */
  options?: InputMaybe<Array<InputMaybe<WixFormsV4ComponentsCheckboxGroupOptionInput>>>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsCheckboxGroupOption = {
  /** Whether this option is selected by default. */
  default?: Maybe<Scalars['Boolean']>;
  /** Option ID. Can be used to connect this option with [Wix Multilingual](https://dev.wix.com/docs/api-reference/business-management/multilingual/translation/introduction) for translation. */
  id?: Maybe<Scalars['String']>;
  /** Selectable option label. */
  label?: Maybe<Scalars['String']>;
  /** Media content associated with this option. */
  media?: Maybe<WixFormsV4ComponentsCommonMediaItem>;
  /** Value stored on submission when this option is selected. */
  value?: Maybe<Scalars['JSON']>;
};

export type WixFormsV4ComponentsCheckboxGroupOptionInput = {
  /** Whether this option is selected by default. */
  default?: InputMaybe<Scalars['Boolean']>;
  /** Option ID. Can be used to connect this option with [Wix Multilingual](https://dev.wix.com/docs/api-reference/business-management/multilingual/translation/introduction) for translation. */
  id?: InputMaybe<Scalars['String']>;
  /** Selectable option label. */
  label?: InputMaybe<Scalars['String']>;
  /** Media content associated with this option. */
  media?: InputMaybe<WixFormsV4ComponentsCommonMediaItemInput>;
  /** Value stored on submission when this option is selected. */
  value?: InputMaybe<Scalars['JSON']>;
};

export type WixFormsV4ComponentsCheckboxInput = {
  /**
   * Whether the checkbox is selected by default when the form loads.
   *
   * Default: `false`
   */
  checked?: InputMaybe<Scalars['Boolean']>;
  /** Field label. */
  label?: InputMaybe<WixRichContentV1RichContentInput>;
};

export enum WixFormsV4ComponentsCommonAlignmentEnumAlignment {
  /** Align center. */
  CENTER = 'CENTER',
  /** Align left. */
  LEFT = 'LEFT',
  /** Align right. */
  RIGHT = 'RIGHT',
  /** Undefined alignment. */
  UNKNOWN_ALIGNMENT = 'UNKNOWN_ALIGNMENT'
}

export type WixFormsV4ComponentsCommonCustomOption = {
  /** Custom option label. */
  label?: Maybe<Scalars['String']>;
  /** Custom option placeholder text. */
  placeholder?: Maybe<Scalars['String']>;
};

export type WixFormsV4ComponentsCommonCustomOptionInput = {
  /** Custom option label. */
  label?: InputMaybe<Scalars['String']>;
  /** Custom option placeholder text. */
  placeholder?: InputMaybe<Scalars['String']>;
};

export enum WixFormsV4ComponentsCommonImageFitEnumImageFit {
  /** Resize the image to fill the element's content box. The image's original sspect ratio may not be preserved. */
  CONTAIN = 'CONTAIN',
  /** Scale the image to maintain its aspect ratio while filling the element's entire content box. Portions of the image may be clipped if the aspect ratios don't match. */
  COVER = 'COVER',
  UNKNOWN_IMAGE_FIT = 'UNKNOWN_IMAGE_FIT'
}

export enum WixFormsV4ComponentsCommonImagePositionEnumImagePosition {
  /** Above the field's label. */
  ABOVE = 'ABOVE',
  /** Below the field's label. */
  BELOW = 'BELOW',
  /** Undefined position. */
  UNKNOWN_IMAGE_POSITION = 'UNKNOWN_IMAGE_POSITION'
}

export type WixFormsV4ComponentsCommonMediaItem = {
  /** WixMedia image. */
  image?: Maybe<ComWixFormsUpstreamWixCommonImage>;
};

export type WixFormsV4ComponentsCommonMediaItemInput = {
  /** WixMedia image. */
  image?: InputMaybe<ComWixFormsUpstreamWixCommonImageInput>;
};

export type WixFormsV4ComponentsCommonMediaSettings = {
  /**
   * Specifies the image alignment.
   * Default: `CENTER`
   */
  imageAlignment?: Maybe<WixFormsV4ComponentsCommonAlignmentEnumAlignment>;
  /**
   * Specifies how an image should be resized to fit.
   * Default: `COVER`
   */
  imageFit?: Maybe<WixFormsV4ComponentsCommonImageFitEnumImageFit>;
  /**
   * Specifies where the image should be displayed relative to the field's label.
   * Default: `BELOW`
   */
  imagePosition?: Maybe<WixFormsV4ComponentsCommonImagePositionEnumImagePosition>;
};

export type WixFormsV4ComponentsCommonMediaSettingsInput = {
  /**
   * Specifies the image alignment.
   * Default: `CENTER`
   */
  imageAlignment?: InputMaybe<WixFormsV4ComponentsCommonAlignmentEnumAlignment>;
  /**
   * Specifies how an image should be resized to fit.
   * Default: `COVER`
   */
  imageFit?: InputMaybe<WixFormsV4ComponentsCommonImageFitEnumImageFit>;
  /**
   * Specifies where the image should be displayed relative to the field's label.
   * Default: `BELOW`
   */
  imagePosition?: InputMaybe<WixFormsV4ComponentsCommonImagePositionEnumImagePosition>;
};

export enum WixFormsV4ComponentsCommonNumberOfColumnsEnumNumberOfColumns {
  /** One column. */
  ONE = 'ONE',
  /** Three columns. */
  THREE = 'THREE',
  /** Two columns. */
  TWO = 'TWO',
  /** Undefined number of columns. */
  UNKNOWN_NUMBER_OF_COLUMNS = 'UNKNOWN_NUMBER_OF_COLUMNS',
  /** Zero columns. */
  ZERO = 'ZERO'
}

export type WixFormsV4ComponentsCommonServiceOption = {
  /** Option id. Used as binding for translations. Corresponds to the Service ID. */
  id?: Maybe<Scalars['String']>;
  /** Service name/label */
  label?: Maybe<Scalars['String']>;
  /** Selectable option value, which is saved to DB. Corresponds to the Service ID. */
  value?: Maybe<Scalars['String']>;
};

export type WixFormsV4ComponentsCommonServiceOptionInput = {
  /** Option id. Used as binding for translations. Corresponds to the Service ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Service name/label */
  label?: InputMaybe<Scalars['String']>;
  /** Selectable option value, which is saved to DB. Corresponds to the Service ID. */
  value?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4ComponentsDateInput = {
  /** Default value for the field. This value is pre-populated in the field when the form loads. */
  default?: Maybe<Scalars['String']>;
  /** Additional description or instructions for the field. */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Field label. */
  label?: Maybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: Maybe<WixFormsV4ComponentsCommonMediaItem>;
  /** Configuration for the media content. */
  mediaSettings?: Maybe<WixFormsV4ComponentsCommonMediaSettings>;
  /**
   * Flag identifying whether to show or hide the date labels.
   * Default: true
   */
  showDateLabels?: Maybe<Scalars['Boolean']>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: Maybe<Scalars['Boolean']>;
  /**
   * Whether to display placeholder text in the field when it's empty.
   *
   * Default: `true`
   */
  showPlaceholder?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsDateInputInput = {
  /** Default value for the field. This value is pre-populated in the field when the form loads. */
  default?: InputMaybe<Scalars['String']>;
  /** Additional description or instructions for the field. */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Field label. */
  label?: InputMaybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: InputMaybe<WixFormsV4ComponentsCommonMediaItemInput>;
  /** Configuration for the media content. */
  mediaSettings?: InputMaybe<WixFormsV4ComponentsCommonMediaSettingsInput>;
  /**
   * Flag identifying whether to show or hide the date labels.
   * Default: true
   */
  showDateLabels?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to display placeholder text in the field when it's empty.
   *
   * Default: `true`
   */
  showPlaceholder?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsDatePicker = {
  /** Default value for the field. This value is pre-populated in the field when the form loads. */
  default?: Maybe<Scalars['String']>;
  /** Additional description or instructions for the field. */
  description?: Maybe<WixRichContentV1RichContent>;
  /** First day of the week displayed on the date picker. */
  firstDayOfWeek?: Maybe<WixFormsV4ComponentsDatePickerFirstDayOfWeekEnumFirstDayOfWeek>;
  /** Field label. */
  label?: Maybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: Maybe<WixFormsV4ComponentsCommonMediaItem>;
  /** Configuration for the media content. */
  mediaSettings?: Maybe<WixFormsV4ComponentsCommonMediaSettings>;
  /** Placeholder text shown when no date is selected. */
  placeholder?: Maybe<Scalars['String']>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: Maybe<Scalars['Boolean']>;
};

export enum WixFormsV4ComponentsDatePickerFirstDayOfWeekEnumFirstDayOfWeek {
  /** First day of the week is Monday. */
  MONDAY = 'MONDAY',
  /** First day of the week is Sunday. */
  SUNDAY = 'SUNDAY'
}

export type WixFormsV4ComponentsDatePickerInput = {
  /** Default value for the field. This value is pre-populated in the field when the form loads. */
  default?: InputMaybe<Scalars['String']>;
  /** Additional description or instructions for the field. */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** First day of the week displayed on the date picker. */
  firstDayOfWeek?: InputMaybe<WixFormsV4ComponentsDatePickerFirstDayOfWeekEnumFirstDayOfWeek>;
  /** Field label. */
  label?: InputMaybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: InputMaybe<WixFormsV4ComponentsCommonMediaItemInput>;
  /** Configuration for the media content. */
  mediaSettings?: InputMaybe<WixFormsV4ComponentsCommonMediaSettingsInput>;
  /** Placeholder text shown when no date is selected. */
  placeholder?: InputMaybe<Scalars['String']>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsDateTimeInput = {
  /** Default value for the field. This value is pre-populated in the field when the form loads. */
  default?: Maybe<Scalars['String']>;
  /** Additional description or instructions for the field. */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Field label. */
  label?: Maybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: Maybe<WixFormsV4ComponentsCommonMediaItem>;
  /** Configuration for the media content. */
  mediaSettings?: Maybe<WixFormsV4ComponentsCommonMediaSettings>;
  /**
   * Flag identifying whether to show or hide the date labels.
   * Default: true
   */
  showDateLabels?: Maybe<Scalars['Boolean']>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: Maybe<Scalars['Boolean']>;
  /**
   * Whether to display placeholder text in the field when it's empty.
   *
   * Default: `true`
   */
  showPlaceholder?: Maybe<Scalars['Boolean']>;
  /**
   * Whether to use 24-hour time format.
   *
   * Default: `false`
   */
  use24HourFormat?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsDateTimeInputInput = {
  /** Default value for the field. This value is pre-populated in the field when the form loads. */
  default?: InputMaybe<Scalars['String']>;
  /** Additional description or instructions for the field. */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Field label. */
  label?: InputMaybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: InputMaybe<WixFormsV4ComponentsCommonMediaItemInput>;
  /** Configuration for the media content. */
  mediaSettings?: InputMaybe<WixFormsV4ComponentsCommonMediaSettingsInput>;
  /**
   * Flag identifying whether to show or hide the date labels.
   * Default: true
   */
  showDateLabels?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to display placeholder text in the field when it's empty.
   *
   * Default: `true`
   */
  showPlaceholder?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to use 24-hour time format.
   *
   * Default: `false`
   */
  use24HourFormat?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsDonationInput = {
  /** Custom option which can be specified by the submitter. */
  customOption?: Maybe<WixFormsV4ComponentsCommonCustomOption>;
  /** Additional description or instructions for the field. */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Field label. */
  label?: Maybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: Maybe<WixFormsV4ComponentsCommonMediaItem>;
  /** Configuration for the media content. */
  mediaSettings?: Maybe<WixFormsV4ComponentsCommonMediaSettings>;
  /**
   * Specifies the number of columns used to display the selections within the component.
   *
   * Default: `ONE`
   */
  numberOfColumns?: Maybe<WixFormsV4ComponentsCommonNumberOfColumnsEnumNumberOfColumns>;
  /** List of donation amount options the submitter can select from. */
  options?: Maybe<Array<Maybe<WixFormsV4ComponentsDonationInputOption>>>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsDonationInputInput = {
  /** Custom option which can be specified by the submitter. */
  customOption?: InputMaybe<WixFormsV4ComponentsCommonCustomOptionInput>;
  /** Additional description or instructions for the field. */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Field label. */
  label?: InputMaybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: InputMaybe<WixFormsV4ComponentsCommonMediaItemInput>;
  /** Configuration for the media content. */
  mediaSettings?: InputMaybe<WixFormsV4ComponentsCommonMediaSettingsInput>;
  /**
   * Specifies the number of columns used to display the selections within the component.
   *
   * Default: `ONE`
   */
  numberOfColumns?: InputMaybe<WixFormsV4ComponentsCommonNumberOfColumnsEnumNumberOfColumns>;
  /** List of donation amount options the submitter can select from. */
  options?: InputMaybe<Array<InputMaybe<WixFormsV4ComponentsDonationInputOptionInput>>>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsDonationInputOption = {
  /** Whether this option is selected by default. */
  default?: Maybe<Scalars['Boolean']>;
  /** Value stored on submission when this option is selected. Must match a product ID found in the field's products list. */
  value?: Maybe<Scalars['String']>;
};

export type WixFormsV4ComponentsDonationInputOptionInput = {
  /** Whether this option is selected by default. */
  default?: InputMaybe<Scalars['Boolean']>;
  /** Value stored on submission when this option is selected. Must match a product ID found in the field's products list. */
  value?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4ComponentsDropdown = {
  /** Custom option which can be specified by the submitter. */
  customOption?: Maybe<WixFormsV4ComponentsCommonCustomOption>;
  /** Additional description or instructions for the field. */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Field label. */
  label?: Maybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: Maybe<WixFormsV4ComponentsCommonMediaItem>;
  /** Configuration for the media content. */
  mediaSettings?: Maybe<WixFormsV4ComponentsCommonMediaSettings>;
  /** List of options the submitter can select from. */
  options?: Maybe<Array<Maybe<WixFormsV4ComponentsDropdownOption>>>;
  /** Placeholder text shown when no option is selected. */
  placeholder?: Maybe<Scalars['String']>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsDropdownInput = {
  /** Custom option which can be specified by the submitter. */
  customOption?: InputMaybe<WixFormsV4ComponentsCommonCustomOptionInput>;
  /** Additional description or instructions for the field. */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Field label. */
  label?: InputMaybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: InputMaybe<WixFormsV4ComponentsCommonMediaItemInput>;
  /** Configuration for the media content. */
  mediaSettings?: InputMaybe<WixFormsV4ComponentsCommonMediaSettingsInput>;
  /** List of options the submitter can select from. */
  options?: InputMaybe<Array<InputMaybe<WixFormsV4ComponentsDropdownOptionInput>>>;
  /** Placeholder text shown when no option is selected. */
  placeholder?: InputMaybe<Scalars['String']>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsDropdownOption = {
  /** Whether this option is selected by default. */
  default?: Maybe<Scalars['Boolean']>;
  /** Option ID. Can be used to connect this option with [Wix Multilingual](https://dev.wix.com/docs/api-reference/business-management/multilingual/translation/introduction) for translation. */
  id?: Maybe<Scalars['String']>;
  /** Selectable option label. */
  label?: Maybe<Scalars['String']>;
  /** Value stored on submission when this option is selected. */
  value?: Maybe<Scalars['String']>;
};

export type WixFormsV4ComponentsDropdownOptionInput = {
  /** Whether this option is selected by default. */
  default?: InputMaybe<Scalars['Boolean']>;
  /** Option ID. Can be used to connect this option with [Wix Multilingual](https://dev.wix.com/docs/api-reference/business-management/multilingual/translation/introduction) for translation. */
  id?: InputMaybe<Scalars['String']>;
  /** Selectable option label. */
  label?: InputMaybe<Scalars['String']>;
  /** Value stored on submission when this option is selected. */
  value?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4ComponentsFileUpload = {
  /** Text displayed on the upload button. */
  buttonText?: Maybe<Scalars['String']>;
  /** Additional description or instructions for the field. */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Custom text displayed when a file is uploaded. If not specified, the file name is shown. */
  explanationText?: Maybe<Scalars['String']>;
  /** Maximum number of files that can be uploaded. */
  fileLimit?: Maybe<Scalars['Int']>;
  /** Field label. */
  label?: Maybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: Maybe<WixFormsV4ComponentsCommonMediaItem>;
  /** Configuration for the media content. */
  mediaSettings?: Maybe<WixFormsV4ComponentsCommonMediaSettings>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: Maybe<Scalars['Boolean']>;
  /** Supported file formats that can be uploaded. */
  uploadFileFormats?: Maybe<Array<Maybe<WixFormsV4FieldsValidationUploadFileFormatEnumUploadFileFormat>>>;
};

export type WixFormsV4ComponentsFileUploadInput = {
  /** Text displayed on the upload button. */
  buttonText?: InputMaybe<Scalars['String']>;
  /** Additional description or instructions for the field. */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Custom text displayed when a file is uploaded. If not specified, the file name is shown. */
  explanationText?: InputMaybe<Scalars['String']>;
  /** Maximum number of files that can be uploaded. */
  fileLimit?: InputMaybe<Scalars['Int']>;
  /** Field label. */
  label?: InputMaybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: InputMaybe<WixFormsV4ComponentsCommonMediaItemInput>;
  /** Configuration for the media content. */
  mediaSettings?: InputMaybe<WixFormsV4ComponentsCommonMediaSettingsInput>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
  /** Supported file formats that can be uploaded. */
  uploadFileFormats?: InputMaybe<Array<InputMaybe<WixFormsV4FieldsValidationUploadFileFormatEnumUploadFileFormat>>>;
};

export type WixFormsV4ComponentsFixedPayment = {
  /** Additional description or instructions for the field. */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Field label. */
  label?: Maybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: Maybe<WixFormsV4ComponentsCommonMediaItem>;
  /** Configuration for the media content. */
  mediaSettings?: Maybe<WixFormsV4ComponentsCommonMediaSettings>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsFixedPaymentInput = {
  /** Additional description or instructions for the field. */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Field label. */
  label?: InputMaybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: InputMaybe<WixFormsV4ComponentsCommonMediaItemInput>;
  /** Configuration for the media content. */
  mediaSettings?: InputMaybe<WixFormsV4ComponentsCommonMediaSettingsInput>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsMultilineAddress = {
  /** Whether autocomplete is enabled for the address line field. */
  autocompleteEnabled?: Maybe<Scalars['Boolean']>;
  /** Default country configuration for the address field. */
  defaultCountryConfig?: Maybe<WixFormsV4ComponentsMultilineAddressDefaultCountryConfig>;
  /** Additional description or instructions for the field. */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Fields settings. */
  fieldSettings?: Maybe<WixFormsV4ComponentsMultilineAddressFieldsSettings>;
  /** Field label. */
  label?: Maybe<Scalars['String']>;
  /**
   * Flag identifying whether to show or hide the address labels.
   * Default: true
   */
  showAddressLabels?: Maybe<Scalars['Boolean']>;
  /** Whether to display country flags in the country selection. */
  showCountryFlags?: Maybe<Scalars['Boolean']>;
  /**
   * Flag identifying whether to show or hide the label.
   * Default: true
   */
  showLabel?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsMultilineAddressAddressLine2 = {
  /** Whether to display the address line 2 field. */
  show?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsMultilineAddressAddressLine2Input = {
  /** Whether to display the address line 2 field. */
  show?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsMultilineAddressDefaultCountryConfig = {
  /** Country code for the pre-selected default country. Two-letter country code in ISO-3166 alpha-2 format. */
  countryOptions?: Maybe<Scalars['String']>;
  /** Default country type. */
  type?: Maybe<WixFormsV4ComponentsMultilineAddressDefaultCountryConfigType>;
};

export type WixFormsV4ComponentsMultilineAddressDefaultCountryConfigInput = {
  /** Country code for the pre-selected default country. Two-letter country code in ISO-3166 alpha-2 format. */
  countryOptions?: InputMaybe<Scalars['String']>;
  /** Default country type. */
  type?: InputMaybe<WixFormsV4ComponentsMultilineAddressDefaultCountryConfigType>;
};

export enum WixFormsV4ComponentsMultilineAddressDefaultCountryConfigType {
  /** Country is determined by the submitter's IP address. */
  BY_IP = 'BY_IP',
  /** Pre-selected default country. */
  COUNTRY = 'COUNTRY',
  /** Unknown default country configuration type. */
  UNKNOWN_DEFAULT_COUNTRY = 'UNKNOWN_DEFAULT_COUNTRY'
}

export type WixFormsV4ComponentsMultilineAddressFieldsSettings = {
  /** Configuration for the address line 2 field. */
  addressLine2?: Maybe<WixFormsV4ComponentsMultilineAddressAddressLine2>;
};

export type WixFormsV4ComponentsMultilineAddressFieldsSettingsInput = {
  /** Configuration for the address line 2 field. */
  addressLine2?: InputMaybe<WixFormsV4ComponentsMultilineAddressAddressLine2Input>;
};

export type WixFormsV4ComponentsMultilineAddressInput = {
  /** Whether autocomplete is enabled for the address line field. */
  autocompleteEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Default country configuration for the address field. */
  defaultCountryConfig?: InputMaybe<WixFormsV4ComponentsMultilineAddressDefaultCountryConfigInput>;
  /** Additional description or instructions for the field. */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Fields settings. */
  fieldSettings?: InputMaybe<WixFormsV4ComponentsMultilineAddressFieldsSettingsInput>;
  /** Field label. */
  label?: InputMaybe<Scalars['String']>;
  /**
   * Flag identifying whether to show or hide the address labels.
   * Default: true
   */
  showAddressLabels?: InputMaybe<Scalars['Boolean']>;
  /** Whether to display country flags in the country selection. */
  showCountryFlags?: InputMaybe<Scalars['Boolean']>;
  /**
   * Flag identifying whether to show or hide the label.
   * Default: true
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsNumberInput = {
  /** Default value for the field. This value is pre-populated in the field when the form loads. */
  default?: Maybe<Scalars['Float']>;
  /** Additional description or instructions for the field. */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Field label. */
  label?: Maybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: Maybe<WixFormsV4ComponentsCommonMediaItem>;
  /** Configuration for the media content. */
  mediaSettings?: Maybe<WixFormsV4ComponentsCommonMediaSettings>;
  /** Placeholder text shown inside the field when it's empty. */
  placeholder?: Maybe<Scalars['String']>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsNumberInputInput = {
  /** Default value for the field. This value is pre-populated in the field when the form loads. */
  default?: InputMaybe<Scalars['Float']>;
  /** Additional description or instructions for the field. */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Field label. */
  label?: InputMaybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: InputMaybe<WixFormsV4ComponentsCommonMediaItemInput>;
  /** Configuration for the media content. */
  mediaSettings?: InputMaybe<WixFormsV4ComponentsCommonMediaSettingsInput>;
  /** Placeholder text shown inside the field when it's empty. */
  placeholder?: InputMaybe<Scalars['String']>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsPaymentInput = {
  /** Default value for the field. This value is pre-populated in the field when the form loads. */
  default?: Maybe<Scalars['Float']>;
  /** Additional description or instructions for the field. */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Field label. */
  label?: Maybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: Maybe<WixFormsV4ComponentsCommonMediaItem>;
  /** Configuration for the media content. */
  mediaSettings?: Maybe<WixFormsV4ComponentsCommonMediaSettings>;
  /** Placeholder text shown inside the field when it's empty. */
  placeholder?: Maybe<Scalars['String']>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsPaymentInputInput = {
  /** Default value for the field. This value is pre-populated in the field when the form loads. */
  default?: InputMaybe<Scalars['Float']>;
  /** Additional description or instructions for the field. */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Field label. */
  label?: InputMaybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: InputMaybe<WixFormsV4ComponentsCommonMediaItemInput>;
  /** Configuration for the media content. */
  mediaSettings?: InputMaybe<WixFormsV4ComponentsCommonMediaSettingsInput>;
  /** Placeholder text shown inside the field when it's empty. */
  placeholder?: InputMaybe<Scalars['String']>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsPhoneInput = {
  /** Default country code for the phone number input. Two-letter country code in ISO-3166 alpha-2 format. */
  defaultCountryCode?: Maybe<Scalars['String']>;
  /** Additional description or instructions for the field. */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Field label. */
  label?: Maybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: Maybe<WixFormsV4ComponentsCommonMediaItem>;
  /** Configuration for the media content. */
  mediaSettings?: Maybe<WixFormsV4ComponentsCommonMediaSettings>;
  /** Placeholder text shown inside the field when it's empty. */
  placeholder?: Maybe<Scalars['String']>;
  /**
   * Whether to display the country flag next to the country code.
   *
   * Default: `false`
   */
  showCountryFlag?: Maybe<Scalars['Boolean']>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsPhoneInputInput = {
  /** Default country code for the phone number input. Two-letter country code in ISO-3166 alpha-2 format. */
  defaultCountryCode?: InputMaybe<Scalars['String']>;
  /** Additional description or instructions for the field. */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Field label. */
  label?: InputMaybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: InputMaybe<WixFormsV4ComponentsCommonMediaItemInput>;
  /** Configuration for the media content. */
  mediaSettings?: InputMaybe<WixFormsV4ComponentsCommonMediaSettingsInput>;
  /** Placeholder text shown inside the field when it's empty. */
  placeholder?: InputMaybe<Scalars['String']>;
  /**
   * Whether to display the country flag next to the country code.
   *
   * Default: `false`
   */
  showCountryFlag?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsProductCheckboxGroup = {
  /** Additional description or instructions for the field. */
  description?: Maybe<WixRichContentV1RichContent>;
  /**
   * How an image should be resized to fit within its option container.
   *
   * Default: `COVER`
   */
  imageFit?: Maybe<WixFormsV4ComponentsCommonImageFitEnumImageFit>;
  /** Field label. */
  label?: Maybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: Maybe<WixFormsV4ComponentsCommonMediaItem>;
  /** Configuration for the media content. */
  mediaSettings?: Maybe<WixFormsV4ComponentsCommonMediaSettings>;
  /** List of product options the submitter can select from. */
  options?: Maybe<Array<Maybe<WixFormsV4ComponentsProductCheckboxGroupOption>>>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsProductCheckboxGroupInput = {
  /** Additional description or instructions for the field. */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /**
   * How an image should be resized to fit within its option container.
   *
   * Default: `COVER`
   */
  imageFit?: InputMaybe<WixFormsV4ComponentsCommonImageFitEnumImageFit>;
  /** Field label. */
  label?: InputMaybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: InputMaybe<WixFormsV4ComponentsCommonMediaItemInput>;
  /** Configuration for the media content. */
  mediaSettings?: InputMaybe<WixFormsV4ComponentsCommonMediaSettingsInput>;
  /** List of product options the submitter can select from. */
  options?: InputMaybe<Array<InputMaybe<WixFormsV4ComponentsProductCheckboxGroupOptionInput>>>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsProductCheckboxGroupOption = {
  /** Whether this option is selected by default. */
  default?: Maybe<Scalars['Boolean']>;
  /** Option ID. Can be used to connect this option with [Wix Multilingual](https://dev.wix.com/docs/api-reference/business-management/multilingual/translation/introduction) for translation. */
  id?: Maybe<Scalars['String']>;
  /** Selectable option label. */
  label?: Maybe<Scalars['String']>;
  /** Media content associated with this option, such as an image. */
  media?: Maybe<WixFormsV4ComponentsCommonMediaItem>;
  /** Value stored on submission when this option is selected. Must match a product ID found in the field's products list. */
  value?: Maybe<Scalars['JSON']>;
};

export type WixFormsV4ComponentsProductCheckboxGroupOptionInput = {
  /** Whether this option is selected by default. */
  default?: InputMaybe<Scalars['Boolean']>;
  /** Option ID. Can be used to connect this option with [Wix Multilingual](https://dev.wix.com/docs/api-reference/business-management/multilingual/translation/introduction) for translation. */
  id?: InputMaybe<Scalars['String']>;
  /** Selectable option label. */
  label?: InputMaybe<Scalars['String']>;
  /** Media content associated with this option, such as an image. */
  media?: InputMaybe<WixFormsV4ComponentsCommonMediaItemInput>;
  /** Value stored on submission when this option is selected. Must match a product ID found in the field's products list. */
  value?: InputMaybe<Scalars['JSON']>;
};

export type WixFormsV4ComponentsRadioGroup = {
  /** Custom option which can be specified by the submitter. */
  customOption?: Maybe<WixFormsV4ComponentsCommonCustomOption>;
  /** Additional description or instructions for the field. */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Field label. */
  label?: Maybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: Maybe<WixFormsV4ComponentsCommonMediaItem>;
  /** Configuration for the media content. */
  mediaSettings?: Maybe<WixFormsV4ComponentsCommonMediaSettings>;
  /**
   * Specifies the number of columns used to display the selections within the component.
   *
   * Default: `ONE`
   */
  numberOfColumns?: Maybe<WixFormsV4ComponentsCommonNumberOfColumnsEnumNumberOfColumns>;
  /** List of options the submitter can select from. */
  options?: Maybe<Array<Maybe<WixFormsV4ComponentsRadioGroupOption>>>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsRadioGroupInput = {
  /** Custom option which can be specified by the submitter. */
  customOption?: InputMaybe<WixFormsV4ComponentsCommonCustomOptionInput>;
  /** Additional description or instructions for the field. */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Field label. */
  label?: InputMaybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: InputMaybe<WixFormsV4ComponentsCommonMediaItemInput>;
  /** Configuration for the media content. */
  mediaSettings?: InputMaybe<WixFormsV4ComponentsCommonMediaSettingsInput>;
  /**
   * Specifies the number of columns used to display the selections within the component.
   *
   * Default: `ONE`
   */
  numberOfColumns?: InputMaybe<WixFormsV4ComponentsCommonNumberOfColumnsEnumNumberOfColumns>;
  /** List of options the submitter can select from. */
  options?: InputMaybe<Array<InputMaybe<WixFormsV4ComponentsRadioGroupOptionInput>>>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsRadioGroupOption = {
  /** Whether this option is selected by default. */
  default?: Maybe<Scalars['Boolean']>;
  /** Option ID. Can be used to connect this option with [Wix Multilingual](https://dev.wix.com/docs/api-reference/business-management/multilingual/translation/introduction) for translation. */
  id?: Maybe<Scalars['String']>;
  /** Selectable option label. */
  label?: Maybe<Scalars['String']>;
  /** Value stored on submission when this option is selected. */
  value?: Maybe<Scalars['String']>;
};

export type WixFormsV4ComponentsRadioGroupOptionInput = {
  /** Whether this option is selected by default. */
  default?: InputMaybe<Scalars['Boolean']>;
  /** Option ID. Can be used to connect this option with [Wix Multilingual](https://dev.wix.com/docs/api-reference/business-management/multilingual/translation/introduction) for translation. */
  id?: InputMaybe<Scalars['String']>;
  /** Selectable option label. */
  label?: InputMaybe<Scalars['String']>;
  /** Value stored on submission when this option is selected. */
  value?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4ComponentsRatingInput = {
  /** Default rating value for the field. */
  defaultValue?: Maybe<Scalars['Int']>;
  /** Additional description or instructions for the field. */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Field label. */
  label?: Maybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: Maybe<WixFormsV4ComponentsCommonMediaItem>;
  /** Configuration for the media content. */
  mediaSettings?: Maybe<WixFormsV4ComponentsCommonMediaSettings>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsRatingInputInput = {
  /** Default rating value for the field. */
  defaultValue?: InputMaybe<Scalars['Int']>;
  /** Additional description or instructions for the field. */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Field label. */
  label?: InputMaybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: InputMaybe<WixFormsV4ComponentsCommonMediaItemInput>;
  /** Configuration for the media content. */
  mediaSettings?: InputMaybe<WixFormsV4ComponentsCommonMediaSettingsInput>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsServicesCheckboxGroup = {
  /** Option which can be specified by UoU, enabled when this object is specified. */
  customOption?: Maybe<WixFormsV4ComponentsCommonCustomOption>;
  /** Description of the field */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Label of the field */
  label?: Maybe<Scalars['String']>;
  /**
   * Specifies the number of columns used to display the selections within the component.
   * Default: ONE
   */
  numberOfColumns?: Maybe<WixFormsV4ComponentsCommonNumberOfColumnsEnumNumberOfColumns>;
  /** List of options to select from */
  options?: Maybe<Array<Maybe<WixFormsV4ComponentsCommonServiceOption>>>;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsServicesCheckboxGroupInput = {
  /** Option which can be specified by UoU, enabled when this object is specified. */
  customOption?: InputMaybe<WixFormsV4ComponentsCommonCustomOptionInput>;
  /** Description of the field */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Label of the field */
  label?: InputMaybe<Scalars['String']>;
  /**
   * Specifies the number of columns used to display the selections within the component.
   * Default: ONE
   */
  numberOfColumns?: InputMaybe<WixFormsV4ComponentsCommonNumberOfColumnsEnumNumberOfColumns>;
  /** List of options to select from */
  options?: InputMaybe<Array<InputMaybe<WixFormsV4ComponentsCommonServiceOptionInput>>>;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsServicesDropdown = {
  /** Custom option which can be specified by the submitter. */
  customOption?: Maybe<WixFormsV4ComponentsCommonCustomOption>;
  /** Field label. */
  label?: Maybe<Scalars['String']>;
  /** List of service options the submitter can select from. */
  options?: Maybe<Array<Maybe<WixFormsV4ComponentsCommonServiceOption>>>;
  /** Placeholder text shown when no service is selected. */
  placeholder?: Maybe<Scalars['String']>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsServicesDropdownInput = {
  /** Custom option which can be specified by the submitter. */
  customOption?: InputMaybe<WixFormsV4ComponentsCommonCustomOptionInput>;
  /** Field label. */
  label?: InputMaybe<Scalars['String']>;
  /** List of service options the submitter can select from. */
  options?: InputMaybe<Array<InputMaybe<WixFormsV4ComponentsCommonServiceOptionInput>>>;
  /** Placeholder text shown when no service is selected. */
  placeholder?: InputMaybe<Scalars['String']>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsSignature = {
  /** Additional description or instructions for the field. */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Whether image upload is enabled for the signature field. */
  imageUploadEnabled?: Maybe<Scalars['Boolean']>;
  /** Field label. */
  label?: Maybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: Maybe<WixFormsV4ComponentsCommonMediaItem>;
  /** Configuration for the media item. */
  mediaSettings?: Maybe<WixFormsV4ComponentsCommonMediaSettings>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsSignatureInput = {
  /** Additional description or instructions for the field. */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Whether image upload is enabled for the signature field. */
  imageUploadEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Field label. */
  label?: InputMaybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: InputMaybe<WixFormsV4ComponentsCommonMediaItemInput>;
  /** Configuration for the media item. */
  mediaSettings?: InputMaybe<WixFormsV4ComponentsCommonMediaSettingsInput>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsTags = {
  /** Custom option which can be specified by the submitter. */
  customOption?: Maybe<WixFormsV4ComponentsCommonCustomOption>;
  /** Additional description or instructions for the field. */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Field label. */
  label?: Maybe<Scalars['String']>;
  /** Media item. Media, associated with field, like image. */
  media?: Maybe<WixFormsV4ComponentsCommonMediaItem>;
  /** Configuration for the media item. */
  mediaSettings?: Maybe<WixFormsV4ComponentsCommonMediaSettings>;
  /**
   * Specifies the number of columns used to display the selections within the component.
   *
   * Default: `ONE`
   */
  numberOfColumns?: Maybe<WixFormsV4ComponentsCommonNumberOfColumnsEnumNumberOfColumns>;
  /** List of options the submitter can select from. */
  options?: Maybe<Array<Maybe<WixFormsV4ComponentsTagsOption>>>;
  /**
   * Whether to display the label.
   *
   * Default: `true`
   */
  showLabel?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsTagsInput = {
  /** Custom option which can be specified by the submitter. */
  customOption?: InputMaybe<WixFormsV4ComponentsCommonCustomOptionInput>;
  /** Additional description or instructions for the field. */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Field label. */
  label?: InputMaybe<Scalars['String']>;
  /** Media item. Media, associated with field, like image. */
  media?: InputMaybe<WixFormsV4ComponentsCommonMediaItemInput>;
  /** Configuration for the media item. */
  mediaSettings?: InputMaybe<WixFormsV4ComponentsCommonMediaSettingsInput>;
  /**
   * Specifies the number of columns used to display the selections within the component.
   *
   * Default: `ONE`
   */
  numberOfColumns?: InputMaybe<WixFormsV4ComponentsCommonNumberOfColumnsEnumNumberOfColumns>;
  /** List of options the submitter can select from. */
  options?: InputMaybe<Array<InputMaybe<WixFormsV4ComponentsTagsOptionInput>>>;
  /**
   * Whether to display the label.
   *
   * Default: `true`
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsTagsOption = {
  /** Flag identifying that option should be selected by default. */
  default?: Maybe<Scalars['Boolean']>;
  /** Option id. Used as binding for translations */
  id?: Maybe<Scalars['String']>;
  /** Selectable option label. */
  label?: Maybe<Scalars['String']>;
  /** Media content associated with the option, such as an image. */
  media?: Maybe<WixFormsV4ComponentsCommonMediaItem>;
  /** Value stored on submission when this option is selected. */
  value?: Maybe<Scalars['JSON']>;
};

export type WixFormsV4ComponentsTagsOptionInput = {
  /** Flag identifying that option should be selected by default. */
  default?: InputMaybe<Scalars['Boolean']>;
  /** Option id. Used as binding for translations */
  id?: InputMaybe<Scalars['String']>;
  /** Selectable option label. */
  label?: InputMaybe<Scalars['String']>;
  /** Media content associated with the option, such as an image. */
  media?: InputMaybe<WixFormsV4ComponentsCommonMediaItemInput>;
  /** Value stored on submission when this option is selected. */
  value?: InputMaybe<Scalars['JSON']>;
};

export type WixFormsV4ComponentsTextInput = {
  /** Default value for the field. This value is pre-populated in the field when the form loads. */
  default?: Maybe<Scalars['String']>;
  /** Additional description or instructions for the field. */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Field label. */
  label?: Maybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: Maybe<WixFormsV4ComponentsCommonMediaItem>;
  /** Configuration for the media content. */
  mediaSettings?: Maybe<WixFormsV4ComponentsCommonMediaSettings>;
  /**
   * Placeholder text shown inside the field when it's empty.
   * Useful for providing a hint about the expected format or content.
   */
  placeholder?: Maybe<Scalars['String']>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsTextInputInput = {
  /** Default value for the field. This value is pre-populated in the field when the form loads. */
  default?: InputMaybe<Scalars['String']>;
  /** Additional description or instructions for the field. */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Field label. */
  label?: InputMaybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: InputMaybe<WixFormsV4ComponentsCommonMediaItemInput>;
  /** Configuration for the media content. */
  mediaSettings?: InputMaybe<WixFormsV4ComponentsCommonMediaSettingsInput>;
  /**
   * Placeholder text shown inside the field when it's empty.
   * Useful for providing a hint about the expected format or content.
   */
  placeholder?: InputMaybe<Scalars['String']>;
  /**
   * Whether to display the field label.
   *
   * Default: `true`
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsTimeInput = {
  /** Default value for the field. This value is pre-populated in the field when the form loads. */
  default?: Maybe<Scalars['String']>;
  /** Field description. */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Field label. */
  label?: Maybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: Maybe<WixFormsV4ComponentsCommonMediaItem>;
  /** Configuration for the media content. */
  mediaSettings?: Maybe<WixFormsV4ComponentsCommonMediaSettings>;
  /**
   * Whether to display the label.
   *
   * Default: `true`
   */
  showLabel?: Maybe<Scalars['Boolean']>;
  /**
   * Whether to display placeholder text in the field when it's empty.
   *
   * Default: `true`
   */
  showPlaceholder?: Maybe<Scalars['Boolean']>;
  /**
   * Whether to use 24-hour time format.
   *
   * Default: `false`
   */
  use24HourFormat?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4ComponentsTimeInputInput = {
  /** Default value for the field. This value is pre-populated in the field when the form loads. */
  default?: InputMaybe<Scalars['String']>;
  /** Field description. */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Field label. */
  label?: InputMaybe<Scalars['String']>;
  /** Media content associated with the field, such as an image. */
  media?: InputMaybe<WixFormsV4ComponentsCommonMediaItemInput>;
  /** Configuration for the media content. */
  mediaSettings?: InputMaybe<WixFormsV4ComponentsCommonMediaSettingsInput>;
  /**
   * Whether to display the label.
   *
   * Default: `true`
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to display placeholder text in the field when it's empty.
   *
   * Default: `true`
   */
  showPlaceholder?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether to use 24-hour time format.
   *
   * Default: `false`
   */
  use24HourFormat?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4CountDeletedFormsRequestInput = {
  /** Filter object for counting deleted form schemas. */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Namespace for filtering the form schemas. */
  namespace?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4CountDeletedFormsResponse = {
  /** Deleted forms count. */
  count?: Maybe<Scalars['Int']>;
};

export type WixFormsV4CountFormsByFilterRequestInput = {
  /** Filter object for counting form schemas. */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Namespace for filtering the form schemas. */
  namespace?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4CountFormsByFilterResponse = {
  /** Total form schemas count. Includes active and disabled forms. Doesn't include deleted forms. */
  count?: Maybe<Scalars['Int']>;
};

export enum WixFormsV4CountFormsRequestCountFormsFieldset {
  /** Include deleted forms count. */
  DELETED = 'DELETED',
  UNKNOWN = 'UNKNOWN'
}

export type WixFormsV4CountFormsRequestInput = {
  /**
   * List of additional form fields to include in the response. For example, use the `DELETED` fieldset to retrieve deleted forms fields in
   * the response in addition to the form’s base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the form’s base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<WixFormsV4CountFormsRequestCountFormsFieldset>>>;
  /** Namespace for filtering form schemas. */
  namespace?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4CountFormsResponse = {
  /** Active form schemas count. Only includes non-disabled forms if `CountFormsActiveCountExcludeDisabled` is `true`, otherwise behaves like `total_count. */
  activeCount?: Maybe<Scalars['Int']>;
  /** Deleted form schemas count. Counted only if specifically requested using a fieldset. */
  deletedCount?: Maybe<Scalars['Int']>;
  /** Disabled form schemas count. */
  disabledCount?: Maybe<Scalars['Int']>;
  /** Total form schemas count. Includes active and disabled forms. Doesn't include deleted forms. */
  totalCount?: Maybe<Scalars['Int']>;
};

export type WixFormsV4CreateFormRequestInput = {
  /** Form schema to create. */
  form?: InputMaybe<WixFormsV4FormInput>;
};

export type WixFormsV4CreateFormResponse = {
  /** Created form schema. */
  form?: Maybe<WixFormsV4Form>;
};

export type WixFormsV4CreateMigratedFormRequestInput = {
  /** Form schema to be created. */
  form?: InputMaybe<WixFormsV4FormInput>;
};

export type WixFormsV4CreateMigratedFormResponse = {
  /** The created form. */
  form?: Maybe<WixFormsV4Form>;
};

export type WixFormsV4DeleteFormFromTrashBinRequestInput = {
  /** Id of the form to delete. */
  formId?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4DeleteFormRequestInput = {
  /** ID of the form schema to delete. */
  formId?: InputMaybe<Scalars['String']>;
  /**
   * Whether to permanently delete the form schema, bypassing the trash bin.
   *
   * Default: `false`
   */
  permanent?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4FieldGroup = {
  /** Id of group, on layout */
  id?: Maybe<Scalars['String']>;
  /** Label of group */
  label?: Maybe<Scalars['String']>;
};

export type WixFormsV4FieldGroupInput = {
  /** Id of group, on layout */
  id?: InputMaybe<Scalars['String']>;
  /** Label of group */
  label?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FieldsDisplayField = {
  /** Type of display field that determines its appearance and behavior. */
  displayFieldType?: Maybe<WixFormsV4FieldsDisplayFieldDisplayFieldType>;
  /** Configuration for page navigation display fields such as navigation or submit buttons. */
  pageNavigationOptions?: Maybe<WixFormsV4FieldsPageNavigationOptions>;
  /** Configuration for rich content display fields. */
  richContentOptions?: Maybe<WixFormsV4FieldsRichContentOptions>;
};

export enum WixFormsV4FieldsDisplayFieldDisplayFieldType {
  /** Login bar display field. */
  LOGIN_BAR = 'LOGIN_BAR',
  /** Page navigation display field. */
  PAGE_NAVIGATION = 'PAGE_NAVIGATION',
  /** Rich content display field. */
  RICH_CONTENT = 'RICH_CONTENT',
  /** Unknown field type. */
  UNKNOWN_FIELD_TYPE = 'UNKNOWN_FIELD_TYPE'
}

export type WixFormsV4FieldsDisplayFieldInput = {
  /** Type of display field that determines its appearance and behavior. */
  displayFieldType?: InputMaybe<WixFormsV4FieldsDisplayFieldDisplayFieldType>;
  /** Configuration for page navigation display fields such as navigation or submit buttons. */
  pageNavigationOptions?: InputMaybe<WixFormsV4FieldsPageNavigationOptionsInput>;
  /** Configuration for rich content display fields. */
  richContentOptions?: InputMaybe<WixFormsV4FieldsRichContentOptionsInput>;
};

export type WixFormsV4FieldsField = {
  /** Configuration for display fields that show information without collecting input. */
  displayOptions?: Maybe<WixFormsV4FieldsDisplayField>;
  /** Field type. */
  fieldType?: Maybe<WixFormsV4FieldsFieldFieldType>;
  /**
   * Whether the field is hidden from submitters.
   *
   * Default: `false`
   */
  hidden?: Maybe<Scalars['Boolean']>;
  /** Field ID. */
  id?: Maybe<Scalars['String']>;
  /** Custom identification for the field. This is intended as a way for you to identify certain fields that you want to apply special behavior to in your own logic. */
  identifier?: Maybe<Scalars['String']>;
  /** Configuration for input fields that collect user data. */
  inputOptions?: Maybe<WixFormsV4FieldsInputField>;
};

export enum WixFormsV4FieldsFieldFieldType {
  /** Display field that shows information without collecting input. */
  DISPLAY = 'DISPLAY',
  /** Input field that collects data from users. */
  INPUT = 'INPUT',
  /** Unknown field type. */
  UNKNOWN_FIELD_TYPE = 'UNKNOWN_FIELD_TYPE'
}

export type WixFormsV4FieldsFieldInput = {
  /** Configuration for display fields that show information without collecting input. */
  displayOptions?: InputMaybe<WixFormsV4FieldsDisplayFieldInput>;
  /** Field type. */
  fieldType?: InputMaybe<WixFormsV4FieldsFieldFieldType>;
  /**
   * Whether the field is hidden from submitters.
   *
   * Default: `false`
   */
  hidden?: InputMaybe<Scalars['Boolean']>;
  /** Field ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Custom identification for the field. This is intended as a way for you to identify certain fields that you want to apply special behavior to in your own logic. */
  identifier?: InputMaybe<Scalars['String']>;
  /** Configuration for input fields that collect user data. */
  inputOptions?: InputMaybe<WixFormsV4FieldsInputFieldInput>;
};

export type WixFormsV4FieldsFormFieldContactInfo = {
  /** Configuration for address contact fields. */
  addressInfo?: Maybe<WixFormsV4FieldsFormFieldContactInfoAddressInfo>;
  /** The [Contact](https://dev.wix.com/docs/rest/crm/members-contacts/contacts/contacts/introduction) field that this form field maps to. */
  contactField?: Maybe<WixFormsV4FieldsFormFieldContactInfoContactField>;
  /** Configuration for custom contact fields. */
  customFieldInfo?: Maybe<WixFormsV4FieldsFormFieldContactInfoCustomFieldInfo>;
  /** Configuration for email contact fields. */
  emailInfo?: Maybe<WixFormsV4FieldsFormFieldContactInfoEmailInfo>;
  /** Configuration for phone contact fields. */
  phoneInfo?: Maybe<WixFormsV4FieldsFormFieldContactInfoPhoneInfo>;
  /** Configuration for subscription contact fields. */
  subscriptionInfo?: Maybe<WixFormsV4FieldsFormFieldContactInfoSubscriptionInfo>;
};

export type WixFormsV4FieldsFormFieldContactInfoAddressInfo = {
  /** Address categorization tag. */
  tag?: Maybe<WixFormsV4FieldsFormFieldContactInfoAddressInfoTag>;
};

export type WixFormsV4FieldsFormFieldContactInfoAddressInfoInput = {
  /** Address categorization tag. */
  tag?: InputMaybe<WixFormsV4FieldsFormFieldContactInfoAddressInfoTag>;
};

export enum WixFormsV4FieldsFormFieldContactInfoAddressInfoTag {
  /** Home address. */
  HOME = 'HOME',
  /** Untagged address. */
  UNTAGGED = 'UNTAGGED'
}

export enum WixFormsV4FieldsFormFieldContactInfoContactField {
  /** Contact's physical address. */
  ADDRESS = 'ADDRESS',
  /** Contact's birth date. */
  BIRTHDATE = 'BIRTHDATE',
  /** Contact's company or organization. */
  COMPANY = 'COMPANY',
  /** Custom contact field defined by the site owner. */
  CUSTOM_FIELD = 'CUSTOM_FIELD',
  /** Contact's email address. */
  EMAIL = 'EMAIL',
  /** Contact's first name. */
  FIRST_NAME = 'FIRST_NAME',
  /** Contact's last name. */
  LAST_NAME = 'LAST_NAME',
  /** Contact's phone number. */
  PHONE = 'PHONE',
  /** Contact's job title or position. */
  POSITION = 'POSITION',
  /** Contact's subscription preferences. */
  SUBSCRIPTION = 'SUBSCRIPTION',
  UNKNOWN_CONTACT_FIELD = 'UNKNOWN_CONTACT_FIELD',
  /** Contact's VAT identification number. */
  VAT_ID = 'VAT_ID'
}

export type WixFormsV4FieldsFormFieldContactInfoCustomFieldInfo = {
  /** Custom field key. */
  key?: Maybe<Scalars['String']>;
};

export type WixFormsV4FieldsFormFieldContactInfoCustomFieldInfoInput = {
  /** Custom field key. */
  key?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FieldsFormFieldContactInfoEmailInfo = {
  /** Email categorization tag. */
  tag?: Maybe<WixFormsV4FieldsFormFieldContactInfoEmailInfoTag>;
};

export type WixFormsV4FieldsFormFieldContactInfoEmailInfoInput = {
  /** Email categorization tag. */
  tag?: InputMaybe<WixFormsV4FieldsFormFieldContactInfoEmailInfoTag>;
};

export enum WixFormsV4FieldsFormFieldContactInfoEmailInfoTag {
  /** Primary email address for the contact. */
  MAIN = 'MAIN',
  /** Untagged email address. */
  UNTAGGED = 'UNTAGGED'
}

export type WixFormsV4FieldsFormFieldContactInfoInput = {
  /** Configuration for address contact fields. */
  addressInfo?: InputMaybe<WixFormsV4FieldsFormFieldContactInfoAddressInfoInput>;
  /** The [Contact](https://dev.wix.com/docs/rest/crm/members-contacts/contacts/contacts/introduction) field that this form field maps to. */
  contactField?: InputMaybe<WixFormsV4FieldsFormFieldContactInfoContactField>;
  /** Configuration for custom contact fields. */
  customFieldInfo?: InputMaybe<WixFormsV4FieldsFormFieldContactInfoCustomFieldInfoInput>;
  /** Configuration for email contact fields. */
  emailInfo?: InputMaybe<WixFormsV4FieldsFormFieldContactInfoEmailInfoInput>;
  /** Configuration for phone contact fields. */
  phoneInfo?: InputMaybe<WixFormsV4FieldsFormFieldContactInfoPhoneInfoInput>;
  /** Configuration for subscription contact fields. */
  subscriptionInfo?: InputMaybe<WixFormsV4FieldsFormFieldContactInfoSubscriptionInfoInput>;
};

export type WixFormsV4FieldsFormFieldContactInfoPhoneInfo = {
  /** Phone number categorization tag. */
  tag?: Maybe<WixFormsV4FieldsFormFieldContactInfoPhoneInfoTag>;
};

export type WixFormsV4FieldsFormFieldContactInfoPhoneInfoInput = {
  /** Phone number categorization tag. */
  tag?: InputMaybe<WixFormsV4FieldsFormFieldContactInfoPhoneInfoTag>;
};

export enum WixFormsV4FieldsFormFieldContactInfoPhoneInfoTag {
  /** Primary phone number for the contact. */
  MAIN = 'MAIN',
  /** Untagged phone number. */
  UNTAGGED = 'UNTAGGED'
}

export type WixFormsV4FieldsFormFieldContactInfoSubscriptionInfo = {
  /**
   * Subscription consent opt-in level, either single or double confirmation.
   * Default: `SINGLE_CONFIRMATION`
   */
  confirmationLevel?: Maybe<WixFormsV4FieldsFormFieldContactInfoSubscriptionInfoConfirmationLevel>;
};

export enum WixFormsV4FieldsFormFieldContactInfoSubscriptionInfoConfirmationLevel {
  /** Double confirmation level. */
  DOUBLE_CONFIRMATION = 'DOUBLE_CONFIRMATION',
  /** Single confirmation level. */
  SINGLE_CONFIRMATION = 'SINGLE_CONFIRMATION',
  /** Unknown confirmation level. */
  UNKNOWN_CONFIRMATION_LEVEL = 'UNKNOWN_CONFIRMATION_LEVEL'
}

export type WixFormsV4FieldsFormFieldContactInfoSubscriptionInfoInput = {
  /**
   * Subscription consent opt-in level, either single or double confirmation.
   * Default: `SINGLE_CONFIRMATION`
   */
  confirmationLevel?: InputMaybe<WixFormsV4FieldsFormFieldContactInfoSubscriptionInfoConfirmationLevel>;
};

export type WixFormsV4FieldsInputField = {
  /** Address input field settings. */
  addressOptions?: Maybe<WixFormsV4FieldsInputFieldAddress>;
  /** Array input field settings. */
  arrayOptions?: Maybe<WixFormsV4FieldsInputFieldArray>;
  /** Boolean input field settings. */
  booleanOptions?: Maybe<WixFormsV4FieldsInputFieldBoolean>;
  /**
   * Mapping configuration for automatically saving field values to contact properties.
   *
   * When specified, form submissions automatically create or update contacts with the field data.
   */
  contactMapping?: Maybe<WixFormsV4FieldsFormFieldContactInfo>;
  /** Type of the input field that determines what kind of data it collects. */
  inputType?: Maybe<WixFormsV4FieldsInputFieldInputType>;
  /** Multiline address input field settings. */
  multilineAddressOptions?: Maybe<WixFormsV4FieldsInputFieldAddress>;
  /** Number input field settings. */
  numberOptions?: Maybe<WixFormsV4FieldsInputFieldNumber>;
  /** Object array input field settings */
  objectArrayOptions?: Maybe<WixFormsV4FieldsInputFieldObjectArray>;
  /** Object input field settings. */
  objectOptions?: Maybe<WixFormsV4FieldsInputFieldObject>;
  /** Payment input field settings. */
  paymentOptions?: Maybe<WixFormsV4FieldsInputFieldPayment>;
  /**
   * Whether this field contains Personally Identifiable Information (PII).
   *
   * PII fields are automatically encrypted when stored.
   *
   * Default: `false`
   */
  pii?: Maybe<Scalars['Boolean']>;
  /**
   * Whether the field is read-only.
   *
   * Default: `false`
   */
  readOnly?: Maybe<Scalars['Boolean']>;
  /**
   * Whether the field is required for form submission.
   *
   * Default: `false`
   */
  required?: Maybe<Scalars['Boolean']>;
  /** Scheduling input field settings. */
  schedulingOptions?: Maybe<WixFormsV4FieldsInputFieldScheduling>;
  /** String input field settings. */
  stringOptions?: Maybe<WixFormsV4FieldsInputFieldString>;
  /**
   * Human readable identifier used to reference a field. For example, `"address"`.
   *
   * Can be set once.
   */
  target?: Maybe<Scalars['String']>;
  /** File input field settings. Files are uploaded to the [Media Manager](https://support.wix.com/en/article/wix-media-about-the-media-manager). */
  wixFileOptions?: Maybe<WixFormsV4FieldsInputFieldWixFile>;
};

export type WixFormsV4FieldsInputFieldAddress = {
  /** Component type of the multiline address field. */
  componentType?: Maybe<WixFormsV4FieldsInputFieldAddressComponentType>;
  /** Multiline address component settings. */
  multilineAddressOptions?: Maybe<WixFormsV4ComponentsMultilineAddress>;
  /** Validation configuration for the multiline address input. */
  validation?: Maybe<WixFormsV4MultilineAddressValidation>;
};

export enum WixFormsV4FieldsInputFieldAddressComponentType {
  /** Multiline address component. */
  MULTILINE_ADDRESS = 'MULTILINE_ADDRESS',
  /** Unknown component type. */
  UNKNOWN_COMPONENT_TYPE = 'UNKNOWN_COMPONENT_TYPE'
}

export type WixFormsV4FieldsInputFieldAddressInput = {
  /** Component type of the multiline address field. */
  componentType?: InputMaybe<WixFormsV4FieldsInputFieldAddressComponentType>;
  /** Multiline address component settings. */
  multilineAddressOptions?: InputMaybe<WixFormsV4ComponentsMultilineAddressInput>;
  /** Validation configuration for the multiline address input. */
  validation?: InputMaybe<WixFormsV4MultilineAddressValidationInput>;
};

export type WixFormsV4FieldsInputFieldArray = {
  /** Checkbox group component settings. */
  checkboxGroupOptions?: Maybe<WixFormsV4ComponentsCheckboxGroup>;
  /** Component type of the array input field. */
  componentType?: Maybe<WixFormsV4FieldsInputFieldArrayComponentType>;
  /** Services checkbox group input field */
  servicesCheckboxGroupOptions?: Maybe<WixFormsV4ComponentsServicesCheckboxGroup>;
  /** Tags component settings. */
  tagsOptions?: Maybe<WixFormsV4ComponentsTags>;
  /** Validation configuration for the array input. */
  validation?: Maybe<WixFormsV4FieldsValidationArrayType>;
};

export enum WixFormsV4FieldsInputFieldArrayComponentType {
  /** Checkbox group component. */
  CHECKBOX_GROUP = 'CHECKBOX_GROUP',
  SERVICES_CHECKBOX_GROUP = 'SERVICES_CHECKBOX_GROUP',
  /** Tags component. */
  TAGS = 'TAGS',
  /** Unknown component type. */
  UNKNOWN_COMPONENT_TYPE = 'UNKNOWN_COMPONENT_TYPE'
}

export type WixFormsV4FieldsInputFieldArrayInput = {
  /** Checkbox group component settings. */
  checkboxGroupOptions?: InputMaybe<WixFormsV4ComponentsCheckboxGroupInput>;
  /** Component type of the array input field. */
  componentType?: InputMaybe<WixFormsV4FieldsInputFieldArrayComponentType>;
  /** Services checkbox group input field */
  servicesCheckboxGroupOptions?: InputMaybe<WixFormsV4ComponentsServicesCheckboxGroupInput>;
  /** Tags component settings. */
  tagsOptions?: InputMaybe<WixFormsV4ComponentsTagsInput>;
  /** Validation configuration for the array input. */
  validation?: InputMaybe<WixFormsV4FieldsValidationArrayTypeInput>;
};

export type WixFormsV4FieldsInputFieldBoolean = {
  /** Checkbox component settings. */
  checkboxOptions?: Maybe<WixFormsV4ComponentsCheckbox>;
  /** Component type of the boolean input field. */
  componentType?: Maybe<WixFormsV4FieldsInputFieldBooleanComponentType>;
  /** Validation configuration for the boolean input. */
  validation?: Maybe<WixFormsV4FieldsValidationBooleanType>;
};

export enum WixFormsV4FieldsInputFieldBooleanComponentType {
  /** Checkbox component. */
  CHECKBOX = 'CHECKBOX',
  /** Unknown component type. */
  UNKNOWN_COMPONENT_TYPE = 'UNKNOWN_COMPONENT_TYPE'
}

export type WixFormsV4FieldsInputFieldBooleanInput = {
  /** Checkbox component settings. */
  checkboxOptions?: InputMaybe<WixFormsV4ComponentsCheckboxInput>;
  /** Component type of the boolean input field. */
  componentType?: InputMaybe<WixFormsV4FieldsInputFieldBooleanComponentType>;
  /** Validation configuration for the boolean input. */
  validation?: InputMaybe<WixFormsV4FieldsValidationBooleanTypeInput>;
};

export type WixFormsV4FieldsInputFieldInput = {
  /** Address input field settings. */
  addressOptions?: InputMaybe<WixFormsV4FieldsInputFieldAddressInput>;
  /** Array input field settings. */
  arrayOptions?: InputMaybe<WixFormsV4FieldsInputFieldArrayInput>;
  /** Boolean input field settings. */
  booleanOptions?: InputMaybe<WixFormsV4FieldsInputFieldBooleanInput>;
  /**
   * Mapping configuration for automatically saving field values to contact properties.
   *
   * When specified, form submissions automatically create or update contacts with the field data.
   */
  contactMapping?: InputMaybe<WixFormsV4FieldsFormFieldContactInfoInput>;
  /** Type of the input field that determines what kind of data it collects. */
  inputType?: InputMaybe<WixFormsV4FieldsInputFieldInputType>;
  /** Multiline address input field settings. */
  multilineAddressOptions?: InputMaybe<WixFormsV4FieldsInputFieldAddressInput>;
  /** Number input field settings. */
  numberOptions?: InputMaybe<WixFormsV4FieldsInputFieldNumberInput>;
  /** Object array input field settings */
  objectArrayOptions?: InputMaybe<WixFormsV4FieldsInputFieldObjectArrayInput>;
  /** Object input field settings. */
  objectOptions?: InputMaybe<WixFormsV4FieldsInputFieldObjectInput>;
  /** Payment input field settings. */
  paymentOptions?: InputMaybe<WixFormsV4FieldsInputFieldPaymentInput>;
  /**
   * Whether this field contains Personally Identifiable Information (PII).
   *
   * PII fields are automatically encrypted when stored.
   *
   * Default: `false`
   */
  pii?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether the field is read-only.
   *
   * Default: `false`
   */
  readOnly?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether the field is required for form submission.
   *
   * Default: `false`
   */
  required?: InputMaybe<Scalars['Boolean']>;
  /** Scheduling input field settings. */
  schedulingOptions?: InputMaybe<WixFormsV4FieldsInputFieldSchedulingInput>;
  /** String input field settings. */
  stringOptions?: InputMaybe<WixFormsV4FieldsInputFieldStringInput>;
  /**
   * Human readable identifier used to reference a field. For example, `"address"`.
   *
   * Can be set once.
   */
  target?: InputMaybe<Scalars['String']>;
  /** File input field settings. Files are uploaded to the [Media Manager](https://support.wix.com/en/article/wix-media-about-the-media-manager). */
  wixFileOptions?: InputMaybe<WixFormsV4FieldsInputFieldWixFileInput>;
};

export enum WixFormsV4FieldsInputFieldInputType {
  /** Address input. */
  ADDRESS = 'ADDRESS',
  /** Array input. */
  ARRAY = 'ARRAY',
  /** Boolean input. */
  BOOLEAN = 'BOOLEAN',
  /** Multiline address input. */
  MULTILINE_ADDRESS = 'MULTILINE_ADDRESS',
  /** Numeric input. */
  NUMBER = 'NUMBER',
  /** Object input. */
  OBJECT = 'OBJECT',
  /** Array of objects input. */
  OBJECT_ARRAY = 'OBJECT_ARRAY',
  /** Payment input. */
  PAYMENT = 'PAYMENT',
  /** Scheduling input. */
  SCHEDULING = 'SCHEDULING',
  /** String input. */
  STRING = 'STRING',
  /** Unknown input type. */
  UNKNOWN_INPUT_TYPE = 'UNKNOWN_INPUT_TYPE',
  /** File upload input. */
  WIX_FILE = 'WIX_FILE'
}

export type WixFormsV4FieldsInputFieldNumber = {
  /** Component type of the number input field. */
  componentType?: Maybe<WixFormsV4FieldsInputFieldNumberComponentType>;
  /** Number input settings. */
  numberInputOptions?: Maybe<WixFormsV4ComponentsNumberInput>;
  /** Rating input settings. */
  ratingInputOptions?: Maybe<WixFormsV4ComponentsRatingInput>;
  /** Validation configuration for the number input. */
  validation?: Maybe<WixFormsV4FieldsValidationNumberType>;
};

export enum WixFormsV4FieldsInputFieldNumberComponentType {
  /** Numeric input component. */
  NUMBER_INPUT = 'NUMBER_INPUT',
  /** Rating input component. */
  RATING_INPUT = 'RATING_INPUT',
  /** Unknown component type. */
  UNKNOWN_COMPONENT_TYPE = 'UNKNOWN_COMPONENT_TYPE'
}

export type WixFormsV4FieldsInputFieldNumberInput = {
  /** Component type of the number input field. */
  componentType?: InputMaybe<WixFormsV4FieldsInputFieldNumberComponentType>;
  /** Number input settings. */
  numberInputOptions?: InputMaybe<WixFormsV4ComponentsNumberInputInput>;
  /** Rating input settings. */
  ratingInputOptions?: InputMaybe<WixFormsV4ComponentsRatingInputInput>;
  /** Validation configuration for the number input. */
  validation?: InputMaybe<WixFormsV4FieldsValidationNumberTypeInput>;
};

export type WixFormsV4FieldsInputFieldObject = {
  /** Validation configuration for the object input. */
  validation?: Maybe<WixFormsV4FieldsValidationObjectType>;
};

export type WixFormsV4FieldsInputFieldObjectArray = {
  /** Component type of the object array input. */
  componentType?: Maybe<WixFormsV4FieldsInputFieldObjectArrayComponentType>;
  /** Repeater component settings. */
  repeaterOptions?: Maybe<WixFormsV4FieldsRepeater>;
  /** Validation configuration for the object array input. */
  validation?: Maybe<WixFormsV4FieldsValidationObjectArrayType>;
};

export enum WixFormsV4FieldsInputFieldObjectArrayComponentType {
  /** Repeater component. */
  REPEATER = 'REPEATER',
  /** Unknown component type. */
  UNKNOWN_COMPONENT_TYPE = 'UNKNOWN_COMPONENT_TYPE'
}

export type WixFormsV4FieldsInputFieldObjectArrayInput = {
  /** Component type of the object array input. */
  componentType?: InputMaybe<WixFormsV4FieldsInputFieldObjectArrayComponentType>;
  /** Repeater component settings. */
  repeaterOptions?: InputMaybe<WixFormsV4FieldsRepeaterInput>;
  /** Validation configuration for the object array input. */
  validation?: InputMaybe<WixFormsV4FieldsValidationObjectArrayTypeInput>;
};

export type WixFormsV4FieldsInputFieldObjectInput = {
  /** Validation configuration for the object input. */
  validation?: InputMaybe<WixFormsV4FieldsValidationObjectTypeInput>;
};

export type WixFormsV4FieldsInputFieldPayment = {
  /** Checkbox group component settings. */
  checkboxGroupOptions?: Maybe<WixFormsV4ComponentsProductCheckboxGroup>;
  /** Component type of the payment input field. */
  componentType?: Maybe<WixFormsV4FieldsInputFieldPaymentComponentType>;
  /** Donation input component settings. */
  donationInputOptions?: Maybe<WixFormsV4ComponentsDonationInput>;
  /** Fixed payment component settings. */
  fixedPaymentOptions?: Maybe<WixFormsV4ComponentsFixedPayment>;
  /** Payment input component settings. */
  paymentInputOptions?: Maybe<WixFormsV4ComponentsPaymentInput>;
  /** Validation configuration for the payment input. */
  validation?: Maybe<WixFormsV4PaymentType>;
};

export enum WixFormsV4FieldsInputFieldPaymentComponentType {
  /** Checkbox group component. */
  CHECKBOX_GROUP = 'CHECKBOX_GROUP',
  /** Donation input component. */
  DONATION_INPUT = 'DONATION_INPUT',
  /** Fixed payment component. */
  FIXED_PAYMENT = 'FIXED_PAYMENT',
  /** Payment input component. */
  PAYMENT_INPUT = 'PAYMENT_INPUT',
  /** Unknown component type. */
  UNKNOWN_COMPONENT_TYPE = 'UNKNOWN_COMPONENT_TYPE'
}

export type WixFormsV4FieldsInputFieldPaymentInput = {
  /** Checkbox group component settings. */
  checkboxGroupOptions?: InputMaybe<WixFormsV4ComponentsProductCheckboxGroupInput>;
  /** Component type of the payment input field. */
  componentType?: InputMaybe<WixFormsV4FieldsInputFieldPaymentComponentType>;
  /** Donation input component settings. */
  donationInputOptions?: InputMaybe<WixFormsV4ComponentsDonationInputInput>;
  /** Fixed payment component settings. */
  fixedPaymentOptions?: InputMaybe<WixFormsV4ComponentsFixedPaymentInput>;
  /** Payment input component settings. */
  paymentInputOptions?: InputMaybe<WixFormsV4ComponentsPaymentInputInput>;
  /** Validation configuration for the payment input. */
  validation?: InputMaybe<WixFormsV4PaymentTypeInput>;
};

export type WixFormsV4FieldsInputFieldScheduling = {
  /** Appointment component settings. */
  appointmentOptions?: Maybe<WixFormsV4ComponentsAppointment>;
  /** Component type of the scheduling field. */
  componentType?: Maybe<WixFormsV4FieldsInputFieldSchedulingComponentType>;
};

export enum WixFormsV4FieldsInputFieldSchedulingComponentType {
  /** Appointment component. */
  APPOINTMENT = 'APPOINTMENT',
  /** Unknown component type. */
  UNKNOWN_COMPONENT_TYPE = 'UNKNOWN_COMPONENT_TYPE'
}

export type WixFormsV4FieldsInputFieldSchedulingInput = {
  /** Appointment component settings. */
  appointmentOptions?: InputMaybe<WixFormsV4ComponentsAppointmentInput>;
  /** Component type of the scheduling field. */
  componentType?: InputMaybe<WixFormsV4FieldsInputFieldSchedulingComponentType>;
};

export type WixFormsV4FieldsInputFieldString = {
  /** Component type of the string input field. */
  componentType?: Maybe<WixFormsV4FieldsInputFieldStringComponentType>;
  /** Date input component settings. */
  dateInputOptions?: Maybe<WixFormsV4ComponentsDateInput>;
  /** Date picker component settings. */
  datePickerOptions?: Maybe<WixFormsV4ComponentsDatePicker>;
  /** Date and time input component settings. */
  dateTimeOptions?: Maybe<WixFormsV4ComponentsDateTimeInput>;
  /** Dropdown component settings. */
  dropdownOptions?: Maybe<WixFormsV4ComponentsDropdown>;
  /** Phone input component settings. */
  phoneInputOptions?: Maybe<WixFormsV4ComponentsPhoneInput>;
  /** Radio group component settings. */
  radioGroupOptions?: Maybe<WixFormsV4ComponentsRadioGroup>;
  /** Services dropdown component settings. */
  servicesDropdownOptions?: Maybe<WixFormsV4ComponentsServicesDropdown>;
  /** Text input component settings. */
  textInputOptions?: Maybe<WixFormsV4ComponentsTextInput>;
  /** Time input component settings. */
  timeInputOptions?: Maybe<WixFormsV4ComponentsTimeInput>;
  /** Validation configuration for the string input. */
  validation?: Maybe<WixFormsV4FieldsValidationStringType>;
};

export enum WixFormsV4FieldsInputFieldStringComponentType {
  /** Date selection component. */
  DATE_INPUT = 'DATE_INPUT',
  /** Calendar-style date picker component. */
  DATE_PICKER = 'DATE_PICKER',
  /** Date and time component. */
  DATE_TIME = 'DATE_TIME',
  /** Dropdown component. */
  DROPDOWN = 'DROPDOWN',
  /** Phone number component. */
  PHONE_INPUT = 'PHONE_INPUT',
  /** Radio group component. */
  RADIO_GROUP = 'RADIO_GROUP',
  /** Dropdown component for selecting available services. */
  SERVICES_DROPDOWN = 'SERVICES_DROPDOWN',
  /** Text input component. */
  TEXT_INPUT = 'TEXT_INPUT',
  /** Time selection component. */
  TIME_INPUT = 'TIME_INPUT',
  /** Unknown component type. */
  UNKNOWN_COMPONENT_TYPE = 'UNKNOWN_COMPONENT_TYPE'
}

export type WixFormsV4FieldsInputFieldStringInput = {
  /** Component type of the string input field. */
  componentType?: InputMaybe<WixFormsV4FieldsInputFieldStringComponentType>;
  /** Date input component settings. */
  dateInputOptions?: InputMaybe<WixFormsV4ComponentsDateInputInput>;
  /** Date picker component settings. */
  datePickerOptions?: InputMaybe<WixFormsV4ComponentsDatePickerInput>;
  /** Date and time input component settings. */
  dateTimeOptions?: InputMaybe<WixFormsV4ComponentsDateTimeInputInput>;
  /** Dropdown component settings. */
  dropdownOptions?: InputMaybe<WixFormsV4ComponentsDropdownInput>;
  /** Phone input component settings. */
  phoneInputOptions?: InputMaybe<WixFormsV4ComponentsPhoneInputInput>;
  /** Radio group component settings. */
  radioGroupOptions?: InputMaybe<WixFormsV4ComponentsRadioGroupInput>;
  /** Services dropdown component settings. */
  servicesDropdownOptions?: InputMaybe<WixFormsV4ComponentsServicesDropdownInput>;
  /** Text input component settings. */
  textInputOptions?: InputMaybe<WixFormsV4ComponentsTextInputInput>;
  /** Time input component settings. */
  timeInputOptions?: InputMaybe<WixFormsV4ComponentsTimeInputInput>;
  /** Validation configuration for the string input. */
  validation?: InputMaybe<WixFormsV4FieldsValidationStringTypeInput>;
};

export type WixFormsV4FieldsInputFieldWixFile = {
  /** Component type of the file input field. */
  componentType?: Maybe<WixFormsV4FieldsInputFieldWixFileComponentType>;
  /** File upload component settings. */
  fileUploadOptions?: Maybe<WixFormsV4ComponentsFileUpload>;
  /** Signature component settings. */
  signatureOptions?: Maybe<WixFormsV4ComponentsSignature>;
  /** Validation configuration for the file input. */
  validation?: Maybe<WixFormsV4FieldsValidationFileType>;
};

export enum WixFormsV4FieldsInputFieldWixFileComponentType {
  /** File upload component. */
  FILE_UPLOAD = 'FILE_UPLOAD',
  /** Signature component. */
  SIGNATURE = 'SIGNATURE',
  /** Unknown component type. */
  UNKNOWN_COMPONENT_TYPE = 'UNKNOWN_COMPONENT_TYPE'
}

export type WixFormsV4FieldsInputFieldWixFileInput = {
  /** Component type of the file input field. */
  componentType?: InputMaybe<WixFormsV4FieldsInputFieldWixFileComponentType>;
  /** File upload component settings. */
  fileUploadOptions?: InputMaybe<WixFormsV4ComponentsFileUploadInput>;
  /** Signature component settings. */
  signatureOptions?: InputMaybe<WixFormsV4ComponentsSignatureInput>;
  /** Validation configuration for the file input. */
  validation?: InputMaybe<WixFormsV4FieldsValidationFileTypeInput>;
};

export type WixFormsV4FieldsPageNavigationOptions = {
  /**
   * Text displayed on the button when it navigates to the next page.
   * Only applicable when the button is not on the final form page.
   */
  nextPageText?: Maybe<Scalars['String']>;
  /**
   * Text displayed on the button when it navigates to the previous page.
   * Only applicable when the button is not on the first form page.
   */
  previousPageText?: Maybe<Scalars['String']>;
  /**
   * Text displayed on the button when it submits the form.
   * Only applicable when the button is on the final form page.
   */
  submitText?: Maybe<Scalars['String']>;
};

export type WixFormsV4FieldsPageNavigationOptionsInput = {
  /**
   * Text displayed on the button when it navigates to the next page.
   * Only applicable when the button is not on the final form page.
   */
  nextPageText?: InputMaybe<Scalars['String']>;
  /**
   * Text displayed on the button when it navigates to the previous page.
   * Only applicable when the button is not on the first form page.
   */
  previousPageText?: InputMaybe<Scalars['String']>;
  /**
   * Text displayed on the button when it submits the form.
   * Only applicable when the button is on the final form page.
   */
  submitText?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FieldsRepeater = {
  /** Additional description or instructions for the field. */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Form fields that define the input elements inside repeater. */
  fields?: Maybe<Array<Maybe<WixFormsV4FieldsField>>>;
  /** Field label. */
  label?: Maybe<Scalars['String']>;
  /** Layout configuration that defines how form fields are arranged within this repeater. */
  layout?: Maybe<WixFormsV4FormLayout>;
  /**
   * Whether to display the label.
   *
   * Default: `true`
   */
  showLabel?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4FieldsRepeaterInput = {
  /** Additional description or instructions for the field. */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Form fields that define the input elements inside repeater. */
  fields?: InputMaybe<Array<InputMaybe<WixFormsV4FieldsFieldInput>>>;
  /** Field label. */
  label?: InputMaybe<Scalars['String']>;
  /** Layout configuration that defines how form fields are arranged within this repeater. */
  layout?: InputMaybe<WixFormsV4FormLayoutInput>;
  /**
   * Whether to display the label.
   *
   * Default: `true`
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4FieldsRichContentOptions = {
  /**
   * Maximum number of paragraphs to show initially.
   * Additional content is hidden behind an expandable section. If not specified, all content is visible.
   */
  maxShownParagraphs?: Maybe<Scalars['Int']>;
  /** Rich content to display in the field. */
  richContent?: Maybe<WixRichContentV1RichContent>;
};

export type WixFormsV4FieldsRichContentOptionsInput = {
  /**
   * Maximum number of paragraphs to show initially.
   * Additional content is hidden behind an expandable section. If not specified, all content is visible.
   */
  maxShownParagraphs?: InputMaybe<Scalars['Int']>;
  /** Rich content to display in the field. */
  richContent?: InputMaybe<WixRichContentV1RichContentInput>;
};

export type WixFormsV4FieldsValidationArrayType = {
  /** Type of items allowed in the array. */
  items?: Maybe<WixFormsV4FieldsValidationArrayTypeArrayItems>;
  /** Maximum number of elements allowed in the array. */
  maxItems?: Maybe<Scalars['Int']>;
  /** Minimum number of elements required in the array. */
  minItems?: Maybe<Scalars['Int']>;
};

export type WixFormsV4FieldsValidationArrayTypeArrayItems = {
  /** Validation rules for boolean array elements. */
  booleanOptions?: Maybe<WixFormsV4FieldsValidationBooleanType>;
  /** Allowed item type. */
  itemType?: Maybe<WixFormsV4FieldsValidationArrayTypeArrayItemsItemType>;
  /** Validation rules for numeric array elements. */
  numberOptions?: Maybe<WixFormsV4FieldsValidationNumberType>;
  /** Validation rules for object array elements. */
  objectOptions?: Maybe<WixFormsV4FieldsValidationObjectType>;
  /** Validation rules for string array elements. */
  stringOptions?: Maybe<WixFormsV4FieldsValidationStringType>;
};

export type WixFormsV4FieldsValidationArrayTypeArrayItemsInput = {
  /** Validation rules for boolean array elements. */
  booleanOptions?: InputMaybe<WixFormsV4FieldsValidationBooleanTypeInput>;
  /** Allowed item type. */
  itemType?: InputMaybe<WixFormsV4FieldsValidationArrayTypeArrayItemsItemType>;
  /** Validation rules for numeric array elements. */
  numberOptions?: InputMaybe<WixFormsV4FieldsValidationNumberTypeInput>;
  /** Validation rules for object array elements. */
  objectOptions?: InputMaybe<WixFormsV4FieldsValidationObjectTypeInput>;
  /** Validation rules for string array elements. */
  stringOptions?: InputMaybe<WixFormsV4FieldsValidationStringTypeInput>;
};

export enum WixFormsV4FieldsValidationArrayTypeArrayItemsItemType {
  /** Array can contain boolean values. */
  BOOLEAN = 'BOOLEAN',
  /** Array can contain numeric values. */
  NUMBER = 'NUMBER',
  /** Array can contain object values. */
  OBJECT = 'OBJECT',
  /** Array can contain string values. */
  STRING = 'STRING',
  /** Unknown item type. */
  UNKNOWN_ITEM_TYPE = 'UNKNOWN_ITEM_TYPE'
}

export type WixFormsV4FieldsValidationArrayTypeInput = {
  /** Type of items allowed in the array. */
  items?: InputMaybe<WixFormsV4FieldsValidationArrayTypeArrayItemsInput>;
  /** Maximum number of elements allowed in the array. */
  maxItems?: InputMaybe<Scalars['Int']>;
  /** Minimum number of elements required in the array. */
  minItems?: InputMaybe<Scalars['Int']>;
};

export type WixFormsV4FieldsValidationBooleanType = {
  /** List of allowed values. */
  enum?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
};

export type WixFormsV4FieldsValidationBooleanTypeInput = {
  /** List of allowed values. */
  enum?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type WixFormsV4FieldsValidationFileType = {
  /** Maximum number of files that can be uploaded. */
  fileLimit?: Maybe<Scalars['Int']>;
  /** Supported file formats for uploaded files. */
  uploadFileFormats?: Maybe<Array<Maybe<WixFormsV4FieldsValidationUploadFileFormatEnumUploadFileFormat>>>;
};

export type WixFormsV4FieldsValidationFileTypeInput = {
  /** Maximum number of files that can be uploaded. */
  fileLimit?: InputMaybe<Scalars['Int']>;
  /** Supported file formats for uploaded files. */
  uploadFileFormats?: InputMaybe<Array<InputMaybe<WixFormsV4FieldsValidationUploadFileFormatEnumUploadFileFormat>>>;
};

export type WixFormsV4FieldsValidationNumberType = {
  /** List of allowed values. */
  enum?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** The maximum value of the number. Inclusive. */
  maximum?: Maybe<Scalars['Float']>;
  /** The minimum value of the number. Inclusive. */
  minimum?: Maybe<Scalars['Float']>;
  /** A number that the value must be a multiple of. */
  multipleOf?: Maybe<Scalars['Float']>;
};

export type WixFormsV4FieldsValidationNumberTypeInput = {
  /** List of allowed values. */
  enum?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** The maximum value of the number. Inclusive. */
  maximum?: InputMaybe<Scalars['Float']>;
  /** The minimum value of the number. Inclusive. */
  minimum?: InputMaybe<Scalars['Float']>;
  /** A number that the value must be a multiple of. */
  multipleOf?: InputMaybe<Scalars['Float']>;
};

export type WixFormsV4FieldsValidationObjectArrayType = {
  /** Maximum number of elements allowed in the array. */
  maxItems?: Maybe<Scalars['Int']>;
  /** Minimum number of elements required in the array. */
  minItems?: Maybe<Scalars['Int']>;
};

export type WixFormsV4FieldsValidationObjectArrayTypeInput = {
  /** Maximum number of elements allowed in the array. */
  maxItems?: InputMaybe<Scalars['Int']>;
  /** Minimum number of elements required in the array. */
  minItems?: InputMaybe<Scalars['Int']>;
};

export type WixFormsV4FieldsValidationObjectType = {
  /** Definition of object properties and their validation rules. */
  properties?: Maybe<WixFormsV4FieldsValidationObjectTypePropertiesType>;
};

export type WixFormsV4FieldsValidationObjectTypeInput = {
  /** Definition of object properties and their validation rules. */
  properties?: InputMaybe<WixFormsV4FieldsValidationObjectTypePropertiesTypeInput>;
};

export type WixFormsV4FieldsValidationObjectTypePropertiesType = {
  /** Validation rules for array properties. */
  arrayOptions?: Maybe<WixFormsV4FieldsValidationArrayType>;
  /** Validation rules for boolean properties. */
  booleanOptions?: Maybe<WixFormsV4FieldsValidationBooleanType>;
  /** Validation rules for numeric properties. */
  numberOptions?: Maybe<WixFormsV4FieldsValidationNumberType>;
  /** Data type of the object property. */
  propertiesType?: Maybe<WixFormsV4FieldsValidationObjectTypePropertiesTypePropertiesTypeEnum>;
  /** Whether the object property is required for validation. */
  required?: Maybe<Scalars['Boolean']>;
  /** Validation rules for string properties. */
  stringOptions?: Maybe<WixFormsV4FieldsValidationStringType>;
};

export type WixFormsV4FieldsValidationObjectTypePropertiesTypeInput = {
  /** Validation rules for array properties. */
  arrayOptions?: InputMaybe<WixFormsV4FieldsValidationArrayTypeInput>;
  /** Validation rules for boolean properties. */
  booleanOptions?: InputMaybe<WixFormsV4FieldsValidationBooleanTypeInput>;
  /** Validation rules for numeric properties. */
  numberOptions?: InputMaybe<WixFormsV4FieldsValidationNumberTypeInput>;
  /** Data type of the object property. */
  propertiesType?: InputMaybe<WixFormsV4FieldsValidationObjectTypePropertiesTypePropertiesTypeEnum>;
  /** Whether the object property is required for validation. */
  required?: InputMaybe<Scalars['Boolean']>;
  /** Validation rules for string properties. */
  stringOptions?: InputMaybe<WixFormsV4FieldsValidationStringTypeInput>;
};

export enum WixFormsV4FieldsValidationObjectTypePropertiesTypePropertiesTypeEnum {
  /** Property must contain an array. */
  ARRAY = 'ARRAY',
  /** Property must contain a boolean value. */
  BOOLEAN = 'BOOLEAN',
  /** Property must contain a numeric value. */
  NUMBER = 'NUMBER',
  /** Property must contain a string value. */
  STRING = 'STRING',
  /** Unknown property type. */
  UNKNOWN_PROPERTY_TYPE = 'UNKNOWN_PROPERTY_TYPE'
}

export type WixFormsV4FieldsValidationStringType = {
  /** Validation rules for string with date and time format, where time is optional. */
  dateOptionalTimeOptions?: Maybe<WixFormsV4FieldsValidationStringTypeDateTimeConstraints>;
  /** Validation rules for strings with date format. */
  dateOptions?: Maybe<WixFormsV4FieldsValidationStringTypeDateTimeConstraints>;
  /** Validation rules for strings with date and time format. */
  dateTimeOptions?: Maybe<WixFormsV4FieldsValidationStringTypeDateTimeConstraints>;
  /**
   * List of specific values that are allowed for this field.
   * When specified, the input must match one of these predefined values.
   */
  enum?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Expected format of the string value. */
  format?: Maybe<WixFormsV4FieldsValidationStringTypeFormatEnumFormat>;
  /** Maximum allowed length for the string value. */
  maxLength?: Maybe<Scalars['Int']>;
  /** Minimum required length for the string value. */
  minLength?: Maybe<Scalars['Int']>;
  /** Regular expression pattern that the string value must match. */
  pattern?: Maybe<Scalars['String']>;
  /** Validation rules for strings with phone number format. */
  phoneOptions?: Maybe<WixFormsV4FieldsValidationStringTypePhoneConstraints>;
  /** Validation rules for strings with time format. */
  timeOptions?: Maybe<WixFormsV4FieldsValidationStringTypeDateTimeConstraints>;
  /** Custom error messages displayed when validation fails. */
  validationMessages?: Maybe<WixFormsV4FieldsValidationStringTypeValidationMessages>;
};

export type WixFormsV4FieldsValidationStringTypeDateTimeConstraints = {
  /**
   * Maximum allowed datetime value.
   *
   * Supports ISO datetime format or dynamic calculations using "$now" keyword.
   * The dynamic calculation supports times in the future and past.
   * The pattern for dynamic calculations: $now([+-]\d{1,2})([yMdmh]).
   *
   * Examples: `"2023-01-01"`, `"$now-1d"` (1 day ago), `"$now+2h"` (2 hours from now).
   */
  maximum?: Maybe<Scalars['String']>;
  /**
   * Minimum allowed datetime value.
   *
   * Supports ISO datetime format or dynamic calculations using "$now" keyword.
   * The dynamic calculation supports times in the future and past.
   * The pattern for dynamic calculations: $now([+-]\d{1,2})([yMdmh]).
   *
   * Examples: `"2023-01-01"`, `"$now-1d"` (1 day ago), `"$now+2h"` (2 hours from now).
   */
  minimum?: Maybe<Scalars['String']>;
};

export type WixFormsV4FieldsValidationStringTypeDateTimeConstraintsInput = {
  /**
   * Maximum allowed datetime value.
   *
   * Supports ISO datetime format or dynamic calculations using "$now" keyword.
   * The dynamic calculation supports times in the future and past.
   * The pattern for dynamic calculations: $now([+-]\d{1,2})([yMdmh]).
   *
   * Examples: `"2023-01-01"`, `"$now-1d"` (1 day ago), `"$now+2h"` (2 hours from now).
   */
  maximum?: InputMaybe<Scalars['String']>;
  /**
   * Minimum allowed datetime value.
   *
   * Supports ISO datetime format or dynamic calculations using "$now" keyword.
   * The dynamic calculation supports times in the future and past.
   * The pattern for dynamic calculations: $now([+-]\d{1,2})([yMdmh]).
   *
   * Examples: `"2023-01-01"`, `"$now-1d"` (1 day ago), `"$now+2h"` (2 hours from now).
   */
  minimum?: InputMaybe<Scalars['String']>;
};

export enum WixFormsV4FieldsValidationStringTypeFormatEnumFormat {
  /** Hexadecimal color code format. */
  COLOR_HEX = 'COLOR_HEX',
  /** Currency format. */
  CURRENCY = 'CURRENCY',
  /** Date format. */
  DATE = 'DATE',
  /** Date with optional time format. */
  DATE_OPTIONAL_TIME = 'DATE_OPTIONAL_TIME',
  /** Date and time format. */
  DATE_TIME = 'DATE_TIME',
  /** Email format. */
  EMAIL = 'EMAIL',
  /** Hostname format. */
  HOSTNAME = 'HOSTNAME',
  /** Language code format. */
  LANGUAGE = 'LANGUAGE',
  /** Phone number format. */
  PHONE = 'PHONE',
  /** Time format. */
  TIME = 'TIME',
  /** Unknown format. */
  UNKNOWN_FORMAT = 'UNKNOWN_FORMAT',
  /** URI format. */
  URI = 'URI',
  /** URL format. */
  URL = 'URL',
  /** UUID format. */
  UUID = 'UUID'
}

export type WixFormsV4FieldsValidationStringTypeInput = {
  /** Validation rules for string with date and time format, where time is optional. */
  dateOptionalTimeOptions?: InputMaybe<WixFormsV4FieldsValidationStringTypeDateTimeConstraintsInput>;
  /** Validation rules for strings with date format. */
  dateOptions?: InputMaybe<WixFormsV4FieldsValidationStringTypeDateTimeConstraintsInput>;
  /** Validation rules for strings with date and time format. */
  dateTimeOptions?: InputMaybe<WixFormsV4FieldsValidationStringTypeDateTimeConstraintsInput>;
  /**
   * List of specific values that are allowed for this field.
   * When specified, the input must match one of these predefined values.
   */
  enum?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Expected format of the string value. */
  format?: InputMaybe<WixFormsV4FieldsValidationStringTypeFormatEnumFormat>;
  /** Maximum allowed length for the string value. */
  maxLength?: InputMaybe<Scalars['Int']>;
  /** Minimum required length for the string value. */
  minLength?: InputMaybe<Scalars['Int']>;
  /** Regular expression pattern that the string value must match. */
  pattern?: InputMaybe<Scalars['String']>;
  /** Validation rules for strings with phone number format. */
  phoneOptions?: InputMaybe<WixFormsV4FieldsValidationStringTypePhoneConstraintsInput>;
  /** Validation rules for strings with time format. */
  timeOptions?: InputMaybe<WixFormsV4FieldsValidationStringTypeDateTimeConstraintsInput>;
  /** Custom error messages displayed when validation fails. */
  validationMessages?: InputMaybe<WixFormsV4FieldsValidationStringTypeValidationMessagesInput>;
};

export type WixFormsV4FieldsValidationStringTypePhoneConstraints = {
  /**
   * Country codes that are allowed for phone number validation.
   *
   * Use ISO 3166-1 alpha-2 country codes. For example, `"US"`, `"GB"`, `"CA"`.
   */
  allowedCountryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type WixFormsV4FieldsValidationStringTypePhoneConstraintsInput = {
  /**
   * Country codes that are allowed for phone number validation.
   *
   * Use ISO 3166-1 alpha-2 country codes. For example, `"US"`, `"GB"`, `"CA"`.
   */
  allowedCountryCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixFormsV4FieldsValidationStringTypeValidationMessages = {
  /**
   * Error message shown when the pattern validation fails.
   *
   * This message is displayed to users when their input doesn't match the specified regex pattern.
   */
  pattern?: Maybe<Scalars['String']>;
};

export type WixFormsV4FieldsValidationStringTypeValidationMessagesInput = {
  /**
   * Error message shown when the pattern validation fails.
   *
   * This message is displayed to users when their input doesn't match the specified regex pattern.
   */
  pattern?: InputMaybe<Scalars['String']>;
};

export enum WixFormsV4FieldsValidationUploadFileFormatEnumUploadFileFormat {
  /** Archive files. */
  ARCHIVE = 'ARCHIVE',
  /** Audio files. */
  AUDIO = 'AUDIO',
  /** Document files. */
  DOCUMENT = 'DOCUMENT',
  /** Image files. */
  IMAGE = 'IMAGE',
  /** Undefined upload file format. */
  UNKNOWN_UPLOAD_FILE_FORMAT = 'UNKNOWN_UPLOAD_FILE_FORMAT',
  /** Video files. */
  VIDEO = 'VIDEO'
}

export type WixFormsV4Form = {
  /** Date and time when the form schema was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Fields which were soft deleted. */
  deletedFields?: Maybe<Array<Maybe<WixFormsV4FormField>>>;
  /** Form fields that were soft deleted. */
  deletedFormFields?: Maybe<Array<Maybe<WixFormsV4FieldsField>>>;
  /**
   * Message displayed to visitors when the form is disabled.
   * This allows you to inform submitters why the form isn't available.
   */
  disabledFormMessage?: Maybe<WixRichContentV1RichContent>;
  /**
   * Whether the form schema is enabled.
   *
   * Default: `true`
   */
  enabled?: Maybe<Scalars['Boolean']>;
  /** Data extensions for storing additional custom properties. */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** Configuration for field groups. */
  fieldGroups?: Maybe<Array<Maybe<WixFormsV4FieldGroup>>>;
  /** List of form fields that represent input elements. */
  fields?: Maybe<Array<Maybe<WixFormsV4FormField>>>;
  /** Form fields that define the input elements and their validation rules. */
  formFields?: Maybe<Array<Maybe<WixFormsV4FieldsField>>>;
  /**
   * Business logic rules that can modify form behavior based on user input or other conditions.
   * These rules can show/hide fields, change validation, or trigger actions.
   */
  formRules?: Maybe<Array<Maybe<WixFormsV4RulesRule>>>;
  /** Form schema ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Regular forms can be freely modified.
   * Extensions are copied from templates and might have restrictions.
   */
  kind?: Maybe<WixFormsV4FormKindKind>;
  /** Submission limits that can automatically disable the form when reached. */
  limitationRule?: Maybe<WixFormsV4FormLimitationRule>;
  /** Media folder ID for storing uploaded files from form submissions. */
  mediaFolderId?: Maybe<Scalars['String']>;
  /** Display name of the form schema. */
  name?: Maybe<Scalars['String']>;
  /**
   * Unique identifier for the app that owns this form schema.
   * For example, `wix.form_app.form` for Wix Forms.
   *
   * See a list of namespaces for [apps made by Wix](https://dev.wix.com/docs/api-reference/crm/forms/form-schemas/introduction#namespaces-of-apps-made-by-wix) section.
   */
  namespace?: Maybe<Scalars['String']>;
  /** Nested forms. */
  nestedForms?: Maybe<Array<Maybe<WixFormsV4FormNestedForm>>>;
  /**
   * Defines triggers that will be executed after the submission, for the submissions based on this schema.
   * Forms provide a set of predefined triggers that allow it to assign specific business cases to created forms.
   */
  postSubmissionTriggers?: Maybe<WixFormsV4PostSubmissionTriggers>;
  /** Properties of the form. */
  properties?: Maybe<WixFormsV4FormFormProperties>;
  /** Configuration for how required field indicators are displayed to the submitter. */
  requiredIndicatorProperties?: Maybe<WixFormsV4RequiredIndicatorProperties>;
  /**
   * Revision number, which increments by 1 each time the form schema is updated.
   * To prevent conflicting changes, the current revision must be passed when updating the form schema.
   */
  revision?: Maybe<Scalars['Long']>;
  /**
   * Form rules, can be applied to layout and items properties.
   * @deprecated Form rules, can be applied to layout and items properties. Replaced by: wix.forms.v4.Form.form_rules. Removal date: 2026-04-01.
   */
  rules?: Maybe<Array<Maybe<WixFormsV4FormRule>>>;
  /** ID of the source form. */
  sourceFormId?: Maybe<Scalars['String']>;
  /**
   * Level of spam protection applied to form submissions.
   *
   * Default: `ADVANCED`
   */
  spamFilterProtectionLevel?: Maybe<WixFormsV4FormSpamFilterProtectionLevel>;
  /**
   * Layout configuration that defines how form fields are organized across multiple steps.
   * Each step represents a page of the form.
   */
  steps?: Maybe<Array<Maybe<WixFormsV4Step>>>;
  /** Configuration for actions taken after a form is successfully submitted. */
  submitSettings?: Maybe<WixFormsV4SubmitSettings>;
  /** Tag IDs collections associated with the current entity. */
  tags?: Maybe<ComWixFormsUpstreamWixCommonPublicTags>;
  /** Date and time when the form schema was last updated. */
  updatedDate?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormField = {
  /** Details identifying field, which is extension of other entity */
  dataExtensionsDetails?: Maybe<WixFormsV4FormFieldDataExtensionsDetails>;
  /** Whether the field is hidden. */
  hidden?: Maybe<Scalars['Boolean']>;
  /** Item ID. */
  id?: Maybe<Scalars['String']>;
  /** Nested form ID. */
  nestedFormId?: Maybe<Scalars['String']>;
  /** Nested form overrides. */
  nestedFormOverrides?: Maybe<WixFormsV4FormFieldNestedFormOverrides>;
  /** Mark the field as containing personal information. This will encrypt user data when storing it. */
  pii?: Maybe<Scalars['Boolean']>;
  /**
   * Whether the field is read only.
   * Default: false
   */
  readOnly?: Maybe<Scalars['Boolean']>;
  /** Definition of a target where the value of field belongs. */
  target?: Maybe<Scalars['String']>;
  /** Validation of field output value. */
  validation?: Maybe<WixFormsV4FormFieldValidation>;
  /** Field view properties. */
  view?: Maybe<Scalars['JSON']>;
};

export type WixFormsV4FormFieldArrayErrorMessages = {
  /** Default error message on invalid validation. */
  default?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldArrayErrorMessagesInput = {
  /** Default error message on invalid validation. */
  default?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldArrayType = {
  /** Custom error message when validation fails. */
  errorMessages?: Maybe<WixFormsV4FormFieldArrayErrorMessages>;
  /** Type of items allowed in array. */
  items?: Maybe<WixFormsV4FormFieldArrayTypeArrayItems>;
  /** Maximum amount of array elements. */
  maxItems?: Maybe<Scalars['Int']>;
  /** Minimum amount of array elements. */
  minItems?: Maybe<Scalars['Int']>;
};

export type WixFormsV4FormFieldArrayTypeArrayItems = {
  /** Boolean type validation for items. */
  boolean?: Maybe<WixFormsV4FormFieldBooleanType>;
  /** Integer type validation for items. */
  integer?: Maybe<WixFormsV4FormFieldIntegerType>;
  /** Number type validation for items. */
  number?: Maybe<WixFormsV4FormFieldNumberType>;
  /** Object type validation for items */
  object?: Maybe<WixFormsV4FormFieldObjectType>;
  /** String type validation for items. */
  string?: Maybe<WixFormsV4FormFieldStringType>;
};

export type WixFormsV4FormFieldArrayTypeArrayItemsInput = {
  /** Boolean type validation for items. */
  boolean?: InputMaybe<WixFormsV4FormFieldBooleanTypeInput>;
  /** Integer type validation for items. */
  integer?: InputMaybe<WixFormsV4FormFieldIntegerTypeInput>;
  /** Number type validation for items. */
  number?: InputMaybe<WixFormsV4FormFieldNumberTypeInput>;
  /** Object type validation for items */
  object?: InputMaybe<WixFormsV4FormFieldObjectTypeInput>;
  /** String type validation for items. */
  string?: InputMaybe<WixFormsV4FormFieldStringTypeInput>;
};

export type WixFormsV4FormFieldArrayTypeInput = {
  /** Custom error message when validation fails. */
  errorMessages?: InputMaybe<WixFormsV4FormFieldArrayErrorMessagesInput>;
  /** Type of items allowed in array. */
  items?: InputMaybe<WixFormsV4FormFieldArrayTypeArrayItemsInput>;
  /** Maximum amount of array elements. */
  maxItems?: InputMaybe<Scalars['Int']>;
  /** Minimum amount of array elements. */
  minItems?: InputMaybe<Scalars['Int']>;
};

export type WixFormsV4FormFieldBooleanErrorMessages = {
  /** Default error message on invalid validation. */
  default?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldBooleanErrorMessagesInput = {
  /** Default error message on invalid validation. */
  default?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldBooleanType = {
  /** List of allowed values. */
  enum?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Custom error message when validation fails. */
  errorMessages?: Maybe<WixFormsV4FormFieldBooleanErrorMessages>;
};

export type WixFormsV4FormFieldBooleanTypeInput = {
  /** List of allowed values. */
  enum?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Custom error message when validation fails. */
  errorMessages?: InputMaybe<WixFormsV4FormFieldBooleanErrorMessagesInput>;
};

export type WixFormsV4FormFieldContactInfo = {
  /** Address info. */
  addressInfo?: Maybe<WixFormsV4FormFieldContactInfoAddressInfo>;
  /** The contact field that the form field maps to. */
  contactField?: Maybe<WixFormsV4FormFieldContactInfoContactField>;
  /** Custom field info. */
  customFieldInfo?: Maybe<WixFormsV4FormFieldContactInfoCustomFieldInfo>;
  /** Email info. */
  emailInfo?: Maybe<WixFormsV4FormFieldContactInfoEmailInfo>;
  /** Phone info. */
  phoneInfo?: Maybe<WixFormsV4FormFieldContactInfoPhoneInfo>;
  /** Subscription info. */
  subscriptionInfo?: Maybe<WixFormsV4FormFieldContactInfoSubscriptionInfo>;
};

export type WixFormsV4FormFieldContactInfoAddressInfo = {
  /** Address tag. */
  tag?: Maybe<WixFormsV4FormFieldContactInfoAddressInfoTag>;
};

export type WixFormsV4FormFieldContactInfoAddressInfoInput = {
  /** Address tag. */
  tag?: InputMaybe<WixFormsV4FormFieldContactInfoAddressInfoTag>;
};

export enum WixFormsV4FormFieldContactInfoAddressInfoTag {
  /** Home address for the contact. */
  HOME = 'HOME',
  /** Address without a specific tag. */
  UNTAGGED = 'UNTAGGED'
}

export enum WixFormsV4FormFieldContactInfoContactField {
  /** Physical address. */
  ADDRESS = 'ADDRESS',
  /** Birth date. */
  BIRTHDATE = 'BIRTHDATE',
  /** Company name. */
  COMPANY = 'COMPANY',
  /** Custom field. */
  CUSTOM_FIELD = 'CUSTOM_FIELD',
  /** Email address. */
  EMAIL = 'EMAIL',
  /** First name. */
  FIRST_NAME = 'FIRST_NAME',
  /** CLast name. */
  LAST_NAME = 'LAST_NAME',
  /** Phone number. */
  PHONE = 'PHONE',
  /** Job position or title. */
  POSITION = 'POSITION',
  /** Subscription status. */
  SUBSCRIPTION = 'SUBSCRIPTION',
  /** Unknown contact field. */
  UNDEFINED = 'UNDEFINED',
  /** VAT identification number. */
  VAT_ID = 'VAT_ID'
}

export type WixFormsV4FormFieldContactInfoCustomFieldInfo = {
  /** Custom field key. */
  key?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldContactInfoCustomFieldInfoInput = {
  /** Custom field key. */
  key?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldContactInfoEmailInfo = {
  /** Email tag. */
  tag?: Maybe<WixFormsV4FormFieldContactInfoEmailInfoTag>;
};

export type WixFormsV4FormFieldContactInfoEmailInfoInput = {
  /** Email tag. */
  tag?: InputMaybe<WixFormsV4FormFieldContactInfoEmailInfoTag>;
};

export enum WixFormsV4FormFieldContactInfoEmailInfoTag {
  /** Primary email address for the contact. */
  MAIN = 'MAIN',
  /** Email without a specific tag. */
  UNTAGGED = 'UNTAGGED'
}

export type WixFormsV4FormFieldContactInfoInput = {
  /** Address info. */
  addressInfo?: InputMaybe<WixFormsV4FormFieldContactInfoAddressInfoInput>;
  /** The contact field that the form field maps to. */
  contactField?: InputMaybe<WixFormsV4FormFieldContactInfoContactField>;
  /** Custom field info. */
  customFieldInfo?: InputMaybe<WixFormsV4FormFieldContactInfoCustomFieldInfoInput>;
  /** Email info. */
  emailInfo?: InputMaybe<WixFormsV4FormFieldContactInfoEmailInfoInput>;
  /** Phone info. */
  phoneInfo?: InputMaybe<WixFormsV4FormFieldContactInfoPhoneInfoInput>;
  /** Subscription info. */
  subscriptionInfo?: InputMaybe<WixFormsV4FormFieldContactInfoSubscriptionInfoInput>;
};

export type WixFormsV4FormFieldContactInfoPhoneInfo = {
  /** Phone tag. */
  tag?: Maybe<WixFormsV4FormFieldContactInfoPhoneInfoTag>;
};

export type WixFormsV4FormFieldContactInfoPhoneInfoInput = {
  /** Phone tag. */
  tag?: InputMaybe<WixFormsV4FormFieldContactInfoPhoneInfoTag>;
};

export enum WixFormsV4FormFieldContactInfoPhoneInfoTag {
  /** Primary phone number for the contact. */
  MAIN = 'MAIN',
  /** Phone number without a specific tag. */
  UNTAGGED = 'UNTAGGED'
}

export type WixFormsV4FormFieldContactInfoSubscriptionInfo = {
  /**
   * Subscription consent opt-in level.
   * Default: `SINGLE_CONFIRMATION`
   */
  optInLevel?: Maybe<WixFormsV4FormFieldContactInfoSubscriptionInfoOptInLevel>;
};

export type WixFormsV4FormFieldContactInfoSubscriptionInfoInput = {
  /**
   * Subscription consent opt-in level.
   * Default: `SINGLE_CONFIRMATION`
   */
  optInLevel?: InputMaybe<WixFormsV4FormFieldContactInfoSubscriptionInfoOptInLevel>;
};

export enum WixFormsV4FormFieldContactInfoSubscriptionInfoOptInLevel {
  /** Double confirmation opt-in. The contact must confirm their subscription via email. */
  DOUBLE_CONFIRMATION = 'DOUBLE_CONFIRMATION',
  /** Single confirmation opt-in. The contact is subscribed immediately. */
  SINGLE_CONFIRMATION = 'SINGLE_CONFIRMATION',
  /** Unknown opt-in level. */
  UNKNOWN = 'UNKNOWN'
}

export type WixFormsV4FormFieldDataExtensionsDetails = {
  /** FQDNS which can be extended with this field */
  fqdns?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type WixFormsV4FormFieldDataExtensionsDetailsInput = {
  /** FQDNS which can be extended with this field */
  fqdns?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixFormsV4FormFieldInput = {
  /** Details identifying field, which is extension of other entity */
  dataExtensionsDetails?: InputMaybe<WixFormsV4FormFieldDataExtensionsDetailsInput>;
  /** Whether the field is hidden. */
  hidden?: InputMaybe<Scalars['Boolean']>;
  /** Item ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Nested form ID. */
  nestedFormId?: InputMaybe<Scalars['String']>;
  /** Nested form overrides. */
  nestedFormOverrides?: InputMaybe<WixFormsV4FormFieldNestedFormOverridesInput>;
  /** Mark the field as containing personal information. This will encrypt user data when storing it. */
  pii?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether the field is read only.
   * Default: false
   */
  readOnly?: InputMaybe<Scalars['Boolean']>;
  /** Definition of a target where the value of field belongs. */
  target?: InputMaybe<Scalars['String']>;
  /** Validation of field output value. */
  validation?: InputMaybe<WixFormsV4FormFieldValidationInput>;
  /** Field view properties. */
  view?: InputMaybe<Scalars['JSON']>;
};

export type WixFormsV4FormFieldIntegerType = {
  /** List of allowed values. */
  enum?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Custom error message when validation fails. */
  errorMessages?: Maybe<WixFormsV4FormFieldNumberErrorMessages>;
  /** Minimum value. */
  maximum?: Maybe<Scalars['Int']>;
  /** Maximum value. */
  minimum?: Maybe<Scalars['Int']>;
  /** Multiple of value. */
  multipleOf?: Maybe<Scalars['Int']>;
};

export type WixFormsV4FormFieldIntegerTypeInput = {
  /** List of allowed values. */
  enum?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Custom error message when validation fails. */
  errorMessages?: InputMaybe<WixFormsV4FormFieldNumberErrorMessagesInput>;
  /** Minimum value. */
  maximum?: InputMaybe<Scalars['Int']>;
  /** Maximum value. */
  minimum?: InputMaybe<Scalars['Int']>;
  /** Multiple of value. */
  multipleOf?: InputMaybe<Scalars['Int']>;
};

export type WixFormsV4FormFieldNestedFormOverrides = {
  /** Field overrides by field ID */
  fieldOverrides?: Maybe<WixFormsV4FormFieldNestedFormOverridesNestedFormFieldOverrides>;
};

export type WixFormsV4FormFieldNestedFormOverridesInput = {
  /** Field overrides by field ID */
  fieldOverrides?: InputMaybe<WixFormsV4FormFieldNestedFormOverridesNestedFormFieldOverridesInput>;
};

export type WixFormsV4FormFieldNestedFormOverridesNestedFormFieldOverrides = {
  /** Whether the field is hidden. Leave blank for no override. */
  hidden?: Maybe<Scalars['Boolean']>;
  /** Whether the field is required. Leave blank for no override. */
  required?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4FormFieldNestedFormOverridesNestedFormFieldOverridesInput = {
  /** Whether the field is hidden. Leave blank for no override. */
  hidden?: InputMaybe<Scalars['Boolean']>;
  /** Whether the field is required. Leave blank for no override. */
  required?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4FormFieldNumberErrorMessages = {
  /** Default error message on invalid validation. */
  default?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldNumberErrorMessagesInput = {
  /** Default error message on invalid validation. */
  default?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldNumberType = {
  /** List of allowed values. */
  enum?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Custom error message when validation fails. */
  errorMessages?: Maybe<WixFormsV4FormFieldNumberErrorMessages>;
  /** Inclusive maximum value. */
  maximum?: Maybe<Scalars['Float']>;
  /** Inclusive minimum value. */
  minimum?: Maybe<Scalars['Float']>;
  /** Multiple of value. */
  multipleOf?: Maybe<Scalars['Float']>;
};

export type WixFormsV4FormFieldNumberTypeInput = {
  /** List of allowed values. */
  enum?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** Custom error message when validation fails. */
  errorMessages?: InputMaybe<WixFormsV4FormFieldNumberErrorMessagesInput>;
  /** Inclusive maximum value. */
  maximum?: InputMaybe<Scalars['Float']>;
  /** Inclusive minimum value. */
  minimum?: InputMaybe<Scalars['Float']>;
  /** Multiple of value. */
  multipleOf?: InputMaybe<Scalars['Float']>;
};

export type WixFormsV4FormFieldObjectErrorMessages = {
  /** Default error message on invalid validation. */
  default?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldObjectErrorMessagesInput = {
  /** Default error message on invalid validation. */
  default?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldObjectType = {
  /** Custom error message when validation fails. */
  errorMessages?: Maybe<WixFormsV4FormFieldObjectErrorMessages>;
  /** Description of object properties. */
  properties?: Maybe<WixFormsV4FormFieldObjectTypePropertiesType>;
};

export type WixFormsV4FormFieldObjectTypeInput = {
  /** Custom error message when validation fails. */
  errorMessages?: InputMaybe<WixFormsV4FormFieldObjectErrorMessagesInput>;
  /** Description of object properties. */
  properties?: InputMaybe<WixFormsV4FormFieldObjectTypePropertiesTypeInput>;
};

export type WixFormsV4FormFieldObjectTypePropertiesType = {
  /** Array type validation for property. */
  array?: Maybe<WixFormsV4FormFieldArrayType>;
  /** Boolean type validation for property. */
  boolean?: Maybe<WixFormsV4FormFieldBooleanType>;
  /** Integer type validation for property. */
  integer?: Maybe<WixFormsV4FormFieldIntegerType>;
  /** Number type validation for property. */
  number?: Maybe<WixFormsV4FormFieldNumberType>;
  /** Whether the property is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** String type validation for property. */
  string?: Maybe<WixFormsV4FormFieldStringType>;
};

export type WixFormsV4FormFieldObjectTypePropertiesTypeInput = {
  /** Array type validation for property. */
  array?: InputMaybe<WixFormsV4FormFieldArrayTypeInput>;
  /** Boolean type validation for property. */
  boolean?: InputMaybe<WixFormsV4FormFieldBooleanTypeInput>;
  /** Integer type validation for property. */
  integer?: InputMaybe<WixFormsV4FormFieldIntegerTypeInput>;
  /** Number type validation for property. */
  number?: InputMaybe<WixFormsV4FormFieldNumberTypeInput>;
  /** Whether the property is required. */
  required?: InputMaybe<Scalars['Boolean']>;
  /** String type validation for property. */
  string?: InputMaybe<WixFormsV4FormFieldStringTypeInput>;
};

export type WixFormsV4FormFieldPaymentInfoProduct = {
  /** Dynamic price options. */
  dynamicPriceOptions?: Maybe<WixFormsV4FormFieldPaymentInfoProductDynamicPriceOptions>;
  /** Fixed price options. */
  fixedPriceOptions?: Maybe<WixFormsV4FormFieldPaymentInfoProductFixedPriceOptions>;
  /** Product ID. */
  id?: Maybe<Scalars['String']>;
  /** Price type. */
  priceType?: Maybe<WixFormsV4FormFieldPaymentInfoProductPriceTypeEnumPriceType>;
  /** Product type. */
  productType?: Maybe<WixFormsV4FormFieldPaymentInfoProductProductTypeEnumProductType>;
  /** Quantity limit. */
  quantityLimit?: Maybe<WixFormsV4FormFieldPaymentInfoProductQuantityLimit>;
};

export type WixFormsV4FormFieldPaymentInfoProductDynamicPriceOptions = {
  /** Maximal price monetary amount. */
  maxPrice?: Maybe<Scalars['String']>;
  /** Minimal price monetary amount. */
  minPrice?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldPaymentInfoProductDynamicPriceOptionsInput = {
  /** Maximal price monetary amount. */
  maxPrice?: InputMaybe<Scalars['String']>;
  /** Minimal price monetary amount. */
  minPrice?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldPaymentInfoProductFixedPriceOptions = {
  /** Fixed price monetary amount. Decimal string with a period as a decimal separator (e.g., 3.99). */
  price?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldPaymentInfoProductFixedPriceOptionsInput = {
  /** Fixed price monetary amount. Decimal string with a period as a decimal separator (e.g., 3.99). */
  price?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldPaymentInfoProductInput = {
  /** Dynamic price options. */
  dynamicPriceOptions?: InputMaybe<WixFormsV4FormFieldPaymentInfoProductDynamicPriceOptionsInput>;
  /** Fixed price options. */
  fixedPriceOptions?: InputMaybe<WixFormsV4FormFieldPaymentInfoProductFixedPriceOptionsInput>;
  /** Product ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Price type. */
  priceType?: InputMaybe<WixFormsV4FormFieldPaymentInfoProductPriceTypeEnumPriceType>;
  /** Product type. */
  productType?: InputMaybe<WixFormsV4FormFieldPaymentInfoProductProductTypeEnumProductType>;
  /** Quantity limit. */
  quantityLimit?: InputMaybe<WixFormsV4FormFieldPaymentInfoProductQuantityLimitInput>;
};

export enum WixFormsV4FormFieldPaymentInfoProductPriceTypeEnumPriceType {
  /** Dynamic price from price range. */
  DYNAMIC_PRICE = 'DYNAMIC_PRICE',
  /** Fixed price. */
  FIXED_PRICE = 'FIXED_PRICE',
  UNKNOWN = 'UNKNOWN'
}

export enum WixFormsV4FormFieldPaymentInfoProductProductTypeEnumProductType {
  /** Digital. */
  DIGITAL = 'DIGITAL',
  /** Shippable (physical). */
  SHIPPABLE = 'SHIPPABLE',
  UNKNOWN = 'UNKNOWN'
}

export type WixFormsV4FormFieldPaymentInfoProductQuantityLimit = {
  /** Maximum quantity. */
  maximum?: Maybe<Scalars['Int']>;
  /** Minimum quantity. */
  minimum?: Maybe<Scalars['Int']>;
};

export type WixFormsV4FormFieldPaymentInfoProductQuantityLimitInput = {
  /** Maximum quantity. */
  maximum?: InputMaybe<Scalars['Int']>;
  /** Minimum quantity. */
  minimum?: InputMaybe<Scalars['Int']>;
};

export type WixFormsV4FormFieldPredefinedValidation = {
  /** Format of predefined validation. */
  format?: Maybe<WixFormsV4FormFieldPredefinedValidationValidationFormat>;
  /** Multiline address validation. */
  multilineAddressOptions?: Maybe<WixFormsV4MultilineAddressValidation>;
  /** Validation configuration for the object array input. */
  objectArrayOptions?: Maybe<WixFormsV4FieldsValidationObjectArrayType>;
  /** Payment input field. */
  paymentOptions?: Maybe<WixFormsV4PaymentType>;
};

export type WixFormsV4FormFieldPredefinedValidationInput = {
  /** Format of predefined validation. */
  format?: InputMaybe<WixFormsV4FormFieldPredefinedValidationValidationFormat>;
  /** Multiline address validation. */
  multilineAddressOptions?: InputMaybe<WixFormsV4MultilineAddressValidationInput>;
  /** Validation configuration for the object array input. */
  objectArrayOptions?: InputMaybe<WixFormsV4FieldsValidationObjectArrayTypeInput>;
  /** Payment input field. */
  paymentOptions?: InputMaybe<WixFormsV4PaymentTypeInput>;
};

export enum WixFormsV4FormFieldPredefinedValidationValidationFormat {
  /** Multiline address. */
  MULTILINE_ADDRESS = 'MULTILINE_ADDRESS',
  /** Object array validation. */
  OBJECT_ARRAY = 'OBJECT_ARRAY',
  /** Payment validation. */
  PAYMENT = 'PAYMENT',
  /** Scheduling validation. */
  SCHEDULING = 'SCHEDULING',
  UNDEFINED = 'UNDEFINED',
  /** File upload validation. */
  WIX_FILE = 'WIX_FILE'
}

export type WixFormsV4FormFieldStringErrorMessages = {
  /** Default error message on invalid validation. */
  default?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldStringErrorMessagesInput = {
  /** Default error message on invalid validation. */
  default?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldStringType = {
  /** DATE_OPTIONAL_TIME format options */
  dateOptionalTimeOptions?: Maybe<WixFormsV4FormFieldStringTypeDateTimeConstraints>;
  /** DATE format options */
  dateOptions?: Maybe<WixFormsV4FormFieldStringTypeDateTimeConstraints>;
  /** DATE_TIME format options */
  dateTimeOptions?: Maybe<WixFormsV4FormFieldStringTypeDateTimeConstraints>;
  /** List of allowed values. */
  enum?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Custom error messages when validation fails. */
  errorMessages?: Maybe<WixFormsV4FormFieldStringErrorMessages>;
  /** Format of a string. */
  format?: Maybe<WixFormsV4FormFieldStringTypeFormatEnumFormat>;
  /** Maximum length. */
  maxLength?: Maybe<Scalars['Int']>;
  /** Minimum length. */
  minLength?: Maybe<Scalars['Int']>;
  /** Pattern for a regular expression match. */
  pattern?: Maybe<Scalars['String']>;
  /** PHONE format options */
  phoneOptions?: Maybe<WixFormsV4FormFieldStringTypePhoneConstraints>;
  /** TIME format options */
  timeOptions?: Maybe<WixFormsV4FormFieldStringTypeDateTimeConstraints>;
  /** User defined error messages when particular validation constraint fails */
  validationMessages?: Maybe<WixFormsV4FormFieldStringTypeValidationMessages>;
};

export type WixFormsV4FormFieldStringTypeDateTimeConstraints = {
  /**
   * Support static constrains defined as ISO date/time format, as well as
   * dynamic calculations can be performed using special keywords such as "$now" to represent the current date and time.
   * The dynamic calculation supports expressions like "$now+2d" (2 days in the future), "$now-1h" (1 hour in the past), etc.
   * The regex pattern for dynamic calculations is: \$now([+-]\d{1,2})([yMdmh])
   */
  maximum?: Maybe<Scalars['String']>;
  /**
   * Support static constrains defined as ISO date/time format, as well as
   * dynamic calculations can be performed using special keywords such as "$now" to represent the current date and time.
   * The dynamic calculation supports expressions like "$now+2d" (2 days in the future), "$now-1h" (1 hour in the past), etc.
   * The regex pattern for dynamic calculations is: \$now([+-]\d{1,2})([yMdmh])
   */
  minimum?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldStringTypeDateTimeConstraintsInput = {
  /**
   * Support static constrains defined as ISO date/time format, as well as
   * dynamic calculations can be performed using special keywords such as "$now" to represent the current date and time.
   * The dynamic calculation supports expressions like "$now+2d" (2 days in the future), "$now-1h" (1 hour in the past), etc.
   * The regex pattern for dynamic calculations is: \$now([+-]\d{1,2})([yMdmh])
   */
  maximum?: InputMaybe<Scalars['String']>;
  /**
   * Support static constrains defined as ISO date/time format, as well as
   * dynamic calculations can be performed using special keywords such as "$now" to represent the current date and time.
   * The dynamic calculation supports expressions like "$now+2d" (2 days in the future), "$now-1h" (1 hour in the past), etc.
   * The regex pattern for dynamic calculations is: \$now([+-]\d{1,2})([yMdmh])
   */
  minimum?: InputMaybe<Scalars['String']>;
};

export enum WixFormsV4FormFieldStringTypeFormatEnumFormat {
  COLOR_HEX = 'COLOR_HEX',
  CURRENCY = 'CURRENCY',
  DATE = 'DATE',
  DATE_OPTIONAL_TIME = 'DATE_OPTIONAL_TIME',
  DATE_TIME = 'DATE_TIME',
  EMAIL = 'EMAIL',
  HOSTNAME = 'HOSTNAME',
  LANGUAGE = 'LANGUAGE',
  PHONE = 'PHONE',
  TIME = 'TIME',
  UNDEFINED = 'UNDEFINED',
  URI = 'URI',
  URL = 'URL',
  UUID = 'UUID'
}

export type WixFormsV4FormFieldStringTypeInput = {
  /** DATE_OPTIONAL_TIME format options */
  dateOptionalTimeOptions?: InputMaybe<WixFormsV4FormFieldStringTypeDateTimeConstraintsInput>;
  /** DATE format options */
  dateOptions?: InputMaybe<WixFormsV4FormFieldStringTypeDateTimeConstraintsInput>;
  /** DATE_TIME format options */
  dateTimeOptions?: InputMaybe<WixFormsV4FormFieldStringTypeDateTimeConstraintsInput>;
  /** List of allowed values. */
  enum?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Custom error messages when validation fails. */
  errorMessages?: InputMaybe<WixFormsV4FormFieldStringErrorMessagesInput>;
  /** Format of a string. */
  format?: InputMaybe<WixFormsV4FormFieldStringTypeFormatEnumFormat>;
  /** Maximum length. */
  maxLength?: InputMaybe<Scalars['Int']>;
  /** Minimum length. */
  minLength?: InputMaybe<Scalars['Int']>;
  /** Pattern for a regular expression match. */
  pattern?: InputMaybe<Scalars['String']>;
  /** PHONE format options */
  phoneOptions?: InputMaybe<WixFormsV4FormFieldStringTypePhoneConstraintsInput>;
  /** TIME format options */
  timeOptions?: InputMaybe<WixFormsV4FormFieldStringTypeDateTimeConstraintsInput>;
  /** User defined error messages when particular validation constraint fails */
  validationMessages?: InputMaybe<WixFormsV4FormFieldStringTypeValidationMessagesInput>;
};

export type WixFormsV4FormFieldStringTypePhoneConstraints = {
  /** Country codes for phone number that are allowed */
  allowedCountryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type WixFormsV4FormFieldStringTypePhoneConstraintsInput = {
  /** Country codes for phone number that are allowed */
  allowedCountryCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixFormsV4FormFieldStringTypeValidationMessages = {
  /** Error message shown when validation of patter fails */
  pattern?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldStringTypeValidationMessagesInput = {
  /** Error message shown when validation of patter fails */
  pattern?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2DisplayField = {
  /** Header field */
  header?: Maybe<WixFormsV4FormFieldV2DisplayFieldHeader>;
  /** Rich text field */
  richText?: Maybe<WixFormsV4FormFieldV2DisplayFieldRichText>;
};

export type WixFormsV4FormFieldV2DisplayFieldHeader = {
  /** Content of the header */
  content?: Maybe<WixRichContentV1RichContent>;
};

export type WixFormsV4FormFieldV2DisplayFieldHeaderInput = {
  /** Content of the header */
  content?: InputMaybe<WixRichContentV1RichContentInput>;
};

export type WixFormsV4FormFieldV2DisplayFieldInput = {
  /** Header field */
  header?: InputMaybe<WixFormsV4FormFieldV2DisplayFieldHeaderInput>;
  /** Rich text field */
  richText?: InputMaybe<WixFormsV4FormFieldV2DisplayFieldRichTextInput>;
};

export type WixFormsV4FormFieldV2DisplayFieldRichText = {
  /** Content of the rich text field */
  content?: Maybe<WixRichContentV1RichContent>;
};

export type WixFormsV4FormFieldV2DisplayFieldRichTextInput = {
  /** Content of the rich text field */
  content?: InputMaybe<WixRichContentV1RichContentInput>;
};

export enum WixFormsV4FormFieldV2FieldType {
  DISPLAY = 'DISPLAY',
  INPUT = 'INPUT',
  SUBMIT = 'SUBMIT',
  UNKNOWN = 'UNKNOWN'
}

export type WixFormsV4FormFieldV2InputField = {
  /** Input return array as value */
  arrayOptions?: Maybe<WixFormsV4FormFieldV2InputFieldArray>;
  /** Input return boolean as value */
  booleanOptions?: Maybe<WixFormsV4FormFieldV2InputFieldBoolean>;
  /** Type of the input field */
  inputType?: Maybe<WixFormsV4FormFieldV2InputFieldInputType>;
  /** Input return number as value */
  numberOptions?: Maybe<WixFormsV4FormFieldV2InputFieldNumber>;
  /** Input return object as value */
  objectOptions?: Maybe<WixFormsV4FormFieldV2InputFieldObject>;
  /** Input returns selected products as value. */
  paymentOptions?: Maybe<WixFormsV4FormFieldV2InputFieldPayment>;
  /**
   * Mark the field as containing personal information. This will encrypt user data when storing it.
   * Default: false
   */
  pii?: Maybe<Scalars['Boolean']>;
  /**
   * Whether the field is required.
   * Default: false
   */
  required?: Maybe<Scalars['Boolean']>;
  /** Input return string as value */
  stringOptions?: Maybe<WixFormsV4FormFieldV2InputFieldString>;
  /** Definition of a target where the value of field belongs. */
  target?: Maybe<Scalars['String']>;
  /** Input return "Wix file" as value */
  wixFileOptions?: Maybe<WixFormsV4FormFieldV2InputFieldWixFile>;
};

export type WixFormsV4FormFieldV2InputFieldArray = {
  /** Checkbox group input field */
  checkboxGroupOptions?: Maybe<WixFormsV4FormFieldV2InputFieldArrayCheckboxGroup>;
  /** Component type of the array input field */
  componentType?: Maybe<WixFormsV4FormFieldV2InputFieldArrayComponentType>;
  /** Validation of array type. */
  validation?: Maybe<WixFormsV4FormFieldV2InputFieldArrayType>;
};

export type WixFormsV4FormFieldV2InputFieldArrayCheckboxGroup = {
  /** Option which can be specified by UoU, enabled when this object is specified. */
  customOption?: Maybe<WixFormsV4FormFieldV2InputFieldArrayCheckboxGroupCustomOption>;
  /** Description of the field */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Label of the field */
  label?: Maybe<Scalars['String']>;
  /** List of options to select from */
  options?: Maybe<Array<Maybe<WixFormsV4FormFieldV2InputFieldArrayCheckboxGroupOption>>>;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4FormFieldV2InputFieldArrayCheckboxGroupCustomOption = {
  /** Label of custom option input */
  label?: Maybe<Scalars['String']>;
  /** Placeholder of custom option input */
  placeholder?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldArrayCheckboxGroupCustomOptionInput = {
  /** Label of custom option input */
  label?: InputMaybe<Scalars['String']>;
  /** Placeholder of custom option input */
  placeholder?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldArrayCheckboxGroupInput = {
  /** Option which can be specified by UoU, enabled when this object is specified. */
  customOption?: InputMaybe<WixFormsV4FormFieldV2InputFieldArrayCheckboxGroupCustomOptionInput>;
  /** Description of the field */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Label of the field */
  label?: InputMaybe<Scalars['String']>;
  /** List of options to select from */
  options?: InputMaybe<Array<InputMaybe<WixFormsV4FormFieldV2InputFieldArrayCheckboxGroupOptionInput>>>;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4FormFieldV2InputFieldArrayCheckboxGroupOption = {
  /** Flag identifying that option should be selected by default */
  default?: Maybe<Scalars['Boolean']>;
  /** Option id. Used as binding for translations */
  id?: Maybe<Scalars['String']>;
  /** Selectable option label */
  label?: Maybe<Scalars['String']>;
  /** Media item. Media, associated with option, like image. */
  media?: Maybe<WixFormsV4FormFieldV2MediaItem>;
  /** Selectable option value, which is saved to DB. */
  value?: Maybe<Scalars['JSON']>;
};

export type WixFormsV4FormFieldV2InputFieldArrayCheckboxGroupOptionInput = {
  /** Flag identifying that option should be selected by default */
  default?: InputMaybe<Scalars['Boolean']>;
  /** Option id. Used as binding for translations */
  id?: InputMaybe<Scalars['String']>;
  /** Selectable option label */
  label?: InputMaybe<Scalars['String']>;
  /** Media item. Media, associated with option, like image. */
  media?: InputMaybe<WixFormsV4FormFieldV2MediaItemInput>;
  /** Selectable option value, which is saved to DB. */
  value?: InputMaybe<Scalars['JSON']>;
};

export enum WixFormsV4FormFieldV2InputFieldArrayComponentType {
  CHECKBOX_GROUP = 'CHECKBOX_GROUP',
  UNKNOWN = 'UNKNOWN'
}

export type WixFormsV4FormFieldV2InputFieldArrayErrorMessages = {
  /** Default error message on invalid validation. */
  default?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldArrayErrorMessagesInput = {
  /** Default error message on invalid validation. */
  default?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldArrayInput = {
  /** Checkbox group input field */
  checkboxGroupOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldArrayCheckboxGroupInput>;
  /** Component type of the array input field */
  componentType?: InputMaybe<WixFormsV4FormFieldV2InputFieldArrayComponentType>;
  /** Validation of array type. */
  validation?: InputMaybe<WixFormsV4FormFieldV2InputFieldArrayTypeInput>;
};

export type WixFormsV4FormFieldV2InputFieldArrayType = {
  /** Custom error message when validation fails. */
  errorMessages?: Maybe<WixFormsV4FormFieldV2InputFieldArrayErrorMessages>;
  /** Type of items allowed in array. */
  items?: Maybe<WixFormsV4FormFieldV2InputFieldArrayTypeArrayItems>;
  /** Maximum amount of array elements. */
  maxItems?: Maybe<Scalars['Int']>;
  /** Minimum amount of array elements. */
  minItems?: Maybe<Scalars['Int']>;
};

export type WixFormsV4FormFieldV2InputFieldArrayTypeArrayItems = {
  /** Boolean type validation for items. */
  booleanOptions?: Maybe<WixFormsV4FormFieldV2InputFieldBooleanType>;
  /** Integer type validation for items. */
  integerOptions?: Maybe<WixFormsV4FormFieldV2InputFieldIntegerType>;
  /** Type of array items */
  itemType?: Maybe<WixFormsV4FormFieldV2InputFieldArrayTypeArrayItemsItemType>;
  /** Number type validation for items. */
  numberOptions?: Maybe<WixFormsV4FormFieldV2InputFieldNumberType>;
  /** Object type validation for items */
  objectOptions?: Maybe<WixFormsV4FormFieldV2InputFieldObjectType>;
  /** String type validation for items. */
  stringOptions?: Maybe<WixFormsV4FormFieldV2InputFieldStringType>;
};

export type WixFormsV4FormFieldV2InputFieldArrayTypeArrayItemsInput = {
  /** Boolean type validation for items. */
  booleanOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldBooleanTypeInput>;
  /** Integer type validation for items. */
  integerOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldIntegerTypeInput>;
  /** Type of array items */
  itemType?: InputMaybe<WixFormsV4FormFieldV2InputFieldArrayTypeArrayItemsItemType>;
  /** Number type validation for items. */
  numberOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldNumberTypeInput>;
  /** Object type validation for items */
  objectOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldObjectTypeInput>;
  /** String type validation for items. */
  stringOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldStringTypeInput>;
};

export enum WixFormsV4FormFieldV2InputFieldArrayTypeArrayItemsItemType {
  BOOLEAN = 'BOOLEAN',
  INTEGER = 'INTEGER',
  NUMBER = 'NUMBER',
  OBJECT = 'OBJECT',
  STRING = 'STRING',
  UNKNOWN = 'UNKNOWN'
}

export type WixFormsV4FormFieldV2InputFieldArrayTypeInput = {
  /** Custom error message when validation fails. */
  errorMessages?: InputMaybe<WixFormsV4FormFieldV2InputFieldArrayErrorMessagesInput>;
  /** Type of items allowed in array. */
  items?: InputMaybe<WixFormsV4FormFieldV2InputFieldArrayTypeArrayItemsInput>;
  /** Maximum amount of array elements. */
  maxItems?: InputMaybe<Scalars['Int']>;
  /** Minimum amount of array elements. */
  minItems?: InputMaybe<Scalars['Int']>;
};

export type WixFormsV4FormFieldV2InputFieldBoolean = {
  /** Checkbox input field */
  checkboxOptions?: Maybe<WixFormsV4FormFieldV2InputFieldBooleanCheckbox>;
  /** Component type of the boolean input field */
  componentType?: Maybe<WixFormsV4FormFieldV2InputFieldBooleanComponentType>;
  /** Validation of field output value. */
  validation?: Maybe<WixFormsV4FormFieldV2InputFieldBooleanType>;
};

export type WixFormsV4FormFieldV2InputFieldBooleanCheckbox = {
  /** Label of the field */
  label?: Maybe<WixRichContentV1RichContent>;
};

export type WixFormsV4FormFieldV2InputFieldBooleanCheckboxInput = {
  /** Label of the field */
  label?: InputMaybe<WixRichContentV1RichContentInput>;
};

export enum WixFormsV4FormFieldV2InputFieldBooleanComponentType {
  CHECKBOX = 'CHECKBOX',
  UNKNOWN = 'UNKNOWN'
}

export type WixFormsV4FormFieldV2InputFieldBooleanErrorMessages = {
  /** Default error message on invalid validation. */
  default?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldBooleanErrorMessagesInput = {
  /** Default error message on invalid validation. */
  default?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldBooleanInput = {
  /** Checkbox input field */
  checkboxOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldBooleanCheckboxInput>;
  /** Component type of the boolean input field */
  componentType?: InputMaybe<WixFormsV4FormFieldV2InputFieldBooleanComponentType>;
  /** Validation of field output value. */
  validation?: InputMaybe<WixFormsV4FormFieldV2InputFieldBooleanTypeInput>;
};

export type WixFormsV4FormFieldV2InputFieldBooleanType = {
  /** List of allowed values. */
  enum?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  /** Custom error message when validation fails. */
  errorMessages?: Maybe<WixFormsV4FormFieldV2InputFieldBooleanErrorMessages>;
};

export type WixFormsV4FormFieldV2InputFieldBooleanTypeInput = {
  /** List of allowed values. */
  enum?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  /** Custom error message when validation fails. */
  errorMessages?: InputMaybe<WixFormsV4FormFieldV2InputFieldBooleanErrorMessagesInput>;
};

export type WixFormsV4FormFieldV2InputFieldInput = {
  /** Input return array as value */
  arrayOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldArrayInput>;
  /** Input return boolean as value */
  booleanOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldBooleanInput>;
  /** Type of the input field */
  inputType?: InputMaybe<WixFormsV4FormFieldV2InputFieldInputType>;
  /** Input return number as value */
  numberOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldNumberInput>;
  /** Input return object as value */
  objectOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldObjectInput>;
  /** Input returns selected products as value. */
  paymentOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldPaymentInput>;
  /**
   * Mark the field as containing personal information. This will encrypt user data when storing it.
   * Default: false
   */
  pii?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether the field is required.
   * Default: false
   */
  required?: InputMaybe<Scalars['Boolean']>;
  /** Input return string as value */
  stringOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldStringInput>;
  /** Definition of a target where the value of field belongs. */
  target?: InputMaybe<Scalars['String']>;
  /** Input return "Wix file" as value */
  wixFileOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldWixFileInput>;
};

export enum WixFormsV4FormFieldV2InputFieldInputType {
  ARRAY = 'ARRAY',
  BOOLEAN = 'BOOLEAN',
  NUMBER = 'NUMBER',
  OBJECT = 'OBJECT',
  PAYMENT = 'PAYMENT',
  STRING = 'STRING',
  UNKNOWN = 'UNKNOWN',
  WIX_FILE = 'WIX_FILE'
}

export type WixFormsV4FormFieldV2InputFieldIntegerType = {
  /** List of allowed values. */
  enum?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Custom error message when validation fails. */
  errorMessages?: Maybe<WixFormsV4FormFieldV2InputFieldNumberErrorMessages>;
  /** Maximum value. */
  maximum?: Maybe<Scalars['Int']>;
  /** Minimum value. */
  minimum?: Maybe<Scalars['Int']>;
  /** Multiple of value. */
  multipleOf?: Maybe<Scalars['Int']>;
};

export type WixFormsV4FormFieldV2InputFieldIntegerTypeInput = {
  /** List of allowed values. */
  enum?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Custom error message when validation fails. */
  errorMessages?: InputMaybe<WixFormsV4FormFieldV2InputFieldNumberErrorMessagesInput>;
  /** Maximum value. */
  maximum?: InputMaybe<Scalars['Int']>;
  /** Minimum value. */
  minimum?: InputMaybe<Scalars['Int']>;
  /** Multiple of value. */
  multipleOf?: InputMaybe<Scalars['Int']>;
};

export type WixFormsV4FormFieldV2InputFieldNumber = {
  /** Component type of the number input field */
  componentType?: Maybe<WixFormsV4FormFieldV2InputFieldNumberComponentType>;
  /** Number value input field */
  numberInputOptions?: Maybe<WixFormsV4FormFieldV2InputFieldNumberNumberInput>;
  /** Validation of field output value. */
  validation?: Maybe<WixFormsV4FormFieldV2InputFieldNumberType>;
};

export enum WixFormsV4FormFieldV2InputFieldNumberComponentType {
  NUMBER_INPUT = 'NUMBER_INPUT',
  UNKNOWN = 'UNKNOWN'
}

export type WixFormsV4FormFieldV2InputFieldNumberErrorMessages = {
  /** Default error message on invalid validation. */
  default?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldNumberErrorMessagesInput = {
  /** Default error message on invalid validation. */
  default?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldNumberInput = {
  /** Component type of the number input field */
  componentType?: InputMaybe<WixFormsV4FormFieldV2InputFieldNumberComponentType>;
  /** Number value input field */
  numberInputOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldNumberNumberInputInput>;
  /** Validation of field output value. */
  validation?: InputMaybe<WixFormsV4FormFieldV2InputFieldNumberTypeInput>;
};

export type WixFormsV4FormFieldV2InputFieldNumberNumberInput = {
  /** Description of the field */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Label of the field */
  label?: Maybe<Scalars['String']>;
  /** Placeholder for the value input */
  placeholder?: Maybe<Scalars['String']>;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4FormFieldV2InputFieldNumberNumberInputInput = {
  /** Description of the field */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Label of the field */
  label?: InputMaybe<Scalars['String']>;
  /** Placeholder for the value input */
  placeholder?: InputMaybe<Scalars['String']>;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4FormFieldV2InputFieldNumberType = {
  /** List of allowed values. */
  enum?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** Custom error message when validation fails. */
  errorMessages?: Maybe<WixFormsV4FormFieldV2InputFieldNumberErrorMessages>;
  /** Inclusive maximum value. */
  maximum?: Maybe<Scalars['Float']>;
  /** Inclusive minimum value. */
  minimum?: Maybe<Scalars['Float']>;
  /** Multiple of value. */
  multipleOf?: Maybe<Scalars['Float']>;
};

export type WixFormsV4FormFieldV2InputFieldNumberTypeInput = {
  /** List of allowed values. */
  enum?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** Custom error message when validation fails. */
  errorMessages?: InputMaybe<WixFormsV4FormFieldV2InputFieldNumberErrorMessagesInput>;
  /** Inclusive maximum value. */
  maximum?: InputMaybe<Scalars['Float']>;
  /** Inclusive minimum value. */
  minimum?: InputMaybe<Scalars['Float']>;
  /** Multiple of value. */
  multipleOf?: InputMaybe<Scalars['Float']>;
};

export type WixFormsV4FormFieldV2InputFieldObject = {
  /** Nested form ID. */
  nestedFormId?: Maybe<Scalars['String']>;
  /** Validation of object type. */
  object?: Maybe<WixFormsV4FormFieldV2InputFieldObjectType>;
};

export type WixFormsV4FormFieldV2InputFieldObjectErrorMessages = {
  /** Default error message on invalid validation. */
  default?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldObjectErrorMessagesInput = {
  /** Default error message on invalid validation. */
  default?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldObjectInput = {
  /** Nested form ID. */
  nestedFormId?: InputMaybe<Scalars['String']>;
  /** Validation of object type. */
  object?: InputMaybe<WixFormsV4FormFieldV2InputFieldObjectTypeInput>;
};

export type WixFormsV4FormFieldV2InputFieldObjectType = {
  /** Custom error message when validation fails. */
  errorMessages?: Maybe<WixFormsV4FormFieldV2InputFieldObjectErrorMessages>;
  /** Description of object properties. */
  properties?: Maybe<WixFormsV4FormFieldV2InputFieldObjectTypePropertiesType>;
};

export type WixFormsV4FormFieldV2InputFieldObjectTypeInput = {
  /** Custom error message when validation fails. */
  errorMessages?: InputMaybe<WixFormsV4FormFieldV2InputFieldObjectErrorMessagesInput>;
  /** Description of object properties. */
  properties?: InputMaybe<WixFormsV4FormFieldV2InputFieldObjectTypePropertiesTypeInput>;
};

export type WixFormsV4FormFieldV2InputFieldObjectTypePropertiesType = {
  /** Array type validation for property. */
  arrayOptions?: Maybe<WixFormsV4FormFieldV2InputFieldArrayType>;
  /** Boolean type validation for property. */
  booleanOptions?: Maybe<WixFormsV4FormFieldV2InputFieldBooleanType>;
  /** Integer type validation for property. */
  integerOptions?: Maybe<WixFormsV4FormFieldV2InputFieldIntegerType>;
  /** Number type validation for property. */
  numberOptions?: Maybe<WixFormsV4FormFieldV2InputFieldNumberType>;
  /** Type of object properties */
  propertiesType?: Maybe<WixFormsV4FormFieldV2InputFieldObjectTypePropertiesTypePropertiesType>;
  /** Whether the property is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** String type validation for property. */
  stringOptions?: Maybe<WixFormsV4FormFieldV2InputFieldStringType>;
};

export type WixFormsV4FormFieldV2InputFieldObjectTypePropertiesTypeInput = {
  /** Array type validation for property. */
  arrayOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldArrayTypeInput>;
  /** Boolean type validation for property. */
  booleanOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldBooleanTypeInput>;
  /** Integer type validation for property. */
  integerOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldIntegerTypeInput>;
  /** Number type validation for property. */
  numberOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldNumberTypeInput>;
  /** Type of object properties */
  propertiesType?: InputMaybe<WixFormsV4FormFieldV2InputFieldObjectTypePropertiesTypePropertiesType>;
  /** Whether the property is required. */
  required?: InputMaybe<Scalars['Boolean']>;
  /** String type validation for property. */
  stringOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldStringTypeInput>;
};

export enum WixFormsV4FormFieldV2InputFieldObjectTypePropertiesTypePropertiesType {
  ARRAY = 'ARRAY',
  BOOLEAN = 'BOOLEAN',
  INTEGER = 'INTEGER',
  NUMBER = 'NUMBER',
  STRING = 'STRING',
  UNKNOWN = 'UNKNOWN'
}

export type WixFormsV4FormFieldV2InputFieldPayment = {
  /** Checkbox group input field. */
  checkboxGroupOptions?: Maybe<WixFormsV4FormFieldV2InputFieldPaymentCheckboxGroup>;
  /** Component type of the payment input field. */
  componentType?: Maybe<WixFormsV4FormFieldV2InputFieldPaymentComponentType>;
  /** Validation of payment type. */
  validation?: Maybe<WixFormsV4PaymentType>;
};

export type WixFormsV4FormFieldV2InputFieldPaymentCheckboxGroup = {
  /** Description of the field. */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Label of the field. */
  label?: Maybe<Scalars['String']>;
  /** List of options to select from. */
  options?: Maybe<Array<Maybe<WixFormsV4FormFieldV2InputFieldPaymentCheckboxGroupOption>>>;
};

export type WixFormsV4FormFieldV2InputFieldPaymentCheckboxGroupInput = {
  /** Description of the field. */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Label of the field. */
  label?: InputMaybe<Scalars['String']>;
  /** List of options to select from. */
  options?: InputMaybe<Array<InputMaybe<WixFormsV4FormFieldV2InputFieldPaymentCheckboxGroupOptionInput>>>;
};

export type WixFormsV4FormFieldV2InputFieldPaymentCheckboxGroupOption = {
  /** Option id. Used as binding for translations. */
  id?: Maybe<Scalars['String']>;
  /** Selectable option label. */
  label?: Maybe<Scalars['String']>;
  /** Media item. Media, associated with option, like image. */
  media?: Maybe<WixFormsV4FormFieldV2MediaItem>;
  /** Selectable option value, which is saved to DB. Corresponds to product id, found in field's products list. */
  value?: Maybe<Scalars['JSON']>;
};

export type WixFormsV4FormFieldV2InputFieldPaymentCheckboxGroupOptionInput = {
  /** Option id. Used as binding for translations. */
  id?: InputMaybe<Scalars['String']>;
  /** Selectable option label. */
  label?: InputMaybe<Scalars['String']>;
  /** Media item. Media, associated with option, like image. */
  media?: InputMaybe<WixFormsV4FormFieldV2MediaItemInput>;
  /** Selectable option value, which is saved to DB. Corresponds to product id, found in field's products list. */
  value?: InputMaybe<Scalars['JSON']>;
};

export enum WixFormsV4FormFieldV2InputFieldPaymentComponentType {
  CHECKBOX_GROUP = 'CHECKBOX_GROUP',
  UNKNOWN = 'UNKNOWN'
}

export type WixFormsV4FormFieldV2InputFieldPaymentInput = {
  /** Checkbox group input field. */
  checkboxGroupOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldPaymentCheckboxGroupInput>;
  /** Component type of the payment input field. */
  componentType?: InputMaybe<WixFormsV4FormFieldV2InputFieldPaymentComponentType>;
  /** Validation of payment type. */
  validation?: InputMaybe<WixFormsV4PaymentTypeInput>;
};

export type WixFormsV4FormFieldV2InputFieldString = {
  /** Component type of the string input field */
  componentType?: Maybe<WixFormsV4FormFieldV2InputFieldStringComponentType>;
  /** Selection field as drop down */
  dropdownOptions?: Maybe<WixFormsV4FormFieldV2InputFieldStringDropdown>;
  /** Selection field as radio group */
  radioGroupOptions?: Maybe<WixFormsV4FormFieldV2InputFieldStringRadioGroup>;
  /** Text input field */
  textInputOptions?: Maybe<WixFormsV4FormFieldV2InputFieldStringTextInput>;
  /** Validation of field output value. */
  validation?: Maybe<WixFormsV4FormFieldV2InputFieldStringType>;
};

export enum WixFormsV4FormFieldV2InputFieldStringComponentType {
  DROPDOWN = 'DROPDOWN',
  RADIO_GROUP = 'RADIO_GROUP',
  TEXT_INPUT = 'TEXT_INPUT',
  UNKNOWN = 'UNKNOWN'
}

export type WixFormsV4FormFieldV2InputFieldStringDropDownCustomOption = {
  /** Label of custom option input */
  label?: Maybe<Scalars['String']>;
  /** Placeholder of custom option input */
  placeholder?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldStringDropDownCustomOptionInput = {
  /** Label of custom option input */
  label?: InputMaybe<Scalars['String']>;
  /** Placeholder of custom option input */
  placeholder?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldStringDropDownOption = {
  /** Flag identifying that option should be selected by default */
  default?: Maybe<Scalars['Boolean']>;
  /** Selectable option label */
  label?: Maybe<Scalars['String']>;
  /** Selectable option value, which is saved to DB. */
  value?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldStringDropDownOptionInput = {
  /** Flag identifying that option should be selected by default */
  default?: InputMaybe<Scalars['Boolean']>;
  /** Selectable option label */
  label?: InputMaybe<Scalars['String']>;
  /** Selectable option value, which is saved to DB. */
  value?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldStringDropdown = {
  /** Option which can be specified by UoU, enabled when this object is specified. */
  customOption?: Maybe<WixFormsV4FormFieldV2InputFieldStringDropdownCustomOption>;
  /** Description of the field */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Label of the field */
  label?: Maybe<Scalars['String']>;
  /** List of options to select from */
  options?: Maybe<Array<Maybe<WixFormsV4FormFieldV2InputFieldStringDropdownOption>>>;
  /** Placeholder of dropdown input */
  placeholder?: Maybe<Scalars['String']>;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4FormFieldV2InputFieldStringDropdownCustomOption = {
  /** Label of custom option input */
  label?: Maybe<Scalars['String']>;
  /** Placeholder of custom option input */
  placeholder?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldStringDropdownCustomOptionInput = {
  /** Label of custom option input */
  label?: InputMaybe<Scalars['String']>;
  /** Placeholder of custom option input */
  placeholder?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldStringDropdownInput = {
  /** Option which can be specified by UoU, enabled when this object is specified. */
  customOption?: InputMaybe<WixFormsV4FormFieldV2InputFieldStringDropdownCustomOptionInput>;
  /** Description of the field */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Label of the field */
  label?: InputMaybe<Scalars['String']>;
  /** List of options to select from */
  options?: InputMaybe<Array<InputMaybe<WixFormsV4FormFieldV2InputFieldStringDropdownOptionInput>>>;
  /** Placeholder of dropdown input */
  placeholder?: InputMaybe<Scalars['String']>;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4FormFieldV2InputFieldStringDropdownOption = {
  /** Flag identifying that option should be selected by default */
  default?: Maybe<Scalars['Boolean']>;
  /** Option id. Used as binding for translations */
  id?: Maybe<Scalars['String']>;
  /** Selectable option label */
  label?: Maybe<Scalars['String']>;
  /** Selectable option value, which is saved to DB. */
  value?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldStringDropdownOptionInput = {
  /** Flag identifying that option should be selected by default */
  default?: InputMaybe<Scalars['Boolean']>;
  /** Option id. Used as binding for translations */
  id?: InputMaybe<Scalars['String']>;
  /** Selectable option label */
  label?: InputMaybe<Scalars['String']>;
  /** Selectable option value, which is saved to DB. */
  value?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldStringErrorMessages = {
  /** Default error message on invalid validation. */
  default?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldStringErrorMessagesInput = {
  /** Default error message on invalid validation. */
  default?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldStringInput = {
  /** Component type of the string input field */
  componentType?: InputMaybe<WixFormsV4FormFieldV2InputFieldStringComponentType>;
  /** Selection field as drop down */
  dropdownOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldStringDropdownInput>;
  /** Selection field as radio group */
  radioGroupOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldStringRadioGroupInput>;
  /** Text input field */
  textInputOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldStringTextInputInput>;
  /** Validation of field output value. */
  validation?: InputMaybe<WixFormsV4FormFieldV2InputFieldStringTypeInput>;
};

export type WixFormsV4FormFieldV2InputFieldStringRadioGroup = {
  /** Option which can be specified by UoU, enabled when this object is specified. */
  customOption?: Maybe<WixFormsV4FormFieldV2InputFieldStringRadioGroupCustomOption>;
  /** Description of the field */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Label of the field */
  label?: Maybe<Scalars['String']>;
  /**
   * Flag identifying to show option allowing input custom value
   * List of options to select from
   */
  options?: Maybe<Array<Maybe<WixFormsV4FormFieldV2InputFieldStringRadioGroupOption>>>;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4FormFieldV2InputFieldStringRadioGroupCustomOption = {
  /** Label of custom option input */
  label?: Maybe<Scalars['String']>;
  /** Placeholder of custom option input */
  placeholder?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldStringRadioGroupCustomOptionInput = {
  /** Label of custom option input */
  label?: InputMaybe<Scalars['String']>;
  /** Placeholder of custom option input */
  placeholder?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldStringRadioGroupInput = {
  /** Option which can be specified by UoU, enabled when this object is specified. */
  customOption?: InputMaybe<WixFormsV4FormFieldV2InputFieldStringRadioGroupCustomOptionInput>;
  /** Description of the field */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Label of the field */
  label?: InputMaybe<Scalars['String']>;
  /**
   * Flag identifying to show option allowing input custom value
   * List of options to select from
   */
  options?: InputMaybe<Array<InputMaybe<WixFormsV4FormFieldV2InputFieldStringRadioGroupOptionInput>>>;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4FormFieldV2InputFieldStringRadioGroupOption = {
  /** Flag identifying that option should be selected by default */
  default?: Maybe<Scalars['Boolean']>;
  /** Option id. Used as binding for translations */
  id?: Maybe<Scalars['String']>;
  /** Selectable option label */
  label?: Maybe<Scalars['String']>;
  /** Selectable option value, which is saved to DB. */
  value?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldStringRadioGroupOptionInput = {
  /** Flag identifying that option should be selected by default */
  default?: InputMaybe<Scalars['Boolean']>;
  /** Option id. Used as binding for translations */
  id?: InputMaybe<Scalars['String']>;
  /** Selectable option label */
  label?: InputMaybe<Scalars['String']>;
  /** Selectable option value, which is saved to DB. */
  value?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldStringTextInput = {
  /** Description of the field */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Label of the field */
  label?: Maybe<Scalars['String']>;
  /** Placeholder for the value input */
  placeholder?: Maybe<Scalars['String']>;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4FormFieldV2InputFieldStringTextInputInput = {
  /** Description of the field */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Label of the field */
  label?: InputMaybe<Scalars['String']>;
  /** Placeholder for the value input */
  placeholder?: InputMaybe<Scalars['String']>;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4FormFieldV2InputFieldStringType = {
  /** List of allowed values. */
  enum?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Custom error messages when validation fails. */
  errorMessages?: Maybe<WixFormsV4FormFieldV2InputFieldStringErrorMessages>;
  /** Format of a string. */
  format?: Maybe<WixFormsV4FormFieldV2InputFieldStringTypeFormatEnumFormat>;
  /** Maximum length. */
  maxLength?: Maybe<Scalars['Int']>;
  /** Minimum length. */
  minLength?: Maybe<Scalars['Int']>;
  /** Pattern for a regular expression match. */
  pattern?: Maybe<Scalars['String']>;
};

export enum WixFormsV4FormFieldV2InputFieldStringTypeFormatEnumFormat {
  COLOR_HEX = 'COLOR_HEX',
  CURRENCY = 'CURRENCY',
  DATE = 'DATE',
  DATE_OPTIONAL_TIME = 'DATE_OPTIONAL_TIME',
  DATE_TIME = 'DATE_TIME',
  EMAIL = 'EMAIL',
  HOSTNAME = 'HOSTNAME',
  LANGUAGE = 'LANGUAGE',
  PHONE = 'PHONE',
  TIME = 'TIME',
  UNDEFINED = 'UNDEFINED',
  URI = 'URI',
  URL = 'URL',
  UUID = 'UUID'
}

export type WixFormsV4FormFieldV2InputFieldStringTypeInput = {
  /** List of allowed values. */
  enum?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Custom error messages when validation fails. */
  errorMessages?: InputMaybe<WixFormsV4FormFieldV2InputFieldStringErrorMessagesInput>;
  /** Format of a string. */
  format?: InputMaybe<WixFormsV4FormFieldV2InputFieldStringTypeFormatEnumFormat>;
  /** Maximum length. */
  maxLength?: InputMaybe<Scalars['Int']>;
  /** Minimum length. */
  minLength?: InputMaybe<Scalars['Int']>;
  /** Pattern for a regular expression match. */
  pattern?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2InputFieldWixFile = {
  /** Component type of the array input field */
  componentType?: Maybe<WixFormsV4FormFieldV2InputFieldWixFileComponentType>;
  /** File upload input field */
  fileUploadOptions?: Maybe<WixFormsV4FormFieldV2InputFieldWixFileFileUpload>;
};

export enum WixFormsV4FormFieldV2InputFieldWixFileComponentType {
  FILE_UPLOAD = 'FILE_UPLOAD',
  UNKNOWN = 'UNKNOWN'
}

export type WixFormsV4FormFieldV2InputFieldWixFileFileUpload = {
  /** Text on upload button */
  buttonText?: Maybe<Scalars['String']>;
  /** Description of the field */
  description?: Maybe<WixRichContentV1RichContent>;
  /** Custom text which appears when file is uploaded, if missing file name will be shown */
  explanationText?: Maybe<Scalars['String']>;
  /** Amount of files allowed to upload */
  fileLimit?: Maybe<Scalars['Int']>;
  /** Selectable option label */
  label?: Maybe<Scalars['String']>;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: Maybe<Scalars['Boolean']>;
  /** Supported file formats for upload */
  uploadFileFormats?: Maybe<Array<Maybe<WixFormsV4FormFieldV2InputFieldWixFileFileUploadUploadFileFormatEnumUploadFileFormat>>>;
};

export type WixFormsV4FormFieldV2InputFieldWixFileFileUploadInput = {
  /** Text on upload button */
  buttonText?: InputMaybe<Scalars['String']>;
  /** Description of the field */
  description?: InputMaybe<WixRichContentV1RichContentInput>;
  /** Custom text which appears when file is uploaded, if missing file name will be shown */
  explanationText?: InputMaybe<Scalars['String']>;
  /** Amount of files allowed to upload */
  fileLimit?: InputMaybe<Scalars['Int']>;
  /** Selectable option label */
  label?: InputMaybe<Scalars['String']>;
  /**
   * Flag identifying to hide or not label
   * Default: true
   */
  showLabel?: InputMaybe<Scalars['Boolean']>;
  /** Supported file formats for upload */
  uploadFileFormats?: InputMaybe<Array<InputMaybe<WixFormsV4FormFieldV2InputFieldWixFileFileUploadUploadFileFormatEnumUploadFileFormat>>>;
};

export enum WixFormsV4FormFieldV2InputFieldWixFileFileUploadUploadFileFormatEnumUploadFileFormat {
  /** Audio files */
  AUDIO = 'AUDIO',
  /** Document files */
  DOCUMENT = 'DOCUMENT',
  /** Image files */
  IMAGE = 'IMAGE',
  UNDEFINED = 'UNDEFINED',
  /** Video files */
  VIDEO = 'VIDEO'
}

export type WixFormsV4FormFieldV2InputFieldWixFileInput = {
  /** Component type of the array input field */
  componentType?: InputMaybe<WixFormsV4FormFieldV2InputFieldWixFileComponentType>;
  /** File upload input field */
  fileUploadOptions?: InputMaybe<WixFormsV4FormFieldV2InputFieldWixFileFileUploadInput>;
};

export type WixFormsV4FormFieldV2MediaItem = {
  /** WixMedia image. */
  image?: Maybe<ComWixFormsUpstreamWixCommonImage>;
};

export type WixFormsV4FormFieldV2MediaItemInput = {
  /** WixMedia image. */
  image?: InputMaybe<ComWixFormsUpstreamWixCommonImageInput>;
};

export type WixFormsV4FormFieldV2SubmitButton = {
  /** When button is not on last page it behaves as switch between pages page, text of label to go to next page. */
  nextText?: Maybe<Scalars['String']>;
  /** When button is not on last page it behaves as switch between pages page, text of label to go to previous page. */
  previousText?: Maybe<Scalars['String']>;
  /** Submit action effect is to redirect to */
  redirect?: Maybe<WixFormsV4FormFieldV2SubmitButtonRedirect>;
  /** Text on the button when button is submitting a form */
  submitText?: Maybe<Scalars['String']>;
  /** Submit action effect is to show message */
  thankYouMessage?: Maybe<WixFormsV4FormFieldV2SubmitButtonThankYouMessage>;
};

export enum WixFormsV4FormFieldV2SubmitButtonExternalUrlExternalUrlTargetEnumExternalUrlTarget {
  /** Url open in new tab */
  BLANK = 'BLANK',
  /** Opened in same browser tab */
  SELF = 'SELF',
  UNDEFINED = 'UNDEFINED'
}

export type WixFormsV4FormFieldV2SubmitButtonInput = {
  /** When button is not on last page it behaves as switch between pages page, text of label to go to next page. */
  nextText?: InputMaybe<Scalars['String']>;
  /** When button is not on last page it behaves as switch between pages page, text of label to go to previous page. */
  previousText?: InputMaybe<Scalars['String']>;
  /** Submit action effect is to redirect to */
  redirect?: InputMaybe<WixFormsV4FormFieldV2SubmitButtonRedirectInput>;
  /** Text on the button when button is submitting a form */
  submitText?: InputMaybe<Scalars['String']>;
  /** Submit action effect is to show message */
  thankYouMessage?: InputMaybe<WixFormsV4FormFieldV2SubmitButtonThankYouMessageInput>;
};

export type WixFormsV4FormFieldV2SubmitButtonRedirect = {
  /** How should url be opened */
  target?: Maybe<WixFormsV4FormFieldV2SubmitButtonRedirectTargetEnumTarget>;
  /** Url to which UoU should be redirected after successful submit of form */
  url?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFieldV2SubmitButtonRedirectInput = {
  /** How should url be opened */
  target?: InputMaybe<WixFormsV4FormFieldV2SubmitButtonRedirectTargetEnumTarget>;
  /** Url to which UoU should be redirected after successful submit of form */
  url?: InputMaybe<Scalars['String']>;
};

export enum WixFormsV4FormFieldV2SubmitButtonRedirectTargetEnumTarget {
  /** Url open in new tab */
  BLANK = 'BLANK',
  /** Opened in same browser tab */
  SELF = 'SELF',
  UNDEFINED = 'UNDEFINED'
}

export type WixFormsV4FormFieldV2SubmitButtonThankYouMessage = {
  /**
   * Duration after how much second it should disappear. If 0, will stay forever.
   * Default: false
   */
  duration?: Maybe<Scalars['Int']>;
  /** Message show after form submission */
  text?: Maybe<WixRichContentV1RichContent>;
};

export type WixFormsV4FormFieldV2SubmitButtonThankYouMessageInput = {
  /**
   * Duration after how much second it should disappear. If 0, will stay forever.
   * Default: false
   */
  duration?: InputMaybe<Scalars['Int']>;
  /** Message show after form submission */
  text?: InputMaybe<WixRichContentV1RichContentInput>;
};

export type WixFormsV4FormFieldValidation = {
  /** Validation of array type. */
  array?: Maybe<WixFormsV4FormFieldArrayType>;
  /** Validation of boolean type. */
  boolean?: Maybe<WixFormsV4FormFieldBooleanType>;
  /** Validation of integer type. */
  integer?: Maybe<WixFormsV4FormFieldIntegerType>;
  /** Validation of number type. */
  number?: Maybe<WixFormsV4FormFieldNumberType>;
  /** Validation of object type. */
  object?: Maybe<WixFormsV4FormFieldObjectType>;
  /** Predefined validation of specific format */
  predefined?: Maybe<WixFormsV4FormFieldPredefinedValidation>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** Validation of string type. */
  string?: Maybe<WixFormsV4FormFieldStringType>;
};

export type WixFormsV4FormFieldValidationInput = {
  /** Validation of array type. */
  array?: InputMaybe<WixFormsV4FormFieldArrayTypeInput>;
  /** Validation of boolean type. */
  boolean?: InputMaybe<WixFormsV4FormFieldBooleanTypeInput>;
  /** Validation of integer type. */
  integer?: InputMaybe<WixFormsV4FormFieldIntegerTypeInput>;
  /** Validation of number type. */
  number?: InputMaybe<WixFormsV4FormFieldNumberTypeInput>;
  /** Validation of object type. */
  object?: InputMaybe<WixFormsV4FormFieldObjectTypeInput>;
  /** Predefined validation of specific format */
  predefined?: InputMaybe<WixFormsV4FormFieldPredefinedValidationInput>;
  /** Whether the field is required. */
  required?: InputMaybe<Scalars['Boolean']>;
  /** Validation of string type. */
  string?: InputMaybe<WixFormsV4FormFieldStringTypeInput>;
};

export enum WixFormsV4FormFieldsetFieldset {
  /** Include nested form fields in the response. */
  NESTED_FORMS = 'NESTED_FORMS',
  UNKNOWN = 'UNKNOWN'
}

export type WixFormsV4FormFormProperties = {
  /**
   * Identifies if the form is disabled.
   * @deprecated Identifies if the form is disabled. Replaced by: wix.forms.v4.Form.enabled. Removal date: 2026-01-06.
   */
  disabled?: Maybe<Scalars['Boolean']>;
  /** Form name. */
  name?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormFormPropertiesInput = {
  /** Form name. */
  name?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4FormInput = {
  /** Date and time when the form schema was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Fields which were soft deleted. */
  deletedFields?: InputMaybe<Array<InputMaybe<WixFormsV4FormFieldInput>>>;
  /** Form fields that were soft deleted. */
  deletedFormFields?: InputMaybe<Array<InputMaybe<WixFormsV4FieldsFieldInput>>>;
  /**
   * Message displayed to visitors when the form is disabled.
   * This allows you to inform submitters why the form isn't available.
   */
  disabledFormMessage?: InputMaybe<WixRichContentV1RichContentInput>;
  /**
   * Whether the form schema is enabled.
   *
   * Default: `true`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Data extensions for storing additional custom properties. */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** Configuration for field groups. */
  fieldGroups?: InputMaybe<Array<InputMaybe<WixFormsV4FieldGroupInput>>>;
  /** List of form fields that represent input elements. */
  fields?: InputMaybe<Array<InputMaybe<WixFormsV4FormFieldInput>>>;
  /** Form fields that define the input elements and their validation rules. */
  formFields?: InputMaybe<Array<InputMaybe<WixFormsV4FieldsFieldInput>>>;
  /**
   * Business logic rules that can modify form behavior based on user input or other conditions.
   * These rules can show/hide fields, change validation, or trigger actions.
   */
  formRules?: InputMaybe<Array<InputMaybe<WixFormsV4RulesRuleInput>>>;
  /** Form schema ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Regular forms can be freely modified.
   * Extensions are copied from templates and might have restrictions.
   */
  kind?: InputMaybe<WixFormsV4FormKindKind>;
  /** Submission limits that can automatically disable the form when reached. */
  limitationRule?: InputMaybe<WixFormsV4FormLimitationRuleInput>;
  /** Media folder ID for storing uploaded files from form submissions. */
  mediaFolderId?: InputMaybe<Scalars['String']>;
  /** Display name of the form schema. */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Unique identifier for the app that owns this form schema.
   * For example, `wix.form_app.form` for Wix Forms.
   *
   * See a list of namespaces for [apps made by Wix](https://dev.wix.com/docs/api-reference/crm/forms/form-schemas/introduction#namespaces-of-apps-made-by-wix) section.
   */
  namespace?: InputMaybe<Scalars['String']>;
  /** Nested forms. */
  nestedForms?: InputMaybe<Array<InputMaybe<WixFormsV4FormNestedFormInput>>>;
  /**
   * Defines triggers that will be executed after the submission, for the submissions based on this schema.
   * Forms provide a set of predefined triggers that allow it to assign specific business cases to created forms.
   */
  postSubmissionTriggers?: InputMaybe<WixFormsV4PostSubmissionTriggersInput>;
  /** Properties of the form. */
  properties?: InputMaybe<WixFormsV4FormFormPropertiesInput>;
  /** Configuration for how required field indicators are displayed to the submitter. */
  requiredIndicatorProperties?: InputMaybe<WixFormsV4RequiredIndicatorPropertiesInput>;
  /**
   * Revision number, which increments by 1 each time the form schema is updated.
   * To prevent conflicting changes, the current revision must be passed when updating the form schema.
   */
  revision?: InputMaybe<Scalars['Long']>;
  /** ID of the source form. */
  sourceFormId?: InputMaybe<Scalars['String']>;
  /**
   * Level of spam protection applied to form submissions.
   *
   * Default: `ADVANCED`
   */
  spamFilterProtectionLevel?: InputMaybe<WixFormsV4FormSpamFilterProtectionLevel>;
  /**
   * Layout configuration that defines how form fields are organized across multiple steps.
   * Each step represents a page of the form.
   */
  steps?: InputMaybe<Array<InputMaybe<WixFormsV4StepInput>>>;
  /** Configuration for actions taken after a form is successfully submitted. */
  submitSettings?: InputMaybe<WixFormsV4SubmitSettingsInput>;
  /** Tag IDs collections associated with the current entity. */
  tags?: InputMaybe<ComWixFormsUpstreamWixCommonPublicTagsInput>;
  /** Date and time when the form schema was last updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export enum WixFormsV4FormKindKind {
  /** Return forms based on common templates, with applied user overrides if they exist. */
  EXTENSION = 'EXTENSION',
  /** Return forms specific to tenant, excluding template based forms. */
  REGULAR = 'REGULAR'
}

export type WixFormsV4FormLayout = {
  /** Layout configuration for large screen breakpoints (desktop). */
  large?: Maybe<WixFormsV4BreakPoint>;
  /** Layout configuration for medium screen breakpoints (tablet). */
  medium?: Maybe<WixFormsV4BreakPoint>;
  /** Layout configuration for small screen breakpoints (mobile). */
  small?: Maybe<WixFormsV4BreakPoint>;
};

export type WixFormsV4FormLayoutInput = {
  /** Layout configuration for large screen breakpoints (desktop). */
  large?: InputMaybe<WixFormsV4BreakPointInput>;
  /** Layout configuration for medium screen breakpoints (tablet). */
  medium?: InputMaybe<WixFormsV4BreakPointInput>;
  /** Layout configuration for small screen breakpoints (mobile). */
  small?: InputMaybe<WixFormsV4BreakPointInput>;
};

export type WixFormsV4FormLimitationRule = {
  /** Limitation by submission date, disables form when a set date and time is reached. */
  dateTimeDeadline?: Maybe<Scalars['String']>;
  /** Limitation by submission count, disables form when a set amount of submissions is reached. */
  maxAllowedSubmissions?: Maybe<Scalars['Int']>;
};

export type WixFormsV4FormLimitationRuleInput = {
  /** Limitation by submission date, disables form when a set date and time is reached. */
  dateTimeDeadline?: InputMaybe<Scalars['String']>;
  /** Limitation by submission count, disables form when a set amount of submissions is reached. */
  maxAllowedSubmissions?: InputMaybe<Scalars['Int']>;
};

export type WixFormsV4FormNestedForm = {
  /** Nested form. */
  form?: Maybe<WixFormsV4Form>;
  /** Targets which have this form. */
  targets?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type WixFormsV4FormNestedFormInput = {
  /** Nested form. */
  form?: InputMaybe<WixFormsV4FormInput>;
  /** Targets which have this form. */
  targets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixFormsV4FormRule = {
  /** Condition that determines when this rule's overrides should be applied. */
  condition?: Maybe<Scalars['JSON']>;
  /** Rule ID. */
  id?: Maybe<Scalars['String']>;
  /** Name for the rule. */
  name?: Maybe<Scalars['String']>;
  /** Namespace rules are part of business logic of app owning namespace, have limited editing possibilities */
  namespaceRule?: Maybe<Scalars['Boolean']>;
  /** Changes to apply to form elements when the condition evaluates to true. */
  overrides?: Maybe<Array<Maybe<WixFormsV4FormRuleFormOverride>>>;
};

export type WixFormsV4FormRuleFormOverride = {
  /**
   * ID of the form element to modify.
   * For nested form fields, use the format: "{fieldIdWithNestedForm}/{nestedFormFieldId}".
   */
  entityId?: Maybe<Scalars['String']>;
  /** Type of form element that this override targets. */
  entityType?: Maybe<WixFormsV4FormRuleFormOverrideOverrideEntityTypeEnumOverrideEntityType>;
  /**
   * Property changes to apply to the form element when the rule condition is met.
   * Each key represents a property path, and the value is the new value to set.
   */
  valueChanges?: Maybe<Scalars['JSON']>;
};

export type WixFormsV4FormRuleFormOverrideInput = {
  /**
   * ID of the form element to modify.
   * For nested form fields, use the format: "{fieldIdWithNestedForm}/{nestedFormFieldId}".
   */
  entityId?: InputMaybe<Scalars['String']>;
  /** Type of form element that this override targets. */
  entityType?: InputMaybe<WixFormsV4FormRuleFormOverrideOverrideEntityTypeEnumOverrideEntityType>;
  /**
   * Property changes to apply to the form element when the rule condition is met.
   * Each key represents a property path, and the value is the new value to set.
   */
  valueChanges?: InputMaybe<Scalars['JSON']>;
};

export enum WixFormsV4FormRuleFormOverrideOverrideEntityTypeEnumOverrideEntityType {
  /** Override applies to a form field. */
  FIELD = 'FIELD',
  /** Override applies to the form itself. */
  FORM = 'FORM',
  /** Override applies to a field within a nested form. */
  NESTED_FORM_FIELD = 'NESTED_FORM_FIELD',
  /** Unknown override entity type. */
  UNKNOWN = 'UNKNOWN'
}

export type WixFormsV4FormRuleInput = {
  /** Condition that determines when this rule's overrides should be applied. */
  condition?: InputMaybe<Scalars['JSON']>;
  /** Rule ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Name for the rule. */
  name?: InputMaybe<Scalars['String']>;
  /** Namespace rules are part of business logic of app owning namespace, have limited editing possibilities */
  namespaceRule?: InputMaybe<Scalars['Boolean']>;
  /** Changes to apply to form elements when the condition evaluates to true. */
  overrides?: InputMaybe<Array<InputMaybe<WixFormsV4FormRuleFormOverrideInput>>>;
};

export enum WixFormsV4FormSpamFilterProtectionLevel {
  /** Advanced spam filtering. Provides comprehensive protection with intelligent screening and the form is open to a low risk of spam submissions. */
  ADVANCED = 'ADVANCED',
  /** Basic spam filtering. Provides minimal protection against obvious spam and the form is open to a high risk of spam submissions. */
  BASIC = 'BASIC',
  /** No spam filtering. All submissions are accepted without screening. */
  NONE = 'NONE',
  /** Unknown spam filter protection level. */
  UNKNOWN = 'UNKNOWN'
}

export type WixFormsV4FormSummary = {
  /**
   * Simplified representation of form fields for quick overview and processing.
   * Contains essential field information without complex validation or layout details.
   */
  fields?: Maybe<Array<Maybe<WixFormsV4FormSummaryField>>>;
  /** Form schema ID. */
  id?: Maybe<Scalars['String']>;
};

export type WixFormsV4FormSummaryField = {
  /** Whether this field has been soft deleted from the form schema and placed in the trash bin. */
  deleted?: Maybe<Scalars['Boolean']>;
  /** Field ID. */
  id?: Maybe<Scalars['String']>;
  /** Display label shown to users for this field. */
  label?: Maybe<Scalars['String']>;
  /** Available options for fields that allow selection from predefined choices. */
  options?: Maybe<Array<Maybe<WixFormsV4FormSummaryFieldOption>>>;
  /** Human readable identifier used to reference a field. */
  target?: Maybe<Scalars['String']>;
  /** Data type that this field accepts and validates. */
  type?: Maybe<WixFormsV4FormSummaryFieldInputType>;
};

export enum WixFormsV4FormSummaryFieldInputType {
  /** Array input. */
  ARRAY = 'ARRAY',
  /** Boolean input. */
  BOOLEAN = 'BOOLEAN',
  /** Color input. */
  COLOR_HEX = 'COLOR_HEX',
  /** Currency input. */
  CURRENCY = 'CURRENCY',
  /** Date input. */
  DATE = 'DATE',
  /** Date input with optional time component. */
  DATE_OPTIONAL_TIME = 'DATE_OPTIONAL_TIME',
  /** Combined date and time input. */
  DATE_TIME = 'DATE_TIME',
  /** Email input. */
  EMAIL = 'EMAIL',
  /** Hostname input. */
  HOSTNAME = 'HOSTNAME',
  /** Language input. */
  LANGUAGE = 'LANGUAGE',
  /** Multi-line address input. */
  MULTILINE_ADDRESS = 'MULTILINE_ADDRESS',
  /** Numeric input. */
  NUMBER = 'NUMBER',
  /** Object input. */
  OBJECT = 'OBJECT',
  /** Payment input. */
  PAYMENT = 'PAYMENT',
  /** Phone number input. */
  PHONE = 'PHONE',
  /** Rating input. */
  RATING = 'RATING',
  /** Digital signature input. */
  SIGNATURE = 'SIGNATURE',
  /** String input. */
  STRING = 'STRING',
  /** Time input. */
  TIME = 'TIME',
  /** Unknown input type. */
  UNKNOWN_INPUT_TYPE = 'UNKNOWN_INPUT_TYPE',
  /** URI input. */
  URI = 'URI',
  /** URL input. */
  URL = 'URL',
  /** UUID input. */
  UUID = 'UUID',
  /** File upload input. */
  WIX_FILE = 'WIX_FILE'
}

export type WixFormsV4FormSummaryFieldOption = {
  /** Display text shown to users for this option. */
  label?: Maybe<Scalars['String']>;
  /** Value associated with this option. */
  value?: Maybe<Scalars['String']>;
};

export type WixFormsV4GetDeletedFormRequestInput = {
  /** ID of the for schema to retrieve */
  formId?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4GetDeletedFormResponse = {
  /** The retrieved deleted form schemas. */
  form?: Maybe<WixFormsV4Form>;
};

export type WixFormsV4GetFormRequestInput = {
  /** Optional metadata passed to SPI implementer, allowing clients to include additional business-specific data. */
  additionalMetadata?: InputMaybe<Scalars['JSON']>;
  /**
   * List of additional form fields to include in the response. For example, use the `NESTED_FORMS` fieldset to retrieve the nested forms field in
   * the response in addition to the form’s base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the form’s base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<WixFormsV4FormFieldsetFieldset>>>;
  id: Scalars['ID'];
};

export type WixFormsV4GetFormSummaryRequestInput = {
  /** ID of the form schema to retrieve the summary for. */
  formId?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4GetFormSummaryResponse = {
  /** The retrieved form schema summary. */
  formSummary?: Maybe<WixFormsV4FormSummary>;
};

export type WixFormsV4Group = {
  /** ID of the field group. */
  groupId?: Maybe<Scalars['String']>;
  /** Layout configuration for individual items within this group. */
  items?: Maybe<Array<Maybe<WixFormsV4ItemLayout>>>;
};

export type WixFormsV4GroupInput = {
  /** ID of the field group. */
  groupId?: InputMaybe<Scalars['String']>;
  /** Layout configuration for individual items within this group. */
  items?: InputMaybe<Array<InputMaybe<WixFormsV4ItemLayoutInput>>>;
};

export type WixFormsV4ItemLayout = {
  /** Column position in the grid where this item is placed. */
  column?: Maybe<Scalars['Int']>;
  /** ID of the form field to be positioned in the layout. */
  fieldId?: Maybe<Scalars['String']>;
  /** Group configuration for positioning multiple fields as a single layout unit. */
  group?: Maybe<WixFormsV4Group>;
  /** Height of the item in grid units. */
  height?: Maybe<Scalars['Int']>;
  /** Row position in the grid where this item is placed. */
  row?: Maybe<Scalars['Int']>;
  /** Width of the item in grid units. */
  width?: Maybe<Scalars['Int']>;
};

export type WixFormsV4ItemLayoutInput = {
  /** Column position in the grid where this item is placed. */
  column?: InputMaybe<Scalars['Int']>;
  /** ID of the form field to be positioned in the layout. */
  fieldId?: InputMaybe<Scalars['String']>;
  /** Group configuration for positioning multiple fields as a single layout unit. */
  group?: InputMaybe<WixFormsV4GroupInput>;
  /** Height of the item in grid units. */
  height?: InputMaybe<Scalars['Int']>;
  /** Row position in the grid where this item is placed. */
  row?: InputMaybe<Scalars['Int']>;
  /** Width of the item in grid units. */
  width?: InputMaybe<Scalars['Int']>;
};

export type WixFormsV4ListDeletedFormsRequestInput = {
  /**
   * Whether to filter for enabled deleted form schemas.
   *
   * When `true`, returns only deleted form schemas that were enabled before deletion.
   * When `false`, returns all deleted form schemas regardless of enabled status.
   *
   * Default: `true`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * IDs of specific deleted form schemas to retrieve.
   *
   * When specified, only deleted form schemas with these IDs are returned.
   */
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Namespace of the deleted form schemas to list. */
  namespace?: InputMaybe<Scalars['String']>;
  /**
   * Order to list deleted forms in the response.
   *
   * Ordering options.
   *
   * - `UPDATED_DATE_ASC`: Order by `updatedDate` in ascending order.
   * - `UPDATED_DATE_DESC`: Order by `updatedDate` in descending order.
   * - `NAME_ASC`: Order by `properties.name` in ascending order.
   * - `NAME_DESC`: Order by `properties.name` in descending order.
   *
   * Default: `UPDATED_DATE_DESC`
   */
  order?: InputMaybe<WixFormsV4ListDeletedFormsRequestListDeletedFormsOrder>;
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not filter or `order`. */
  paging?: InputMaybe<ComWixFormsUpstreamWixCommonCursorPagingInput>;
  /**
   * Whether to filter for deleted payment form schemas.
   *
   * When `true`, returns only deleted form schemas that contain payment fields.
   * When `false`, returns all deleted form schemas regardless of payment fields.
   */
  paymentForm?: InputMaybe<Scalars['Boolean']>;
};

export enum WixFormsV4ListDeletedFormsRequestListDeletedFormsOrder {
  /** Sort by name in ascending order. */
  NAME_ASC = 'NAME_ASC',
  /** Sort by name in descending order. */
  NAME_DESC = 'NAME_DESC',
  /** Sort by updated date in ascending order. */
  UPDATED_DATE_ASC = 'UPDATED_DATE_ASC',
  /** Sort by updated date in descending order. Default. */
  UPDATED_DATE_DESC = 'UPDATED_DATE_DESC'
}

export type WixFormsV4ListDeletedFormsResponse = {
  /** The retrieved form schemas. */
  forms?: Maybe<Array<Maybe<WixFormsV4Form>>>;
  /** Details on the paged set of results returned. */
  pagingMetadata?: Maybe<ComWixFormsUpstreamWixCommonCursorPagingMetadata>;
};

export enum WixFormsV4ListFormsOrderEnumListFormsOrder {
  /** Sort by created date in ascending order. */
  CREATED_DATE_ASC = 'CREATED_DATE_ASC',
  /** Sort by created date in descending order. */
  CREATED_DATE_DESC = 'CREATED_DATE_DESC',
  /** Sort by name in ascending order. */
  NAME_ASC = 'NAME_ASC',
  /** Sort by name in descending order. */
  NAME_DESC = 'NAME_DESC',
  /** Sort by updated date in ascending order . */
  UPDATED_DATE_ASC = 'UPDATED_DATE_ASC',
  /** Sort by updated date in descending order. Default. */
  UPDATED_DATE_DESC = 'UPDATED_DATE_DESC'
}

export type WixFormsV4ListFormsRequestInput = {
  /** Optional metadata passed to SPI implementer, allowing clients to include additional business-specific data. */
  additionalMetadata?: InputMaybe<Scalars['JSON']>;
  /**
   * Whether to filter for enabled form schemas.
   *
   * When `true`, returns only enabled form schemas.
   * When `false`, returns all form schemas regardless of enabled status.
   *
   * Default: `true`
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * List of additional form fields to include in the response. For example, use the `NESTED_FORMS` fieldset to retrieve the nested forms field in
   * the response in addition to the form’s base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the form’s base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<WixFormsV4FormFieldsetFieldset>>>;
  /**
   * IDs of specific form schemas to retrieve.
   *
   * When specified, only form schemas with these IDs are returned.
   */
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Kind of forms. */
  kind?: InputMaybe<WixFormsV4FormKindKind>;
  /** Filter by name */
  nameFilter?: InputMaybe<WixFormsV4NameFilterInput>;
  /** Namespace of the form schemas to list. */
  namespace?: InputMaybe<Scalars['String']>;
  /**
   * Order to list forms in the response.
   *
   * Ordering options.
   *
   * - `UPDATED_DATE_DESC`: Order by `updatedDate` in descending order.
   * - `UPDATED_DATE_ASC`: Order by `updatedDate` in ascending order.
   * - `CREATED_DATE_ASC`: Order by `createdDate` in ascending order.
   * - `CREATED_DATE_DESC`: Order by `createdDate` in descending order.
   * - `NAME_ASC`: Order by `properties.name` in ascending order.
   * - `NAME_DESC`: Order by `properties.name` in descending order.
   *
   * Default: `UPDATED_DATE_DESC`
   */
  order?: InputMaybe<WixFormsV4ListFormsRequestListFormsOrder>;
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not filter or `order`. */
  paging?: InputMaybe<ComWixFormsUpstreamWixCommonCursorPagingInput>;
  /**
   * Whether to filter for payment form schemas.
   *
   * When `true`, returns only form schemas that contain payment fields.
   * When `false`, returns all form schemas regardless of payment fields.
   */
  paymentForm?: InputMaybe<Scalars['Boolean']>;
};

export enum WixFormsV4ListFormsRequestListFormsOrder {
  /** Sort by created date in ascending order. */
  CREATED_DATE_ASC = 'CREATED_DATE_ASC',
  /** Sort by created date in descending order. */
  CREATED_DATE_DESC = 'CREATED_DATE_DESC',
  /** Sort by name in ascending order. */
  NAME_ASC = 'NAME_ASC',
  /** Sort by name in descending order. */
  NAME_DESC = 'NAME_DESC',
  /** Sort by updated date in ascending order. */
  UPDATED_DATE_ASC = 'UPDATED_DATE_ASC',
  /** Sort by updated date in descending order. Default. */
  UPDATED_DATE_DESC = 'UPDATED_DATE_DESC'
}

export type WixFormsV4ListFormsResponse = {
  /** The retrieved forms. */
  forms?: Maybe<Array<Maybe<WixFormsV4Form>>>;
  /** Details on the paged set of results returned. */
  pagingMetadata?: Maybe<ComWixFormsUpstreamWixCommonCursorPagingMetadata>;
};

export type WixFormsV4ListTemplateExtensionsRequestInput = {
  /** Optional metadata passed to SPI implementer, allowing clients to include additional business-specific data. */
  additionalMetadata?: InputMaybe<Scalars['JSON']>;
  /** Identifies if the form is disabled. */
  disabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * List of additional form fields to include in the response. For example, use the `NESTED_FORMS` fieldset to retrieve the nested forms field in
   * the response in addition to the form’s base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the form’s base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<WixFormsV4FormFieldsetFieldset>>>;
  /** Form ids. */
  formIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter by name */
  nameFilter?: InputMaybe<WixFormsV4NameFilterInput>;
  /** Namespace name. */
  namespace?: InputMaybe<Scalars['String']>;
  /**
   * Ordering options.
   *
   * - `UPDATED_DATE_DESC`: Ordered by `updatedDate` in descending order.
   * - `UPDATED_DATE_ASC`: Ordered by `updatedDate` in ascending order.
   * - `CREATED_DATE_ASC`: Ordered by `createdDate` in ascending order.
   * - `CREATED_DATE_DESC`: Ordered by `createdDate` in descending order.
   * - `NAME_ASC`: Ordered by `properties.name` in ascending order.
   * - `NAME_DESC`: Ordered by `properties.name` in descending order.
   *
   * Default: `UPDATED_DATE_DESC`
   */
  order?: InputMaybe<WixFormsV4ListFormsOrderEnumListFormsOrder>;
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not filter or `order`. */
  paging?: InputMaybe<ComWixFormsUpstreamWixCommonCursorPagingInput>;
  /** List of templates id, which extensions expected */
  templateIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixFormsV4ListTemplateExtensionsResponse = {
  /** The retrieved forms. */
  forms?: Maybe<Array<Maybe<WixFormsV4Form>>>;
  /** Details on the paged set of results returned. */
  pagingMetadata?: Maybe<ComWixFormsUpstreamWixCommonCursorPagingMetadata>;
};

export type WixFormsV4MultilineAddressValidation = {
  /**
   * Countries from which addresses are accepted.
   * If empty, addresses from all countries are allowed.
   */
  allowedCountries?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Customization configuration for individual address field components. */
  fields?: Maybe<WixFormsV4MultilineAddressValidationFieldsOverrides>;
};

export type WixFormsV4MultilineAddressValidationFieldOverrides = {
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4MultilineAddressValidationFieldOverridesInput = {
  /** Whether the field is required. */
  required?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4MultilineAddressValidationFieldsOverrides = {
  /** Address line settings. */
  addressLine?: Maybe<WixFormsV4MultilineAddressValidationFieldOverrides>;
  /** Address line 2 settings. */
  addressLine2?: Maybe<WixFormsV4MultilineAddressValidationFieldOverrides>;
  /** City settings. */
  city?: Maybe<WixFormsV4MultilineAddressValidationFieldOverrides>;
  /** Country settings. */
  country?: Maybe<WixFormsV4MultilineAddressValidationFieldOverrides>;
  /** Postal code settings. */
  postalCode?: Maybe<WixFormsV4MultilineAddressValidationFieldOverrides>;
  /** Street name settings. */
  streetName?: Maybe<WixFormsV4MultilineAddressValidationFieldOverrides>;
  /** Street number settings. */
  streetNumber?: Maybe<WixFormsV4MultilineAddressValidationFieldOverrides>;
  /** Subdivision settings. */
  subdivision?: Maybe<WixFormsV4MultilineAddressValidationFieldOverrides>;
};

export type WixFormsV4MultilineAddressValidationFieldsOverridesInput = {
  /** Address line settings. */
  addressLine?: InputMaybe<WixFormsV4MultilineAddressValidationFieldOverridesInput>;
  /** Address line 2 settings. */
  addressLine2?: InputMaybe<WixFormsV4MultilineAddressValidationFieldOverridesInput>;
  /** City settings. */
  city?: InputMaybe<WixFormsV4MultilineAddressValidationFieldOverridesInput>;
  /** Country settings. */
  country?: InputMaybe<WixFormsV4MultilineAddressValidationFieldOverridesInput>;
  /** Postal code settings. */
  postalCode?: InputMaybe<WixFormsV4MultilineAddressValidationFieldOverridesInput>;
  /** Street name settings. */
  streetName?: InputMaybe<WixFormsV4MultilineAddressValidationFieldOverridesInput>;
  /** Street number settings. */
  streetNumber?: InputMaybe<WixFormsV4MultilineAddressValidationFieldOverridesInput>;
  /** Subdivision settings. */
  subdivision?: InputMaybe<WixFormsV4MultilineAddressValidationFieldOverridesInput>;
};

export type WixFormsV4MultilineAddressValidationInput = {
  /**
   * Countries from which addresses are accepted.
   * If empty, addresses from all countries are allowed.
   */
  allowedCountries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Customization configuration for individual address field components. */
  fields?: InputMaybe<WixFormsV4MultilineAddressValidationFieldsOverridesInput>;
};

export enum WixFormsV4NameFilterFilterType {
  /** Return form schemas with names that exactly match the specified name. */
  EXACT_MATCH = 'EXACT_MATCH',
  /** Return form schemas with names that start with the specified name. */
  STARTS_WITH = 'STARTS_WITH'
}

export type WixFormsV4NameFilterInput = {
  /** Type of name matching to perform. */
  filterType?: InputMaybe<WixFormsV4NameFilterFilterType>;
  /** Name or name prefix to search for. */
  name?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4PaymentType = {
  /** Maximum number of different products that can be selected. */
  maxItems?: Maybe<Scalars['Int']>;
  /** Minimum number of different products that must be selected. */
  minItems?: Maybe<Scalars['Int']>;
  /** Products the submitter can select to make a payment for. */
  products?: Maybe<Array<Maybe<WixFormsV4PaymentTypeProduct>>>;
};

export type WixFormsV4PaymentTypeInput = {
  /** Maximum number of different products that can be selected. */
  maxItems?: InputMaybe<Scalars['Int']>;
  /** Minimum number of different products that must be selected. */
  minItems?: InputMaybe<Scalars['Int']>;
  /** Products the submitter can select to make a payment for. */
  products?: InputMaybe<Array<InputMaybe<WixFormsV4PaymentTypeProductInput>>>;
};

export type WixFormsV4PaymentTypeProduct = {
  /** Configuration for products with variable pricing within a range. */
  dynamicPriceOptions?: Maybe<WixFormsV4PaymentTypeProductDynamicPriceOptions>;
  /** Configuration for products with fixed pricing. */
  fixedPriceOptions?: Maybe<WixFormsV4PaymentTypeProductFixedPriceOptions>;
  /** Product ID. */
  id?: Maybe<Scalars['String']>;
  /** Price type. */
  priceType?: Maybe<WixFormsV4PaymentTypeProductPriceTypeEnumPriceType>;
  /** Product type. */
  productType?: Maybe<WixFormsV4PaymentTypeProductProductTypeEnumProductType>;
  /** Limits on how many units of this product can be selected. */
  quantityLimit?: Maybe<WixFormsV4PaymentTypeProductQuantityLimit>;
};

export type WixFormsV4PaymentTypeProductDynamicPriceOptions = {
  /**
   * Maximum monetary price of the product.
   *
   * Specified as a decimal string with period as decimal separator. For example, `"10.00"`.
   *
   * If not specified, there is no upper limit on the price.
   */
  maxPrice?: Maybe<Scalars['String']>;
  /**
   * Minimum price of the product.
   *
   * Specified as a decimal string with period as decimal separator. For example, `"1.00"`.
   */
  minPrice?: Maybe<Scalars['String']>;
};

export type WixFormsV4PaymentTypeProductDynamicPriceOptionsInput = {
  /**
   * Maximum monetary price of the product.
   *
   * Specified as a decimal string with period as decimal separator. For example, `"10.00"`.
   *
   * If not specified, there is no upper limit on the price.
   */
  maxPrice?: InputMaybe<Scalars['String']>;
  /**
   * Minimum price of the product.
   *
   * Specified as a decimal string with period as decimal separator. For example, `"1.00"`.
   */
  minPrice?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4PaymentTypeProductFixedPriceOptions = {
  /**
   * Fixed price of the product.
   *
   * Specified as a decimal string with period as decimal separator. For example, `"3.99"`.
   */
  price?: Maybe<Scalars['String']>;
};

export type WixFormsV4PaymentTypeProductFixedPriceOptionsInput = {
  /**
   * Fixed price of the product.
   *
   * Specified as a decimal string with period as decimal separator. For example, `"3.99"`.
   */
  price?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4PaymentTypeProductInput = {
  /** Configuration for products with variable pricing within a range. */
  dynamicPriceOptions?: InputMaybe<WixFormsV4PaymentTypeProductDynamicPriceOptionsInput>;
  /** Configuration for products with fixed pricing. */
  fixedPriceOptions?: InputMaybe<WixFormsV4PaymentTypeProductFixedPriceOptionsInput>;
  /** Product ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Price type. */
  priceType?: InputMaybe<WixFormsV4PaymentTypeProductPriceTypeEnumPriceType>;
  /** Product type. */
  productType?: InputMaybe<WixFormsV4PaymentTypeProductProductTypeEnumProductType>;
  /** Limits on how many units of this product can be selected. */
  quantityLimit?: InputMaybe<WixFormsV4PaymentTypeProductQuantityLimitInput>;
};

export enum WixFormsV4PaymentTypeProductPriceTypeEnumPriceType {
  /** Product price can vary within a specified range. */
  DYNAMIC_PRICE = 'DYNAMIC_PRICE',
  /** Product has a single, unchanging price. */
  FIXED_PRICE = 'FIXED_PRICE',
  /** Unknown price type. */
  UNKNOWN_PRICE_TYPE = 'UNKNOWN_PRICE_TYPE'
}

export enum WixFormsV4PaymentTypeProductProductTypeEnumProductType {
  /** Digital product. */
  DIGITAL = 'DIGITAL',
  /** Physical product that can be shipped. */
  SHIPPABLE = 'SHIPPABLE',
  /** Unknown product type. */
  UNKNOWN_PRODUCT_TYPE = 'UNKNOWN_PRODUCT_TYPE'
}

export type WixFormsV4PaymentTypeProductQuantityLimit = {
  /** Maximum quantity that can be selected for this product. */
  maximum?: Maybe<Scalars['Int']>;
  /** Minimum quantity that must be selected for this product. */
  minimum?: Maybe<Scalars['Int']>;
};

export type WixFormsV4PaymentTypeProductQuantityLimitInput = {
  /** Maximum quantity that can be selected for this product. */
  maximum?: InputMaybe<Scalars['Int']>;
  /** Minimum quantity that must be selected for this product. */
  minimum?: InputMaybe<Scalars['Int']>;
};

export type WixFormsV4PostSubmissionTriggers = {
  /** Upserts a [contact](https://support.wix.com/en/article/about-your-contact-list) to the Wix site from the form submission data. */
  upsertContact?: Maybe<WixFormsV4UpsertContact>;
};

export type WixFormsV4PostSubmissionTriggersInput = {
  /** Upserts a [contact](https://support.wix.com/en/article/about-your-contact-list) to the Wix site from the form submission data. */
  upsertContact?: InputMaybe<WixFormsV4UpsertContactInput>;
};

export type WixFormsV4QueryDeletedFormsRequestInput = {
  /** Namespace name. */
  namespace?: InputMaybe<Scalars['String']>;
  /** WQL expression. You must specify a namespace equality filter. For example, `"namespace:{"$eq":"<your_namespace>"}`. */
  query?: InputMaybe<ComWixFormsUpstreamWixCommonCursorQueryInput>;
};

export type WixFormsV4QueryDeletedFormsResponse = {
  /** The retrieved Forms */
  forms?: Maybe<Array<Maybe<WixFormsV4Form>>>;
  /** Details on the paged set of results returned. */
  metadata?: Maybe<ComWixFormsUpstreamWixCommonCursorPagingMetadata>;
};

export type WixFormsV4QueryFormsRequestInput = {
  /** Optional metadata passed to SPI implementer, allowing clients to include additional business-specific data. */
  additionalMetadata?: InputMaybe<Scalars['JSON']>;
  /**
   * List of additional form fields to include in the response. For example, use the `NESTED_FORMS` fieldset to retrieve the nested forms field in
   * the response in addition to the form’s base fields. Base fields don’t include any of the supported fieldset values. By default
   * only the form’s base fields are returned.
   */
  fieldsets?: InputMaybe<Array<InputMaybe<WixFormsV4FormFieldsetFieldset>>>;
  /**
   * Kind of queried forms.
   * REGULAR - will return forms specific to tenant, excluding template based forms.
   * EXTENSION - will return forms based on common templates, with applied user overrides if there are such.
   */
  kind?: InputMaybe<WixFormsV4FormKindKind>;
  /** Namespace for filtering form schemas. */
  namespace?: InputMaybe<Scalars['String']>;
  /** WQL expression. You must specify a namespace equality filter. For example, `"namespace:{"$eq":"<your_namespace>"}`. */
  query?: InputMaybe<ComWixFormsUpstreamWixCommonCursorQueryInput>;
};

export type WixFormsV4QueryFormsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<WixFormsV4Form>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixFormsV4RemoveFormFromTrashBinRequestInput = {
  /** ID of the form schema to permanently delete from the trash bin. */
  formId?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4RequiredIndicatorProperties = {
  /** Type of visual indicator used to mark required fields. */
  requiredIndicator?: Maybe<WixFormsV4RequiredIndicatorPropertiesRequiredIndicator>;
  /** Position where the required indicator appears relative to the field title. */
  requiredIndicatorPlacement?: Maybe<WixFormsV4RequiredIndicatorPropertiesRequiredIndicatorPlacement>;
};

export type WixFormsV4RequiredIndicatorPropertiesInput = {
  /** Type of visual indicator used to mark required fields. */
  requiredIndicator?: InputMaybe<WixFormsV4RequiredIndicatorPropertiesRequiredIndicator>;
  /** Position where the required indicator appears relative to the field title. */
  requiredIndicatorPlacement?: InputMaybe<WixFormsV4RequiredIndicatorPropertiesRequiredIndicatorPlacement>;
};

export enum WixFormsV4RequiredIndicatorPropertiesRequiredIndicator {
  /** Display an asterisk (*) symbol to indicate required fields. */
  ASTERISK = 'ASTERISK',
  /** No visual indicator is shown for required fields. */
  NONE = 'NONE',
  /** Display the text "Required" to indicate required fields. */
  TEXT = 'TEXT',
  /** Unknown required indicator type. */
  UNKNOWN_INDICATOR = 'UNKNOWN_INDICATOR'
}

export enum WixFormsV4RequiredIndicatorPropertiesRequiredIndicatorPlacement {
  /** Place the required indicator after the field title. */
  AFTER_FIELD_TITLE = 'AFTER_FIELD_TITLE',
  /** Place the required indicator before the field title. */
  BEFORE_FIELD_TITLE = 'BEFORE_FIELD_TITLE',
  /** Unknown required indicator placement. */
  UNKNOWN_PLACEMENT = 'UNKNOWN_PLACEMENT'
}

export type WixFormsV4RestoreFromTrashBinRequestInput = {
  /** ID of the form schema to restore from the trash bin. */
  formId?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4RestoreFromTrashBinResponse = {
  /** Restored form schema. */
  form?: Maybe<WixFormsV4Form>;
};

export type WixFormsV4RulesAndCondition = {
  /** List of conditions that must all evaluate to true. */
  conditions?: Maybe<Array<Maybe<WixFormsV4RulesConditionNode>>>;
};

export type WixFormsV4RulesAndConditionInput = {
  /** List of conditions that must all evaluate to true. */
  conditions?: InputMaybe<Array<InputMaybe<WixFormsV4RulesConditionNodeInput>>>;
};

export enum WixFormsV4RulesChangeablePropertyEnumChangeableProperty {
  /** Allowed values property type. */
  ALLOWED_VALUES = 'ALLOWED_VALUES',
  /** Hidden property type. */
  HIDDEN = 'HIDDEN',
  /** Required property type. */
  REQUIRED = 'REQUIRED',
  /** Unknown property type. */
  UNKNOWN_CHANGEABLE_PROPERTY = 'UNKNOWN_CHANGEABLE_PROPERTY'
}

export type WixFormsV4RulesCondition = {
  /** Comparison operator to use for evaluating the condition. */
  operator?: Maybe<WixFormsV4RulesOperatorEnumOperator>;
  /**
   * Human readable identifier used to reference a field.
   * Supports dot notation for nested properties. For example, `"address.city"`.
   */
  target?: Maybe<Scalars['String']>;
  /** Value to compare against the value in the target field. */
  value?: Maybe<Scalars['JSON']>;
};

export type WixFormsV4RulesConditionInput = {
  /** Comparison operator to use for evaluating the condition. */
  operator?: InputMaybe<WixFormsV4RulesOperatorEnumOperator>;
  /**
   * Human readable identifier used to reference a field.
   * Supports dot notation for nested properties. For example, `"address.city"`.
   */
  target?: InputMaybe<Scalars['String']>;
  /** Value to compare against the value in the target field. */
  value?: InputMaybe<Scalars['JSON']>;
};

export type WixFormsV4RulesConditionNode = {
  /** Logical AND condition with 1 or more child conditions. All child conditions must be true. */
  and?: Maybe<WixFormsV4RulesAndCondition>;
  /** Single condition to evaluate. */
  condition?: Maybe<WixFormsV4RulesCondition>;
  /** Logical OR condition with 1 or more child conditions. At least 1 child condition must be true. */
  or?: Maybe<WixFormsV4RulesOrCondition>;
};

export type WixFormsV4RulesConditionNodeInput = {
  /** Logical AND condition with 1 or more child conditions. All child conditions must be true. */
  and?: InputMaybe<WixFormsV4RulesAndConditionInput>;
  /** Single condition to evaluate. */
  condition?: InputMaybe<WixFormsV4RulesConditionInput>;
  /** Logical OR condition with 1 or more child conditions. At least 1 child condition must be true. */
  or?: InputMaybe<WixFormsV4RulesOrConditionInput>;
};

export enum WixFormsV4RulesOperatorEnumOperator {
  /** Date value in the target field is after the specified date. */
  AFTER = 'AFTER',
  /** Date value in the target field is after or equal to the specified date. */
  AFTER_OR_EQUAL = 'AFTER_OR_EQUAL',
  /** Value in the target field matches any of the specified values. */
  ANY = 'ANY',
  /** Array value in the target field exactly equals the specified array. */
  ARRAY_EQUAL = 'ARRAY_EQUAL',
  /** Array value in the target field doesn't equal the specified array. */
  ARRAY_NOT_EQUAL = 'ARRAY_NOT_EQUAL',
  /** Date value in the target field is before the specified date. */
  BEFORE = 'BEFORE',
  /** Date value in the target field is before or equal to the specified date. */
  BEFORE_OR_EQUAL = 'BEFORE_OR_EQUAL',
  /** Value in the target field falls within the specified range. */
  BETWEEN = 'BETWEEN',
  /** Checkbox or boolean field value in the target field is checked. */
  CHECKED = 'CHECKED',
  /** String value in the target field contains the specified substring. */
  CONTAINS = 'CONTAINS',
  /** Target field is empty or has no value. */
  EMPTY = 'EMPTY',
  /** Specified value equals the value in the target field. */
  EQUAL = 'EQUAL',
  /** Numeric value in the target field is greater than the specified value. */
  GREATER_THAN = 'GREATER_THAN',
  /** Numeric value in the target field is greater than or equal to the specified value. */
  GREATER_THAN_OR_EQUALS = 'GREATER_THAN_OR_EQUALS',
  /** Value in the target field is included in the specified list. */
  IN = 'IN',
  /** Date value in the target field is newer than the specified time period. */
  IS_DATE_NEWER_THAN = 'IS_DATE_NEWER_THAN',
  /** Date value in the target field is newer than or equal to the specified time period. */
  IS_DATE_NEWER_THAN_OR_EQUAL = 'IS_DATE_NEWER_THAN_OR_EQUAL',
  /** Date value in the target field is older than the specified time period. */
  IS_DATE_OLDER_THAN = 'IS_DATE_OLDER_THAN',
  /** Date value in the target field is older than or equal to the specified time period. */
  IS_DATE_OLDER_THAN_OR_EQUAL = 'IS_DATE_OLDER_THAN_OR_EQUAL',
  /** Numeric value in the target field is less than the specified value. */
  LESS_THAN = 'LESS_THAN',
  /** Numeric value in the target field is less than or equal to the specified value. */
  LESS_THAN_OR_EQUALS = 'LESS_THAN_OR_EQUALS',
  /** Checkbox or boolean field value in the target field isn't checked. */
  NOT_CHECKED = 'NOT_CHECKED',
  /** String value in the target field doesn't contain the specified substring. */
  NOT_CONTAINS = 'NOT_CONTAINS',
  /** Target field isn't empty and has a value. */
  NOT_EMPTY = 'NOT_EMPTY',
  /** Specified value doesn't equal the value in the target field. */
  NOT_EQUAL = 'NOT_EQUAL',
  /** Value in the target field isn't included in the specified list. */
  NOT_IN = 'NOT_IN',
  UNKNOWN_OPERATOR = 'UNKNOWN_OPERATOR'
}

export type WixFormsV4RulesOrCondition = {
  /** List of conditions where at least 1 must evaluate to true. */
  conditions?: Maybe<Array<Maybe<WixFormsV4RulesConditionNode>>>;
};

export type WixFormsV4RulesOrConditionInput = {
  /** List of conditions where at least 1 must evaluate to true. */
  conditions?: InputMaybe<Array<InputMaybe<WixFormsV4RulesConditionNodeInput>>>;
};

export type WixFormsV4RulesRule = {
  /**
   * Conditional expression that determines when this rule should be applied.
   * The overrides defined in this rule are applied when this expression evaluates to true.
   */
  expression?: Maybe<WixFormsV4RulesConditionNode>;
  /** Rule ID. */
  id?: Maybe<Scalars['String']>;
  /** Human-readable name for the rule. */
  name?: Maybe<Scalars['String']>;
  /** Namespace rules are part of business logic of app owning namespace, have limited editing possibilities */
  namespaceRule?: Maybe<Scalars['Boolean']>;
  /**
   * Form modifications that are applied when the rule expression evaluates to true.
   * Each override specifies how a form element should be changed.
   */
  overrides?: Maybe<Array<Maybe<WixFormsV4RulesRuleFormOverride>>>;
};

export type WixFormsV4RulesRuleFormOverride = {
  /** Type of form element being modified by this override. */
  entityType?: Maybe<WixFormsV4RulesRuleFormOverrideOverrideEntityTypeEnumOverrideEntityType>;
  /** Field override settings. */
  fieldOptions?: Maybe<WixFormsV4RulesRuleFormOverrideFieldOverride>;
};

export type WixFormsV4RulesRuleFormOverrideFieldOverride = {
  /** Configuration for changing the allowed values of a field. */
  allowedValuesOptions?: Maybe<WixFormsV4RulesRuleFormOverrideFieldOverrideAllowedValuesOptions>;
  /** ID of the field to be modified by this override. */
  fieldId?: Maybe<Scalars['String']>;
  /** Configuration for changing the visibility property of a field. */
  hiddenOptions?: Maybe<WixFormsV4RulesRuleFormOverrideFieldOverrideHiddenOptions>;
  /** The new value for the field property that will be set when the rule conditions are met. */
  propertyType?: Maybe<WixFormsV4RulesChangeablePropertyEnumChangeableProperty>;
  /** Configuration for changing the required property of a field. */
  requiredOptions?: Maybe<WixFormsV4RulesRuleFormOverrideFieldOverrideRequiredOptions>;
};

export type WixFormsV4RulesRuleFormOverrideFieldOverrideAllowedValuesOptions = {
  /**
   * List of values that are allowed for the field when this rule is active.
   * Restricts user input to only these predefined options.
   */
  allowedValues?: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

export type WixFormsV4RulesRuleFormOverrideFieldOverrideAllowedValuesOptionsInput = {
  /**
   * List of values that are allowed for the field when this rule is active.
   * Restricts user input to only these predefined options.
   */
  allowedValues?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type WixFormsV4RulesRuleFormOverrideFieldOverrideHiddenOptions = {
  /** Whether the field should be hidden. */
  hidden?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4RulesRuleFormOverrideFieldOverrideHiddenOptionsInput = {
  /** Whether the field should be hidden. */
  hidden?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4RulesRuleFormOverrideFieldOverrideInput = {
  /** Configuration for changing the allowed values of a field. */
  allowedValuesOptions?: InputMaybe<WixFormsV4RulesRuleFormOverrideFieldOverrideAllowedValuesOptionsInput>;
  /** ID of the field to be modified by this override. */
  fieldId?: InputMaybe<Scalars['String']>;
  /** Configuration for changing the visibility property of a field. */
  hiddenOptions?: InputMaybe<WixFormsV4RulesRuleFormOverrideFieldOverrideHiddenOptionsInput>;
  /** The new value for the field property that will be set when the rule conditions are met. */
  propertyType?: InputMaybe<WixFormsV4RulesChangeablePropertyEnumChangeableProperty>;
  /** Configuration for changing the required property of a field. */
  requiredOptions?: InputMaybe<WixFormsV4RulesRuleFormOverrideFieldOverrideRequiredOptionsInput>;
};

export type WixFormsV4RulesRuleFormOverrideFieldOverrideRequiredOptions = {
  /** Whether the field should be required. */
  required?: Maybe<Scalars['Boolean']>;
};

export type WixFormsV4RulesRuleFormOverrideFieldOverrideRequiredOptionsInput = {
  /** Whether the field should be required. */
  required?: InputMaybe<Scalars['Boolean']>;
};

export type WixFormsV4RulesRuleFormOverrideInput = {
  /** Type of form element being modified by this override. */
  entityType?: InputMaybe<WixFormsV4RulesRuleFormOverrideOverrideEntityTypeEnumOverrideEntityType>;
  /** Field override settings. */
  fieldOptions?: InputMaybe<WixFormsV4RulesRuleFormOverrideFieldOverrideInput>;
};

export enum WixFormsV4RulesRuleFormOverrideOverrideEntityTypeEnumOverrideEntityType {
  /** Override applies to a form field. */
  FIELD = 'FIELD',
  /** Unknown override entity type. */
  UNKNOWN_OVERRIDE_ENTITY_TYPE = 'UNKNOWN_OVERRIDE_ENTITY_TYPE'
}

export type WixFormsV4RulesRuleInput = {
  /**
   * Conditional expression that determines when this rule should be applied.
   * The overrides defined in this rule are applied when this expression evaluates to true.
   */
  expression?: InputMaybe<WixFormsV4RulesConditionNodeInput>;
  /** Rule ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Human-readable name for the rule. */
  name?: InputMaybe<Scalars['String']>;
  /** Namespace rules are part of business logic of app owning namespace, have limited editing possibilities */
  namespaceRule?: InputMaybe<Scalars['Boolean']>;
  /**
   * Form modifications that are applied when the rule expression evaluates to true.
   * Each override specifies how a form element should be changed.
   */
  overrides?: InputMaybe<Array<InputMaybe<WixFormsV4RulesRuleFormOverrideInput>>>;
};

export type WixFormsV4Step = {
  /** Whether the step is hidden. */
  hidden?: Maybe<Scalars['Boolean']>;
  /** Step ID. */
  id?: Maybe<Scalars['String']>;
  /** Layout configuration that defines how form fields are arranged within this step. */
  layout?: Maybe<WixFormsV4FormLayout>;
  /** Name of the step. */
  name?: Maybe<Scalars['String']>;
};

export type WixFormsV4StepInput = {
  /** Whether the step is hidden. */
  hidden?: InputMaybe<Scalars['Boolean']>;
  /** Step ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Layout configuration that defines how form fields are arranged within this step. */
  layout?: InputMaybe<WixFormsV4FormLayoutInput>;
  /** Name of the step. */
  name?: InputMaybe<Scalars['String']>;
};

export type WixFormsV4SubmitSettings = {
  /** Configuration for redirecting submitters to a URL after submission. */
  redirectOptions?: Maybe<WixFormsV4SubmitSettingsRedirectOptions>;
  /** Action that's triggered after a form is successfully submitted. */
  submitSuccessAction?: Maybe<WixFormsV4SubmitSettingsSubmitSuccessActionEnumSubmitSuccessAction>;
  /** Configuration for displaying a thank you message after submission. */
  thankYouMessageOptions?: Maybe<WixFormsV4SubmitSettingsThankYouMessageOptions>;
};

export type WixFormsV4SubmitSettingsInput = {
  /** Configuration for redirecting submitters to a URL after submission. */
  redirectOptions?: InputMaybe<WixFormsV4SubmitSettingsRedirectOptionsInput>;
  /** Action that's triggered after a form is successfully submitted. */
  submitSuccessAction?: InputMaybe<WixFormsV4SubmitSettingsSubmitSuccessActionEnumSubmitSuccessAction>;
  /** Configuration for displaying a thank you message after submission. */
  thankYouMessageOptions?: InputMaybe<WixFormsV4SubmitSettingsThankYouMessageOptionsInput>;
};

export type WixFormsV4SubmitSettingsRedirectOptions = {
  /** URL to which the user should be redirected after successfully submitting the form. */
  redirectUrl?: Maybe<Scalars['String']>;
  /** How the redirect URL should be opened in the browser. */
  target?: Maybe<WixFormsV4SubmitSettingsRedirectOptionsUrlTargetEnumTarget>;
};

export type WixFormsV4SubmitSettingsRedirectOptionsInput = {
  /** URL to which the user should be redirected after successfully submitting the form. */
  redirectUrl?: InputMaybe<Scalars['String']>;
  /** How the redirect URL should be opened in the browser. */
  target?: InputMaybe<WixFormsV4SubmitSettingsRedirectOptionsUrlTargetEnumTarget>;
};

export enum WixFormsV4SubmitSettingsRedirectOptionsUrlTargetEnumTarget {
  /** Open the URL in a new browser tab. */
  BLANK = 'BLANK',
  /** Open the URL in the same browser tab, replacing the current page. */
  SELF = 'SELF',
  /** Unknown target behavior. */
  UNKNOWN_TARGET = 'UNKNOWN_TARGET'
}

export enum WixFormsV4SubmitSettingsSubmitSuccessActionEnumSubmitSuccessAction {
  /** No action is taken after form submission. */
  NO_ACTION = 'NO_ACTION',
  /** Redirect the user to a specified URL after form submission. */
  REDIRECT = 'REDIRECT',
  /** Display a thank you message after form submission. */
  THANK_YOU_MESSAGE = 'THANK_YOU_MESSAGE',
  /** Unknown submit success action. */
  UNKNOWN_SUBMIT_SUCCESS_ACTION = 'UNKNOWN_SUBMIT_SUCCESS_ACTION'
}

export type WixFormsV4SubmitSettingsThankYouMessageOptions = {
  /**
   * Duration in seconds before the thank you message automatically disappears.
   * If set to 0, the message remains visible until manually dismissed.
   */
  durationInSeconds?: Maybe<Scalars['Int']>;
  /** Rich content message displayed to users after successful form submission. */
  richContent?: Maybe<WixRichContentV1RichContent>;
};

export type WixFormsV4SubmitSettingsThankYouMessageOptionsInput = {
  /**
   * Duration in seconds before the thank you message automatically disappears.
   * If set to 0, the message remains visible until manually dismissed.
   */
  durationInSeconds?: InputMaybe<Scalars['Int']>;
  /** Rich content message displayed to users after successful form submission. */
  richContent?: InputMaybe<WixRichContentV1RichContentInput>;
};

export type WixFormsV4UpdateExtendedFieldsResponse = {
  /** namespace that was updated */
  namespace?: Maybe<Scalars['String']>;
  /** only data from UpdateExtendedFieldsRequest namespace_data */
  namespaceData?: Maybe<Scalars['JSON']>;
};

export type WixFormsV4UpdateFormRequestInput = {
  /** Form schema to update. */
  form?: InputMaybe<WixFormsV4FormInput>;
  /** List of field paths to update. Only specified fields are modified. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixFormsV4UpdateFormResponse = {
  /** Updated form schema. */
  form?: Maybe<WixFormsV4Form>;
};

export type WixFormsV4UpsertContact = {
  /**
   * Fields mapping between the form fields and the contact fields.
   *
   * This is the target form field mapped to the corresponding contact field.
   *
   * The key is the form field ID, and the value is the contact field.
   */
  fieldsMapping?: Maybe<WixFormsV4FormFieldContactInfo>;
  /** List of [labels](https://support.wix.com/en/article/creating-contact-labels) to add to the contact to help categorize it. */
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type WixFormsV4UpsertContactInput = {
  /**
   * Fields mapping between the form fields and the contact fields.
   *
   * This is the target form field mapped to the corresponding contact field.
   *
   * The key is the form field ID, and the value is the contact field.
   */
  fieldsMapping?: InputMaybe<WixFormsV4FormFieldContactInfoInput>;
  /** List of [labels](https://support.wix.com/en/article/creating-contact-labels) to add to the contact to help categorize it. */
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixGiftCardsGiftCardV1Amount = {
  /**
   * Monetary amount in the specified currency as a decimal string.
   * For example, `"10.50"` for $10.50, or `"100"` for $100.00.
   */
  amount?: Maybe<Scalars['String']>;
  /**
   * Amount formatted with currency symbol for display purposes.
   * For example: `"$10.50"` or `"€25.00"`.
   */
  formattedAmount?: Maybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1AmountInput = {
  /**
   * Monetary amount in the specified currency as a decimal string.
   * For example, `"10.50"` for $10.50, or `"100"` for $100.00.
   */
  amount?: InputMaybe<Scalars['String']>;
  /**
   * Amount formatted with currency symbol for display purposes.
   * For example: `"$10.50"` or `"€25.00"`.
   */
  formattedAmount?: InputMaybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1CountGiftCardsRequestInput = {
  /**
   * Filter options to count specific gift cards.
   * Use the same filter format as Query Gift Cards.
   */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type WixGiftCardsGiftCardV1CountGiftCardsResponse = {
  /** Total number of gift cards matching the filter criteria. */
  count?: Maybe<Scalars['Int']>;
};

export type WixGiftCardsGiftCardV1CreateGiftCardRequestInput = {
  /** Gift card to create. */
  giftCard?: InputMaybe<WixGiftCardsGiftCardV1GiftCardInput>;
  /**
   * Unique identifier to prevent duplicate gift card creation.
   * Use this to safely retry gift card creation requests.
   */
  idempotencyKey?: InputMaybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1CreateGiftCardResponse = {
  /**
   * Created gift card with the full code visible and unobfuscated.
   *
   * The full code isn't retrievable with the other methods.
   */
  giftCard?: Maybe<WixGiftCardsGiftCardV1GiftCard>;
};

export type WixGiftCardsGiftCardV1DisableGiftCardRequestInput = {
  /** Gift card ID. */
  giftCardId?: InputMaybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1DisableGiftCardResponse = {
  /** Disabled gift card with updated disable date. */
  giftCard?: Maybe<WixGiftCardsGiftCardV1GiftCard>;
};

export type WixGiftCardsGiftCardV1FulfillGiftCardOrderRequestInput = {
  /** Order ID containing gift cards to fulfill. */
  orderId?: InputMaybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1GetGiftCardRequestInput = {
  id: Scalars['ID'];
};

export type WixGiftCardsGiftCardV1GetTransactionRequestInput = {
  id: Scalars['ID'];
};

export type WixGiftCardsGiftCardV1GiftCard = {
  /**
   * Current available balance that can be spent.
   *
   * Decreases when the gift card is used for purchases and increases with refunds.
   */
  balance?: Maybe<WixGiftCardsGiftCardV1Amount>;
  /**
   * Gift card code used for redemption.
   *
   * > **Notes:**
   * > + The gift card code can be custom-provided or automatically generated by omitting the field.
   * > + When returned by Create Gift Card, the `code` field contains the **full** gift card code, for example, `1111-2222-3333-4444`.
   * > + In any other method response, as well as in the Gift Card Created domain event, the `code` field contains the **obfuscated** gift card code, for example, `****-****-****-4444`.
   */
  code?: Maybe<Scalars['String']>;
  /** Last 4 characters of the gift card code for search and identification purposes. */
  codeSuffix?: Maybe<Scalars['String']>;
  /** Date and time the gift card was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Three-letter currency code in [ISO 4217](https://en.wikipedia.org/wiki/ISO_4217) format. For example, `"USD"`, `"EUR"`. */
  currency?: Maybe<Scalars['String']>;
  /** Date and time the gift card was disabled, if applicable. */
  disabledDate?: Maybe<Scalars['String']>;
  /** Date and time when the gift card expires and becomes unusable. */
  expirationDate?: Maybe<Scalars['String']>;
  /** Gift card ID. */
  id?: Maybe<Scalars['String']>;
  /** Initial monetary value assigned to the gift card when created. */
  initialValue?: Maybe<WixGiftCardsGiftCardV1Amount>;
  /** Email notification settings including recipient, sender, and delivery options. */
  notificationInfo?: Maybe<WixGiftCardsGiftCardV1NotificationInfo>;
  /** Order details when the gift card was purchased through an order. */
  orderInfo?: Maybe<WixGiftCardsGiftCardV1OrderInfo>;
  /** How the gift card was created. */
  source?: Maybe<WixGiftCardsGiftCardV1Source>;
  transactionsVirtualReference?: Maybe<WixGiftCardsGiftCardV1QueryGiftCardTransactionsResponse>;
  /** Date and time the gift card was last updated. */
  updatedDate?: Maybe<Scalars['String']>;
};


export type WixGiftCardsGiftCardV1GiftCardTransactionsVirtualReferenceArgs = {
  queryInput?: InputMaybe<WixGiftCardsGiftCardV1QueryGiftCardTransactionsRequestInput>;
};

export type WixGiftCardsGiftCardV1GiftCardInput = {
  /**
   * Current available balance that can be spent.
   *
   * Decreases when the gift card is used for purchases and increases with refunds.
   */
  balance?: InputMaybe<WixGiftCardsGiftCardV1AmountInput>;
  /**
   * Gift card code used for redemption.
   *
   * > **Notes:**
   * > + The gift card code can be custom-provided or automatically generated by omitting the field.
   * > + When returned by Create Gift Card, the `code` field contains the **full** gift card code, for example, `1111-2222-3333-4444`.
   * > + In any other method response, as well as in the Gift Card Created domain event, the `code` field contains the **obfuscated** gift card code, for example, `****-****-****-4444`.
   */
  code?: InputMaybe<Scalars['String']>;
  /** Last 4 characters of the gift card code for search and identification purposes. */
  codeSuffix?: InputMaybe<Scalars['String']>;
  /** Date and time the gift card was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Three-letter currency code in [ISO 4217](https://en.wikipedia.org/wiki/ISO_4217) format. For example, `"USD"`, `"EUR"`. */
  currency?: InputMaybe<Scalars['String']>;
  /** Date and time the gift card was disabled, if applicable. */
  disabledDate?: InputMaybe<Scalars['String']>;
  /** Date and time when the gift card expires and becomes unusable. */
  expirationDate?: InputMaybe<Scalars['String']>;
  /** Gift card ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Initial monetary value assigned to the gift card when created. */
  initialValue?: InputMaybe<WixGiftCardsGiftCardV1AmountInput>;
  /** Email notification settings including recipient, sender, and delivery options. */
  notificationInfo?: InputMaybe<WixGiftCardsGiftCardV1NotificationInfoInput>;
  /** Order details when the gift card was purchased through an order. */
  orderInfo?: InputMaybe<WixGiftCardsGiftCardV1OrderInfoInput>;
  /** How the gift card was created. */
  source?: InputMaybe<WixGiftCardsGiftCardV1Source>;
  /** Date and time the gift card was last updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1ListGiftCardsByEmailRequestInput = {
  /** Email address to search for in sender or recipient information. */
  email?: InputMaybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1ListGiftCardsByEmailResponse = {
  /**
   * Gift cards associated with the specified email address.
   *
   * Returns up to 50 gift cards sorted by creation date in descending order.
   */
  giftCards?: Maybe<Array<Maybe<WixGiftCardsGiftCardV1GiftCard>>>;
};

export type WixGiftCardsGiftCardV1NotificationInfo = {
  /**
   * URL of the image to display in the gift card email.
   * Use this to customize the visual appearance of the gift card.
   */
  imageUrl?: Maybe<Scalars['String']>;
  /**
   * Scheduled date and time to send the gift card email notification.
   * Leave empty to send the email immediately.
   */
  notificationDate?: Maybe<Scalars['String']>;
  /**
   * Custom message to include in the gift card email.
   * Personalizes the gift card for the recipient.
   */
  personalizedMessage?: Maybe<Scalars['String']>;
  /** Recipient information for email delivery. */
  recipient?: Maybe<WixGiftCardsGiftCardV1Recipient>;
  /** Sender information for email display. */
  sender?: Maybe<WixGiftCardsGiftCardV1Sender>;
};

export type WixGiftCardsGiftCardV1NotificationInfoInput = {
  /**
   * URL of the image to display in the gift card email.
   * Use this to customize the visual appearance of the gift card.
   */
  imageUrl?: InputMaybe<Scalars['String']>;
  /**
   * Scheduled date and time to send the gift card email notification.
   * Leave empty to send the email immediately.
   */
  notificationDate?: InputMaybe<Scalars['String']>;
  /**
   * Custom message to include in the gift card email.
   * Personalizes the gift card for the recipient.
   */
  personalizedMessage?: InputMaybe<Scalars['String']>;
  /** Recipient information for email delivery. */
  recipient?: InputMaybe<WixGiftCardsGiftCardV1RecipientInput>;
  /** Sender information for email display. */
  sender?: InputMaybe<WixGiftCardsGiftCardV1SenderInput>;
};

export type WixGiftCardsGiftCardV1OrderInfo = {
  /** Order ID associated with the gift card purchase. */
  order?: Maybe<ComWixEcomOrdersV1Order>;
  /** Order ID associated with the gift card purchase. */
  orderId?: Maybe<Scalars['String']>;
  /**
   * Human-readable order number displayed to customers.
   * For example, `"1001"`.
   */
  orderNumber?: Maybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1OrderInfoInput = {
  /** Order ID associated with the gift card purchase. */
  orderId?: InputMaybe<Scalars['String']>;
  /**
   * Human-readable order number displayed to customers.
   * For example, `"1001"`.
   */
  orderNumber?: InputMaybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1QueryGiftCardTransactionsRequestInput = {
  /** Gift card ID to retrieve transactions for. */
  giftCardId?: InputMaybe<Scalars['String']>;
  /**
   * Query expression to filter, sort, and page through transactions.
   * Use to search by transaction type, creation date, or operation type.
   */
  query?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonCursorQueryInput>;
};

export type WixGiftCardsGiftCardV1QueryGiftCardTransactionsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<WixGiftCardsGiftCardV1Transaction>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixGiftCardsGiftCardV1QueryGiftCardsRequestInput = {
  /**
   * Query options to filter, sort, and page through gift cards.
   * Use to search by creation date, balance, expiration date, code, or code suffix.
   */
  query?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonCursorQueryInput>;
};

export type WixGiftCardsGiftCardV1QueryGiftCardsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<WixGiftCardsGiftCardV1GiftCard>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixGiftCardsGiftCardV1Recipient = {
  /** Email address where the gift card will be sent. */
  email?: Maybe<Scalars['String']>;
  /** Display name shown in the gift card email. */
  name?: Maybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1RecipientInput = {
  /** Email address where the gift card will be sent. */
  email?: InputMaybe<Scalars['String']>;
  /** Display name shown in the gift card email. */
  name?: InputMaybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1SearchGiftCardsRequestInput = {
  /**
   * Search options with text matching, filtering, and aggregation capabilities.
   * Supports searching by gift card code and code suffix.
   */
  search?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonCursorSearchInput>;
};

export type WixGiftCardsGiftCardV1SearchGiftCardsResponse = {
  /** Aggregation data providing insights about the search results. */
  aggregationData?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationData>;
  /** Retrieved gift cards matching the search criteria. */
  giftCards?: Maybe<Array<Maybe<WixGiftCardsGiftCardV1GiftCard>>>;
  /** Paging information for navigating through large result sets. */
  pagingMetadata?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonCursorPagingMetadata>;
};

export type WixGiftCardsGiftCardV1SendGiftCardEmailRequestInput = {
  /** Gift card ID. */
  giftCardId?: InputMaybe<Scalars['String']>;
  /**
   * Recipient email address to send the gift card notification.
   * If not provided, uses the recipient email stored in the gift card's notification info.
   */
  recipientEmail?: InputMaybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1Sender = {
  /** Email address displayed in the gift card notification. */
  email?: Maybe<Scalars['String']>;
  /** Display name shown in the gift card email. */
  name?: Maybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1SenderInput = {
  /** Email address displayed in the gift card notification. */
  email?: InputMaybe<Scalars['String']>;
  /** Display name shown in the gift card email. */
  name?: InputMaybe<Scalars['String']>;
};

export enum WixGiftCardsGiftCardV1Source {
  /** Gift card was created manually via API. */
  MANUAL = 'MANUAL',
  /** Gift card was purchased through an order. */
  ORDER = 'ORDER',
  UNKNOWN_SOURCE = 'UNKNOWN_SOURCE'
}

export type WixGiftCardsGiftCardV1Transaction = {
  /**
   * Monetary amount of the transaction.
   * Positive values represent credits, negative values represent debits.
   */
  amount?: Maybe<WixGiftCardsGiftCardV1Amount>;
  /** Date and time the transaction was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Gift card ID associated with this transaction. */
  giftCard?: Maybe<WixGiftCardsGiftCardV1GiftCard>;
  /** Gift card ID associated with this transaction. */
  giftCardId?: Maybe<Scalars['String']>;
  /** Transaction ID. */
  id?: Maybe<Scalars['String']>;
  /** Whether the transaction adds to or subtracts from the gift card balance. */
  operationType?: Maybe<WixGiftCardsGiftCardV1TransactionOperationType>;
  /** Order details when the transaction is related to an eCommerce purchase or refund. */
  orderInfo?: Maybe<WixGiftCardsGiftCardV1OrderInfo>;
  /** Type of transaction indicating the reason for the balance change. */
  type?: Maybe<WixGiftCardsGiftCardV1TransactionTransactionType>;
  /** Gift card balance after this transaction was applied. */
  updatedBalance?: Maybe<WixGiftCardsGiftCardV1Amount>;
};

export enum WixGiftCardsGiftCardV1TransactionOperationType {
  /** Transaction adds value to the gift card balance. */
  ADD = 'ADD',
  /** Transaction subtracts value from the gift card balance. */
  SUBTRACT = 'SUBTRACT'
}

export enum WixGiftCardsGiftCardV1TransactionTransactionType {
  /** Initial value was assigned when the gift card was created. */
  INITIAL = 'INITIAL',
  /** Manual adjustment made via admin interface or API. */
  MANUAL = 'MANUAL',
  /** Refund was processed, adding value back to the gift card. */
  PAYMENT_METHOD_REFUND = 'PAYMENT_METHOD_REFUND',
  /** Gift card was used to pay for a purchase. */
  REDEEM = 'REDEEM',
  UNKNOWN_TRANSACTION_TYPE = 'UNKNOWN_TRANSACTION_TYPE',
  /** Previous redemption was cancelled, restoring the gift card balance. */
  VOID = 'VOID'
}

export type WixGiftCardsGiftCardV1TriggerGiftCardsAppInstallationFlowEventInput = {
  /** The meta site ID to trigger installation flow for. */
  metaSiteId?: InputMaybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationData = {
  /** key = aggregation name (as derived from search request) */
  results?: Maybe<Array<Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResults>>>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResults = {
  /** Date histogram aggregation results */
  dateHistogram?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResults>;
  /** Field to aggregate by as derived from search request */
  fieldPath?: Maybe<Scalars['String']>;
  /** Group by value aggregation results */
  groupedByValue?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResults>;
  /** User-defined name of aggregation as derived from search request */
  name?: Maybe<Scalars['String']>;
  /** Nested aggregation results */
  nested?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResults>;
  /** Range aggregation results */
  ranges?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsRangeResults>;
  /** Scalar aggregation results */
  scalar?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsScalarResult>;
  /** Type of aggregation that must match provided kind as derived from search request */
  type?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationType>;
  /** Value aggregation results */
  values?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsValueResults>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResults = {
  /** List of date histogram aggregations */
  results?: Maybe<Array<Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult>>>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult = {
  /** Count of documents in the bucket */
  count?: Maybe<Scalars['Int']>;
  /** Date in ISO 8601 format */
  value?: Maybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResults = {
  /** List of value aggregations */
  results?: Maybe<Array<Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult>>>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult = {
  /** Nested aggregations */
  nestedResults?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedAggregationResults>;
  /** Value of the field */
  value?: Maybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedAggregationResults = {
  /** Field to aggregate by, matches the one provided in request */
  fieldPath?: Maybe<Scalars['String']>;
  /** User-defined name of aggregation, matches the one provided in request */
  name?: Maybe<Scalars['String']>;
  /** Range aggregation results */
  ranges?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsRangeResults>;
  /** Scalar aggregation results */
  scalar?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsScalarResult>;
  /** Type of aggregation that matches result */
  type?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationType>;
  /** Value aggregation results */
  values?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsValueResults>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResults = {
  /** List of nested aggregations */
  results?: Maybe<Array<Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsResults>>>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue = {
  /** Date histogram aggregation result */
  dateHistogram?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult>;
  /** Range aggregation result */
  range?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsRangeResult>;
  /** Scalar aggregation result */
  scalar?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsScalarResult>;
  /** Value aggregation result */
  value?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsRangeResult = {
  /** Count of entities in this range */
  count?: Maybe<Scalars['Int']>;
  /** Inclusive lower bound of the range */
  from?: Maybe<Scalars['Float']>;
  /** Exclusive upper bound of the range */
  to?: Maybe<Scalars['Float']>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsResults = {
  /** List of nested aggregations */
  results?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsScalarResult = {
  /** Value of the scalar aggregation */
  value?: Maybe<Scalars['Float']>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult = {
  /** Count of entities with this value */
  count?: Maybe<Scalars['Int']>;
  /** Value of the field */
  value?: Maybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsRangeResults = {
  /** List of ranges returned in same order as requested */
  results?: Maybe<Array<Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult>>>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult = {
  /** Count of entities in this range */
  count?: Maybe<Scalars['Int']>;
  /** Inclusive lower bound of the range */
  from?: Maybe<Scalars['Float']>;
  /** Exclusive upper bound of the range */
  to?: Maybe<Scalars['Float']>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsScalarResult = {
  /** Type of scalar aggregation */
  type?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonScalarType>;
  /** Value of the scalar aggregation */
  value?: Maybe<Scalars['Float']>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsValueResults = {
  /** List of value aggregations */
  results?: Maybe<Array<Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult>>>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult = {
  /** Count of entities with this value */
  count?: Maybe<Scalars['Int']>;
  /** Value of the field */
  value?: Maybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDateHistogramAggregationInput = {
  /** Interval for date histogram aggregation */
  interval?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDateHistogramAggregationInterval>;
};

export enum WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDateHistogramAggregationInterval {
  /** Daily interval */
  DAY = 'DAY',
  /** Hourly interval */
  HOUR = 'HOUR',
  /** Minute interval */
  MINUTE = 'MINUTE',
  /** Monthly interval */
  MONTH = 'MONTH',
  /** Second interval */
  SECOND = 'SECOND',
  UNKNOWN_INTERVAL = 'UNKNOWN_INTERVAL',
  /** Weekly interval */
  WEEK = 'WEEK',
  /** Yearly interval */
  YEAR = 'YEAR'
}

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationInput = {
  /** Date histogram aggregation */
  dateHistogram?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDateHistogramAggregationInput>;
  /** Field to aggregate by, use dot notation to specify json path */
  fieldPath?: InputMaybe<Scalars['String']>;
  /** User-defined name of aggregation, should be unique, will appear in aggregation results */
  name?: InputMaybe<Scalars['String']>;
  /** Nested aggregation */
  nested?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationNestedAggregationInput>;
  /** Range aggregation */
  range?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationRangeAggregationInput>;
  /** Scalar aggregation */
  scalar?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationScalarAggregationInput>;
  /** Type of aggregation, client must provide matching aggregation field below */
  type?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationType>;
  /** Value aggregation */
  value?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationInput>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationNestedAggregationInput = {
  /** Flattened list of aggregations, where each next aggregation is nested within previous one */
  nestedAggregations?: InputMaybe<Array<InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationNestedAggregationNestedAggregationItemInput>>>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationNestedAggregationNestedAggregationItemInput = {
  /** Date histogram aggregation */
  dateHistogram?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationDateHistogramAggregationInput>;
  /** Field to aggregate by, use dont notation to specify json path */
  fieldPath?: InputMaybe<Scalars['String']>;
  /** User-defined name of aggregation, should be unique, will appear in aggregation results */
  name?: InputMaybe<Scalars['String']>;
  /** Range aggregation */
  range?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationRangeAggregationInput>;
  /** Scalar aggregation */
  scalar?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationScalarAggregationInput>;
  /** Type of aggregation, client must provide matching aggregation field below */
  type?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationNestedAggregationNestedAggregationType>;
  /** Value aggregation */
  value?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationInput>;
};

export enum WixGiftCardsGiftCardV1UpstreamWixCommonAggregationNestedAggregationNestedAggregationType {
  /** An aggregation, where result buckets are dynamically built - one per time interval (hour, day, week, etc.) */
  DATE_HISTOGRAM = 'DATE_HISTOGRAM',
  /** An aggregation, where user can define set of ranges - each representing a bucket */
  RANGE = 'RANGE',
  /** A single-value metric aggregation - e.g. min, max, sum, avg */
  SCALAR = 'SCALAR',
  UNKNOWN_AGGREGATION_TYPE = 'UNKNOWN_AGGREGATION_TYPE',
  /** An aggregation where result buckets are dynamically built - one per unique value */
  VALUE = 'VALUE'
}

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationRangeAggregationInput = {
  /** List of range buckets, where during aggregation each entity will be placed in the first bucket where its value falls into based on provided range bounds */
  buckets?: InputMaybe<Array<InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationRangeAggregationRangeBucketInput>>>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationRangeAggregationRangeBucketInput = {
  /** Inclusive lower bound of the range. Required if to is not given */
  from?: InputMaybe<Scalars['Float']>;
  /** Exclusive upper bound of the range. Required if from is not given */
  to?: InputMaybe<Scalars['Float']>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationScalarAggregationInput = {
  /** Define the operator for the scalar aggregation */
  type?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonScalarType>;
};

export enum WixGiftCardsGiftCardV1UpstreamWixCommonAggregationType {
  /** An aggregation, where result buckets are dynamically built - one per time interval (hour, day, week, etc.) */
  DATE_HISTOGRAM = 'DATE_HISTOGRAM',
  /** Multi-level aggregation, where each next aggregation is nested within previous one */
  NESTED = 'NESTED',
  /** An aggregation, where user can define set of ranges - each representing a bucket */
  RANGE = 'RANGE',
  /** A single-value metric aggregation - e.g. min, max, sum, avg */
  SCALAR = 'SCALAR',
  UNKNOWN_AGGREGATION_TYPE = 'UNKNOWN_AGGREGATION_TYPE',
  /** An aggregation where result buckets are dynamically built - one per unique value */
  VALUE = 'VALUE'
}

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationIncludeMissingValuesOptionsInput = {
  /** Can specify custom bucket name. Defaults are [string -> "N/A"], [int -> "0"], [bool -> "false"] ... */
  addToBucket?: InputMaybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationInput = {
  /** Options for including missing values */
  includeOptions?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationIncludeMissingValuesOptionsInput>;
  /** How many aggregations would you like to return? Can be between 1 and 250. 10 is the default. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Should missing values be included or excluded from the aggregation results. Default is EXCLUDE */
  missingValues?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationMissingValues>;
  /** Should sort in ascending or descending order */
  sortDirection?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationSortDirection>;
  /** Should sort by number of matches or value of the field */
  sortType?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationSortType>;
};

export enum WixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationMissingValues {
  /** Should missing values be excluded from the aggregation results */
  EXCLUDE = 'EXCLUDE',
  /** Should missing values be included in the aggregation results */
  INCLUDE = 'INCLUDE'
}

export enum WixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationSortDirection {
  /** Should sort in ascending order */
  ASC = 'ASC',
  /** Should sort in descending order */
  DESC = 'DESC'
}

export enum WixGiftCardsGiftCardV1UpstreamWixCommonAggregationValueAggregationSortType {
  /** Should sort by number of matches */
  COUNT = 'COUNT',
  /** Should sort by value of the field alphabetically */
  VALUE = 'VALUE'
}

export type WixGiftCardsGiftCardV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   * Pass the relevant cursor token from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Maximum number of items to return in the results. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonCursorPagingMetadata = {
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Cursor strings that point to the next page, previous page, or both. */
  cursors?: Maybe<WixGiftCardsGiftCardV1UpstreamWixCommonCursors>;
  /**
   * Whether there are more pages to retrieve following the current page.
   * + `true`: Another page of results can be retrieved.
   * + `false`: This is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonCursorQueryInput = {
  /**
   * Cursor paging options.
   *
   * Learn more about [cursor paging](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#cursor-paging).
   */
  cursorPaging?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object.
   *
   * Learn more about the [filter section](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#the-filter-section).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object.
   *
   * Learn more about the [sort section](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#the-sort-section).
   */
  sort?: InputMaybe<Array<InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonSortingInput>>>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonCursorSearchInput = {
  /** Aggregations | Faceted search: refers to a way to explore large amounts of data by displaying summaries about various partitions of the data and later allowing to narrow the navigation to a specific partition. */
  aggregations?: InputMaybe<Array<InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonAggregationInput>>>;
  /**
   * Cursor paging options.
   *
   * Learn more about [cursor paging](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#cursor-paging).
   */
  cursorPaging?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object.
   *
   * Learn more about the [filter section](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#the-filter-section).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Free text to match in searchable fields. */
  search?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonSearchDetailsInput>;
  /**
   * List of sort objects.
   *
   * Learn more about the [sort section](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#the-sort-section).
   */
  sort?: InputMaybe<Array<InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonSortingInput>>>;
  /**
   * UTC offset or IANA time zone. Valid values are
   * ISO 8601 UTC offsets, such as +02:00 or -06:00,
   * and IANA time zone IDs, such as Europe/Rome
   *
   * Affects all filters and aggregations returned values.
   * You may override this behavior in a specific filter by providing
   * timestamps including time zone. e.g. `"2023-12-20T10:52:34.795Z"`
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type WixGiftCardsGiftCardV1UpstreamWixCommonCursors = {
  /** Cursor string pointing to the next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to the previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export enum WixGiftCardsGiftCardV1UpstreamWixCommonScalarType {
  /** Average of values */
  AVG = 'AVG',
  /** Count of distinct values */
  COUNT_DISTINCT = 'COUNT_DISTINCT',
  /** Maximum value */
  MAX = 'MAX',
  /** Minimum value */
  MIN = 'MIN',
  /** Sum of values */
  SUM = 'SUM',
  UNKNOWN_SCALAR_TYPE = 'UNKNOWN_SCALAR_TYPE'
}

export type WixGiftCardsGiftCardV1UpstreamWixCommonSearchDetailsInput = {
  /** Search term or expression */
  expression?: InputMaybe<Scalars['String']>;
  /** Fields to search in. If empty - will search in all searchable fields. Use dot notation to specify json path */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Flag if should use auto fuzzy search (allowing typos by a managed proximity algorithm) */
  fuzzy?: InputMaybe<Scalars['Boolean']>;
  /** Defines how separate search terms in `expression` are combined */
  mode?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonSearchDetailsMode>;
};

export enum WixGiftCardsGiftCardV1UpstreamWixCommonSearchDetailsMode {
  /** All search terms must be present */
  AND = 'AND',
  /** Any of the search terms must be present */
  OR = 'OR'
}

export enum WixGiftCardsGiftCardV1UpstreamWixCommonSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type WixGiftCardsGiftCardV1UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixGiftCardsGiftCardV1UpstreamWixCommonSortOrder>;
  /**
   * When `field_name` is a property of repeated field that is marked as `MATCH_ITEMS` and sort should be done by
   * a specific element from a collection, filter can/should be provided to ensure correct sort value is picked.
   *
   * If multiple filters are provided, they are combined with AND operator.
   *
   * Example:
   * Given we have document like {"id": "1", "nestedField": [{"price": 10, "region": "EU"}, {"price": 20, "region": "US"}]}
   * and `nestedField` is marked as `MATCH_ITEMS`, to ensure that sorting is done by correct region, filter should be
   * { fieldName: "nestedField.price", "select_items_by": [{"nestedField.region": "US"}] }
   */
  selectItemsBy?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type WixHeadlessV1CreateOAuthAppRequestInput = {
  /** OAuth app to create. */
  oAuthApp?: InputMaybe<WixHeadlessV1OAuthAppInput>;
};

export type WixHeadlessV1CreateOAuthAppResponse = {
  /** Created OAuth app info. */
  oAuthApp?: Maybe<WixHeadlessV1OAuthApp>;
};

export type WixHeadlessV1DeleteOAuthAppRequestInput = {
  /** ID of the OAuth app to delete. */
  oAuthAppId?: InputMaybe<Scalars['String']>;
};

export type WixHeadlessV1GenerateOAuthAppSecretRequestInput = {
  /** ID of the OAuth app to generate a secret for. */
  oAuthAppId?: InputMaybe<Scalars['String']>;
};

export type WixHeadlessV1GenerateOAuthAppSecretResponse = {
  /** Secret generated. */
  oAuthAppSecret?: Maybe<Scalars['String']>;
};

export type WixHeadlessV1GetOAuthAppRequestInput = {
  id: Scalars['ID'];
};

export type WixHeadlessV1OAuthApp = {
  /** For internal use only. */
  allowSecretGeneration?: Maybe<Scalars['Boolean']>;
  /**
   * List of domains to which redirection from Wix is allowed after processes other than authentication.
   *
   * When a client redirects a user to a Wix page (for example, for checkout), the client provides a URL to redirect the user back to.
   * Wix only redirects the user if the URL is in one of the specified domains.
   * @deprecated List of domains to which redirection from Wix is allowed after processes other than authentication.
   *
   * When a client redirects a user to a Wix page (for example, for checkout), the client provides a URL to redirect the user back to.
   * Wix only redirects the user if the URL is in one of the specified domains. Replaced by: allowed_redirect_domains. Removal date: 2023-05-01.
   */
  allowedDomains?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * List of domains to which redirection from Wix is allowed after processes other than authentication.
   *
   * When a client redirects a user to a Wix page (for example, for checkout), the client provides a URL to redirect the user back to.
   * Wix only redirects the user if the URL is in one of the specified domains.
   */
  allowedRedirectDomains?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * List of URIs to which redirection from Wix is allowed after authentication.
   *
   * When a client redirects a user to Wix for authentication, the client provides a URI to redirect the user back to after the user has been authenticated.
   * Wix only redirects the user if the exact URI is contained in this array.
   */
  allowedRedirectUris?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** OAuth application type. */
  applicationType?: Maybe<WixHeadlessV1OAuthAppType>;
  /** Date and time the OAuth app was created, in ISO 8601 format. */
  createdDate?: Maybe<Scalars['String']>;
  /** Description of the OAuth app, as it appears in the dashboard. */
  description?: Maybe<Scalars['String']>;
  /** ID of the OAuth app. */
  id?: Maybe<Scalars['String']>;
  /** External login URL to which users are redirected automatically to authenticate. If no login URL is specified, the user is redirected to Wix to authenticate. */
  loginUrl?: Maybe<Scalars['String']>;
  /** External logout URL to which we invoke when user logout at wix. If no logout URL is specified, the user is logged out only at Wix. */
  logoutUrl?: Maybe<Scalars['String']>;
  /** Display name of the OAuth app, as it appears in the dashboard. */
  name?: Maybe<Scalars['String']>;
  /** Redirect url for Wix-hosted pages. */
  redirectUrlWixPages?: Maybe<Scalars['String']>;
  /** For internal use only. */
  secret?: Maybe<Scalars['String']>;
  /** OAuth technology used by the oauth application. */
  technology?: Maybe<WixHeadlessV1OAuthTechnologies>;
  /**
   * List of domain mappings from external domains to Wix domains.
   * When a user accesses a non-Wix domain, they can be automatically forwarded to the corresponding
   * Wix domain based on these mappings. This enables domain-level redirection from
   * external domains to Wix-hosted pages.
   */
  wixPagesDomainsMappings?: Maybe<Array<Maybe<WixHeadlessV1WixPagesDomainMapping>>>;
};

export type WixHeadlessV1OAuthAppInput = {
  /** For internal use only. */
  allowSecretGeneration?: InputMaybe<Scalars['Boolean']>;
  /**
   * List of domains to which redirection from Wix is allowed after processes other than authentication.
   *
   * When a client redirects a user to a Wix page (for example, for checkout), the client provides a URL to redirect the user back to.
   * Wix only redirects the user if the URL is in one of the specified domains.
   */
  allowedRedirectDomains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * List of URIs to which redirection from Wix is allowed after authentication.
   *
   * When a client redirects a user to Wix for authentication, the client provides a URI to redirect the user back to after the user has been authenticated.
   * Wix only redirects the user if the exact URI is contained in this array.
   */
  allowedRedirectUris?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** OAuth application type. */
  applicationType?: InputMaybe<WixHeadlessV1OAuthAppType>;
  /** Date and time the OAuth app was created, in ISO 8601 format. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Description of the OAuth app, as it appears in the dashboard. */
  description?: InputMaybe<Scalars['String']>;
  /** ID of the OAuth app. */
  id?: InputMaybe<Scalars['String']>;
  /** External login URL to which users are redirected automatically to authenticate. If no login URL is specified, the user is redirected to Wix to authenticate. */
  loginUrl?: InputMaybe<Scalars['String']>;
  /** External logout URL to which we invoke when user logout at wix. If no logout URL is specified, the user is logged out only at Wix. */
  logoutUrl?: InputMaybe<Scalars['String']>;
  /** Display name of the OAuth app, as it appears in the dashboard. */
  name?: InputMaybe<Scalars['String']>;
  /** Redirect url for Wix-hosted pages. */
  redirectUrlWixPages?: InputMaybe<Scalars['String']>;
  /** For internal use only. */
  secret?: InputMaybe<Scalars['String']>;
  /** OAuth technology used by the oauth application. */
  technology?: InputMaybe<WixHeadlessV1OAuthTechnologies>;
  /**
   * List of domain mappings from external domains to Wix domains.
   * When a user accesses a non-Wix domain, they can be automatically forwarded to the corresponding
   * Wix domain based on these mappings. This enables domain-level redirection from
   * external domains to Wix-hosted pages.
   */
  wixPagesDomainsMappings?: InputMaybe<Array<InputMaybe<WixHeadlessV1WixPagesDomainMappingInput>>>;
};

export enum WixHeadlessV1OAuthAppType {
  /** OAuth app type is a mobile application. */
  MOBILE = 'MOBILE',
  /** OAuth app type is not specified. */
  OAUTH_APP_TYPE_UNSPECIFIED = 'OAUTH_APP_TYPE_UNSPECIFIED',
  /** OAuth app type is some other type of application. */
  OTHER = 'OTHER',
  /** OAuth app type is a web application. */
  WEB_APP = 'WEB_APP'
}

export enum WixHeadlessV1OAuthTechnologies {
  /** OAuth technology using Android. */
  ANDROID = 'ANDROID',
  /** OAuth technology using Angular. */
  ANGULAR = 'ANGULAR',
  /** OAuth technology using iOS. */
  IOS = 'IOS',
  /** OAuth technology using JavaScript. */
  JAVASCRIPT = 'JAVASCRIPT',
  /** The OAuth technology is not specified. */
  OAUTH_TECHNOLOGY_UNSPECIFIED = 'OAUTH_TECHNOLOGY_UNSPECIFIED',
  /** OAuth technology using some other kind of technology. */
  OTHER_TECHNOLOGY = 'OTHER_TECHNOLOGY',
  /** OAuth technology using React. */
  REACT = 'REACT',
  /** OAuth technology using React Native. */
  REACT_NATIVE = 'REACT_NATIVE',
  /** OAuth technology using Vue.js. */
  VUE = 'VUE'
}

export type WixHeadlessV1PlatformQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Paging options to limit and skip the number of items. */
  paging?: InputMaybe<WixCommonPagingInput>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"name","order":"ASC"},{"fieldName":"created_date","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type WixHeadlessV1QueryOAuthAppsRequestInput = {
  /** Query options. */
  query?: InputMaybe<WixHeadlessV1PlatformQueryInput>;
};

export type WixHeadlessV1QueryOAuthAppsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<WixHeadlessV1OAuthApp>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixHeadlessV1UpdateOAuthAppRequestInput = {
  /** Explicit list of fields to update. Only fields listed are updated. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Updated OAuth app details. May include some or all fields. */
  oAuthApp?: InputMaybe<WixHeadlessV1OAuthAppInput>;
};

export type WixHeadlessV1UpdateOAuthAppResponse = {
  /** Updated OAuth app info. */
  oAuthApp?: Maybe<WixHeadlessV1OAuthApp>;
};

export type WixHeadlessV1WixPagesDomainMapping = {
  destination?: Maybe<Scalars['String']>;
  origin?: Maybe<Scalars['String']>;
};

export type WixHeadlessV1WixPagesDomainMappingInput = {
  destination?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
};

export type WixInfraTimecapsuleV2CronTzInput = {
  /**
   * Cron expression is a string of five space-separated sub-expressions.
   *
   * * * * * *
   * | | | | |
   * minute of hour | | | day of week
   * hour of day | month of year
   * day of month
   *
   * Field            Accepted values
   * ---------------  -------------------------------------
   * minute of hour   `0..59` `/` `*` `,`
   * hour of day      `0..23` `/` `*` `,`
   * day of month     `1..31` `/` `*` `,` `L` `W`
   * month of year    `1..12` `/` `*` `,`
   * day of week      `0..7` `MON..SUN` `/` `*` `,` `#` `L`
   *
   * Coma separates multiple values:
   * 0,20,40 * * * * => on 0th, 20th and 40th minute
   * Slash selects every Nth value:
   * * /20 * * * * => equivalent to 0,20,40
   * 5/20 * * * * => on 5th, 25th and 45th minute
   * `L` selects the last day of ...
   * 0 0 L * *    => last day of each month
   * 0 0 * * FRIL => the last Friday of the month
   * `W` modifies day of month to be a working day
   * 0 0 15W * * => working day around 15th day of the month (14th if 15th is SAT, 16th if 15th is SUN)
   * 0 0 LW * * => last working day of each month
   * `#` selects Nth occurrence of the day of week in the month
   * 0 0 * * Mon#1 => the first Monday of the month
   *
   * Following aliases are supported: @hourly, @daily, @weekly, @monthly
   *
   * The first execution time will be evaluated based on the client invocation time (approximately the moment the
   * client call returns).
   * All executions will be evaluated in UTC.
   *
   * Example:
   * 00:19:59 - client schedules a task with cron = 0/20 * * * * (every 20-th minute of the hour)
   * 00:20:02 - task reaches Time Capsule database
   * 00:21:00 - task is executed by Time Capsule, the client is triggered with a ~1 minute delay
   * 00:40:00 - task is executed by Time Capsule according to the schedule with no delay
   */
  expression?: InputMaybe<Scalars['String']>;
  /**
   * IANA regional time zone ID.
   * For example "America/New_York", "Asia/Jerusalem", "Europe/Kyiv", "Europe/Vilnius", etc..
   * Equivalent to "UTC" if omitted.
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type WixInfraTimecapsuleV2TaskIdInput = {
  /**
   * A free-form string that together with `namespace` and `task_type` uniquely identifies a task.
   * When there is an entity involved, setting this to be equal to the ID of an entity related to the task is a good option.
   */
  key?: InputMaybe<Scalars['String']>;
  /**
   * A unique identifier of an application or a source that define the task. In most cases this would be the appDefId or
   * Artifact.fullId
   */
  namespace?: InputMaybe<Scalars['String']>;
  /**
   * A free-form string distinguishing different families of tasks within a namespace.
   * For example: "send-promo-email", "ClearTrashBin", "premium expiration reminder"
   */
  taskType?: InputMaybe<Scalars['String']>;
};

export type WixInfraTimecapsuleV2TaskInput = {
  /** A free-form string used to classify tasks. Each task is assigned a topic based on its classifier, and tasks with the same classifier will be routed to the same topic. */
  classifier?: InputMaybe<Scalars['String']>;
  /** Deprecated. Equivalent to cronTz(cron, "UTC") */
  cron?: InputMaybe<Scalars['String']>;
  /** A trigger defined by a cron expression and an optional time zone */
  cronTz?: InputMaybe<WixInfraTimecapsuleV2CronTzInput>;
  /** Task id */
  id?: InputMaybe<WixInfraTimecapsuleV2TaskIdInput>;
  /** A trigger which will fire once at a specified timestamp */
  oneTime?: InputMaybe<Scalars['String']>;
  /** Task payload */
  payload?: InputMaybe<Scalars['JSON']>;
  /** The time when this task is scheduled to trigger. For reoccurring tasks, this will be hold the next time this task will run and will be updated after every run */
  scheduledFor?: InputMaybe<Scalars['String']>;
  /** A Greyhound topic to which the task will be produced when triggered */
  topic?: InputMaybe<Scalars['String']>;
};

export type WixInventoryApiV1PreorderInfo = {
  /** Whether the item is available for preorder. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** Number of products that can be preordered after stock reaches zero. */
  limit?: Maybe<Scalars['Int']>;
  /** A message the buyer will see when the item is out of stock and preorder is enabled. */
  message?: Maybe<Scalars['String']>;
};

export enum WixOnlineprogramsCommonV3ProgramAccessType {
  /** send a join request to the owner and get an approval from him. */
  PRIVATE = 'PRIVATE',
  /** join without approvals */
  PUBLIC = 'PUBLIC',
  /** join possible only after owner invite. */
  SECRET = 'SECRET'
}

export type WixOnlineprogramsCommonV3ProgramDescription = {
  /** step additional details */
  details?: Maybe<Scalars['String']>;
  /** WixMedia image */
  image?: Maybe<WixCommonImage>;
  /** step title */
  title?: Maybe<Scalars['String']>;
  /** WixMedia video */
  video?: Maybe<WixCommonVideoV2>;
};

export type WixOnlineprogramsCommonV3ProgramDescriptionInput = {
  /** step additional details */
  details?: InputMaybe<Scalars['String']>;
  /** WixMedia image */
  image?: InputMaybe<WixCommonImageInput>;
  /** step title */
  title?: InputMaybe<Scalars['String']>;
  /** WixMedia video */
  video?: InputMaybe<WixCommonVideoV2Input>;
};

export type WixOnlineprogramsCommonV3ProgramRestrictions = {
  /** hide steps in the Pending state. */
  hideFutureSteps?: Maybe<Scalars['Boolean']>;
  /** limit of active participants in the program. */
  maxParticipants?: Maybe<Scalars['Int']>;
  /** allow participants complete steps in the certain order. */
  resolveStepsInOrder?: Maybe<Scalars['Boolean']>;
  /** allow program participants to share their progress in group */
  shareProgress?: Maybe<Scalars['Boolean']>;
};

export type WixOnlineprogramsCommonV3ProgramRestrictionsInput = {
  /** hide steps in the Pending state. */
  hideFutureSteps?: InputMaybe<Scalars['Boolean']>;
  /** limit of active participants in the program. */
  maxParticipants?: InputMaybe<Scalars['Int']>;
  /** allow participants complete steps in the certain order. */
  resolveStepsInOrder?: InputMaybe<Scalars['Boolean']>;
  /** allow program participants to share their progress in group */
  shareProgress?: InputMaybe<Scalars['Boolean']>;
};

export type WixOnlineprogramsCommonV3ProgramReward = {
  /** badges participant will get on program complete */
  badgeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** certificate for program. Currently is program GUID */
  certificate?: Maybe<WixOnlineprogramsCommonV3ProgramRewardCertificate>;
  /** on which action rewards must be assigned. */
  trigger?: Maybe<WixOnlineprogramsCommonV3ProgramRewardTrigger>;
};

export type WixOnlineprogramsCommonV3ProgramRewardCertificate = {
  /** date it was connected to program */
  connectedDate?: Maybe<Scalars['String']>;
  /** Certificate for program completion. Currently is program GUID */
  id?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsCommonV3ProgramRewardCertificateInput = {
  /** date it was connected to program */
  connectedDate?: InputMaybe<Scalars['String']>;
  /** Certificate for program completion. Currently is program GUID */
  id?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsCommonV3ProgramRewardInput = {
  /** badges participant will get on program complete */
  badgeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** certificate for program. Currently is program GUID */
  certificate?: InputMaybe<WixOnlineprogramsCommonV3ProgramRewardCertificateInput>;
  /** on which action rewards must be assigned. */
  trigger?: InputMaybe<WixOnlineprogramsCommonV3ProgramRewardTrigger>;
};

export enum WixOnlineprogramsCommonV3ProgramRewardTrigger {
  /** all steps are completed. */
  ALL_STEPS_COMPLETED = 'ALL_STEPS_COMPLETED',
  /** member joins the program */
  JOINED_TO_PROGRAM = 'JOINED_TO_PROGRAM',
  /** at least one step completed */
  STEP_COMPLETED = 'STEP_COMPLETED'
}

export type WixOnlineprogramsCommonV3ProgramSeo = {
  /** image url from description media */
  imageUrl?: Maybe<Scalars['String']>;
  /** schema used by Seo team */
  seoData?: Maybe<ComWixpressAdvancedSeoSeoSchema>;
  /** challenge slug expression. */
  slug?: Maybe<Scalars['String']>;
  /** program url */
  url?: Maybe<WixCommonPageUrl>;
};

export type WixOnlineprogramsCommonV3ProgramSeoInput = {
  /** image url from description media */
  imageUrl?: InputMaybe<Scalars['String']>;
  /** schema used by Seo team */
  seoData?: InputMaybe<ComWixpressAdvancedSeoSeoSchemaInput>;
  /** challenge slug expression. */
  slug?: InputMaybe<Scalars['String']>;
  /** program url */
  url?: InputMaybe<WixCommonPageUrlInput>;
};

export enum WixOnlineprogramsCommonV3ProgramState {
  /** closed program. Joins and sections/steps are not available for participants. */
  ARCHIVED = 'ARCHIVED',
  /** not published program, visible only on BM */
  DRAFT = 'DRAFT',
  /** program isn't available to join. */
  ENDED = 'ENDED',
  /** program visible regarding to restrictions */
  PUBLISHED = 'PUBLISHED'
}

export type WixOnlineprogramsCommonV3ProgramTimeline = {
  /** condition on which the program is completed */
  finishCondition?: Maybe<WixOnlineprogramsCommonV3ProgramTimelineFinishCondition>;
  /** are sections/steps evaluated every day? Or can UoU participate in a self paced mode? */
  selfPaced?: Maybe<Scalars['Boolean']>;
  /** everyone starts on this day */
  startDate?: Maybe<Scalars['String']>;
  /** evaluate after some period of time in days. */
  timeEvaluationOptions?: Maybe<WixOnlineprogramsCommonV3ProgramTimelineTimeEvaluationOptions>;
};

export enum WixOnlineprogramsCommonV3ProgramTimelineFinishCondition {
  /** finish participation when all steps are resolved. */
  ALL_STEPS_COMPLETED = 'ALL_STEPS_COMPLETED',
  /** finish participation after some time. */
  TIME_EVALUATION = 'TIME_EVALUATION',
  UNKNOWN_FINISH_CONDITION = 'UNKNOWN_FINISH_CONDITION'
}

export type WixOnlineprogramsCommonV3ProgramTimelineInput = {
  /** condition on which the program is completed */
  finishCondition?: InputMaybe<WixOnlineprogramsCommonV3ProgramTimelineFinishCondition>;
  /** are sections/steps evaluated every day? Or can UoU participate in a self paced mode? */
  selfPaced?: InputMaybe<Scalars['Boolean']>;
  /** everyone starts on this day */
  startDate?: InputMaybe<Scalars['String']>;
  /** evaluate after some period of time in days. */
  timeEvaluationOptions?: InputMaybe<WixOnlineprogramsCommonV3ProgramTimelineTimeEvaluationOptionsInput>;
};

export type WixOnlineprogramsCommonV3ProgramTimelineTimeEvaluationOptions = {
  /** duration in days */
  durationInDays?: Maybe<Scalars['Int']>;
};

export type WixOnlineprogramsCommonV3ProgramTimelineTimeEvaluationOptionsInput = {
  /** duration in days */
  durationInDays?: InputMaybe<Scalars['Int']>;
};

export type WixOnlineprogramsParticipantsV3ApplyCouponRequestInput = {
  couponCode?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
  participantId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3ApplyCouponResponse = {
  couponId?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

export type WixOnlineprogramsParticipantsV3BulkAddAllToProgramRequestInput = {
  /** Exclude site members. */
  excludeMemberIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Program to which bulk add participants. */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3BulkAddAllToProgramResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
};

export type WixOnlineprogramsParticipantsV3BulkAddToProgramRequestInput = {
  /** Site members. */
  memberIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Program to which bulk add participants. */
  programId?: InputMaybe<Scalars['String']>;
  /** Return added participants in the response or not. */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type WixOnlineprogramsParticipantsV3BulkAddToProgramResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Participants created by bulk action */
  results?: Maybe<Array<Maybe<WixOnlineprogramsParticipantsV3BulkAddToProgramResponseBulkAddToProgramResult>>>;
};

export type WixOnlineprogramsParticipantsV3BulkAddToProgramResponseBulkAddToProgramResult = {
  /** Added participant */
  item?: Maybe<WixOnlineprogramsParticipantsV3Participant>;
  /** Added participant metadata. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixOnlineprogramsParticipantsV3BulkApproveAllParticipantRequestInput = {
  /** Exclude site members. */
  excludeParticipantIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Program to approve all participants. */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3BulkApproveAllParticipantResponse = {
  /** Job id with async process */
  jobId?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3BulkApproveParticipantRequestInput = {
  /** Participants to add */
  participantIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** program to approve participant */
  programId?: InputMaybe<Scalars['String']>;
  /** Return approved participants in the response or not */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type WixOnlineprogramsParticipantsV3BulkApproveParticipantResponse = {
  /** Bulk action metadata */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Participants approved by bulk action */
  results?: Maybe<Array<Maybe<WixOnlineprogramsParticipantsV3BulkApproveParticipantResponseBulkApproveParticipantResult>>>;
};

export type WixOnlineprogramsParticipantsV3BulkApproveParticipantResponseBulkApproveParticipantResult = {
  /** Approved or existing participant */
  item?: Maybe<WixOnlineprogramsParticipantsV3Participant>;
  /** Approved participant metadata */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixOnlineprogramsParticipantsV3BulkCreateResolvedStepMigrationRequestInput = {
  /** resolved steps to create */
  resolvedSteps?: InputMaybe<Array<InputMaybe<WixOnlineprogramsParticipantsV3ResolvedStepInput>>>;
};

export type WixOnlineprogramsParticipantsV3BulkCreateResolvedStepMigrationResponse = {
  /** metadata about resolved steps that were to insert */
  bulkActionMetadata?: Maybe<WixOnlineprogramsParticipantsV3UpstreamWixCommonBulkActionMetadata>;
  /** results of bulk insertion */
  results?: Maybe<Array<Maybe<WixOnlineprogramsParticipantsV3BulkCreateResolvedStepMigrationResponseBulkResolvedStepResult>>>;
};

export type WixOnlineprogramsParticipantsV3BulkCreateResolvedStepMigrationResponseBulkResolvedStepResult = {
  /** resolved step itself */
  item?: Maybe<WixOnlineprogramsParticipantsV3ResolvedStep>;
  /** info about whether resolved step was inserted etc */
  itemMetadata?: Maybe<WixOnlineprogramsParticipantsV3UpstreamWixCommonItemMetadata>;
};

export type WixOnlineprogramsParticipantsV3BulkInviteAllToProgramRequestInput = {
  /** Exclude site members. */
  excludeMemberIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Program to which bulk add participants. */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3BulkInviteAllToProgramResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
};

export type WixOnlineprogramsParticipantsV3BulkInviteToProgramRequestInput = {
  /** Return added participants in the response or not. */
  memberIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Program to which bulk invite participants. */
  programId?: InputMaybe<Scalars['String']>;
  /** Return invited participants in the response or not. */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type WixOnlineprogramsParticipantsV3BulkInviteToProgramResponse = {
  /** Bulk action metadata. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Participants created by bulk action */
  results?: Maybe<Array<Maybe<WixOnlineprogramsParticipantsV3BulkInviteToProgramResponseBulkInviteToProgramResult>>>;
};

export type WixOnlineprogramsParticipantsV3BulkInviteToProgramResponseBulkInviteToProgramResult = {
  /** Invited participant */
  item?: Maybe<WixOnlineprogramsParticipantsV3Participant>;
  /** Invited participant metadata. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixOnlineprogramsParticipantsV3CompleteParticipantRequestInput = {
  /** ID of participant */
  participantId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3CompleteParticipantResponse = {
  /** Updated participant */
  participant?: Maybe<WixOnlineprogramsParticipantsV3Participant>;
};

export type WixOnlineprogramsParticipantsV3DeleteAllParticipantResolvedStepsRequestInput = {
  /** participant id to remove all steps */
  participantId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3DeleteAllParticipantResolvedStepsResponse = {
  /** Count of resolved steps that failed to be deleted */
  failedCount?: Maybe<Scalars['Int']>;
  /** Total count of resolved steps for participant */
  resolvedStepsTotal?: Maybe<Scalars['Int']>;
  /** Count of successfully deleted resolved steps */
  successfulCount?: Maybe<Scalars['Int']>;
};

export type WixOnlineprogramsParticipantsV3DeleteParticipantRequestInput = {
  /** Participants to delete */
  participantId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3ExportParticipantsStatsRequestInput = {
  /** program id to export data from */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3GetAccessStatusResponse = {
  /** True if participants cannot access online programs due to some limitations */
  isBlocked?: Maybe<Scalars['Boolean']>;
};

export type WixOnlineprogramsParticipantsV3GetCompletionStatsRequestInput = {
  /** program id to get stats for */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3GetCompletionStatsResponse = {
  /** Number of participants that completed the program */
  completedAll?: Maybe<Scalars['Int']>;
  /** Percentage of participants that completed the program */
  completionRate?: Maybe<Scalars['Float']>;
};

export type WixOnlineprogramsParticipantsV3GetParticipantRequestInput = {
  id: Scalars['ID'];
};

export type WixOnlineprogramsParticipantsV3GetPremiumStatsResponse = {
  /** Count of active participants on the site */
  activeParticipantsCount?: Maybe<Scalars['Int']>;
  /** Limit of active participants on a site without premium */
  activeParticipantsLimit?: Maybe<Scalars['Int']>;
  /** True if site has Online Programs premium feature */
  hasPremium?: Maybe<Scalars['Boolean']>;
};

export type WixOnlineprogramsParticipantsV3GetProgramSummariesRequestInput = {
  /** Programs to get summary about */
  programIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixOnlineprogramsParticipantsV3GetProgramSummariesResponse = {
  /** summaries for each program in the same order as program_ids */
  summaries?: Maybe<Array<Maybe<WixOnlineprogramsParticipantsV3ParticipantsSummary>>>;
};

export type WixOnlineprogramsParticipantsV3GetResolvedStepRequestInput = {
  participantId?: InputMaybe<Scalars['String']>;
  stepId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3GetResolvedStepResponse = {
  resolvedStep?: Maybe<WixOnlineprogramsParticipantsV3ResolvedStep>;
};

export type WixOnlineprogramsParticipantsV3GetStatisticsRequestInput = {
  /** Program to get statistics about */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3GetStatisticsResponse = {
  /** number of participants waiting for the owner payment confirmation. */
  totalApprovalWaiting?: Maybe<Scalars['Int']>;
  /** number of pending join requests */
  totalCompleted?: Maybe<Scalars['Int']>;
  /** number of invited members. */
  totalFailed?: Maybe<Scalars['Int']>;
  /** number of active and finished participants. */
  totalJoined?: Maybe<Scalars['Int']>;
  /** number of participant who started progress on program */
  totalWithProgress?: Maybe<Scalars['Int']>;
  /** number of participants who not started progress on program */
  totalWithoutProgress?: Maybe<Scalars['Int']>;
};

export type WixOnlineprogramsParticipantsV3IssueCertificateRequestInput = {
  /** Participant to get certificate */
  participantId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3IssueCertificateResponse = {
  /** Updated participant */
  participant?: Maybe<WixOnlineprogramsParticipantsV3Participant>;
};

export type WixOnlineprogramsParticipantsV3JoinProgramRequestInput = {
  /** Program to join */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3JoinProgramResponse = {
  /** Created participant with corresponding state */
  participant?: Maybe<WixOnlineprogramsParticipantsV3Participant>;
};

export type WixOnlineprogramsParticipantsV3LeaveProgramRequestInput = {
  /** Participant id to leave program */
  participantId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3ListResolvedStepsRequestInput = {
  participantId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3ListResolvedStepsResponse = {
  resolvedSteps?: Maybe<Array<Maybe<WixOnlineprogramsParticipantsV3ResolvedStep>>>;
};

export type WixOnlineprogramsParticipantsV3Membership = {
  /** number of completed steps */
  completedStepsCount?: Maybe<Scalars['Int']>;
  /** Referenced participant id */
  participant?: Maybe<WixOnlineprogramsParticipantsV3Participant>;
  /** Referenced participant id */
  participantId?: Maybe<Scalars['String']>;
  /** state of the participant */
  state?: Maybe<WixOnlineprogramsParticipantsV3ParticipantState>;
};

export type WixOnlineprogramsParticipantsV3Participant = {
  /** options for auto removed participant */
  autoRemovedOptions?: Maybe<WixOnlineprogramsParticipantsV3ParticipantAutoRemovedOptions>;
  /** Certificate issued to participant */
  certificate?: Maybe<WixOnlineprogramsParticipantsV3ParticipantCertificate>;
  completedOptions?: Maybe<WixOnlineprogramsParticipantsV3ParticipantCompletedOptions>;
  createdDate?: Maybe<Scalars['String']>;
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  failedOptions?: Maybe<WixOnlineprogramsParticipantsV3ParticipantFailedOptions>;
  /** Participant ID. */
  id?: Maybe<Scalars['String']>;
  joinedOptions?: Maybe<WixOnlineprogramsParticipantsV3ParticipantJoinedOptions>;
  /** Member ID of participant on site */
  member?: Maybe<ComWixpressMembersApiMember>;
  /** Member ID of participant on site */
  memberId?: Maybe<Scalars['String']>;
  paymentPendingOptions?: Maybe<WixOnlineprogramsParticipantsV3ParticipantPaymentPendingOptions>;
  /** Program ID which participant participates in */
  programId?: Maybe<Scalars['String']>;
  /** Program completion progress */
  progress?: Maybe<WixOnlineprogramsParticipantsV3Progress>;
  revision?: Maybe<Scalars['Long']>;
  /** state of participation in the program */
  state?: Maybe<WixOnlineprogramsParticipantsV3ParticipantState>;
  suspendedOptions?: Maybe<WixOnlineprogramsParticipantsV3ParticipantSuspendedOptions>;
  updatedDate?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3ParticipantAutoRemovedOptions = {
  /** date participant started the program */
  startDate?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3ParticipantCertificate = {
  /** when certificate was issued, UTC */
  issuedDate?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3ParticipantCompletedOptions = {
  /** date participant started the program */
  startDate?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3ParticipantFailedOptions = {
  /** date participant started the program */
  startDate?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3ParticipantJoinedOptions = {
  freeCouponOptions?: Maybe<WixOnlineprogramsParticipantsV3ParticipantJoinedOptionsFreeCouponOptions>;
  joinPath?: Maybe<WixOnlineprogramsParticipantsV3ParticipantJoinedOptionsJoinPath>;
  paidPlanOptions?: Maybe<WixOnlineprogramsParticipantsV3ParticipantJoinedOptionsPaidPlanOptions>;
  singlePaymentOptions?: Maybe<WixOnlineprogramsParticipantsV3ParticipantJoinedOptionsSinglePaymentOptions>;
  startDate?: Maybe<Scalars['String']>;
  timeZone?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3ParticipantJoinedOptionsFreeCouponOptions = {
  couponId?: Maybe<Scalars['String']>;
};

export enum WixOnlineprogramsParticipantsV3ParticipantJoinedOptionsJoinPath {
  /** Member was added to the program by site owner */
  ADDED = 'ADDED',
  /** Member joined to the program for free */
  FREE = 'FREE',
  /** Member joined with the Free Coupon */
  FREE_COUPON = 'FREE_COUPON',
  /** Member has Paid Plan to join */
  PAID_PLAN = 'PAID_PLAN',
  /** Member paid once to join the program */
  SINGLE_PAYMENT = 'SINGLE_PAYMENT',
  UNKNOWN_JOIN_PATH = 'UNKNOWN_JOIN_PATH'
}

export type WixOnlineprogramsParticipantsV3ParticipantJoinedOptionsPaidPlanOptions = {
  planIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type WixOnlineprogramsParticipantsV3ParticipantJoinedOptionsSinglePaymentOptions = {
  orderId?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3ParticipantPaymentPendingOptions = {
  /** Offline payment transaction */
  offlineTrxId?: Maybe<Scalars['String']>;
  /** Pricing plans */
  paidPlanIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Payment order */
  paymentOrderId?: Maybe<Scalars['String']>;
};

export enum WixOnlineprogramsParticipantsV3ParticipantState {
  /** Member asked owner to participate in program */
  APPROVAL_PENDING = 'APPROVAL_PENDING',
  /** Participant removed automatically after some program condition */
  AUTO_REMOVED = 'AUTO_REMOVED',
  /** Participant completed the program, and could join again */
  COMPLETED = 'COMPLETED',
  /** Participant failed to complete the program, and could join again */
  FAILED = 'FAILED',
  /** Member invited to participate in program */
  INVITED = 'INVITED',
  /** Member joined the program and became participant */
  JOINED = 'JOINED',
  PAYMENT_PENDING = 'PAYMENT_PENDING',
  /** Participant with ended pricing plan (PP), will be joined as renew PP */
  SUSPENDED = 'SUSPENDED',
  /** Unknown state */
  UNKNOWN_STATE = 'UNKNOWN_STATE'
}

export type WixOnlineprogramsParticipantsV3ParticipantSuspendedOptions = {
  /** date participant started the program */
  startDate?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3ParticipantsBulkCompleteEventInput = {
  /** Optional cursor for the next result page */
  cursorNext?: InputMaybe<Scalars['String']>;
  /** Program ID */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3ParticipantsBulkDeleteEventInput = {
  /** Optional cursor for the next result page */
  cursorNext?: InputMaybe<Scalars['String']>;
  /** Program ID */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3ParticipantsSummary = {
  /** Membership of the participant; if participant is not in the program, this field will be empty */
  membership?: Maybe<WixOnlineprogramsParticipantsV3Membership>;
  /** Referenced program id */
  program?: Maybe<WixOnlineprogramsProgramsV3Program>;
  /** Referenced program id */
  programId?: Maybe<Scalars['String']>;
  /** Statistics for the program */
  statistic?: Maybe<WixOnlineprogramsParticipantsV3Statistic>;
};

export type WixOnlineprogramsParticipantsV3ProgramSummary = {
  /** Membership of the participant; if participant is not in the program, this field will be empty */
  membership?: Maybe<WixOnlineprogramsParticipantsV3Membership>;
  /** Program */
  program?: Maybe<WixOnlineprogramsProgramsV3Program>;
  /** Statistic for the program */
  statistic?: Maybe<WixOnlineprogramsParticipantsV3Statistic>;
};

export type WixOnlineprogramsParticipantsV3Progress = {
  /** Completion percentage */
  completionPercentage?: Maybe<Scalars['Float']>;
  /** Total number of program steps available to resolve */
  totalStepsAvailable?: Maybe<Scalars['Int']>;
  /** Number of program steps completed by member */
  totalStepsCompleted?: Maybe<Scalars['Int']>;
};

export type WixOnlineprogramsParticipantsV3QueryParticipantsRequestInput = {
  /** Platformized query */
  query?: InputMaybe<WixOnlineprogramsParticipantsV3UpstreamWixQueryCursorQueryInput>;
};

export type WixOnlineprogramsParticipantsV3QueryParticipantsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<WixOnlineprogramsParticipantsV3Participant>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixOnlineprogramsParticipantsV3QueryProgramSummariesRequestInput = {
  /**
   * Basically the query to sort and query the programs;
   * Works exactly the same as the query in QueryPrograms request
   */
  query?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonQueryV2Input>;
};

export type WixOnlineprogramsParticipantsV3QueryProgramSummariesResponse = {
  /** paging metadata */
  pagingMetadata?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonPagingMetadataV2>;
  /** summaries */
  summaries?: Maybe<Array<Maybe<WixOnlineprogramsParticipantsV3ProgramSummary>>>;
};

export type WixOnlineprogramsParticipantsV3QueryResolvedStepsRequestInput = {
  query?: InputMaybe<WixOnlineprogramsParticipantsV3UpstreamWixQueryCursorQueryInput>;
};

export type WixOnlineprogramsParticipantsV3QueryResolvedStepsResponse = {
  pagingMetadata?: Maybe<WixOnlineprogramsParticipantsV3UpstreamWixCommonCursorPagingMetadata>;
  resolvedSteps?: Maybe<Array<Maybe<WixOnlineprogramsParticipantsV3ResolvedStep>>>;
};

export type WixOnlineprogramsParticipantsV3ResolveStepRequestInput = {
  participantId?: InputMaybe<Scalars['String']>;
  quizSubmissionId?: InputMaybe<Scalars['String']>;
  stepId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3ResolveStepResponse = {
  resolvedStep?: Maybe<WixOnlineprogramsParticipantsV3ResolvedStep>;
};

export type WixOnlineprogramsParticipantsV3ResolvedStep = {
  /** created date of resolved step */
  createdDate?: Maybe<Scalars['String']>;
  /** earned score for resolved step */
  earnedScore?: Maybe<Scalars['Int']>;
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** participant who resolved step */
  participant?: Maybe<WixOnlineprogramsParticipantsV3Participant>;
  /** participant who resolved step */
  participantId?: Maybe<Scalars['String']>;
  /** step passing grade */
  passingGrade?: Maybe<Scalars['Int']>;
  /** program step been resolve */
  programStepId?: Maybe<Scalars['String']>;
  /** quiz submission */
  quizSubmissionId?: Maybe<Scalars['String']>;
  /** resolved step status */
  status?: Maybe<WixOnlineprogramsParticipantsV3ResolvedStepStatus>;
  /** program step been resolve */
  step?: Maybe<WixOnlineprogramsStepsV3Step>;
  /** updated date of resolved step */
  updatedDate?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3ResolvedStepInput = {
  /** created date of resolved step */
  createdDate?: InputMaybe<Scalars['String']>;
  /** earned score for resolved step */
  earnedScore?: InputMaybe<Scalars['Int']>;
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** participant who resolved step */
  participantId?: InputMaybe<Scalars['String']>;
  /** step passing grade */
  passingGrade?: InputMaybe<Scalars['Int']>;
  /** program step been resolve */
  programStepId?: InputMaybe<Scalars['String']>;
  /** quiz submission */
  quizSubmissionId?: InputMaybe<Scalars['String']>;
  /** resolved step status */
  status?: InputMaybe<WixOnlineprogramsParticipantsV3ResolvedStepStatus>;
  /** updated date of resolved step */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export enum WixOnlineprogramsParticipantsV3ResolvedStepStatus {
  /** step completed */
  COMPLETED = 'COMPLETED',
  /** participant failed to resolve step */
  FAILED = 'FAILED'
}

export type WixOnlineprogramsParticipantsV3RevertCouponRequestInput = {
  couponId?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
  participantId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3RevertCouponResponse = {
  total?: Maybe<Scalars['Float']>;
};

export type WixOnlineprogramsParticipantsV3Statistic = {
  /** number of join requests */
  approvalPending?: Maybe<Scalars['Long']>;
  /** number of finished participants */
  completed?: Maybe<Scalars['Long']>;
  /** number of failed participants */
  failed?: Maybe<Scalars['Long']>;
  /** number of participants who started the program */
  inProgress?: Maybe<Scalars['Long']>;
  /** number of invited members */
  invited?: Maybe<Scalars['Long']>;
  /** number of joined participants */
  joined?: Maybe<Scalars['Long']>;
  /** number of participants waiting for the owner payment confirmation */
  paymentPending?: Maybe<Scalars['Long']>;
  /** number of suspended participants */
  suspended?: Maybe<Scalars['Long']>;
};

export type WixOnlineprogramsParticipantsV3UndoStepRequestInput = {
  participantId?: InputMaybe<Scalars['String']>;
  stepId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3UpstreamWixCommonBulkActionMetadata = {
  /** Number of items that couldn't be processed. */
  totalFailures?: Maybe<Scalars['Int']>;
  /** Number of items that were successfully processed. */
  totalSuccesses?: Maybe<Scalars['Int']>;
  /** Number of failures without details because detailed failure threshold was exceeded. */
  undetailedFailures?: Maybe<Scalars['Int']>;
};

export type WixOnlineprogramsParticipantsV3UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixOnlineprogramsParticipantsV3UpstreamWixCommonCursorPagingMetadata = {
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Offset that was requested. */
  cursors?: Maybe<WixOnlineprogramsParticipantsV3UpstreamWixCommonCursors>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
};

export type WixOnlineprogramsParticipantsV3UpstreamWixCommonCursors = {
  /** Cursor pointing to next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsParticipantsV3UpstreamWixCommonItemMetadata = {
  /** Details about the error in case of failure. */
  error?: Maybe<WixApiApplicationError>;
  /** Item ID. Should always be available, unless it's impossible (for example, when failing to create an item). */
  id?: Maybe<Scalars['String']>;
  /** Index of the item within the request array. Allows for correlation between request and response items. */
  originalIndex?: Maybe<Scalars['Int']>;
  /** Whether the requested action was successful for this item. When `false`, the `error` field is populated. */
  success?: Maybe<Scalars['Boolean']>;
};

export enum WixOnlineprogramsParticipantsV3UpstreamWixCommonSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type WixOnlineprogramsParticipantsV3UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixOnlineprogramsParticipantsV3UpstreamWixCommonSortOrder>;
};

export type WixOnlineprogramsParticipantsV3UpstreamWixQueryCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixOnlineprogramsParticipantsV3UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixOnlineprogramsParticipantsV3UpstreamWixCommonSortingInput>>>;
};

export enum WixOnlineprogramsProgramsV3AccessType {
  /** send a join request to the owner and get an approval from him. */
  PRIVATE = 'PRIVATE',
  /** join without approvals */
  PUBLIC = 'PUBLIC',
  /** join possible only after owner invite. */
  SECRET = 'SECRET'
}

export type WixOnlineprogramsProgramsV3ArchiveProgramRequestInput = {
  /** Program to archive */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3ArchiveProgramResponse = {
  /** Archived program */
  program?: Maybe<WixOnlineprogramsProgramsV3Program>;
};

export type WixOnlineprogramsProgramsV3BulkCreateProgramsMigrationRequestInput = {
  /** List of programs you want to create */
  programs?: InputMaybe<Array<InputMaybe<WixOnlineprogramsProgramsV3BulkCreateProgramsMigrationRequestProgramMigrationInput>>>;
};

export type WixOnlineprogramsProgramsV3BulkCreateProgramsMigrationRequestProgramMigrationInput = {
  /** program to create */
  program?: InputMaybe<WixOnlineprogramsProgramsV3ProgramInput>;
  /** section ids in program */
  sectionIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** step ids in program */
  stepIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixOnlineprogramsProgramsV3BulkCreateProgramsMigrationResponse = {
  /** Metadata about whole bulk action. */
  bulkActionMetadata?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonBulkActionMetadata>;
  /** Results of bulk action. */
  results?: Maybe<Array<Maybe<WixOnlineprogramsProgramsV3BulkProgramResult>>>;
};

export type WixOnlineprogramsProgramsV3BulkProgramResult = {
  /** Action type of bulk action (INSERT OR UPDATE) for that endpoint. */
  action?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonBulkActionType>;
  /** Item itself (empty if return_entity in request is false). */
  item?: Maybe<WixOnlineprogramsProgramsV3Program>;
  /** Metadata of item. */
  itemMetadata?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonItemMetadata>;
};

export type WixOnlineprogramsProgramsV3BulkUpdateProgramsRequestInput = {
  /** List of programs you want to update */
  programs?: InputMaybe<Array<InputMaybe<WixOnlineprogramsProgramsV3BulkUpdateProgramsRequestMaskedProgramInput>>>;
  /** set to `true` if you wish to receive back the created programs in the response */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type WixOnlineprogramsProgramsV3BulkUpdateProgramsRequestMaskedProgramInput = {
  /** Explicit list of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Program to be updated, may be partial */
  program?: InputMaybe<WixOnlineprogramsProgramsV3ProgramInput>;
};

export type WixOnlineprogramsProgramsV3BulkUpdateProgramsResponse = {
  /** metadata */
  bulkActionMetadata?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonBulkActionMetadata>;
  results?: Maybe<Array<Maybe<WixOnlineprogramsProgramsV3BulkUpdateProgramsResponseBulkUpdateProgramResult>>>;
};

export type WixOnlineprogramsProgramsV3BulkUpdateProgramsResponseBulkUpdateProgramResult = {
  /** Only exists if `returnEntity` was set to true in the request */
  item?: Maybe<WixOnlineprogramsProgramsV3Program>;
  /** item metadata */
  itemMetadata?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonItemMetadata>;
};

export type WixOnlineprogramsProgramsV3ContentSummary = {
  /** number of sections in program */
  sectionCount?: Maybe<Scalars['Int']>;
  /** number of steps in program */
  stepCount?: Maybe<Scalars['Int']>;
};

export type WixOnlineprogramsProgramsV3ContentSummaryInput = {
  /** number of sections in program */
  sectionCount?: InputMaybe<Scalars['Int']>;
  /** number of steps in program */
  stepCount?: InputMaybe<Scalars['Int']>;
};

export type WixOnlineprogramsProgramsV3CountProgramsRequestInput = {
  /** filter for which count is requested */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type WixOnlineprogramsProgramsV3CountProgramsResponse = {
  /** count of programs matching filter */
  count?: Maybe<Scalars['Int']>;
};

export type WixOnlineprogramsProgramsV3CreateProgramRequestInput = {
  /** Program to be created. */
  program?: InputMaybe<WixOnlineprogramsProgramsV3ProgramInput>;
};

export type WixOnlineprogramsProgramsV3CreateProgramResponse = {
  /** The created Program. */
  program?: Maybe<WixOnlineprogramsProgramsV3Program>;
};

export type WixOnlineprogramsProgramsV3DeleteProgramRequestInput = {
  /** Id of the Program to delete. */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3Description = {
  details?: Maybe<Scalars['String']>;
  /** WixMedia image */
  image?: Maybe<WixCommonImage>;
  title?: Maybe<Scalars['String']>;
  /** WixMedia video */
  video?: Maybe<WixCommonVideoV2>;
};

export type WixOnlineprogramsProgramsV3DescriptionInput = {
  details?: InputMaybe<Scalars['String']>;
  /** WixMedia image */
  image?: InputMaybe<WixCommonImageInput>;
  title?: InputMaybe<Scalars['String']>;
  /** WixMedia video */
  video?: InputMaybe<WixCommonVideoV2Input>;
};

export type WixOnlineprogramsProgramsV3DuplicateProgramRequestInput = {
  /** Program to be duplicated from. */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3DuplicateProgramResponse = {
  /** The created Program. */
  program?: Maybe<WixOnlineprogramsProgramsV3Program>;
};

export type WixOnlineprogramsProgramsV3EndProgramRequestInput = {
  /** Program to finish */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3EndProgramResponse = {
  /** Finished program */
  program?: Maybe<WixOnlineprogramsProgramsV3Program>;
};

export type WixOnlineprogramsProgramsV3GetProgramMembershipRequestInput = {
  /** program to get membership */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3GetProgramMembershipResponse = {
  /** membership */
  programMembership?: Maybe<WixOnlineprogramsProgramsV3ProgramMembership>;
};

export type WixOnlineprogramsProgramsV3GetProgramRequestInput = {
  id: Scalars['ID'];
};

export type WixOnlineprogramsProgramsV3ListProgramMembershipsRequestInput = {
  /** paging */
  paging?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonCursorPagingInput>;
};

export type WixOnlineprogramsProgramsV3ListProgramMembershipsResponse = {
  /** metadata */
  pagingMetadata?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonCursorPagingMetadata>;
  /** memberships */
  programMemberships?: Maybe<Array<Maybe<WixOnlineprogramsProgramsV3ProgramMembership>>>;
};

export type WixOnlineprogramsProgramsV3ListSampleProgramsResponse = {
  /** sample programs */
  programs?: Maybe<Array<Maybe<WixOnlineprogramsProgramsV3Program>>>;
};

export type WixOnlineprogramsProgramsV3Membership = {
  /** participant in this program */
  participant?: Maybe<WixOnlineprogramsParticipantsV3Participant>;
  /** participant in this program */
  participantId?: Maybe<Scalars['String']>;
  /** participant's state */
  participantState?: Maybe<WixOnlineprogramsProgramsV3MembershipParticipantState>;
};

export enum WixOnlineprogramsProgramsV3MembershipParticipantState {
  /** participant completed program */
  COMPLETED = 'COMPLETED',
  /** participant failed to complete program in time */
  FAILED = 'FAILED',
  /** participant invited to program */
  INVITED = 'INVITED',
  /** participant joined program */
  JOINED = 'JOINED',
  /** participant asked to join the program */
  JOIN_REQUESTED = 'JOIN_REQUESTED'
}

export type WixOnlineprogramsProgramsV3Program = {
  /** join flow options. */
  accessType?: Maybe<WixOnlineprogramsProgramsV3AccessType>;
  /** assigned categories */
  categoryIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** number of content entities in program */
  contentSummary?: Maybe<WixOnlineprogramsProgramsV3ContentSummary>;
  createdDate?: Maybe<Scalars['String']>;
  /** general program info. */
  description?: Maybe<WixOnlineprogramsProgramsV3Description>;
  /** extensible field */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** Program ID. */
  id?: Maybe<Scalars['String']>;
  /** user id of owner, who created this program */
  ownerUserId?: Maybe<Scalars['String']>;
  participantsVirtualReference?: Maybe<WixOnlineprogramsParticipantsV3QueryParticipantsResponse>;
  /** single-payment price. */
  price?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonMoney>;
  /** participant limitation, step-completion pace and etc. */
  restrictions?: Maybe<WixOnlineprogramsProgramsV3Restrictions>;
  revision?: Maybe<Scalars['Long']>;
  /** rewards to be assigned after reaching some of the program milestones. */
  rewards?: Maybe<Array<Maybe<WixOnlineprogramsProgramsV3Reward>>>;
  /** seo settings. */
  seo?: Maybe<WixOnlineprogramsProgramsV3Seo>;
  /** if true -> invoice is sent to the customer who purchased the program via single payment; else -> payment confirmation email is sent */
  shouldSendInvoice?: Maybe<Scalars['Boolean']>;
  /** connected social group. */
  socialGroupId?: Maybe<Scalars['String']>;
  /** current program state / does participant need it? */
  state?: Maybe<WixOnlineprogramsProgramsV3State>;
  stateUpdatedDate?: Maybe<Scalars['String']>;
  /** current program state in v2 format */
  status?: Maybe<WixOnlineprogramsProgramsV3ProgramStatus>;
  /** date of the last status update */
  statusUpdatedDate?: Maybe<Scalars['String']>;
  /** timeline type -> Self-paced, time-restricted. */
  timeline?: Maybe<WixOnlineprogramsProgramsV3Timeline>;
  updatedDate?: Maybe<Scalars['String']>;
  /** settings related to video steps in programs */
  videoStepsSettings?: Maybe<WixOnlineprogramsProgramsV3VideoStepsSettings>;
};


export type WixOnlineprogramsProgramsV3ProgramParticipantsVirtualReferenceArgs = {
  queryInput?: InputMaybe<WixOnlineprogramsParticipantsV3QueryParticipantsRequestInput>;
};

export type WixOnlineprogramsProgramsV3ProgramInput = {
  /** join flow options. */
  accessType?: InputMaybe<WixOnlineprogramsProgramsV3AccessType>;
  /** assigned categories */
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** number of content entities in program */
  contentSummary?: InputMaybe<WixOnlineprogramsProgramsV3ContentSummaryInput>;
  createdDate?: InputMaybe<Scalars['String']>;
  /** general program info. */
  description?: InputMaybe<WixOnlineprogramsProgramsV3DescriptionInput>;
  /** extensible field */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** Program ID. */
  id?: InputMaybe<Scalars['String']>;
  /** user id of owner, who created this program */
  ownerUserId?: InputMaybe<Scalars['String']>;
  /** single-payment price. */
  price?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonMoneyInput>;
  /** participant limitation, step-completion pace and etc. */
  restrictions?: InputMaybe<WixOnlineprogramsProgramsV3RestrictionsInput>;
  revision?: InputMaybe<Scalars['Long']>;
  /** rewards to be assigned after reaching some of the program milestones. */
  rewards?: InputMaybe<Array<InputMaybe<WixOnlineprogramsProgramsV3RewardInput>>>;
  /** seo settings. */
  seo?: InputMaybe<WixOnlineprogramsProgramsV3SeoInput>;
  /** if true -> invoice is sent to the customer who purchased the program via single payment; else -> payment confirmation email is sent */
  shouldSendInvoice?: InputMaybe<Scalars['Boolean']>;
  /** connected social group. */
  socialGroupId?: InputMaybe<Scalars['String']>;
  /** current program state / does participant need it? */
  state?: InputMaybe<WixOnlineprogramsProgramsV3State>;
  stateUpdatedDate?: InputMaybe<Scalars['String']>;
  /** current program state in v2 format */
  status?: InputMaybe<WixOnlineprogramsProgramsV3ProgramStatus>;
  /** date of the last status update */
  statusUpdatedDate?: InputMaybe<Scalars['String']>;
  /** timeline type -> Self-paced, time-restricted. */
  timeline?: InputMaybe<WixOnlineprogramsProgramsV3TimelineInput>;
  updatedDate?: InputMaybe<Scalars['String']>;
  /** settings related to video steps in programs */
  videoStepsSettings?: InputMaybe<WixOnlineprogramsProgramsV3VideoStepsSettingsInput>;
};

export type WixOnlineprogramsProgramsV3ProgramMembership = {
  /** participant's membership */
  membership?: Maybe<WixOnlineprogramsProgramsV3Membership>;
  /** program */
  program?: Maybe<WixOnlineprogramsProgramsV3Program>;
};

export enum WixOnlineprogramsProgramsV3ProgramStatus {
  /** closed program. Joins and sections/steps are not available for participants. */
  ARCHIVED = 'ARCHIVED',
  /** not published program, visible only on BM */
  DRAFT = 'DRAFT',
  /** program isn't available to join. */
  ENDED = 'ENDED',
  /** program visible regarding to restrictions */
  PUBLISHED = 'PUBLISHED',
  /** unknown state */
  UNKNOWN_STATUS = 'UNKNOWN_STATUS'
}

export type WixOnlineprogramsProgramsV3PublishProgramRequestInput = {
  /** Program to publish */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3PublishProgramResponse = {
  /** Published program */
  program?: Maybe<WixOnlineprogramsProgramsV3Program>;
};

export type WixOnlineprogramsProgramsV3QueryProgramsRequestInput = {
  /** Query to filter programs */
  query?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonQueryV2Input>;
};

export type WixOnlineprogramsProgramsV3QueryProgramsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<WixOnlineprogramsProgramsV3Program>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixOnlineprogramsProgramsV3ResolveProgramSlugRequestInput = {
  /** seo slug of online program. */
  slug?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3ResolveProgramSlugResponse = {
  program?: Maybe<WixOnlineprogramsProgramsV3Program>;
  programId?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3Restrictions = {
  /** access restrictions options regarding visibility. */
  accessType?: Maybe<WixOnlineprogramsProgramsV3RestrictionsAccessType>;
  /** hide steps in the Pending state. */
  hideFutureSteps?: Maybe<Scalars['Boolean']>;
  /** limit of active participants in the program. */
  maxParticipants?: Maybe<Scalars['Int']>;
  /** allow participants complete steps in the certain order. */
  resolveStepsInOrder?: Maybe<Scalars['Boolean']>;
  /** allow program participants to share their progress in group */
  shareProgress?: Maybe<Scalars['Boolean']>;
};

export enum WixOnlineprogramsProgramsV3RestrictionsAccessType {
  /** send a join request to the owner and get an approval from him. */
  PRIVATE = 'PRIVATE',
  /** join without approvals */
  PUBLIC = 'PUBLIC',
  /** join possible only after owner invite. */
  SECRET = 'SECRET',
  /** unknown access type */
  UNKNOWN_ACCESS_TYPE = 'UNKNOWN_ACCESS_TYPE'
}

export type WixOnlineprogramsProgramsV3RestrictionsInput = {
  /** access restrictions options regarding visibility. */
  accessType?: InputMaybe<WixOnlineprogramsProgramsV3RestrictionsAccessType>;
  /** hide steps in the Pending state. */
  hideFutureSteps?: InputMaybe<Scalars['Boolean']>;
  /** limit of active participants in the program. */
  maxParticipants?: InputMaybe<Scalars['Int']>;
  /** allow participants complete steps in the certain order. */
  resolveStepsInOrder?: InputMaybe<Scalars['Boolean']>;
  /** allow program participants to share their progress in group */
  shareProgress?: InputMaybe<Scalars['Boolean']>;
};

export type WixOnlineprogramsProgramsV3Reward = {
  /** badges participant will get on program complete */
  badgeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** certificate for program. Currently is program GUID */
  certificate?: Maybe<WixOnlineprogramsProgramsV3RewardCertificate>;
  /** on which action rewards must be assigned. */
  trigger?: Maybe<WixOnlineprogramsProgramsV3RewardTrigger>;
};

export type WixOnlineprogramsProgramsV3RewardCertificate = {
  /** date it was connected to program */
  connectedDate?: Maybe<Scalars['String']>;
  /** Certificate for program completion. Currently is program GUID */
  id?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3RewardCertificateInput = {
  /** date it was connected to program */
  connectedDate?: InputMaybe<Scalars['String']>;
  /** Certificate for program completion. Currently is program GUID */
  id?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3RewardInput = {
  /** badges participant will get on program complete */
  badgeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** certificate for program. Currently is program GUID */
  certificate?: InputMaybe<WixOnlineprogramsProgramsV3RewardCertificateInput>;
  /** on which action rewards must be assigned. */
  trigger?: InputMaybe<WixOnlineprogramsProgramsV3RewardTrigger>;
};

export enum WixOnlineprogramsProgramsV3RewardTrigger {
  /** all steps are completed. */
  ALL_STEPS_COMPLETED = 'ALL_STEPS_COMPLETED',
  /** member joins the program */
  JOINED_TO_PROGRAM = 'JOINED_TO_PROGRAM',
  /** at least one step completed */
  STEP_COMPLETED = 'STEP_COMPLETED'
}

export type WixOnlineprogramsProgramsV3SearchProgramsRequestInput = {
  /** Query to search programs */
  search?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonCursorSearchInput>;
};

export type WixOnlineprogramsProgramsV3SearchProgramsResponse = {
  /** aggregation */
  aggregationData?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationData>;
  /** paging */
  pagingMetadata?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonCursorPagingMetadata>;
  /** Found programs */
  programs?: Maybe<Array<Maybe<WixOnlineprogramsProgramsV3Program>>>;
};

export type WixOnlineprogramsProgramsV3Seo = {
  /** Approximate SEO program duration in Iso-8601 */
  courseWorkload?: Maybe<Scalars['String']>;
  /** alt text of image */
  imageAlt?: Maybe<Scalars['String']>;
  /** image url from description media */
  imageUrl?: Maybe<Scalars['String']>;
  /** schema used by Seo team */
  seoData?: Maybe<ComWixpressAdvancedSeoSeoSchema>;
  /** program slug expression */
  slug?: Maybe<Scalars['String']>;
  /** program url */
  url?: Maybe<WixCommonPageUrl>;
};

export type WixOnlineprogramsProgramsV3SeoInput = {
  /** Approximate SEO program duration in Iso-8601 */
  courseWorkload?: InputMaybe<Scalars['String']>;
  /** alt text of image */
  imageAlt?: InputMaybe<Scalars['String']>;
  /** image url from description media */
  imageUrl?: InputMaybe<Scalars['String']>;
  /** schema used by Seo team */
  seoData?: InputMaybe<ComWixpressAdvancedSeoSeoSchemaInput>;
  /** program slug expression */
  slug?: InputMaybe<Scalars['String']>;
  /** program url */
  url?: InputMaybe<WixCommonPageUrlInput>;
};

export enum WixOnlineprogramsProgramsV3State {
  /** closed program. Joins and sections/steps are not available for participants. */
  ARCHIVED = 'ARCHIVED',
  /** not published program, visible only on BM */
  DRAFT = 'DRAFT',
  /** program isn't available to join. */
  ENDED = 'ENDED',
  /** program visible regarding to restrictions */
  PUBLISHED = 'PUBLISHED'
}

export type WixOnlineprogramsProgramsV3Timeline = {
  /** duration of program in days (if applicable). */
  durationInDays?: Maybe<Scalars['Int']>;
  /** are sections/steps evaluated every day? Or can UoU participate in a self paced mode? */
  selfPaced?: Maybe<Scalars['Boolean']>;
  /** everyone starts on this day */
  startDate?: Maybe<Scalars['String']>;
};

export enum WixOnlineprogramsProgramsV3TimelineFinishCondition {
  /** finish participation when all steps are resolved. */
  ALL_STEPS_COMPLETED = 'ALL_STEPS_COMPLETED',
  /** finish participation after some time. */
  TIME_EVALUATION = 'TIME_EVALUATION',
  UNKNOWN_FINISH_CONDITION = 'UNKNOWN_FINISH_CONDITION'
}

export type WixOnlineprogramsProgramsV3TimelineInput = {
  /** duration of program in days (if applicable). */
  durationInDays?: InputMaybe<Scalars['Int']>;
  /** are sections/steps evaluated every day? Or can UoU participate in a self paced mode? */
  selfPaced?: InputMaybe<Scalars['Boolean']>;
  /** everyone starts on this day */
  startDate?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3TimelineTimeEvaluationOptions = {
  /** duration in days */
  durationInDays?: Maybe<Scalars['Int']>;
};

export type WixOnlineprogramsProgramsV3TimelineTimeEvaluationOptionsInput = {
  /** duration in days */
  durationInDays?: InputMaybe<Scalars['Int']>;
};

export type WixOnlineprogramsProgramsV3UpdateProgramRequestInput = {
  /**
   * Set of fields to update.
   *
   * Fields that aren't included in `fieldMask.paths` are ignored.
   */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Program to be updated, may be partial. */
  program?: InputMaybe<WixOnlineprogramsProgramsV3ProgramInput>;
};

export type WixOnlineprogramsProgramsV3UpdateProgramResponse = {
  /** Updated Program. */
  program?: Maybe<WixOnlineprogramsProgramsV3Program>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationData = {
  /** key = aggregation name (as derived from search request). */
  results?: Maybe<Array<Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResults>>>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResults = {
  /** Date histogram aggregation results. */
  dateHistogram?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResults>;
  /** Field to aggregate by as derived from search request. */
  fieldPath?: Maybe<Scalars['String']>;
  /** Group by value aggregation results. */
  groupedByValue?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResults>;
  /** User-defined name of aggregation as derived from search request. */
  name?: Maybe<Scalars['String']>;
  /** Nested aggregation results. */
  nested?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResults>;
  /** Range aggregation results. */
  ranges?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsRangeResults>;
  /** Scalar aggregation results. */
  scalar?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsScalarResult>;
  /** Type of aggregation that must match provided kind as derived from search request. */
  type?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationType>;
  /** Value aggregation results. */
  values?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsValueResults>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResults = {
  /** List of date histogram aggregations. */
  results?: Maybe<Array<Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult>>>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsDateHistogramResultsDateHistogramResult = {
  /** Count of documents in the bucket. */
  count?: Maybe<Scalars['Int']>;
  /** Date in ISO 8601 format. */
  value?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResults = {
  /** List of value aggregations. */
  results?: Maybe<Array<Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult>>>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsGroupByValueResultsNestedValueAggregationResult = {
  /** Nested aggregations. */
  nestedResults?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedAggregationResults>;
  /** Value of the field. */
  value?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedAggregationResults = {
  /** Field to aggregate by, matches the one provided in request. */
  fieldPath?: Maybe<Scalars['String']>;
  /** User-defined name of aggregation, matches the one provided in request. */
  name?: Maybe<Scalars['String']>;
  /** Range aggregation results. */
  ranges?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsRangeResults>;
  /** Scalar aggregation results. */
  scalar?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsScalarResult>;
  /** Type of aggregation that matches result. */
  type?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationType>;
  /** Value aggregation results. */
  values?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsValueResults>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResults = {
  /** List of nested aggregations. */
  results?: Maybe<Array<Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsResults>>>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue = {
  /** Date histogram aggregation result. */
  dateHistogram?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult>;
  /** Range aggregation result. */
  range?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsRangeResult>;
  /** Scalar aggregation result. */
  scalar?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsScalarResult>;
  /** Value aggregation result. */
  value?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsRangeResult = {
  /** Count of entities in this range. */
  count?: Maybe<Scalars['Int']>;
  /** Inclusive lower bound of the range. */
  from?: Maybe<Scalars['Float']>;
  /** Exclusive upper bound of the range. */
  to?: Maybe<Scalars['Float']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsResults = {
  /** List of nested aggregations. */
  results?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsNestedResultValue>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsScalarResult = {
  /** Value of the scalar aggregation. */
  value?: Maybe<Scalars['Float']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsNestedResultsValueResult = {
  /** Count of entities with this value. */
  count?: Maybe<Scalars['Int']>;
  /** Value of the field. */
  value?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsRangeResults = {
  /** List of ranges returned in same order as requested. */
  results?: Maybe<Array<Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult>>>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsRangeResultsRangeAggregationResult = {
  /** Count of entities in this range. */
  count?: Maybe<Scalars['Int']>;
  /** Inclusive lower bound of the range. */
  from?: Maybe<Scalars['Float']>;
  /** Exclusive upper bound of the range. */
  to?: Maybe<Scalars['Float']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsScalarResult = {
  /** Type of scalar aggregation. */
  type?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonScalarType>;
  /** Value of the scalar aggregation. */
  value?: Maybe<Scalars['Float']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsValueResults = {
  /** List of value aggregations. */
  results?: Maybe<Array<Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult>>>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDataAggregationResultsValueResultsValueAggregationResult = {
  /** Count of entities with this value. */
  count?: Maybe<Scalars['Int']>;
  /** Value of the field. */
  value?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDateHistogramAggregationInput = {
  /** Interval for date histogram aggregation. */
  interval?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDateHistogramAggregationInterval>;
};

export enum WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDateHistogramAggregationInterval {
  /** Daily interval */
  DAY = 'DAY',
  /** Hourly interval */
  HOUR = 'HOUR',
  /** Minute interval */
  MINUTE = 'MINUTE',
  /** Monthly interval */
  MONTH = 'MONTH',
  /** Second interval */
  SECOND = 'SECOND',
  UNKNOWN_INTERVAL = 'UNKNOWN_INTERVAL',
  /** Weekly interval */
  WEEK = 'WEEK',
  /** Yearly interval */
  YEAR = 'YEAR'
}

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationGroupByAggregationInput = {
  /** Field to aggregate by. */
  fieldPath?: InputMaybe<Scalars['String']>;
  /** User-defined name of aggregation, should be unique, will appear in aggregation results. */
  name?: InputMaybe<Scalars['String']>;
  /** Value aggregation configuration. */
  value?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationInput>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationInput = {
  /** Date histogram aggregation. */
  dateHistogram?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDateHistogramAggregationInput>;
  /** Field to aggregate by, use dot notation to specify json path. */
  fieldPath?: InputMaybe<Scalars['String']>;
  /** User-defined name of aggregation, should be unique, will appear in aggregation results. */
  name?: InputMaybe<Scalars['String']>;
  /** Nested aggregation. */
  nested?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationNestedAggregationInput>;
  /** Range aggregation. */
  range?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationRangeAggregationInput>;
  /** Scalar aggregation. */
  scalar?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationScalarAggregationInput>;
  /** Type of aggregation, client must provide matching aggregation field below. */
  type?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationType>;
  /** Value aggregation. */
  value?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationInput>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationNestedAggregationInput = {
  /** Flattened list of aggregations, where each next aggregation is nested within previous one. */
  nestedAggregations?: InputMaybe<Array<InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationNestedAggregationNestedAggregationItemInput>>>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationNestedAggregationNestedAggregationItemInput = {
  /** Date histogram aggregation. */
  dateHistogram?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationDateHistogramAggregationInput>;
  /** Field to aggregate by, use dot notation to specify json path. */
  fieldPath?: InputMaybe<Scalars['String']>;
  /** User-defined name of aggregation, should be unique, will appear in aggregation results. */
  name?: InputMaybe<Scalars['String']>;
  /** Range aggregation. */
  range?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationRangeAggregationInput>;
  /** Scalar aggregation. */
  scalar?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationScalarAggregationInput>;
  /** Type of aggregation, client must provide matching aggregation field below. */
  type?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationNestedAggregationNestedAggregationType>;
  /** Value aggregation. */
  value?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationInput>;
};

export enum WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationNestedAggregationNestedAggregationType {
  /** An aggregation, where result buckets are dynamically built - one per time interval (hour, day, week, etc.). */
  DATE_HISTOGRAM = 'DATE_HISTOGRAM',
  /** An aggregation, where user can define set of ranges - each representing a bucket. */
  RANGE = 'RANGE',
  /** A single-value metric aggregation. For example, min, max, sum, avg. */
  SCALAR = 'SCALAR',
  UNKNOWN_AGGREGATION_TYPE = 'UNKNOWN_AGGREGATION_TYPE',
  /** An aggregation where result buckets are dynamically built - one per unique value. */
  VALUE = 'VALUE'
}

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationRangeAggregationInput = {
  /** List of range buckets, where during aggregation each entity will be placed in the first bucket its value falls into, based on the provided range bounds. */
  buckets?: InputMaybe<Array<InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationRangeAggregationRangeBucketInput>>>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationRangeAggregationRangeBucketInput = {
  /** Inclusive lower bound of the range. Required if `to` is not provided. */
  from?: InputMaybe<Scalars['Float']>;
  /** Exclusive upper bound of the range. Required if `from` is not provided. */
  to?: InputMaybe<Scalars['Float']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationScalarAggregationInput = {
  /** Define the operator for the scalar aggregation. */
  type?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonScalarType>;
};

export enum WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationType {
  /** An aggregation, where result buckets are dynamically built - one per time interval (hour, day, week, etc.) */
  DATE_HISTOGRAM = 'DATE_HISTOGRAM',
  /** Multi-level aggregation, where each next aggregation is nested within previous one. */
  NESTED = 'NESTED',
  /** An aggregation, where user can define set of ranges - each representing a bucket. */
  RANGE = 'RANGE',
  /** A single-value metric aggregation. For example, min, max, sum, avg. */
  SCALAR = 'SCALAR',
  UNKNOWN_AGGREGATION_TYPE = 'UNKNOWN_AGGREGATION_TYPE',
  /** An aggregation where result buckets are dynamically built - one per unique value. */
  VALUE = 'VALUE'
}

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationIncludeMissingValuesOptionsInput = {
  /** Specify custom bucket name. Defaults are [string -> "N/A"], [int -> "0"], [bool -> "false"] ... */
  addToBucket?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationInput = {
  /** Options for including missing values. */
  includeOptions?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationIncludeMissingValuesOptionsInput>;
  /** How many aggregations to return. Can be between 1 and 250. 10 is the default. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Whether to include or exclude missing values from the aggregation results. Default: `EXCLUDE`. */
  missingValues?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationMissingValues>;
  /** Whether to sort in ascending or descending order. */
  sortDirection?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationSortDirection>;
  /** Whether to sort by number of matches or value of the field. */
  sortType?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationSortType>;
};

export enum WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationMissingValues {
  /** Exclude missing values from the aggregation results. */
  EXCLUDE = 'EXCLUDE',
  /** Include missing values in the aggregation results. */
  INCLUDE = 'INCLUDE'
}

export enum WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationSortDirection {
  /** Sort in ascending order. */
  ASC = 'ASC',
  /** Sort in descending order. */
  DESC = 'DESC'
}

export enum WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationValueAggregationSortType {
  /** Sort by number of matches. */
  COUNT = 'COUNT',
  /** Sort by value of the field alphabetically. */
  VALUE = 'VALUE'
}

export type WixOnlineprogramsProgramsV3UpstreamWixCommonBulkActionMetadata = {
  /** Number of items that couldn't be processed. */
  totalFailures?: Maybe<Scalars['Int']>;
  /** Number of items that were successfully processed. */
  totalSuccesses?: Maybe<Scalars['Int']>;
  /** Number of failures without details because detailed failure threshold was exceeded. */
  undetailedFailures?: Maybe<Scalars['Int']>;
};

export enum WixOnlineprogramsProgramsV3UpstreamWixCommonBulkActionType {
  /** DELETE */
  DELETE = 'DELETE',
  /** INSERT */
  INSERT = 'INSERT',
  /** UNKNOWN_ACTION_TYPE */
  UNKNOWN_ACTION_TYPE = 'UNKNOWN_ACTION_TYPE',
  /** UPDATE */
  UPDATE = 'UPDATE'
}

export type WixOnlineprogramsProgramsV3UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * Pass the relevant cursor token from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Maximum number of items to return in the results. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonCursorPagingMetadata = {
  /** Number of items returned in current page. */
  count?: Maybe<Scalars['Int']>;
  /** Cursor strings that point to the next page, previous page, or both. */
  cursors?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonCursors>;
  /**
   * Whether there are more pages to retrieve following the current page.
   *
   * + `true`: Another page of results can be retrieved.
   * + `false`: This is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
  /**
   * Total number of items matching the filter.
   * Available only on the first page of *Search* results, not included in *Query* or *List* results.
   * If the Search results span multiple pages, the value of `total` will exceed the number of items returned on the first page.
   */
  total?: Maybe<Scalars['Int']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonCursorSearchInput = {
  /** Aggregations are a way to explore large amounts of data by displaying summaries about various partitions of the data and later allowing to narrow the navigation to a specific partition. */
  aggregations?: InputMaybe<Array<InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonAggregationInput>>>;
  /**
   * Cursor paging options.
   *
   * Learn more about [cursor paging](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#cursor-paging).
   */
  cursorPaging?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object.
   *
   * Learn more about the [filter section](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#the-filter-section).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Free text to match in searchable fields. */
  search?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonSearchDetailsInput>;
  /**
   * List of sort objects.
   *
   * Learn more about the [sort section](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#the-sort-section).
   */
  sort?: InputMaybe<Array<InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonSortingInput>>>;
  /**
   * UTC offset or IANA time zone. Valid values are
   * ISO 8601 UTC offsets, such as +02:00 or -06:00,
   * and IANA time zone IDs, such as Europe/Rome.
   *
   * Affects all filters and aggregations returned values.
   * You may override this behavior in a specific filter by providing
   * timestamps including time zone. For example, `"2023-12-20T10:52:34.795Z"`.
   */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonCursors = {
  /** Cursor string pointing to the next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to the previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonItemMetadata = {
  /** Details about the error in case of failure. */
  error?: Maybe<WixApiApplicationError>;
  /** Item ID. Should always be available, unless it's impossible (for example, when failing to create an item). */
  id?: Maybe<Scalars['String']>;
  /** Index of the item within the request array. Allows for correlation between request and response items. */
  originalIndex?: Maybe<Scalars['Int']>;
  /** Whether the requested action was successful for this item. When `false`, the `error` field is populated. */
  success?: Maybe<Scalars['Boolean']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonMoney = {
  /** Currency code. Must be valid ISO 4217 currency code (e.g., USD). */
  currency?: Maybe<Scalars['String']>;
  /** Monetary amount. Decimal string with a period as a decimal separator (e.g., 3.99). */
  value?: Maybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonMoneyInput = {
  /** Currency code. Must be valid ISO 4217 currency code (e.g., USD). */
  currency?: InputMaybe<Scalars['String']>;
  /** Monetary amount. Decimal string with a period as a decimal separator (e.g., 3.99). */
  value?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonPagingInput = {
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonPagingMetadataV2 = {
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Cursors to navigate through the result pages using `next` and `prev`. Returned if cursor paging is used. */
  cursors?: Maybe<WixOnlineprogramsProgramsV3UpstreamWixCommonCursors>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
  /** Offset that was requested. */
  offset?: Maybe<Scalars['Int']>;
  /** Flag that indicates the server failed to calculate the `total` field. */
  tooManyToCount?: Maybe<Scalars['Boolean']>;
  /** Total number of items that match the query. Returned if offset paging is used and the `tooManyToCount` flag is not set. */
  total?: Maybe<Scalars['Int']>;
};

export type WixOnlineprogramsProgramsV3UpstreamWixCommonQueryV2Input = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonCursorPagingInput>;
  /** Array of projected fields. A list of specific field names to return. If `fieldsets` are also specified, the union of `fieldsets` and `fields` is returned. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of named, predefined sets of projected fields. A array of predefined named sets of fields to be returned. Specifying multiple `fieldsets` will return the union of fields from all sets. If `fields` are also specified, the union of `fieldsets` and `fields` is returned. */
  fieldsets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter object.
   *
   * Learn more about the [filter section](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#the-filter-section).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Paging options to limit and skip the number of items. */
  paging?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonPagingInput>;
  /**
   * Sort object.
   *
   * Learn more about the [sort section](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language#the-sort-section).
   */
  sort?: InputMaybe<Array<InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonSortingInput>>>;
};

export enum WixOnlineprogramsProgramsV3UpstreamWixCommonScalarType {
  /** Average of values. */
  AVG = 'AVG',
  /** Count of distinct values. */
  COUNT_DISTINCT = 'COUNT_DISTINCT',
  /** Maximum value. */
  MAX = 'MAX',
  /** Minimum value. */
  MIN = 'MIN',
  /** Sum of values. */
  SUM = 'SUM',
  UNKNOWN_SCALAR_TYPE = 'UNKNOWN_SCALAR_TYPE'
}

export type WixOnlineprogramsProgramsV3UpstreamWixCommonSearchDetailsInput = {
  /** Search term or expression. */
  expression?: InputMaybe<Scalars['String']>;
  /** Fields to search in. If empty - will search in all searchable fields. Use dot notation to specify json path. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Whether to use auto fuzzy search (allowing typos by a managed proximity algorithm). */
  fuzzy?: InputMaybe<Scalars['Boolean']>;
  /** Defines how separate search terms in `expression` are combined. */
  mode?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonSearchDetailsMode>;
};

export enum WixOnlineprogramsProgramsV3UpstreamWixCommonSearchDetailsMode {
  /** All search terms must be present. */
  AND = 'AND',
  /** Any of the search terms must be present. */
  OR = 'OR'
}

export enum WixOnlineprogramsProgramsV3UpstreamWixCommonSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type WixOnlineprogramsProgramsV3UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixOnlineprogramsProgramsV3UpstreamWixCommonSortOrder>;
  /**
   * When `field_name` is a property of repeated field that is marked as `MATCH_ITEMS` and sort should be done by
   * a specific element from a collection, filter can/should be provided to ensure correct sort value is picked.
   *
   * If multiple filters are provided, they are combined with AND operator.
   *
   * Example:
   * Given we have document like {"id": "1", "nestedField": [{"price": 10, "region": "EU"}, {"price": 20, "region": "US"}]}
   * and `nestedField` is marked as `MATCH_ITEMS`, to ensure that sorting is done by correct region, filter should be
   * { fieldName: "nestedField.price", "select_items_by": [{"nestedField.region": "US"}] }
   */
  selectItemsBy?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type WixOnlineprogramsProgramsV3VideoStepsSettings = {
  /** automatically switch to next video step after finishing current one */
  autoNavigate?: Maybe<Scalars['Boolean']>;
  /** how many percents of video need to be watched to complete step */
  requiredCompletionPercentage?: Maybe<Scalars['Float']>;
};

export type WixOnlineprogramsProgramsV3VideoStepsSettingsInput = {
  /** automatically switch to next video step after finishing current one */
  autoNavigate?: InputMaybe<Scalars['Boolean']>;
  /** how many percents of video need to be watched to complete step */
  requiredCompletionPercentage?: InputMaybe<Scalars['Float']>;
};

export type WixOnlineprogramsStepsV3BulkCloneStepRequestInput = {
  /** id of program which was cloned */
  clonedProgramId?: InputMaybe<Scalars['String']>;
  /** mapping of original to cloned section ids */
  prototypeIdToClonedId?: InputMaybe<Scalars['JSON']>;
  /** id of program which was cloned */
  prototypeProgramId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsStepsV3BulkCloneStepResponse = {
  /** ids of newly created steps */
  createdStepIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type WixOnlineprogramsStepsV3BulkCreateStepMigrationRequestInput = {
  /** Program in which steps are to be created. */
  programId?: InputMaybe<Scalars['String']>;
  /** List of steps you want to create */
  steps?: InputMaybe<Array<InputMaybe<WixOnlineprogramsStepsV3StepInput>>>;
};

export type WixOnlineprogramsStepsV3BulkCreateStepMigrationResponse = {
  /** Metadata about whole bulk action. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Results of bulk action. */
  results?: Maybe<Array<Maybe<WixOnlineprogramsStepsV3BulkStepResult>>>;
};

export type WixOnlineprogramsStepsV3BulkCreateStepRequestInput = {
  /** Program id in which steps are to be created. */
  programId?: InputMaybe<Scalars['String']>;
  /** Whether to return entities in response or not. */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /** List of steps you want to create */
  steps?: InputMaybe<Array<InputMaybe<WixOnlineprogramsStepsV3StepInput>>>;
};

export type WixOnlineprogramsStepsV3BulkCreateStepResponse = {
  /** Metadata about whole bulk action. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Results of bulk action. */
  results?: Maybe<Array<Maybe<WixOnlineprogramsStepsV3BulkStepResult>>>;
};

export type WixOnlineprogramsStepsV3BulkStepResult = {
  /** Action type of bulk action (INSERT OR UPDATE) for that endpoint. */
  action?: Maybe<WixCommonBulkActionType>;
  /** Item itself (empty if return_entity in request is false). */
  item?: Maybe<WixOnlineprogramsStepsV3Step>;
  /** Metadata of item. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixOnlineprogramsStepsV3CloneStepRequestInput = {
  /** what step to clone */
  stepId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsStepsV3CloneStepResponse = {
  /** created step. */
  step?: Maybe<WixOnlineprogramsStepsV3Step>;
};

export type WixOnlineprogramsStepsV3CreateStepRequestInput = {
  /** Program id in which step is to be created. */
  programId?: InputMaybe<Scalars['String']>;
  /** Step to be created. */
  step?: InputMaybe<WixOnlineprogramsStepsV3StepInput>;
};

export type WixOnlineprogramsStepsV3CreateStepResponse = {
  /** The created Step. */
  step?: Maybe<WixOnlineprogramsStepsV3Step>;
};

export type WixOnlineprogramsStepsV3DeleteAllProgramStepsRequestInput = {
  /** Program id to delete steps from */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsStepsV3DeleteAllProgramStepsResponse = {
  /** Count of steps that failed to be deleted */
  failedCount?: Maybe<Scalars['Int']>;
  /** Total count of steps in the program */
  stepsTotal?: Maybe<Scalars['Int']>;
  /** Count of successfully deleted steps */
  successfulCount?: Maybe<Scalars['Int']>;
};

export type WixOnlineprogramsStepsV3DeleteStepRequestInput = {
  /** Id of the Step to delete. */
  stepId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsStepsV3Description = {
  details?: Maybe<Scalars['String']>;
  /** WixMedia image */
  image?: Maybe<WixCommonImage>;
  title?: Maybe<Scalars['String']>;
  /** WixMedia video */
  video?: Maybe<WixCommonVideoV2>;
};

export type WixOnlineprogramsStepsV3DescriptionInput = {
  details?: InputMaybe<Scalars['String']>;
  /** WixMedia image */
  image?: InputMaybe<WixCommonImageInput>;
  title?: InputMaybe<Scalars['String']>;
  /** WixMedia video */
  video?: InputMaybe<WixCommonVideoV2Input>;
};

export type WixOnlineprogramsStepsV3GetStepRequestInput = {
  /** Whenever to return description only with title or with details as well */
  descriptionFieldSet?: InputMaybe<WixOnlineprogramsStepsV3UpstreamWixCommonDescriptionFieldSet>;
  id: Scalars['ID'];
};

export type WixOnlineprogramsStepsV3ListAllProgramStepsRequestInput = {
  /** Whenever to return description only with title or with details as well */
  descriptionFieldSet?: InputMaybe<WixOnlineprogramsStepsV3UpstreamWixCommonDescriptionFieldSet>;
  /** program id of requested steps */
  programId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsStepsV3ListAllProgramStepsResponse = {
  /** List of Steps. */
  steps?: Maybe<Array<Maybe<WixOnlineprogramsStepsV3Step>>>;
};

export type WixOnlineprogramsStepsV3MoveStepRequestInput = {
  /** insert after this step id (can be empty if it's the first position in the section) */
  afterStepId?: InputMaybe<Scalars['String']>;
  revision?: InputMaybe<Scalars['Long']>;
  /** target section (keep the same or move step to a different one) */
  sectionId?: InputMaybe<Scalars['String']>;
  /** what step to move */
  stepId?: InputMaybe<Scalars['String']>;
};

export type WixOnlineprogramsStepsV3MoveStepResponse = {
  /** Moved step with updated ordering. */
  step?: Maybe<WixOnlineprogramsStepsV3Step>;
};

export type WixOnlineprogramsStepsV3QueryStepsRequestInput = {
  /** Whenever to return description only with title or with details as well */
  descriptionFieldSet?: InputMaybe<WixOnlineprogramsStepsV3UpstreamWixCommonDescriptionFieldSet>;
  /** Program id to query steps */
  programId?: InputMaybe<Scalars['String']>;
  /** WQL expression. */
  query?: InputMaybe<WixOnlineprogramsStepsV3UpstreamWixCommonCursorQueryInput>;
};

export type WixOnlineprogramsStepsV3QueryStepsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<WixOnlineprogramsStepsV3Step>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixOnlineprogramsStepsV3QueryStepsWithoutPagingRequestInput = {
  /** Whenever to return description only with title or with details as well */
  descriptionFieldSet?: InputMaybe<WixOnlineprogramsStepsV3UpstreamWixCommonDescriptionFieldSet>;
  /** Program id to query steps */
  programId?: InputMaybe<Scalars['String']>;
  /** WQL expression. Cursor paging is not supported in this endpoint. */
  query?: InputMaybe<WixOnlineprogramsStepsV3UpstreamWixCommonCursorQueryInput>;
};

export type WixOnlineprogramsStepsV3QueryStepsWithoutPagingResponse = {
  /** List of Steps. */
  steps?: Maybe<Array<Maybe<WixOnlineprogramsStepsV3Step>>>;
};

export type WixOnlineprogramsStepsV3Step = {
  /** Represents the time this Task was created */
  createdDate?: Maybe<Scalars['String']>;
  /** title, description and media content. */
  description?: Maybe<WixOnlineprogramsStepsV3Description>;
  /** extensible field */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** Program Task ID */
  id?: Maybe<Scalars['String']>;
  /** field for manual ordering of steps */
  ordering?: Maybe<Scalars['Float']>;
  /** id of the owning program. */
  programId?: Maybe<Scalars['String']>;
  /** options of quiz step. */
  quizOptions?: Maybe<WixOnlineprogramsStepsV3StepQuizOptions>;
  /** Represents the current state of an item. Each time the item is modified, its `revision` changes by the server. for an update operation to succeed, you MUST pass the latest revision */
  revision?: Maybe<Scalars['Long']>;
  /** id of the owning section. */
  sectionId?: Maybe<Scalars['String']>;
  /** Content type of a step, can be article, quiz or video. */
  stepType?: Maybe<WixOnlineprogramsStepsV3StepStepType>;
  /** Represents the time this Task was last updated */
  updatedDate?: Maybe<Scalars['String']>;
  /** options of video step. */
  videoOptions?: Maybe<WixOnlineprogramsStepsV3StepVideoOptions>;
};

export type WixOnlineprogramsStepsV3StepInput = {
  /** Represents the time this Task was created */
  createdDate?: InputMaybe<Scalars['String']>;
  /** title, description and media content. */
  description?: InputMaybe<WixOnlineprogramsStepsV3DescriptionInput>;
  /** extensible field */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** Program Task ID */
  id?: InputMaybe<Scalars['String']>;
  /** field for manual ordering of steps */
  ordering?: InputMaybe<Scalars['Float']>;
  /** id of the owning program. */
  programId?: InputMaybe<Scalars['String']>;
  /** options of quiz step. */
  quizOptions?: InputMaybe<WixOnlineprogramsStepsV3StepQuizOptionsInput>;
  /** Represents the current state of an item. Each time the item is modified, its `revision` changes by the server. for an update operation to succeed, you MUST pass the latest revision */
  revision?: InputMaybe<Scalars['Long']>;
  /** id of the owning section. */
  sectionId?: InputMaybe<Scalars['String']>;
  /** Content type of a step, can be article, quiz or video. */
  stepType?: InputMaybe<WixOnlineprogramsStepsV3StepStepType>;
  /** Represents the time this Task was last updated */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** options of video step. */
  videoOptions?: InputMaybe<WixOnlineprogramsStepsV3StepVideoOptionsInput>;
};

export type WixOnlineprogramsStepsV3StepQuizOptions = {
  /** quiz id */
  id?: Maybe<Scalars['String']>;
  /** percentage of right answers to complete the quiz. */
  passingGrade?: Maybe<Scalars['Float']>;
  /** number of questions inside the quiz */
  totalQuestions?: Maybe<Scalars['Int']>;
};

export type WixOnlineprogramsStepsV3StepQuizOptionsInput = {
  /** quiz id */
  id?: InputMaybe<Scalars['String']>;
  /** percentage of right answers to complete the quiz. */
  passingGrade?: InputMaybe<Scalars['Float']>;
  /** number of questions inside the quiz */
  totalQuestions?: InputMaybe<Scalars['Int']>;
};

export enum WixOnlineprogramsStepsV3StepStepType {
  /** text-based step. */
  ARTICLE = 'ARTICLE',
  /** step containing quiz. */
  QUIZ = 'QUIZ',
  /** step with video content. */
  VIDEO = 'VIDEO'
}

export type WixOnlineprogramsStepsV3StepVideoOptions = {
  /** Cover image of video. */
  coverImage?: Maybe<WixCommonImage>;
  /** Shows if video is deleted or not (only for videos uploaded via Media Manager). */
  deleted?: Maybe<Scalars['Boolean']>;
  /** Duration of video in milliseconds. */
  durationInMilliseconds?: Maybe<Scalars['Int']>;
  /** How many percent you need to watch to complete step. */
  requiredCompletionPercentage?: Maybe<Scalars['Float']>;
  /** Video uploaded via Media Manager. */
  video?: Maybe<WixCommonVideoV2>;
  /** Video from Wix Video product. */
  wixVideo?: Maybe<WixOnlineprogramsStepsV3StepVideoOptionsWixVideo>;
};

export type WixOnlineprogramsStepsV3StepVideoOptionsInput = {
  /** Cover image of video. */
  coverImage?: InputMaybe<WixCommonImageInput>;
  /** Shows if video is deleted or not (only for videos uploaded via Media Manager). */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** Duration of video in milliseconds. */
  durationInMilliseconds?: InputMaybe<Scalars['Int']>;
  /** How many percent you need to watch to complete step. */
  requiredCompletionPercentage?: InputMaybe<Scalars['Float']>;
  /** Video uploaded via Media Manager. */
  video?: InputMaybe<WixCommonVideoV2Input>;
  /** Video from Wix Video product. */
  wixVideo?: InputMaybe<WixOnlineprogramsStepsV3StepVideoOptionsWixVideoInput>;
};

export type WixOnlineprogramsStepsV3StepVideoOptionsWixVideo = {
  /** Id of Wix Video. */
  id?: Maybe<Scalars['String']>;
  /** Is Wix Video paid or not. */
  paid?: Maybe<Scalars['Boolean']>;
};

export type WixOnlineprogramsStepsV3StepVideoOptionsWixVideoInput = {
  /** Id of Wix Video. */
  id?: InputMaybe<Scalars['String']>;
  /** Is Wix Video paid or not. */
  paid?: InputMaybe<Scalars['Boolean']>;
};

export type WixOnlineprogramsStepsV3UpdateStepRequestInput = {
  /**
   * Set of fields to update.
   *
   * Fields that aren't included in `fieldMask.paths` are ignored.
   */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Step to be updated, may be partial. */
  step?: InputMaybe<WixOnlineprogramsStepsV3StepInput>;
};

export type WixOnlineprogramsStepsV3UpdateStepResponse = {
  /** Updated Step. */
  step?: Maybe<WixOnlineprogramsStepsV3Step>;
};

export type WixOnlineprogramsStepsV3UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixOnlineprogramsStepsV3UpstreamWixCommonCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixOnlineprogramsStepsV3UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export enum WixOnlineprogramsStepsV3UpstreamWixCommonDescriptionFieldSet {
  EXTENDED = 'EXTENDED',
  STANDARD = 'STANDARD'
}

export type WixOrdersApiV2AppliedCouponInput = {
  /** Coupon code */
  code?: InputMaybe<Scalars['String']>;
  /** Coupon ID */
  couponId?: InputMaybe<Scalars['String']>;
  /** Coupon name */
  name?: InputMaybe<Scalars['String']>;
};

export type WixOrdersApiV2BillingInfoInput = {
  /** Deprecated (use paymentProviderTransactionId instead) */
  externalTransactionId?: InputMaybe<Scalars['String']>;
  /** Payment date */
  paidDate?: InputMaybe<Scalars['String']>;
  /** Transaction ID from payment gateway (e.g., Wix Payments) */
  paymentGatewayTransactionId?: InputMaybe<Scalars['String']>;
  /** Payment method used for this order */
  paymentMethod?: InputMaybe<Scalars['String']>;
  /** Transaction ID from payment provider (e.g., PayPal, Square, Stripe) transaction ID */
  paymentProviderTransactionId?: InputMaybe<Scalars['String']>;
  /** Whether order can be refunded by payment provider (manually or automatic) */
  refundableByPaymentProvider?: InputMaybe<Scalars['Boolean']>;
};

export type WixOrdersApiV2BuyerInfoInput = {
  /** Contact Id. needed for cases where the user is the buyer and so it doesn't exist on the buyer info */
  contactId?: InputMaybe<Scalars['String']>;
  /** Customer's email address */
  email?: InputMaybe<Scalars['String']>;
  /** Customer's first name */
  firstName?: InputMaybe<Scalars['String']>;
  /** Wix customer ID */
  id?: InputMaybe<Scalars['String']>;
  /** Customer type */
  identityType?: InputMaybe<WixOrdersApiV2IdentityType>;
  /** Customer's last name */
  lastName?: InputMaybe<Scalars['String']>;
  /** Customer's phone number */
  phone?: InputMaybe<Scalars['String']>;
  /** Deprecated (use identityType instead) */
  type?: InputMaybe<WixOrdersApiV2IdentityType>;
};

export enum WixOrdersApiV2FulfillmentStatus {
  /** Order is canceled */
  CANCELED = 'CANCELED',
  /**
   * All of the order items are fulfilled
   * Orders without shipping info are fulfilled automatically
   */
  FULFILLED = 'FULFILLED',
  /** None of the order items are fulfilled */
  NOT_FULFILLED = 'NOT_FULFILLED',
  /** Some, but not all of the order items are fulfilled */
  PARTIALLY_FULFILLED = 'PARTIALLY_FULFILLED'
}

export enum WixOrdersApiV2IdentityType {
  /** Contact */
  CONTACT = 'CONTACT',
  /** Site member */
  MEMBER = 'MEMBER',
  UNSPECIFIED_IDENTITY_TYPE = 'UNSPECIFIED_IDENTITY_TYPE'
}

export type WixOrdersApiV2OrderCreatedInput = {
  /** Applied coupon */
  appliedCoupon?: InputMaybe<WixOrdersApiV2AppliedCouponInput>;
  /** Order archive status */
  archived?: InputMaybe<Scalars['Boolean']>;
  /** Billing information. */
  billingInfo?: InputMaybe<WixOrdersApiV2BillingInfoInput>;
  /** Customer information */
  buyerInfo?: InputMaybe<WixOrdersApiV2BuyerInfoInput>;
  cartId?: InputMaybe<Scalars['String']>;
  /** Checkout id */
  checkoutId?: InputMaybe<Scalars['String']>;
  /** Currency used for pricing in this store */
  currency?: InputMaybe<Scalars['String']>;
  /** Order creation date */
  dateCreated?: InputMaybe<Scalars['String']>;
  /** Order fulfillment status */
  fulfillmentStatus?: InputMaybe<WixOrdersApiV2FulfillmentStatus>;
  /** ID displayed in the owner's store (auto generated) */
  number?: InputMaybe<Scalars['Int']>;
  /** Order ID (auto generated upon order creation) */
  orderId?: InputMaybe<Scalars['String']>;
  ordersExperiments?: InputMaybe<ComWixEcomOrdersSideEffectsMigrationApiOrdersExperimentsInput>;
  /** Order payment status */
  paymentStatus?: InputMaybe<WixOrdersApiV2PaymentStatus>;
  /** Whether the order was read by the store owner */
  read?: InputMaybe<Scalars['Boolean']>;
  /** Subscription information */
  subscriptionInfo?: InputMaybe<WixOrdersApiV2SubscriptionInfoInput>;
  /** Totals for order's line items */
  totals?: InputMaybe<WixOrdersApiV2TotalsInput>;
  /** Weight unit used in this store */
  weightUnit?: InputMaybe<ComWixEcommercePlatformCommonApiWeightUnit>;
};

export enum WixOrdersApiV2PaymentStatus {
  /** Full order total price was refunded */
  FULLY_REFUNDED = 'FULLY_REFUNDED',
  /** Order is marked as not paid, and can be marked as paid later on. This is relevant for POS and offline orders */
  NOT_PAID = 'NOT_PAID',
  /** The order is marked as paid */
  PAID = 'PAID',
  /** At least one payment was received and approved, covering less than total price amount */
  PARTIALLY_PAID = 'PARTIALLY_PAID',
  /** Order was refunded, refund amount less than order total price */
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
  /** Order is pending response from the payment provider */
  PENDING = 'PENDING',
  /** Payment status can't be classified, due to an error */
  UNSPECIFIED_PAYMENT_STATUS = 'UNSPECIFIED_PAYMENT_STATUS'
}

export type WixOrdersApiV2SubscriptionInfoInput = {
  /** Current cycle number. For example, if the subscription is in the 3rd month of a 4-month subscription, the value will be `3`. */
  cycleNumber?: InputMaybe<Scalars['Int']>;
  /** Subscription ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Subscription options info. */
  subscriptionOptionInfo?: InputMaybe<WixOrdersApiV2SubscriptionOptionInfoInput>;
  /** Subscription settings. */
  subscriptionSettings?: InputMaybe<WixEcommerceSubscriptionOptionApiV1SubscriptionSettingsInput>;
};

export type WixOrdersApiV2SubscriptionOptionInfoInput = {
  /** Subscription option description. */
  description?: InputMaybe<Scalars['String']>;
  /** Subscription option ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Subscription option title. */
  title?: InputMaybe<Scalars['String']>;
};

export type WixOrdersApiV2TotalsInput = {
  /** Total calculated discount value. */
  discount?: InputMaybe<Scalars['String']>;
  /** Total calculated gift card value. */
  giftCard?: InputMaybe<Scalars['String']>;
  /** Total number of line items. */
  quantity?: InputMaybe<Scalars['Int']>;
  /** Total refund. */
  refund?: InputMaybe<Scalars['String']>;
  /** Total shipping price, before tax. */
  shipping?: InputMaybe<Scalars['String']>;
  /** Subtotal of all the line items, before tax. */
  subtotal?: InputMaybe<Scalars['String']>;
  /** Total tax. */
  tax?: InputMaybe<Scalars['String']>;
  /** Total price charged. */
  total?: InputMaybe<Scalars['String']>;
  /** Total items weight. */
  weight?: InputMaybe<Scalars['String']>;
};

export enum WixPaymentApiPayV2SubscriptionFrequency {
  DAY = 'DAY',
  MONTH = 'MONTH',
  UNDEFINED = 'UNDEFINED',
  WEEK = 'WEEK',
  YEAR = 'YEAR'
}

export type WixPaymentApiPayV3AccountInfoInput = {
  /** The email of an Account used by Payment Method */
  email?: InputMaybe<Scalars['String']>;
};

export type WixPaymentApiPayV3CreditCardPaymentMethodDataInput = {
  /** Card expiration month. */
  expiryMonth?: InputMaybe<Scalars['String']>;
  /** Card holder's full name specified on the card. */
  holderName?: InputMaybe<Scalars['String']>;
  /** Card last 4 digits. */
  lastFourDigits?: InputMaybe<Scalars['String']>;
  /** Card number with only bin and last4 positions showed (non-PCI data) */
  maskedCreditCard?: InputMaybe<Scalars['String']>;
  /** Card issuing network */
  network?: InputMaybe<Scalars['String']>;
};

export type WixPaymentApiPayV3CurrencyAmountInput = {
  /** Amount */
  amount?: InputMaybe<Scalars['Float']>;
  currency?: InputMaybe<Scalars['String']>;
};

export type WixPaymentApiPayV3OrderAdditionalChargesInput = {
  /** Application fee */
  applicationFee?: InputMaybe<Scalars['Float']>;
  /** Discount amount applied to the order */
  discount?: InputMaybe<Scalars['Float']>;
  /** Shipping cost charged to the order */
  shipping?: InputMaybe<Scalars['Float']>;
  /** Absolute taxes charged to the order */
  tax?: InputMaybe<Scalars['Float']>;
};

export type WixPaymentApiPayV3OrderInput = {
  /** Additional charges to the order - e.g., tax, shipping or discount (optional) */
  additionalCharges?: InputMaybe<WixPaymentApiPayV3OrderAdditionalChargesInput>;
  /** Order creation date */
  createdAt?: InputMaybe<Scalars['String']>;
  externalData?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  /** Items included in the order */
  items?: InputMaybe<Array<InputMaybe<WixPaymentApiPayV3OrderItemInput>>>;
  /**
   * total number of items in order
   * items_total_count > `items`.size if `items` doesn't contain all items
   */
  itemsTotalCount?: InputMaybe<Scalars['Int']>;
  /** Customer's shipping address (optional) */
  shippingAddress?: InputMaybe<WixCommonAddressInput>;
  /** Customer's shipping address details (optional) */
  shippingAddressContacts?: InputMaybe<WixCommonFullAddressContactDetailsInput>;
  /** Wix app buyer ID */
  wixAppBuyerId?: InputMaybe<Scalars['String']>;
  /** Wix app order ID */
  wixAppOrderId?: InputMaybe<Scalars['String']>;
};

export type WixPaymentApiPayV3OrderItemInput = {
  /** Whether the item is a physical a digital product */
  category?: InputMaybe<WixPaymentApiPayV3OrderItemOrderItemCategory>;
  /** Order item description */
  description?: InputMaybe<Scalars['String']>;
  /** Order item ID (required) */
  id?: InputMaybe<Scalars['String']>;
  /** Order item name (required) */
  name?: InputMaybe<Scalars['String']>;
  /** Total price charged for this item in the order - quantity * price (required) */
  price?: InputMaybe<Scalars['Float']>;
  /** Quantity (required) */
  quantity?: InputMaybe<Scalars['Int']>;
  /** Weight of one item */
  weightInKg?: InputMaybe<Scalars['Float']>;
};

export enum WixPaymentApiPayV3OrderItemOrderItemCategory {
  /** Digital product */
  DIGITAL = 'DIGITAL',
  /** Physical product */
  PHYSICAL = 'PHYSICAL',
  UNDEFINED = 'UNDEFINED'
}

export enum WixPaymentApiPayV3PaymentEventEventType {
  RECURRING_PAYMENT_STATUS_CHANGED = 'RECURRING_PAYMENT_STATUS_CHANGED',
  REFUND_STATUS_CHANGED = 'REFUND_STATUS_CHANGED',
  TRANSACTION_CREATED = 'TRANSACTION_CREATED',
  TRANSACTION_STATUS_CHANGED = 'TRANSACTION_STATUS_CHANGED',
  TRANSACTION_UPDATED = 'TRANSACTION_UPDATED',
  UNDEFINED = 'UNDEFINED'
}

export type WixPaymentApiPayV3PaymentEventInput = {
  /** Event timestamp */
  eventTime?: InputMaybe<Scalars['String']>;
  /** Event type. */
  eventType?: InputMaybe<WixPaymentApiPayV3PaymentEventEventType>;
  /** Unique event ID. */
  id?: InputMaybe<Scalars['String']>;
  /** ID of Wix app that mediated between Wix Payments and the Wix app that triggered the event (if relevant). */
  managingWixAppId?: InputMaybe<Scalars['String']>;
  recurringPaymentStatusChangedEvent?: InputMaybe<WixPaymentApiPayV3RecurringPaymentStatusChangedEventInput>;
  refundStatusChangedEvent?: InputMaybe<WixPaymentApiPayV3RefundStatusChangedEventInput>;
  transactionCreatedEvent?: InputMaybe<WixPaymentApiPayV3TransactionCreatedEventInput>;
  transactionStatusChangedEvent?: InputMaybe<WixPaymentApiPayV3TransactionStatusChangedEventInput>;
  transactionUpdatedEvent?: InputMaybe<WixPaymentApiPayV3TransactionUpdatedEventInput>;
  /** ID of the [Wix app](https://dev.wix.com/docs/rest/articles/getting-started/wix-business-solutions) that triggered this event. */
  wixAppId?: InputMaybe<Scalars['String']>;
  /** Unique ID assigned to each Wix app in each site. */
  wixAppInstanceId?: InputMaybe<Scalars['String']>;
};

export enum WixPaymentApiPayV3RecurringPaymentCancellationDetailsInitiator {
  BUYER = 'BUYER',
  MERCHANT = 'MERCHANT',
  PAYMENT = 'PAYMENT',
  SETUP = 'SETUP',
  UNDEFINED = 'UNDEFINED'
}

export type WixPaymentApiPayV3RecurringPaymentCancellationDetailsInput = {
  /** Initiator of cancellation */
  initiator?: InputMaybe<WixPaymentApiPayV3RecurringPaymentCancellationDetailsInitiator>;
  /** Successfully paid recurring cycles count before the cancellation */
  paidRegularCycleCount?: InputMaybe<Scalars['Int']>;
};

export type WixPaymentApiPayV3RecurringPaymentDetailsInput = {
  /** Current cycle number (Recurring payments only) */
  cycleNumber?: InputMaybe<Scalars['Int']>;
};

export type WixPaymentApiPayV3RecurringPaymentStatusChangedEventInput = {
  /** Details of RecurringPayment cancellation (empty if `status` is not CANCELLED). */
  cancellationDetails?: InputMaybe<WixPaymentApiPayV3RecurringPaymentCancellationDetailsInput>;
  /** Order details(limited to 30 items). */
  order?: InputMaybe<WixPaymentApiPayV3OrderInput>;
  /** Previous recurring payment status. */
  previousStatus?: InputMaybe<WixPaymentApiPayV3RecurringPaymentStatusStatus>;
  /** Recurring payment status. */
  status?: InputMaybe<WixPaymentApiPayV3RecurringPaymentStatusStatus>;
};

export enum WixPaymentApiPayV3RecurringPaymentStatusStatus {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  FINISHED = 'FINISHED',
  PENDING = 'PENDING',
  SUSPENDED = 'SUSPENDED',
  UNDEFINED = 'UNDEFINED'
}

export type WixPaymentApiPayV3RefundInput = {
  /** Amount and currency of refund */
  amount?: InputMaybe<WixPaymentApiPayV3CurrencyAmountInput>;
  /** Refund creation date */
  createdAt?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  /** Reason provided for status change */
  reasonCode?: InputMaybe<Scalars['String']>;
  /** Updated refund status */
  status?: InputMaybe<WixPaymentApiPayV3RefundRefundStatus>;
};

export enum WixPaymentApiPayV3RefundRefundStatus {
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
  PENDING = 'PENDING',
  UNDEFINED = 'UNDEFINED'
}

export type WixPaymentApiPayV3RefundStatusChangedEventInput = {
  /** Order details (limited to 30 items). */
  order?: InputMaybe<WixPaymentApiPayV3OrderInput>;
  /** Previous refund status. */
  previousStatus?: InputMaybe<WixPaymentApiPayV3RefundRefundStatus>;
  /** Updated refund details. */
  refund?: InputMaybe<WixPaymentApiPayV3RefundInput>;
  /** Updated transaction details. */
  transaction?: InputMaybe<WixPaymentApiPayV3TransactionInput>;
};

export type WixPaymentApiPayV3ScheduledActionInput = {
  /** the date and time of the action */
  executionDate?: InputMaybe<Scalars['String']>;
  /** type of the action */
  type?: InputMaybe<WixPaymentApiPayV3ScheduledActionScheduledActionType>;
};

export enum WixPaymentApiPayV3ScheduledActionScheduledActionType {
  CAPTURE = 'CAPTURE',
  VOID = 'VOID'
}

export type WixPaymentApiPayV3TransactionCreatedEventInput = {
  /** Order details (limited to 30 items). */
  order?: InputMaybe<WixPaymentApiPayV3OrderInput>;
  /** Updated transaction details. */
  transaction?: InputMaybe<WixPaymentApiPayV3TransactionInput>;
};

export type WixPaymentApiPayV3TransactionInput = {
  /** Amount and currency of transaction */
  amount?: InputMaybe<WixPaymentApiPayV3CurrencyAmountInput>;
  /** Customer's billing address (optional) */
  billingAddress?: InputMaybe<WixCommonAddressInput>;
  /** Customer's billing address - contact details (optional) */
  billingAddressContacts?: InputMaybe<WixCommonFullAddressContactDetailsInput>;
  /** Transaction creation date */
  createdAt?: InputMaybe<Scalars['String']>;
  creditCardPaymentMethodData?: InputMaybe<WixPaymentApiPayV3CreditCardPaymentMethodDataInput>;
  /** Transaction ID */
  id?: InputMaybe<Scalars['String']>;
  /** Total number of installments */
  installments?: InputMaybe<Scalars['Int']>;
  /** Payment method */
  paymentMethod?: InputMaybe<Scalars['String']>;
  /** The details of a payment method account. */
  paymentMethodAccountInfo?: InputMaybe<WixPaymentApiPayV3AccountInfoInput>;
  /** Payment service provider */
  paymentProvider?: InputMaybe<Scalars['String']>;
  /** Provider transaction ID */
  providerTransactionId?: InputMaybe<Scalars['String']>;
  /** Reason provided for status change */
  reasonCode?: InputMaybe<Scalars['String']>;
  /** Details of subscription, which (if) the transaction is a part of */
  recurringPaymentDetails?: InputMaybe<WixPaymentApiPayV3RecurringPaymentDetailsInput>;
  /** Refunded amount and currency of transaction */
  refundedAmount?: InputMaybe<WixPaymentApiPayV3CurrencyAmountInput>;
  /** Scheduled action for this transaction */
  scheduledAction?: InputMaybe<WixPaymentApiPayV3ScheduledActionInput>;
  /** Updated transaction status */
  status?: InputMaybe<WixPaymentApiPayV3TransactionTransactionStatus>;
  /** order id associated with the transaction on the vertical side */
  verticalOrderId?: InputMaybe<Scalars['String']>;
};

export type WixPaymentApiPayV3TransactionStatusChangedEventInput = {
  /** Order details (limited to 30 items). */
  order?: InputMaybe<WixPaymentApiPayV3OrderInput>;
  /** Previous transaction status. */
  previousStatus?: InputMaybe<WixPaymentApiPayV3TransactionTransactionStatus>;
  /** New transaction details. */
  transaction?: InputMaybe<WixPaymentApiPayV3TransactionInput>;
};

export enum WixPaymentApiPayV3TransactionTransactionStatus {
  APPROVED = 'APPROVED',
  AUTHORIZED = 'AUTHORIZED',
  CANCELED = 'CANCELED',
  DECLINED = 'DECLINED',
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
  PENDING = 'PENDING',
  PENDING_MERCHANT = 'PENDING_MERCHANT',
  REFUNDED = 'REFUNDED',
  UNDEFINED = 'UNDEFINED',
  VOIDED = 'VOIDED'
}

export type WixPaymentApiPayV3TransactionUpdatedEventInput = {
  /** Order details (limited to 30 items). */
  order?: InputMaybe<WixPaymentApiPayV3OrderInput>;
  /** Updated transaction details. */
  transaction?: InputMaybe<WixPaymentApiPayV3TransactionInput>;
  /** Is event triggered by request to clean user data */
  triggeredByAnonymizeRequest?: InputMaybe<Scalars['Boolean']>;
};

export type WixPaymentsPaymentAgreementsV1CreatePaymentAgreementRequestInput = {
  /**
   * List of heeded fields that will be returned.
   * You should have additional permission in order to get them as described in RequestedFields documentation.
   */
  fields?: InputMaybe<Array<InputMaybe<WixPaymentsPaymentAgreementsV1RequestedFields>>>;
  /** Idempotency key. */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** PaymentAgreement to be created. */
  paymentAgreement?: InputMaybe<WixPaymentsPaymentAgreementsV1PaymentAgreementInput>;
  /** Temporary token of credit card tokenized by Wix. This token is used to create a persistent token */
  temporaryCardToken?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1CreatePaymentAgreementResponse = {
  /** The created PaymentAgreement. */
  paymentAgreement?: Maybe<WixPaymentsPaymentAgreementsV1PaymentAgreement>;
};

export type WixPaymentsPaymentAgreementsV1DeletePaymentAgreementRequestInput = {
  /** Id of the PaymentAgreement to delete. */
  paymentAgreementId?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1FinalizePaymentAgreementRequestInput = {
  /** Payment agreement ID. */
  paymentAgreementId?: InputMaybe<Scalars['String']>;
  /** Meta-site ID. */
  siteId?: InputMaybe<Scalars['String']>;
  /**
   * Temporary token for the payment agreement finalization,
   * by default temporary token is taken from the payment agreement.
   */
  temporaryToken?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1GetPaymentAgreementRequestInput = {
  /**
   * List of heeded fields that will be returned.
   * You should have additional permission in order to get them as described in RequestedFields documentation.
   */
  fields?: InputMaybe<Array<InputMaybe<WixPaymentsPaymentAgreementsV1RequestedFields>>>;
  id: Scalars['ID'];
};

export type WixPaymentsPaymentAgreementsV1PaymentAgreement = {
  /** The Account Connection ID to use with this Payment Agreement for future payments */
  accountConnectionId?: Maybe<Scalars['String']>;
  /** Billing address of the PaymentAgreement's owner. */
  billingAddress?: Maybe<WixPaymentsPaymentAgreementsV1PaymentAgreementBillingAddress>;
  /** The ID of a Charge if it was an origin of this PaymentAgreement. */
  chargeId?: Maybe<Scalars['String']>;
  /** Date and time the PaymentAgreement was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Data Extensions */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  id?: Maybe<Scalars['String']>;
  /** Indicates whether the PaymentAgreement was created by a Merchant during MOTO payment or by a customer. */
  merchantCreated?: Maybe<Scalars['Boolean']>;
  /** PaymentAgreement's owner identities. */
  owner?: Maybe<WixPaymentsPaymentAgreementsV1PaymentAgreementOwner>;
  /** The ID of a Payment Intent if it was an origin of this PaymentAgreement. */
  paymentIntentId?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<WixPaymentsPaymentAgreementsV1PaymentAgreementPaymentMethod>;
  /**
   * Payment service provider ID that was used to create a PaymentAgreement.
   * *INTERNAL* as it should eventually be replaced with a reference to provider account which contains this information.
   */
  providerId?: Maybe<Scalars['String']>;
  /**
   * Revision number, which increments by 1 each time the PaymentAgreement is updated.
   * To prevent conflicting changes,
   * the current revision must be passed when updating the PaymentAgreement.
   *
   * Ignored when creating a PaymentAgreement.
   */
  revision?: Maybe<Scalars['Long']>;
  /**
   * Indicates whether the PaymentAgreement is in sandbox mode.
   * *INTERNAL* as it should eventually be replaced with a reference to provider account which contains this information.
   */
  sandbox?: Maybe<Scalars['Boolean']>;
  /**
   * Saved payment method which is used to charge customer within a PaymentAgreement.
   * Empty when PaymentAgreement was created without creation of a SavedPaymentMethod, e.g. the Recurring Setup flow
   */
  savedPaymentMethodId?: Maybe<Scalars['String']>;
  sensitiveInfo?: Maybe<WixPaymentsPaymentAgreementsV1PaymentAgreementSensitiveInfo>;
  /** Date and time the PaymentAgreement was last updated. */
  updatedDate?: Maybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1PaymentAgreementAccountInfo = {
  /** Country code as 2 letters ISO-3166-1 */
  countryCode?: Maybe<Scalars['String']>;
  /** The email of an Account used by Payment Method */
  email?: Maybe<Scalars['String']>;
  /** International bank account number. */
  iban?: Maybe<Scalars['String']>;
  /** Owner name associated with the account. */
  ownerName?: Maybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1PaymentAgreementAccountInfoInput = {
  /** Country code as 2 letters ISO-3166-1 */
  countryCode?: InputMaybe<Scalars['String']>;
  /** The email of an Account used by Payment Method */
  email?: InputMaybe<Scalars['String']>;
  /** International bank account number. */
  iban?: InputMaybe<Scalars['String']>;
  /** Owner name associated with the account. */
  ownerName?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1PaymentAgreementBillingAddress = {
  /** todo: remove unused fields from decomposition and remove validations */
  address?: Maybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonAddress>;
  /** todo: remove unused fields from decomposition and remove validations */
  contactDetails?: Maybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonFullAddressContactDetails>;
};

export type WixPaymentsPaymentAgreementsV1PaymentAgreementBillingAddressInput = {
  /** todo: remove unused fields from decomposition and remove validations */
  address?: InputMaybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonAddressInput>;
  /** todo: remove unused fields from decomposition and remove validations */
  contactDetails?: InputMaybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonFullAddressContactDetailsInput>;
};

export enum WixPaymentsPaymentAgreementsV1PaymentAgreementCardBrandEnumCardBrand {
  AMEX = 'AMEX',
  DANKORT = 'DANKORT',
  DINERS = 'DINERS',
  DISCOVER = 'DISCOVER',
  ISRACARD = 'ISRACARD',
  JCB = 'JCB',
  MAESTRO = 'MAESTRO',
  MASTERCARD = 'MASTERCARD',
  RUPAY = 'RUPAY',
  UNIONPAY = 'UNIONPAY',
  UNKNOWN_CARD_BRAND = 'UNKNOWN_CARD_BRAND',
  VISA = 'VISA'
}

export type WixPaymentsPaymentAgreementsV1PaymentAgreementCardInfo = {
  /** Card BIN (Bank Identification Number). It's the first 4-8 digits of a card number. */
  bin?: Maybe<Scalars['String']>;
  /**
   * Card brand.
   * *INTERNAL* as it's not platformized yet.
   */
  brand?: Maybe<WixPaymentsPaymentAgreementsV1PaymentAgreementCardBrandEnumCardBrand>;
  /** Card holder's full name specified on the card. */
  cardholderName?: Maybe<Scalars['String']>;
  /** Card expiration month. */
  expirationMonth?: Maybe<Scalars['Int']>;
  /** Card expiration year. */
  expirationYear?: Maybe<Scalars['Int']>;
  /** Card last 4 digits. */
  lastFourDigits?: Maybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1PaymentAgreementCardInfoInput = {
  /** Card BIN (Bank Identification Number). It's the first 4-8 digits of a card number. */
  bin?: InputMaybe<Scalars['String']>;
  /**
   * Card brand.
   * *INTERNAL* as it's not platformized yet.
   */
  brand?: InputMaybe<WixPaymentsPaymentAgreementsV1PaymentAgreementCardBrandEnumCardBrand>;
  /** Card holder's full name specified on the card. */
  cardholderName?: InputMaybe<Scalars['String']>;
  /** Card expiration month. */
  expirationMonth?: InputMaybe<Scalars['Int']>;
  /** Card expiration year. */
  expirationYear?: InputMaybe<Scalars['Int']>;
  /** Card last 4 digits. */
  lastFourDigits?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1PaymentAgreementInput = {
  /** The Account Connection ID to use with this Payment Agreement for future payments */
  accountConnectionId?: InputMaybe<Scalars['String']>;
  /** Billing address of the PaymentAgreement's owner. */
  billingAddress?: InputMaybe<WixPaymentsPaymentAgreementsV1PaymentAgreementBillingAddressInput>;
  /** The ID of a Charge if it was an origin of this PaymentAgreement. */
  chargeId?: InputMaybe<Scalars['String']>;
  /** Date and time the PaymentAgreement was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Data Extensions */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  id?: InputMaybe<Scalars['String']>;
  /** Indicates whether the PaymentAgreement was created by a Merchant during MOTO payment or by a customer. */
  merchantCreated?: InputMaybe<Scalars['Boolean']>;
  /** PaymentAgreement's owner identities. */
  owner?: InputMaybe<WixPaymentsPaymentAgreementsV1PaymentAgreementOwnerInput>;
  /** The ID of a Payment Intent if it was an origin of this PaymentAgreement. */
  paymentIntentId?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<WixPaymentsPaymentAgreementsV1PaymentAgreementPaymentMethodInput>;
  /**
   * Payment service provider ID that was used to create a PaymentAgreement.
   * *INTERNAL* as it should eventually be replaced with a reference to provider account which contains this information.
   */
  providerId?: InputMaybe<Scalars['String']>;
  /**
   * Revision number, which increments by 1 each time the PaymentAgreement is updated.
   * To prevent conflicting changes,
   * the current revision must be passed when updating the PaymentAgreement.
   *
   * Ignored when creating a PaymentAgreement.
   */
  revision?: InputMaybe<Scalars['Long']>;
  /**
   * Indicates whether the PaymentAgreement is in sandbox mode.
   * *INTERNAL* as it should eventually be replaced with a reference to provider account which contains this information.
   */
  sandbox?: InputMaybe<Scalars['Boolean']>;
  /**
   * Saved payment method which is used to charge customer within a PaymentAgreement.
   * Empty when PaymentAgreement was created without creation of a SavedPaymentMethod, e.g. the Recurring Setup flow
   */
  savedPaymentMethodId?: InputMaybe<Scalars['String']>;
  sensitiveInfo?: InputMaybe<WixPaymentsPaymentAgreementsV1PaymentAgreementSensitiveInfoInput>;
  /** Date and time the PaymentAgreement was last updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1PaymentAgreementNetworkReference = {
  /** Transaction ID assigned by 3D Secure 2 directory server. */
  dsTransactionId?: Maybe<Scalars['String']>;
  /** Transaction ID assigned by a card scheme (Trace ID for Mastercard or Transaction ID for Visa). */
  networkTransactionId?: Maybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1PaymentAgreementNetworkReferenceInput = {
  /** Transaction ID assigned by 3D Secure 2 directory server. */
  dsTransactionId?: InputMaybe<Scalars['String']>;
  /** Transaction ID assigned by a card scheme (Trace ID for Mastercard or Transaction ID for Visa). */
  networkTransactionId?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1PaymentAgreementOwner = {
  contactId?: Maybe<Scalars['String']>;
  siteMemberId?: Maybe<Scalars['String']>;
  siteVisitorId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1PaymentAgreementOwnerInput = {
  contactId?: InputMaybe<Scalars['String']>;
  siteMemberId?: InputMaybe<Scalars['String']>;
  siteVisitorId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1PaymentAgreementPaymentMethod = {
  /** The details of an account. */
  accountInfo?: Maybe<WixPaymentsPaymentAgreementsV1PaymentAgreementAccountInfo>;
  /** The details of a card. */
  cardInfo?: Maybe<WixPaymentsPaymentAgreementsV1PaymentAgreementCardInfo>;
  /** Payment method type id. Supported values are `creditCard`, `payPal`, `applePay`. */
  typeId?: Maybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1PaymentAgreementPaymentMethodInput = {
  /** The details of an account. */
  accountInfo?: InputMaybe<WixPaymentsPaymentAgreementsV1PaymentAgreementAccountInfoInput>;
  /** The details of a card. */
  cardInfo?: InputMaybe<WixPaymentsPaymentAgreementsV1PaymentAgreementCardInfoInput>;
  /** Payment method type id. Supported values are `creditCard`, `payPal`, `applePay`. */
  typeId?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1PaymentAgreementSensitiveInfo = {
  /**
   * Merchant credentials of payment provider that was used to create a payment agreement.
   * *INTERNAL* as it should eventually be replaced with a reference to provider account which contains this information.
   */
  merchantCredentials?: Maybe<Scalars['String']>;
  /** Transaction reference provided by a payment network. */
  networkReference?: Maybe<WixPaymentsPaymentAgreementsV1PaymentAgreementNetworkReference>;
  /**
   * Token of Card which is stored in PCI environment
   * Intended to generate a new instance of temporary Card token for payments by this Payment Agreement
   */
  persistentCardToken?: Maybe<Scalars['String']>;
  /** Tokens that are used to reference a payment agreement in external payment provider. */
  providerToken?: Maybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1PaymentAgreementSensitiveInfoInput = {
  /**
   * Merchant credentials of payment provider that was used to create a payment agreement.
   * *INTERNAL* as it should eventually be replaced with a reference to provider account which contains this information.
   */
  merchantCredentials?: InputMaybe<Scalars['String']>;
  /** Transaction reference provided by a payment network. */
  networkReference?: InputMaybe<WixPaymentsPaymentAgreementsV1PaymentAgreementNetworkReferenceInput>;
  /**
   * Token of Card which is stored in PCI environment
   * Intended to generate a new instance of temporary Card token for payments by this Payment Agreement
   */
  persistentCardToken?: InputMaybe<Scalars['String']>;
  /** Tokens that are used to reference a payment agreement in external payment provider. */
  providerToken?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1QueryPaymentAgreementsRequestInput = {
  /**
   * List of heeded fields that will be returned.
   * You should have additional permission in order to get them as described in RequestedFields documentation.
   */
  fields?: InputMaybe<Array<InputMaybe<WixPaymentsPaymentAgreementsV1RequestedFields>>>;
  /** WQL expression. */
  query?: InputMaybe<WixPaymentsPaymentAgreementsV1UpstreamWixQueryCursorQueryInput>;
};

export type WixPaymentsPaymentAgreementsV1QueryPaymentAgreementsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<WixPaymentsPaymentAgreementsV1PaymentAgreement>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export enum WixPaymentsPaymentAgreementsV1RequestedFields {
  SENSITIVE_INFO = 'SENSITIVE_INFO',
  /** Default value. This value is unused. */
  UNKNOWN_REQUESTED_FIELD = 'UNKNOWN_REQUESTED_FIELD'
}

export type WixPaymentsPaymentAgreementsV1UpdateExtendedFieldsRequestInput = {
  /**
   * List of heeded fields that will be returned.
   * You should have additional permission in order to get them as described in RequestedFields documentation.
   */
  fields?: InputMaybe<Array<InputMaybe<WixPaymentsPaymentAgreementsV1RequestedFields>>>;
  /** ID of the PaymentAgreement to update. */
  id?: InputMaybe<Scalars['String']>;
  /** Identifier for the app whose extended fields are being updated. */
  namespace?: InputMaybe<Scalars['String']>;
  /** Data to update. Structured according to the [schema](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields#json-schema-for-extended-fields) defined when the extended fields were configured. */
  namespaceData?: InputMaybe<Scalars['JSON']>;
};

export type WixPaymentsPaymentAgreementsV1UpdateExtendedFieldsResponse = {
  /** Updated PaymentAgreement. */
  paymentAgreement?: Maybe<WixPaymentsPaymentAgreementsV1PaymentAgreement>;
};

export type WixPaymentsPaymentAgreementsV1UpdatePaymentAgreementRequestInput = {
  /**
   * Set of fields to update.
   *
   * Fields that aren't included in `fieldMask.paths` are ignored.
   */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * List of heeded fields that will be returned.
   * You should have additional permission in order to get them as described in RequestedFields documentation.
   */
  fields?: InputMaybe<Array<InputMaybe<WixPaymentsPaymentAgreementsV1RequestedFields>>>;
  /** PaymentAgreement to be updated, may be partial. */
  paymentAgreement?: InputMaybe<WixPaymentsPaymentAgreementsV1PaymentAgreementInput>;
};

export type WixPaymentsPaymentAgreementsV1UpdatePaymentAgreementResponse = {
  /** Updated PaymentAgreement. */
  paymentAgreement?: Maybe<WixPaymentsPaymentAgreementsV1PaymentAgreement>;
};

export type WixPaymentsPaymentAgreementsV1UpstreamWixCommonAddress = {
  /** Main address line, usually street and number as free text. */
  addressLine?: Maybe<Scalars['String']>;
  /** Free text providing more detailed address info. Usually contains Apt, Suite, and Floor. */
  addressLine2?: Maybe<Scalars['String']>;
  /** City name. */
  city?: Maybe<Scalars['String']>;
  /** Country code. */
  country?: Maybe<Scalars['String']>;
  /** Country full name. */
  countryFullname?: Maybe<Scalars['String']>;
  /** A string containing the full address of this location. */
  formattedAddress?: Maybe<Scalars['String']>;
  /** Coordinates of the physical address. */
  geocode?: Maybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonAddressLocation>;
  /** Free text to help find the address. */
  hint?: Maybe<Scalars['String']>;
  /** Zip/postal code. */
  postalCode?: Maybe<Scalars['String']>;
  /** Street name and number. */
  streetAddress?: Maybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonStreetAddress>;
  /** Subdivision. Usually a state, region, prefecture, or province code, according to [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2). */
  subdivision?: Maybe<Scalars['String']>;
  /** Subdivision full name. */
  subdivisionFullname?: Maybe<Scalars['String']>;
  /** Multi-level subdivisions from top to bottom. */
  subdivisions?: Maybe<Array<Maybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonSubdivision>>>;
};

export type WixPaymentsPaymentAgreementsV1UpstreamWixCommonAddressInput = {
  /** Main address line, usually street and number as free text. */
  addressLine?: InputMaybe<Scalars['String']>;
  /** Free text providing more detailed address info. Usually contains Apt, Suite, and Floor. */
  addressLine2?: InputMaybe<Scalars['String']>;
  /** City name. */
  city?: InputMaybe<Scalars['String']>;
  /** Country code. */
  country?: InputMaybe<Scalars['String']>;
  /** Country full name. */
  countryFullname?: InputMaybe<Scalars['String']>;
  /** A string containing the full address of this location. */
  formattedAddress?: InputMaybe<Scalars['String']>;
  /** Coordinates of the physical address. */
  geocode?: InputMaybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonAddressLocationInput>;
  /** Free text to help find the address. */
  hint?: InputMaybe<Scalars['String']>;
  /** Zip/postal code. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** Street name and number. */
  streetAddress?: InputMaybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonStreetAddressInput>;
  /** Subdivision. Usually a state, region, prefecture, or province code, according to [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2). */
  subdivision?: InputMaybe<Scalars['String']>;
  /** Subdivision full name. */
  subdivisionFullname?: InputMaybe<Scalars['String']>;
  /** Multi-level subdivisions from top to bottom. */
  subdivisions?: InputMaybe<Array<InputMaybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonSubdivisionInput>>>;
};

export type WixPaymentsPaymentAgreementsV1UpstreamWixCommonAddressLocation = {
  /** Address latitude. */
  latitude?: Maybe<Scalars['Float']>;
  /** Address longitude. */
  longitude?: Maybe<Scalars['Float']>;
};

export type WixPaymentsPaymentAgreementsV1UpstreamWixCommonAddressLocationInput = {
  /** Address latitude. */
  latitude?: InputMaybe<Scalars['Float']>;
  /** Address longitude. */
  longitude?: InputMaybe<Scalars['Float']>;
};

export type WixPaymentsPaymentAgreementsV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixPaymentsPaymentAgreementsV1UpstreamWixCommonFullAddressContactDetails = {
  /** Contact's company name. */
  company?: Maybe<Scalars['String']>;
  /** Email associated with the address. */
  email?: Maybe<Scalars['String']>;
  /** Contact's first name. */
  firstName?: Maybe<Scalars['String']>;
  /** Contact's full name. */
  fullName?: Maybe<Scalars['String']>;
  /** Contact's last name. */
  lastName?: Maybe<Scalars['String']>;
  /** Contact's phone number. */
  phone?: Maybe<Scalars['String']>;
  /** Tax info. Currently usable only in Brazil. */
  vatId?: Maybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonVatId>;
};

export type WixPaymentsPaymentAgreementsV1UpstreamWixCommonFullAddressContactDetailsInput = {
  /** Contact's company name. */
  company?: InputMaybe<Scalars['String']>;
  /** Email associated with the address. */
  email?: InputMaybe<Scalars['String']>;
  /** Contact's first name. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Contact's full name. */
  fullName?: InputMaybe<Scalars['String']>;
  /** Contact's last name. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Contact's phone number. */
  phone?: InputMaybe<Scalars['String']>;
  /** Tax info. Currently usable only in Brazil. */
  vatId?: InputMaybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonVatIdInput>;
};

export enum WixPaymentsPaymentAgreementsV1UpstreamWixCommonSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type WixPaymentsPaymentAgreementsV1UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonSortOrder>;
};

export type WixPaymentsPaymentAgreementsV1UpstreamWixCommonStreetAddress = {
  /** Apartment number. */
  apt?: Maybe<Scalars['String']>;
  /** Optional address line 1 */
  formattedAddressLine?: Maybe<Scalars['String']>;
  /** Street name. */
  name?: Maybe<Scalars['String']>;
  /** Street number. */
  number?: Maybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1UpstreamWixCommonStreetAddressInput = {
  /** Apartment number. */
  apt?: InputMaybe<Scalars['String']>;
  /** Optional address line 1 */
  formattedAddressLine?: InputMaybe<Scalars['String']>;
  /** Street name. */
  name?: InputMaybe<Scalars['String']>;
  /** Street number. */
  number?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1UpstreamWixCommonSubdivision = {
  /** Short subdivision code. */
  code?: Maybe<Scalars['String']>;
  /** Subdivision full name. */
  name?: Maybe<Scalars['String']>;
  /** Subdivision level */
  type?: Maybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonSubdivisionSubdivisionType>;
  /** Free text description of subdivision type. */
  typeInfo?: Maybe<Scalars['String']>;
};

export type WixPaymentsPaymentAgreementsV1UpstreamWixCommonSubdivisionInput = {
  /** Short subdivision code. */
  code?: InputMaybe<Scalars['String']>;
  /** Subdivision full name. */
  name?: InputMaybe<Scalars['String']>;
  /** Subdivision level */
  type?: InputMaybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonSubdivisionSubdivisionType>;
  /** Free text description of subdivision type. */
  typeInfo?: InputMaybe<Scalars['String']>;
};

export enum WixPaymentsPaymentAgreementsV1UpstreamWixCommonSubdivisionSubdivisionType {
  /** State */
  ADMINISTRATIVE_AREA_LEVEL_1 = 'ADMINISTRATIVE_AREA_LEVEL_1',
  /** County */
  ADMINISTRATIVE_AREA_LEVEL_2 = 'ADMINISTRATIVE_AREA_LEVEL_2',
  /** City/town */
  ADMINISTRATIVE_AREA_LEVEL_3 = 'ADMINISTRATIVE_AREA_LEVEL_3',
  /** Neighborhood/quarter */
  ADMINISTRATIVE_AREA_LEVEL_4 = 'ADMINISTRATIVE_AREA_LEVEL_4',
  /** Street/block */
  ADMINISTRATIVE_AREA_LEVEL_5 = 'ADMINISTRATIVE_AREA_LEVEL_5',
  /** ADMINISTRATIVE_AREA_LEVEL_0. Indicates the national political entity, and is typically the highest order type returned by the Geocoder. */
  COUNTRY = 'COUNTRY',
  UNKNOWN_SUBDIVISION_TYPE = 'UNKNOWN_SUBDIVISION_TYPE'
}

export type WixPaymentsPaymentAgreementsV1UpstreamWixCommonVatId = {
  /** Customer's tax ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Tax type.
   *
   * Supported values:
   * + `CPF`: for individual tax payers
   * + `CNPJ`: for corporations
   */
  type?: Maybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonVatType>;
};

export type WixPaymentsPaymentAgreementsV1UpstreamWixCommonVatIdInput = {
  /** Customer's tax ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Tax type.
   *
   * Supported values:
   * + `CPF`: for individual tax payers
   * + `CNPJ`: for corporations
   */
  type?: InputMaybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonVatType>;
};

export enum WixPaymentsPaymentAgreementsV1UpstreamWixCommonVatType {
  /** CNPJ - for corporations */
  CNPJ = 'CNPJ',
  /** CPF - for individual tax payers. */
  CPF = 'CPF',
  UNSPECIFIED = 'UNSPECIFIED'
}

export type WixPaymentsPaymentAgreementsV1UpstreamWixQueryCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixPaymentsPaymentAgreementsV1UpstreamWixCommonSortingInput>>>;
};

export type WixPaymentsRefundsV1CreateRefundRequestInput = {
  /**
   * Amount of the charge that was previously refunded.
   *
   * Specify this to compare your records of previously refunded amounts against those on the server. If they don't match, this method will return an error with the code `PREVIOUSLY_REFUNDED_AMOUNT_MISMATCH`.
   *
   * Learn more about [preventing unintended refunds](https://dev.wix.com/docs/rest/business-management/payments/refunds/introduction#preventing-unintended-refunds).
   */
  previouslyRefundedAmount?: InputMaybe<Scalars['String']>;
  /** Refund to be created. */
  refund?: InputMaybe<WixPaymentsRefundsV1RefundInput>;
  /**
   * _INTERNAL_
   * True means processing fee for the refunded charge should be returned to the merchant.
   * Applies only to Wix Payments charges.
   * `PAYMENTS.REFUND_RETURN_PROCESSING_FEE` permission is required.
   */
  returnProcessingFee?: InputMaybe<Scalars['Boolean']>;
};

export type WixPaymentsRefundsV1CreateRefundResponse = {
  /** The created refund. */
  refund?: Maybe<WixPaymentsRefundsV1Refund>;
};

export type WixPaymentsRefundsV1GetRefundRequestInput = {
  id: Scalars['ID'];
};

export type WixPaymentsRefundsV1GetRefundabilityRequestInput = {
  /** ID of the charge to calculate refundability for. */
  chargeId?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsRefundsV1GetRefundabilityResponse = {
  /** Refundability of the charge. */
  refundability?: Maybe<WixPaymentsRefundsV1Refundability>;
};

export type WixPaymentsRefundsV1InternalSyncRefundRequestInput = {
  /** Unique number assigned to a refund. This number is shared across all parties involved in processing the refund. It allows the merchant to track the refund with their bank. */
  acquirerReferenceNumber?: InputMaybe<Scalars['String']>;
  /**
   * Amount of refund in base units, what's returned to the buyer.
   * E.g. "12.95".
   */
  amount?: InputMaybe<Scalars['String']>;
  /** ID of charge for which the funds are returned by this refund. */
  chargeId?: InputMaybe<Scalars['String']>;
  /** Currency of refund, should be the same as currency of charge. */
  currency?: InputMaybe<Scalars['String']>;
  /** Currency of refund, should be the same as currency of charge. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Who initiated this refund. */
  initiator?: InputMaybe<WixPaymentsRefundsV1RefundInitiator>;
  /** Optional free-text note about this refund. */
  note?: InputMaybe<Scalars['String']>;
  /** ID of the refund on the PSP side. */
  providerRefundId?: InputMaybe<Scalars['String']>;
  /** Reason why this refund was issued. */
  reason?: InputMaybe<Scalars['String']>;
  /** Refund ID. */
  refundId?: InputMaybe<Scalars['String']>;
  /**
   * Application fee returned to merchant from Wix.
   * Having this as a separate field since Refund.returned_application_fee is readOnly.
   */
  returnedApplicationFee?: InputMaybe<Scalars['String']>;
  /**
   * Processing fee returned to merchant from Wix.
   * Having this as a separate field since Refund.returned_processing_fee is readOnly.
   */
  returnedProcessingFee?: InputMaybe<Scalars['String']>;
  /**
   * Status of the refund.
   * Read more about statuses in this [article](<https://dev.wix.com/docs/rest/business-management/payments/refunds/introduction#lifecycle-of-a-refund>).
   */
  status?: InputMaybe<WixPaymentsRefundsV1RefundStatus>;
  /**
   * Status code.
   * [Read more about reason codes.](https://dev.wix.com/docs/rest/api-reference/payment-provider-spi/reason-codes)
   */
  statusCode?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsRefundsV1InternalSyncRefundResponse = {
  /** Created/updated refund. */
  refund?: Maybe<WixPaymentsRefundsV1Refund>;
};

export type WixPaymentsRefundsV1QueryRefundsRequestInput = {
  /** Query options. */
  query?: InputMaybe<WixPaymentsRefundsV1UpstreamWixQueryCursorQueryInput>;
};

export type WixPaymentsRefundsV1QueryRefundsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<WixPaymentsRefundsV1Refund>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixPaymentsRefundsV1Refund = {
  /** Unique number assigned to a refund. This number is shared across all parties involved in processing the refund. It allows the merchant to track the refund with their bank. */
  acquirerReferenceNumber?: Maybe<Scalars['String']>;
  /**
   * Amount being returned to the buyer in the refund currency's main units (such as dollars or euros).
   * For example, `"12.95"`.
   */
  amount?: Maybe<Scalars['String']>;
  /** ID of the charge to refund. */
  chargeId?: Maybe<Scalars['String']>;
  /** Date and time the refund was created in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#coordinated_Universal_Time_(UTC)) format. For example, "2024-01-30T13:30:00". */
  createdDate?: Maybe<Scalars['String']>;
  /** Refund currency. Should be the same as the charge currency. */
  currency?: Maybe<Scalars['String']>;
  /** Refund currency. Should be the same as the charge currency. */
  currencyCode?: Maybe<Scalars['String']>;
  /**
   * Custom field data for the refund object.
   *
   * [Extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields) must be configured in the app dashboard before they can be accessed with API calls.
   */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** Whether the refund is for the entire amount of the charge. */
  full?: Maybe<Scalars['Boolean']>;
  /** Refund ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * _INTERNAL_
   * Who initiated this refund. Setting this field requires PAYMENTS.REFUND_SET_INITIATOR permission.
   */
  initiator?: Maybe<WixPaymentsRefundsV1RefundInitiator>;
  /** Note providing additional information about this refund. */
  note?: Maybe<Scalars['String']>;
  /** Payment service provider's ID for the refund. */
  providerRefundId?: Maybe<Scalars['String']>;
  /** Reason this refund was issued. */
  reason?: Maybe<Scalars['String']>;
  /**
   * Application fee returned to the merchant from Wix in the refund currency's main units (such as dollars or euros). For example, `"12.95"`.
   *
   * Only included if an application fee was returned.
   */
  returnedApplicationFee?: Maybe<Scalars['String']>;
  /**
   * Processing fee returned to the merchant from the payment service provider in the refund currency's main units (such as dollars or euros). For example, `"12.95"`.
   *
   * This field is empty when the processing fee is unknown.
   */
  returnedProcessingFee?: Maybe<Scalars['String']>;
  /**
   * Revision number, which increments by 1 each time the refund is updated.
   *
   * Ignored when creating a refund.
   */
  revision?: Maybe<Scalars['Long']>;
  /**
   * Status of the refund.
   *
   * Learn more about the [refund lifecycle](https://dev.wix.com/docs/rest/business-management/payments/refunds/introduction#lifecycle-of-a-refund>).
   */
  status?: Maybe<WixPaymentsRefundsV1RefundStatus>;
  /**
   * Details about the refund status.
   * Used to provide additional information about why a refund was given its status.
   */
  statusInfo?: Maybe<WixPaymentsRefundsV1StatusInfo>;
  /** Date and time the refund was last updated in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#coordinated_Universal_Time_(UTC)) format. For example, "2024-01-30T13:30:00". */
  updatedDate?: Maybe<Scalars['String']>;
};

export type WixPaymentsRefundsV1RefundDetails = {
  /** Maximum allowed refund amount in the refund currency's main units (such as dollars or euros). For example, `"12.95"`. */
  maxRefundAmount?: Maybe<Scalars['String']>;
  /** Minimum allowed refund amount in the refund currency's main units (such as dollars or euros). For example, `"0.50"`. */
  minRefundAmount?: Maybe<Scalars['String']>;
};

export enum WixPaymentsRefundsV1RefundInitiator {
  API = 'API',
  PROVIDER = 'PROVIDER',
  UNKNOWN_INITIATOR = 'UNKNOWN_INITIATOR',
  WIX = 'WIX'
}

export type WixPaymentsRefundsV1RefundInput = {
  /** Unique number assigned to a refund. This number is shared across all parties involved in processing the refund. It allows the merchant to track the refund with their bank. */
  acquirerReferenceNumber?: InputMaybe<Scalars['String']>;
  /**
   * Amount being returned to the buyer in the refund currency's main units (such as dollars or euros).
   * For example, `"12.95"`.
   */
  amount?: InputMaybe<Scalars['String']>;
  /** ID of the charge to refund. */
  chargeId?: InputMaybe<Scalars['String']>;
  /** Date and time the refund was created in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#coordinated_Universal_Time_(UTC)) format. For example, "2024-01-30T13:30:00". */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Refund currency. Should be the same as the charge currency. */
  currency?: InputMaybe<Scalars['String']>;
  /** Refund currency. Should be the same as the charge currency. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /**
   * Custom field data for the refund object.
   *
   * [Extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields) must be configured in the app dashboard before they can be accessed with API calls.
   */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** Whether the refund is for the entire amount of the charge. */
  full?: InputMaybe<Scalars['Boolean']>;
  /** Refund ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * _INTERNAL_
   * Who initiated this refund. Setting this field requires PAYMENTS.REFUND_SET_INITIATOR permission.
   */
  initiator?: InputMaybe<WixPaymentsRefundsV1RefundInitiator>;
  /** Note providing additional information about this refund. */
  note?: InputMaybe<Scalars['String']>;
  /** Payment service provider's ID for the refund. */
  providerRefundId?: InputMaybe<Scalars['String']>;
  /** Reason this refund was issued. */
  reason?: InputMaybe<Scalars['String']>;
  /**
   * Application fee returned to the merchant from Wix in the refund currency's main units (such as dollars or euros). For example, `"12.95"`.
   *
   * Only included if an application fee was returned.
   */
  returnedApplicationFee?: InputMaybe<Scalars['String']>;
  /**
   * Processing fee returned to the merchant from the payment service provider in the refund currency's main units (such as dollars or euros). For example, `"12.95"`.
   *
   * This field is empty when the processing fee is unknown.
   */
  returnedProcessingFee?: InputMaybe<Scalars['String']>;
  /**
   * Revision number, which increments by 1 each time the refund is updated.
   *
   * Ignored when creating a refund.
   */
  revision?: InputMaybe<Scalars['Long']>;
  /**
   * Status of the refund.
   *
   * Learn more about the [refund lifecycle](https://dev.wix.com/docs/rest/business-management/payments/refunds/introduction#lifecycle-of-a-refund>).
   */
  status?: InputMaybe<WixPaymentsRefundsV1RefundStatus>;
  /**
   * Details about the refund status.
   * Used to provide additional information about why a refund was given its status.
   */
  statusInfo?: InputMaybe<WixPaymentsRefundsV1StatusInfoInput>;
  /** Date and time the refund was last updated in [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601#coordinated_Universal_Time_(UTC)) format. For example, "2024-01-30T13:30:00". */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export enum WixPaymentsRefundsV1RefundStatus {
  /** Refund failed. */
  FAILED = 'FAILED',
  /** Refund is in progress. */
  PENDING = 'PENDING',
  /** Refund had succeeded, but has since been reversed. */
  REVERSED = 'REVERSED',
  /** Refund succeeded. */
  SUCCEEDED = 'SUCCEEDED',
  /** Unknown status. This value isn't used. */
  UNKNOWN_STATUS = 'UNKNOWN_STATUS'
}

export type WixPaymentsRefundsV1Refundability = {
  /** Charge currency. */
  currency?: Maybe<Scalars['String']>;
  /** Charge currency. */
  currencyCode?: Maybe<Scalars['String']>;
  /**
   * Sum of amounts of previous refunds for this charge with the `SUCCEEDED` status in the charge currency's main units (such as dollars or euros). For example, `"6.47"`.
   * Used to [prevent unintended refunds](https://dev.wix.com/docs/rest/business-management/payments/refunds/introduction#preventing-unintended-refunds).
   */
  previouslyRefundedAmount?: Maybe<Scalars['String']>;
  /** When the charge is refundable, specifies the allowed range for the refund amount. */
  refundDetails?: Maybe<WixPaymentsRefundsV1RefundDetails>;
  /** Whether you can refund the charge. This depends on your app's permissions, and the permissions of the user checking the refundability. */
  refundable?: Maybe<Scalars['Boolean']>;
  /** When charge is not refundable, specifies why the refund is not allowed. */
  rejectionDetails?: Maybe<WixPaymentsRefundsV1RejectionDetails>;
};

export type WixPaymentsRefundsV1RejectionDetails = {
  /** Reason the refund was rejected. */
  reason?: Maybe<WixPaymentsRefundsV1RejectionDetailsRejectionReason>;
};

export enum WixPaymentsRefundsV1RejectionDetailsRejectionReason {
  /** Charge was disputed. */
  CHARGE_DISPUTED = 'CHARGE_DISPUTED',
  /** Charge was fully refunded. */
  CHARGE_REFUNDED = 'CHARGE_REFUNDED',
  /** Another refund was initiated for this charge and is waiting for confirmation from the provider. */
  CHARGE_REFUND_IN_PROGRESS = 'CHARGE_REFUND_IN_PROGRESS',
  /** Charge is too old to be refunded. */
  CHARGE_REFUND_PERIOD_ENDED = 'CHARGE_REFUND_PERIOD_ENDED',
  /** Charge is unpaid. */
  CHARGE_UNPAID = 'CHARGE_UNPAID',
  /** Merchant doesn't have enough balance to issue a refund for the charge. */
  MERCHANT_BALANCE_INSUFFICIENT = 'MERCHANT_BALANCE_INSUFFICIENT',
  /** The identity requesting the refund doesn't have the required permissions. This can occur if a site collaborator attempts to create a refund on behalf of the merchant. */
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  /** Charges done via POS terminal and should be refunded on that POS terminal. */
  ONLINE_REFUND_NOT_SUPPORTED = 'ONLINE_REFUND_NOT_SUPPORTED',
  /** Payment method used for the charge doesn't support refunds. */
  PAYMENT_METHOD_NOT_SUPPORTED = 'PAYMENT_METHOD_NOT_SUPPORTED',
  /** PSP is temporarily unavailable. */
  PROVIDER_DOWN = 'PROVIDER_DOWN',
  /**
   * PSP doesn't support the refund for one of the following reasons:
   * - The PSP doesn't currently support refunds.
   * - The charge is in an invalid state.
   * - The PSP does not have the required information for this transaction.
   */
  PROVIDER_NOT_SUPPORTED = 'PROVIDER_NOT_SUPPORTED',
  /** Unknown rejection reason. This value isn't used. */
  UNKNOWN_REJECTION_REASON = 'UNKNOWN_REJECTION_REASON'
}

export enum WixPaymentsRefundsV1RejectionRejectionReason {
  /** Charge was disputed. */
  CHARGE_DISPUTED = 'CHARGE_DISPUTED',
  /** Charge is already fully refunded. */
  CHARGE_REFUNDED = 'CHARGE_REFUNDED',
  /** Another refund was initiated for this charge and is waiting for confirmation from the provider. */
  CHARGE_REFUND_IN_PROGRESS = 'CHARGE_REFUND_IN_PROGRESS',
  /** Charge is too old to be refunded. */
  CHARGE_REFUND_PERIOD_ENDED = 'CHARGE_REFUND_PERIOD_ENDED',
  /** Charge is unpaid. */
  CHARGE_UNPAID = 'CHARGE_UNPAID',
  /** Merchant account doesn't support refunds at the moment. */
  MERCHANT_ACCOUNT_NOT_SUPPORTED = 'MERCHANT_ACCOUNT_NOT_SUPPORTED',
  /** Merchant doesn't have enough balance to issue a refund for this charge. */
  MERCHANT_BALANCE_INSUFFICIENT = 'MERCHANT_BALANCE_INSUFFICIENT',
  /** Logged in merchant has no permission to refund this charge. */
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  /** Payment method of a charge doesn't support refunds. */
  PAYMENT_METHOD_NOT_SUPPORTED = 'PAYMENT_METHOD_NOT_SUPPORTED',
  /** PSP is temporarily down. */
  PROVIDER_DOWN = 'PROVIDER_DOWN',
  /**
   * Provider doesn't support refunds at the moment, transaction in a wrong state or we don't
   * have required information for this transaction.
   */
  PROVIDER_NOT_SUPPORTED = 'PROVIDER_NOT_SUPPORTED',
  UNKNOWN_REJECTION_REASON = 'UNKNOWN_REJECTION_REASON'
}

export type WixPaymentsRefundsV1StatusInfo = {
  /**
   * Reason code with detailed information about the refund status.
   * See the full list of [reason codes](https://dev.wix.com/docs/rest/business-management/payments/service-plugins/payment-service-provider-service-plugin/reason-codes#refund-declined).
   */
  code?: Maybe<Scalars['String']>;
  /** Description of the status. */
  description?: Maybe<Scalars['String']>;
};

export type WixPaymentsRefundsV1StatusInfoInput = {
  /**
   * Reason code with detailed information about the refund status.
   * See the full list of [reason codes](https://dev.wix.com/docs/rest/business-management/payments/service-plugins/payment-service-provider-service-plugin/reason-codes#refund-declined).
   */
  code?: InputMaybe<Scalars['String']>;
  /** Description of the status. */
  description?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsRefundsV1UpdateExtendedFieldsResponse = {
  /** Updated refund. */
  refund?: Maybe<WixPaymentsRefundsV1Refund>;
};

export type WixPaymentsRefundsV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export enum WixPaymentsRefundsV1UpstreamWixCommonSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type WixPaymentsRefundsV1UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixPaymentsRefundsV1UpstreamWixCommonSortOrder>;
};

export type WixPaymentsRefundsV1UpstreamWixQueryCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixPaymentsRefundsV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixPaymentsRefundsV1UpstreamWixCommonSortingInput>>>;
};

export type WixPaymentsSavedPaymentMethodsUpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * Pass the relevant cursor token from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Maximum number of items to return in the results. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixPaymentsSavedPaymentMethodsUpstreamWixCommonCursorPagingMetadata = {
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Cursor strings that point to the next page, previous page, or both. */
  cursors?: Maybe<WixPaymentsSavedPaymentMethodsUpstreamWixCommonCursors>;
  /**
   * Whether there are more pages to retrieve following the current page.
   *
   * + `true`: Another page of results can be retrieved.
   * + `false`: This is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSavedPaymentMethodsUpstreamWixCommonCursors = {
  /** Cursor string pointing to the next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to the previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export enum WixPaymentsSavedPaymentMethodsV1CardBrandEnumCardBrand {
  AMEX = 'AMEX',
  DANKORT = 'DANKORT',
  DINERS = 'DINERS',
  DISCOVER = 'DISCOVER',
  ISRACARD = 'ISRACARD',
  JCB = 'JCB',
  MAESTRO = 'MAESTRO',
  MASTERCARD = 'MASTERCARD',
  RUPAY = 'RUPAY',
  UNIONPAY = 'UNIONPAY',
  UNKNOWN_CARD_BRAND = 'UNKNOWN_CARD_BRAND',
  VISA = 'VISA'
}

export type WixPaymentsSavedPaymentMethodsV1DeleteSavedPaymentMethodRequestInput = {
  /** Unique identifier of a saved payment method. */
  savedPaymentMethodId?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsSavedPaymentMethodsV1FindSavedCreditCardRequestInput = {
  /** expiration month */
  expirationMonth?: InputMaybe<Scalars['Int']>;
  /** expiration year */
  expirationYear?: InputMaybe<Scalars['Int']>;
  /** site member id */
  siteMemberId?: InputMaybe<Scalars['String']>;
  /** temporary card token */
  temporaryCardToken?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsSavedPaymentMethodsV1FindSavedCreditCardResponse = {
  /** saved payment method id */
  savedPaymentMethodId?: Maybe<Scalars['String']>;
};

export type WixPaymentsSavedPaymentMethodsV1GetSavedPaymentMethodRequestInput = {
  /**
   * List of heeded fields that will be returned.
   * You should have additional permission in order to get them as described in HidedFields documentation.
   */
  fields?: InputMaybe<Array<InputMaybe<WixPaymentsSavedPaymentMethodsV1RequestedFields>>>;
  id: Scalars['ID'];
};

export type WixPaymentsSavedPaymentMethodsV1ListSavedPaymentMethodsRequestInput = {
  /**
   * List of requested fields that will be returned.
   * Supported values:
   * SENSITIVE_INFO - Sensitive information of a SavedPaymentMethod like credit card tokens that's needed to process payments with it.
   * In order to receive it you should have `PAYMENTS.SAVED_PAYMENT_METHOD_READ_SENSITIVE_INFO` permission
   */
  fields?: InputMaybe<Array<InputMaybe<WixPaymentsSavedPaymentMethodsV1RequestedFields>>>;
  /**
   * Defines whether this payment method can be used by the merchant for making unscheduled payments.
   * Even if it's set to `false` payment method still can be used for scheduled payments e.g. subscription renewal without the buyer being present.
   */
  merchantUseAllowed?: InputMaybe<Scalars['Boolean']>;
  /**
   * Paging for limit the response size.
   * If no paging provider default response limit 100 will be used.
   */
  paging?: InputMaybe<WixPaymentsSavedPaymentMethodsUpstreamWixCommonCursorPagingInput>;
  /** Payment method type id. Supported values are `creditCard`, `payPal`. */
  paymentMethodTypeId?: InputMaybe<Scalars['String']>;
  /**
   * Site member that owns saved payment methods.
   * Pass `me` to list saved payment method of the current site member.
   */
  siteMemberId?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsSavedPaymentMethodsV1ListSavedPaymentMethodsResponse = {
  /** Paging metadata. */
  pagingMetadata?: Maybe<WixPaymentsSavedPaymentMethodsUpstreamWixCommonCursorPagingMetadata>;
  /** List of saved payment methods. */
  savedPaymentMethods?: Maybe<Array<Maybe<WixPaymentsSavedPaymentMethodsV1SavedPaymentMethod>>>;
};

export type WixPaymentsSavedPaymentMethodsV1MarkSavedPaymentMethodPrimaryRequestInput = {
  /** Unique identifier of a saved payment method. */
  savedPaymentMethodId?: InputMaybe<Scalars['String']>;
};

export enum WixPaymentsSavedPaymentMethodsV1RequestedFields {
  SENSITIVE_INFO = 'SENSITIVE_INFO',
  /** Default value. This value is unused. */
  UNKNOWN_REQUESTED_FIELD = 'UNKNOWN_REQUESTED_FIELD'
}

export type WixPaymentsSavedPaymentMethodsV1SavedPaymentMethod = {
  /** SavedPaymentMethod creation time. */
  createdDate?: Maybe<Scalars['String']>;
  /** Data Extensions */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** Unique identifier of a saved payment method. */
  id?: Maybe<Scalars['String']>;
  /** Saved payment method owner's member ID. */
  member?: Maybe<ComWixpressMembersApiMember>;
  /**
   * Defines whether this payment method can be used by the merchant for making unscheduled payments.
   * Even if it's set to `false` payment method still can be used for scheduled payments e.g. subscription renewal without the buyer being present.
   */
  merchantUseAllowed?: Maybe<Scalars['Boolean']>;
  /** Payment method details. */
  paymentMethod?: Maybe<WixPaymentsSavedPaymentMethodsV1SavedPaymentMethodPaymentMethod>;
  /** Defines whether this payment method is primary for the member. Member can only have at most one primary saved payment method. */
  primary?: Maybe<Scalars['Boolean']>;
  /** Represents the current state of a saved payment method. Each time saved payment method is modified, its `revision` changes. For an update operation to succeed, you MUST pass the latest revision. */
  revision?: Maybe<Scalars['Long']>;
  /** Saved payment method sensitive information. */
  sensitiveInfo?: Maybe<WixPaymentsSavedPaymentMethodsV1SensitiveInfo>;
  /** Saved payment method owner's member ID. */
  siteMemberId?: Maybe<Scalars['String']>;
  /** SavedPaymentMethod last update time. */
  updatedDate?: Maybe<Scalars['String']>;
};

export type WixPaymentsSavedPaymentMethodsV1SavedPaymentMethodCardInfo = {
  /** Credit card's BIN (Bank Identification Number). It's first 4-6 digits of card's number. */
  bin?: Maybe<Scalars['String']>;
  /** INTERNAL* Card brand. */
  brand?: Maybe<WixPaymentsSavedPaymentMethodsV1CardBrandEnumCardBrand>;
  /** Card holder's full name specified on the card. */
  cardholderName?: Maybe<Scalars['String']>;
  /** Credit card's expiration month. */
  expirationMonth?: Maybe<Scalars['Int']>;
  /** Credit card's expiration year. */
  expirationYear?: Maybe<Scalars['Int']>;
  /** Credit card's last 4 digits. */
  lastFourDigits?: Maybe<Scalars['String']>;
};

export type WixPaymentsSavedPaymentMethodsV1SavedPaymentMethodCardInfoInput = {
  /** Credit card's BIN (Bank Identification Number). It's first 4-6 digits of card's number. */
  bin?: InputMaybe<Scalars['String']>;
  /** INTERNAL* Card brand. */
  brand?: InputMaybe<WixPaymentsSavedPaymentMethodsV1CardBrandEnumCardBrand>;
  /** Card holder's full name specified on the card. */
  cardholderName?: InputMaybe<Scalars['String']>;
  /** Credit card's expiration month. */
  expirationMonth?: InputMaybe<Scalars['Int']>;
  /** Credit card's expiration year. */
  expirationYear?: InputMaybe<Scalars['Int']>;
  /** Credit card's last 4 digits. */
  lastFourDigits?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsSavedPaymentMethodsV1SavedPaymentMethodInput = {
  /** SavedPaymentMethod creation time. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Data Extensions */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** Unique identifier of a saved payment method. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Defines whether this payment method can be used by the merchant for making unscheduled payments.
   * Even if it's set to `false` payment method still can be used for scheduled payments e.g. subscription renewal without the buyer being present.
   */
  merchantUseAllowed?: InputMaybe<Scalars['Boolean']>;
  /** Payment method details. */
  paymentMethod?: InputMaybe<WixPaymentsSavedPaymentMethodsV1SavedPaymentMethodPaymentMethodInput>;
  /** Defines whether this payment method is primary for the member. Member can only have at most one primary saved payment method. */
  primary?: InputMaybe<Scalars['Boolean']>;
  /** Represents the current state of a saved payment method. Each time saved payment method is modified, its `revision` changes. For an update operation to succeed, you MUST pass the latest revision. */
  revision?: InputMaybe<Scalars['Long']>;
  /** Saved payment method sensitive information. */
  sensitiveInfo?: InputMaybe<WixPaymentsSavedPaymentMethodsV1SensitiveInfoInput>;
  /** Saved payment method owner's member ID. */
  siteMemberId?: InputMaybe<Scalars['String']>;
  /** SavedPaymentMethod last update time. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsSavedPaymentMethodsV1SavedPaymentMethodPaymentMethod = {
  /** Details of credit card. */
  cardInfo?: Maybe<WixPaymentsSavedPaymentMethodsV1SavedPaymentMethodCardInfo>;
  /** Payment method brand ID. */
  paymentMethodBrandId?: Maybe<Scalars['String']>;
  /** Payment method type ID. */
  paymentMethodTypeId?: Maybe<Scalars['String']>;
  /** Legacy payment method type ID. Supported values are `creditCard`, `payPal`. */
  typeId?: Maybe<Scalars['String']>;
};

export type WixPaymentsSavedPaymentMethodsV1SavedPaymentMethodPaymentMethodInput = {
  /** Details of credit card. */
  cardInfo?: InputMaybe<WixPaymentsSavedPaymentMethodsV1SavedPaymentMethodCardInfoInput>;
  /** Payment method brand ID. */
  paymentMethodBrandId?: InputMaybe<Scalars['String']>;
  /** Payment method type ID. */
  paymentMethodTypeId?: InputMaybe<Scalars['String']>;
  /** Legacy payment method type ID. Supported values are `creditCard`, `payPal`. */
  typeId?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsSavedPaymentMethodsV1SensitiveInfo = {
  /** Sensitive details of credit card like card token. */
  cardSensitiveInfo?: Maybe<WixPaymentsSavedPaymentMethodsV1SensitiveInfoCardSensitiveInfo>;
};

export type WixPaymentsSavedPaymentMethodsV1SensitiveInfoCardSensitiveInfo = {
  /** Persistent token of credit card tokenized by Wix. */
  persistentToken?: Maybe<Scalars['String']>;
};

export type WixPaymentsSavedPaymentMethodsV1SensitiveInfoCardSensitiveInfoInput = {
  /** Persistent token of credit card tokenized by Wix. */
  persistentToken?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsSavedPaymentMethodsV1SensitiveInfoInput = {
  /** Sensitive details of credit card like card token. */
  cardSensitiveInfo?: InputMaybe<WixPaymentsSavedPaymentMethodsV1SensitiveInfoCardSensitiveInfoInput>;
};

export type WixPaymentsSavedPaymentMethodsV1UpdateSavedPaymentMethodRequestInput = {
  /** Explicit list of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Saved payment method to update. */
  savedPaymentMethod?: InputMaybe<WixPaymentsSavedPaymentMethodsV1SavedPaymentMethodInput>;
};

export type WixPaymentsSavedPaymentMethodsV1UpdateSavedPaymentMethodResponse = {
  /** Updated saved payment method. */
  savedPaymentMethod?: Maybe<WixPaymentsSavedPaymentMethodsV1SavedPaymentMethod>;
};

export type WixPaymentsSavedPaymentMethodsV1UpsertSavedPaymentMethodRequestInput = {
  /** Saved payment method. */
  savedPaymentMethod?: InputMaybe<WixPaymentsSavedPaymentMethodsV1SavedPaymentMethodInput>;
  /** Temporary token of credit card tokenized by Wix. This token is used to create a persistent token */
  temporaryCardToken?: InputMaybe<Scalars['String']>;
};

export type WixPaymentsSavedPaymentMethodsV1UpsertSavedPaymentMethodResponse = {
  /** Saved payment method. */
  savedPaymentMethod?: Maybe<WixPaymentsSavedPaymentMethodsV1SavedPaymentMethod>;
};

export type WixPaymentsSitePaymentMethodTypesV1BuyerFlow = {
  /** Indicates that payment method type is restricted in provided country. */
  countryRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the merchant cannot choose to accept payments from this payment method type. */
  hidden?: Maybe<Scalars['Boolean']>;
  /**
   * Details about the icons to display for this payment method type on a site's checkout page. Icons are localized according to the locale of the call.
   *
   * Define a locale by specifying a `countryCode` and `languageCode` when calling `Get Payment Method Type` or `List Payment Method Types`.
   * For more detailed information, see the method descriptions.
   */
  icons?: Maybe<Array<Maybe<WixPaymentsSitePaymentMethodTypesV1Icon>>>;
  /**
   * Minimum payment amount that can be made with this payment method type.
   * If the request omits `currencyCode`, the field is not set because its value depends on the currency.
   */
  minPaymentAmount?: Maybe<Scalars['String']>;
  /**
   * The priority given to this payment method type in the list of payment method types shown to the buyer.
   * A lower value relative to other payment method types means a higher position on the list.
   */
  priority?: Maybe<Scalars['Int']>;
};

export type WixPaymentsSitePaymentMethodTypesV1Features = {
  /** Authorize and capture configuration. */
  authCapture?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesAuthCapture>;
  /** Credential-on-File (CoF) configuration. */
  credentialOnFile?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesCredentialOnFile>;
  /** Custom tokenization configuration. */
  customTokenization?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesCustomTokenization>;
  /** Disputes configuration. */
  disputes?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesDisputes>;
  /** Express flow configuration. */
  expressFlow?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesExpressFlow>;
  /** Installments configuration. */
  installments?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesInstallments>;
  /** Mail Order/Telephone Order (MOTO) configuration. */
  moto?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesMoto>;
  /** Next action configuration. */
  nextAction?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesNextAction>;
  /** Promotional message configuration. */
  promotionalMessages?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesPromotionalMessages>;
  /** Refunds configuration. */
  refunds?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesRefunds>;
  /** Regular flow configuration. */
  regularFlow?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesRegularFlow>;
  /** Regular tokenization configuration. */
  regularTokenization?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesRegularTokenization>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesAuthCapture = {
  /** Period to wait for the auth capture to be completed before canceling the transaction. */
  maxCapturePeriodInDays?: Maybe<Scalars['Int']>;
  /** Whether the authorize and capture flow is supported for this payment method type. */
  supported?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesCredentialOnFile = {
  /** Whether the Credential-on-File (CoF) feature is supported for this payment method type. */
  supported?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesCustomTokenization = {
  /** Whether a custom tokenization mechanism can be configured for this payment method type, such as a provider-specific tokenization method. */
  supported?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesDisputes = {
  /** Whether disputes are supported for this payment method type. */
  supported?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesExpressFlow = {
  /** Whether this payment method type can be used in an express flow on checkout. */
  supported?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesInstallments = {
  /**
   * Countries for which installments can be enabled.
   * @deprecated Countries for which installments can be enabled. Replaced by: allowed_country_codes. Removal date: 2025-12-31.
   */
  allowedCountries?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Countries for which installments can be enabled. */
  allowedCountryCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Max number of installments that can be configured by a provider. */
  maxInstallmentLimit?: Maybe<Scalars['Int']>;
  /** Whether installments are supported for this payment method type. */
  supported?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesMoto = {
  /** Whether Mail Order/Telephone Order (MOTO) is supported for this payment method type. */
  supported?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesNextAction = {
  /** Barcode configuration. */
  barcode?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesNextActionBarcode>;
  /** Full page redirect configuration. */
  fullPageRedirect?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesNextActionFullPageRedirect>;
  /** iframe configuration. */
  iframe?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesNextActionIFrame>;
  /** New tab configuration. */
  newTab?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesNextActionNewTab>;
  /** QR code configuration. */
  qrCode?: Maybe<WixPaymentsSitePaymentMethodTypesV1FeaturesNextActionQrCode>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesNextActionBarcode = {
  /** Whether the next payment action can be shown as a barcode to scan. */
  supported?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesNextActionFullPageRedirect = {
  /** Whether the next payment action can be shown by redirecting to a new page. */
  supported?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesNextActionIFrame = {
  /** Whether the next payment action can be shown in an iframe. */
  supported?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesNextActionNewTab = {
  /** Whether the next payment action can be shown in a new tab. */
  supported?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesNextActionQrCode = {
  /** Whether the next payment action can be shown as a QR code to scan. */
  supported?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesPromotionalMessages = {
  /** Whether promotional messages is supported for this payment method type. */
  supported?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesRefunds = {
  /** Maximum period in which payments made using this payment method type can be refunded. */
  maxRefundabilityPeriodInDays?: Maybe<Scalars['Int']>;
  /** Whether refunds are supported for this payment method type. */
  supported?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesRegularFlow = {
  /** Whether this payment method type can be used in a regular flow on checkout. */
  supported?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1FeaturesRegularTokenization = {
  /** Whether the default tokenization mechanism can be configured for this payment method type. */
  supported?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1GetSitePaymentMethodTypeRequestInput = {
  /**
   * Country used to determine localized values for fields in the response.
   *
   * Must be a 2-letter country code in [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2#officially_assigned_code_elements) format.
   */
  countryCode?: InputMaybe<Scalars['String']>;
  /**
   * Currency used to determine localized values for fields in the response.
   *
   * Must be a 3-letter currency code in [ISO 4217](https://en.wikipedia.org/wiki/ISO_4217) format.
   */
  currencyCode?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  /**
   * Language used to determine localized values for fields in the response.
   *
   * Must be a 2-letter language code in [ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format.
   */
  languageCode?: InputMaybe<Scalars['String']>;
  /** Requested additional fields */
  requestedFields?: InputMaybe<Array<InputMaybe<WixPaymentsSitePaymentMethodTypesV1RequestedFields>>>;
};

export type WixPaymentsSitePaymentMethodTypesV1Icon = {
  /** Icon image format. */
  format?: Maybe<WixPaymentsSitePaymentMethodTypesV1IconFormat>;
  /** Icon image. */
  image?: Maybe<WixPaymentsSitePaymentMethodTypesV1UpstreamWixCommonImage>;
  /**
   * Icon tag. Payment method types can have multiple icons, and tags are used to differentiate between them.
   * For example, the UI design for multiple payment method types is upgraded, and now they each have an old icon tagged "v1" and a new icon tagged "v2". Developers can then easily choose to display all the original "v1" style of icons, or all the new "v2" style.
   */
  tag?: Maybe<Scalars['String']>;
};

export enum WixPaymentsSitePaymentMethodTypesV1IconFormat {
  PNG = 'PNG',
  SVG = 'SVG',
  UNKNOWN_FORMAT = 'UNKNOWN_FORMAT'
}

export type WixPaymentsSitePaymentMethodTypesV1ListSitePaymentMethodTypesRequestInput = {
  /**
   * Country used to filter payment method types and determine localized values for fields in the response.
   *
   * Must be a 2-letter country code in [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2#officially_assigned_code_elements) format.
   */
  countryCode?: InputMaybe<Scalars['String']>;
  /**
   * Currency used to determine localized values for fields in the response.
   *
   * Must be a 3-letter currency code in [ISO 4217](https://en.wikipedia.org/wiki/ISO_4217) format.
   */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** IDs or legacy IDs of site payment method types to retrieve. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Language used to determine localized values for fields in the response.
   *
   * Must be a 2-letter language code in [ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format.
   */
  languageCode?: InputMaybe<Scalars['String']>;
  /** Requested additional fields */
  requestedFields?: InputMaybe<Array<InputMaybe<WixPaymentsSitePaymentMethodTypesV1RequestedFields>>>;
};

export type WixPaymentsSitePaymentMethodTypesV1ListSitePaymentMethodTypesResponse = {
  /** List of site payment method types. */
  sitePaymentMethodTypes?: Maybe<Array<Maybe<WixPaymentsSitePaymentMethodTypesV1SitePaymentMethodType>>>;
};

export type WixPaymentsSitePaymentMethodTypesV1MerchantFlow = {
  /** Indicates that payment method type is restricted in provided country. */
  countryRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the merchant cannot choose to accept payments from this payment method type. */
  hidden?: Maybe<Scalars['Boolean']>;
  /**
   * Details about the icons to display for this payment method type on the merchant's Accept Payments page in the site dashboard. Icons are localized according to the locale of the call.
   *
   * Define a locale by specifying a `countryCode` and `languageCode` when calling `Get Payment Method Type` or `List Payment Method Types`.
   * For more detailed information, see the method descriptions.
   */
  icons?: Maybe<Array<Maybe<WixPaymentsSitePaymentMethodTypesV1Icon>>>;
  /**
   * Priority given to this payment method type in the list shown to the merchant.
   * A lower value relative to other payment method types means a higher position on the list.
   */
  priority?: Maybe<Scalars['Int']>;
  /** Whether the payment method type is promoted. Promoted payment method types are displayed more prominently on the Accept Payments page. */
  promoted?: Maybe<Scalars['Boolean']>;
};

export enum WixPaymentsSitePaymentMethodTypesV1RequestedFields {
  /** Return `allowedCurrencyCodes`. */
  ALLOWED_CURRENCIES = 'ALLOWED_CURRENCIES',
  UNKNOWN_REQUESTED_FIELD = 'UNKNOWN_REQUESTED_FIELD'
}

export type WixPaymentsSitePaymentMethodTypesV1SitePaymentMethodType = {
  /**
   * _INTERNAL_: Allowed currencies
   * @deprecated _INTERNAL_: Allowed currencies. Replaced by: allowed_currency_codes. Removal date: 2025-12-31.
   */
  allowedCurrencies?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Allowed currencies */
  allowedCurrencyCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Whether this payment method type is only used to represent a supported payment brand for another payment method type.
   *
   * For example, a Visa payment method is used to indicate that Visa can be used for credit card transactions. But the Visa payment method type is not used to accept payments. Instead, the credit card payment method type is used.
   *
   * Brand-only payment method types cannot be used to accept payments, and are not listed as a payment method type in a site's dashboard.
   */
  brandOnly?: Maybe<Scalars['Boolean']>;
  /** Settings that determine if and how to display this payment method type in the buyer flow. The buyer flow is the process a buyer goes through to make a purchase att checkout. */
  buyerFlow?: Maybe<WixPaymentsSitePaymentMethodTypesV1BuyerFlow>;
  /** Indicates that payment method type is restricted for the provided `currencyCode`. */
  currencyRestricted?: Maybe<Scalars['Boolean']>;
  /** Indicates the payment method type has currency restriction and it is enabled. */
  currencyRestrictionEnabled?: Maybe<Scalars['Boolean']>;
  /**
   * Payment method type description, based on locale.
   *
   * Used by Wix when displaying the payment method type, such as in the payment settings page for merchants, or the checkout page for buyers.
   *
   * Define your locale by specifying a `countryCode` and `languageCode` when calling `Get Payment Method Type` or `List Payment Method Types`.
   * For more detailed information, see the descriptions for the `countryCode` and `languageCode` parameters for those methods.
   */
  description?: Maybe<Scalars['String']>;
  /**
   * Payment method type display name, based on locale.
   *
   * Used by Wix when displaying the payment method type, such as in the payment settings page for merchants, or the checkout page for buyers.
   *
   * Define your locale by specifying a `countryCode` and `languageCode` when calling `Get Payment Method Type` or `List Payment Method Types`.
   * For more detailed information, see the descriptions for the `countryCode` and `languageCode` parameters for those methods.
   */
  displayName?: Maybe<Scalars['String']>;
  /** Features supported for this payment method type. */
  features?: Maybe<WixPaymentsSitePaymentMethodTypesV1Features>;
  /** Payment method type ID. */
  id?: Maybe<Scalars['String']>;
  /** Whether the payment method type can only be used for in-person payments, such as cash, point-of-sale payments, and card readers. */
  inPerson?: Maybe<Scalars['Boolean']>;
  /** Value used buy some legacy APIs to refer to this payment method type. Can be empty. */
  legacyId?: Maybe<Scalars['String']>;
  /** Settings that determine if and how to display this payment method type in the merchant flow. The merchant flow is the process a merchant goes through to configure which payment method types they accept on their site. */
  merchantFlow?: Maybe<WixPaymentsSitePaymentMethodTypesV1MerchantFlow>;
  /**
   * Time (in seconds after which a transaction is marked as expired if it is not completed.
   *
   * Max: `15552000` (180 days)
   */
  transactionExpirationDelayInSeconds?: Maybe<Scalars['Int']>;
  /** Indicates that this payment method type comes from [Velo integration](https://dev.wix.com/docs/develop-websites/articles/code-tutorials/wix-pay/tutorial-payment-provider-service-plugin). */
  velo?: Maybe<Scalars['Boolean']>;
};

export type WixPaymentsSitePaymentMethodTypesV1UpstreamWixCommonImage = {
  /** Original image height. */
  height?: Maybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: Maybe<Scalars['String']>;
  /** Image URL. */
  url?: Maybe<Scalars['String']>;
  /** Original image width. */
  width?: Maybe<Scalars['Int']>;
};

export type WixPopulationV2CreatedElementsEventInput = {
  /** list of elements created */
  created?: InputMaybe<Array<InputMaybe<WixPopulationV2ElementInput>>>;
  /** The population ID */
  populationId?: InputMaybe<Scalars['String']>;
};

export type WixPopulationV2ElementInput = {
  /** Represents the time this Element was created */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Element ID */
  id?: InputMaybe<Scalars['String']>;
  /** Note you can add */
  note?: InputMaybe<Scalars['String']>;
  /** Population ID */
  populationId?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1AdditionalFee = {
  /** Additional fee name. */
  name?: Maybe<Scalars['String']>;
  /**
   * Additional fee amount after taxes.
   * If no taxes apply to this fee, this will be the same as `priceBeforeTax`.
   */
  priceAfterTax?: Maybe<Scalars['String']>;
  /** Additional fee price before taxes. */
  priceBeforeTax?: Maybe<Scalars['String']>;
  /** Additional fee tax breakdown. */
  taxBreakdown?: Maybe<Array<Maybe<WixReceiptsV1AdditionalFeeTax>>>;
};

export type WixReceiptsV1AdditionalFeeInput = {
  /** Additional fee name. */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Additional fee amount after taxes.
   * If no taxes apply to this fee, this will be the same as `priceBeforeTax`.
   */
  priceAfterTax?: InputMaybe<Scalars['String']>;
  /** Additional fee price before taxes. */
  priceBeforeTax?: InputMaybe<Scalars['String']>;
  /** Additional fee tax breakdown. */
  taxBreakdown?: InputMaybe<Array<InputMaybe<WixReceiptsV1AdditionalFeeTaxInput>>>;
};

export type WixReceiptsV1AdditionalFeeTax = {
  /** Tax amount. */
  amount?: Maybe<Scalars['String']>;
  /** Tax name. */
  name?: Maybe<Scalars['String']>;
  /**
   * Tax rate.
   * Example: 0.1000 signifies 10% tax and 2.1000 signifies 210% tax.
   */
  rate?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1AdditionalFeeTaxInput = {
  /** Tax amount. */
  amount?: InputMaybe<Scalars['String']>;
  /** Tax name. */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Tax rate.
   * Example: 0.1000 signifies 10% tax and 2.1000 signifies 210% tax.
   */
  rate?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1BackofficeUpdateReceiptRequestInput = {
  /** Fields that aren't included in `fieldMask.paths` are ignored. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Receipt. */
  receipt?: InputMaybe<WixReceiptsV1ReceiptInput>;
};

export type WixReceiptsV1BackofficeUpdateReceiptResponse = {
  /** Receipt. */
  receipt?: Maybe<WixReceiptsV1Receipt>;
};

export type WixReceiptsV1BusinessDetails = {
  /** Business address. */
  address?: Maybe<WixReceiptsV1UpstreamWixCommonAddress>;
  /** Business email. */
  email?: Maybe<Scalars['String']>;
  /** Business logo. */
  logo?: Maybe<WixReceiptsV1UpstreamWixCommonImage>;
  /** Business name. */
  name?: Maybe<Scalars['String']>;
  /** Business phone. */
  phone?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1BusinessDetailsInput = {
  /** Business address. */
  address?: InputMaybe<WixReceiptsV1UpstreamWixCommonAddressInput>;
  /** Business email. */
  email?: InputMaybe<Scalars['String']>;
  /** Business logo. */
  logo?: InputMaybe<WixReceiptsV1UpstreamWixCommonImageInput>;
  /** Business name. */
  name?: InputMaybe<Scalars['String']>;
  /** Business phone. */
  phone?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1CreateReceiptRequestInput = {
  /** Receipt to create. */
  receipt?: InputMaybe<WixReceiptsV1ReceiptInput>;
};

export type WixReceiptsV1CreateReceiptResponse = {
  /** Created receipt. */
  receipt?: Maybe<WixReceiptsV1Receipt>;
};

export type WixReceiptsV1CustomField = {
  /** Title. */
  title?: Maybe<Scalars['String']>;
  /** Value. */
  value?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1CustomFieldInput = {
  /** Title. */
  title?: InputMaybe<Scalars['String']>;
  /** Value. */
  value?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1CustomFields = {
  /** Business custom fields. */
  businessCustomFields?: Maybe<Array<Maybe<WixReceiptsV1CustomField>>>;
  /** Customer custom fields. */
  customerCustomFields?: Maybe<Array<Maybe<WixReceiptsV1CustomField>>>;
  /** Footer custom fields. */
  footerCustomFields?: Maybe<Array<Maybe<WixReceiptsV1FooterCustomField>>>;
  /** Header custom fields. */
  headerCustomFields?: Maybe<Array<Maybe<WixReceiptsV1CustomField>>>;
};

export type WixReceiptsV1CustomFieldsInput = {
  /** Business custom fields. */
  businessCustomFields?: InputMaybe<Array<InputMaybe<WixReceiptsV1CustomFieldInput>>>;
  /** Customer custom fields. */
  customerCustomFields?: InputMaybe<Array<InputMaybe<WixReceiptsV1CustomFieldInput>>>;
  /** Footer custom fields. */
  footerCustomFields?: InputMaybe<Array<InputMaybe<WixReceiptsV1FooterCustomFieldInput>>>;
  /** Header custom fields. */
  headerCustomFields?: InputMaybe<Array<InputMaybe<WixReceiptsV1CustomFieldInput>>>;
};

export type WixReceiptsV1Customer = {
  /** Customer's billing address. */
  billingAddress?: Maybe<WixReceiptsV1UpstreamWixCommonAddress>;
  /** Customer's contact ID. */
  contact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
  /** Customer's contact details. */
  contactDetails?: Maybe<WixReceiptsV1UpstreamWixCommonFullAddressContactDetails>;
  /** Customer's contact ID. */
  contactId?: Maybe<Scalars['String']>;
  /** Customer's shipping address. */
  shippingAddress?: Maybe<WixReceiptsV1UpstreamWixCommonAddress>;
  /** Shipping address contact details. Allows to have a separate contact details (name, email, etc.) for the shipping address. */
  shippingAddressContactDetails?: Maybe<WixReceiptsV1UpstreamWixCommonShippingAddressContactDetails>;
};

export type WixReceiptsV1CustomerInput = {
  /** Customer's billing address. */
  billingAddress?: InputMaybe<WixReceiptsV1UpstreamWixCommonAddressInput>;
  /** Customer's contact details. */
  contactDetails?: InputMaybe<WixReceiptsV1UpstreamWixCommonFullAddressContactDetailsInput>;
  /** Customer's contact ID. */
  contactId?: InputMaybe<Scalars['String']>;
  /** Customer's shipping address. */
  shippingAddress?: InputMaybe<WixReceiptsV1UpstreamWixCommonAddressInput>;
  /** Shipping address contact details. Allows to have a separate contact details (name, email, etc.) for the shipping address. */
  shippingAddressContactDetails?: InputMaybe<WixReceiptsV1UpstreamWixCommonShippingAddressContactDetailsInput>;
};

export type WixReceiptsV1Discount = {
  /** Discount amount. */
  amount?: Maybe<Scalars['String']>;
  /** Discount name. */
  displayName?: Maybe<Scalars['String']>;
  /**
   * Deprecated: Use `display_name` instead.
   * @deprecated Deprecated: Use `display_name` instead. Replaced by: display_name. Removal date: 2025-06-01.
   */
  name?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1DiscountInput = {
  /** Discount amount. */
  amount?: InputMaybe<Scalars['String']>;
  /** Discount name. */
  displayName?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1Document = {
  /** Document download URL. */
  downloadUrl?: Maybe<Scalars['String']>;
  /** Document status. */
  status?: Maybe<WixReceiptsV1DocumentDocumentStatus>;
};

export enum WixReceiptsV1DocumentDocumentStatus {
  /** Generation was successful. You can downloaded the document using the `downloadUrl`. */
  AVAILABLE = 'AVAILABLE',
  /** Generation has failed. You can retrigger document generation by calling Regenerate Receipt Document. */
  FAILED = 'FAILED',
  /** Generation is in progress. Call Get Receipt after 6-10 seconds to check the updated status. */
  PROCESSING = 'PROCESSING',
  /** Generation status is unknown. */
  UNKNOWN_DOCUMENT_STATUS = 'UNKNOWN_DOCUMENT_STATUS'
}

export type WixReceiptsV1DocumentInput = {
  /** Document download URL. */
  downloadUrl?: InputMaybe<Scalars['String']>;
  /** Document status. */
  status?: InputMaybe<WixReceiptsV1DocumentDocumentStatus>;
};

export type WixReceiptsV1EventsGenerateReceiptDocumentInput = {
  /** Receipt Id. */
  receiptId?: InputMaybe<Scalars['String']>;
  /** Shows how request for document generation was made. */
  requestOrigin?: InputMaybe<WixReceiptsV1EventsGenerateReceiptDocumentRequestOrigin>;
};

export enum WixReceiptsV1EventsGenerateReceiptDocumentRequestOrigin {
  INITIAL = 'INITIAL',
  MANUAL = 'MANUAL'
}

export type WixReceiptsV1EventsReceiptDocumentHandledFailedInput = {
  /** Receipt Id. */
  receiptId?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1EventsReceiptDocumentHandledInput = {
  /** Populated only if receipt document handling has failed. */
  failed?: InputMaybe<WixReceiptsV1EventsReceiptDocumentHandledFailedInput>;
  /** Populated only if receipt document handling has succeeded. */
  succeeded?: InputMaybe<WixReceiptsV1EventsReceiptDocumentHandledSucceededInput>;
};

export type WixReceiptsV1EventsReceiptDocumentHandledSucceededInput = {
  /** Download URL. */
  downloadUrl?: InputMaybe<Scalars['String']>;
  /** Media file Id. */
  mediaFileId?: InputMaybe<Scalars['String']>;
  /** Receipt Id. */
  receiptId?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1EventsReceiptNumberingProcessInput = {
  /** Receipt Id. */
  receiptId?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1FooterCustomField = {
  /** Title. */
  title?: Maybe<Scalars['String']>;
  /** Value. */
  value?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1FooterCustomFieldInput = {
  /** Title. */
  title?: InputMaybe<Scalars['String']>;
  /** Value. */
  value?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1GetLatestReceiptNumberRequestInput = {
  /** Receipt prefix to filter by. */
  prefix?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1GetLatestReceiptNumberResponse = {
  /** Receipt number. */
  number?: Maybe<Scalars['Int']>;
};

export type WixReceiptsV1GetReceiptRequestInput = {
  id: Scalars['ID'];
};

export type WixReceiptsV1LineItem = {
  /** Line item description. */
  description?: Maybe<Scalars['String']>;
  /** Line item ID. */
  id?: Maybe<Scalars['String']>;
  /** Line item name. */
  name?: Maybe<Scalars['String']>;
  /** Line item unit price per unit after discounts. */
  price?: Maybe<Scalars['String']>;
  /** Line item price per unit before discounts. */
  priceBeforeDiscounts?: Maybe<Scalars['String']>;
  /** Line item quantity. */
  quantity?: Maybe<Scalars['String']>;
  /** Line item tax breakdown. */
  taxBreakdown?: Maybe<Array<Maybe<WixReceiptsV1LineItemTax>>>;
  /** Line item totals. */
  totals?: Maybe<WixReceiptsV1LineItemTotals>;
};

export type WixReceiptsV1LineItemInput = {
  /** Line item description. */
  description?: InputMaybe<Scalars['String']>;
  /** Line item ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Line item name. */
  name?: InputMaybe<Scalars['String']>;
  /** Line item unit price per unit after discounts. */
  price?: InputMaybe<Scalars['String']>;
  /** Line item price per unit before discounts. */
  priceBeforeDiscounts?: InputMaybe<Scalars['String']>;
  /** Line item quantity. */
  quantity?: InputMaybe<Scalars['String']>;
  /** Line item tax breakdown. */
  taxBreakdown?: InputMaybe<Array<InputMaybe<WixReceiptsV1LineItemTaxInput>>>;
  /** Line item totals. */
  totals?: InputMaybe<WixReceiptsV1LineItemTotalsInput>;
};

export type WixReceiptsV1LineItemTax = {
  /** Amount of tax calculated for this line item. */
  taxAmount?: Maybe<Scalars['String']>;
  /** Tax name. */
  taxName?: Maybe<Scalars['String']>;
  /**
   * Tax rate percentage.
   * For example: 0.1000 means 10% tax, and 2.1000 means 210% tax.
   */
  taxRate?: Maybe<Scalars['String']>;
  /** Amount of the line item price that is taxable. */
  taxableAmount?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1LineItemTaxInput = {
  /** Amount of tax calculated for this line item. */
  taxAmount?: InputMaybe<Scalars['String']>;
  /** Tax name. */
  taxName?: InputMaybe<Scalars['String']>;
  /**
   * Tax rate percentage.
   * For example: 0.1000 means 10% tax, and 2.1000 means 210% tax.
   */
  taxRate?: InputMaybe<Scalars['String']>;
  /** Amount of the line item price that is taxable. */
  taxableAmount?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1LineItemTotals = {
  /** Line item total discount. */
  totalDiscount?: Maybe<Scalars['String']>;
  /** Line item total price after taxes and discounts. */
  totalPriceAfterTax?: Maybe<Scalars['String']>;
  /** Line item total price after discounts and before taxes. */
  totalPriceBeforeTax?: Maybe<Scalars['String']>;
  /** Line item total applied tax. */
  totalTax?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1LineItemTotalsInput = {
  /** Line item total discount. */
  totalDiscount?: InputMaybe<Scalars['String']>;
  /** Line item total price after taxes and discounts. */
  totalPriceAfterTax?: InputMaybe<Scalars['String']>;
  /** Line item total price after discounts and before taxes. */
  totalPriceBeforeTax?: InputMaybe<Scalars['String']>;
  /** Line item total applied tax. */
  totalTax?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1Locale = {
  /**
   * Two-letter country code in [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2#officially_assigned_code_elements) format.
   * For example: `US`, `DE`, `JP`.
   */
  country?: Maybe<Scalars['String']>;
  /**
   * Two-letter language code in [ISO-639-1 alpha-2](https://en.wikipedia.org/wiki/ISO_639-1) format.
   * For example: `en`, `de`, `ja`.
   */
  languageCode?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1LocaleInput = {
  /**
   * Two-letter country code in [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2#officially_assigned_code_elements) format.
   * For example: `US`, `DE`, `JP`.
   */
  country?: InputMaybe<Scalars['String']>;
  /**
   * Two-letter language code in [ISO-639-1 alpha-2](https://en.wikipedia.org/wiki/ISO_639-1) format.
   * For example: `en`, `de`, `ja`.
   */
  languageCode?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1Payment = {
  /** Payment amount. */
  amount?: Maybe<Scalars['String']>;
  /** Payment method. */
  paymentMethod?: Maybe<Scalars['String']>;
  /** Payment details. */
  paymentMethodDetails?: Maybe<Scalars['String']>;
  /** Payment transaction date. */
  transactionDate?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1PaymentInput = {
  /** Payment amount. */
  amount?: InputMaybe<Scalars['String']>;
  /** Payment method. */
  paymentMethod?: InputMaybe<Scalars['String']>;
  /** Payment details. */
  paymentMethodDetails?: InputMaybe<Scalars['String']>;
  /** Payment transaction date. */
  transactionDate?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1QueryReceiptsRequestInput = {
  /** Query options. */
  query?: InputMaybe<WixReceiptsV1UpstreamWixCommonCursorQueryInput>;
};

export type WixReceiptsV1QueryReceiptsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<WixReceiptsV1Receipt>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixReceiptsV1Receipt = {
  /** Additional fees. */
  additionalFees?: Maybe<Array<Maybe<WixReceiptsV1AdditionalFee>>>;
  /**
   * Business details.
   * When business properties are not provided, defaults are taken from the site's properties, available in the Site Properties API.
   */
  businessDetails?: Maybe<WixReceiptsV1BusinessDetails>;
  /** Date and time the receipt was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Currency code in [ISO-4217 alphabetic](https://www.iso.org/iso-4217-currency-codes.html) format. */
  currency?: Maybe<Scalars['String']>;
  /**
   * Custom fields for this receipt.
   * Values appear on the receipt in the specified order.
   */
  customFields?: Maybe<WixReceiptsV1CustomFields>;
  /** Customer details. */
  customer?: Maybe<WixReceiptsV1Customer>;
  /** Discounts. */
  discounts?: Maybe<Array<Maybe<WixReceiptsV1Discount>>>;
  /** Document details. */
  document?: Maybe<WixReceiptsV1Document>;
  /**
   * Custom field data for the receipt.
   * Extended fields must be configured in the app dashboard before they can be accessed with API calls.
   */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** Receipt ID. */
  id?: Maybe<Scalars['String']>;
  /** Line item details. */
  lineItems?: Maybe<Array<Maybe<WixReceiptsV1LineItem>>>;
  /** Receipt numbering. */
  numbering?: Maybe<WixReceiptsV1ReceiptNumbering>;
  /** Payment details. */
  payment?: Maybe<WixReceiptsV1Payment>;
  /**
   * Receipt preset ID.
   * Defaults to the default receipt preset ID, available with Get Default Receipt Preset ID.
   */
  presetId?: Maybe<Scalars['String']>;
  /**
   * Regional properties pertaining to the receipt.
   * When regional properties are not provided, defaults are taken from the site's properties, available in the Site Properties API.
   */
  regionalProperties?: Maybe<WixReceiptsV1RegionalProperties>;
  /**
   * Revision number, which increments by 1 each time the receipt is updated.
   * To prevent conflicting changes,
   * the current revision must be passed when updating the receipt.
   */
  revision?: Maybe<Scalars['Long']>;
  /** Shipping info. */
  shippingInfo?: Maybe<WixReceiptsV1ShippingInfo>;
  /** Details about the associated Wix eCommerce or Wix Payments order. */
  sourceReference?: Maybe<WixReceiptsV1SourceReference>;
  /** Tax and taxable amounts breakdowns. */
  taxBreakdown?: Maybe<Array<Maybe<WixReceiptsV1Tax>>>;
  /** Summaries of totals including tax, shipping, additional fees and discounts. */
  totals?: Maybe<WixReceiptsV1Totals>;
  /**
   * Date and time the receipt was last updated.
   * Relevant updates include receipt regeneratation and number allocation changes. Updates to financial information are not stored.
   */
  updatedDate?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1ReceiptInput = {
  /** Additional fees. */
  additionalFees?: InputMaybe<Array<InputMaybe<WixReceiptsV1AdditionalFeeInput>>>;
  /**
   * Business details.
   * When business properties are not provided, defaults are taken from the site's properties, available in the Site Properties API.
   */
  businessDetails?: InputMaybe<WixReceiptsV1BusinessDetailsInput>;
  /** Date and time the receipt was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Currency code in [ISO-4217 alphabetic](https://www.iso.org/iso-4217-currency-codes.html) format. */
  currency?: InputMaybe<Scalars['String']>;
  /**
   * Custom fields for this receipt.
   * Values appear on the receipt in the specified order.
   */
  customFields?: InputMaybe<WixReceiptsV1CustomFieldsInput>;
  /** Customer details. */
  customer?: InputMaybe<WixReceiptsV1CustomerInput>;
  /** Discounts. */
  discounts?: InputMaybe<Array<InputMaybe<WixReceiptsV1DiscountInput>>>;
  /** Document details. */
  document?: InputMaybe<WixReceiptsV1DocumentInput>;
  /**
   * Custom field data for the receipt.
   * Extended fields must be configured in the app dashboard before they can be accessed with API calls.
   */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** Receipt ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Line item details. */
  lineItems?: InputMaybe<Array<InputMaybe<WixReceiptsV1LineItemInput>>>;
  /** Receipt numbering. */
  numbering?: InputMaybe<WixReceiptsV1ReceiptNumberingInput>;
  /** Payment details. */
  payment?: InputMaybe<WixReceiptsV1PaymentInput>;
  /**
   * Receipt preset ID.
   * Defaults to the default receipt preset ID, available with Get Default Receipt Preset ID.
   */
  presetId?: InputMaybe<Scalars['String']>;
  /**
   * Regional properties pertaining to the receipt.
   * When regional properties are not provided, defaults are taken from the site's properties, available in the Site Properties API.
   */
  regionalProperties?: InputMaybe<WixReceiptsV1RegionalPropertiesInput>;
  /**
   * Revision number, which increments by 1 each time the receipt is updated.
   * To prevent conflicting changes,
   * the current revision must be passed when updating the receipt.
   */
  revision?: InputMaybe<Scalars['Long']>;
  /** Shipping info. */
  shippingInfo?: InputMaybe<WixReceiptsV1ShippingInfoInput>;
  /** Details about the associated Wix eCommerce or Wix Payments order. */
  sourceReference?: InputMaybe<WixReceiptsV1SourceReferenceInput>;
  /** Tax and taxable amounts breakdowns. */
  taxBreakdown?: InputMaybe<Array<InputMaybe<WixReceiptsV1TaxInput>>>;
  /** Summaries of totals including tax, shipping, additional fees and discounts. */
  totals?: InputMaybe<WixReceiptsV1TotalsInput>;
  /**
   * Date and time the receipt was last updated.
   * Relevant updates include receipt regeneratation and number allocation changes. Updates to financial information are not stored.
   */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1ReceiptNumbering = {
  /** Full receipt display number, in [prefix][number][suffix] format. */
  displayNumber?: Maybe<Scalars['String']>;
  /** Receipt number. */
  number?: Maybe<Scalars['Int']>;
  /** Receipt prefix that will be displayed before the receipt number. */
  prefix?: Maybe<Scalars['String']>;
  /** Receipt suffix that will be displayed after the receipt number. */
  suffix?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1ReceiptNumberingInput = {
  /** Full receipt display number, in [prefix][number][suffix] format. */
  displayNumber?: InputMaybe<Scalars['String']>;
  /** Receipt number. */
  number?: InputMaybe<Scalars['Int']>;
  /** Receipt prefix that will be displayed before the receipt number. */
  prefix?: InputMaybe<Scalars['String']>;
  /** Receipt suffix that will be displayed after the receipt number. */
  suffix?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1RegenerateReceiptDocumentRequestInput = {
  /** Receipt ID. */
  receiptId?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1RegionalProperties = {
  /**
   * Receipt language. Determines the language of receipt static content (i.e. field and column titles). If not provided, defaults to locale's language.
   * Two-letter language code in [ISO-639-1 alpha-2](https://en.wikipedia.org/wiki/ISO_639-1) format.
   */
  language?: Maybe<Scalars['String']>;
  /** Locale. Determines formating of numbers, dates and times. */
  locale?: Maybe<WixReceiptsV1Locale>;
  /** Time zone. Determines offset of dates and times. */
  timeZone?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1RegionalPropertiesInput = {
  /**
   * Receipt language. Determines the language of receipt static content (i.e. field and column titles). If not provided, defaults to locale's language.
   * Two-letter language code in [ISO-639-1 alpha-2](https://en.wikipedia.org/wiki/ISO_639-1) format.
   */
  language?: InputMaybe<Scalars['String']>;
  /** Locale. Determines formating of numbers, dates and times. */
  locale?: InputMaybe<WixReceiptsV1LocaleInput>;
  /** Time zone. Determines offset of dates and times. */
  timeZone?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1SendReceiptEmailRequestInput = {
  /** Recipient contact ID. */
  contactId?: InputMaybe<Scalars['String']>;
  /** Receipt ID to send. */
  receiptId?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1ShippingInfo = {
  /** Shipping price after all discounts (if any exist), and after tax. */
  priceAfterTax?: Maybe<Scalars['String']>;
  /** Shipping amount after discounts (when relevant), and before tax. */
  priceBeforeTax?: Maybe<Scalars['String']>;
  /** Shipping tax breakdown. */
  taxBreakdown?: Maybe<Array<Maybe<WixReceiptsV1ShippingTax>>>;
  /** Shipping title. */
  title?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1ShippingInfoInput = {
  /** Shipping price after all discounts (if any exist), and after tax. */
  priceAfterTax?: InputMaybe<Scalars['String']>;
  /** Shipping amount after discounts (when relevant), and before tax. */
  priceBeforeTax?: InputMaybe<Scalars['String']>;
  /** Shipping tax breakdown. */
  taxBreakdown?: InputMaybe<Array<InputMaybe<WixReceiptsV1ShippingTaxInput>>>;
  /** Shipping title. */
  title?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1ShippingTax = {
  /** Tax amount. */
  amount?: Maybe<Scalars['String']>;
  /** Tax name. */
  name?: Maybe<Scalars['String']>;
  /**
   * Tax rate percentage.
   * Example: 0.1000 signifies 10% tax and 2.1000 signifies 210% tax.
   */
  rate?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1ShippingTaxInput = {
  /** Tax amount. */
  amount?: InputMaybe<Scalars['String']>;
  /** Tax name. */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Tax rate percentage.
   * Example: 0.1000 signifies 10% tax and 2.1000 signifies 210% tax.
   */
  rate?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1SourceReference = {
  /** ID of the app that generated the receipt. */
  appId?: Maybe<Scalars['String']>;
  /**
   * External reference ID.
   * For example: Wix eCommerce `orderId`, Wix Events `eventId`.
   */
  externalReferenceId?: Maybe<Scalars['String']>;
  /** Order type. */
  receiptOrderType?: Maybe<WixReceiptsV1SourceReferenceReceiptOrderType>;
  /** Wix eCommerce order. */
  wixEcomOrder?: Maybe<WixReceiptsV1SourceReferenceWixEcom>;
  /** Wix Payments order. */
  wixPaymentOrder?: Maybe<WixReceiptsV1SourceReferenceWixPayment>;
};

export type WixReceiptsV1SourceReferenceInput = {
  /** ID of the app that generated the receipt. */
  appId?: InputMaybe<Scalars['String']>;
  /**
   * External reference ID.
   * For example: Wix eCommerce `orderId`, Wix Events `eventId`.
   */
  externalReferenceId?: InputMaybe<Scalars['String']>;
  /** Order type. */
  receiptOrderType?: InputMaybe<WixReceiptsV1SourceReferenceReceiptOrderType>;
  /** Wix eCommerce order. */
  wixEcomOrder?: InputMaybe<WixReceiptsV1SourceReferenceWixEcomInput>;
  /** Wix Payments order. */
  wixPaymentOrder?: InputMaybe<WixReceiptsV1SourceReferenceWixPaymentInput>;
};

export enum WixReceiptsV1SourceReferenceReceiptOrderType {
  UNKNOWN_ORDER_TYPE = 'UNKNOWN_ORDER_TYPE',
  WIX_ECOM = 'WIX_ECOM',
  WIX_PAYMENT = 'WIX_PAYMENT'
}

export type WixReceiptsV1SourceReferenceWixEcom = {
  /** Wix eCommerce order ID. */
  orderId?: Maybe<Scalars['String']>;
  /** Wix eCommerce transaction ID. */
  transactionId?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1SourceReferenceWixEcomInput = {
  /** Wix eCommerce order ID. */
  orderId?: InputMaybe<Scalars['String']>;
  /** Wix eCommerce transaction ID. */
  transactionId?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1SourceReferenceWixPayment = {
  /** Wix Payments order ID. */
  orderId?: Maybe<Scalars['String']>;
  /** Wix Payments transaction ID. */
  transactionId?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1SourceReferenceWixPaymentInput = {
  /** Wix Payments order ID. */
  orderId?: InputMaybe<Scalars['String']>;
  /** Wix Payments transaction ID. */
  transactionId?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1Tax = {
  /** Tax name. */
  name?: Maybe<Scalars['String']>;
  /** Tax rate percentage, as a positive decimal numeral. For example, "0.13". */
  rate?: Maybe<Scalars['String']>;
  /** Tax amount. */
  taxAmount?: Maybe<Scalars['String']>;
  /** Taxable amount this tax applies to. */
  taxableAmount?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1TaxInput = {
  /** Tax name. */
  name?: InputMaybe<Scalars['String']>;
  /** Tax rate percentage, as a positive decimal numeral. For example, "0.13". */
  rate?: InputMaybe<Scalars['String']>;
  /** Tax amount. */
  taxAmount?: InputMaybe<Scalars['String']>;
  /** Taxable amount this tax applies to. */
  taxableAmount?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1Totals = {
  /** Additional fee amount, before discounts and tax. */
  additionalFees?: Maybe<Scalars['String']>;
  /** Discount amount. */
  discount?: Maybe<Scalars['String']>;
  /** Shipping price, before discounts and tax. */
  shipping?: Maybe<Scalars['String']>;
  /** Subtotal of all line items, before discounts and before taxes. */
  subtotal?: Maybe<Scalars['String']>;
  /** Tax amount. */
  tax?: Maybe<Scalars['String']>;
  /** Total amount after all calculations. Equates to: subtotal - discounts + taxes + shipping + additional_fees. */
  total?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1TotalsInput = {
  /** Additional fee amount, before discounts and tax. */
  additionalFees?: InputMaybe<Scalars['String']>;
  /** Discount amount. */
  discount?: InputMaybe<Scalars['String']>;
  /** Shipping price, before discounts and tax. */
  shipping?: InputMaybe<Scalars['String']>;
  /** Subtotal of all line items, before discounts and before taxes. */
  subtotal?: InputMaybe<Scalars['String']>;
  /** Tax amount. */
  tax?: InputMaybe<Scalars['String']>;
  /** Total amount after all calculations. Equates to: subtotal - discounts + taxes + shipping + additional_fees. */
  total?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1UpdateExtendedFieldsResponse = {
  /** Updated receipt. */
  receipt?: Maybe<WixReceiptsV1Receipt>;
};

export type WixReceiptsV1UpstreamWixCommonAddress = {
  /** Main address line, usually street and number as free text. */
  addressLine?: Maybe<Scalars['String']>;
  /** Free text providing more detailed address info. Usually contains Apt, Suite, and Floor. */
  addressLine2?: Maybe<Scalars['String']>;
  /** City name. */
  city?: Maybe<Scalars['String']>;
  /** Country code. */
  country?: Maybe<Scalars['String']>;
  /** Country full name. */
  countryFullname?: Maybe<Scalars['String']>;
  /** A string containing the full address of this location. */
  formattedAddress?: Maybe<Scalars['String']>;
  /** Coordinates of the physical address. */
  geocode?: Maybe<WixReceiptsV1UpstreamWixCommonAddressLocation>;
  /** Free text to help find the address. */
  hint?: Maybe<Scalars['String']>;
  /** Zip/postal code. */
  postalCode?: Maybe<Scalars['String']>;
  /** Street name and number. */
  streetAddress?: Maybe<WixReceiptsV1UpstreamWixCommonStreetAddress>;
  /** Subdivision shorthand. Usually, a short code (2 or 3 letters) that represents a state, region, prefecture, or province. e.g. NY */
  subdivision?: Maybe<Scalars['String']>;
  /** Subdivision full name. */
  subdivisionFullname?: Maybe<Scalars['String']>;
  /** Subdivision. Usually a state, region, prefecture, or province code, according to [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2), e.g. US-NY */
  subdivisionIso31662?: Maybe<Scalars['String']>;
  /** Multi-level subdivisions from top to bottom. */
  subdivisions?: Maybe<Array<Maybe<WixReceiptsV1UpstreamWixCommonSubdivision>>>;
};

export type WixReceiptsV1UpstreamWixCommonAddressInput = {
  /** Main address line, usually street and number as free text. */
  addressLine?: InputMaybe<Scalars['String']>;
  /** Free text providing more detailed address info. Usually contains Apt, Suite, and Floor. */
  addressLine2?: InputMaybe<Scalars['String']>;
  /** City name. */
  city?: InputMaybe<Scalars['String']>;
  /** Country code. */
  country?: InputMaybe<Scalars['String']>;
  /** Country full name. */
  countryFullname?: InputMaybe<Scalars['String']>;
  /** A string containing the full address of this location. */
  formattedAddress?: InputMaybe<Scalars['String']>;
  /** Coordinates of the physical address. */
  geocode?: InputMaybe<WixReceiptsV1UpstreamWixCommonAddressLocationInput>;
  /** Free text to help find the address. */
  hint?: InputMaybe<Scalars['String']>;
  /** Zip/postal code. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** Street name and number. */
  streetAddress?: InputMaybe<WixReceiptsV1UpstreamWixCommonStreetAddressInput>;
  /** Subdivision shorthand. Usually, a short code (2 or 3 letters) that represents a state, region, prefecture, or province. e.g. NY */
  subdivision?: InputMaybe<Scalars['String']>;
  /** Subdivision full name. */
  subdivisionFullname?: InputMaybe<Scalars['String']>;
  /** Subdivision. Usually a state, region, prefecture, or province code, according to [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2), e.g. US-NY */
  subdivisionIso31662?: InputMaybe<Scalars['String']>;
  /** Multi-level subdivisions from top to bottom. */
  subdivisions?: InputMaybe<Array<InputMaybe<WixReceiptsV1UpstreamWixCommonSubdivisionInput>>>;
};

export type WixReceiptsV1UpstreamWixCommonAddressLocation = {
  /** Address latitude. */
  latitude?: Maybe<Scalars['Float']>;
  /** Address longitude. */
  longitude?: Maybe<Scalars['Float']>;
};

export type WixReceiptsV1UpstreamWixCommonAddressLocationInput = {
  /** Address latitude. */
  latitude?: InputMaybe<Scalars['Float']>;
  /** Address longitude. */
  longitude?: InputMaybe<Scalars['Float']>;
};

export type WixReceiptsV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * Pass the relevant cursor token from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Maximum number of items to return in the results. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixReceiptsV1UpstreamWixCommonCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixReceiptsV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixReceiptsV1UpstreamWixCommonSortingInput>>>;
};

export type WixReceiptsV1UpstreamWixCommonFullAddressContactDetails = {
  /** Contact's company name. */
  company?: Maybe<Scalars['String']>;
  /** Email associated with the address. */
  email?: Maybe<Scalars['String']>;
  /** Contact's first name. */
  firstName?: Maybe<Scalars['String']>;
  /** Contact's full name. */
  fullName?: Maybe<Scalars['String']>;
  /** Contact's last name. */
  lastName?: Maybe<Scalars['String']>;
  /** Contact's phone number. */
  phone?: Maybe<Scalars['String']>;
  /** Tax info. Currently usable only in Brazil. */
  vatId?: Maybe<WixReceiptsV1UpstreamWixCommonVatId>;
};

export type WixReceiptsV1UpstreamWixCommonFullAddressContactDetailsInput = {
  /** Contact's company name. */
  company?: InputMaybe<Scalars['String']>;
  /** Email associated with the address. */
  email?: InputMaybe<Scalars['String']>;
  /** Contact's first name. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Contact's full name. */
  fullName?: InputMaybe<Scalars['String']>;
  /** Contact's last name. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Contact's phone number. */
  phone?: InputMaybe<Scalars['String']>;
  /** Tax info. Currently usable only in Brazil. */
  vatId?: InputMaybe<WixReceiptsV1UpstreamWixCommonVatIdInput>;
};

export type WixReceiptsV1UpstreamWixCommonImage = {
  /** Image alt text. */
  altText?: Maybe<Scalars['String']>;
  /** Image filename. */
  filename?: Maybe<Scalars['String']>;
  /** Original image height. */
  height?: Maybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: Maybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: Maybe<Scalars['String']>;
  /** Image URL. */
  url?: Maybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: Maybe<Scalars['String']>;
  /** Original image width. */
  width?: Maybe<Scalars['Int']>;
};

export type WixReceiptsV1UpstreamWixCommonImageInput = {
  /** Image alt text. */
  altText?: InputMaybe<Scalars['String']>;
  /** Image filename. */
  filename?: InputMaybe<Scalars['String']>;
  /** Original image height. */
  height?: InputMaybe<Scalars['Int']>;
  /** WixMedia image ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Image size in bytes. */
  sizeInBytes?: InputMaybe<Scalars['String']>;
  /** Image URL. */
  url?: InputMaybe<Scalars['String']>;
  /** Image URL expiration date (when relevant). */
  urlExpirationDate?: InputMaybe<Scalars['String']>;
  /** Original image width. */
  width?: InputMaybe<Scalars['Int']>;
};

export type WixReceiptsV1UpstreamWixCommonShippingAddressContactDetails = {
  /** Contact's company name. */
  company?: Maybe<Scalars['String']>;
  /** Email associated with the address. */
  email?: Maybe<Scalars['String']>;
  /** Contact's first name. */
  firstName?: Maybe<Scalars['String']>;
  /** Contact's full name. */
  fullName?: Maybe<Scalars['String']>;
  /** Contact's last name. */
  lastName?: Maybe<Scalars['String']>;
  /** Contact's phone number. */
  phone?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1UpstreamWixCommonShippingAddressContactDetailsInput = {
  /** Contact's company name. */
  company?: InputMaybe<Scalars['String']>;
  /** Email associated with the address. */
  email?: InputMaybe<Scalars['String']>;
  /** Contact's first name. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Contact's full name. */
  fullName?: InputMaybe<Scalars['String']>;
  /** Contact's last name. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Contact's phone number. */
  phone?: InputMaybe<Scalars['String']>;
};

export enum WixReceiptsV1UpstreamWixCommonSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type WixReceiptsV1UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixReceiptsV1UpstreamWixCommonSortOrder>;
  /**
   * When `field_name` is a property of repeated field that is marked as `MATCH_ITEMS` and sort should be done by
   * a specific element from a collection, filter can/should be provided to ensure correct sort value is picked.
   *
   * If multiple filters are provided, they are combined with AND operator.
   *
   * Example:
   * Given we have document like {"id": "1", "nestedField": [{"price": 10, "region": "EU"}, {"price": 20, "region": "US"}]}
   * and `nestedField` is marked as `MATCH_ITEMS`, to ensure that sorting is done by correct region, filter should be
   * { fieldName: "nestedField.price", "select_items_by": [{"nestedField.region": "US"}] }
   */
  selectItemsBy?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type WixReceiptsV1UpstreamWixCommonStreetAddress = {
  /** Apartment number. */
  apt?: Maybe<Scalars['String']>;
  /** Optional address line 1 */
  formattedAddressLine?: Maybe<Scalars['String']>;
  /** Street name. */
  name?: Maybe<Scalars['String']>;
  /** Street number. */
  number?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1UpstreamWixCommonStreetAddressInput = {
  /** Apartment number. */
  apt?: InputMaybe<Scalars['String']>;
  /** Optional address line 1 */
  formattedAddressLine?: InputMaybe<Scalars['String']>;
  /** Street name. */
  name?: InputMaybe<Scalars['String']>;
  /** Street number. */
  number?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1UpstreamWixCommonSubdivision = {
  /** Short subdivision code. */
  code?: Maybe<Scalars['String']>;
  /** Subdivision full name. */
  name?: Maybe<Scalars['String']>;
  /** Standard organizations details (e.g. ISO). */
  standardDetails?: Maybe<WixReceiptsV1UpstreamWixCommonSubdivisionStandardDetails>;
  /** Subdivision level */
  type?: Maybe<WixReceiptsV1UpstreamWixCommonSubdivisionSubdivisionType>;
  /** Free text description of subdivision type. */
  typeInfo?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1UpstreamWixCommonSubdivisionInput = {
  /** Short subdivision code. */
  code?: InputMaybe<Scalars['String']>;
  /** Subdivision full name. */
  name?: InputMaybe<Scalars['String']>;
  /** Standard organizations details (e.g. ISO). */
  standardDetails?: InputMaybe<WixReceiptsV1UpstreamWixCommonSubdivisionStandardDetailsInput>;
  /** Subdivision level */
  type?: InputMaybe<WixReceiptsV1UpstreamWixCommonSubdivisionSubdivisionType>;
  /** Free text description of subdivision type. */
  typeInfo?: InputMaybe<Scalars['String']>;
};

export type WixReceiptsV1UpstreamWixCommonSubdivisionStandardDetails = {
  /** subdivision iso-3166-2 code according to [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2). e.g. US-NY, GB-SCT, NO-30 */
  iso31662?: Maybe<Scalars['String']>;
};

export type WixReceiptsV1UpstreamWixCommonSubdivisionStandardDetailsInput = {
  /** subdivision iso-3166-2 code according to [ISO 3166-2](https://en.wikipedia.org/wiki/ISO_3166-2). e.g. US-NY, GB-SCT, NO-30 */
  iso31662?: InputMaybe<Scalars['String']>;
};

export enum WixReceiptsV1UpstreamWixCommonSubdivisionSubdivisionType {
  /** State */
  ADMINISTRATIVE_AREA_LEVEL_1 = 'ADMINISTRATIVE_AREA_LEVEL_1',
  /** County */
  ADMINISTRATIVE_AREA_LEVEL_2 = 'ADMINISTRATIVE_AREA_LEVEL_2',
  /** City/town */
  ADMINISTRATIVE_AREA_LEVEL_3 = 'ADMINISTRATIVE_AREA_LEVEL_3',
  /** Neighborhood/quarter */
  ADMINISTRATIVE_AREA_LEVEL_4 = 'ADMINISTRATIVE_AREA_LEVEL_4',
  /** Street/block */
  ADMINISTRATIVE_AREA_LEVEL_5 = 'ADMINISTRATIVE_AREA_LEVEL_5',
  /** ADMINISTRATIVE_AREA_LEVEL_0. Indicates the national political entity, and is typically the highest order type returned by the Geocoder. */
  COUNTRY = 'COUNTRY',
  UNKNOWN_SUBDIVISION_TYPE = 'UNKNOWN_SUBDIVISION_TYPE'
}

export type WixReceiptsV1UpstreamWixCommonVatId = {
  /** Customer's tax ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Tax type.
   *
   * Supported values:
   * + `CPF`: for individual tax payers
   * + `CNPJ`: for corporations
   */
  type?: Maybe<WixReceiptsV1UpstreamWixCommonVatType>;
};

export type WixReceiptsV1UpstreamWixCommonVatIdInput = {
  /** Customer's tax ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Tax type.
   *
   * Supported values:
   * + `CPF`: for individual tax payers
   * + `CNPJ`: for corporations
   */
  type?: InputMaybe<WixReceiptsV1UpstreamWixCommonVatType>;
};

export enum WixReceiptsV1UpstreamWixCommonVatType {
  /** CNPJ - for corporations */
  CNPJ = 'CNPJ',
  /** CPF - for individual tax payers. */
  CPF = 'CPF',
  UNSPECIFIED = 'UNSPECIFIED'
}

export type WixRestaurantsMenusItemModifierV1BulkCreateModifierResult = {
  /** Metadata for creation of the item modifer. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
  /** Created item modifier. */
  modifier?: Maybe<WixRestaurantsMenusItemModifierV1Modifier>;
};

export type WixRestaurantsMenusItemModifierV1BulkCreateModifiersRequestInput = {
  /** List of item modifiers to create. */
  modifiers?: InputMaybe<Array<InputMaybe<WixRestaurantsMenusItemModifierV1ModifierInput>>>;
  /**
   * Whether the created item modifiers are included in the response. <br />
   * Default: `false`.
   */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type WixRestaurantsMenusItemModifierV1BulkCreateModifiersResponse = {
  /** Metadata for Bulk Create Modifiers API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Information about the created item modifiers. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusItemModifierV1BulkCreateModifierResult>>>;
};

export type WixRestaurantsMenusItemModifierV1BulkDeleteModifiersRequestInput = {
  /** Item Modifier IDs. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixRestaurantsMenusItemModifierV1BulkDeleteModifiersResponse = {
  /** Metadata for the API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Information about the deleted modifiers. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusItemModifierV1BulkDeleteModifiersResult>>>;
};

export type WixRestaurantsMenusItemModifierV1BulkDeleteModifiersResult = {
  /** Metadata for modifiers deletion. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixRestaurantsMenusItemModifierV1BulkUpdateAttachedToOrphanItemRequestInput = {
  modifierIdAttachedToOrphanItem?: InputMaybe<Array<InputMaybe<WixRestaurantsMenusItemModifierV1ModifierIdAttachedToOrphanItemInput>>>;
};

export type WixRestaurantsMenusItemModifierV1BulkUpdateAttachedToOrphanItemResponse = {
  /** Information about the updated modifiers. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusItemModifierV1BulkUpdateAttachedToOrphanItemResponseBulkItemResult>>>;
};

export type WixRestaurantsMenusItemModifierV1BulkUpdateAttachedToOrphanItemResponseBulkItemResult = {
  /** Metadata for item update. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsPerEntityRequestInput = {
  modifierIdLocationIds?: InputMaybe<Array<InputMaybe<WixRestaurantsMenusItemModifierV1ModifierIdLocationIdsInput>>>;
};

export type WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsPerEntityResponse = {
  /** Information about the updated modifiers. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult>>>;
};

export type WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult = {
  /** Metadata for item update. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsRequestInput = {
  /** Business Location Ids. */
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** modifier ids */
  modifierIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsResponse = {
  /** Information about the updated modifiers. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsResponseBulkItemResult>>>;
};

export type WixRestaurantsMenusItemModifierV1BulkUpdateBusinessLocationIdsResponseBulkItemResult = {
  /** Metadata for item update. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixRestaurantsMenusItemModifierV1BulkUpdateModifierResult = {
  /** Metadata for the update of the item modifer. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
  /** Updated item modifier. */
  modifier?: Maybe<WixRestaurantsMenusItemModifierV1Modifier>;
};

export type WixRestaurantsMenusItemModifierV1BulkUpdateModifiersRequestInput = {
  /** List of item modifiers to update. */
  modifiers?: InputMaybe<Array<InputMaybe<WixRestaurantsMenusItemModifierV1MaskedModifierInput>>>;
  /** Whether the updated item modifiers are included in the response. */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type WixRestaurantsMenusItemModifierV1BulkUpdateModifiersResponse = {
  /** Metadata for Bulk Update Modifiers API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Information about the updated item modifiers. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusItemModifierV1BulkUpdateModifierResult>>>;
};

export type WixRestaurantsMenusItemModifierV1CloneModifiersRequestInput = {
  /** The MetaSiteId to clone from */
  metaSiteId?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusItemModifierV1CountModifiersRequestInput = {
  /** Filter for counting modifiers. */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type WixRestaurantsMenusItemModifierV1CountModifiersResponse = {
  /** Counted modifiers. */
  count?: Maybe<Scalars['Int']>;
};

export type WixRestaurantsMenusItemModifierV1CreateModifierRequestInput = {
  /** Item modifier to create. */
  modifier?: InputMaybe<WixRestaurantsMenusItemModifierV1ModifierInput>;
};

export type WixRestaurantsMenusItemModifierV1CreateModifierResponse = {
  /** Created item modifier. */
  modifier?: Maybe<WixRestaurantsMenusItemModifierV1Modifier>;
};

export type WixRestaurantsMenusItemModifierV1DeleteModifierRequestInput = {
  /** ID of the item modifier to delete. */
  modifierId?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusItemModifierV1ExternalReferenceInfo = {
  /** Whether the connection to the external system is currently active. */
  connected?: Maybe<Scalars['Boolean']>;
  /** ID of the external integrator app\system associated with this object. */
  externalAppId?: Maybe<Scalars['String']>;
  /** Reference to an external resource ID. Used to link this object to a specific entity in an external system. */
  externalEntityId?: Maybe<Scalars['String']>;
  /** Last time this item modifier was synced with the external app. */
  lastSyncDate?: Maybe<Scalars['String']>;
};

export type WixRestaurantsMenusItemModifierV1ExternalReferenceInfoInput = {
  /** Whether the connection to the external system is currently active. */
  connected?: InputMaybe<Scalars['Boolean']>;
  /** ID of the external integrator app\system associated with this object. */
  externalAppId?: InputMaybe<Scalars['String']>;
  /** Reference to an external resource ID. Used to link this object to a specific entity in an external system. */
  externalEntityId?: InputMaybe<Scalars['String']>;
  /** Last time this item modifier was synced with the external app. */
  lastSyncDate?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusItemModifierV1GetModifierRequestInput = {
  id: Scalars['ID'];
};

export type WixRestaurantsMenusItemModifierV1ListModifiersRequestInput = {
  /** IDs of the item modifiers to retrieve. */
  modifierIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Metadata of the paginated results. */
  paging?: InputMaybe<WixRestaurantsMenusItemModifierV1UpstreamWixCommonCursorPagingInput>;
};

export type WixRestaurantsMenusItemModifierV1ListModifiersResponse = {
  /** Metadata of the paginated results. */
  metadata?: Maybe<WixRestaurantsMenusItemModifierV1UpstreamWixCommonCursorPagingMetadata>;
  /** Retrieved item modifiers. */
  modifiers?: Maybe<Array<Maybe<WixRestaurantsMenusItemModifierV1Modifier>>>;
};

export type WixRestaurantsMenusItemModifierV1MaskedModifierInput = {
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Item modifier to update. */
  modifier?: InputMaybe<WixRestaurantsMenusItemModifierV1ModifierInput>;
};

export type WixRestaurantsMenusItemModifierV1Modifier = {
  /** Used in multilocation permissions, allowing this entity to be read & written */
  attachedToOrphanItem?: Maybe<Scalars['Boolean']>;
  /** IDs of the business locations ([SDK](https://dev.wix.com/docs/sdk/backend-modules/restaurants/wix-restaurants-new/about-business-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/restaurants/wix-restaurants-new/about-business-locations)) where these item modifiers are available. */
  businessLocationIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Date and time the item modifier was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Extended fields. */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** References to an external app and resource associated with this object. Used for integration and tracking across different platforms. */
  externalReferenceInfo?: Maybe<WixRestaurantsMenusItemModifierV1ExternalReferenceInfo>;
  /** Item modifier ID. */
  id?: Maybe<Scalars['String']>;
  /**
   * Whether the modifier is in stock.
   * Default: `true`.
   */
  inStock?: Maybe<Scalars['Boolean']>;
  /** IDs of the business locations ([SDK](https://dev.wix.com/docs/sdk/backend-modules/restaurants/wix-restaurants-new/about-business-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/restaurants/wix-restaurants-new/about-business-locations)) where these item modifiers are available. */
  locations?: Maybe<ComWixpressLocationsQueryLocationsResponse>;
  /** Item modifier display name. */
  name?: Maybe<Scalars['String']>;
  /**
   * Revision number, which increments by 1 each time the item modifier is updated.
   * To prevent conflicting changes,
   * the current revision must be passed when updating the item modifier. <br />
   *
   * Ignored when creating an item modifier.
   */
  revision?: Maybe<Scalars['Long']>;
  /** Date and time the item modifier was updated. */
  updatedDate?: Maybe<Scalars['String']>;
};


export type WixRestaurantsMenusItemModifierV1ModifierLocationsArgs = {
  queryInput?: InputMaybe<ComWixpressLocationsQueryLocationsRequestInput>;
};

export type WixRestaurantsMenusItemModifierV1ModifierIdAttachedToOrphanItemInput = {
  /** Attached to orphan item */
  attachedToOrphanItem?: InputMaybe<Scalars['Boolean']>;
  /** Modifier ID */
  modifierId?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusItemModifierV1ModifierIdLocationIdsInput = {
  /** Business Location IDs */
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** modifier ID */
  modifierId?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusItemModifierV1ModifierInput = {
  /** Used in multilocation permissions, allowing this entity to be read & written */
  attachedToOrphanItem?: InputMaybe<Scalars['Boolean']>;
  /** IDs of the business locations ([SDK](https://dev.wix.com/docs/sdk/backend-modules/restaurants/wix-restaurants-new/about-business-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/restaurants/wix-restaurants-new/about-business-locations)) where these item modifiers are available. */
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Date and time the item modifier was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Extended fields. */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** References to an external app and resource associated with this object. Used for integration and tracking across different platforms. */
  externalReferenceInfo?: InputMaybe<WixRestaurantsMenusItemModifierV1ExternalReferenceInfoInput>;
  /** Item modifier ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Whether the modifier is in stock.
   * Default: `true`.
   */
  inStock?: InputMaybe<Scalars['Boolean']>;
  /** Item modifier display name. */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Revision number, which increments by 1 each time the item modifier is updated.
   * To prevent conflicting changes,
   * the current revision must be passed when updating the item modifier. <br />
   *
   * Ignored when creating an item modifier.
   */
  revision?: InputMaybe<Scalars['Long']>;
  /** Date and time the item modifier was updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export enum WixRestaurantsMenusItemModifierV1ModifierType {
  MODIFIER = 'MODIFIER',
  UNKNOWN_VARIATION_AND_MODIFIER = 'UNKNOWN_VARIATION_AND_MODIFIER',
  VARIANT = 'VARIANT'
}

export type WixRestaurantsMenusItemModifierV1QueryModifiersRequestInput = {
  /** Query options. */
  query?: InputMaybe<WixRestaurantsMenusItemModifierV1UpstreamWixCommonCursorQueryInput>;
};

export type WixRestaurantsMenusItemModifierV1QueryModifiersResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<WixRestaurantsMenusItemModifierV1Modifier>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixRestaurantsMenusItemModifierV1SyncContentToMultilingualRequestInput = {
  /** MetaSite ID */
  metaSiteId?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusItemModifierV1UpdateModifierRequestInput = {
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Item Modifier with updated properties. */
  modifier?: InputMaybe<WixRestaurantsMenusItemModifierV1ModifierInput>;
};

export type WixRestaurantsMenusItemModifierV1UpdateModifierResponse = {
  /** Updated item modifier. */
  modifier?: Maybe<WixRestaurantsMenusItemModifierV1Modifier>;
};

export type WixRestaurantsMenusItemModifierV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Maximum number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixRestaurantsMenusItemModifierV1UpstreamWixCommonCursorPagingMetadata = {
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Cursor pointing to the next page and the previous page in the list of results. */
  cursors?: Maybe<WixRestaurantsMenusItemModifierV1UpstreamWixCommonCursors>;
  /**
   * Whether there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
};

export type WixRestaurantsMenusItemModifierV1UpstreamWixCommonCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixRestaurantsMenusItemModifierV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object.
   * See [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language)
   * for more information.
   *
   * For a detailed list of supported filters, see
   * [Supported Filters](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item-modifiers/supported-filters-and-sorting).
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Sort object. */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type WixRestaurantsMenusItemModifierV1UpstreamWixCommonCursors = {
  /** Cursor pointing to next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export type WixRestaurantsMenusItemVariantV1BulkCreateVariantsRequestInput = {
  /** Whether to receive the created item variants in the response. */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /** Item variants details. */
  variants?: InputMaybe<Array<InputMaybe<WixRestaurantsMenusItemVariantV1VariantInput>>>;
};

export type WixRestaurantsMenusItemVariantV1BulkCreateVariantsResponse = {
  /** Metadata for the API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Information about the created item variants. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusItemVariantV1BulkVariantResult>>>;
};

export type WixRestaurantsMenusItemVariantV1BulkDeleteVariantsRequestInput = {
  /** Item variant IDs. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixRestaurantsMenusItemVariantV1BulkDeleteVariantsResponse = {
  /** Metadata for the API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Information about the deleted variants. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusItemVariantV1BulkDeleteVariantsResult>>>;
};

export type WixRestaurantsMenusItemVariantV1BulkDeleteVariantsResult = {
  /** Metadata for variants deletion. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixRestaurantsMenusItemVariantV1BulkUpdateAttachedToOrphanItemRequestInput = {
  variantIdAttachedToOrphanItem?: InputMaybe<Array<InputMaybe<WixRestaurantsMenusItemVariantV1VariantIdAttachedToOrphanItemInput>>>;
};

export type WixRestaurantsMenusItemVariantV1BulkUpdateAttachedToOrphanItemResponse = {
  /** Information about the updated variants. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusItemVariantV1BulkUpdateAttachedToOrphanItemResponseBulkItemResult>>>;
};

export type WixRestaurantsMenusItemVariantV1BulkUpdateAttachedToOrphanItemResponseBulkItemResult = {
  /** Metadata for item update. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsPerEntityRequestInput = {
  variantIdLocationIds?: InputMaybe<Array<InputMaybe<WixRestaurantsMenusItemVariantV1VariantIdLocationIdsInput>>>;
};

export type WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsPerEntityResponse = {
  /** Information about the updated variants. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult>>>;
};

export type WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult = {
  /** Metadata for item update. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsRequestInput = {
  /** Business Location Ids. */
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** variant ids */
  variantIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsResponse = {
  /** Information about the updated variants. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsResponseBulkItemResult>>>;
};

export type WixRestaurantsMenusItemVariantV1BulkUpdateBusinessLocationIdsResponseBulkItemResult = {
  /** Metadata for item update. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixRestaurantsMenusItemVariantV1BulkUpdateVariantsRequestInput = {
  /** Whether to receive the updated item variants in the response. */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /** Item variants to be updated. */
  variants?: InputMaybe<Array<InputMaybe<WixRestaurantsMenusItemVariantV1MaskedVariantInput>>>;
};

export type WixRestaurantsMenusItemVariantV1BulkUpdateVariantsResponse = {
  /** Metadata for the API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Information about the updated item variants. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusItemVariantV1BulkVariantResult>>>;
};

export type WixRestaurantsMenusItemVariantV1BulkVariantResult = {
  /** Metadata for creation of item variants. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
  /** Created item variants. Only returned if the `returnEntity` value is `true`. */
  variant?: Maybe<WixRestaurantsMenusItemVariantV1Variant>;
};

export type WixRestaurantsMenusItemVariantV1CloneVariantsRequestInput = {
  /** The MetaSiteId to clone from */
  metaSiteId?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusItemVariantV1CountVariantsRequestInput = {
  /** Filter for counting variants. */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type WixRestaurantsMenusItemVariantV1CountVariantsResponse = {
  /** Counted variants. */
  count?: Maybe<Scalars['Int']>;
};

export type WixRestaurantsMenusItemVariantV1CreateVariantRequestInput = {
  /** Item variant info. */
  variant?: InputMaybe<WixRestaurantsMenusItemVariantV1VariantInput>;
};

export type WixRestaurantsMenusItemVariantV1CreateVariantResponse = {
  /** Item variant. */
  variant?: Maybe<WixRestaurantsMenusItemVariantV1Variant>;
};

export type WixRestaurantsMenusItemVariantV1DeleteVariantRequestInput = {
  /** Item variant ID. */
  variantId?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusItemVariantV1ExternalReferenceInfo = {
  /** ID of the external integrator app\system associated with this object. */
  externalAppId?: Maybe<Scalars['String']>;
  /** Reference to an external resource ID. Used to link this object to a specific entity in an external system. */
  externalEntityId?: Maybe<Scalars['String']>;
  /** Last time this item variant was synced with the external app. */
  lastSyncDate?: Maybe<Scalars['String']>;
};

export type WixRestaurantsMenusItemVariantV1ExternalReferenceInfoInput = {
  /** ID of the external integrator app\system associated with this object. */
  externalAppId?: InputMaybe<Scalars['String']>;
  /** Reference to an external resource ID. Used to link this object to a specific entity in an external system. */
  externalEntityId?: InputMaybe<Scalars['String']>;
  /** Last time this item variant was synced with the external app. */
  lastSyncDate?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusItemVariantV1GetVariantRequestInput = {
  id: Scalars['ID'];
};

export type WixRestaurantsMenusItemVariantV1ListVariantsRequestInput = {
  /** The metadata of the paginated results. */
  paging?: InputMaybe<WixRestaurantsMenusItemVariantV1UpstreamWixCommonCursorPagingInput>;
  /** Item variant IDs. */
  variantIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixRestaurantsMenusItemVariantV1ListVariantsResponse = {
  /** The metadata of the paginated results. */
  metadata?: Maybe<WixRestaurantsMenusItemVariantV1UpstreamWixCommonCursorPagingMetadata>;
  /** The retrieved item variants. */
  variants?: Maybe<Array<Maybe<WixRestaurantsMenusItemVariantV1Variant>>>;
};

export type WixRestaurantsMenusItemVariantV1MaskedVariantInput = {
  /** Explicit list of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Item variant to update. */
  variant?: InputMaybe<WixRestaurantsMenusItemVariantV1VariantInput>;
};

export type WixRestaurantsMenusItemVariantV1QueryVariantsRequestInput = {
  /** Query options. */
  query?: InputMaybe<WixRestaurantsMenusItemVariantV1UpstreamWixQueryCursorQueryInput>;
};

export type WixRestaurantsMenusItemVariantV1QueryVariantsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<WixRestaurantsMenusItemVariantV1Variant>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixRestaurantsMenusItemVariantV1UpdateVariantRequestInput = {
  /** Set of fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Item variant to update. */
  variant?: InputMaybe<WixRestaurantsMenusItemVariantV1VariantInput>;
};

export type WixRestaurantsMenusItemVariantV1UpdateVariantResponse = {
  /** Updated item variant. */
  variant?: Maybe<WixRestaurantsMenusItemVariantV1Variant>;
};

export type WixRestaurantsMenusItemVariantV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixRestaurantsMenusItemVariantV1UpstreamWixCommonCursorPagingMetadata = {
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Offset that was requested. */
  cursors?: Maybe<WixRestaurantsMenusItemVariantV1UpstreamWixCommonCursors>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
};

export type WixRestaurantsMenusItemVariantV1UpstreamWixCommonCursors = {
  /** Cursor pointing to next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export enum WixRestaurantsMenusItemVariantV1UpstreamWixCommonSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type WixRestaurantsMenusItemVariantV1UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixRestaurantsMenusItemVariantV1UpstreamWixCommonSortOrder>;
};

export type WixRestaurantsMenusItemVariantV1UpstreamWixQueryCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixRestaurantsMenusItemVariantV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixRestaurantsMenusItemVariantV1UpstreamWixCommonSortingInput>>>;
};

export type WixRestaurantsMenusItemVariantV1Variant = {
  /** Used in multilocation permissions, allowing this entity to be read & written */
  attachedToOrphanItem?: Maybe<Scalars['Boolean']>;
  /** IDs of the business locations ([SDK](https://dev.wix.com/docs/sdk/backend-modules/restaurants/wix-restaurants-new/about-business-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/restaurants/wix-restaurants-new/about-business-locations)) where these item variants are available. */
  businessLocationIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Date and time the item variant was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Extended fields. */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** References to an external app and resource associated with this object. Used for integration and tracking across different platforms. */
  externalReferenceInfo?: Maybe<WixRestaurantsMenusItemVariantV1ExternalReferenceInfo>;
  /** Item variant ID. */
  id?: Maybe<Scalars['String']>;
  /** IDs of the business locations ([SDK](https://dev.wix.com/docs/sdk/backend-modules/restaurants/wix-restaurants-new/about-business-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/restaurants/wix-restaurants-new/about-business-locations)) where these item variants are available. */
  locations?: Maybe<ComWixpressLocationsQueryLocationsResponse>;
  /** Item variant name. */
  name?: Maybe<Scalars['String']>;
  oloMigrationVariantId?: Maybe<Scalars['String']>;
  /** Revision number, which increments by 1 each time the item variant is updated. To prevent conflicting changes, the current revision must be passed when updating the item variant. Ignored when creating an item variant. */
  revision?: Maybe<Scalars['Long']>;
  /** Date and time the item variant was updated. */
  updatedDate?: Maybe<Scalars['String']>;
};


export type WixRestaurantsMenusItemVariantV1VariantLocationsArgs = {
  queryInput?: InputMaybe<ComWixpressLocationsQueryLocationsRequestInput>;
};

export type WixRestaurantsMenusItemVariantV1VariantIdAttachedToOrphanItemInput = {
  /** Attached to orphan item */
  attachedToOrphanItem?: InputMaybe<Scalars['Boolean']>;
  /** variant ID */
  variantId?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusItemVariantV1VariantIdLocationIdsInput = {
  /** Business Location IDs */
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** variant ID */
  variantId?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusItemVariantV1VariantInput = {
  /** Used in multilocation permissions, allowing this entity to be read & written */
  attachedToOrphanItem?: InputMaybe<Scalars['Boolean']>;
  /** IDs of the business locations ([SDK](https://dev.wix.com/docs/sdk/backend-modules/restaurants/wix-restaurants-new/about-business-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/restaurants/wix-restaurants-new/about-business-locations)) where these item variants are available. */
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Date and time the item variant was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Extended fields. */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** References to an external app and resource associated with this object. Used for integration and tracking across different platforms. */
  externalReferenceInfo?: InputMaybe<WixRestaurantsMenusItemVariantV1ExternalReferenceInfoInput>;
  /** Item variant ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Item variant name. */
  name?: InputMaybe<Scalars['String']>;
  oloMigrationVariantId?: InputMaybe<Scalars['String']>;
  /** Revision number, which increments by 1 each time the item variant is updated. To prevent conflicting changes, the current revision must be passed when updating the item variant. Ignored when creating an item variant. */
  revision?: InputMaybe<Scalars['Long']>;
  /** Date and time the item variant was updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusV1AddModifiersToGroupUnlimitedRequestInput = {
  /** Modifier group ID to add modifiers to. */
  modifierGroupId?: InputMaybe<Scalars['String']>;
  /** List of modifier IDs to add to the modifier group. Limited to 500 items. */
  modifierIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixRestaurantsMenusV1AddModifiersToGroupUnlimitedResponse = {
  /** Updated modifier group with the new modifiers added. */
  modifierGroup?: Maybe<WixRestaurantsMenusV1ModifierGroup>;
};

export type WixRestaurantsMenusV1AdditionalChargeInfo = {
  /** Additional charge for the item modifier. A value of `0` means the item modifier is free. */
  additionalCharge?: Maybe<Scalars['String']>;
  /** Formatted additional charge. */
  formattedAdditionalCharge?: Maybe<Scalars['String']>;
};

export type WixRestaurantsMenusV1AdditionalChargeInfoInput = {
  /** Additional charge for the item modifier. A value of `0` means the item modifier is free. */
  additionalCharge?: InputMaybe<Scalars['String']>;
  /** Formatted additional charge. */
  formattedAdditionalCharge?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusV1BulkCreateModifierGroupsRequestInput = {
  /** Modifier groups details. */
  modifierGroups?: InputMaybe<Array<InputMaybe<WixRestaurantsMenusV1ModifierGroupInput>>>;
  /** Whether to receive the created modifier groups in the response. */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type WixRestaurantsMenusV1BulkCreateModifierGroupsResponse = {
  /** Metadata for the API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Information about the created modifier groups. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusV1BulkCreateModifierGroupsResult>>>;
};

export type WixRestaurantsMenusV1BulkCreateModifierGroupsResult = {
  /** Metadata for group modifier creation. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
  /** Created modifier group. */
  modifierGroup?: Maybe<WixRestaurantsMenusV1ModifierGroup>;
};

export type WixRestaurantsMenusV1BulkDeleteModifierGroupsRequestInput = {
  /** Modifier Group IDs. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixRestaurantsMenusV1BulkDeleteModifierGroupsResponse = {
  /** Metadata for the API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Information about the deleted modifier group. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusV1BulkDeleteModifierGroupsResult>>>;
};

export type WixRestaurantsMenusV1BulkDeleteModifierGroupsResult = {
  /** Metadata for group modifier deletion. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixRestaurantsMenusV1BulkUpdateAttachedToOrphanItemRequestInput = {
  modifierGroupIdAttachedToOrphanItem?: InputMaybe<Array<InputMaybe<WixRestaurantsMenusV1ModifierGroupIdAttachedToOrphanItemInput>>>;
};

export type WixRestaurantsMenusV1BulkUpdateAttachedToOrphanItemResponse = {
  /** Information about the updated modifier groups. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusV1BulkUpdateAttachedToOrphanItemResponseBulkItemResult>>>;
};

export type WixRestaurantsMenusV1BulkUpdateAttachedToOrphanItemResponseBulkItemResult = {
  /** Metadata for item update. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsPerEntityRequestInput = {
  modifierGroupIdLocationIds?: InputMaybe<Array<InputMaybe<WixRestaurantsMenusV1ModifierGroupIdLocationIdsInput>>>;
};

export type WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsPerEntityResponse = {
  /** Information about the updated modifier groups. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult>>>;
};

export type WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult = {
  /** Metadata for item update. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsRequestInput = {
  /** Business Location IDs. */
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Modifier group IDs */
  modifierGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsResponse = {
  /** Information about the updated modifier groups. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsResponseBulkItemResult>>>;
};

export type WixRestaurantsMenusV1BulkUpdateBusinessLocationIdsResponseBulkItemResult = {
  /** Metadata for item update. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
};

export type WixRestaurantsMenusV1BulkUpdateModifierGroupsRequestInput = {
  /** Modifier groups to update. */
  modifierGroups?: InputMaybe<Array<InputMaybe<WixRestaurantsMenusV1MaskedModifierGroupInput>>>;
  /** Whether to receive the updated modifier groups in the response. */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
};

export type WixRestaurantsMenusV1BulkUpdateModifierGroupsResponse = {
  /** Metadata for the API call. */
  bulkActionMetadata?: Maybe<WixCommonBulkActionMetadata>;
  /** Information about the updated modifier groups. */
  results?: Maybe<Array<Maybe<WixRestaurantsMenusV1BulkUpdateModifierGroupsResult>>>;
};

export type WixRestaurantsMenusV1BulkUpdateModifierGroupsResult = {
  /** Metadata for group modifier update. */
  itemMetadata?: Maybe<WixCommonItemMetadata>;
  /** Updated modifier group. Only returned if `returnEntity` is set to `true`. */
  modifierGroup?: Maybe<WixRestaurantsMenusV1ModifierGroup>;
};

export type WixRestaurantsMenusV1CloneModifierGroupsRequestInput = {
  /** The MetaSiteId to clone from. */
  metaSiteId?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusV1CountModifierGroupsRequestInput = {
  /** Filter for counting modifier groups. */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type WixRestaurantsMenusV1CountModifierGroupsResponse = {
  /** Counted modifier groups. */
  count?: Maybe<Scalars['Int']>;
};

export type WixRestaurantsMenusV1CreateModifierGroupRequestInput = {
  /** Modifier group details. */
  modifierGroup?: InputMaybe<WixRestaurantsMenusV1ModifierGroupInput>;
};

export type WixRestaurantsMenusV1CreateModifierGroupResponse = {
  /** Modifier group. */
  modifierGroup?: Maybe<WixRestaurantsMenusV1ModifierGroup>;
};

export type WixRestaurantsMenusV1DeleteLocationIdsFromModifiersInput = {
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  modifierIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixRestaurantsMenusV1DeleteModifierGroupRequestInput = {
  /** Modifier group ID. */
  modifierGroupId?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusV1ExternalReferenceInfo = {
  /** Whether the connection to the external system is currently active. */
  connected?: Maybe<Scalars['Boolean']>;
  /** ID of the external integrator app\system associated with this object. */
  externalAppId?: Maybe<Scalars['String']>;
  /** Reference to an external resource ID. Used to link this object to a specific entity in an external system. */
  externalEntityId?: Maybe<Scalars['String']>;
  /** Last time this modifier group was synced with the external app. */
  lastSyncDate?: Maybe<Scalars['String']>;
};

export type WixRestaurantsMenusV1ExternalReferenceInfoInput = {
  /** Whether the connection to the external system is currently active. */
  connected?: InputMaybe<Scalars['Boolean']>;
  /** ID of the external integrator app\system associated with this object. */
  externalAppId?: InputMaybe<Scalars['String']>;
  /** Reference to an external resource ID. Used to link this object to a specific entity in an external system. */
  externalEntityId?: InputMaybe<Scalars['String']>;
  /** Last time this modifier group was synced with the external app. */
  lastSyncDate?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusV1GetModifierGroupRequestInput = {
  id: Scalars['ID'];
};

export type WixRestaurantsMenusV1ListModifierGroupRequestInput = {
  /** Modifier group IDs. */
  modifierGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The metadata of the paginated results. */
  paging?: InputMaybe<WixRestaurantsMenusV1UpstreamWixCommonCursorPagingInput>;
};

export type WixRestaurantsMenusV1ListModifierGroupResponse = {
  /** The metadata of the paginated results. */
  metadata?: Maybe<WixRestaurantsMenusV1UpstreamWixCommonCursorPagingMetadata>;
  /** Retrieved modifier groups. */
  modifierGroups?: Maybe<Array<Maybe<WixRestaurantsMenusV1ModifierGroup>>>;
};

export type WixRestaurantsMenusV1MaskedModifierGroupInput = {
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Modifier group to update. */
  modifierGroup?: InputMaybe<WixRestaurantsMenusV1ModifierGroupInput>;
};

export type WixRestaurantsMenusV1Modifier = {
  /**
   * Deprecated, modifier additional charge. Can be 0 to represent free.
   * @deprecated Deprecated, modifier additional charge. Can be 0 to represent free. Replaced by: AdditionalChargeInfo.additional_charge. Removal date: 2024-06-30.
   */
  additionalCharge?: Maybe<Scalars['String']>;
  /** Item modifier price details. */
  additionalChargeInfo?: Maybe<WixRestaurantsMenusV1AdditionalChargeInfo>;
  /** Item modifier ID. */
  id?: Maybe<Scalars['String']>;
  /** Item modifier ID. */
  modifier?: Maybe<WixRestaurantsMenusItemModifierV1Modifier>;
  /**
   * Whether the item modifier is pre-selected.
   * Default: `false`.
   */
  preSelected?: Maybe<Scalars['Boolean']>;
};

export type WixRestaurantsMenusV1ModifierGroup = {
  /** Used in multilocation permissions, allowing this entity to be read & written */
  attachedToOrphanItem?: Maybe<Scalars['Boolean']>;
  /** IDs of the business locations ([SDK](https://dev.wix.com/docs/sdk/backend-modules/restaurants/wix-restaurants-new/about-business-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/restaurants/wix-restaurants-new/about-business-locations)) where these item modifier groups are available. */
  businessLocationIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Date and time the modifier group was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Extended fields. */
  extendedFields?: Maybe<WixCommonDataDataextensionsExtendedFields>;
  /** References to an external app and resource associated with this object. Used for integration and tracking across different platforms. */
  externalReferenceInfo?: Maybe<WixRestaurantsMenusV1ExternalReferenceInfo>;
  /** Modifier group ID. */
  id?: Maybe<Scalars['String']>;
  /** IDs of the business locations ([SDK](https://dev.wix.com/docs/sdk/backend-modules/restaurants/wix-restaurants-new/about-business-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/restaurants/wix-restaurants-new/about-business-locations)) where these item modifier groups are available. */
  locations?: Maybe<ComWixpressLocationsQueryLocationsResponse>;
  /** Group of item modifiers. */
  modifiers?: Maybe<Array<Maybe<WixRestaurantsMenusV1Modifier>>>;
  /** Modifier group name. */
  name?: Maybe<Scalars['String']>;
  /** Revision number, which increments by 1 each time the modifier group is updated. To prevent conflicting changes, the current revision must be passed when updating the modifier group. Ignored when creating a modifier group. */
  revision?: Maybe<Scalars['Long']>;
  /** Modifier group details. */
  rule?: Maybe<WixRestaurantsMenusV1Rule>;
  /** Date and time the modifier group was updated. */
  updatedDate?: Maybe<Scalars['String']>;
};


export type WixRestaurantsMenusV1ModifierGroupLocationsArgs = {
  queryInput?: InputMaybe<ComWixpressLocationsQueryLocationsRequestInput>;
};

export type WixRestaurantsMenusV1ModifierGroupIdAttachedToOrphanItemInput = {
  /** Attached to orphan item */
  attachedToOrphanItem?: InputMaybe<Scalars['Boolean']>;
  /** Modifier group ID */
  modifierGroupId?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusV1ModifierGroupIdLocationIdsInput = {
  /** Business Location IDs */
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Modifier group ID */
  modifierGroupId?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusV1ModifierGroupInput = {
  /** Used in multilocation permissions, allowing this entity to be read & written */
  attachedToOrphanItem?: InputMaybe<Scalars['Boolean']>;
  /** IDs of the business locations ([SDK](https://dev.wix.com/docs/sdk/backend-modules/restaurants/wix-restaurants-new/about-business-locations) | [REST](https://dev.wix.com/docs/rest/business-solutions/restaurants/wix-restaurants-new/about-business-locations)) where these item modifier groups are available. */
  businessLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Date and time the modifier group was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Extended fields. */
  extendedFields?: InputMaybe<WixCommonDataDataextensionsExtendedFieldsInput>;
  /** References to an external app and resource associated with this object. Used for integration and tracking across different platforms. */
  externalReferenceInfo?: InputMaybe<WixRestaurantsMenusV1ExternalReferenceInfoInput>;
  /** Modifier group ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Group of item modifiers. */
  modifiers?: InputMaybe<Array<InputMaybe<WixRestaurantsMenusV1ModifierInput>>>;
  /** Modifier group name. */
  name?: InputMaybe<Scalars['String']>;
  /** Revision number, which increments by 1 each time the modifier group is updated. To prevent conflicting changes, the current revision must be passed when updating the modifier group. Ignored when creating a modifier group. */
  revision?: InputMaybe<Scalars['Long']>;
  /** Modifier group details. */
  rule?: InputMaybe<WixRestaurantsMenusV1RuleInput>;
  /** Date and time the modifier group was updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusV1ModifierInput = {
  /** Item modifier price details. */
  additionalChargeInfo?: InputMaybe<WixRestaurantsMenusV1AdditionalChargeInfoInput>;
  /** Item modifier ID. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Whether the item modifier is pre-selected.
   * Default: `false`.
   */
  preSelected?: InputMaybe<Scalars['Boolean']>;
};

export type WixRestaurantsMenusV1QueryModifierGroupsRequestInput = {
  /** Query options. */
  query?: InputMaybe<WixRestaurantsMenusV1UpstreamWixCommonCursorQueryInput>;
};

export type WixRestaurantsMenusV1QueryModifierGroupsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<WixRestaurantsMenusV1ModifierGroup>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixRestaurantsMenusV1Rule = {
  /** Maximum number of item modifiers a site visitor may select. Must be greater than or equal to the value of `minSelections`. */
  maxSelections?: Maybe<Scalars['Int']>;
  /**
   * Minimum number of item modifiers a site visitor must select. The value must be lower or equal to the available item modifiers in the group.
   * Default: `0`.
   */
  minSelections?: Maybe<Scalars['Int']>;
  /** Whether the items from the modifier group must be selected. */
  required?: Maybe<Scalars['Boolean']>;
};

export type WixRestaurantsMenusV1RuleInput = {
  /** Maximum number of item modifiers a site visitor may select. Must be greater than or equal to the value of `minSelections`. */
  maxSelections?: InputMaybe<Scalars['Int']>;
  /**
   * Minimum number of item modifiers a site visitor must select. The value must be lower or equal to the available item modifiers in the group.
   * Default: `0`.
   */
  minSelections?: InputMaybe<Scalars['Int']>;
  /** Whether the items from the modifier group must be selected. */
  required?: InputMaybe<Scalars['Boolean']>;
};

export type WixRestaurantsMenusV1RuleMultiSelect = {
  /** Number of selections given to the customer for free. */
  freeSelections?: Maybe<Scalars['Int']>;
  /** Maximum number of extras a customer can choose. Must be greater than or equal to the value of `minSelections`. */
  maxSelections?: Maybe<Scalars['Int']>;
  /** Minimum number of extras a customer must choose. Defaults to `0`. Must be lower or equal to the available modifiers in the group */
  minSelections?: Maybe<Scalars['Int']>;
};

export type WixRestaurantsMenusV1RuleMultiSelectInput = {
  /** Number of selections given to the customer for free. */
  freeSelections?: InputMaybe<Scalars['Int']>;
  /** Maximum number of extras a customer can choose. Must be greater than or equal to the value of `minSelections`. */
  maxSelections?: InputMaybe<Scalars['Int']>;
  /** Minimum number of extras a customer must choose. Defaults to `0`. Must be lower or equal to the available modifiers in the group */
  minSelections?: InputMaybe<Scalars['Int']>;
};

export enum WixRestaurantsMenusV1RuleType {
  MULTI_SELECT = 'MULTI_SELECT',
  SINGLE_SELECT = 'SINGLE_SELECT',
  UNSPECIFIED_RULE = 'UNSPECIFIED_RULE'
}

export type WixRestaurantsMenusV1SyncContentToMultilingualRequestInput = {
  /** MetaSite ID */
  metaSiteId?: InputMaybe<Scalars['String']>;
};

export type WixRestaurantsMenusV1UpdateModifierGroupRequestInput = {
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Modifier group to update. */
  modifierGroup?: InputMaybe<WixRestaurantsMenusV1ModifierGroupInput>;
};

export type WixRestaurantsMenusV1UpdateModifierGroupResponse = {
  /** Updated modifier group. */
  modifierGroup?: Maybe<WixRestaurantsMenusV1ModifierGroup>;
};

export type WixRestaurantsMenusV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixRestaurantsMenusV1UpstreamWixCommonCursorPagingMetadata = {
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Offset that was requested. */
  cursors?: Maybe<WixRestaurantsMenusV1UpstreamWixCommonCursors>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
};

export type WixRestaurantsMenusV1UpstreamWixCommonCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixRestaurantsMenusV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixCommonSortingInput>>>;
};

export type WixRestaurantsMenusV1UpstreamWixCommonCursors = {
  /** Cursor pointing to next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export type WixRichContentV1AnchorData = {
  /** The target node's ID. */
  anchor?: Maybe<Scalars['String']>;
};

export type WixRichContentV1AnchorDataInput = {
  /** The target node's ID. */
  anchor?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1AppEmbedData = {
  /** Data for embedded Wix Bookings content. */
  bookingData?: Maybe<WixRichContentV1AppEmbedDataBookingData>;
  /** Button styling options. */
  buttonStyles?: Maybe<WixRichContentV1AppEmbedDataButtonStyles>;
  /** Card styling options. */
  cardStyles?: Maybe<WixRichContentV1AppEmbedDataCardStyles>;
  /** Styling for the app embed's container. */
  containerData?: Maybe<WixRichContentV1PluginContainerData>;
  /** Data for embedded Wix Events content. */
  eventData?: Maybe<WixRichContentV1AppEmbedDataEventData>;
  /** Whether to hide the button. */
  hideButton?: Maybe<Scalars['Boolean']>;
  /** Whether to hide the date and time (Event). */
  hideDateTime?: Maybe<Scalars['Boolean']>;
  /** Whether to hide the description (Event and Booking). */
  hideDescription?: Maybe<Scalars['Boolean']>;
  /** Whether to hide the duration (Booking). */
  hideDuration?: Maybe<Scalars['Boolean']>;
  /** Whether to hide the image. */
  hideImage?: Maybe<Scalars['Boolean']>;
  /** Whether to hide the location (Event). */
  hideLocation?: Maybe<Scalars['Boolean']>;
  /** Whether to hide the price. */
  hidePrice?: Maybe<Scalars['Boolean']>;
  /** Whether to hide the ribbon. */
  hideRibbon?: Maybe<Scalars['Boolean']>;
  /** Whether to hide the title. */
  hideTitle?: Maybe<Scalars['Boolean']>;
  /** An image for the embedded content. */
  image?: Maybe<WixRichContentV1Media>;
  /** Deprecated: Use `image` instead. */
  imageSrc?: Maybe<Scalars['String']>;
  /** Image styling options. */
  imageStyles?: Maybe<WixRichContentV1AppEmbedDataImageStyles>;
  /** The ID of the embedded content. */
  itemId?: Maybe<Scalars['String']>;
  /** The name of the embedded content. */
  name?: Maybe<Scalars['String']>;
  /** Pricing data for embedded Wix App content. */
  pricingData?: Maybe<WixRichContentV1AppEmbedDataPricingData>;
  /** Ribbon styling options. */
  ribbonStyles?: Maybe<WixRichContentV1AppEmbedDataRibbonStyles>;
  /** The type of Wix App content being embedded. */
  type?: Maybe<WixRichContentV1AppEmbedDataAppType>;
  /** The URL for the embedded content. */
  url?: Maybe<Scalars['String']>;
};

export enum WixRichContentV1AppEmbedDataAppType {
  BOOKING = 'BOOKING',
  EVENT = 'EVENT',
  PRODUCT = 'PRODUCT'
}

export type WixRichContentV1AppEmbedDataBookingData = {
  /** Booking duration in minutes. */
  durations?: Maybe<Scalars['String']>;
};

export type WixRichContentV1AppEmbedDataBookingDataInput = {
  /** Booking duration in minutes. */
  durations?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1AppEmbedDataButtonStyles = {
  /** Background color as a hexadecimal value. */
  backgroundColor?: Maybe<Scalars['String']>;
  /** Background color as a hexadecimal value (hover state). */
  backgroundColorHover?: Maybe<Scalars['String']>;
  /** Border color as a hexadecimal value. */
  borderColor?: Maybe<Scalars['String']>;
  /** Border color as a hexadecimal value (hover state). */
  borderColorHover?: Maybe<Scalars['String']>;
  /** Border radius in pixels. */
  borderRadius?: Maybe<Scalars['Int']>;
  /** Border width in pixels. */
  borderWidth?: Maybe<Scalars['Int']>;
  /** Button size option, one of `SMALL`, `MEDIUM` or `LARGE`. Defaults to `MEDIUM`. */
  buttonSize?: Maybe<Scalars['String']>;
  /** Text to display on the button. */
  buttonText?: Maybe<Scalars['String']>;
  /** Text color as a hexadecimal value. */
  textColor?: Maybe<Scalars['String']>;
  /** Text color as a hexadecimal value (hover state). */
  textColorHover?: Maybe<Scalars['String']>;
};

export type WixRichContentV1AppEmbedDataButtonStylesInput = {
  /** Background color as a hexadecimal value. */
  backgroundColor?: InputMaybe<Scalars['String']>;
  /** Background color as a hexadecimal value (hover state). */
  backgroundColorHover?: InputMaybe<Scalars['String']>;
  /** Border color as a hexadecimal value. */
  borderColor?: InputMaybe<Scalars['String']>;
  /** Border color as a hexadecimal value (hover state). */
  borderColorHover?: InputMaybe<Scalars['String']>;
  /** Border radius in pixels. */
  borderRadius?: InputMaybe<Scalars['Int']>;
  /** Border width in pixels. */
  borderWidth?: InputMaybe<Scalars['Int']>;
  /** Button size option, one of `SMALL`, `MEDIUM` or `LARGE`. Defaults to `MEDIUM`. */
  buttonSize?: InputMaybe<Scalars['String']>;
  /** Text to display on the button. */
  buttonText?: InputMaybe<Scalars['String']>;
  /** Text color as a hexadecimal value. */
  textColor?: InputMaybe<Scalars['String']>;
  /** Text color as a hexadecimal value (hover state). */
  textColorHover?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1AppEmbedDataCardStyles = {
  /** Content alignment. Defaults to `START`. */
  alignment?: Maybe<WixRichContentV1AppEmbedDataCardStylesAlignment>;
  /** Card background color as a hexadecimal value. */
  backgroundColor?: Maybe<Scalars['String']>;
  /** Card border color as a hexadecimal value. */
  borderColor?: Maybe<Scalars['String']>;
  /** Card border radius in pixels. */
  borderRadius?: Maybe<Scalars['Int']>;
  /** Card border width in pixels. */
  borderWidth?: Maybe<Scalars['Int']>;
  /** Text color as a hexadecimal value. */
  textColor?: Maybe<Scalars['String']>;
  /** Title text color as a hexadecimal value. */
  titleColor?: Maybe<Scalars['String']>;
  /** Layout for title and price. Defaults to `STACKED`. */
  titlePriceLayout?: Maybe<WixRichContentV1AppEmbedDataCardStylesLayout>;
  /** Card type. Defaults to `CONTAINED`. */
  type?: Maybe<WixRichContentV1AppEmbedDataCardStylesType>;
};

export enum WixRichContentV1AppEmbedDataCardStylesAlignment {
  /** Content centered */
  CENTER = 'CENTER',
  /** Content aligned to end (right in LTR layouts, left in RTL layouts) */
  END = 'END',
  /** Content aligned to start (left in LTR layouts, right in RTL layouts) */
  START = 'START'
}

export type WixRichContentV1AppEmbedDataCardStylesInput = {
  /** Content alignment. Defaults to `START`. */
  alignment?: InputMaybe<WixRichContentV1AppEmbedDataCardStylesAlignment>;
  /** Card background color as a hexadecimal value. */
  backgroundColor?: InputMaybe<Scalars['String']>;
  /** Card border color as a hexadecimal value. */
  borderColor?: InputMaybe<Scalars['String']>;
  /** Card border radius in pixels. */
  borderRadius?: InputMaybe<Scalars['Int']>;
  /** Card border width in pixels. */
  borderWidth?: InputMaybe<Scalars['Int']>;
  /** Text color as a hexadecimal value. */
  textColor?: InputMaybe<Scalars['String']>;
  /** Title text color as a hexadecimal value. */
  titleColor?: InputMaybe<Scalars['String']>;
  /** Layout for title and price. Defaults to `STACKED`. */
  titlePriceLayout?: InputMaybe<WixRichContentV1AppEmbedDataCardStylesLayout>;
  /** Card type. Defaults to `CONTAINED`. */
  type?: InputMaybe<WixRichContentV1AppEmbedDataCardStylesType>;
};

export enum WixRichContentV1AppEmbedDataCardStylesLayout {
  /** Elements arranged horizontally */
  SIDE_BY_SIDE = 'SIDE_BY_SIDE',
  /** Elements stacked vertically */
  STACKED = 'STACKED'
}

export enum WixRichContentV1AppEmbedDataCardStylesType {
  /** Card with visible border and background */
  CONTAINED = 'CONTAINED',
  /** Card without visible border */
  FRAMELESS = 'FRAMELESS'
}

export type WixRichContentV1AppEmbedDataEventData = {
  /** Event location. */
  location?: Maybe<Scalars['String']>;
  /** Event schedule. */
  scheduling?: Maybe<Scalars['String']>;
};

export type WixRichContentV1AppEmbedDataEventDataInput = {
  /** Event location. */
  location?: InputMaybe<Scalars['String']>;
  /** Event schedule. */
  scheduling?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1AppEmbedDataImageStyles = {
  /** Aspect ratio for the image. Defaults to `SQUARE`. */
  aspectRatio?: Maybe<WixRichContentV1AppEmbedDataImageStylesAspectRatio>;
  /** Image border color as a hexadecimal value. */
  borderColor?: Maybe<Scalars['String']>;
  /** Image border radius in pixels. */
  borderRadius?: Maybe<Scalars['Int']>;
  /** Image border width in pixels. */
  borderWidth?: Maybe<Scalars['Int']>;
  /** Whether to hide the image. */
  hideImage?: Maybe<Scalars['Boolean']>;
  /** Position of image. Defaults to `START`. */
  imagePosition?: Maybe<WixRichContentV1AppEmbedDataImageStylesPosition>;
  /** How the image should be resized. Defaults to `FILL`. */
  resizing?: Maybe<WixRichContentV1AppEmbedDataImageStylesResizing>;
};

export enum WixRichContentV1AppEmbedDataImageStylesAspectRatio {
  /** 16:9 aspect ratio */
  RECTANGLE = 'RECTANGLE',
  /** 1:1 aspect ratio */
  SQUARE = 'SQUARE'
}

export type WixRichContentV1AppEmbedDataImageStylesInput = {
  /** Aspect ratio for the image. Defaults to `SQUARE`. */
  aspectRatio?: InputMaybe<WixRichContentV1AppEmbedDataImageStylesAspectRatio>;
  /** Image border color as a hexadecimal value. */
  borderColor?: InputMaybe<Scalars['String']>;
  /** Image border radius in pixels. */
  borderRadius?: InputMaybe<Scalars['Int']>;
  /** Image border width in pixels. */
  borderWidth?: InputMaybe<Scalars['Int']>;
  /** Whether to hide the image. */
  hideImage?: InputMaybe<Scalars['Boolean']>;
  /** Position of image. Defaults to `START`. */
  imagePosition?: InputMaybe<WixRichContentV1AppEmbedDataImageStylesPosition>;
  /** How the image should be resized. Defaults to `FILL`. */
  resizing?: InputMaybe<WixRichContentV1AppEmbedDataImageStylesResizing>;
};

export enum WixRichContentV1AppEmbedDataImageStylesPosition {
  /** Image positioned at the end (right in LTR layouts, left in RTL layouts) */
  END = 'END',
  /** Image positioned at the start (left in LTR layouts, right in RTL layouts) */
  START = 'START',
  /** Image positioned at the top */
  TOP = 'TOP'
}

export enum WixRichContentV1AppEmbedDataImageStylesResizing {
  /** Fill the container, may crop the image */
  FILL = 'FILL',
  /** Fit the image within the container */
  FIT = 'FIT'
}

export type WixRichContentV1AppEmbedDataInput = {
  /** Data for embedded Wix Bookings content. */
  bookingData?: InputMaybe<WixRichContentV1AppEmbedDataBookingDataInput>;
  /** Button styling options. */
  buttonStyles?: InputMaybe<WixRichContentV1AppEmbedDataButtonStylesInput>;
  /** Card styling options. */
  cardStyles?: InputMaybe<WixRichContentV1AppEmbedDataCardStylesInput>;
  /** Styling for the app embed's container. */
  containerData?: InputMaybe<WixRichContentV1PluginContainerDataInput>;
  /** Data for embedded Wix Events content. */
  eventData?: InputMaybe<WixRichContentV1AppEmbedDataEventDataInput>;
  /** Whether to hide the button. */
  hideButton?: InputMaybe<Scalars['Boolean']>;
  /** Whether to hide the date and time (Event). */
  hideDateTime?: InputMaybe<Scalars['Boolean']>;
  /** Whether to hide the description (Event and Booking). */
  hideDescription?: InputMaybe<Scalars['Boolean']>;
  /** Whether to hide the duration (Booking). */
  hideDuration?: InputMaybe<Scalars['Boolean']>;
  /** Whether to hide the image. */
  hideImage?: InputMaybe<Scalars['Boolean']>;
  /** Whether to hide the location (Event). */
  hideLocation?: InputMaybe<Scalars['Boolean']>;
  /** Whether to hide the price. */
  hidePrice?: InputMaybe<Scalars['Boolean']>;
  /** Whether to hide the ribbon. */
  hideRibbon?: InputMaybe<Scalars['Boolean']>;
  /** Whether to hide the title. */
  hideTitle?: InputMaybe<Scalars['Boolean']>;
  /** An image for the embedded content. */
  image?: InputMaybe<WixRichContentV1MediaInput>;
  /** Deprecated: Use `image` instead. */
  imageSrc?: InputMaybe<Scalars['String']>;
  /** Image styling options. */
  imageStyles?: InputMaybe<WixRichContentV1AppEmbedDataImageStylesInput>;
  /** The ID of the embedded content. */
  itemId?: InputMaybe<Scalars['String']>;
  /** The name of the embedded content. */
  name?: InputMaybe<Scalars['String']>;
  /** Pricing data for embedded Wix App content. */
  pricingData?: InputMaybe<WixRichContentV1AppEmbedDataPricingDataInput>;
  /** Ribbon styling options. */
  ribbonStyles?: InputMaybe<WixRichContentV1AppEmbedDataRibbonStylesInput>;
  /** The type of Wix App content being embedded. */
  type?: InputMaybe<WixRichContentV1AppEmbedDataAppType>;
  /** The URL for the embedded content. */
  url?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1AppEmbedDataPricingData = {
  /** Currency of the value in ISO 4217 format (e.g., "USD", "EUR"). */
  currency?: Maybe<Scalars['String']>;
  /** Numeric price value as string after discount application (e.g., "15.99"). */
  discountedValue?: Maybe<Scalars['String']>;
  /** Pricing plan ID. */
  pricingPlanId?: Maybe<Scalars['String']>;
  /** Minimum numeric price value as string (e.g., "10.99"). */
  valueFrom?: Maybe<Scalars['String']>;
  /** Maximum numeric price value as string (e.g., "19.99"). */
  valueTo?: Maybe<Scalars['String']>;
};

export type WixRichContentV1AppEmbedDataPricingDataInput = {
  /** Currency of the value in ISO 4217 format (e.g., "USD", "EUR"). */
  currency?: InputMaybe<Scalars['String']>;
  /** Numeric price value as string after discount application (e.g., "15.99"). */
  discountedValue?: InputMaybe<Scalars['String']>;
  /** Pricing plan ID. */
  pricingPlanId?: InputMaybe<Scalars['String']>;
  /** Minimum numeric price value as string (e.g., "10.99"). */
  valueFrom?: InputMaybe<Scalars['String']>;
  /** Maximum numeric price value as string (e.g., "19.99"). */
  valueTo?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1AppEmbedDataRibbonStyles = {
  /** Ribbon background color as a hexadecimal value. */
  backgroundColor?: Maybe<Scalars['String']>;
  /** Ribbon border color as a hexadecimal value. */
  borderColor?: Maybe<Scalars['String']>;
  /** Ribbon border radius in pixels. */
  borderRadius?: Maybe<Scalars['Int']>;
  /** Ribbon border width in pixels. */
  borderWidth?: Maybe<Scalars['Int']>;
  /** Placement of the ribbon. Defaults to `IMAGE`. */
  ribbonPlacement?: Maybe<WixRichContentV1AppEmbedDataRibbonStylesPlacement>;
  /** Text to display on the ribbon. */
  ribbonText?: Maybe<Scalars['String']>;
  /** Ribbon text color as a hexadecimal value. */
  textColor?: Maybe<Scalars['String']>;
};

export type WixRichContentV1AppEmbedDataRibbonStylesInput = {
  /** Ribbon background color as a hexadecimal value. */
  backgroundColor?: InputMaybe<Scalars['String']>;
  /** Ribbon border color as a hexadecimal value. */
  borderColor?: InputMaybe<Scalars['String']>;
  /** Ribbon border radius in pixels. */
  borderRadius?: InputMaybe<Scalars['Int']>;
  /** Ribbon border width in pixels. */
  borderWidth?: InputMaybe<Scalars['Int']>;
  /** Placement of the ribbon. Defaults to `IMAGE`. */
  ribbonPlacement?: InputMaybe<WixRichContentV1AppEmbedDataRibbonStylesPlacement>;
  /** Text to display on the ribbon. */
  ribbonText?: InputMaybe<Scalars['String']>;
  /** Ribbon text color as a hexadecimal value. */
  textColor?: InputMaybe<Scalars['String']>;
};

export enum WixRichContentV1AppEmbedDataRibbonStylesPlacement {
  /** Ribbon placed on the image */
  IMAGE = 'IMAGE',
  /** Ribbon placed on the product information */
  PRODUCT_INFO = 'PRODUCT_INFO'
}

export type WixRichContentV1AudioData = {
  /** Audio file details. */
  audio?: Maybe<WixRichContentV1Media>;
  /** Author name. */
  authorName?: Maybe<Scalars['String']>;
  /** Styling for the audio node's container. */
  containerData?: Maybe<WixRichContentV1PluginContainerData>;
  /** Cover image. */
  coverImage?: Maybe<WixRichContentV1Media>;
  /** Sets whether the audio node's download button is disabled. Defaults to `false`. */
  disableDownload?: Maybe<Scalars['Boolean']>;
  /** An HTML version of the audio node. */
  html?: Maybe<Scalars['String']>;
  /** Track name. */
  name?: Maybe<Scalars['String']>;
};

export type WixRichContentV1AudioDataInput = {
  /** Audio file details. */
  audio?: InputMaybe<WixRichContentV1MediaInput>;
  /** Author name. */
  authorName?: InputMaybe<Scalars['String']>;
  /** Styling for the audio node's container. */
  containerData?: InputMaybe<WixRichContentV1PluginContainerDataInput>;
  /** Cover image. */
  coverImage?: InputMaybe<WixRichContentV1MediaInput>;
  /** Sets whether the audio node's download button is disabled. Defaults to `false`. */
  disableDownload?: InputMaybe<Scalars['Boolean']>;
  /** An HTML version of the audio node. */
  html?: InputMaybe<Scalars['String']>;
  /** Track name. */
  name?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1BlockquoteData = {
  /** Indentation level from 1-4. */
  indentation?: Maybe<Scalars['Int']>;
};

export type WixRichContentV1BlockquoteDataInput = {
  /** Indentation level from 1-4. */
  indentation?: InputMaybe<Scalars['Int']>;
};

export type WixRichContentV1BulletedListData = {
  /** Indentation level from 0-4. */
  indentation?: Maybe<Scalars['Int']>;
  /** Offset level from 0-4. */
  offset?: Maybe<Scalars['Int']>;
};

export type WixRichContentV1BulletedListDataInput = {
  /** Indentation level from 0-4. */
  indentation?: InputMaybe<Scalars['Int']>;
  /** Offset level from 0-4. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type WixRichContentV1ButtonData = {
  /** Styling for the button's container. */
  containerData?: Maybe<WixRichContentV1PluginContainerData>;
  /** Button link details. */
  link?: Maybe<WixRichContentV1Link>;
  /** Styling for the button. */
  styles?: Maybe<WixRichContentV1ButtonDataStyles>;
  /** The text to display on the button. */
  text?: Maybe<Scalars['String']>;
  /** The button type. */
  type?: Maybe<WixRichContentV1ButtonDataType>;
};

export type WixRichContentV1ButtonDataInput = {
  /** Styling for the button's container. */
  containerData?: InputMaybe<WixRichContentV1PluginContainerDataInput>;
  /** Button link details. */
  link?: InputMaybe<WixRichContentV1LinkInput>;
  /** Styling for the button. */
  styles?: InputMaybe<WixRichContentV1ButtonDataStylesInput>;
  /** The text to display on the button. */
  text?: InputMaybe<Scalars['String']>;
  /** The button type. */
  type?: InputMaybe<WixRichContentV1ButtonDataType>;
};

export type WixRichContentV1ButtonDataStyles = {
  /** Background color as a hexadecimal value. */
  backgroundColor?: Maybe<Scalars['String']>;
  /** Background color as a hexadecimal value (hover state). */
  backgroundColorHover?: Maybe<Scalars['String']>;
  /** Deprecated: Use `borderWidth` and `borderRadius` instead. */
  border?: Maybe<WixRichContentV1ButtonDataStylesBorder>;
  /** Border color as a hexadecimal value. */
  borderColor?: Maybe<Scalars['String']>;
  /** Border color as a hexadecimal value (hover state). */
  borderColorHover?: Maybe<Scalars['String']>;
  /** Border radius in pixels. */
  borderRadius?: Maybe<Scalars['Int']>;
  /** Border width in pixels. */
  borderWidth?: Maybe<Scalars['Int']>;
  /** Deprecated: Use `borderWidth` for normal/hover states instead. */
  borderWidthHover?: Maybe<Scalars['Int']>;
  /** Button size option, one of `SMALL`, `MEDIUM` or `LARGE`. Defaults to `MEDIUM`. */
  buttonSize?: Maybe<Scalars['String']>;
  /** Deprecated: Use `textColor`, `borderColor` and `backgroundColor` instead. */
  colors?: Maybe<WixRichContentV1ButtonDataStylesColors>;
  /** Text color as a hexadecimal value. */
  textColor?: Maybe<Scalars['String']>;
  /** Text color as a hexadecimal value (hover state). */
  textColorHover?: Maybe<Scalars['String']>;
};

export type WixRichContentV1ButtonDataStylesBorder = {
  /** Deprecated: Use `borderRadius` in `styles` instead. */
  radius?: Maybe<Scalars['Int']>;
  /** Deprecated: Use `borderWidth` in `styles` instead. */
  width?: Maybe<Scalars['Int']>;
};

export type WixRichContentV1ButtonDataStylesBorderInput = {
  /** Deprecated: Use `borderRadius` in `styles` instead. */
  radius?: InputMaybe<Scalars['Int']>;
  /** Deprecated: Use `borderWidth` in `styles` instead. */
  width?: InputMaybe<Scalars['Int']>;
};

export type WixRichContentV1ButtonDataStylesColors = {
  /** Deprecated: Use `backgroundColor` in `styles` instead. */
  background?: Maybe<Scalars['String']>;
  /** Deprecated: Use `borderColor` in `styles` instead. */
  border?: Maybe<Scalars['String']>;
  /** Deprecated: Use `textColor` in `styles` instead. */
  text?: Maybe<Scalars['String']>;
};

export type WixRichContentV1ButtonDataStylesColorsInput = {
  /** Deprecated: Use `backgroundColor` in `styles` instead. */
  background?: InputMaybe<Scalars['String']>;
  /** Deprecated: Use `borderColor` in `styles` instead. */
  border?: InputMaybe<Scalars['String']>;
  /** Deprecated: Use `textColor` in `styles` instead. */
  text?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1ButtonDataStylesInput = {
  /** Background color as a hexadecimal value. */
  backgroundColor?: InputMaybe<Scalars['String']>;
  /** Background color as a hexadecimal value (hover state). */
  backgroundColorHover?: InputMaybe<Scalars['String']>;
  /** Deprecated: Use `borderWidth` and `borderRadius` instead. */
  border?: InputMaybe<WixRichContentV1ButtonDataStylesBorderInput>;
  /** Border color as a hexadecimal value. */
  borderColor?: InputMaybe<Scalars['String']>;
  /** Border color as a hexadecimal value (hover state). */
  borderColorHover?: InputMaybe<Scalars['String']>;
  /** Border radius in pixels. */
  borderRadius?: InputMaybe<Scalars['Int']>;
  /** Border width in pixels. */
  borderWidth?: InputMaybe<Scalars['Int']>;
  /** Deprecated: Use `borderWidth` for normal/hover states instead. */
  borderWidthHover?: InputMaybe<Scalars['Int']>;
  /** Button size option, one of `SMALL`, `MEDIUM` or `LARGE`. Defaults to `MEDIUM`. */
  buttonSize?: InputMaybe<Scalars['String']>;
  /** Deprecated: Use `textColor`, `borderColor` and `backgroundColor` instead. */
  colors?: InputMaybe<WixRichContentV1ButtonDataStylesColorsInput>;
  /** Text color as a hexadecimal value. */
  textColor?: InputMaybe<Scalars['String']>;
  /** Text color as a hexadecimal value (hover state). */
  textColorHover?: InputMaybe<Scalars['String']>;
};

export enum WixRichContentV1ButtonDataType {
  /** Triggers custom action that is defined in plugin configuration by the consumer */
  ACTION = 'ACTION',
  /** Regular link button */
  LINK = 'LINK'
}

export type WixRichContentV1CaptionData = {
  textStyle?: Maybe<WixRichContentV1TextStyle>;
};

export type WixRichContentV1CaptionDataInput = {
  textStyle?: InputMaybe<WixRichContentV1TextStyleInput>;
};

export type WixRichContentV1CodeBlockData = {
  /** Styling for the code block's text. */
  textStyle?: Maybe<WixRichContentV1TextStyle>;
};

export type WixRichContentV1CodeBlockDataInput = {
  /** Styling for the code block's text. */
  textStyle?: InputMaybe<WixRichContentV1TextStyleInput>;
};

export type WixRichContentV1CollapsibleListData = {
  /** Styling for the collapsible list's container. */
  containerData?: Maybe<WixRichContentV1PluginContainerData>;
  /** The direction of the text in the list. Either left-to-right or right-to-left. */
  direction?: Maybe<WixRichContentV1CollapsibleListDataDirection>;
  /** If `true`, only one item can be expanded at a time. Defaults to `false`. */
  expandOnlyOne?: Maybe<Scalars['Boolean']>;
  /** Sets which items are expanded when the page loads. */
  initialExpandedItems?: Maybe<WixRichContentV1CollapsibleListDataInitialExpandedItems>;
  /** If `true`, The collapsible item will appear in search results as an FAQ. */
  isQapageData?: Maybe<Scalars['Boolean']>;
};

export enum WixRichContentV1CollapsibleListDataDirection {
  /** Left-to-right */
  LTR = 'LTR',
  /** Right-to-left */
  RTL = 'RTL'
}

export enum WixRichContentV1CollapsibleListDataInitialExpandedItems {
  /** All items will expended initally */
  ALL = 'ALL',
  /** First item will be expended initally */
  FIRST = 'FIRST',
  /** All items collapsed initally */
  NONE = 'NONE'
}

export type WixRichContentV1CollapsibleListDataInput = {
  /** Styling for the collapsible list's container. */
  containerData?: InputMaybe<WixRichContentV1PluginContainerDataInput>;
  /** The direction of the text in the list. Either left-to-right or right-to-left. */
  direction?: InputMaybe<WixRichContentV1CollapsibleListDataDirection>;
  /** If `true`, only one item can be expanded at a time. Defaults to `false`. */
  expandOnlyOne?: InputMaybe<Scalars['Boolean']>;
  /** Sets which items are expanded when the page loads. */
  initialExpandedItems?: InputMaybe<WixRichContentV1CollapsibleListDataInitialExpandedItems>;
  /** If `true`, The collapsible item will appear in search results as an FAQ. */
  isQapageData?: InputMaybe<Scalars['Boolean']>;
};

export type WixRichContentV1ColorData = {
  /** The text's background color as a hexadecimal value. */
  background?: Maybe<Scalars['String']>;
  /** The text's foreground color as a hexadecimal value. */
  foreground?: Maybe<Scalars['String']>;
};

export type WixRichContentV1ColorDataInput = {
  /** The text's background color as a hexadecimal value. */
  background?: InputMaybe<Scalars['String']>;
  /** The text's foreground color as a hexadecimal value. */
  foreground?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1Decoration = {
  /** Data for an anchor link decoration. */
  anchorData?: Maybe<WixRichContentV1AnchorData>;
  /** Data for a color decoration. */
  colorData?: Maybe<WixRichContentV1ColorData>;
  /** Data for a font family decoration. */
  fontFamilyData?: Maybe<WixRichContentV1FontFamilyData>;
  /** Data for a font size decoration. */
  fontSizeData?: Maybe<WixRichContentV1FontSizeData>;
  /** Font weight for a bold decoration. */
  fontWeightValue?: Maybe<Scalars['Int']>;
  /** Data for an italic decoration. Defaults to `true`. */
  italicData?: Maybe<Scalars['Boolean']>;
  /** Data for an external link decoration. */
  linkData?: Maybe<WixRichContentV1LinkData>;
  /** Data for a mention decoration. */
  mentionData?: Maybe<WixRichContentV1MentionData>;
  /** Data for a spoiler decoration. */
  spoilerData?: Maybe<WixRichContentV1SpoilerData>;
  /** Data for a strikethrough decoration. Defaults to `true`. */
  strikethroughData?: Maybe<Scalars['Boolean']>;
  /** Data for a subscript decoration. Defaults to `true`. */
  subscriptData?: Maybe<Scalars['Boolean']>;
  /** Data for a superscript decoration. Defaults to `true`. */
  superscriptData?: Maybe<Scalars['Boolean']>;
  /** The type of decoration to apply. */
  type?: Maybe<WixRichContentV1DecorationType>;
  /** Data for an underline decoration. Defaults to `true`. */
  underlineData?: Maybe<Scalars['Boolean']>;
};

export type WixRichContentV1DecorationInput = {
  /** Data for an anchor link decoration. */
  anchorData?: InputMaybe<WixRichContentV1AnchorDataInput>;
  /** Data for a color decoration. */
  colorData?: InputMaybe<WixRichContentV1ColorDataInput>;
  /** Data for a font family decoration. */
  fontFamilyData?: InputMaybe<WixRichContentV1FontFamilyDataInput>;
  /** Data for a font size decoration. */
  fontSizeData?: InputMaybe<WixRichContentV1FontSizeDataInput>;
  /** Font weight for a bold decoration. */
  fontWeightValue?: InputMaybe<Scalars['Int']>;
  /** Data for an italic decoration. Defaults to `true`. */
  italicData?: InputMaybe<Scalars['Boolean']>;
  /** Data for an external link decoration. */
  linkData?: InputMaybe<WixRichContentV1LinkDataInput>;
  /** Data for a mention decoration. */
  mentionData?: InputMaybe<WixRichContentV1MentionDataInput>;
  /** Data for a spoiler decoration. */
  spoilerData?: InputMaybe<WixRichContentV1SpoilerDataInput>;
  /** Data for a strikethrough decoration. Defaults to `true`. */
  strikethroughData?: InputMaybe<Scalars['Boolean']>;
  /** Data for a subscript decoration. Defaults to `true`. */
  subscriptData?: InputMaybe<Scalars['Boolean']>;
  /** Data for a superscript decoration. Defaults to `true`. */
  superscriptData?: InputMaybe<Scalars['Boolean']>;
  /** The type of decoration to apply. */
  type?: InputMaybe<WixRichContentV1DecorationType>;
  /** Data for an underline decoration. Defaults to `true`. */
  underlineData?: InputMaybe<Scalars['Boolean']>;
};

export enum WixRichContentV1DecorationType {
  ANCHOR = 'ANCHOR',
  BOLD = 'BOLD',
  COLOR = 'COLOR',
  EXTERNAL = 'EXTERNAL',
  FONT_FAMILY = 'FONT_FAMILY',
  FONT_SIZE = 'FONT_SIZE',
  ITALIC = 'ITALIC',
  LINK = 'LINK',
  MENTION = 'MENTION',
  SPOILER = 'SPOILER',
  STRIKETHROUGH = 'STRIKETHROUGH',
  SUBSCRIPT = 'SUBSCRIPT',
  SUPERSCRIPT = 'SUPERSCRIPT',
  UNDERLINE = 'UNDERLINE'
}

export type WixRichContentV1DividerData = {
  /** Divider alignment. */
  alignment?: Maybe<WixRichContentV1DividerDataAlignment>;
  /** Styling for the divider's container. */
  containerData?: Maybe<WixRichContentV1PluginContainerData>;
  /** Divider line style. */
  lineStyle?: Maybe<WixRichContentV1DividerDataLineStyle>;
  /** Divider width. */
  width?: Maybe<WixRichContentV1DividerDataWidth>;
};

export enum WixRichContentV1DividerDataAlignment {
  /** Center alignment */
  CENTER = 'CENTER',
  /** Left alignment */
  LEFT = 'LEFT',
  /** Right alignment */
  RIGHT = 'RIGHT'
}

export type WixRichContentV1DividerDataInput = {
  /** Divider alignment. */
  alignment?: InputMaybe<WixRichContentV1DividerDataAlignment>;
  /** Styling for the divider's container. */
  containerData?: InputMaybe<WixRichContentV1PluginContainerDataInput>;
  /** Divider line style. */
  lineStyle?: InputMaybe<WixRichContentV1DividerDataLineStyle>;
  /** Divider width. */
  width?: InputMaybe<WixRichContentV1DividerDataWidth>;
};

export enum WixRichContentV1DividerDataLineStyle {
  /** Dashed Line */
  DASHED = 'DASHED',
  /** Dotted Line */
  DOTTED = 'DOTTED',
  /** Double Line */
  DOUBLE = 'DOUBLE',
  /** Single Line */
  SINGLE = 'SINGLE'
}

export enum WixRichContentV1DividerDataWidth {
  /** Large line */
  LARGE = 'LARGE',
  /** Medium line */
  MEDIUM = 'MEDIUM',
  /** Small line */
  SMALL = 'SMALL'
}

export type WixRichContentV1DocumentStyle = {
  /** Styling for block quote nodes. */
  blockquote?: Maybe<WixRichContentV1TextNodeStyle>;
  /** Styling for code block nodes. */
  codeBlock?: Maybe<WixRichContentV1TextNodeStyle>;
  /** Styling for H5 nodes. */
  headerFive?: Maybe<WixRichContentV1TextNodeStyle>;
  /** Styling for H4 nodes. */
  headerFour?: Maybe<WixRichContentV1TextNodeStyle>;
  /** Styling for H1 nodes. */
  headerOne?: Maybe<WixRichContentV1TextNodeStyle>;
  /** Styling for H6 nodes. */
  headerSix?: Maybe<WixRichContentV1TextNodeStyle>;
  /** Styling for H3 nodes. */
  headerThree?: Maybe<WixRichContentV1TextNodeStyle>;
  /** Styling for H2 nodes. */
  headerTwo?: Maybe<WixRichContentV1TextNodeStyle>;
  /** Styling for paragraph nodes. */
  paragraph?: Maybe<WixRichContentV1TextNodeStyle>;
};

export type WixRichContentV1DocumentStyleInput = {
  /** Styling for block quote nodes. */
  blockquote?: InputMaybe<WixRichContentV1TextNodeStyleInput>;
  /** Styling for code block nodes. */
  codeBlock?: InputMaybe<WixRichContentV1TextNodeStyleInput>;
  /** Styling for H5 nodes. */
  headerFive?: InputMaybe<WixRichContentV1TextNodeStyleInput>;
  /** Styling for H4 nodes. */
  headerFour?: InputMaybe<WixRichContentV1TextNodeStyleInput>;
  /** Styling for H1 nodes. */
  headerOne?: InputMaybe<WixRichContentV1TextNodeStyleInput>;
  /** Styling for H6 nodes. */
  headerSix?: InputMaybe<WixRichContentV1TextNodeStyleInput>;
  /** Styling for H3 nodes. */
  headerThree?: InputMaybe<WixRichContentV1TextNodeStyleInput>;
  /** Styling for H2 nodes. */
  headerTwo?: InputMaybe<WixRichContentV1TextNodeStyleInput>;
  /** Styling for paragraph nodes. */
  paragraph?: InputMaybe<WixRichContentV1TextNodeStyleInput>;
};

export type WixRichContentV1EmbedData = {
  /** Styling for the oEmbed node's container. */
  containerData?: Maybe<WixRichContentV1PluginContainerData>;
  /** An [oEmbed](https://www.oembed.com) object. */
  oembed?: Maybe<WixRichContentV1Oembed>;
  /** Origin asset source. */
  src?: Maybe<Scalars['String']>;
};

export type WixRichContentV1EmbedDataInput = {
  /** Styling for the oEmbed node's container. */
  containerData?: InputMaybe<WixRichContentV1PluginContainerDataInput>;
  /** An [oEmbed](https://www.oembed.com) object. */
  oembed?: InputMaybe<WixRichContentV1OembedInput>;
  /** Origin asset source. */
  src?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1FileData = {
  /** Styling for the file's container. */
  containerData?: Maybe<WixRichContentV1PluginContainerData>;
  /** File MIME type. */
  mimeType?: Maybe<Scalars['String']>;
  /** File name. */
  name?: Maybe<Scalars['String']>;
  /** File path. */
  path?: Maybe<Scalars['String']>;
  /** Settings for PDF files. */
  pdfSettings?: Maybe<WixRichContentV1FileDataPdfSettings>;
  /** Use `sizeInKb` instead. */
  size?: Maybe<Scalars['Int']>;
  /** File size in KB. */
  sizeInKb?: Maybe<Scalars['String']>;
  /** The source for the file's data. */
  src?: Maybe<WixRichContentV1FileSource>;
  /** File type. */
  type?: Maybe<Scalars['String']>;
};

export type WixRichContentV1FileDataInput = {
  /** Styling for the file's container. */
  containerData?: InputMaybe<WixRichContentV1PluginContainerDataInput>;
  /** File MIME type. */
  mimeType?: InputMaybe<Scalars['String']>;
  /** File name. */
  name?: InputMaybe<Scalars['String']>;
  /** File path. */
  path?: InputMaybe<Scalars['String']>;
  /** Settings for PDF files. */
  pdfSettings?: InputMaybe<WixRichContentV1FileDataPdfSettingsInput>;
  /** Use `sizeInKb` instead. */
  size?: InputMaybe<Scalars['Int']>;
  /** File size in KB. */
  sizeInKb?: InputMaybe<Scalars['String']>;
  /** The source for the file's data. */
  src?: InputMaybe<WixRichContentV1FileSourceInput>;
  /** File type. */
  type?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1FileDataPdfSettings = {
  /** Sets whether the PDF download button is disabled. Defaults to `false`. */
  disableDownload?: Maybe<Scalars['Boolean']>;
  /** Sets whether the PDF print button is disabled. Defaults to `false`. */
  disablePrint?: Maybe<Scalars['Boolean']>;
  /**
   * PDF view mode. One of the following:
   * `NONE` : The PDF isn't displayed.
   * `FULL` : A full page view of the PDF is displayed.
   * `MINI` : A mini view of the PDF is displayed.
   */
  viewMode?: Maybe<WixRichContentV1FileDataPdfSettingsViewMode>;
};

export type WixRichContentV1FileDataPdfSettingsInput = {
  /** Sets whether the PDF download button is disabled. Defaults to `false`. */
  disableDownload?: InputMaybe<Scalars['Boolean']>;
  /** Sets whether the PDF print button is disabled. Defaults to `false`. */
  disablePrint?: InputMaybe<Scalars['Boolean']>;
  /**
   * PDF view mode. One of the following:
   * `NONE` : The PDF isn't displayed.
   * `FULL` : A full page view of the PDF is displayed.
   * `MINI` : A mini view of the PDF is displayed.
   */
  viewMode?: InputMaybe<WixRichContentV1FileDataPdfSettingsViewMode>;
};

export enum WixRichContentV1FileDataPdfSettingsViewMode {
  /** Full PDF view */
  FULL = 'FULL',
  /** Mini PDF view */
  MINI = 'MINI',
  /** No PDF view */
  NONE = 'NONE'
}

export type WixRichContentV1FileSource = {
  /** Custom ID. Use `id` instead. */
  custom?: Maybe<Scalars['String']>;
  /** An ID that's resolved to a URL by a resolver function. */
  id?: Maybe<Scalars['String']>;
  /** Indicates whether the file's source is private. Defaults to `false`. */
  private?: Maybe<Scalars['Boolean']>;
  /** The absolute URL for the file's source. */
  url?: Maybe<Scalars['String']>;
};

export type WixRichContentV1FileSourceInput = {
  /** Custom ID. Use `id` instead. */
  custom?: InputMaybe<Scalars['String']>;
  /** An ID that's resolved to a URL by a resolver function. */
  id?: InputMaybe<Scalars['String']>;
  /** Indicates whether the file's source is private. Defaults to `false`. */
  private?: InputMaybe<Scalars['Boolean']>;
  /** The absolute URL for the file's source. */
  url?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1FontFamilyData = {
  value?: Maybe<Scalars['String']>;
};

export type WixRichContentV1FontFamilyDataInput = {
  value?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1FontSizeData = {
  /** The units used for the font size. */
  unit?: Maybe<WixRichContentV1FontSizeDatafontType>;
  /** Font size value. */
  value?: Maybe<Scalars['Int']>;
};

export type WixRichContentV1FontSizeDataInput = {
  /** The units used for the font size. */
  unit?: InputMaybe<WixRichContentV1FontSizeDatafontType>;
  /** Font size value. */
  value?: InputMaybe<Scalars['Int']>;
};

export enum WixRichContentV1FontSizeDatafontType {
  EM = 'EM',
  PX = 'PX'
}

export type WixRichContentV1Gif = {
  /** GIF format URL. */
  gif?: Maybe<Scalars['String']>;
  /** MP4 format URL. */
  mp4?: Maybe<Scalars['String']>;
  /** Thumbnail URL. */
  still?: Maybe<Scalars['String']>;
};

export type WixRichContentV1GifData = {
  /** Styling for the GIF's container. */
  containerData?: Maybe<WixRichContentV1PluginContainerData>;
  /** The source of the downsized GIF. */
  downsized?: Maybe<WixRichContentV1Gif>;
  /** Type of GIF (Sticker or NORMAL). Defaults to `NORMAL`. */
  gifType?: Maybe<WixRichContentV1GifDataGifType>;
  /** Height in pixels. */
  height?: Maybe<Scalars['Int']>;
  /** The source of the full size GIF. */
  original?: Maybe<WixRichContentV1Gif>;
  /** Width in pixels. */
  width?: Maybe<Scalars['Int']>;
};

export type WixRichContentV1GifDataInput = {
  /** Styling for the GIF's container. */
  containerData?: InputMaybe<WixRichContentV1PluginContainerDataInput>;
  /** The source of the downsized GIF. */
  downsized?: InputMaybe<WixRichContentV1GifInput>;
  /** Type of GIF (Sticker or NORMAL). Defaults to `NORMAL`. */
  gifType?: InputMaybe<WixRichContentV1GifDataGifType>;
  /** Height in pixels. */
  height?: InputMaybe<Scalars['Int']>;
  /** The source of the full size GIF. */
  original?: InputMaybe<WixRichContentV1GifInput>;
  /** Width in pixels. */
  width?: InputMaybe<Scalars['Int']>;
};

export type WixRichContentV1GifInput = {
  /** GIF format URL. */
  gif?: InputMaybe<Scalars['String']>;
  /** MP4 format URL. */
  mp4?: InputMaybe<Scalars['String']>;
  /** Thumbnail URL. */
  still?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1GalleryData = {
  /** Styling for the gallery's container. */
  containerData?: Maybe<WixRichContentV1PluginContainerData>;
  /** Sets whether the gallery's download button is disabled. Defaults to `false`. */
  disableDownload?: Maybe<Scalars['Boolean']>;
  /** Sets whether the gallery's expand button is disabled. Defaults to `false`. */
  disableExpand?: Maybe<Scalars['Boolean']>;
  /** The items in the gallery. */
  items?: Maybe<Array<Maybe<WixRichContentV1GalleryDataItem>>>;
  /** Options for defining the gallery's appearance. */
  options?: Maybe<WixRichContentV1GalleryOptions>;
};

export type WixRichContentV1GalleryDataInput = {
  /** Styling for the gallery's container. */
  containerData?: InputMaybe<WixRichContentV1PluginContainerDataInput>;
  /** Sets whether the gallery's download button is disabled. Defaults to `false`. */
  disableDownload?: InputMaybe<Scalars['Boolean']>;
  /** Sets whether the gallery's expand button is disabled. Defaults to `false`. */
  disableExpand?: InputMaybe<Scalars['Boolean']>;
  /** The items in the gallery. */
  items?: InputMaybe<Array<InputMaybe<WixRichContentV1GalleryDataItemInput>>>;
  /** Options for defining the gallery's appearance. */
  options?: InputMaybe<WixRichContentV1GalleryOptionsInput>;
};

export type WixRichContentV1GalleryDataItem = {
  /** Item's alternative text. */
  altText?: Maybe<Scalars['String']>;
  /** An image item. */
  image?: Maybe<WixRichContentV1GalleryDataItemImage>;
  /** Item title. */
  title?: Maybe<Scalars['String']>;
  /** A video item. */
  video?: Maybe<WixRichContentV1GalleryDataItemVideo>;
};

export type WixRichContentV1GalleryDataItemImage = {
  /** Link details for images that are links. */
  link?: Maybe<WixRichContentV1Link>;
  /** Image file details. */
  media?: Maybe<WixRichContentV1Media>;
};

export type WixRichContentV1GalleryDataItemImageInput = {
  /** Link details for images that are links. */
  link?: InputMaybe<WixRichContentV1LinkInput>;
  /** Image file details. */
  media?: InputMaybe<WixRichContentV1MediaInput>;
};

export type WixRichContentV1GalleryDataItemInput = {
  /** Item's alternative text. */
  altText?: InputMaybe<Scalars['String']>;
  /** An image item. */
  image?: InputMaybe<WixRichContentV1GalleryDataItemImageInput>;
  /** Item title. */
  title?: InputMaybe<Scalars['String']>;
  /** A video item. */
  video?: InputMaybe<WixRichContentV1GalleryDataItemVideoInput>;
};

export type WixRichContentV1GalleryDataItemVideo = {
  /** Video file details. */
  media?: Maybe<WixRichContentV1Media>;
  /** Video thumbnail file details. */
  thumbnail?: Maybe<WixRichContentV1Media>;
};

export type WixRichContentV1GalleryDataItemVideoInput = {
  /** Video file details. */
  media?: InputMaybe<WixRichContentV1MediaInput>;
  /** Video thumbnail file details. */
  thumbnail?: InputMaybe<WixRichContentV1MediaInput>;
};

export type WixRichContentV1GalleryOptions = {
  /** Styling for gallery items. */
  item?: Maybe<WixRichContentV1GalleryOptionsItemStyle>;
  /** Gallery layout. */
  layout?: Maybe<WixRichContentV1GalleryOptionsLayout>;
  /** Styling for gallery thumbnail images. */
  thumbnails?: Maybe<WixRichContentV1GalleryOptionsThumbnails>;
};

export type WixRichContentV1GalleryOptionsInput = {
  /** Styling for gallery items. */
  item?: InputMaybe<WixRichContentV1GalleryOptionsItemStyleInput>;
  /** Gallery layout. */
  layout?: InputMaybe<WixRichContentV1GalleryOptionsLayoutInput>;
  /** Styling for gallery thumbnail images. */
  thumbnails?: InputMaybe<WixRichContentV1GalleryOptionsThumbnailsInput>;
};

export type WixRichContentV1GalleryOptionsItemStyle = {
  /** Sets how item images are cropped. */
  crop?: Maybe<WixRichContentV1GalleryOptionsItemStyleCrop>;
  /** Item ratio */
  ratio?: Maybe<Scalars['Float']>;
  /** The spacing between items in pixels. */
  spacing?: Maybe<Scalars['Int']>;
  /** Desirable dimension for each item in pixels (behvaior changes according to gallery type) */
  targetSize?: Maybe<Scalars['Int']>;
};

export enum WixRichContentV1GalleryOptionsItemStyleCrop {
  /** Crop to fill */
  FILL = 'FILL',
  /** Crop to fit */
  FIT = 'FIT'
}

export type WixRichContentV1GalleryOptionsItemStyleInput = {
  /** Sets how item images are cropped. */
  crop?: InputMaybe<WixRichContentV1GalleryOptionsItemStyleCrop>;
  /** Item ratio */
  ratio?: InputMaybe<Scalars['Float']>;
  /** The spacing between items in pixels. */
  spacing?: InputMaybe<Scalars['Int']>;
  /** Desirable dimension for each item in pixels (behvaior changes according to gallery type) */
  targetSize?: InputMaybe<Scalars['Int']>;
};

export type WixRichContentV1GalleryOptionsLayout = {
  /** Sets whether horizontal scroll is enabled. Defaults to `true` unless the layout `type` is set to `GRID` or `COLLAGE`. */
  horizontalScroll?: Maybe<Scalars['Boolean']>;
  /** The number of columns to display on mobile screens. */
  mobileNumberOfColumns?: Maybe<Scalars['Int']>;
  /** The number of columns to display on full size screens. */
  numberOfColumns?: Maybe<Scalars['Int']>;
  /** Gallery orientation. */
  orientation?: Maybe<WixRichContentV1GalleryOptionsLayoutOrientation>;
  /** Gallery layout type. */
  type?: Maybe<WixRichContentV1GalleryOptionsLayoutType>;
};

export type WixRichContentV1GalleryOptionsLayoutInput = {
  /** Sets whether horizontal scroll is enabled. Defaults to `true` unless the layout `type` is set to `GRID` or `COLLAGE`. */
  horizontalScroll?: InputMaybe<Scalars['Boolean']>;
  /** The number of columns to display on mobile screens. */
  mobileNumberOfColumns?: InputMaybe<Scalars['Int']>;
  /** The number of columns to display on full size screens. */
  numberOfColumns?: InputMaybe<Scalars['Int']>;
  /** Gallery orientation. */
  orientation?: InputMaybe<WixRichContentV1GalleryOptionsLayoutOrientation>;
  /** Gallery layout type. */
  type?: InputMaybe<WixRichContentV1GalleryOptionsLayoutType>;
};

export enum WixRichContentV1GalleryOptionsLayoutOrientation {
  /** Columns Orientation */
  COLUMNS = 'COLUMNS',
  /** Rows Orientation */
  ROWS = 'ROWS'
}

export enum WixRichContentV1GalleryOptionsLayoutType {
  /** Collage type */
  COLLAGE = 'COLLAGE',
  /** Column type */
  COLUMN = 'COLUMN',
  /** Fullsize images type */
  FULLSIZE = 'FULLSIZE',
  /** Grid type */
  GRID = 'GRID',
  /** Magic type */
  MAGIC = 'MAGIC',
  /** Masonry type */
  MASONRY = 'MASONRY',
  /** Panorama type */
  PANORAMA = 'PANORAMA',
  /** Slider type */
  SLIDER = 'SLIDER',
  /** Slideshow type */
  SLIDESHOW = 'SLIDESHOW',
  /** Thumbnail type */
  THUMBNAIL = 'THUMBNAIL'
}

export type WixRichContentV1GalleryOptionsThumbnails = {
  /** Thumbnail alignment. */
  placement?: Maybe<WixRichContentV1GalleryOptionsThumbnailsAlignment>;
  /** Spacing between thumbnails in pixels. */
  spacing?: Maybe<Scalars['Int']>;
};

export enum WixRichContentV1GalleryOptionsThumbnailsAlignment {
  /** Bottom alignment */
  BOTTOM = 'BOTTOM',
  /** Left alignment */
  LEFT = 'LEFT',
  /** No thumbnail */
  NONE = 'NONE',
  /** Right alignment */
  RIGHT = 'RIGHT',
  /** Top alignment */
  TOP = 'TOP'
}

export type WixRichContentV1GalleryOptionsThumbnailsInput = {
  /** Thumbnail alignment. */
  placement?: InputMaybe<WixRichContentV1GalleryOptionsThumbnailsAlignment>;
  /** Spacing between thumbnails in pixels. */
  spacing?: InputMaybe<Scalars['Int']>;
};

export enum WixRichContentV1GifDataGifType {
  NORMAL = 'NORMAL',
  STICKER = 'STICKER'
}

export type WixRichContentV1HtmlData = {
  /** If container height is aligned with its content height. Defaults to `true`. */
  autoHeight?: Maybe<Scalars['Boolean']>;
  /** Styling for the HTML node's container. Height property is irrelevant for HTML embeds when autoHeight is set to `true`. */
  containerData?: Maybe<WixRichContentV1PluginContainerData>;
  /** The HTML code for the node. */
  html?: Maybe<Scalars['String']>;
  /** Whether this is an AdSense element. Use `source` instead. */
  isAdsense?: Maybe<Scalars['Boolean']>;
  /** The type of HTML code. */
  source?: Maybe<WixRichContentV1HtmlDataSource>;
  /** The URL for the HTML code for the node. */
  url?: Maybe<Scalars['String']>;
};

export type WixRichContentV1HtmlDataInput = {
  /** If container height is aligned with its content height. Defaults to `true`. */
  autoHeight?: InputMaybe<Scalars['Boolean']>;
  /** Styling for the HTML node's container. Height property is irrelevant for HTML embeds when autoHeight is set to `true`. */
  containerData?: InputMaybe<WixRichContentV1PluginContainerDataInput>;
  /** The HTML code for the node. */
  html?: InputMaybe<Scalars['String']>;
  /** Whether this is an AdSense element. Use `source` instead. */
  isAdsense?: InputMaybe<Scalars['Boolean']>;
  /** The type of HTML code. */
  source?: InputMaybe<WixRichContentV1HtmlDataSource>;
  /** The URL for the HTML code for the node. */
  url?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1HeadingData = {
  /** Indentation level from 1-4. */
  indentation?: Maybe<Scalars['Int']>;
  /** Heading level from 1-6. */
  level?: Maybe<Scalars['Int']>;
  /** Styling for the heading text. */
  textStyle?: Maybe<WixRichContentV1TextStyle>;
};

export type WixRichContentV1HeadingDataInput = {
  /** Indentation level from 1-4. */
  indentation?: InputMaybe<Scalars['Int']>;
  /** Heading level from 1-6. */
  level?: InputMaybe<Scalars['Int']>;
  /** Styling for the heading text. */
  textStyle?: InputMaybe<WixRichContentV1TextStyleInput>;
};

export enum WixRichContentV1HtmlDataSource {
  ADSENSE = 'ADSENSE',
  AI = 'AI',
  HTML = 'HTML'
}

export type WixRichContentV1ImageData = {
  /** Image's alternative text. */
  altText?: Maybe<Scalars['String']>;
  /** Deprecated: use Caption node instead. */
  caption?: Maybe<Scalars['String']>;
  /** Styling for the image's container. */
  containerData?: Maybe<WixRichContentV1PluginContainerData>;
  /** Sets whether the image is decorative and does not need an explanation. Defaults to `false`. */
  decorative?: Maybe<Scalars['Boolean']>;
  /** Sets whether the image's download button is disabled. Defaults to `false`. */
  disableDownload?: Maybe<Scalars['Boolean']>;
  /** Sets whether the image expands to full screen when clicked. Defaults to `false`. */
  disableExpand?: Maybe<Scalars['Boolean']>;
  /** Image file details. */
  image?: Maybe<WixRichContentV1Media>;
  /** Link details for images that are links. */
  link?: Maybe<WixRichContentV1Link>;
  /** Styling for the image. */
  styles?: Maybe<WixRichContentV1ImageDataStyles>;
};

export type WixRichContentV1ImageDataInput = {
  /** Image's alternative text. */
  altText?: InputMaybe<Scalars['String']>;
  /** Deprecated: use Caption node instead. */
  caption?: InputMaybe<Scalars['String']>;
  /** Styling for the image's container. */
  containerData?: InputMaybe<WixRichContentV1PluginContainerDataInput>;
  /** Sets whether the image is decorative and does not need an explanation. Defaults to `false`. */
  decorative?: InputMaybe<Scalars['Boolean']>;
  /** Sets whether the image's download button is disabled. Defaults to `false`. */
  disableDownload?: InputMaybe<Scalars['Boolean']>;
  /** Sets whether the image expands to full screen when clicked. Defaults to `false`. */
  disableExpand?: InputMaybe<Scalars['Boolean']>;
  /** Image file details. */
  image?: InputMaybe<WixRichContentV1MediaInput>;
  /** Link details for images that are links. */
  link?: InputMaybe<WixRichContentV1LinkInput>;
  /** Styling for the image. */
  styles?: InputMaybe<WixRichContentV1ImageDataStylesInput>;
};

export type WixRichContentV1ImageDataStyles = {
  /** Border attributes. */
  border?: Maybe<WixRichContentV1ImageDataStylesBorder>;
};

export type WixRichContentV1ImageDataStylesBorder = {
  /** Border color as a hexadecimal value. */
  color?: Maybe<Scalars['String']>;
  /** Border radius in pixels. */
  radius?: Maybe<Scalars['Int']>;
  /** Border width in pixels. */
  width?: Maybe<Scalars['Int']>;
};

export type WixRichContentV1ImageDataStylesBorderInput = {
  /** Border color as a hexadecimal value. */
  color?: InputMaybe<Scalars['String']>;
  /** Border radius in pixels. */
  radius?: InputMaybe<Scalars['Int']>;
  /** Border width in pixels. */
  width?: InputMaybe<Scalars['Int']>;
};

export type WixRichContentV1ImageDataStylesInput = {
  /** Border attributes. */
  border?: InputMaybe<WixRichContentV1ImageDataStylesBorderInput>;
};

export type WixRichContentV1LayoutCellData = {
  /** Size of the cell in 12 columns grid. */
  colSpan?: Maybe<Scalars['Int']>;
};

export type WixRichContentV1LayoutCellDataInput = {
  /** Size of the cell in 12 columns grid. */
  colSpan?: InputMaybe<Scalars['Int']>;
};

export type WixRichContentV1LayoutData = {
  /** Backdrop color as a hexadecimal value. */
  backdropColor?: Maybe<Scalars['String']>;
  /** Backdrop image.radius in pixels. */
  backdropImage?: Maybe<WixRichContentV1LayoutDataBackgroundImage>;
  /** Backdrop bottom padding */
  backdropPaddingBottom?: Maybe<Scalars['Int']>;
  /** Backdrop top padding. */
  backdropPaddingTop?: Maybe<Scalars['Int']>;
  /** Background color as a hexadecimal value. */
  backgroundColor?: Maybe<Scalars['String']>;
  /** Background image. */
  backgroundImage?: Maybe<WixRichContentV1LayoutDataBackgroundImage>;
  /** Border color as a hexadecimal value. */
  borderColor?: Maybe<Scalars['String']>;
  /** Border */
  borderRadius?: Maybe<Scalars['Int']>;
  /** Border width in pixels. */
  borderWidth?: Maybe<Scalars['Int']>;
  /** Padding in pixels for cells. Follows CSS order: top, right, bottom, left */
  cellPadding?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Vertical alignment for the cell's items. */
  cellVerticalAlignment?: Maybe<WixRichContentV1LayoutDataVerticalAlignmentAlignment>;
  /** Styling for the layout's container. */
  containerData?: Maybe<WixRichContentV1PluginContainerData>;
  /** Horizontal and vertical gap between columns */
  gap?: Maybe<Scalars['Int']>;
  /** Responsiveness behaviour of columns when responsiveness applies. Either stacks or wrappers. */
  responsivenessBehaviour?: Maybe<WixRichContentV1LayoutDataResponsivenessBehaviour>;
  /** Size in pixels when responsiveness_behaviour applies */
  responsivenessBreakpoint?: Maybe<Scalars['Int']>;
};

export type WixRichContentV1LayoutDataBackgroundImage = {
  /** Background image. */
  media?: Maybe<WixRichContentV1Media>;
  /** Background image opacity. */
  opacity?: Maybe<Scalars['Int']>;
  /** Position of background. Defaults to `CENTER`. */
  position?: Maybe<WixRichContentV1LayoutDataImagePosition>;
  /** Background image scaling. */
  scaling?: Maybe<WixRichContentV1LayoutDataImageScalingScaling>;
};

export type WixRichContentV1LayoutDataBackgroundImageInput = {
  /** Background image. */
  media?: InputMaybe<WixRichContentV1MediaInput>;
  /** Background image opacity. */
  opacity?: InputMaybe<Scalars['Int']>;
  /** Position of background. Defaults to `CENTER`. */
  position?: InputMaybe<WixRichContentV1LayoutDataImagePosition>;
  /** Background image scaling. */
  scaling?: InputMaybe<WixRichContentV1LayoutDataImageScalingScaling>;
};

export enum WixRichContentV1LayoutDataImagePosition {
  /** Image positioned at the center bottom */
  BOTTOM = 'BOTTOM',
  /** Image positioned at the bottom left */
  BOTTOM_LEFT = 'BOTTOM_LEFT',
  /** Image positioned at the bottom right */
  BOTTOM_RIGHT = 'BOTTOM_RIGHT',
  /** Image positioned at the center */
  CENTER = 'CENTER',
  /** Image positioned on the left */
  CENTER_LEFT = 'CENTER_LEFT',
  /** Image positioned on the right */
  CENTER_RIGHT = 'CENTER_RIGHT',
  /** Image positioned at the center top */
  TOP = 'TOP',
  /** Image positioned at the top left */
  TOP_LEFT = 'TOP_LEFT',
  /** Image positioned at the top right */
  TOP_RIGHT = 'TOP_RIGHT'
}

export enum WixRichContentV1LayoutDataImageScalingScaling {
  /** Auto image scaling */
  AUTO = 'AUTO',
  /** Contain image scaling */
  CONTAIN = 'CONTAIN',
  /** Cover image scaling */
  COVER = 'COVER'
}

export type WixRichContentV1LayoutDataInput = {
  /** Backdrop color as a hexadecimal value. */
  backdropColor?: InputMaybe<Scalars['String']>;
  /** Backdrop image.radius in pixels. */
  backdropImage?: InputMaybe<WixRichContentV1LayoutDataBackgroundImageInput>;
  /** Backdrop bottom padding */
  backdropPaddingBottom?: InputMaybe<Scalars['Int']>;
  /** Backdrop top padding. */
  backdropPaddingTop?: InputMaybe<Scalars['Int']>;
  /** Background color as a hexadecimal value. */
  backgroundColor?: InputMaybe<Scalars['String']>;
  /** Background image. */
  backgroundImage?: InputMaybe<WixRichContentV1LayoutDataBackgroundImageInput>;
  /** Border color as a hexadecimal value. */
  borderColor?: InputMaybe<Scalars['String']>;
  /** Border */
  borderRadius?: InputMaybe<Scalars['Int']>;
  /** Border width in pixels. */
  borderWidth?: InputMaybe<Scalars['Int']>;
  /** Padding in pixels for cells. Follows CSS order: top, right, bottom, left */
  cellPadding?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Vertical alignment for the cell's items. */
  cellVerticalAlignment?: InputMaybe<WixRichContentV1LayoutDataVerticalAlignmentAlignment>;
  /** Styling for the layout's container. */
  containerData?: InputMaybe<WixRichContentV1PluginContainerDataInput>;
  /** Horizontal and vertical gap between columns */
  gap?: InputMaybe<Scalars['Int']>;
  /** Responsiveness behaviour of columns when responsiveness applies. Either stacks or wrappers. */
  responsivenessBehaviour?: InputMaybe<WixRichContentV1LayoutDataResponsivenessBehaviour>;
  /** Size in pixels when responsiveness_behaviour applies */
  responsivenessBreakpoint?: InputMaybe<Scalars['Int']>;
};

export enum WixRichContentV1LayoutDataResponsivenessBehaviour {
  /** Stacking of columns */
  STACK = 'STACK',
  /** Wrapping of columns */
  WRAP = 'WRAP'
}

export enum WixRichContentV1LayoutDataVerticalAlignmentAlignment {
  /** Bottom alignment */
  BOTTOM = 'BOTTOM',
  /** Middle alignment */
  MIDDLE = 'MIDDLE',
  /** Top alignment */
  TOP = 'TOP'
}

export type WixRichContentV1Link = {
  /** The target node's ID. Used for linking to another node in this object. */
  anchor?: Maybe<Scalars['String']>;
  /** A serialized object used for a custom or external link panel. */
  customData?: Maybe<Scalars['String']>;
  /** The HTML `rel` attribute value for the link. This object specifies the relationship between the current document and the linked document. */
  rel?: Maybe<WixRichContentV1LinkRel>;
  /**
   * he HTML `target` attribute value for the link. This property defines where the linked document opens as follows:
   * `SELF` - Default. Opens the linked document in the same frame as the link.
   * `BLANK` - Opens the linked document in a new browser tab or window.
   * `PARENT` - Opens the linked document in the link's parent frame.
   * `TOP` - Opens the linked document in the full body of the link's browser tab or window.
   */
  target?: Maybe<WixRichContentV1LinkTarget>;
  /** The absolute URL for the linked document. */
  url?: Maybe<Scalars['String']>;
};

export type WixRichContentV1LinkData = {
  /** Link details. */
  link?: Maybe<WixRichContentV1Link>;
};

export type WixRichContentV1LinkDataInput = {
  /** Link details. */
  link?: InputMaybe<WixRichContentV1LinkInput>;
};

export type WixRichContentV1LinkInput = {
  /** The target node's ID. Used for linking to another node in this object. */
  anchor?: InputMaybe<Scalars['String']>;
  /** A serialized object used for a custom or external link panel. */
  customData?: InputMaybe<Scalars['String']>;
  /** The HTML `rel` attribute value for the link. This object specifies the relationship between the current document and the linked document. */
  rel?: InputMaybe<WixRichContentV1LinkRelInput>;
  /**
   * he HTML `target` attribute value for the link. This property defines where the linked document opens as follows:
   * `SELF` - Default. Opens the linked document in the same frame as the link.
   * `BLANK` - Opens the linked document in a new browser tab or window.
   * `PARENT` - Opens the linked document in the link's parent frame.
   * `TOP` - Opens the linked document in the full body of the link's browser tab or window.
   */
  target?: InputMaybe<WixRichContentV1LinkTarget>;
  /** The absolute URL for the linked document. */
  url?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1LinkPreviewData = {
  /** Styling for the link preview's container. */
  containerData?: Maybe<WixRichContentV1PluginContainerData>;
  /** Preview description. */
  description?: Maybe<Scalars['String']>;
  /** The preview content as HTML. */
  html?: Maybe<Scalars['String']>;
  /** Link details. */
  link?: Maybe<WixRichContentV1Link>;
  /** Styling for the link preview. */
  styles?: Maybe<WixRichContentV1LinkPreviewDataStyles>;
  /** Preview thumbnail URL. */
  thumbnailUrl?: Maybe<Scalars['String']>;
  /** Preview title. */
  title?: Maybe<Scalars['String']>;
};

export type WixRichContentV1LinkPreviewDataInput = {
  /** Styling for the link preview's container. */
  containerData?: InputMaybe<WixRichContentV1PluginContainerDataInput>;
  /** Preview description. */
  description?: InputMaybe<Scalars['String']>;
  /** The preview content as HTML. */
  html?: InputMaybe<Scalars['String']>;
  /** Link details. */
  link?: InputMaybe<WixRichContentV1LinkInput>;
  /** Styling for the link preview. */
  styles?: InputMaybe<WixRichContentV1LinkPreviewDataStylesInput>;
  /** Preview thumbnail URL. */
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  /** Preview title. */
  title?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1LinkPreviewDataStyles = {
  /** Background color as a hexadecimal value. */
  backgroundColor?: Maybe<Scalars['String']>;
  /** Border color as a hexadecimal value. */
  borderColor?: Maybe<Scalars['String']>;
  /** Border radius in pixels. */
  borderRadius?: Maybe<Scalars['Int']>;
  /** Border width in pixels. */
  borderWidth?: Maybe<Scalars['Int']>;
  /** Link color as a hexadecimal value. */
  linkColor?: Maybe<Scalars['String']>;
  /** Subtitle color as a hexadecimal value. */
  subtitleColor?: Maybe<Scalars['String']>;
  /** Position of thumbnail. Defaults to `START`. */
  thumbnailPosition?: Maybe<WixRichContentV1LinkPreviewDataStylesPosition>;
  /** Title color as a hexadecimal value. */
  titleColor?: Maybe<Scalars['String']>;
};

export type WixRichContentV1LinkPreviewDataStylesInput = {
  /** Background color as a hexadecimal value. */
  backgroundColor?: InputMaybe<Scalars['String']>;
  /** Border color as a hexadecimal value. */
  borderColor?: InputMaybe<Scalars['String']>;
  /** Border radius in pixels. */
  borderRadius?: InputMaybe<Scalars['Int']>;
  /** Border width in pixels. */
  borderWidth?: InputMaybe<Scalars['Int']>;
  /** Link color as a hexadecimal value. */
  linkColor?: InputMaybe<Scalars['String']>;
  /** Subtitle color as a hexadecimal value. */
  subtitleColor?: InputMaybe<Scalars['String']>;
  /** Position of thumbnail. Defaults to `START`. */
  thumbnailPosition?: InputMaybe<WixRichContentV1LinkPreviewDataStylesPosition>;
  /** Title color as a hexadecimal value. */
  titleColor?: InputMaybe<Scalars['String']>;
};

export enum WixRichContentV1LinkPreviewDataStylesPosition {
  /** Thumbnail positioned at the end (right in LTR layouts, left in RTL layouts) */
  END = 'END',
  /** Thumbnail hidden and not displayed */
  HIDDEN = 'HIDDEN',
  /** Thumbnail positioned at the start (left in LTR layouts, right in RTL layouts) */
  START = 'START',
  /** Thumbnail positioned at the top */
  TOP = 'TOP'
}

export type WixRichContentV1LinkRel = {
  /** Indicates to search engine crawlers not to follow the link. Defaults to `false`. */
  nofollow?: Maybe<Scalars['Boolean']>;
  /** Indicates that this link protect referral information from being passed to the target website. */
  noreferrer?: Maybe<Scalars['Boolean']>;
  /** Indicates to search engine crawlers that the link is a paid placement such as sponsored content or an advertisement. Defaults to `false`. */
  sponsored?: Maybe<Scalars['Boolean']>;
  /** Indicates that this link is user-generated content and isn't necessarily trusted or endorsed by the page’s author. For example, a link in a fourm post. Defaults to `false`. */
  ugc?: Maybe<Scalars['Boolean']>;
};

export type WixRichContentV1LinkRelInput = {
  /** Indicates to search engine crawlers not to follow the link. Defaults to `false`. */
  nofollow?: InputMaybe<Scalars['Boolean']>;
  /** Indicates that this link protect referral information from being passed to the target website. */
  noreferrer?: InputMaybe<Scalars['Boolean']>;
  /** Indicates to search engine crawlers that the link is a paid placement such as sponsored content or an advertisement. Defaults to `false`. */
  sponsored?: InputMaybe<Scalars['Boolean']>;
  /** Indicates that this link is user-generated content and isn't necessarily trusted or endorsed by the page’s author. For example, a link in a fourm post. Defaults to `false`. */
  ugc?: InputMaybe<Scalars['Boolean']>;
};

export enum WixRichContentV1LinkTarget {
  /** Opens the linked document in a new window or tab */
  BLANK = 'BLANK',
  /** Opens the linked document in the parent frame */
  PARENT = 'PARENT',
  /** Opens the linked document in the same frame as it was clicked (this is default) */
  SELF = 'SELF',
  /** Opens the linked document in the full body of the window */
  TOP = 'TOP'
}

export type WixRichContentV1ListValue = {
  /** Repeated field of dynamically typed values. */
  values?: Maybe<Array<Maybe<WixRichContentV1Value>>>;
};

export type WixRichContentV1ListValueInput = {
  /** Repeated field of dynamically typed values. */
  values?: InputMaybe<Array<InputMaybe<WixRichContentV1ValueInput>>>;
};

export type WixRichContentV1MapData = {
  /** Styling for the map's container. */
  containerData?: Maybe<WixRichContentV1PluginContainerData>;
  /** Map settings. */
  mapSettings?: Maybe<WixRichContentV1MapSettings>;
};

export type WixRichContentV1MapDataInput = {
  /** Styling for the map's container. */
  containerData?: InputMaybe<WixRichContentV1PluginContainerDataInput>;
  /** Map settings. */
  mapSettings?: InputMaybe<WixRichContentV1MapSettingsInput>;
};

export type WixRichContentV1MapSettings = {
  /** The address to display on the map. */
  address?: Maybe<Scalars['String']>;
  /** Sets whether the map is draggable. */
  draggable?: Maybe<Scalars['Boolean']>;
  /** Initial zoom value. */
  initialZoom?: Maybe<Scalars['Int']>;
  /** Location latitude. */
  lat?: Maybe<Scalars['Float']>;
  /** Location longitude. */
  lng?: Maybe<Scalars['Float']>;
  /** Location name. */
  locationName?: Maybe<Scalars['String']>;
  /** Map type. `HYBRID` is a combination of the `ROADMAP` and `SATELLITE` map types. */
  mapType?: Maybe<WixRichContentV1MapType>;
  /** Sets whether the location marker is visible. */
  marker?: Maybe<Scalars['Boolean']>;
  /** Sets whether street view control is enabled. */
  streetViewControl?: Maybe<Scalars['Boolean']>;
  /** Sets whether view mode control is enabled. */
  viewModeControl?: Maybe<Scalars['Boolean']>;
  /** Sets whether zoom control is enabled. */
  zoomControl?: Maybe<Scalars['Boolean']>;
};

export type WixRichContentV1MapSettingsInput = {
  /** The address to display on the map. */
  address?: InputMaybe<Scalars['String']>;
  /** Sets whether the map is draggable. */
  draggable?: InputMaybe<Scalars['Boolean']>;
  /** Initial zoom value. */
  initialZoom?: InputMaybe<Scalars['Int']>;
  /** Location latitude. */
  lat?: InputMaybe<Scalars['Float']>;
  /** Location longitude. */
  lng?: InputMaybe<Scalars['Float']>;
  /** Location name. */
  locationName?: InputMaybe<Scalars['String']>;
  /** Map type. `HYBRID` is a combination of the `ROADMAP` and `SATELLITE` map types. */
  mapType?: InputMaybe<WixRichContentV1MapType>;
  /** Sets whether the location marker is visible. */
  marker?: InputMaybe<Scalars['Boolean']>;
  /** Sets whether street view control is enabled. */
  streetViewControl?: InputMaybe<Scalars['Boolean']>;
  /** Sets whether view mode control is enabled. */
  viewModeControl?: InputMaybe<Scalars['Boolean']>;
  /** Sets whether zoom control is enabled. */
  zoomControl?: InputMaybe<Scalars['Boolean']>;
};

export enum WixRichContentV1MapType {
  /** Hybrid map type */
  HYBRID = 'HYBRID',
  /** Roadmap map type */
  ROADMAP = 'ROADMAP',
  /** Satellite map type */
  SATELITE = 'SATELITE',
  /** Terrain map type */
  TERRAIN = 'TERRAIN'
}

export type WixRichContentV1Media = {
  /** Media duration in seconds. Only relevant for audio and video files. */
  duration?: Maybe<Scalars['Float']>;
  /** Media height in pixels. */
  height?: Maybe<Scalars['Int']>;
  /** The source for the media's data. */
  src?: Maybe<WixRichContentV1FileSource>;
  /** Media width in pixels. */
  width?: Maybe<Scalars['Int']>;
};

export type WixRichContentV1MediaInput = {
  /** Media duration in seconds. Only relevant for audio and video files. */
  duration?: InputMaybe<Scalars['Float']>;
  /** Media height in pixels. */
  height?: InputMaybe<Scalars['Int']>;
  /** The source for the media's data. */
  src?: InputMaybe<WixRichContentV1FileSourceInput>;
  /** Media width in pixels. */
  width?: InputMaybe<Scalars['Int']>;
};

export type WixRichContentV1MentionData = {
  /** Mentioned user's ID. */
  id?: Maybe<Scalars['String']>;
  /** The mentioned user's name. */
  name?: Maybe<Scalars['String']>;
  /** The version of the user's name that appears after the `@` character in the mention. */
  slug?: Maybe<Scalars['String']>;
};

export type WixRichContentV1MentionDataInput = {
  /** Mentioned user's ID. */
  id?: InputMaybe<Scalars['String']>;
  /** The mentioned user's name. */
  name?: InputMaybe<Scalars['String']>;
  /** The version of the user's name that appears after the `@` character in the mention. */
  slug?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1Metadata = {
  /** When the object was created. */
  createdTimestamp?: Maybe<Scalars['String']>;
  /** Object ID. */
  id?: Maybe<Scalars['String']>;
  /** When the object was most recently updated. */
  updatedTimestamp?: Maybe<Scalars['String']>;
  /** Schema version. */
  version?: Maybe<Scalars['Int']>;
};

export type WixRichContentV1MetadataInput = {
  /** When the object was created. */
  createdTimestamp?: InputMaybe<Scalars['String']>;
  /** Object ID. */
  id?: InputMaybe<Scalars['String']>;
  /** When the object was most recently updated. */
  updatedTimestamp?: InputMaybe<Scalars['String']>;
  /** Schema version. */
  version?: InputMaybe<Scalars['Int']>;
};

export type WixRichContentV1Node = {
  /** Data for an app embed node. */
  appEmbedData?: Maybe<WixRichContentV1AppEmbedData>;
  /** Data for an audio node. */
  audioData?: Maybe<WixRichContentV1AudioData>;
  /** Data for a block quote node. */
  blockquoteData?: Maybe<WixRichContentV1BlockquoteData>;
  /** Data for a bulleted list node. */
  bulletedListData?: Maybe<WixRichContentV1BulletedListData>;
  /** Data for a button node. */
  buttonData?: Maybe<WixRichContentV1ButtonData>;
  /** Data for a caption node. */
  captionData?: Maybe<WixRichContentV1CaptionData>;
  /** Data for a code block node. */
  codeBlockData?: Maybe<WixRichContentV1CodeBlockData>;
  /** Data for a collapsible list node. */
  collapsibleListData?: Maybe<WixRichContentV1CollapsibleListData>;
  /** Data for a divider node. */
  dividerData?: Maybe<WixRichContentV1DividerData>;
  /** Data for an oEmbed node. */
  embedData?: Maybe<WixRichContentV1EmbedData>;
  /** Data for a custom external node. */
  externalData?: Maybe<WixRichContentV1Struct>;
  /** Data for a file node. */
  fileData?: Maybe<WixRichContentV1FileData>;
  /** Data for a gallery node. */
  galleryData?: Maybe<WixRichContentV1GalleryData>;
  /** Data for a GIF node. */
  gifData?: Maybe<WixRichContentV1GifData>;
  /** Data for a heading node. */
  headingData?: Maybe<WixRichContentV1HeadingData>;
  /** Data for an embedded HTML node. */
  htmlData?: Maybe<WixRichContentV1HtmlData>;
  /** Node ID. */
  id?: Maybe<Scalars['String']>;
  /** Data for an image node. */
  imageData?: Maybe<WixRichContentV1ImageData>;
  /** Data for a cell node. */
  layoutCellData?: Maybe<WixRichContentV1LayoutCellData>;
  /** Data for a layout node. Reserved for future use. */
  layoutData?: Maybe<WixRichContentV1LayoutData>;
  /** Data for a link preview node. */
  linkPreviewData?: Maybe<WixRichContentV1LinkPreviewData>;
  mapData?: Maybe<WixRichContentV1MapData>;
  /** A list of child nodes. */
  nodes?: Maybe<Array<Maybe<WixRichContentV1Node>>>;
  /** Data for an ordered list node. */
  orderedListData?: Maybe<WixRichContentV1OrderedListData>;
  /** Data for a paragraph node. */
  paragraphData?: Maybe<WixRichContentV1ParagraphData>;
  /** Data for a poll node. */
  pollData?: Maybe<WixRichContentV1PollData>;
  /** Padding and background color styling for the node. */
  style?: Maybe<WixRichContentV1NodeStyle>;
  /** Data for a table cell node. */
  tableCellData?: Maybe<WixRichContentV1TableCellData>;
  /** Data for a table node. */
  tableData?: Maybe<WixRichContentV1TableData>;
  /** Data for a text node. Used to apply decorations to text. */
  textData?: Maybe<WixRichContentV1TextData>;
  /** Node type. Use `APP_EMBED` for nodes that embed content from other Wix apps. Use `EMBED` to embed content in [oEmbed](https://oembed.com/) format. */
  type?: Maybe<WixRichContentV1NodeType>;
  /** Data for a video node. */
  videoData?: Maybe<WixRichContentV1VideoData>;
};

export type WixRichContentV1NodeInput = {
  /** Data for an app embed node. */
  appEmbedData?: InputMaybe<WixRichContentV1AppEmbedDataInput>;
  /** Data for an audio node. */
  audioData?: InputMaybe<WixRichContentV1AudioDataInput>;
  /** Data for a block quote node. */
  blockquoteData?: InputMaybe<WixRichContentV1BlockquoteDataInput>;
  /** Data for a bulleted list node. */
  bulletedListData?: InputMaybe<WixRichContentV1BulletedListDataInput>;
  /** Data for a button node. */
  buttonData?: InputMaybe<WixRichContentV1ButtonDataInput>;
  /** Data for a caption node. */
  captionData?: InputMaybe<WixRichContentV1CaptionDataInput>;
  /** Data for a code block node. */
  codeBlockData?: InputMaybe<WixRichContentV1CodeBlockDataInput>;
  /** Data for a collapsible list node. */
  collapsibleListData?: InputMaybe<WixRichContentV1CollapsibleListDataInput>;
  /** Data for a divider node. */
  dividerData?: InputMaybe<WixRichContentV1DividerDataInput>;
  /** Data for an oEmbed node. */
  embedData?: InputMaybe<WixRichContentV1EmbedDataInput>;
  /** Data for a custom external node. */
  externalData?: InputMaybe<WixRichContentV1StructInput>;
  /** Data for a file node. */
  fileData?: InputMaybe<WixRichContentV1FileDataInput>;
  /** Data for a gallery node. */
  galleryData?: InputMaybe<WixRichContentV1GalleryDataInput>;
  /** Data for a GIF node. */
  gifData?: InputMaybe<WixRichContentV1GifDataInput>;
  /** Data for a heading node. */
  headingData?: InputMaybe<WixRichContentV1HeadingDataInput>;
  /** Data for an embedded HTML node. */
  htmlData?: InputMaybe<WixRichContentV1HtmlDataInput>;
  /** Node ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Data for an image node. */
  imageData?: InputMaybe<WixRichContentV1ImageDataInput>;
  /** Data for a cell node. */
  layoutCellData?: InputMaybe<WixRichContentV1LayoutCellDataInput>;
  /** Data for a layout node. Reserved for future use. */
  layoutData?: InputMaybe<WixRichContentV1LayoutDataInput>;
  /** Data for a link preview node. */
  linkPreviewData?: InputMaybe<WixRichContentV1LinkPreviewDataInput>;
  mapData?: InputMaybe<WixRichContentV1MapDataInput>;
  /** A list of child nodes. */
  nodes?: InputMaybe<Array<InputMaybe<WixRichContentV1NodeInput>>>;
  /** Data for an ordered list node. */
  orderedListData?: InputMaybe<WixRichContentV1OrderedListDataInput>;
  /** Data for a paragraph node. */
  paragraphData?: InputMaybe<WixRichContentV1ParagraphDataInput>;
  /** Data for a poll node. */
  pollData?: InputMaybe<WixRichContentV1PollDataInput>;
  /** Padding and background color styling for the node. */
  style?: InputMaybe<WixRichContentV1NodeStyleInput>;
  /** Data for a table cell node. */
  tableCellData?: InputMaybe<WixRichContentV1TableCellDataInput>;
  /** Data for a table node. */
  tableData?: InputMaybe<WixRichContentV1TableDataInput>;
  /** Data for a text node. Used to apply decorations to text. */
  textData?: InputMaybe<WixRichContentV1TextDataInput>;
  /** Node type. Use `APP_EMBED` for nodes that embed content from other Wix apps. Use `EMBED` to embed content in [oEmbed](https://oembed.com/) format. */
  type?: InputMaybe<WixRichContentV1NodeType>;
  /** Data for a video node. */
  videoData?: InputMaybe<WixRichContentV1VideoDataInput>;
};

export type WixRichContentV1NodeStyle = {
  /** The background color as a hexadecimal value. */
  backgroundColor?: Maybe<Scalars['String']>;
  /** The bottom padding value in pixels. */
  paddingBottom?: Maybe<Scalars['String']>;
  /** The top padding value in pixels. */
  paddingTop?: Maybe<Scalars['String']>;
};

export type WixRichContentV1NodeStyleInput = {
  /** The background color as a hexadecimal value. */
  backgroundColor?: InputMaybe<Scalars['String']>;
  /** The bottom padding value in pixels. */
  paddingBottom?: InputMaybe<Scalars['String']>;
  /** The top padding value in pixels. */
  paddingTop?: InputMaybe<Scalars['String']>;
};

export enum WixRichContentV1NodeType {
  APP_EMBED = 'APP_EMBED',
  AUDIO = 'AUDIO',
  BLOCKQUOTE = 'BLOCKQUOTE',
  BULLETED_LIST = 'BULLETED_LIST',
  BUTTON = 'BUTTON',
  CAPTION = 'CAPTION',
  CODE_BLOCK = 'CODE_BLOCK',
  COLLAPSIBLE_ITEM = 'COLLAPSIBLE_ITEM',
  COLLAPSIBLE_ITEM_BODY = 'COLLAPSIBLE_ITEM_BODY',
  COLLAPSIBLE_ITEM_TITLE = 'COLLAPSIBLE_ITEM_TITLE',
  COLLAPSIBLE_LIST = 'COLLAPSIBLE_LIST',
  DIVIDER = 'DIVIDER',
  EMBED = 'EMBED',
  EXTERNAL = 'EXTERNAL',
  FILE = 'FILE',
  GALLERY = 'GALLERY',
  GIF = 'GIF',
  HEADING = 'HEADING',
  HTML = 'HTML',
  IMAGE = 'IMAGE',
  LAYOUT = 'LAYOUT',
  LAYOUT_CELL = 'LAYOUT_CELL',
  LINK_PREVIEW = 'LINK_PREVIEW',
  LIST_ITEM = 'LIST_ITEM',
  /** @deprecated */
  MAP = 'MAP',
  ORDERED_LIST = 'ORDERED_LIST',
  PARAGRAPH = 'PARAGRAPH',
  POLL = 'POLL',
  TABLE = 'TABLE',
  TABLE_CELL = 'TABLE_CELL',
  TABLE_ROW = 'TABLE_ROW',
  TEXT = 'TEXT',
  VIDEO = 'VIDEO'
}

export enum WixRichContentV1NullValue {
  /** Null value. */
  NULL_VALUE = 'NULL_VALUE'
}

export type WixRichContentV1Oembed = {
  /** The name of the author or owner of the resource. */
  authorName?: Maybe<Scalars['String']>;
  /** The URL for the author or owner of the resource. */
  authorUrl?: Maybe<Scalars['String']>;
  /** The height of the resource specified in the `url` property in pixels. */
  height?: Maybe<Scalars['Int']>;
  /** HTML for embedding a video player. The HTML should have no padding or margins. */
  html?: Maybe<Scalars['String']>;
  /** The name of the resource provider. */
  providerName?: Maybe<Scalars['String']>;
  /** The URL for the resource provider. */
  providerUrl?: Maybe<Scalars['String']>;
  /** The height of the resource's thumbnail image. If this property is defined, `thumbnailUrl` and `thumbnailWidth`must also be defined. */
  thumbnailHeight?: Maybe<Scalars['String']>;
  /** The URL for a thumbnail image for the resource. If this property is defined, `thumbnailWidth` and `thumbnailHeight` must also be defined. */
  thumbnailUrl?: Maybe<Scalars['String']>;
  /** The width of the resource's thumbnail image. If this property is defined, `thumbnailUrl` and `thumbnailHeight` must also be defined. */
  thumbnailWidth?: Maybe<Scalars['String']>;
  /** Resource title. */
  title?: Maybe<Scalars['String']>;
  /** The resource type. */
  type?: Maybe<Scalars['String']>;
  /** The source URL for the resource. */
  url?: Maybe<Scalars['String']>;
  /** The oEmbed version number.  This value must be `1.0`. */
  version?: Maybe<Scalars['String']>;
  /** The URL for an embedded viedo. */
  videoUrl?: Maybe<Scalars['String']>;
  /** The width of the resource specified in the `url` property in pixels. */
  width?: Maybe<Scalars['Int']>;
};

export type WixRichContentV1OembedInput = {
  /** The name of the author or owner of the resource. */
  authorName?: InputMaybe<Scalars['String']>;
  /** The URL for the author or owner of the resource. */
  authorUrl?: InputMaybe<Scalars['String']>;
  /** The height of the resource specified in the `url` property in pixels. */
  height?: InputMaybe<Scalars['Int']>;
  /** HTML for embedding a video player. The HTML should have no padding or margins. */
  html?: InputMaybe<Scalars['String']>;
  /** The name of the resource provider. */
  providerName?: InputMaybe<Scalars['String']>;
  /** The URL for the resource provider. */
  providerUrl?: InputMaybe<Scalars['String']>;
  /** The height of the resource's thumbnail image. If this property is defined, `thumbnailUrl` and `thumbnailWidth`must also be defined. */
  thumbnailHeight?: InputMaybe<Scalars['String']>;
  /** The URL for a thumbnail image for the resource. If this property is defined, `thumbnailWidth` and `thumbnailHeight` must also be defined. */
  thumbnailUrl?: InputMaybe<Scalars['String']>;
  /** The width of the resource's thumbnail image. If this property is defined, `thumbnailUrl` and `thumbnailHeight` must also be defined. */
  thumbnailWidth?: InputMaybe<Scalars['String']>;
  /** Resource title. */
  title?: InputMaybe<Scalars['String']>;
  /** The resource type. */
  type?: InputMaybe<Scalars['String']>;
  /** The source URL for the resource. */
  url?: InputMaybe<Scalars['String']>;
  /** The oEmbed version number.  This value must be `1.0`. */
  version?: InputMaybe<Scalars['String']>;
  /** The URL for an embedded viedo. */
  videoUrl?: InputMaybe<Scalars['String']>;
  /** The width of the resource specified in the `url` property in pixels. */
  width?: InputMaybe<Scalars['Int']>;
};

export type WixRichContentV1OrderedListData = {
  /** Indentation level from 0-4. */
  indentation?: Maybe<Scalars['Int']>;
  /** Offset level from 0-4. */
  offset?: Maybe<Scalars['Int']>;
  /** List start number. */
  start?: Maybe<Scalars['Int']>;
};

export type WixRichContentV1OrderedListDataInput = {
  /** Indentation level from 0-4. */
  indentation?: InputMaybe<Scalars['Int']>;
  /** Offset level from 0-4. */
  offset?: InputMaybe<Scalars['Int']>;
  /** List start number. */
  start?: InputMaybe<Scalars['Int']>;
};

export type WixRichContentV1ParagraphData = {
  /** Indentation level from 1-4. */
  indentation?: Maybe<Scalars['Int']>;
  /** Paragraph level */
  level?: Maybe<Scalars['Int']>;
  /** Styling for the paragraph text. */
  textStyle?: Maybe<WixRichContentV1TextStyle>;
};

export type WixRichContentV1ParagraphDataInput = {
  /** Indentation level from 1-4. */
  indentation?: InputMaybe<Scalars['Int']>;
  /** Paragraph level */
  level?: InputMaybe<Scalars['Int']>;
  /** Styling for the paragraph text. */
  textStyle?: InputMaybe<WixRichContentV1TextStyleInput>;
};

export type WixRichContentV1PlaybackOptions = {
  /** Sets whether the media will automatically start playing. */
  autoPlay?: Maybe<Scalars['Boolean']>;
  /** Sets whether media's will be looped. */
  playInLoop?: Maybe<Scalars['Boolean']>;
  /** Sets whether media's controls will be shown. */
  showControls?: Maybe<Scalars['Boolean']>;
};

export type WixRichContentV1PlaybackOptionsInput = {
  /** Sets whether the media will automatically start playing. */
  autoPlay?: InputMaybe<Scalars['Boolean']>;
  /** Sets whether media's will be looped. */
  playInLoop?: InputMaybe<Scalars['Boolean']>;
  /** Sets whether media's controls will be shown. */
  showControls?: InputMaybe<Scalars['Boolean']>;
};

export type WixRichContentV1PluginContainerData = {
  /** The node's alignment within its container. */
  alignment?: Maybe<WixRichContentV1PluginContainerDataAlignment>;
  /** The height of the node when it's displayed. */
  height?: Maybe<WixRichContentV1PluginContainerDataHeight>;
  /** Spoiler cover settings for the node. */
  spoiler?: Maybe<WixRichContentV1PluginContainerDataSpoiler>;
  /** Sets whether text should wrap around this node when it's displayed. If `textWrap` is `false`, the node takes up the width of its container. Defaults to `true` for all node types except 'DIVIVDER' where it defaults to `false`. */
  textWrap?: Maybe<Scalars['Boolean']>;
  /** The width of the node when it's displayed. */
  width?: Maybe<WixRichContentV1PluginContainerDataWidth>;
};

export enum WixRichContentV1PluginContainerDataAlignment {
  /** Center Alignment */
  CENTER = 'CENTER',
  /** Left Alignment */
  LEFT = 'LEFT',
  /** Right Alignment */
  RIGHT = 'RIGHT'
}

export type WixRichContentV1PluginContainerDataHeight = {
  /** A custom height value in pixels. */
  custom?: Maybe<Scalars['String']>;
};

export type WixRichContentV1PluginContainerDataHeightInput = {
  /** A custom height value in pixels. */
  custom?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1PluginContainerDataInput = {
  /** The node's alignment within its container. */
  alignment?: InputMaybe<WixRichContentV1PluginContainerDataAlignment>;
  /** The height of the node when it's displayed. */
  height?: InputMaybe<WixRichContentV1PluginContainerDataHeightInput>;
  /** Spoiler cover settings for the node. */
  spoiler?: InputMaybe<WixRichContentV1PluginContainerDataSpoilerInput>;
  /** Sets whether text should wrap around this node when it's displayed. If `textWrap` is `false`, the node takes up the width of its container. Defaults to `true` for all node types except 'DIVIVDER' where it defaults to `false`. */
  textWrap?: InputMaybe<Scalars['Boolean']>;
  /** The width of the node when it's displayed. */
  width?: InputMaybe<WixRichContentV1PluginContainerDataWidthInput>;
};

export type WixRichContentV1PluginContainerDataSpoiler = {
  /** The text for the button used to remove the spoiler cover. */
  buttonText?: Maybe<Scalars['String']>;
  /** The description displayed on top of the spoiler cover. */
  description?: Maybe<Scalars['String']>;
  /** Sets whether the spoiler cover is enabled for this node. Defaults to `false`. */
  enabled?: Maybe<Scalars['Boolean']>;
};

export type WixRichContentV1PluginContainerDataSpoilerInput = {
  /** The text for the button used to remove the spoiler cover. */
  buttonText?: InputMaybe<Scalars['String']>;
  /** The description displayed on top of the spoiler cover. */
  description?: InputMaybe<Scalars['String']>;
  /** Sets whether the spoiler cover is enabled for this node. Defaults to `false`. */
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type WixRichContentV1PluginContainerDataWidth = {
  /** A custom width value in pixels. */
  custom?: Maybe<Scalars['String']>;
  /**
   * One of the following predefined width options:
   * `CONTENT`: The width of the container matches the content width.
   * `SMALL`: A small width.
   * `ORIGINAL`: For `imageData` containers only. The width of the container matches the original image width.
   * `FULL_WIDTH`: For `imageData` containers only. The image container takes up the full width of the screen.
   */
  size?: Maybe<WixRichContentV1PluginContainerDataWidthType>;
};

export type WixRichContentV1PluginContainerDataWidthInput = {
  /** A custom width value in pixels. */
  custom?: InputMaybe<Scalars['String']>;
  /**
   * One of the following predefined width options:
   * `CONTENT`: The width of the container matches the content width.
   * `SMALL`: A small width.
   * `ORIGINAL`: For `imageData` containers only. The width of the container matches the original image width.
   * `FULL_WIDTH`: For `imageData` containers only. The image container takes up the full width of the screen.
   */
  size?: InputMaybe<WixRichContentV1PluginContainerDataWidthType>;
};

export enum WixRichContentV1PluginContainerDataWidthType {
  /** Width matches the content width */
  CONTENT = 'CONTENT',
  /** coast-to-coast display */
  FULL_WIDTH = 'FULL_WIDTH',
  /** Width will match the original asset width */
  ORIGINAL = 'ORIGINAL',
  /** Small Width */
  SMALL = 'SMALL'
}

export type WixRichContentV1PollData = {
  /** Styling for the poll's container. */
  containerData?: Maybe<WixRichContentV1PluginContainerData>;
  /** Styling for the poll and voting options. */
  design?: Maybe<WixRichContentV1PollDataDesign>;
  /** Layout settings for the poll and voting options. */
  layout?: Maybe<WixRichContentV1PollDataLayout>;
  /** Poll data. */
  poll?: Maybe<WixRichContentV1PollDataPoll>;
};

export type WixRichContentV1PollDataDesign = {
  /** Styling for voting options. */
  options?: Maybe<WixRichContentV1PollDataDesignOptionDesign>;
  /** Styling for the poll. */
  poll?: Maybe<WixRichContentV1PollDataDesignPollDesign>;
};

export type WixRichContentV1PollDataDesignInput = {
  /** Styling for voting options. */
  options?: InputMaybe<WixRichContentV1PollDataDesignOptionDesignInput>;
  /** Styling for the poll. */
  poll?: InputMaybe<WixRichContentV1PollDataDesignPollDesignInput>;
};

export type WixRichContentV1PollDataDesignOptionDesign = {
  /** Border radius in pixels. */
  borderRadius?: Maybe<Scalars['Int']>;
};

export type WixRichContentV1PollDataDesignOptionDesignInput = {
  /** Border radius in pixels. */
  borderRadius?: InputMaybe<Scalars['Int']>;
};

export type WixRichContentV1PollDataDesignPollDesign = {
  /** Background styling. */
  background?: Maybe<WixRichContentV1PollDataDesignPollDesignBackground>;
  /** Border radius in pixels. */
  borderRadius?: Maybe<Scalars['Int']>;
};

export type WixRichContentV1PollDataDesignPollDesignBackground = {
  /** The background color as a hexademical value. */
  color?: Maybe<Scalars['String']>;
  /** Details for a gradient background. */
  gradient?: Maybe<WixRichContentV1PollDataDesignPollDesignBackgroundGradient>;
  /** An image to use for the background. */
  image?: Maybe<WixRichContentV1Media>;
  /** Background type. For each option, include the relevant details. */
  type?: Maybe<WixRichContentV1PollDataDesignPollDesignBackgroundType>;
};

export type WixRichContentV1PollDataDesignPollDesignBackgroundGradient = {
  /** The gradient angle in degrees. */
  angle?: Maybe<Scalars['Int']>;
  /** The end color as a hexademical value. */
  lastColor?: Maybe<Scalars['String']>;
  /** The start color as a hexademical value. */
  startColor?: Maybe<Scalars['String']>;
};

export type WixRichContentV1PollDataDesignPollDesignBackgroundGradientInput = {
  /** The gradient angle in degrees. */
  angle?: InputMaybe<Scalars['Int']>;
  /** The end color as a hexademical value. */
  lastColor?: InputMaybe<Scalars['String']>;
  /** The start color as a hexademical value. */
  startColor?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1PollDataDesignPollDesignBackgroundInput = {
  /** The background color as a hexademical value. */
  color?: InputMaybe<Scalars['String']>;
  /** Details for a gradient background. */
  gradient?: InputMaybe<WixRichContentV1PollDataDesignPollDesignBackgroundGradientInput>;
  /** An image to use for the background. */
  image?: InputMaybe<WixRichContentV1MediaInput>;
  /** Background type. For each option, include the relevant details. */
  type?: InputMaybe<WixRichContentV1PollDataDesignPollDesignBackgroundType>;
};

export enum WixRichContentV1PollDataDesignPollDesignBackgroundType {
  /** Color background type */
  COLOR = 'COLOR',
  /** Gradiant background type */
  GRADIENT = 'GRADIENT',
  /** Image background type */
  IMAGE = 'IMAGE'
}

export type WixRichContentV1PollDataDesignPollDesignInput = {
  /** Background styling. */
  background?: InputMaybe<WixRichContentV1PollDataDesignPollDesignBackgroundInput>;
  /** Border radius in pixels. */
  borderRadius?: InputMaybe<Scalars['Int']>;
};

export type WixRichContentV1PollDataInput = {
  /** Styling for the poll's container. */
  containerData?: InputMaybe<WixRichContentV1PluginContainerDataInput>;
  /** Styling for the poll and voting options. */
  design?: InputMaybe<WixRichContentV1PollDataDesignInput>;
  /** Layout settings for the poll and voting options. */
  layout?: InputMaybe<WixRichContentV1PollDataLayoutInput>;
  /** Poll data. */
  poll?: InputMaybe<WixRichContentV1PollDataPollInput>;
};

export type WixRichContentV1PollDataLayout = {
  /** Voting otpions layout settings. */
  options?: Maybe<WixRichContentV1PollDataLayoutOptionLayout>;
  /** Poll layout settings. */
  poll?: Maybe<WixRichContentV1PollDataLayoutPollLayout>;
};

export type WixRichContentV1PollDataLayoutInput = {
  /** Voting otpions layout settings. */
  options?: InputMaybe<WixRichContentV1PollDataLayoutOptionLayoutInput>;
  /** Poll layout settings. */
  poll?: InputMaybe<WixRichContentV1PollDataLayoutPollLayoutInput>;
};

export type WixRichContentV1PollDataLayoutOptionLayout = {
  /** Sets whether to display option images. Defaults to `false`. */
  enableImage?: Maybe<Scalars['Boolean']>;
};

export type WixRichContentV1PollDataLayoutOptionLayoutInput = {
  /** Sets whether to display option images. Defaults to `false`. */
  enableImage?: InputMaybe<Scalars['Boolean']>;
};

export type WixRichContentV1PollDataLayoutPollLayout = {
  /** The direction of the text displayed in the voting options. Text can be displayed either right-to-left or left-to-right. */
  direction?: Maybe<WixRichContentV1PollDataLayoutPollLayoutDirection>;
  /** Sets whether to display the main poll image. Defaults to `false`. */
  enableImage?: Maybe<Scalars['Boolean']>;
  /** The layout for displaying the voting options. */
  type?: Maybe<WixRichContentV1PollDataLayoutPollLayoutType>;
};

export enum WixRichContentV1PollDataLayoutPollLayoutDirection {
  /** Left-to-right */
  LTR = 'LTR',
  /** Right-to-left */
  RTL = 'RTL'
}

export type WixRichContentV1PollDataLayoutPollLayoutInput = {
  /** The direction of the text displayed in the voting options. Text can be displayed either right-to-left or left-to-right. */
  direction?: InputMaybe<WixRichContentV1PollDataLayoutPollLayoutDirection>;
  /** Sets whether to display the main poll image. Defaults to `false`. */
  enableImage?: InputMaybe<Scalars['Boolean']>;
  /** The layout for displaying the voting options. */
  type?: InputMaybe<WixRichContentV1PollDataLayoutPollLayoutType>;
};

export enum WixRichContentV1PollDataLayoutPollLayoutType {
  /** Grid */
  GRID = 'GRID',
  /** List */
  LIST = 'LIST'
}

export type WixRichContentV1PollDataPoll = {
  /** Poll creator ID. */
  creatorId?: Maybe<Scalars['String']>;
  /** Poll ID. */
  id?: Maybe<Scalars['String']>;
  /** Main poll image. */
  image?: Maybe<WixRichContentV1Media>;
  /** Voting options. */
  options?: Maybe<Array<Maybe<WixRichContentV1PollDataPollOption>>>;
  /** The poll's permissions and display settings. */
  settings?: Maybe<WixRichContentV1PollDataPollSettings>;
  /** Poll title. */
  title?: Maybe<Scalars['String']>;
};

export type WixRichContentV1PollDataPollInput = {
  /** Poll creator ID. */
  creatorId?: InputMaybe<Scalars['String']>;
  /** Poll ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Main poll image. */
  image?: InputMaybe<WixRichContentV1MediaInput>;
  /** Voting options. */
  options?: InputMaybe<Array<InputMaybe<WixRichContentV1PollDataPollOptionInput>>>;
  /** The poll's permissions and display settings. */
  settings?: InputMaybe<WixRichContentV1PollDataPollSettingsInput>;
  /** Poll title. */
  title?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1PollDataPollOption = {
  /** Option ID. */
  id?: Maybe<Scalars['String']>;
  /** The image displayed with the option. */
  image?: Maybe<WixRichContentV1Media>;
  /** Option title. */
  title?: Maybe<Scalars['String']>;
};

export type WixRichContentV1PollDataPollOptionInput = {
  /** Option ID. */
  id?: InputMaybe<Scalars['String']>;
  /** The image displayed with the option. */
  image?: InputMaybe<WixRichContentV1MediaInput>;
  /** Option title. */
  title?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1PollDataPollSettings = {
  /** Permissions settings for voting. */
  permissions?: Maybe<WixRichContentV1PollDataPollSettingsPermissions>;
  /** Sets whether voters are displayed in the vote results. Defaults to `true`. */
  showVoters?: Maybe<Scalars['Boolean']>;
  /** Sets whether the vote count is displayed. Defaults to `true`. */
  showVotesCount?: Maybe<Scalars['Boolean']>;
};

export type WixRichContentV1PollDataPollSettingsInput = {
  /** Permissions settings for voting. */
  permissions?: InputMaybe<WixRichContentV1PollDataPollSettingsPermissionsInput>;
  /** Sets whether voters are displayed in the vote results. Defaults to `true`. */
  showVoters?: InputMaybe<Scalars['Boolean']>;
  /** Sets whether the vote count is displayed. Defaults to `true`. */
  showVotesCount?: InputMaybe<Scalars['Boolean']>;
};

export type WixRichContentV1PollDataPollSettingsPermissions = {
  /** Sets whether one voter can vote multiple times. Defaults to `false`. */
  allowMultipleVotes?: Maybe<Scalars['Boolean']>;
  /** Sets who can view the poll results. */
  view?: Maybe<WixRichContentV1PollDataPollSettingsPermissionsViewRole>;
  /** Sets who can vote. */
  vote?: Maybe<WixRichContentV1PollDataPollSettingsPermissionsVoteRole>;
};

export type WixRichContentV1PollDataPollSettingsPermissionsInput = {
  /** Sets whether one voter can vote multiple times. Defaults to `false`. */
  allowMultipleVotes?: InputMaybe<Scalars['Boolean']>;
  /** Sets who can view the poll results. */
  view?: InputMaybe<WixRichContentV1PollDataPollSettingsPermissionsViewRole>;
  /** Sets who can vote. */
  vote?: InputMaybe<WixRichContentV1PollDataPollSettingsPermissionsVoteRole>;
};

export enum WixRichContentV1PollDataPollSettingsPermissionsViewRole {
  /** Only Poll creator can view the results */
  CREATOR = 'CREATOR',
  /** Anyone can see the results, even if one didn't vote */
  EVERYONE = 'EVERYONE',
  /** Anyone who voted can see the results */
  VOTERS = 'VOTERS'
}

export enum WixRichContentV1PollDataPollSettingsPermissionsVoteRole {
  /** Anyone */
  ALL = 'ALL',
  /** Logged in member */
  SITE_MEMBERS = 'SITE_MEMBERS'
}

export type WixRichContentV1RichContent = {
  /** Global styling for header, paragraph, block quote, and code block nodes in the object. */
  documentStyle?: Maybe<WixRichContentV1DocumentStyle>;
  /** Object metadata. */
  metadata?: Maybe<WixRichContentV1Metadata>;
  /** Node objects representing a rich content document. */
  nodes?: Maybe<Array<Maybe<WixRichContentV1Node>>>;
};

export type WixRichContentV1RichContentInput = {
  /** Global styling for header, paragraph, block quote, and code block nodes in the object. */
  documentStyle?: InputMaybe<WixRichContentV1DocumentStyleInput>;
  /** Object metadata. */
  metadata?: InputMaybe<WixRichContentV1MetadataInput>;
  /** Node objects representing a rich content document. */
  nodes?: InputMaybe<Array<InputMaybe<WixRichContentV1NodeInput>>>;
};

export type WixRichContentV1SpoilerData = {
  /** Spoiler ID. */
  id?: Maybe<Scalars['String']>;
};

export type WixRichContentV1SpoilerDataInput = {
  /** Spoiler ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1Struct = {
  /** An unordered map of dynamically typed values. */
  fields?: Maybe<WixRichContentV1Value>;
};

export type WixRichContentV1StructInput = {
  /** An unordered map of dynamically typed values. */
  fields?: InputMaybe<WixRichContentV1ValueInput>;
};

export type WixRichContentV1TableCellData = {
  /** The cell's border colors. */
  borderColors?: Maybe<WixRichContentV1TableCellDataBorderColors>;
  /** The cell's border widths. */
  borderWidths?: Maybe<WixRichContentV1TableCellDataBorderWidths>;
  /** Styling for the cell's background color and text alignment. */
  cellStyle?: Maybe<WixRichContentV1TableCellDataCellStyle>;
  /** Defines how many columns the cell spans. Default: 1. */
  colspan?: Maybe<Scalars['Int']>;
  /** Defines how many rows the cell spans. Default: 1. */
  rowspan?: Maybe<Scalars['Int']>;
};

export type WixRichContentV1TableCellDataBorderColors = {
  /** Bottom border color as a hexadecimal value. */
  bottom?: Maybe<Scalars['String']>;
  /** Left border color as a hexadecimal value. */
  left?: Maybe<Scalars['String']>;
  /** Right border color as a hexadecimal value. */
  right?: Maybe<Scalars['String']>;
  /** Top border color as a hexadecimal value. */
  top?: Maybe<Scalars['String']>;
};

export type WixRichContentV1TableCellDataBorderColorsInput = {
  /** Bottom border color as a hexadecimal value. */
  bottom?: InputMaybe<Scalars['String']>;
  /** Left border color as a hexadecimal value. */
  left?: InputMaybe<Scalars['String']>;
  /** Right border color as a hexadecimal value. */
  right?: InputMaybe<Scalars['String']>;
  /** Top border color as a hexadecimal value. */
  top?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1TableCellDataBorderWidths = {
  /** Bottom border width in pixels. */
  bottom?: Maybe<Scalars['Int']>;
  /** Left border width in pixels. */
  left?: Maybe<Scalars['Int']>;
  /** Right border width in pixels. */
  right?: Maybe<Scalars['Int']>;
  /** Top border width in pixels. */
  top?: Maybe<Scalars['Int']>;
};

export type WixRichContentV1TableCellDataBorderWidthsInput = {
  /** Bottom border width in pixels. */
  bottom?: InputMaybe<Scalars['Int']>;
  /** Left border width in pixels. */
  left?: InputMaybe<Scalars['Int']>;
  /** Right border width in pixels. */
  right?: InputMaybe<Scalars['Int']>;
  /** Top border width in pixels. */
  top?: InputMaybe<Scalars['Int']>;
};

export type WixRichContentV1TableCellDataCellStyle = {
  /** Cell background color as a hexadecimal value. */
  backgroundColor?: Maybe<Scalars['String']>;
  /** Vertical alignment for the cell's text. */
  verticalAlignment?: Maybe<WixRichContentV1TableCellDataVerticalAlignment>;
};

export type WixRichContentV1TableCellDataCellStyleInput = {
  /** Cell background color as a hexadecimal value. */
  backgroundColor?: InputMaybe<Scalars['String']>;
  /** Vertical alignment for the cell's text. */
  verticalAlignment?: InputMaybe<WixRichContentV1TableCellDataVerticalAlignment>;
};

export type WixRichContentV1TableCellDataInput = {
  /** The cell's border colors. */
  borderColors?: InputMaybe<WixRichContentV1TableCellDataBorderColorsInput>;
  /** The cell's border widths. */
  borderWidths?: InputMaybe<WixRichContentV1TableCellDataBorderWidthsInput>;
  /** Styling for the cell's background color and text alignment. */
  cellStyle?: InputMaybe<WixRichContentV1TableCellDataCellStyleInput>;
  /** Defines how many columns the cell spans. Default: 1. */
  colspan?: InputMaybe<Scalars['Int']>;
  /** Defines how many rows the cell spans. Default: 1. */
  rowspan?: InputMaybe<Scalars['Int']>;
};

export enum WixRichContentV1TableCellDataVerticalAlignment {
  /** Bottom alignment */
  BOTTOM = 'BOTTOM',
  /** Middle alignment */
  MIDDLE = 'MIDDLE',
  /** Top alignment */
  TOP = 'TOP'
}

export type WixRichContentV1TableData = {
  /** Padding in pixels for cells. Follows CSS order: top, right, bottom, left. */
  cellPadding?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** The spacing between cells in pixels. Defaults to `0`. */
  cellSpacing?: Maybe<Scalars['Int']>;
  /** Sets whether the table's first column is a header. Defaults to `false`. */
  columnHeader?: Maybe<Scalars['Boolean']>;
  /** Styling for the table's container. */
  containerData?: Maybe<WixRichContentV1PluginContainerData>;
  /** The table's dimensions. */
  dimensions?: Maybe<WixRichContentV1TableDataDimensions>;
  /** Deprecated: Use `rowHeader` and `columnHeader` instead. */
  header?: Maybe<Scalars['Boolean']>;
  /** Sets whether the table's first row is a header. Defaults to `false`. */
  rowHeader?: Maybe<Scalars['Boolean']>;
};

export type WixRichContentV1TableDataDimensions = {
  /** An array representing the minimum width of each column in pixels. */
  colsMinWidth?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** An array representing relative width of each column in relation to the other columns. */
  colsWidthRatio?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** An array representing the height of each row in pixels. */
  rowsHeight?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type WixRichContentV1TableDataDimensionsInput = {
  /** An array representing the minimum width of each column in pixels. */
  colsMinWidth?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** An array representing relative width of each column in relation to the other columns. */
  colsWidthRatio?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** An array representing the height of each row in pixels. */
  rowsHeight?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type WixRichContentV1TableDataInput = {
  /** Padding in pixels for cells. Follows CSS order: top, right, bottom, left. */
  cellPadding?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** The spacing between cells in pixels. Defaults to `0`. */
  cellSpacing?: InputMaybe<Scalars['Int']>;
  /** Sets whether the table's first column is a header. Defaults to `false`. */
  columnHeader?: InputMaybe<Scalars['Boolean']>;
  /** Styling for the table's container. */
  containerData?: InputMaybe<WixRichContentV1PluginContainerDataInput>;
  /** The table's dimensions. */
  dimensions?: InputMaybe<WixRichContentV1TableDataDimensionsInput>;
  /** Deprecated: Use `rowHeader` and `columnHeader` instead. */
  header?: InputMaybe<Scalars['Boolean']>;
  /** Sets whether the table's first row is a header. Defaults to `false`. */
  rowHeader?: InputMaybe<Scalars['Boolean']>;
};

export type WixRichContentV1TextData = {
  /** The decorations to apply. */
  decorations?: Maybe<Array<Maybe<WixRichContentV1Decoration>>>;
  /** The text to apply decorations to. */
  text?: Maybe<Scalars['String']>;
};

export type WixRichContentV1TextDataInput = {
  /** The decorations to apply. */
  decorations?: InputMaybe<Array<InputMaybe<WixRichContentV1DecorationInput>>>;
  /** The text to apply decorations to. */
  text?: InputMaybe<Scalars['String']>;
};

export type WixRichContentV1TextNodeStyle = {
  /** The decorations to apply to the node. */
  decorations?: Maybe<Array<Maybe<WixRichContentV1Decoration>>>;
  /** Line height for text in the node. */
  lineHeight?: Maybe<Scalars['String']>;
  /** Padding and background color for the node. */
  nodeStyle?: Maybe<WixRichContentV1NodeStyle>;
};

export type WixRichContentV1TextNodeStyleInput = {
  /** The decorations to apply to the node. */
  decorations?: InputMaybe<Array<InputMaybe<WixRichContentV1DecorationInput>>>;
  /** Line height for text in the node. */
  lineHeight?: InputMaybe<Scalars['String']>;
  /** Padding and background color for the node. */
  nodeStyle?: InputMaybe<WixRichContentV1NodeStyleInput>;
};

export type WixRichContentV1TextStyle = {
  /** A CSS `line-height` value for the text expressed as a ratio relative to the font size. For example, if the font size is 20px, a `lineHeight` value of `'1.5'`` results in a line height of 30px. */
  lineHeight?: Maybe<Scalars['String']>;
  /** Text alignment. Defaults to `AUTO`. */
  textAlignment?: Maybe<WixRichContentV1TextStyleTextAlignment>;
};

export type WixRichContentV1TextStyleInput = {
  /** A CSS `line-height` value for the text expressed as a ratio relative to the font size. For example, if the font size is 20px, a `lineHeight` value of `'1.5'`` results in a line height of 30px. */
  lineHeight?: InputMaybe<Scalars['String']>;
  /** Text alignment. Defaults to `AUTO`. */
  textAlignment?: InputMaybe<WixRichContentV1TextStyleTextAlignment>;
};

export enum WixRichContentV1TextStyleTextAlignment {
  /** browser default, eqivalent to `initial` */
  AUTO = 'AUTO',
  /** Center align */
  CENTER = 'CENTER',
  /** Text is spaced to line up its left and right edges to the left and right edges of the line box, except for the last line */
  JUSTIFY = 'JUSTIFY',
  /** Left align */
  LEFT = 'LEFT',
  /** Right align */
  RIGHT = 'RIGHT'
}

export type WixRichContentV1Value = {
  /** A boolean value. */
  boolValue?: Maybe<Scalars['Boolean']>;
  /** An array of `value` objects. */
  listValue?: Maybe<WixRichContentV1ListValue>;
  /** A null value. */
  nullValue?: Maybe<WixRichContentV1NullValue>;
  /** A double value. */
  numberValue?: Maybe<Scalars['Float']>;
  /** A string value. */
  stringValue?: Maybe<Scalars['String']>;
  /** A structured value. */
  structValue?: Maybe<WixRichContentV1Struct>;
};

export type WixRichContentV1ValueInput = {
  /** A boolean value. */
  boolValue?: InputMaybe<Scalars['Boolean']>;
  /** An array of `value` objects. */
  listValue?: InputMaybe<WixRichContentV1ListValueInput>;
  /** A null value. */
  nullValue?: InputMaybe<WixRichContentV1NullValue>;
  /** A double value. */
  numberValue?: InputMaybe<Scalars['Float']>;
  /** A string value. */
  stringValue?: InputMaybe<Scalars['String']>;
  /** A structured value. */
  structValue?: InputMaybe<WixRichContentV1StructInput>;
};

export type WixRichContentV1VideoData = {
  /** Styling for the video's container. */
  containerData?: Maybe<WixRichContentV1PluginContainerData>;
  /** Sets whether the video's download button is disabled. Defaults to `false`. */
  disableDownload?: Maybe<Scalars['Boolean']>;
  /** Video options. */
  options?: Maybe<WixRichContentV1PlaybackOptions>;
  /** Video thumbnail details. */
  thumbnail?: Maybe<WixRichContentV1Media>;
  /** Video title. */
  title?: Maybe<Scalars['String']>;
  /** Video details. */
  video?: Maybe<WixRichContentV1Media>;
};

export type WixRichContentV1VideoDataInput = {
  /** Styling for the video's container. */
  containerData?: InputMaybe<WixRichContentV1PluginContainerDataInput>;
  /** Sets whether the video's download button is disabled. Defaults to `false`. */
  disableDownload?: InputMaybe<Scalars['Boolean']>;
  /** Video options. */
  options?: InputMaybe<WixRichContentV1PlaybackOptionsInput>;
  /** Video thumbnail details. */
  thumbnail?: InputMaybe<WixRichContentV1MediaInput>;
  /** Video title. */
  title?: InputMaybe<Scalars['String']>;
  /** Video details. */
  video?: InputMaybe<WixRichContentV1MediaInput>;
};

export type WixRiseV1ActionInitiator = {
  /** ID of the initiator */
  id?: Maybe<Scalars['String']>;
  /** The type of the initiator (e.g., app, user) */
  type?: Maybe<WixRiseV1ActionInitiatorInitiatorType>;
};

export enum WixRiseV1ActionInitiatorInitiatorType {
  APP = 'APP',
  UNKNOWN_INITIATOR = 'UNKNOWN_INITIATOR',
  USER = 'USER'
}

export type WixRiseV1ActionInitiatorInput = {
  /** ID of the initiator */
  id?: InputMaybe<Scalars['String']>;
  /** The type of the initiator (e.g., app, user) */
  type?: InputMaybe<WixRiseV1ActionInitiatorInitiatorType>;
};

export type WixRiseV1AddCustomerReferenceRequestInput = {
  /** Customer reference */
  customerReference?: InputMaybe<WixRiseV1CustomerReferenceInput>;
  /** Wallet ID */
  walletId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1AddCustomerReferenceResponse = {
  /** Customer reference */
  customerReference?: Maybe<WixRiseV1CustomerReference>;
};

export type WixRiseV1BulkCreateMigrationTransactionsRequestInput = {
  /** The gift card ID for all transactions */
  giftCardId?: InputMaybe<Scalars['String']>;
  /** The transactions to create in bulk for this gift card */
  transactions?: InputMaybe<Array<InputMaybe<WixRiseV1TransactionInput>>>;
};

export type WixRiseV1BulkCreateMigrationTransactionsResponse = {
  /** The created transactions */
  transactions?: Maybe<Array<Maybe<WixRiseV1Transaction>>>;
};

export type WixRiseV1BulkCreateMigrationWalletActionsRequestInput = {
  /** ID of the gift card that belongs to the wallet. */
  giftCardId?: InputMaybe<Scalars['String']>;
  /** Set to `true` to receive the created WalletActions in the response. */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /** List of WalletActions to be created. Maximum 100 items per request. */
  walletActions?: InputMaybe<Array<InputMaybe<WixRiseV1WalletActionInput>>>;
};

export type WixRiseV1BulkCreateMigrationWalletActionsResponse = {
  /** list of wallet actions created. */
  walletActions?: Maybe<Array<Maybe<WixRiseV1WalletAction>>>;
};

export type WixRiseV1BulkDeleteGiftCardsByFilterRequestInput = {
  /** Expected gift card amount to delete */
  expectedAmount?: InputMaybe<Scalars['Int']>;
  /** MSID from which to delete the gift cards */
  metaSiteId?: InputMaybe<Scalars['String']>;
  /** WQL expression */
  query?: InputMaybe<WixCommonQueryV2Input>;
};

export type WixRiseV1BulkDeleteGiftCardsByFilterResponse = {
  jobId?: Maybe<Scalars['String']>;
};

export type WixRiseV1BulkEndMigrationWalletActionsRequestInput = {
  /** ID of the gift card that belongs to the wallet */
  giftCardId?: InputMaybe<Scalars['String']>;
  /** Set to `true` to receive the ended WalletActions in the response. */
  returnEntity?: InputMaybe<Scalars['Boolean']>;
  /** List of wallet actions to end with their amounts. Maximum 800 items per request. */
  walletActions?: InputMaybe<Array<InputMaybe<WixRiseV1WalletActionEndDetailsInput>>>;
};

export type WixRiseV1BulkEndMigrationWalletActionsResponse = {
  /** List of ended wallet actions */
  walletActions?: Maybe<Array<Maybe<WixRiseV1WalletAction>>>;
};

export type WixRiseV1BulkOptions = {
  /** ID of the bulk that issued the gift card or transaction. */
  bulkId?: Maybe<Scalars['String']>;
  /** Indicates whether the gift card or transaction is a liability. */
  liability?: Maybe<Scalars['Boolean']>;
  /** Internal note about the bulk */
  note?: Maybe<Scalars['String']>;
};

export type WixRiseV1BulkOptionsInput = {
  /** ID of the bulk that issued the gift card or transaction. */
  bulkId?: InputMaybe<Scalars['String']>;
  /** Indicates whether the gift card or transaction is a liability. */
  liability?: InputMaybe<Scalars['Boolean']>;
  /** Internal note about the bulk */
  note?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1BulkUpdateWalletActionTagsByFilterRequestInput = {
  /** List of Tags to assign */
  assignTags?: InputMaybe<WixRiseWalletActionV1UpstreamWixCommonTagsInput>;
  /** Filter */
  filter?: InputMaybe<Scalars['JSON']>;
  /** List of Tags to unAssign */
  unassignTags?: InputMaybe<WixRiseWalletActionV1UpstreamWixCommonTagsInput>;
};

export type WixRiseV1BulkUpdateWalletActionTagsByFilterResponse = {
  /** Job ID */
  jobId?: Maybe<Scalars['String']>;
};

export type WixRiseV1BulkUpdateWalletActionTagsRequestInput = {
  /** List of Tags to assign */
  assignTags?: InputMaybe<WixRiseWalletActionV1UpstreamWixCommonTagsInput>;
  /** List of wallet-actions that their tags will update. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** List of Tags to unAssign */
  unassignTags?: InputMaybe<WixRiseWalletActionV1UpstreamWixCommonTagsInput>;
};

export type WixRiseV1BulkUpdateWalletActionTagsResponse = {
  /** Metadata regarding the bulk update operation */
  bulkActionMetadata?: Maybe<WixRiseWalletActionV1UpstreamWixCommonBulkActionMetadata>;
  /** Results */
  results?: Maybe<Array<Maybe<WixRiseV1BulkUpdateWalletActionTagsResponseBulkUpdateWalletActionTagsResult>>>;
};

export type WixRiseV1BulkUpdateWalletActionTagsResponseBulkUpdateWalletActionTagsResult = {
  /** Metadata regarding the specific single update operation */
  itemMetadata?: Maybe<WixRiseWalletActionV1UpstreamWixCommonItemMetadata>;
};

export type WixRiseV1CampaignOptions = {
  campaignId?: Maybe<Scalars['String']>;
  liability?: Maybe<Scalars['Boolean']>;
};

export type WixRiseV1CampaignOptionsInput = {
  campaignId?: InputMaybe<Scalars['String']>;
  liability?: InputMaybe<Scalars['Boolean']>;
};

export type WixRiseV1ContactDetails = {
  /** Email of the wallet. */
  email?: Maybe<Scalars['String']>;
  /** First name of the wallet. */
  firstName?: Maybe<Scalars['String']>;
  /** Last name of the wallet. */
  lastName?: Maybe<Scalars['String']>;
  /** Phone number of the wallet. */
  phone?: Maybe<Scalars['String']>;
};

export type WixRiseV1ContactDetailsInput = {
  /** Email of the wallet. */
  email?: InputMaybe<Scalars['String']>;
  /** First name of the wallet. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Last name of the wallet. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Phone number of the wallet. */
  phone?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1CountGiftCardsRequestInput = {
  /** [API Query Language](https://platform.rise.ai/docs/#tag/About-API-Query-Language) filter to count gift cards. */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type WixRiseV1CountGiftCardsResponse = {
  /** The number of gift cards that match the provided filter. */
  count?: Maybe<Scalars['Int']>;
};

export type WixRiseV1CountWalletsRequestInput = {
  /** Filter by which to count wallets. */
  filter?: InputMaybe<Scalars['JSON']>;
};

export type WixRiseV1CountWalletsResponse = {
  /** Number of wallets matching the filter. */
  count?: Maybe<Scalars['Int']>;
};

export type WixRiseV1CreateCustomerReferenceRequestInput = {
  /** Customer reference */
  customerReference?: InputMaybe<WixRiseV1CustomerReferenceInput>;
};

export type WixRiseV1CreateCustomerReferenceResponse = {
  /** Customer reference */
  customerReference?: Maybe<WixRiseV1CustomerReference>;
};

export type WixRiseV1CreateGiftCardRequestInput = {
  /** The GiftCard to create. */
  giftCard?: InputMaybe<WixRiseV1GiftCardInput>;
};

export type WixRiseV1CreateGiftCardResponse = {
  /** The created GiftCard. */
  giftCard?: Maybe<WixRiseV1GiftCard>;
};

export type WixRiseV1CreateMigrationGiftCardRequestInput = {
  /** The gift card to create. */
  giftCard?: InputMaybe<WixRiseV1GiftCardInput>;
};

export type WixRiseV1CreateMigrationGiftCardResponse = {
  /** The created gift card. */
  giftCard?: Maybe<WixRiseV1GiftCard>;
};

export type WixRiseV1CreateMigrationTransactionRequestInput = {
  /** The transaction to create. */
  transaction?: InputMaybe<WixRiseV1TransactionInput>;
};

export type WixRiseV1CreateMigrationTransactionResponse = {
  /** The created transaction. */
  transaction?: Maybe<WixRiseV1Transaction>;
};

export type WixRiseV1CreateMigrationWalletActionRequestInput = {
  /** ID of the giftcard that belongs to the wallet. */
  giftCardId?: InputMaybe<Scalars['String']>;
  /** WalletAction to be created. */
  walletAction?: InputMaybe<WixRiseV1WalletActionInput>;
};

export type WixRiseV1CreateMigrationWalletActionResponse = {
  /** The created WalletAction. */
  walletAction?: Maybe<WixRiseV1WalletAction>;
};

export type WixRiseV1CreateWalletActionByCustomerReferenceRequestInput = {
  /** CustomerReference of the customer for which to create the wallet action. */
  customerReference?: InputMaybe<WixRiseV1CustomerReferenceInput>;
  /** The currency for the new wallet, if no wallet already exists. */
  newWalletCurrency?: InputMaybe<Scalars['String']>;
  /** WalletAction to be created. */
  walletAction?: InputMaybe<WixRiseV1WalletActionInput>;
};

export type WixRiseV1CreateWalletActionByCustomerReferenceResponse = {
  /** The wallet to which the wallet action was added. */
  wallet?: Maybe<WixRiseV1Wallet>;
  /** The created WalletAction. */
  walletAction?: Maybe<WixRiseV1WalletAction>;
};

export type WixRiseV1CreateWalletActionRequestInput = {
  /** WalletAction to be created. */
  walletAction?: InputMaybe<WixRiseV1WalletActionInput>;
};

export type WixRiseV1CreateWalletActionResponse = {
  /** The created WalletAction. */
  walletAction?: Maybe<WixRiseV1WalletAction>;
};

export type WixRiseV1CreateWalletRequestInput = {
  /** Currency of the wallet. */
  currency?: InputMaybe<Scalars['String']>;
  /** Initial Customer Reference for the wallet. */
  customerReference?: InputMaybe<WixRiseV1CustomerReferenceInput>;
  /** Initial amount of store credit. */
  initialValue?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1CreateWalletResponse = {
  /** Created wallet. */
  wallet?: Maybe<WixRiseV1Wallet>;
  /** ID of the walletAction (store credit) created by this request. */
  walletActionId?: Maybe<Scalars['String']>;
};

export type WixRiseV1CreateWalletV2RequestInput = {
  /** Contact details of the wallet. */
  contactDetails?: InputMaybe<WixRiseV1ContactDetailsInput>;
  /** Currency of the wallet. */
  currency?: InputMaybe<Scalars['String']>;
  /** Optional initial Customer Reference for the wallet. */
  customerReference?: InputMaybe<WixRiseV1CustomerReferenceInput>;
};

export type WixRiseV1CreateWalletV2Response = {
  /** Created wallet. */
  wallet?: Maybe<WixRiseV1Wallet>;
};

export type WixRiseV1CustomerReference = {
  /** Internal Rise id. */
  contact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
  /** Email address. */
  email?: Maybe<Scalars['String']>;
  /** First name. */
  firstName?: Maybe<Scalars['String']>;
  /** Internal Rise id. */
  id?: Maybe<Scalars['String']>;
  /** Last name. */
  lastName?: Maybe<Scalars['String']>;
  /** Phone number. */
  phone?: Maybe<Scalars['String']>;
  /** Source channel, i.e. Shopify. */
  sourceChannelId?: Maybe<Scalars['String']>;
  /** Customer ID in Source. */
  sourceCustomerId?: Maybe<Scalars['String']>;
  /** Tenant ID in Source, i.e. shop ID. */
  sourceTenantId?: Maybe<Scalars['String']>;
};

export type WixRiseV1CustomerReferenceInput = {
  /** Email address. */
  email?: InputMaybe<Scalars['String']>;
  /** First name. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Internal Rise id. */
  id?: InputMaybe<Scalars['String']>;
  /** Last name. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Phone number. */
  phone?: InputMaybe<Scalars['String']>;
  /** Source channel, i.e. Shopify. */
  sourceChannelId?: InputMaybe<Scalars['String']>;
  /** Customer ID in Source. */
  sourceCustomerId?: InputMaybe<Scalars['String']>;
  /** Tenant ID in Source, i.e. shop ID. */
  sourceTenantId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1CustomerReferenceQueryInput = {
  /** CustomerReference source (i.e. source channel, tenant, and customer IDs) */
  customerReferenceSource?: InputMaybe<WixRiseV1SourceInput>;
};

export type WixRiseV1DecreaseBalanceRequestInput = {
  /** The Transaction to be created. */
  transaction?: InputMaybe<WixRiseV1TransactionInput>;
};

export type WixRiseV1DecreaseBalanceResponse = {
  /** GiftCard balance after Transaction. */
  balance?: Maybe<Scalars['String']>;
  /** Transaction Currency. */
  currency?: Maybe<Scalars['String']>;
  /** The created Transaction. */
  transaction?: Maybe<WixRiseV1Transaction>;
};

export type WixRiseV1DeleteCustomerReferenceRequestInput = {
  /** Query by customer reference source (i.e. source channel, tenant, and customer IDs) */
  query?: InputMaybe<WixRiseV1CustomerReferenceQueryInput>;
};

export type WixRiseV1DeleteWalletActionRequestInput = {
  /** The revision of the WalletAction. */
  revision?: InputMaybe<Scalars['Long']>;
  /** ID of the WalletAction to delete. */
  walletActionId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1DisableGiftCardRequestInput = {
  /** The ID of the GiftCard to disable. */
  giftCardId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1DisableGiftCardResponse = {
  /** The disabled GiftCard. */
  giftCard?: Maybe<WixRiseV1GiftCard>;
};

export type WixRiseV1DisableWalletActionRequestInput = {
  /** The revision of the WalletAction. */
  revision?: InputMaybe<Scalars['Long']>;
  /** ID of the WalletAction to delete. */
  walletActionId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1DisableWalletActionResponse = {
  /** The disabled WalletAction. */
  walletAction?: Maybe<WixRiseV1WalletAction>;
};

export type WixRiseV1EndMigrationWalletActionRequestInput = {
  /** Amount of the WalletAction to subtract from the wallet. */
  amountToSubtract?: InputMaybe<Scalars['String']>;
  /** ID of the giftcard that belongs to the wallet. */
  giftCardId?: InputMaybe<Scalars['String']>;
  /** ID of the WalletAction to be ended. */
  walletActionId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1EndMigrationWalletActionResponse = {
  /** The ended WalletAction. */
  walletAction?: Maybe<WixRiseV1WalletAction>;
};

export type WixRiseV1ExternalEvent = {
  /** Short description or identifier of the event */
  description?: Maybe<Scalars['String']>;
  /** Event type indicator */
  name?: Maybe<WixRiseV1ExternalEventExternalEventType>;
};

export enum WixRiseV1ExternalEventExternalEventType {
  COMPENSATION = 'COMPENSATION',
  MEMBERSHIP = 'MEMBERSHIP',
  ORDER = 'ORDER',
  OTHER = 'OTHER',
  REFERRAL = 'REFERRAL',
  REFUND = 'REFUND',
  SIGN_UP = 'SIGN_UP',
  UNKNOWN_EVENT_TYPE = 'UNKNOWN_EVENT_TYPE'
}

export type WixRiseV1ExternalEventInput = {
  /** Short description or identifier of the event */
  description?: InputMaybe<Scalars['String']>;
  /** Event type indicator */
  name?: InputMaybe<WixRiseV1ExternalEventExternalEventType>;
};

export type WixRiseV1GetCustomerReferenceRequestInput = {
  /** Customer Reference query object. */
  query?: InputMaybe<WixRiseV1CustomerReferenceQueryInput>;
};

export type WixRiseV1GetCustomerReferenceResponse = {
  /** Retrieved Customer reference. */
  customerReference?: Maybe<WixRiseV1CustomerReference>;
};

export type WixRiseV1GetGiftCardConsistentRequestInput = {
  /** The ID of the GiftCard to retrieve. */
  giftCardId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1GetGiftCardConsistentResponse = {
  /** The retrieved GiftCard. */
  giftCard?: Maybe<WixRiseV1GiftCard>;
};

export type WixRiseV1GetGiftCardRequestInput = {
  id: Scalars['ID'];
};

export type WixRiseV1GetOrCreateWalletRequestInput = {
  /** Currency of the wallet. */
  currency?: InputMaybe<Scalars['String']>;
  /** The customer reference with which to create or retrieve the wallet. */
  customerReference?: InputMaybe<WixRiseV1CustomerReferenceInput>;
};

export type WixRiseV1GetOrCreateWalletResponse = {
  /** The retrieved or created wallet. */
  wallet?: Maybe<WixRiseV1Wallet>;
};

export type WixRiseV1GetOrCreateWalletV2RequestInput = {
  /** Contact details of the wallet. */
  contactDetails?: InputMaybe<WixRiseV1ContactDetailsInput>;
  /** Optional initial Customer Reference for the wallet. */
  customerReference?: InputMaybe<WixRiseV1CustomerReferenceInput>;
};

export type WixRiseV1GetOrCreateWalletV2Response = {
  /** The retrieved or created wallet. */
  wallet?: Maybe<WixRiseV1Wallet>;
};

export type WixRiseV1GetRefundableAmountsRequestInput = {
  /** ID of the transaction to get refundable amounts for */
  transactionId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1GetRefundableAmountsResponse = {
  amounts?: Maybe<Array<Maybe<WixRiseV1RefundableAmount>>>;
};

export type WixRiseV1GetTransactionRequestInput = {
  id: Scalars['ID'];
};

export type WixRiseV1GetWalletActionRequestInput = {
  id: Scalars['ID'];
};

export type WixRiseV1GetWalletGiftCardRequestInput = {
  /** Wallet ID, email, or customer reference source by which to retrieve the gift card. */
  query?: InputMaybe<WixRiseV1WalletQueryInput>;
};

export type WixRiseV1GetWalletGiftCardResponse = {
  /** The retrieved Gift Card. */
  giftCard?: Maybe<WixRiseV1GiftCard>;
};

export type WixRiseV1GetWalletRequestInput = {
  id: Scalars['ID'];
};

export type WixRiseV1GetWalletResponse = {
  /** The retrieved Wallet. */
  wallet?: Maybe<WixRiseV1Wallet>;
};

export type WixRiseV1GetWalletV2RequestInput = {
  /** Additional fields to include in the response. */
  fields?: InputMaybe<Array<InputMaybe<WixRiseV1RequestedFields>>>;
  /** Query object. */
  query?: InputMaybe<WixRiseV1WalletQueryInput>;
};

export type WixRiseV1GetWalletV2Response = {
  /** The retrieved Wallet. */
  wallet?: Maybe<WixRiseV1Wallet>;
};

export type WixRiseV1GiftCard = {
  /** Current balance of the Gift Card. */
  balance?: Maybe<Scalars['String']>;
  /** Gift Card code for redemption. */
  code?: Maybe<Scalars['String']>;
  /** Last 4 characters of the gift card code for easier reference and searching. */
  codeSuffix?: Maybe<Scalars['String']>;
  /** Gift Card creation date. */
  createdDate?: Maybe<Scalars['String']>;
  /** Gift Card currency. */
  currency?: Maybe<Scalars['String']>;
  /** Gift Card disable date, if the gift card was disabled. */
  disableDate?: Maybe<Scalars['String']>;
  /** Gift Card expiration date. */
  expirationDate?: Maybe<Scalars['String']>;
  /** Unique ID of the Gift Card. */
  id?: Maybe<Scalars['String']>;
  /** Gift Card idempotency key, to prevent duplicate creation. */
  idempotencyKey?: Maybe<Scalars['String']>;
  /** Initial value of the Gift Card. */
  initialValue?: Maybe<Scalars['String']>;
  /** Internal field to optimize the logic of Reminders feature. */
  lastActivityForReminders?: Maybe<Scalars['String']>;
  /**
   * ID of the last transaction that modified the gift card balance.
   * @deprecated ID of the last transaction that modified the gift card balance. Replaced by: transaction_details.last_transaction.id. Removal date: 2026-03-01.
   */
  lastTransactionId?: Maybe<Scalars['String']>;
  /** Gift Card revision. */
  revision?: Maybe<Scalars['Long']>;
  /** Information about the source of the gift card. */
  sourceInfo?: Maybe<WixRiseV1GiftCardSourceInfo>;
  /** Transaction details related to the gift card. */
  transactionDetails?: Maybe<WixRiseV1TransactionDetails>;
  /** Gift Card last update date. */
  updatedDate?: Maybe<Scalars['String']>;
  walletsVirtualReference?: Maybe<WixRiseV1QueryWalletsResponse>;
};


export type WixRiseV1GiftCardWalletsVirtualReferenceArgs = {
  queryInput?: InputMaybe<WixRiseV1QueryWalletsRequestInput>;
};

export type WixRiseV1GiftCardInfo = {
  /** Current Gift Card Balance */
  balance?: Maybe<Scalars['String']>;
  /** Gift Card Code */
  code?: Maybe<Scalars['String']>;
  /** Gift Card Code Suffix */
  codeSuffix?: Maybe<Scalars['String']>;
  /** Gift Card Currency */
  currency?: Maybe<Scalars['String']>;
};

export type WixRiseV1GiftCardInput = {
  /** Current balance of the Gift Card. */
  balance?: InputMaybe<Scalars['String']>;
  /** Gift Card code for redemption. */
  code?: InputMaybe<Scalars['String']>;
  /** Last 4 characters of the gift card code for easier reference and searching. */
  codeSuffix?: InputMaybe<Scalars['String']>;
  /** Gift Card creation date. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Gift Card currency. */
  currency?: InputMaybe<Scalars['String']>;
  /** Gift Card disable date, if the gift card was disabled. */
  disableDate?: InputMaybe<Scalars['String']>;
  /** Gift Card expiration date. */
  expirationDate?: InputMaybe<Scalars['String']>;
  /** Unique ID of the Gift Card. */
  id?: InputMaybe<Scalars['String']>;
  /** Gift Card idempotency key, to prevent duplicate creation. */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** Initial value of the Gift Card. */
  initialValue?: InputMaybe<Scalars['String']>;
  /** Internal field to optimize the logic of Reminders feature. */
  lastActivityForReminders?: InputMaybe<Scalars['String']>;
  /** Gift Card revision. */
  revision?: InputMaybe<Scalars['Long']>;
  /** Information about the source of the gift card. */
  sourceInfo?: InputMaybe<WixRiseV1GiftCardSourceInfoInput>;
  /** Transaction details related to the gift card. */
  transactionDetails?: InputMaybe<WixRiseV1TransactionDetailsInput>;
  /** Gift Card last update date. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1GiftCardSourceInfo = {
  /** Detailed information about a Gift Card or Gift Card transaction issued from a bulk. */
  bulkOptions?: Maybe<WixRiseV1BulkOptions>;
  /** Bulk Options (deprecated) */
  campaignOptions?: Maybe<WixRiseV1CampaignOptions>;
  /** Details of the API client creating this Gift Card. */
  initiator?: Maybe<WixRiseV1ActionInitiator>;
  /** Detailed information about a Gift Card that was created manually. */
  manualOptions?: Maybe<WixRiseV1ManualOptions>;
  /** Detailed information about a Gift Card or Gift Card Transaction whose source is a migration from Rise V1 or another platform. */
  migrationOptions?: Maybe<WixRiseV1MigrationOptions>;
  /** Detailed information about a Gift Card issued from an order. */
  orderOptions?: Maybe<WixRiseV1OrderOptions>;
  /** The Channel ID of the sales channel that is associated with the gift card creation (e.g. Shopify channel id). */
  sourceChannelId?: Maybe<Scalars['String']>;
  /** The location ID that is associated with the action (supports POS cases). */
  sourceLocationId?: Maybe<Scalars['String']>;
  /** The Tenant ID of the sales channel that is associated with the gift card creation (e.g. Shopify shop id). */
  sourceTenantId?: Maybe<Scalars['String']>;
  /** Detailed information about a Gift Card that belongs to a Store Credit Wallet. */
  storeCreditOptions?: Maybe<WixRiseV1StoreCreditOptions>;
  /** The source type of the gift card. */
  type?: Maybe<WixRiseV1GiftCardType>;
  /** Detailed information about a Gift Card issued from a workflow. */
  workflowOptions?: Maybe<WixRiseV1WorkflowOptions>;
};

export enum WixRiseV1GiftCardSourceInfoGiftCardType {
  CAMPAIGN = 'CAMPAIGN',
  MANUAL = 'MANUAL',
  MIGRATION = 'MIGRATION',
  ORDER = 'ORDER',
  STORE_CREDIT = 'STORE_CREDIT',
  UNKNOWN = 'UNKNOWN'
}

export type WixRiseV1GiftCardSourceInfoInput = {
  /** Detailed information about a Gift Card or Gift Card transaction issued from a bulk. */
  bulkOptions?: InputMaybe<WixRiseV1BulkOptionsInput>;
  /** Bulk Options (deprecated) */
  campaignOptions?: InputMaybe<WixRiseV1CampaignOptionsInput>;
  /** Details of the API client creating this Gift Card. */
  initiator?: InputMaybe<WixRiseV1ActionInitiatorInput>;
  /** Detailed information about a Gift Card that was created manually. */
  manualOptions?: InputMaybe<WixRiseV1ManualOptionsInput>;
  /** Detailed information about a Gift Card or Gift Card Transaction whose source is a migration from Rise V1 or another platform. */
  migrationOptions?: InputMaybe<WixRiseV1MigrationOptionsInput>;
  /** Detailed information about a Gift Card issued from an order. */
  orderOptions?: InputMaybe<WixRiseV1OrderOptionsInput>;
  /** The Channel ID of the sales channel that is associated with the gift card creation (e.g. Shopify channel id). */
  sourceChannelId?: InputMaybe<Scalars['String']>;
  /** The location ID that is associated with the action (supports POS cases). */
  sourceLocationId?: InputMaybe<Scalars['String']>;
  /** The Tenant ID of the sales channel that is associated with the gift card creation (e.g. Shopify shop id). */
  sourceTenantId?: InputMaybe<Scalars['String']>;
  /** Detailed information about a Gift Card that belongs to a Store Credit Wallet. */
  storeCreditOptions?: InputMaybe<WixRiseV1StoreCreditOptionsInput>;
  /** The source type of the gift card. */
  type?: InputMaybe<WixRiseV1GiftCardType>;
  /** Detailed information about a Gift Card issued from a workflow. */
  workflowOptions?: InputMaybe<WixRiseV1WorkflowOptionsInput>;
};

export enum WixRiseV1GiftCardType {
  /** Issued from a bulk operation. */
  BULK = 'BULK',
  CAMPAIGN = 'CAMPAIGN',
  /** Issued from the dashboard. */
  MANUAL = 'MANUAL',
  /** Migrated from Rise V1 or another platform. */
  MIGRATION = 'MIGRATION',
  /** Issued from an order. */
  ORDER = 'ORDER',
  /** Belongs to a Store Credit Wallet. */
  STORE_CREDIT = 'STORE_CREDIT',
  UNKNOWN_GIFT_CARD_TYPE = 'UNKNOWN_GIFT_CARD_TYPE',
  /** Issued from a workflow. */
  WORKFLOW = 'WORKFLOW'
}

export type WixRiseV1IncreaseBalanceRequestInput = {
  /** The Transaction to be created. */
  transaction?: InputMaybe<WixRiseV1TransactionInput>;
};

export type WixRiseV1IncreaseBalanceResponse = {
  /** GiftCard balance after transaction. */
  balance?: Maybe<Scalars['String']>;
  /** Transaction Currency. */
  currency?: Maybe<Scalars['String']>;
  /** The created Transaction. */
  transaction?: Maybe<WixRiseV1Transaction>;
};

export type WixRiseV1InitialOptions = {
  /** Type of the gift card being initialized. */
  giftCardType?: Maybe<WixRiseV1GiftCardType>;
};

export type WixRiseV1InitialOptionsInput = {
  /** Type of the gift card being initialized. */
  giftCardType?: InputMaybe<WixRiseV1GiftCardType>;
};

export type WixRiseV1IssueStoreCreditRequestInput = {
  /** Contact details of the wallet to create or add the wallet action. */
  contactDetails?: InputMaybe<WixRiseV1ContactDetailsInput>;
  /** CustomerReference of the customer for which to create the wallet action. */
  customerReference?: InputMaybe<WixRiseV1CustomerReferenceInput>;
  /** WalletAction to be created. */
  walletAction?: InputMaybe<WixRiseV1WalletActionInput>;
  /** ID of the wallet to which the wallet action will be added. */
  walletId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1IssueStoreCreditResponse = {
  /** The wallet to which the wallet action was added. */
  wallet?: Maybe<WixRiseV1Wallet>;
  /** The created WalletAction. */
  walletAction?: Maybe<WixRiseV1WalletAction>;
};

export type WixRiseV1ManualOptions = {
  /** Internal note about the Transaction/Gift Card. */
  note?: Maybe<Scalars['String']>;
};

export type WixRiseV1ManualOptionsInput = {
  /** Internal note about the Transaction/Gift Card. */
  note?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1MigrateWalletRequestInput = {
  /** channel id */
  channelId?: InputMaybe<Scalars['String']>;
  /** Customer reference */
  customerReference?: InputMaybe<WixRiseV1CustomerReferenceInput>;
  /** gift card id */
  giftCard?: InputMaybe<WixRiseV1GiftCardInput>;
  /** tenant id */
  tenantId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1MigrateWalletResponse = {
  /** giftCard */
  giftCard?: Maybe<WixRiseV1GiftCard>;
  /** wallet */
  wallet?: Maybe<WixRiseV1Wallet>;
};

export type WixRiseV1MigrationOptions = {
  /** Indicates whether the gift card or transaction is a liability. */
  liability?: Maybe<Scalars['Boolean']>;
  /** Note about the gift card or transaction being migrated. */
  note?: Maybe<Scalars['String']>;
  /** ID of the gift card or transaction in Rise V1. */
  previousId?: Maybe<Scalars['String']>;
};

export type WixRiseV1MigrationOptionsInput = {
  /** Indicates whether the gift card or transaction is a liability. */
  liability?: InputMaybe<Scalars['Boolean']>;
  /** Note about the gift card or transaction being migrated. */
  note?: InputMaybe<Scalars['String']>;
  /** ID of the gift card or transaction in Rise V1. */
  previousId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1OrderOptions = {
  /** Indicates whether the gift card order is a liability. */
  liability?: Maybe<Scalars['Boolean']>;
  /** ID of the gift card order. */
  orderId?: Maybe<Scalars['String']>;
  /** Order number of the gift card order. */
  orderNumber?: Maybe<Scalars['String']>;
};

export type WixRiseV1OrderOptionsInput = {
  /** Indicates whether the gift card order is a liability. */
  liability?: InputMaybe<Scalars['Boolean']>;
  /** ID of the gift card order. */
  orderId?: InputMaybe<Scalars['String']>;
  /** Order number of the gift card order. */
  orderNumber?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1PaymentMethodRefundOptions = {
  /** Optional details for the refund that is based of a specific store credit. */
  activeFundingTransaction?: Maybe<WixRiseV1PaymentMethodRefundWalletActionDetails>;
  /** Indicates whether the payment method refund is a liability. */
  liability?: Maybe<Scalars['Boolean']>;
  /** ID of the order associated with the refund. */
  orderId?: Maybe<Scalars['String']>;
  /** Order number associated with the refund. */
  orderNumber?: Maybe<Scalars['String']>;
};

export type WixRiseV1PaymentMethodRefundOptionsInput = {
  /** Optional details for the refund that is based of a specific store credit. */
  activeFundingTransaction?: InputMaybe<WixRiseV1PaymentMethodRefundWalletActionDetailsInput>;
  /** Indicates whether the payment method refund is a liability. */
  liability?: InputMaybe<Scalars['Boolean']>;
  /** ID of the order associated with the refund. */
  orderId?: InputMaybe<Scalars['String']>;
  /** Order number associated with the refund. */
  orderNumber?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1PaymentMethodRefundWalletActionDetails = {
  fundingTransactionId?: Maybe<Scalars['String']>;
  transaction?: Maybe<WixRiseV1Transaction>;
  walletAction?: Maybe<WixRiseV1WalletAction>;
  walletActionId?: Maybe<Scalars['String']>;
};

export type WixRiseV1PaymentMethodRefundWalletActionDetailsInput = {
  fundingTransactionId?: InputMaybe<Scalars['String']>;
  walletActionId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1ProduceTransactionAddedEventRequestInput = {
  transactionId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1QueryByContactInput = {
  /** Contact filter object. */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Limit for the number of wallets to return. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Sort object. */
  sort?: InputMaybe<Array<InputMaybe<WixRiseV1UpstreamWixCommonSortingInput>>>;
};

export type WixRiseV1QueryGiftCardsRequestInput = {
  /** API Query Language expression. */
  query?: InputMaybe<WixCommonQueryV2Input>;
};

export type WixRiseV1QueryGiftCardsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<WixRiseV1GiftCard>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixRiseV1QueryTransactionsInternalRequestInput = {
  /** WQL expression. */
  query?: InputMaybe<WixCommonQueryV2Input>;
};

export type WixRiseV1QueryTransactionsInternalResponse = {
  pagingMetadata?: Maybe<WixCommonPagingMetadataV2>;
  /** The retrieved Transactions. */
  transactions?: Maybe<Array<Maybe<WixRiseV1Transaction>>>;
};

export type WixRiseV1QueryTransactionsRequestInput = {
  /** WQL expression. */
  query?: InputMaybe<WixCommonQueryV2Input>;
};

export type WixRiseV1QueryTransactionsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<WixRiseV1Transaction>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixRiseV1QueryUnredeemedWalletActionsRequestInput = {
  /** API Query Language expression. */
  query?: InputMaybe<WixRiseWalletActionV1UpstreamWixQueryQueryV2Input>;
};

export type WixRiseV1QueryUnredeemedWalletActionsResponse = {
  pagingMetadata?: Maybe<WixRiseWalletActionV1UpstreamWixCommonPagingMetadataV2>;
  /** The retrieved unredeemed WalletActions with their balances. */
  walletActions?: Maybe<Array<Maybe<WixRiseV1WalletActionWithBalance>>>;
};

export type WixRiseV1QueryWalletActionBalancesRequestInput = {
  /** API Query Language expression. */
  query?: InputMaybe<WixRiseWalletActionV1UpstreamWixQueryQueryV2Input>;
};

export type WixRiseV1QueryWalletActionBalancesResponse = {
  pagingMetadata?: Maybe<WixRiseWalletActionV1UpstreamWixCommonPagingMetadataV2>;
  /** The retrieved WalletActions with their balances. */
  walletActions?: Maybe<Array<Maybe<WixRiseV1WalletActionWithBalance>>>;
};

export type WixRiseV1QueryWalletActionBalancesResponseWalletActionWithBalance = {
  /** WalletAction balance */
  balance?: Maybe<Scalars['String']>;
  /** WalletAction */
  walletAction?: Maybe<WixRiseV1WalletAction>;
};

export type WixRiseV1QueryWalletActionRequestInput = {
  /** API Query Language expression. */
  query?: InputMaybe<WixRiseWalletActionV1UpstreamWixQueryQueryV2Input>;
};

export type WixRiseV1QueryWalletActionResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<WixRiseV1WalletAction>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixRiseV1QueryWalletsByContactRequestInput = {
  /** Contact query object. */
  query?: InputMaybe<WixRiseV1QueryByContactInput>;
};

export type WixRiseV1QueryWalletsByContactResponse = {
  /** List of retrieved wallets with gift card information. */
  wallets?: Maybe<Array<Maybe<WixRiseV1Wallet>>>;
};

export type WixRiseV1QueryWalletsRequestInput = {
  /** Additional fields to include in the response. */
  fields?: InputMaybe<Array<InputMaybe<WixRiseV1RequestedFields>>>;
  /** API Query Language expression. */
  query?: InputMaybe<WixRiseV1UpstreamWixQueryQueryV2Input>;
};

export type WixRiseV1QueryWalletsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<WixRiseV1Wallet>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixRiseV1RedeemOptions = {
  /** Indicates whether the redemption is a liability. */
  liability?: Maybe<Scalars['Boolean']>;
  /** ID of the order associated with the redemption. */
  orderId?: Maybe<Scalars['String']>;
  /** Order number associated with the redemption. */
  orderNumber?: Maybe<Scalars['String']>;
  /** Total price of the order. */
  totalPrice?: Maybe<Scalars['String']>;
};

export type WixRiseV1RedeemOptionsInput = {
  /** Indicates whether the redemption is a liability. */
  liability?: InputMaybe<Scalars['Boolean']>;
  /** ID of the order associated with the redemption. */
  orderId?: InputMaybe<Scalars['String']>;
  /** Order number associated with the redemption. */
  orderNumber?: InputMaybe<Scalars['String']>;
  /** Total price of the order. */
  totalPrice?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1RefundTransactionContextInput = {
  /** An unique identifier for this request's context. */
  externalRefundId?: InputMaybe<Scalars['String']>;
  sourceChannelId?: InputMaybe<Scalars['String']>;
  sourceLocationId?: InputMaybe<Scalars['String']>;
  sourceOrderId?: InputMaybe<Scalars['String']>;
  sourceOrderNumber?: InputMaybe<Scalars['String']>;
  sourceTenantId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1RefundTransactionRequestInput = {
  /** Optional custom amount to refund. If not provided, the full amount of the transaction will be refunded. */
  amount?: InputMaybe<Scalars['String']>;
  context?: InputMaybe<WixRiseV1RefundTransactionContextInput>;
  transactionId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1RefundableAmount = {
  amount?: Maybe<Scalars['String']>;
  fundingTransactionId?: Maybe<Scalars['String']>;
  walletActionId?: Maybe<Scalars['String']>;
};

export type WixRiseV1RegenerateCodeRequestInput = {
  /** The ID of the GiftCard to regenerate code for. */
  giftCardId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1RegenerateCodeResponse = {
  /** The GiftCard with the new code. */
  giftCard?: Maybe<WixRiseV1GiftCard>;
};

export enum WixRiseV1RequestedFields {
  CONTACT_DETAILS = 'CONTACT_DETAILS',
  UNKNOWN_REQUESTED_FIELD = 'UNKNOWN_REQUESTED_FIELD'
}

export type WixRiseV1RewardOptions = {
  liability?: Maybe<Scalars['Boolean']>;
  walletAction?: Maybe<WixRiseV1WalletAction>;
  walletActionId?: Maybe<Scalars['String']>;
};

export type WixRiseV1RewardOptionsInput = {
  liability?: InputMaybe<Scalars['Boolean']>;
  walletActionId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1SearchGiftCardsRequestInput = {
  search?: InputMaybe<WixCommonCursorSearchInput>;
};

export type WixRiseV1SearchGiftCardsResponse = {
  /** Aggregation data. */
  aggregationData?: Maybe<WixCommonAggregationData>;
  /** Gift Cards which satisfy the provided query. */
  giftCards?: Maybe<Array<Maybe<WixRiseV1GiftCard>>>;
  /** Paging metadata. Contains cursor which can be used in next query. */
  pagingMetadata?: Maybe<WixCommonCursorPagingMetadata>;
};

export type WixRiseV1SourceInput = {
  /** Source channel, i.e. Shopify. */
  sourceChannelId?: InputMaybe<Scalars['String']>;
  /** Customer ID in Source. */
  sourceCustomerId?: InputMaybe<Scalars['String']>;
  /** Tenant ID in Source, i.e. shop ID. */
  sourceTenantId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1StoreCreditContext = {
  /** The issuer type of the store credit (e.g., workflow, bulk, manual) */
  issuer?: Maybe<WixRiseV1StoreCreditContextStoreCreditIssuerType>;
  /** Indicates a specific instance of the issuer (relevant for workflow/bulk) */
  issuerId?: Maybe<Scalars['String']>;
  /** An internal note associated with the store credit */
  note?: Maybe<Scalars['String']>;
  /** The Channel ID of the sales channel that is associated with the store credit (e.g. Shopify channel id) */
  sourceChannelId?: Maybe<Scalars['String']>;
  /** The Tenant ID of the sales channel that is associated with the store credit (e.g. Shopify shop id) */
  sourceTenantId?: Maybe<Scalars['String']>;
};

export type WixRiseV1StoreCreditContextInput = {
  /** The issuer type of the store credit (e.g., workflow, bulk, manual) */
  issuer?: InputMaybe<WixRiseV1StoreCreditContextStoreCreditIssuerType>;
  /** Indicates a specific instance of the issuer (relevant for workflow/bulk) */
  issuerId?: InputMaybe<Scalars['String']>;
  /** An internal note associated with the store credit */
  note?: InputMaybe<Scalars['String']>;
  /** The Channel ID of the sales channel that is associated with the store credit (e.g. Shopify channel id) */
  sourceChannelId?: InputMaybe<Scalars['String']>;
  /** The Tenant ID of the sales channel that is associated with the store credit (e.g. Shopify shop id) */
  sourceTenantId?: InputMaybe<Scalars['String']>;
};

export enum WixRiseV1StoreCreditContextStoreCreditIssuerType {
  /** Issued from a bulk */
  BULK = 'BULK',
  /** Issued from the Rise dashboard */
  MANUAL = 'MANUAL',
  /** Issued from another source */
  OTHER = 'OTHER',
  /** Issued from a referral - a referred customer created a wallet from the referral link */
  REFERRAL_REFERRED_CUSTOMER = 'REFERRAL_REFERRED_CUSTOMER',
  /** Issued from a referral - a referrer made a successful referral. The referred customer placed the first order */
  REFERRAL_REFERRER = 'REFERRAL_REFERRER',
  /** Issued from a refund */
  REFUND = 'REFUND',
  /** Issued from a refund incentive - issuer_id is the corresponding Refund Wallet Action ID */
  REFUND_INCENTIVE = 'REFUND_INCENTIVE',
  UNKNOWN_ISSUER = 'UNKNOWN_ISSUER',
  /** Issued from a workflow */
  WORKFLOW = 'WORKFLOW'
}

export type WixRiseV1StoreCreditOptions = {
  /** ID of the store credit wallet. */
  wallet?: Maybe<WixRiseV1Wallet>;
  /** ID of the store credit wallet. */
  walletId?: Maybe<Scalars['String']>;
};

export type WixRiseV1StoreCreditOptionsInput = {
  /** ID of the store credit wallet. */
  walletId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1StoreCreditRefundOptions = {
  /** Indicates whether the store credit refund is a liability. */
  liability?: Maybe<Scalars['Boolean']>;
  /** ID of the wallet action (store credit) given as a refund. */
  walletAction?: Maybe<WixRiseV1WalletAction>;
  /** ID of the wallet action (store credit) given as a refund. */
  walletActionId?: Maybe<Scalars['String']>;
};

export type WixRiseV1StoreCreditRefundOptionsInput = {
  /** Indicates whether the store credit refund is a liability. */
  liability?: InputMaybe<Scalars['Boolean']>;
  /** ID of the wallet action (store credit) given as a refund. */
  walletActionId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1Transaction = {
  /** Transaction amount. */
  amount?: Maybe<Scalars['String']>;
  /**
   * Bulk Options.
   * @deprecated Bulk Options. Replaced by: wallet_action_start_options. Removal date: 2024-12-22.
   */
  bulkOptions?: Maybe<WixRiseV1BulkOptions>;
  /** Bulk Options. */
  campaignOptions?: Maybe<WixRiseV1CampaignOptions>;
  /** Transaction creation date. */
  createdDate?: Maybe<Scalars['String']>;
  /** Information about an external event that lead to the transaction. */
  externalEvent?: Maybe<WixRiseV1ExternalEvent>;
  /** ID of the transaction in a 3rd party system if created there. */
  externalId?: Maybe<Scalars['String']>;
  /** Unique ID of the gift card associated with this transaction. */
  giftCardId?: Maybe<Scalars['String']>;
  /** Transaction unique id. */
  id?: Maybe<Scalars['String']>;
  /** Idempotency key, to prevent duplicate creation. */
  idempotencyKey?: Maybe<Scalars['String']>;
  /** Information about the first transaction that initializes a gift card. */
  initialOptions?: Maybe<WixRiseV1InitialOptions>;
  /** Information about a transaction issued manually from the Rise dashboard. */
  manualOptions?: Maybe<WixRiseV1ManualOptions>;
  /** Information about a transaction whose source is a migration from Rise V1 or another platform. */
  migrationOptions?: Maybe<WixRiseV1MigrationOptions>;
  /** Indicates whether the transaction adds or subtracts from the GiftCard balance. */
  operationType?: Maybe<WixRiseV1TransactionOperationType>;
  /** Information about a transaction whose source is a refunding a payment method. */
  paymentMethodRefundOptions?: Maybe<WixRiseV1PaymentMethodRefundOptions>;
  /** Information about a transaction whose source is a gift card redemption. */
  redeemOptions?: Maybe<WixRiseV1RedeemOptions>;
  /** Reward Options. */
  rewardOptions?: Maybe<WixRiseV1RewardOptions>;
  /** Information about the source of the transaction. */
  sourceInfo?: Maybe<WixRiseV1TransactionSourceInfo>;
  /** Information about a transaction whose source is a store credit refund. */
  storeCreditRefundOptions?: Maybe<WixRiseV1StoreCreditRefundOptions>;
  /** Type of transaction. */
  type?: Maybe<WixRiseV1TransactionTransactionType>;
  /** Gift card Balance after this transaction operation. */
  updatedBalance?: Maybe<Scalars['String']>;
  /** Information about a transaction that comes to void a previous transaction. */
  voidOptions?: Maybe<WixRiseV1VoidOptions>;
  /** Information about a transaction whose source is the end of a wallet action (store credit). */
  walletActionEndOptions?: Maybe<WixRiseV1WalletActionEndOptions>;
  /** Information about a transaction whose source is a wallet action (store credit) to a customer. */
  walletActionStartOptions?: Maybe<WixRiseV1WalletActionStartOptions>;
};

export type WixRiseV1TransactionDetails = {
  /** The last transaction that decreased the gift card balance, such as redemption or refund. */
  lastDecreasingTransaction?: Maybe<WixRiseV1TransactionDetailsTransactionWrapper>;
  /** ID of the last transaction that increased the gift card balance. */
  lastIncreasingTransaction?: Maybe<WixRiseV1TransactionDetailsTransactionWrapper>;
  /** The last transaction that modified the gift card balance. */
  lastTransaction?: Maybe<WixRiseV1TransactionDetailsTransactionWrapper>;
};

export type WixRiseV1TransactionDetailsInput = {
  /** The last transaction that decreased the gift card balance, such as redemption or refund. */
  lastDecreasingTransaction?: InputMaybe<WixRiseV1TransactionDetailsTransactionWrapperInput>;
  /** ID of the last transaction that increased the gift card balance. */
  lastIncreasingTransaction?: InputMaybe<WixRiseV1TransactionDetailsTransactionWrapperInput>;
  /** The last transaction that modified the gift card balance. */
  lastTransaction?: InputMaybe<WixRiseV1TransactionDetailsTransactionWrapperInput>;
};

export type WixRiseV1TransactionDetailsTransactionWrapper = {
  /** Date and time the Transaction was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Transaction ID. */
  id?: Maybe<Scalars['String']>;
  /** Transaction ID. */
  transaction?: Maybe<WixRiseV1Transaction>;
};

export type WixRiseV1TransactionDetailsTransactionWrapperInput = {
  /** Date and time the Transaction was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Transaction ID. */
  id?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1TransactionInput = {
  /** Transaction amount. */
  amount?: InputMaybe<Scalars['String']>;
  /** Bulk Options. */
  campaignOptions?: InputMaybe<WixRiseV1CampaignOptionsInput>;
  /** Transaction creation date. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Information about an external event that lead to the transaction. */
  externalEvent?: InputMaybe<WixRiseV1ExternalEventInput>;
  /** ID of the transaction in a 3rd party system if created there. */
  externalId?: InputMaybe<Scalars['String']>;
  /** Unique ID of the gift card associated with this transaction. */
  giftCardId?: InputMaybe<Scalars['String']>;
  /** Transaction unique id. */
  id?: InputMaybe<Scalars['String']>;
  /** Idempotency key, to prevent duplicate creation. */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** Information about the first transaction that initializes a gift card. */
  initialOptions?: InputMaybe<WixRiseV1InitialOptionsInput>;
  /** Information about a transaction issued manually from the Rise dashboard. */
  manualOptions?: InputMaybe<WixRiseV1ManualOptionsInput>;
  /** Information about a transaction whose source is a migration from Rise V1 or another platform. */
  migrationOptions?: InputMaybe<WixRiseV1MigrationOptionsInput>;
  /** Indicates whether the transaction adds or subtracts from the GiftCard balance. */
  operationType?: InputMaybe<WixRiseV1TransactionOperationType>;
  /** Information about a transaction whose source is a refunding a payment method. */
  paymentMethodRefundOptions?: InputMaybe<WixRiseV1PaymentMethodRefundOptionsInput>;
  /** Information about a transaction whose source is a gift card redemption. */
  redeemOptions?: InputMaybe<WixRiseV1RedeemOptionsInput>;
  /** Reward Options. */
  rewardOptions?: InputMaybe<WixRiseV1RewardOptionsInput>;
  /** Information about the source of the transaction. */
  sourceInfo?: InputMaybe<WixRiseV1TransactionSourceInfoInput>;
  /** Information about a transaction whose source is a store credit refund. */
  storeCreditRefundOptions?: InputMaybe<WixRiseV1StoreCreditRefundOptionsInput>;
  /** Type of transaction. */
  type?: InputMaybe<WixRiseV1TransactionTransactionType>;
  /** Gift card Balance after this transaction operation. */
  updatedBalance?: InputMaybe<Scalars['String']>;
  /** Information about a transaction that comes to void a previous transaction. */
  voidOptions?: InputMaybe<WixRiseV1VoidOptionsInput>;
  /** Information about a transaction whose source is the end of a wallet action (store credit). */
  walletActionEndOptions?: InputMaybe<WixRiseV1WalletActionEndOptionsInput>;
  /** Information about a transaction whose source is a wallet action (store credit) to a customer. */
  walletActionStartOptions?: InputMaybe<WixRiseV1WalletActionStartOptionsInput>;
};

export enum WixRiseV1TransactionOperationType {
  ADD = 'ADD',
  SUBTRACT = 'SUBTRACT'
}

export type WixRiseV1TransactionSourceInfo = {
  /** Details of the API client creating this Transaction. */
  initiator?: Maybe<WixRiseV1ActionInitiator>;
  /** The Channel ID that is associated with the action. */
  sourceChannelId?: Maybe<Scalars['String']>;
  /** The location ID that is associated with the action (supports POS cases). */
  sourceLocationId?: Maybe<Scalars['String']>;
  /** The Tenant ID that is associated with the action. */
  sourceTenantId?: Maybe<Scalars['String']>;
};

export type WixRiseV1TransactionSourceInfoInput = {
  /** Details of the API client creating this Transaction. */
  initiator?: InputMaybe<WixRiseV1ActionInitiatorInput>;
  /** The Channel ID that is associated with the action. */
  sourceChannelId?: InputMaybe<Scalars['String']>;
  /** The location ID that is associated with the action (supports POS cases). */
  sourceLocationId?: InputMaybe<Scalars['String']>;
  /** The Tenant ID that is associated with the action. */
  sourceTenantId?: InputMaybe<Scalars['String']>;
};

export enum WixRiseV1TransactionTransactionType {
  BULK = 'BULK',
  CAMPAIGN = 'CAMPAIGN',
  /** Initial transaction for a gift card. */
  INITIAL = 'INITIAL',
  /** Issued from the dashboard. */
  MANUAL = 'MANUAL',
  /** Migration from Rise V1 or another platform. */
  MIGRATION = 'MIGRATION',
  /** Refunding a payment method. */
  PAYMENT_METHOD_REFUND = 'PAYMENT_METHOD_REFUND',
  REDEEM = 'REDEEM',
  REWARD = 'REWARD',
  STORE_CREDIT_REFUND = 'STORE_CREDIT_REFUND',
  UNKNOWN_TRANSACTION_TYPE = 'UNKNOWN_TRANSACTION_TYPE',
  /** Void of a previous transaction. */
  VOID = 'VOID',
  /** End of a wallet action (store credit). */
  WALLET_ACTION_END = 'WALLET_ACTION_END',
  /** Start of a wallet action (store credit). */
  WALLET_ACTION_START = 'WALLET_ACTION_START'
}

export type WixRiseV1UpdateCustomerReferenceRequestInput = {
  customerReference?: InputMaybe<WixRiseV1CustomerReferenceInput>;
};

export type WixRiseV1UpdateCustomerReferenceResponse = {
  /** Customer reference */
  customerReference?: Maybe<WixRiseV1CustomerReference>;
};

export type WixRiseV1UpdateGiftCardRequestInput = {
  /** The fields to update. */
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The GiftCard to update. */
  giftCard?: InputMaybe<WixRiseV1GiftCardInput>;
  /** The ID of the GiftCard to update. */
  giftCardId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1UpdateGiftCardResponse = {
  /** The updated GiftCard. */
  giftCard?: Maybe<WixRiseV1GiftCard>;
};

export type WixRiseV1UpdateLastActivityForRemindersRequestInput = {
  /** Gift Card ID */
  giftCardId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1UpdateLastActivityForRemindersResponse = {
  /** Updated Gift Card */
  giftCard?: Maybe<WixRiseV1GiftCard>;
};

export type WixRiseV1UpdateWalletActionRequestInput = {
  /** Explicit list of fields to update. */
  mask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** WalletAction to be updated, may be partial. */
  walletAction?: InputMaybe<WixRiseV1WalletActionInput>;
};

export type WixRiseV1UpdateWalletActionResponse = {
  /** The updated WalletAction. */
  walletAction?: Maybe<WixRiseV1WalletAction>;
};

export type WixRiseV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixRiseV1UpstreamWixCommonPagingInput = {
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the current sort order. */
  offset?: InputMaybe<Scalars['Int']>;
};

export enum WixRiseV1UpstreamWixCommonSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type WixRiseV1UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixRiseV1UpstreamWixCommonSortOrder>;
};

export type WixRiseV1UpstreamWixQueryQueryV2Input = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixRiseV1UpstreamWixCommonCursorPagingInput>;
  /** Array of projected fields. A list of specific field names to return. If `fieldsets` are also specified, the union of `fieldsets` and `fields` is returned. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of named, predefined sets of projected fields. A array of predefined named sets of fields to be returned. Specifying multiple `fieldsets` will return the union of fields from all sets. If `fields` are also specified, the union of `fieldsets` and `fields` is returned. */
  fieldsets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Paging options to limit and skip the number of items. */
  paging?: InputMaybe<WixRiseV1UpstreamWixCommonPagingInput>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixRiseV1UpstreamWixCommonSortingInput>>>;
};

export type WixRiseV1VoidOptions = {
  /** ID of the transaction being voided. */
  transaction?: Maybe<WixRiseV1Transaction>;
  /** ID of the transaction being voided. */
  transactionId?: Maybe<Scalars['String']>;
};

export type WixRiseV1VoidOptionsInput = {
  /** ID of the transaction being voided. */
  transactionId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1VoidTransactionRequestInput = {
  sourceChannelId?: InputMaybe<Scalars['String']>;
  sourceTenantId?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1VoidTransactionResponse = {
  /** GiftCard balance after transaction. */
  balance?: Maybe<Scalars['String']>;
  /** GiftCard Currency. */
  currency?: Maybe<Scalars['String']>;
  transaction?: Maybe<WixRiseV1Transaction>;
};

export type WixRiseV1Wallet = {
  /** Wallet's primary Contact */
  contact?: Maybe<ComWixpressContactsCoreApiV4Contact>;
  /** The time this Wallet was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** List of references to the customer in specific source channels. See definition below. */
  customerReferences?: Maybe<Array<Maybe<WixRiseV1CustomerReference>>>;
  /** ID of the Gift Card associated with this Wallet. */
  giftCard?: Maybe<WixRiseV1GiftCard>;
  /** ID of the Gift Card associated with this Wallet. */
  giftCardId?: Maybe<Scalars['String']>;
  /** Information about the Gift Card associated with this Wallet. */
  giftCardInfo?: Maybe<WixRiseV1GiftCardInfo>;
  /** Wallet ID. */
  id?: Maybe<Scalars['String']>;
  primaryContactDetails?: Maybe<WixRiseV1ContactDetails>;
  /** Wallet's primary Contact */
  primaryContactId?: Maybe<Scalars['String']>;
  /** ID of the primary customer reference, which is the customer reference with the most contact fields defined. */
  primaryCustomerReferenceId?: Maybe<Scalars['String']>;
  /** Wallet's primary Email Address */
  primaryEmail?: Maybe<Scalars['String']>;
  /** Wallet's primary Phone Number */
  primaryPhone?: Maybe<Scalars['String']>;
  /** Represents the current state of an item. Each time the item is modified, its `revision` changes. for an update operation to succeed, you MUST pass the latest revision. */
  revision?: Maybe<Scalars['Long']>;
  /** The time this Wallet was last updated. */
  updatedDate?: Maybe<Scalars['String']>;
  walletActionsVirtualReference?: Maybe<WixRiseV1QueryWalletActionResponse>;
};


export type WixRiseV1WalletContactArgs = {
  referenceKey?: InputMaybe<Scalars['String']>;
};


export type WixRiseV1WalletWalletActionsVirtualReferenceArgs = {
  queryInput?: InputMaybe<WixRiseV1QueryWalletActionRequestInput>;
};

export type WixRiseV1WalletAction = {
  /** The amount to be added to the Wallet. */
  amount?: Maybe<Scalars['String']>;
  /** Represents the time this WalletAction was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Represents the time at which the WalletAction was manually disabled, if applicable. */
  disableDate?: Maybe<Scalars['String']>;
  /** Represents the time at which the unused balance of the WalletAction will be deducted from the account. Defaults to never. */
  expirationDate?: Maybe<Scalars['String']>;
  /** Information about the external event that triggered the WalletAction, such as type of event and a short description or identifier of the event. */
  externalEvent?: Maybe<WixRiseV1ExternalEvent>;
  /** WalletAction ID. */
  id?: Maybe<Scalars['String']>;
  /** Unique key to identify the WalletAction, used to prevent duplicate WalletActions from being created in case of retries or network issues. The key should be unique for each WalletAction and should not be reused. */
  idempotencyKey?: Maybe<Scalars['String']>;
  /** Indicates whether the WalletAction is a liability. The default is false. */
  liability?: Maybe<Scalars['Boolean']>;
  /** Free text comment regarding the WalletAction context */
  note?: Maybe<Scalars['String']>;
  /** Settings of the notifications related to the WalletAction. This field is used to specify whether to skip email dispatch or override the template ID for email notifications. */
  notifications?: Maybe<WixRiseV1WalletActionNotifications>;
  /** Represents the current state of an item. Each time the item is modified, its `revision` changes. For an update operation to succeed, you MUST pass the latest revision. */
  revision?: Maybe<Scalars['Long']>;
  /** Information about the initiator of the WalletAction, such as the app or user that initiated the action. Set when the WalletAction is created. */
  source?: Maybe<WixRiseV1ActionInitiator>;
  /** Represents the time at which the WalletAction's amount will be added to the account. Defaults to immediately. */
  startDate?: Maybe<Scalars['String']>;
  /** The current status of the WalletAction. Set to PENDING when the WalletAction is created and updated to ACTIVE when the amount is added to the wallet. */
  status?: Maybe<WixRiseV1WalletActionWalletActionStatus>;
  /** Detailed information about the context of a store credit, such as the issuer type and sales channel. */
  storeCreditContext?: Maybe<WixRiseV1StoreCreditContext>;
  /** Tags */
  tags?: Maybe<WixRiseWalletActionV1UpstreamWixCommonTags>;
  /** Indicates the kind of the specific WalletAction */
  type?: Maybe<WixRiseV1WalletActionWalletActionType>;
  /** Represents the time this WalletAction was last updated. */
  updatedDate?: Maybe<Scalars['String']>;
  /** ID of the wallet to which the WalletAction belongs. */
  wallet?: Maybe<WixRiseV1Wallet>;
  /** Details about the execution of the ending of the wallet action (due to expiration, disabling, etc), such as transaction ID and execution date. Set when the WalletAction is ended (i.e. when the amount is deducted from the account). */
  walletActionEnded?: Maybe<WixRiseV1WalletActionWalletActionExecutionDetails>;
  /** Details about the WalletAction's execution, such as transaction ID and execution date. Set when the WalletAction is executed (e.g., when the amount is added to the account). */
  walletActionStarted?: Maybe<WixRiseV1WalletActionWalletActionExecutionDetails>;
  /** ID of the wallet to which the WalletAction belongs. */
  walletId?: Maybe<Scalars['String']>;
};

export type WixRiseV1WalletActionEmailParams = {
  /** ID of the email template to be used for the WalletAction, if default template is to be overridden. */
  overrideTemplateId?: Maybe<Scalars['String']>;
  /** Indicates whether to skip email dispatch for the WalletAction. The default is false. */
  skipEmailDispatch?: Maybe<Scalars['Boolean']>;
};

export type WixRiseV1WalletActionEmailParamsInput = {
  /** ID of the email template to be used for the WalletAction, if default template is to be overridden. */
  overrideTemplateId?: InputMaybe<Scalars['String']>;
  /** Indicates whether to skip email dispatch for the WalletAction. The default is false. */
  skipEmailDispatch?: InputMaybe<Scalars['Boolean']>;
};

export type WixRiseV1WalletActionEndDetailsInput = {
  /** Amount to subtract from the wallet */
  amountToSubtract?: InputMaybe<Scalars['String']>;
  /** ID of the WalletAction to end */
  walletActionId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1WalletActionEndOptions = {
  /** Indicates whether the wallet action end is a liability. */
  liability?: Maybe<Scalars['Boolean']>;
  /** Reason the wallet action is ending. */
  reason?: Maybe<WixRiseV1WalletActionEndOptionsWalletActionEndReason>;
  /** ID of the transaction being reversed. */
  transaction?: Maybe<WixRiseV1Transaction>;
  /** ID of the transaction being reversed. */
  transactionId?: Maybe<Scalars['String']>;
  /** ID of the wallet action being ended. */
  walletAction?: Maybe<WixRiseV1WalletAction>;
  /** ID of the wallet action being ended. */
  walletActionId?: Maybe<Scalars['String']>;
};

export type WixRiseV1WalletActionEndOptionsInput = {
  /** Indicates whether the wallet action end is a liability. */
  liability?: InputMaybe<Scalars['Boolean']>;
  /** Reason the wallet action is ending. */
  reason?: InputMaybe<WixRiseV1WalletActionEndOptionsWalletActionEndReason>;
  /** ID of the transaction being reversed. */
  transactionId?: InputMaybe<Scalars['String']>;
  /** ID of the wallet action being ended. */
  walletActionId?: InputMaybe<Scalars['String']>;
};

export enum WixRiseV1WalletActionEndOptionsWalletActionEndReason {
  CANCEL = 'CANCEL',
  EXPIRATION = 'EXPIRATION',
  UNKNOWN_REASON = 'UNKNOWN_REASON'
}

export type WixRiseV1WalletActionInput = {
  /** The amount to be added to the Wallet. */
  amount?: InputMaybe<Scalars['String']>;
  /** Represents the time this WalletAction was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Represents the time at which the WalletAction was manually disabled, if applicable. */
  disableDate?: InputMaybe<Scalars['String']>;
  /** Represents the time at which the unused balance of the WalletAction will be deducted from the account. Defaults to never. */
  expirationDate?: InputMaybe<Scalars['String']>;
  /** Information about the external event that triggered the WalletAction, such as type of event and a short description or identifier of the event. */
  externalEvent?: InputMaybe<WixRiseV1ExternalEventInput>;
  /** WalletAction ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Unique key to identify the WalletAction, used to prevent duplicate WalletActions from being created in case of retries or network issues. The key should be unique for each WalletAction and should not be reused. */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** Indicates whether the WalletAction is a liability. The default is false. */
  liability?: InputMaybe<Scalars['Boolean']>;
  /** Free text comment regarding the WalletAction context */
  note?: InputMaybe<Scalars['String']>;
  /** Settings of the notifications related to the WalletAction. This field is used to specify whether to skip email dispatch or override the template ID for email notifications. */
  notifications?: InputMaybe<WixRiseV1WalletActionNotificationsInput>;
  /** Represents the current state of an item. Each time the item is modified, its `revision` changes. For an update operation to succeed, you MUST pass the latest revision. */
  revision?: InputMaybe<Scalars['Long']>;
  /** Information about the initiator of the WalletAction, such as the app or user that initiated the action. Set when the WalletAction is created. */
  source?: InputMaybe<WixRiseV1ActionInitiatorInput>;
  /** Represents the time at which the WalletAction's amount will be added to the account. Defaults to immediately. */
  startDate?: InputMaybe<Scalars['String']>;
  /** The current status of the WalletAction. Set to PENDING when the WalletAction is created and updated to ACTIVE when the amount is added to the wallet. */
  status?: InputMaybe<WixRiseV1WalletActionWalletActionStatus>;
  /** Detailed information about the context of a store credit, such as the issuer type and sales channel. */
  storeCreditContext?: InputMaybe<WixRiseV1StoreCreditContextInput>;
  /** Tags */
  tags?: InputMaybe<WixRiseWalletActionV1UpstreamWixCommonTagsInput>;
  /** Indicates the kind of the specific WalletAction */
  type?: InputMaybe<WixRiseV1WalletActionWalletActionType>;
  /** Represents the time this WalletAction was last updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
  /** Details about the execution of the ending of the wallet action (due to expiration, disabling, etc), such as transaction ID and execution date. Set when the WalletAction is ended (i.e. when the amount is deducted from the account). */
  walletActionEnded?: InputMaybe<WixRiseV1WalletActionWalletActionExecutionDetailsInput>;
  /** Details about the WalletAction's execution, such as transaction ID and execution date. Set when the WalletAction is executed (e.g., when the amount is added to the account). */
  walletActionStarted?: InputMaybe<WixRiseV1WalletActionWalletActionExecutionDetailsInput>;
  /** ID of the wallet to which the WalletAction belongs. */
  walletId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1WalletActionNotifications = {
  /** Settings for email notifications related to the WalletAction. This field is used to specify whether to skip email dispatch or override the template ID for email notifications. */
  emailParams?: Maybe<WixRiseV1WalletActionEmailParams>;
};

export type WixRiseV1WalletActionNotificationsInput = {
  /** Settings for email notifications related to the WalletAction. This field is used to specify whether to skip email dispatch or override the template ID for email notifications. */
  emailParams?: InputMaybe<WixRiseV1WalletActionEmailParamsInput>;
};

export type WixRiseV1WalletActionStartOptions = {
  /** Detailed information about the context of a store credit, such as the issuer type and sales channel. */
  context?: Maybe<WixRiseV1StoreCreditContext>;
  /** Indicates whether the wallet action is a liability. */
  liability?: Maybe<Scalars['Boolean']>;
  /** ID of the wallet action. */
  walletAction?: Maybe<WixRiseV1WalletAction>;
  /** ID of the wallet action. */
  walletActionId?: Maybe<Scalars['String']>;
};

export type WixRiseV1WalletActionStartOptionsInput = {
  /** Detailed information about the context of a store credit, such as the issuer type and sales channel. */
  context?: InputMaybe<WixRiseV1StoreCreditContextInput>;
  /** Indicates whether the wallet action is a liability. */
  liability?: InputMaybe<Scalars['Boolean']>;
  /** ID of the wallet action. */
  walletActionId?: InputMaybe<Scalars['String']>;
};

export enum WixRiseV1WalletActionWalletActionContextContextType {
  UNKNOWN_CONTEXT = 'UNKNOWN_CONTEXT',
  WORKFLOW = 'WORKFLOW'
}

export type WixRiseV1WalletActionWalletActionContextWorkflowPayload = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type WixRiseV1WalletActionWalletActionContextWorkflowPayloadInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1WalletActionWalletActionExecutionDetails = {
  /** Represents the time at which the WalletAction was executed. */
  executionDate?: Maybe<Scalars['String']>;
  /** ID of the Gift Card Transaction created by the WalletAction. */
  transactionId?: Maybe<Scalars['String']>;
};

export type WixRiseV1WalletActionWalletActionExecutionDetailsInput = {
  /** Represents the time at which the WalletAction was executed. */
  executionDate?: InputMaybe<Scalars['String']>;
  /** ID of the Gift Card Transaction created by the WalletAction. */
  transactionId?: InputMaybe<Scalars['String']>;
};

export enum WixRiseV1WalletActionWalletActionSourceSourceType {
  APP = 'APP',
  UNKNOWN_SOURCE = 'UNKNOWN_SOURCE',
  USER = 'USER'
}

export enum WixRiseV1WalletActionWalletActionStatus {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  PENDING = 'PENDING'
}

export enum WixRiseV1WalletActionWalletActionType {
  REFUND = 'REFUND',
  REWARD = 'REWARD',
  UNKNOWN = 'UNKNOWN'
}

export type WixRiseV1WalletActionWithBalance = {
  /** Remaining balance of the WalletAction. */
  balance?: Maybe<Scalars['String']>;
  /** WalletAction. */
  walletAction?: Maybe<WixRiseV1WalletAction>;
};

export type WixRiseV1WalletQueryInput = {
  /** CustomerReference source (i.e. source channel, tenant, and customer IDs). */
  customerReferenceSource?: InputMaybe<WixRiseV1SourceInput>;
  /** Email address. */
  email?: InputMaybe<Scalars['String']>;
  /** Wallet ID. */
  walletId?: InputMaybe<Scalars['String']>;
};

export type WixRiseV1WorkflowOptions = {
  /** ID of the workflow that issued the gift card. */
  workflowId?: Maybe<Scalars['String']>;
};

export type WixRiseV1WorkflowOptionsInput = {
  /** ID of the workflow that issued the gift card. */
  workflowId?: InputMaybe<Scalars['String']>;
};

export type WixRiseWalletActionV1UpstreamWixCommonBulkActionMetadata = {
  /** Number of items that couldn't be processed. */
  totalFailures?: Maybe<Scalars['Int']>;
  /** Number of items that were successfully processed. */
  totalSuccesses?: Maybe<Scalars['Int']>;
  /** Number of failures without details because detailed failure threshold was exceeded. */
  undetailedFailures?: Maybe<Scalars['Int']>;
};

export type WixRiseWalletActionV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export type WixRiseWalletActionV1UpstreamWixCommonCursors = {
  /** Cursor pointing to next page in the list of results. */
  next?: Maybe<Scalars['String']>;
  /** Cursor pointing to previous page in the list of results. */
  prev?: Maybe<Scalars['String']>;
};

export type WixRiseWalletActionV1UpstreamWixCommonItemMetadata = {
  /** Details about the error in case of failure. */
  error?: Maybe<WixApiApplicationError>;
  /** Item ID. Provided only whenever possible. For example, `itemId` can't be provided when item creation has failed. */
  id?: Maybe<Scalars['String']>;
  /** Index of the item within the request array. Allows for correlation between request and response items. */
  originalIndex?: Maybe<Scalars['Int']>;
  /** Whether the requested action for this item was successful. When `false`, the `error` field is returned. */
  success?: Maybe<Scalars['Boolean']>;
};

export type WixRiseWalletActionV1UpstreamWixCommonPagingInput = {
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip in the current sort order. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type WixRiseWalletActionV1UpstreamWixCommonPagingMetadataV2 = {
  /** Number of items returned in the response. */
  count?: Maybe<Scalars['Int']>;
  /** Cursors to navigate through the result pages using `next` and `prev`. Returned if cursor paging is used. */
  cursors?: Maybe<WixRiseWalletActionV1UpstreamWixCommonCursors>;
  /**
   * Indicates if there are more results after the current page.
   * If `true`, another page of results can be retrieved.
   * If `false`, this is the last page.
   */
  hasNext?: Maybe<Scalars['Boolean']>;
  /** Offset that was requested. */
  offset?: Maybe<Scalars['Int']>;
  /** Flag that indicates the server failed to calculate the `total` field. */
  tooManyToCount?: Maybe<Scalars['Boolean']>;
  /** Total number of items that match the query. Returned if offset paging is used and the `tooManyToCount` flag is not set. */
  total?: Maybe<Scalars['Int']>;
};

export enum WixRiseWalletActionV1UpstreamWixCommonSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type WixRiseWalletActionV1UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixRiseWalletActionV1UpstreamWixCommonSortOrder>;
};

export type WixRiseWalletActionV1UpstreamWixCommonTags = {
  /** Tags that require an additional permission in order to access them, typically restricted from site members and visitors. */
  privateTags?: Maybe<WixRiseWalletActionV1UpstreamWixCommonTagsTagList>;
  /** Tags that are exposed to anyone with access to the entity, including site members and visitors. */
  publicTags?: Maybe<WixRiseWalletActionV1UpstreamWixCommonTagsTagList>;
};

export type WixRiseWalletActionV1UpstreamWixCommonTagsInput = {
  /** Tags that require an additional permission in order to access them, typically restricted from site members and visitors. */
  privateTags?: InputMaybe<WixRiseWalletActionV1UpstreamWixCommonTagsTagListInput>;
  /** Tags that are exposed to anyone with access to the entity, including site members and visitors. */
  publicTags?: InputMaybe<WixRiseWalletActionV1UpstreamWixCommonTagsTagListInput>;
};

export type WixRiseWalletActionV1UpstreamWixCommonTagsTagList = {
  /** List of tag IDs. */
  tagIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type WixRiseWalletActionV1UpstreamWixCommonTagsTagListInput = {
  /** List of tag IDs. */
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type WixRiseWalletActionV1UpstreamWixQueryQueryV2Input = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixRiseWalletActionV1UpstreamWixCommonCursorPagingInput>;
  /** Array of projected fields. A list of specific field names to return. If `fieldsets` are also specified, the union of `fieldsets` and `fields` is returned. */
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of named, predefined sets of projected fields. A array of predefined named sets of fields to be returned. Specifying multiple `fieldsets` will return the union of fields from all sets. If `fields` are also specified, the union of `fieldsets` and `fields` is returned. */
  fieldsets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /** Paging options to limit and skip the number of items. */
  paging?: InputMaybe<WixRiseWalletActionV1UpstreamWixCommonPagingInput>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixRiseWalletActionV1UpstreamWixCommonSortingInput>>>;
};

export type WixRiseWorkflowV1Action = {
  conditionOptions?: Maybe<WixRiseWorkflowV1ConditionOptions>;
  fieldsReferences?: Maybe<WixRiseWorkflowV1FieldValueMapper>;
  id?: Maybe<Scalars['String']>;
  /** Issue store credit */
  issueStoreCreditOptions?: Maybe<WixRiseWorkflowV1IssueStoreCreditOptions>;
  type?: Maybe<WixRiseWorkflowV1ActionActionType>;
};

export enum WixRiseWorkflowV1ActionActionType {
  CONDITION = 'CONDITION',
  ISSUE_STORE_CREDIT = 'ISSUE_STORE_CREDIT',
  UNKNOWN_ACTION_TYPE = 'UNKNOWN_ACTION_TYPE'
}

export type WixRiseWorkflowV1ActionInput = {
  conditionOptions?: InputMaybe<WixRiseWorkflowV1ConditionOptionsInput>;
  fieldsReferences?: InputMaybe<WixRiseWorkflowV1FieldValueMapperInput>;
  id?: InputMaybe<Scalars['String']>;
  /** Issue store credit */
  issueStoreCreditOptions?: InputMaybe<WixRiseWorkflowV1IssueStoreCreditOptionsInput>;
  type?: InputMaybe<WixRiseWorkflowV1ActionActionType>;
};

export type WixRiseWorkflowV1ConditionOptions = {
  actions?: Maybe<Array<Maybe<WixRiseWorkflowV1Action>>>;
  conditions?: Maybe<Array<Maybe<WixRiseWorkflowV1LogicalCondition>>>;
  operator?: Maybe<WixRiseWorkflowV1ConditionOptionsCompoundOperator>;
};

export enum WixRiseWorkflowV1ConditionOptionsCompoundOperator {
  AND = 'AND',
  OR = 'OR',
  UNKNOWN_COMPOUND_OPERATOR_TYPE = 'UNKNOWN_COMPOUND_OPERATOR_TYPE'
}

export type WixRiseWorkflowV1ConditionOptionsInput = {
  actions?: InputMaybe<Array<InputMaybe<WixRiseWorkflowV1ActionInput>>>;
  conditions?: InputMaybe<Array<InputMaybe<WixRiseWorkflowV1LogicalConditionInput>>>;
  operator?: InputMaybe<WixRiseWorkflowV1ConditionOptionsCompoundOperator>;
};

export type WixRiseWorkflowV1CreateWorkflowRequestInput = {
  /** Workflow to be created. */
  workflow?: InputMaybe<WixRiseWorkflowV1WorkflowInput>;
};

export type WixRiseWorkflowV1CreateWorkflowResponse = {
  /** The created Workflow. */
  workflow?: Maybe<WixRiseWorkflowV1Workflow>;
};

export type WixRiseWorkflowV1CustomerReferenceInput = {
  /** Email */
  email?: InputMaybe<Scalars['String']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']>;
  /** Internal id */
  id?: InputMaybe<Scalars['String']>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']>;
  /** Phone */
  phone?: InputMaybe<Scalars['String']>;
  /** Source channel, i.e. Shopify */
  sourceChannelId?: InputMaybe<Scalars['String']>;
  /** Customer ID in Source */
  sourceCustomerId?: InputMaybe<Scalars['String']>;
  /** Tenant ID in Source, i.e. shop ID */
  sourceTenantId?: InputMaybe<Scalars['String']>;
};

export type WixRiseWorkflowV1DeleteWorkflowRequestInput = {
  revision?: InputMaybe<Scalars['Long']>;
  /** Id of the Workflow to delete. */
  workflowId?: InputMaybe<Scalars['String']>;
};

export type WixRiseWorkflowV1FieldValueMapper = {
  type?: Maybe<WixRiseWorkflowV1FieldValueMapperMappingType>;
  value?: Maybe<Scalars['String']>;
};

export type WixRiseWorkflowV1FieldValueMapperInput = {
  type?: InputMaybe<WixRiseWorkflowV1FieldValueMapperMappingType>;
  value?: InputMaybe<Scalars['String']>;
};

export enum WixRiseWorkflowV1FieldValueMapperMappingType {
  FIXED = 'FIXED',
  PATH = 'PATH',
  UNKNOWN_MAPPING_TYPE = 'UNKNOWN_MAPPING_TYPE'
}

export type WixRiseWorkflowV1GetWorkflowRequestInput = {
  id: Scalars['ID'];
};

export type WixRiseWorkflowV1IssueStoreCreditOptions = {
  settings?: Maybe<WixRiseWorkflowV1IssueStoreCreditSettings>;
};

export type WixRiseWorkflowV1IssueStoreCreditOptionsInput = {
  settings?: InputMaybe<WixRiseWorkflowV1IssueStoreCreditSettingsInput>;
};

export type WixRiseWorkflowV1IssueStoreCreditSettings = {
  amount?: Maybe<Scalars['String']>;
  type?: Maybe<WixRiseWorkflowV1IssueStoreCreditSettingsType>;
};

export type WixRiseWorkflowV1IssueStoreCreditSettingsInput = {
  amount?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<WixRiseWorkflowV1IssueStoreCreditSettingsType>;
};

export enum WixRiseWorkflowV1IssueStoreCreditSettingsType {
  FIXED = 'FIXED',
  PERCENTAGE = 'PERCENTAGE',
  UNKNOWN_TYPE = 'UNKNOWN_TYPE'
}

export type WixRiseWorkflowV1ListTriggersResponse = {
  /** The created Workflow. */
  triggers?: Maybe<Array<Maybe<WixRiseWorkflowV1Trigger>>>;
};

export type WixRiseWorkflowV1LogicalCondition = {
  /** i.e: orderTotal */
  fieldReference?: Maybe<Scalars['String']>;
  operator?: Maybe<WixRiseWorkflowV1LogicalConditionLogicalOperator>;
  /** i.e: 100 (USD) */
  value?: Maybe<Scalars['String']>;
};

export type WixRiseWorkflowV1LogicalConditionInput = {
  /** i.e: orderTotal */
  fieldReference?: InputMaybe<Scalars['String']>;
  operator?: InputMaybe<WixRiseWorkflowV1LogicalConditionLogicalOperator>;
  /** i.e: 100 (USD) */
  value?: InputMaybe<Scalars['String']>;
};

export enum WixRiseWorkflowV1LogicalConditionLogicalOperator {
  EQ = 'EQ',
  NUMBER_EQ = 'NUMBER_EQ',
  NUMBER_GT = 'NUMBER_GT',
  NUMBER_GTE = 'NUMBER_GTE',
  NUMBER_LT = 'NUMBER_LT',
  NUMBER_LTE = 'NUMBER_LTE',
  UNKNOWN_LOGICAL_OPERATOR_TYPE = 'UNKNOWN_LOGICAL_OPERATOR_TYPE'
}

export type WixRiseWorkflowV1OrderPaidOptionsInput = {
  payload?: InputMaybe<WixRiseWorkflowV1OrderPaidPayloadInput>;
};

export type WixRiseWorkflowV1OrderPaidPayloadInput = {
  currency?: InputMaybe<Scalars['String']>;
  customerReference?: InputMaybe<WixRiseWorkflowV1CustomerReferenceInput>;
  orderId?: InputMaybe<Scalars['String']>;
  orderTotal?: InputMaybe<Scalars['String']>;
};

export type WixRiseWorkflowV1QueryWorkflowsRequestInput = {
  /** WQL expression. */
  query?: InputMaybe<WixRiseWorkflowV1UpstreamWixQueryCursorQueryInput>;
};

export type WixRiseWorkflowV1QueryWorkflowsResponse = {
  /** Query results */
  items?: Maybe<Array<Maybe<WixRiseWorkflowV1Workflow>>>;
  /** Pagination data */
  pageInfo?: Maybe<PageInfo>;
};

export type WixRiseWorkflowV1ReportTriggerRequestInput = {
  orderPaidOptions?: InputMaybe<WixRiseWorkflowV1OrderPaidOptionsInput>;
  type?: InputMaybe<WixRiseWorkflowV1ReportTriggerRequestTriggerType>;
};

export enum WixRiseWorkflowV1ReportTriggerRequestTriggerType {
  ORDER_PAID = 'ORDER_PAID',
  UNKNOWN = 'UNKNOWN'
}

export type WixRiseWorkflowV1Trigger = {
  /** Id of the trigger */
  id?: Maybe<Scalars['String']>;
  /** Friendly name of the trigger */
  name?: Maybe<Scalars['String']>;
};

export type WixRiseWorkflowV1UpdateWorkflowRequestInput = {
  fieldMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Workflow to be updated, may be partial. */
  workflow?: InputMaybe<WixRiseWorkflowV1WorkflowInput>;
};

export type WixRiseWorkflowV1UpdateWorkflowResponse = {
  /** Updated Workflow. */
  workflow?: Maybe<WixRiseWorkflowV1Workflow>;
};

export type WixRiseWorkflowV1UpstreamWixCommonCursorPagingInput = {
  /**
   * Pointer to the next or previous page in the list of results.
   *
   * You can get the relevant cursor token
   * from the `pagingMetadata` object in the previous call's response.
   * Not relevant for the first request.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of items to load. */
  limit?: InputMaybe<Scalars['Int']>;
};

export enum WixRiseWorkflowV1UpstreamWixCommonSortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type WixRiseWorkflowV1UpstreamWixCommonSortingInput = {
  /** Name of the field to sort by. */
  fieldName?: InputMaybe<Scalars['String']>;
  /** Sort order. */
  order?: InputMaybe<WixRiseWorkflowV1UpstreamWixCommonSortOrder>;
};

export type WixRiseWorkflowV1UpstreamWixQueryCursorQueryInput = {
  /** Cursor token pointing to a page of results. Not used in the first request. Following requests use the cursor token and not `filter` or `sort`. */
  cursorPaging?: InputMaybe<WixRiseWorkflowV1UpstreamWixCommonCursorPagingInput>;
  /**
   * Filter object in the following format:
   * `"filter" : {
   * "fieldName1": "value1",
   * "fieldName2":{"$operator":"value2"}
   * }`
   * Example of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`
   */
  filter?: InputMaybe<Scalars['JSON']>;
  /**
   * Sort object in the following format:
   * `[{"fieldName":"sortField1","order":"ASC"},{"fieldName":"sortField2","order":"DESC"}]`
   */
  sort?: InputMaybe<Array<InputMaybe<WixRiseWorkflowV1UpstreamWixCommonSortingInput>>>;
};

export type WixRiseWorkflowV1Workflow = {
  /** List of all the actions that will be executed in this workflow. */
  actions?: Maybe<Array<Maybe<WixRiseWorkflowV1Action>>>;
  /** Date and time the Workflow was created. */
  createdDate?: Maybe<Scalars['String']>;
  /** Description of the workflow */
  description?: Maybe<Scalars['String']>;
  esbConfigurationId?: Maybe<Scalars['String']>;
  /** Workflow ID. */
  id?: Maybe<Scalars['String']>;
  /** Name of the workflow */
  name?: Maybe<Scalars['String']>;
  revision?: Maybe<Scalars['Long']>;
  /** Status of the workflow */
  status?: Maybe<WixRiseWorkflowV1WorkflowStatus>;
  /** The initial trigger that starts the workflow */
  triggerId?: Maybe<Scalars['String']>;
  /** Date and time the Workflow was last updated. */
  updatedDate?: Maybe<Scalars['String']>;
};

export type WixRiseWorkflowV1WorkflowInput = {
  /** List of all the actions that will be executed in this workflow. */
  actions?: InputMaybe<Array<InputMaybe<WixRiseWorkflowV1ActionInput>>>;
  /** Date and time the Workflow was created. */
  createdDate?: InputMaybe<Scalars['String']>;
  /** Description of the workflow */
  description?: InputMaybe<Scalars['String']>;
  esbConfigurationId?: InputMaybe<Scalars['String']>;
  /** Workflow ID. */
  id?: InputMaybe<Scalars['String']>;
  /** Name of the workflow */
  name?: InputMaybe<Scalars['String']>;
  revision?: InputMaybe<Scalars['Long']>;
  /** Status of the workflow */
  status?: InputMaybe<WixRiseWorkflowV1WorkflowStatus>;
  /** The initial trigger that starts the workflow */
  triggerId?: InputMaybe<Scalars['String']>;
  /** Date and time the Workflow was last updated. */
  updatedDate?: InputMaybe<Scalars['String']>;
};

export enum WixRiseWorkflowV1WorkflowStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  UNKNOWN_STATUS = 'UNKNOWN_STATUS'
}

export type WixSearchV1SearchIndexingNotificationInput = {
  /** type of the document the notification is targeted for. Applies to all types if not provided */
  documentType?: InputMaybe<Scalars['String']>;
  /** new state of indexing for the site specified in ms_id */
  indexState?: InputMaybe<WixSearchV1SearchIndexingNotificationState>;
  /** languaInternalDocumentUpdateByFilterOperationge the notification is targeted for. Applies to all languages if not provided */
  language?: InputMaybe<Scalars['String']>;
  /** site for which notification is targeted */
  msId?: InputMaybe<Scalars['String']>;
};

export enum WixSearchV1SearchIndexingNotificationState {
  /** metasite does not require site search indexing */
  Off = 'Off',
  /** metasite requires site search indexing */
  On = 'On',
  /** default state */
  Unknown = 'Unknown'
}

export type WixSubscriptionsApiV1AppliedCouponInput = {
  /** Coupon code */
  code?: InputMaybe<Scalars['String']>;
  /** Coupon ID */
  couponId?: InputMaybe<Scalars['String']>;
  /** Coupon name */
  name?: InputMaybe<Scalars['String']>;
};

export type WixSubscriptionsApiV1BillingInfoInput = {
  /** Order ID from payment gateway (e.g., Wix Payments) */
  paymentGatewayOrderId?: InputMaybe<Scalars['String']>;
  /** Transaction ID from payment gateway (e.g., Wix Payments) */
  paymentGatewayTransactionId?: InputMaybe<Scalars['String']>;
  /** Payment method used for this order */
  paymentMethod?: InputMaybe<Scalars['String']>;
};

export type WixSubscriptionsApiV1BuyerInfoInput = {
  /** Wix customer ID */
  id?: InputMaybe<Scalars['String']>;
  /** Customer type */
  identityType?: InputMaybe<WixSubscriptionsApiV1IdentityType>;
  visitorId?: InputMaybe<Scalars['String']>;
};

export enum WixSubscriptionsApiV1ChannelInfoChannelType {
  OTHER_PLATFORM = 'OTHER_PLATFORM',
  UNSPECIFIED = 'UNSPECIFIED',
  WEB = 'WEB',
  WIX_APP_STORE = 'WIX_APP_STORE'
}

export type WixSubscriptionsApiV1ChannelInfoInput = {
  /** Sales channel that submitted the subscription */
  type?: InputMaybe<WixSubscriptionsApiV1ChannelInfoChannelType>;
};

export type WixSubscriptionsApiV1ChargeDetailsInput = {
  /** Discount applied for this line item */
  discount?: InputMaybe<Scalars['Float']>;
  /** price of line item (depends on subscription option) */
  price?: InputMaybe<Scalars['Float']>;
  /** Tax applied for this line item */
  tax?: InputMaybe<Scalars['Float']>;
  /** Is tax applied for this line item */
  taxIncludedInPrice?: InputMaybe<Scalars['Boolean']>;
  /** Tax rate %, as a decimal point >= 0 */
  taxRate?: InputMaybe<Scalars['String']>;
  /** Total price charged to the customer (for this line items) after computation of quantity and discount */
  totalPrice?: InputMaybe<Scalars['Float']>;
};

export type WixSubscriptionsApiV1CustomFieldInput = {
  /** Title for the custom field */
  title?: InputMaybe<Scalars['String']>;
  /** The title translated according to the buyer language */
  translatedTitle?: InputMaybe<Scalars['String']>;
  /** Free text that the customer entered in the custom field during the checkout process */
  value?: InputMaybe<Scalars['String']>;
};

export type WixSubscriptionsApiV1CustomTextFieldSelectionInput = {
  /** Custom text field name */
  title?: InputMaybe<Scalars['String']>;
  /** Custom text field value */
  value?: InputMaybe<Scalars['String']>;
};

export enum WixSubscriptionsApiV1IdentityType {
  /** Contact */
  CONTACT = 'CONTACT',
  /** Site member */
  MEMBER = 'MEMBER',
  UNSPECIFIED_IDENTITY_TYPE = 'UNSPECIFIED_IDENTITY_TYPE'
}

export type WixSubscriptionsApiV1LineItemInput = {
  /** Charges details */
  chargeDetails?: InputMaybe<WixSubscriptionsApiV1ChargeDetailsInput>;
  /** Line item custom text field selections */
  customTextFields?: InputMaybe<Array<InputMaybe<WixSubscriptionsApiV1CustomTextFieldSelectionInput>>>;
  /** Line item ID (auto-generated) */
  index?: InputMaybe<Scalars['Int']>;
  /** Line item options ordered */
  options?: InputMaybe<Array<InputMaybe<WixSubscriptionsApiV1OptionSelectionInput>>>;
  /** Product details */
  productDetails?: InputMaybe<WixSubscriptionsApiV1ProductDetailsInput>;
  /** Line item quantity */
  quantity?: InputMaybe<Scalars['Int']>;
  /** Line item variantId (from Stores Catalog) */
  variantId?: InputMaybe<Scalars['String']>;
};

export enum WixSubscriptionsApiV1LineItemType {
  /** Custom item price */
  CUSTOM_AMOUNT_ITEM = 'CUSTOM_AMOUNT_ITEM',
  /** Digital item type */
  DIGITAL = 'DIGITAL',
  /** Physical item type */
  PHYSICAL = 'PHYSICAL',
  /** Line item type can't be classified, due to an error */
  UNSPECIFIED_LINE_ITEM_TYPE = 'UNSPECIFIED_LINE_ITEM_TYPE'
}

export type WixSubscriptionsApiV1MediaItemInput = {
  /** Alternative text for presentation when media cannot be displayed */
  altText?: InputMaybe<Scalars['String']>;
  /** Media external URL */
  externalImageUrl?: InputMaybe<Scalars['String']>;
  /** Media item height */
  height?: InputMaybe<Scalars['Int']>;
  /** Media ID (for media items previously saved in Wix Media) */
  id?: InputMaybe<Scalars['String']>;
  /** Media type */
  mediaType?: InputMaybe<WixSubscriptionsApiV1MediaItemType>;
  /** Media URL */
  url?: InputMaybe<Scalars['String']>;
  /** Media item width */
  width?: InputMaybe<Scalars['Int']>;
};

export enum WixSubscriptionsApiV1MediaItemType {
  /** Image item type */
  IMAGE = 'IMAGE',
  /** Media item type can't be classified, due to an error */
  UNSPECIFIED_MEDIA_TYPE_ITEM = 'UNSPECIFIED_MEDIA_TYPE_ITEM'
}

export type WixSubscriptionsApiV1OptionSelectionInput = {
  /** Option name */
  option?: InputMaybe<Scalars['String']>;
  /** Selected choice for this option */
  selection?: InputMaybe<Scalars['String']>;
};

export type WixSubscriptionsApiV1PickupAddressInput = {
  /** Address */
  addressLine?: InputMaybe<Scalars['String']>;
  /** City */
  city?: InputMaybe<Scalars['String']>;
  /** Country code (2 letters) */
  country?: InputMaybe<Scalars['String']>;
  /** State/District */
  subdivision?: InputMaybe<Scalars['String']>;
  /** ZIP/postal code */
  zipCode?: InputMaybe<Scalars['String']>;
};

export type WixSubscriptionsApiV1PickupDetailsInput = {
  /** Pickup address */
  address?: InputMaybe<WixSubscriptionsApiV1PickupAddressInput>;
  /** Store owner's pickup instructions */
  pickupInstructions?: InputMaybe<Scalars['String']>;
};

export type WixSubscriptionsApiV1ProductDetailsInput = {
  /** App id from the catalog reference */
  appId?: InputMaybe<Scalars['String']>;
  /** Line item fulfillerId from stores fulfillers. No value means self fulfilled */
  fulfillerId?: InputMaybe<Scalars['String']>;
  /** Line item type (may be extended) */
  lineItemType?: InputMaybe<WixSubscriptionsApiV1LineItemType>;
  /** Line item primary media for preview */
  mediaItem?: InputMaybe<WixSubscriptionsApiV1MediaItemInput>;
  /** Line item name */
  name?: InputMaybe<Scalars['String']>;
  /** Line item notes */
  notes?: InputMaybe<Scalars['String']>;
  /** Line item product ID (optional for POS orders) */
  productId?: InputMaybe<Scalars['String']>;
  /** Line item SKU */
  sku?: InputMaybe<Scalars['String']>;
  /** Tax group id */
  taxGroupId?: InputMaybe<Scalars['String']>;
  /** Line item name translated to buyer's language */
  translatedName?: InputMaybe<Scalars['String']>;
  /** Line item weight */
  weight?: InputMaybe<Scalars['Float']>;
};

export type WixSubscriptionsApiV1ShipmentDetailsInput = {
  /** Shipping destination address */
  address?: InputMaybe<ComWixEcommerceCommonsApiAddressInput>;
  /** Discount applied for shipping */
  discount?: InputMaybe<Scalars['Float']>;
  /** Tax applied for shipping */
  tax?: InputMaybe<Scalars['Float']>;
  /** Whether tax is included in the price */
  taxIncludedInPrice?: InputMaybe<Scalars['Boolean']>;
  /** Tax rate % for shipping, as a decimal point >= 0 */
  taxRate?: InputMaybe<Scalars['String']>;
};

export type WixSubscriptionsApiV1ShippingInfoInput = {
  /** Delivery option name */
  deliveryOption?: InputMaybe<Scalars['String']>;
  /** Delivery option delivery time */
  estimatedDeliveryTime?: InputMaybe<Scalars['String']>;
  /** Pickup details (when this object describes pickup) */
  pickupDetails?: InputMaybe<WixSubscriptionsApiV1PickupDetailsInput>;
  /** Shipment details (when this object describes shipment) */
  shipmentDetails?: InputMaybe<WixSubscriptionsApiV1ShipmentDetailsInput>;
};

export type WixSubscriptionsApiV1StoreSettingsInput = {
  /**
   * The language to be used when communicating with the buyer
   * For a site that support multiple languages, this would be the language the buyer selected
   * Otherwise this would be the site language
   */
  buyerLanguage?: InputMaybe<Scalars['String']>;
  /** Currency used for pricing in this store */
  currency?: InputMaybe<Scalars['String']>;
  /** Weight unit used in this store */
  weightUnit?: InputMaybe<ComWixEcommercePlatformCommonApiWeightUnit>;
};

export type WixSubscriptionsApiV1SubscriptionCreatedInput = {
  subscription?: InputMaybe<WixSubscriptionsApiV1SubscriptionInput>;
};

export type WixSubscriptionsApiV1SubscriptionInput = {
  /** Coupon that was applied to subscription */
  appliedCoupon?: InputMaybe<WixSubscriptionsApiV1AppliedCouponInput>;
  /** Full billing address */
  billingAddress?: InputMaybe<ComWixEcommerceCommonsApiAddressInput>;
  /** information about first subscription payment */
  billingInfo?: InputMaybe<WixSubscriptionsApiV1BillingInfoInput>;
  /** member or contact */
  buyerInfo?: InputMaybe<WixSubscriptionsApiV1BuyerInfoInput>;
  /** Message from the customer (e.g., customization request) */
  buyerNote?: InputMaybe<Scalars['String']>;
  /** The id of the cart this order was created from */
  cartId?: InputMaybe<Scalars['String']>;
  /** Sales channel that submitted this subscription */
  channelInfo?: InputMaybe<WixSubscriptionsApiV1ChannelInfoInput>;
  /** The id of the checkout this subscriptions was created from */
  checkoutId?: InputMaybe<Scalars['String']>;
  /** Custom field */
  customField?: InputMaybe<WixSubscriptionsApiV1CustomFieldInput>;
  /** Subscription creation date */
  dateCreated?: InputMaybe<Scalars['String']>;
  /** id of subscription in external system */
  externalId?: InputMaybe<Scalars['String']>;
  /** Subscription id (auto-generated upon subscription creation) */
  id?: InputMaybe<Scalars['String']>;
  /** Line items ordered */
  lineItems?: InputMaybe<Array<InputMaybe<WixSubscriptionsApiV1LineItemInput>>>;
  /** Delivery information */
  shippingInfo?: InputMaybe<WixSubscriptionsApiV1ShippingInfoInput>;
  /** site settings at the moment when subscription created */
  storeSettings?: InputMaybe<WixSubscriptionsApiV1StoreSettingsInput>;
  /** Information about subscription option from which subscription was created */
  subscriptionOptionInfo?: InputMaybe<WixSubscriptionsApiV1SubscriptionOptionInfoInput>;
  /** defines when subscriber will be charged: for frequency=MONTH, billingCycles=6, interval=2 payment will be done every 2 month during one year */
  subscriptionSettings?: InputMaybe<WixEcommerceSubscriptionOptionApiV1SubscriptionSettingsInput>;
  /** Totals for subscription's line items */
  totals?: InputMaybe<WixSubscriptionsApiV1TotalsInput>;
};

export type WixSubscriptionsApiV1SubscriptionOptionInfoInput = {
  description?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<WixEcommerceSubscriptionOptionApiV1DiscountInput>;
  id?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type WixSubscriptionsApiV1TotalsInput = {
  /** Total calculated discount value */
  discount?: InputMaybe<Scalars['Float']>;
  /** Total line items quantity */
  quantity?: InputMaybe<Scalars['Int']>;
  /** Total shipping price, including tax */
  shipping?: InputMaybe<Scalars['Float']>;
  /** Total shipping price, after tax (identical to shipping) */
  shippingAfterTax?: InputMaybe<Scalars['Float']>;
  /** Total shipping price, before tax */
  shippingBeforeTax?: InputMaybe<Scalars['Float']>;
  /** Subtotal of all line items, before tax */
  subtotal?: InputMaybe<Scalars['Float']>;
  /** Total tax */
  tax?: InputMaybe<Scalars['Float']>;
  /** Total price */
  total?: InputMaybe<Scalars['Float']>;
  /** Total weight */
  weight?: InputMaybe<Scalars['Float']>;
};

export type CheckoutFragment = { id?: string | null, buyerNote?: string | null, conversionCurrency?: string | null, weightUnit?: ComWixEcommercePlatformCommonApiWeightUnit | null, currency?: string | null, paymentCurrency?: string | null, channelType?: ComWixEcommercePlatformCommonApiChannelType | null, siteLanguage?: string | null, buyerLanguage?: string | null, completed?: boolean | null, taxIncludedInPrice?: boolean | null, createdDate?: string | null, updatedDate?: string | null, cartId?: string | null, orderId?: string | null, purchaseFlowId?: string | null, paymentRequired?: boolean | null, lineItems?: Array<{ id?: string | null, quantity?: number | null, fulfillerId?: string | null, shippingGroupId?: string | null, paymentOption?: ComWixEcommerceCatalogSpiApiV1PaymentOptionType | null, rootCatalogItemId?: string | null, consentRequiredPaymentPolicy?: string | null, savePaymentMethod?: boolean | null, priceUndetermined?: boolean | null, fixedQuantity?: boolean | null, membersOnly?: boolean | null, deliveryProfileId?: string | null, catalogReference?: { catalogItemId?: string | null, appId?: string | null, options?: any | null } | null, productName?: { original?: string | null, translated?: string | null } | null, url?: { relativePath?: string | null, url?: string | null } | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, lineItemPrice?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, fullPrice?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, priceBeforeDiscounts?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceAfterTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, modifiersTotalPrice?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, descriptionLines?: Array<{ lineType?: ComWixEcommerceCatalogSpiApiV1DescriptionLineDescriptionLineType | null, color?: string | null, name?: { original?: string | null, translated?: string | null } | null, plainText?: { original?: string | null, translated?: string | null } | null, colorInfo?: { original?: string | null, translated?: string | null, code?: string | null } | null, plainTextValue?: { original?: string | null, translated?: string | null } | null } | null> | null, media?: { id?: string | null, url?: string | null, height?: number | null, width?: number | null, altText?: string | null, urlExpirationDate?: string | null, filename?: string | null, sizeInBytes?: string | null } | null, availability?: { status?: EcomCheckoutV1ItemAvailabilityStatus | null, quantityAvailable?: number | null } | null, physicalProperties?: { weight?: number | null, sku?: string | null, shippable?: boolean | null } | null, couponScopes?: Array<{ namespace?: string | null, group?: { name?: string | null, entityId?: string | null } | null } | null> | null, itemType?: { preset?: ComWixEcommerceCatalogSpiApiV1ItemTypeItemType | null, custom?: string | null } | null, subscriptionOptionInfo?: { subscriptionSettings?: { frequency?: WixPaymentApiPayV2SubscriptionFrequency | null, interval?: number | null, autoRenewal?: boolean | null, billingCycles?: number | null, startDate?: string | null, freeTrialPeriod?: { interval?: number | null, frequency?: WixPaymentApiPayV2SubscriptionFrequency | null } | null } | null, title?: { original?: string | null, translated?: string | null } | null, description?: { original?: string | null, translated?: string | null } | null } | null, digitalFile?: { id?: string | null, fileName?: string | null, fileType?: ComWixEcommerceCatalogSpiApiV1SecuredMediaFileType | null } | null, serviceProperties?: { scheduledDate?: string | null, numberOfParticipants?: number | null } | null, priceDescription?: { original?: string | null, translated?: string | null } | null, depositAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, policies?: Array<{ title?: string | null, content?: string | null } | null> | null, taxableAddress?: { addressType?: ComWixEcommercePlatformCommonApiTaxableAddressTaxableAddressType | null } | null, modifierGroups?: Array<{ id?: string | null, name?: { original?: string | null, translated?: string | null } | null, modifiers?: Array<{ id?: string | null, quantity?: number | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, label?: { original?: string | null, translated?: string | null } | null, details?: { original?: string | null, translated?: string | null } | null } | null> | null } | null> | null } | null> | null, billingInfo?: { addressesServiceId?: string | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null, contactDetails?: { firstName?: string | null, lastName?: string | null, phone?: string | null, company?: string | null, vatId?: { id?: string | null, type?: WixCommonVatType | null } | null } | null } | null, shippingInfo?: { shippingDestination?: { addressesServiceId?: string | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, geocode?: { latitude?: number | null, longitude?: number | null } | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null, contactDetails?: { firstName?: string | null, lastName?: string | null, phone?: string | null, company?: string | null, vatId?: { id?: string | null, type?: WixCommonVatType | null } | null } | null } | null, selectedCarrierServiceOption?: { code?: string | null, title?: string | null, requestedShippingOption?: boolean | null, carrierId?: string | null, logistics?: { deliveryTime?: string | null, instructions?: string | null, pickupDetails?: { businessLocation?: boolean | null, pickupMethod?: ComWixEcomTotalsCalculatorV1PickupDetailsPickupMethod | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, geocode?: { latitude?: number | null, longitude?: number | null } | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null } | null, deliveryTimeSlot?: { from?: string | null, to?: string | null } | null } | null, cost?: { totalPriceAfterTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, totalDiscount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, otherCharges?: Array<{ type?: ComWixEcomTotalsCalculatorV1ChargeType | null, details?: string | null, cost?: { totalPriceAfterTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, totalDiscount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null } | null> | null } | null, region?: { id?: string | null, name?: string | null } | null, carrierServiceOptions?: Array<{ carrierId?: string | null, shippingOptions?: Array<{ code?: string | null, title?: string | null, partial?: boolean | null, logistics?: { deliveryTime?: string | null, instructions?: string | null, pickupDetails?: { businessLocation?: boolean | null, pickupMethod?: ComWixEcomTotalsCalculatorV1PickupDetailsPickupMethod | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, geocode?: { latitude?: number | null, longitude?: number | null } | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null } | null, deliveryTimeSlot?: { from?: string | null, to?: string | null } | null } | null, cost?: { price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, otherCharges?: Array<{ type?: ComWixEcomTotalsCalculatorV1ChargeType | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null } | null } | null> | null } | null> | null } | null, buyerInfo?: { contactId?: string | null, email?: string | null, visitorId?: string | null, memberId?: string | null, openAccess?: boolean | null } | null, priceSummary?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, calculationErrors?: { generalShippingCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, carrierErrors?: { errors?: Array<{ carrierId?: string | null, error?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null } | null> | null } | null, taxCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, couponCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, giftCardCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, membershipError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, discountsCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, orderValidationErrors?: Array<{ code?: string | null, description?: string | null, data?: any | null } | null> | null } | null, giftCard?: { id?: string | null, obfuscatedCode?: string | null, appId?: string | null, amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, appliedDiscounts?: Array<{ discountType?: ComWixEcomTotalsCalculatorV1AppliedDiscountDiscountType | null, lineItemIds?: Array<string | null> | null, coupon?: { id?: string | null, code?: string | null, name?: string | null, couponType?: string | null, amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, merchantDiscount?: { amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, discountRule?: { id?: string | null, name?: { original?: string | null, translated?: string | null } | null, amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null } | null> | null, customFields?: Array<{ value?: any | null, title?: string | null, translatedTitle?: string | null } | null> | null, taxSummary?: { manualTaxRate?: string | null, taxEstimationId?: string | null, averageTaxRate?: string | null, taxName?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, calculationDetails?: { rateType?: ComWixEcomTaxApiRateType | null, manualRateReason?: ComWixEcomTaxApiManualCalculationReason | null, autoTaxFallbackDetails?: { fallbackReason?: ComWixEcomTaxApiAutoTaxFallbackCalculationDetailsFallbackReason | null, error?: { code?: string | null, description?: string | null, data?: any | null } | null } | null } | null, totalExempt?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, aggregatedTaxBreakdown?: Array<{ taxName?: string | null, aggregatedTaxAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, aggregatedExemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null } | null, createdBy?: { userId?: string | null, memberId?: string | null, visitorId?: string | null, appId?: string | null } | null, payNow?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, payLater?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, payAfterFreeTrial?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, membershipOptions?: { eligibleMemberships?: Array<{ id?: string | null, appId?: string | null, lineItemIds?: Array<string | null> | null, expirationDate?: string | null, additionalData?: any | null, name?: { original?: string | null, translated?: string | null } | null, credits?: { total?: number | null, remaining?: number | null } | null } | null> | null, invalidMemberships?: Array<{ reason?: string | null, membership?: { id?: string | null, appId?: string | null, lineItemIds?: Array<string | null> | null, expirationDate?: string | null, additionalData?: any | null, name?: { original?: string | null, translated?: string | null } | null, credits?: { total?: number | null, remaining?: number | null } | null } | null } | null> | null, selectedMemberships?: { memberships?: Array<{ id?: string | null, appId?: string | null, lineItemIds?: Array<string | null> | null } | null> | null } | null } | null, additionalFees?: Array<{ code?: string | null, source?: ComWixEcomTotalsCalculatorV1AdditionalFeeAdditionalFeeSource | null, name?: string | null, translatedName?: string | null, providerAppId?: string | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, priceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, conversionInfo?: { siteCurrency?: string | null, conversionRate?: string | null } | null, payNowTotalAfterGiftCard?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, violations?: Array<{ severity?: ComWixEcommerceValidationsSpiV1ViolationSeverity | null, description?: string | null, target?: { lineItem?: { id?: string | null, name?: ComWixEcommerceValidationsSpiV1TargetNameInLineItem | null, suggestedFix?: ComWixEcommerceValidationsSpiV1TargetLineItemSuggestedFix | null } | null, other?: { name?: ComWixEcommerceValidationsSpiV1TargetNameInOther | null } | null } | null } | null> | null, totalAfterGiftCard?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, extendedFields?: { namespaces?: any | null } | null, customSettings?: { lockGiftCard?: boolean | null, lockCouponCode?: boolean | null, disabledManualPayment?: boolean | null, disabledPolicyAgreementCheckbox?: boolean | null } | null, subscriptionCharges?: Array<{ description?: string | null, lineItemIds?: Array<string | null> | null, charges?: Array<{ cycleBillingDate?: string | null, cycleCount?: number | null, cycleFrom?: number | null, priceSummary?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null } | null> | null } | null> | null, lineItemsSubtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null };

export type SubscriptionChargesFragment = { description?: string | null, lineItemIds?: Array<string | null> | null, charges?: Array<{ cycleBillingDate?: string | null, cycleCount?: number | null, cycleFrom?: number | null, priceSummary?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null } | null> | null };

export type SubscriptionChargeFragment = { cycleBillingDate?: string | null, cycleCount?: number | null, cycleFrom?: number | null, priceSummary?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null };

export type ViolationFragment = { severity?: ComWixEcommerceValidationsSpiV1ViolationSeverity | null, description?: string | null, target?: { lineItem?: { id?: string | null, name?: ComWixEcommerceValidationsSpiV1TargetNameInLineItem | null, suggestedFix?: ComWixEcommerceValidationsSpiV1TargetLineItemSuggestedFix | null } | null, other?: { name?: ComWixEcommerceValidationsSpiV1TargetNameInOther | null } | null } | null };

export type ViolationTargetFragment = { lineItem?: { id?: string | null, name?: ComWixEcommerceValidationsSpiV1TargetNameInLineItem | null, suggestedFix?: ComWixEcommerceValidationsSpiV1TargetLineItemSuggestedFix | null } | null, other?: { name?: ComWixEcommerceValidationsSpiV1TargetNameInOther | null } | null };

export type ViolationLineItemTargetFragment = { id?: string | null, name?: ComWixEcommerceValidationsSpiV1TargetNameInLineItem | null, suggestedFix?: ComWixEcommerceValidationsSpiV1TargetLineItemSuggestedFix | null };

export type ViolationOtherTargetFragment = { name?: ComWixEcommerceValidationsSpiV1TargetNameInOther | null };

export type ConversionInfoFragment = { siteCurrency?: string | null, conversionRate?: string | null };

export type AdditionalFeeFragment = { code?: string | null, source?: ComWixEcomTotalsCalculatorV1AdditionalFeeAdditionalFeeSource | null, name?: string | null, translatedName?: string | null, providerAppId?: string | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, priceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null };

export type MembershipOptionsFragment = { eligibleMemberships?: Array<{ id?: string | null, appId?: string | null, lineItemIds?: Array<string | null> | null, expirationDate?: string | null, additionalData?: any | null, name?: { original?: string | null, translated?: string | null } | null, credits?: { total?: number | null, remaining?: number | null } | null } | null> | null, invalidMemberships?: Array<{ reason?: string | null, membership?: { id?: string | null, appId?: string | null, lineItemIds?: Array<string | null> | null, expirationDate?: string | null, additionalData?: any | null, name?: { original?: string | null, translated?: string | null } | null, credits?: { total?: number | null, remaining?: number | null } | null } | null } | null> | null, selectedMemberships?: { memberships?: Array<{ id?: string | null, appId?: string | null, lineItemIds?: Array<string | null> | null } | null> | null } | null };

export type SelectedMembershipFragment = { id?: string | null, appId?: string | null, lineItemIds?: Array<string | null> | null };

export type InvalidMembershipFragment = { reason?: string | null, membership?: { id?: string | null, appId?: string | null, lineItemIds?: Array<string | null> | null, expirationDate?: string | null, additionalData?: any | null, name?: { original?: string | null, translated?: string | null } | null, credits?: { total?: number | null, remaining?: number | null } | null } | null };

export type MembershipFragment = { id?: string | null, appId?: string | null, lineItemIds?: Array<string | null> | null, expirationDate?: string | null, additionalData?: any | null, name?: { original?: string | null, translated?: string | null } | null, credits?: { total?: number | null, remaining?: number | null } | null };

export type MembershipPaymentCreditsFragment = { total?: number | null, remaining?: number | null };

export type MembershipNameFragment = { original?: string | null, translated?: string | null };

export type CreatedByFragment = { userId?: string | null, memberId?: string | null, visitorId?: string | null, appId?: string | null };

export type TaxSummaryFragment = { manualTaxRate?: string | null, taxEstimationId?: string | null, averageTaxRate?: string | null, taxName?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, calculationDetails?: { rateType?: ComWixEcomTaxApiRateType | null, manualRateReason?: ComWixEcomTaxApiManualCalculationReason | null, autoTaxFallbackDetails?: { fallbackReason?: ComWixEcomTaxApiAutoTaxFallbackCalculationDetailsFallbackReason | null, error?: { code?: string | null, description?: string | null, data?: any | null } | null } | null } | null, totalExempt?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, aggregatedTaxBreakdown?: Array<{ taxName?: string | null, aggregatedTaxAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, aggregatedExemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null };

export type TaxCalculationDetailsFragment = { rateType?: ComWixEcomTaxApiRateType | null, manualRateReason?: ComWixEcomTaxApiManualCalculationReason | null, autoTaxFallbackDetails?: { fallbackReason?: ComWixEcomTaxApiAutoTaxFallbackCalculationDetailsFallbackReason | null, error?: { code?: string | null, description?: string | null, data?: any | null } | null } | null };

export type AggregatedTaxBreakdownFragment = { taxName?: string | null, aggregatedTaxAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, aggregatedExemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null };

export type AutoTaxFallbackCalculationDetailsFragment = { fallbackReason?: ComWixEcomTaxApiAutoTaxFallbackCalculationDetailsFallbackReason | null, error?: { code?: string | null, description?: string | null, data?: any | null } | null };

export type CustomFieldFragment = { value?: any | null, title?: string | null, translatedTitle?: string | null };

export type AppliedDiscountFragment = { discountType?: ComWixEcomTotalsCalculatorV1AppliedDiscountDiscountType | null, lineItemIds?: Array<string | null> | null, coupon?: { id?: string | null, code?: string | null, name?: string | null, couponType?: string | null, amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, merchantDiscount?: { amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, discountRule?: { id?: string | null, name?: { original?: string | null, translated?: string | null } | null, amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null };

export type DiscountRuleFragment = { id?: string | null, name?: { original?: string | null, translated?: string | null } | null, amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null };

export type DiscountRuleNameFragment = { original?: string | null, translated?: string | null };

export type MerchantDiscountFragment = { amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null };

export type CouponFragment = { id?: string | null, code?: string | null, name?: string | null, couponType?: string | null, amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null };

export type GiftCardFragment = { id?: string | null, obfuscatedCode?: string | null, appId?: string | null, amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null };

export type CalculationErrorsFragment = { generalShippingCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, carrierErrors?: { errors?: Array<{ carrierId?: string | null, error?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null } | null> | null } | null, taxCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, couponCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, giftCardCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, membershipError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, discountsCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, orderValidationErrors?: Array<{ code?: string | null, description?: string | null, data?: any | null } | null> | null };

export type CarrierErrorsFragment = { errors?: Array<{ carrierId?: string | null, error?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null } | null> | null };

export type CarrierErrorFragment = { carrierId?: string | null, error?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null };

export type ErrorDetailsFragment = { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null };

export type ValidationErrorFragment = { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null };

export type FieldViolationFragment = { field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null };

export type ApplicationErrorFragment = { code?: string | null, description?: string | null, data?: any | null };

export type PriceSummaryFragment = { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null };

export type BuyerInfoFragment = { contactId?: string | null, email?: string | null, visitorId?: string | null, memberId?: string | null, openAccess?: boolean | null };

export type ShippingInfoFragment = { shippingDestination?: { addressesServiceId?: string | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, geocode?: { latitude?: number | null, longitude?: number | null } | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null, contactDetails?: { firstName?: string | null, lastName?: string | null, phone?: string | null, company?: string | null, vatId?: { id?: string | null, type?: WixCommonVatType | null } | null } | null } | null, selectedCarrierServiceOption?: { code?: string | null, title?: string | null, requestedShippingOption?: boolean | null, carrierId?: string | null, logistics?: { deliveryTime?: string | null, instructions?: string | null, pickupDetails?: { businessLocation?: boolean | null, pickupMethod?: ComWixEcomTotalsCalculatorV1PickupDetailsPickupMethod | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, geocode?: { latitude?: number | null, longitude?: number | null } | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null } | null, deliveryTimeSlot?: { from?: string | null, to?: string | null } | null } | null, cost?: { totalPriceAfterTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, totalDiscount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, otherCharges?: Array<{ type?: ComWixEcomTotalsCalculatorV1ChargeType | null, details?: string | null, cost?: { totalPriceAfterTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, totalDiscount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null } | null> | null } | null, region?: { id?: string | null, name?: string | null } | null, carrierServiceOptions?: Array<{ carrierId?: string | null, shippingOptions?: Array<{ code?: string | null, title?: string | null, partial?: boolean | null, logistics?: { deliveryTime?: string | null, instructions?: string | null, pickupDetails?: { businessLocation?: boolean | null, pickupMethod?: ComWixEcomTotalsCalculatorV1PickupDetailsPickupMethod | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, geocode?: { latitude?: number | null, longitude?: number | null } | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null } | null, deliveryTimeSlot?: { from?: string | null, to?: string | null } | null } | null, cost?: { price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, otherCharges?: Array<{ type?: ComWixEcomTotalsCalculatorV1ChargeType | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null } | null } | null> | null } | null> | null };

export type CarrierServiceOptionFragment = { carrierId?: string | null, shippingOptions?: Array<{ code?: string | null, title?: string | null, partial?: boolean | null, logistics?: { deliveryTime?: string | null, instructions?: string | null, pickupDetails?: { businessLocation?: boolean | null, pickupMethod?: ComWixEcomTotalsCalculatorV1PickupDetailsPickupMethod | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, geocode?: { latitude?: number | null, longitude?: number | null } | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null } | null, deliveryTimeSlot?: { from?: string | null, to?: string | null } | null } | null, cost?: { price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, otherCharges?: Array<{ type?: ComWixEcomTotalsCalculatorV1ChargeType | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null } | null } | null> | null };

export type ShippingOptionFragment = { code?: string | null, title?: string | null, partial?: boolean | null, logistics?: { deliveryTime?: string | null, instructions?: string | null, pickupDetails?: { businessLocation?: boolean | null, pickupMethod?: ComWixEcomTotalsCalculatorV1PickupDetailsPickupMethod | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, geocode?: { latitude?: number | null, longitude?: number | null } | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null } | null, deliveryTimeSlot?: { from?: string | null, to?: string | null } | null } | null, cost?: { price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, otherCharges?: Array<{ type?: ComWixEcomTotalsCalculatorV1ChargeType | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null } | null };

export type ShippingPriceFragment = { price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, otherCharges?: Array<{ type?: ComWixEcomTotalsCalculatorV1ChargeType | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null };

export type OtherChargeFragment = { type?: ComWixEcomTotalsCalculatorV1ChargeType | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null };

export type ShippingRegionFragment = { id?: string | null, name?: string | null };

export type SelectedCarrierServiceOptionFragment = { code?: string | null, title?: string | null, requestedShippingOption?: boolean | null, carrierId?: string | null, logistics?: { deliveryTime?: string | null, instructions?: string | null, pickupDetails?: { businessLocation?: boolean | null, pickupMethod?: ComWixEcomTotalsCalculatorV1PickupDetailsPickupMethod | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, geocode?: { latitude?: number | null, longitude?: number | null } | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null } | null, deliveryTimeSlot?: { from?: string | null, to?: string | null } | null } | null, cost?: { totalPriceAfterTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, totalDiscount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, otherCharges?: Array<{ type?: ComWixEcomTotalsCalculatorV1ChargeType | null, details?: string | null, cost?: { totalPriceAfterTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, totalDiscount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null } | null> | null };

export type SelectedCarrierServiceOptionOtherChargeFragment = { type?: ComWixEcomTotalsCalculatorV1ChargeType | null, details?: string | null, cost?: { totalPriceAfterTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, totalDiscount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null };

export type SelectedCarrierServiceOptionPricesFragment = { totalPriceAfterTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, totalDiscount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null };

export type DeliveryLogisticsFragment = { deliveryTime?: string | null, instructions?: string | null, pickupDetails?: { businessLocation?: boolean | null, pickupMethod?: ComWixEcomTotalsCalculatorV1PickupDetailsPickupMethod | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, geocode?: { latitude?: number | null, longitude?: number | null } | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null } | null, deliveryTimeSlot?: { from?: string | null, to?: string | null } | null };

export type PickupDetailsFragment = { businessLocation?: boolean | null, pickupMethod?: ComWixEcomTotalsCalculatorV1PickupDetailsPickupMethod | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, geocode?: { latitude?: number | null, longitude?: number | null } | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null };

export type AddressWithContactNoGeoFragment = { addressesServiceId?: string | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null, contactDetails?: { firstName?: string | null, lastName?: string | null, phone?: string | null, company?: string | null, vatId?: { id?: string | null, type?: WixCommonVatType | null } | null } | null };

export type AddressWithContactFragment = { addressesServiceId?: string | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, geocode?: { latitude?: number | null, longitude?: number | null } | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null, contactDetails?: { firstName?: string | null, lastName?: string | null, phone?: string | null, company?: string | null, vatId?: { id?: string | null, type?: WixCommonVatType | null } | null } | null };

export type FullAddressContactDetailsFragment = { firstName?: string | null, lastName?: string | null, phone?: string | null, company?: string | null, vatId?: { id?: string | null, type?: WixCommonVatType | null } | null };

export type VatIdFragment = { id?: string | null, type?: WixCommonVatType | null };

export type GeoCodeFragment = { latitude?: number | null, longitude?: number | null };

export type ApiAddressNoGeoFragment = { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null };

export type ApiAddressFragment = { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, geocode?: { latitude?: number | null, longitude?: number | null } | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null };

export type StreetAddressFragment = { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null };

export type LineItemFragment = { id?: string | null, quantity?: number | null, fulfillerId?: string | null, shippingGroupId?: string | null, paymentOption?: ComWixEcommerceCatalogSpiApiV1PaymentOptionType | null, rootCatalogItemId?: string | null, consentRequiredPaymentPolicy?: string | null, savePaymentMethod?: boolean | null, priceUndetermined?: boolean | null, fixedQuantity?: boolean | null, membersOnly?: boolean | null, deliveryProfileId?: string | null, catalogReference?: { catalogItemId?: string | null, appId?: string | null, options?: any | null } | null, productName?: { original?: string | null, translated?: string | null } | null, url?: { relativePath?: string | null, url?: string | null } | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, lineItemPrice?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, fullPrice?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, priceBeforeDiscounts?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceAfterTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, modifiersTotalPrice?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, descriptionLines?: Array<{ lineType?: ComWixEcommerceCatalogSpiApiV1DescriptionLineDescriptionLineType | null, color?: string | null, name?: { original?: string | null, translated?: string | null } | null, plainText?: { original?: string | null, translated?: string | null } | null, colorInfo?: { original?: string | null, translated?: string | null, code?: string | null } | null, plainTextValue?: { original?: string | null, translated?: string | null } | null } | null> | null, media?: { id?: string | null, url?: string | null, height?: number | null, width?: number | null, altText?: string | null, urlExpirationDate?: string | null, filename?: string | null, sizeInBytes?: string | null } | null, availability?: { status?: EcomCheckoutV1ItemAvailabilityStatus | null, quantityAvailable?: number | null } | null, physicalProperties?: { weight?: number | null, sku?: string | null, shippable?: boolean | null } | null, couponScopes?: Array<{ namespace?: string | null, group?: { name?: string | null, entityId?: string | null } | null } | null> | null, itemType?: { preset?: ComWixEcommerceCatalogSpiApiV1ItemTypeItemType | null, custom?: string | null } | null, subscriptionOptionInfo?: { subscriptionSettings?: { frequency?: WixPaymentApiPayV2SubscriptionFrequency | null, interval?: number | null, autoRenewal?: boolean | null, billingCycles?: number | null, startDate?: string | null, freeTrialPeriod?: { interval?: number | null, frequency?: WixPaymentApiPayV2SubscriptionFrequency | null } | null } | null, title?: { original?: string | null, translated?: string | null } | null, description?: { original?: string | null, translated?: string | null } | null } | null, digitalFile?: { id?: string | null, fileName?: string | null, fileType?: ComWixEcommerceCatalogSpiApiV1SecuredMediaFileType | null } | null, serviceProperties?: { scheduledDate?: string | null, numberOfParticipants?: number | null } | null, priceDescription?: { original?: string | null, translated?: string | null } | null, depositAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, policies?: Array<{ title?: string | null, content?: string | null } | null> | null, taxableAddress?: { addressType?: ComWixEcommercePlatformCommonApiTaxableAddressTaxableAddressType | null } | null, modifierGroups?: Array<{ id?: string | null, name?: { original?: string | null, translated?: string | null } | null, modifiers?: Array<{ id?: string | null, quantity?: number | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, label?: { original?: string | null, translated?: string | null } | null, details?: { original?: string | null, translated?: string | null } | null } | null> | null } | null> | null };

export type TaxableAddressFragment = { addressType?: ComWixEcommercePlatformCommonApiTaxableAddressTaxableAddressType | null };

export type PolicyFragment = { title?: string | null, content?: string | null };

export type PriceDescriptionFragment = { original?: string | null, translated?: string | null };

export type ServicePropertiesFragment = { scheduledDate?: string | null, numberOfParticipants?: number | null };

export type SecuredMediaFragment = { id?: string | null, fileName?: string | null, fileType?: ComWixEcommerceCatalogSpiApiV1SecuredMediaFileType | null };

export type SubscriptionOptionInfoFragment = { subscriptionSettings?: { frequency?: WixPaymentApiPayV2SubscriptionFrequency | null, interval?: number | null, autoRenewal?: boolean | null, billingCycles?: number | null, startDate?: string | null, freeTrialPeriod?: { interval?: number | null, frequency?: WixPaymentApiPayV2SubscriptionFrequency | null } | null } | null, title?: { original?: string | null, translated?: string | null } | null, description?: { original?: string | null, translated?: string | null } | null };

export type DescriptionFragment = { original?: string | null, translated?: string | null };

export type TitleFragment = { original?: string | null, translated?: string | null };

export type SubscriptionSettingsFragment = { frequency?: WixPaymentApiPayV2SubscriptionFrequency | null, interval?: number | null, autoRenewal?: boolean | null, billingCycles?: number | null, startDate?: string | null, freeTrialPeriod?: { interval?: number | null, frequency?: WixPaymentApiPayV2SubscriptionFrequency | null } | null };

export type FreeTrialPeriodFragment = { interval?: number | null, frequency?: WixPaymentApiPayV2SubscriptionFrequency | null };

export type ItemTypeFragment = { preset?: ComWixEcommerceCatalogSpiApiV1ItemTypeItemType | null, custom?: string | null };

export type ScopeFragment = { namespace?: string | null, group?: { name?: string | null, entityId?: string | null } | null };

export type GroupFragment = { name?: string | null, entityId?: string | null };

export type PhysicalPropertiesFragment = { weight?: number | null, sku?: string | null, shippable?: boolean | null };

export type ItemAvailabilityInfoFragment = { status?: EcomCheckoutV1ItemAvailabilityStatus | null, quantityAvailable?: number | null };

export type ImageFragment = { id?: string | null, url?: string | null, height?: number | null, width?: number | null, altText?: string | null, urlExpirationDate?: string | null, filename?: string | null, sizeInBytes?: string | null };

export type CatalogReferenceFragment = { catalogItemId?: string | null, appId?: string | null, options?: any | null };

export type ProductNameFragment = { original?: string | null, translated?: string | null };

export type PageUrlV2Fragment = { relativePath?: string | null, url?: string | null };

export type ItemTaxFullDetailsFragment = { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null };

export type TaxRateBreakdownFragment = { name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null };

export type DescriptionLineFragment = { lineType?: ComWixEcommerceCatalogSpiApiV1DescriptionLineDescriptionLineType | null, color?: string | null, name?: { original?: string | null, translated?: string | null } | null, plainText?: { original?: string | null, translated?: string | null } | null, colorInfo?: { original?: string | null, translated?: string | null, code?: string | null } | null, plainTextValue?: { original?: string | null, translated?: string | null } | null };

export type ColorFragment = { original?: string | null, translated?: string | null, code?: string | null };

export type PlainTextValueFragment = { original?: string | null, translated?: string | null };

export type DescriptionLineNameFragment = { original?: string | null, translated?: string | null };

export type MultiCurrencyPriceFragment = { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null };

export type ExtendedFieldsFragment = { namespaces?: any | null };

export type CustomSettingsFragment = { lockGiftCard?: boolean | null, lockCouponCode?: boolean | null, disabledManualPayment?: boolean | null, disabledPolicyAgreementCheckbox?: boolean | null };

export type ModifierGroupFragment = { id?: string | null, name?: { original?: string | null, translated?: string | null } | null, modifiers?: Array<{ id?: string | null, quantity?: number | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, label?: { original?: string | null, translated?: string | null } | null, details?: { original?: string | null, translated?: string | null } | null } | null> | null };

export type ModifierGroupNameFragment = { original?: string | null, translated?: string | null };

export type ModifierFragment = { id?: string | null, quantity?: number | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, label?: { original?: string | null, translated?: string | null } | null, details?: { original?: string | null, translated?: string | null } | null };

export type ModifierLabelFragment = { original?: string | null, translated?: string | null };

export type ModifierDetailsFragment = { original?: string | null, translated?: string | null };

export type CreateOrderAndChargeMutationVariables = Exact<{
  input: EcomCheckoutV1CreateOrderAndChargeRequestInput;
}>;


export type CreateOrderAndChargeMutation = { checkoutMutation?: { orderId?: string | null, subscriptionId?: string | null, paymentResponseToken?: string | null, paymentGatewayOrderId?: string | null, checkoutCompleted?: boolean | null } | null };

export type GetCheckoutQueryVariables = Exact<{
  checkoutId: Scalars['ID'];
}>;


export type GetCheckoutQuery = { checkout?: { id?: string | null, buyerNote?: string | null, conversionCurrency?: string | null, weightUnit?: ComWixEcommercePlatformCommonApiWeightUnit | null, currency?: string | null, paymentCurrency?: string | null, channelType?: ComWixEcommercePlatformCommonApiChannelType | null, siteLanguage?: string | null, buyerLanguage?: string | null, completed?: boolean | null, taxIncludedInPrice?: boolean | null, createdDate?: string | null, updatedDate?: string | null, cartId?: string | null, orderId?: string | null, purchaseFlowId?: string | null, paymentRequired?: boolean | null, lineItems?: Array<{ id?: string | null, quantity?: number | null, fulfillerId?: string | null, shippingGroupId?: string | null, paymentOption?: ComWixEcommerceCatalogSpiApiV1PaymentOptionType | null, rootCatalogItemId?: string | null, consentRequiredPaymentPolicy?: string | null, savePaymentMethod?: boolean | null, priceUndetermined?: boolean | null, fixedQuantity?: boolean | null, membersOnly?: boolean | null, deliveryProfileId?: string | null, catalogReference?: { catalogItemId?: string | null, appId?: string | null, options?: any | null } | null, productName?: { original?: string | null, translated?: string | null } | null, url?: { relativePath?: string | null, url?: string | null } | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, lineItemPrice?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, fullPrice?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, priceBeforeDiscounts?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceAfterTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, modifiersTotalPrice?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, descriptionLines?: Array<{ lineType?: ComWixEcommerceCatalogSpiApiV1DescriptionLineDescriptionLineType | null, color?: string | null, name?: { original?: string | null, translated?: string | null } | null, plainText?: { original?: string | null, translated?: string | null } | null, colorInfo?: { original?: string | null, translated?: string | null, code?: string | null } | null, plainTextValue?: { original?: string | null, translated?: string | null } | null } | null> | null, media?: { id?: string | null, url?: string | null, height?: number | null, width?: number | null, altText?: string | null, urlExpirationDate?: string | null, filename?: string | null, sizeInBytes?: string | null } | null, availability?: { status?: EcomCheckoutV1ItemAvailabilityStatus | null, quantityAvailable?: number | null } | null, physicalProperties?: { weight?: number | null, sku?: string | null, shippable?: boolean | null } | null, couponScopes?: Array<{ namespace?: string | null, group?: { name?: string | null, entityId?: string | null } | null } | null> | null, itemType?: { preset?: ComWixEcommerceCatalogSpiApiV1ItemTypeItemType | null, custom?: string | null } | null, subscriptionOptionInfo?: { subscriptionSettings?: { frequency?: WixPaymentApiPayV2SubscriptionFrequency | null, interval?: number | null, autoRenewal?: boolean | null, billingCycles?: number | null, startDate?: string | null, freeTrialPeriod?: { interval?: number | null, frequency?: WixPaymentApiPayV2SubscriptionFrequency | null } | null } | null, title?: { original?: string | null, translated?: string | null } | null, description?: { original?: string | null, translated?: string | null } | null } | null, digitalFile?: { id?: string | null, fileName?: string | null, fileType?: ComWixEcommerceCatalogSpiApiV1SecuredMediaFileType | null } | null, serviceProperties?: { scheduledDate?: string | null, numberOfParticipants?: number | null } | null, priceDescription?: { original?: string | null, translated?: string | null } | null, depositAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, policies?: Array<{ title?: string | null, content?: string | null } | null> | null, taxableAddress?: { addressType?: ComWixEcommercePlatformCommonApiTaxableAddressTaxableAddressType | null } | null, modifierGroups?: Array<{ id?: string | null, name?: { original?: string | null, translated?: string | null } | null, modifiers?: Array<{ id?: string | null, quantity?: number | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, label?: { original?: string | null, translated?: string | null } | null, details?: { original?: string | null, translated?: string | null } | null } | null> | null } | null> | null } | null> | null, billingInfo?: { addressesServiceId?: string | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null, contactDetails?: { firstName?: string | null, lastName?: string | null, phone?: string | null, company?: string | null, vatId?: { id?: string | null, type?: WixCommonVatType | null } | null } | null } | null, shippingInfo?: { shippingDestination?: { addressesServiceId?: string | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, geocode?: { latitude?: number | null, longitude?: number | null } | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null, contactDetails?: { firstName?: string | null, lastName?: string | null, phone?: string | null, company?: string | null, vatId?: { id?: string | null, type?: WixCommonVatType | null } | null } | null } | null, selectedCarrierServiceOption?: { code?: string | null, title?: string | null, requestedShippingOption?: boolean | null, carrierId?: string | null, logistics?: { deliveryTime?: string | null, instructions?: string | null, pickupDetails?: { businessLocation?: boolean | null, pickupMethod?: ComWixEcomTotalsCalculatorV1PickupDetailsPickupMethod | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, geocode?: { latitude?: number | null, longitude?: number | null } | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null } | null, deliveryTimeSlot?: { from?: string | null, to?: string | null } | null } | null, cost?: { totalPriceAfterTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, totalDiscount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, otherCharges?: Array<{ type?: ComWixEcomTotalsCalculatorV1ChargeType | null, details?: string | null, cost?: { totalPriceAfterTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, totalDiscount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null } | null> | null } | null, region?: { id?: string | null, name?: string | null } | null, carrierServiceOptions?: Array<{ carrierId?: string | null, shippingOptions?: Array<{ code?: string | null, title?: string | null, partial?: boolean | null, logistics?: { deliveryTime?: string | null, instructions?: string | null, pickupDetails?: { businessLocation?: boolean | null, pickupMethod?: ComWixEcomTotalsCalculatorV1PickupDetailsPickupMethod | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, geocode?: { latitude?: number | null, longitude?: number | null } | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null } | null, deliveryTimeSlot?: { from?: string | null, to?: string | null } | null } | null, cost?: { price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, otherCharges?: Array<{ type?: ComWixEcomTotalsCalculatorV1ChargeType | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null } | null } | null> | null } | null> | null } | null, buyerInfo?: { contactId?: string | null, email?: string | null, visitorId?: string | null, memberId?: string | null, openAccess?: boolean | null } | null, priceSummary?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, calculationErrors?: { generalShippingCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, carrierErrors?: { errors?: Array<{ carrierId?: string | null, error?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null } | null> | null } | null, taxCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, couponCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, giftCardCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, membershipError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, discountsCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, orderValidationErrors?: Array<{ code?: string | null, description?: string | null, data?: any | null } | null> | null } | null, giftCard?: { id?: string | null, obfuscatedCode?: string | null, appId?: string | null, amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, appliedDiscounts?: Array<{ discountType?: ComWixEcomTotalsCalculatorV1AppliedDiscountDiscountType | null, lineItemIds?: Array<string | null> | null, coupon?: { id?: string | null, code?: string | null, name?: string | null, couponType?: string | null, amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, merchantDiscount?: { amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, discountRule?: { id?: string | null, name?: { original?: string | null, translated?: string | null } | null, amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null } | null> | null, customFields?: Array<{ value?: any | null, title?: string | null, translatedTitle?: string | null } | null> | null, taxSummary?: { manualTaxRate?: string | null, taxEstimationId?: string | null, averageTaxRate?: string | null, taxName?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, calculationDetails?: { rateType?: ComWixEcomTaxApiRateType | null, manualRateReason?: ComWixEcomTaxApiManualCalculationReason | null, autoTaxFallbackDetails?: { fallbackReason?: ComWixEcomTaxApiAutoTaxFallbackCalculationDetailsFallbackReason | null, error?: { code?: string | null, description?: string | null, data?: any | null } | null } | null } | null, totalExempt?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, aggregatedTaxBreakdown?: Array<{ taxName?: string | null, aggregatedTaxAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, aggregatedExemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null } | null, createdBy?: { userId?: string | null, memberId?: string | null, visitorId?: string | null, appId?: string | null } | null, payNow?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, payLater?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, payAfterFreeTrial?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, membershipOptions?: { eligibleMemberships?: Array<{ id?: string | null, appId?: string | null, lineItemIds?: Array<string | null> | null, expirationDate?: string | null, additionalData?: any | null, name?: { original?: string | null, translated?: string | null } | null, credits?: { total?: number | null, remaining?: number | null } | null } | null> | null, invalidMemberships?: Array<{ reason?: string | null, membership?: { id?: string | null, appId?: string | null, lineItemIds?: Array<string | null> | null, expirationDate?: string | null, additionalData?: any | null, name?: { original?: string | null, translated?: string | null } | null, credits?: { total?: number | null, remaining?: number | null } | null } | null } | null> | null, selectedMemberships?: { memberships?: Array<{ id?: string | null, appId?: string | null, lineItemIds?: Array<string | null> | null } | null> | null } | null } | null, additionalFees?: Array<{ code?: string | null, source?: ComWixEcomTotalsCalculatorV1AdditionalFeeAdditionalFeeSource | null, name?: string | null, translatedName?: string | null, providerAppId?: string | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, priceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, conversionInfo?: { siteCurrency?: string | null, conversionRate?: string | null } | null, payNowTotalAfterGiftCard?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, violations?: Array<{ severity?: ComWixEcommerceValidationsSpiV1ViolationSeverity | null, description?: string | null, target?: { lineItem?: { id?: string | null, name?: ComWixEcommerceValidationsSpiV1TargetNameInLineItem | null, suggestedFix?: ComWixEcommerceValidationsSpiV1TargetLineItemSuggestedFix | null } | null, other?: { name?: ComWixEcommerceValidationsSpiV1TargetNameInOther | null } | null } | null } | null> | null, totalAfterGiftCard?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, extendedFields?: { namespaces?: any | null } | null, customSettings?: { lockGiftCard?: boolean | null, lockCouponCode?: boolean | null, disabledManualPayment?: boolean | null, disabledPolicyAgreementCheckbox?: boolean | null } | null, subscriptionCharges?: Array<{ description?: string | null, lineItemIds?: Array<string | null> | null, charges?: Array<{ cycleBillingDate?: string | null, cycleCount?: number | null, cycleFrom?: number | null, priceSummary?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null } | null> | null } | null> | null, lineItemsSubtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null };

export type RefreshCheckoutQueryVariables = Exact<{
  checkoutId: Scalars['ID'];
}>;


export type RefreshCheckoutQuery = { checkout?: { id?: string | null, buyerNote?: string | null, conversionCurrency?: string | null, weightUnit?: ComWixEcommercePlatformCommonApiWeightUnit | null, currency?: string | null, paymentCurrency?: string | null, channelType?: ComWixEcommercePlatformCommonApiChannelType | null, siteLanguage?: string | null, buyerLanguage?: string | null, completed?: boolean | null, taxIncludedInPrice?: boolean | null, createdDate?: string | null, updatedDate?: string | null, cartId?: string | null, orderId?: string | null, purchaseFlowId?: string | null, paymentRequired?: boolean | null, lineItems?: Array<{ id?: string | null, quantity?: number | null, fulfillerId?: string | null, shippingGroupId?: string | null, paymentOption?: ComWixEcommerceCatalogSpiApiV1PaymentOptionType | null, rootCatalogItemId?: string | null, consentRequiredPaymentPolicy?: string | null, savePaymentMethod?: boolean | null, priceUndetermined?: boolean | null, fixedQuantity?: boolean | null, membersOnly?: boolean | null, deliveryProfileId?: string | null, catalogReference?: { catalogItemId?: string | null, appId?: string | null, options?: any | null } | null, productName?: { original?: string | null, translated?: string | null } | null, url?: { relativePath?: string | null, url?: string | null } | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, lineItemPrice?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, fullPrice?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, priceBeforeDiscounts?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceAfterTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, modifiersTotalPrice?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, descriptionLines?: Array<{ lineType?: ComWixEcommerceCatalogSpiApiV1DescriptionLineDescriptionLineType | null, color?: string | null, name?: { original?: string | null, translated?: string | null } | null, plainText?: { original?: string | null, translated?: string | null } | null, colorInfo?: { original?: string | null, translated?: string | null, code?: string | null } | null, plainTextValue?: { original?: string | null, translated?: string | null } | null } | null> | null, media?: { id?: string | null, url?: string | null, height?: number | null, width?: number | null, altText?: string | null, urlExpirationDate?: string | null, filename?: string | null, sizeInBytes?: string | null } | null, availability?: { status?: EcomCheckoutV1ItemAvailabilityStatus | null, quantityAvailable?: number | null } | null, physicalProperties?: { weight?: number | null, sku?: string | null, shippable?: boolean | null } | null, couponScopes?: Array<{ namespace?: string | null, group?: { name?: string | null, entityId?: string | null } | null } | null> | null, itemType?: { preset?: ComWixEcommerceCatalogSpiApiV1ItemTypeItemType | null, custom?: string | null } | null, subscriptionOptionInfo?: { subscriptionSettings?: { frequency?: WixPaymentApiPayV2SubscriptionFrequency | null, interval?: number | null, autoRenewal?: boolean | null, billingCycles?: number | null, startDate?: string | null, freeTrialPeriod?: { interval?: number | null, frequency?: WixPaymentApiPayV2SubscriptionFrequency | null } | null } | null, title?: { original?: string | null, translated?: string | null } | null, description?: { original?: string | null, translated?: string | null } | null } | null, digitalFile?: { id?: string | null, fileName?: string | null, fileType?: ComWixEcommerceCatalogSpiApiV1SecuredMediaFileType | null } | null, serviceProperties?: { scheduledDate?: string | null, numberOfParticipants?: number | null } | null, priceDescription?: { original?: string | null, translated?: string | null } | null, depositAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, policies?: Array<{ title?: string | null, content?: string | null } | null> | null, taxableAddress?: { addressType?: ComWixEcommercePlatformCommonApiTaxableAddressTaxableAddressType | null } | null, modifierGroups?: Array<{ id?: string | null, name?: { original?: string | null, translated?: string | null } | null, modifiers?: Array<{ id?: string | null, quantity?: number | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, label?: { original?: string | null, translated?: string | null } | null, details?: { original?: string | null, translated?: string | null } | null } | null> | null } | null> | null } | null> | null, billingInfo?: { addressesServiceId?: string | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null, contactDetails?: { firstName?: string | null, lastName?: string | null, phone?: string | null, company?: string | null, vatId?: { id?: string | null, type?: WixCommonVatType | null } | null } | null } | null, shippingInfo?: { shippingDestination?: { addressesServiceId?: string | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, geocode?: { latitude?: number | null, longitude?: number | null } | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null, contactDetails?: { firstName?: string | null, lastName?: string | null, phone?: string | null, company?: string | null, vatId?: { id?: string | null, type?: WixCommonVatType | null } | null } | null } | null, selectedCarrierServiceOption?: { code?: string | null, title?: string | null, requestedShippingOption?: boolean | null, carrierId?: string | null, logistics?: { deliveryTime?: string | null, instructions?: string | null, pickupDetails?: { businessLocation?: boolean | null, pickupMethod?: ComWixEcomTotalsCalculatorV1PickupDetailsPickupMethod | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, geocode?: { latitude?: number | null, longitude?: number | null } | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null } | null, deliveryTimeSlot?: { from?: string | null, to?: string | null } | null } | null, cost?: { totalPriceAfterTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, totalDiscount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, otherCharges?: Array<{ type?: ComWixEcomTotalsCalculatorV1ChargeType | null, details?: string | null, cost?: { totalPriceAfterTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, totalDiscount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null } | null> | null } | null, region?: { id?: string | null, name?: string | null } | null, carrierServiceOptions?: Array<{ carrierId?: string | null, shippingOptions?: Array<{ code?: string | null, title?: string | null, partial?: boolean | null, logistics?: { deliveryTime?: string | null, instructions?: string | null, pickupDetails?: { businessLocation?: boolean | null, pickupMethod?: ComWixEcomTotalsCalculatorV1PickupDetailsPickupMethod | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, geocode?: { latitude?: number | null, longitude?: number | null } | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null } | null, deliveryTimeSlot?: { from?: string | null, to?: string | null } | null } | null, cost?: { price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, otherCharges?: Array<{ type?: ComWixEcomTotalsCalculatorV1ChargeType | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null } | null } | null> | null } | null> | null } | null, buyerInfo?: { contactId?: string | null, email?: string | null, visitorId?: string | null, memberId?: string | null, openAccess?: boolean | null } | null, priceSummary?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, calculationErrors?: { generalShippingCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, carrierErrors?: { errors?: Array<{ carrierId?: string | null, error?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null } | null> | null } | null, taxCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, couponCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, giftCardCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, membershipError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, discountsCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, orderValidationErrors?: Array<{ code?: string | null, description?: string | null, data?: any | null } | null> | null } | null, giftCard?: { id?: string | null, obfuscatedCode?: string | null, appId?: string | null, amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, appliedDiscounts?: Array<{ discountType?: ComWixEcomTotalsCalculatorV1AppliedDiscountDiscountType | null, lineItemIds?: Array<string | null> | null, coupon?: { id?: string | null, code?: string | null, name?: string | null, couponType?: string | null, amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, merchantDiscount?: { amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, discountRule?: { id?: string | null, name?: { original?: string | null, translated?: string | null } | null, amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null } | null> | null, customFields?: Array<{ value?: any | null, title?: string | null, translatedTitle?: string | null } | null> | null, taxSummary?: { manualTaxRate?: string | null, taxEstimationId?: string | null, averageTaxRate?: string | null, taxName?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, calculationDetails?: { rateType?: ComWixEcomTaxApiRateType | null, manualRateReason?: ComWixEcomTaxApiManualCalculationReason | null, autoTaxFallbackDetails?: { fallbackReason?: ComWixEcomTaxApiAutoTaxFallbackCalculationDetailsFallbackReason | null, error?: { code?: string | null, description?: string | null, data?: any | null } | null } | null } | null, totalExempt?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, aggregatedTaxBreakdown?: Array<{ taxName?: string | null, aggregatedTaxAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, aggregatedExemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null } | null, createdBy?: { userId?: string | null, memberId?: string | null, visitorId?: string | null, appId?: string | null } | null, payNow?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, payLater?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, payAfterFreeTrial?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, membershipOptions?: { eligibleMemberships?: Array<{ id?: string | null, appId?: string | null, lineItemIds?: Array<string | null> | null, expirationDate?: string | null, additionalData?: any | null, name?: { original?: string | null, translated?: string | null } | null, credits?: { total?: number | null, remaining?: number | null } | null } | null> | null, invalidMemberships?: Array<{ reason?: string | null, membership?: { id?: string | null, appId?: string | null, lineItemIds?: Array<string | null> | null, expirationDate?: string | null, additionalData?: any | null, name?: { original?: string | null, translated?: string | null } | null, credits?: { total?: number | null, remaining?: number | null } | null } | null } | null> | null, selectedMemberships?: { memberships?: Array<{ id?: string | null, appId?: string | null, lineItemIds?: Array<string | null> | null } | null> | null } | null } | null, additionalFees?: Array<{ code?: string | null, source?: ComWixEcomTotalsCalculatorV1AdditionalFeeAdditionalFeeSource | null, name?: string | null, translatedName?: string | null, providerAppId?: string | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, priceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, conversionInfo?: { siteCurrency?: string | null, conversionRate?: string | null } | null, payNowTotalAfterGiftCard?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, violations?: Array<{ severity?: ComWixEcommerceValidationsSpiV1ViolationSeverity | null, description?: string | null, target?: { lineItem?: { id?: string | null, name?: ComWixEcommerceValidationsSpiV1TargetNameInLineItem | null, suggestedFix?: ComWixEcommerceValidationsSpiV1TargetLineItemSuggestedFix | null } | null, other?: { name?: ComWixEcommerceValidationsSpiV1TargetNameInOther | null } | null } | null } | null> | null, totalAfterGiftCard?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, extendedFields?: { namespaces?: any | null } | null, customSettings?: { lockGiftCard?: boolean | null, lockCouponCode?: boolean | null, disabledManualPayment?: boolean | null, disabledPolicyAgreementCheckbox?: boolean | null } | null, subscriptionCharges?: Array<{ description?: string | null, lineItemIds?: Array<string | null> | null, charges?: Array<{ cycleBillingDate?: string | null, cycleCount?: number | null, cycleFrom?: number | null, priceSummary?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null } | null> | null } | null> | null, lineItemsSubtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null };

export type RemoveCouponMutationVariables = Exact<{
  input: EcomCheckoutV1RemoveCouponRequestInput;
}>;


export type RemoveCouponMutation = { checkoutMutation?: { checkout?: { id?: string | null, buyerNote?: string | null, conversionCurrency?: string | null, weightUnit?: ComWixEcommercePlatformCommonApiWeightUnit | null, currency?: string | null, paymentCurrency?: string | null, channelType?: ComWixEcommercePlatformCommonApiChannelType | null, siteLanguage?: string | null, buyerLanguage?: string | null, completed?: boolean | null, taxIncludedInPrice?: boolean | null, createdDate?: string | null, updatedDate?: string | null, cartId?: string | null, orderId?: string | null, purchaseFlowId?: string | null, paymentRequired?: boolean | null, lineItems?: Array<{ id?: string | null, quantity?: number | null, fulfillerId?: string | null, shippingGroupId?: string | null, paymentOption?: ComWixEcommerceCatalogSpiApiV1PaymentOptionType | null, rootCatalogItemId?: string | null, consentRequiredPaymentPolicy?: string | null, savePaymentMethod?: boolean | null, priceUndetermined?: boolean | null, fixedQuantity?: boolean | null, membersOnly?: boolean | null, deliveryProfileId?: string | null, catalogReference?: { catalogItemId?: string | null, appId?: string | null, options?: any | null } | null, productName?: { original?: string | null, translated?: string | null } | null, url?: { relativePath?: string | null, url?: string | null } | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, lineItemPrice?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, fullPrice?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, priceBeforeDiscounts?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceAfterTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, modifiersTotalPrice?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, descriptionLines?: Array<{ lineType?: ComWixEcommerceCatalogSpiApiV1DescriptionLineDescriptionLineType | null, color?: string | null, name?: { original?: string | null, translated?: string | null } | null, plainText?: { original?: string | null, translated?: string | null } | null, colorInfo?: { original?: string | null, translated?: string | null, code?: string | null } | null, plainTextValue?: { original?: string | null, translated?: string | null } | null } | null> | null, media?: { id?: string | null, url?: string | null, height?: number | null, width?: number | null, altText?: string | null, urlExpirationDate?: string | null, filename?: string | null, sizeInBytes?: string | null } | null, availability?: { status?: EcomCheckoutV1ItemAvailabilityStatus | null, quantityAvailable?: number | null } | null, physicalProperties?: { weight?: number | null, sku?: string | null, shippable?: boolean | null } | null, couponScopes?: Array<{ namespace?: string | null, group?: { name?: string | null, entityId?: string | null } | null } | null> | null, itemType?: { preset?: ComWixEcommerceCatalogSpiApiV1ItemTypeItemType | null, custom?: string | null } | null, subscriptionOptionInfo?: { subscriptionSettings?: { frequency?: WixPaymentApiPayV2SubscriptionFrequency | null, interval?: number | null, autoRenewal?: boolean | null, billingCycles?: number | null, startDate?: string | null, freeTrialPeriod?: { interval?: number | null, frequency?: WixPaymentApiPayV2SubscriptionFrequency | null } | null } | null, title?: { original?: string | null, translated?: string | null } | null, description?: { original?: string | null, translated?: string | null } | null } | null, digitalFile?: { id?: string | null, fileName?: string | null, fileType?: ComWixEcommerceCatalogSpiApiV1SecuredMediaFileType | null } | null, serviceProperties?: { scheduledDate?: string | null, numberOfParticipants?: number | null } | null, priceDescription?: { original?: string | null, translated?: string | null } | null, depositAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, policies?: Array<{ title?: string | null, content?: string | null } | null> | null, taxableAddress?: { addressType?: ComWixEcommercePlatformCommonApiTaxableAddressTaxableAddressType | null } | null, modifierGroups?: Array<{ id?: string | null, name?: { original?: string | null, translated?: string | null } | null, modifiers?: Array<{ id?: string | null, quantity?: number | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, label?: { original?: string | null, translated?: string | null } | null, details?: { original?: string | null, translated?: string | null } | null } | null> | null } | null> | null } | null> | null, billingInfo?: { addressesServiceId?: string | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null, contactDetails?: { firstName?: string | null, lastName?: string | null, phone?: string | null, company?: string | null, vatId?: { id?: string | null, type?: WixCommonVatType | null } | null } | null } | null, shippingInfo?: { shippingDestination?: { addressesServiceId?: string | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, geocode?: { latitude?: number | null, longitude?: number | null } | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null, contactDetails?: { firstName?: string | null, lastName?: string | null, phone?: string | null, company?: string | null, vatId?: { id?: string | null, type?: WixCommonVatType | null } | null } | null } | null, selectedCarrierServiceOption?: { code?: string | null, title?: string | null, requestedShippingOption?: boolean | null, carrierId?: string | null, logistics?: { deliveryTime?: string | null, instructions?: string | null, pickupDetails?: { businessLocation?: boolean | null, pickupMethod?: ComWixEcomTotalsCalculatorV1PickupDetailsPickupMethod | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, geocode?: { latitude?: number | null, longitude?: number | null } | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null } | null, deliveryTimeSlot?: { from?: string | null, to?: string | null } | null } | null, cost?: { totalPriceAfterTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, totalDiscount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, otherCharges?: Array<{ type?: ComWixEcomTotalsCalculatorV1ChargeType | null, details?: string | null, cost?: { totalPriceAfterTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, totalDiscount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null } | null> | null } | null, region?: { id?: string | null, name?: string | null } | null, carrierServiceOptions?: Array<{ carrierId?: string | null, shippingOptions?: Array<{ code?: string | null, title?: string | null, partial?: boolean | null, logistics?: { deliveryTime?: string | null, instructions?: string | null, pickupDetails?: { businessLocation?: boolean | null, pickupMethod?: ComWixEcomTotalsCalculatorV1PickupDetailsPickupMethod | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, geocode?: { latitude?: number | null, longitude?: number | null } | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null } | null, deliveryTimeSlot?: { from?: string | null, to?: string | null } | null } | null, cost?: { price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, otherCharges?: Array<{ type?: ComWixEcomTotalsCalculatorV1ChargeType | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null } | null } | null> | null } | null> | null } | null, buyerInfo?: { contactId?: string | null, email?: string | null, visitorId?: string | null, memberId?: string | null, openAccess?: boolean | null } | null, priceSummary?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, calculationErrors?: { generalShippingCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, carrierErrors?: { errors?: Array<{ carrierId?: string | null, error?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null } | null> | null } | null, taxCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, couponCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, giftCardCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, membershipError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, discountsCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, orderValidationErrors?: Array<{ code?: string | null, description?: string | null, data?: any | null } | null> | null } | null, giftCard?: { id?: string | null, obfuscatedCode?: string | null, appId?: string | null, amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, appliedDiscounts?: Array<{ discountType?: ComWixEcomTotalsCalculatorV1AppliedDiscountDiscountType | null, lineItemIds?: Array<string | null> | null, coupon?: { id?: string | null, code?: string | null, name?: string | null, couponType?: string | null, amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, merchantDiscount?: { amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, discountRule?: { id?: string | null, name?: { original?: string | null, translated?: string | null } | null, amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null } | null> | null, customFields?: Array<{ value?: any | null, title?: string | null, translatedTitle?: string | null } | null> | null, taxSummary?: { manualTaxRate?: string | null, taxEstimationId?: string | null, averageTaxRate?: string | null, taxName?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, calculationDetails?: { rateType?: ComWixEcomTaxApiRateType | null, manualRateReason?: ComWixEcomTaxApiManualCalculationReason | null, autoTaxFallbackDetails?: { fallbackReason?: ComWixEcomTaxApiAutoTaxFallbackCalculationDetailsFallbackReason | null, error?: { code?: string | null, description?: string | null, data?: any | null } | null } | null } | null, totalExempt?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, aggregatedTaxBreakdown?: Array<{ taxName?: string | null, aggregatedTaxAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, aggregatedExemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null } | null, createdBy?: { userId?: string | null, memberId?: string | null, visitorId?: string | null, appId?: string | null } | null, payNow?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, payLater?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, payAfterFreeTrial?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, membershipOptions?: { eligibleMemberships?: Array<{ id?: string | null, appId?: string | null, lineItemIds?: Array<string | null> | null, expirationDate?: string | null, additionalData?: any | null, name?: { original?: string | null, translated?: string | null } | null, credits?: { total?: number | null, remaining?: number | null } | null } | null> | null, invalidMemberships?: Array<{ reason?: string | null, membership?: { id?: string | null, appId?: string | null, lineItemIds?: Array<string | null> | null, expirationDate?: string | null, additionalData?: any | null, name?: { original?: string | null, translated?: string | null } | null, credits?: { total?: number | null, remaining?: number | null } | null } | null } | null> | null, selectedMemberships?: { memberships?: Array<{ id?: string | null, appId?: string | null, lineItemIds?: Array<string | null> | null } | null> | null } | null } | null, additionalFees?: Array<{ code?: string | null, source?: ComWixEcomTotalsCalculatorV1AdditionalFeeAdditionalFeeSource | null, name?: string | null, translatedName?: string | null, providerAppId?: string | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, priceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, conversionInfo?: { siteCurrency?: string | null, conversionRate?: string | null } | null, payNowTotalAfterGiftCard?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, violations?: Array<{ severity?: ComWixEcommerceValidationsSpiV1ViolationSeverity | null, description?: string | null, target?: { lineItem?: { id?: string | null, name?: ComWixEcommerceValidationsSpiV1TargetNameInLineItem | null, suggestedFix?: ComWixEcommerceValidationsSpiV1TargetLineItemSuggestedFix | null } | null, other?: { name?: ComWixEcommerceValidationsSpiV1TargetNameInOther | null } | null } | null } | null> | null, totalAfterGiftCard?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, extendedFields?: { namespaces?: any | null } | null, customSettings?: { lockGiftCard?: boolean | null, lockCouponCode?: boolean | null, disabledManualPayment?: boolean | null, disabledPolicyAgreementCheckbox?: boolean | null } | null, subscriptionCharges?: Array<{ description?: string | null, lineItemIds?: Array<string | null> | null, charges?: Array<{ cycleBillingDate?: string | null, cycleCount?: number | null, cycleFrom?: number | null, priceSummary?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null } | null> | null } | null> | null, lineItemsSubtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null } | null };

export type RemoveGiftCardMutationVariables = Exact<{
  input: EcomCheckoutV1RemoveGiftCardRequestInput;
}>;


export type RemoveGiftCardMutation = { checkoutMutation?: { checkout?: { id?: string | null, buyerNote?: string | null, conversionCurrency?: string | null, weightUnit?: ComWixEcommercePlatformCommonApiWeightUnit | null, currency?: string | null, paymentCurrency?: string | null, channelType?: ComWixEcommercePlatformCommonApiChannelType | null, siteLanguage?: string | null, buyerLanguage?: string | null, completed?: boolean | null, taxIncludedInPrice?: boolean | null, createdDate?: string | null, updatedDate?: string | null, cartId?: string | null, orderId?: string | null, purchaseFlowId?: string | null, paymentRequired?: boolean | null, lineItems?: Array<{ id?: string | null, quantity?: number | null, fulfillerId?: string | null, shippingGroupId?: string | null, paymentOption?: ComWixEcommerceCatalogSpiApiV1PaymentOptionType | null, rootCatalogItemId?: string | null, consentRequiredPaymentPolicy?: string | null, savePaymentMethod?: boolean | null, priceUndetermined?: boolean | null, fixedQuantity?: boolean | null, membersOnly?: boolean | null, deliveryProfileId?: string | null, catalogReference?: { catalogItemId?: string | null, appId?: string | null, options?: any | null } | null, productName?: { original?: string | null, translated?: string | null } | null, url?: { relativePath?: string | null, url?: string | null } | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, lineItemPrice?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, fullPrice?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, priceBeforeDiscounts?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceAfterTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, modifiersTotalPrice?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, descriptionLines?: Array<{ lineType?: ComWixEcommerceCatalogSpiApiV1DescriptionLineDescriptionLineType | null, color?: string | null, name?: { original?: string | null, translated?: string | null } | null, plainText?: { original?: string | null, translated?: string | null } | null, colorInfo?: { original?: string | null, translated?: string | null, code?: string | null } | null, plainTextValue?: { original?: string | null, translated?: string | null } | null } | null> | null, media?: { id?: string | null, url?: string | null, height?: number | null, width?: number | null, altText?: string | null, urlExpirationDate?: string | null, filename?: string | null, sizeInBytes?: string | null } | null, availability?: { status?: EcomCheckoutV1ItemAvailabilityStatus | null, quantityAvailable?: number | null } | null, physicalProperties?: { weight?: number | null, sku?: string | null, shippable?: boolean | null } | null, couponScopes?: Array<{ namespace?: string | null, group?: { name?: string | null, entityId?: string | null } | null } | null> | null, itemType?: { preset?: ComWixEcommerceCatalogSpiApiV1ItemTypeItemType | null, custom?: string | null } | null, subscriptionOptionInfo?: { subscriptionSettings?: { frequency?: WixPaymentApiPayV2SubscriptionFrequency | null, interval?: number | null, autoRenewal?: boolean | null, billingCycles?: number | null, startDate?: string | null, freeTrialPeriod?: { interval?: number | null, frequency?: WixPaymentApiPayV2SubscriptionFrequency | null } | null } | null, title?: { original?: string | null, translated?: string | null } | null, description?: { original?: string | null, translated?: string | null } | null } | null, digitalFile?: { id?: string | null, fileName?: string | null, fileType?: ComWixEcommerceCatalogSpiApiV1SecuredMediaFileType | null } | null, serviceProperties?: { scheduledDate?: string | null, numberOfParticipants?: number | null } | null, priceDescription?: { original?: string | null, translated?: string | null } | null, depositAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, policies?: Array<{ title?: string | null, content?: string | null } | null> | null, taxableAddress?: { addressType?: ComWixEcommercePlatformCommonApiTaxableAddressTaxableAddressType | null } | null, modifierGroups?: Array<{ id?: string | null, name?: { original?: string | null, translated?: string | null } | null, modifiers?: Array<{ id?: string | null, quantity?: number | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, label?: { original?: string | null, translated?: string | null } | null, details?: { original?: string | null, translated?: string | null } | null } | null> | null } | null> | null } | null> | null, billingInfo?: { addressesServiceId?: string | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null, contactDetails?: { firstName?: string | null, lastName?: string | null, phone?: string | null, company?: string | null, vatId?: { id?: string | null, type?: WixCommonVatType | null } | null } | null } | null, shippingInfo?: { shippingDestination?: { addressesServiceId?: string | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, geocode?: { latitude?: number | null, longitude?: number | null } | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null, contactDetails?: { firstName?: string | null, lastName?: string | null, phone?: string | null, company?: string | null, vatId?: { id?: string | null, type?: WixCommonVatType | null } | null } | null } | null, selectedCarrierServiceOption?: { code?: string | null, title?: string | null, requestedShippingOption?: boolean | null, carrierId?: string | null, logistics?: { deliveryTime?: string | null, instructions?: string | null, pickupDetails?: { businessLocation?: boolean | null, pickupMethod?: ComWixEcomTotalsCalculatorV1PickupDetailsPickupMethod | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, geocode?: { latitude?: number | null, longitude?: number | null } | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null } | null, deliveryTimeSlot?: { from?: string | null, to?: string | null } | null } | null, cost?: { totalPriceAfterTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, totalDiscount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, otherCharges?: Array<{ type?: ComWixEcomTotalsCalculatorV1ChargeType | null, details?: string | null, cost?: { totalPriceAfterTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, totalDiscount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null } | null> | null } | null, region?: { id?: string | null, name?: string | null } | null, carrierServiceOptions?: Array<{ carrierId?: string | null, shippingOptions?: Array<{ code?: string | null, title?: string | null, partial?: boolean | null, logistics?: { deliveryTime?: string | null, instructions?: string | null, pickupDetails?: { businessLocation?: boolean | null, pickupMethod?: ComWixEcomTotalsCalculatorV1PickupDetailsPickupMethod | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, geocode?: { latitude?: number | null, longitude?: number | null } | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null } | null, deliveryTimeSlot?: { from?: string | null, to?: string | null } | null } | null, cost?: { price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, otherCharges?: Array<{ type?: ComWixEcomTotalsCalculatorV1ChargeType | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null } | null } | null> | null } | null> | null } | null, buyerInfo?: { contactId?: string | null, email?: string | null, visitorId?: string | null, memberId?: string | null, openAccess?: boolean | null } | null, priceSummary?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, calculationErrors?: { generalShippingCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, carrierErrors?: { errors?: Array<{ carrierId?: string | null, error?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null } | null> | null } | null, taxCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, couponCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, giftCardCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, membershipError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, discountsCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, orderValidationErrors?: Array<{ code?: string | null, description?: string | null, data?: any | null } | null> | null } | null, giftCard?: { id?: string | null, obfuscatedCode?: string | null, appId?: string | null, amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, appliedDiscounts?: Array<{ discountType?: ComWixEcomTotalsCalculatorV1AppliedDiscountDiscountType | null, lineItemIds?: Array<string | null> | null, coupon?: { id?: string | null, code?: string | null, name?: string | null, couponType?: string | null, amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, merchantDiscount?: { amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, discountRule?: { id?: string | null, name?: { original?: string | null, translated?: string | null } | null, amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null } | null> | null, customFields?: Array<{ value?: any | null, title?: string | null, translatedTitle?: string | null } | null> | null, taxSummary?: { manualTaxRate?: string | null, taxEstimationId?: string | null, averageTaxRate?: string | null, taxName?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, calculationDetails?: { rateType?: ComWixEcomTaxApiRateType | null, manualRateReason?: ComWixEcomTaxApiManualCalculationReason | null, autoTaxFallbackDetails?: { fallbackReason?: ComWixEcomTaxApiAutoTaxFallbackCalculationDetailsFallbackReason | null, error?: { code?: string | null, description?: string | null, data?: any | null } | null } | null } | null, totalExempt?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, aggregatedTaxBreakdown?: Array<{ taxName?: string | null, aggregatedTaxAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, aggregatedExemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null } | null, createdBy?: { userId?: string | null, memberId?: string | null, visitorId?: string | null, appId?: string | null } | null, payNow?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, payLater?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, payAfterFreeTrial?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, membershipOptions?: { eligibleMemberships?: Array<{ id?: string | null, appId?: string | null, lineItemIds?: Array<string | null> | null, expirationDate?: string | null, additionalData?: any | null, name?: { original?: string | null, translated?: string | null } | null, credits?: { total?: number | null, remaining?: number | null } | null } | null> | null, invalidMemberships?: Array<{ reason?: string | null, membership?: { id?: string | null, appId?: string | null, lineItemIds?: Array<string | null> | null, expirationDate?: string | null, additionalData?: any | null, name?: { original?: string | null, translated?: string | null } | null, credits?: { total?: number | null, remaining?: number | null } | null } | null } | null> | null, selectedMemberships?: { memberships?: Array<{ id?: string | null, appId?: string | null, lineItemIds?: Array<string | null> | null } | null> | null } | null } | null, additionalFees?: Array<{ code?: string | null, source?: ComWixEcomTotalsCalculatorV1AdditionalFeeAdditionalFeeSource | null, name?: string | null, translatedName?: string | null, providerAppId?: string | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, priceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, conversionInfo?: { siteCurrency?: string | null, conversionRate?: string | null } | null, payNowTotalAfterGiftCard?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, violations?: Array<{ severity?: ComWixEcommerceValidationsSpiV1ViolationSeverity | null, description?: string | null, target?: { lineItem?: { id?: string | null, name?: ComWixEcommerceValidationsSpiV1TargetNameInLineItem | null, suggestedFix?: ComWixEcommerceValidationsSpiV1TargetLineItemSuggestedFix | null } | null, other?: { name?: ComWixEcommerceValidationsSpiV1TargetNameInOther | null } | null } | null } | null> | null, totalAfterGiftCard?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, extendedFields?: { namespaces?: any | null } | null, customSettings?: { lockGiftCard?: boolean | null, lockCouponCode?: boolean | null, disabledManualPayment?: boolean | null, disabledPolicyAgreementCheckbox?: boolean | null } | null, subscriptionCharges?: Array<{ description?: string | null, lineItemIds?: Array<string | null> | null, charges?: Array<{ cycleBillingDate?: string | null, cycleCount?: number | null, cycleFrom?: number | null, priceSummary?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null } | null> | null } | null> | null, lineItemsSubtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null } | null };

export type RemoveLineItemMutationVariables = Exact<{
  input: EcomCheckoutV1RemoveLineItemsRequestInput;
}>;


export type RemoveLineItemMutation = { checkoutMutation?: { checkout?: { id?: string | null, buyerNote?: string | null, conversionCurrency?: string | null, weightUnit?: ComWixEcommercePlatformCommonApiWeightUnit | null, currency?: string | null, paymentCurrency?: string | null, channelType?: ComWixEcommercePlatformCommonApiChannelType | null, siteLanguage?: string | null, buyerLanguage?: string | null, completed?: boolean | null, taxIncludedInPrice?: boolean | null, createdDate?: string | null, updatedDate?: string | null, cartId?: string | null, orderId?: string | null, purchaseFlowId?: string | null, paymentRequired?: boolean | null, lineItems?: Array<{ id?: string | null, quantity?: number | null, fulfillerId?: string | null, shippingGroupId?: string | null, paymentOption?: ComWixEcommerceCatalogSpiApiV1PaymentOptionType | null, rootCatalogItemId?: string | null, consentRequiredPaymentPolicy?: string | null, savePaymentMethod?: boolean | null, priceUndetermined?: boolean | null, fixedQuantity?: boolean | null, membersOnly?: boolean | null, deliveryProfileId?: string | null, catalogReference?: { catalogItemId?: string | null, appId?: string | null, options?: any | null } | null, productName?: { original?: string | null, translated?: string | null } | null, url?: { relativePath?: string | null, url?: string | null } | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, lineItemPrice?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, fullPrice?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, priceBeforeDiscounts?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceAfterTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, modifiersTotalPrice?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, descriptionLines?: Array<{ lineType?: ComWixEcommerceCatalogSpiApiV1DescriptionLineDescriptionLineType | null, color?: string | null, name?: { original?: string | null, translated?: string | null } | null, plainText?: { original?: string | null, translated?: string | null } | null, colorInfo?: { original?: string | null, translated?: string | null, code?: string | null } | null, plainTextValue?: { original?: string | null, translated?: string | null } | null } | null> | null, media?: { id?: string | null, url?: string | null, height?: number | null, width?: number | null, altText?: string | null, urlExpirationDate?: string | null, filename?: string | null, sizeInBytes?: string | null } | null, availability?: { status?: EcomCheckoutV1ItemAvailabilityStatus | null, quantityAvailable?: number | null } | null, physicalProperties?: { weight?: number | null, sku?: string | null, shippable?: boolean | null } | null, couponScopes?: Array<{ namespace?: string | null, group?: { name?: string | null, entityId?: string | null } | null } | null> | null, itemType?: { preset?: ComWixEcommerceCatalogSpiApiV1ItemTypeItemType | null, custom?: string | null } | null, subscriptionOptionInfo?: { subscriptionSettings?: { frequency?: WixPaymentApiPayV2SubscriptionFrequency | null, interval?: number | null, autoRenewal?: boolean | null, billingCycles?: number | null, startDate?: string | null, freeTrialPeriod?: { interval?: number | null, frequency?: WixPaymentApiPayV2SubscriptionFrequency | null } | null } | null, title?: { original?: string | null, translated?: string | null } | null, description?: { original?: string | null, translated?: string | null } | null } | null, digitalFile?: { id?: string | null, fileName?: string | null, fileType?: ComWixEcommerceCatalogSpiApiV1SecuredMediaFileType | null } | null, serviceProperties?: { scheduledDate?: string | null, numberOfParticipants?: number | null } | null, priceDescription?: { original?: string | null, translated?: string | null } | null, depositAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, policies?: Array<{ title?: string | null, content?: string | null } | null> | null, taxableAddress?: { addressType?: ComWixEcommercePlatformCommonApiTaxableAddressTaxableAddressType | null } | null, modifierGroups?: Array<{ id?: string | null, name?: { original?: string | null, translated?: string | null } | null, modifiers?: Array<{ id?: string | null, quantity?: number | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, label?: { original?: string | null, translated?: string | null } | null, details?: { original?: string | null, translated?: string | null } | null } | null> | null } | null> | null } | null> | null, billingInfo?: { addressesServiceId?: string | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null, contactDetails?: { firstName?: string | null, lastName?: string | null, phone?: string | null, company?: string | null, vatId?: { id?: string | null, type?: WixCommonVatType | null } | null } | null } | null, shippingInfo?: { shippingDestination?: { addressesServiceId?: string | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, geocode?: { latitude?: number | null, longitude?: number | null } | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null, contactDetails?: { firstName?: string | null, lastName?: string | null, phone?: string | null, company?: string | null, vatId?: { id?: string | null, type?: WixCommonVatType | null } | null } | null } | null, selectedCarrierServiceOption?: { code?: string | null, title?: string | null, requestedShippingOption?: boolean | null, carrierId?: string | null, logistics?: { deliveryTime?: string | null, instructions?: string | null, pickupDetails?: { businessLocation?: boolean | null, pickupMethod?: ComWixEcomTotalsCalculatorV1PickupDetailsPickupMethod | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, geocode?: { latitude?: number | null, longitude?: number | null } | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null } | null, deliveryTimeSlot?: { from?: string | null, to?: string | null } | null } | null, cost?: { totalPriceAfterTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, totalDiscount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, otherCharges?: Array<{ type?: ComWixEcomTotalsCalculatorV1ChargeType | null, details?: string | null, cost?: { totalPriceAfterTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, totalDiscount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null } | null> | null } | null, region?: { id?: string | null, name?: string | null } | null, carrierServiceOptions?: Array<{ carrierId?: string | null, shippingOptions?: Array<{ code?: string | null, title?: string | null, partial?: boolean | null, logistics?: { deliveryTime?: string | null, instructions?: string | null, pickupDetails?: { businessLocation?: boolean | null, pickupMethod?: ComWixEcomTotalsCalculatorV1PickupDetailsPickupMethod | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, geocode?: { latitude?: number | null, longitude?: number | null } | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null } | null, deliveryTimeSlot?: { from?: string | null, to?: string | null } | null } | null, cost?: { price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, otherCharges?: Array<{ type?: ComWixEcomTotalsCalculatorV1ChargeType | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null } | null } | null> | null } | null> | null } | null, buyerInfo?: { contactId?: string | null, email?: string | null, visitorId?: string | null, memberId?: string | null, openAccess?: boolean | null } | null, priceSummary?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, calculationErrors?: { generalShippingCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, carrierErrors?: { errors?: Array<{ carrierId?: string | null, error?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null } | null> | null } | null, taxCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, couponCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, giftCardCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, membershipError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, discountsCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, orderValidationErrors?: Array<{ code?: string | null, description?: string | null, data?: any | null } | null> | null } | null, giftCard?: { id?: string | null, obfuscatedCode?: string | null, appId?: string | null, amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, appliedDiscounts?: Array<{ discountType?: ComWixEcomTotalsCalculatorV1AppliedDiscountDiscountType | null, lineItemIds?: Array<string | null> | null, coupon?: { id?: string | null, code?: string | null, name?: string | null, couponType?: string | null, amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, merchantDiscount?: { amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, discountRule?: { id?: string | null, name?: { original?: string | null, translated?: string | null } | null, amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null } | null> | null, customFields?: Array<{ value?: any | null, title?: string | null, translatedTitle?: string | null } | null> | null, taxSummary?: { manualTaxRate?: string | null, taxEstimationId?: string | null, averageTaxRate?: string | null, taxName?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, calculationDetails?: { rateType?: ComWixEcomTaxApiRateType | null, manualRateReason?: ComWixEcomTaxApiManualCalculationReason | null, autoTaxFallbackDetails?: { fallbackReason?: ComWixEcomTaxApiAutoTaxFallbackCalculationDetailsFallbackReason | null, error?: { code?: string | null, description?: string | null, data?: any | null } | null } | null } | null, totalExempt?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, aggregatedTaxBreakdown?: Array<{ taxName?: string | null, aggregatedTaxAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, aggregatedExemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null } | null, createdBy?: { userId?: string | null, memberId?: string | null, visitorId?: string | null, appId?: string | null } | null, payNow?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, payLater?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, payAfterFreeTrial?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, membershipOptions?: { eligibleMemberships?: Array<{ id?: string | null, appId?: string | null, lineItemIds?: Array<string | null> | null, expirationDate?: string | null, additionalData?: any | null, name?: { original?: string | null, translated?: string | null } | null, credits?: { total?: number | null, remaining?: number | null } | null } | null> | null, invalidMemberships?: Array<{ reason?: string | null, membership?: { id?: string | null, appId?: string | null, lineItemIds?: Array<string | null> | null, expirationDate?: string | null, additionalData?: any | null, name?: { original?: string | null, translated?: string | null } | null, credits?: { total?: number | null, remaining?: number | null } | null } | null } | null> | null, selectedMemberships?: { memberships?: Array<{ id?: string | null, appId?: string | null, lineItemIds?: Array<string | null> | null } | null> | null } | null } | null, additionalFees?: Array<{ code?: string | null, source?: ComWixEcomTotalsCalculatorV1AdditionalFeeAdditionalFeeSource | null, name?: string | null, translatedName?: string | null, providerAppId?: string | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, priceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, conversionInfo?: { siteCurrency?: string | null, conversionRate?: string | null } | null, payNowTotalAfterGiftCard?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, violations?: Array<{ severity?: ComWixEcommerceValidationsSpiV1ViolationSeverity | null, description?: string | null, target?: { lineItem?: { id?: string | null, name?: ComWixEcommerceValidationsSpiV1TargetNameInLineItem | null, suggestedFix?: ComWixEcommerceValidationsSpiV1TargetLineItemSuggestedFix | null } | null, other?: { name?: ComWixEcommerceValidationsSpiV1TargetNameInOther | null } | null } | null } | null> | null, totalAfterGiftCard?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, extendedFields?: { namespaces?: any | null } | null, customSettings?: { lockGiftCard?: boolean | null, lockCouponCode?: boolean | null, disabledManualPayment?: boolean | null, disabledPolicyAgreementCheckbox?: boolean | null } | null, subscriptionCharges?: Array<{ description?: string | null, lineItemIds?: Array<string | null> | null, charges?: Array<{ cycleBillingDate?: string | null, cycleCount?: number | null, cycleFrom?: number | null, priceSummary?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null } | null> | null } | null> | null, lineItemsSubtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null } | null };

export type UpdateCheckoutMutationVariables = Exact<{
  input: EcomCheckoutV1UpdateCheckoutRequestInput;
}>;


export type UpdateCheckoutMutation = { checkoutMutation?: { checkout?: { id?: string | null, buyerNote?: string | null, conversionCurrency?: string | null, weightUnit?: ComWixEcommercePlatformCommonApiWeightUnit | null, currency?: string | null, paymentCurrency?: string | null, channelType?: ComWixEcommercePlatformCommonApiChannelType | null, siteLanguage?: string | null, buyerLanguage?: string | null, completed?: boolean | null, taxIncludedInPrice?: boolean | null, createdDate?: string | null, updatedDate?: string | null, cartId?: string | null, orderId?: string | null, purchaseFlowId?: string | null, paymentRequired?: boolean | null, lineItems?: Array<{ id?: string | null, quantity?: number | null, fulfillerId?: string | null, shippingGroupId?: string | null, paymentOption?: ComWixEcommerceCatalogSpiApiV1PaymentOptionType | null, rootCatalogItemId?: string | null, consentRequiredPaymentPolicy?: string | null, savePaymentMethod?: boolean | null, priceUndetermined?: boolean | null, fixedQuantity?: boolean | null, membersOnly?: boolean | null, deliveryProfileId?: string | null, catalogReference?: { catalogItemId?: string | null, appId?: string | null, options?: any | null } | null, productName?: { original?: string | null, translated?: string | null } | null, url?: { relativePath?: string | null, url?: string | null } | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, lineItemPrice?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, fullPrice?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, priceBeforeDiscounts?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceAfterTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, modifiersTotalPrice?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, descriptionLines?: Array<{ lineType?: ComWixEcommerceCatalogSpiApiV1DescriptionLineDescriptionLineType | null, color?: string | null, name?: { original?: string | null, translated?: string | null } | null, plainText?: { original?: string | null, translated?: string | null } | null, colorInfo?: { original?: string | null, translated?: string | null, code?: string | null } | null, plainTextValue?: { original?: string | null, translated?: string | null } | null } | null> | null, media?: { id?: string | null, url?: string | null, height?: number | null, width?: number | null, altText?: string | null, urlExpirationDate?: string | null, filename?: string | null, sizeInBytes?: string | null } | null, availability?: { status?: EcomCheckoutV1ItemAvailabilityStatus | null, quantityAvailable?: number | null } | null, physicalProperties?: { weight?: number | null, sku?: string | null, shippable?: boolean | null } | null, couponScopes?: Array<{ namespace?: string | null, group?: { name?: string | null, entityId?: string | null } | null } | null> | null, itemType?: { preset?: ComWixEcommerceCatalogSpiApiV1ItemTypeItemType | null, custom?: string | null } | null, subscriptionOptionInfo?: { subscriptionSettings?: { frequency?: WixPaymentApiPayV2SubscriptionFrequency | null, interval?: number | null, autoRenewal?: boolean | null, billingCycles?: number | null, startDate?: string | null, freeTrialPeriod?: { interval?: number | null, frequency?: WixPaymentApiPayV2SubscriptionFrequency | null } | null } | null, title?: { original?: string | null, translated?: string | null } | null, description?: { original?: string | null, translated?: string | null } | null } | null, digitalFile?: { id?: string | null, fileName?: string | null, fileType?: ComWixEcommerceCatalogSpiApiV1SecuredMediaFileType | null } | null, serviceProperties?: { scheduledDate?: string | null, numberOfParticipants?: number | null } | null, priceDescription?: { original?: string | null, translated?: string | null } | null, depositAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, policies?: Array<{ title?: string | null, content?: string | null } | null> | null, taxableAddress?: { addressType?: ComWixEcommercePlatformCommonApiTaxableAddressTaxableAddressType | null } | null, modifierGroups?: Array<{ id?: string | null, name?: { original?: string | null, translated?: string | null } | null, modifiers?: Array<{ id?: string | null, quantity?: number | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, label?: { original?: string | null, translated?: string | null } | null, details?: { original?: string | null, translated?: string | null } | null } | null> | null } | null> | null } | null> | null, billingInfo?: { addressesServiceId?: string | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null, contactDetails?: { firstName?: string | null, lastName?: string | null, phone?: string | null, company?: string | null, vatId?: { id?: string | null, type?: WixCommonVatType | null } | null } | null } | null, shippingInfo?: { shippingDestination?: { addressesServiceId?: string | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, geocode?: { latitude?: number | null, longitude?: number | null } | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null, contactDetails?: { firstName?: string | null, lastName?: string | null, phone?: string | null, company?: string | null, vatId?: { id?: string | null, type?: WixCommonVatType | null } | null } | null } | null, selectedCarrierServiceOption?: { code?: string | null, title?: string | null, requestedShippingOption?: boolean | null, carrierId?: string | null, logistics?: { deliveryTime?: string | null, instructions?: string | null, pickupDetails?: { businessLocation?: boolean | null, pickupMethod?: ComWixEcomTotalsCalculatorV1PickupDetailsPickupMethod | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, geocode?: { latitude?: number | null, longitude?: number | null } | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null } | null, deliveryTimeSlot?: { from?: string | null, to?: string | null } | null } | null, cost?: { totalPriceAfterTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, totalDiscount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, otherCharges?: Array<{ type?: ComWixEcomTotalsCalculatorV1ChargeType | null, details?: string | null, cost?: { totalPriceAfterTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalPriceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, totalDiscount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null } | null> | null } | null, region?: { id?: string | null, name?: string | null } | null, carrierServiceOptions?: Array<{ carrierId?: string | null, shippingOptions?: Array<{ code?: string | null, title?: string | null, partial?: boolean | null, logistics?: { deliveryTime?: string | null, instructions?: string | null, pickupDetails?: { businessLocation?: boolean | null, pickupMethod?: ComWixEcomTotalsCalculatorV1PickupDetailsPickupMethod | null, address?: { country?: string | null, subdivision?: string | null, city?: string | null, postalCode?: string | null, addressLine?: string | null, addressLine2?: string | null, countryFullname?: string | null, subdivisionFullname?: string | null, geocode?: { latitude?: number | null, longitude?: number | null } | null, streetAddress?: { number?: string | null, name?: string | null, apt?: string | null, formattedAddressLine?: string | null } | null } | null } | null, deliveryTimeSlot?: { from?: string | null, to?: string | null } | null } | null, cost?: { price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, otherCharges?: Array<{ type?: ComWixEcomTotalsCalculatorV1ChargeType | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null } | null } | null> | null } | null> | null } | null, buyerInfo?: { contactId?: string | null, email?: string | null, visitorId?: string | null, memberId?: string | null, openAccess?: boolean | null } | null, priceSummary?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, calculationErrors?: { generalShippingCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, carrierErrors?: { errors?: Array<{ carrierId?: string | null, error?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null } | null> | null } | null, taxCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, couponCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, giftCardCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, membershipError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, discountsCalculationError?: { tracing?: any | null, applicationError?: { code?: string | null, description?: string | null, data?: any | null } | null, validationError?: { fieldViolations?: Array<{ field?: string | null, description?: string | null, violatedRule?: WixApiValidationErrorRuleType | null, ruleName?: string | null, data?: any | null } | null> | null } | null } | null, orderValidationErrors?: Array<{ code?: string | null, description?: string | null, data?: any | null } | null> | null } | null, giftCard?: { id?: string | null, obfuscatedCode?: string | null, appId?: string | null, amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, appliedDiscounts?: Array<{ discountType?: ComWixEcomTotalsCalculatorV1AppliedDiscountDiscountType | null, lineItemIds?: Array<string | null> | null, coupon?: { id?: string | null, code?: string | null, name?: string | null, couponType?: string | null, amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, merchantDiscount?: { amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, discountRule?: { id?: string | null, name?: { original?: string | null, translated?: string | null } | null, amount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null } | null> | null, customFields?: Array<{ value?: any | null, title?: string | null, translatedTitle?: string | null } | null> | null, taxSummary?: { manualTaxRate?: string | null, taxEstimationId?: string | null, averageTaxRate?: string | null, taxName?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, calculationDetails?: { rateType?: ComWixEcomTaxApiRateType | null, manualRateReason?: ComWixEcomTaxApiManualCalculationReason | null, autoTaxFallbackDetails?: { fallbackReason?: ComWixEcomTaxApiAutoTaxFallbackCalculationDetailsFallbackReason | null, error?: { code?: string | null, description?: string | null, data?: any | null } | null } | null } | null, totalExempt?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, aggregatedTaxBreakdown?: Array<{ taxName?: string | null, aggregatedTaxAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, aggregatedExemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null } | null, createdBy?: { userId?: string | null, memberId?: string | null, visitorId?: string | null, appId?: string | null } | null, payNow?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, payLater?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, payAfterFreeTrial?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, membershipOptions?: { eligibleMemberships?: Array<{ id?: string | null, appId?: string | null, lineItemIds?: Array<string | null> | null, expirationDate?: string | null, additionalData?: any | null, name?: { original?: string | null, translated?: string | null } | null, credits?: { total?: number | null, remaining?: number | null } | null } | null> | null, invalidMemberships?: Array<{ reason?: string | null, membership?: { id?: string | null, appId?: string | null, lineItemIds?: Array<string | null> | null, expirationDate?: string | null, additionalData?: any | null, name?: { original?: string | null, translated?: string | null } | null, credits?: { total?: number | null, remaining?: number | null } | null } | null } | null> | null, selectedMemberships?: { memberships?: Array<{ id?: string | null, appId?: string | null, lineItemIds?: Array<string | null> | null } | null> | null } | null } | null, additionalFees?: Array<{ code?: string | null, source?: ComWixEcomTotalsCalculatorV1AdditionalFeeAdditionalFeeSource | null, name?: string | null, translatedName?: string | null, providerAppId?: string | null, price?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, taxDetails?: { taxGroupId?: string | null, taxRate?: string | null, taxableAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, totalTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, rateBreakdown?: Array<{ name?: string | null, rate?: string | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, exemptAmount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null, priceBeforeTax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null> | null, conversionInfo?: { siteCurrency?: string | null, conversionRate?: string | null } | null, payNowTotalAfterGiftCard?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, violations?: Array<{ severity?: ComWixEcommerceValidationsSpiV1ViolationSeverity | null, description?: string | null, target?: { lineItem?: { id?: string | null, name?: ComWixEcommerceValidationsSpiV1TargetNameInLineItem | null, suggestedFix?: ComWixEcommerceValidationsSpiV1TargetLineItemSuggestedFix | null } | null, other?: { name?: ComWixEcommerceValidationsSpiV1TargetNameInOther | null } | null } | null } | null> | null, totalAfterGiftCard?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, extendedFields?: { namespaces?: any | null } | null, customSettings?: { lockGiftCard?: boolean | null, lockCouponCode?: boolean | null, disabledManualPayment?: boolean | null, disabledPolicyAgreementCheckbox?: boolean | null } | null, subscriptionCharges?: Array<{ description?: string | null, lineItemIds?: Array<string | null> | null, charges?: Array<{ cycleBillingDate?: string | null, cycleCount?: number | null, cycleFrom?: number | null, priceSummary?: { subtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, shipping?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, tax?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, discount?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, total?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null, additionalFees?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null } | null> | null } | null> | null, lineItemsSubtotal?: { amount?: string | null, convertedAmount?: string | null, formattedAmount?: string | null, formattedConvertedAmount?: string | null } | null } | null } | null };

export const CatalogReferenceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CatalogReference"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1CatalogReference"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogItemId"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}},{"kind":"Field","name":{"kind":"Name","value":"options"}}]}}]} as unknown as DocumentNode<CatalogReferenceFragment, unknown>;
export const ProductNameFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1ProductName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}}]} as unknown as DocumentNode<ProductNameFragment, unknown>;
export const PageUrlV2FragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageUrlV2"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonPageUrlV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relativePath"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode<PageUrlV2Fragment, unknown>;
export const MultiCurrencyPriceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiCurrencyPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiMultiCurrencyPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"convertedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedConvertedAmount"}}]}}]} as unknown as DocumentNode<MultiCurrencyPriceFragment, unknown>;
export const TaxRateBreakdownFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxRateBreakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1TaxRateBreakdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiCurrencyPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiMultiCurrencyPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"convertedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedConvertedAmount"}}]}}]} as unknown as DocumentNode<TaxRateBreakdownFragment, unknown>;
export const ItemTaxFullDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemTaxFullDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ItemTaxFullDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxableAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"totalTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rateBreakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxRateBreakdown"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exemptAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiCurrencyPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiMultiCurrencyPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"convertedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedConvertedAmount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxRateBreakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1TaxRateBreakdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}}]} as unknown as DocumentNode<ItemTaxFullDetailsFragment, unknown>;
export const DescriptionLineNameFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DescriptionLineName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1DescriptionLineName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}}]} as unknown as DocumentNode<DescriptionLineNameFragment, unknown>;
export const PlainTextValueFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlainTextValue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1PlainTextValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}}]} as unknown as DocumentNode<PlainTextValueFragment, unknown>;
export const ColorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Color"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Color"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<ColorFragment, unknown>;
export const DescriptionLineFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DescriptionLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1DescriptionLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DescriptionLineName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineType"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlainTextValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"colorInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plainTextValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlainTextValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DescriptionLineName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1DescriptionLineName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlainTextValue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1PlainTextValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Color"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Color"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<DescriptionLineFragment, unknown>;
export const ImageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonImage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"urlExpirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"sizeInBytes"}}]}}]} as unknown as DocumentNode<ImageFragment, unknown>;
export const ItemAvailabilityInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemAvailabilityInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1ItemAvailabilityInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"quantityAvailable"}}]}}]} as unknown as DocumentNode<ItemAvailabilityInfoFragment, unknown>;
export const PhysicalPropertiesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhysicalProperties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1PhysicalProperties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"shippable"}}]}}]} as unknown as DocumentNode<PhysicalPropertiesFragment, unknown>;
export const GroupFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Group"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCouponsApiV2ScopeGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}}]}}]} as unknown as DocumentNode<GroupFragment, unknown>;
export const ScopeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Scope"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCouponsApiV2Scope"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"namespace"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Group"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Group"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCouponsApiV2ScopeGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}}]}}]} as unknown as DocumentNode<ScopeFragment, unknown>;
export const ItemTypeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1ItemType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preset"}},{"kind":"Field","name":{"kind":"Name","value":"custom"}}]}}]} as unknown as DocumentNode<ItemTypeFragment, unknown>;
export const FreeTrialPeriodFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FreeTrialPeriod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1FreeTrialPeriod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}}]}}]} as unknown as DocumentNode<FreeTrialPeriodFragment, unknown>;
export const SubscriptionSettingsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1SubscriptionSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"autoRenewal"}},{"kind":"Field","name":{"kind":"Name","value":"billingCycles"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"freeTrialPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FreeTrialPeriod"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FreeTrialPeriod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1FreeTrialPeriod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}}]}}]} as unknown as DocumentNode<SubscriptionSettingsFragment, unknown>;
export const TitleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Title"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Title"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}}]} as unknown as DocumentNode<TitleFragment, unknown>;
export const DescriptionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Description"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Description"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}}]} as unknown as DocumentNode<DescriptionFragment, unknown>;
export const SubscriptionOptionInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionOptionInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1SubscriptionOptionInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionSettings"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Description"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FreeTrialPeriod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1FreeTrialPeriod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1SubscriptionSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"autoRenewal"}},{"kind":"Field","name":{"kind":"Name","value":"billingCycles"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"freeTrialPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FreeTrialPeriod"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Title"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Title"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Description"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Description"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}}]} as unknown as DocumentNode<SubscriptionOptionInfoFragment, unknown>;
export const SecuredMediaFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecuredMedia"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1SecuredMedia"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}}]}}]} as unknown as DocumentNode<SecuredMediaFragment, unknown>;
export const ServicePropertiesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServiceProperties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1ServiceProperties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledDate"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfParticipants"}}]}}]} as unknown as DocumentNode<ServicePropertiesFragment, unknown>;
export const PriceDescriptionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1PriceDescription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}}]} as unknown as DocumentNode<PriceDescriptionFragment, unknown>;
export const PolicyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Policy"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Policy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]} as unknown as DocumentNode<PolicyFragment, unknown>;
export const TaxableAddressFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxableAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTaxableAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressType"}}]}}]} as unknown as DocumentNode<TaxableAddressFragment, unknown>;
export const ModifierGroupNameFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierGroupName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTranslatableString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}}]} as unknown as DocumentNode<ModifierGroupNameFragment, unknown>;
export const ModifierLabelFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierLabel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTranslatableString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}}]} as unknown as DocumentNode<ModifierLabelFragment, unknown>;
export const ModifierDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTranslatableString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}}]} as unknown as DocumentNode<ModifierDetailsFragment, unknown>;
export const ModifierFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Modifier"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomCartCheckoutCommonApiV1ItemModifier"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierLabel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiCurrencyPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiMultiCurrencyPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"convertedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedConvertedAmount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierLabel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTranslatableString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTranslatableString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}}]} as unknown as DocumentNode<ModifierFragment, unknown>;
export const ModifierGroupFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomCartCheckoutCommonApiV1ModifierGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierGroupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Modifier"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiCurrencyPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiMultiCurrencyPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"convertedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedConvertedAmount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierLabel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTranslatableString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTranslatableString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierGroupName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTranslatableString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Modifier"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomCartCheckoutCommonApiV1ItemModifier"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierLabel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierDetails"}}]}}]}}]} as unknown as DocumentNode<ModifierGroupFragment, unknown>;
export const LineItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LineItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1LineItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"catalogReference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CatalogReference"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageUrlV2"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItemPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fullPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceBeforeDiscounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceAfterTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceBeforeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiersTotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemTaxFullDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"descriptionLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DescriptionLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemAvailabilityInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"physicalProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhysicalProperties"}}]}},{"kind":"Field","name":{"kind":"Name","value":"couponScopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Scope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionOptionInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionOptionInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fulfillerId"}},{"kind":"Field","name":{"kind":"Name","value":"shippingGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"digitalFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SecuredMedia"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentOption"}},{"kind":"Field","name":{"kind":"Name","value":"serviceProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceProperties"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rootCatalogItemId"}},{"kind":"Field","name":{"kind":"Name","value":"priceDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceDescription"}}]}},{"kind":"Field","name":{"kind":"Name","value":"depositAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"policies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Policy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consentRequiredPaymentPolicy"}},{"kind":"Field","name":{"kind":"Name","value":"savePaymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"taxableAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxableAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceUndetermined"}},{"kind":"Field","name":{"kind":"Name","value":"fixedQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"membersOnly"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"modifierGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierGroup"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiCurrencyPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiMultiCurrencyPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"convertedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedConvertedAmount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxRateBreakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1TaxRateBreakdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DescriptionLineName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1DescriptionLineName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlainTextValue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1PlainTextValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Color"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Color"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Group"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCouponsApiV2ScopeGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FreeTrialPeriod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1FreeTrialPeriod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1SubscriptionSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"autoRenewal"}},{"kind":"Field","name":{"kind":"Name","value":"billingCycles"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"freeTrialPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FreeTrialPeriod"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Title"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Title"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Description"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Description"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierGroupName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTranslatableString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierLabel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTranslatableString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTranslatableString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Modifier"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomCartCheckoutCommonApiV1ItemModifier"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierLabel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CatalogReference"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1CatalogReference"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogItemId"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}},{"kind":"Field","name":{"kind":"Name","value":"options"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1ProductName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageUrlV2"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonPageUrlV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relativePath"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemTaxFullDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ItemTaxFullDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxableAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"totalTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rateBreakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxRateBreakdown"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exemptAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DescriptionLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1DescriptionLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DescriptionLineName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineType"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlainTextValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"colorInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plainTextValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlainTextValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonImage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"urlExpirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"sizeInBytes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemAvailabilityInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1ItemAvailabilityInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"quantityAvailable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhysicalProperties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1PhysicalProperties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"shippable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Scope"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCouponsApiV2Scope"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"namespace"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Group"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1ItemType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preset"}},{"kind":"Field","name":{"kind":"Name","value":"custom"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionOptionInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1SubscriptionOptionInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionSettings"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Description"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecuredMedia"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1SecuredMedia"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServiceProperties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1ServiceProperties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledDate"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfParticipants"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1PriceDescription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Policy"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Policy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxableAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTaxableAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomCartCheckoutCommonApiV1ModifierGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierGroupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Modifier"}}]}}]}}]} as unknown as DocumentNode<LineItemFragment, unknown>;
export const StreetAddressFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StreetAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonStreetAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"apt"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddressLine"}}]}}]} as unknown as DocumentNode<StreetAddressFragment, unknown>;
export const ApiAddressNoGeoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApiAddressNoGeo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"subdivision"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"countryFullname"}},{"kind":"Field","name":{"kind":"Name","value":"subdivisionFullname"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StreetAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StreetAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonStreetAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"apt"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddressLine"}}]}}]} as unknown as DocumentNode<ApiAddressNoGeoFragment, unknown>;
export const VatIdFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatId"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonVatId"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<VatIdFragment, unknown>;
export const FullAddressContactDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullAddressContactDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiFullAddressContactDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"vatId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatId"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonVatId"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<FullAddressContactDetailsFragment, unknown>;
export const AddressWithContactNoGeoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressWithContactNoGeo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1AddressWithContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddressNoGeo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullAddressContactDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addressesServiceId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StreetAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonStreetAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"apt"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddressLine"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatId"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonVatId"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApiAddressNoGeo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"subdivision"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"countryFullname"}},{"kind":"Field","name":{"kind":"Name","value":"subdivisionFullname"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StreetAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullAddressContactDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiFullAddressContactDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"vatId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatId"}}]}}]}}]} as unknown as DocumentNode<AddressWithContactNoGeoFragment, unknown>;
export const GeoCodeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GeoCode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonAddressLocation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]} as unknown as DocumentNode<GeoCodeFragment, unknown>;
export const ApiAddressFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApiAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddressNoGeo"}},{"kind":"Field","name":{"kind":"Name","value":"geocode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GeoCode"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StreetAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonStreetAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"apt"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddressLine"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApiAddressNoGeo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"subdivision"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"countryFullname"}},{"kind":"Field","name":{"kind":"Name","value":"subdivisionFullname"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StreetAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GeoCode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonAddressLocation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]} as unknown as DocumentNode<ApiAddressFragment, unknown>;
export const AddressWithContactFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressWithContact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1AddressWithContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullAddressContactDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addressesServiceId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StreetAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonStreetAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"apt"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddressLine"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApiAddressNoGeo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"subdivision"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"countryFullname"}},{"kind":"Field","name":{"kind":"Name","value":"subdivisionFullname"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StreetAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GeoCode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonAddressLocation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatId"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonVatId"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApiAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddressNoGeo"}},{"kind":"Field","name":{"kind":"Name","value":"geocode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GeoCode"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullAddressContactDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiFullAddressContactDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"vatId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatId"}}]}}]}}]} as unknown as DocumentNode<AddressWithContactFragment, unknown>;
export const PickupDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PickupDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1PickupDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessLocation"}},{"kind":"Field","name":{"kind":"Name","value":"pickupMethod"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StreetAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonStreetAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"apt"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddressLine"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApiAddressNoGeo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"subdivision"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"countryFullname"}},{"kind":"Field","name":{"kind":"Name","value":"subdivisionFullname"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StreetAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GeoCode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonAddressLocation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApiAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddressNoGeo"}},{"kind":"Field","name":{"kind":"Name","value":"geocode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GeoCode"}}]}}]}}]} as unknown as DocumentNode<PickupDetailsFragment, unknown>;
export const DeliveryLogisticsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeliveryLogistics"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1DeliveryLogistics"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryTime"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"pickupDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PickupDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryTimeSlot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StreetAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonStreetAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"apt"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddressLine"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApiAddressNoGeo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"subdivision"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"countryFullname"}},{"kind":"Field","name":{"kind":"Name","value":"subdivisionFullname"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StreetAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GeoCode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonAddressLocation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApiAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddressNoGeo"}},{"kind":"Field","name":{"kind":"Name","value":"geocode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GeoCode"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PickupDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1PickupDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessLocation"}},{"kind":"Field","name":{"kind":"Name","value":"pickupMethod"}}]}}]} as unknown as DocumentNode<DeliveryLogisticsFragment, unknown>;
export const SelectedCarrierServiceOptionPricesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedCarrierServiceOptionPrices"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPrices"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalPriceAfterTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceBeforeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemTaxFullDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiCurrencyPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiMultiCurrencyPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"convertedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedConvertedAmount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxRateBreakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1TaxRateBreakdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemTaxFullDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ItemTaxFullDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxableAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"totalTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rateBreakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxRateBreakdown"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exemptAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}}]} as unknown as DocumentNode<SelectedCarrierServiceOptionPricesFragment, unknown>;
export const SelectedCarrierServiceOptionOtherChargeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedCarrierServiceOptionOtherCharge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionOtherCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOptionPrices"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiCurrencyPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiMultiCurrencyPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"convertedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedConvertedAmount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxRateBreakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1TaxRateBreakdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemTaxFullDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ItemTaxFullDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxableAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"totalTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rateBreakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxRateBreakdown"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exemptAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedCarrierServiceOptionPrices"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPrices"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalPriceAfterTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceBeforeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemTaxFullDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}}]} as unknown as DocumentNode<SelectedCarrierServiceOptionOtherChargeFragment, unknown>;
export const SelectedCarrierServiceOptionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedCarrierServiceOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"logistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryLogistics"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOptionPrices"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requestedShippingOption"}},{"kind":"Field","name":{"kind":"Name","value":"otherCharges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOptionOtherCharge"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrierId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StreetAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonStreetAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"apt"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddressLine"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApiAddressNoGeo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"subdivision"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"countryFullname"}},{"kind":"Field","name":{"kind":"Name","value":"subdivisionFullname"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StreetAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GeoCode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonAddressLocation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApiAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddressNoGeo"}},{"kind":"Field","name":{"kind":"Name","value":"geocode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GeoCode"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PickupDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1PickupDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessLocation"}},{"kind":"Field","name":{"kind":"Name","value":"pickupMethod"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiCurrencyPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiMultiCurrencyPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"convertedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedConvertedAmount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxRateBreakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1TaxRateBreakdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemTaxFullDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ItemTaxFullDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxableAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"totalTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rateBreakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxRateBreakdown"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exemptAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedCarrierServiceOptionPrices"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPrices"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalPriceAfterTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceBeforeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemTaxFullDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeliveryLogistics"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1DeliveryLogistics"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryTime"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"pickupDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PickupDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryTimeSlot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedCarrierServiceOptionOtherCharge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionOtherCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOptionPrices"}}]}}]}}]} as unknown as DocumentNode<SelectedCarrierServiceOptionFragment, unknown>;
export const ShippingRegionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ShippingRegion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<ShippingRegionFragment, unknown>;
export const OtherChargeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OtherCharge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1OtherCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiCurrencyPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiMultiCurrencyPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"convertedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedConvertedAmount"}}]}}]} as unknown as DocumentNode<OtherChargeFragment, unknown>;
export const ShippingPriceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ShippingPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherCharges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OtherCharge"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiCurrencyPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiMultiCurrencyPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"convertedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedConvertedAmount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OtherCharge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1OtherCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}}]} as unknown as DocumentNode<ShippingPriceFragment, unknown>;
export const ShippingOptionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ShippingOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"partial"}},{"kind":"Field","name":{"kind":"Name","value":"logistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryLogistics"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StreetAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonStreetAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"apt"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddressLine"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApiAddressNoGeo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"subdivision"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"countryFullname"}},{"kind":"Field","name":{"kind":"Name","value":"subdivisionFullname"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StreetAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GeoCode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonAddressLocation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApiAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddressNoGeo"}},{"kind":"Field","name":{"kind":"Name","value":"geocode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GeoCode"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PickupDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1PickupDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessLocation"}},{"kind":"Field","name":{"kind":"Name","value":"pickupMethod"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiCurrencyPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiMultiCurrencyPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"convertedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedConvertedAmount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OtherCharge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1OtherCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeliveryLogistics"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1DeliveryLogistics"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryTime"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"pickupDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PickupDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryTimeSlot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ShippingPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherCharges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OtherCharge"}}]}}]}}]} as unknown as DocumentNode<ShippingOptionFragment, unknown>;
export const CarrierServiceOptionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarrierServiceOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CarrierServiceOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carrierId"}},{"kind":"Field","name":{"kind":"Name","value":"shippingOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StreetAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonStreetAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"apt"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddressLine"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApiAddressNoGeo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"subdivision"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"countryFullname"}},{"kind":"Field","name":{"kind":"Name","value":"subdivisionFullname"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StreetAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GeoCode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonAddressLocation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApiAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddressNoGeo"}},{"kind":"Field","name":{"kind":"Name","value":"geocode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GeoCode"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PickupDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1PickupDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessLocation"}},{"kind":"Field","name":{"kind":"Name","value":"pickupMethod"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeliveryLogistics"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1DeliveryLogistics"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryTime"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"pickupDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PickupDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryTimeSlot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiCurrencyPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiMultiCurrencyPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"convertedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedConvertedAmount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OtherCharge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1OtherCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ShippingPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherCharges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OtherCharge"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ShippingOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"partial"}},{"kind":"Field","name":{"kind":"Name","value":"logistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryLogistics"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingPrice"}}]}}]}}]} as unknown as DocumentNode<CarrierServiceOptionFragment, unknown>;
export const ShippingInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1ShippingInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shippingDestination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddressWithContact"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedCarrierServiceOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOption"}}]}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingRegion"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrierServiceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CarrierServiceOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StreetAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonStreetAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"apt"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddressLine"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApiAddressNoGeo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"subdivision"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"countryFullname"}},{"kind":"Field","name":{"kind":"Name","value":"subdivisionFullname"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StreetAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GeoCode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonAddressLocation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApiAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddressNoGeo"}},{"kind":"Field","name":{"kind":"Name","value":"geocode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GeoCode"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatId"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonVatId"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullAddressContactDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiFullAddressContactDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"vatId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PickupDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1PickupDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessLocation"}},{"kind":"Field","name":{"kind":"Name","value":"pickupMethod"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeliveryLogistics"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1DeliveryLogistics"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryTime"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"pickupDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PickupDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryTimeSlot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiCurrencyPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiMultiCurrencyPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"convertedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedConvertedAmount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxRateBreakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1TaxRateBreakdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemTaxFullDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ItemTaxFullDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxableAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"totalTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rateBreakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxRateBreakdown"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exemptAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedCarrierServiceOptionPrices"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPrices"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalPriceAfterTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceBeforeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemTaxFullDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedCarrierServiceOptionOtherCharge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionOtherCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOptionPrices"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OtherCharge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1OtherCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ShippingPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherCharges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OtherCharge"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ShippingOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"partial"}},{"kind":"Field","name":{"kind":"Name","value":"logistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryLogistics"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressWithContact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1AddressWithContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullAddressContactDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addressesServiceId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedCarrierServiceOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"logistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryLogistics"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOptionPrices"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requestedShippingOption"}},{"kind":"Field","name":{"kind":"Name","value":"otherCharges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOptionOtherCharge"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrierId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ShippingRegion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarrierServiceOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CarrierServiceOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carrierId"}},{"kind":"Field","name":{"kind":"Name","value":"shippingOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingOption"}}]}}]}}]} as unknown as DocumentNode<ShippingInfoFragment, unknown>;
export const BuyerInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1BuyerInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"visitorId"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"openAccess"}}]}}]} as unknown as DocumentNode<BuyerInfoFragment, unknown>;
export const PriceSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1PriceSummary"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subtotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiCurrencyPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiMultiCurrencyPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"convertedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedConvertedAmount"}}]}}]} as unknown as DocumentNode<PriceSummaryFragment, unknown>;
export const ApplicationErrorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApplicationError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiApplicationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]} as unknown as DocumentNode<ApplicationErrorFragment, unknown>;
export const FieldViolationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldViolation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiValidationErrorFieldViolation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"violatedRule"}},{"kind":"Field","name":{"kind":"Name","value":"ruleName"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]} as unknown as DocumentNode<FieldViolationFragment, unknown>;
export const ValidationErrorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ValidationError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldViolations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FieldViolation"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldViolation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiValidationErrorFieldViolation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"violatedRule"}},{"kind":"Field","name":{"kind":"Name","value":"ruleName"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]} as unknown as DocumentNode<ValidationErrorFragment, unknown>;
export const ErrorDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ErrorDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applicationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplicationError"}}]}},{"kind":"Field","name":{"kind":"Name","value":"validationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ValidationError"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tracing"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldViolation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiValidationErrorFieldViolation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"violatedRule"}},{"kind":"Field","name":{"kind":"Name","value":"ruleName"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApplicationError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiApplicationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ValidationError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldViolations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FieldViolation"}}]}}]}}]} as unknown as DocumentNode<ErrorDetailsFragment, unknown>;
export const CarrierErrorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarrierError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CarrierError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carrierId"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApplicationError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiApplicationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldViolation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiValidationErrorFieldViolation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"violatedRule"}},{"kind":"Field","name":{"kind":"Name","value":"ruleName"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ValidationError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldViolations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FieldViolation"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ErrorDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applicationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplicationError"}}]}},{"kind":"Field","name":{"kind":"Name","value":"validationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ValidationError"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tracing"}}]}}]} as unknown as DocumentNode<CarrierErrorFragment, unknown>;
export const CarrierErrorsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarrierErrors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CarrierErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CarrierError"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApplicationError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiApplicationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldViolation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiValidationErrorFieldViolation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"violatedRule"}},{"kind":"Field","name":{"kind":"Name","value":"ruleName"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ValidationError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldViolations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FieldViolation"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ErrorDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applicationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplicationError"}}]}},{"kind":"Field","name":{"kind":"Name","value":"validationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ValidationError"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tracing"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarrierError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CarrierError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carrierId"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}}]}}]} as unknown as DocumentNode<CarrierErrorsFragment, unknown>;
export const CalculationErrorsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CalculationErrors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CalculationErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generalShippingCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrierErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CarrierErrors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"couponCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"giftCardCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"membershipError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountsCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderValidationErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplicationError"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApplicationError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiApplicationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldViolation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiValidationErrorFieldViolation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"violatedRule"}},{"kind":"Field","name":{"kind":"Name","value":"ruleName"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ValidationError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldViolations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FieldViolation"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ErrorDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applicationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplicationError"}}]}},{"kind":"Field","name":{"kind":"Name","value":"validationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ValidationError"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tracing"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarrierError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CarrierError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carrierId"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarrierErrors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CarrierErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CarrierError"}}]}}]}}]} as unknown as DocumentNode<CalculationErrorsFragment, unknown>;
export const GiftCardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GiftCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1GiftCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"obfuscatedCode"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiCurrencyPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiMultiCurrencyPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"convertedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedConvertedAmount"}}]}}]} as unknown as DocumentNode<GiftCardFragment, unknown>;
export const CouponFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Coupon"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1Coupon"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"couponType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiCurrencyPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiMultiCurrencyPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"convertedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedConvertedAmount"}}]}}]} as unknown as DocumentNode<CouponFragment, unknown>;
export const MerchantDiscountFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MerchantDiscount"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1MerchantDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiCurrencyPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiMultiCurrencyPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"convertedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedConvertedAmount"}}]}}]} as unknown as DocumentNode<MerchantDiscountFragment, unknown>;
export const DiscountRuleNameFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiscountRuleName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1DiscountRuleName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}}]} as unknown as DocumentNode<DiscountRuleNameFragment, unknown>;
export const DiscountRuleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiscountRule"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1DiscountRule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiscountRuleName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiscountRuleName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1DiscountRuleName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiCurrencyPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiMultiCurrencyPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"convertedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedConvertedAmount"}}]}}]} as unknown as DocumentNode<DiscountRuleFragment, unknown>;
export const AppliedDiscountFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppliedDiscount"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1AppliedDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}},{"kind":"Field","name":{"kind":"Name","value":"coupon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Coupon"}}]}},{"kind":"Field","name":{"kind":"Name","value":"merchantDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MerchantDiscount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiscountRule"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiCurrencyPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiMultiCurrencyPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"convertedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedConvertedAmount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiscountRuleName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1DiscountRuleName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Coupon"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1Coupon"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"couponType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MerchantDiscount"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1MerchantDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiscountRule"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1DiscountRule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiscountRuleName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}}]} as unknown as DocumentNode<AppliedDiscountFragment, unknown>;
export const CustomFieldFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomOrdersV1CustomField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"translatedTitle"}}]}}]} as unknown as DocumentNode<CustomFieldFragment, unknown>;
export const AutoTaxFallbackCalculationDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AutoTaxFallbackCalculationDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTaxApiAutoTaxFallbackCalculationDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fallbackReason"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplicationError"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApplicationError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiApplicationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]} as unknown as DocumentNode<AutoTaxFallbackCalculationDetailsFragment, unknown>;
export const TaxCalculationDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxCalculationDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTaxApiTaxCalculationDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rateType"}},{"kind":"Field","name":{"kind":"Name","value":"manualRateReason"}},{"kind":"Field","name":{"kind":"Name","value":"autoTaxFallbackDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AutoTaxFallbackCalculationDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApplicationError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiApplicationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AutoTaxFallbackCalculationDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTaxApiAutoTaxFallbackCalculationDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fallbackReason"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplicationError"}}]}}]}}]} as unknown as DocumentNode<TaxCalculationDetailsFragment, unknown>;
export const AggregatedTaxBreakdownFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AggregatedTaxBreakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1AggregatedTaxBreakdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxName"}},{"kind":"Field","name":{"kind":"Name","value":"aggregatedTaxAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregatedExemptAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiCurrencyPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiMultiCurrencyPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"convertedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedConvertedAmount"}}]}}]} as unknown as DocumentNode<AggregatedTaxBreakdownFragment, unknown>;
export const TaxSummaryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1TaxSummary"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxableAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manualTaxRate"}},{"kind":"Field","name":{"kind":"Name","value":"calculationDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxCalculationDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxEstimationId"}},{"kind":"Field","name":{"kind":"Name","value":"averageTaxRate"}},{"kind":"Field","name":{"kind":"Name","value":"taxName"}},{"kind":"Field","name":{"kind":"Name","value":"totalExempt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregatedTaxBreakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AggregatedTaxBreakdown"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApplicationError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiApplicationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AutoTaxFallbackCalculationDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTaxApiAutoTaxFallbackCalculationDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fallbackReason"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplicationError"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiCurrencyPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiMultiCurrencyPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"convertedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedConvertedAmount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxCalculationDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTaxApiTaxCalculationDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rateType"}},{"kind":"Field","name":{"kind":"Name","value":"manualRateReason"}},{"kind":"Field","name":{"kind":"Name","value":"autoTaxFallbackDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AutoTaxFallbackCalculationDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AggregatedTaxBreakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1AggregatedTaxBreakdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxName"}},{"kind":"Field","name":{"kind":"Name","value":"aggregatedTaxAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregatedExemptAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}}]} as unknown as DocumentNode<TaxSummaryFragment, unknown>;
export const CreatedByFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreatedBy"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1CreatedBy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"visitorId"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}}]}}]} as unknown as DocumentNode<CreatedByFragment, unknown>;
export const MembershipNameFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembershipName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1MembershipName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}}]} as unknown as DocumentNode<MembershipNameFragment, unknown>;
export const MembershipPaymentCreditsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembershipPaymentCredits"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1MembershipPaymentCredits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"remaining"}}]}}]} as unknown as DocumentNode<MembershipPaymentCreditsFragment, unknown>;
export const MembershipFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Membership"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1HostMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembershipName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}},{"kind":"Field","name":{"kind":"Name","value":"credits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembershipPaymentCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"additionalData"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembershipName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1MembershipName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembershipPaymentCredits"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1MembershipPaymentCredits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"remaining"}}]}}]} as unknown as DocumentNode<MembershipFragment, unknown>;
export const InvalidMembershipFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidMembership"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1HostInvalidMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Membership"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembershipName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1MembershipName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembershipPaymentCredits"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1MembershipPaymentCredits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"remaining"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Membership"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1HostMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembershipName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}},{"kind":"Field","name":{"kind":"Name","value":"credits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembershipPaymentCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"additionalData"}}]}}]} as unknown as DocumentNode<InvalidMembershipFragment, unknown>;
export const SelectedMembershipFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedMembership"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1HostSelectedMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}}]}}]} as unknown as DocumentNode<SelectedMembershipFragment, unknown>;
export const MembershipOptionsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembershipOptions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1MembershipOptions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eligibleMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Membership"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invalidMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidMembership"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedMembership"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembershipName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1MembershipName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembershipPaymentCredits"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1MembershipPaymentCredits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"remaining"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Membership"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1HostMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembershipName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}},{"kind":"Field","name":{"kind":"Name","value":"credits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembershipPaymentCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"additionalData"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidMembership"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1HostInvalidMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Membership"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedMembership"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1HostSelectedMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}}]}}]} as unknown as DocumentNode<MembershipOptionsFragment, unknown>;
export const AdditionalFeeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdditionalFee"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1AdditionalFee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemTaxFullDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"providerAppId"}},{"kind":"Field","name":{"kind":"Name","value":"priceBeforeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiCurrencyPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiMultiCurrencyPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"convertedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedConvertedAmount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxRateBreakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1TaxRateBreakdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemTaxFullDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ItemTaxFullDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxableAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"totalTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rateBreakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxRateBreakdown"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exemptAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}}]} as unknown as DocumentNode<AdditionalFeeFragment, unknown>;
export const ConversionInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConversionInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1ConversionInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"conversionRate"}}]}}]} as unknown as DocumentNode<ConversionInfoFragment, unknown>;
export const ViolationLineItemTargetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViolationLineItemTarget"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1TargetLineItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedFix"}}]}}]} as unknown as DocumentNode<ViolationLineItemTargetFragment, unknown>;
export const ViolationOtherTargetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViolationOtherTarget"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1TargetOther"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<ViolationOtherTargetFragment, unknown>;
export const ViolationTargetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViolationTarget"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1Target"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViolationLineItemTarget"}}]}},{"kind":"Field","name":{"kind":"Name","value":"other"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViolationOtherTarget"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViolationLineItemTarget"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1TargetLineItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedFix"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViolationOtherTarget"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1TargetOther"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<ViolationTargetFragment, unknown>;
export const ViolationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Violation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1Violation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"severity"}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViolationTarget"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViolationLineItemTarget"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1TargetLineItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedFix"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViolationOtherTarget"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1TargetOther"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViolationTarget"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1Target"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViolationLineItemTarget"}}]}},{"kind":"Field","name":{"kind":"Name","value":"other"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViolationOtherTarget"}}]}}]}}]} as unknown as DocumentNode<ViolationFragment, unknown>;
export const ExtendedFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExtendedFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonDataDataextensionsExtendedFields"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"namespaces"}}]}}]} as unknown as DocumentNode<ExtendedFieldsFragment, unknown>;
export const CustomSettingsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1CustomSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lockGiftCard"}},{"kind":"Field","name":{"kind":"Name","value":"lockCouponCode"}},{"kind":"Field","name":{"kind":"Name","value":"disabledManualPayment"}},{"kind":"Field","name":{"kind":"Name","value":"disabledPolicyAgreementCheckbox"}}]}}]} as unknown as DocumentNode<CustomSettingsFragment, unknown>;
export const SubscriptionChargeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionCharge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1Charge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cycleBillingDate"}},{"kind":"Field","name":{"kind":"Name","value":"cycleCount"}},{"kind":"Field","name":{"kind":"Name","value":"cycleFrom"}},{"kind":"Field","name":{"kind":"Name","value":"priceSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiCurrencyPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiMultiCurrencyPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"convertedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedConvertedAmount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1PriceSummary"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subtotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}}]} as unknown as DocumentNode<SubscriptionChargeFragment, unknown>;
export const SubscriptionChargesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionCharges"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1SubscriptionCharges"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionCharge"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiCurrencyPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiMultiCurrencyPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"convertedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedConvertedAmount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1PriceSummary"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subtotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionCharge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1Charge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cycleBillingDate"}},{"kind":"Field","name":{"kind":"Name","value":"cycleCount"}},{"kind":"Field","name":{"kind":"Name","value":"cycleFrom"}},{"kind":"Field","name":{"kind":"Name","value":"priceSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}}]}}]} as unknown as DocumentNode<SubscriptionChargesFragment, unknown>;
export const CheckoutFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Checkout"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1Checkout"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LineItem"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddressWithContactNoGeo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyerNote"}},{"kind":"Field","name":{"kind":"Name","value":"buyerInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"conversionCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"priceSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calculationErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalculationErrors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"giftCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GiftCard"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appliedDiscounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppliedDiscount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weightUnit"}},{"kind":"Field","name":{"kind":"Name","value":"taxSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"paymentCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"channelType"}},{"kind":"Field","name":{"kind":"Name","value":"siteLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"buyerLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"taxIncludedInPrice"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CreatedBy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"payNow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payLater"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payAfterFreeTrial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"membershipOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembershipOptions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdditionalFee"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cartId"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"conversionInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConversionInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payNowTotalAfterGiftCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"purchaseFlowId"}},{"kind":"Field","name":{"kind":"Name","value":"calculationErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalculationErrors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"violations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Violation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalAfterGiftCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"extendedFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExtendedFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomSettings"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionCharges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionCharges"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentRequired"}},{"kind":"Field","name":{"kind":"Name","value":"taxIncludedInPrice"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemsSubtotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CatalogReference"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1CatalogReference"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogItemId"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}},{"kind":"Field","name":{"kind":"Name","value":"options"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1ProductName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageUrlV2"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonPageUrlV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relativePath"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiCurrencyPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiMultiCurrencyPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"convertedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedConvertedAmount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxRateBreakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1TaxRateBreakdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemTaxFullDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ItemTaxFullDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxableAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"totalTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rateBreakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxRateBreakdown"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exemptAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DescriptionLineName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1DescriptionLineName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlainTextValue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1PlainTextValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Color"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Color"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DescriptionLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1DescriptionLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DescriptionLineName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineType"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlainTextValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"colorInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plainTextValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlainTextValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonImage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"urlExpirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"sizeInBytes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemAvailabilityInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1ItemAvailabilityInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"quantityAvailable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhysicalProperties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1PhysicalProperties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"shippable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Group"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCouponsApiV2ScopeGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Scope"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCouponsApiV2Scope"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"namespace"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Group"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1ItemType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preset"}},{"kind":"Field","name":{"kind":"Name","value":"custom"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FreeTrialPeriod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1FreeTrialPeriod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1SubscriptionSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"autoRenewal"}},{"kind":"Field","name":{"kind":"Name","value":"billingCycles"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"freeTrialPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FreeTrialPeriod"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Title"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Title"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Description"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Description"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionOptionInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1SubscriptionOptionInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionSettings"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Description"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecuredMedia"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1SecuredMedia"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServiceProperties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1ServiceProperties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledDate"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfParticipants"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1PriceDescription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Policy"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Policy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxableAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTaxableAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierGroupName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTranslatableString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierLabel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTranslatableString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTranslatableString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Modifier"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomCartCheckoutCommonApiV1ItemModifier"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierLabel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomCartCheckoutCommonApiV1ModifierGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierGroupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Modifier"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StreetAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonStreetAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"apt"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddressLine"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApiAddressNoGeo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"subdivision"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"countryFullname"}},{"kind":"Field","name":{"kind":"Name","value":"subdivisionFullname"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StreetAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatId"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonVatId"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullAddressContactDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiFullAddressContactDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"vatId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GeoCode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonAddressLocation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApiAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddressNoGeo"}},{"kind":"Field","name":{"kind":"Name","value":"geocode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GeoCode"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressWithContact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1AddressWithContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullAddressContactDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addressesServiceId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PickupDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1PickupDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessLocation"}},{"kind":"Field","name":{"kind":"Name","value":"pickupMethod"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeliveryLogistics"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1DeliveryLogistics"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryTime"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"pickupDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PickupDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryTimeSlot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedCarrierServiceOptionPrices"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPrices"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalPriceAfterTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceBeforeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemTaxFullDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedCarrierServiceOptionOtherCharge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionOtherCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOptionPrices"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedCarrierServiceOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"logistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryLogistics"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOptionPrices"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requestedShippingOption"}},{"kind":"Field","name":{"kind":"Name","value":"otherCharges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOptionOtherCharge"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrierId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ShippingRegion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OtherCharge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1OtherCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ShippingPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherCharges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OtherCharge"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ShippingOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"partial"}},{"kind":"Field","name":{"kind":"Name","value":"logistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryLogistics"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarrierServiceOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CarrierServiceOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carrierId"}},{"kind":"Field","name":{"kind":"Name","value":"shippingOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApplicationError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiApplicationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldViolation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiValidationErrorFieldViolation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"violatedRule"}},{"kind":"Field","name":{"kind":"Name","value":"ruleName"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ValidationError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldViolations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FieldViolation"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ErrorDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applicationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplicationError"}}]}},{"kind":"Field","name":{"kind":"Name","value":"validationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ValidationError"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tracing"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarrierError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CarrierError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carrierId"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarrierErrors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CarrierErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CarrierError"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Coupon"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1Coupon"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"couponType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MerchantDiscount"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1MerchantDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiscountRuleName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1DiscountRuleName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiscountRule"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1DiscountRule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiscountRuleName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AutoTaxFallbackCalculationDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTaxApiAutoTaxFallbackCalculationDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fallbackReason"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplicationError"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxCalculationDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTaxApiTaxCalculationDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rateType"}},{"kind":"Field","name":{"kind":"Name","value":"manualRateReason"}},{"kind":"Field","name":{"kind":"Name","value":"autoTaxFallbackDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AutoTaxFallbackCalculationDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AggregatedTaxBreakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1AggregatedTaxBreakdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxName"}},{"kind":"Field","name":{"kind":"Name","value":"aggregatedTaxAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregatedExemptAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembershipName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1MembershipName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembershipPaymentCredits"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1MembershipPaymentCredits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"remaining"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Membership"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1HostMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembershipName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}},{"kind":"Field","name":{"kind":"Name","value":"credits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembershipPaymentCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"additionalData"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidMembership"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1HostInvalidMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Membership"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedMembership"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1HostSelectedMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViolationLineItemTarget"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1TargetLineItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedFix"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViolationOtherTarget"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1TargetOther"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViolationTarget"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1Target"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViolationLineItemTarget"}}]}},{"kind":"Field","name":{"kind":"Name","value":"other"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViolationOtherTarget"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1PriceSummary"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subtotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionCharge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1Charge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cycleBillingDate"}},{"kind":"Field","name":{"kind":"Name","value":"cycleCount"}},{"kind":"Field","name":{"kind":"Name","value":"cycleFrom"}},{"kind":"Field","name":{"kind":"Name","value":"priceSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LineItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1LineItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"catalogReference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CatalogReference"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageUrlV2"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItemPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fullPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceBeforeDiscounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceAfterTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceBeforeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiersTotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemTaxFullDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"descriptionLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DescriptionLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemAvailabilityInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"physicalProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhysicalProperties"}}]}},{"kind":"Field","name":{"kind":"Name","value":"couponScopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Scope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionOptionInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionOptionInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fulfillerId"}},{"kind":"Field","name":{"kind":"Name","value":"shippingGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"digitalFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SecuredMedia"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentOption"}},{"kind":"Field","name":{"kind":"Name","value":"serviceProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceProperties"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rootCatalogItemId"}},{"kind":"Field","name":{"kind":"Name","value":"priceDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceDescription"}}]}},{"kind":"Field","name":{"kind":"Name","value":"depositAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"policies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Policy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consentRequiredPaymentPolicy"}},{"kind":"Field","name":{"kind":"Name","value":"savePaymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"taxableAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxableAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceUndetermined"}},{"kind":"Field","name":{"kind":"Name","value":"fixedQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"membersOnly"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"modifierGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierGroup"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressWithContactNoGeo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1AddressWithContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddressNoGeo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullAddressContactDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addressesServiceId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1ShippingInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shippingDestination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddressWithContact"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedCarrierServiceOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOption"}}]}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingRegion"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrierServiceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CarrierServiceOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1BuyerInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"visitorId"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"openAccess"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CalculationErrors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CalculationErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generalShippingCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrierErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CarrierErrors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"couponCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"giftCardCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"membershipError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountsCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderValidationErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplicationError"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GiftCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1GiftCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"obfuscatedCode"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppliedDiscount"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1AppliedDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}},{"kind":"Field","name":{"kind":"Name","value":"coupon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Coupon"}}]}},{"kind":"Field","name":{"kind":"Name","value":"merchantDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MerchantDiscount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiscountRule"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomOrdersV1CustomField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"translatedTitle"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1TaxSummary"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxableAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manualTaxRate"}},{"kind":"Field","name":{"kind":"Name","value":"calculationDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxCalculationDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxEstimationId"}},{"kind":"Field","name":{"kind":"Name","value":"averageTaxRate"}},{"kind":"Field","name":{"kind":"Name","value":"taxName"}},{"kind":"Field","name":{"kind":"Name","value":"totalExempt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregatedTaxBreakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AggregatedTaxBreakdown"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreatedBy"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1CreatedBy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"visitorId"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembershipOptions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1MembershipOptions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eligibleMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Membership"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invalidMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidMembership"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedMembership"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdditionalFee"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1AdditionalFee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemTaxFullDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"providerAppId"}},{"kind":"Field","name":{"kind":"Name","value":"priceBeforeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConversionInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1ConversionInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"conversionRate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Violation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1Violation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"severity"}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViolationTarget"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExtendedFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonDataDataextensionsExtendedFields"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"namespaces"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1CustomSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lockGiftCard"}},{"kind":"Field","name":{"kind":"Name","value":"lockCouponCode"}},{"kind":"Field","name":{"kind":"Name","value":"disabledManualPayment"}},{"kind":"Field","name":{"kind":"Name","value":"disabledPolicyAgreementCheckbox"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionCharges"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1SubscriptionCharges"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionCharge"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}}]}}]} as unknown as DocumentNode<CheckoutFragment, unknown>;
export const CreateOrderAndChargeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createOrderAndCharge"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1CreateOrderAndChargeRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"checkoutMutation"},"name":{"kind":"Name","value":"ecomCheckoutV1CreateOrderAndCharge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionId"}},{"kind":"Field","name":{"kind":"Name","value":"paymentResponseToken"}},{"kind":"Field","name":{"kind":"Name","value":"paymentGatewayOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"checkoutCompleted"}}]}}]}}]} as unknown as DocumentNode<CreateOrderAndChargeMutation, CreateOrderAndChargeMutationVariables>;
export const GetCheckoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCheckout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"checkoutId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"checkout"},"name":{"kind":"Name","value":"ecomCheckoutV1Checkout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"checkoutId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Checkout"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CatalogReference"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1CatalogReference"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogItemId"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}},{"kind":"Field","name":{"kind":"Name","value":"options"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1ProductName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageUrlV2"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonPageUrlV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relativePath"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiCurrencyPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiMultiCurrencyPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"convertedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedConvertedAmount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxRateBreakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1TaxRateBreakdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemTaxFullDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ItemTaxFullDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxableAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"totalTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rateBreakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxRateBreakdown"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exemptAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DescriptionLineName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1DescriptionLineName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlainTextValue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1PlainTextValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Color"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Color"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DescriptionLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1DescriptionLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DescriptionLineName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineType"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlainTextValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"colorInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plainTextValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlainTextValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonImage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"urlExpirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"sizeInBytes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemAvailabilityInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1ItemAvailabilityInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"quantityAvailable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhysicalProperties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1PhysicalProperties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"shippable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Group"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCouponsApiV2ScopeGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Scope"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCouponsApiV2Scope"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"namespace"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Group"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1ItemType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preset"}},{"kind":"Field","name":{"kind":"Name","value":"custom"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FreeTrialPeriod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1FreeTrialPeriod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1SubscriptionSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"autoRenewal"}},{"kind":"Field","name":{"kind":"Name","value":"billingCycles"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"freeTrialPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FreeTrialPeriod"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Title"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Title"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Description"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Description"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionOptionInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1SubscriptionOptionInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionSettings"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Description"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecuredMedia"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1SecuredMedia"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServiceProperties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1ServiceProperties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledDate"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfParticipants"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1PriceDescription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Policy"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Policy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxableAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTaxableAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierGroupName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTranslatableString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierLabel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTranslatableString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTranslatableString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Modifier"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomCartCheckoutCommonApiV1ItemModifier"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierLabel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomCartCheckoutCommonApiV1ModifierGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierGroupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Modifier"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LineItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1LineItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"catalogReference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CatalogReference"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageUrlV2"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItemPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fullPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceBeforeDiscounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceAfterTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceBeforeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiersTotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemTaxFullDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"descriptionLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DescriptionLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemAvailabilityInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"physicalProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhysicalProperties"}}]}},{"kind":"Field","name":{"kind":"Name","value":"couponScopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Scope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionOptionInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionOptionInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fulfillerId"}},{"kind":"Field","name":{"kind":"Name","value":"shippingGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"digitalFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SecuredMedia"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentOption"}},{"kind":"Field","name":{"kind":"Name","value":"serviceProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceProperties"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rootCatalogItemId"}},{"kind":"Field","name":{"kind":"Name","value":"priceDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceDescription"}}]}},{"kind":"Field","name":{"kind":"Name","value":"depositAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"policies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Policy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consentRequiredPaymentPolicy"}},{"kind":"Field","name":{"kind":"Name","value":"savePaymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"taxableAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxableAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceUndetermined"}},{"kind":"Field","name":{"kind":"Name","value":"fixedQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"membersOnly"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"modifierGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierGroup"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StreetAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonStreetAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"apt"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddressLine"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApiAddressNoGeo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"subdivision"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"countryFullname"}},{"kind":"Field","name":{"kind":"Name","value":"subdivisionFullname"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StreetAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatId"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonVatId"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullAddressContactDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiFullAddressContactDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"vatId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressWithContactNoGeo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1AddressWithContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddressNoGeo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullAddressContactDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addressesServiceId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GeoCode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonAddressLocation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApiAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddressNoGeo"}},{"kind":"Field","name":{"kind":"Name","value":"geocode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GeoCode"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressWithContact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1AddressWithContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullAddressContactDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addressesServiceId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PickupDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1PickupDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessLocation"}},{"kind":"Field","name":{"kind":"Name","value":"pickupMethod"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeliveryLogistics"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1DeliveryLogistics"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryTime"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"pickupDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PickupDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryTimeSlot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedCarrierServiceOptionPrices"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPrices"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalPriceAfterTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceBeforeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemTaxFullDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedCarrierServiceOptionOtherCharge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionOtherCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOptionPrices"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedCarrierServiceOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"logistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryLogistics"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOptionPrices"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requestedShippingOption"}},{"kind":"Field","name":{"kind":"Name","value":"otherCharges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOptionOtherCharge"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrierId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ShippingRegion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OtherCharge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1OtherCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ShippingPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherCharges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OtherCharge"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ShippingOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"partial"}},{"kind":"Field","name":{"kind":"Name","value":"logistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryLogistics"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarrierServiceOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CarrierServiceOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carrierId"}},{"kind":"Field","name":{"kind":"Name","value":"shippingOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1ShippingInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shippingDestination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddressWithContact"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedCarrierServiceOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOption"}}]}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingRegion"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrierServiceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CarrierServiceOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1BuyerInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"visitorId"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"openAccess"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1PriceSummary"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subtotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApplicationError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiApplicationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldViolation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiValidationErrorFieldViolation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"violatedRule"}},{"kind":"Field","name":{"kind":"Name","value":"ruleName"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ValidationError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldViolations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FieldViolation"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ErrorDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applicationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplicationError"}}]}},{"kind":"Field","name":{"kind":"Name","value":"validationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ValidationError"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tracing"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarrierError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CarrierError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carrierId"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarrierErrors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CarrierErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CarrierError"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CalculationErrors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CalculationErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generalShippingCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrierErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CarrierErrors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"couponCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"giftCardCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"membershipError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountsCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderValidationErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplicationError"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GiftCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1GiftCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"obfuscatedCode"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Coupon"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1Coupon"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"couponType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MerchantDiscount"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1MerchantDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiscountRuleName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1DiscountRuleName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiscountRule"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1DiscountRule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiscountRuleName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppliedDiscount"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1AppliedDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}},{"kind":"Field","name":{"kind":"Name","value":"coupon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Coupon"}}]}},{"kind":"Field","name":{"kind":"Name","value":"merchantDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MerchantDiscount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiscountRule"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomOrdersV1CustomField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"translatedTitle"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AutoTaxFallbackCalculationDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTaxApiAutoTaxFallbackCalculationDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fallbackReason"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplicationError"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxCalculationDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTaxApiTaxCalculationDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rateType"}},{"kind":"Field","name":{"kind":"Name","value":"manualRateReason"}},{"kind":"Field","name":{"kind":"Name","value":"autoTaxFallbackDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AutoTaxFallbackCalculationDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AggregatedTaxBreakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1AggregatedTaxBreakdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxName"}},{"kind":"Field","name":{"kind":"Name","value":"aggregatedTaxAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregatedExemptAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1TaxSummary"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxableAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manualTaxRate"}},{"kind":"Field","name":{"kind":"Name","value":"calculationDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxCalculationDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxEstimationId"}},{"kind":"Field","name":{"kind":"Name","value":"averageTaxRate"}},{"kind":"Field","name":{"kind":"Name","value":"taxName"}},{"kind":"Field","name":{"kind":"Name","value":"totalExempt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregatedTaxBreakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AggregatedTaxBreakdown"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreatedBy"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1CreatedBy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"visitorId"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembershipName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1MembershipName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembershipPaymentCredits"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1MembershipPaymentCredits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"remaining"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Membership"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1HostMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembershipName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}},{"kind":"Field","name":{"kind":"Name","value":"credits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembershipPaymentCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"additionalData"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidMembership"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1HostInvalidMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Membership"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedMembership"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1HostSelectedMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembershipOptions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1MembershipOptions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eligibleMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Membership"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invalidMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidMembership"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedMembership"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdditionalFee"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1AdditionalFee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemTaxFullDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"providerAppId"}},{"kind":"Field","name":{"kind":"Name","value":"priceBeforeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConversionInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1ConversionInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"conversionRate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViolationLineItemTarget"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1TargetLineItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedFix"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViolationOtherTarget"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1TargetOther"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViolationTarget"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1Target"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViolationLineItemTarget"}}]}},{"kind":"Field","name":{"kind":"Name","value":"other"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViolationOtherTarget"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Violation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1Violation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"severity"}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViolationTarget"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExtendedFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonDataDataextensionsExtendedFields"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"namespaces"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1CustomSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lockGiftCard"}},{"kind":"Field","name":{"kind":"Name","value":"lockCouponCode"}},{"kind":"Field","name":{"kind":"Name","value":"disabledManualPayment"}},{"kind":"Field","name":{"kind":"Name","value":"disabledPolicyAgreementCheckbox"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionCharge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1Charge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cycleBillingDate"}},{"kind":"Field","name":{"kind":"Name","value":"cycleCount"}},{"kind":"Field","name":{"kind":"Name","value":"cycleFrom"}},{"kind":"Field","name":{"kind":"Name","value":"priceSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionCharges"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1SubscriptionCharges"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionCharge"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Checkout"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1Checkout"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LineItem"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddressWithContactNoGeo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyerNote"}},{"kind":"Field","name":{"kind":"Name","value":"buyerInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"conversionCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"priceSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calculationErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalculationErrors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"giftCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GiftCard"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appliedDiscounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppliedDiscount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weightUnit"}},{"kind":"Field","name":{"kind":"Name","value":"taxSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"paymentCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"channelType"}},{"kind":"Field","name":{"kind":"Name","value":"siteLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"buyerLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"taxIncludedInPrice"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CreatedBy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"payNow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payLater"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payAfterFreeTrial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"membershipOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembershipOptions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdditionalFee"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cartId"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"conversionInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConversionInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payNowTotalAfterGiftCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"purchaseFlowId"}},{"kind":"Field","name":{"kind":"Name","value":"calculationErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalculationErrors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"violations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Violation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalAfterGiftCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"extendedFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExtendedFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomSettings"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionCharges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionCharges"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentRequired"}},{"kind":"Field","name":{"kind":"Name","value":"taxIncludedInPrice"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemsSubtotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}}]} as unknown as DocumentNode<GetCheckoutQuery, GetCheckoutQueryVariables>;
export const RefreshCheckoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"refreshCheckout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"checkoutId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"checkout"},"name":{"kind":"Name","value":"ecomCheckoutV1GetCheckout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"queryInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"checkoutId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"refresh"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Checkout"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CatalogReference"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1CatalogReference"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogItemId"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}},{"kind":"Field","name":{"kind":"Name","value":"options"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1ProductName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageUrlV2"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonPageUrlV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relativePath"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiCurrencyPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiMultiCurrencyPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"convertedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedConvertedAmount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxRateBreakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1TaxRateBreakdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemTaxFullDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ItemTaxFullDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxableAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"totalTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rateBreakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxRateBreakdown"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exemptAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DescriptionLineName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1DescriptionLineName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlainTextValue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1PlainTextValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Color"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Color"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DescriptionLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1DescriptionLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DescriptionLineName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineType"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlainTextValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"colorInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plainTextValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlainTextValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonImage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"urlExpirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"sizeInBytes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemAvailabilityInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1ItemAvailabilityInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"quantityAvailable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhysicalProperties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1PhysicalProperties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"shippable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Group"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCouponsApiV2ScopeGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Scope"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCouponsApiV2Scope"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"namespace"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Group"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1ItemType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preset"}},{"kind":"Field","name":{"kind":"Name","value":"custom"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FreeTrialPeriod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1FreeTrialPeriod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1SubscriptionSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"autoRenewal"}},{"kind":"Field","name":{"kind":"Name","value":"billingCycles"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"freeTrialPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FreeTrialPeriod"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Title"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Title"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Description"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Description"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionOptionInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1SubscriptionOptionInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionSettings"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Description"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecuredMedia"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1SecuredMedia"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServiceProperties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1ServiceProperties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledDate"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfParticipants"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1PriceDescription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Policy"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Policy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxableAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTaxableAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierGroupName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTranslatableString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierLabel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTranslatableString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTranslatableString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Modifier"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomCartCheckoutCommonApiV1ItemModifier"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierLabel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomCartCheckoutCommonApiV1ModifierGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierGroupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Modifier"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LineItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1LineItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"catalogReference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CatalogReference"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageUrlV2"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItemPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fullPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceBeforeDiscounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceAfterTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceBeforeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiersTotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemTaxFullDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"descriptionLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DescriptionLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemAvailabilityInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"physicalProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhysicalProperties"}}]}},{"kind":"Field","name":{"kind":"Name","value":"couponScopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Scope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionOptionInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionOptionInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fulfillerId"}},{"kind":"Field","name":{"kind":"Name","value":"shippingGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"digitalFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SecuredMedia"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentOption"}},{"kind":"Field","name":{"kind":"Name","value":"serviceProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceProperties"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rootCatalogItemId"}},{"kind":"Field","name":{"kind":"Name","value":"priceDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceDescription"}}]}},{"kind":"Field","name":{"kind":"Name","value":"depositAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"policies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Policy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consentRequiredPaymentPolicy"}},{"kind":"Field","name":{"kind":"Name","value":"savePaymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"taxableAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxableAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceUndetermined"}},{"kind":"Field","name":{"kind":"Name","value":"fixedQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"membersOnly"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"modifierGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierGroup"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StreetAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonStreetAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"apt"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddressLine"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApiAddressNoGeo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"subdivision"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"countryFullname"}},{"kind":"Field","name":{"kind":"Name","value":"subdivisionFullname"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StreetAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatId"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonVatId"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullAddressContactDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiFullAddressContactDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"vatId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressWithContactNoGeo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1AddressWithContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddressNoGeo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullAddressContactDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addressesServiceId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GeoCode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonAddressLocation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApiAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddressNoGeo"}},{"kind":"Field","name":{"kind":"Name","value":"geocode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GeoCode"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressWithContact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1AddressWithContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullAddressContactDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addressesServiceId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PickupDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1PickupDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessLocation"}},{"kind":"Field","name":{"kind":"Name","value":"pickupMethod"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeliveryLogistics"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1DeliveryLogistics"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryTime"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"pickupDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PickupDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryTimeSlot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedCarrierServiceOptionPrices"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPrices"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalPriceAfterTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceBeforeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemTaxFullDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedCarrierServiceOptionOtherCharge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionOtherCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOptionPrices"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedCarrierServiceOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"logistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryLogistics"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOptionPrices"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requestedShippingOption"}},{"kind":"Field","name":{"kind":"Name","value":"otherCharges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOptionOtherCharge"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrierId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ShippingRegion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OtherCharge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1OtherCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ShippingPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherCharges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OtherCharge"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ShippingOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"partial"}},{"kind":"Field","name":{"kind":"Name","value":"logistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryLogistics"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarrierServiceOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CarrierServiceOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carrierId"}},{"kind":"Field","name":{"kind":"Name","value":"shippingOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1ShippingInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shippingDestination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddressWithContact"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedCarrierServiceOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOption"}}]}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingRegion"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrierServiceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CarrierServiceOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1BuyerInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"visitorId"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"openAccess"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1PriceSummary"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subtotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApplicationError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiApplicationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldViolation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiValidationErrorFieldViolation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"violatedRule"}},{"kind":"Field","name":{"kind":"Name","value":"ruleName"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ValidationError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldViolations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FieldViolation"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ErrorDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applicationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplicationError"}}]}},{"kind":"Field","name":{"kind":"Name","value":"validationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ValidationError"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tracing"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarrierError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CarrierError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carrierId"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarrierErrors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CarrierErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CarrierError"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CalculationErrors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CalculationErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generalShippingCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrierErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CarrierErrors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"couponCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"giftCardCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"membershipError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountsCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderValidationErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplicationError"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GiftCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1GiftCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"obfuscatedCode"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Coupon"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1Coupon"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"couponType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MerchantDiscount"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1MerchantDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiscountRuleName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1DiscountRuleName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiscountRule"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1DiscountRule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiscountRuleName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppliedDiscount"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1AppliedDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}},{"kind":"Field","name":{"kind":"Name","value":"coupon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Coupon"}}]}},{"kind":"Field","name":{"kind":"Name","value":"merchantDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MerchantDiscount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiscountRule"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomOrdersV1CustomField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"translatedTitle"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AutoTaxFallbackCalculationDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTaxApiAutoTaxFallbackCalculationDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fallbackReason"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplicationError"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxCalculationDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTaxApiTaxCalculationDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rateType"}},{"kind":"Field","name":{"kind":"Name","value":"manualRateReason"}},{"kind":"Field","name":{"kind":"Name","value":"autoTaxFallbackDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AutoTaxFallbackCalculationDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AggregatedTaxBreakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1AggregatedTaxBreakdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxName"}},{"kind":"Field","name":{"kind":"Name","value":"aggregatedTaxAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregatedExemptAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1TaxSummary"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxableAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manualTaxRate"}},{"kind":"Field","name":{"kind":"Name","value":"calculationDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxCalculationDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxEstimationId"}},{"kind":"Field","name":{"kind":"Name","value":"averageTaxRate"}},{"kind":"Field","name":{"kind":"Name","value":"taxName"}},{"kind":"Field","name":{"kind":"Name","value":"totalExempt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregatedTaxBreakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AggregatedTaxBreakdown"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreatedBy"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1CreatedBy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"visitorId"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembershipName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1MembershipName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembershipPaymentCredits"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1MembershipPaymentCredits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"remaining"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Membership"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1HostMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembershipName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}},{"kind":"Field","name":{"kind":"Name","value":"credits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembershipPaymentCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"additionalData"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidMembership"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1HostInvalidMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Membership"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedMembership"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1HostSelectedMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembershipOptions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1MembershipOptions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eligibleMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Membership"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invalidMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidMembership"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedMembership"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdditionalFee"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1AdditionalFee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemTaxFullDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"providerAppId"}},{"kind":"Field","name":{"kind":"Name","value":"priceBeforeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConversionInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1ConversionInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"conversionRate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViolationLineItemTarget"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1TargetLineItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedFix"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViolationOtherTarget"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1TargetOther"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViolationTarget"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1Target"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViolationLineItemTarget"}}]}},{"kind":"Field","name":{"kind":"Name","value":"other"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViolationOtherTarget"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Violation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1Violation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"severity"}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViolationTarget"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExtendedFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonDataDataextensionsExtendedFields"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"namespaces"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1CustomSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lockGiftCard"}},{"kind":"Field","name":{"kind":"Name","value":"lockCouponCode"}},{"kind":"Field","name":{"kind":"Name","value":"disabledManualPayment"}},{"kind":"Field","name":{"kind":"Name","value":"disabledPolicyAgreementCheckbox"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionCharge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1Charge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cycleBillingDate"}},{"kind":"Field","name":{"kind":"Name","value":"cycleCount"}},{"kind":"Field","name":{"kind":"Name","value":"cycleFrom"}},{"kind":"Field","name":{"kind":"Name","value":"priceSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionCharges"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1SubscriptionCharges"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionCharge"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Checkout"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1Checkout"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LineItem"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddressWithContactNoGeo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyerNote"}},{"kind":"Field","name":{"kind":"Name","value":"buyerInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"conversionCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"priceSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calculationErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalculationErrors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"giftCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GiftCard"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appliedDiscounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppliedDiscount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weightUnit"}},{"kind":"Field","name":{"kind":"Name","value":"taxSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"paymentCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"channelType"}},{"kind":"Field","name":{"kind":"Name","value":"siteLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"buyerLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"taxIncludedInPrice"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CreatedBy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"payNow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payLater"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payAfterFreeTrial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"membershipOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembershipOptions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdditionalFee"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cartId"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"conversionInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConversionInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payNowTotalAfterGiftCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"purchaseFlowId"}},{"kind":"Field","name":{"kind":"Name","value":"calculationErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalculationErrors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"violations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Violation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalAfterGiftCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"extendedFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExtendedFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomSettings"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionCharges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionCharges"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentRequired"}},{"kind":"Field","name":{"kind":"Name","value":"taxIncludedInPrice"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemsSubtotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}}]} as unknown as DocumentNode<RefreshCheckoutQuery, RefreshCheckoutQueryVariables>;
export const RemoveCouponDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeCoupon"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1RemoveCouponRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"checkoutMutation"},"name":{"kind":"Name","value":"ecomCheckoutV1RemoveCoupon"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Checkout"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CatalogReference"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1CatalogReference"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogItemId"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}},{"kind":"Field","name":{"kind":"Name","value":"options"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1ProductName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageUrlV2"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonPageUrlV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relativePath"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiCurrencyPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiMultiCurrencyPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"convertedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedConvertedAmount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxRateBreakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1TaxRateBreakdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemTaxFullDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ItemTaxFullDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxableAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"totalTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rateBreakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxRateBreakdown"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exemptAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DescriptionLineName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1DescriptionLineName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlainTextValue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1PlainTextValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Color"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Color"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DescriptionLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1DescriptionLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DescriptionLineName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineType"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlainTextValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"colorInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plainTextValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlainTextValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonImage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"urlExpirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"sizeInBytes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemAvailabilityInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1ItemAvailabilityInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"quantityAvailable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhysicalProperties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1PhysicalProperties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"shippable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Group"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCouponsApiV2ScopeGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Scope"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCouponsApiV2Scope"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"namespace"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Group"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1ItemType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preset"}},{"kind":"Field","name":{"kind":"Name","value":"custom"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FreeTrialPeriod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1FreeTrialPeriod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1SubscriptionSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"autoRenewal"}},{"kind":"Field","name":{"kind":"Name","value":"billingCycles"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"freeTrialPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FreeTrialPeriod"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Title"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Title"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Description"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Description"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionOptionInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1SubscriptionOptionInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionSettings"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Description"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecuredMedia"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1SecuredMedia"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServiceProperties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1ServiceProperties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledDate"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfParticipants"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1PriceDescription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Policy"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Policy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxableAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTaxableAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierGroupName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTranslatableString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierLabel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTranslatableString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTranslatableString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Modifier"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomCartCheckoutCommonApiV1ItemModifier"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierLabel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomCartCheckoutCommonApiV1ModifierGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierGroupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Modifier"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LineItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1LineItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"catalogReference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CatalogReference"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageUrlV2"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItemPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fullPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceBeforeDiscounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceAfterTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceBeforeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiersTotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemTaxFullDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"descriptionLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DescriptionLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemAvailabilityInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"physicalProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhysicalProperties"}}]}},{"kind":"Field","name":{"kind":"Name","value":"couponScopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Scope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionOptionInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionOptionInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fulfillerId"}},{"kind":"Field","name":{"kind":"Name","value":"shippingGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"digitalFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SecuredMedia"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentOption"}},{"kind":"Field","name":{"kind":"Name","value":"serviceProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceProperties"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rootCatalogItemId"}},{"kind":"Field","name":{"kind":"Name","value":"priceDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceDescription"}}]}},{"kind":"Field","name":{"kind":"Name","value":"depositAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"policies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Policy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consentRequiredPaymentPolicy"}},{"kind":"Field","name":{"kind":"Name","value":"savePaymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"taxableAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxableAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceUndetermined"}},{"kind":"Field","name":{"kind":"Name","value":"fixedQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"membersOnly"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"modifierGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierGroup"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StreetAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonStreetAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"apt"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddressLine"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApiAddressNoGeo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"subdivision"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"countryFullname"}},{"kind":"Field","name":{"kind":"Name","value":"subdivisionFullname"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StreetAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatId"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonVatId"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullAddressContactDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiFullAddressContactDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"vatId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressWithContactNoGeo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1AddressWithContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddressNoGeo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullAddressContactDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addressesServiceId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GeoCode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonAddressLocation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApiAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddressNoGeo"}},{"kind":"Field","name":{"kind":"Name","value":"geocode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GeoCode"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressWithContact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1AddressWithContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullAddressContactDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addressesServiceId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PickupDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1PickupDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessLocation"}},{"kind":"Field","name":{"kind":"Name","value":"pickupMethod"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeliveryLogistics"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1DeliveryLogistics"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryTime"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"pickupDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PickupDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryTimeSlot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedCarrierServiceOptionPrices"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPrices"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalPriceAfterTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceBeforeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemTaxFullDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedCarrierServiceOptionOtherCharge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionOtherCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOptionPrices"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedCarrierServiceOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"logistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryLogistics"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOptionPrices"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requestedShippingOption"}},{"kind":"Field","name":{"kind":"Name","value":"otherCharges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOptionOtherCharge"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrierId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ShippingRegion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OtherCharge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1OtherCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ShippingPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherCharges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OtherCharge"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ShippingOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"partial"}},{"kind":"Field","name":{"kind":"Name","value":"logistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryLogistics"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarrierServiceOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CarrierServiceOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carrierId"}},{"kind":"Field","name":{"kind":"Name","value":"shippingOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1ShippingInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shippingDestination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddressWithContact"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedCarrierServiceOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOption"}}]}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingRegion"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrierServiceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CarrierServiceOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1BuyerInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"visitorId"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"openAccess"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1PriceSummary"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subtotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApplicationError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiApplicationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldViolation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiValidationErrorFieldViolation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"violatedRule"}},{"kind":"Field","name":{"kind":"Name","value":"ruleName"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ValidationError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldViolations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FieldViolation"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ErrorDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applicationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplicationError"}}]}},{"kind":"Field","name":{"kind":"Name","value":"validationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ValidationError"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tracing"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarrierError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CarrierError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carrierId"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarrierErrors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CarrierErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CarrierError"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CalculationErrors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CalculationErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generalShippingCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrierErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CarrierErrors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"couponCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"giftCardCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"membershipError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountsCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderValidationErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplicationError"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GiftCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1GiftCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"obfuscatedCode"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Coupon"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1Coupon"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"couponType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MerchantDiscount"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1MerchantDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiscountRuleName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1DiscountRuleName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiscountRule"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1DiscountRule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiscountRuleName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppliedDiscount"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1AppliedDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}},{"kind":"Field","name":{"kind":"Name","value":"coupon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Coupon"}}]}},{"kind":"Field","name":{"kind":"Name","value":"merchantDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MerchantDiscount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiscountRule"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomOrdersV1CustomField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"translatedTitle"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AutoTaxFallbackCalculationDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTaxApiAutoTaxFallbackCalculationDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fallbackReason"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplicationError"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxCalculationDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTaxApiTaxCalculationDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rateType"}},{"kind":"Field","name":{"kind":"Name","value":"manualRateReason"}},{"kind":"Field","name":{"kind":"Name","value":"autoTaxFallbackDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AutoTaxFallbackCalculationDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AggregatedTaxBreakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1AggregatedTaxBreakdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxName"}},{"kind":"Field","name":{"kind":"Name","value":"aggregatedTaxAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregatedExemptAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1TaxSummary"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxableAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manualTaxRate"}},{"kind":"Field","name":{"kind":"Name","value":"calculationDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxCalculationDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxEstimationId"}},{"kind":"Field","name":{"kind":"Name","value":"averageTaxRate"}},{"kind":"Field","name":{"kind":"Name","value":"taxName"}},{"kind":"Field","name":{"kind":"Name","value":"totalExempt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregatedTaxBreakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AggregatedTaxBreakdown"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreatedBy"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1CreatedBy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"visitorId"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembershipName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1MembershipName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembershipPaymentCredits"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1MembershipPaymentCredits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"remaining"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Membership"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1HostMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembershipName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}},{"kind":"Field","name":{"kind":"Name","value":"credits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembershipPaymentCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"additionalData"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidMembership"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1HostInvalidMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Membership"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedMembership"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1HostSelectedMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembershipOptions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1MembershipOptions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eligibleMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Membership"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invalidMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidMembership"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedMembership"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdditionalFee"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1AdditionalFee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemTaxFullDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"providerAppId"}},{"kind":"Field","name":{"kind":"Name","value":"priceBeforeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConversionInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1ConversionInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"conversionRate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViolationLineItemTarget"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1TargetLineItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedFix"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViolationOtherTarget"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1TargetOther"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViolationTarget"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1Target"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViolationLineItemTarget"}}]}},{"kind":"Field","name":{"kind":"Name","value":"other"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViolationOtherTarget"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Violation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1Violation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"severity"}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViolationTarget"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExtendedFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonDataDataextensionsExtendedFields"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"namespaces"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1CustomSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lockGiftCard"}},{"kind":"Field","name":{"kind":"Name","value":"lockCouponCode"}},{"kind":"Field","name":{"kind":"Name","value":"disabledManualPayment"}},{"kind":"Field","name":{"kind":"Name","value":"disabledPolicyAgreementCheckbox"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionCharge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1Charge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cycleBillingDate"}},{"kind":"Field","name":{"kind":"Name","value":"cycleCount"}},{"kind":"Field","name":{"kind":"Name","value":"cycleFrom"}},{"kind":"Field","name":{"kind":"Name","value":"priceSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionCharges"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1SubscriptionCharges"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionCharge"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Checkout"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1Checkout"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LineItem"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddressWithContactNoGeo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyerNote"}},{"kind":"Field","name":{"kind":"Name","value":"buyerInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"conversionCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"priceSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calculationErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalculationErrors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"giftCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GiftCard"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appliedDiscounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppliedDiscount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weightUnit"}},{"kind":"Field","name":{"kind":"Name","value":"taxSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"paymentCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"channelType"}},{"kind":"Field","name":{"kind":"Name","value":"siteLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"buyerLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"taxIncludedInPrice"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CreatedBy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"payNow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payLater"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payAfterFreeTrial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"membershipOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembershipOptions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdditionalFee"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cartId"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"conversionInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConversionInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payNowTotalAfterGiftCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"purchaseFlowId"}},{"kind":"Field","name":{"kind":"Name","value":"calculationErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalculationErrors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"violations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Violation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalAfterGiftCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"extendedFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExtendedFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomSettings"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionCharges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionCharges"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentRequired"}},{"kind":"Field","name":{"kind":"Name","value":"taxIncludedInPrice"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemsSubtotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}}]} as unknown as DocumentNode<RemoveCouponMutation, RemoveCouponMutationVariables>;
export const RemoveGiftCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeGiftCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1RemoveGiftCardRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"checkoutMutation"},"name":{"kind":"Name","value":"ecomCheckoutV1RemoveGiftCard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Checkout"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CatalogReference"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1CatalogReference"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogItemId"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}},{"kind":"Field","name":{"kind":"Name","value":"options"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1ProductName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageUrlV2"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonPageUrlV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relativePath"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiCurrencyPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiMultiCurrencyPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"convertedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedConvertedAmount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxRateBreakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1TaxRateBreakdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemTaxFullDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ItemTaxFullDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxableAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"totalTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rateBreakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxRateBreakdown"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exemptAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DescriptionLineName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1DescriptionLineName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlainTextValue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1PlainTextValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Color"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Color"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DescriptionLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1DescriptionLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DescriptionLineName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineType"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlainTextValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"colorInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plainTextValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlainTextValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonImage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"urlExpirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"sizeInBytes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemAvailabilityInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1ItemAvailabilityInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"quantityAvailable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhysicalProperties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1PhysicalProperties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"shippable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Group"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCouponsApiV2ScopeGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Scope"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCouponsApiV2Scope"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"namespace"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Group"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1ItemType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preset"}},{"kind":"Field","name":{"kind":"Name","value":"custom"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FreeTrialPeriod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1FreeTrialPeriod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1SubscriptionSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"autoRenewal"}},{"kind":"Field","name":{"kind":"Name","value":"billingCycles"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"freeTrialPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FreeTrialPeriod"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Title"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Title"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Description"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Description"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionOptionInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1SubscriptionOptionInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionSettings"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Description"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecuredMedia"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1SecuredMedia"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServiceProperties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1ServiceProperties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledDate"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfParticipants"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1PriceDescription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Policy"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Policy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxableAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTaxableAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierGroupName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTranslatableString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierLabel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTranslatableString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTranslatableString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Modifier"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomCartCheckoutCommonApiV1ItemModifier"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierLabel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomCartCheckoutCommonApiV1ModifierGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierGroupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Modifier"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LineItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1LineItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"catalogReference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CatalogReference"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageUrlV2"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItemPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fullPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceBeforeDiscounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceAfterTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceBeforeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiersTotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemTaxFullDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"descriptionLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DescriptionLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemAvailabilityInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"physicalProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhysicalProperties"}}]}},{"kind":"Field","name":{"kind":"Name","value":"couponScopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Scope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionOptionInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionOptionInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fulfillerId"}},{"kind":"Field","name":{"kind":"Name","value":"shippingGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"digitalFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SecuredMedia"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentOption"}},{"kind":"Field","name":{"kind":"Name","value":"serviceProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceProperties"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rootCatalogItemId"}},{"kind":"Field","name":{"kind":"Name","value":"priceDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceDescription"}}]}},{"kind":"Field","name":{"kind":"Name","value":"depositAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"policies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Policy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consentRequiredPaymentPolicy"}},{"kind":"Field","name":{"kind":"Name","value":"savePaymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"taxableAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxableAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceUndetermined"}},{"kind":"Field","name":{"kind":"Name","value":"fixedQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"membersOnly"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"modifierGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierGroup"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StreetAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonStreetAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"apt"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddressLine"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApiAddressNoGeo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"subdivision"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"countryFullname"}},{"kind":"Field","name":{"kind":"Name","value":"subdivisionFullname"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StreetAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatId"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonVatId"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullAddressContactDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiFullAddressContactDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"vatId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressWithContactNoGeo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1AddressWithContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddressNoGeo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullAddressContactDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addressesServiceId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GeoCode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonAddressLocation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApiAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddressNoGeo"}},{"kind":"Field","name":{"kind":"Name","value":"geocode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GeoCode"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressWithContact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1AddressWithContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullAddressContactDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addressesServiceId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PickupDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1PickupDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessLocation"}},{"kind":"Field","name":{"kind":"Name","value":"pickupMethod"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeliveryLogistics"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1DeliveryLogistics"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryTime"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"pickupDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PickupDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryTimeSlot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedCarrierServiceOptionPrices"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPrices"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalPriceAfterTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceBeforeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemTaxFullDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedCarrierServiceOptionOtherCharge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionOtherCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOptionPrices"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedCarrierServiceOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"logistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryLogistics"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOptionPrices"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requestedShippingOption"}},{"kind":"Field","name":{"kind":"Name","value":"otherCharges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOptionOtherCharge"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrierId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ShippingRegion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OtherCharge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1OtherCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ShippingPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherCharges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OtherCharge"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ShippingOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"partial"}},{"kind":"Field","name":{"kind":"Name","value":"logistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryLogistics"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarrierServiceOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CarrierServiceOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carrierId"}},{"kind":"Field","name":{"kind":"Name","value":"shippingOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1ShippingInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shippingDestination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddressWithContact"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedCarrierServiceOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOption"}}]}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingRegion"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrierServiceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CarrierServiceOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1BuyerInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"visitorId"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"openAccess"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1PriceSummary"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subtotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApplicationError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiApplicationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldViolation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiValidationErrorFieldViolation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"violatedRule"}},{"kind":"Field","name":{"kind":"Name","value":"ruleName"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ValidationError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldViolations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FieldViolation"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ErrorDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applicationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplicationError"}}]}},{"kind":"Field","name":{"kind":"Name","value":"validationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ValidationError"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tracing"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarrierError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CarrierError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carrierId"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarrierErrors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CarrierErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CarrierError"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CalculationErrors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CalculationErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generalShippingCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrierErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CarrierErrors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"couponCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"giftCardCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"membershipError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountsCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderValidationErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplicationError"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GiftCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1GiftCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"obfuscatedCode"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Coupon"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1Coupon"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"couponType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MerchantDiscount"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1MerchantDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiscountRuleName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1DiscountRuleName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiscountRule"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1DiscountRule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiscountRuleName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppliedDiscount"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1AppliedDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}},{"kind":"Field","name":{"kind":"Name","value":"coupon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Coupon"}}]}},{"kind":"Field","name":{"kind":"Name","value":"merchantDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MerchantDiscount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiscountRule"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomOrdersV1CustomField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"translatedTitle"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AutoTaxFallbackCalculationDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTaxApiAutoTaxFallbackCalculationDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fallbackReason"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplicationError"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxCalculationDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTaxApiTaxCalculationDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rateType"}},{"kind":"Field","name":{"kind":"Name","value":"manualRateReason"}},{"kind":"Field","name":{"kind":"Name","value":"autoTaxFallbackDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AutoTaxFallbackCalculationDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AggregatedTaxBreakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1AggregatedTaxBreakdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxName"}},{"kind":"Field","name":{"kind":"Name","value":"aggregatedTaxAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregatedExemptAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1TaxSummary"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxableAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manualTaxRate"}},{"kind":"Field","name":{"kind":"Name","value":"calculationDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxCalculationDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxEstimationId"}},{"kind":"Field","name":{"kind":"Name","value":"averageTaxRate"}},{"kind":"Field","name":{"kind":"Name","value":"taxName"}},{"kind":"Field","name":{"kind":"Name","value":"totalExempt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregatedTaxBreakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AggregatedTaxBreakdown"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreatedBy"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1CreatedBy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"visitorId"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembershipName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1MembershipName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembershipPaymentCredits"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1MembershipPaymentCredits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"remaining"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Membership"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1HostMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembershipName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}},{"kind":"Field","name":{"kind":"Name","value":"credits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembershipPaymentCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"additionalData"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidMembership"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1HostInvalidMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Membership"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedMembership"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1HostSelectedMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembershipOptions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1MembershipOptions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eligibleMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Membership"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invalidMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidMembership"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedMembership"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdditionalFee"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1AdditionalFee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemTaxFullDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"providerAppId"}},{"kind":"Field","name":{"kind":"Name","value":"priceBeforeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConversionInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1ConversionInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"conversionRate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViolationLineItemTarget"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1TargetLineItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedFix"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViolationOtherTarget"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1TargetOther"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViolationTarget"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1Target"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViolationLineItemTarget"}}]}},{"kind":"Field","name":{"kind":"Name","value":"other"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViolationOtherTarget"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Violation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1Violation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"severity"}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViolationTarget"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExtendedFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonDataDataextensionsExtendedFields"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"namespaces"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1CustomSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lockGiftCard"}},{"kind":"Field","name":{"kind":"Name","value":"lockCouponCode"}},{"kind":"Field","name":{"kind":"Name","value":"disabledManualPayment"}},{"kind":"Field","name":{"kind":"Name","value":"disabledPolicyAgreementCheckbox"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionCharge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1Charge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cycleBillingDate"}},{"kind":"Field","name":{"kind":"Name","value":"cycleCount"}},{"kind":"Field","name":{"kind":"Name","value":"cycleFrom"}},{"kind":"Field","name":{"kind":"Name","value":"priceSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionCharges"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1SubscriptionCharges"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionCharge"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Checkout"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1Checkout"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LineItem"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddressWithContactNoGeo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyerNote"}},{"kind":"Field","name":{"kind":"Name","value":"buyerInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"conversionCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"priceSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calculationErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalculationErrors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"giftCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GiftCard"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appliedDiscounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppliedDiscount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weightUnit"}},{"kind":"Field","name":{"kind":"Name","value":"taxSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"paymentCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"channelType"}},{"kind":"Field","name":{"kind":"Name","value":"siteLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"buyerLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"taxIncludedInPrice"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CreatedBy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"payNow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payLater"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payAfterFreeTrial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"membershipOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembershipOptions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdditionalFee"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cartId"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"conversionInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConversionInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payNowTotalAfterGiftCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"purchaseFlowId"}},{"kind":"Field","name":{"kind":"Name","value":"calculationErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalculationErrors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"violations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Violation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalAfterGiftCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"extendedFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExtendedFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomSettings"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionCharges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionCharges"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentRequired"}},{"kind":"Field","name":{"kind":"Name","value":"taxIncludedInPrice"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemsSubtotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}}]} as unknown as DocumentNode<RemoveGiftCardMutation, RemoveGiftCardMutationVariables>;
export const RemoveLineItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeLineItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1RemoveLineItemsRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"checkoutMutation"},"name":{"kind":"Name","value":"ecomCheckoutV1RemoveLineItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Checkout"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CatalogReference"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1CatalogReference"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogItemId"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}},{"kind":"Field","name":{"kind":"Name","value":"options"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1ProductName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageUrlV2"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonPageUrlV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relativePath"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiCurrencyPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiMultiCurrencyPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"convertedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedConvertedAmount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxRateBreakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1TaxRateBreakdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemTaxFullDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ItemTaxFullDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxableAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"totalTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rateBreakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxRateBreakdown"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exemptAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DescriptionLineName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1DescriptionLineName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlainTextValue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1PlainTextValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Color"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Color"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DescriptionLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1DescriptionLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DescriptionLineName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineType"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlainTextValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"colorInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plainTextValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlainTextValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonImage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"urlExpirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"sizeInBytes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemAvailabilityInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1ItemAvailabilityInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"quantityAvailable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhysicalProperties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1PhysicalProperties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"shippable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Group"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCouponsApiV2ScopeGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Scope"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCouponsApiV2Scope"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"namespace"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Group"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1ItemType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preset"}},{"kind":"Field","name":{"kind":"Name","value":"custom"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FreeTrialPeriod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1FreeTrialPeriod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1SubscriptionSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"autoRenewal"}},{"kind":"Field","name":{"kind":"Name","value":"billingCycles"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"freeTrialPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FreeTrialPeriod"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Title"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Title"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Description"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Description"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionOptionInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1SubscriptionOptionInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionSettings"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Description"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecuredMedia"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1SecuredMedia"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServiceProperties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1ServiceProperties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledDate"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfParticipants"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1PriceDescription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Policy"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Policy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxableAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTaxableAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierGroupName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTranslatableString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierLabel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTranslatableString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTranslatableString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Modifier"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomCartCheckoutCommonApiV1ItemModifier"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierLabel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomCartCheckoutCommonApiV1ModifierGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierGroupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Modifier"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LineItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1LineItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"catalogReference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CatalogReference"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageUrlV2"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItemPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fullPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceBeforeDiscounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceAfterTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceBeforeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiersTotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemTaxFullDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"descriptionLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DescriptionLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemAvailabilityInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"physicalProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhysicalProperties"}}]}},{"kind":"Field","name":{"kind":"Name","value":"couponScopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Scope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionOptionInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionOptionInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fulfillerId"}},{"kind":"Field","name":{"kind":"Name","value":"shippingGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"digitalFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SecuredMedia"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentOption"}},{"kind":"Field","name":{"kind":"Name","value":"serviceProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceProperties"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rootCatalogItemId"}},{"kind":"Field","name":{"kind":"Name","value":"priceDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceDescription"}}]}},{"kind":"Field","name":{"kind":"Name","value":"depositAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"policies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Policy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consentRequiredPaymentPolicy"}},{"kind":"Field","name":{"kind":"Name","value":"savePaymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"taxableAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxableAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceUndetermined"}},{"kind":"Field","name":{"kind":"Name","value":"fixedQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"membersOnly"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"modifierGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierGroup"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StreetAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonStreetAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"apt"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddressLine"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApiAddressNoGeo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"subdivision"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"countryFullname"}},{"kind":"Field","name":{"kind":"Name","value":"subdivisionFullname"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StreetAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatId"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonVatId"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullAddressContactDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiFullAddressContactDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"vatId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressWithContactNoGeo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1AddressWithContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddressNoGeo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullAddressContactDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addressesServiceId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GeoCode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonAddressLocation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApiAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddressNoGeo"}},{"kind":"Field","name":{"kind":"Name","value":"geocode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GeoCode"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressWithContact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1AddressWithContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullAddressContactDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addressesServiceId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PickupDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1PickupDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessLocation"}},{"kind":"Field","name":{"kind":"Name","value":"pickupMethod"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeliveryLogistics"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1DeliveryLogistics"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryTime"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"pickupDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PickupDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryTimeSlot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedCarrierServiceOptionPrices"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPrices"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalPriceAfterTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceBeforeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemTaxFullDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedCarrierServiceOptionOtherCharge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionOtherCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOptionPrices"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedCarrierServiceOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"logistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryLogistics"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOptionPrices"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requestedShippingOption"}},{"kind":"Field","name":{"kind":"Name","value":"otherCharges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOptionOtherCharge"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrierId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ShippingRegion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OtherCharge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1OtherCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ShippingPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherCharges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OtherCharge"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ShippingOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"partial"}},{"kind":"Field","name":{"kind":"Name","value":"logistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryLogistics"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarrierServiceOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CarrierServiceOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carrierId"}},{"kind":"Field","name":{"kind":"Name","value":"shippingOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1ShippingInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shippingDestination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddressWithContact"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedCarrierServiceOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOption"}}]}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingRegion"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrierServiceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CarrierServiceOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1BuyerInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"visitorId"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"openAccess"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1PriceSummary"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subtotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApplicationError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiApplicationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldViolation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiValidationErrorFieldViolation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"violatedRule"}},{"kind":"Field","name":{"kind":"Name","value":"ruleName"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ValidationError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldViolations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FieldViolation"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ErrorDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applicationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplicationError"}}]}},{"kind":"Field","name":{"kind":"Name","value":"validationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ValidationError"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tracing"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarrierError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CarrierError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carrierId"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarrierErrors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CarrierErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CarrierError"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CalculationErrors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CalculationErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generalShippingCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrierErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CarrierErrors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"couponCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"giftCardCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"membershipError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountsCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderValidationErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplicationError"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GiftCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1GiftCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"obfuscatedCode"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Coupon"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1Coupon"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"couponType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MerchantDiscount"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1MerchantDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiscountRuleName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1DiscountRuleName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiscountRule"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1DiscountRule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiscountRuleName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppliedDiscount"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1AppliedDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}},{"kind":"Field","name":{"kind":"Name","value":"coupon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Coupon"}}]}},{"kind":"Field","name":{"kind":"Name","value":"merchantDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MerchantDiscount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiscountRule"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomOrdersV1CustomField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"translatedTitle"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AutoTaxFallbackCalculationDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTaxApiAutoTaxFallbackCalculationDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fallbackReason"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplicationError"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxCalculationDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTaxApiTaxCalculationDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rateType"}},{"kind":"Field","name":{"kind":"Name","value":"manualRateReason"}},{"kind":"Field","name":{"kind":"Name","value":"autoTaxFallbackDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AutoTaxFallbackCalculationDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AggregatedTaxBreakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1AggregatedTaxBreakdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxName"}},{"kind":"Field","name":{"kind":"Name","value":"aggregatedTaxAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregatedExemptAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1TaxSummary"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxableAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manualTaxRate"}},{"kind":"Field","name":{"kind":"Name","value":"calculationDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxCalculationDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxEstimationId"}},{"kind":"Field","name":{"kind":"Name","value":"averageTaxRate"}},{"kind":"Field","name":{"kind":"Name","value":"taxName"}},{"kind":"Field","name":{"kind":"Name","value":"totalExempt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregatedTaxBreakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AggregatedTaxBreakdown"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreatedBy"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1CreatedBy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"visitorId"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembershipName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1MembershipName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembershipPaymentCredits"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1MembershipPaymentCredits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"remaining"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Membership"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1HostMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembershipName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}},{"kind":"Field","name":{"kind":"Name","value":"credits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembershipPaymentCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"additionalData"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidMembership"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1HostInvalidMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Membership"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedMembership"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1HostSelectedMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembershipOptions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1MembershipOptions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eligibleMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Membership"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invalidMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidMembership"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedMembership"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdditionalFee"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1AdditionalFee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemTaxFullDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"providerAppId"}},{"kind":"Field","name":{"kind":"Name","value":"priceBeforeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConversionInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1ConversionInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"conversionRate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViolationLineItemTarget"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1TargetLineItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedFix"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViolationOtherTarget"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1TargetOther"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViolationTarget"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1Target"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViolationLineItemTarget"}}]}},{"kind":"Field","name":{"kind":"Name","value":"other"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViolationOtherTarget"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Violation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1Violation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"severity"}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViolationTarget"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExtendedFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonDataDataextensionsExtendedFields"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"namespaces"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1CustomSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lockGiftCard"}},{"kind":"Field","name":{"kind":"Name","value":"lockCouponCode"}},{"kind":"Field","name":{"kind":"Name","value":"disabledManualPayment"}},{"kind":"Field","name":{"kind":"Name","value":"disabledPolicyAgreementCheckbox"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionCharge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1Charge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cycleBillingDate"}},{"kind":"Field","name":{"kind":"Name","value":"cycleCount"}},{"kind":"Field","name":{"kind":"Name","value":"cycleFrom"}},{"kind":"Field","name":{"kind":"Name","value":"priceSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionCharges"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1SubscriptionCharges"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionCharge"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Checkout"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1Checkout"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LineItem"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddressWithContactNoGeo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyerNote"}},{"kind":"Field","name":{"kind":"Name","value":"buyerInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"conversionCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"priceSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calculationErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalculationErrors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"giftCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GiftCard"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appliedDiscounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppliedDiscount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weightUnit"}},{"kind":"Field","name":{"kind":"Name","value":"taxSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"paymentCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"channelType"}},{"kind":"Field","name":{"kind":"Name","value":"siteLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"buyerLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"taxIncludedInPrice"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CreatedBy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"payNow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payLater"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payAfterFreeTrial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"membershipOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembershipOptions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdditionalFee"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cartId"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"conversionInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConversionInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payNowTotalAfterGiftCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"purchaseFlowId"}},{"kind":"Field","name":{"kind":"Name","value":"calculationErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalculationErrors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"violations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Violation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalAfterGiftCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"extendedFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExtendedFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomSettings"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionCharges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionCharges"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentRequired"}},{"kind":"Field","name":{"kind":"Name","value":"taxIncludedInPrice"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemsSubtotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}}]} as unknown as DocumentNode<RemoveLineItemMutation, RemoveLineItemMutationVariables>;
export const UpdateCheckoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCheckout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1UpdateCheckoutRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"checkoutMutation"},"name":{"kind":"Name","value":"ecomCheckoutV1UpdateCheckout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Checkout"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CatalogReference"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1CatalogReference"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogItemId"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}},{"kind":"Field","name":{"kind":"Name","value":"options"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1ProductName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageUrlV2"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonPageUrlV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relativePath"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiCurrencyPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiMultiCurrencyPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"convertedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"formattedConvertedAmount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxRateBreakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1TaxRateBreakdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemTaxFullDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ItemTaxFullDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxableAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"taxRate"}},{"kind":"Field","name":{"kind":"Name","value":"totalTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rateBreakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxRateBreakdown"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exemptAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DescriptionLineName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1DescriptionLineName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlainTextValue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1PlainTextValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Color"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Color"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DescriptionLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1DescriptionLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DescriptionLineName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineType"}},{"kind":"Field","name":{"kind":"Name","value":"plainText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlainTextValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"colorInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plainTextValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlainTextValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Image"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonImage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"urlExpirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"sizeInBytes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemAvailabilityInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1ItemAvailabilityInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"quantityAvailable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhysicalProperties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1PhysicalProperties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"shippable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Group"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCouponsApiV2ScopeGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Scope"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCouponsApiV2Scope"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"namespace"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Group"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1ItemType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preset"}},{"kind":"Field","name":{"kind":"Name","value":"custom"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FreeTrialPeriod"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1FreeTrialPeriod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1SubscriptionSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"autoRenewal"}},{"kind":"Field","name":{"kind":"Name","value":"billingCycles"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"freeTrialPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FreeTrialPeriod"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Title"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Title"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Description"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Description"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionOptionInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1SubscriptionOptionInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionSettings"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Description"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecuredMedia"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1SecuredMedia"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServiceProperties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1ServiceProperties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduledDate"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfParticipants"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1PriceDescription"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Policy"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceCatalogSpiApiV1Policy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxableAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTaxableAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierGroupName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTranslatableString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierLabel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTranslatableString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiTranslatableString"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Modifier"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomCartCheckoutCommonApiV1ItemModifier"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierLabel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ModifierGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomCartCheckoutCommonApiV1ModifierGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierGroupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Modifier"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LineItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1LineItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"catalogReference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CatalogReference"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productName"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageUrlV2"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItemPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fullPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceBeforeDiscounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceAfterTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceBeforeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifiersTotalPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemTaxFullDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"descriptionLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DescriptionLine"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Image"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemAvailabilityInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"physicalProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhysicalProperties"}}]}},{"kind":"Field","name":{"kind":"Name","value":"couponScopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Scope"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionOptionInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionOptionInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fulfillerId"}},{"kind":"Field","name":{"kind":"Name","value":"shippingGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"digitalFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SecuredMedia"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentOption"}},{"kind":"Field","name":{"kind":"Name","value":"serviceProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceProperties"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rootCatalogItemId"}},{"kind":"Field","name":{"kind":"Name","value":"priceDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceDescription"}}]}},{"kind":"Field","name":{"kind":"Name","value":"depositAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"policies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Policy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consentRequiredPaymentPolicy"}},{"kind":"Field","name":{"kind":"Name","value":"savePaymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"taxableAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxableAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceUndetermined"}},{"kind":"Field","name":{"kind":"Name","value":"fixedQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"membersOnly"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"modifierGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ModifierGroup"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StreetAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonStreetAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"apt"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddressLine"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApiAddressNoGeo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"subdivision"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"countryFullname"}},{"kind":"Field","name":{"kind":"Name","value":"subdivisionFullname"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StreetAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VatId"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonVatId"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullAddressContactDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiFullAddressContactDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"vatId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VatId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressWithContactNoGeo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1AddressWithContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddressNoGeo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullAddressContactDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addressesServiceId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GeoCode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonAddressLocation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApiAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommercePlatformCommonApiAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddressNoGeo"}},{"kind":"Field","name":{"kind":"Name","value":"geocode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GeoCode"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressWithContact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1AddressWithContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullAddressContactDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addressesServiceId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PickupDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1PickupDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApiAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"businessLocation"}},{"kind":"Field","name":{"kind":"Name","value":"pickupMethod"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeliveryLogistics"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1DeliveryLogistics"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryTime"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"pickupDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PickupDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryTimeSlot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedCarrierServiceOptionPrices"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionPrices"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalPriceAfterTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceBeforeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemTaxFullDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedCarrierServiceOptionOtherCharge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOptionOtherCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOptionPrices"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedCarrierServiceOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1SelectedCarrierServiceOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"logistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryLogistics"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOptionPrices"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requestedShippingOption"}},{"kind":"Field","name":{"kind":"Name","value":"otherCharges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOptionOtherCharge"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrierId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingRegion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ShippingRegion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OtherCharge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1OtherCharge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ShippingPrice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherCharges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OtherCharge"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1ShippingOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"partial"}},{"kind":"Field","name":{"kind":"Name","value":"logistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryLogistics"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarrierServiceOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CarrierServiceOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carrierId"}},{"kind":"Field","name":{"kind":"Name","value":"shippingOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShippingInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1ShippingInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shippingDestination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddressWithContact"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedCarrierServiceOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedCarrierServiceOption"}}]}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingRegion"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrierServiceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CarrierServiceOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1BuyerInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"visitorId"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"openAccess"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PriceSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1PriceSummary"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subtotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApplicationError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiApplicationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FieldViolation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiValidationErrorFieldViolation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"violatedRule"}},{"kind":"Field","name":{"kind":"Name","value":"ruleName"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ValidationError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldViolations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FieldViolation"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ErrorDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixApiDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applicationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplicationError"}}]}},{"kind":"Field","name":{"kind":"Name","value":"validationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ValidationError"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tracing"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarrierError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CarrierError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carrierId"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CarrierErrors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CarrierErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CarrierError"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CalculationErrors"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1CalculationErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generalShippingCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrierErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CarrierErrors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"couponCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"giftCardCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"membershipError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountsCalculationError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ErrorDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderValidationErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplicationError"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GiftCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1GiftCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"obfuscatedCode"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Coupon"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1Coupon"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"couponType"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MerchantDiscount"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1MerchantDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiscountRuleName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1DiscountRuleName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DiscountRule"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1DiscountRule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiscountRuleName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppliedDiscount"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1AppliedDiscount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}},{"kind":"Field","name":{"kind":"Name","value":"coupon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Coupon"}}]}},{"kind":"Field","name":{"kind":"Name","value":"merchantDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MerchantDiscount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DiscountRule"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomOrdersV1CustomField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"translatedTitle"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AutoTaxFallbackCalculationDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTaxApiAutoTaxFallbackCalculationDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fallbackReason"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplicationError"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxCalculationDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTaxApiTaxCalculationDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rateType"}},{"kind":"Field","name":{"kind":"Name","value":"manualRateReason"}},{"kind":"Field","name":{"kind":"Name","value":"autoTaxFallbackDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AutoTaxFallbackCalculationDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AggregatedTaxBreakdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1AggregatedTaxBreakdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxName"}},{"kind":"Field","name":{"kind":"Name","value":"aggregatedTaxAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregatedExemptAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaxSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1TaxSummary"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxableAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manualTaxRate"}},{"kind":"Field","name":{"kind":"Name","value":"calculationDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxCalculationDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxEstimationId"}},{"kind":"Field","name":{"kind":"Name","value":"averageTaxRate"}},{"kind":"Field","name":{"kind":"Name","value":"taxName"}},{"kind":"Field","name":{"kind":"Name","value":"totalExempt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregatedTaxBreakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AggregatedTaxBreakdown"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreatedBy"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1CreatedBy"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"visitorId"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembershipName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1MembershipName"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"translated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembershipPaymentCredits"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1MembershipPaymentCredits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"remaining"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Membership"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1HostMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembershipName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}},{"kind":"Field","name":{"kind":"Name","value":"credits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembershipPaymentCredits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"additionalData"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidMembership"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1HostInvalidMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Membership"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectedMembership"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomMembershipsSpiV1HostSelectedMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembershipOptions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1MembershipOptions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eligibleMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Membership"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invalidMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvalidMembership"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selectedMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SelectedMembership"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdditionalFee"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcomTotalsCalculatorV1AdditionalFee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"translatedName"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemTaxFullDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"providerAppId"}},{"kind":"Field","name":{"kind":"Name","value":"priceBeforeTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ConversionInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1ConversionInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"conversionRate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViolationLineItemTarget"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1TargetLineItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedFix"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViolationOtherTarget"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1TargetOther"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ViolationTarget"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1Target"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViolationLineItemTarget"}}]}},{"kind":"Field","name":{"kind":"Name","value":"other"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViolationOtherTarget"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Violation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComWixEcommerceValidationsSpiV1Violation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"severity"}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ViolationTarget"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExtendedFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WixCommonDataDataextensionsExtendedFields"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"namespaces"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1CustomSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lockGiftCard"}},{"kind":"Field","name":{"kind":"Name","value":"lockCouponCode"}},{"kind":"Field","name":{"kind":"Name","value":"disabledManualPayment"}},{"kind":"Field","name":{"kind":"Name","value":"disabledPolicyAgreementCheckbox"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionCharge"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1Charge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cycleBillingDate"}},{"kind":"Field","name":{"kind":"Name","value":"cycleCount"}},{"kind":"Field","name":{"kind":"Name","value":"cycleFrom"}},{"kind":"Field","name":{"kind":"Name","value":"priceSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionCharges"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1SubscriptionCharges"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionCharge"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemIds"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Checkout"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EcomCheckoutV1Checkout"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LineItem"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddressWithContactNoGeo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShippingInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyerNote"}},{"kind":"Field","name":{"kind":"Name","value":"buyerInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"conversionCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"priceSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calculationErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalculationErrors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"giftCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GiftCard"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appliedDiscounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppliedDiscount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weightUnit"}},{"kind":"Field","name":{"kind":"Name","value":"taxSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaxSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"paymentCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"channelType"}},{"kind":"Field","name":{"kind":"Name","value":"siteLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"buyerLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"taxIncludedInPrice"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CreatedBy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"payNow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payLater"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payAfterFreeTrial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PriceSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"membershipOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembershipOptions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdditionalFee"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cartId"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"conversionInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ConversionInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payNowTotalAfterGiftCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"purchaseFlowId"}},{"kind":"Field","name":{"kind":"Name","value":"calculationErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalculationErrors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"violations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Violation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalAfterGiftCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"extendedFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExtendedFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomSettings"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionCharges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscriptionCharges"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentRequired"}},{"kind":"Field","name":{"kind":"Name","value":"taxIncludedInPrice"}},{"kind":"Field","name":{"kind":"Name","value":"lineItemsSubtotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiCurrencyPrice"}}]}}]}}]} as unknown as DocumentNode<UpdateCheckoutMutation, UpdateCheckoutMutationVariables>;